/* eslint-disable */
export enum qx_ePrivilege_enum_desc {
  AccessReports = "Generation of Access Reports",
  AIAssistant = "Use the AI Assistant",
  AIBilling = "Manage AI billing tier and overage spending",
  Audit = "Viewing of Audit Trails",
  BandwidthConfig = "Configuration of Gateway Bandwidth",
  CameraConfig = "Configuration of Cameras",
  CameraOperator = "Control of Cameras",
  CameraView = "View Cameras",
  ClipManagement = "Clip Management",
  DeviceConfig = "Configuration of Devices",
  DeviceOperator = "Control of Device DIOs",
  DeviceView = "View of devices",
  DoorConfig = "Configuration of Doors",
  DoorOperator = "Control of Doors",
  DoorView = "View Doors",
  GatewayConfig = "Configuration of Gateways",
  GatewayView = "View of Gateways",
  IntrusionConfig = "Configuration of Intrusion Panel and Zoness",
  IntrusionOperator = "Control of Intrusion Panels and Zones",
  IntrusionView = "View Intrustion Panels and Zones",
  LiveEvents = "Viewing of Live Events",
  LiveVideo = "Live Video Access",
  LockDown = "Control Lockdown of Places",
  PeopleConfig = "People Management",
  PeopleView = "View of People",
  PlaceConfig = "Configuration of Places",
  RecordedVideo = "Recorded Video Access",
  RoleConfig = "Role Management",
  RulesConfig = "Configuration of Rules",
  RulesView = "View of Rules",
  ScheduleConfig = "Configuration of Schedules",
  Search = "Searching of Events",
  Snapshots = "View of Snapshots",
  UserCreation = "Allows Inviting Users to Qx Control",
  View = "View based on Place Hierarchy",
  ViewConfig = "Configuration of Views",
}

export enum qx_eFlowTraceActionStatus_enum {
  Failed = "Failed",
  RateLimited = "RateLimited",
  Running = "Running",
  RunOnCloudOnly = "RunOnCloudOnly",
  Success = "Success",
  Suppressed = "Suppressed",
}

export enum qx_eFlowTraceActionStatus_enum_desc {
  Failed = "Failed",
  RateLimited = "Rate Limited",
  Running = "Running",
  RunOnCloudOnly = "Run On Cloud Only",
  Success = "Success",
  Suppressed = "Suppressed",
}
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Device_scalar: { input: any; output: any; }
  EventType_scalar: { input: any; output: any; }
  JSON: { input: any; output: any; }
  MediaProfile_scalar: { input: any; output: any; }
  Place_scalar: { input: any; output: any; }
  VideoSource_scalar: { input: any; output: any; }
  bigint: { input: any; output: any; }
  bpchar: { input: any; output: any; }
  bytea: { input: any; output: any; }
  date: { input: any; output: any; }
  inet: { input: any; output: any; }
  interval: { input: any; output: any; }
  json: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  smallint: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

export type AccessReport = {
  __typename?: 'AccessReport';
  columns: Array<string>;
  rows?: any;
  totalCount: number;
  type: ReportType;
};

export type AccessReportFilterInput = {
  deviceDIOID?: Array<string>;
  deviceID?: Array<string>;
  doorID?: Array<string>;
  eventID?: Array<string>;
  gatewayID?: Array<string>;
  personID?: Array<string>;
  placeID?: Array<string>;
  status?: Array<string>;
  type?: Array<string>;
  videoSourceID?: Array<string>;
};

export type AccessReportInfo = {
  __typename?: 'AccessReportInfo';
  columns: Array<string>;
  filterable: Array<string>;
  sortable: Array<string>;
  type: ReportType;
};

export type AccessReportOptionsInput = {
  columns?: Array<string>;
  end?: string;
  placePath?: string;
  start?: string;
  timeZone?: string;
};

export enum AccessReportOrderByEnum {
  asc = 'asc',
  desc = 'desc'
}

export type AccessReportOrderByInput = {
  createdAt?: AccessReportOrderByEnum;
  doorID?: AccessReportOrderByEnum;
  eventID?: AccessReportOrderByEnum;
  firstName?: AccessReportOrderByEnum;
  lastEventDoor?: AccessReportOrderByEnum;
  lastEventTime?: AccessReportOrderByEnum;
  lastEventType?: AccessReportOrderByEnum;
  lastName?: AccessReportOrderByEnum;
  personID?: AccessReportOrderByEnum;
  placeID?: AccessReportOrderByEnum;
  status?: AccessReportOrderByEnum;
  time?: AccessReportOrderByEnum;
  videoSourceName?: AccessReportOrderByEnum;
};

export type AccessReportUrlOutput = {
  __typename?: 'AccessReportUrlOutput';
  expiresAt: string;
  url: string;
};

/** columns and relationships of "analytics.AnalyticSource" */
export type AnalyticSources = {
  __typename?: 'AnalyticSources';
  comment?: string;
  id: number;
  value: string;
};

/** aggregated selection of "analytics.AnalyticSource" */
export type AnalyticSources_aggregate = {
  __typename?: 'AnalyticSources_aggregate';
  aggregate?: AnalyticSources_aggregate_fields;
  nodes: Array<AnalyticSources>;
};

/** aggregate fields of "analytics.AnalyticSource" */
export type AnalyticSources_aggregate_fields = {
  __typename?: 'AnalyticSources_aggregate_fields';
  avg?: AnalyticSources_avg_fields;
  count: number;
  max?: AnalyticSources_max_fields;
  min?: AnalyticSources_min_fields;
  stddev?: AnalyticSources_stddev_fields;
  stddev_pop?: AnalyticSources_stddev_pop_fields;
  stddev_samp?: AnalyticSources_stddev_samp_fields;
  sum?: AnalyticSources_sum_fields;
  var_pop?: AnalyticSources_var_pop_fields;
  var_samp?: AnalyticSources_var_samp_fields;
  variance?: AnalyticSources_variance_fields;
};


/** aggregate fields of "analytics.AnalyticSource" */
export type AnalyticSources_aggregate_fieldscountArgs = {
  columns?: Array<AnalyticSources_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type AnalyticSources_avg_fields = {
  __typename?: 'AnalyticSources_avg_fields';
  id?: number;
};

/** Boolean expression to filter rows from the table "analytics.AnalyticSource". All fields are combined with a logical 'AND'. */
export type AnalyticSources_bool_exp = {
  _and?: Array<AnalyticSources_bool_exp>;
  _not?: AnalyticSources_bool_exp;
  _or?: Array<AnalyticSources_bool_exp>;
  comment?: String_comparison_exp;
  id?: Int_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "analytics.AnalyticSource" */
export enum AnalyticSources_constraint {
  /** unique or primary key constraint on columns "id" */
  AnalyticSource_id_key = 'AnalyticSource_id_key',
  /** unique or primary key constraint on columns "value" */
  eAnalyticSource_pkey = 'eAnalyticSource_pkey'
}

/** input type for incrementing numeric columns in table "analytics.AnalyticSource" */
export type AnalyticSources_inc_input = {
  id?: number;
};

/** input type for inserting data into table "analytics.AnalyticSource" */
export type AnalyticSources_insert_input = {
  comment?: string;
  id?: number;
  value?: string;
};

/** aggregate max on columns */
export type AnalyticSources_max_fields = {
  __typename?: 'AnalyticSources_max_fields';
  comment?: string;
  id?: number;
  value?: string;
};

/** aggregate min on columns */
export type AnalyticSources_min_fields = {
  __typename?: 'AnalyticSources_min_fields';
  comment?: string;
  id?: number;
  value?: string;
};

/** response of any mutation on the table "analytics.AnalyticSource" */
export type AnalyticSources_mutation_response = {
  __typename?: 'AnalyticSources_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<AnalyticSources>;
};

/** input type for inserting object relation for remote table "analytics.AnalyticSource" */
export type AnalyticSources_obj_rel_insert_input = {
  data: AnalyticSources_insert_input;
  /** upsert condition */
  on_conflict?: AnalyticSources_on_conflict;
};

/** on_conflict condition type for table "analytics.AnalyticSource" */
export type AnalyticSources_on_conflict = {
  constraint: AnalyticSources_constraint;
  update_columns?: Array<AnalyticSources_update_column>;
  where?: AnalyticSources_bool_exp;
};

/** Ordering options when selecting data from "analytics.AnalyticSource". */
export type AnalyticSources_order_by = {
  comment?: order_by;
  id?: order_by;
  value?: order_by;
};

/** primary key columns input for table: analytics.AnalyticSource */
export type AnalyticSources_pk_columns_input = {
  value: string;
};

/** select columns of table "analytics.AnalyticSource" */
export enum AnalyticSources_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  id = 'id',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "analytics.AnalyticSource" */
export type AnalyticSources_set_input = {
  comment?: string;
  id?: number;
  value?: string;
};

/** aggregate stddev on columns */
export type AnalyticSources_stddev_fields = {
  __typename?: 'AnalyticSources_stddev_fields';
  id?: number;
};

/** aggregate stddev_pop on columns */
export type AnalyticSources_stddev_pop_fields = {
  __typename?: 'AnalyticSources_stddev_pop_fields';
  id?: number;
};

/** aggregate stddev_samp on columns */
export type AnalyticSources_stddev_samp_fields = {
  __typename?: 'AnalyticSources_stddev_samp_fields';
  id?: number;
};

/** Streaming cursor of the table "AnalyticSources" */
export type AnalyticSources_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: AnalyticSources_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type AnalyticSources_stream_cursor_value_input = {
  comment?: string;
  id?: number;
  value?: string;
};

/** aggregate sum on columns */
export type AnalyticSources_sum_fields = {
  __typename?: 'AnalyticSources_sum_fields';
  id?: number;
};

/** update columns of table "analytics.AnalyticSource" */
export enum AnalyticSources_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  id = 'id',
  /** column name */
  value = 'value'
}

export type AnalyticSources_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: AnalyticSources_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: AnalyticSources_set_input;
  /** filter the rows which have to be updated */
  where: AnalyticSources_bool_exp;
};

/** aggregate var_pop on columns */
export type AnalyticSources_var_pop_fields = {
  __typename?: 'AnalyticSources_var_pop_fields';
  id?: number;
};

/** aggregate var_samp on columns */
export type AnalyticSources_var_samp_fields = {
  __typename?: 'AnalyticSources_var_samp_fields';
  id?: number;
};

/** aggregate variance on columns */
export type AnalyticSources_variance_fields = {
  __typename?: 'AnalyticSources_variance_fields';
  id?: number;
};

export type AppPassword = {
  __typename?: 'AppPassword';
  token: string;
};

/** columns and relationships of "qx.ApplicationUserGatewayPassword" */
export type ApplicationUserGatewayPassword = {
  __typename?: 'ApplicationUserGatewayPassword';
  gatewayPasswordHash: string;
  id: string;
  /** An object relationship */
  person?: qx_Person;
  personID: string;
};

/** aggregated selection of "qx.ApplicationUserGatewayPassword" */
export type ApplicationUserGatewayPassword_aggregate = {
  __typename?: 'ApplicationUserGatewayPassword_aggregate';
  aggregate?: ApplicationUserGatewayPassword_aggregate_fields;
  nodes: Array<ApplicationUserGatewayPassword>;
};

/** aggregate fields of "qx.ApplicationUserGatewayPassword" */
export type ApplicationUserGatewayPassword_aggregate_fields = {
  __typename?: 'ApplicationUserGatewayPassword_aggregate_fields';
  count: number;
  max?: ApplicationUserGatewayPassword_max_fields;
  min?: ApplicationUserGatewayPassword_min_fields;
};


/** aggregate fields of "qx.ApplicationUserGatewayPassword" */
export type ApplicationUserGatewayPassword_aggregate_fieldscountArgs = {
  columns?: Array<ApplicationUserGatewayPassword_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.ApplicationUserGatewayPassword". All fields are combined with a logical 'AND'. */
export type ApplicationUserGatewayPassword_bool_exp = {
  _and?: Array<ApplicationUserGatewayPassword_bool_exp>;
  _not?: ApplicationUserGatewayPassword_bool_exp;
  _or?: Array<ApplicationUserGatewayPassword_bool_exp>;
  gatewayPasswordHash?: String_comparison_exp;
  id?: String_comparison_exp;
  person?: qx_Person_bool_exp;
  personID?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.ApplicationUserGatewayPassword" */
export enum ApplicationUserGatewayPassword_constraint {
  /** unique or primary key constraint on columns "personID" */
  ApplicationUserGatewayPassword_personID_key = 'ApplicationUserGatewayPassword_personID_key',
  /** unique or primary key constraint on columns "id" */
  ApplicationUserGatewayPassword_pkey = 'ApplicationUserGatewayPassword_pkey'
}

/** input type for inserting data into table "qx.ApplicationUserGatewayPassword" */
export type ApplicationUserGatewayPassword_insert_input = {
  gatewayPasswordHash?: string;
  id?: string;
  person?: qx_Person_obj_rel_insert_input;
  personID?: string;
};

/** aggregate max on columns */
export type ApplicationUserGatewayPassword_max_fields = {
  __typename?: 'ApplicationUserGatewayPassword_max_fields';
  gatewayPasswordHash?: string;
  id?: string;
  personID?: string;
};

/** aggregate min on columns */
export type ApplicationUserGatewayPassword_min_fields = {
  __typename?: 'ApplicationUserGatewayPassword_min_fields';
  gatewayPasswordHash?: string;
  id?: string;
  personID?: string;
};

/** response of any mutation on the table "qx.ApplicationUserGatewayPassword" */
export type ApplicationUserGatewayPassword_mutation_response = {
  __typename?: 'ApplicationUserGatewayPassword_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<ApplicationUserGatewayPassword>;
};

/** input type for inserting object relation for remote table "qx.ApplicationUserGatewayPassword" */
export type ApplicationUserGatewayPassword_obj_rel_insert_input = {
  data: ApplicationUserGatewayPassword_insert_input;
  /** upsert condition */
  on_conflict?: ApplicationUserGatewayPassword_on_conflict;
};

/** on_conflict condition type for table "qx.ApplicationUserGatewayPassword" */
export type ApplicationUserGatewayPassword_on_conflict = {
  constraint: ApplicationUserGatewayPassword_constraint;
  update_columns?: Array<ApplicationUserGatewayPassword_update_column>;
  where?: ApplicationUserGatewayPassword_bool_exp;
};

/** Ordering options when selecting data from "qx.ApplicationUserGatewayPassword". */
export type ApplicationUserGatewayPassword_order_by = {
  gatewayPasswordHash?: order_by;
  id?: order_by;
  person?: qx_Person_order_by;
  personID?: order_by;
};

/** primary key columns input for table: qx.ApplicationUserGatewayPassword */
export type ApplicationUserGatewayPassword_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.ApplicationUserGatewayPassword" */
export enum ApplicationUserGatewayPassword_select_column {
  /** column name */
  gatewayPasswordHash = 'gatewayPasswordHash',
  /** column name */
  id = 'id',
  /** column name */
  personID = 'personID'
}

/** input type for updating data in table "qx.ApplicationUserGatewayPassword" */
export type ApplicationUserGatewayPassword_set_input = {
  gatewayPasswordHash?: string;
  id?: string;
  personID?: string;
};

/** Streaming cursor of the table "ApplicationUserGatewayPassword" */
export type ApplicationUserGatewayPassword_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: ApplicationUserGatewayPassword_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type ApplicationUserGatewayPassword_stream_cursor_value_input = {
  gatewayPasswordHash?: string;
  id?: string;
  personID?: string;
};

/** update columns of table "qx.ApplicationUserGatewayPassword" */
export enum ApplicationUserGatewayPassword_update_column {
  /** column name */
  gatewayPasswordHash = 'gatewayPasswordHash',
  /** column name */
  id = 'id',
  /** column name */
  personID = 'personID'
}

export type ApplicationUserGatewayPassword_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: ApplicationUserGatewayPassword_set_input;
  /** filter the rows which have to be updated */
  where: ApplicationUserGatewayPassword_bool_exp;
};

/** columns and relationships of "qx.ApplicationUserTwoFactor" */
export type ApplicationUserTwoFactor = {
  __typename?: 'ApplicationUserTwoFactor';
  codes?: string;
  createdAt: string;
  email: string;
  id: string;
  verified: boolean;
};

/** aggregated selection of "qx.ApplicationUserTwoFactor" */
export type ApplicationUserTwoFactor_aggregate = {
  __typename?: 'ApplicationUserTwoFactor_aggregate';
  aggregate?: ApplicationUserTwoFactor_aggregate_fields;
  nodes: Array<ApplicationUserTwoFactor>;
};

/** aggregate fields of "qx.ApplicationUserTwoFactor" */
export type ApplicationUserTwoFactor_aggregate_fields = {
  __typename?: 'ApplicationUserTwoFactor_aggregate_fields';
  count: number;
  max?: ApplicationUserTwoFactor_max_fields;
  min?: ApplicationUserTwoFactor_min_fields;
};


/** aggregate fields of "qx.ApplicationUserTwoFactor" */
export type ApplicationUserTwoFactor_aggregate_fieldscountArgs = {
  columns?: Array<ApplicationUserTwoFactor_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.ApplicationUserTwoFactor". All fields are combined with a logical 'AND'. */
export type ApplicationUserTwoFactor_bool_exp = {
  _and?: Array<ApplicationUserTwoFactor_bool_exp>;
  _not?: ApplicationUserTwoFactor_bool_exp;
  _or?: Array<ApplicationUserTwoFactor_bool_exp>;
  codes?: String_comparison_exp;
  createdAt?: timestamptz_comparison_exp;
  email?: String_comparison_exp;
  id?: String_comparison_exp;
  verified?: Boolean_comparison_exp;
};

/** unique or primary key constraints on table "qx.ApplicationUserTwoFactor" */
export enum ApplicationUserTwoFactor_constraint {
  /** unique or primary key constraint on columns "id" */
  ApplicationUserBackupCodes_pkey = 'ApplicationUserBackupCodes_pkey',
  /** unique or primary key constraint on columns "email" */
  ApplicationUserTwoFactor_email_key = 'ApplicationUserTwoFactor_email_key'
}

/** input type for inserting data into table "qx.ApplicationUserTwoFactor" */
export type ApplicationUserTwoFactor_insert_input = {
  codes?: string;
  createdAt?: string;
  email?: string;
  id?: string;
  verified?: boolean;
};

/** aggregate max on columns */
export type ApplicationUserTwoFactor_max_fields = {
  __typename?: 'ApplicationUserTwoFactor_max_fields';
  codes?: string;
  createdAt?: string;
  email?: string;
  id?: string;
};

/** aggregate min on columns */
export type ApplicationUserTwoFactor_min_fields = {
  __typename?: 'ApplicationUserTwoFactor_min_fields';
  codes?: string;
  createdAt?: string;
  email?: string;
  id?: string;
};

/** response of any mutation on the table "qx.ApplicationUserTwoFactor" */
export type ApplicationUserTwoFactor_mutation_response = {
  __typename?: 'ApplicationUserTwoFactor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<ApplicationUserTwoFactor>;
};

/** input type for inserting object relation for remote table "qx.ApplicationUserTwoFactor" */
export type ApplicationUserTwoFactor_obj_rel_insert_input = {
  data: ApplicationUserTwoFactor_insert_input;
  /** upsert condition */
  on_conflict?: ApplicationUserTwoFactor_on_conflict;
};

/** on_conflict condition type for table "qx.ApplicationUserTwoFactor" */
export type ApplicationUserTwoFactor_on_conflict = {
  constraint: ApplicationUserTwoFactor_constraint;
  update_columns?: Array<ApplicationUserTwoFactor_update_column>;
  where?: ApplicationUserTwoFactor_bool_exp;
};

/** Ordering options when selecting data from "qx.ApplicationUserTwoFactor". */
export type ApplicationUserTwoFactor_order_by = {
  codes?: order_by;
  createdAt?: order_by;
  email?: order_by;
  id?: order_by;
  verified?: order_by;
};

/** primary key columns input for table: qx.ApplicationUserTwoFactor */
export type ApplicationUserTwoFactor_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.ApplicationUserTwoFactor" */
export enum ApplicationUserTwoFactor_select_column {
  /** column name */
  codes = 'codes',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  email = 'email',
  /** column name */
  id = 'id',
  /** column name */
  verified = 'verified'
}

/** input type for updating data in table "qx.ApplicationUserTwoFactor" */
export type ApplicationUserTwoFactor_set_input = {
  codes?: string;
  createdAt?: string;
  email?: string;
  id?: string;
  verified?: boolean;
};

/** Streaming cursor of the table "ApplicationUserTwoFactor" */
export type ApplicationUserTwoFactor_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: ApplicationUserTwoFactor_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type ApplicationUserTwoFactor_stream_cursor_value_input = {
  codes?: string;
  createdAt?: string;
  email?: string;
  id?: string;
  verified?: boolean;
};

/** update columns of table "qx.ApplicationUserTwoFactor" */
export enum ApplicationUserTwoFactor_update_column {
  /** column name */
  codes = 'codes',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  email = 'email',
  /** column name */
  id = 'id',
  /** column name */
  verified = 'verified'
}

export type ApplicationUserTwoFactor_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: ApplicationUserTwoFactor_set_input;
  /** filter the rows which have to be updated */
  where: ApplicationUserTwoFactor_bool_exp;
};

export type AuthSession = {
  __typename?: 'AuthSession';
  authDevice?: string;
  current: boolean;
  device?: AuthSessionDevice;
  expiresAt: string;
  id: string;
  ip: string;
  lastUsed: string;
  location?: AuthSessionLocation;
  signedInAt: string;
  strategy: AuthStrategy;
  type: SessionType;
};

export type AuthSessionDevice = {
  __typename?: 'AuthSessionDevice';
  client: AuthSessionDeviceClient;
  device: AuthSessionDeviceInfo;
  os: AuthSessionDeviceOS;
};

export type AuthSessionDeviceClient = {
  __typename?: 'AuthSessionDeviceClient';
  engine?: string;
  engine_version?: string;
  family?: string;
  name?: string;
  short_name?: string;
  type?: string;
  version?: string;
};

export type AuthSessionDeviceInfo = {
  __typename?: 'AuthSessionDeviceInfo';
  brand?: string;
  id?: string;
  model?: string;
  type?: string;
};

export type AuthSessionDeviceOS = {
  __typename?: 'AuthSessionDeviceOS';
  family?: string;
  name?: string;
  platform?: string;
  short_name?: string;
  version?: string;
};

export type AuthSessionLocation = {
  __typename?: 'AuthSessionLocation';
  city?: string;
  country?: string;
  countryCode?: string;
  isVPN?: boolean;
};

export enum AuthStrategy {
  Firebase = 'Firebase',
  MagicCode = 'MagicCode',
  Microsoft = 'Microsoft',
  OAuth = 'OAuth',
  Password = 'Password',
  Register = 'Register',
  TOTP = 'TOTP',
  WebAuthn = 'WebAuthn'
}

export type AxisBodyWornUser = {
  __typename?: 'AxisBodyWornUser';
  id: string;
  name: string;
};

export type BackupCodes = {
  __typename?: 'BackupCodes';
  codes?: Array<string>;
  createdAt: string;
};

export type BandwidthMetricResponse = {
  __typename?: 'BandwidthMetricResponse';
  nic: string;
  received?: Array<Metric>;
  transmitted?: Array<Metric>;
  unitOfMeasure: string;
  unitOfTime: string;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_comparison_exp = {
  _eq?: boolean;
  _gt?: boolean;
  _gte?: boolean;
  _in?: Array<boolean>;
  _is_null?: boolean;
  _lt?: boolean;
  _lte?: boolean;
  _neq?: boolean;
  _nin?: Array<boolean>;
};

export type ClipUrlOutput = {
  __typename?: 'ClipUrlOutput';
  base64?: string;
  expiresAt: string;
  url: string;
};

export type CpuStat = {
  __typename?: 'CpuStat';
  time?: string;
  total?: string;
  used?: string;
};

export type CreateDeviceInput = {
  address: string;
  controllerGateway?: string;
  controllerSubnet?: string;
  createdAt?: string;
  description?: string;
  dst?: boolean;
  dynamicDNSServers?: any;
  dynamicNTPServers?: any;
  firmware?: string;
  gatewayID: string;
  hostname?: string;
  installerAccessCode?: string;
  integrationAccessCode?: string;
  integrationKey?: string;
  kind: string;
  mac?: string;
  make?: string;
  masterAccessCode?: string;
  meta?: any;
  model?: string;
  name: string;
  ntp?: boolean;
  pacsBlob?: string;
  pacsConfigurationID?: string;
  pacsUpdate?: string;
  pacsUpdateTime?: string;
  password: string;
  port?: number;
  scriptArgs?: string;
  scriptExecTime?: string;
  scriptID?: string;
  serial?: string;
  staticDNSServers?: any;
  staticNTPServers?: any;
  timezone?: string;
  tls?: boolean;
  updatedAt?: string;
  username: string;
};

export type CreateDeviceOutput = {
  __typename?: 'CreateDeviceOutput';
  address: string;
  connectionStatus: string;
  description?: string;
  /** An array relationship */
  doors: Array<qx_Door>;
  /** An aggregate relationship */
  doors_aggregate: qx_Door_aggregate;
  firmware?: string;
  gatewayID: string;
  id: string;
  kind: string;
  mac?: string;
  make?: string;
  model?: string;
  name: string;
  pacsConfigurationID?: string;
  password: string;
  port: string;
  serial?: string;
  tls: string;
  username: string;
  /** An array relationship */
  videoSources: Array<qx_VideoSource>;
  /** An aggregate relationship */
  videoSources_aggregate: qx_VideoSource_aggregate;
};


export type CreateDeviceOutputdoorsArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


export type CreateDeviceOutputdoors_aggregateArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


export type CreateDeviceOutputvideoSourcesArgs = {
  distinct_on?: Array<qx_VideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_VideoSource_order_by>;
  where?: qx_VideoSource_bool_exp;
};


export type CreateDeviceOutputvideoSources_aggregateArgs = {
  distinct_on?: Array<qx_VideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_VideoSource_order_by>;
  where?: qx_VideoSource_bool_exp;
};

export enum CredentialOrderByEnum {
  asc = 'asc',
  desc = 'desc'
}

export type CredentialOrderByInput = {
  createdAt?: CredentialOrderByEnum;
  enabled?: CredentialOrderByEnum;
  pin?: CredentialOrderByEnum;
  status?: CredentialOrderByEnum;
  updatedAt?: CredentialOrderByEnum;
  validFrom?: CredentialOrderByEnum;
  validTo?: CredentialOrderByEnum;
  value?: CredentialOrderByEnum;
};

export type CredentialSearchOutput = {
  __typename?: 'CredentialSearchOutput';
  credentials: Array<CredentialSearchRow>;
  totalCount: number;
};

export type CredentialSearchRow = {
  __typename?: 'CredentialSearchRow';
  enabled: boolean;
  extendedTimeEnabled: boolean;
  /** the gateways an OSS card reaches; empty for every other credential type */
  gatewayIDs: Array<string>;
  id: string;
  ossPayload?: string;
  personID: string;
  pin?: string;
  reason?: string;
  status?: string;
  type: string;
  validFrom?: string;
  validTo?: string;
  value: string;
};

export type DIOType = {
  __typename?: 'DIOType';
  channel: number;
  defaultState: string;
  id: string;
  name: string;
  supervise: string;
  type: string;
};

/** Additional connection details needed for DSC devices */
export type DSCConnection = {
  __typename?: 'DSCConnection';
  /** An object relationship */
  Device: qx_Device;
  /** A computed field, executes function "qx.get_dsc_installer_access_code" */
  decryptedInstallerAccessCode?: string;
  /** A computed field, executes function "qx.get_dsc_integration_access_code" */
  decryptedIntegrationAccessCode?: string;
  /** A computed field, executes function "qx.get_dsc_master_access_code" */
  decryptedMasterAccessCode?: string;
  deviceID: string;
  installerAccessCode: string;
  integrationAccessCode: string;
  integrationKey: string;
  masterAccessCode: string;
};

/** aggregated selection of "qx.DSCConnection" */
export type DSCConnection_aggregate = {
  __typename?: 'DSCConnection_aggregate';
  aggregate?: DSCConnection_aggregate_fields;
  nodes: Array<DSCConnection>;
};

export type DSCConnection_aggregate_bool_exp = {
  count?: DSCConnection_aggregate_bool_exp_count;
};

export type DSCConnection_aggregate_bool_exp_count = {
  arguments?: Array<DSCConnection_select_column>;
  distinct?: boolean;
  filter?: DSCConnection_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.DSCConnection" */
export type DSCConnection_aggregate_fields = {
  __typename?: 'DSCConnection_aggregate_fields';
  count: number;
  max?: DSCConnection_max_fields;
  min?: DSCConnection_min_fields;
};


/** aggregate fields of "qx.DSCConnection" */
export type DSCConnection_aggregate_fieldscountArgs = {
  columns?: Array<DSCConnection_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.DSCConnection" */
export type DSCConnection_aggregate_order_by = {
  count?: order_by;
  max?: DSCConnection_max_order_by;
  min?: DSCConnection_min_order_by;
};

/** input type for inserting array relation for remote table "qx.DSCConnection" */
export type DSCConnection_arr_rel_insert_input = {
  data: Array<DSCConnection_insert_input>;
  /** upsert condition */
  on_conflict?: DSCConnection_on_conflict;
};

/** Boolean expression to filter rows from the table "qx.DSCConnection". All fields are combined with a logical 'AND'. */
export type DSCConnection_bool_exp = {
  Device?: qx_Device_bool_exp;
  _and?: Array<DSCConnection_bool_exp>;
  _not?: DSCConnection_bool_exp;
  _or?: Array<DSCConnection_bool_exp>;
  decryptedInstallerAccessCode?: String_comparison_exp;
  decryptedIntegrationAccessCode?: String_comparison_exp;
  decryptedMasterAccessCode?: String_comparison_exp;
  deviceID?: String_comparison_exp;
  installerAccessCode?: String_comparison_exp;
  integrationAccessCode?: String_comparison_exp;
  integrationKey?: String_comparison_exp;
  masterAccessCode?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.DSCConnection" */
export enum DSCConnection_constraint {
  /** unique or primary key constraint on columns "deviceID" */
  DSCConnection_pkey = 'DSCConnection_pkey'
}

/** input type for inserting data into table "qx.DSCConnection" */
export type DSCConnection_insert_input = {
  Device?: qx_Device_obj_rel_insert_input;
  deviceID?: string;
  installerAccessCode?: string;
  integrationAccessCode?: string;
  integrationKey?: string;
  masterAccessCode?: string;
};

/** aggregate max on columns */
export type DSCConnection_max_fields = {
  __typename?: 'DSCConnection_max_fields';
  /** A computed field, executes function "qx.get_dsc_installer_access_code" */
  decryptedInstallerAccessCode?: string;
  /** A computed field, executes function "qx.get_dsc_integration_access_code" */
  decryptedIntegrationAccessCode?: string;
  /** A computed field, executes function "qx.get_dsc_master_access_code" */
  decryptedMasterAccessCode?: string;
  deviceID?: string;
  installerAccessCode?: string;
  integrationAccessCode?: string;
  integrationKey?: string;
  masterAccessCode?: string;
};

/** order by max() on columns of table "qx.DSCConnection" */
export type DSCConnection_max_order_by = {
  deviceID?: order_by;
  installerAccessCode?: order_by;
  integrationAccessCode?: order_by;
  integrationKey?: order_by;
  masterAccessCode?: order_by;
};

/** aggregate min on columns */
export type DSCConnection_min_fields = {
  __typename?: 'DSCConnection_min_fields';
  /** A computed field, executes function "qx.get_dsc_installer_access_code" */
  decryptedInstallerAccessCode?: string;
  /** A computed field, executes function "qx.get_dsc_integration_access_code" */
  decryptedIntegrationAccessCode?: string;
  /** A computed field, executes function "qx.get_dsc_master_access_code" */
  decryptedMasterAccessCode?: string;
  deviceID?: string;
  installerAccessCode?: string;
  integrationAccessCode?: string;
  integrationKey?: string;
  masterAccessCode?: string;
};

/** order by min() on columns of table "qx.DSCConnection" */
export type DSCConnection_min_order_by = {
  deviceID?: order_by;
  installerAccessCode?: order_by;
  integrationAccessCode?: order_by;
  integrationKey?: order_by;
  masterAccessCode?: order_by;
};

/** response of any mutation on the table "qx.DSCConnection" */
export type DSCConnection_mutation_response = {
  __typename?: 'DSCConnection_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<DSCConnection>;
};

/** on_conflict condition type for table "qx.DSCConnection" */
export type DSCConnection_on_conflict = {
  constraint: DSCConnection_constraint;
  update_columns?: Array<DSCConnection_update_column>;
  where?: DSCConnection_bool_exp;
};

/** Ordering options when selecting data from "qx.DSCConnection". */
export type DSCConnection_order_by = {
  Device?: qx_Device_order_by;
  decryptedInstallerAccessCode?: order_by;
  decryptedIntegrationAccessCode?: order_by;
  decryptedMasterAccessCode?: order_by;
  deviceID?: order_by;
  installerAccessCode?: order_by;
  integrationAccessCode?: order_by;
  integrationKey?: order_by;
  masterAccessCode?: order_by;
};

/** primary key columns input for table: qx.DSCConnection */
export type DSCConnection_pk_columns_input = {
  deviceID: string;
};

/** select columns of table "qx.DSCConnection" */
export enum DSCConnection_select_column {
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  installerAccessCode = 'installerAccessCode',
  /** column name */
  integrationAccessCode = 'integrationAccessCode',
  /** column name */
  integrationKey = 'integrationKey',
  /** column name */
  masterAccessCode = 'masterAccessCode'
}

/** input type for updating data in table "qx.DSCConnection" */
export type DSCConnection_set_input = {
  deviceID?: string;
  installerAccessCode?: string;
  integrationAccessCode?: string;
  integrationKey?: string;
  masterAccessCode?: string;
};

/** Streaming cursor of the table "DSCConnection" */
export type DSCConnection_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: DSCConnection_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type DSCConnection_stream_cursor_value_input = {
  deviceID?: string;
  installerAccessCode?: string;
  integrationAccessCode?: string;
  integrationKey?: string;
  masterAccessCode?: string;
};

/** update columns of table "qx.DSCConnection" */
export enum DSCConnection_update_column {
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  installerAccessCode = 'installerAccessCode',
  /** column name */
  integrationAccessCode = 'integrationAccessCode',
  /** column name */
  integrationKey = 'integrationKey',
  /** column name */
  masterAccessCode = 'masterAccessCode'
}

export type DSCConnection_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: DSCConnection_set_input;
  /** filter the rows which have to be updated */
  where: DSCConnection_bool_exp;
};

export type DeleteDeviceVideoDataOutput = {
  __typename?: 'DeleteDeviceVideoDataOutput';
  status: string;
};

export type DiscoveredDevice = {
  __typename?: 'DiscoveredDevice';
  addresses: any;
  discoveryDriver: string;
  firmwareVersion?: string;
  hardwareID?: string;
  location?: string;
  mac?: string;
  model?: string;
  name?: string;
  networkInterfaceAddress: string;
  networkInterfaceName: string;
  profiles?: Array<string>;
  scopes?: Array<string>;
  serialNumber?: string;
  type: string;
  utcDateTime?: string;
  vendor?: string;
  webServices?: Array<string>;
};

export enum DiscoveryType {
  /** arp scan */
  Arp = 'Arp',
  /** mercury scan */
  Mercury = 'Mercury',
  /** onvif scan */
  Onvif = 'Onvif',
  /** rosslare scan */
  Rosslare = 'Rosslare',
  /** Sensor scan */
  Sensor = 'Sensor'
}

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_comparison_exp = {
  _eq?: number;
  _gt?: number;
  _gte?: number;
  _in?: Array<number>;
  _is_null?: boolean;
  _lt?: number;
  _lte?: number;
  _neq?: number;
  _nin?: Array<number>;
};

export type FlowAction = {
  __typename?: 'FlowAction';
  arguments?: Array<string>;
  environments: Array<string>;
  name: string;
};

export type FlowEvent = {
  __typename?: 'FlowEvent';
  computed?: Array<string>;
  delete?: Array<string>;
  insert?: Array<string>;
  name: string;
  relationships?: Array<string>;
  table: string;
  update?: Array<string>;
};

export type GetSharedLinkUrlOutput = {
  __typename?: 'GetSharedLinkUrlOutput';
  expiresAt?: string;
  linkableID: string;
  linkableType: string;
  url: string;
};

export type IceServerInput = {
  credential?: string;
  urls: Array<string>;
  username?: string;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_array_comparison_exp = {
  /** is the array contained in the given array value */
  _contained_in?: Array<number>;
  /** does the array contain the given value */
  _contains?: Array<number>;
  _eq?: Array<number>;
  _gt?: Array<number>;
  _gte?: Array<number>;
  _in?: InputMaybe<Array<Array<number>>>;
  _is_null?: boolean;
  _lt?: Array<number>;
  _lte?: Array<number>;
  _neq?: Array<number>;
  _nin?: InputMaybe<Array<Array<number>>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_comparison_exp = {
  _eq?: number;
  _gt?: number;
  _gte?: number;
  _in?: Array<number>;
  _is_null?: boolean;
  _lt?: number;
  _lte?: number;
  _neq?: number;
  _nin?: Array<number>;
};

/** Stores the access code for a person on an intrusion device */
export type IntrusionAccessCode = {
  __typename?: 'IntrusionAccessCode';
  /** An object relationship */
  Person: qx_Person;
  canBypass: boolean;
  code: number;
  enabled: boolean;
  id: string;
  index?: number;
  isDuress: boolean;
  isSupervisor: boolean;
  oneTime: boolean;
  personID: string;
  remoteAccessEnabled: boolean;
};

/** aggregated selection of "qx.IntrusionAccessCode" */
export type IntrusionAccessCode_aggregate = {
  __typename?: 'IntrusionAccessCode_aggregate';
  aggregate?: IntrusionAccessCode_aggregate_fields;
  nodes: Array<IntrusionAccessCode>;
};

export type IntrusionAccessCode_aggregate_bool_exp = {
  bool_and?: IntrusionAccessCode_aggregate_bool_exp_bool_and;
  bool_or?: IntrusionAccessCode_aggregate_bool_exp_bool_or;
  count?: IntrusionAccessCode_aggregate_bool_exp_count;
};

export type IntrusionAccessCode_aggregate_bool_exp_bool_and = {
  arguments: IntrusionAccessCode_select_column_IntrusionAccessCode_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: IntrusionAccessCode_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type IntrusionAccessCode_aggregate_bool_exp_bool_or = {
  arguments: IntrusionAccessCode_select_column_IntrusionAccessCode_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: IntrusionAccessCode_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type IntrusionAccessCode_aggregate_bool_exp_count = {
  arguments?: Array<IntrusionAccessCode_select_column>;
  distinct?: boolean;
  filter?: IntrusionAccessCode_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.IntrusionAccessCode" */
export type IntrusionAccessCode_aggregate_fields = {
  __typename?: 'IntrusionAccessCode_aggregate_fields';
  avg?: IntrusionAccessCode_avg_fields;
  count: number;
  max?: IntrusionAccessCode_max_fields;
  min?: IntrusionAccessCode_min_fields;
  stddev?: IntrusionAccessCode_stddev_fields;
  stddev_pop?: IntrusionAccessCode_stddev_pop_fields;
  stddev_samp?: IntrusionAccessCode_stddev_samp_fields;
  sum?: IntrusionAccessCode_sum_fields;
  var_pop?: IntrusionAccessCode_var_pop_fields;
  var_samp?: IntrusionAccessCode_var_samp_fields;
  variance?: IntrusionAccessCode_variance_fields;
};


/** aggregate fields of "qx.IntrusionAccessCode" */
export type IntrusionAccessCode_aggregate_fieldscountArgs = {
  columns?: Array<IntrusionAccessCode_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.IntrusionAccessCode" */
export type IntrusionAccessCode_aggregate_order_by = {
  avg?: IntrusionAccessCode_avg_order_by;
  count?: order_by;
  max?: IntrusionAccessCode_max_order_by;
  min?: IntrusionAccessCode_min_order_by;
  stddev?: IntrusionAccessCode_stddev_order_by;
  stddev_pop?: IntrusionAccessCode_stddev_pop_order_by;
  stddev_samp?: IntrusionAccessCode_stddev_samp_order_by;
  sum?: IntrusionAccessCode_sum_order_by;
  var_pop?: IntrusionAccessCode_var_pop_order_by;
  var_samp?: IntrusionAccessCode_var_samp_order_by;
  variance?: IntrusionAccessCode_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.IntrusionAccessCode" */
export type IntrusionAccessCode_arr_rel_insert_input = {
  data: Array<IntrusionAccessCode_insert_input>;
  /** upsert condition */
  on_conflict?: IntrusionAccessCode_on_conflict;
};

/** aggregate avg on columns */
export type IntrusionAccessCode_avg_fields = {
  __typename?: 'IntrusionAccessCode_avg_fields';
  code?: number;
  index?: number;
};

/** order by avg() on columns of table "qx.IntrusionAccessCode" */
export type IntrusionAccessCode_avg_order_by = {
  code?: order_by;
  index?: order_by;
};

/** Boolean expression to filter rows from the table "qx.IntrusionAccessCode". All fields are combined with a logical 'AND'. */
export type IntrusionAccessCode_bool_exp = {
  Person?: qx_Person_bool_exp;
  _and?: Array<IntrusionAccessCode_bool_exp>;
  _not?: IntrusionAccessCode_bool_exp;
  _or?: Array<IntrusionAccessCode_bool_exp>;
  canBypass?: Boolean_comparison_exp;
  code?: Int_comparison_exp;
  enabled?: Boolean_comparison_exp;
  id?: String_comparison_exp;
  index?: Int_comparison_exp;
  isDuress?: Boolean_comparison_exp;
  isSupervisor?: Boolean_comparison_exp;
  oneTime?: Boolean_comparison_exp;
  personID?: String_comparison_exp;
  remoteAccessEnabled?: Boolean_comparison_exp;
};

/** unique or primary key constraints on table "qx.IntrusionAccessCode" */
export enum IntrusionAccessCode_constraint {
  /** unique or primary key constraint on columns "id" */
  IntrusionAccessCode_pkey = 'IntrusionAccessCode_pkey'
}

/** input type for incrementing numeric columns in table "qx.IntrusionAccessCode" */
export type IntrusionAccessCode_inc_input = {
  code?: number;
  index?: number;
};

/** input type for inserting data into table "qx.IntrusionAccessCode" */
export type IntrusionAccessCode_insert_input = {
  Person?: qx_Person_obj_rel_insert_input;
  canBypass?: boolean;
  code?: number;
  enabled?: boolean;
  id?: string;
  index?: number;
  isDuress?: boolean;
  isSupervisor?: boolean;
  oneTime?: boolean;
  personID?: string;
  remoteAccessEnabled?: boolean;
};

/** aggregate max on columns */
export type IntrusionAccessCode_max_fields = {
  __typename?: 'IntrusionAccessCode_max_fields';
  code?: number;
  id?: string;
  index?: number;
  personID?: string;
};

/** order by max() on columns of table "qx.IntrusionAccessCode" */
export type IntrusionAccessCode_max_order_by = {
  code?: order_by;
  id?: order_by;
  index?: order_by;
  personID?: order_by;
};

/** aggregate min on columns */
export type IntrusionAccessCode_min_fields = {
  __typename?: 'IntrusionAccessCode_min_fields';
  code?: number;
  id?: string;
  index?: number;
  personID?: string;
};

/** order by min() on columns of table "qx.IntrusionAccessCode" */
export type IntrusionAccessCode_min_order_by = {
  code?: order_by;
  id?: order_by;
  index?: order_by;
  personID?: order_by;
};

/** response of any mutation on the table "qx.IntrusionAccessCode" */
export type IntrusionAccessCode_mutation_response = {
  __typename?: 'IntrusionAccessCode_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<IntrusionAccessCode>;
};

/** on_conflict condition type for table "qx.IntrusionAccessCode" */
export type IntrusionAccessCode_on_conflict = {
  constraint: IntrusionAccessCode_constraint;
  update_columns?: Array<IntrusionAccessCode_update_column>;
  where?: IntrusionAccessCode_bool_exp;
};

/** Ordering options when selecting data from "qx.IntrusionAccessCode". */
export type IntrusionAccessCode_order_by = {
  Person?: qx_Person_order_by;
  canBypass?: order_by;
  code?: order_by;
  enabled?: order_by;
  id?: order_by;
  index?: order_by;
  isDuress?: order_by;
  isSupervisor?: order_by;
  oneTime?: order_by;
  personID?: order_by;
  remoteAccessEnabled?: order_by;
};

/** primary key columns input for table: qx.IntrusionAccessCode */
export type IntrusionAccessCode_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.IntrusionAccessCode" */
export enum IntrusionAccessCode_select_column {
  /** column name */
  canBypass = 'canBypass',
  /** column name */
  code = 'code',
  /** column name */
  enabled = 'enabled',
  /** column name */
  id = 'id',
  /** column name */
  index = 'index',
  /** column name */
  isDuress = 'isDuress',
  /** column name */
  isSupervisor = 'isSupervisor',
  /** column name */
  oneTime = 'oneTime',
  /** column name */
  personID = 'personID',
  /** column name */
  remoteAccessEnabled = 'remoteAccessEnabled'
}

/** select "IntrusionAccessCode_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.IntrusionAccessCode" */
export enum IntrusionAccessCode_select_column_IntrusionAccessCode_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  canBypass = 'canBypass',
  /** column name */
  enabled = 'enabled',
  /** column name */
  isDuress = 'isDuress',
  /** column name */
  isSupervisor = 'isSupervisor',
  /** column name */
  oneTime = 'oneTime',
  /** column name */
  remoteAccessEnabled = 'remoteAccessEnabled'
}

/** select "IntrusionAccessCode_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.IntrusionAccessCode" */
export enum IntrusionAccessCode_select_column_IntrusionAccessCode_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  canBypass = 'canBypass',
  /** column name */
  enabled = 'enabled',
  /** column name */
  isDuress = 'isDuress',
  /** column name */
  isSupervisor = 'isSupervisor',
  /** column name */
  oneTime = 'oneTime',
  /** column name */
  remoteAccessEnabled = 'remoteAccessEnabled'
}

/** input type for updating data in table "qx.IntrusionAccessCode" */
export type IntrusionAccessCode_set_input = {
  canBypass?: boolean;
  code?: number;
  enabled?: boolean;
  id?: string;
  index?: number;
  isDuress?: boolean;
  isSupervisor?: boolean;
  oneTime?: boolean;
  personID?: string;
  remoteAccessEnabled?: boolean;
};

/** aggregate stddev on columns */
export type IntrusionAccessCode_stddev_fields = {
  __typename?: 'IntrusionAccessCode_stddev_fields';
  code?: number;
  index?: number;
};

/** order by stddev() on columns of table "qx.IntrusionAccessCode" */
export type IntrusionAccessCode_stddev_order_by = {
  code?: order_by;
  index?: order_by;
};

/** aggregate stddev_pop on columns */
export type IntrusionAccessCode_stddev_pop_fields = {
  __typename?: 'IntrusionAccessCode_stddev_pop_fields';
  code?: number;
  index?: number;
};

/** order by stddev_pop() on columns of table "qx.IntrusionAccessCode" */
export type IntrusionAccessCode_stddev_pop_order_by = {
  code?: order_by;
  index?: order_by;
};

/** aggregate stddev_samp on columns */
export type IntrusionAccessCode_stddev_samp_fields = {
  __typename?: 'IntrusionAccessCode_stddev_samp_fields';
  code?: number;
  index?: number;
};

/** order by stddev_samp() on columns of table "qx.IntrusionAccessCode" */
export type IntrusionAccessCode_stddev_samp_order_by = {
  code?: order_by;
  index?: order_by;
};

/** Streaming cursor of the table "IntrusionAccessCode" */
export type IntrusionAccessCode_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: IntrusionAccessCode_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type IntrusionAccessCode_stream_cursor_value_input = {
  canBypass?: boolean;
  code?: number;
  enabled?: boolean;
  id?: string;
  index?: number;
  isDuress?: boolean;
  isSupervisor?: boolean;
  oneTime?: boolean;
  personID?: string;
  remoteAccessEnabled?: boolean;
};

/** aggregate sum on columns */
export type IntrusionAccessCode_sum_fields = {
  __typename?: 'IntrusionAccessCode_sum_fields';
  code?: number;
  index?: number;
};

/** order by sum() on columns of table "qx.IntrusionAccessCode" */
export type IntrusionAccessCode_sum_order_by = {
  code?: order_by;
  index?: order_by;
};

/** update columns of table "qx.IntrusionAccessCode" */
export enum IntrusionAccessCode_update_column {
  /** column name */
  canBypass = 'canBypass',
  /** column name */
  code = 'code',
  /** column name */
  enabled = 'enabled',
  /** column name */
  id = 'id',
  /** column name */
  index = 'index',
  /** column name */
  isDuress = 'isDuress',
  /** column name */
  isSupervisor = 'isSupervisor',
  /** column name */
  oneTime = 'oneTime',
  /** column name */
  personID = 'personID',
  /** column name */
  remoteAccessEnabled = 'remoteAccessEnabled'
}

export type IntrusionAccessCode_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: IntrusionAccessCode_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: IntrusionAccessCode_set_input;
  /** filter the rows which have to be updated */
  where: IntrusionAccessCode_bool_exp;
};

/** aggregate var_pop on columns */
export type IntrusionAccessCode_var_pop_fields = {
  __typename?: 'IntrusionAccessCode_var_pop_fields';
  code?: number;
  index?: number;
};

/** order by var_pop() on columns of table "qx.IntrusionAccessCode" */
export type IntrusionAccessCode_var_pop_order_by = {
  code?: order_by;
  index?: order_by;
};

/** aggregate var_samp on columns */
export type IntrusionAccessCode_var_samp_fields = {
  __typename?: 'IntrusionAccessCode_var_samp_fields';
  code?: number;
  index?: number;
};

/** order by var_samp() on columns of table "qx.IntrusionAccessCode" */
export type IntrusionAccessCode_var_samp_order_by = {
  code?: order_by;
  index?: order_by;
};

/** aggregate variance on columns */
export type IntrusionAccessCode_variance_fields = {
  __typename?: 'IntrusionAccessCode_variance_fields';
  code?: number;
  index?: number;
};

/** order by variance() on columns of table "qx.IntrusionAccessCode" */
export type IntrusionAccessCode_variance_order_by = {
  code?: order_by;
  index?: order_by;
};

export enum IntrusionArmMode {
  AwayArmed = 'AwayArmed',
  Disarmed = 'Disarmed',
  NightModeArmed = 'NightModeArmed',
  StayArmed = 'StayArmed'
}

/** sectioned-off portion of an intrusion system that can be operated independently from the rest of the system, containing multiple zones */
export type IntrusionPartition = {
  __typename?: 'IntrusionPartition';
  /** An object relationship */
  Device: qx_Device;
  /** An array relationship */
  PartitionZoneAssignments: Array<PartitionZoneAssignments>;
  /** An aggregate relationship */
  PartitionZoneAssignments_aggregate: PartitionZoneAssignments_aggregate;
  /** An object relationship */
  Place: qx_Place;
  /** An object relationship */
  VideoSource?: qx_VideoSource;
  alarm: number;
  /** A computed field, executes function "qx.get_partition_alarm_values" */
  alarmValues?: any;
  /** A computed field, executes function "qx.can_arm_partition" */
  canArm?: boolean;
  /** A computed field, executes function "qx.can_disarm_partition" */
  canDisarm?: boolean;
  /** A computed field, executes function "qx.can_operate_intrusion_partition" */
  canOperate?: boolean;
  chimeEnabled: boolean;
  defaultVideoSourceID?: string;
  description?: string;
  deviceID: string;
  enabled: boolean;
  id: string;
  index: number;
  name: string;
  placeID: string;
  /** An array relationship */
  privileges: Array<personIntrusionPartitionAppPrivileges>;
  /** An aggregate relationship */
  privileges_aggregate: personIntrusionPartitionAppPrivileges_aggregate;
  state: number;
  /** A computed field, executes function "qx.get_partition_state_values" */
  stateValues?: any;
  updatedAt: string;
};


/** sectioned-off portion of an intrusion system that can be operated independently from the rest of the system, containing multiple zones */
export type IntrusionPartitionPartitionZoneAssignmentsArgs = {
  distinct_on?: Array<PartitionZoneAssignments_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<PartitionZoneAssignments_order_by>;
  where?: PartitionZoneAssignments_bool_exp;
};


/** sectioned-off portion of an intrusion system that can be operated independently from the rest of the system, containing multiple zones */
export type IntrusionPartitionPartitionZoneAssignments_aggregateArgs = {
  distinct_on?: Array<PartitionZoneAssignments_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<PartitionZoneAssignments_order_by>;
  where?: PartitionZoneAssignments_bool_exp;
};


/** sectioned-off portion of an intrusion system that can be operated independently from the rest of the system, containing multiple zones */
export type IntrusionPartitionalarmValuesArgs = {
  path?: string;
};


/** sectioned-off portion of an intrusion system that can be operated independently from the rest of the system, containing multiple zones */
export type IntrusionPartitionprivilegesArgs = {
  distinct_on?: Array<personIntrusionPartitionAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personIntrusionPartitionAppPrivileges_order_by>;
  where?: personIntrusionPartitionAppPrivileges_bool_exp;
};


/** sectioned-off portion of an intrusion system that can be operated independently from the rest of the system, containing multiple zones */
export type IntrusionPartitionprivileges_aggregateArgs = {
  distinct_on?: Array<personIntrusionPartitionAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personIntrusionPartitionAppPrivileges_order_by>;
  where?: personIntrusionPartitionAppPrivileges_bool_exp;
};


/** sectioned-off portion of an intrusion system that can be operated independently from the rest of the system, containing multiple zones */
export type IntrusionPartitionstateValuesArgs = {
  path?: string;
};

/** aggregated selection of "qx.IntrusionPartition" */
export type IntrusionPartition_aggregate = {
  __typename?: 'IntrusionPartition_aggregate';
  aggregate?: IntrusionPartition_aggregate_fields;
  nodes: Array<IntrusionPartition>;
};

export type IntrusionPartition_aggregate_bool_exp = {
  bool_and?: IntrusionPartition_aggregate_bool_exp_bool_and;
  bool_or?: IntrusionPartition_aggregate_bool_exp_bool_or;
  count?: IntrusionPartition_aggregate_bool_exp_count;
};

export type IntrusionPartition_aggregate_bool_exp_bool_and = {
  arguments: IntrusionPartition_select_column_IntrusionPartition_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: IntrusionPartition_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type IntrusionPartition_aggregate_bool_exp_bool_or = {
  arguments: IntrusionPartition_select_column_IntrusionPartition_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: IntrusionPartition_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type IntrusionPartition_aggregate_bool_exp_count = {
  arguments?: Array<IntrusionPartition_select_column>;
  distinct?: boolean;
  filter?: IntrusionPartition_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.IntrusionPartition" */
export type IntrusionPartition_aggregate_fields = {
  __typename?: 'IntrusionPartition_aggregate_fields';
  avg?: IntrusionPartition_avg_fields;
  count: number;
  max?: IntrusionPartition_max_fields;
  min?: IntrusionPartition_min_fields;
  stddev?: IntrusionPartition_stddev_fields;
  stddev_pop?: IntrusionPartition_stddev_pop_fields;
  stddev_samp?: IntrusionPartition_stddev_samp_fields;
  sum?: IntrusionPartition_sum_fields;
  var_pop?: IntrusionPartition_var_pop_fields;
  var_samp?: IntrusionPartition_var_samp_fields;
  variance?: IntrusionPartition_variance_fields;
};


/** aggregate fields of "qx.IntrusionPartition" */
export type IntrusionPartition_aggregate_fieldscountArgs = {
  columns?: Array<IntrusionPartition_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.IntrusionPartition" */
export type IntrusionPartition_aggregate_order_by = {
  avg?: IntrusionPartition_avg_order_by;
  count?: order_by;
  max?: IntrusionPartition_max_order_by;
  min?: IntrusionPartition_min_order_by;
  stddev?: IntrusionPartition_stddev_order_by;
  stddev_pop?: IntrusionPartition_stddev_pop_order_by;
  stddev_samp?: IntrusionPartition_stddev_samp_order_by;
  sum?: IntrusionPartition_sum_order_by;
  var_pop?: IntrusionPartition_var_pop_order_by;
  var_samp?: IntrusionPartition_var_samp_order_by;
  variance?: IntrusionPartition_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.IntrusionPartition" */
export type IntrusionPartition_arr_rel_insert_input = {
  data: Array<IntrusionPartition_insert_input>;
  /** upsert condition */
  on_conflict?: IntrusionPartition_on_conflict;
};

/** aggregate avg on columns */
export type IntrusionPartition_avg_fields = {
  __typename?: 'IntrusionPartition_avg_fields';
  alarm?: number;
  defaultVideoSourceID?: number;
  index?: number;
  state?: number;
};

/** order by avg() on columns of table "qx.IntrusionPartition" */
export type IntrusionPartition_avg_order_by = {
  alarm?: order_by;
  defaultVideoSourceID?: order_by;
  index?: order_by;
  state?: order_by;
};

/** Boolean expression to filter rows from the table "qx.IntrusionPartition". All fields are combined with a logical 'AND'. */
export type IntrusionPartition_bool_exp = {
  Device?: qx_Device_bool_exp;
  PartitionZoneAssignments?: PartitionZoneAssignments_bool_exp;
  PartitionZoneAssignments_aggregate?: PartitionZoneAssignments_aggregate_bool_exp;
  Place?: qx_Place_bool_exp;
  VideoSource?: qx_VideoSource_bool_exp;
  _and?: Array<IntrusionPartition_bool_exp>;
  _not?: IntrusionPartition_bool_exp;
  _or?: Array<IntrusionPartition_bool_exp>;
  alarm?: Int_comparison_exp;
  alarmValues?: jsonb_comparison_exp;
  canArm?: Boolean_comparison_exp;
  canDisarm?: Boolean_comparison_exp;
  canOperate?: Boolean_comparison_exp;
  chimeEnabled?: Boolean_comparison_exp;
  defaultVideoSourceID?: bigint_comparison_exp;
  description?: String_comparison_exp;
  deviceID?: String_comparison_exp;
  enabled?: Boolean_comparison_exp;
  id?: String_comparison_exp;
  index?: Int_comparison_exp;
  name?: String_comparison_exp;
  placeID?: String_comparison_exp;
  privileges?: personIntrusionPartitionAppPrivileges_bool_exp;
  privileges_aggregate?: personIntrusionPartitionAppPrivileges_aggregate_bool_exp;
  state?: Int_comparison_exp;
  stateValues?: jsonb_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
};

/** unique or primary key constraints on table "qx.IntrusionPartition" */
export enum IntrusionPartition_constraint {
  /** unique or primary key constraint on columns "index", "deviceID" */
  IntrusionPartition_index_deviceID_key = 'IntrusionPartition_index_deviceID_key',
  /** unique or primary key constraint on columns "id" */
  IntrusionPartition_pkey = 'IntrusionPartition_pkey'
}

/** input type for incrementing numeric columns in table "qx.IntrusionPartition" */
export type IntrusionPartition_inc_input = {
  alarm?: number;
  defaultVideoSourceID?: string;
  index?: number;
  state?: number;
};

/** input type for inserting data into table "qx.IntrusionPartition" */
export type IntrusionPartition_insert_input = {
  Device?: qx_Device_obj_rel_insert_input;
  PartitionZoneAssignments?: PartitionZoneAssignments_arr_rel_insert_input;
  Place?: qx_Place_obj_rel_insert_input;
  VideoSource?: qx_VideoSource_obj_rel_insert_input;
  alarm?: number;
  chimeEnabled?: boolean;
  defaultVideoSourceID?: string;
  description?: string;
  deviceID?: string;
  enabled?: boolean;
  id?: string;
  index?: number;
  name?: string;
  placeID?: string;
  privileges?: personIntrusionPartitionAppPrivileges_arr_rel_insert_input;
  state?: number;
  updatedAt?: string;
};

/** aggregate max on columns */
export type IntrusionPartition_max_fields = {
  __typename?: 'IntrusionPartition_max_fields';
  alarm?: number;
  defaultVideoSourceID?: string;
  description?: string;
  deviceID?: string;
  id?: string;
  index?: number;
  name?: string;
  placeID?: string;
  state?: number;
  updatedAt?: string;
};

/** order by max() on columns of table "qx.IntrusionPartition" */
export type IntrusionPartition_max_order_by = {
  alarm?: order_by;
  defaultVideoSourceID?: order_by;
  description?: order_by;
  deviceID?: order_by;
  id?: order_by;
  index?: order_by;
  name?: order_by;
  placeID?: order_by;
  state?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type IntrusionPartition_min_fields = {
  __typename?: 'IntrusionPartition_min_fields';
  alarm?: number;
  defaultVideoSourceID?: string;
  description?: string;
  deviceID?: string;
  id?: string;
  index?: number;
  name?: string;
  placeID?: string;
  state?: number;
  updatedAt?: string;
};

/** order by min() on columns of table "qx.IntrusionPartition" */
export type IntrusionPartition_min_order_by = {
  alarm?: order_by;
  defaultVideoSourceID?: order_by;
  description?: order_by;
  deviceID?: order_by;
  id?: order_by;
  index?: order_by;
  name?: order_by;
  placeID?: order_by;
  state?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.IntrusionPartition" */
export type IntrusionPartition_mutation_response = {
  __typename?: 'IntrusionPartition_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<IntrusionPartition>;
};

/** input type for inserting object relation for remote table "qx.IntrusionPartition" */
export type IntrusionPartition_obj_rel_insert_input = {
  data: IntrusionPartition_insert_input;
  /** upsert condition */
  on_conflict?: IntrusionPartition_on_conflict;
};

/** on_conflict condition type for table "qx.IntrusionPartition" */
export type IntrusionPartition_on_conflict = {
  constraint: IntrusionPartition_constraint;
  update_columns?: Array<IntrusionPartition_update_column>;
  where?: IntrusionPartition_bool_exp;
};

/** Ordering options when selecting data from "qx.IntrusionPartition". */
export type IntrusionPartition_order_by = {
  Device?: qx_Device_order_by;
  PartitionZoneAssignments_aggregate?: PartitionZoneAssignments_aggregate_order_by;
  Place?: qx_Place_order_by;
  VideoSource?: qx_VideoSource_order_by;
  alarm?: order_by;
  alarmValues?: order_by;
  canArm?: order_by;
  canDisarm?: order_by;
  canOperate?: order_by;
  chimeEnabled?: order_by;
  defaultVideoSourceID?: order_by;
  description?: order_by;
  deviceID?: order_by;
  enabled?: order_by;
  id?: order_by;
  index?: order_by;
  name?: order_by;
  placeID?: order_by;
  privileges_aggregate?: personIntrusionPartitionAppPrivileges_aggregate_order_by;
  state?: order_by;
  stateValues?: order_by;
  updatedAt?: order_by;
};

/** primary key columns input for table: qx.IntrusionPartition */
export type IntrusionPartition_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.IntrusionPartition" */
export enum IntrusionPartition_select_column {
  /** column name */
  alarm = 'alarm',
  /** column name */
  chimeEnabled = 'chimeEnabled',
  /** column name */
  defaultVideoSourceID = 'defaultVideoSourceID',
  /** column name */
  description = 'description',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  enabled = 'enabled',
  /** column name */
  id = 'id',
  /** column name */
  index = 'index',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  state = 'state',
  /** column name */
  updatedAt = 'updatedAt'
}

/** select "IntrusionPartition_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.IntrusionPartition" */
export enum IntrusionPartition_select_column_IntrusionPartition_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  chimeEnabled = 'chimeEnabled',
  /** column name */
  enabled = 'enabled'
}

/** select "IntrusionPartition_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.IntrusionPartition" */
export enum IntrusionPartition_select_column_IntrusionPartition_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  chimeEnabled = 'chimeEnabled',
  /** column name */
  enabled = 'enabled'
}

/** input type for updating data in table "qx.IntrusionPartition" */
export type IntrusionPartition_set_input = {
  alarm?: number;
  chimeEnabled?: boolean;
  defaultVideoSourceID?: string;
  description?: string;
  deviceID?: string;
  enabled?: boolean;
  id?: string;
  index?: number;
  name?: string;
  placeID?: string;
  state?: number;
  updatedAt?: string;
};

/** aggregate stddev on columns */
export type IntrusionPartition_stddev_fields = {
  __typename?: 'IntrusionPartition_stddev_fields';
  alarm?: number;
  defaultVideoSourceID?: number;
  index?: number;
  state?: number;
};

/** order by stddev() on columns of table "qx.IntrusionPartition" */
export type IntrusionPartition_stddev_order_by = {
  alarm?: order_by;
  defaultVideoSourceID?: order_by;
  index?: order_by;
  state?: order_by;
};

/** aggregate stddev_pop on columns */
export type IntrusionPartition_stddev_pop_fields = {
  __typename?: 'IntrusionPartition_stddev_pop_fields';
  alarm?: number;
  defaultVideoSourceID?: number;
  index?: number;
  state?: number;
};

/** order by stddev_pop() on columns of table "qx.IntrusionPartition" */
export type IntrusionPartition_stddev_pop_order_by = {
  alarm?: order_by;
  defaultVideoSourceID?: order_by;
  index?: order_by;
  state?: order_by;
};

/** aggregate stddev_samp on columns */
export type IntrusionPartition_stddev_samp_fields = {
  __typename?: 'IntrusionPartition_stddev_samp_fields';
  alarm?: number;
  defaultVideoSourceID?: number;
  index?: number;
  state?: number;
};

/** order by stddev_samp() on columns of table "qx.IntrusionPartition" */
export type IntrusionPartition_stddev_samp_order_by = {
  alarm?: order_by;
  defaultVideoSourceID?: order_by;
  index?: order_by;
  state?: order_by;
};

/** Streaming cursor of the table "IntrusionPartition" */
export type IntrusionPartition_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: IntrusionPartition_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type IntrusionPartition_stream_cursor_value_input = {
  alarm?: number;
  chimeEnabled?: boolean;
  defaultVideoSourceID?: string;
  description?: string;
  deviceID?: string;
  enabled?: boolean;
  id?: string;
  index?: number;
  name?: string;
  placeID?: string;
  state?: number;
  updatedAt?: string;
};

/** aggregate sum on columns */
export type IntrusionPartition_sum_fields = {
  __typename?: 'IntrusionPartition_sum_fields';
  alarm?: number;
  defaultVideoSourceID?: string;
  index?: number;
  state?: number;
};

/** order by sum() on columns of table "qx.IntrusionPartition" */
export type IntrusionPartition_sum_order_by = {
  alarm?: order_by;
  defaultVideoSourceID?: order_by;
  index?: order_by;
  state?: order_by;
};

/** update columns of table "qx.IntrusionPartition" */
export enum IntrusionPartition_update_column {
  /** column name */
  alarm = 'alarm',
  /** column name */
  chimeEnabled = 'chimeEnabled',
  /** column name */
  defaultVideoSourceID = 'defaultVideoSourceID',
  /** column name */
  description = 'description',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  enabled = 'enabled',
  /** column name */
  id = 'id',
  /** column name */
  index = 'index',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  state = 'state',
  /** column name */
  updatedAt = 'updatedAt'
}

export type IntrusionPartition_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: IntrusionPartition_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: IntrusionPartition_set_input;
  /** filter the rows which have to be updated */
  where: IntrusionPartition_bool_exp;
};

/** aggregate var_pop on columns */
export type IntrusionPartition_var_pop_fields = {
  __typename?: 'IntrusionPartition_var_pop_fields';
  alarm?: number;
  defaultVideoSourceID?: number;
  index?: number;
  state?: number;
};

/** order by var_pop() on columns of table "qx.IntrusionPartition" */
export type IntrusionPartition_var_pop_order_by = {
  alarm?: order_by;
  defaultVideoSourceID?: order_by;
  index?: order_by;
  state?: order_by;
};

/** aggregate var_samp on columns */
export type IntrusionPartition_var_samp_fields = {
  __typename?: 'IntrusionPartition_var_samp_fields';
  alarm?: number;
  defaultVideoSourceID?: number;
  index?: number;
  state?: number;
};

/** order by var_samp() on columns of table "qx.IntrusionPartition" */
export type IntrusionPartition_var_samp_order_by = {
  alarm?: order_by;
  defaultVideoSourceID?: order_by;
  index?: order_by;
  state?: order_by;
};

/** aggregate variance on columns */
export type IntrusionPartition_variance_fields = {
  __typename?: 'IntrusionPartition_variance_fields';
  alarm?: number;
  defaultVideoSourceID?: number;
  index?: number;
  state?: number;
};

/** order by variance() on columns of table "qx.IntrusionPartition" */
export type IntrusionPartition_variance_order_by = {
  alarm?: order_by;
  defaultVideoSourceID?: order_by;
  index?: order_by;
  state?: order_by;
};

/** defined, monitored area or volume within an intrusion system where sensors detect unauthorized entry */
export type IntrusionZone = {
  __typename?: 'IntrusionZone';
  /** An object relationship */
  Device: qx_Device;
  /** An array relationship */
  PartitionZoneAssignments: Array<PartitionZoneAssignments>;
  /** An aggregate relationship */
  PartitionZoneAssignments_aggregate: PartitionZoneAssignments_aggregate;
  /** An object relationship */
  Place: qx_Place;
  /** An object relationship */
  VideoSource?: qx_VideoSource;
  alarm: number;
  /** A computed field, executes function "qx.get_zone_alarm_values" */
  alarmValues?: any;
  /** A computed field, executes function "qx.can_bypass_zone" */
  canBypass?: boolean;
  /** A computed field, executes function "qx.can_operate_intrusion_zone" */
  canOperate?: boolean;
  defaultVideoSourceID?: string;
  description?: string;
  deviceID: string;
  /** An object relationship */
  eIntrusionZoneType: qx_eIntrusionZoneType;
  id: string;
  index: number;
  name: string;
  placeID: string;
  state: number;
  /** A computed field, executes function "qx.get_zone_state_values" */
  stateValues?: any;
  type: qx_eIntrusionZoneType_enum;
  updatedAt: string;
};


/** defined, monitored area or volume within an intrusion system where sensors detect unauthorized entry */
export type IntrusionZonePartitionZoneAssignmentsArgs = {
  distinct_on?: Array<PartitionZoneAssignments_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<PartitionZoneAssignments_order_by>;
  where?: PartitionZoneAssignments_bool_exp;
};


/** defined, monitored area or volume within an intrusion system where sensors detect unauthorized entry */
export type IntrusionZonePartitionZoneAssignments_aggregateArgs = {
  distinct_on?: Array<PartitionZoneAssignments_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<PartitionZoneAssignments_order_by>;
  where?: PartitionZoneAssignments_bool_exp;
};


/** defined, monitored area or volume within an intrusion system where sensors detect unauthorized entry */
export type IntrusionZonealarmValuesArgs = {
  path?: string;
};


/** defined, monitored area or volume within an intrusion system where sensors detect unauthorized entry */
export type IntrusionZonestateValuesArgs = {
  path?: string;
};

/** aggregated selection of "qx.IntrusionZone" */
export type IntrusionZone_aggregate = {
  __typename?: 'IntrusionZone_aggregate';
  aggregate?: IntrusionZone_aggregate_fields;
  nodes: Array<IntrusionZone>;
};

export type IntrusionZone_aggregate_bool_exp = {
  count?: IntrusionZone_aggregate_bool_exp_count;
};

export type IntrusionZone_aggregate_bool_exp_count = {
  arguments?: Array<IntrusionZone_select_column>;
  distinct?: boolean;
  filter?: IntrusionZone_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.IntrusionZone" */
export type IntrusionZone_aggregate_fields = {
  __typename?: 'IntrusionZone_aggregate_fields';
  avg?: IntrusionZone_avg_fields;
  count: number;
  max?: IntrusionZone_max_fields;
  min?: IntrusionZone_min_fields;
  stddev?: IntrusionZone_stddev_fields;
  stddev_pop?: IntrusionZone_stddev_pop_fields;
  stddev_samp?: IntrusionZone_stddev_samp_fields;
  sum?: IntrusionZone_sum_fields;
  var_pop?: IntrusionZone_var_pop_fields;
  var_samp?: IntrusionZone_var_samp_fields;
  variance?: IntrusionZone_variance_fields;
};


/** aggregate fields of "qx.IntrusionZone" */
export type IntrusionZone_aggregate_fieldscountArgs = {
  columns?: Array<IntrusionZone_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.IntrusionZone" */
export type IntrusionZone_aggregate_order_by = {
  avg?: IntrusionZone_avg_order_by;
  count?: order_by;
  max?: IntrusionZone_max_order_by;
  min?: IntrusionZone_min_order_by;
  stddev?: IntrusionZone_stddev_order_by;
  stddev_pop?: IntrusionZone_stddev_pop_order_by;
  stddev_samp?: IntrusionZone_stddev_samp_order_by;
  sum?: IntrusionZone_sum_order_by;
  var_pop?: IntrusionZone_var_pop_order_by;
  var_samp?: IntrusionZone_var_samp_order_by;
  variance?: IntrusionZone_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.IntrusionZone" */
export type IntrusionZone_arr_rel_insert_input = {
  data: Array<IntrusionZone_insert_input>;
  /** upsert condition */
  on_conflict?: IntrusionZone_on_conflict;
};

/** aggregate avg on columns */
export type IntrusionZone_avg_fields = {
  __typename?: 'IntrusionZone_avg_fields';
  alarm?: number;
  defaultVideoSourceID?: number;
  index?: number;
  state?: number;
};

/** order by avg() on columns of table "qx.IntrusionZone" */
export type IntrusionZone_avg_order_by = {
  alarm?: order_by;
  defaultVideoSourceID?: order_by;
  index?: order_by;
  state?: order_by;
};

/** Boolean expression to filter rows from the table "qx.IntrusionZone". All fields are combined with a logical 'AND'. */
export type IntrusionZone_bool_exp = {
  Device?: qx_Device_bool_exp;
  PartitionZoneAssignments?: PartitionZoneAssignments_bool_exp;
  PartitionZoneAssignments_aggregate?: PartitionZoneAssignments_aggregate_bool_exp;
  Place?: qx_Place_bool_exp;
  VideoSource?: qx_VideoSource_bool_exp;
  _and?: Array<IntrusionZone_bool_exp>;
  _not?: IntrusionZone_bool_exp;
  _or?: Array<IntrusionZone_bool_exp>;
  alarm?: Int_comparison_exp;
  alarmValues?: jsonb_comparison_exp;
  canBypass?: Boolean_comparison_exp;
  canOperate?: Boolean_comparison_exp;
  defaultVideoSourceID?: bigint_comparison_exp;
  description?: String_comparison_exp;
  deviceID?: String_comparison_exp;
  eIntrusionZoneType?: qx_eIntrusionZoneType_bool_exp;
  id?: String_comparison_exp;
  index?: Int_comparison_exp;
  name?: String_comparison_exp;
  placeID?: String_comparison_exp;
  state?: Int_comparison_exp;
  stateValues?: jsonb_comparison_exp;
  type?: qx_eIntrusionZoneType_enum_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
};

/** unique or primary key constraints on table "qx.IntrusionZone" */
export enum IntrusionZone_constraint {
  /** unique or primary key constraint on columns "index", "deviceID" */
  IntrusionZone_index_deviceID_key = 'IntrusionZone_index_deviceID_key',
  /** unique or primary key constraint on columns "id" */
  IntrusionZone_pkey = 'IntrusionZone_pkey'
}

/** input type for incrementing numeric columns in table "qx.IntrusionZone" */
export type IntrusionZone_inc_input = {
  alarm?: number;
  defaultVideoSourceID?: string;
  index?: number;
  state?: number;
};

/** input type for inserting data into table "qx.IntrusionZone" */
export type IntrusionZone_insert_input = {
  Device?: qx_Device_obj_rel_insert_input;
  PartitionZoneAssignments?: PartitionZoneAssignments_arr_rel_insert_input;
  Place?: qx_Place_obj_rel_insert_input;
  VideoSource?: qx_VideoSource_obj_rel_insert_input;
  alarm?: number;
  defaultVideoSourceID?: string;
  description?: string;
  deviceID?: string;
  eIntrusionZoneType?: qx_eIntrusionZoneType_obj_rel_insert_input;
  id?: string;
  index?: number;
  name?: string;
  placeID?: string;
  state?: number;
  type?: qx_eIntrusionZoneType_enum;
  updatedAt?: string;
};

/** aggregate max on columns */
export type IntrusionZone_max_fields = {
  __typename?: 'IntrusionZone_max_fields';
  alarm?: number;
  defaultVideoSourceID?: string;
  description?: string;
  deviceID?: string;
  id?: string;
  index?: number;
  name?: string;
  placeID?: string;
  state?: number;
  updatedAt?: string;
};

/** order by max() on columns of table "qx.IntrusionZone" */
export type IntrusionZone_max_order_by = {
  alarm?: order_by;
  defaultVideoSourceID?: order_by;
  description?: order_by;
  deviceID?: order_by;
  id?: order_by;
  index?: order_by;
  name?: order_by;
  placeID?: order_by;
  state?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type IntrusionZone_min_fields = {
  __typename?: 'IntrusionZone_min_fields';
  alarm?: number;
  defaultVideoSourceID?: string;
  description?: string;
  deviceID?: string;
  id?: string;
  index?: number;
  name?: string;
  placeID?: string;
  state?: number;
  updatedAt?: string;
};

/** order by min() on columns of table "qx.IntrusionZone" */
export type IntrusionZone_min_order_by = {
  alarm?: order_by;
  defaultVideoSourceID?: order_by;
  description?: order_by;
  deviceID?: order_by;
  id?: order_by;
  index?: order_by;
  name?: order_by;
  placeID?: order_by;
  state?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.IntrusionZone" */
export type IntrusionZone_mutation_response = {
  __typename?: 'IntrusionZone_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<IntrusionZone>;
};

/** input type for inserting object relation for remote table "qx.IntrusionZone" */
export type IntrusionZone_obj_rel_insert_input = {
  data: IntrusionZone_insert_input;
  /** upsert condition */
  on_conflict?: IntrusionZone_on_conflict;
};

/** on_conflict condition type for table "qx.IntrusionZone" */
export type IntrusionZone_on_conflict = {
  constraint: IntrusionZone_constraint;
  update_columns?: Array<IntrusionZone_update_column>;
  where?: IntrusionZone_bool_exp;
};

/** Ordering options when selecting data from "qx.IntrusionZone". */
export type IntrusionZone_order_by = {
  Device?: qx_Device_order_by;
  PartitionZoneAssignments_aggregate?: PartitionZoneAssignments_aggregate_order_by;
  Place?: qx_Place_order_by;
  VideoSource?: qx_VideoSource_order_by;
  alarm?: order_by;
  alarmValues?: order_by;
  canBypass?: order_by;
  canOperate?: order_by;
  defaultVideoSourceID?: order_by;
  description?: order_by;
  deviceID?: order_by;
  eIntrusionZoneType?: qx_eIntrusionZoneType_order_by;
  id?: order_by;
  index?: order_by;
  name?: order_by;
  placeID?: order_by;
  state?: order_by;
  stateValues?: order_by;
  type?: order_by;
  updatedAt?: order_by;
};

/** primary key columns input for table: qx.IntrusionZone */
export type IntrusionZone_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.IntrusionZone" */
export enum IntrusionZone_select_column {
  /** column name */
  alarm = 'alarm',
  /** column name */
  defaultVideoSourceID = 'defaultVideoSourceID',
  /** column name */
  description = 'description',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  id = 'id',
  /** column name */
  index = 'index',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  state = 'state',
  /** column name */
  type = 'type',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "qx.IntrusionZone" */
export type IntrusionZone_set_input = {
  alarm?: number;
  defaultVideoSourceID?: string;
  description?: string;
  deviceID?: string;
  id?: string;
  index?: number;
  name?: string;
  placeID?: string;
  state?: number;
  type?: qx_eIntrusionZoneType_enum;
  updatedAt?: string;
};

/** aggregate stddev on columns */
export type IntrusionZone_stddev_fields = {
  __typename?: 'IntrusionZone_stddev_fields';
  alarm?: number;
  defaultVideoSourceID?: number;
  index?: number;
  state?: number;
};

/** order by stddev() on columns of table "qx.IntrusionZone" */
export type IntrusionZone_stddev_order_by = {
  alarm?: order_by;
  defaultVideoSourceID?: order_by;
  index?: order_by;
  state?: order_by;
};

/** aggregate stddev_pop on columns */
export type IntrusionZone_stddev_pop_fields = {
  __typename?: 'IntrusionZone_stddev_pop_fields';
  alarm?: number;
  defaultVideoSourceID?: number;
  index?: number;
  state?: number;
};

/** order by stddev_pop() on columns of table "qx.IntrusionZone" */
export type IntrusionZone_stddev_pop_order_by = {
  alarm?: order_by;
  defaultVideoSourceID?: order_by;
  index?: order_by;
  state?: order_by;
};

/** aggregate stddev_samp on columns */
export type IntrusionZone_stddev_samp_fields = {
  __typename?: 'IntrusionZone_stddev_samp_fields';
  alarm?: number;
  defaultVideoSourceID?: number;
  index?: number;
  state?: number;
};

/** order by stddev_samp() on columns of table "qx.IntrusionZone" */
export type IntrusionZone_stddev_samp_order_by = {
  alarm?: order_by;
  defaultVideoSourceID?: order_by;
  index?: order_by;
  state?: order_by;
};

/** Streaming cursor of the table "IntrusionZone" */
export type IntrusionZone_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: IntrusionZone_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type IntrusionZone_stream_cursor_value_input = {
  alarm?: number;
  defaultVideoSourceID?: string;
  description?: string;
  deviceID?: string;
  id?: string;
  index?: number;
  name?: string;
  placeID?: string;
  state?: number;
  type?: qx_eIntrusionZoneType_enum;
  updatedAt?: string;
};

/** aggregate sum on columns */
export type IntrusionZone_sum_fields = {
  __typename?: 'IntrusionZone_sum_fields';
  alarm?: number;
  defaultVideoSourceID?: string;
  index?: number;
  state?: number;
};

/** order by sum() on columns of table "qx.IntrusionZone" */
export type IntrusionZone_sum_order_by = {
  alarm?: order_by;
  defaultVideoSourceID?: order_by;
  index?: order_by;
  state?: order_by;
};

/** update columns of table "qx.IntrusionZone" */
export enum IntrusionZone_update_column {
  /** column name */
  alarm = 'alarm',
  /** column name */
  defaultVideoSourceID = 'defaultVideoSourceID',
  /** column name */
  description = 'description',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  id = 'id',
  /** column name */
  index = 'index',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  state = 'state',
  /** column name */
  type = 'type',
  /** column name */
  updatedAt = 'updatedAt'
}

export type IntrusionZone_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: IntrusionZone_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: IntrusionZone_set_input;
  /** filter the rows which have to be updated */
  where: IntrusionZone_bool_exp;
};

/** aggregate var_pop on columns */
export type IntrusionZone_var_pop_fields = {
  __typename?: 'IntrusionZone_var_pop_fields';
  alarm?: number;
  defaultVideoSourceID?: number;
  index?: number;
  state?: number;
};

/** order by var_pop() on columns of table "qx.IntrusionZone" */
export type IntrusionZone_var_pop_order_by = {
  alarm?: order_by;
  defaultVideoSourceID?: order_by;
  index?: order_by;
  state?: order_by;
};

/** aggregate var_samp on columns */
export type IntrusionZone_var_samp_fields = {
  __typename?: 'IntrusionZone_var_samp_fields';
  alarm?: number;
  defaultVideoSourceID?: number;
  index?: number;
  state?: number;
};

/** order by var_samp() on columns of table "qx.IntrusionZone" */
export type IntrusionZone_var_samp_order_by = {
  alarm?: order_by;
  defaultVideoSourceID?: order_by;
  index?: order_by;
  state?: order_by;
};

/** aggregate variance on columns */
export type IntrusionZone_variance_fields = {
  __typename?: 'IntrusionZone_variance_fields';
  alarm?: number;
  defaultVideoSourceID?: number;
  index?: number;
  state?: number;
};

/** order by variance() on columns of table "qx.IntrusionZone" */
export type IntrusionZone_variance_order_by = {
  alarm?: order_by;
  defaultVideoSourceID?: order_by;
  index?: order_by;
  state?: order_by;
};

export type JsonOutput = {
  __typename?: 'JsonOutput';
  output: any;
};

export type LdapConfiguration = {
  bindDN?: string;
  host: string;
  mailAttribute?: string;
  password: string;
  port: number;
  searchDN?: string;
  username: string;
};

export type MediaProfileRecordingDateItem = {
  __typename?: 'MediaProfileRecordingDateItem';
  bitIndex: number;
  byteIndex: number;
  mediaProfile?: qx_MediaProfile;
  mediaProfileID: string;
  timestamp: string;
  type: string;
};

export type MediaProfileRecordingItem = {
  __typename?: 'MediaProfileRecordingItem';
  baseDate: string;
  mediaProfile?: qx_MediaProfile;
  mediaProfileID: string;
  recordings: any;
  type: string;
};

export type MemoryStat = {
  __typename?: 'MemoryStat';
  time?: string;
  total?: string;
  used?: string;
};

export type MercuryDIOUsageOutput = {
  __typename?: 'MercuryDIOUsageOutput';
  inputMax: number;
  inputs?: Array<DIOType>;
  inputsAvailable?: Array<number>;
  inventoryId: string;
  outputMax: number;
  outputs?: Array<DIOType>;
  outputsAvailable?: Array<number>;
};

export type Metric = {
  __typename?: 'Metric';
  timestamp: string;
  value: number;
};

export enum MinionAccessPointAction {
  Access = 'Access',
  Bypass = 'Bypass'
}

export enum MinionAccessPointDirection {
  Enter = 'Enter',
  Exit = 'Exit'
}

export type MinionAccessPointInput = {
  delete?: boolean;
  id?: string;
  settings?: MinionAccessPointSettingsInput;
};

export type MinionAccessPointSettingsInput = {
  action?: MinionAccessPointAction;
  description?: string;
  direction?: MinionAccessPointDirection;
  enabled?: boolean;
  name?: string;
};

export type MinionAccessPolicyInput = {
  accessPointID: string;
  scheduleID: string;
};

export type MinionAccessProfileInput = {
  accessPolicies?: Array<MinionAccessPolicyInput>;
  delete?: boolean;
  description?: string;
  enabled?: boolean;
  id?: string;
  name?: string;
};

export type MinionAudioEncoderSettingsInput = {
  bitrate?: number;
  encoding?: string;
  samplerate?: number;
};

export type MinionConnectionSettingsInput = {
  address?: string;
  password?: string;
  port?: number;
  tls?: boolean;
  username?: string;
};

export type MinionCredentialIdentifierInput = {
  name?: string;
  value?: string;
};

export type MinionCredentialInput = {
  accessProfiles?: Array<string>;
  delete?: boolean;
  id?: string;
  settings?: MinionCredentialSettingsInput;
};

export type MinionCredentialSettingsInput = {
  description?: string;
  enabled?: boolean;
  extendedTimeEnabled?: boolean;
  identifiers?: Array<MinionCredentialIdentifierInput>;
  validFrom?: string;
  validTo?: string;
};

export type MinionDeviceInput = {
  accessPoints?: Array<MinionAccessPointInput>;
  accessProfiles?: Array<MinionAccessProfileInput>;
  connection?: MinionConnectionSettingsInput;
  credentials?: Array<MinionCredentialInput>;
  dios?: Array<MinionDioInput>;
  doors?: Array<MinionDoorInput>;
  holidaySets?: Array<MinionHolidaySetInput>;
  id?: string;
  kind?: string;
  make?: string;
  mediaProfiles?: Array<MinionMediaProfileInput>;
  model?: string;
  schedules?: Array<MinionScheduleInput>;
  settings?: MinionDeviceSettingsInput;
  videoSources?: Array<MinionVideoSourceInput>;
};

export type MinionDeviceSettingsInput = {
  dst?: boolean;
  name?: string;
  ntp?: boolean;
  staticDNSServers?: Array<string>;
  staticNTPServers?: Array<string>;
  timezone?: string;
};

export type MinionDevices = {
  input?: Array<MinionDeviceInput>;
};

export type MinionDioInput = {
  delayTime?: string;
  delete?: boolean;
  id?: string;
  idleState?: string;
  type?: string;
};

export type MinionDoorInput = {
  delete?: boolean;
  id?: string;
  scheduleID?: string;
  settings?: MinionDoorSettingsInput;
};

export type MinionDoorSettingsInput = {
  accessTime?: string;
  accessType?: string;
  description?: string;
  doorMonitorAddress?: string;
  extendedAccessTime?: string;
  extendedOpenTime?: string;
  lockAddress?: string;
  name?: string;
  openTime?: string;
  preAlarmTime?: string;
};

export type MinionHolidaySetInput = {
  dates?: Array<string>;
  delete?: boolean;
  id?: string;
  name?: string;
};

export type MinionImagingInput = {
  blcLevel?: number;
  blcMode?: MinionSettingsMode;
  brightness?: number;
  contrast?: number;
  exposureMode?: MinionSettingsMode;
  focusMode?: MinionSettingsMode;
  ircutMode?: MinionSettingsMode;
  rotateDegree?: number;
  rotateMode?: MinionSettingsMode;
  saturation?: number;
  sharpness?: number;
  wbBlueGain?: number;
  wbMode?: MinionSettingsMode;
  wbRedGain?: number;
  wdrLevel?: number;
  wdrMode?: MinionSettingsMode;
};

export type MinionMediaProfileInput = {
  audioEncoderSettings?: MinionAudioEncoderSettingsInput;
  delete?: boolean;
  id?: string;
  streamEnabled?: boolean;
  videoEncoderSettings?: MinionVideoEncoderSettingsInput;
};

export type MinionScheduleBlockInput = {
  date?: string;
  duration?: string;
  holidaySets?: Array<string>;
  weekdays?: string;
};

export type MinionScheduleInput = {
  blocks?: Array<MinionScheduleBlockInput>;
  delete?: boolean;
  description?: string;
  id?: string;
  name?: string;
};

export enum MinionSettingsMode {
  Auto = 'Auto',
  Manual = 'Manual',
  Off = 'Off',
  On = 'On'
}

export type MinionVideoEncoderSettingsInput = {
  bitrate?: number;
  encoding?: MinionVideoEncoding;
  fps?: number;
  gopSize?: number;
  profile?: string;
  quality?: number;
  resolution?: string;
};

export enum MinionVideoEncoding {
  H264 = 'H264',
  H265 = 'H265',
  JPEG = 'JPEG',
  MPEG4 = 'MPEG4',
  Off = 'Off'
}

export type MinionVideoSourceInput = {
  delete?: boolean;
  id?: string;
  imaging?: MinionImagingInput;
};

export type NetworkInterfaceSimple = {
  __typename?: 'NetworkInterfaceSimple';
  address: string;
  cidr: string;
  exposedToInternet?: boolean;
  family: string;
  mac: string;
  name: string;
  netmask: string;
};

export type NodeMetrics = {
  __typename?: 'NodeMetrics';
  cpu?: CpuStat;
  memory?: MemoryStat;
  node: string;
};

export type OSSCredential = {
  __typename?: 'OSSCredential';
  doors: Array<OSSCredentialDoor>;
  enabled: boolean;
  id: string;
  identifiers: Array<OSSCredentialIdentifier>;
  name?: string;
  ossPayload?: string;
  validFrom?: string;
  validTo?: string;
  value?: string;
};

export type OSSCredentialDataOutput = {
  __typename?: 'OSSCredentialDataOutput';
  blockList: Array<string>;
  credential?: OSSCredential;
  holidaySets: Array<OSSHolidaySet>;
  schedules: Array<OSSSchedule>;
  siteId?: number;
};

export type OSSCredentialDoor = {
  __typename?: 'OSSCredentialDoor';
  id: string;
  scheduleId: string;
};

export type OSSCredentialIdentifier = {
  __typename?: 'OSSCredentialIdentifier';
  name: string;
  value: string;
};

export type OSSDataOutput = {
  __typename?: 'OSSDataOutput';
  blockList: Array<string>;
  credentials: Array<OSSCredential>;
  doors: Array<OSSDoor>;
  holidaySets: Array<OSSHolidaySet>;
  schedules: Array<OSSSchedule>;
  siteId?: number;
};

export type OSSDoor = {
  __typename?: 'OSSDoor';
  extendedUnlockTime?: string;
  groups: Array<number>;
  /** the Door row's key, null when no Door carries the blob's OSS number */
  id?: string;
  name?: string;
  /** the 16-bit number the lock and its blob know the door by */
  ossID: number;
  unlockTime?: string;
};

export type OSSDoorDataOutput = {
  __typename?: 'OSSDoorDataOutput';
  door?: OSSDoor;
  dst?: boolean;
  siteId?: number;
  /** the lock door's place UTC offset, or its site's when the place has none */
  tzoffset?: string;
};

export type OSSHolidaySet = {
  __typename?: 'OSSHolidaySet';
  dates: Array<string>;
  id: string;
  name?: string;
};

export type OSSKeysOutput = {
  __typename?: 'OSSKeysOutput';
  keys?: string;
};

export type OSSSchedule = {
  __typename?: 'OSSSchedule';
  blocks: Array<OSSScheduleBlock>;
  id: string;
};

export type OSSScheduleBlock = {
  __typename?: 'OSSScheduleBlock';
  date?: string;
  duration?: string;
  holidaySets?: Array<string>;
  weekdays?: string;
};

/** assignments between a device, partition, and zone on an intrusion system. */
export type PartitionZoneAssignments = {
  __typename?: 'PartitionZoneAssignments';
  /** An object relationship */
  Device: qx_Device;
  /** An object relationship */
  IntrusionPartition: IntrusionPartition;
  /** An object relationship */
  IntrusionZone: IntrusionZone;
  deviceID: string;
  enabled: boolean;
  id: string;
  partitionID: string;
  zoneID: string;
};

/** aggregated selection of "qx.PartitionZoneAssignments" */
export type PartitionZoneAssignments_aggregate = {
  __typename?: 'PartitionZoneAssignments_aggregate';
  aggregate?: PartitionZoneAssignments_aggregate_fields;
  nodes: Array<PartitionZoneAssignments>;
};

export type PartitionZoneAssignments_aggregate_bool_exp = {
  bool_and?: PartitionZoneAssignments_aggregate_bool_exp_bool_and;
  bool_or?: PartitionZoneAssignments_aggregate_bool_exp_bool_or;
  count?: PartitionZoneAssignments_aggregate_bool_exp_count;
};

export type PartitionZoneAssignments_aggregate_bool_exp_bool_and = {
  arguments: PartitionZoneAssignments_select_column_PartitionZoneAssignments_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: PartitionZoneAssignments_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type PartitionZoneAssignments_aggregate_bool_exp_bool_or = {
  arguments: PartitionZoneAssignments_select_column_PartitionZoneAssignments_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: PartitionZoneAssignments_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type PartitionZoneAssignments_aggregate_bool_exp_count = {
  arguments?: Array<PartitionZoneAssignments_select_column>;
  distinct?: boolean;
  filter?: PartitionZoneAssignments_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.PartitionZoneAssignments" */
export type PartitionZoneAssignments_aggregate_fields = {
  __typename?: 'PartitionZoneAssignments_aggregate_fields';
  count: number;
  max?: PartitionZoneAssignments_max_fields;
  min?: PartitionZoneAssignments_min_fields;
};


/** aggregate fields of "qx.PartitionZoneAssignments" */
export type PartitionZoneAssignments_aggregate_fieldscountArgs = {
  columns?: Array<PartitionZoneAssignments_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.PartitionZoneAssignments" */
export type PartitionZoneAssignments_aggregate_order_by = {
  count?: order_by;
  max?: PartitionZoneAssignments_max_order_by;
  min?: PartitionZoneAssignments_min_order_by;
};

/** input type for inserting array relation for remote table "qx.PartitionZoneAssignments" */
export type PartitionZoneAssignments_arr_rel_insert_input = {
  data: Array<PartitionZoneAssignments_insert_input>;
  /** upsert condition */
  on_conflict?: PartitionZoneAssignments_on_conflict;
};

/** Boolean expression to filter rows from the table "qx.PartitionZoneAssignments". All fields are combined with a logical 'AND'. */
export type PartitionZoneAssignments_bool_exp = {
  Device?: qx_Device_bool_exp;
  IntrusionPartition?: IntrusionPartition_bool_exp;
  IntrusionZone?: IntrusionZone_bool_exp;
  _and?: Array<PartitionZoneAssignments_bool_exp>;
  _not?: PartitionZoneAssignments_bool_exp;
  _or?: Array<PartitionZoneAssignments_bool_exp>;
  deviceID?: String_comparison_exp;
  enabled?: Boolean_comparison_exp;
  id?: String_comparison_exp;
  partitionID?: String_comparison_exp;
  zoneID?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.PartitionZoneAssignments" */
export enum PartitionZoneAssignments_constraint {
  /** unique or primary key constraint on columns "zoneID", "partitionID", "deviceID" */
  PartitionZoneAssignments_deviceID_partitionID_zoneID_key = 'PartitionZoneAssignments_deviceID_partitionID_zoneID_key',
  /** unique or primary key constraint on columns "id" */
  PartitionZoneAssignments_pkey = 'PartitionZoneAssignments_pkey'
}

/** input type for inserting data into table "qx.PartitionZoneAssignments" */
export type PartitionZoneAssignments_insert_input = {
  Device?: qx_Device_obj_rel_insert_input;
  IntrusionPartition?: IntrusionPartition_obj_rel_insert_input;
  IntrusionZone?: IntrusionZone_obj_rel_insert_input;
  deviceID?: string;
  enabled?: boolean;
  id?: string;
  partitionID?: string;
  zoneID?: string;
};

/** aggregate max on columns */
export type PartitionZoneAssignments_max_fields = {
  __typename?: 'PartitionZoneAssignments_max_fields';
  deviceID?: string;
  id?: string;
  partitionID?: string;
  zoneID?: string;
};

/** order by max() on columns of table "qx.PartitionZoneAssignments" */
export type PartitionZoneAssignments_max_order_by = {
  deviceID?: order_by;
  id?: order_by;
  partitionID?: order_by;
  zoneID?: order_by;
};

/** aggregate min on columns */
export type PartitionZoneAssignments_min_fields = {
  __typename?: 'PartitionZoneAssignments_min_fields';
  deviceID?: string;
  id?: string;
  partitionID?: string;
  zoneID?: string;
};

/** order by min() on columns of table "qx.PartitionZoneAssignments" */
export type PartitionZoneAssignments_min_order_by = {
  deviceID?: order_by;
  id?: order_by;
  partitionID?: order_by;
  zoneID?: order_by;
};

/** response of any mutation on the table "qx.PartitionZoneAssignments" */
export type PartitionZoneAssignments_mutation_response = {
  __typename?: 'PartitionZoneAssignments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<PartitionZoneAssignments>;
};

/** on_conflict condition type for table "qx.PartitionZoneAssignments" */
export type PartitionZoneAssignments_on_conflict = {
  constraint: PartitionZoneAssignments_constraint;
  update_columns?: Array<PartitionZoneAssignments_update_column>;
  where?: PartitionZoneAssignments_bool_exp;
};

/** Ordering options when selecting data from "qx.PartitionZoneAssignments". */
export type PartitionZoneAssignments_order_by = {
  Device?: qx_Device_order_by;
  IntrusionPartition?: IntrusionPartition_order_by;
  IntrusionZone?: IntrusionZone_order_by;
  deviceID?: order_by;
  enabled?: order_by;
  id?: order_by;
  partitionID?: order_by;
  zoneID?: order_by;
};

/** primary key columns input for table: qx.PartitionZoneAssignments */
export type PartitionZoneAssignments_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.PartitionZoneAssignments" */
export enum PartitionZoneAssignments_select_column {
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  enabled = 'enabled',
  /** column name */
  id = 'id',
  /** column name */
  partitionID = 'partitionID',
  /** column name */
  zoneID = 'zoneID'
}

/** select "PartitionZoneAssignments_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.PartitionZoneAssignments" */
export enum PartitionZoneAssignments_select_column_PartitionZoneAssignments_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  enabled = 'enabled'
}

/** select "PartitionZoneAssignments_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.PartitionZoneAssignments" */
export enum PartitionZoneAssignments_select_column_PartitionZoneAssignments_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  enabled = 'enabled'
}

/** input type for updating data in table "qx.PartitionZoneAssignments" */
export type PartitionZoneAssignments_set_input = {
  deviceID?: string;
  enabled?: boolean;
  id?: string;
  partitionID?: string;
  zoneID?: string;
};

/** Streaming cursor of the table "PartitionZoneAssignments" */
export type PartitionZoneAssignments_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: PartitionZoneAssignments_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type PartitionZoneAssignments_stream_cursor_value_input = {
  deviceID?: string;
  enabled?: boolean;
  id?: string;
  partitionID?: string;
  zoneID?: string;
};

/** update columns of table "qx.PartitionZoneAssignments" */
export enum PartitionZoneAssignments_update_column {
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  enabled = 'enabled',
  /** column name */
  id = 'id',
  /** column name */
  partitionID = 'partitionID',
  /** column name */
  zoneID = 'zoneID'
}

export type PartitionZoneAssignments_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: PartitionZoneAssignments_set_input;
  /** filter the rows which have to be updated */
  where: PartitionZoneAssignments_bool_exp;
};

/** columns and relationships of "qx.PassKeyProvider" */
export type PassKeyProvider = {
  __typename?: 'PassKeyProvider';
  aaguid: string;
  icon_dark?: string;
  icon_light?: string;
  name: string;
};

/** aggregated selection of "qx.PassKeyProvider" */
export type PassKeyProvider_aggregate = {
  __typename?: 'PassKeyProvider_aggregate';
  aggregate?: PassKeyProvider_aggregate_fields;
  nodes: Array<PassKeyProvider>;
};

/** aggregate fields of "qx.PassKeyProvider" */
export type PassKeyProvider_aggregate_fields = {
  __typename?: 'PassKeyProvider_aggregate_fields';
  count: number;
  max?: PassKeyProvider_max_fields;
  min?: PassKeyProvider_min_fields;
};


/** aggregate fields of "qx.PassKeyProvider" */
export type PassKeyProvider_aggregate_fieldscountArgs = {
  columns?: Array<PassKeyProvider_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.PassKeyProvider". All fields are combined with a logical 'AND'. */
export type PassKeyProvider_bool_exp = {
  _and?: Array<PassKeyProvider_bool_exp>;
  _not?: PassKeyProvider_bool_exp;
  _or?: Array<PassKeyProvider_bool_exp>;
  aaguid?: String_comparison_exp;
  icon_dark?: String_comparison_exp;
  icon_light?: String_comparison_exp;
  name?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.PassKeyProvider" */
export enum PassKeyProvider_constraint {
  /** unique or primary key constraint on columns "aaguid" */
  PassKeyProvider_pkey = 'PassKeyProvider_pkey'
}

/** input type for inserting data into table "qx.PassKeyProvider" */
export type PassKeyProvider_insert_input = {
  aaguid?: string;
  icon_dark?: string;
  icon_light?: string;
  name?: string;
};

/** aggregate max on columns */
export type PassKeyProvider_max_fields = {
  __typename?: 'PassKeyProvider_max_fields';
  aaguid?: string;
  icon_dark?: string;
  icon_light?: string;
  name?: string;
};

/** aggregate min on columns */
export type PassKeyProvider_min_fields = {
  __typename?: 'PassKeyProvider_min_fields';
  aaguid?: string;
  icon_dark?: string;
  icon_light?: string;
  name?: string;
};

/** response of any mutation on the table "qx.PassKeyProvider" */
export type PassKeyProvider_mutation_response = {
  __typename?: 'PassKeyProvider_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<PassKeyProvider>;
};

/** input type for inserting object relation for remote table "qx.PassKeyProvider" */
export type PassKeyProvider_obj_rel_insert_input = {
  data: PassKeyProvider_insert_input;
  /** upsert condition */
  on_conflict?: PassKeyProvider_on_conflict;
};

/** on_conflict condition type for table "qx.PassKeyProvider" */
export type PassKeyProvider_on_conflict = {
  constraint: PassKeyProvider_constraint;
  update_columns?: Array<PassKeyProvider_update_column>;
  where?: PassKeyProvider_bool_exp;
};

/** Ordering options when selecting data from "qx.PassKeyProvider". */
export type PassKeyProvider_order_by = {
  aaguid?: order_by;
  icon_dark?: order_by;
  icon_light?: order_by;
  name?: order_by;
};

/** primary key columns input for table: qx.PassKeyProvider */
export type PassKeyProvider_pk_columns_input = {
  aaguid: string;
};

/** select columns of table "qx.PassKeyProvider" */
export enum PassKeyProvider_select_column {
  /** column name */
  aaguid = 'aaguid',
  /** column name */
  icon_dark = 'icon_dark',
  /** column name */
  icon_light = 'icon_light',
  /** column name */
  name = 'name'
}

/** input type for updating data in table "qx.PassKeyProvider" */
export type PassKeyProvider_set_input = {
  aaguid?: string;
  icon_dark?: string;
  icon_light?: string;
  name?: string;
};

/** Streaming cursor of the table "PassKeyProvider" */
export type PassKeyProvider_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: PassKeyProvider_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type PassKeyProvider_stream_cursor_value_input = {
  aaguid?: string;
  icon_dark?: string;
  icon_light?: string;
  name?: string;
};

/** update columns of table "qx.PassKeyProvider" */
export enum PassKeyProvider_update_column {
  /** column name */
  aaguid = 'aaguid',
  /** column name */
  icon_dark = 'icon_dark',
  /** column name */
  icon_light = 'icon_light',
  /** column name */
  name = 'name'
}

export type PassKeyProvider_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: PassKeyProvider_set_input;
  /** filter the rows which have to be updated */
  where: PassKeyProvider_bool_exp;
};

export type Peer = {
  __typename?: 'Peer';
  id: number;
  offer: string;
  status: PeerStatus;
  trickle: boolean;
  userID: string;
};

export enum PeerStatus {
  Connected = 'Connected',
  Connecting = 'Connecting',
  Disconnected = 'Disconnected'
}

/** many-to-many mapping that allows users in a Permission to disarm the assigned IntrusionPartitions on door access granted */
export type PermissionPartitionAssignments = {
  __typename?: 'PermissionPartitionAssignments';
  /** An object relationship */
  IntrusionPartition: IntrusionPartition;
  /** An object relationship */
  Permission: qx_Permission;
  id: string;
  partitionID: string;
  permissionID: string;
  updatedAt: string;
};

/** aggregated selection of "qx.PermissionPartitionAssignments" */
export type PermissionPartitionAssignments_aggregate = {
  __typename?: 'PermissionPartitionAssignments_aggregate';
  aggregate?: PermissionPartitionAssignments_aggregate_fields;
  nodes: Array<PermissionPartitionAssignments>;
};

export type PermissionPartitionAssignments_aggregate_bool_exp = {
  count?: PermissionPartitionAssignments_aggregate_bool_exp_count;
};

export type PermissionPartitionAssignments_aggregate_bool_exp_count = {
  arguments?: Array<PermissionPartitionAssignments_select_column>;
  distinct?: boolean;
  filter?: PermissionPartitionAssignments_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.PermissionPartitionAssignments" */
export type PermissionPartitionAssignments_aggregate_fields = {
  __typename?: 'PermissionPartitionAssignments_aggregate_fields';
  count: number;
  max?: PermissionPartitionAssignments_max_fields;
  min?: PermissionPartitionAssignments_min_fields;
};


/** aggregate fields of "qx.PermissionPartitionAssignments" */
export type PermissionPartitionAssignments_aggregate_fieldscountArgs = {
  columns?: Array<PermissionPartitionAssignments_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.PermissionPartitionAssignments" */
export type PermissionPartitionAssignments_aggregate_order_by = {
  count?: order_by;
  max?: PermissionPartitionAssignments_max_order_by;
  min?: PermissionPartitionAssignments_min_order_by;
};

/** input type for inserting array relation for remote table "qx.PermissionPartitionAssignments" */
export type PermissionPartitionAssignments_arr_rel_insert_input = {
  data: Array<PermissionPartitionAssignments_insert_input>;
  /** upsert condition */
  on_conflict?: PermissionPartitionAssignments_on_conflict;
};

/** Boolean expression to filter rows from the table "qx.PermissionPartitionAssignments". All fields are combined with a logical 'AND'. */
export type PermissionPartitionAssignments_bool_exp = {
  IntrusionPartition?: IntrusionPartition_bool_exp;
  Permission?: qx_Permission_bool_exp;
  _and?: Array<PermissionPartitionAssignments_bool_exp>;
  _not?: PermissionPartitionAssignments_bool_exp;
  _or?: Array<PermissionPartitionAssignments_bool_exp>;
  id?: String_comparison_exp;
  partitionID?: String_comparison_exp;
  permissionID?: String_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
};

/** unique or primary key constraints on table "qx.PermissionPartitionAssignments" */
export enum PermissionPartitionAssignments_constraint {
  /** unique or primary key constraint on columns "permissionID", "partitionID" */
  PermissionPartitionAssignments_permissionID_partitionID_key = 'PermissionPartitionAssignments_permissionID_partitionID_key',
  /** unique or primary key constraint on columns "id" */
  PermissionPartitionAssignments_pkey = 'PermissionPartitionAssignments_pkey'
}

/** input type for inserting data into table "qx.PermissionPartitionAssignments" */
export type PermissionPartitionAssignments_insert_input = {
  IntrusionPartition?: IntrusionPartition_obj_rel_insert_input;
  Permission?: qx_Permission_obj_rel_insert_input;
  id?: string;
  partitionID?: string;
  permissionID?: string;
  updatedAt?: string;
};

/** aggregate max on columns */
export type PermissionPartitionAssignments_max_fields = {
  __typename?: 'PermissionPartitionAssignments_max_fields';
  id?: string;
  partitionID?: string;
  permissionID?: string;
  updatedAt?: string;
};

/** order by max() on columns of table "qx.PermissionPartitionAssignments" */
export type PermissionPartitionAssignments_max_order_by = {
  id?: order_by;
  partitionID?: order_by;
  permissionID?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type PermissionPartitionAssignments_min_fields = {
  __typename?: 'PermissionPartitionAssignments_min_fields';
  id?: string;
  partitionID?: string;
  permissionID?: string;
  updatedAt?: string;
};

/** order by min() on columns of table "qx.PermissionPartitionAssignments" */
export type PermissionPartitionAssignments_min_order_by = {
  id?: order_by;
  partitionID?: order_by;
  permissionID?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.PermissionPartitionAssignments" */
export type PermissionPartitionAssignments_mutation_response = {
  __typename?: 'PermissionPartitionAssignments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<PermissionPartitionAssignments>;
};

/** on_conflict condition type for table "qx.PermissionPartitionAssignments" */
export type PermissionPartitionAssignments_on_conflict = {
  constraint: PermissionPartitionAssignments_constraint;
  update_columns?: Array<PermissionPartitionAssignments_update_column>;
  where?: PermissionPartitionAssignments_bool_exp;
};

/** Ordering options when selecting data from "qx.PermissionPartitionAssignments". */
export type PermissionPartitionAssignments_order_by = {
  IntrusionPartition?: IntrusionPartition_order_by;
  Permission?: qx_Permission_order_by;
  id?: order_by;
  partitionID?: order_by;
  permissionID?: order_by;
  updatedAt?: order_by;
};

/** primary key columns input for table: qx.PermissionPartitionAssignments */
export type PermissionPartitionAssignments_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.PermissionPartitionAssignments" */
export enum PermissionPartitionAssignments_select_column {
  /** column name */
  id = 'id',
  /** column name */
  partitionID = 'partitionID',
  /** column name */
  permissionID = 'permissionID',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "qx.PermissionPartitionAssignments" */
export type PermissionPartitionAssignments_set_input = {
  id?: string;
  partitionID?: string;
  permissionID?: string;
  updatedAt?: string;
};

/** Streaming cursor of the table "PermissionPartitionAssignments" */
export type PermissionPartitionAssignments_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: PermissionPartitionAssignments_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type PermissionPartitionAssignments_stream_cursor_value_input = {
  id?: string;
  partitionID?: string;
  permissionID?: string;
  updatedAt?: string;
};

/** update columns of table "qx.PermissionPartitionAssignments" */
export enum PermissionPartitionAssignments_update_column {
  /** column name */
  id = 'id',
  /** column name */
  partitionID = 'partitionID',
  /** column name */
  permissionID = 'permissionID',
  /** column name */
  updatedAt = 'updatedAt'
}

export type PermissionPartitionAssignments_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: PermissionPartitionAssignments_set_input;
  /** filter the rows which have to be updated */
  where: PermissionPartitionAssignments_bool_exp;
};

export type PermissionWithPartitionsInput = {
  description?: string;
  groupID: string;
  name: string;
  placeID: string;
  scheduleID: string;
  thumbnail?: string;
};

/** columns and relationships of "qx.PersonTermsAgreement" */
export type PersonTermsAgreement = {
  __typename?: 'PersonTermsAgreement';
  email: string;
  /** An object relationship */
  person?: qx_Person;
  termsID: string;
};

/** aggregated selection of "qx.PersonTermsAgreement" */
export type PersonTermsAgreement_aggregate = {
  __typename?: 'PersonTermsAgreement_aggregate';
  aggregate?: PersonTermsAgreement_aggregate_fields;
  nodes: Array<PersonTermsAgreement>;
};

/** aggregate fields of "qx.PersonTermsAgreement" */
export type PersonTermsAgreement_aggregate_fields = {
  __typename?: 'PersonTermsAgreement_aggregate_fields';
  count: number;
  max?: PersonTermsAgreement_max_fields;
  min?: PersonTermsAgreement_min_fields;
};


/** aggregate fields of "qx.PersonTermsAgreement" */
export type PersonTermsAgreement_aggregate_fieldscountArgs = {
  columns?: Array<PersonTermsAgreement_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.PersonTermsAgreement". All fields are combined with a logical 'AND'. */
export type PersonTermsAgreement_bool_exp = {
  _and?: Array<PersonTermsAgreement_bool_exp>;
  _not?: PersonTermsAgreement_bool_exp;
  _or?: Array<PersonTermsAgreement_bool_exp>;
  email?: String_comparison_exp;
  person?: qx_Person_bool_exp;
  termsID?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.PersonTermsAgreement" */
export enum PersonTermsAgreement_constraint {
  /** unique or primary key constraint on columns "email" */
  PersonTermsAgreement_email_key = 'PersonTermsAgreement_email_key',
  /** unique or primary key constraint on columns "email" */
  PersonTermsAgreement_pkey = 'PersonTermsAgreement_pkey'
}

/** input type for inserting data into table "qx.PersonTermsAgreement" */
export type PersonTermsAgreement_insert_input = {
  email?: string;
  person?: qx_Person_obj_rel_insert_input;
  termsID?: string;
};

/** aggregate max on columns */
export type PersonTermsAgreement_max_fields = {
  __typename?: 'PersonTermsAgreement_max_fields';
  email?: string;
  termsID?: string;
};

/** aggregate min on columns */
export type PersonTermsAgreement_min_fields = {
  __typename?: 'PersonTermsAgreement_min_fields';
  email?: string;
  termsID?: string;
};

/** response of any mutation on the table "qx.PersonTermsAgreement" */
export type PersonTermsAgreement_mutation_response = {
  __typename?: 'PersonTermsAgreement_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<PersonTermsAgreement>;
};

/** input type for inserting object relation for remote table "qx.PersonTermsAgreement" */
export type PersonTermsAgreement_obj_rel_insert_input = {
  data: PersonTermsAgreement_insert_input;
  /** upsert condition */
  on_conflict?: PersonTermsAgreement_on_conflict;
};

/** on_conflict condition type for table "qx.PersonTermsAgreement" */
export type PersonTermsAgreement_on_conflict = {
  constraint: PersonTermsAgreement_constraint;
  update_columns?: Array<PersonTermsAgreement_update_column>;
  where?: PersonTermsAgreement_bool_exp;
};

/** Ordering options when selecting data from "qx.PersonTermsAgreement". */
export type PersonTermsAgreement_order_by = {
  email?: order_by;
  person?: qx_Person_order_by;
  termsID?: order_by;
};

/** primary key columns input for table: qx.PersonTermsAgreement */
export type PersonTermsAgreement_pk_columns_input = {
  email: string;
};

/** select columns of table "qx.PersonTermsAgreement" */
export enum PersonTermsAgreement_select_column {
  /** column name */
  email = 'email',
  /** column name */
  termsID = 'termsID'
}

/** input type for updating data in table "qx.PersonTermsAgreement" */
export type PersonTermsAgreement_set_input = {
  email?: string;
  termsID?: string;
};

/** Streaming cursor of the table "PersonTermsAgreement" */
export type PersonTermsAgreement_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: PersonTermsAgreement_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type PersonTermsAgreement_stream_cursor_value_input = {
  email?: string;
  termsID?: string;
};

/** update columns of table "qx.PersonTermsAgreement" */
export enum PersonTermsAgreement_update_column {
  /** column name */
  email = 'email',
  /** column name */
  termsID = 'termsID'
}

export type PersonTermsAgreement_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: PersonTermsAgreement_set_input;
  /** filter the rows which have to be updated */
  where: PersonTermsAgreement_bool_exp;
};

export type PodMetrics = {
  __typename?: 'PodMetrics';
  cpu?: CpuStat;
  memory?: MemoryStat;
  name: string;
  node: string;
};

export type QrResponse = {
  __typename?: 'QrResponse';
  qr: string;
  url: string;
};

export type ReaderAccessType = {
  __typename?: 'ReaderAccessType';
  comment: string;
  panel: string;
  value: string;
};

export type ReaderProtocol = {
  __typename?: 'ReaderProtocol';
  comment: string;
  panel: string;
  value: string;
};

export enum ReportType {
  CameraHealth = 'CameraHealth',
  DioActivity = 'DioActivity',
  DoorActivity = 'DoorActivity',
  UserActivity = 'UserActivity',
  UserList = 'UserList'
}

export type SaveClipOutput = {
  __typename?: 'SaveClipOutput';
  id?: string;
  success: boolean;
};

export type SearchSegmentsOutput = {
  __typename?: 'SearchSegmentsOutput';
  drive?: number;
  duration: number;
  id: string;
  offset?: string;
  path: string;
  signedUrl: string;
  size: number;
  time: string;
};

export type SearchSnapshotsOutput = {
  __typename?: 'SearchSnapshotsOutput';
  id: string;
  signedUrl: string;
};

export enum SessionType {
  Cookie = 'Cookie',
  JWT = 'JWT'
}

export type SetupCameraGatewayOutput = {
  __typename?: 'SetupCameraGatewayOutput';
  deviceID?: string;
};

export enum SharedLinkType {
  Clip = 'Clip'
}

export type StorageDriveStats = {
  __typename?: 'StorageDriveStats';
  available: number;
  path: string;
  percentageAvailable: number;
  total: number;
};

export type StringOutput = {
  __typename?: 'StringOutput';
  output: string;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_array_comparison_exp = {
  /** is the array contained in the given array value */
  _contained_in?: Array<string>;
  /** does the array contain the given value */
  _contains?: Array<string>;
  _eq?: Array<string>;
  _gt?: Array<string>;
  _gte?: Array<string>;
  _in?: InputMaybe<Array<Array<string>>>;
  _is_null?: boolean;
  _lt?: Array<string>;
  _lte?: Array<string>;
  _neq?: Array<string>;
  _nin?: InputMaybe<Array<Array<string>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_comparison_exp = {
  _eq?: string;
  _gt?: string;
  _gte?: string;
  /** does the column match the given case-insensitive pattern */
  _ilike?: string;
  _in?: Array<string>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: string;
  _is_null?: boolean;
  /** does the column match the given pattern */
  _like?: string;
  _lt?: string;
  _lte?: string;
  _neq?: string;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: string;
  _nin?: Array<string>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: string;
  /** does the column NOT match the given pattern */
  _nlike?: string;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: string;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: string;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: string;
  /** does the column match the given SQL regular expression */
  _similar?: string;
};

export type SuccessOutput = {
  __typename?: 'SuccessOutput';
  success: boolean;
};

export type SuccessResponse = {
  __typename?: 'SuccessResponse';
  success: boolean;
};

export type SuperviseInputs = {
  __typename?: 'SuperviseInputs';
  comment: string;
  panel: string;
  value: string;
};

export type SysInfo = {
  __typename?: 'SysInfo';
  bootTime?: string;
  buildID?: string;
  buildTime?: string;
  env: string;
  error?: string;
  gatewayID?: string;
  gitBranch?: string;
  gitMessage?: string;
  gitRevision?: string;
  loggingEndpoints?: Array<SystemActionEndpoint>;
  name: string;
  prodLevel?: string;
  restartCount?: number;
  serviceActions?: Array<SystemActionEndpoint>;
  time?: string;
  version?: string;
};

export type SystemActionEndpoint = {
  __typename?: 'SystemActionEndpoint';
  description?: string;
  endpoint?: string;
  method?: string;
};

export type UpdateDeviceWithConnectionInput = {
  address?: string;
  controllerGateway?: string;
  controllerSubnet?: string;
  description?: string;
  enabled?: boolean;
  hostname?: string;
  id: string;
  installerAccessCode?: string;
  integrationAccessCode?: string;
  integrationKey?: string;
  masterAccessCode?: string;
  meta?: any;
  name?: string;
  pacsConfigurationID?: string;
  password?: string;
  port?: number;
  tls?: boolean;
  username?: string;
};

export type UploadSegmentMetricResponse = {
  __typename?: 'UploadSegmentMetricResponse';
  bitsQueued?: Array<Metric>;
  bitsSent?: Array<Metric>;
  secondsQueued?: Array<Metric>;
  secondsSent?: Array<Metric>;
  totalBitsQueued?: Array<Metric>;
  totalSecondsQueued?: Array<Metric>;
  unitOfTime: string;
};

export type UploadStatsResponse = {
  __typename?: 'UploadStatsResponse';
  oldestSegmentNotUploaded?: string;
  uploadQueueDepth?: number;
};

export type ValidateHardwareResult = {
  __typename?: 'ValidateHardwareResult';
  error?: string;
  success: boolean;
};

/** columns and relationships of "analytics.AnalyticAttributeProperty" */
export type analyticAttributeProperties = {
  __typename?: 'analyticAttributeProperties';
  /** An object relationship */
  analyticAttribute: analyticAttributes;
  analyticAttributeID: string;
  /** An object relationship */
  attributeProperty: attributeProperties;
  attributePropertyValue: string;
};

/** aggregated selection of "analytics.AnalyticAttributeProperty" */
export type analyticAttributeProperties_aggregate = {
  __typename?: 'analyticAttributeProperties_aggregate';
  aggregate?: analyticAttributeProperties_aggregate_fields;
  nodes: Array<analyticAttributeProperties>;
};

export type analyticAttributeProperties_aggregate_bool_exp = {
  count?: analyticAttributeProperties_aggregate_bool_exp_count;
};

export type analyticAttributeProperties_aggregate_bool_exp_count = {
  arguments?: Array<analyticAttributeProperties_select_column>;
  distinct?: boolean;
  filter?: analyticAttributeProperties_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "analytics.AnalyticAttributeProperty" */
export type analyticAttributeProperties_aggregate_fields = {
  __typename?: 'analyticAttributeProperties_aggregate_fields';
  avg?: analyticAttributeProperties_avg_fields;
  count: number;
  max?: analyticAttributeProperties_max_fields;
  min?: analyticAttributeProperties_min_fields;
  stddev?: analyticAttributeProperties_stddev_fields;
  stddev_pop?: analyticAttributeProperties_stddev_pop_fields;
  stddev_samp?: analyticAttributeProperties_stddev_samp_fields;
  sum?: analyticAttributeProperties_sum_fields;
  var_pop?: analyticAttributeProperties_var_pop_fields;
  var_samp?: analyticAttributeProperties_var_samp_fields;
  variance?: analyticAttributeProperties_variance_fields;
};


/** aggregate fields of "analytics.AnalyticAttributeProperty" */
export type analyticAttributeProperties_aggregate_fieldscountArgs = {
  columns?: Array<analyticAttributeProperties_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "analytics.AnalyticAttributeProperty" */
export type analyticAttributeProperties_aggregate_order_by = {
  avg?: analyticAttributeProperties_avg_order_by;
  count?: order_by;
  max?: analyticAttributeProperties_max_order_by;
  min?: analyticAttributeProperties_min_order_by;
  stddev?: analyticAttributeProperties_stddev_order_by;
  stddev_pop?: analyticAttributeProperties_stddev_pop_order_by;
  stddev_samp?: analyticAttributeProperties_stddev_samp_order_by;
  sum?: analyticAttributeProperties_sum_order_by;
  var_pop?: analyticAttributeProperties_var_pop_order_by;
  var_samp?: analyticAttributeProperties_var_samp_order_by;
  variance?: analyticAttributeProperties_variance_order_by;
};

/** input type for inserting array relation for remote table "analytics.AnalyticAttributeProperty" */
export type analyticAttributeProperties_arr_rel_insert_input = {
  data: Array<analyticAttributeProperties_insert_input>;
  /** upsert condition */
  on_conflict?: analyticAttributeProperties_on_conflict;
};

/** aggregate avg on columns */
export type analyticAttributeProperties_avg_fields = {
  __typename?: 'analyticAttributeProperties_avg_fields';
  analyticAttributeID?: number;
};

/** order by avg() on columns of table "analytics.AnalyticAttributeProperty" */
export type analyticAttributeProperties_avg_order_by = {
  analyticAttributeID?: order_by;
};

/** Boolean expression to filter rows from the table "analytics.AnalyticAttributeProperty". All fields are combined with a logical 'AND'. */
export type analyticAttributeProperties_bool_exp = {
  _and?: Array<analyticAttributeProperties_bool_exp>;
  _not?: analyticAttributeProperties_bool_exp;
  _or?: Array<analyticAttributeProperties_bool_exp>;
  analyticAttribute?: analyticAttributes_bool_exp;
  analyticAttributeID?: bigint_comparison_exp;
  attributeProperty?: attributeProperties_bool_exp;
  attributePropertyValue?: String_comparison_exp;
};

/** unique or primary key constraints on table "analytics.AnalyticAttributeProperty" */
export enum analyticAttributeProperties_constraint {
  /** unique or primary key constraint on columns "analyticAttributeID", "attributePropertyValue" */
  AnalyticAttributeProperty_analytic_attribute_key = 'AnalyticAttributeProperty_analytic_attribute_key',
  /** unique or primary key constraint on columns "analyticAttributeID", "attributePropertyValue" */
  AnalyticAttributeProperty_pkey = 'AnalyticAttributeProperty_pkey'
}

/** input type for incrementing numeric columns in table "analytics.AnalyticAttributeProperty" */
export type analyticAttributeProperties_inc_input = {
  analyticAttributeID?: string;
};

/** input type for inserting data into table "analytics.AnalyticAttributeProperty" */
export type analyticAttributeProperties_insert_input = {
  analyticAttribute?: analyticAttributes_obj_rel_insert_input;
  analyticAttributeID?: string;
  attributeProperty?: attributeProperties_obj_rel_insert_input;
  attributePropertyValue?: string;
};

/** aggregate max on columns */
export type analyticAttributeProperties_max_fields = {
  __typename?: 'analyticAttributeProperties_max_fields';
  analyticAttributeID?: string;
  attributePropertyValue?: string;
};

/** order by max() on columns of table "analytics.AnalyticAttributeProperty" */
export type analyticAttributeProperties_max_order_by = {
  analyticAttributeID?: order_by;
  attributePropertyValue?: order_by;
};

/** aggregate min on columns */
export type analyticAttributeProperties_min_fields = {
  __typename?: 'analyticAttributeProperties_min_fields';
  analyticAttributeID?: string;
  attributePropertyValue?: string;
};

/** order by min() on columns of table "analytics.AnalyticAttributeProperty" */
export type analyticAttributeProperties_min_order_by = {
  analyticAttributeID?: order_by;
  attributePropertyValue?: order_by;
};

/** response of any mutation on the table "analytics.AnalyticAttributeProperty" */
export type analyticAttributeProperties_mutation_response = {
  __typename?: 'analyticAttributeProperties_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<analyticAttributeProperties>;
};

/** on_conflict condition type for table "analytics.AnalyticAttributeProperty" */
export type analyticAttributeProperties_on_conflict = {
  constraint: analyticAttributeProperties_constraint;
  update_columns?: Array<analyticAttributeProperties_update_column>;
  where?: analyticAttributeProperties_bool_exp;
};

/** Ordering options when selecting data from "analytics.AnalyticAttributeProperty". */
export type analyticAttributeProperties_order_by = {
  analyticAttribute?: analyticAttributes_order_by;
  analyticAttributeID?: order_by;
  attributeProperty?: attributeProperties_order_by;
  attributePropertyValue?: order_by;
};

/** primary key columns input for table: analytics.AnalyticAttributeProperty */
export type analyticAttributeProperties_pk_columns_input = {
  analyticAttributeID: string;
  attributePropertyValue: string;
};

/** select columns of table "analytics.AnalyticAttributeProperty" */
export enum analyticAttributeProperties_select_column {
  /** column name */
  analyticAttributeID = 'analyticAttributeID',
  /** column name */
  attributePropertyValue = 'attributePropertyValue'
}

/** input type for updating data in table "analytics.AnalyticAttributeProperty" */
export type analyticAttributeProperties_set_input = {
  analyticAttributeID?: string;
  attributePropertyValue?: string;
};

/** aggregate stddev on columns */
export type analyticAttributeProperties_stddev_fields = {
  __typename?: 'analyticAttributeProperties_stddev_fields';
  analyticAttributeID?: number;
};

/** order by stddev() on columns of table "analytics.AnalyticAttributeProperty" */
export type analyticAttributeProperties_stddev_order_by = {
  analyticAttributeID?: order_by;
};

/** aggregate stddev_pop on columns */
export type analyticAttributeProperties_stddev_pop_fields = {
  __typename?: 'analyticAttributeProperties_stddev_pop_fields';
  analyticAttributeID?: number;
};

/** order by stddev_pop() on columns of table "analytics.AnalyticAttributeProperty" */
export type analyticAttributeProperties_stddev_pop_order_by = {
  analyticAttributeID?: order_by;
};

/** aggregate stddev_samp on columns */
export type analyticAttributeProperties_stddev_samp_fields = {
  __typename?: 'analyticAttributeProperties_stddev_samp_fields';
  analyticAttributeID?: number;
};

/** order by stddev_samp() on columns of table "analytics.AnalyticAttributeProperty" */
export type analyticAttributeProperties_stddev_samp_order_by = {
  analyticAttributeID?: order_by;
};

/** Streaming cursor of the table "analyticAttributeProperties" */
export type analyticAttributeProperties_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: analyticAttributeProperties_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type analyticAttributeProperties_stream_cursor_value_input = {
  analyticAttributeID?: string;
  attributePropertyValue?: string;
};

/** aggregate sum on columns */
export type analyticAttributeProperties_sum_fields = {
  __typename?: 'analyticAttributeProperties_sum_fields';
  analyticAttributeID?: string;
};

/** order by sum() on columns of table "analytics.AnalyticAttributeProperty" */
export type analyticAttributeProperties_sum_order_by = {
  analyticAttributeID?: order_by;
};

/** update columns of table "analytics.AnalyticAttributeProperty" */
export enum analyticAttributeProperties_update_column {
  /** column name */
  analyticAttributeID = 'analyticAttributeID',
  /** column name */
  attributePropertyValue = 'attributePropertyValue'
}

export type analyticAttributeProperties_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: analyticAttributeProperties_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: analyticAttributeProperties_set_input;
  /** filter the rows which have to be updated */
  where: analyticAttributeProperties_bool_exp;
};

/** aggregate var_pop on columns */
export type analyticAttributeProperties_var_pop_fields = {
  __typename?: 'analyticAttributeProperties_var_pop_fields';
  analyticAttributeID?: number;
};

/** order by var_pop() on columns of table "analytics.AnalyticAttributeProperty" */
export type analyticAttributeProperties_var_pop_order_by = {
  analyticAttributeID?: order_by;
};

/** aggregate var_samp on columns */
export type analyticAttributeProperties_var_samp_fields = {
  __typename?: 'analyticAttributeProperties_var_samp_fields';
  analyticAttributeID?: number;
};

/** order by var_samp() on columns of table "analytics.AnalyticAttributeProperty" */
export type analyticAttributeProperties_var_samp_order_by = {
  analyticAttributeID?: order_by;
};

/** aggregate variance on columns */
export type analyticAttributeProperties_variance_fields = {
  __typename?: 'analyticAttributeProperties_variance_fields';
  analyticAttributeID?: number;
};

/** order by variance() on columns of table "analytics.AnalyticAttributeProperty" */
export type analyticAttributeProperties_variance_order_by = {
  analyticAttributeID?: order_by;
};

/** columns and relationships of "analytics.AnalyticAttribute" */
export type analyticAttributes = {
  __typename?: 'analyticAttributes';
  /** An array relationship */
  analyticAttributeProperties: Array<analyticAttributeProperties>;
  /** An aggregate relationship */
  analyticAttributeProperties_aggregate: analyticAttributeProperties_aggregate;
  /** An array relationship */
  analyticDetectedProperties: Array<analyticDetectedProperties>;
  /** An aggregate relationship */
  analyticDetectedProperties_aggregate: analyticDetectedProperties_aggregate;
  analyticType: string;
  /** An object relationship */
  attribute: attributes;
  attributeType: string;
  id: string;
  /** An object relationship */
  parentAttribute?: attributes;
  parentAttributeType?: string;
  /** An object relationship */
  type: analyticTypes;
};


/** columns and relationships of "analytics.AnalyticAttribute" */
export type analyticAttributesanalyticAttributePropertiesArgs = {
  distinct_on?: Array<analyticAttributeProperties_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticAttributeProperties_order_by>;
  where?: analyticAttributeProperties_bool_exp;
};


/** columns and relationships of "analytics.AnalyticAttribute" */
export type analyticAttributesanalyticAttributeProperties_aggregateArgs = {
  distinct_on?: Array<analyticAttributeProperties_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticAttributeProperties_order_by>;
  where?: analyticAttributeProperties_bool_exp;
};


/** columns and relationships of "analytics.AnalyticAttribute" */
export type analyticAttributesanalyticDetectedPropertiesArgs = {
  distinct_on?: Array<analyticDetectedProperties_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticDetectedProperties_order_by>;
  where?: analyticDetectedProperties_bool_exp;
};


/** columns and relationships of "analytics.AnalyticAttribute" */
export type analyticAttributesanalyticDetectedProperties_aggregateArgs = {
  distinct_on?: Array<analyticDetectedProperties_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticDetectedProperties_order_by>;
  where?: analyticDetectedProperties_bool_exp;
};

/** aggregated selection of "analytics.AnalyticAttribute" */
export type analyticAttributes_aggregate = {
  __typename?: 'analyticAttributes_aggregate';
  aggregate?: analyticAttributes_aggregate_fields;
  nodes: Array<analyticAttributes>;
};

export type analyticAttributes_aggregate_bool_exp = {
  count?: analyticAttributes_aggregate_bool_exp_count;
};

export type analyticAttributes_aggregate_bool_exp_count = {
  arguments?: Array<analyticAttributes_select_column>;
  distinct?: boolean;
  filter?: analyticAttributes_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "analytics.AnalyticAttribute" */
export type analyticAttributes_aggregate_fields = {
  __typename?: 'analyticAttributes_aggregate_fields';
  avg?: analyticAttributes_avg_fields;
  count: number;
  max?: analyticAttributes_max_fields;
  min?: analyticAttributes_min_fields;
  stddev?: analyticAttributes_stddev_fields;
  stddev_pop?: analyticAttributes_stddev_pop_fields;
  stddev_samp?: analyticAttributes_stddev_samp_fields;
  sum?: analyticAttributes_sum_fields;
  var_pop?: analyticAttributes_var_pop_fields;
  var_samp?: analyticAttributes_var_samp_fields;
  variance?: analyticAttributes_variance_fields;
};


/** aggregate fields of "analytics.AnalyticAttribute" */
export type analyticAttributes_aggregate_fieldscountArgs = {
  columns?: Array<analyticAttributes_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "analytics.AnalyticAttribute" */
export type analyticAttributes_aggregate_order_by = {
  avg?: analyticAttributes_avg_order_by;
  count?: order_by;
  max?: analyticAttributes_max_order_by;
  min?: analyticAttributes_min_order_by;
  stddev?: analyticAttributes_stddev_order_by;
  stddev_pop?: analyticAttributes_stddev_pop_order_by;
  stddev_samp?: analyticAttributes_stddev_samp_order_by;
  sum?: analyticAttributes_sum_order_by;
  var_pop?: analyticAttributes_var_pop_order_by;
  var_samp?: analyticAttributes_var_samp_order_by;
  variance?: analyticAttributes_variance_order_by;
};

/** input type for inserting array relation for remote table "analytics.AnalyticAttribute" */
export type analyticAttributes_arr_rel_insert_input = {
  data: Array<analyticAttributes_insert_input>;
  /** upsert condition */
  on_conflict?: analyticAttributes_on_conflict;
};

/** aggregate avg on columns */
export type analyticAttributes_avg_fields = {
  __typename?: 'analyticAttributes_avg_fields';
  id?: number;
};

/** order by avg() on columns of table "analytics.AnalyticAttribute" */
export type analyticAttributes_avg_order_by = {
  id?: order_by;
};

/** Boolean expression to filter rows from the table "analytics.AnalyticAttribute". All fields are combined with a logical 'AND'. */
export type analyticAttributes_bool_exp = {
  _and?: Array<analyticAttributes_bool_exp>;
  _not?: analyticAttributes_bool_exp;
  _or?: Array<analyticAttributes_bool_exp>;
  analyticAttributeProperties?: analyticAttributeProperties_bool_exp;
  analyticAttributeProperties_aggregate?: analyticAttributeProperties_aggregate_bool_exp;
  analyticDetectedProperties?: analyticDetectedProperties_bool_exp;
  analyticDetectedProperties_aggregate?: analyticDetectedProperties_aggregate_bool_exp;
  analyticType?: String_comparison_exp;
  attribute?: attributes_bool_exp;
  attributeType?: String_comparison_exp;
  id?: bigint_comparison_exp;
  parentAttribute?: attributes_bool_exp;
  parentAttributeType?: String_comparison_exp;
  type?: analyticTypes_bool_exp;
};

/** unique or primary key constraints on table "analytics.AnalyticAttribute" */
export enum analyticAttributes_constraint {
  /** unique or primary key constraint on columns "attributeType", "analyticType" */
  AnalyticAttribute_analytic_attribute_key = 'AnalyticAttribute_analytic_attribute_key',
  /** unique or primary key constraint on columns "attributeType", "analyticType", "parentAttributeType" */
  AnalyticAttribute_analytic_attribute_parent_key = 'AnalyticAttribute_analytic_attribute_parent_key',
  /** unique or primary key constraint on columns "id" */
  AnalyticAttribute_pkey = 'AnalyticAttribute_pkey'
}

/** input type for incrementing numeric columns in table "analytics.AnalyticAttribute" */
export type analyticAttributes_inc_input = {
  id?: string;
};

/** input type for inserting data into table "analytics.AnalyticAttribute" */
export type analyticAttributes_insert_input = {
  analyticAttributeProperties?: analyticAttributeProperties_arr_rel_insert_input;
  analyticDetectedProperties?: analyticDetectedProperties_arr_rel_insert_input;
  analyticType?: string;
  attribute?: attributes_obj_rel_insert_input;
  attributeType?: string;
  id?: string;
  parentAttribute?: attributes_obj_rel_insert_input;
  parentAttributeType?: string;
  type?: analyticTypes_obj_rel_insert_input;
};

/** aggregate max on columns */
export type analyticAttributes_max_fields = {
  __typename?: 'analyticAttributes_max_fields';
  analyticType?: string;
  attributeType?: string;
  id?: string;
  parentAttributeType?: string;
};

/** order by max() on columns of table "analytics.AnalyticAttribute" */
export type analyticAttributes_max_order_by = {
  analyticType?: order_by;
  attributeType?: order_by;
  id?: order_by;
  parentAttributeType?: order_by;
};

/** aggregate min on columns */
export type analyticAttributes_min_fields = {
  __typename?: 'analyticAttributes_min_fields';
  analyticType?: string;
  attributeType?: string;
  id?: string;
  parentAttributeType?: string;
};

/** order by min() on columns of table "analytics.AnalyticAttribute" */
export type analyticAttributes_min_order_by = {
  analyticType?: order_by;
  attributeType?: order_by;
  id?: order_by;
  parentAttributeType?: order_by;
};

/** response of any mutation on the table "analytics.AnalyticAttribute" */
export type analyticAttributes_mutation_response = {
  __typename?: 'analyticAttributes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<analyticAttributes>;
};

/** input type for inserting object relation for remote table "analytics.AnalyticAttribute" */
export type analyticAttributes_obj_rel_insert_input = {
  data: analyticAttributes_insert_input;
  /** upsert condition */
  on_conflict?: analyticAttributes_on_conflict;
};

/** on_conflict condition type for table "analytics.AnalyticAttribute" */
export type analyticAttributes_on_conflict = {
  constraint: analyticAttributes_constraint;
  update_columns?: Array<analyticAttributes_update_column>;
  where?: analyticAttributes_bool_exp;
};

/** Ordering options when selecting data from "analytics.AnalyticAttribute". */
export type analyticAttributes_order_by = {
  analyticAttributeProperties_aggregate?: analyticAttributeProperties_aggregate_order_by;
  analyticDetectedProperties_aggregate?: analyticDetectedProperties_aggregate_order_by;
  analyticType?: order_by;
  attribute?: attributes_order_by;
  attributeType?: order_by;
  id?: order_by;
  parentAttribute?: attributes_order_by;
  parentAttributeType?: order_by;
  type?: analyticTypes_order_by;
};

/** primary key columns input for table: analytics.AnalyticAttribute */
export type analyticAttributes_pk_columns_input = {
  id: string;
};

/** select columns of table "analytics.AnalyticAttribute" */
export enum analyticAttributes_select_column {
  /** column name */
  analyticType = 'analyticType',
  /** column name */
  attributeType = 'attributeType',
  /** column name */
  id = 'id',
  /** column name */
  parentAttributeType = 'parentAttributeType'
}

/** input type for updating data in table "analytics.AnalyticAttribute" */
export type analyticAttributes_set_input = {
  analyticType?: string;
  attributeType?: string;
  id?: string;
  parentAttributeType?: string;
};

/** aggregate stddev on columns */
export type analyticAttributes_stddev_fields = {
  __typename?: 'analyticAttributes_stddev_fields';
  id?: number;
};

/** order by stddev() on columns of table "analytics.AnalyticAttribute" */
export type analyticAttributes_stddev_order_by = {
  id?: order_by;
};

/** aggregate stddev_pop on columns */
export type analyticAttributes_stddev_pop_fields = {
  __typename?: 'analyticAttributes_stddev_pop_fields';
  id?: number;
};

/** order by stddev_pop() on columns of table "analytics.AnalyticAttribute" */
export type analyticAttributes_stddev_pop_order_by = {
  id?: order_by;
};

/** aggregate stddev_samp on columns */
export type analyticAttributes_stddev_samp_fields = {
  __typename?: 'analyticAttributes_stddev_samp_fields';
  id?: number;
};

/** order by stddev_samp() on columns of table "analytics.AnalyticAttribute" */
export type analyticAttributes_stddev_samp_order_by = {
  id?: order_by;
};

/** Streaming cursor of the table "analyticAttributes" */
export type analyticAttributes_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: analyticAttributes_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type analyticAttributes_stream_cursor_value_input = {
  analyticType?: string;
  attributeType?: string;
  id?: string;
  parentAttributeType?: string;
};

/** aggregate sum on columns */
export type analyticAttributes_sum_fields = {
  __typename?: 'analyticAttributes_sum_fields';
  id?: string;
};

/** order by sum() on columns of table "analytics.AnalyticAttribute" */
export type analyticAttributes_sum_order_by = {
  id?: order_by;
};

/** update columns of table "analytics.AnalyticAttribute" */
export enum analyticAttributes_update_column {
  /** column name */
  analyticType = 'analyticType',
  /** column name */
  attributeType = 'attributeType',
  /** column name */
  id = 'id',
  /** column name */
  parentAttributeType = 'parentAttributeType'
}

export type analyticAttributes_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: analyticAttributes_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: analyticAttributes_set_input;
  /** filter the rows which have to be updated */
  where: analyticAttributes_bool_exp;
};

/** aggregate var_pop on columns */
export type analyticAttributes_var_pop_fields = {
  __typename?: 'analyticAttributes_var_pop_fields';
  id?: number;
};

/** order by var_pop() on columns of table "analytics.AnalyticAttribute" */
export type analyticAttributes_var_pop_order_by = {
  id?: order_by;
};

/** aggregate var_samp on columns */
export type analyticAttributes_var_samp_fields = {
  __typename?: 'analyticAttributes_var_samp_fields';
  id?: number;
};

/** order by var_samp() on columns of table "analytics.AnalyticAttribute" */
export type analyticAttributes_var_samp_order_by = {
  id?: order_by;
};

/** aggregate variance on columns */
export type analyticAttributes_variance_fields = {
  __typename?: 'analyticAttributes_variance_fields';
  id?: number;
};

/** order by variance() on columns of table "analytics.AnalyticAttribute" */
export type analyticAttributes_variance_order_by = {
  id?: order_by;
};

/** columns and relationships of "analytics.AnalyticPropertyDetected" */
export type analyticDetectedProperties = {
  __typename?: 'analyticDetectedProperties';
  /** An object relationship */
  analytic: analytics;
  /** An object relationship */
  analyticAttribute: analyticAttributes;
  analyticAttributeID: string;
  analyticID: string;
  /** An object relationship */
  attributeProperty?: attributeProperties;
  id: string;
  likelihood?: number;
  property?: string;
  time: string;
  value?: string;
};

/** aggregated selection of "analytics.AnalyticPropertyDetected" */
export type analyticDetectedProperties_aggregate = {
  __typename?: 'analyticDetectedProperties_aggregate';
  aggregate?: analyticDetectedProperties_aggregate_fields;
  nodes: Array<analyticDetectedProperties>;
};

export type analyticDetectedProperties_aggregate_bool_exp = {
  count?: analyticDetectedProperties_aggregate_bool_exp_count;
};

export type analyticDetectedProperties_aggregate_bool_exp_count = {
  arguments?: Array<analyticDetectedProperties_select_column>;
  distinct?: boolean;
  filter?: analyticDetectedProperties_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "analytics.AnalyticPropertyDetected" */
export type analyticDetectedProperties_aggregate_fields = {
  __typename?: 'analyticDetectedProperties_aggregate_fields';
  avg?: analyticDetectedProperties_avg_fields;
  count: number;
  max?: analyticDetectedProperties_max_fields;
  min?: analyticDetectedProperties_min_fields;
  stddev?: analyticDetectedProperties_stddev_fields;
  stddev_pop?: analyticDetectedProperties_stddev_pop_fields;
  stddev_samp?: analyticDetectedProperties_stddev_samp_fields;
  sum?: analyticDetectedProperties_sum_fields;
  var_pop?: analyticDetectedProperties_var_pop_fields;
  var_samp?: analyticDetectedProperties_var_samp_fields;
  variance?: analyticDetectedProperties_variance_fields;
};


/** aggregate fields of "analytics.AnalyticPropertyDetected" */
export type analyticDetectedProperties_aggregate_fieldscountArgs = {
  columns?: Array<analyticDetectedProperties_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "analytics.AnalyticPropertyDetected" */
export type analyticDetectedProperties_aggregate_order_by = {
  avg?: analyticDetectedProperties_avg_order_by;
  count?: order_by;
  max?: analyticDetectedProperties_max_order_by;
  min?: analyticDetectedProperties_min_order_by;
  stddev?: analyticDetectedProperties_stddev_order_by;
  stddev_pop?: analyticDetectedProperties_stddev_pop_order_by;
  stddev_samp?: analyticDetectedProperties_stddev_samp_order_by;
  sum?: analyticDetectedProperties_sum_order_by;
  var_pop?: analyticDetectedProperties_var_pop_order_by;
  var_samp?: analyticDetectedProperties_var_samp_order_by;
  variance?: analyticDetectedProperties_variance_order_by;
};

/** input type for inserting array relation for remote table "analytics.AnalyticPropertyDetected" */
export type analyticDetectedProperties_arr_rel_insert_input = {
  data: Array<analyticDetectedProperties_insert_input>;
  /** upsert condition */
  on_conflict?: analyticDetectedProperties_on_conflict;
};

/** aggregate avg on columns */
export type analyticDetectedProperties_avg_fields = {
  __typename?: 'analyticDetectedProperties_avg_fields';
  analyticAttributeID?: number;
  analyticID?: number;
  id?: number;
  likelihood?: number;
};

/** order by avg() on columns of table "analytics.AnalyticPropertyDetected" */
export type analyticDetectedProperties_avg_order_by = {
  analyticAttributeID?: order_by;
  analyticID?: order_by;
  id?: order_by;
  likelihood?: order_by;
};

/** Boolean expression to filter rows from the table "analytics.AnalyticPropertyDetected". All fields are combined with a logical 'AND'. */
export type analyticDetectedProperties_bool_exp = {
  _and?: Array<analyticDetectedProperties_bool_exp>;
  _not?: analyticDetectedProperties_bool_exp;
  _or?: Array<analyticDetectedProperties_bool_exp>;
  analytic?: analytics_bool_exp;
  analyticAttribute?: analyticAttributes_bool_exp;
  analyticAttributeID?: bigint_comparison_exp;
  analyticID?: bigint_comparison_exp;
  attributeProperty?: attributeProperties_bool_exp;
  id?: bigint_comparison_exp;
  likelihood?: Int_comparison_exp;
  property?: String_comparison_exp;
  time?: timestamptz_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "analytics.AnalyticPropertyDetected" */
export enum analyticDetectedProperties_constraint {
  /** unique or primary key constraint on columns "analyticAttributeID", "property", "analyticID" */
  AnalyticPropertyDetected_analyticID_analyticAttributeID_attribu = 'AnalyticPropertyDetected_analyticID_analyticAttributeID_attribu',
  /** unique or primary key constraint on columns "id" */
  AnalyticPropertyDetected_pkey = 'AnalyticPropertyDetected_pkey'
}

/** input type for incrementing numeric columns in table "analytics.AnalyticPropertyDetected" */
export type analyticDetectedProperties_inc_input = {
  analyticAttributeID?: string;
  analyticID?: string;
  id?: string;
  likelihood?: number;
};

/** input type for inserting data into table "analytics.AnalyticPropertyDetected" */
export type analyticDetectedProperties_insert_input = {
  analytic?: analytics_obj_rel_insert_input;
  analyticAttribute?: analyticAttributes_obj_rel_insert_input;
  analyticAttributeID?: string;
  analyticID?: string;
  attributeProperty?: attributeProperties_obj_rel_insert_input;
  id?: string;
  likelihood?: number;
  property?: string;
  time?: string;
  value?: string;
};

/** aggregate max on columns */
export type analyticDetectedProperties_max_fields = {
  __typename?: 'analyticDetectedProperties_max_fields';
  analyticAttributeID?: string;
  analyticID?: string;
  id?: string;
  likelihood?: number;
  property?: string;
  time?: string;
  value?: string;
};

/** order by max() on columns of table "analytics.AnalyticPropertyDetected" */
export type analyticDetectedProperties_max_order_by = {
  analyticAttributeID?: order_by;
  analyticID?: order_by;
  id?: order_by;
  likelihood?: order_by;
  property?: order_by;
  time?: order_by;
  value?: order_by;
};

/** aggregate min on columns */
export type analyticDetectedProperties_min_fields = {
  __typename?: 'analyticDetectedProperties_min_fields';
  analyticAttributeID?: string;
  analyticID?: string;
  id?: string;
  likelihood?: number;
  property?: string;
  time?: string;
  value?: string;
};

/** order by min() on columns of table "analytics.AnalyticPropertyDetected" */
export type analyticDetectedProperties_min_order_by = {
  analyticAttributeID?: order_by;
  analyticID?: order_by;
  id?: order_by;
  likelihood?: order_by;
  property?: order_by;
  time?: order_by;
  value?: order_by;
};

/** response of any mutation on the table "analytics.AnalyticPropertyDetected" */
export type analyticDetectedProperties_mutation_response = {
  __typename?: 'analyticDetectedProperties_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<analyticDetectedProperties>;
};

/** on_conflict condition type for table "analytics.AnalyticPropertyDetected" */
export type analyticDetectedProperties_on_conflict = {
  constraint: analyticDetectedProperties_constraint;
  update_columns?: Array<analyticDetectedProperties_update_column>;
  where?: analyticDetectedProperties_bool_exp;
};

/** Ordering options when selecting data from "analytics.AnalyticPropertyDetected". */
export type analyticDetectedProperties_order_by = {
  analytic?: analytics_order_by;
  analyticAttribute?: analyticAttributes_order_by;
  analyticAttributeID?: order_by;
  analyticID?: order_by;
  attributeProperty?: attributeProperties_order_by;
  id?: order_by;
  likelihood?: order_by;
  property?: order_by;
  time?: order_by;
  value?: order_by;
};

/** primary key columns input for table: analytics.AnalyticPropertyDetected */
export type analyticDetectedProperties_pk_columns_input = {
  id: string;
};

/** select columns of table "analytics.AnalyticPropertyDetected" */
export enum analyticDetectedProperties_select_column {
  /** column name */
  analyticAttributeID = 'analyticAttributeID',
  /** column name */
  analyticID = 'analyticID',
  /** column name */
  id = 'id',
  /** column name */
  likelihood = 'likelihood',
  /** column name */
  property = 'property',
  /** column name */
  time = 'time',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "analytics.AnalyticPropertyDetected" */
export type analyticDetectedProperties_set_input = {
  analyticAttributeID?: string;
  analyticID?: string;
  id?: string;
  likelihood?: number;
  property?: string;
  time?: string;
  value?: string;
};

/** aggregate stddev on columns */
export type analyticDetectedProperties_stddev_fields = {
  __typename?: 'analyticDetectedProperties_stddev_fields';
  analyticAttributeID?: number;
  analyticID?: number;
  id?: number;
  likelihood?: number;
};

/** order by stddev() on columns of table "analytics.AnalyticPropertyDetected" */
export type analyticDetectedProperties_stddev_order_by = {
  analyticAttributeID?: order_by;
  analyticID?: order_by;
  id?: order_by;
  likelihood?: order_by;
};

/** aggregate stddev_pop on columns */
export type analyticDetectedProperties_stddev_pop_fields = {
  __typename?: 'analyticDetectedProperties_stddev_pop_fields';
  analyticAttributeID?: number;
  analyticID?: number;
  id?: number;
  likelihood?: number;
};

/** order by stddev_pop() on columns of table "analytics.AnalyticPropertyDetected" */
export type analyticDetectedProperties_stddev_pop_order_by = {
  analyticAttributeID?: order_by;
  analyticID?: order_by;
  id?: order_by;
  likelihood?: order_by;
};

/** aggregate stddev_samp on columns */
export type analyticDetectedProperties_stddev_samp_fields = {
  __typename?: 'analyticDetectedProperties_stddev_samp_fields';
  analyticAttributeID?: number;
  analyticID?: number;
  id?: number;
  likelihood?: number;
};

/** order by stddev_samp() on columns of table "analytics.AnalyticPropertyDetected" */
export type analyticDetectedProperties_stddev_samp_order_by = {
  analyticAttributeID?: order_by;
  analyticID?: order_by;
  id?: order_by;
  likelihood?: order_by;
};

/** Streaming cursor of the table "analyticDetectedProperties" */
export type analyticDetectedProperties_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: analyticDetectedProperties_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type analyticDetectedProperties_stream_cursor_value_input = {
  analyticAttributeID?: string;
  analyticID?: string;
  id?: string;
  likelihood?: number;
  property?: string;
  time?: string;
  value?: string;
};

/** aggregate sum on columns */
export type analyticDetectedProperties_sum_fields = {
  __typename?: 'analyticDetectedProperties_sum_fields';
  analyticAttributeID?: string;
  analyticID?: string;
  id?: string;
  likelihood?: number;
};

/** order by sum() on columns of table "analytics.AnalyticPropertyDetected" */
export type analyticDetectedProperties_sum_order_by = {
  analyticAttributeID?: order_by;
  analyticID?: order_by;
  id?: order_by;
  likelihood?: order_by;
};

/** update columns of table "analytics.AnalyticPropertyDetected" */
export enum analyticDetectedProperties_update_column {
  /** column name */
  analyticAttributeID = 'analyticAttributeID',
  /** column name */
  analyticID = 'analyticID',
  /** column name */
  id = 'id',
  /** column name */
  likelihood = 'likelihood',
  /** column name */
  property = 'property',
  /** column name */
  time = 'time',
  /** column name */
  value = 'value'
}

export type analyticDetectedProperties_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: analyticDetectedProperties_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: analyticDetectedProperties_set_input;
  /** filter the rows which have to be updated */
  where: analyticDetectedProperties_bool_exp;
};

/** aggregate var_pop on columns */
export type analyticDetectedProperties_var_pop_fields = {
  __typename?: 'analyticDetectedProperties_var_pop_fields';
  analyticAttributeID?: number;
  analyticID?: number;
  id?: number;
  likelihood?: number;
};

/** order by var_pop() on columns of table "analytics.AnalyticPropertyDetected" */
export type analyticDetectedProperties_var_pop_order_by = {
  analyticAttributeID?: order_by;
  analyticID?: order_by;
  id?: order_by;
  likelihood?: order_by;
};

/** aggregate var_samp on columns */
export type analyticDetectedProperties_var_samp_fields = {
  __typename?: 'analyticDetectedProperties_var_samp_fields';
  analyticAttributeID?: number;
  analyticID?: number;
  id?: number;
  likelihood?: number;
};

/** order by var_samp() on columns of table "analytics.AnalyticPropertyDetected" */
export type analyticDetectedProperties_var_samp_order_by = {
  analyticAttributeID?: order_by;
  analyticID?: order_by;
  id?: order_by;
  likelihood?: order_by;
};

/** aggregate variance on columns */
export type analyticDetectedProperties_variance_fields = {
  __typename?: 'analyticDetectedProperties_variance_fields';
  analyticAttributeID?: number;
  analyticID?: number;
  id?: number;
  likelihood?: number;
};

/** order by variance() on columns of table "analytics.AnalyticPropertyDetected" */
export type analyticDetectedProperties_variance_order_by = {
  analyticAttributeID?: order_by;
  analyticID?: order_by;
  id?: order_by;
  likelihood?: order_by;
};

/** columns and relationships of "analytics.AnalyticType" */
export type analyticTypes = {
  __typename?: 'analyticTypes';
  /** An array relationship */
  analyticAttribute: Array<analyticAttributes>;
  /** An aggregate relationship */
  analyticAttribute_aggregate: analyticAttributes_aggregate;
  /** An object relationship */
  analyticState?: eAnalyticStates;
  /** An array relationship */
  analytics: Array<analytics>;
  /** An aggregate relationship */
  analytics_aggregate: analytics_aggregate;
  description?: string;
  /** An object relationship */
  eAnalyticIntegration: eAnalyticIntegrations;
  integration: eAnalyticIntegrations_enum;
  label?: string;
  mapType?: string;
  sensitivity?: number;
  snapshotCooldown?: number;
  state?: eAnalyticStates_enum;
  type: string;
};


/** columns and relationships of "analytics.AnalyticType" */
export type analyticTypesanalyticAttributeArgs = {
  distinct_on?: Array<analyticAttributes_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticAttributes_order_by>;
  where?: analyticAttributes_bool_exp;
};


/** columns and relationships of "analytics.AnalyticType" */
export type analyticTypesanalyticAttribute_aggregateArgs = {
  distinct_on?: Array<analyticAttributes_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticAttributes_order_by>;
  where?: analyticAttributes_bool_exp;
};


/** columns and relationships of "analytics.AnalyticType" */
export type analyticTypesanalyticsArgs = {
  distinct_on?: Array<analytics_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analytics_order_by>;
  where?: analytics_bool_exp;
};


/** columns and relationships of "analytics.AnalyticType" */
export type analyticTypesanalytics_aggregateArgs = {
  distinct_on?: Array<analytics_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analytics_order_by>;
  where?: analytics_bool_exp;
};

/** aggregated selection of "analytics.AnalyticType" */
export type analyticTypes_aggregate = {
  __typename?: 'analyticTypes_aggregate';
  aggregate?: analyticTypes_aggregate_fields;
  nodes: Array<analyticTypes>;
};

export type analyticTypes_aggregate_bool_exp = {
  count?: analyticTypes_aggregate_bool_exp_count;
};

export type analyticTypes_aggregate_bool_exp_count = {
  arguments?: Array<analyticTypes_select_column>;
  distinct?: boolean;
  filter?: analyticTypes_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "analytics.AnalyticType" */
export type analyticTypes_aggregate_fields = {
  __typename?: 'analyticTypes_aggregate_fields';
  avg?: analyticTypes_avg_fields;
  count: number;
  max?: analyticTypes_max_fields;
  min?: analyticTypes_min_fields;
  stddev?: analyticTypes_stddev_fields;
  stddev_pop?: analyticTypes_stddev_pop_fields;
  stddev_samp?: analyticTypes_stddev_samp_fields;
  sum?: analyticTypes_sum_fields;
  var_pop?: analyticTypes_var_pop_fields;
  var_samp?: analyticTypes_var_samp_fields;
  variance?: analyticTypes_variance_fields;
};


/** aggregate fields of "analytics.AnalyticType" */
export type analyticTypes_aggregate_fieldscountArgs = {
  columns?: Array<analyticTypes_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "analytics.AnalyticType" */
export type analyticTypes_aggregate_order_by = {
  avg?: analyticTypes_avg_order_by;
  count?: order_by;
  max?: analyticTypes_max_order_by;
  min?: analyticTypes_min_order_by;
  stddev?: analyticTypes_stddev_order_by;
  stddev_pop?: analyticTypes_stddev_pop_order_by;
  stddev_samp?: analyticTypes_stddev_samp_order_by;
  sum?: analyticTypes_sum_order_by;
  var_pop?: analyticTypes_var_pop_order_by;
  var_samp?: analyticTypes_var_samp_order_by;
  variance?: analyticTypes_variance_order_by;
};

/** input type for inserting array relation for remote table "analytics.AnalyticType" */
export type analyticTypes_arr_rel_insert_input = {
  data: Array<analyticTypes_insert_input>;
  /** upsert condition */
  on_conflict?: analyticTypes_on_conflict;
};

/** aggregate avg on columns */
export type analyticTypes_avg_fields = {
  __typename?: 'analyticTypes_avg_fields';
  sensitivity?: number;
  snapshotCooldown?: number;
};

/** order by avg() on columns of table "analytics.AnalyticType" */
export type analyticTypes_avg_order_by = {
  sensitivity?: order_by;
  snapshotCooldown?: order_by;
};

/** Boolean expression to filter rows from the table "analytics.AnalyticType". All fields are combined with a logical 'AND'. */
export type analyticTypes_bool_exp = {
  _and?: Array<analyticTypes_bool_exp>;
  _not?: analyticTypes_bool_exp;
  _or?: Array<analyticTypes_bool_exp>;
  analyticAttribute?: analyticAttributes_bool_exp;
  analyticAttribute_aggregate?: analyticAttributes_aggregate_bool_exp;
  analyticState?: eAnalyticStates_bool_exp;
  analytics?: analytics_bool_exp;
  analytics_aggregate?: analytics_aggregate_bool_exp;
  description?: String_comparison_exp;
  eAnalyticIntegration?: eAnalyticIntegrations_bool_exp;
  integration?: eAnalyticIntegrations_enum_comparison_exp;
  label?: String_comparison_exp;
  mapType?: String_comparison_exp;
  sensitivity?: Int_comparison_exp;
  snapshotCooldown?: Int_comparison_exp;
  state?: eAnalyticStates_enum_comparison_exp;
  type?: String_comparison_exp;
};

/** unique or primary key constraints on table "analytics.AnalyticType" */
export enum analyticTypes_constraint {
  /** unique or primary key constraint on columns "type" */
  AnalyticType_pkey = 'AnalyticType_pkey'
}

/** input type for incrementing numeric columns in table "analytics.AnalyticType" */
export type analyticTypes_inc_input = {
  sensitivity?: number;
  snapshotCooldown?: number;
};

/** input type for inserting data into table "analytics.AnalyticType" */
export type analyticTypes_insert_input = {
  analyticAttribute?: analyticAttributes_arr_rel_insert_input;
  analyticState?: eAnalyticStates_obj_rel_insert_input;
  analytics?: analytics_arr_rel_insert_input;
  description?: string;
  eAnalyticIntegration?: eAnalyticIntegrations_obj_rel_insert_input;
  integration?: eAnalyticIntegrations_enum;
  label?: string;
  mapType?: string;
  sensitivity?: number;
  snapshotCooldown?: number;
  state?: eAnalyticStates_enum;
  type?: string;
};

/** aggregate max on columns */
export type analyticTypes_max_fields = {
  __typename?: 'analyticTypes_max_fields';
  description?: string;
  label?: string;
  mapType?: string;
  sensitivity?: number;
  snapshotCooldown?: number;
  type?: string;
};

/** order by max() on columns of table "analytics.AnalyticType" */
export type analyticTypes_max_order_by = {
  description?: order_by;
  label?: order_by;
  mapType?: order_by;
  sensitivity?: order_by;
  snapshotCooldown?: order_by;
  type?: order_by;
};

/** aggregate min on columns */
export type analyticTypes_min_fields = {
  __typename?: 'analyticTypes_min_fields';
  description?: string;
  label?: string;
  mapType?: string;
  sensitivity?: number;
  snapshotCooldown?: number;
  type?: string;
};

/** order by min() on columns of table "analytics.AnalyticType" */
export type analyticTypes_min_order_by = {
  description?: order_by;
  label?: order_by;
  mapType?: order_by;
  sensitivity?: order_by;
  snapshotCooldown?: order_by;
  type?: order_by;
};

/** response of any mutation on the table "analytics.AnalyticType" */
export type analyticTypes_mutation_response = {
  __typename?: 'analyticTypes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<analyticTypes>;
};

/** input type for inserting object relation for remote table "analytics.AnalyticType" */
export type analyticTypes_obj_rel_insert_input = {
  data: analyticTypes_insert_input;
  /** upsert condition */
  on_conflict?: analyticTypes_on_conflict;
};

/** on_conflict condition type for table "analytics.AnalyticType" */
export type analyticTypes_on_conflict = {
  constraint: analyticTypes_constraint;
  update_columns?: Array<analyticTypes_update_column>;
  where?: analyticTypes_bool_exp;
};

/** Ordering options when selecting data from "analytics.AnalyticType". */
export type analyticTypes_order_by = {
  analyticAttribute_aggregate?: analyticAttributes_aggregate_order_by;
  analyticState?: eAnalyticStates_order_by;
  analytics_aggregate?: analytics_aggregate_order_by;
  description?: order_by;
  eAnalyticIntegration?: eAnalyticIntegrations_order_by;
  integration?: order_by;
  label?: order_by;
  mapType?: order_by;
  sensitivity?: order_by;
  snapshotCooldown?: order_by;
  state?: order_by;
  type?: order_by;
};

/** primary key columns input for table: analytics.AnalyticType */
export type analyticTypes_pk_columns_input = {
  type: string;
};

/** select columns of table "analytics.AnalyticType" */
export enum analyticTypes_select_column {
  /** column name */
  description = 'description',
  /** column name */
  integration = 'integration',
  /** column name */
  label = 'label',
  /** column name */
  mapType = 'mapType',
  /** column name */
  sensitivity = 'sensitivity',
  /** column name */
  snapshotCooldown = 'snapshotCooldown',
  /** column name */
  state = 'state',
  /** column name */
  type = 'type'
}

/** input type for updating data in table "analytics.AnalyticType" */
export type analyticTypes_set_input = {
  description?: string;
  integration?: eAnalyticIntegrations_enum;
  label?: string;
  mapType?: string;
  sensitivity?: number;
  snapshotCooldown?: number;
  state?: eAnalyticStates_enum;
  type?: string;
};

/** aggregate stddev on columns */
export type analyticTypes_stddev_fields = {
  __typename?: 'analyticTypes_stddev_fields';
  sensitivity?: number;
  snapshotCooldown?: number;
};

/** order by stddev() on columns of table "analytics.AnalyticType" */
export type analyticTypes_stddev_order_by = {
  sensitivity?: order_by;
  snapshotCooldown?: order_by;
};

/** aggregate stddev_pop on columns */
export type analyticTypes_stddev_pop_fields = {
  __typename?: 'analyticTypes_stddev_pop_fields';
  sensitivity?: number;
  snapshotCooldown?: number;
};

/** order by stddev_pop() on columns of table "analytics.AnalyticType" */
export type analyticTypes_stddev_pop_order_by = {
  sensitivity?: order_by;
  snapshotCooldown?: order_by;
};

/** aggregate stddev_samp on columns */
export type analyticTypes_stddev_samp_fields = {
  __typename?: 'analyticTypes_stddev_samp_fields';
  sensitivity?: number;
  snapshotCooldown?: number;
};

/** order by stddev_samp() on columns of table "analytics.AnalyticType" */
export type analyticTypes_stddev_samp_order_by = {
  sensitivity?: order_by;
  snapshotCooldown?: order_by;
};

/** Streaming cursor of the table "analyticTypes" */
export type analyticTypes_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: analyticTypes_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type analyticTypes_stream_cursor_value_input = {
  description?: string;
  integration?: eAnalyticIntegrations_enum;
  label?: string;
  mapType?: string;
  sensitivity?: number;
  snapshotCooldown?: number;
  state?: eAnalyticStates_enum;
  type?: string;
};

/** aggregate sum on columns */
export type analyticTypes_sum_fields = {
  __typename?: 'analyticTypes_sum_fields';
  sensitivity?: number;
  snapshotCooldown?: number;
};

/** order by sum() on columns of table "analytics.AnalyticType" */
export type analyticTypes_sum_order_by = {
  sensitivity?: order_by;
  snapshotCooldown?: order_by;
};

/** update columns of table "analytics.AnalyticType" */
export enum analyticTypes_update_column {
  /** column name */
  description = 'description',
  /** column name */
  integration = 'integration',
  /** column name */
  label = 'label',
  /** column name */
  mapType = 'mapType',
  /** column name */
  sensitivity = 'sensitivity',
  /** column name */
  snapshotCooldown = 'snapshotCooldown',
  /** column name */
  state = 'state',
  /** column name */
  type = 'type'
}

export type analyticTypes_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: analyticTypes_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: analyticTypes_set_input;
  /** filter the rows which have to be updated */
  where: analyticTypes_bool_exp;
};

/** aggregate var_pop on columns */
export type analyticTypes_var_pop_fields = {
  __typename?: 'analyticTypes_var_pop_fields';
  sensitivity?: number;
  snapshotCooldown?: number;
};

/** order by var_pop() on columns of table "analytics.AnalyticType" */
export type analyticTypes_var_pop_order_by = {
  sensitivity?: order_by;
  snapshotCooldown?: order_by;
};

/** aggregate var_samp on columns */
export type analyticTypes_var_samp_fields = {
  __typename?: 'analyticTypes_var_samp_fields';
  sensitivity?: number;
  snapshotCooldown?: number;
};

/** order by var_samp() on columns of table "analytics.AnalyticType" */
export type analyticTypes_var_samp_order_by = {
  sensitivity?: order_by;
  snapshotCooldown?: order_by;
};

/** aggregate variance on columns */
export type analyticTypes_variance_fields = {
  __typename?: 'analyticTypes_variance_fields';
  sensitivity?: number;
  snapshotCooldown?: number;
};

/** order by variance() on columns of table "analytics.AnalyticType" */
export type analyticTypes_variance_order_by = {
  sensitivity?: order_by;
  snapshotCooldown?: order_by;
};

/** columns and relationships of "analytics.Analytic" */
export type analytics = {
  __typename?: 'analytics';
  analyticType?: string;
  /** An array relationship */
  detectedProperties: Array<analyticDetectedProperties>;
  /** An aggregate relationship */
  detectedProperties_aggregate: analyticDetectedProperties_aggregate;
  endTime?: string;
  id: string;
  likelihood?: number;
  objectID?: string;
  /** An object relationship */
  place: qx_Place;
  placeID: string;
  /** An object relationship */
  snapshot?: qx_Snapshot;
  snapshotID?: string;
  time: string;
  /** An object relationship */
  type?: analyticTypes;
  /** An object relationship */
  videoSource?: qx_VideoSource;
  videoSourceID?: string;
};


/** columns and relationships of "analytics.Analytic" */
export type analyticsdetectedPropertiesArgs = {
  distinct_on?: Array<analyticDetectedProperties_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticDetectedProperties_order_by>;
  where?: analyticDetectedProperties_bool_exp;
};


/** columns and relationships of "analytics.Analytic" */
export type analyticsdetectedProperties_aggregateArgs = {
  distinct_on?: Array<analyticDetectedProperties_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticDetectedProperties_order_by>;
  where?: analyticDetectedProperties_bool_exp;
};

/** aggregated selection of "analytics.Analytic" */
export type analytics_aggregate = {
  __typename?: 'analytics_aggregate';
  aggregate?: analytics_aggregate_fields;
  nodes: Array<analytics>;
};

export type analytics_aggregate_bool_exp = {
  count?: analytics_aggregate_bool_exp_count;
};

export type analytics_aggregate_bool_exp_count = {
  arguments?: Array<analytics_select_column>;
  distinct?: boolean;
  filter?: analytics_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "analytics.Analytic" */
export type analytics_aggregate_fields = {
  __typename?: 'analytics_aggregate_fields';
  avg?: analytics_avg_fields;
  count: number;
  max?: analytics_max_fields;
  min?: analytics_min_fields;
  stddev?: analytics_stddev_fields;
  stddev_pop?: analytics_stddev_pop_fields;
  stddev_samp?: analytics_stddev_samp_fields;
  sum?: analytics_sum_fields;
  var_pop?: analytics_var_pop_fields;
  var_samp?: analytics_var_samp_fields;
  variance?: analytics_variance_fields;
};


/** aggregate fields of "analytics.Analytic" */
export type analytics_aggregate_fieldscountArgs = {
  columns?: Array<analytics_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "analytics.Analytic" */
export type analytics_aggregate_order_by = {
  avg?: analytics_avg_order_by;
  count?: order_by;
  max?: analytics_max_order_by;
  min?: analytics_min_order_by;
  stddev?: analytics_stddev_order_by;
  stddev_pop?: analytics_stddev_pop_order_by;
  stddev_samp?: analytics_stddev_samp_order_by;
  sum?: analytics_sum_order_by;
  var_pop?: analytics_var_pop_order_by;
  var_samp?: analytics_var_samp_order_by;
  variance?: analytics_variance_order_by;
};

/** input type for inserting array relation for remote table "analytics.Analytic" */
export type analytics_arr_rel_insert_input = {
  data: Array<analytics_insert_input>;
  /** upsert condition */
  on_conflict?: analytics_on_conflict;
};

/** aggregate avg on columns */
export type analytics_avg_fields = {
  __typename?: 'analytics_avg_fields';
  id?: number;
  likelihood?: number;
  videoSourceID?: number;
};

/** order by avg() on columns of table "analytics.Analytic" */
export type analytics_avg_order_by = {
  id?: order_by;
  likelihood?: order_by;
  videoSourceID?: order_by;
};

/** Boolean expression to filter rows from the table "analytics.Analytic". All fields are combined with a logical 'AND'. */
export type analytics_bool_exp = {
  _and?: Array<analytics_bool_exp>;
  _not?: analytics_bool_exp;
  _or?: Array<analytics_bool_exp>;
  analyticType?: String_comparison_exp;
  detectedProperties?: analyticDetectedProperties_bool_exp;
  detectedProperties_aggregate?: analyticDetectedProperties_aggregate_bool_exp;
  endTime?: timestamptz_comparison_exp;
  id?: bigint_comparison_exp;
  likelihood?: Int_comparison_exp;
  objectID?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
  snapshot?: qx_Snapshot_bool_exp;
  snapshotID?: String_comparison_exp;
  time?: timestamptz_comparison_exp;
  type?: analyticTypes_bool_exp;
  videoSource?: qx_VideoSource_bool_exp;
  videoSourceID?: bigint_comparison_exp;
};

/** unique or primary key constraints on table "analytics.Analytic" */
export enum analytics_constraint {
  /** unique or primary key constraint on columns "id" */
  Analytic_pkey = 'Analytic_pkey'
}

/** input type for incrementing numeric columns in table "analytics.Analytic" */
export type analytics_inc_input = {
  id?: string;
  likelihood?: number;
  videoSourceID?: string;
};

/** input type for inserting data into table "analytics.Analytic" */
export type analytics_insert_input = {
  analyticType?: string;
  detectedProperties?: analyticDetectedProperties_arr_rel_insert_input;
  endTime?: string;
  id?: string;
  likelihood?: number;
  objectID?: string;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
  snapshot?: qx_Snapshot_obj_rel_insert_input;
  snapshotID?: string;
  time?: string;
  type?: analyticTypes_obj_rel_insert_input;
  videoSource?: qx_VideoSource_obj_rel_insert_input;
  videoSourceID?: string;
};

/** aggregate max on columns */
export type analytics_max_fields = {
  __typename?: 'analytics_max_fields';
  analyticType?: string;
  endTime?: string;
  id?: string;
  likelihood?: number;
  objectID?: string;
  placeID?: string;
  snapshotID?: string;
  time?: string;
  videoSourceID?: string;
};

/** order by max() on columns of table "analytics.Analytic" */
export type analytics_max_order_by = {
  analyticType?: order_by;
  endTime?: order_by;
  id?: order_by;
  likelihood?: order_by;
  objectID?: order_by;
  placeID?: order_by;
  snapshotID?: order_by;
  time?: order_by;
  videoSourceID?: order_by;
};

/** aggregate min on columns */
export type analytics_min_fields = {
  __typename?: 'analytics_min_fields';
  analyticType?: string;
  endTime?: string;
  id?: string;
  likelihood?: number;
  objectID?: string;
  placeID?: string;
  snapshotID?: string;
  time?: string;
  videoSourceID?: string;
};

/** order by min() on columns of table "analytics.Analytic" */
export type analytics_min_order_by = {
  analyticType?: order_by;
  endTime?: order_by;
  id?: order_by;
  likelihood?: order_by;
  objectID?: order_by;
  placeID?: order_by;
  snapshotID?: order_by;
  time?: order_by;
  videoSourceID?: order_by;
};

/** response of any mutation on the table "analytics.Analytic" */
export type analytics_mutation_response = {
  __typename?: 'analytics_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<analytics>;
};

/** input type for inserting object relation for remote table "analytics.Analytic" */
export type analytics_obj_rel_insert_input = {
  data: analytics_insert_input;
  /** upsert condition */
  on_conflict?: analytics_on_conflict;
};

/** on_conflict condition type for table "analytics.Analytic" */
export type analytics_on_conflict = {
  constraint: analytics_constraint;
  update_columns?: Array<analytics_update_column>;
  where?: analytics_bool_exp;
};

/** Ordering options when selecting data from "analytics.Analytic". */
export type analytics_order_by = {
  analyticType?: order_by;
  detectedProperties_aggregate?: analyticDetectedProperties_aggregate_order_by;
  endTime?: order_by;
  id?: order_by;
  likelihood?: order_by;
  objectID?: order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
  snapshot?: qx_Snapshot_order_by;
  snapshotID?: order_by;
  time?: order_by;
  type?: analyticTypes_order_by;
  videoSource?: qx_VideoSource_order_by;
  videoSourceID?: order_by;
};

/** primary key columns input for table: analytics.Analytic */
export type analytics_pk_columns_input = {
  id: string;
};

/** select columns of table "analytics.Analytic" */
export enum analytics_select_column {
  /** column name */
  analyticType = 'analyticType',
  /** column name */
  endTime = 'endTime',
  /** column name */
  id = 'id',
  /** column name */
  likelihood = 'likelihood',
  /** column name */
  objectID = 'objectID',
  /** column name */
  placeID = 'placeID',
  /** column name */
  snapshotID = 'snapshotID',
  /** column name */
  time = 'time',
  /** column name */
  videoSourceID = 'videoSourceID'
}

/** input type for updating data in table "analytics.Analytic" */
export type analytics_set_input = {
  analyticType?: string;
  endTime?: string;
  id?: string;
  likelihood?: number;
  objectID?: string;
  placeID?: string;
  snapshotID?: string;
  time?: string;
  videoSourceID?: string;
};

/** aggregate stddev on columns */
export type analytics_stddev_fields = {
  __typename?: 'analytics_stddev_fields';
  id?: number;
  likelihood?: number;
  videoSourceID?: number;
};

/** order by stddev() on columns of table "analytics.Analytic" */
export type analytics_stddev_order_by = {
  id?: order_by;
  likelihood?: order_by;
  videoSourceID?: order_by;
};

/** aggregate stddev_pop on columns */
export type analytics_stddev_pop_fields = {
  __typename?: 'analytics_stddev_pop_fields';
  id?: number;
  likelihood?: number;
  videoSourceID?: number;
};

/** order by stddev_pop() on columns of table "analytics.Analytic" */
export type analytics_stddev_pop_order_by = {
  id?: order_by;
  likelihood?: order_by;
  videoSourceID?: order_by;
};

/** aggregate stddev_samp on columns */
export type analytics_stddev_samp_fields = {
  __typename?: 'analytics_stddev_samp_fields';
  id?: number;
  likelihood?: number;
  videoSourceID?: number;
};

/** order by stddev_samp() on columns of table "analytics.Analytic" */
export type analytics_stddev_samp_order_by = {
  id?: order_by;
  likelihood?: order_by;
  videoSourceID?: order_by;
};

/** Streaming cursor of the table "analytics" */
export type analytics_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: analytics_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type analytics_stream_cursor_value_input = {
  analyticType?: string;
  endTime?: string;
  id?: string;
  likelihood?: number;
  objectID?: string;
  placeID?: string;
  snapshotID?: string;
  time?: string;
  videoSourceID?: string;
};

/** aggregate sum on columns */
export type analytics_sum_fields = {
  __typename?: 'analytics_sum_fields';
  id?: string;
  likelihood?: number;
  videoSourceID?: string;
};

/** order by sum() on columns of table "analytics.Analytic" */
export type analytics_sum_order_by = {
  id?: order_by;
  likelihood?: order_by;
  videoSourceID?: order_by;
};

/** update columns of table "analytics.Analytic" */
export enum analytics_update_column {
  /** column name */
  analyticType = 'analyticType',
  /** column name */
  endTime = 'endTime',
  /** column name */
  id = 'id',
  /** column name */
  likelihood = 'likelihood',
  /** column name */
  objectID = 'objectID',
  /** column name */
  placeID = 'placeID',
  /** column name */
  snapshotID = 'snapshotID',
  /** column name */
  time = 'time',
  /** column name */
  videoSourceID = 'videoSourceID'
}

export type analytics_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: analytics_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: analytics_set_input;
  /** filter the rows which have to be updated */
  where: analytics_bool_exp;
};

/** aggregate var_pop on columns */
export type analytics_var_pop_fields = {
  __typename?: 'analytics_var_pop_fields';
  id?: number;
  likelihood?: number;
  videoSourceID?: number;
};

/** order by var_pop() on columns of table "analytics.Analytic" */
export type analytics_var_pop_order_by = {
  id?: order_by;
  likelihood?: order_by;
  videoSourceID?: order_by;
};

/** aggregate var_samp on columns */
export type analytics_var_samp_fields = {
  __typename?: 'analytics_var_samp_fields';
  id?: number;
  likelihood?: number;
  videoSourceID?: number;
};

/** order by var_samp() on columns of table "analytics.Analytic" */
export type analytics_var_samp_order_by = {
  id?: order_by;
  likelihood?: order_by;
  videoSourceID?: order_by;
};

/** aggregate variance on columns */
export type analytics_variance_fields = {
  __typename?: 'analytics_variance_fields';
  id?: number;
  likelihood?: number;
  videoSourceID?: number;
};

/** order by variance() on columns of table "analytics.Analytic" */
export type analytics_variance_order_by = {
  id?: order_by;
  likelihood?: order_by;
  videoSourceID?: order_by;
};

/** columns and relationships of "qx.ApplicationUserAppPassword" */
export type applicationUserAppPasswords = {
  __typename?: 'applicationUserAppPasswords';
  createdAt: string;
  id: string;
  label: string;
  lastUsedAt?: string;
  /** An object relationship */
  person: qx_Person;
  personID: string;
  qxApi?: boolean;
};

/** aggregated selection of "qx.ApplicationUserAppPassword" */
export type applicationUserAppPasswords_aggregate = {
  __typename?: 'applicationUserAppPasswords_aggregate';
  aggregate?: applicationUserAppPasswords_aggregate_fields;
  nodes: Array<applicationUserAppPasswords>;
};

export type applicationUserAppPasswords_aggregate_bool_exp = {
  bool_and?: applicationUserAppPasswords_aggregate_bool_exp_bool_and;
  bool_or?: applicationUserAppPasswords_aggregate_bool_exp_bool_or;
  count?: applicationUserAppPasswords_aggregate_bool_exp_count;
};

export type applicationUserAppPasswords_aggregate_bool_exp_bool_and = {
  arguments: applicationUserAppPasswords_select_column_applicationUserAppPasswords_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: applicationUserAppPasswords_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type applicationUserAppPasswords_aggregate_bool_exp_bool_or = {
  arguments: applicationUserAppPasswords_select_column_applicationUserAppPasswords_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: applicationUserAppPasswords_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type applicationUserAppPasswords_aggregate_bool_exp_count = {
  arguments?: Array<applicationUserAppPasswords_select_column>;
  distinct?: boolean;
  filter?: applicationUserAppPasswords_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.ApplicationUserAppPassword" */
export type applicationUserAppPasswords_aggregate_fields = {
  __typename?: 'applicationUserAppPasswords_aggregate_fields';
  avg?: applicationUserAppPasswords_avg_fields;
  count: number;
  max?: applicationUserAppPasswords_max_fields;
  min?: applicationUserAppPasswords_min_fields;
  stddev?: applicationUserAppPasswords_stddev_fields;
  stddev_pop?: applicationUserAppPasswords_stddev_pop_fields;
  stddev_samp?: applicationUserAppPasswords_stddev_samp_fields;
  sum?: applicationUserAppPasswords_sum_fields;
  var_pop?: applicationUserAppPasswords_var_pop_fields;
  var_samp?: applicationUserAppPasswords_var_samp_fields;
  variance?: applicationUserAppPasswords_variance_fields;
};


/** aggregate fields of "qx.ApplicationUserAppPassword" */
export type applicationUserAppPasswords_aggregate_fieldscountArgs = {
  columns?: Array<applicationUserAppPasswords_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.ApplicationUserAppPassword" */
export type applicationUserAppPasswords_aggregate_order_by = {
  avg?: applicationUserAppPasswords_avg_order_by;
  count?: order_by;
  max?: applicationUserAppPasswords_max_order_by;
  min?: applicationUserAppPasswords_min_order_by;
  stddev?: applicationUserAppPasswords_stddev_order_by;
  stddev_pop?: applicationUserAppPasswords_stddev_pop_order_by;
  stddev_samp?: applicationUserAppPasswords_stddev_samp_order_by;
  sum?: applicationUserAppPasswords_sum_order_by;
  var_pop?: applicationUserAppPasswords_var_pop_order_by;
  var_samp?: applicationUserAppPasswords_var_samp_order_by;
  variance?: applicationUserAppPasswords_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.ApplicationUserAppPassword" */
export type applicationUserAppPasswords_arr_rel_insert_input = {
  data: Array<applicationUserAppPasswords_insert_input>;
  /** upsert condition */
  on_conflict?: applicationUserAppPasswords_on_conflict;
};

/** aggregate avg on columns */
export type applicationUserAppPasswords_avg_fields = {
  __typename?: 'applicationUserAppPasswords_avg_fields';
  id?: number;
};

/** order by avg() on columns of table "qx.ApplicationUserAppPassword" */
export type applicationUserAppPasswords_avg_order_by = {
  id?: order_by;
};

/** Boolean expression to filter rows from the table "qx.ApplicationUserAppPassword". All fields are combined with a logical 'AND'. */
export type applicationUserAppPasswords_bool_exp = {
  _and?: Array<applicationUserAppPasswords_bool_exp>;
  _not?: applicationUserAppPasswords_bool_exp;
  _or?: Array<applicationUserAppPasswords_bool_exp>;
  createdAt?: timestamptz_comparison_exp;
  id?: bigint_comparison_exp;
  label?: String_comparison_exp;
  lastUsedAt?: timestamptz_comparison_exp;
  person?: qx_Person_bool_exp;
  personID?: String_comparison_exp;
  qxApi?: Boolean_comparison_exp;
};

/** unique or primary key constraints on table "qx.ApplicationUserAppPassword" */
export enum applicationUserAppPasswords_constraint {
  /** unique or primary key constraint on columns "id" */
  ApplicationUserAppPassword_pkey = 'ApplicationUserAppPassword_pkey'
}

/** input type for incrementing numeric columns in table "qx.ApplicationUserAppPassword" */
export type applicationUserAppPasswords_inc_input = {
  id?: string;
};

/** input type for inserting data into table "qx.ApplicationUserAppPassword" */
export type applicationUserAppPasswords_insert_input = {
  createdAt?: string;
  id?: string;
  label?: string;
  lastUsedAt?: string;
  person?: qx_Person_obj_rel_insert_input;
  personID?: string;
  qxApi?: boolean;
};

/** aggregate max on columns */
export type applicationUserAppPasswords_max_fields = {
  __typename?: 'applicationUserAppPasswords_max_fields';
  createdAt?: string;
  id?: string;
  label?: string;
  lastUsedAt?: string;
  personID?: string;
};

/** order by max() on columns of table "qx.ApplicationUserAppPassword" */
export type applicationUserAppPasswords_max_order_by = {
  createdAt?: order_by;
  id?: order_by;
  label?: order_by;
  lastUsedAt?: order_by;
  personID?: order_by;
};

/** aggregate min on columns */
export type applicationUserAppPasswords_min_fields = {
  __typename?: 'applicationUserAppPasswords_min_fields';
  createdAt?: string;
  id?: string;
  label?: string;
  lastUsedAt?: string;
  personID?: string;
};

/** order by min() on columns of table "qx.ApplicationUserAppPassword" */
export type applicationUserAppPasswords_min_order_by = {
  createdAt?: order_by;
  id?: order_by;
  label?: order_by;
  lastUsedAt?: order_by;
  personID?: order_by;
};

/** response of any mutation on the table "qx.ApplicationUserAppPassword" */
export type applicationUserAppPasswords_mutation_response = {
  __typename?: 'applicationUserAppPasswords_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<applicationUserAppPasswords>;
};

/** on_conflict condition type for table "qx.ApplicationUserAppPassword" */
export type applicationUserAppPasswords_on_conflict = {
  constraint: applicationUserAppPasswords_constraint;
  update_columns?: Array<applicationUserAppPasswords_update_column>;
  where?: applicationUserAppPasswords_bool_exp;
};

/** Ordering options when selecting data from "qx.ApplicationUserAppPassword". */
export type applicationUserAppPasswords_order_by = {
  createdAt?: order_by;
  id?: order_by;
  label?: order_by;
  lastUsedAt?: order_by;
  person?: qx_Person_order_by;
  personID?: order_by;
  qxApi?: order_by;
};

/** primary key columns input for table: qx.ApplicationUserAppPassword */
export type applicationUserAppPasswords_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.ApplicationUserAppPassword" */
export enum applicationUserAppPasswords_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  lastUsedAt = 'lastUsedAt',
  /** column name */
  personID = 'personID',
  /** column name */
  qxApi = 'qxApi'
}

/** select "applicationUserAppPasswords_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.ApplicationUserAppPassword" */
export enum applicationUserAppPasswords_select_column_applicationUserAppPasswords_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  qxApi = 'qxApi'
}

/** select "applicationUserAppPasswords_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.ApplicationUserAppPassword" */
export enum applicationUserAppPasswords_select_column_applicationUserAppPasswords_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  qxApi = 'qxApi'
}

/** input type for updating data in table "qx.ApplicationUserAppPassword" */
export type applicationUserAppPasswords_set_input = {
  createdAt?: string;
  id?: string;
  label?: string;
  lastUsedAt?: string;
  personID?: string;
  qxApi?: boolean;
};

/** aggregate stddev on columns */
export type applicationUserAppPasswords_stddev_fields = {
  __typename?: 'applicationUserAppPasswords_stddev_fields';
  id?: number;
};

/** order by stddev() on columns of table "qx.ApplicationUserAppPassword" */
export type applicationUserAppPasswords_stddev_order_by = {
  id?: order_by;
};

/** aggregate stddev_pop on columns */
export type applicationUserAppPasswords_stddev_pop_fields = {
  __typename?: 'applicationUserAppPasswords_stddev_pop_fields';
  id?: number;
};

/** order by stddev_pop() on columns of table "qx.ApplicationUserAppPassword" */
export type applicationUserAppPasswords_stddev_pop_order_by = {
  id?: order_by;
};

/** aggregate stddev_samp on columns */
export type applicationUserAppPasswords_stddev_samp_fields = {
  __typename?: 'applicationUserAppPasswords_stddev_samp_fields';
  id?: number;
};

/** order by stddev_samp() on columns of table "qx.ApplicationUserAppPassword" */
export type applicationUserAppPasswords_stddev_samp_order_by = {
  id?: order_by;
};

/** Streaming cursor of the table "applicationUserAppPasswords" */
export type applicationUserAppPasswords_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: applicationUserAppPasswords_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type applicationUserAppPasswords_stream_cursor_value_input = {
  createdAt?: string;
  id?: string;
  label?: string;
  lastUsedAt?: string;
  personID?: string;
  qxApi?: boolean;
};

/** aggregate sum on columns */
export type applicationUserAppPasswords_sum_fields = {
  __typename?: 'applicationUserAppPasswords_sum_fields';
  id?: string;
};

/** order by sum() on columns of table "qx.ApplicationUserAppPassword" */
export type applicationUserAppPasswords_sum_order_by = {
  id?: order_by;
};

/** update columns of table "qx.ApplicationUserAppPassword" */
export enum applicationUserAppPasswords_update_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  lastUsedAt = 'lastUsedAt',
  /** column name */
  personID = 'personID',
  /** column name */
  qxApi = 'qxApi'
}

export type applicationUserAppPasswords_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: applicationUserAppPasswords_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: applicationUserAppPasswords_set_input;
  /** filter the rows which have to be updated */
  where: applicationUserAppPasswords_bool_exp;
};

/** aggregate var_pop on columns */
export type applicationUserAppPasswords_var_pop_fields = {
  __typename?: 'applicationUserAppPasswords_var_pop_fields';
  id?: number;
};

/** order by var_pop() on columns of table "qx.ApplicationUserAppPassword" */
export type applicationUserAppPasswords_var_pop_order_by = {
  id?: order_by;
};

/** aggregate var_samp on columns */
export type applicationUserAppPasswords_var_samp_fields = {
  __typename?: 'applicationUserAppPasswords_var_samp_fields';
  id?: number;
};

/** order by var_samp() on columns of table "qx.ApplicationUserAppPassword" */
export type applicationUserAppPasswords_var_samp_order_by = {
  id?: order_by;
};

/** aggregate variance on columns */
export type applicationUserAppPasswords_variance_fields = {
  __typename?: 'applicationUserAppPasswords_variance_fields';
  id?: number;
};

/** order by variance() on columns of table "qx.ApplicationUserAppPassword" */
export type applicationUserAppPasswords_variance_order_by = {
  id?: order_by;
};

/** columns and relationships of "qx.ApplicationUserDevice" */
export type applicationUserDevices = {
  __typename?: 'applicationUserDevices';
  aaguid?: string;
  counter: any;
  createdAt?: string;
  credentialBackedUp?: boolean;
  credentialDeviceType: string;
  credentialID: string;
  credentialPublicKey: any;
  id: string;
  label?: string;
  lastUsedAt?: string;
  /** An array relationship */
  people: Array<qx_Person>;
  /** An aggregate relationship */
  people_aggregate: qx_Person_aggregate;
  personID: string;
  /** An object relationship */
  provider?: PassKeyProvider;
  transports: any;
};


/** columns and relationships of "qx.ApplicationUserDevice" */
export type applicationUserDevicespeopleArgs = {
  distinct_on?: Array<qx_Person_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Person_order_by>;
  where?: qx_Person_bool_exp;
};


/** columns and relationships of "qx.ApplicationUserDevice" */
export type applicationUserDevicespeople_aggregateArgs = {
  distinct_on?: Array<qx_Person_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Person_order_by>;
  where?: qx_Person_bool_exp;
};


/** columns and relationships of "qx.ApplicationUserDevice" */
export type applicationUserDevicestransportsArgs = {
  path?: string;
};

/** aggregated selection of "qx.ApplicationUserDevice" */
export type applicationUserDevices_aggregate = {
  __typename?: 'applicationUserDevices_aggregate';
  aggregate?: applicationUserDevices_aggregate_fields;
  nodes: Array<applicationUserDevices>;
};

/** aggregate fields of "qx.ApplicationUserDevice" */
export type applicationUserDevices_aggregate_fields = {
  __typename?: 'applicationUserDevices_aggregate_fields';
  avg?: applicationUserDevices_avg_fields;
  count: number;
  max?: applicationUserDevices_max_fields;
  min?: applicationUserDevices_min_fields;
  stddev?: applicationUserDevices_stddev_fields;
  stddev_pop?: applicationUserDevices_stddev_pop_fields;
  stddev_samp?: applicationUserDevices_stddev_samp_fields;
  sum?: applicationUserDevices_sum_fields;
  var_pop?: applicationUserDevices_var_pop_fields;
  var_samp?: applicationUserDevices_var_samp_fields;
  variance?: applicationUserDevices_variance_fields;
};


/** aggregate fields of "qx.ApplicationUserDevice" */
export type applicationUserDevices_aggregate_fieldscountArgs = {
  columns?: Array<applicationUserDevices_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type applicationUserDevices_append_input = {
  transports?: any;
};

/** aggregate avg on columns */
export type applicationUserDevices_avg_fields = {
  __typename?: 'applicationUserDevices_avg_fields';
  counter?: number;
  id?: number;
};

/** Boolean expression to filter rows from the table "qx.ApplicationUserDevice". All fields are combined with a logical 'AND'. */
export type applicationUserDevices_bool_exp = {
  _and?: Array<applicationUserDevices_bool_exp>;
  _not?: applicationUserDevices_bool_exp;
  _or?: Array<applicationUserDevices_bool_exp>;
  aaguid?: String_comparison_exp;
  counter?: numeric_comparison_exp;
  createdAt?: timestamptz_comparison_exp;
  credentialBackedUp?: Boolean_comparison_exp;
  credentialDeviceType?: String_comparison_exp;
  credentialID?: String_comparison_exp;
  credentialPublicKey?: bytea_comparison_exp;
  id?: bigint_comparison_exp;
  label?: String_comparison_exp;
  lastUsedAt?: timestamptz_comparison_exp;
  people?: qx_Person_bool_exp;
  people_aggregate?: qx_Person_aggregate_bool_exp;
  personID?: String_comparison_exp;
  provider?: PassKeyProvider_bool_exp;
  transports?: jsonb_comparison_exp;
};

/** unique or primary key constraints on table "qx.ApplicationUserDevice" */
export enum applicationUserDevices_constraint {
  /** unique or primary key constraint on columns "id" */
  ApplicationUserDevice_pkey = 'ApplicationUserDevice_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type applicationUserDevices_delete_at_path_input = {
  transports?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type applicationUserDevices_delete_elem_input = {
  transports?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type applicationUserDevices_delete_key_input = {
  transports?: string;
};

/** input type for incrementing numeric columns in table "qx.ApplicationUserDevice" */
export type applicationUserDevices_inc_input = {
  counter?: any;
  id?: string;
};

/** input type for inserting data into table "qx.ApplicationUserDevice" */
export type applicationUserDevices_insert_input = {
  aaguid?: string;
  counter?: any;
  createdAt?: string;
  credentialBackedUp?: boolean;
  credentialDeviceType?: string;
  credentialID?: string;
  credentialPublicKey?: any;
  id?: string;
  label?: string;
  lastUsedAt?: string;
  people?: qx_Person_arr_rel_insert_input;
  personID?: string;
  provider?: PassKeyProvider_obj_rel_insert_input;
  transports?: any;
};

/** aggregate max on columns */
export type applicationUserDevices_max_fields = {
  __typename?: 'applicationUserDevices_max_fields';
  aaguid?: string;
  counter?: any;
  createdAt?: string;
  credentialDeviceType?: string;
  credentialID?: string;
  id?: string;
  label?: string;
  lastUsedAt?: string;
  personID?: string;
};

/** aggregate min on columns */
export type applicationUserDevices_min_fields = {
  __typename?: 'applicationUserDevices_min_fields';
  aaguid?: string;
  counter?: any;
  createdAt?: string;
  credentialDeviceType?: string;
  credentialID?: string;
  id?: string;
  label?: string;
  lastUsedAt?: string;
  personID?: string;
};

/** response of any mutation on the table "qx.ApplicationUserDevice" */
export type applicationUserDevices_mutation_response = {
  __typename?: 'applicationUserDevices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<applicationUserDevices>;
};

/** on_conflict condition type for table "qx.ApplicationUserDevice" */
export type applicationUserDevices_on_conflict = {
  constraint: applicationUserDevices_constraint;
  update_columns?: Array<applicationUserDevices_update_column>;
  where?: applicationUserDevices_bool_exp;
};

/** Ordering options when selecting data from "qx.ApplicationUserDevice". */
export type applicationUserDevices_order_by = {
  aaguid?: order_by;
  counter?: order_by;
  createdAt?: order_by;
  credentialBackedUp?: order_by;
  credentialDeviceType?: order_by;
  credentialID?: order_by;
  credentialPublicKey?: order_by;
  id?: order_by;
  label?: order_by;
  lastUsedAt?: order_by;
  people_aggregate?: qx_Person_aggregate_order_by;
  personID?: order_by;
  provider?: PassKeyProvider_order_by;
  transports?: order_by;
};

/** primary key columns input for table: qx.ApplicationUserDevice */
export type applicationUserDevices_pk_columns_input = {
  id: string;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type applicationUserDevices_prepend_input = {
  transports?: any;
};

/** select columns of table "qx.ApplicationUserDevice" */
export enum applicationUserDevices_select_column {
  /** column name */
  aaguid = 'aaguid',
  /** column name */
  counter = 'counter',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  credentialBackedUp = 'credentialBackedUp',
  /** column name */
  credentialDeviceType = 'credentialDeviceType',
  /** column name */
  credentialID = 'credentialID',
  /** column name */
  credentialPublicKey = 'credentialPublicKey',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  lastUsedAt = 'lastUsedAt',
  /** column name */
  personID = 'personID',
  /** column name */
  transports = 'transports'
}

/** input type for updating data in table "qx.ApplicationUserDevice" */
export type applicationUserDevices_set_input = {
  aaguid?: string;
  counter?: any;
  createdAt?: string;
  credentialBackedUp?: boolean;
  credentialDeviceType?: string;
  credentialID?: string;
  credentialPublicKey?: any;
  id?: string;
  label?: string;
  lastUsedAt?: string;
  personID?: string;
  transports?: any;
};

/** aggregate stddev on columns */
export type applicationUserDevices_stddev_fields = {
  __typename?: 'applicationUserDevices_stddev_fields';
  counter?: number;
  id?: number;
};

/** aggregate stddev_pop on columns */
export type applicationUserDevices_stddev_pop_fields = {
  __typename?: 'applicationUserDevices_stddev_pop_fields';
  counter?: number;
  id?: number;
};

/** aggregate stddev_samp on columns */
export type applicationUserDevices_stddev_samp_fields = {
  __typename?: 'applicationUserDevices_stddev_samp_fields';
  counter?: number;
  id?: number;
};

/** Streaming cursor of the table "applicationUserDevices" */
export type applicationUserDevices_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: applicationUserDevices_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type applicationUserDevices_stream_cursor_value_input = {
  aaguid?: string;
  counter?: any;
  createdAt?: string;
  credentialBackedUp?: boolean;
  credentialDeviceType?: string;
  credentialID?: string;
  credentialPublicKey?: any;
  id?: string;
  label?: string;
  lastUsedAt?: string;
  personID?: string;
  transports?: any;
};

/** aggregate sum on columns */
export type applicationUserDevices_sum_fields = {
  __typename?: 'applicationUserDevices_sum_fields';
  counter?: any;
  id?: string;
};

/** update columns of table "qx.ApplicationUserDevice" */
export enum applicationUserDevices_update_column {
  /** column name */
  aaguid = 'aaguid',
  /** column name */
  counter = 'counter',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  credentialBackedUp = 'credentialBackedUp',
  /** column name */
  credentialDeviceType = 'credentialDeviceType',
  /** column name */
  credentialID = 'credentialID',
  /** column name */
  credentialPublicKey = 'credentialPublicKey',
  /** column name */
  id = 'id',
  /** column name */
  label = 'label',
  /** column name */
  lastUsedAt = 'lastUsedAt',
  /** column name */
  personID = 'personID',
  /** column name */
  transports = 'transports'
}

export type applicationUserDevices_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: applicationUserDevices_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: applicationUserDevices_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: applicationUserDevices_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: applicationUserDevices_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: applicationUserDevices_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: applicationUserDevices_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: applicationUserDevices_set_input;
  /** filter the rows which have to be updated */
  where: applicationUserDevices_bool_exp;
};

/** aggregate var_pop on columns */
export type applicationUserDevices_var_pop_fields = {
  __typename?: 'applicationUserDevices_var_pop_fields';
  counter?: number;
  id?: number;
};

/** aggregate var_samp on columns */
export type applicationUserDevices_var_samp_fields = {
  __typename?: 'applicationUserDevices_var_samp_fields';
  counter?: number;
  id?: number;
};

/** aggregate variance on columns */
export type applicationUserDevices_variance_fields = {
  __typename?: 'applicationUserDevices_variance_fields';
  counter?: number;
  id?: number;
};

/** columns and relationships of "analytics.AttributeProperty" */
export type attributeProperties = {
  __typename?: 'attributeProperties';
  /** An array relationship */
  analyticAttributeProperties: Array<analyticAttributeProperties>;
  /** An aggregate relationship */
  analyticAttributeProperties_aggregate: analyticAttributeProperties_aggregate;
  /** An object relationship */
  analyticState?: eAnalyticStates;
  /** An array relationship */
  detectedProperties: Array<analyticDetectedProperties>;
  /** An aggregate relationship */
  detectedProperties_aggregate: analyticDetectedProperties_aggregate;
  label?: string;
  parentAttributeProperty?: string;
  state?: eAnalyticStates_enum;
  value: string;
};


/** columns and relationships of "analytics.AttributeProperty" */
export type attributePropertiesanalyticAttributePropertiesArgs = {
  distinct_on?: Array<analyticAttributeProperties_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticAttributeProperties_order_by>;
  where?: analyticAttributeProperties_bool_exp;
};


/** columns and relationships of "analytics.AttributeProperty" */
export type attributePropertiesanalyticAttributeProperties_aggregateArgs = {
  distinct_on?: Array<analyticAttributeProperties_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticAttributeProperties_order_by>;
  where?: analyticAttributeProperties_bool_exp;
};


/** columns and relationships of "analytics.AttributeProperty" */
export type attributePropertiesdetectedPropertiesArgs = {
  distinct_on?: Array<analyticDetectedProperties_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticDetectedProperties_order_by>;
  where?: analyticDetectedProperties_bool_exp;
};


/** columns and relationships of "analytics.AttributeProperty" */
export type attributePropertiesdetectedProperties_aggregateArgs = {
  distinct_on?: Array<analyticDetectedProperties_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticDetectedProperties_order_by>;
  where?: analyticDetectedProperties_bool_exp;
};

/** aggregated selection of "analytics.AttributeProperty" */
export type attributeProperties_aggregate = {
  __typename?: 'attributeProperties_aggregate';
  aggregate?: attributeProperties_aggregate_fields;
  nodes: Array<attributeProperties>;
};

/** aggregate fields of "analytics.AttributeProperty" */
export type attributeProperties_aggregate_fields = {
  __typename?: 'attributeProperties_aggregate_fields';
  count: number;
  max?: attributeProperties_max_fields;
  min?: attributeProperties_min_fields;
};


/** aggregate fields of "analytics.AttributeProperty" */
export type attributeProperties_aggregate_fieldscountArgs = {
  columns?: Array<attributeProperties_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "analytics.AttributeProperty". All fields are combined with a logical 'AND'. */
export type attributeProperties_bool_exp = {
  _and?: Array<attributeProperties_bool_exp>;
  _not?: attributeProperties_bool_exp;
  _or?: Array<attributeProperties_bool_exp>;
  analyticAttributeProperties?: analyticAttributeProperties_bool_exp;
  analyticAttributeProperties_aggregate?: analyticAttributeProperties_aggregate_bool_exp;
  analyticState?: eAnalyticStates_bool_exp;
  detectedProperties?: analyticDetectedProperties_bool_exp;
  detectedProperties_aggregate?: analyticDetectedProperties_aggregate_bool_exp;
  label?: String_comparison_exp;
  parentAttributeProperty?: String_comparison_exp;
  state?: eAnalyticStates_enum_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "analytics.AttributeProperty" */
export enum attributeProperties_constraint {
  /** unique or primary key constraint on columns "value" */
  AttributeProperty_pkey = 'AttributeProperty_pkey'
}

/** input type for inserting data into table "analytics.AttributeProperty" */
export type attributeProperties_insert_input = {
  analyticAttributeProperties?: analyticAttributeProperties_arr_rel_insert_input;
  analyticState?: eAnalyticStates_obj_rel_insert_input;
  detectedProperties?: analyticDetectedProperties_arr_rel_insert_input;
  label?: string;
  parentAttributeProperty?: string;
  state?: eAnalyticStates_enum;
  value?: string;
};

/** aggregate max on columns */
export type attributeProperties_max_fields = {
  __typename?: 'attributeProperties_max_fields';
  label?: string;
  parentAttributeProperty?: string;
  value?: string;
};

/** aggregate min on columns */
export type attributeProperties_min_fields = {
  __typename?: 'attributeProperties_min_fields';
  label?: string;
  parentAttributeProperty?: string;
  value?: string;
};

/** response of any mutation on the table "analytics.AttributeProperty" */
export type attributeProperties_mutation_response = {
  __typename?: 'attributeProperties_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<attributeProperties>;
};

/** input type for inserting object relation for remote table "analytics.AttributeProperty" */
export type attributeProperties_obj_rel_insert_input = {
  data: attributeProperties_insert_input;
  /** upsert condition */
  on_conflict?: attributeProperties_on_conflict;
};

/** on_conflict condition type for table "analytics.AttributeProperty" */
export type attributeProperties_on_conflict = {
  constraint: attributeProperties_constraint;
  update_columns?: Array<attributeProperties_update_column>;
  where?: attributeProperties_bool_exp;
};

/** Ordering options when selecting data from "analytics.AttributeProperty". */
export type attributeProperties_order_by = {
  analyticAttributeProperties_aggregate?: analyticAttributeProperties_aggregate_order_by;
  analyticState?: eAnalyticStates_order_by;
  detectedProperties_aggregate?: analyticDetectedProperties_aggregate_order_by;
  label?: order_by;
  parentAttributeProperty?: order_by;
  state?: order_by;
  value?: order_by;
};

/** primary key columns input for table: analytics.AttributeProperty */
export type attributeProperties_pk_columns_input = {
  value: string;
};

/** select columns of table "analytics.AttributeProperty" */
export enum attributeProperties_select_column {
  /** column name */
  label = 'label',
  /** column name */
  parentAttributeProperty = 'parentAttributeProperty',
  /** column name */
  state = 'state',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "analytics.AttributeProperty" */
export type attributeProperties_set_input = {
  label?: string;
  parentAttributeProperty?: string;
  state?: eAnalyticStates_enum;
  value?: string;
};

/** Streaming cursor of the table "attributeProperties" */
export type attributeProperties_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: attributeProperties_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type attributeProperties_stream_cursor_value_input = {
  label?: string;
  parentAttributeProperty?: string;
  state?: eAnalyticStates_enum;
  value?: string;
};

/** update columns of table "analytics.AttributeProperty" */
export enum attributeProperties_update_column {
  /** column name */
  label = 'label',
  /** column name */
  parentAttributeProperty = 'parentAttributeProperty',
  /** column name */
  state = 'state',
  /** column name */
  value = 'value'
}

export type attributeProperties_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: attributeProperties_set_input;
  /** filter the rows which have to be updated */
  where: attributeProperties_bool_exp;
};

/** columns and relationships of "analytics.Attribute" */
export type attributes = {
  __typename?: 'attributes';
  /** An array relationship */
  analyticAttribute: Array<analyticAttributes>;
  /** An aggregate relationship */
  analyticAttribute_aggregate: analyticAttributes_aggregate;
  /** An object relationship */
  analyticState?: eAnalyticStates;
  description?: string;
  label: string;
  mapType?: string;
  state?: eAnalyticStates_enum;
  type: string;
};


/** columns and relationships of "analytics.Attribute" */
export type attributesanalyticAttributeArgs = {
  distinct_on?: Array<analyticAttributes_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticAttributes_order_by>;
  where?: analyticAttributes_bool_exp;
};


/** columns and relationships of "analytics.Attribute" */
export type attributesanalyticAttribute_aggregateArgs = {
  distinct_on?: Array<analyticAttributes_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticAttributes_order_by>;
  where?: analyticAttributes_bool_exp;
};

/** aggregated selection of "analytics.Attribute" */
export type attributes_aggregate = {
  __typename?: 'attributes_aggregate';
  aggregate?: attributes_aggregate_fields;
  nodes: Array<attributes>;
};

/** aggregate fields of "analytics.Attribute" */
export type attributes_aggregate_fields = {
  __typename?: 'attributes_aggregate_fields';
  count: number;
  max?: attributes_max_fields;
  min?: attributes_min_fields;
};


/** aggregate fields of "analytics.Attribute" */
export type attributes_aggregate_fieldscountArgs = {
  columns?: Array<attributes_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "analytics.Attribute". All fields are combined with a logical 'AND'. */
export type attributes_bool_exp = {
  _and?: Array<attributes_bool_exp>;
  _not?: attributes_bool_exp;
  _or?: Array<attributes_bool_exp>;
  analyticAttribute?: analyticAttributes_bool_exp;
  analyticAttribute_aggregate?: analyticAttributes_aggregate_bool_exp;
  analyticState?: eAnalyticStates_bool_exp;
  description?: String_comparison_exp;
  label?: String_comparison_exp;
  mapType?: String_comparison_exp;
  state?: eAnalyticStates_enum_comparison_exp;
  type?: String_comparison_exp;
};

/** unique or primary key constraints on table "analytics.Attribute" */
export enum attributes_constraint {
  /** unique or primary key constraint on columns "type" */
  Attribute_pkey = 'Attribute_pkey'
}

/** input type for inserting data into table "analytics.Attribute" */
export type attributes_insert_input = {
  analyticAttribute?: analyticAttributes_arr_rel_insert_input;
  analyticState?: eAnalyticStates_obj_rel_insert_input;
  description?: string;
  label?: string;
  mapType?: string;
  state?: eAnalyticStates_enum;
  type?: string;
};

/** aggregate max on columns */
export type attributes_max_fields = {
  __typename?: 'attributes_max_fields';
  description?: string;
  label?: string;
  mapType?: string;
  type?: string;
};

/** aggregate min on columns */
export type attributes_min_fields = {
  __typename?: 'attributes_min_fields';
  description?: string;
  label?: string;
  mapType?: string;
  type?: string;
};

/** response of any mutation on the table "analytics.Attribute" */
export type attributes_mutation_response = {
  __typename?: 'attributes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<attributes>;
};

/** input type for inserting object relation for remote table "analytics.Attribute" */
export type attributes_obj_rel_insert_input = {
  data: attributes_insert_input;
  /** upsert condition */
  on_conflict?: attributes_on_conflict;
};

/** on_conflict condition type for table "analytics.Attribute" */
export type attributes_on_conflict = {
  constraint: attributes_constraint;
  update_columns?: Array<attributes_update_column>;
  where?: attributes_bool_exp;
};

/** Ordering options when selecting data from "analytics.Attribute". */
export type attributes_order_by = {
  analyticAttribute_aggregate?: analyticAttributes_aggregate_order_by;
  analyticState?: eAnalyticStates_order_by;
  description?: order_by;
  label?: order_by;
  mapType?: order_by;
  state?: order_by;
  type?: order_by;
};

/** primary key columns input for table: analytics.Attribute */
export type attributes_pk_columns_input = {
  type: string;
};

/** select columns of table "analytics.Attribute" */
export enum attributes_select_column {
  /** column name */
  description = 'description',
  /** column name */
  label = 'label',
  /** column name */
  mapType = 'mapType',
  /** column name */
  state = 'state',
  /** column name */
  type = 'type'
}

/** input type for updating data in table "analytics.Attribute" */
export type attributes_set_input = {
  description?: string;
  label?: string;
  mapType?: string;
  state?: eAnalyticStates_enum;
  type?: string;
};

/** Streaming cursor of the table "attributes" */
export type attributes_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: attributes_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type attributes_stream_cursor_value_input = {
  description?: string;
  label?: string;
  mapType?: string;
  state?: eAnalyticStates_enum;
  type?: string;
};

/** update columns of table "analytics.Attribute" */
export enum attributes_update_column {
  /** column name */
  description = 'description',
  /** column name */
  label = 'label',
  /** column name */
  mapType = 'mapType',
  /** column name */
  state = 'state',
  /** column name */
  type = 'type'
}

export type attributes_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: attributes_set_input;
  /** filter the rows which have to be updated */
  where: attributes_bool_exp;
};

/** audit view tracking historical changes to audio source configurations */
export type audioSourceAudit = {
  __typename?: 'audioSourceAudit';
  action?: string;
  /** An object relationship */
  audioSource?: qx_AudioSource;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  row_data?: any;
  time?: string;
};


/** audit view tracking historical changes to audio source configurations */
export type audioSourceAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes to audio source configurations */
export type audioSourceAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.vAudioSourceAudit" */
export type audioSourceAudit_aggregate = {
  __typename?: 'audioSourceAudit_aggregate';
  aggregate?: audioSourceAudit_aggregate_fields;
  nodes: Array<audioSourceAudit>;
};

/** aggregate fields of "audit.vAudioSourceAudit" */
export type audioSourceAudit_aggregate_fields = {
  __typename?: 'audioSourceAudit_aggregate_fields';
  avg?: audioSourceAudit_avg_fields;
  count: number;
  max?: audioSourceAudit_max_fields;
  min?: audioSourceAudit_min_fields;
  stddev?: audioSourceAudit_stddev_fields;
  stddev_pop?: audioSourceAudit_stddev_pop_fields;
  stddev_samp?: audioSourceAudit_stddev_samp_fields;
  sum?: audioSourceAudit_sum_fields;
  var_pop?: audioSourceAudit_var_pop_fields;
  var_samp?: audioSourceAudit_var_samp_fields;
  variance?: audioSourceAudit_variance_fields;
};


/** aggregate fields of "audit.vAudioSourceAudit" */
export type audioSourceAudit_aggregate_fieldscountArgs = {
  columns?: Array<audioSourceAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type audioSourceAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type audioSourceAudit_avg_fields = {
  __typename?: 'audioSourceAudit_avg_fields';
  auditID?: number;
  id?: number;
};

/** Boolean expression to filter rows from the table "audit.vAudioSourceAudit". All fields are combined with a logical 'AND'. */
export type audioSourceAudit_bool_exp = {
  _and?: Array<audioSourceAudit_bool_exp>;
  _not?: audioSourceAudit_bool_exp;
  _or?: Array<audioSourceAudit_bool_exp>;
  action?: String_comparison_exp;
  audioSource?: qx_AudioSource_bool_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  id?: bigint_comparison_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type audioSourceAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type audioSourceAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type audioSourceAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.vAudioSourceAudit" */
export type audioSourceAudit_inc_input = {
  auditID?: string;
  id?: string;
};

/** input type for inserting data into table "audit.vAudioSourceAudit" */
export type audioSourceAudit_insert_input = {
  action?: string;
  audioSource?: qx_AudioSource_obj_rel_insert_input;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate max on columns */
export type audioSourceAudit_max_fields = {
  __typename?: 'audioSourceAudit_max_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** aggregate min on columns */
export type audioSourceAudit_min_fields = {
  __typename?: 'audioSourceAudit_min_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** response of any mutation on the table "audit.vAudioSourceAudit" */
export type audioSourceAudit_mutation_response = {
  __typename?: 'audioSourceAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<audioSourceAudit>;
};

/** Ordering options when selecting data from "audit.vAudioSourceAudit". */
export type audioSourceAudit_order_by = {
  action?: order_by;
  audioSource?: qx_AudioSource_order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  id?: order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  row_data?: order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type audioSourceAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.vAudioSourceAudit" */
export enum audioSourceAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  id = 'id',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.vAudioSourceAudit" */
export type audioSourceAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type audioSourceAudit_stddev_fields = {
  __typename?: 'audioSourceAudit_stddev_fields';
  auditID?: number;
  id?: number;
};

/** aggregate stddev_pop on columns */
export type audioSourceAudit_stddev_pop_fields = {
  __typename?: 'audioSourceAudit_stddev_pop_fields';
  auditID?: number;
  id?: number;
};

/** aggregate stddev_samp on columns */
export type audioSourceAudit_stddev_samp_fields = {
  __typename?: 'audioSourceAudit_stddev_samp_fields';
  auditID?: number;
  id?: number;
};

/** Streaming cursor of the table "audioSourceAudit" */
export type audioSourceAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: audioSourceAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type audioSourceAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type audioSourceAudit_sum_fields = {
  __typename?: 'audioSourceAudit_sum_fields';
  auditID?: string;
  id?: string;
};

export type audioSourceAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: audioSourceAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: audioSourceAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: audioSourceAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: audioSourceAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: audioSourceAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: audioSourceAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: audioSourceAudit_set_input;
  /** filter the rows which have to be updated */
  where: audioSourceAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type audioSourceAudit_var_pop_fields = {
  __typename?: 'audioSourceAudit_var_pop_fields';
  auditID?: number;
  id?: number;
};

/** aggregate var_samp on columns */
export type audioSourceAudit_var_samp_fields = {
  __typename?: 'audioSourceAudit_var_samp_fields';
  auditID?: number;
  id?: number;
};

/** aggregate variance on columns */
export type audioSourceAudit_variance_fields = {
  __typename?: 'audioSourceAudit_variance_fields';
  auditID?: number;
  id?: number;
};

/** columns and relationships of "qx.vAudioSourceVideoSource" */
export type audioSourceVideoSource = {
  __typename?: 'audioSourceVideoSource';
  /** An object relationship */
  audioSource?: qx_AudioSource;
  audioSourceID?: string;
  /** An object relationship */
  videoSource?: qx_VideoSource;
  videoSourceID?: string;
};

/** aggregated selection of "qx.vAudioSourceVideoSource" */
export type audioSourceVideoSource_aggregate = {
  __typename?: 'audioSourceVideoSource_aggregate';
  aggregate?: audioSourceVideoSource_aggregate_fields;
  nodes: Array<audioSourceVideoSource>;
};

export type audioSourceVideoSource_aggregate_bool_exp = {
  count?: audioSourceVideoSource_aggregate_bool_exp_count;
};

export type audioSourceVideoSource_aggregate_bool_exp_count = {
  arguments?: Array<audioSourceVideoSource_select_column>;
  distinct?: boolean;
  filter?: audioSourceVideoSource_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.vAudioSourceVideoSource" */
export type audioSourceVideoSource_aggregate_fields = {
  __typename?: 'audioSourceVideoSource_aggregate_fields';
  avg?: audioSourceVideoSource_avg_fields;
  count: number;
  max?: audioSourceVideoSource_max_fields;
  min?: audioSourceVideoSource_min_fields;
  stddev?: audioSourceVideoSource_stddev_fields;
  stddev_pop?: audioSourceVideoSource_stddev_pop_fields;
  stddev_samp?: audioSourceVideoSource_stddev_samp_fields;
  sum?: audioSourceVideoSource_sum_fields;
  var_pop?: audioSourceVideoSource_var_pop_fields;
  var_samp?: audioSourceVideoSource_var_samp_fields;
  variance?: audioSourceVideoSource_variance_fields;
};


/** aggregate fields of "qx.vAudioSourceVideoSource" */
export type audioSourceVideoSource_aggregate_fieldscountArgs = {
  columns?: Array<audioSourceVideoSource_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.vAudioSourceVideoSource" */
export type audioSourceVideoSource_aggregate_order_by = {
  avg?: audioSourceVideoSource_avg_order_by;
  count?: order_by;
  max?: audioSourceVideoSource_max_order_by;
  min?: audioSourceVideoSource_min_order_by;
  stddev?: audioSourceVideoSource_stddev_order_by;
  stddev_pop?: audioSourceVideoSource_stddev_pop_order_by;
  stddev_samp?: audioSourceVideoSource_stddev_samp_order_by;
  sum?: audioSourceVideoSource_sum_order_by;
  var_pop?: audioSourceVideoSource_var_pop_order_by;
  var_samp?: audioSourceVideoSource_var_samp_order_by;
  variance?: audioSourceVideoSource_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.vAudioSourceVideoSource" */
export type audioSourceVideoSource_arr_rel_insert_input = {
  data: Array<audioSourceVideoSource_insert_input>;
};

/** aggregate avg on columns */
export type audioSourceVideoSource_avg_fields = {
  __typename?: 'audioSourceVideoSource_avg_fields';
  audioSourceID?: number;
  videoSourceID?: number;
};

/** order by avg() on columns of table "qx.vAudioSourceVideoSource" */
export type audioSourceVideoSource_avg_order_by = {
  audioSourceID?: order_by;
  videoSourceID?: order_by;
};

/** Boolean expression to filter rows from the table "qx.vAudioSourceVideoSource". All fields are combined with a logical 'AND'. */
export type audioSourceVideoSource_bool_exp = {
  _and?: Array<audioSourceVideoSource_bool_exp>;
  _not?: audioSourceVideoSource_bool_exp;
  _or?: Array<audioSourceVideoSource_bool_exp>;
  audioSource?: qx_AudioSource_bool_exp;
  audioSourceID?: bigint_comparison_exp;
  videoSource?: qx_VideoSource_bool_exp;
  videoSourceID?: bigint_comparison_exp;
};

/** input type for inserting data into table "qx.vAudioSourceVideoSource" */
export type audioSourceVideoSource_insert_input = {
  audioSource?: qx_AudioSource_obj_rel_insert_input;
  audioSourceID?: string;
  videoSource?: qx_VideoSource_obj_rel_insert_input;
  videoSourceID?: string;
};

/** aggregate max on columns */
export type audioSourceVideoSource_max_fields = {
  __typename?: 'audioSourceVideoSource_max_fields';
  audioSourceID?: string;
  videoSourceID?: string;
};

/** order by max() on columns of table "qx.vAudioSourceVideoSource" */
export type audioSourceVideoSource_max_order_by = {
  audioSourceID?: order_by;
  videoSourceID?: order_by;
};

/** aggregate min on columns */
export type audioSourceVideoSource_min_fields = {
  __typename?: 'audioSourceVideoSource_min_fields';
  audioSourceID?: string;
  videoSourceID?: string;
};

/** order by min() on columns of table "qx.vAudioSourceVideoSource" */
export type audioSourceVideoSource_min_order_by = {
  audioSourceID?: order_by;
  videoSourceID?: order_by;
};

/** Ordering options when selecting data from "qx.vAudioSourceVideoSource". */
export type audioSourceVideoSource_order_by = {
  audioSource?: qx_AudioSource_order_by;
  audioSourceID?: order_by;
  videoSource?: qx_VideoSource_order_by;
  videoSourceID?: order_by;
};

/** select columns of table "qx.vAudioSourceVideoSource" */
export enum audioSourceVideoSource_select_column {
  /** column name */
  audioSourceID = 'audioSourceID',
  /** column name */
  videoSourceID = 'videoSourceID'
}

/** aggregate stddev on columns */
export type audioSourceVideoSource_stddev_fields = {
  __typename?: 'audioSourceVideoSource_stddev_fields';
  audioSourceID?: number;
  videoSourceID?: number;
};

/** order by stddev() on columns of table "qx.vAudioSourceVideoSource" */
export type audioSourceVideoSource_stddev_order_by = {
  audioSourceID?: order_by;
  videoSourceID?: order_by;
};

/** aggregate stddev_pop on columns */
export type audioSourceVideoSource_stddev_pop_fields = {
  __typename?: 'audioSourceVideoSource_stddev_pop_fields';
  audioSourceID?: number;
  videoSourceID?: number;
};

/** order by stddev_pop() on columns of table "qx.vAudioSourceVideoSource" */
export type audioSourceVideoSource_stddev_pop_order_by = {
  audioSourceID?: order_by;
  videoSourceID?: order_by;
};

/** aggregate stddev_samp on columns */
export type audioSourceVideoSource_stddev_samp_fields = {
  __typename?: 'audioSourceVideoSource_stddev_samp_fields';
  audioSourceID?: number;
  videoSourceID?: number;
};

/** order by stddev_samp() on columns of table "qx.vAudioSourceVideoSource" */
export type audioSourceVideoSource_stddev_samp_order_by = {
  audioSourceID?: order_by;
  videoSourceID?: order_by;
};

/** Streaming cursor of the table "audioSourceVideoSource" */
export type audioSourceVideoSource_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: audioSourceVideoSource_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type audioSourceVideoSource_stream_cursor_value_input = {
  audioSourceID?: string;
  videoSourceID?: string;
};

/** aggregate sum on columns */
export type audioSourceVideoSource_sum_fields = {
  __typename?: 'audioSourceVideoSource_sum_fields';
  audioSourceID?: string;
  videoSourceID?: string;
};

/** order by sum() on columns of table "qx.vAudioSourceVideoSource" */
export type audioSourceVideoSource_sum_order_by = {
  audioSourceID?: order_by;
  videoSourceID?: order_by;
};

/** aggregate var_pop on columns */
export type audioSourceVideoSource_var_pop_fields = {
  __typename?: 'audioSourceVideoSource_var_pop_fields';
  audioSourceID?: number;
  videoSourceID?: number;
};

/** order by var_pop() on columns of table "qx.vAudioSourceVideoSource" */
export type audioSourceVideoSource_var_pop_order_by = {
  audioSourceID?: order_by;
  videoSourceID?: order_by;
};

/** aggregate var_samp on columns */
export type audioSourceVideoSource_var_samp_fields = {
  __typename?: 'audioSourceVideoSource_var_samp_fields';
  audioSourceID?: number;
  videoSourceID?: number;
};

/** order by var_samp() on columns of table "qx.vAudioSourceVideoSource" */
export type audioSourceVideoSource_var_samp_order_by = {
  audioSourceID?: order_by;
  videoSourceID?: order_by;
};

/** aggregate variance on columns */
export type audioSourceVideoSource_variance_fields = {
  __typename?: 'audioSourceVideoSource_variance_fields';
  audioSourceID?: number;
  videoSourceID?: number;
};

/** order by variance() on columns of table "qx.vAudioSourceVideoSource" */
export type audioSourceVideoSource_variance_order_by = {
  audioSourceID?: order_by;
  videoSourceID?: order_by;
};

/** History of auditable actions on audited tables, from audit.if_modified_func() */
export type audit_logged_actions = {
  __typename?: 'audit_logged_actions';
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  action: string;
  /** Transaction start timestamp for tx in which audited event occurred */
  action_tstamp_tx: string;
  /** Place that record was modified, used when deleted records no longer have reference to record */
  changed_fields?: any;
  /** Unique identifier for each auditable event */
  event_id: string;
  /** An object relationship */
  person?: qx_Person;
  /** Unique identifier of the user that modified the record */
  person_id?: string;
  place_id?: string;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  row_data?: any;
  /** Database schema audited table for this event is in */
  schema_name: string;
  statement_only: boolean;
  /** Non-schema-qualified table name of table event occured in */
  table_name: string;
};


/** History of auditable actions on audited tables, from audit.if_modified_func() */
export type audit_logged_actionschanged_fieldsArgs = {
  path?: string;
};


/** History of auditable actions on audited tables, from audit.if_modified_func() */
export type audit_logged_actionsrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.logged_actions" */
export type audit_logged_actions_aggregate = {
  __typename?: 'audit_logged_actions_aggregate';
  aggregate?: audit_logged_actions_aggregate_fields;
  nodes: Array<audit_logged_actions>;
};

/** aggregate fields of "audit.logged_actions" */
export type audit_logged_actions_aggregate_fields = {
  __typename?: 'audit_logged_actions_aggregate_fields';
  avg?: audit_logged_actions_avg_fields;
  count: number;
  max?: audit_logged_actions_max_fields;
  min?: audit_logged_actions_min_fields;
  stddev?: audit_logged_actions_stddev_fields;
  stddev_pop?: audit_logged_actions_stddev_pop_fields;
  stddev_samp?: audit_logged_actions_stddev_samp_fields;
  sum?: audit_logged_actions_sum_fields;
  var_pop?: audit_logged_actions_var_pop_fields;
  var_samp?: audit_logged_actions_var_samp_fields;
  variance?: audit_logged_actions_variance_fields;
};


/** aggregate fields of "audit.logged_actions" */
export type audit_logged_actions_aggregate_fieldscountArgs = {
  columns?: Array<audit_logged_actions_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type audit_logged_actions_append_input = {
  /** Place that record was modified, used when deleted records no longer have reference to record */
  changed_fields?: any;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  row_data?: any;
};

/** aggregate avg on columns */
export type audit_logged_actions_avg_fields = {
  __typename?: 'audit_logged_actions_avg_fields';
  /** Unique identifier for each auditable event */
  event_id?: number;
};

/** Boolean expression to filter rows from the table "audit.logged_actions". All fields are combined with a logical 'AND'. */
export type audit_logged_actions_bool_exp = {
  _and?: Array<audit_logged_actions_bool_exp>;
  _not?: audit_logged_actions_bool_exp;
  _or?: Array<audit_logged_actions_bool_exp>;
  action?: String_comparison_exp;
  action_tstamp_tx?: timestamptz_comparison_exp;
  changed_fields?: jsonb_comparison_exp;
  event_id?: bigint_comparison_exp;
  person?: qx_Person_bool_exp;
  person_id?: String_comparison_exp;
  place_id?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  schema_name?: String_comparison_exp;
  statement_only?: Boolean_comparison_exp;
  table_name?: String_comparison_exp;
};

/** unique or primary key constraints on table "audit.logged_actions" */
export enum audit_logged_actions_constraint {
  /** unique or primary key constraint on columns "event_id" */
  logged_actions_pkey = 'logged_actions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type audit_logged_actions_delete_at_path_input = {
  /** Place that record was modified, used when deleted records no longer have reference to record */
  changed_fields?: Array<string>;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type audit_logged_actions_delete_elem_input = {
  /** Place that record was modified, used when deleted records no longer have reference to record */
  changed_fields?: number;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type audit_logged_actions_delete_key_input = {
  /** Place that record was modified, used when deleted records no longer have reference to record */
  changed_fields?: string;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.logged_actions" */
export type audit_logged_actions_inc_input = {
  /** Unique identifier for each auditable event */
  event_id?: string;
};

/** input type for inserting data into table "audit.logged_actions" */
export type audit_logged_actions_insert_input = {
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  action?: string;
  /** Transaction start timestamp for tx in which audited event occurred */
  action_tstamp_tx?: string;
  /** Place that record was modified, used when deleted records no longer have reference to record */
  changed_fields?: any;
  /** Unique identifier for each auditable event */
  event_id?: string;
  person?: qx_Person_obj_rel_insert_input;
  /** Unique identifier of the user that modified the record */
  person_id?: string;
  place_id?: string;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  row_data?: any;
  /** Database schema audited table for this event is in */
  schema_name?: string;
  statement_only?: boolean;
  /** Non-schema-qualified table name of table event occured in */
  table_name?: string;
};

/** aggregate max on columns */
export type audit_logged_actions_max_fields = {
  __typename?: 'audit_logged_actions_max_fields';
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  action?: string;
  /** Transaction start timestamp for tx in which audited event occurred */
  action_tstamp_tx?: string;
  /** Unique identifier for each auditable event */
  event_id?: string;
  /** Unique identifier of the user that modified the record */
  person_id?: string;
  place_id?: string;
  /** Database schema audited table for this event is in */
  schema_name?: string;
  /** Non-schema-qualified table name of table event occured in */
  table_name?: string;
};

/** aggregate min on columns */
export type audit_logged_actions_min_fields = {
  __typename?: 'audit_logged_actions_min_fields';
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  action?: string;
  /** Transaction start timestamp for tx in which audited event occurred */
  action_tstamp_tx?: string;
  /** Unique identifier for each auditable event */
  event_id?: string;
  /** Unique identifier of the user that modified the record */
  person_id?: string;
  place_id?: string;
  /** Database schema audited table for this event is in */
  schema_name?: string;
  /** Non-schema-qualified table name of table event occured in */
  table_name?: string;
};

/** response of any mutation on the table "audit.logged_actions" */
export type audit_logged_actions_mutation_response = {
  __typename?: 'audit_logged_actions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<audit_logged_actions>;
};

/** on_conflict condition type for table "audit.logged_actions" */
export type audit_logged_actions_on_conflict = {
  constraint: audit_logged_actions_constraint;
  update_columns?: Array<audit_logged_actions_update_column>;
  where?: audit_logged_actions_bool_exp;
};

/** Ordering options when selecting data from "audit.logged_actions". */
export type audit_logged_actions_order_by = {
  action?: order_by;
  action_tstamp_tx?: order_by;
  changed_fields?: order_by;
  event_id?: order_by;
  person?: qx_Person_order_by;
  person_id?: order_by;
  place_id?: order_by;
  row_data?: order_by;
  schema_name?: order_by;
  statement_only?: order_by;
  table_name?: order_by;
};

/** primary key columns input for table: audit.logged_actions */
export type audit_logged_actions_pk_columns_input = {
  /** Unique identifier for each auditable event */
  event_id: string;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type audit_logged_actions_prepend_input = {
  /** Place that record was modified, used when deleted records no longer have reference to record */
  changed_fields?: any;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  row_data?: any;
};

/** select columns of table "audit.logged_actions" */
export enum audit_logged_actions_select_column {
  /** column name */
  action = 'action',
  /** column name */
  action_tstamp_tx = 'action_tstamp_tx',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  event_id = 'event_id',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  schema_name = 'schema_name',
  /** column name */
  statement_only = 'statement_only',
  /** column name */
  table_name = 'table_name'
}

/** input type for updating data in table "audit.logged_actions" */
export type audit_logged_actions_set_input = {
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  action?: string;
  /** Transaction start timestamp for tx in which audited event occurred */
  action_tstamp_tx?: string;
  /** Place that record was modified, used when deleted records no longer have reference to record */
  changed_fields?: any;
  /** Unique identifier for each auditable event */
  event_id?: string;
  /** Unique identifier of the user that modified the record */
  person_id?: string;
  place_id?: string;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  row_data?: any;
  /** Database schema audited table for this event is in */
  schema_name?: string;
  statement_only?: boolean;
  /** Non-schema-qualified table name of table event occured in */
  table_name?: string;
};

/** aggregate stddev on columns */
export type audit_logged_actions_stddev_fields = {
  __typename?: 'audit_logged_actions_stddev_fields';
  /** Unique identifier for each auditable event */
  event_id?: number;
};

/** aggregate stddev_pop on columns */
export type audit_logged_actions_stddev_pop_fields = {
  __typename?: 'audit_logged_actions_stddev_pop_fields';
  /** Unique identifier for each auditable event */
  event_id?: number;
};

/** aggregate stddev_samp on columns */
export type audit_logged_actions_stddev_samp_fields = {
  __typename?: 'audit_logged_actions_stddev_samp_fields';
  /** Unique identifier for each auditable event */
  event_id?: number;
};

/** Streaming cursor of the table "audit_logged_actions" */
export type audit_logged_actions_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: audit_logged_actions_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type audit_logged_actions_stream_cursor_value_input = {
  /** Action type; I = insert, D = delete, U = update, T = truncate */
  action?: string;
  /** Transaction start timestamp for tx in which audited event occurred */
  action_tstamp_tx?: string;
  /** Place that record was modified, used when deleted records no longer have reference to record */
  changed_fields?: any;
  /** Unique identifier for each auditable event */
  event_id?: string;
  /** Unique identifier of the user that modified the record */
  person_id?: string;
  place_id?: string;
  /** Record value. Null for statement-level trigger. For INSERT this is the new tuple. For DELETE and UPDATE it is the old tuple. */
  row_data?: any;
  /** Database schema audited table for this event is in */
  schema_name?: string;
  statement_only?: boolean;
  /** Non-schema-qualified table name of table event occured in */
  table_name?: string;
};

/** aggregate sum on columns */
export type audit_logged_actions_sum_fields = {
  __typename?: 'audit_logged_actions_sum_fields';
  /** Unique identifier for each auditable event */
  event_id?: string;
};

/** update columns of table "audit.logged_actions" */
export enum audit_logged_actions_update_column {
  /** column name */
  action = 'action',
  /** column name */
  action_tstamp_tx = 'action_tstamp_tx',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  event_id = 'event_id',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  schema_name = 'schema_name',
  /** column name */
  statement_only = 'statement_only',
  /** column name */
  table_name = 'table_name'
}

export type audit_logged_actions_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: audit_logged_actions_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: audit_logged_actions_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: audit_logged_actions_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: audit_logged_actions_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: audit_logged_actions_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: audit_logged_actions_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: audit_logged_actions_set_input;
  /** filter the rows which have to be updated */
  where: audit_logged_actions_bool_exp;
};

/** aggregate var_pop on columns */
export type audit_logged_actions_var_pop_fields = {
  __typename?: 'audit_logged_actions_var_pop_fields';
  /** Unique identifier for each auditable event */
  event_id?: number;
};

/** aggregate var_samp on columns */
export type audit_logged_actions_var_samp_fields = {
  __typename?: 'audit_logged_actions_var_samp_fields';
  /** Unique identifier for each auditable event */
  event_id?: number;
};

/** aggregate variance on columns */
export type audit_logged_actions_variance_fields = {
  __typename?: 'audit_logged_actions_variance_fields';
  /** Unique identifier for each auditable event */
  event_id?: number;
};

/** audit view tracking historical changes to sensor configurations */
export type audit_vSensorAudit = {
  __typename?: 'audit_vSensorAudit';
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  row_data?: any;
  /** An object relationship */
  sensor?: qx_Sensor;
  time?: string;
};


/** audit view tracking historical changes to sensor configurations */
export type audit_vSensorAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes to sensor configurations */
export type audit_vSensorAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.vSensorAudit" */
export type audit_vSensorAudit_aggregate = {
  __typename?: 'audit_vSensorAudit_aggregate';
  aggregate?: audit_vSensorAudit_aggregate_fields;
  nodes: Array<audit_vSensorAudit>;
};

/** aggregate fields of "audit.vSensorAudit" */
export type audit_vSensorAudit_aggregate_fields = {
  __typename?: 'audit_vSensorAudit_aggregate_fields';
  avg?: audit_vSensorAudit_avg_fields;
  count: number;
  max?: audit_vSensorAudit_max_fields;
  min?: audit_vSensorAudit_min_fields;
  stddev?: audit_vSensorAudit_stddev_fields;
  stddev_pop?: audit_vSensorAudit_stddev_pop_fields;
  stddev_samp?: audit_vSensorAudit_stddev_samp_fields;
  sum?: audit_vSensorAudit_sum_fields;
  var_pop?: audit_vSensorAudit_var_pop_fields;
  var_samp?: audit_vSensorAudit_var_samp_fields;
  variance?: audit_vSensorAudit_variance_fields;
};


/** aggregate fields of "audit.vSensorAudit" */
export type audit_vSensorAudit_aggregate_fieldscountArgs = {
  columns?: Array<audit_vSensorAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type audit_vSensorAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type audit_vSensorAudit_avg_fields = {
  __typename?: 'audit_vSensorAudit_avg_fields';
  auditID?: number;
  id?: number;
};

/** Boolean expression to filter rows from the table "audit.vSensorAudit". All fields are combined with a logical 'AND'. */
export type audit_vSensorAudit_bool_exp = {
  _and?: Array<audit_vSensorAudit_bool_exp>;
  _not?: audit_vSensorAudit_bool_exp;
  _or?: Array<audit_vSensorAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changed_fields?: jsonb_comparison_exp;
  id?: bigint_comparison_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  sensor?: qx_Sensor_bool_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type audit_vSensorAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type audit_vSensorAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type audit_vSensorAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.vSensorAudit" */
export type audit_vSensorAudit_inc_input = {
  auditID?: string;
  id?: string;
};

/** input type for inserting data into table "audit.vSensorAudit" */
export type audit_vSensorAudit_insert_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  row_data?: any;
  sensor?: qx_Sensor_obj_rel_insert_input;
  time?: string;
};

/** aggregate max on columns */
export type audit_vSensorAudit_max_fields = {
  __typename?: 'audit_vSensorAudit_max_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** aggregate min on columns */
export type audit_vSensorAudit_min_fields = {
  __typename?: 'audit_vSensorAudit_min_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** response of any mutation on the table "audit.vSensorAudit" */
export type audit_vSensorAudit_mutation_response = {
  __typename?: 'audit_vSensorAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<audit_vSensorAudit>;
};

/** Ordering options when selecting data from "audit.vSensorAudit". */
export type audit_vSensorAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changed_fields?: order_by;
  id?: order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  row_data?: order_by;
  sensor?: qx_Sensor_order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type audit_vSensorAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.vSensorAudit" */
export enum audit_vSensorAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  id = 'id',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.vSensorAudit" */
export type audit_vSensorAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type audit_vSensorAudit_stddev_fields = {
  __typename?: 'audit_vSensorAudit_stddev_fields';
  auditID?: number;
  id?: number;
};

/** aggregate stddev_pop on columns */
export type audit_vSensorAudit_stddev_pop_fields = {
  __typename?: 'audit_vSensorAudit_stddev_pop_fields';
  auditID?: number;
  id?: number;
};

/** aggregate stddev_samp on columns */
export type audit_vSensorAudit_stddev_samp_fields = {
  __typename?: 'audit_vSensorAudit_stddev_samp_fields';
  auditID?: number;
  id?: number;
};

/** Streaming cursor of the table "audit_vSensorAudit" */
export type audit_vSensorAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: audit_vSensorAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type audit_vSensorAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type audit_vSensorAudit_sum_fields = {
  __typename?: 'audit_vSensorAudit_sum_fields';
  auditID?: string;
  id?: string;
};

export type audit_vSensorAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: audit_vSensorAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: audit_vSensorAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: audit_vSensorAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: audit_vSensorAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: audit_vSensorAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: audit_vSensorAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: audit_vSensorAudit_set_input;
  /** filter the rows which have to be updated */
  where: audit_vSensorAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type audit_vSensorAudit_var_pop_fields = {
  __typename?: 'audit_vSensorAudit_var_pop_fields';
  auditID?: number;
  id?: number;
};

/** aggregate var_samp on columns */
export type audit_vSensorAudit_var_samp_fields = {
  __typename?: 'audit_vSensorAudit_var_samp_fields';
  auditID?: number;
  id?: number;
};

/** aggregate variance on columns */
export type audit_vSensorAudit_variance_fields = {
  __typename?: 'audit_vSensorAudit_variance_fields';
  auditID?: number;
  id?: number;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type bigint_comparison_exp = {
  _eq?: string;
  _gt?: string;
  _gte?: string;
  _in?: Array<string>;
  _is_null?: boolean;
  _lt?: string;
  _lte?: string;
  _neq?: string;
  _nin?: Array<string>;
};

/** Boolean expression to compare columns of type "bpchar". All fields are combined with logical 'AND'. */
export type bpchar_comparison_exp = {
  _eq?: any;
  _gt?: any;
  _gte?: any;
  /** does the column match the given case-insensitive pattern */
  _ilike?: any;
  _in?: Array<any>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: any;
  _is_null?: boolean;
  /** does the column match the given pattern */
  _like?: any;
  _lt?: any;
  _lte?: any;
  _neq?: any;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: any;
  _nin?: Array<any>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: any;
  /** does the column NOT match the given pattern */
  _nlike?: any;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: any;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: any;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: any;
  /** does the column match the given SQL regular expression */
  _similar?: any;
};

/** Boolean expression to compare columns of type "bytea". All fields are combined with logical 'AND'. */
export type bytea_comparison_exp = {
  _eq?: any;
  _gt?: any;
  _gte?: any;
  _in?: Array<any>;
  _is_null?: boolean;
  _lt?: any;
  _lte?: any;
  _neq?: any;
  _nin?: Array<any>;
};

/** columns and relationships of "qx.CloudStorageTimelapseOptions" */
export type cloudStorageTimelapseOptions = {
  __typename?: 'cloudStorageTimelapseOptions';
  cloudStorageDays: number;
  partName?: string;
  /** An array relationship */
  videoSources: Array<qx_VideoSource>;
  /** An aggregate relationship */
  videoSources_aggregate: qx_VideoSource_aggregate;
};


/** columns and relationships of "qx.CloudStorageTimelapseOptions" */
export type cloudStorageTimelapseOptionsvideoSourcesArgs = {
  distinct_on?: Array<qx_VideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_VideoSource_order_by>;
  where?: qx_VideoSource_bool_exp;
};


/** columns and relationships of "qx.CloudStorageTimelapseOptions" */
export type cloudStorageTimelapseOptionsvideoSources_aggregateArgs = {
  distinct_on?: Array<qx_VideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_VideoSource_order_by>;
  where?: qx_VideoSource_bool_exp;
};

/** aggregated selection of "qx.CloudStorageTimelapseOptions" */
export type cloudStorageTimelapseOptions_aggregate = {
  __typename?: 'cloudStorageTimelapseOptions_aggregate';
  aggregate?: cloudStorageTimelapseOptions_aggregate_fields;
  nodes: Array<cloudStorageTimelapseOptions>;
};

/** aggregate fields of "qx.CloudStorageTimelapseOptions" */
export type cloudStorageTimelapseOptions_aggregate_fields = {
  __typename?: 'cloudStorageTimelapseOptions_aggregate_fields';
  avg?: cloudStorageTimelapseOptions_avg_fields;
  count: number;
  max?: cloudStorageTimelapseOptions_max_fields;
  min?: cloudStorageTimelapseOptions_min_fields;
  stddev?: cloudStorageTimelapseOptions_stddev_fields;
  stddev_pop?: cloudStorageTimelapseOptions_stddev_pop_fields;
  stddev_samp?: cloudStorageTimelapseOptions_stddev_samp_fields;
  sum?: cloudStorageTimelapseOptions_sum_fields;
  var_pop?: cloudStorageTimelapseOptions_var_pop_fields;
  var_samp?: cloudStorageTimelapseOptions_var_samp_fields;
  variance?: cloudStorageTimelapseOptions_variance_fields;
};


/** aggregate fields of "qx.CloudStorageTimelapseOptions" */
export type cloudStorageTimelapseOptions_aggregate_fieldscountArgs = {
  columns?: Array<cloudStorageTimelapseOptions_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type cloudStorageTimelapseOptions_avg_fields = {
  __typename?: 'cloudStorageTimelapseOptions_avg_fields';
  cloudStorageDays?: number;
};

/** Boolean expression to filter rows from the table "qx.CloudStorageTimelapseOptions". All fields are combined with a logical 'AND'. */
export type cloudStorageTimelapseOptions_bool_exp = {
  _and?: Array<cloudStorageTimelapseOptions_bool_exp>;
  _not?: cloudStorageTimelapseOptions_bool_exp;
  _or?: Array<cloudStorageTimelapseOptions_bool_exp>;
  cloudStorageDays?: Int_comparison_exp;
  partName?: String_comparison_exp;
  videoSources?: qx_VideoSource_bool_exp;
  videoSources_aggregate?: qx_VideoSource_aggregate_bool_exp;
};

/** unique or primary key constraints on table "qx.CloudStorageTimelapseOptions" */
export enum cloudStorageTimelapseOptions_constraint {
  /** unique or primary key constraint on columns "cloudStorageDays" */
  CloudStorageTimelapseOptions_pkey = 'CloudStorageTimelapseOptions_pkey'
}

/** input type for incrementing numeric columns in table "qx.CloudStorageTimelapseOptions" */
export type cloudStorageTimelapseOptions_inc_input = {
  cloudStorageDays?: number;
};

/** input type for inserting data into table "qx.CloudStorageTimelapseOptions" */
export type cloudStorageTimelapseOptions_insert_input = {
  cloudStorageDays?: number;
  partName?: string;
  videoSources?: qx_VideoSource_arr_rel_insert_input;
};

/** aggregate max on columns */
export type cloudStorageTimelapseOptions_max_fields = {
  __typename?: 'cloudStorageTimelapseOptions_max_fields';
  cloudStorageDays?: number;
  partName?: string;
};

/** aggregate min on columns */
export type cloudStorageTimelapseOptions_min_fields = {
  __typename?: 'cloudStorageTimelapseOptions_min_fields';
  cloudStorageDays?: number;
  partName?: string;
};

/** response of any mutation on the table "qx.CloudStorageTimelapseOptions" */
export type cloudStorageTimelapseOptions_mutation_response = {
  __typename?: 'cloudStorageTimelapseOptions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<cloudStorageTimelapseOptions>;
};

/** on_conflict condition type for table "qx.CloudStorageTimelapseOptions" */
export type cloudStorageTimelapseOptions_on_conflict = {
  constraint: cloudStorageTimelapseOptions_constraint;
  update_columns?: Array<cloudStorageTimelapseOptions_update_column>;
  where?: cloudStorageTimelapseOptions_bool_exp;
};

/** Ordering options when selecting data from "qx.CloudStorageTimelapseOptions". */
export type cloudStorageTimelapseOptions_order_by = {
  cloudStorageDays?: order_by;
  partName?: order_by;
  videoSources_aggregate?: qx_VideoSource_aggregate_order_by;
};

/** primary key columns input for table: qx.CloudStorageTimelapseOptions */
export type cloudStorageTimelapseOptions_pk_columns_input = {
  cloudStorageDays: number;
};

/** select columns of table "qx.CloudStorageTimelapseOptions" */
export enum cloudStorageTimelapseOptions_select_column {
  /** column name */
  cloudStorageDays = 'cloudStorageDays',
  /** column name */
  partName = 'partName'
}

/** input type for updating data in table "qx.CloudStorageTimelapseOptions" */
export type cloudStorageTimelapseOptions_set_input = {
  cloudStorageDays?: number;
  partName?: string;
};

/** aggregate stddev on columns */
export type cloudStorageTimelapseOptions_stddev_fields = {
  __typename?: 'cloudStorageTimelapseOptions_stddev_fields';
  cloudStorageDays?: number;
};

/** aggregate stddev_pop on columns */
export type cloudStorageTimelapseOptions_stddev_pop_fields = {
  __typename?: 'cloudStorageTimelapseOptions_stddev_pop_fields';
  cloudStorageDays?: number;
};

/** aggregate stddev_samp on columns */
export type cloudStorageTimelapseOptions_stddev_samp_fields = {
  __typename?: 'cloudStorageTimelapseOptions_stddev_samp_fields';
  cloudStorageDays?: number;
};

/** Streaming cursor of the table "cloudStorageTimelapseOptions" */
export type cloudStorageTimelapseOptions_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: cloudStorageTimelapseOptions_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type cloudStorageTimelapseOptions_stream_cursor_value_input = {
  cloudStorageDays?: number;
  partName?: string;
};

/** aggregate sum on columns */
export type cloudStorageTimelapseOptions_sum_fields = {
  __typename?: 'cloudStorageTimelapseOptions_sum_fields';
  cloudStorageDays?: number;
};

/** update columns of table "qx.CloudStorageTimelapseOptions" */
export enum cloudStorageTimelapseOptions_update_column {
  /** column name */
  cloudStorageDays = 'cloudStorageDays',
  /** column name */
  partName = 'partName'
}

export type cloudStorageTimelapseOptions_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: cloudStorageTimelapseOptions_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: cloudStorageTimelapseOptions_set_input;
  /** filter the rows which have to be updated */
  where: cloudStorageTimelapseOptions_bool_exp;
};

/** aggregate var_pop on columns */
export type cloudStorageTimelapseOptions_var_pop_fields = {
  __typename?: 'cloudStorageTimelapseOptions_var_pop_fields';
  cloudStorageDays?: number;
};

/** aggregate var_samp on columns */
export type cloudStorageTimelapseOptions_var_samp_fields = {
  __typename?: 'cloudStorageTimelapseOptions_var_samp_fields';
  cloudStorageDays?: number;
};

/** aggregate variance on columns */
export type cloudStorageTimelapseOptions_variance_fields = {
  __typename?: 'cloudStorageTimelapseOptions_variance_fields';
  cloudStorageDays?: number;
};

export type connectionSettings = {
  address?: string;
  password?: string;
  port?: number;
  tls?: boolean;
  username?: string;
};

/** audit view tracking historical changes to access credentials (creates, updates, deletes) */
export type credentialAudit = {
  __typename?: 'credentialAudit';
  action?: string;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  /** An object relationship */
  credential?: qx_Credential;
  id?: string;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  row_data?: any;
  time?: string;
};


/** audit view tracking historical changes to access credentials (creates, updates, deletes) */
export type credentialAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes to access credentials (creates, updates, deletes) */
export type credentialAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.vCredentialAudit" */
export type credentialAudit_aggregate = {
  __typename?: 'credentialAudit_aggregate';
  aggregate?: credentialAudit_aggregate_fields;
  nodes: Array<credentialAudit>;
};

/** aggregate fields of "audit.vCredentialAudit" */
export type credentialAudit_aggregate_fields = {
  __typename?: 'credentialAudit_aggregate_fields';
  avg?: credentialAudit_avg_fields;
  count: number;
  max?: credentialAudit_max_fields;
  min?: credentialAudit_min_fields;
  stddev?: credentialAudit_stddev_fields;
  stddev_pop?: credentialAudit_stddev_pop_fields;
  stddev_samp?: credentialAudit_stddev_samp_fields;
  sum?: credentialAudit_sum_fields;
  var_pop?: credentialAudit_var_pop_fields;
  var_samp?: credentialAudit_var_samp_fields;
  variance?: credentialAudit_variance_fields;
};


/** aggregate fields of "audit.vCredentialAudit" */
export type credentialAudit_aggregate_fieldscountArgs = {
  columns?: Array<credentialAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type credentialAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type credentialAudit_avg_fields = {
  __typename?: 'credentialAudit_avg_fields';
  auditID?: number;
};

/** Boolean expression to filter rows from the table "audit.vCredentialAudit". All fields are combined with a logical 'AND'. */
export type credentialAudit_bool_exp = {
  _and?: Array<credentialAudit_bool_exp>;
  _not?: credentialAudit_bool_exp;
  _or?: Array<credentialAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  credential?: qx_Credential_bool_exp;
  id?: String_comparison_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type credentialAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type credentialAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type credentialAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.vCredentialAudit" */
export type credentialAudit_inc_input = {
  auditID?: string;
};

/** input type for inserting data into table "audit.vCredentialAudit" */
export type credentialAudit_insert_input = {
  action?: string;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  credential?: qx_Credential_obj_rel_insert_input;
  id?: string;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate max on columns */
export type credentialAudit_max_fields = {
  __typename?: 'credentialAudit_max_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** aggregate min on columns */
export type credentialAudit_min_fields = {
  __typename?: 'credentialAudit_min_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** response of any mutation on the table "audit.vCredentialAudit" */
export type credentialAudit_mutation_response = {
  __typename?: 'credentialAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<credentialAudit>;
};

/** Ordering options when selecting data from "audit.vCredentialAudit". */
export type credentialAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  credential?: qx_Credential_order_by;
  id?: order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  row_data?: order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type credentialAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.vCredentialAudit" */
export enum credentialAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  id = 'id',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.vCredentialAudit" */
export type credentialAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type credentialAudit_stddev_fields = {
  __typename?: 'credentialAudit_stddev_fields';
  auditID?: number;
};

/** aggregate stddev_pop on columns */
export type credentialAudit_stddev_pop_fields = {
  __typename?: 'credentialAudit_stddev_pop_fields';
  auditID?: number;
};

/** aggregate stddev_samp on columns */
export type credentialAudit_stddev_samp_fields = {
  __typename?: 'credentialAudit_stddev_samp_fields';
  auditID?: number;
};

/** Streaming cursor of the table "credentialAudit" */
export type credentialAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: credentialAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type credentialAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type credentialAudit_sum_fields = {
  __typename?: 'credentialAudit_sum_fields';
  auditID?: string;
};

export type credentialAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: credentialAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: credentialAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: credentialAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: credentialAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: credentialAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: credentialAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: credentialAudit_set_input;
  /** filter the rows which have to be updated */
  where: credentialAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type credentialAudit_var_pop_fields = {
  __typename?: 'credentialAudit_var_pop_fields';
  auditID?: number;
};

/** aggregate var_samp on columns */
export type credentialAudit_var_samp_fields = {
  __typename?: 'credentialAudit_var_samp_fields';
  auditID?: number;
};

/** aggregate variance on columns */
export type credentialAudit_variance_fields = {
  __typename?: 'credentialAudit_variance_fields';
  auditID?: number;
};

/** ordering argument of a cursor */
export enum cursor_ordering {
  /** ascending ordering of the cursor */
  ASC = 'ASC',
  /** descending ordering of the cursor */
  DESC = 'DESC'
}

/** audit view tracking historical changes to customer-level permissions */
export type customerPermissionAudit = {
  __typename?: 'customerPermissionAudit';
  action?: string;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  /** An object relationship */
  customerPermission?: qx_CustomerPermission;
  customerPlaceID?: string;
  /** An object relationship */
  person?: qx_Person;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  row_data?: any;
  time?: string;
};


/** audit view tracking historical changes to customer-level permissions */
export type customerPermissionAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes to customer-level permissions */
export type customerPermissionAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.vCustomerPermissionAudit" */
export type customerPermissionAudit_aggregate = {
  __typename?: 'customerPermissionAudit_aggregate';
  aggregate?: customerPermissionAudit_aggregate_fields;
  nodes: Array<customerPermissionAudit>;
};

/** aggregate fields of "audit.vCustomerPermissionAudit" */
export type customerPermissionAudit_aggregate_fields = {
  __typename?: 'customerPermissionAudit_aggregate_fields';
  avg?: customerPermissionAudit_avg_fields;
  count: number;
  max?: customerPermissionAudit_max_fields;
  min?: customerPermissionAudit_min_fields;
  stddev?: customerPermissionAudit_stddev_fields;
  stddev_pop?: customerPermissionAudit_stddev_pop_fields;
  stddev_samp?: customerPermissionAudit_stddev_samp_fields;
  sum?: customerPermissionAudit_sum_fields;
  var_pop?: customerPermissionAudit_var_pop_fields;
  var_samp?: customerPermissionAudit_var_samp_fields;
  variance?: customerPermissionAudit_variance_fields;
};


/** aggregate fields of "audit.vCustomerPermissionAudit" */
export type customerPermissionAudit_aggregate_fieldscountArgs = {
  columns?: Array<customerPermissionAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type customerPermissionAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type customerPermissionAudit_avg_fields = {
  __typename?: 'customerPermissionAudit_avg_fields';
  auditID?: number;
};

/** Boolean expression to filter rows from the table "audit.vCustomerPermissionAudit". All fields are combined with a logical 'AND'. */
export type customerPermissionAudit_bool_exp = {
  _and?: Array<customerPermissionAudit_bool_exp>;
  _not?: customerPermissionAudit_bool_exp;
  _or?: Array<customerPermissionAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  customerPermission?: qx_CustomerPermission_bool_exp;
  customerPlaceID?: String_comparison_exp;
  person?: qx_Person_bool_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type customerPermissionAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type customerPermissionAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type customerPermissionAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.vCustomerPermissionAudit" */
export type customerPermissionAudit_inc_input = {
  auditID?: string;
};

/** input type for inserting data into table "audit.vCustomerPermissionAudit" */
export type customerPermissionAudit_insert_input = {
  action?: string;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  customerPermission?: qx_CustomerPermission_obj_rel_insert_input;
  customerPlaceID?: string;
  person?: qx_Person_obj_rel_insert_input;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate max on columns */
export type customerPermissionAudit_max_fields = {
  __typename?: 'customerPermissionAudit_max_fields';
  action?: string;
  auditID?: string;
  customerPlaceID?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** aggregate min on columns */
export type customerPermissionAudit_min_fields = {
  __typename?: 'customerPermissionAudit_min_fields';
  action?: string;
  auditID?: string;
  customerPlaceID?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** response of any mutation on the table "audit.vCustomerPermissionAudit" */
export type customerPermissionAudit_mutation_response = {
  __typename?: 'customerPermissionAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<customerPermissionAudit>;
};

/** Ordering options when selecting data from "audit.vCustomerPermissionAudit". */
export type customerPermissionAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  customerPermission?: qx_CustomerPermission_order_by;
  customerPlaceID?: order_by;
  person?: qx_Person_order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  row_data?: order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type customerPermissionAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.vCustomerPermissionAudit" */
export enum customerPermissionAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  customerPlaceID = 'customerPlaceID',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.vCustomerPermissionAudit" */
export type customerPermissionAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  customerPlaceID?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type customerPermissionAudit_stddev_fields = {
  __typename?: 'customerPermissionAudit_stddev_fields';
  auditID?: number;
};

/** aggregate stddev_pop on columns */
export type customerPermissionAudit_stddev_pop_fields = {
  __typename?: 'customerPermissionAudit_stddev_pop_fields';
  auditID?: number;
};

/** aggregate stddev_samp on columns */
export type customerPermissionAudit_stddev_samp_fields = {
  __typename?: 'customerPermissionAudit_stddev_samp_fields';
  auditID?: number;
};

/** Streaming cursor of the table "customerPermissionAudit" */
export type customerPermissionAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: customerPermissionAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type customerPermissionAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  customerPlaceID?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type customerPermissionAudit_sum_fields = {
  __typename?: 'customerPermissionAudit_sum_fields';
  auditID?: string;
};

export type customerPermissionAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: customerPermissionAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: customerPermissionAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: customerPermissionAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: customerPermissionAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: customerPermissionAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: customerPermissionAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: customerPermissionAudit_set_input;
  /** filter the rows which have to be updated */
  where: customerPermissionAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type customerPermissionAudit_var_pop_fields = {
  __typename?: 'customerPermissionAudit_var_pop_fields';
  auditID?: number;
};

/** aggregate var_samp on columns */
export type customerPermissionAudit_var_samp_fields = {
  __typename?: 'customerPermissionAudit_var_samp_fields';
  auditID?: number;
};

/** aggregate variance on columns */
export type customerPermissionAudit_variance_fields = {
  __typename?: 'customerPermissionAudit_variance_fields';
  auditID?: number;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type date_comparison_exp = {
  _eq?: string;
  _gt?: string;
  _gte?: string;
  _in?: Array<string>;
  _is_null?: boolean;
  _lt?: string;
  _lte?: string;
  _neq?: string;
  _nin?: Array<string>;
};

/** columns and relationships of "qx.DeviceAnalyticSource" */
export type deviceAnalyticSource = {
  __typename?: 'deviceAnalyticSource';
  /** An object relationship */
  analyticSource: AnalyticSources;
  analyticSourceID: number;
  /** An object relationship */
  device: qx_Device;
  deviceID: string;
  id: number;
};

/** aggregated selection of "qx.DeviceAnalyticSource" */
export type deviceAnalyticSource_aggregate = {
  __typename?: 'deviceAnalyticSource_aggregate';
  aggregate?: deviceAnalyticSource_aggregate_fields;
  nodes: Array<deviceAnalyticSource>;
};

export type deviceAnalyticSource_aggregate_bool_exp = {
  count?: deviceAnalyticSource_aggregate_bool_exp_count;
};

export type deviceAnalyticSource_aggregate_bool_exp_count = {
  arguments?: Array<deviceAnalyticSource_select_column>;
  distinct?: boolean;
  filter?: deviceAnalyticSource_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.DeviceAnalyticSource" */
export type deviceAnalyticSource_aggregate_fields = {
  __typename?: 'deviceAnalyticSource_aggregate_fields';
  avg?: deviceAnalyticSource_avg_fields;
  count: number;
  max?: deviceAnalyticSource_max_fields;
  min?: deviceAnalyticSource_min_fields;
  stddev?: deviceAnalyticSource_stddev_fields;
  stddev_pop?: deviceAnalyticSource_stddev_pop_fields;
  stddev_samp?: deviceAnalyticSource_stddev_samp_fields;
  sum?: deviceAnalyticSource_sum_fields;
  var_pop?: deviceAnalyticSource_var_pop_fields;
  var_samp?: deviceAnalyticSource_var_samp_fields;
  variance?: deviceAnalyticSource_variance_fields;
};


/** aggregate fields of "qx.DeviceAnalyticSource" */
export type deviceAnalyticSource_aggregate_fieldscountArgs = {
  columns?: Array<deviceAnalyticSource_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.DeviceAnalyticSource" */
export type deviceAnalyticSource_aggregate_order_by = {
  avg?: deviceAnalyticSource_avg_order_by;
  count?: order_by;
  max?: deviceAnalyticSource_max_order_by;
  min?: deviceAnalyticSource_min_order_by;
  stddev?: deviceAnalyticSource_stddev_order_by;
  stddev_pop?: deviceAnalyticSource_stddev_pop_order_by;
  stddev_samp?: deviceAnalyticSource_stddev_samp_order_by;
  sum?: deviceAnalyticSource_sum_order_by;
  var_pop?: deviceAnalyticSource_var_pop_order_by;
  var_samp?: deviceAnalyticSource_var_samp_order_by;
  variance?: deviceAnalyticSource_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.DeviceAnalyticSource" */
export type deviceAnalyticSource_arr_rel_insert_input = {
  data: Array<deviceAnalyticSource_insert_input>;
  /** upsert condition */
  on_conflict?: deviceAnalyticSource_on_conflict;
};

/** aggregate avg on columns */
export type deviceAnalyticSource_avg_fields = {
  __typename?: 'deviceAnalyticSource_avg_fields';
  analyticSourceID?: number;
  id?: number;
};

/** order by avg() on columns of table "qx.DeviceAnalyticSource" */
export type deviceAnalyticSource_avg_order_by = {
  analyticSourceID?: order_by;
  id?: order_by;
};

/** Boolean expression to filter rows from the table "qx.DeviceAnalyticSource". All fields are combined with a logical 'AND'. */
export type deviceAnalyticSource_bool_exp = {
  _and?: Array<deviceAnalyticSource_bool_exp>;
  _not?: deviceAnalyticSource_bool_exp;
  _or?: Array<deviceAnalyticSource_bool_exp>;
  analyticSource?: AnalyticSources_bool_exp;
  analyticSourceID?: Int_comparison_exp;
  device?: qx_Device_bool_exp;
  deviceID?: String_comparison_exp;
  id?: Int_comparison_exp;
};

/** unique or primary key constraints on table "qx.DeviceAnalyticSource" */
export enum deviceAnalyticSource_constraint {
  /** unique or primary key constraint on columns "analyticSourceID", "deviceID" */
  DeviceAnalyticSource_deviceId_analyticSourceId_key = 'DeviceAnalyticSource_deviceId_analyticSourceId_key',
  /** unique or primary key constraint on columns "id" */
  DeviceAnalyticSource_pkey = 'DeviceAnalyticSource_pkey'
}

/** input type for incrementing numeric columns in table "qx.DeviceAnalyticSource" */
export type deviceAnalyticSource_inc_input = {
  analyticSourceID?: number;
  id?: number;
};

/** input type for inserting data into table "qx.DeviceAnalyticSource" */
export type deviceAnalyticSource_insert_input = {
  analyticSource?: AnalyticSources_obj_rel_insert_input;
  analyticSourceID?: number;
  device?: qx_Device_obj_rel_insert_input;
  deviceID?: string;
  id?: number;
};

/** aggregate max on columns */
export type deviceAnalyticSource_max_fields = {
  __typename?: 'deviceAnalyticSource_max_fields';
  analyticSourceID?: number;
  deviceID?: string;
  id?: number;
};

/** order by max() on columns of table "qx.DeviceAnalyticSource" */
export type deviceAnalyticSource_max_order_by = {
  analyticSourceID?: order_by;
  deviceID?: order_by;
  id?: order_by;
};

/** aggregate min on columns */
export type deviceAnalyticSource_min_fields = {
  __typename?: 'deviceAnalyticSource_min_fields';
  analyticSourceID?: number;
  deviceID?: string;
  id?: number;
};

/** order by min() on columns of table "qx.DeviceAnalyticSource" */
export type deviceAnalyticSource_min_order_by = {
  analyticSourceID?: order_by;
  deviceID?: order_by;
  id?: order_by;
};

/** response of any mutation on the table "qx.DeviceAnalyticSource" */
export type deviceAnalyticSource_mutation_response = {
  __typename?: 'deviceAnalyticSource_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<deviceAnalyticSource>;
};

/** on_conflict condition type for table "qx.DeviceAnalyticSource" */
export type deviceAnalyticSource_on_conflict = {
  constraint: deviceAnalyticSource_constraint;
  update_columns?: Array<deviceAnalyticSource_update_column>;
  where?: deviceAnalyticSource_bool_exp;
};

/** Ordering options when selecting data from "qx.DeviceAnalyticSource". */
export type deviceAnalyticSource_order_by = {
  analyticSource?: AnalyticSources_order_by;
  analyticSourceID?: order_by;
  device?: qx_Device_order_by;
  deviceID?: order_by;
  id?: order_by;
};

/** primary key columns input for table: qx.DeviceAnalyticSource */
export type deviceAnalyticSource_pk_columns_input = {
  id: number;
};

/** select columns of table "qx.DeviceAnalyticSource" */
export enum deviceAnalyticSource_select_column {
  /** column name */
  analyticSourceID = 'analyticSourceID',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  id = 'id'
}

/** input type for updating data in table "qx.DeviceAnalyticSource" */
export type deviceAnalyticSource_set_input = {
  analyticSourceID?: number;
  deviceID?: string;
  id?: number;
};

/** aggregate stddev on columns */
export type deviceAnalyticSource_stddev_fields = {
  __typename?: 'deviceAnalyticSource_stddev_fields';
  analyticSourceID?: number;
  id?: number;
};

/** order by stddev() on columns of table "qx.DeviceAnalyticSource" */
export type deviceAnalyticSource_stddev_order_by = {
  analyticSourceID?: order_by;
  id?: order_by;
};

/** aggregate stddev_pop on columns */
export type deviceAnalyticSource_stddev_pop_fields = {
  __typename?: 'deviceAnalyticSource_stddev_pop_fields';
  analyticSourceID?: number;
  id?: number;
};

/** order by stddev_pop() on columns of table "qx.DeviceAnalyticSource" */
export type deviceAnalyticSource_stddev_pop_order_by = {
  analyticSourceID?: order_by;
  id?: order_by;
};

/** aggregate stddev_samp on columns */
export type deviceAnalyticSource_stddev_samp_fields = {
  __typename?: 'deviceAnalyticSource_stddev_samp_fields';
  analyticSourceID?: number;
  id?: number;
};

/** order by stddev_samp() on columns of table "qx.DeviceAnalyticSource" */
export type deviceAnalyticSource_stddev_samp_order_by = {
  analyticSourceID?: order_by;
  id?: order_by;
};

/** Streaming cursor of the table "deviceAnalyticSource" */
export type deviceAnalyticSource_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: deviceAnalyticSource_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type deviceAnalyticSource_stream_cursor_value_input = {
  analyticSourceID?: number;
  deviceID?: string;
  id?: number;
};

/** aggregate sum on columns */
export type deviceAnalyticSource_sum_fields = {
  __typename?: 'deviceAnalyticSource_sum_fields';
  analyticSourceID?: number;
  id?: number;
};

/** order by sum() on columns of table "qx.DeviceAnalyticSource" */
export type deviceAnalyticSource_sum_order_by = {
  analyticSourceID?: order_by;
  id?: order_by;
};

/** update columns of table "qx.DeviceAnalyticSource" */
export enum deviceAnalyticSource_update_column {
  /** column name */
  analyticSourceID = 'analyticSourceID',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  id = 'id'
}

export type deviceAnalyticSource_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: deviceAnalyticSource_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: deviceAnalyticSource_set_input;
  /** filter the rows which have to be updated */
  where: deviceAnalyticSource_bool_exp;
};

/** aggregate var_pop on columns */
export type deviceAnalyticSource_var_pop_fields = {
  __typename?: 'deviceAnalyticSource_var_pop_fields';
  analyticSourceID?: number;
  id?: number;
};

/** order by var_pop() on columns of table "qx.DeviceAnalyticSource" */
export type deviceAnalyticSource_var_pop_order_by = {
  analyticSourceID?: order_by;
  id?: order_by;
};

/** aggregate var_samp on columns */
export type deviceAnalyticSource_var_samp_fields = {
  __typename?: 'deviceAnalyticSource_var_samp_fields';
  analyticSourceID?: number;
  id?: number;
};

/** order by var_samp() on columns of table "qx.DeviceAnalyticSource" */
export type deviceAnalyticSource_var_samp_order_by = {
  analyticSourceID?: order_by;
  id?: order_by;
};

/** aggregate variance on columns */
export type deviceAnalyticSource_variance_fields = {
  __typename?: 'deviceAnalyticSource_variance_fields';
  analyticSourceID?: number;
  id?: number;
};

/** order by variance() on columns of table "qx.DeviceAnalyticSource" */
export type deviceAnalyticSource_variance_order_by = {
  analyticSourceID?: order_by;
  id?: order_by;
};

/** audit view tracking historical changes to device records */
export type deviceAudit = {
  __typename?: 'deviceAudit';
  action?: string;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  /** An object relationship */
  device?: qx_Device;
  id?: string;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  row_data?: any;
  time?: string;
};


/** audit view tracking historical changes to device records */
export type deviceAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes to device records */
export type deviceAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.vDeviceAudit" */
export type deviceAudit_aggregate = {
  __typename?: 'deviceAudit_aggregate';
  aggregate?: deviceAudit_aggregate_fields;
  nodes: Array<deviceAudit>;
};

/** aggregate fields of "audit.vDeviceAudit" */
export type deviceAudit_aggregate_fields = {
  __typename?: 'deviceAudit_aggregate_fields';
  avg?: deviceAudit_avg_fields;
  count: number;
  max?: deviceAudit_max_fields;
  min?: deviceAudit_min_fields;
  stddev?: deviceAudit_stddev_fields;
  stddev_pop?: deviceAudit_stddev_pop_fields;
  stddev_samp?: deviceAudit_stddev_samp_fields;
  sum?: deviceAudit_sum_fields;
  var_pop?: deviceAudit_var_pop_fields;
  var_samp?: deviceAudit_var_samp_fields;
  variance?: deviceAudit_variance_fields;
};


/** aggregate fields of "audit.vDeviceAudit" */
export type deviceAudit_aggregate_fieldscountArgs = {
  columns?: Array<deviceAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type deviceAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type deviceAudit_avg_fields = {
  __typename?: 'deviceAudit_avg_fields';
  auditID?: number;
};

/** Boolean expression to filter rows from the table "audit.vDeviceAudit". All fields are combined with a logical 'AND'. */
export type deviceAudit_bool_exp = {
  _and?: Array<deviceAudit_bool_exp>;
  _not?: deviceAudit_bool_exp;
  _or?: Array<deviceAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  device?: qx_Device_bool_exp;
  id?: String_comparison_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type deviceAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type deviceAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type deviceAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.vDeviceAudit" */
export type deviceAudit_inc_input = {
  auditID?: string;
};

/** input type for inserting data into table "audit.vDeviceAudit" */
export type deviceAudit_insert_input = {
  action?: string;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  device?: qx_Device_obj_rel_insert_input;
  id?: string;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate max on columns */
export type deviceAudit_max_fields = {
  __typename?: 'deviceAudit_max_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** aggregate min on columns */
export type deviceAudit_min_fields = {
  __typename?: 'deviceAudit_min_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** response of any mutation on the table "audit.vDeviceAudit" */
export type deviceAudit_mutation_response = {
  __typename?: 'deviceAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<deviceAudit>;
};

/** Ordering options when selecting data from "audit.vDeviceAudit". */
export type deviceAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  device?: qx_Device_order_by;
  id?: order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  row_data?: order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type deviceAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.vDeviceAudit" */
export enum deviceAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  id = 'id',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.vDeviceAudit" */
export type deviceAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type deviceAudit_stddev_fields = {
  __typename?: 'deviceAudit_stddev_fields';
  auditID?: number;
};

/** aggregate stddev_pop on columns */
export type deviceAudit_stddev_pop_fields = {
  __typename?: 'deviceAudit_stddev_pop_fields';
  auditID?: number;
};

/** aggregate stddev_samp on columns */
export type deviceAudit_stddev_samp_fields = {
  __typename?: 'deviceAudit_stddev_samp_fields';
  auditID?: number;
};

/** Streaming cursor of the table "deviceAudit" */
export type deviceAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: deviceAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type deviceAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type deviceAudit_sum_fields = {
  __typename?: 'deviceAudit_sum_fields';
  auditID?: string;
};

export type deviceAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: deviceAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: deviceAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: deviceAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: deviceAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: deviceAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: deviceAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: deviceAudit_set_input;
  /** filter the rows which have to be updated */
  where: deviceAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type deviceAudit_var_pop_fields = {
  __typename?: 'deviceAudit_var_pop_fields';
  auditID?: number;
};

/** aggregate var_samp on columns */
export type deviceAudit_var_samp_fields = {
  __typename?: 'deviceAudit_var_samp_fields';
  auditID?: number;
};

/** aggregate variance on columns */
export type deviceAudit_variance_fields = {
  __typename?: 'deviceAudit_variance_fields';
  auditID?: number;
};

/** audit view tracking historical changes to device digital I/O channel configurations */
export type deviceDIOAudit = {
  __typename?: 'deviceDIOAudit';
  action?: string;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  /** An object relationship */
  deviceDIO?: qx_DeviceDIO;
  id?: string;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  row_data?: any;
  time?: string;
};


/** audit view tracking historical changes to device digital I/O channel configurations */
export type deviceDIOAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes to device digital I/O channel configurations */
export type deviceDIOAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.vDeviceDIOAudit" */
export type deviceDIOAudit_aggregate = {
  __typename?: 'deviceDIOAudit_aggregate';
  aggregate?: deviceDIOAudit_aggregate_fields;
  nodes: Array<deviceDIOAudit>;
};

/** aggregate fields of "audit.vDeviceDIOAudit" */
export type deviceDIOAudit_aggregate_fields = {
  __typename?: 'deviceDIOAudit_aggregate_fields';
  avg?: deviceDIOAudit_avg_fields;
  count: number;
  max?: deviceDIOAudit_max_fields;
  min?: deviceDIOAudit_min_fields;
  stddev?: deviceDIOAudit_stddev_fields;
  stddev_pop?: deviceDIOAudit_stddev_pop_fields;
  stddev_samp?: deviceDIOAudit_stddev_samp_fields;
  sum?: deviceDIOAudit_sum_fields;
  var_pop?: deviceDIOAudit_var_pop_fields;
  var_samp?: deviceDIOAudit_var_samp_fields;
  variance?: deviceDIOAudit_variance_fields;
};


/** aggregate fields of "audit.vDeviceDIOAudit" */
export type deviceDIOAudit_aggregate_fieldscountArgs = {
  columns?: Array<deviceDIOAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type deviceDIOAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type deviceDIOAudit_avg_fields = {
  __typename?: 'deviceDIOAudit_avg_fields';
  auditID?: number;
};

/** Boolean expression to filter rows from the table "audit.vDeviceDIOAudit". All fields are combined with a logical 'AND'. */
export type deviceDIOAudit_bool_exp = {
  _and?: Array<deviceDIOAudit_bool_exp>;
  _not?: deviceDIOAudit_bool_exp;
  _or?: Array<deviceDIOAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  deviceDIO?: qx_DeviceDIO_bool_exp;
  id?: String_comparison_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type deviceDIOAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type deviceDIOAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type deviceDIOAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.vDeviceDIOAudit" */
export type deviceDIOAudit_inc_input = {
  auditID?: string;
};

/** input type for inserting data into table "audit.vDeviceDIOAudit" */
export type deviceDIOAudit_insert_input = {
  action?: string;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  deviceDIO?: qx_DeviceDIO_obj_rel_insert_input;
  id?: string;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate max on columns */
export type deviceDIOAudit_max_fields = {
  __typename?: 'deviceDIOAudit_max_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** aggregate min on columns */
export type deviceDIOAudit_min_fields = {
  __typename?: 'deviceDIOAudit_min_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** response of any mutation on the table "audit.vDeviceDIOAudit" */
export type deviceDIOAudit_mutation_response = {
  __typename?: 'deviceDIOAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<deviceDIOAudit>;
};

/** Ordering options when selecting data from "audit.vDeviceDIOAudit". */
export type deviceDIOAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  deviceDIO?: qx_DeviceDIO_order_by;
  id?: order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  row_data?: order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type deviceDIOAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.vDeviceDIOAudit" */
export enum deviceDIOAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  id = 'id',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.vDeviceDIOAudit" */
export type deviceDIOAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type deviceDIOAudit_stddev_fields = {
  __typename?: 'deviceDIOAudit_stddev_fields';
  auditID?: number;
};

/** aggregate stddev_pop on columns */
export type deviceDIOAudit_stddev_pop_fields = {
  __typename?: 'deviceDIOAudit_stddev_pop_fields';
  auditID?: number;
};

/** aggregate stddev_samp on columns */
export type deviceDIOAudit_stddev_samp_fields = {
  __typename?: 'deviceDIOAudit_stddev_samp_fields';
  auditID?: number;
};

/** Streaming cursor of the table "deviceDIOAudit" */
export type deviceDIOAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: deviceDIOAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type deviceDIOAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type deviceDIOAudit_sum_fields = {
  __typename?: 'deviceDIOAudit_sum_fields';
  auditID?: string;
};

export type deviceDIOAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: deviceDIOAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: deviceDIOAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: deviceDIOAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: deviceDIOAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: deviceDIOAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: deviceDIOAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: deviceDIOAudit_set_input;
  /** filter the rows which have to be updated */
  where: deviceDIOAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type deviceDIOAudit_var_pop_fields = {
  __typename?: 'deviceDIOAudit_var_pop_fields';
  auditID?: number;
};

/** aggregate var_samp on columns */
export type deviceDIOAudit_var_samp_fields = {
  __typename?: 'deviceDIOAudit_var_samp_fields';
  auditID?: number;
};

/** aggregate variance on columns */
export type deviceDIOAudit_variance_fields = {
  __typename?: 'deviceDIOAudit_variance_fields';
  auditID?: number;
};

/** audit view tracking historical changes to door configurations */
export type doorAudit = {
  __typename?: 'doorAudit';
  action?: string;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  /** An object relationship */
  door?: qx_Door;
  id?: string;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  row_data?: any;
  time?: string;
};


/** audit view tracking historical changes to door configurations */
export type doorAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes to door configurations */
export type doorAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.vDoorAudit" */
export type doorAudit_aggregate = {
  __typename?: 'doorAudit_aggregate';
  aggregate?: doorAudit_aggregate_fields;
  nodes: Array<doorAudit>;
};

/** aggregate fields of "audit.vDoorAudit" */
export type doorAudit_aggregate_fields = {
  __typename?: 'doorAudit_aggregate_fields';
  avg?: doorAudit_avg_fields;
  count: number;
  max?: doorAudit_max_fields;
  min?: doorAudit_min_fields;
  stddev?: doorAudit_stddev_fields;
  stddev_pop?: doorAudit_stddev_pop_fields;
  stddev_samp?: doorAudit_stddev_samp_fields;
  sum?: doorAudit_sum_fields;
  var_pop?: doorAudit_var_pop_fields;
  var_samp?: doorAudit_var_samp_fields;
  variance?: doorAudit_variance_fields;
};


/** aggregate fields of "audit.vDoorAudit" */
export type doorAudit_aggregate_fieldscountArgs = {
  columns?: Array<doorAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type doorAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type doorAudit_avg_fields = {
  __typename?: 'doorAudit_avg_fields';
  auditID?: number;
  id?: number;
};

/** Boolean expression to filter rows from the table "audit.vDoorAudit". All fields are combined with a logical 'AND'. */
export type doorAudit_bool_exp = {
  _and?: Array<doorAudit_bool_exp>;
  _not?: doorAudit_bool_exp;
  _or?: Array<doorAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  door?: qx_Door_bool_exp;
  id?: bigint_comparison_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type doorAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type doorAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type doorAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.vDoorAudit" */
export type doorAudit_inc_input = {
  auditID?: string;
  id?: string;
};

/** input type for inserting data into table "audit.vDoorAudit" */
export type doorAudit_insert_input = {
  action?: string;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  door?: qx_Door_obj_rel_insert_input;
  id?: string;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate max on columns */
export type doorAudit_max_fields = {
  __typename?: 'doorAudit_max_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** aggregate min on columns */
export type doorAudit_min_fields = {
  __typename?: 'doorAudit_min_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** response of any mutation on the table "audit.vDoorAudit" */
export type doorAudit_mutation_response = {
  __typename?: 'doorAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<doorAudit>;
};

/** Ordering options when selecting data from "audit.vDoorAudit". */
export type doorAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  door?: qx_Door_order_by;
  id?: order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  row_data?: order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type doorAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.vDoorAudit" */
export enum doorAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  id = 'id',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.vDoorAudit" */
export type doorAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type doorAudit_stddev_fields = {
  __typename?: 'doorAudit_stddev_fields';
  auditID?: number;
  id?: number;
};

/** aggregate stddev_pop on columns */
export type doorAudit_stddev_pop_fields = {
  __typename?: 'doorAudit_stddev_pop_fields';
  auditID?: number;
  id?: number;
};

/** aggregate stddev_samp on columns */
export type doorAudit_stddev_samp_fields = {
  __typename?: 'doorAudit_stddev_samp_fields';
  auditID?: number;
  id?: number;
};

/** Streaming cursor of the table "doorAudit" */
export type doorAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: doorAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type doorAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type doorAudit_sum_fields = {
  __typename?: 'doorAudit_sum_fields';
  auditID?: string;
  id?: string;
};

export type doorAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: doorAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: doorAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: doorAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: doorAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: doorAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: doorAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: doorAudit_set_input;
  /** filter the rows which have to be updated */
  where: doorAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type doorAudit_var_pop_fields = {
  __typename?: 'doorAudit_var_pop_fields';
  auditID?: number;
  id?: number;
};

/** aggregate var_samp on columns */
export type doorAudit_var_samp_fields = {
  __typename?: 'doorAudit_var_samp_fields';
  auditID?: number;
  id?: number;
};

/** aggregate variance on columns */
export type doorAudit_variance_fields = {
  __typename?: 'doorAudit_variance_fields';
  auditID?: number;
  id?: number;
};

export type doorSettings = {
  accessTime?: string;
  accessType?: string;
  configuration?: Array<namevalue>;
  doorMonitor?: string;
  doorMonitorAddress?: string;
  enabled?: boolean;
  extendedAccessTime?: string;
  extendedOpenTime?: string;
  lockAddress?: string;
  monitorLockID?: string;
  monitorLockState?: string;
  openTime?: string;
  preAlarmTime?: string;
  refId?: string;
  type?: string;
  unlockScheduleID?: string;
};

/** columns and relationships of "analytics.eAnalyticIntegration" */
export type eAnalyticIntegrations = {
  __typename?: 'eAnalyticIntegrations';
  /** An array relationship */
  Analytics: Array<analyticTypes>;
  /** An aggregate relationship */
  Analytics_aggregate: analyticTypes_aggregate;
  comment?: string;
  value: string;
};


/** columns and relationships of "analytics.eAnalyticIntegration" */
export type eAnalyticIntegrationsAnalyticsArgs = {
  distinct_on?: Array<analyticTypes_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticTypes_order_by>;
  where?: analyticTypes_bool_exp;
};


/** columns and relationships of "analytics.eAnalyticIntegration" */
export type eAnalyticIntegrationsAnalytics_aggregateArgs = {
  distinct_on?: Array<analyticTypes_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticTypes_order_by>;
  where?: analyticTypes_bool_exp;
};

/** aggregated selection of "analytics.eAnalyticIntegration" */
export type eAnalyticIntegrations_aggregate = {
  __typename?: 'eAnalyticIntegrations_aggregate';
  aggregate?: eAnalyticIntegrations_aggregate_fields;
  nodes: Array<eAnalyticIntegrations>;
};

/** aggregate fields of "analytics.eAnalyticIntegration" */
export type eAnalyticIntegrations_aggregate_fields = {
  __typename?: 'eAnalyticIntegrations_aggregate_fields';
  count: number;
  max?: eAnalyticIntegrations_max_fields;
  min?: eAnalyticIntegrations_min_fields;
};


/** aggregate fields of "analytics.eAnalyticIntegration" */
export type eAnalyticIntegrations_aggregate_fieldscountArgs = {
  columns?: Array<eAnalyticIntegrations_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "analytics.eAnalyticIntegration". All fields are combined with a logical 'AND'. */
export type eAnalyticIntegrations_bool_exp = {
  Analytics?: analyticTypes_bool_exp;
  Analytics_aggregate?: analyticTypes_aggregate_bool_exp;
  _and?: Array<eAnalyticIntegrations_bool_exp>;
  _not?: eAnalyticIntegrations_bool_exp;
  _or?: Array<eAnalyticIntegrations_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "analytics.eAnalyticIntegration" */
export enum eAnalyticIntegrations_constraint {
  /** unique or primary key constraint on columns "value" */
  eAnalyticIntegration_pkey = 'eAnalyticIntegration_pkey'
}

export enum eAnalyticIntegrations_enum {
  /** Qumulex */
  Qumulex = 'Qumulex'
}

/** Boolean expression to compare columns of type "eAnalyticIntegrations_enum". All fields are combined with logical 'AND'. */
export type eAnalyticIntegrations_enum_comparison_exp = {
  _eq?: eAnalyticIntegrations_enum;
  _in?: Array<eAnalyticIntegrations_enum>;
  _is_null?: boolean;
  _neq?: eAnalyticIntegrations_enum;
  _nin?: Array<eAnalyticIntegrations_enum>;
};

/** input type for inserting data into table "analytics.eAnalyticIntegration" */
export type eAnalyticIntegrations_insert_input = {
  Analytics?: analyticTypes_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type eAnalyticIntegrations_max_fields = {
  __typename?: 'eAnalyticIntegrations_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type eAnalyticIntegrations_min_fields = {
  __typename?: 'eAnalyticIntegrations_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "analytics.eAnalyticIntegration" */
export type eAnalyticIntegrations_mutation_response = {
  __typename?: 'eAnalyticIntegrations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<eAnalyticIntegrations>;
};

/** input type for inserting object relation for remote table "analytics.eAnalyticIntegration" */
export type eAnalyticIntegrations_obj_rel_insert_input = {
  data: eAnalyticIntegrations_insert_input;
  /** upsert condition */
  on_conflict?: eAnalyticIntegrations_on_conflict;
};

/** on_conflict condition type for table "analytics.eAnalyticIntegration" */
export type eAnalyticIntegrations_on_conflict = {
  constraint: eAnalyticIntegrations_constraint;
  update_columns?: Array<eAnalyticIntegrations_update_column>;
  where?: eAnalyticIntegrations_bool_exp;
};

/** Ordering options when selecting data from "analytics.eAnalyticIntegration". */
export type eAnalyticIntegrations_order_by = {
  Analytics_aggregate?: analyticTypes_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: analytics.eAnalyticIntegration */
export type eAnalyticIntegrations_pk_columns_input = {
  value: string;
};

/** select columns of table "analytics.eAnalyticIntegration" */
export enum eAnalyticIntegrations_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "analytics.eAnalyticIntegration" */
export type eAnalyticIntegrations_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "eAnalyticIntegrations" */
export type eAnalyticIntegrations_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: eAnalyticIntegrations_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type eAnalyticIntegrations_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "analytics.eAnalyticIntegration" */
export enum eAnalyticIntegrations_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type eAnalyticIntegrations_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: eAnalyticIntegrations_set_input;
  /** filter the rows which have to be updated */
  where: eAnalyticIntegrations_bool_exp;
};

/** columns and relationships of "analytics.eAnalyticState" */
export type eAnalyticStates = {
  __typename?: 'eAnalyticStates';
  comment?: string;
  value: string;
};

/** aggregated selection of "analytics.eAnalyticState" */
export type eAnalyticStates_aggregate = {
  __typename?: 'eAnalyticStates_aggregate';
  aggregate?: eAnalyticStates_aggregate_fields;
  nodes: Array<eAnalyticStates>;
};

/** aggregate fields of "analytics.eAnalyticState" */
export type eAnalyticStates_aggregate_fields = {
  __typename?: 'eAnalyticStates_aggregate_fields';
  count: number;
  max?: eAnalyticStates_max_fields;
  min?: eAnalyticStates_min_fields;
};


/** aggregate fields of "analytics.eAnalyticState" */
export type eAnalyticStates_aggregate_fieldscountArgs = {
  columns?: Array<eAnalyticStates_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "analytics.eAnalyticState". All fields are combined with a logical 'AND'. */
export type eAnalyticStates_bool_exp = {
  _and?: Array<eAnalyticStates_bool_exp>;
  _not?: eAnalyticStates_bool_exp;
  _or?: Array<eAnalyticStates_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "analytics.eAnalyticState" */
export enum eAnalyticStates_constraint {
  /** unique or primary key constraint on columns "value" */
  eAnalyticState_pkey = 'eAnalyticState_pkey'
}

export enum eAnalyticStates_enum {
  /** Hidden */
  Hidden = 'Hidden',
  /** Unknown */
  Unknown = 'Unknown',
  /** Visible */
  Visible = 'Visible'
}

/** Boolean expression to compare columns of type "eAnalyticStates_enum". All fields are combined with logical 'AND'. */
export type eAnalyticStates_enum_comparison_exp = {
  _eq?: eAnalyticStates_enum;
  _in?: Array<eAnalyticStates_enum>;
  _is_null?: boolean;
  _neq?: eAnalyticStates_enum;
  _nin?: Array<eAnalyticStates_enum>;
};

/** input type for inserting data into table "analytics.eAnalyticState" */
export type eAnalyticStates_insert_input = {
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type eAnalyticStates_max_fields = {
  __typename?: 'eAnalyticStates_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type eAnalyticStates_min_fields = {
  __typename?: 'eAnalyticStates_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "analytics.eAnalyticState" */
export type eAnalyticStates_mutation_response = {
  __typename?: 'eAnalyticStates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<eAnalyticStates>;
};

/** input type for inserting object relation for remote table "analytics.eAnalyticState" */
export type eAnalyticStates_obj_rel_insert_input = {
  data: eAnalyticStates_insert_input;
  /** upsert condition */
  on_conflict?: eAnalyticStates_on_conflict;
};

/** on_conflict condition type for table "analytics.eAnalyticState" */
export type eAnalyticStates_on_conflict = {
  constraint: eAnalyticStates_constraint;
  update_columns?: Array<eAnalyticStates_update_column>;
  where?: eAnalyticStates_bool_exp;
};

/** Ordering options when selecting data from "analytics.eAnalyticState". */
export type eAnalyticStates_order_by = {
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: analytics.eAnalyticState */
export type eAnalyticStates_pk_columns_input = {
  value: string;
};

/** select columns of table "analytics.eAnalyticState" */
export enum eAnalyticStates_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "analytics.eAnalyticState" */
export type eAnalyticStates_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "eAnalyticStates" */
export type eAnalyticStates_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: eAnalyticStates_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type eAnalyticStates_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "analytics.eAnalyticState" */
export enum eAnalyticStates_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type eAnalyticStates_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: eAnalyticStates_set_input;
  /** filter the rows which have to be updated */
  where: eAnalyticStates_bool_exp;
};

/** enum: hardware model categories of supported gateway devices */
export type eGatewayType = {
  __typename?: 'eGatewayType';
  comment: string;
  value: string;
};

/** aggregated selection of "qx.eGatewayType" */
export type eGatewayType_aggregate = {
  __typename?: 'eGatewayType_aggregate';
  aggregate?: eGatewayType_aggregate_fields;
  nodes: Array<eGatewayType>;
};

/** aggregate fields of "qx.eGatewayType" */
export type eGatewayType_aggregate_fields = {
  __typename?: 'eGatewayType_aggregate_fields';
  count: number;
  max?: eGatewayType_max_fields;
  min?: eGatewayType_min_fields;
};


/** aggregate fields of "qx.eGatewayType" */
export type eGatewayType_aggregate_fieldscountArgs = {
  columns?: Array<eGatewayType_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eGatewayType". All fields are combined with a logical 'AND'. */
export type eGatewayType_bool_exp = {
  _and?: Array<eGatewayType_bool_exp>;
  _not?: eGatewayType_bool_exp;
  _or?: Array<eGatewayType_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eGatewayType" */
export enum eGatewayType_constraint {
  /** unique or primary key constraint on columns "value" */
  eGatewayType_pkey = 'eGatewayType_pkey'
}

export enum eGatewayType_enum {
  /** Camera */
  Camera = 'Camera',
  /** Gateway */
  Gateway = 'Gateway'
}

/** Boolean expression to compare columns of type "eGatewayType_enum". All fields are combined with logical 'AND'. */
export type eGatewayType_enum_comparison_exp = {
  _eq?: eGatewayType_enum;
  _in?: Array<eGatewayType_enum>;
  _is_null?: boolean;
  _neq?: eGatewayType_enum;
  _nin?: Array<eGatewayType_enum>;
};

/** input type for inserting data into table "qx.eGatewayType" */
export type eGatewayType_insert_input = {
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type eGatewayType_max_fields = {
  __typename?: 'eGatewayType_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type eGatewayType_min_fields = {
  __typename?: 'eGatewayType_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eGatewayType" */
export type eGatewayType_mutation_response = {
  __typename?: 'eGatewayType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<eGatewayType>;
};

/** on_conflict condition type for table "qx.eGatewayType" */
export type eGatewayType_on_conflict = {
  constraint: eGatewayType_constraint;
  update_columns?: Array<eGatewayType_update_column>;
  where?: eGatewayType_bool_exp;
};

/** Ordering options when selecting data from "qx.eGatewayType". */
export type eGatewayType_order_by = {
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eGatewayType */
export type eGatewayType_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eGatewayType" */
export enum eGatewayType_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eGatewayType" */
export type eGatewayType_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "eGatewayType" */
export type eGatewayType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: eGatewayType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type eGatewayType_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eGatewayType" */
export enum eGatewayType_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type eGatewayType_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: eGatewayType_set_input;
  /** filter the rows which have to be updated */
  where: eGatewayType_bool_exp;
};

/** enum: intended usage types for S3 cloud storage buckets (clips, snapshots, timelapse, etc.) */
export type eS3BucketType = {
  __typename?: 'eS3BucketType';
  comment: string;
  value: string;
};

/** aggregated selection of "qx.eS3BucketType" */
export type eS3BucketType_aggregate = {
  __typename?: 'eS3BucketType_aggregate';
  aggregate?: eS3BucketType_aggregate_fields;
  nodes: Array<eS3BucketType>;
};

/** aggregate fields of "qx.eS3BucketType" */
export type eS3BucketType_aggregate_fields = {
  __typename?: 'eS3BucketType_aggregate_fields';
  count: number;
  max?: eS3BucketType_max_fields;
  min?: eS3BucketType_min_fields;
};


/** aggregate fields of "qx.eS3BucketType" */
export type eS3BucketType_aggregate_fieldscountArgs = {
  columns?: Array<eS3BucketType_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eS3BucketType". All fields are combined with a logical 'AND'. */
export type eS3BucketType_bool_exp = {
  _and?: Array<eS3BucketType_bool_exp>;
  _not?: eS3BucketType_bool_exp;
  _or?: Array<eS3BucketType_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eS3BucketType" */
export enum eS3BucketType_constraint {
  /** unique or primary key constraint on columns "value" */
  eS3BucketType_pkey = 'eS3BucketType_pkey'
}

export enum eS3BucketType_enum {
  /** Clip Bucket */
  Clip = 'Clip',
  /** Schedule Bucket */
  Schedule = 'Schedule',
  /** Segment Bucket */
  Segment = 'Segment',
  /** Snapshot Bucket */
  Snapshot = 'Snapshot'
}

/** Boolean expression to compare columns of type "eS3BucketType_enum". All fields are combined with logical 'AND'. */
export type eS3BucketType_enum_comparison_exp = {
  _eq?: eS3BucketType_enum;
  _in?: Array<eS3BucketType_enum>;
  _is_null?: boolean;
  _neq?: eS3BucketType_enum;
  _nin?: Array<eS3BucketType_enum>;
};

/** input type for inserting data into table "qx.eS3BucketType" */
export type eS3BucketType_insert_input = {
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type eS3BucketType_max_fields = {
  __typename?: 'eS3BucketType_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type eS3BucketType_min_fields = {
  __typename?: 'eS3BucketType_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eS3BucketType" */
export type eS3BucketType_mutation_response = {
  __typename?: 'eS3BucketType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<eS3BucketType>;
};

/** on_conflict condition type for table "qx.eS3BucketType" */
export type eS3BucketType_on_conflict = {
  constraint: eS3BucketType_constraint;
  update_columns?: Array<eS3BucketType_update_column>;
  where?: eS3BucketType_bool_exp;
};

/** Ordering options when selecting data from "qx.eS3BucketType". */
export type eS3BucketType_order_by = {
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eS3BucketType */
export type eS3BucketType_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eS3BucketType" */
export enum eS3BucketType_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eS3BucketType" */
export type eS3BucketType_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "eS3BucketType" */
export type eS3BucketType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: eS3BucketType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type eS3BucketType_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eS3BucketType" */
export enum eS3BucketType_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type eS3BucketType_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: eS3BucketType_set_input;
  /** filter the rows which have to be updated */
  where: eS3BucketType_bool_exp;
};

/** audit view tracking historical changes to flow automation definitions */
export type flowAudit = {
  __typename?: 'flowAudit';
  action?: string;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  /** An object relationship */
  flow?: qx_Flow;
  id?: string;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  row_data?: any;
  time?: string;
};


/** audit view tracking historical changes to flow automation definitions */
export type flowAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes to flow automation definitions */
export type flowAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.vFlowAudit" */
export type flowAudit_aggregate = {
  __typename?: 'flowAudit_aggregate';
  aggregate?: flowAudit_aggregate_fields;
  nodes: Array<flowAudit>;
};

/** aggregate fields of "audit.vFlowAudit" */
export type flowAudit_aggregate_fields = {
  __typename?: 'flowAudit_aggregate_fields';
  avg?: flowAudit_avg_fields;
  count: number;
  max?: flowAudit_max_fields;
  min?: flowAudit_min_fields;
  stddev?: flowAudit_stddev_fields;
  stddev_pop?: flowAudit_stddev_pop_fields;
  stddev_samp?: flowAudit_stddev_samp_fields;
  sum?: flowAudit_sum_fields;
  var_pop?: flowAudit_var_pop_fields;
  var_samp?: flowAudit_var_samp_fields;
  variance?: flowAudit_variance_fields;
};


/** aggregate fields of "audit.vFlowAudit" */
export type flowAudit_aggregate_fieldscountArgs = {
  columns?: Array<flowAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type flowAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type flowAudit_avg_fields = {
  __typename?: 'flowAudit_avg_fields';
  auditID?: number;
  id?: number;
};

/** Boolean expression to filter rows from the table "audit.vFlowAudit". All fields are combined with a logical 'AND'. */
export type flowAudit_bool_exp = {
  _and?: Array<flowAudit_bool_exp>;
  _not?: flowAudit_bool_exp;
  _or?: Array<flowAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  flow?: qx_Flow_bool_exp;
  id?: bigint_comparison_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type flowAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type flowAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type flowAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.vFlowAudit" */
export type flowAudit_inc_input = {
  auditID?: string;
  id?: string;
};

/** input type for inserting data into table "audit.vFlowAudit" */
export type flowAudit_insert_input = {
  action?: string;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  flow?: qx_Flow_obj_rel_insert_input;
  id?: string;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate max on columns */
export type flowAudit_max_fields = {
  __typename?: 'flowAudit_max_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** aggregate min on columns */
export type flowAudit_min_fields = {
  __typename?: 'flowAudit_min_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** response of any mutation on the table "audit.vFlowAudit" */
export type flowAudit_mutation_response = {
  __typename?: 'flowAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<flowAudit>;
};

/** Ordering options when selecting data from "audit.vFlowAudit". */
export type flowAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  flow?: qx_Flow_order_by;
  id?: order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  row_data?: order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type flowAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.vFlowAudit" */
export enum flowAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  id = 'id',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.vFlowAudit" */
export type flowAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type flowAudit_stddev_fields = {
  __typename?: 'flowAudit_stddev_fields';
  auditID?: number;
  id?: number;
};

/** aggregate stddev_pop on columns */
export type flowAudit_stddev_pop_fields = {
  __typename?: 'flowAudit_stddev_pop_fields';
  auditID?: number;
  id?: number;
};

/** aggregate stddev_samp on columns */
export type flowAudit_stddev_samp_fields = {
  __typename?: 'flowAudit_stddev_samp_fields';
  auditID?: number;
  id?: number;
};

/** Streaming cursor of the table "flowAudit" */
export type flowAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: flowAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type flowAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type flowAudit_sum_fields = {
  __typename?: 'flowAudit_sum_fields';
  auditID?: string;
  id?: string;
};

export type flowAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: flowAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: flowAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: flowAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: flowAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: flowAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: flowAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: flowAudit_set_input;
  /** filter the rows which have to be updated */
  where: flowAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type flowAudit_var_pop_fields = {
  __typename?: 'flowAudit_var_pop_fields';
  auditID?: number;
  id?: number;
};

/** aggregate var_samp on columns */
export type flowAudit_var_samp_fields = {
  __typename?: 'flowAudit_var_samp_fields';
  auditID?: number;
  id?: number;
};

/** aggregate variance on columns */
export type flowAudit_variance_fields = {
  __typename?: 'flowAudit_variance_fields';
  auditID?: number;
  id?: number;
};

/** columns and relationships of "audit.vGatewayAudit" */
export type gatewayAudit = {
  __typename?: 'gatewayAudit';
  action?: string;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  /** An object relationship */
  gateway?: qx_Gateway;
  id?: string;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  row_data?: any;
  time?: string;
};


/** columns and relationships of "audit.vGatewayAudit" */
export type gatewayAuditchanged_fieldsArgs = {
  path?: string;
};


/** columns and relationships of "audit.vGatewayAudit" */
export type gatewayAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.vGatewayAudit" */
export type gatewayAudit_aggregate = {
  __typename?: 'gatewayAudit_aggregate';
  aggregate?: gatewayAudit_aggregate_fields;
  nodes: Array<gatewayAudit>;
};

/** aggregate fields of "audit.vGatewayAudit" */
export type gatewayAudit_aggregate_fields = {
  __typename?: 'gatewayAudit_aggregate_fields';
  avg?: gatewayAudit_avg_fields;
  count: number;
  max?: gatewayAudit_max_fields;
  min?: gatewayAudit_min_fields;
  stddev?: gatewayAudit_stddev_fields;
  stddev_pop?: gatewayAudit_stddev_pop_fields;
  stddev_samp?: gatewayAudit_stddev_samp_fields;
  sum?: gatewayAudit_sum_fields;
  var_pop?: gatewayAudit_var_pop_fields;
  var_samp?: gatewayAudit_var_samp_fields;
  variance?: gatewayAudit_variance_fields;
};


/** aggregate fields of "audit.vGatewayAudit" */
export type gatewayAudit_aggregate_fieldscountArgs = {
  columns?: Array<gatewayAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type gatewayAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type gatewayAudit_avg_fields = {
  __typename?: 'gatewayAudit_avg_fields';
  auditID?: number;
};

/** Boolean expression to filter rows from the table "audit.vGatewayAudit". All fields are combined with a logical 'AND'. */
export type gatewayAudit_bool_exp = {
  _and?: Array<gatewayAudit_bool_exp>;
  _not?: gatewayAudit_bool_exp;
  _or?: Array<gatewayAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  gateway?: qx_Gateway_bool_exp;
  id?: String_comparison_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type gatewayAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type gatewayAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type gatewayAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.vGatewayAudit" */
export type gatewayAudit_inc_input = {
  auditID?: string;
};

/** input type for inserting data into table "audit.vGatewayAudit" */
export type gatewayAudit_insert_input = {
  action?: string;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  gateway?: qx_Gateway_obj_rel_insert_input;
  id?: string;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate max on columns */
export type gatewayAudit_max_fields = {
  __typename?: 'gatewayAudit_max_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** aggregate min on columns */
export type gatewayAudit_min_fields = {
  __typename?: 'gatewayAudit_min_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** response of any mutation on the table "audit.vGatewayAudit" */
export type gatewayAudit_mutation_response = {
  __typename?: 'gatewayAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<gatewayAudit>;
};

/** Ordering options when selecting data from "audit.vGatewayAudit". */
export type gatewayAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  gateway?: qx_Gateway_order_by;
  id?: order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  row_data?: order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type gatewayAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.vGatewayAudit" */
export enum gatewayAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  id = 'id',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.vGatewayAudit" */
export type gatewayAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type gatewayAudit_stddev_fields = {
  __typename?: 'gatewayAudit_stddev_fields';
  auditID?: number;
};

/** aggregate stddev_pop on columns */
export type gatewayAudit_stddev_pop_fields = {
  __typename?: 'gatewayAudit_stddev_pop_fields';
  auditID?: number;
};

/** aggregate stddev_samp on columns */
export type gatewayAudit_stddev_samp_fields = {
  __typename?: 'gatewayAudit_stddev_samp_fields';
  auditID?: number;
};

/** Streaming cursor of the table "gatewayAudit" */
export type gatewayAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: gatewayAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type gatewayAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type gatewayAudit_sum_fields = {
  __typename?: 'gatewayAudit_sum_fields';
  auditID?: string;
};

export type gatewayAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: gatewayAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: gatewayAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: gatewayAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: gatewayAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: gatewayAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: gatewayAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: gatewayAudit_set_input;
  /** filter the rows which have to be updated */
  where: gatewayAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type gatewayAudit_var_pop_fields = {
  __typename?: 'gatewayAudit_var_pop_fields';
  auditID?: number;
};

/** aggregate var_samp on columns */
export type gatewayAudit_var_samp_fields = {
  __typename?: 'gatewayAudit_var_samp_fields';
  auditID?: number;
};

/** aggregate variance on columns */
export type gatewayAudit_variance_fields = {
  __typename?: 'gatewayAudit_variance_fields';
  auditID?: number;
};

/** audit view tracking historical changes to gateway bandwidth schedule settings */
export type gatewayBandwidthScheduleAudit = {
  __typename?: 'gatewayBandwidthScheduleAudit';
  action?: string;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  /** An object relationship */
  gateway?: qx_Gateway;
  gatewayID?: string;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  row_data?: any;
  time?: string;
};


/** audit view tracking historical changes to gateway bandwidth schedule settings */
export type gatewayBandwidthScheduleAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes to gateway bandwidth schedule settings */
export type gatewayBandwidthScheduleAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.vGatewayBandwidthScheduleAudit" */
export type gatewayBandwidthScheduleAudit_aggregate = {
  __typename?: 'gatewayBandwidthScheduleAudit_aggregate';
  aggregate?: gatewayBandwidthScheduleAudit_aggregate_fields;
  nodes: Array<gatewayBandwidthScheduleAudit>;
};

/** aggregate fields of "audit.vGatewayBandwidthScheduleAudit" */
export type gatewayBandwidthScheduleAudit_aggregate_fields = {
  __typename?: 'gatewayBandwidthScheduleAudit_aggregate_fields';
  avg?: gatewayBandwidthScheduleAudit_avg_fields;
  count: number;
  max?: gatewayBandwidthScheduleAudit_max_fields;
  min?: gatewayBandwidthScheduleAudit_min_fields;
  stddev?: gatewayBandwidthScheduleAudit_stddev_fields;
  stddev_pop?: gatewayBandwidthScheduleAudit_stddev_pop_fields;
  stddev_samp?: gatewayBandwidthScheduleAudit_stddev_samp_fields;
  sum?: gatewayBandwidthScheduleAudit_sum_fields;
  var_pop?: gatewayBandwidthScheduleAudit_var_pop_fields;
  var_samp?: gatewayBandwidthScheduleAudit_var_samp_fields;
  variance?: gatewayBandwidthScheduleAudit_variance_fields;
};


/** aggregate fields of "audit.vGatewayBandwidthScheduleAudit" */
export type gatewayBandwidthScheduleAudit_aggregate_fieldscountArgs = {
  columns?: Array<gatewayBandwidthScheduleAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type gatewayBandwidthScheduleAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type gatewayBandwidthScheduleAudit_avg_fields = {
  __typename?: 'gatewayBandwidthScheduleAudit_avg_fields';
  auditID?: number;
};

/** Boolean expression to filter rows from the table "audit.vGatewayBandwidthScheduleAudit". All fields are combined with a logical 'AND'. */
export type gatewayBandwidthScheduleAudit_bool_exp = {
  _and?: Array<gatewayBandwidthScheduleAudit_bool_exp>;
  _not?: gatewayBandwidthScheduleAudit_bool_exp;
  _or?: Array<gatewayBandwidthScheduleAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  gateway?: qx_Gateway_bool_exp;
  gatewayID?: String_comparison_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type gatewayBandwidthScheduleAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type gatewayBandwidthScheduleAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type gatewayBandwidthScheduleAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.vGatewayBandwidthScheduleAudit" */
export type gatewayBandwidthScheduleAudit_inc_input = {
  auditID?: string;
};

/** input type for inserting data into table "audit.vGatewayBandwidthScheduleAudit" */
export type gatewayBandwidthScheduleAudit_insert_input = {
  action?: string;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  gateway?: qx_Gateway_obj_rel_insert_input;
  gatewayID?: string;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate max on columns */
export type gatewayBandwidthScheduleAudit_max_fields = {
  __typename?: 'gatewayBandwidthScheduleAudit_max_fields';
  action?: string;
  auditID?: string;
  gatewayID?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** aggregate min on columns */
export type gatewayBandwidthScheduleAudit_min_fields = {
  __typename?: 'gatewayBandwidthScheduleAudit_min_fields';
  action?: string;
  auditID?: string;
  gatewayID?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** response of any mutation on the table "audit.vGatewayBandwidthScheduleAudit" */
export type gatewayBandwidthScheduleAudit_mutation_response = {
  __typename?: 'gatewayBandwidthScheduleAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<gatewayBandwidthScheduleAudit>;
};

/** Ordering options when selecting data from "audit.vGatewayBandwidthScheduleAudit". */
export type gatewayBandwidthScheduleAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  gateway?: qx_Gateway_order_by;
  gatewayID?: order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  row_data?: order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type gatewayBandwidthScheduleAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.vGatewayBandwidthScheduleAudit" */
export enum gatewayBandwidthScheduleAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  gatewayID = 'gatewayID',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.vGatewayBandwidthScheduleAudit" */
export type gatewayBandwidthScheduleAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  gatewayID?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type gatewayBandwidthScheduleAudit_stddev_fields = {
  __typename?: 'gatewayBandwidthScheduleAudit_stddev_fields';
  auditID?: number;
};

/** aggregate stddev_pop on columns */
export type gatewayBandwidthScheduleAudit_stddev_pop_fields = {
  __typename?: 'gatewayBandwidthScheduleAudit_stddev_pop_fields';
  auditID?: number;
};

/** aggregate stddev_samp on columns */
export type gatewayBandwidthScheduleAudit_stddev_samp_fields = {
  __typename?: 'gatewayBandwidthScheduleAudit_stddev_samp_fields';
  auditID?: number;
};

/** Streaming cursor of the table "gatewayBandwidthScheduleAudit" */
export type gatewayBandwidthScheduleAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: gatewayBandwidthScheduleAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type gatewayBandwidthScheduleAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  gatewayID?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type gatewayBandwidthScheduleAudit_sum_fields = {
  __typename?: 'gatewayBandwidthScheduleAudit_sum_fields';
  auditID?: string;
};

export type gatewayBandwidthScheduleAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: gatewayBandwidthScheduleAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: gatewayBandwidthScheduleAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: gatewayBandwidthScheduleAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: gatewayBandwidthScheduleAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: gatewayBandwidthScheduleAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: gatewayBandwidthScheduleAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: gatewayBandwidthScheduleAudit_set_input;
  /** filter the rows which have to be updated */
  where: gatewayBandwidthScheduleAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type gatewayBandwidthScheduleAudit_var_pop_fields = {
  __typename?: 'gatewayBandwidthScheduleAudit_var_pop_fields';
  auditID?: number;
};

/** aggregate var_samp on columns */
export type gatewayBandwidthScheduleAudit_var_samp_fields = {
  __typename?: 'gatewayBandwidthScheduleAudit_var_samp_fields';
  auditID?: number;
};

/** aggregate variance on columns */
export type gatewayBandwidthScheduleAudit_variance_fields = {
  __typename?: 'gatewayBandwidthScheduleAudit_variance_fields';
  auditID?: number;
};

/** audit view tracking historical changes to group definitions */
export type groupAudit = {
  __typename?: 'groupAudit';
  action?: string;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  /** An object relationship */
  group?: qx_Group;
  id?: string;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  row_data?: any;
  time?: string;
};


/** audit view tracking historical changes to group definitions */
export type groupAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes to group definitions */
export type groupAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.vGroupAudit" */
export type groupAudit_aggregate = {
  __typename?: 'groupAudit_aggregate';
  aggregate?: groupAudit_aggregate_fields;
  nodes: Array<groupAudit>;
};

/** aggregate fields of "audit.vGroupAudit" */
export type groupAudit_aggregate_fields = {
  __typename?: 'groupAudit_aggregate_fields';
  avg?: groupAudit_avg_fields;
  count: number;
  max?: groupAudit_max_fields;
  min?: groupAudit_min_fields;
  stddev?: groupAudit_stddev_fields;
  stddev_pop?: groupAudit_stddev_pop_fields;
  stddev_samp?: groupAudit_stddev_samp_fields;
  sum?: groupAudit_sum_fields;
  var_pop?: groupAudit_var_pop_fields;
  var_samp?: groupAudit_var_samp_fields;
  variance?: groupAudit_variance_fields;
};


/** aggregate fields of "audit.vGroupAudit" */
export type groupAudit_aggregate_fieldscountArgs = {
  columns?: Array<groupAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type groupAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type groupAudit_avg_fields = {
  __typename?: 'groupAudit_avg_fields';
  auditID?: number;
};

/** Boolean expression to filter rows from the table "audit.vGroupAudit". All fields are combined with a logical 'AND'. */
export type groupAudit_bool_exp = {
  _and?: Array<groupAudit_bool_exp>;
  _not?: groupAudit_bool_exp;
  _or?: Array<groupAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  group?: qx_Group_bool_exp;
  id?: String_comparison_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type groupAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type groupAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type groupAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.vGroupAudit" */
export type groupAudit_inc_input = {
  auditID?: string;
};

/** input type for inserting data into table "audit.vGroupAudit" */
export type groupAudit_insert_input = {
  action?: string;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  group?: qx_Group_obj_rel_insert_input;
  id?: string;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate max on columns */
export type groupAudit_max_fields = {
  __typename?: 'groupAudit_max_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** aggregate min on columns */
export type groupAudit_min_fields = {
  __typename?: 'groupAudit_min_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** response of any mutation on the table "audit.vGroupAudit" */
export type groupAudit_mutation_response = {
  __typename?: 'groupAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<groupAudit>;
};

/** Ordering options when selecting data from "audit.vGroupAudit". */
export type groupAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  group?: qx_Group_order_by;
  id?: order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  row_data?: order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type groupAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.vGroupAudit" */
export enum groupAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  id = 'id',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.vGroupAudit" */
export type groupAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type groupAudit_stddev_fields = {
  __typename?: 'groupAudit_stddev_fields';
  auditID?: number;
};

/** aggregate stddev_pop on columns */
export type groupAudit_stddev_pop_fields = {
  __typename?: 'groupAudit_stddev_pop_fields';
  auditID?: number;
};

/** aggregate stddev_samp on columns */
export type groupAudit_stddev_samp_fields = {
  __typename?: 'groupAudit_stddev_samp_fields';
  auditID?: number;
};

/** Streaming cursor of the table "groupAudit" */
export type groupAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: groupAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type groupAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type groupAudit_sum_fields = {
  __typename?: 'groupAudit_sum_fields';
  auditID?: string;
};

export type groupAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: groupAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: groupAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: groupAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: groupAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: groupAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: groupAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: groupAudit_set_input;
  /** filter the rows which have to be updated */
  where: groupAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type groupAudit_var_pop_fields = {
  __typename?: 'groupAudit_var_pop_fields';
  auditID?: number;
};

/** aggregate var_samp on columns */
export type groupAudit_var_samp_fields = {
  __typename?: 'groupAudit_var_samp_fields';
  auditID?: number;
};

/** aggregate variance on columns */
export type groupAudit_variance_fields = {
  __typename?: 'groupAudit_variance_fields';
  auditID?: number;
};

/** columns and relationships of "qx.GuestAccess" */
export type guestAccess = {
  __typename?: 'guestAccess';
  expiresAt: string;
  /** An object relationship */
  person: qx_Person;
  personID: string;
};

/** aggregated selection of "qx.GuestAccess" */
export type guestAccess_aggregate = {
  __typename?: 'guestAccess_aggregate';
  aggregate?: guestAccess_aggregate_fields;
  nodes: Array<guestAccess>;
};

/** aggregate fields of "qx.GuestAccess" */
export type guestAccess_aggregate_fields = {
  __typename?: 'guestAccess_aggregate_fields';
  count: number;
  max?: guestAccess_max_fields;
  min?: guestAccess_min_fields;
};


/** aggregate fields of "qx.GuestAccess" */
export type guestAccess_aggregate_fieldscountArgs = {
  columns?: Array<guestAccess_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.GuestAccess". All fields are combined with a logical 'AND'. */
export type guestAccess_bool_exp = {
  _and?: Array<guestAccess_bool_exp>;
  _not?: guestAccess_bool_exp;
  _or?: Array<guestAccess_bool_exp>;
  expiresAt?: timestamptz_comparison_exp;
  person?: qx_Person_bool_exp;
  personID?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.GuestAccess" */
export enum guestAccess_constraint {
  /** unique or primary key constraint on columns "personID" */
  GuestAccess_pkey = 'GuestAccess_pkey'
}

/** input type for inserting data into table "qx.GuestAccess" */
export type guestAccess_insert_input = {
  expiresAt?: string;
  person?: qx_Person_obj_rel_insert_input;
  personID?: string;
};

/** aggregate max on columns */
export type guestAccess_max_fields = {
  __typename?: 'guestAccess_max_fields';
  expiresAt?: string;
  personID?: string;
};

/** aggregate min on columns */
export type guestAccess_min_fields = {
  __typename?: 'guestAccess_min_fields';
  expiresAt?: string;
  personID?: string;
};

/** response of any mutation on the table "qx.GuestAccess" */
export type guestAccess_mutation_response = {
  __typename?: 'guestAccess_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<guestAccess>;
};

/** on_conflict condition type for table "qx.GuestAccess" */
export type guestAccess_on_conflict = {
  constraint: guestAccess_constraint;
  update_columns?: Array<guestAccess_update_column>;
  where?: guestAccess_bool_exp;
};

/** Ordering options when selecting data from "qx.GuestAccess". */
export type guestAccess_order_by = {
  expiresAt?: order_by;
  person?: qx_Person_order_by;
  personID?: order_by;
};

/** primary key columns input for table: qx.GuestAccess */
export type guestAccess_pk_columns_input = {
  personID: string;
};

/** select columns of table "qx.GuestAccess" */
export enum guestAccess_select_column {
  /** column name */
  expiresAt = 'expiresAt',
  /** column name */
  personID = 'personID'
}

/** input type for updating data in table "qx.GuestAccess" */
export type guestAccess_set_input = {
  expiresAt?: string;
  personID?: string;
};

/** Streaming cursor of the table "guestAccess" */
export type guestAccess_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: guestAccess_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type guestAccess_stream_cursor_value_input = {
  expiresAt?: string;
  personID?: string;
};

/** update columns of table "qx.GuestAccess" */
export enum guestAccess_update_column {
  /** column name */
  expiresAt = 'expiresAt',
  /** column name */
  personID = 'personID'
}

export type guestAccess_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: guestAccess_set_input;
  /** filter the rows which have to be updated */
  where: guestAccess_bool_exp;
};

export type holidayActive_qx_Schedule_args = {
  tz_override?: string;
};

/** audit view tracking historical changes to holiday set definitions */
export type holidaySetAudit = {
  __typename?: 'holidaySetAudit';
  action?: string;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  /** An object relationship */
  holidaySet?: qx_HolidaySet;
  id?: string;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  row_data?: any;
  time?: string;
};


/** audit view tracking historical changes to holiday set definitions */
export type holidaySetAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes to holiday set definitions */
export type holidaySetAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.vHolidaySetAudit" */
export type holidaySetAudit_aggregate = {
  __typename?: 'holidaySetAudit_aggregate';
  aggregate?: holidaySetAudit_aggregate_fields;
  nodes: Array<holidaySetAudit>;
};

/** aggregate fields of "audit.vHolidaySetAudit" */
export type holidaySetAudit_aggregate_fields = {
  __typename?: 'holidaySetAudit_aggregate_fields';
  avg?: holidaySetAudit_avg_fields;
  count: number;
  max?: holidaySetAudit_max_fields;
  min?: holidaySetAudit_min_fields;
  stddev?: holidaySetAudit_stddev_fields;
  stddev_pop?: holidaySetAudit_stddev_pop_fields;
  stddev_samp?: holidaySetAudit_stddev_samp_fields;
  sum?: holidaySetAudit_sum_fields;
  var_pop?: holidaySetAudit_var_pop_fields;
  var_samp?: holidaySetAudit_var_samp_fields;
  variance?: holidaySetAudit_variance_fields;
};


/** aggregate fields of "audit.vHolidaySetAudit" */
export type holidaySetAudit_aggregate_fieldscountArgs = {
  columns?: Array<holidaySetAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type holidaySetAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type holidaySetAudit_avg_fields = {
  __typename?: 'holidaySetAudit_avg_fields';
  auditID?: number;
};

/** Boolean expression to filter rows from the table "audit.vHolidaySetAudit". All fields are combined with a logical 'AND'. */
export type holidaySetAudit_bool_exp = {
  _and?: Array<holidaySetAudit_bool_exp>;
  _not?: holidaySetAudit_bool_exp;
  _or?: Array<holidaySetAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  holidaySet?: qx_HolidaySet_bool_exp;
  id?: String_comparison_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type holidaySetAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type holidaySetAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type holidaySetAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.vHolidaySetAudit" */
export type holidaySetAudit_inc_input = {
  auditID?: string;
};

/** input type for inserting data into table "audit.vHolidaySetAudit" */
export type holidaySetAudit_insert_input = {
  action?: string;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  holidaySet?: qx_HolidaySet_obj_rel_insert_input;
  id?: string;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate max on columns */
export type holidaySetAudit_max_fields = {
  __typename?: 'holidaySetAudit_max_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** aggregate min on columns */
export type holidaySetAudit_min_fields = {
  __typename?: 'holidaySetAudit_min_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** response of any mutation on the table "audit.vHolidaySetAudit" */
export type holidaySetAudit_mutation_response = {
  __typename?: 'holidaySetAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<holidaySetAudit>;
};

/** Ordering options when selecting data from "audit.vHolidaySetAudit". */
export type holidaySetAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  holidaySet?: qx_HolidaySet_order_by;
  id?: order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  row_data?: order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type holidaySetAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.vHolidaySetAudit" */
export enum holidaySetAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  id = 'id',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.vHolidaySetAudit" */
export type holidaySetAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type holidaySetAudit_stddev_fields = {
  __typename?: 'holidaySetAudit_stddev_fields';
  auditID?: number;
};

/** aggregate stddev_pop on columns */
export type holidaySetAudit_stddev_pop_fields = {
  __typename?: 'holidaySetAudit_stddev_pop_fields';
  auditID?: number;
};

/** aggregate stddev_samp on columns */
export type holidaySetAudit_stddev_samp_fields = {
  __typename?: 'holidaySetAudit_stddev_samp_fields';
  auditID?: number;
};

/** Streaming cursor of the table "holidaySetAudit" */
export type holidaySetAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: holidaySetAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type holidaySetAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type holidaySetAudit_sum_fields = {
  __typename?: 'holidaySetAudit_sum_fields';
  auditID?: string;
};

export type holidaySetAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: holidaySetAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: holidaySetAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: holidaySetAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: holidaySetAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: holidaySetAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: holidaySetAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: holidaySetAudit_set_input;
  /** filter the rows which have to be updated */
  where: holidaySetAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type holidaySetAudit_var_pop_fields = {
  __typename?: 'holidaySetAudit_var_pop_fields';
  auditID?: number;
};

/** aggregate var_samp on columns */
export type holidaySetAudit_var_samp_fields = {
  __typename?: 'holidaySetAudit_var_samp_fields';
  auditID?: number;
};

/** aggregate variance on columns */
export type holidaySetAudit_variance_fields = {
  __typename?: 'holidaySetAudit_variance_fields';
  auditID?: number;
};

/** audit view tracking historical changes (creates, updates, deletes) to holiday set to schedule block mappings */
export type holidaySetToScheduleBlockAudit = {
  __typename?: 'holidaySetToScheduleBlockAudit';
  action?: string;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  /** An object relationship */
  holidaySet?: qx_HolidaySet;
  holidaySetID?: string;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  row_data?: any;
  /** An object relationship */
  scheduleBlock?: qx_ScheduleBlock;
  scheduleBlockID?: string;
  time?: string;
};


/** audit view tracking historical changes (creates, updates, deletes) to holiday set to schedule block mappings */
export type holidaySetToScheduleBlockAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes (creates, updates, deletes) to holiday set to schedule block mappings */
export type holidaySetToScheduleBlockAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.v_HolidaySetToScheduleBlockAudit" */
export type holidaySetToScheduleBlockAudit_aggregate = {
  __typename?: 'holidaySetToScheduleBlockAudit_aggregate';
  aggregate?: holidaySetToScheduleBlockAudit_aggregate_fields;
  nodes: Array<holidaySetToScheduleBlockAudit>;
};

/** aggregate fields of "audit.v_HolidaySetToScheduleBlockAudit" */
export type holidaySetToScheduleBlockAudit_aggregate_fields = {
  __typename?: 'holidaySetToScheduleBlockAudit_aggregate_fields';
  avg?: holidaySetToScheduleBlockAudit_avg_fields;
  count: number;
  max?: holidaySetToScheduleBlockAudit_max_fields;
  min?: holidaySetToScheduleBlockAudit_min_fields;
  stddev?: holidaySetToScheduleBlockAudit_stddev_fields;
  stddev_pop?: holidaySetToScheduleBlockAudit_stddev_pop_fields;
  stddev_samp?: holidaySetToScheduleBlockAudit_stddev_samp_fields;
  sum?: holidaySetToScheduleBlockAudit_sum_fields;
  var_pop?: holidaySetToScheduleBlockAudit_var_pop_fields;
  var_samp?: holidaySetToScheduleBlockAudit_var_samp_fields;
  variance?: holidaySetToScheduleBlockAudit_variance_fields;
};


/** aggregate fields of "audit.v_HolidaySetToScheduleBlockAudit" */
export type holidaySetToScheduleBlockAudit_aggregate_fieldscountArgs = {
  columns?: Array<holidaySetToScheduleBlockAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type holidaySetToScheduleBlockAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type holidaySetToScheduleBlockAudit_avg_fields = {
  __typename?: 'holidaySetToScheduleBlockAudit_avg_fields';
  auditID?: number;
};

/** Boolean expression to filter rows from the table "audit.v_HolidaySetToScheduleBlockAudit". All fields are combined with a logical 'AND'. */
export type holidaySetToScheduleBlockAudit_bool_exp = {
  _and?: Array<holidaySetToScheduleBlockAudit_bool_exp>;
  _not?: holidaySetToScheduleBlockAudit_bool_exp;
  _or?: Array<holidaySetToScheduleBlockAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  holidaySet?: qx_HolidaySet_bool_exp;
  holidaySetID?: String_comparison_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  scheduleBlock?: qx_ScheduleBlock_bool_exp;
  scheduleBlockID?: String_comparison_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type holidaySetToScheduleBlockAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type holidaySetToScheduleBlockAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type holidaySetToScheduleBlockAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.v_HolidaySetToScheduleBlockAudit" */
export type holidaySetToScheduleBlockAudit_inc_input = {
  auditID?: string;
};

/** input type for inserting data into table "audit.v_HolidaySetToScheduleBlockAudit" */
export type holidaySetToScheduleBlockAudit_insert_input = {
  action?: string;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  holidaySet?: qx_HolidaySet_obj_rel_insert_input;
  holidaySetID?: string;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  row_data?: any;
  scheduleBlock?: qx_ScheduleBlock_obj_rel_insert_input;
  scheduleBlockID?: string;
  time?: string;
};

/** aggregate max on columns */
export type holidaySetToScheduleBlockAudit_max_fields = {
  __typename?: 'holidaySetToScheduleBlockAudit_max_fields';
  action?: string;
  auditID?: string;
  holidaySetID?: string;
  person_id?: string;
  place_id?: string;
  scheduleBlockID?: string;
  time?: string;
};

/** aggregate min on columns */
export type holidaySetToScheduleBlockAudit_min_fields = {
  __typename?: 'holidaySetToScheduleBlockAudit_min_fields';
  action?: string;
  auditID?: string;
  holidaySetID?: string;
  person_id?: string;
  place_id?: string;
  scheduleBlockID?: string;
  time?: string;
};

/** response of any mutation on the table "audit.v_HolidaySetToScheduleBlockAudit" */
export type holidaySetToScheduleBlockAudit_mutation_response = {
  __typename?: 'holidaySetToScheduleBlockAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<holidaySetToScheduleBlockAudit>;
};

/** Ordering options when selecting data from "audit.v_HolidaySetToScheduleBlockAudit". */
export type holidaySetToScheduleBlockAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  holidaySet?: qx_HolidaySet_order_by;
  holidaySetID?: order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  row_data?: order_by;
  scheduleBlock?: qx_ScheduleBlock_order_by;
  scheduleBlockID?: order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type holidaySetToScheduleBlockAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.v_HolidaySetToScheduleBlockAudit" */
export enum holidaySetToScheduleBlockAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  holidaySetID = 'holidaySetID',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  scheduleBlockID = 'scheduleBlockID',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.v_HolidaySetToScheduleBlockAudit" */
export type holidaySetToScheduleBlockAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  holidaySetID?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  scheduleBlockID?: string;
  time?: string;
};

/** aggregate stddev on columns */
export type holidaySetToScheduleBlockAudit_stddev_fields = {
  __typename?: 'holidaySetToScheduleBlockAudit_stddev_fields';
  auditID?: number;
};

/** aggregate stddev_pop on columns */
export type holidaySetToScheduleBlockAudit_stddev_pop_fields = {
  __typename?: 'holidaySetToScheduleBlockAudit_stddev_pop_fields';
  auditID?: number;
};

/** aggregate stddev_samp on columns */
export type holidaySetToScheduleBlockAudit_stddev_samp_fields = {
  __typename?: 'holidaySetToScheduleBlockAudit_stddev_samp_fields';
  auditID?: number;
};

/** Streaming cursor of the table "holidaySetToScheduleBlockAudit" */
export type holidaySetToScheduleBlockAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: holidaySetToScheduleBlockAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type holidaySetToScheduleBlockAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  holidaySetID?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  scheduleBlockID?: string;
  time?: string;
};

/** aggregate sum on columns */
export type holidaySetToScheduleBlockAudit_sum_fields = {
  __typename?: 'holidaySetToScheduleBlockAudit_sum_fields';
  auditID?: string;
};

export type holidaySetToScheduleBlockAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: holidaySetToScheduleBlockAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: holidaySetToScheduleBlockAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: holidaySetToScheduleBlockAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: holidaySetToScheduleBlockAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: holidaySetToScheduleBlockAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: holidaySetToScheduleBlockAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: holidaySetToScheduleBlockAudit_set_input;
  /** filter the rows which have to be updated */
  where: holidaySetToScheduleBlockAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type holidaySetToScheduleBlockAudit_var_pop_fields = {
  __typename?: 'holidaySetToScheduleBlockAudit_var_pop_fields';
  auditID?: number;
};

/** aggregate var_samp on columns */
export type holidaySetToScheduleBlockAudit_var_samp_fields = {
  __typename?: 'holidaySetToScheduleBlockAudit_var_samp_fields';
  auditID?: number;
};

/** aggregate variance on columns */
export type holidaySetToScheduleBlockAudit_variance_fields = {
  __typename?: 'holidaySetToScheduleBlockAudit_variance_fields';
  auditID?: number;
};

/** Boolean expression to compare columns of type "inet". All fields are combined with logical 'AND'. */
export type inet_comparison_exp = {
  _eq?: Scalars['inet']['input'];
  _gt?: Scalars['inet']['input'];
  _gte?: Scalars['inet']['input'];
  _in?: Array<Scalars['inet']['input']>;
  _is_null?: boolean;
  _lt?: Scalars['inet']['input'];
  _lte?: Scalars['inet']['input'];
  _neq?: Scalars['inet']['input'];
  _nin?: Array<Scalars['inet']['input']>;
};

/** audit view tracking historical changes to input point configurations */
export type inputPointAudit = {
  __typename?: 'inputPointAudit';
  action?: string;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  id?: string;
  /** An object relationship */
  inputPoint?: qx_InputPoint;
  /** An object relationship */
  person?: qx_Person;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  row_data?: any;
  time?: string;
};


/** audit view tracking historical changes to input point configurations */
export type inputPointAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes to input point configurations */
export type inputPointAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.vInputPointAudit" */
export type inputPointAudit_aggregate = {
  __typename?: 'inputPointAudit_aggregate';
  aggregate?: inputPointAudit_aggregate_fields;
  nodes: Array<inputPointAudit>;
};

/** aggregate fields of "audit.vInputPointAudit" */
export type inputPointAudit_aggregate_fields = {
  __typename?: 'inputPointAudit_aggregate_fields';
  avg?: inputPointAudit_avg_fields;
  count: number;
  max?: inputPointAudit_max_fields;
  min?: inputPointAudit_min_fields;
  stddev?: inputPointAudit_stddev_fields;
  stddev_pop?: inputPointAudit_stddev_pop_fields;
  stddev_samp?: inputPointAudit_stddev_samp_fields;
  sum?: inputPointAudit_sum_fields;
  var_pop?: inputPointAudit_var_pop_fields;
  var_samp?: inputPointAudit_var_samp_fields;
  variance?: inputPointAudit_variance_fields;
};


/** aggregate fields of "audit.vInputPointAudit" */
export type inputPointAudit_aggregate_fieldscountArgs = {
  columns?: Array<inputPointAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type inputPointAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type inputPointAudit_avg_fields = {
  __typename?: 'inputPointAudit_avg_fields';
  auditID?: number;
};

/** Boolean expression to filter rows from the table "audit.vInputPointAudit". All fields are combined with a logical 'AND'. */
export type inputPointAudit_bool_exp = {
  _and?: Array<inputPointAudit_bool_exp>;
  _not?: inputPointAudit_bool_exp;
  _or?: Array<inputPointAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  id?: String_comparison_exp;
  inputPoint?: qx_InputPoint_bool_exp;
  person?: qx_Person_bool_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type inputPointAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type inputPointAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type inputPointAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.vInputPointAudit" */
export type inputPointAudit_inc_input = {
  auditID?: string;
};

/** input type for inserting data into table "audit.vInputPointAudit" */
export type inputPointAudit_insert_input = {
  action?: string;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  id?: string;
  inputPoint?: qx_InputPoint_obj_rel_insert_input;
  person?: qx_Person_obj_rel_insert_input;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate max on columns */
export type inputPointAudit_max_fields = {
  __typename?: 'inputPointAudit_max_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** aggregate min on columns */
export type inputPointAudit_min_fields = {
  __typename?: 'inputPointAudit_min_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** response of any mutation on the table "audit.vInputPointAudit" */
export type inputPointAudit_mutation_response = {
  __typename?: 'inputPointAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<inputPointAudit>;
};

/** Ordering options when selecting data from "audit.vInputPointAudit". */
export type inputPointAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  id?: order_by;
  inputPoint?: qx_InputPoint_order_by;
  person?: qx_Person_order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  row_data?: order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type inputPointAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.vInputPointAudit" */
export enum inputPointAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  id = 'id',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.vInputPointAudit" */
export type inputPointAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type inputPointAudit_stddev_fields = {
  __typename?: 'inputPointAudit_stddev_fields';
  auditID?: number;
};

/** aggregate stddev_pop on columns */
export type inputPointAudit_stddev_pop_fields = {
  __typename?: 'inputPointAudit_stddev_pop_fields';
  auditID?: number;
};

/** aggregate stddev_samp on columns */
export type inputPointAudit_stddev_samp_fields = {
  __typename?: 'inputPointAudit_stddev_samp_fields';
  auditID?: number;
};

/** Streaming cursor of the table "inputPointAudit" */
export type inputPointAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: inputPointAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type inputPointAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type inputPointAudit_sum_fields = {
  __typename?: 'inputPointAudit_sum_fields';
  auditID?: string;
};

export type inputPointAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: inputPointAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: inputPointAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: inputPointAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: inputPointAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: inputPointAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: inputPointAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: inputPointAudit_set_input;
  /** filter the rows which have to be updated */
  where: inputPointAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type inputPointAudit_var_pop_fields = {
  __typename?: 'inputPointAudit_var_pop_fields';
  auditID?: number;
};

/** aggregate var_samp on columns */
export type inputPointAudit_var_samp_fields = {
  __typename?: 'inputPointAudit_var_samp_fields';
  auditID?: number;
};

/** aggregate variance on columns */
export type inputPointAudit_variance_fields = {
  __typename?: 'inputPointAudit_variance_fields';
  auditID?: number;
};

/** Boolean expression to compare columns of type "interval". All fields are combined with logical 'AND'. */
export type interval_comparison_exp = {
  _eq?: any;
  _gt?: any;
  _gte?: any;
  _in?: Array<any>;
  _is_null?: boolean;
  _lt?: any;
  _lte?: any;
  _neq?: any;
  _nin?: Array<any>;
};

export type isActive_qx_Schedule_args = {
  tz_override?: string;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type json_comparison_exp = {
  _eq?: any;
  _gt?: any;
  _gte?: any;
  _in?: Array<any>;
  _is_null?: boolean;
  _lt?: any;
  _lte?: any;
  _neq?: any;
  _nin?: Array<any>;
};

export type jsonb_cast_exp = {
  String?: String_comparison_exp;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type jsonb_comparison_exp = {
  _cast?: jsonb_cast_exp;
  /** is the column contained in the given json value */
  _contained_in?: any;
  /** does the column contain the given json value at the top level */
  _contains?: any;
  _eq?: any;
  _gt?: any;
  _gte?: any;
  /** does the string exist as a top-level key in the column */
  _has_key?: string;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: Array<string>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: Array<string>;
  _in?: Array<any>;
  _is_null?: boolean;
  /** does the jsonpath return any item for the specified JSON value */
  _jsonb_path_exists?: string;
  /** does the jsonpath predicate check return true for the specified JSON value */
  _jsonb_path_match?: string;
  _lt?: any;
  _lte?: any;
  _neq?: any;
  _nin?: Array<any>;
};

/** audit view tracking historical changes to lock hardware configurations */
export type lockAudit = {
  __typename?: 'lockAudit';
  action?: string;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  id?: string;
  /** An object relationship */
  lock?: qx_Lock;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  row_data?: any;
  time?: string;
};


/** audit view tracking historical changes to lock hardware configurations */
export type lockAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes to lock hardware configurations */
export type lockAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.vLockAudit" */
export type lockAudit_aggregate = {
  __typename?: 'lockAudit_aggregate';
  aggregate?: lockAudit_aggregate_fields;
  nodes: Array<lockAudit>;
};

/** aggregate fields of "audit.vLockAudit" */
export type lockAudit_aggregate_fields = {
  __typename?: 'lockAudit_aggregate_fields';
  avg?: lockAudit_avg_fields;
  count: number;
  max?: lockAudit_max_fields;
  min?: lockAudit_min_fields;
  stddev?: lockAudit_stddev_fields;
  stddev_pop?: lockAudit_stddev_pop_fields;
  stddev_samp?: lockAudit_stddev_samp_fields;
  sum?: lockAudit_sum_fields;
  var_pop?: lockAudit_var_pop_fields;
  var_samp?: lockAudit_var_samp_fields;
  variance?: lockAudit_variance_fields;
};


/** aggregate fields of "audit.vLockAudit" */
export type lockAudit_aggregate_fieldscountArgs = {
  columns?: Array<lockAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type lockAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type lockAudit_avg_fields = {
  __typename?: 'lockAudit_avg_fields';
  auditID?: number;
};

/** Boolean expression to filter rows from the table "audit.vLockAudit". All fields are combined with a logical 'AND'. */
export type lockAudit_bool_exp = {
  _and?: Array<lockAudit_bool_exp>;
  _not?: lockAudit_bool_exp;
  _or?: Array<lockAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  id?: String_comparison_exp;
  lock?: qx_Lock_bool_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type lockAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type lockAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type lockAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.vLockAudit" */
export type lockAudit_inc_input = {
  auditID?: string;
};

/** input type for inserting data into table "audit.vLockAudit" */
export type lockAudit_insert_input = {
  action?: string;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  id?: string;
  lock?: qx_Lock_obj_rel_insert_input;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate max on columns */
export type lockAudit_max_fields = {
  __typename?: 'lockAudit_max_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** aggregate min on columns */
export type lockAudit_min_fields = {
  __typename?: 'lockAudit_min_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** response of any mutation on the table "audit.vLockAudit" */
export type lockAudit_mutation_response = {
  __typename?: 'lockAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<lockAudit>;
};

/** Ordering options when selecting data from "audit.vLockAudit". */
export type lockAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  id?: order_by;
  lock?: qx_Lock_order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  row_data?: order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type lockAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.vLockAudit" */
export enum lockAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  id = 'id',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.vLockAudit" */
export type lockAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type lockAudit_stddev_fields = {
  __typename?: 'lockAudit_stddev_fields';
  auditID?: number;
};

/** aggregate stddev_pop on columns */
export type lockAudit_stddev_pop_fields = {
  __typename?: 'lockAudit_stddev_pop_fields';
  auditID?: number;
};

/** aggregate stddev_samp on columns */
export type lockAudit_stddev_samp_fields = {
  __typename?: 'lockAudit_stddev_samp_fields';
  auditID?: number;
};

/** Streaming cursor of the table "lockAudit" */
export type lockAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: lockAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type lockAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type lockAudit_sum_fields = {
  __typename?: 'lockAudit_sum_fields';
  auditID?: string;
};

export type lockAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: lockAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: lockAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: lockAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: lockAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: lockAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: lockAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: lockAudit_set_input;
  /** filter the rows which have to be updated */
  where: lockAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type lockAudit_var_pop_fields = {
  __typename?: 'lockAudit_var_pop_fields';
  auditID?: number;
};

/** aggregate var_samp on columns */
export type lockAudit_var_samp_fields = {
  __typename?: 'lockAudit_var_samp_fields';
  auditID?: number;
};

/** aggregate variance on columns */
export type lockAudit_variance_fields = {
  __typename?: 'lockAudit_variance_fields';
  auditID?: number;
};

export type lockSettings = {
  configuration?: Array<namevalue>;
  direction?: string;
  doorRefId?: string;
  enabled?: boolean;
  powerMonitor?: string;
  refId?: string;
  relayMonitor?: string;
  type?: string;
};

/** audit view tracking historical changes to media profile recording configurations */
export type mediaProfileAudit = {
  __typename?: 'mediaProfileAudit';
  action?: string;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  id?: string;
  /** An object relationship */
  mediaProfile?: qx_MediaProfile;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  row_data?: any;
  time?: string;
};


/** audit view tracking historical changes to media profile recording configurations */
export type mediaProfileAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes to media profile recording configurations */
export type mediaProfileAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.vMediaProfileAudit" */
export type mediaProfileAudit_aggregate = {
  __typename?: 'mediaProfileAudit_aggregate';
  aggregate?: mediaProfileAudit_aggregate_fields;
  nodes: Array<mediaProfileAudit>;
};

/** aggregate fields of "audit.vMediaProfileAudit" */
export type mediaProfileAudit_aggregate_fields = {
  __typename?: 'mediaProfileAudit_aggregate_fields';
  avg?: mediaProfileAudit_avg_fields;
  count: number;
  max?: mediaProfileAudit_max_fields;
  min?: mediaProfileAudit_min_fields;
  stddev?: mediaProfileAudit_stddev_fields;
  stddev_pop?: mediaProfileAudit_stddev_pop_fields;
  stddev_samp?: mediaProfileAudit_stddev_samp_fields;
  sum?: mediaProfileAudit_sum_fields;
  var_pop?: mediaProfileAudit_var_pop_fields;
  var_samp?: mediaProfileAudit_var_samp_fields;
  variance?: mediaProfileAudit_variance_fields;
};


/** aggregate fields of "audit.vMediaProfileAudit" */
export type mediaProfileAudit_aggregate_fieldscountArgs = {
  columns?: Array<mediaProfileAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type mediaProfileAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type mediaProfileAudit_avg_fields = {
  __typename?: 'mediaProfileAudit_avg_fields';
  auditID?: number;
  id?: number;
};

/** Boolean expression to filter rows from the table "audit.vMediaProfileAudit". All fields are combined with a logical 'AND'. */
export type mediaProfileAudit_bool_exp = {
  _and?: Array<mediaProfileAudit_bool_exp>;
  _not?: mediaProfileAudit_bool_exp;
  _or?: Array<mediaProfileAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  id?: bigint_comparison_exp;
  mediaProfile?: qx_MediaProfile_bool_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type mediaProfileAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type mediaProfileAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type mediaProfileAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.vMediaProfileAudit" */
export type mediaProfileAudit_inc_input = {
  auditID?: string;
  id?: string;
};

/** input type for inserting data into table "audit.vMediaProfileAudit" */
export type mediaProfileAudit_insert_input = {
  action?: string;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  id?: string;
  mediaProfile?: qx_MediaProfile_obj_rel_insert_input;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate max on columns */
export type mediaProfileAudit_max_fields = {
  __typename?: 'mediaProfileAudit_max_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** aggregate min on columns */
export type mediaProfileAudit_min_fields = {
  __typename?: 'mediaProfileAudit_min_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** response of any mutation on the table "audit.vMediaProfileAudit" */
export type mediaProfileAudit_mutation_response = {
  __typename?: 'mediaProfileAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<mediaProfileAudit>;
};

/** Ordering options when selecting data from "audit.vMediaProfileAudit". */
export type mediaProfileAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  id?: order_by;
  mediaProfile?: qx_MediaProfile_order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  row_data?: order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type mediaProfileAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.vMediaProfileAudit" */
export enum mediaProfileAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  id = 'id',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.vMediaProfileAudit" */
export type mediaProfileAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type mediaProfileAudit_stddev_fields = {
  __typename?: 'mediaProfileAudit_stddev_fields';
  auditID?: number;
  id?: number;
};

/** aggregate stddev_pop on columns */
export type mediaProfileAudit_stddev_pop_fields = {
  __typename?: 'mediaProfileAudit_stddev_pop_fields';
  auditID?: number;
  id?: number;
};

/** aggregate stddev_samp on columns */
export type mediaProfileAudit_stddev_samp_fields = {
  __typename?: 'mediaProfileAudit_stddev_samp_fields';
  auditID?: number;
  id?: number;
};

/** Streaming cursor of the table "mediaProfileAudit" */
export type mediaProfileAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: mediaProfileAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type mediaProfileAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type mediaProfileAudit_sum_fields = {
  __typename?: 'mediaProfileAudit_sum_fields';
  auditID?: string;
  id?: string;
};

export type mediaProfileAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: mediaProfileAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: mediaProfileAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: mediaProfileAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: mediaProfileAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: mediaProfileAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: mediaProfileAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: mediaProfileAudit_set_input;
  /** filter the rows which have to be updated */
  where: mediaProfileAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type mediaProfileAudit_var_pop_fields = {
  __typename?: 'mediaProfileAudit_var_pop_fields';
  auditID?: number;
  id?: number;
};

/** aggregate var_samp on columns */
export type mediaProfileAudit_var_samp_fields = {
  __typename?: 'mediaProfileAudit_var_samp_fields';
  auditID?: number;
  id?: number;
};

/** aggregate variance on columns */
export type mediaProfileAudit_variance_fields = {
  __typename?: 'mediaProfileAudit_variance_fields';
  auditID?: number;
  id?: number;
};

/** mutation root */
export type mutation_root = {
  __typename?: 'mutation_root';
  _deleteGateway?: qx_Gateway;
  _deleteGateways?: qx_Gateway_mutation_response;
  acceptTermsOfAgreement: SuccessOutput;
  accessDoor: SuccessOutput;
  accessReport: AccessReport;
  accessReportInfo: AccessReportInfo;
  activateOutput: SuccessOutput;
  /** Perform an arm or disarm action on a partition */
  armPartition: SuccessOutput;
  blockDoor: SuccessOutput;
  /** Perform a bypass action on a zone */
  bypassZone: SuccessOutput;
  cancelPendingBillingDowngrade: SuccessOutput;
  clearFlowStatus: SuccessOutput;
  cloudPeerOffer: StringOutput;
  cloudPushCandidate: SuccessOutput;
  /** insert a single row into the table: "qx.eAccessBoardType" */
  createAccessBoardTypeEnum?: qx_eAccessBoardType;
  /** insert data into the table: "qx.eAccessBoardType" */
  createAccessBoardTypeEnums?: qx_eAccessBoardType_mutation_response;
  /** insert a single row into the table: "qx.AccessCatalog" */
  createAccessCatalog?: qx_AccessCatalog;
  /** insert data into the table: "qx.AccessCatalog" */
  createAccessCatalogs?: qx_AccessCatalog_mutation_response;
  /** insert a single row into the table: "qx.eAccessDeniedReason" */
  createAccessDeniedReasonEnum?: qx_eAccessDeniedReason;
  /** insert data into the table: "qx.eAccessDeniedReason" */
  createAccessDeniedReasonEnums?: qx_eAccessDeniedReason_mutation_response;
  /** insert a single row into the table: "qx.eAccessInterfaceType" */
  createAccessInterfaceTypeEnum?: qx_eAccessInterfaceType;
  /** insert data into the table: "qx.eAccessInterfaceType" */
  createAccessInterfaceTypeEnums?: qx_eAccessInterfaceType_mutation_response;
  /** insert data into the table: "qx.AccessInventory" */
  createAccessInventories?: qx_AccessInventory_mutation_response;
  /** insert a single row into the table: "qx.AccessInventory" */
  createAccessInventory?: qx_AccessInventory;
  /** insert a single row into the table: "qx.eAccessPointAction" */
  createAccessPointActionEnum?: qx_eAccessPointAction;
  /** insert data into the table: "qx.eAccessPointAction" */
  createAccessPointActionEnums?: qx_eAccessPointAction_mutation_response;
  /** insert a single row into the table: "qx.eAccessPointDirection" */
  createAccessPointDirectionEnum?: qx_eAccessPointDirection;
  /** insert data into the table: "qx.eAccessPointDirection" */
  createAccessPointDirectionEnums?: qx_eAccessPointDirection_mutation_response;
  /** insert a single row into the table: "qx.eAccessPointType" */
  createAccessPointTypeEnum?: qx_eAccessPointType;
  /** insert data into the table: "qx.eAccessPointType" */
  createAccessPointTypeEnums?: qx_eAccessPointType_mutation_response;
  createApiAppPassword: AppPassword;
  createAppPassword: AppPassword;
  /** insert a single row into the table: "qx.AudioSource" */
  createAudioSource?: qx_AudioSource;
  /** insert data into the table: "qx.AudioSource" */
  createAudioSources?: qx_AudioSource_mutation_response;
  /** insert a single row into the table: "qx.eAuthStrategy" */
  createAuthStrategyEnum?: qx_eAuthStrategy;
  /** insert data into the table: "qx.eAuthStrategy" */
  createAuthStrategyEnums?: qx_eAuthStrategy_mutation_response;
  /** insert a single row into the table: "qx.eBatteryLevel" */
  createBatteryLevelEnum?: qx_eBatteryLevel;
  /** insert data into the table: "qx.eBatteryLevel" */
  createBatteryLevelEnums?: qx_eBatteryLevel_mutation_response;
  /** insert a single row into the table: "qx.eBaudrate" */
  createBaudrateEnum?: qx_eBaudrate;
  /** insert data into the table: "qx.eBaudrate" */
  createBaudrateEnums?: qx_eBaudrate_mutation_response;
  /** insert a single row into the table: "qx.BillingPeriod" */
  createBillingPeriod?: qx_BillingPeriod;
  /** insert a single row into the table: "qx.eBillingTier" */
  createBillingTierEnum?: qx_eBillingTier;
  /** insert data into the table: "qx.eBillingTier" */
  createBillingTierEnums?: qx_eBillingTier_mutation_response;
  /** insert data into the table: "qx.ChatUsageHistory" */
  createChatUsageHistories?: qx_ChatUsageHistory_mutation_response;
  /** insert a single row into the table: "qx.ChatUsageHistory" */
  createChatUsageHistory?: qx_ChatUsageHistory;
  /** insert a single row into the table: "qx.Clip" */
  createClip?: qx_Clip;
  /** insert a single row into the table: "qx.eClipStatus" */
  createClipStatusEnum?: qx_eClipStatus;
  /** insert data into the table: "qx.eClipStatus" */
  createClipStatusEnums?: qx_eClipStatus_mutation_response;
  /** insert a single row into the table: "qx.eClipType" */
  createClipTypeEnum?: qx_eClipType;
  /** insert data into the table: "qx.eClipType" */
  createClipTypeEnums?: qx_eClipType_mutation_response;
  /** insert data into the table: "qx.Clip" */
  createClips?: qx_Clip_mutation_response;
  /** insert a single row into the table: "qx.CloudStorageOptions" */
  createCloudStorageOption?: qx_CloudStorageOptions;
  /** insert a single row into the table: "qx.Credential" */
  createCredential?: qx_Credential;
  /** insert a single row into the table: "qx.eCredentialType" */
  createCredentialTypeEnum?: qx_eCredentialType;
  /** insert data into the table: "qx.eCredentialType" */
  createCredentialTypeEnums?: qx_eCredentialType_mutation_response;
  /** insert data into the table: "qx.Credential" */
  createCredentials?: qx_Credential_mutation_response;
  /** insert a single row into the table: "qx.CustomerPermission" */
  createCustomerPermission?: qx_CustomerPermission;
  /** insert data into the table: "qx.CustomerPermission" */
  createCustomerPermissions?: qx_CustomerPermission_mutation_response;
  /** insert a single row into the table: "qx.eDIONormalState" */
  createDIONormalStateEnum?: qx_eDIONormalState;
  /** insert data into the table: "qx.eDIONormalState" */
  createDIONormalStateEnums?: qx_eDIONormalState_mutation_response;
  /** insert a single row into the table: "qx.eDIOState" */
  createDIOStateEnum?: qx_eDIOState;
  /** insert data into the table: "qx.eDIOState" */
  createDIOStateEnums?: qx_eDIOState_mutation_response;
  /** insert a single row into the table: "qx.eDIOType" */
  createDIOTypeEnum?: qx_eDIOType;
  /** insert data into the table: "qx.eDIOType" */
  createDIOTypeEnums?: qx_eDIOType_mutation_response;
  createDevice: CreateDeviceOutput;
  /** insert a single row into the table: "qx.eDeviceConnectionStatus" */
  createDeviceConnectionStatusEnum?: qx_eDeviceConnectionStatus;
  /** insert data into the table: "qx.eDeviceConnectionStatus" */
  createDeviceConnectionStatusEnums?: qx_eDeviceConnectionStatus_mutation_response;
  /** insert a single row into the table: "qx.DeviceDIO" */
  createDeviceDIO?: qx_DeviceDIO;
  /** insert data into the table: "qx.DeviceDIO" */
  createDeviceDIOs?: qx_DeviceDIO_mutation_response;
  /** insert a single row into the table: "qx.eDeviceKind" */
  createDeviceKindEnum?: qx_eDeviceKind;
  /** insert data into the table: "qx.eDeviceKind" */
  createDeviceKindEnums?: qx_eDeviceKind_mutation_response;
  createDevices: Array<CreateDeviceOutput>;
  /** insert a single row into the table: "qx.Door" */
  createDoor?: qx_Door;
  /** insert a single row into the table: "qx.eDoorAlarm" */
  createDoorAlarmEnum?: qx_eDoorAlarm;
  /** insert data into the table: "qx.eDoorAlarm" */
  createDoorAlarmEnums?: qx_eDoorAlarm_mutation_response;
  /** insert a single row into the table: "qx.DoorConfiguration" */
  createDoorConfiguration?: qx_DoorConfiguration;
  /** insert data into the table: "qx.DoorConfiguration" */
  createDoorConfigurations?: qx_DoorConfiguration_mutation_response;
  /** insert a single row into the table: "qx.DoorMeta" */
  createDoorMeta?: qx_DoorMeta;
  /** insert data into the table: "qx.DoorMeta" */
  createDoorMetas?: qx_DoorMeta_mutation_response;
  /** insert a single row into the table: "qx.eDoorMode" */
  createDoorModeEnum?: qx_eDoorMode;
  /** insert data into the table: "qx.eDoorMode" */
  createDoorModeEnums?: qx_eDoorMode_mutation_response;
  /** insert a single row into the table: "qx.eDoorMonitor" */
  createDoorMonitorEnum?: qx_eDoorMonitor;
  /** insert data into the table: "qx.eDoorMonitor" */
  createDoorMonitorEnums?: qx_eDoorMonitor_mutation_response;
  /** insert a single row into the table: "qx.eDoorState" */
  createDoorStateEnum?: qx_eDoorState;
  /** insert data into the table: "qx.eDoorState" */
  createDoorStateEnums?: qx_eDoorState_mutation_response;
  /** insert a single row into the table: "qx.DoorTemplate" */
  createDoorTemplate?: qx_DoorTemplate;
  /** insert data into the table: "qx.DoorTemplate" */
  createDoorTemplates?: qx_DoorTemplate_mutation_response;
  /** insert data into the table: "qx.Door" */
  createDoors?: qx_Door_mutation_response;
  /** insert a single row into the table: "qx.Event" */
  createEvent?: qx_Event;
  /** insert data into the table: "qx.EventType" */
  createEventTypes?: qx_EventType_mutation_response;
  /** insert data into the table: "qx.Event" */
  createEvents?: qx_Event_mutation_response;
  /** insert a single row into the table: "qx.Flow" */
  createFlow?: qx_Flow;
  /** insert a single row into the table: "qx.eFlowNotificationType" */
  createFlowNotificationTypeEnum?: qx_eFlowNotificationType;
  /** insert data into the table: "qx.eFlowNotificationType" */
  createFlowNotificationTypeEnums?: qx_eFlowNotificationType_mutation_response;
  /** insert a single row into the table: "qx.FlowTrace" */
  createFlowTrace?: qx_FlowTrace;
  /** insert data into the table: "qx.FlowTrace" */
  createFlowTraces?: qx_FlowTrace_mutation_response;
  /** insert data into the table: "qx.Flow" */
  createFlows?: qx_Flow_mutation_response;
  /** insert a single row into the table: "qx.Gateway" */
  createGateway?: qx_Gateway;
  /** insert a single row into the table: "qx.GatewayBandwidthSchedule" */
  createGatewayBandwidthSchedule?: qx_GatewayBandwidthSchedule;
  /** insert data into the table: "qx.GatewayBandwidthSchedule" */
  createGatewayBandwidthSchedules?: qx_GatewayBandwidthSchedule_mutation_response;
  /** insert a single row into the table: "qx.eGatewayServiceType" */
  createGatewayServiceTypeEnum?: qx_eGatewayServiceType;
  /** insert data into the table: "qx.eGatewayServiceType" */
  createGatewayServiceTypeEnums?: qx_eGatewayServiceType_mutation_response;
  /** insert a single row into the table: "qx.eGatewaySyncStatus" */
  createGatewaySyncStatusEnum?: qx_eGatewaySyncStatus;
  /** insert data into the table: "qx.eGatewaySyncStatus" */
  createGatewaySyncStatusEnums?: qx_eGatewaySyncStatus_mutation_response;
  /** insert data into the table: "qx.Gateway" */
  createGateways?: qx_Gateway_mutation_response;
  /** insert a single row into the table: "qx.Group" */
  createGroup?: qx_Group;
  /** insert data into the table: "qx.Group" */
  createGroups?: qx_Group_mutation_response;
  /** insert a single row into the table: "qx.HolidaySet" */
  createHolidaySet?: qx_HolidaySet;
  /** insert a single row into the table: "qx._HolidaySetToScheduleBlock" */
  createHolidaySetToScheduleBlock?: qx__HolidaySetToScheduleBlock;
  /** insert data into the table: "qx._HolidaySetToScheduleBlock" */
  createHolidaySetToScheduleBlocks?: qx__HolidaySetToScheduleBlock_mutation_response;
  /** insert data into the table: "qx.HolidaySet" */
  createHolidaySets?: qx_HolidaySet_mutation_response;
  /** insert a single row into the table: "qx.InputPoint" */
  createInputPoint?: qx_InputPoint;
  /** insert data into the table: "qx.InputPoint" */
  createInputPoints?: qx_InputPoint_mutation_response;
  /** insert a single row into the table: "qx.eKeypadMode" */
  createKeyModeEnum?: qx_eKeypadMode;
  /** insert data into the table: "qx.eKeypadMode" */
  createKeyModeEnums?: qx_eKeypadMode_mutation_response;
  /** insert a single row into the table: "qx.Layout" */
  createLayout?: qx_Layout;
  /** insert data into the table: "qx.Layout" */
  createLayouts?: qx_Layout_mutation_response;
  /** insert a single row into the table: "qx.LensProfile" */
  createLensProfile?: qx_LensProfile;
  /** insert data into the table: "qx.LensProfile" */
  createLensProfiles?: qx_LensProfile_mutation_response;
  /** insert a single row into the table: "qx.Lock" */
  createLock?: qx_Lock;
  /** insert a single row into the table: "qx.eLockPowerMonitor" */
  createLockPowerMonitorEnum?: qx_eLockPowerMonitor;
  /** insert data into the table: "qx.eLockPowerMonitor" */
  createLockPowerMonitorEnums?: qx_eLockPowerMonitor_mutation_response;
  /** insert a single row into the table: "qx.eLockRelayMonitor" */
  createLockRelayMonitorEnum?: qx_eLockRelayMonitor;
  /** insert data into the table: "qx.eLockRelayMonitor" */
  createLockRelayMonitorEnums?: qx_eLockRelayMonitor_mutation_response;
  /** insert a single row into the table: "qx.eLockType" */
  createLockTypeEnum?: qx_eLockType;
  /** insert data into the table: "qx.eLockType" */
  createLockTypeEnums?: qx_eLockType_mutation_response;
  /** insert data into the table: "qx.Lock" */
  createLocks?: qx_Lock_mutation_response;
  /** insert a single row into the table: "qx.MediaProfile" */
  createMediaProfile?: qx_MediaProfile;
  /** insert data into the table: "qx.MediaProfile" */
  createMediaProfiles?: qx_MediaProfile_mutation_response;
  /** insert a single row into the table: "qx.MercuryControlPoint" */
  createMercuryControlPoint?: qx_MercuryControlPoint;
  /** insert data into the table: "qx.MercuryControlPoint" */
  createMercuryControlPoints?: qx_MercuryControlPoint_mutation_response;
  /** insert a single row into the table: "qx.MercuryMonitorPoint" */
  createMercuryMonitorPoint?: qx_MercuryMonitorPoint;
  /** insert data into the table: "qx.MercuryMonitorPoint" */
  createMercuryMonitorPoints?: qx_MercuryMonitorPoint_mutation_response;
  /** insert a single row into the table: "qx.eMonitorLockState" */
  createMonitorLockStateEnum?: qx_eMonitorLockState;
  /** insert data into the table: "qx.eMonitorLockState" */
  createMonitorLockStateEnums?: qx_eMonitorLockState_mutation_response;
  /** insert a single row into the table: "qx.eMountPosition" */
  createMountPositionEnum?: qx_eMountPosition;
  /** insert data into the table: "qx.eMountPosition" */
  createMountPositionEnums?: qx_eMountPosition_mutation_response;
  /** insert a single row into the table: "qx.eObjectAction" */
  createObjectActionEnum?: qx_eObjectAction;
  /** insert data into the table: "qx.eObjectAction" */
  createObjectActionEnums?: qx_eObjectAction_mutation_response;
  /** insert a single row into the table: "qx.OssIdAssignment" */
  createOssIdAssignment?: qx_OssIdAssignment;
  /** insert data into the table: "qx.OssIdAssignment" */
  createOssIdAssignments?: qx_OssIdAssignment_mutation_response;
  /** insert a single row into the table: "qx.OutputPoint" */
  createOutputPoint?: qx_OutputPoint;
  /** insert data into the table: "qx.OutputPoint" */
  createOutputPoints?: qx_OutputPoint_mutation_response;
  /** insert a single row into the table: "qx.ePACSStatus" */
  createPACSStatusEnum?: qx_ePACSStatus;
  /** insert data into the table: "qx.ePACSStatus" */
  createPACSStatusEnums?: qx_ePACSStatus_mutation_response;
  /** insert data into the table: "qx.Person" */
  createPeople?: qx_Person_mutation_response;
  /** insert a single row into the table: "qx.Permission" */
  createPermission?: qx_Permission;
  /** Create a Permission and assign it to a set of IntrusionPartitions */
  createPermissionWithPartitions: StringOutput;
  /** insert data into the table: "qx.Permission" */
  createPermissions?: qx_Permission_mutation_response;
  /** insert a single row into the table: "qx.Person" */
  createPerson?: qx_Person;
  /** insert a single row into the table: "qx._PersonToGroup" */
  createPersonGroup?: qx__PersonToGroup;
  /** insert data into the table: "qx._PersonToGroup" */
  createPersonGroups?: qx__PersonToGroup_mutation_response;
  /** insert a single row into the table: "qx.ePersonStatus" */
  createPersonStatusEnum?: qx_ePersonStatus;
  /** insert data into the table: "qx.ePersonStatus" */
  createPersonStatusEnums?: qx_ePersonStatus_mutation_response;
  /** insert a single row into the table: "qx.Place" */
  createPlace?: qx_Place;
  /** insert a single row into the table: "qx.ePlaceType" */
  createPlaceTypeEnum?: qx_ePlaceType;
  /** insert data into the table: "qx.ePlaceType" */
  createPlaceTypeEnums?: qx_ePlaceType_mutation_response;
  /** insert data into the table: "qx.Place" */
  createPlaces?: qx_Place_mutation_response;
  /** insert a single row into the table: "qx.ePrivilege" */
  createPrivilegeEnum?: qx_ePrivilege;
  /** insert a single row into the table: "qx._PrivilegeEnumToRole" */
  createPrivilegeEnumToRole?: qx__PrivilegeEnumToRole;
  /** insert data into the table: "qx._PrivilegeEnumToRole" */
  createPrivilegeEnumToRoles?: qx__PrivilegeEnumToRole_mutation_response;
  /** insert data into the table: "qx.ePrivilege" */
  createPrivilegeEnums?: qx_ePrivilege_mutation_response;
  /** insert a single row into the table: "qx.Reader" */
  createReader?: qx_Reader;
  /** insert a single row into the table: "qx.eReaderAccessType" */
  createReaderAccessTypeEnum?: qx_eReaderAccessType;
  /** insert data into the table: "qx.eReaderAccessType" */
  createReaderAccessTypeEnums?: qx_eReaderAccessType_mutation_response;
  /** insert a single row into the table: "qx.eReaderProtocol" */
  createReaderProtocolEnum?: qx_eReaderProtocol;
  /** insert data into the table: "qx.eReaderProtocol" */
  createReaderProtocolEnums?: qx_eReaderProtocol_mutation_response;
  /** insert data into the table: "qx.Reader" */
  createReaders?: qx_Reader_mutation_response;
  /** insert a single row into the table: "qx.eRexState" */
  createRexStateEnum?: qx_eRexState;
  /** insert data into the table: "qx.eRexState" */
  createRexStateEnums?: qx_eRexState_mutation_response;
  /** insert a single row into the table: "qx.Role" */
  createRole?: qx_Role;
  /** insert data into the table: "qx.Role" */
  createRoles?: qx_Role_mutation_response;
  /** insert a single row into the table: "qx.RosslareConnection" */
  createRosslareConnection?: qx_RosslareConnection;
  /** insert data into the table: "qx.RosslareConnection" */
  createRosslareConnections?: qx_RosslareConnection_mutation_response;
  /** insert a single row into the table: "qx.Schedule" */
  createSchedule?: qx_Schedule;
  /** insert a single row into the table: "qx.ScheduleBlock" */
  createScheduleBlock?: qx_ScheduleBlock;
  /** insert data into the table: "qx.ScheduleBlock" */
  createScheduleBlocks?: qx_ScheduleBlock_mutation_response;
  /** insert data into the table: "qx.Schedule" */
  createSchedules?: qx_Schedule_mutation_response;
  /** insert a single row into the table: "qx.Segment" */
  createSegment?: qx_Segment;
  /** insert data into the table: "qx.Segment" */
  createSegments?: qx_Segment_mutation_response;
  /** insert a single row into the table: "qx.Sensor" */
  createSensor?: qx_Sensor;
  /** insert a single row into the table: "qx.eSensorAction" */
  createSensorActionEnum?: qx_eSensorAction;
  /** insert data into the table: "qx.eSensorAction" */
  createSensorActionEnums?: qx_eSensorAction_mutation_response;
  /** insert a single row into the table: "qx.eSensorType" */
  createSensorTypeEnum?: qx_eSensorType;
  /** insert data into the table: "qx.eSensorType" */
  createSensorTypeEnums?: qx_eSensorType_mutation_response;
  /** insert data into the table: "qx.Sensor" */
  createSensors?: qx_Sensor_mutation_response;
  createSharedLink: GetSharedLinkUrlOutput;
  /** insert a single row into the table: "qx.Snapshot" */
  createSnapshot?: qx_Snapshot;
  /** insert data into the table: "qx.Snapshot" */
  createSnapshots?: qx_Snapshot_mutation_response;
  /** insert a single row into the table: "qx.eStreamStatus" */
  createStreamStatusEnum?: qx_eStreamStatus;
  /** insert data into the table: "qx.eStreamStatus" */
  createStreamStatusEnums?: qx_eStreamStatus_mutation_response;
  /** insert a single row into the table: "qx.eSuperviseInputs" */
  createSuperviseInputsEnum?: qx_eSuperviseInputs;
  /** insert data into the table: "qx.eSuperviseInputs" */
  createSuperviseInputsEnums?: qx_eSuperviseInputs_mutation_response;
  /** insert a single row into the table: "qx.TermsAgreement" */
  createTermsAgreement?: qx_TermsAgreement;
  /** insert data into the table: "qx.TermsAgreement" */
  createTermsAgreements?: qx_TermsAgreement_mutation_response;
  /** insert a single row into the table: "qx.TimeZone" */
  createTimeZone?: qx_TimeZone;
  /** insert data into the table: "qx.TimeZone" */
  createTimeZones?: qx_TimeZone_mutation_response;
  /** insert a single row into the table: "qx.UserSetting" */
  createUserSetting?: qx_UserSetting;
  /** insert data into the table: "qx.UserSetting" */
  createUserSettings?: qx_UserSetting_mutation_response;
  /** insert a single row into the table: "qx.VideoSource" */
  createVideoSource?: qx_VideoSource;
  /** insert data into the table: "qx.VideoSource" */
  createVideoSources?: qx_VideoSource_mutation_response;
  /** insert a single row into the table: "qx.View" */
  createView?: qx_View;
  /** insert data into the table: "qx.View" */
  createViews?: qx_View_mutation_response;
  /** insert a single row into the table: "qx.WiegandCardFormat" */
  createWiegandCardFormat?: qx_WiegandCardFormat;
  /** insert data into the table: "qx.WiegandCardFormat" */
  createWiegandCardFormats?: qx_WiegandCardFormat_mutation_response;
  deactivateOutput: SuccessOutput;
  /** delete single row from the table: "qx.eAccessBoardType" */
  deleteAccessBoardTypeEnum?: qx_eAccessBoardType;
  /** delete data from the table: "qx.eAccessBoardType" */
  deleteAccessBoardTypeEnums?: qx_eAccessBoardType_mutation_response;
  /** delete single row from the table: "qx.AccessCatalog" */
  deleteAccessCatalog?: qx_AccessCatalog;
  /** delete data from the table: "qx.AccessCatalog" */
  deleteAccessCatalogs?: qx_AccessCatalog_mutation_response;
  /** delete single row from the table: "qx.eAccessDeniedReason" */
  deleteAccessDeniedReasonEnum?: qx_eAccessDeniedReason;
  /** delete data from the table: "qx.eAccessDeniedReason" */
  deleteAccessDeniedReasonEnums?: qx_eAccessDeniedReason_mutation_response;
  /** delete single row from the table: "qx.eAccessInterfaceType" */
  deleteAccessInterfaceTypeEnum?: qx_eAccessInterfaceType;
  /** delete data from the table: "qx.eAccessInterfaceType" */
  deleteAccessInterfaceTypeEnums?: qx_eAccessInterfaceType_mutation_response;
  /** delete data from the table: "qx.AccessInventory" */
  deleteAccessInventories?: qx_AccessInventory_mutation_response;
  /** delete single row from the table: "qx.AccessInventory" */
  deleteAccessInventory?: qx_AccessInventory;
  /** delete single row from the table: "qx.eAccessPointAction" */
  deleteAccessPointActionEnum?: qx_eAccessPointAction;
  /** delete data from the table: "qx.eAccessPointAction" */
  deleteAccessPointActionEnums?: qx_eAccessPointAction_mutation_response;
  /** delete single row from the table: "qx.eAccessPointDirection" */
  deleteAccessPointDirectionEnum?: qx_eAccessPointDirection;
  /** delete data from the table: "qx.eAccessPointDirection" */
  deleteAccessPointDirectionEnums?: qx_eAccessPointDirection_mutation_response;
  /** delete single row from the table: "qx.eAccessPointType" */
  deleteAccessPointTypeEnum?: qx_eAccessPointType;
  /** delete data from the table: "qx.eAccessPointType" */
  deleteAccessPointTypeEnums?: qx_eAccessPointType_mutation_response;
  /** delete single row from the table: "qx.AudioSource" */
  deleteAudioSource?: qx_AudioSource;
  /** delete data from the table: "qx.AudioSource" */
  deleteAudioSources?: qx_AudioSource_mutation_response;
  /** delete single row from the table: "qx.eAuthStrategy" */
  deleteAuthStrategyEnum?: qx_eAuthStrategy;
  /** delete data from the table: "qx.eAuthStrategy" */
  deleteAuthStrategyEnums?: qx_eAuthStrategy_mutation_response;
  /** delete single row from the table: "qx.eBatteryLevel" */
  deleteBatteryLevelEnum?: qx_eBatteryLevel;
  /** delete data from the table: "qx.eBatteryLevel" */
  deleteBatteryLevelEnums?: qx_eBatteryLevel_mutation_response;
  /** delete single row from the table: "qx.eBaudrate" */
  deleteBaudrateEnum?: qx_eBaudrate;
  /** delete data from the table: "qx.eBaudrate" */
  deleteBaudrateEnums?: qx_eBaudrate_mutation_response;
  /** delete single row from the table: "qx.BillingPeriod" */
  deleteBillingPeriod?: qx_BillingPeriod;
  /** delete single row from the table: "qx.eBillingTier" */
  deleteBillingTierEnum?: qx_eBillingTier;
  /** delete data from the table: "qx.eBillingTier" */
  deleteBillingTierEnums?: qx_eBillingTier_mutation_response;
  /** delete data from the table: "qx.ChatUsageHistory" */
  deleteChatUsageHistories?: qx_ChatUsageHistory_mutation_response;
  /** delete single row from the table: "qx.ChatUsageHistory" */
  deleteChatUsageHistory?: qx_ChatUsageHistory;
  /** delete single row from the table: "qx.eClipStatus" */
  deleteClipStatusEnum?: qx_eClipStatus;
  /** delete data from the table: "qx.eClipStatus" */
  deleteClipStatusEnums?: qx_eClipStatus_mutation_response;
  /** delete single row from the table: "qx.eClipType" */
  deleteClipTypeEnum?: qx_eClipType;
  /** delete data from the table: "qx.eClipType" */
  deleteClipTypeEnums?: qx_eClipType_mutation_response;
  /** delete data from the table: "qx.Clip" */
  deleteClips?: qx_Clip_mutation_response;
  /** delete single row from the table: "qx.CloudStorageOptions" */
  deleteCloudStorageOption?: qx_CloudStorageOptions;
  /** delete single row from the table: "qx.Credential" */
  deleteCredential?: qx_Credential;
  /** delete single row from the table: "qx.eCredentialType" */
  deleteCredentialTypeEnum?: qx_eCredentialType;
  /** delete data from the table: "qx.eCredentialType" */
  deleteCredentialTypeEnums?: qx_eCredentialType_mutation_response;
  /** delete data from the table: "qx.Credential" */
  deleteCredentials?: qx_Credential_mutation_response;
  /** delete single row from the table: "qx.CustomerPermission" */
  deleteCustomerPermission?: qx_CustomerPermission;
  /** delete data from the table: "qx.CustomerPermission" */
  deleteCustomerPermissions?: qx_CustomerPermission_mutation_response;
  /** delete single row from the table: "qx.eDIONormalState" */
  deleteDIONormalStateEnum?: qx_eDIONormalState;
  /** delete data from the table: "qx.eDIONormalState" */
  deleteDIONormalStateEnums?: qx_eDIONormalState_mutation_response;
  /** delete single row from the table: "qx.eDIOState" */
  deleteDIOStateEnum?: qx_eDIOState;
  /** delete data from the table: "qx.eDIOState" */
  deleteDIOStateEnums?: qx_eDIOState_mutation_response;
  /** delete single row from the table: "qx.eDIOType" */
  deleteDIOTypeEnum?: qx_eDIOType;
  /** delete data from the table: "qx.eDIOType" */
  deleteDIOTypeEnums?: qx_eDIOType_mutation_response;
  /** delete single row from the table: "qx.Device" */
  deleteDevice?: qx_Device;
  /** delete single row from the table: "qx.eDeviceConnectionStatus" */
  deleteDeviceConnectionStatusEnum?: qx_eDeviceConnectionStatus;
  /** delete data from the table: "qx.eDeviceConnectionStatus" */
  deleteDeviceConnectionStatusEnums?: qx_eDeviceConnectionStatus_mutation_response;
  /** delete single row from the table: "qx.DeviceDIO" */
  deleteDeviceDIO?: qx_DeviceDIO;
  /** delete data from the table: "qx.DeviceDIO" */
  deleteDeviceDIOs?: qx_DeviceDIO_mutation_response;
  deleteDeviceDioData: SuccessOutput;
  /** delete single row from the table: "qx.eDeviceKind" */
  deleteDeviceKindEnum?: qx_eDeviceKind;
  /** delete data from the table: "qx.eDeviceKind" */
  deleteDeviceKindEnums?: qx_eDeviceKind_mutation_response;
  deleteDeviceVideoData: DeleteDeviceVideoDataOutput;
  /** delete data from the table: "qx.Device" */
  deleteDevices?: qx_Device_mutation_response;
  /** delete single row from the table: "qx.Door" */
  deleteDoor?: qx_Door;
  /** delete single row from the table: "qx.eDoorAlarm" */
  deleteDoorAlarmEnum?: qx_eDoorAlarm;
  /** delete data from the table: "qx.eDoorAlarm" */
  deleteDoorAlarmEnums?: qx_eDoorAlarm_mutation_response;
  /** delete single row from the table: "qx.DoorConfiguration" */
  deleteDoorConfiguration?: qx_DoorConfiguration;
  /** delete data from the table: "qx.DoorConfiguration" */
  deleteDoorConfigurations?: qx_DoorConfiguration_mutation_response;
  /** delete single row from the table: "qx.DoorMeta" */
  deleteDoorMeta?: qx_DoorMeta;
  /** delete data from the table: "qx.DoorMeta" */
  deleteDoorMetas?: qx_DoorMeta_mutation_response;
  /** delete single row from the table: "qx.eDoorMode" */
  deleteDoorModeEnum?: qx_eDoorMode;
  /** delete data from the table: "qx.eDoorMode" */
  deleteDoorModeEnums?: qx_eDoorMode_mutation_response;
  /** delete single row from the table: "qx.eDoorMonitor" */
  deleteDoorMonitorEnum?: qx_eDoorMonitor;
  /** delete data from the table: "qx.eDoorMonitor" */
  deleteDoorMonitorEnums?: qx_eDoorMonitor_mutation_response;
  /** delete single row from the table: "qx.eDoorState" */
  deleteDoorStateEnum?: qx_eDoorState;
  /** delete data from the table: "qx.eDoorState" */
  deleteDoorStateEnums?: qx_eDoorState_mutation_response;
  /** delete single row from the table: "qx.DoorTemplate" */
  deleteDoorTemplate?: qx_DoorTemplate;
  /** delete data from the table: "qx.DoorTemplate" */
  deleteDoorTemplates?: qx_DoorTemplate_mutation_response;
  /** delete data from the table: "qx.Door" */
  deleteDoors?: qx_Door_mutation_response;
  /** delete single row from the table: "qx.Event" */
  deleteEvent?: qx_Event;
  /** delete data from the table: "qx.EventType" */
  deleteEventTypes?: qx_EventType_mutation_response;
  /** delete data from the table: "qx.Event" */
  deleteEvents?: qx_Event_mutation_response;
  /** delete single row from the table: "qx.Flow" */
  deleteFlow?: qx_Flow;
  /** delete single row from the table: "qx.eFlowNotificationType" */
  deleteFlowNotificationTypeEnum?: qx_eFlowNotificationType;
  /** delete data from the table: "qx.eFlowNotificationType" */
  deleteFlowNotificationTypeEnums?: qx_eFlowNotificationType_mutation_response;
  /** delete single row from the table: "qx.FlowTrace" */
  deleteFlowTrace?: qx_FlowTrace;
  /** delete data from the table: "qx.FlowTrace" */
  deleteFlowTraces?: qx_FlowTrace_mutation_response;
  /** delete data from the table: "qx.Flow" */
  deleteFlows?: qx_Flow_mutation_response;
  deleteGateway?: SuccessOutput;
  /** delete single row from the table: "qx.GatewayBandwidthSchedule" */
  deleteGatewayBandwidthSchedule?: qx_GatewayBandwidthSchedule;
  /** delete data from the table: "qx.GatewayBandwidthSchedule" */
  deleteGatewayBandwidthScshedules?: qx_GatewayBandwidthSchedule_mutation_response;
  /** delete single row from the table: "qx.eGatewayServiceType" */
  deleteGatewayServiceTypeEnum?: qx_eGatewayServiceType;
  /** delete data from the table: "qx.eGatewayServiceType" */
  deleteGatewayServiceTypeEnums?: qx_eGatewayServiceType_mutation_response;
  /** delete single row from the table: "qx.eGatewaySyncStatus" */
  deleteGatewaySyncStatusEnum?: qx_eGatewaySyncStatus;
  /** delete data from the table: "qx.eGatewaySyncStatus" */
  deleteGatewaySyncStatusEnums?: qx_eGatewaySyncStatus_mutation_response;
  /** delete single row from the table: "qx.Group" */
  deleteGroup?: qx_Group;
  /** delete data from the table: "qx.Group" */
  deleteGroups?: qx_Group_mutation_response;
  /** delete single row from the table: "qx.HolidaySet" */
  deleteHolidaySet?: qx_HolidaySet;
  /** delete single row from the table: "qx._HolidaySetToScheduleBlock" */
  deleteHolidaySetToScheduleBlock?: qx__HolidaySetToScheduleBlock;
  /** delete data from the table: "qx._HolidaySetToScheduleBlock" */
  deleteHolidaySetToScheduleBlocks?: qx__HolidaySetToScheduleBlock_mutation_response;
  /** delete data from the table: "qx.HolidaySet" */
  deleteHolidaySets?: qx_HolidaySet_mutation_response;
  /** delete single row from the table: "qx.InputPoint" */
  deleteInputPoint?: qx_InputPoint;
  /** delete data from the table: "qx.InputPoint" */
  deleteInputPoints?: qx_InputPoint_mutation_response;
  /** delete single row from the table: "qx.eKeypadMode" */
  deleteKeyModeEnum?: qx_eKeypadMode;
  /** delete data from the table: "qx.eKeypadMode" */
  deleteKeyModeEnums?: qx_eKeypadMode_mutation_response;
  /** delete single row from the table: "qx.Layout" */
  deleteLayout?: qx_Layout;
  /** delete data from the table: "qx.Layout" */
  deleteLayouts?: qx_Layout_mutation_response;
  /** delete single row from the table: "qx.LensProfile" */
  deleteLensProfile?: qx_LensProfile;
  /** delete data from the table: "qx.LensProfile" */
  deleteLensProfiles?: qx_LensProfile_mutation_response;
  /** delete single row from the table: "qx.Lock" */
  deleteLock?: qx_Lock;
  /** delete single row from the table: "qx.eLockPowerMonitor" */
  deleteLockPowerMonitorEnum?: qx_eLockPowerMonitor;
  /** delete data from the table: "qx.eLockPowerMonitor" */
  deleteLockPowerMonitorEnums?: qx_eLockPowerMonitor_mutation_response;
  /** delete single row from the table: "qx.eLockRelayMonitor" */
  deleteLockRelayMonitorEnum?: qx_eLockRelayMonitor;
  /** delete data from the table: "qx.eLockRelayMonitor" */
  deleteLockRelayMonitorEnums?: qx_eLockRelayMonitor_mutation_response;
  /** delete single row from the table: "qx.eLockType" */
  deleteLockTypeEnum?: qx_eLockType;
  /** delete data from the table: "qx.eLockType" */
  deleteLockTypeEnums?: qx_eLockType_mutation_response;
  /** delete data from the table: "qx.Lock" */
  deleteLocks?: qx_Lock_mutation_response;
  /** delete single row from the table: "qx.MediaProfile" */
  deleteMediaProfile?: qx_MediaProfile;
  /** delete data from the table: "qx.MediaProfile" */
  deleteMediaProfiles?: qx_MediaProfile_mutation_response;
  /** delete single row from the table: "qx.MercuryControlPoint" */
  deleteMercuryControlPoint?: qx_MercuryControlPoint;
  /** delete data from the table: "qx.MercuryControlPoint" */
  deleteMercuryControlPoints?: qx_MercuryControlPoint_mutation_response;
  /** delete single row from the table: "qx.MercuryMonitorPoint" */
  deleteMercuryMonitorPoint?: qx_MercuryMonitorPoint;
  /** delete data from the table: "qx.MercuryMonitorPoint" */
  deleteMercuryMonitorPoints?: qx_MercuryMonitorPoint_mutation_response;
  /** delete single row from the table: "qx.eMonitorLockState" */
  deleteMonitorLockStateEnum?: qx_eMonitorLockState;
  /** delete data from the table: "qx.eMonitorLockState" */
  deleteMonitorLockStateEnums?: qx_eMonitorLockState_mutation_response;
  /** delete single row from the table: "qx.eMountPosition" */
  deleteMountPositionEnum?: qx_eMountPosition;
  /** delete data from the table: "qx.eMountPosition" */
  deleteMountPositionEnums?: qx_eMountPosition_mutation_response;
  /** delete single row from the table: "qx.eObjectAction" */
  deleteObjectActionEnum?: qx_eObjectAction;
  /** delete data from the table: "qx.eObjectAction" */
  deleteObjectActionEnums?: qx_eObjectAction_mutation_response;
  /** delete single row from the table: "qx.OssIdAssignment" */
  deleteOssIdAssignment?: qx_OssIdAssignment;
  /** delete data from the table: "qx.OssIdAssignment" */
  deleteOssIdAssignments?: qx_OssIdAssignment_mutation_response;
  /** delete single row from the table: "qx.OutputPoint" */
  deleteOutputPoint?: qx_OutputPoint;
  /** delete data from the table: "qx.OutputPoint" */
  deleteOutputPoints?: qx_OutputPoint_mutation_response;
  /** delete single row from the table: "qx.ePACSStatus" */
  deletePACSStatusEnum?: qx_ePACSStatus;
  /** delete data from the table: "qx.ePACSStatus" */
  deletePACSStatusEnums?: qx_ePACSStatus_mutation_response;
  /** delete data from the table: "qx.Person" */
  deletePeople?: qx_Person_mutation_response;
  /** delete single row from the table: "qx.Permission" */
  deletePermission?: qx_Permission;
  /** delete data from the table: "qx.Permission" */
  deletePermissions?: qx_Permission_mutation_response;
  /** delete single row from the table: "qx.Person" */
  deletePerson?: qx_Person;
  /** delete single row from the table: "qx._PersonToGroup" */
  deletePersonGroup?: qx__PersonToGroup;
  /** delete data from the table: "qx._PersonToGroup" */
  deletePersonGroups?: qx__PersonToGroup_mutation_response;
  /** delete single row from the table: "qx.ePersonStatus" */
  deletePersonStatusEnum?: qx_ePersonStatus;
  /** delete data from the table: "qx.ePersonStatus" */
  deletePersonStatusEnums?: qx_ePersonStatus_mutation_response;
  /** delete single row from the table: "qx.Place" */
  deletePlace?: qx_Place;
  /** delete single row from the table: "qx.ePlaceType" */
  deletePlaceTypeEnum?: qx_ePlaceType;
  /** delete data from the table: "qx.ePlaceType" */
  deletePlaceTypeEnums?: qx_ePlaceType_mutation_response;
  /** delete data from the table: "qx.Place" */
  deletePlaces?: qx_Place_mutation_response;
  /** delete single row from the table: "qx.ePrivilege" */
  deletePrivilegeEnum?: qx_ePrivilege;
  /** delete single row from the table: "qx._PrivilegeEnumToRole" */
  deletePrivilegeEnumToRole?: qx__PrivilegeEnumToRole;
  /** delete data from the table: "qx._PrivilegeEnumToRole" */
  deletePrivilegeEnumToRoles?: qx__PrivilegeEnumToRole_mutation_response;
  /** delete data from the table: "qx.ePrivilege" */
  deletePrivilegeEnums?: qx_ePrivilege_mutation_response;
  /** delete single row from the table: "qx.Reader" */
  deleteReader?: qx_Reader;
  /** delete single row from the table: "qx.eReaderAccessType" */
  deleteReaderAccessTypeEnum?: qx_eReaderAccessType;
  /** delete data from the table: "qx.eReaderAccessType" */
  deleteReaderAccessTypeEnums?: qx_eReaderAccessType_mutation_response;
  /** delete single row from the table: "qx.eReaderProtocol" */
  deleteReaderProtocolEnum?: qx_eReaderProtocol;
  /** delete data from the table: "qx.eReaderProtocol" */
  deleteReaderProtocolEnums?: qx_eReaderProtocol_mutation_response;
  /** delete data from the table: "qx.Reader" */
  deleteReaders?: qx_Reader_mutation_response;
  /** delete single row from the table: "qx.eRexState" */
  deleteRexStateEnum?: qx_eRexState;
  /** delete data from the table: "qx.eRexState" */
  deleteRexStateEnums?: qx_eRexState_mutation_response;
  /** delete single row from the table: "qx.Role" */
  deleteRole?: qx_Role;
  /** delete data from the table: "qx.Role" */
  deleteRoles?: qx_Role_mutation_response;
  /** delete single row from the table: "qx.RosslareConnection" */
  deleteRosslareConnection?: qx_RosslareConnection;
  /** delete data from the table: "qx.RosslareConnection" */
  deleteRosslareConnections?: qx_RosslareConnection_mutation_response;
  /** delete single row from the table: "qx.Schedule" */
  deleteSchedule?: qx_Schedule;
  /** delete single row from the table: "qx.ScheduleBlock" */
  deleteScheduleBlock?: qx_ScheduleBlock;
  /** delete data from the table: "qx.ScheduleBlock" */
  deleteScheduleBlocks?: qx_ScheduleBlock_mutation_response;
  /** delete data from the table: "qx.Schedule" */
  deleteSchedules?: qx_Schedule_mutation_response;
  /** delete single row from the table: "qx.Segment" */
  deleteSegment?: qx_Segment;
  /** delete data from the table: "qx.Segment" */
  deleteSegments?: qx_Segment_mutation_response;
  /** delete single row from the table: "qx.Sensor" */
  deleteSensor?: qx_Sensor;
  /** delete single row from the table: "qx.eSensorAction" */
  deleteSensorActionEnum?: qx_eSensorAction;
  /** delete data from the table: "qx.eSensorAction" */
  deleteSensorActionEnums?: qx_eSensorAction_mutation_response;
  /** delete single row from the table: "qx.eSensorType" */
  deleteSensorTypeEnum?: qx_eSensorType;
  /** delete data from the table: "qx.eSensorType" */
  deleteSensorTypeEnums?: qx_eSensorType_mutation_response;
  /** delete data from the table: "qx.Sensor" */
  deleteSensors?: qx_Sensor_mutation_response;
  /** delete single row from the table: "qx.SharedLinks" */
  deleteSharedLink?: qx_SharedLinks;
  /** delete data from the table: "qx.SharedLinks" */
  deleteSharedLinks?: qx_SharedLinks_mutation_response;
  /** delete single row from the table: "qx.Snapshot" */
  deleteSnapshot?: qx_Snapshot;
  /** delete data from the table: "qx.Snapshot" */
  deleteSnapshots?: qx_Snapshot_mutation_response;
  /** delete single row from the table: "qx.eStreamStatus" */
  deleteStreamStatusEnum?: qx_eStreamStatus;
  /** delete data from the table: "qx.eStreamStatus" */
  deleteStreamStatusEnums?: qx_eStreamStatus_mutation_response;
  /** delete single row from the table: "qx.eSuperviseInputs" */
  deleteSuperviseInputsEnum?: qx_eSuperviseInputs;
  /** delete data from the table: "qx.eSuperviseInputs" */
  deleteSuperviseInputsEnums?: qx_eSuperviseInputs_mutation_response;
  /** delete single row from the table: "qx.TermsAgreement" */
  deleteTermsAgreement?: qx_TermsAgreement;
  /** delete data from the table: "qx.TermsAgreement" */
  deleteTermsAgreements?: qx_TermsAgreement_mutation_response;
  /** delete single row from the table: "qx.TimeZone" */
  deleteTimeZone?: qx_TimeZone;
  /** delete data from the table: "qx.TimeZone" */
  deleteTimeZones?: qx_TimeZone_mutation_response;
  /** delete single row from the table: "qx.UserSetting" */
  deleteUserSetting?: qx_UserSetting;
  /** delete data from the table: "qx.UserSetting" */
  deleteUserSettings?: qx_UserSetting_mutation_response;
  /** delete single row from the table: "qx.VideoSource" */
  deleteVideoSource?: qx_VideoSource;
  /** delete data from the table: "qx.VideoSource" */
  deleteVideoSources?: qx_VideoSource_mutation_response;
  /** delete single row from the table: "qx.View" */
  deleteView?: qx_View;
  /** delete data from the table: "qx.View" */
  deleteViews?: qx_View_mutation_response;
  /** delete single row from the table: "qx.WiegandCardFormat" */
  deleteWiegandCardFormat?: qx_WiegandCardFormat;
  /** delete data from the table: "qx.WiegandCardFormat" */
  deleteWiegandCardFormats?: qx_WiegandCardFormat_mutation_response;
  /** delete data from the table: "analytics.AnalyticSource" */
  delete_AnalyticSources?: AnalyticSources_mutation_response;
  /** delete single row from the table: "analytics.AnalyticSource" */
  delete_AnalyticSources_by_pk?: AnalyticSources;
  /** delete data from the table: "qx.ApplicationUserGatewayPassword" */
  delete_ApplicationUserGatewayPassword?: ApplicationUserGatewayPassword_mutation_response;
  /** delete single row from the table: "qx.ApplicationUserGatewayPassword" */
  delete_ApplicationUserGatewayPassword_by_pk?: ApplicationUserGatewayPassword;
  /** delete data from the table: "qx.ApplicationUserTwoFactor" */
  delete_ApplicationUserTwoFactor?: ApplicationUserTwoFactor_mutation_response;
  /** delete single row from the table: "qx.ApplicationUserTwoFactor" */
  delete_ApplicationUserTwoFactor_by_pk?: ApplicationUserTwoFactor;
  /** delete data from the table: "qx.DSCConnection" */
  delete_DSCConnection?: DSCConnection_mutation_response;
  /** delete single row from the table: "qx.DSCConnection" */
  delete_DSCConnection_by_pk?: DSCConnection;
  /** delete data from the table: "qx.IntrusionAccessCode" */
  delete_IntrusionAccessCode?: IntrusionAccessCode_mutation_response;
  /** delete single row from the table: "qx.IntrusionAccessCode" */
  delete_IntrusionAccessCode_by_pk?: IntrusionAccessCode;
  /** delete data from the table: "qx.IntrusionPartition" */
  delete_IntrusionPartition?: IntrusionPartition_mutation_response;
  /** delete single row from the table: "qx.IntrusionPartition" */
  delete_IntrusionPartition_by_pk?: IntrusionPartition;
  /** delete data from the table: "qx.IntrusionZone" */
  delete_IntrusionZone?: IntrusionZone_mutation_response;
  /** delete single row from the table: "qx.IntrusionZone" */
  delete_IntrusionZone_by_pk?: IntrusionZone;
  /** delete data from the table: "qx.PartitionZoneAssignments" */
  delete_PartitionZoneAssignments?: PartitionZoneAssignments_mutation_response;
  /** delete single row from the table: "qx.PartitionZoneAssignments" */
  delete_PartitionZoneAssignments_by_pk?: PartitionZoneAssignments;
  /** delete data from the table: "qx.PassKeyProvider" */
  delete_PassKeyProvider?: PassKeyProvider_mutation_response;
  /** delete single row from the table: "qx.PassKeyProvider" */
  delete_PassKeyProvider_by_pk?: PassKeyProvider;
  /** delete data from the table: "qx.PermissionPartitionAssignments" */
  delete_PermissionPartitionAssignments?: PermissionPartitionAssignments_mutation_response;
  /** delete single row from the table: "qx.PermissionPartitionAssignments" */
  delete_PermissionPartitionAssignments_by_pk?: PermissionPartitionAssignments;
  /** delete data from the table: "qx.PersonTermsAgreement" */
  delete_PersonTermsAgreement?: PersonTermsAgreement_mutation_response;
  /** delete single row from the table: "qx.PersonTermsAgreement" */
  delete_PersonTermsAgreement_by_pk?: PersonTermsAgreement;
  /** delete data from the table: "analytics.AnalyticAttributeProperty" */
  delete_analyticAttributeProperties?: analyticAttributeProperties_mutation_response;
  /** delete single row from the table: "analytics.AnalyticAttributeProperty" */
  delete_analyticAttributeProperties_by_pk?: analyticAttributeProperties;
  /** delete data from the table: "analytics.AnalyticAttribute" */
  delete_analyticAttributes?: analyticAttributes_mutation_response;
  /** delete single row from the table: "analytics.AnalyticAttribute" */
  delete_analyticAttributes_by_pk?: analyticAttributes;
  /** delete data from the table: "analytics.AnalyticPropertyDetected" */
  delete_analyticDetectedProperties?: analyticDetectedProperties_mutation_response;
  /** delete single row from the table: "analytics.AnalyticPropertyDetected" */
  delete_analyticDetectedProperties_by_pk?: analyticDetectedProperties;
  /** delete data from the table: "analytics.AnalyticType" */
  delete_analyticTypes?: analyticTypes_mutation_response;
  /** delete single row from the table: "analytics.AnalyticType" */
  delete_analyticTypes_by_pk?: analyticTypes;
  /** delete data from the table: "analytics.Analytic" */
  delete_analytics?: analytics_mutation_response;
  /** delete single row from the table: "analytics.Analytic" */
  delete_analytics_by_pk?: analytics;
  /** delete data from the table: "qx.ApplicationUserAppPassword" */
  delete_applicationUserAppPasswords?: applicationUserAppPasswords_mutation_response;
  /** delete single row from the table: "qx.ApplicationUserAppPassword" */
  delete_applicationUserAppPasswords_by_pk?: applicationUserAppPasswords;
  /** delete data from the table: "qx.ApplicationUserDevice" */
  delete_applicationUserDevices?: applicationUserDevices_mutation_response;
  /** delete single row from the table: "qx.ApplicationUserDevice" */
  delete_applicationUserDevices_by_pk?: applicationUserDevices;
  /** delete data from the table: "analytics.AttributeProperty" */
  delete_attributeProperties?: attributeProperties_mutation_response;
  /** delete single row from the table: "analytics.AttributeProperty" */
  delete_attributeProperties_by_pk?: attributeProperties;
  /** delete data from the table: "analytics.Attribute" */
  delete_attributes?: attributes_mutation_response;
  /** delete single row from the table: "analytics.Attribute" */
  delete_attributes_by_pk?: attributes;
  /** delete data from the table: "audit.vAudioSourceAudit" */
  delete_audioSourceAudit?: audioSourceAudit_mutation_response;
  /** delete data from the table: "audit.logged_actions" */
  delete_audit_logged_actions?: audit_logged_actions_mutation_response;
  /** delete single row from the table: "audit.logged_actions" */
  delete_audit_logged_actions_by_pk?: audit_logged_actions;
  /** delete data from the table: "audit.vSensorAudit" */
  delete_audit_vSensorAudit?: audit_vSensorAudit_mutation_response;
  /** delete data from the table: "qx.CloudStorageTimelapseOptions" */
  delete_cloudStorageTimelapseOptions?: cloudStorageTimelapseOptions_mutation_response;
  /** delete single row from the table: "qx.CloudStorageTimelapseOptions" */
  delete_cloudStorageTimelapseOptions_by_pk?: cloudStorageTimelapseOptions;
  /** delete data from the table: "audit.vCredentialAudit" */
  delete_credentialAudit?: credentialAudit_mutation_response;
  /** delete data from the table: "audit.vCustomerPermissionAudit" */
  delete_customerPermissionAudit?: customerPermissionAudit_mutation_response;
  /** delete data from the table: "qx.DeviceAnalyticSource" */
  delete_deviceAnalyticSource?: deviceAnalyticSource_mutation_response;
  /** delete single row from the table: "qx.DeviceAnalyticSource" */
  delete_deviceAnalyticSource_by_pk?: deviceAnalyticSource;
  /** delete data from the table: "audit.vDeviceAudit" */
  delete_deviceAudit?: deviceAudit_mutation_response;
  /** delete data from the table: "audit.vDeviceDIOAudit" */
  delete_deviceDIOAudit?: deviceDIOAudit_mutation_response;
  /** delete data from the table: "audit.vDoorAudit" */
  delete_doorAudit?: doorAudit_mutation_response;
  /** delete data from the table: "analytics.eAnalyticIntegration" */
  delete_eAnalyticIntegrations?: eAnalyticIntegrations_mutation_response;
  /** delete single row from the table: "analytics.eAnalyticIntegration" */
  delete_eAnalyticIntegrations_by_pk?: eAnalyticIntegrations;
  /** delete data from the table: "analytics.eAnalyticState" */
  delete_eAnalyticStates?: eAnalyticStates_mutation_response;
  /** delete single row from the table: "analytics.eAnalyticState" */
  delete_eAnalyticStates_by_pk?: eAnalyticStates;
  /** delete data from the table: "qx.eGatewayType" */
  delete_eGatewayType?: eGatewayType_mutation_response;
  /** delete single row from the table: "qx.eGatewayType" */
  delete_eGatewayType_by_pk?: eGatewayType;
  /** delete data from the table: "qx.eS3BucketType" */
  delete_eS3BucketType?: eS3BucketType_mutation_response;
  /** delete single row from the table: "qx.eS3BucketType" */
  delete_eS3BucketType_by_pk?: eS3BucketType;
  /** delete data from the table: "audit.vFlowAudit" */
  delete_flowAudit?: flowAudit_mutation_response;
  /** delete data from the table: "audit.vGatewayAudit" */
  delete_gatewayAudit?: gatewayAudit_mutation_response;
  /** delete data from the table: "audit.vGatewayBandwidthScheduleAudit" */
  delete_gatewayBandwidthScheduleAudit?: gatewayBandwidthScheduleAudit_mutation_response;
  /** delete data from the table: "audit.vGroupAudit" */
  delete_groupAudit?: groupAudit_mutation_response;
  /** delete data from the table: "qx.GuestAccess" */
  delete_guestAccess?: guestAccess_mutation_response;
  /** delete single row from the table: "qx.GuestAccess" */
  delete_guestAccess_by_pk?: guestAccess;
  /** delete data from the table: "audit.vHolidaySetAudit" */
  delete_holidaySetAudit?: holidaySetAudit_mutation_response;
  /** delete data from the table: "audit.v_HolidaySetToScheduleBlockAudit" */
  delete_holidaySetToScheduleBlockAudit?: holidaySetToScheduleBlockAudit_mutation_response;
  /** delete data from the table: "audit.vInputPointAudit" */
  delete_inputPointAudit?: inputPointAudit_mutation_response;
  /** delete data from the table: "audit.vLockAudit" */
  delete_lockAudit?: lockAudit_mutation_response;
  /** delete data from the table: "audit.vMediaProfileAudit" */
  delete_mediaProfileAudit?: mediaProfileAudit_mutation_response;
  /** delete data from the table: "audit.vOutputPointAudit" */
  delete_outputPointAudit?: outputPointAudit_mutation_response;
  /** delete data from the table: "audit.vPermissionAudit" */
  delete_permissionAudit?: permissionAudit_mutation_response;
  /** delete data from the table: "audit.vPersonAudit" */
  delete_personAudit?: personAudit_mutation_response;
  /** delete data from the table: "qx.PersonDeviceAppPrivileges" */
  delete_personDeviceAppPrivileges?: personDeviceAppPrivileges_mutation_response;
  /** delete single row from the table: "qx.PersonDeviceAppPrivileges" */
  delete_personDeviceAppPrivileges_by_pk?: personDeviceAppPrivileges;
  /** delete data from the table: "qx.PersonDoorAppPrivileges" */
  delete_personDoorAppPrivileges?: personDoorAppPrivileges_mutation_response;
  /** delete single row from the table: "qx.PersonDoorAppPrivileges" */
  delete_personDoorAppPrivileges_by_pk?: personDoorAppPrivileges;
  /** delete data from the table: "qx.PersonIntrusionPartitionAppPrivileges" */
  delete_personIntrusionPartitionAppPrivileges?: personIntrusionPartitionAppPrivileges_mutation_response;
  /** delete single row from the table: "qx.PersonIntrusionPartitionAppPrivileges" */
  delete_personIntrusionPartitionAppPrivileges_by_pk?: personIntrusionPartitionAppPrivileges;
  /** delete data from the table: "qx.PersonPlaceAppPrivileges" */
  delete_personPlaceAppPrivileges?: personPlaceAppPrivileges_mutation_response;
  /** delete single row from the table: "qx.PersonPlaceAppPrivileges" */
  delete_personPlaceAppPrivileges_by_pk?: personPlaceAppPrivileges;
  /** delete data from the table: "audit.v_PersonToGroupAudit" */
  delete_personToGroupAudit?: personToGroupAudit_mutation_response;
  /** delete data from the table: "qx.PersonVideoSourceAppPrivileges" */
  delete_personVideoSourceAppPrivileges?: personVideoSourceAppPrivileges_mutation_response;
  /** delete single row from the table: "qx.PersonVideoSourceAppPrivileges" */
  delete_personVideoSourceAppPrivileges_by_pk?: personVideoSourceAppPrivileges;
  /** delete data from the table: "audit.vPlaceAudit" */
  delete_placeAudit?: placeAudit_mutation_response;
  /** delete data from the table: "qx.PlaceWhitelist" */
  delete_placeWhiteLists?: placeWhiteLists_mutation_response;
  /** delete single row from the table: "qx.PlaceWhitelist" */
  delete_placeWhiteLists_by_pk?: placeWhiteLists;
  /** delete data from the table: "audit.v_PrivilegeEnumToRoleAudit" */
  delete_privilegeEnumToRoleAudit?: privilegeEnumToRoleAudit_mutation_response;
  /** delete data from the table: "qx.AccessCatalogCapabilities" */
  delete_qx_AccessCatalogCapabilities?: qx_AccessCatalogCapabilities_mutation_response;
  /** delete single row from the table: "qx.AccessCatalogCapabilities" */
  delete_qx_AccessCatalogCapabilities_by_pk?: qx_AccessCatalogCapabilities;
  /** delete data from the table: "qx.AuditLog" */
  delete_qx_AuditLog?: qx_AuditLog_mutation_response;
  /** delete single row from the table: "qx.AuditLog" */
  delete_qx_AuditLog_by_pk?: qx_AuditLog;
  /** delete data from the table: "qx.AuditableAction" */
  delete_qx_AuditableAction?: qx_AuditableAction_mutation_response;
  /** delete single row from the table: "qx.AuditableAction" */
  delete_qx_AuditableAction_by_pk?: qx_AuditableAction;
  /** delete data from the table: "qx.AuditableType" */
  delete_qx_AuditableType?: qx_AuditableType_mutation_response;
  /** delete single row from the table: "qx.AuditableType" */
  delete_qx_AuditableType_by_pk?: qx_AuditableType;
  /** delete data from the table: "qx.BillingPeriod" */
  delete_qx_BillingPeriod?: qx_BillingPeriod_mutation_response;
  /** delete data from the table: "qx.CatalogProtocolOverride" */
  delete_qx_CatalogProtocolOverride?: qx_CatalogProtocolOverride_mutation_response;
  /** delete single row from the table: "qx.CatalogProtocolOverride" */
  delete_qx_CatalogProtocolOverride_by_pk?: qx_CatalogProtocolOverride;
  /** delete data from the table: "qx.ClipAuditLog" */
  delete_qx_ClipAuditLog?: qx_ClipAuditLog_mutation_response;
  /** delete single row from the table: "qx.Clip" */
  delete_qx_Clip_by_pk?: qx_Clip;
  /** delete data from the table: "qx.CloudStorageOptions" */
  delete_qx_CloudStorageOptions?: qx_CloudStorageOptions_mutation_response;
  /** delete data from the table: "qx.CustomerAuthProvider" */
  delete_qx_CustomerAuthProvider?: qx_CustomerAuthProvider_mutation_response;
  /** delete single row from the table: "qx.CustomerAuthProvider" */
  delete_qx_CustomerAuthProvider_by_pk?: qx_CustomerAuthProvider;
  /** delete data from the table: "qx.DiscoveryType" */
  delete_qx_DiscoveryType?: qx_DiscoveryType_mutation_response;
  /** delete single row from the table: "qx.DiscoveryType" */
  delete_qx_DiscoveryType_by_pk?: qx_DiscoveryType;
  /** delete single row from the table: "qx.EventType" */
  delete_qx_EventType_by_pk?: qx_EventType;
  /** delete data from the table: "qx.IntrusionAlarm" */
  delete_qx_IntrusionAlarm?: qx_IntrusionAlarm_mutation_response;
  /** delete single row from the table: "qx.IntrusionAlarm" */
  delete_qx_IntrusionAlarm_by_pk?: qx_IntrusionAlarm;
  /** delete data from the table: "qx.IntrusionPartitionState" */
  delete_qx_IntrusionPartitionState?: qx_IntrusionPartitionState_mutation_response;
  /** delete single row from the table: "qx.IntrusionPartitionState" */
  delete_qx_IntrusionPartitionState_by_pk?: qx_IntrusionPartitionState;
  /** delete data from the table: "qx.IntrusionZoneState" */
  delete_qx_IntrusionZoneState?: qx_IntrusionZoneState_mutation_response;
  /** delete single row from the table: "qx.IntrusionZoneState" */
  delete_qx_IntrusionZoneState_by_pk?: qx_IntrusionZoneState;
  /** delete data from the table: "qx.MediaProfileRecording" */
  delete_qx_MediaProfileRecording?: qx_MediaProfileRecording_mutation_response;
  /** delete single row from the table: "qx.MediaProfileRecording" */
  delete_qx_MediaProfileRecording_by_pk?: qx_MediaProfileRecording;
  /** delete data from the table: "qx.OssKey" */
  delete_qx_OssKey?: qx_OssKey_mutation_response;
  /** delete single row from the table: "qx.OssKey" */
  delete_qx_OssKey_by_pk?: qx_OssKey;
  /** delete data from the table: "qx.SharedLinkAuditLog" */
  delete_qx_SharedLinkAuditLog?: qx_SharedLinkAuditLog_mutation_response;
  /** delete data from the table: "qx.SharedLinkType" */
  delete_qx_SharedLinkType?: qx_SharedLinkType_mutation_response;
  /** delete single row from the table: "qx.SharedLinkType" */
  delete_qx_SharedLinkType_by_pk?: qx_SharedLinkType;
  /** delete data from the table: "qx.VideoSourceStorageAudit" */
  delete_qx_VideoSourceStorageAudit?: qx_VideoSourceStorageAudit_mutation_response;
  /** delete single row from the table: "qx.VideoSourceStorageAudit" */
  delete_qx_VideoSourceStorageAudit_by_pk?: qx_VideoSourceStorageAudit;
  /** delete data from the table: "qx.eAccessMake" */
  delete_qx_eAccessMake?: qx_eAccessMake_mutation_response;
  /** delete single row from the table: "qx.eAccessMake" */
  delete_qx_eAccessMake_by_pk?: qx_eAccessMake;
  /** delete data from the table: "qx.eAppPrivilegeType" */
  delete_qx_eAppPrivilegeType?: qx_eAppPrivilegeType_mutation_response;
  /** delete single row from the table: "qx.eAppPrivilegeType" */
  delete_qx_eAppPrivilegeType_by_pk?: qx_eAppPrivilegeType;
  /** delete data from the table: "qx.eAuthProvider" */
  delete_qx_eAuthProvider?: qx_eAuthProvider_mutation_response;
  /** delete single row from the table: "qx.eAuthProvider" */
  delete_qx_eAuthProvider_by_pk?: qx_eAuthProvider;
  /** delete data from the table: "qx.eFlowStatus" */
  delete_qx_eFlowStatus?: qx_eFlowStatus_mutation_response;
  /** delete single row from the table: "qx.eFlowStatus" */
  delete_qx_eFlowStatus_by_pk?: qx_eFlowStatus;
  /** delete data from the table: "qx.eFlowTraceActionStatus" */
  delete_qx_eFlowTraceActionStatus?: qx_eFlowTraceActionStatus_mutation_response;
  /** delete single row from the table: "qx.eFlowTraceActionStatus" */
  delete_qx_eFlowTraceActionStatus_by_pk?: qx_eFlowTraceActionStatus;
  /** delete data from the table: "qx.eFlowTraceState" */
  delete_qx_eFlowTraceState?: qx_eFlowTraceState_mutation_response;
  /** delete single row from the table: "qx.eFlowTraceState" */
  delete_qx_eFlowTraceState_by_pk?: qx_eFlowTraceState;
  /** delete data from the table: "qx.eIntrusionZoneType" */
  delete_qx_eIntrusionZoneType?: qx_eIntrusionZoneType_mutation_response;
  /** delete single row from the table: "qx.eIntrusionZoneType" */
  delete_qx_eIntrusionZoneType_by_pk?: qx_eIntrusionZoneType;
  /** delete data from the table: "qx.eLockMode" */
  delete_qx_eLockMode?: qx_eLockMode_mutation_response;
  /** delete single row from the table: "qx.eLockMode" */
  delete_qx_eLockMode_by_pk?: qx_eLockMode;
  /** delete data from the table: "qx.eMercuryMonitorPointLatchModes" */
  delete_qx_eMercuryMonitorPointLatchModes?: qx_eMercuryMonitorPointLatchModes_mutation_response;
  /** delete single row from the table: "qx.eMercuryMonitorPointLatchModes" */
  delete_qx_eMercuryMonitorPointLatchModes_by_pk?: qx_eMercuryMonitorPointLatchModes;
  /** delete data from the table: "qx.vPlacePrivilege" */
  delete_qx_vPlacePrivilege?: qx_vPlacePrivilege_mutation_response;
  /** delete data from the table: "qx.vProfiles" */
  delete_qx_vProfiles?: qx_vProfiles_mutation_response;
  /** delete data from the table: "qxanalytics.CloudUsage" */
  delete_qxanalytics_CloudUsage?: qxanalytics_CloudUsage_mutation_response;
  /** delete data from the table: "qx.ReaderAccessTypeCompatibility" */
  delete_readerAccessTypeCompatibility?: readerAccessTypeCompatibility_mutation_response;
  /** delete single row from the table: "qx.ReaderAccessTypeCompatibility" */
  delete_readerAccessTypeCompatibility_by_pk?: readerAccessTypeCompatibility;
  /** delete data from the table: "audit.vReaderAudit" */
  delete_readerAudit?: readerAudit_mutation_response;
  /** delete data from the table: "qx.ReaderProtocolCompatibility" */
  delete_readerProtocolCompatibility?: readerProtocolCompatibility_mutation_response;
  /** delete single row from the table: "qx.ReaderProtocolCompatibility" */
  delete_readerProtocolCompatibility_by_pk?: readerProtocolCompatibility;
  /** delete data from the table: "qx.RoleAppPrivileges" */
  delete_roleAppPrivileges?: roleAppPrivileges_mutation_response;
  /** delete single row from the table: "qx.RoleAppPrivileges" */
  delete_roleAppPrivileges_by_pk?: roleAppPrivileges;
  /** delete data from the table: "audit.vRoleAudit" */
  delete_roleAudit?: roleAudit_mutation_response;
  /** delete data from the table: "qx.RosslareCatalog" */
  delete_rosslareCatalogs?: rosslareCatalogs_mutation_response;
  /** delete single row from the table: "qx.RosslareCatalog" */
  delete_rosslareCatalogs_by_pk?: rosslareCatalogs;
  /** delete data from the table: "qx.S3BucketConfiguration" */
  delete_s3BucketConfigurations?: s3BucketConfigurations_mutation_response;
  /** delete single row from the table: "qx.S3BucketConfiguration" */
  delete_s3BucketConfigurations_by_pk?: s3BucketConfigurations;
  /** delete data from the table: "audit.vScheduleAudit" */
  delete_scheduleAudit?: scheduleAudit_mutation_response;
  /** delete data from the table: "audit.vScheduleBlockAudit" */
  delete_scheduleBlockAudit?: scheduleBlockAudit_mutation_response;
  /** delete data from the table: "qx.SuperviseInputCompatibility" */
  delete_superviseInputCompatibility?: superviseInputCompatibility_mutation_response;
  /** delete single row from the table: "qx.SuperviseInputCompatibility" */
  delete_superviseInputCompatibility_by_pk?: superviseInputCompatibility;
  /** delete data from the table: "audit.vVideoSourceAudit" */
  delete_videoSourceAudit?: videoSourceAudit_mutation_response;
  /** delete data from the table: "qx.VideoSourceState" */
  delete_videoSourceState?: videoSourceState_mutation_response;
  /** delete single row from the table: "qx.VideoSourceState" */
  delete_videoSourceState_by_pk?: videoSourceState;
  detachDevice: SuccessOutput;
  doorStates: SuccessOutput;
  doorStatesPlace: SuccessOutput;
  doubleLockDoor: SuccessOutput;
  flow_accessDoor: SuccessOutput;
  flow_awayArmPartition: SuccessOutput;
  flow_bypassZone: SuccessOutput;
  flow_disarmPartition: SuccessOutput;
  flow_email_notification: SuccessOutput;
  flow_lockDoor: SuccessOutput;
  flow_lockDownDoor: SuccessOutput;
  flow_lockDownPlace: SuccessOutput;
  flow_ptzMoveToPreset: SuccessOutput;
  flow_releaseLockDownDoor: SuccessOutput;
  flow_releaseLockDownPlace: SuccessOutput;
  flow_resetOutput: SuccessOutput;
  flow_revertDoor: SuccessOutput;
  /** {"environments":["cloud"]} */
  flow_sms_notification: SuccessOutput;
  flow_stayArmPartition: SuccessOutput;
  flow_triggerOutput: SuccessOutput;
  flow_unlockDoor: SuccessOutput;
  flow_webhook: SuccessOutput;
  generateTwoFactorBackupCodes: BackupCodes;
  getClipUrl: ClipUrlOutput;
  getDownloadAccessReportUrl: AccessReportUrlOutput;
  getDownloadClipUrl: ClipUrlOutput;
  /** insert a single row into the table: "qx.AuditLog" */
  insertAuditLog?: qx_AuditLog;
  /** insert data into the table: "qx.AuditLog" */
  insertAuditLogs?: qx_AuditLog_mutation_response;
  /** insert a single row into the table: "qx.SharedLinks" */
  insertSharedLink?: qx_SharedLinks;
  /** insert data into the table: "qx.SharedLinks" */
  insertSharedLinks?: qx_SharedLinks_mutation_response;
  /** insert data into the table: "analytics.AnalyticSource" */
  insert_AnalyticSources?: AnalyticSources_mutation_response;
  /** insert a single row into the table: "analytics.AnalyticSource" */
  insert_AnalyticSources_one?: AnalyticSources;
  /** insert data into the table: "qx.ApplicationUserGatewayPassword" */
  insert_ApplicationUserGatewayPassword?: ApplicationUserGatewayPassword_mutation_response;
  /** insert a single row into the table: "qx.ApplicationUserGatewayPassword" */
  insert_ApplicationUserGatewayPassword_one?: ApplicationUserGatewayPassword;
  /** insert data into the table: "qx.ApplicationUserTwoFactor" */
  insert_ApplicationUserTwoFactor?: ApplicationUserTwoFactor_mutation_response;
  /** insert a single row into the table: "qx.ApplicationUserTwoFactor" */
  insert_ApplicationUserTwoFactor_one?: ApplicationUserTwoFactor;
  /** insert data into the table: "qx.DSCConnection" */
  insert_DSCConnection?: DSCConnection_mutation_response;
  /** insert a single row into the table: "qx.DSCConnection" */
  insert_DSCConnection_one?: DSCConnection;
  /** insert data into the table: "qx.IntrusionAccessCode" */
  insert_IntrusionAccessCode?: IntrusionAccessCode_mutation_response;
  /** insert a single row into the table: "qx.IntrusionAccessCode" */
  insert_IntrusionAccessCode_one?: IntrusionAccessCode;
  /** insert data into the table: "qx.IntrusionPartition" */
  insert_IntrusionPartition?: IntrusionPartition_mutation_response;
  /** insert a single row into the table: "qx.IntrusionPartition" */
  insert_IntrusionPartition_one?: IntrusionPartition;
  /** insert data into the table: "qx.IntrusionZone" */
  insert_IntrusionZone?: IntrusionZone_mutation_response;
  /** insert a single row into the table: "qx.IntrusionZone" */
  insert_IntrusionZone_one?: IntrusionZone;
  /** insert data into the table: "qx.PartitionZoneAssignments" */
  insert_PartitionZoneAssignments?: PartitionZoneAssignments_mutation_response;
  /** insert a single row into the table: "qx.PartitionZoneAssignments" */
  insert_PartitionZoneAssignments_one?: PartitionZoneAssignments;
  /** insert data into the table: "qx.PassKeyProvider" */
  insert_PassKeyProvider?: PassKeyProvider_mutation_response;
  /** insert a single row into the table: "qx.PassKeyProvider" */
  insert_PassKeyProvider_one?: PassKeyProvider;
  /** insert data into the table: "qx.PermissionPartitionAssignments" */
  insert_PermissionPartitionAssignments?: PermissionPartitionAssignments_mutation_response;
  /** insert a single row into the table: "qx.PermissionPartitionAssignments" */
  insert_PermissionPartitionAssignments_one?: PermissionPartitionAssignments;
  /** insert data into the table: "qx.PersonTermsAgreement" */
  insert_PersonTermsAgreement?: PersonTermsAgreement_mutation_response;
  /** insert a single row into the table: "qx.PersonTermsAgreement" */
  insert_PersonTermsAgreement_one?: PersonTermsAgreement;
  /** insert data into the table: "analytics.AnalyticAttributeProperty" */
  insert_analyticAttributeProperties?: analyticAttributeProperties_mutation_response;
  /** insert a single row into the table: "analytics.AnalyticAttributeProperty" */
  insert_analyticAttributeProperties_one?: analyticAttributeProperties;
  /** insert data into the table: "analytics.AnalyticAttribute" */
  insert_analyticAttributes?: analyticAttributes_mutation_response;
  /** insert a single row into the table: "analytics.AnalyticAttribute" */
  insert_analyticAttributes_one?: analyticAttributes;
  /** insert data into the table: "analytics.AnalyticPropertyDetected" */
  insert_analyticDetectedProperties?: analyticDetectedProperties_mutation_response;
  /** insert a single row into the table: "analytics.AnalyticPropertyDetected" */
  insert_analyticDetectedProperties_one?: analyticDetectedProperties;
  /** insert data into the table: "analytics.AnalyticType" */
  insert_analyticTypes?: analyticTypes_mutation_response;
  /** insert a single row into the table: "analytics.AnalyticType" */
  insert_analyticTypes_one?: analyticTypes;
  /** insert data into the table: "analytics.Analytic" */
  insert_analytics?: analytics_mutation_response;
  /** insert a single row into the table: "analytics.Analytic" */
  insert_analytics_one?: analytics;
  /** insert data into the table: "qx.ApplicationUserAppPassword" */
  insert_applicationUserAppPasswords?: applicationUserAppPasswords_mutation_response;
  /** insert a single row into the table: "qx.ApplicationUserAppPassword" */
  insert_applicationUserAppPasswords_one?: applicationUserAppPasswords;
  /** insert data into the table: "qx.ApplicationUserDevice" */
  insert_applicationUserDevices?: applicationUserDevices_mutation_response;
  /** insert a single row into the table: "qx.ApplicationUserDevice" */
  insert_applicationUserDevices_one?: applicationUserDevices;
  /** insert data into the table: "analytics.AttributeProperty" */
  insert_attributeProperties?: attributeProperties_mutation_response;
  /** insert a single row into the table: "analytics.AttributeProperty" */
  insert_attributeProperties_one?: attributeProperties;
  /** insert data into the table: "analytics.Attribute" */
  insert_attributes?: attributes_mutation_response;
  /** insert a single row into the table: "analytics.Attribute" */
  insert_attributes_one?: attributes;
  /** insert data into the table: "audit.vAudioSourceAudit" */
  insert_audioSourceAudit?: audioSourceAudit_mutation_response;
  /** insert a single row into the table: "audit.vAudioSourceAudit" */
  insert_audioSourceAudit_one?: audioSourceAudit;
  /** insert data into the table: "audit.logged_actions" */
  insert_audit_logged_actions?: audit_logged_actions_mutation_response;
  /** insert a single row into the table: "audit.logged_actions" */
  insert_audit_logged_actions_one?: audit_logged_actions;
  /** insert data into the table: "audit.vSensorAudit" */
  insert_audit_vSensorAudit?: audit_vSensorAudit_mutation_response;
  /** insert a single row into the table: "audit.vSensorAudit" */
  insert_audit_vSensorAudit_one?: audit_vSensorAudit;
  /** insert data into the table: "qx.CloudStorageTimelapseOptions" */
  insert_cloudStorageTimelapseOptions?: cloudStorageTimelapseOptions_mutation_response;
  /** insert a single row into the table: "qx.CloudStorageTimelapseOptions" */
  insert_cloudStorageTimelapseOptions_one?: cloudStorageTimelapseOptions;
  /** insert data into the table: "audit.vCredentialAudit" */
  insert_credentialAudit?: credentialAudit_mutation_response;
  /** insert a single row into the table: "audit.vCredentialAudit" */
  insert_credentialAudit_one?: credentialAudit;
  /** insert data into the table: "audit.vCustomerPermissionAudit" */
  insert_customerPermissionAudit?: customerPermissionAudit_mutation_response;
  /** insert a single row into the table: "audit.vCustomerPermissionAudit" */
  insert_customerPermissionAudit_one?: customerPermissionAudit;
  /** insert data into the table: "qx.DeviceAnalyticSource" */
  insert_deviceAnalyticSource?: deviceAnalyticSource_mutation_response;
  /** insert a single row into the table: "qx.DeviceAnalyticSource" */
  insert_deviceAnalyticSource_one?: deviceAnalyticSource;
  /** insert data into the table: "audit.vDeviceAudit" */
  insert_deviceAudit?: deviceAudit_mutation_response;
  /** insert a single row into the table: "audit.vDeviceAudit" */
  insert_deviceAudit_one?: deviceAudit;
  /** insert data into the table: "audit.vDeviceDIOAudit" */
  insert_deviceDIOAudit?: deviceDIOAudit_mutation_response;
  /** insert a single row into the table: "audit.vDeviceDIOAudit" */
  insert_deviceDIOAudit_one?: deviceDIOAudit;
  /** insert data into the table: "audit.vDoorAudit" */
  insert_doorAudit?: doorAudit_mutation_response;
  /** insert a single row into the table: "audit.vDoorAudit" */
  insert_doorAudit_one?: doorAudit;
  /** insert data into the table: "analytics.eAnalyticIntegration" */
  insert_eAnalyticIntegrations?: eAnalyticIntegrations_mutation_response;
  /** insert a single row into the table: "analytics.eAnalyticIntegration" */
  insert_eAnalyticIntegrations_one?: eAnalyticIntegrations;
  /** insert data into the table: "analytics.eAnalyticState" */
  insert_eAnalyticStates?: eAnalyticStates_mutation_response;
  /** insert a single row into the table: "analytics.eAnalyticState" */
  insert_eAnalyticStates_one?: eAnalyticStates;
  /** insert data into the table: "qx.eGatewayType" */
  insert_eGatewayType?: eGatewayType_mutation_response;
  /** insert a single row into the table: "qx.eGatewayType" */
  insert_eGatewayType_one?: eGatewayType;
  /** insert data into the table: "qx.eS3BucketType" */
  insert_eS3BucketType?: eS3BucketType_mutation_response;
  /** insert a single row into the table: "qx.eS3BucketType" */
  insert_eS3BucketType_one?: eS3BucketType;
  /** insert data into the table: "audit.vFlowAudit" */
  insert_flowAudit?: flowAudit_mutation_response;
  /** insert a single row into the table: "audit.vFlowAudit" */
  insert_flowAudit_one?: flowAudit;
  /** insert data into the table: "audit.vGatewayAudit" */
  insert_gatewayAudit?: gatewayAudit_mutation_response;
  /** insert a single row into the table: "audit.vGatewayAudit" */
  insert_gatewayAudit_one?: gatewayAudit;
  /** insert data into the table: "audit.vGatewayBandwidthScheduleAudit" */
  insert_gatewayBandwidthScheduleAudit?: gatewayBandwidthScheduleAudit_mutation_response;
  /** insert a single row into the table: "audit.vGatewayBandwidthScheduleAudit" */
  insert_gatewayBandwidthScheduleAudit_one?: gatewayBandwidthScheduleAudit;
  /** insert data into the table: "audit.vGroupAudit" */
  insert_groupAudit?: groupAudit_mutation_response;
  /** insert a single row into the table: "audit.vGroupAudit" */
  insert_groupAudit_one?: groupAudit;
  /** insert data into the table: "qx.GuestAccess" */
  insert_guestAccess?: guestAccess_mutation_response;
  /** insert a single row into the table: "qx.GuestAccess" */
  insert_guestAccess_one?: guestAccess;
  /** insert data into the table: "audit.vHolidaySetAudit" */
  insert_holidaySetAudit?: holidaySetAudit_mutation_response;
  /** insert a single row into the table: "audit.vHolidaySetAudit" */
  insert_holidaySetAudit_one?: holidaySetAudit;
  /** insert data into the table: "audit.v_HolidaySetToScheduleBlockAudit" */
  insert_holidaySetToScheduleBlockAudit?: holidaySetToScheduleBlockAudit_mutation_response;
  /** insert a single row into the table: "audit.v_HolidaySetToScheduleBlockAudit" */
  insert_holidaySetToScheduleBlockAudit_one?: holidaySetToScheduleBlockAudit;
  /** insert data into the table: "audit.vInputPointAudit" */
  insert_inputPointAudit?: inputPointAudit_mutation_response;
  /** insert a single row into the table: "audit.vInputPointAudit" */
  insert_inputPointAudit_one?: inputPointAudit;
  /** insert data into the table: "audit.vLockAudit" */
  insert_lockAudit?: lockAudit_mutation_response;
  /** insert a single row into the table: "audit.vLockAudit" */
  insert_lockAudit_one?: lockAudit;
  /** insert data into the table: "audit.vMediaProfileAudit" */
  insert_mediaProfileAudit?: mediaProfileAudit_mutation_response;
  /** insert a single row into the table: "audit.vMediaProfileAudit" */
  insert_mediaProfileAudit_one?: mediaProfileAudit;
  /** insert data into the table: "audit.vOutputPointAudit" */
  insert_outputPointAudit?: outputPointAudit_mutation_response;
  /** insert a single row into the table: "audit.vOutputPointAudit" */
  insert_outputPointAudit_one?: outputPointAudit;
  /** insert data into the table: "audit.vPermissionAudit" */
  insert_permissionAudit?: permissionAudit_mutation_response;
  /** insert a single row into the table: "audit.vPermissionAudit" */
  insert_permissionAudit_one?: permissionAudit;
  /** insert data into the table: "audit.vPersonAudit" */
  insert_personAudit?: personAudit_mutation_response;
  /** insert a single row into the table: "audit.vPersonAudit" */
  insert_personAudit_one?: personAudit;
  /** insert data into the table: "qx.PersonDeviceAppPrivileges" */
  insert_personDeviceAppPrivileges?: personDeviceAppPrivileges_mutation_response;
  /** insert a single row into the table: "qx.PersonDeviceAppPrivileges" */
  insert_personDeviceAppPrivileges_one?: personDeviceAppPrivileges;
  /** insert data into the table: "qx.PersonDoorAppPrivileges" */
  insert_personDoorAppPrivileges?: personDoorAppPrivileges_mutation_response;
  /** insert a single row into the table: "qx.PersonDoorAppPrivileges" */
  insert_personDoorAppPrivileges_one?: personDoorAppPrivileges;
  /** insert data into the table: "qx.PersonIntrusionPartitionAppPrivileges" */
  insert_personIntrusionPartitionAppPrivileges?: personIntrusionPartitionAppPrivileges_mutation_response;
  /** insert a single row into the table: "qx.PersonIntrusionPartitionAppPrivileges" */
  insert_personIntrusionPartitionAppPrivileges_one?: personIntrusionPartitionAppPrivileges;
  /** insert data into the table: "qx.PersonPlaceAppPrivileges" */
  insert_personPlaceAppPrivileges?: personPlaceAppPrivileges_mutation_response;
  /** insert a single row into the table: "qx.PersonPlaceAppPrivileges" */
  insert_personPlaceAppPrivileges_one?: personPlaceAppPrivileges;
  /** insert data into the table: "audit.v_PersonToGroupAudit" */
  insert_personToGroupAudit?: personToGroupAudit_mutation_response;
  /** insert a single row into the table: "audit.v_PersonToGroupAudit" */
  insert_personToGroupAudit_one?: personToGroupAudit;
  /** insert data into the table: "qx.PersonVideoSourceAppPrivileges" */
  insert_personVideoSourceAppPrivileges?: personVideoSourceAppPrivileges_mutation_response;
  /** insert a single row into the table: "qx.PersonVideoSourceAppPrivileges" */
  insert_personVideoSourceAppPrivileges_one?: personVideoSourceAppPrivileges;
  /** insert data into the table: "audit.vPlaceAudit" */
  insert_placeAudit?: placeAudit_mutation_response;
  /** insert a single row into the table: "audit.vPlaceAudit" */
  insert_placeAudit_one?: placeAudit;
  /** insert data into the table: "qx.PlaceWhitelist" */
  insert_placeWhiteLists?: placeWhiteLists_mutation_response;
  /** insert a single row into the table: "qx.PlaceWhitelist" */
  insert_placeWhiteLists_one?: placeWhiteLists;
  /** insert data into the table: "audit.v_PrivilegeEnumToRoleAudit" */
  insert_privilegeEnumToRoleAudit?: privilegeEnumToRoleAudit_mutation_response;
  /** insert a single row into the table: "audit.v_PrivilegeEnumToRoleAudit" */
  insert_privilegeEnumToRoleAudit_one?: privilegeEnumToRoleAudit;
  /** insert data into the table: "qx.AccessCatalogCapabilities" */
  insert_qx_AccessCatalogCapabilities?: qx_AccessCatalogCapabilities_mutation_response;
  /** insert a single row into the table: "qx.AccessCatalogCapabilities" */
  insert_qx_AccessCatalogCapabilities_one?: qx_AccessCatalogCapabilities;
  /** insert data into the table: "qx.AuditableAction" */
  insert_qx_AuditableAction?: qx_AuditableAction_mutation_response;
  /** insert a single row into the table: "qx.AuditableAction" */
  insert_qx_AuditableAction_one?: qx_AuditableAction;
  /** insert data into the table: "qx.AuditableType" */
  insert_qx_AuditableType?: qx_AuditableType_mutation_response;
  /** insert a single row into the table: "qx.AuditableType" */
  insert_qx_AuditableType_one?: qx_AuditableType;
  /** insert data into the table: "qx.BillingPeriod" */
  insert_qx_BillingPeriod?: qx_BillingPeriod_mutation_response;
  /** insert data into the table: "qx.CatalogProtocolOverride" */
  insert_qx_CatalogProtocolOverride?: qx_CatalogProtocolOverride_mutation_response;
  /** insert a single row into the table: "qx.CatalogProtocolOverride" */
  insert_qx_CatalogProtocolOverride_one?: qx_CatalogProtocolOverride;
  /** insert data into the table: "qx.ClipAuditLog" */
  insert_qx_ClipAuditLog?: qx_ClipAuditLog_mutation_response;
  /** insert a single row into the table: "qx.ClipAuditLog" */
  insert_qx_ClipAuditLog_one?: qx_ClipAuditLog;
  /** insert data into the table: "qx.CloudStorageOptions" */
  insert_qx_CloudStorageOptions?: qx_CloudStorageOptions_mutation_response;
  /** insert data into the table: "qx.CustomerAuthProvider" */
  insert_qx_CustomerAuthProvider?: qx_CustomerAuthProvider_mutation_response;
  /** insert a single row into the table: "qx.CustomerAuthProvider" */
  insert_qx_CustomerAuthProvider_one?: qx_CustomerAuthProvider;
  /** insert data into the table: "qx.DiscoveryType" */
  insert_qx_DiscoveryType?: qx_DiscoveryType_mutation_response;
  /** insert a single row into the table: "qx.DiscoveryType" */
  insert_qx_DiscoveryType_one?: qx_DiscoveryType;
  /** insert a single row into the table: "qx.EventType" */
  insert_qx_EventType_one?: qx_EventType;
  /** insert data into the table: "qx.IntrusionAlarm" */
  insert_qx_IntrusionAlarm?: qx_IntrusionAlarm_mutation_response;
  /** insert a single row into the table: "qx.IntrusionAlarm" */
  insert_qx_IntrusionAlarm_one?: qx_IntrusionAlarm;
  /** insert data into the table: "qx.IntrusionPartitionState" */
  insert_qx_IntrusionPartitionState?: qx_IntrusionPartitionState_mutation_response;
  /** insert a single row into the table: "qx.IntrusionPartitionState" */
  insert_qx_IntrusionPartitionState_one?: qx_IntrusionPartitionState;
  /** insert data into the table: "qx.IntrusionZoneState" */
  insert_qx_IntrusionZoneState?: qx_IntrusionZoneState_mutation_response;
  /** insert a single row into the table: "qx.IntrusionZoneState" */
  insert_qx_IntrusionZoneState_one?: qx_IntrusionZoneState;
  /** insert data into the table: "qx.MediaProfileRecording" */
  insert_qx_MediaProfileRecording?: qx_MediaProfileRecording_mutation_response;
  /** insert a single row into the table: "qx.MediaProfileRecording" */
  insert_qx_MediaProfileRecording_one?: qx_MediaProfileRecording;
  /** insert data into the table: "qx.OssKey" */
  insert_qx_OssKey?: qx_OssKey_mutation_response;
  /** insert a single row into the table: "qx.OssKey" */
  insert_qx_OssKey_one?: qx_OssKey;
  /** insert data into the table: "qx.SharedLinkAuditLog" */
  insert_qx_SharedLinkAuditLog?: qx_SharedLinkAuditLog_mutation_response;
  /** insert a single row into the table: "qx.SharedLinkAuditLog" */
  insert_qx_SharedLinkAuditLog_one?: qx_SharedLinkAuditLog;
  /** insert data into the table: "qx.SharedLinkType" */
  insert_qx_SharedLinkType?: qx_SharedLinkType_mutation_response;
  /** insert a single row into the table: "qx.SharedLinkType" */
  insert_qx_SharedLinkType_one?: qx_SharedLinkType;
  /** insert data into the table: "qx.VideoSourceStorageAudit" */
  insert_qx_VideoSourceStorageAudit?: qx_VideoSourceStorageAudit_mutation_response;
  /** insert a single row into the table: "qx.VideoSourceStorageAudit" */
  insert_qx_VideoSourceStorageAudit_one?: qx_VideoSourceStorageAudit;
  /** insert data into the table: "qx.eAccessMake" */
  insert_qx_eAccessMake?: qx_eAccessMake_mutation_response;
  /** insert a single row into the table: "qx.eAccessMake" */
  insert_qx_eAccessMake_one?: qx_eAccessMake;
  /** insert data into the table: "qx.eAppPrivilegeType" */
  insert_qx_eAppPrivilegeType?: qx_eAppPrivilegeType_mutation_response;
  /** insert a single row into the table: "qx.eAppPrivilegeType" */
  insert_qx_eAppPrivilegeType_one?: qx_eAppPrivilegeType;
  /** insert data into the table: "qx.eAuthProvider" */
  insert_qx_eAuthProvider?: qx_eAuthProvider_mutation_response;
  /** insert a single row into the table: "qx.eAuthProvider" */
  insert_qx_eAuthProvider_one?: qx_eAuthProvider;
  /** insert data into the table: "qx.eFlowStatus" */
  insert_qx_eFlowStatus?: qx_eFlowStatus_mutation_response;
  /** insert a single row into the table: "qx.eFlowStatus" */
  insert_qx_eFlowStatus_one?: qx_eFlowStatus;
  /** insert data into the table: "qx.eFlowTraceActionStatus" */
  insert_qx_eFlowTraceActionStatus?: qx_eFlowTraceActionStatus_mutation_response;
  /** insert a single row into the table: "qx.eFlowTraceActionStatus" */
  insert_qx_eFlowTraceActionStatus_one?: qx_eFlowTraceActionStatus;
  /** insert data into the table: "qx.eFlowTraceState" */
  insert_qx_eFlowTraceState?: qx_eFlowTraceState_mutation_response;
  /** insert a single row into the table: "qx.eFlowTraceState" */
  insert_qx_eFlowTraceState_one?: qx_eFlowTraceState;
  /** insert data into the table: "qx.eIntrusionZoneType" */
  insert_qx_eIntrusionZoneType?: qx_eIntrusionZoneType_mutation_response;
  /** insert a single row into the table: "qx.eIntrusionZoneType" */
  insert_qx_eIntrusionZoneType_one?: qx_eIntrusionZoneType;
  /** insert data into the table: "qx.eLockMode" */
  insert_qx_eLockMode?: qx_eLockMode_mutation_response;
  /** insert a single row into the table: "qx.eLockMode" */
  insert_qx_eLockMode_one?: qx_eLockMode;
  /** insert data into the table: "qx.eMercuryMonitorPointLatchModes" */
  insert_qx_eMercuryMonitorPointLatchModes?: qx_eMercuryMonitorPointLatchModes_mutation_response;
  /** insert a single row into the table: "qx.eMercuryMonitorPointLatchModes" */
  insert_qx_eMercuryMonitorPointLatchModes_one?: qx_eMercuryMonitorPointLatchModes;
  /** insert data into the table: "qx.vPlacePrivilege" */
  insert_qx_vPlacePrivilege?: qx_vPlacePrivilege_mutation_response;
  /** insert a single row into the table: "qx.vPlacePrivilege" */
  insert_qx_vPlacePrivilege_one?: qx_vPlacePrivilege;
  /** insert data into the table: "qx.vProfiles" */
  insert_qx_vProfiles?: qx_vProfiles_mutation_response;
  /** insert a single row into the table: "qx.vProfiles" */
  insert_qx_vProfiles_one?: qx_vProfiles;
  /** insert data into the table: "qxanalytics.CloudUsage" */
  insert_qxanalytics_CloudUsage?: qxanalytics_CloudUsage_mutation_response;
  /** insert a single row into the table: "qxanalytics.CloudUsage" */
  insert_qxanalytics_CloudUsage_one?: qxanalytics_CloudUsage;
  /** insert data into the table: "qx.ReaderAccessTypeCompatibility" */
  insert_readerAccessTypeCompatibility?: readerAccessTypeCompatibility_mutation_response;
  /** insert a single row into the table: "qx.ReaderAccessTypeCompatibility" */
  insert_readerAccessTypeCompatibility_one?: readerAccessTypeCompatibility;
  /** insert data into the table: "audit.vReaderAudit" */
  insert_readerAudit?: readerAudit_mutation_response;
  /** insert a single row into the table: "audit.vReaderAudit" */
  insert_readerAudit_one?: readerAudit;
  /** insert data into the table: "qx.ReaderProtocolCompatibility" */
  insert_readerProtocolCompatibility?: readerProtocolCompatibility_mutation_response;
  /** insert a single row into the table: "qx.ReaderProtocolCompatibility" */
  insert_readerProtocolCompatibility_one?: readerProtocolCompatibility;
  /** insert data into the table: "qx.RoleAppPrivileges" */
  insert_roleAppPrivileges?: roleAppPrivileges_mutation_response;
  /** insert a single row into the table: "qx.RoleAppPrivileges" */
  insert_roleAppPrivileges_one?: roleAppPrivileges;
  /** insert data into the table: "audit.vRoleAudit" */
  insert_roleAudit?: roleAudit_mutation_response;
  /** insert a single row into the table: "audit.vRoleAudit" */
  insert_roleAudit_one?: roleAudit;
  /** insert data into the table: "qx.RosslareCatalog" */
  insert_rosslareCatalogs?: rosslareCatalogs_mutation_response;
  /** insert a single row into the table: "qx.RosslareCatalog" */
  insert_rosslareCatalogs_one?: rosslareCatalogs;
  /** insert data into the table: "qx.S3BucketConfiguration" */
  insert_s3BucketConfigurations?: s3BucketConfigurations_mutation_response;
  /** insert a single row into the table: "qx.S3BucketConfiguration" */
  insert_s3BucketConfigurations_one?: s3BucketConfigurations;
  /** insert data into the table: "audit.vScheduleAudit" */
  insert_scheduleAudit?: scheduleAudit_mutation_response;
  /** insert a single row into the table: "audit.vScheduleAudit" */
  insert_scheduleAudit_one?: scheduleAudit;
  /** insert data into the table: "audit.vScheduleBlockAudit" */
  insert_scheduleBlockAudit?: scheduleBlockAudit_mutation_response;
  /** insert a single row into the table: "audit.vScheduleBlockAudit" */
  insert_scheduleBlockAudit_one?: scheduleBlockAudit;
  /** insert data into the table: "qx.SuperviseInputCompatibility" */
  insert_superviseInputCompatibility?: superviseInputCompatibility_mutation_response;
  /** insert a single row into the table: "qx.SuperviseInputCompatibility" */
  insert_superviseInputCompatibility_one?: superviseInputCompatibility;
  /** insert data into the table: "audit.vVideoSourceAudit" */
  insert_videoSourceAudit?: videoSourceAudit_mutation_response;
  /** insert a single row into the table: "audit.vVideoSourceAudit" */
  insert_videoSourceAudit_one?: videoSourceAudit;
  /** insert data into the table: "qx.VideoSourceState" */
  insert_videoSourceState?: videoSourceState_mutation_response;
  /** insert a single row into the table: "qx.VideoSourceState" */
  insert_videoSourceState_one?: videoSourceState;
  lockDoor: SuccessOutput;
  lockDownDoor: SuccessOutput;
  lockDownPlace: SuccessOutput;
  lockDownReleaseDoor: SuccessOutput;
  lockDownReleasePlace: SuccessOutput;
  lockOpenDoor: SuccessOutput;
  lockOpenReleaseDoor: SuccessOutput;
  movePlace?: SuccessOutput;
  pacsConfigurationUpdatePlace: SuccessOutput;
  pacsHardwareConfiguration: SuccessOutput;
  pacsUpdate: SuccessOutput;
  peerOffer: StringOutput;
  permanentlyDeletePerson?: SuccessOutput;
  postDevicesToGatewayFromCloud: SuccessOutput;
  pushCandidate: SuccessOutput;
  qx_createDevice?: qx_Device;
  qx_createDevices?: qx_Device_mutation_response;
  rebootMinion: SuccessOutput;
  reconnectMinion: SuccessOutput;
  refreshDeviceConnectionStatuses?: SuccessOutput;
  removeClip: SuccessOutput;
  removeSSO: SuccessResponse;
  removeSharedLink: SuccessOutput;
  removeSharedLinks: SuccessOutput;
  removeTwoFactor: SuccessResponse;
  revertDoor: SuccessOutput;
  saveClip: SaveClipOutput;
  scanSegments: any;
  /** setOSSKeys */
  setOSSKeys: OSSKeysOutput;
  setOfflinePassword: SuccessOutput;
  setupCameraGateway: any;
  setupSSO: SuccessResponse;
  setupTwoFactor: BackupCodes;
  signout: SuccessResponse;
  signoutEverywhere: SuccessResponse;
  submitHardware: SuccessOutput;
  switchProfile: SuccessResponse;
  sync: SuccessResponse;
  /** syncMediaProfileRecordings */
  syncMediaProfileRecordings?: SuccessOutput;
  syncPeopleFromAuthProvider: SuccessResponse;
  testDeviceConnection: SuccessOutput;
  unlockDoor: SuccessOutput;
  /** update data of the table: "qx.eBatteryLevel" */
  upateBatteryLevelEnums?: qx_eBatteryLevel_mutation_response;
  /** update single row of the table: "qx.eAccessBoardType" */
  updateAccessBoardTypeEnum?: qx_eAccessBoardType;
  /** update data of the table: "qx.eAccessBoardType" */
  updateAccessBoardTypeEnums?: qx_eAccessBoardType_mutation_response;
  /** update single row of the table: "qx.AccessCatalog" */
  updateAccessCatalog?: qx_AccessCatalog;
  /** update data of the table: "qx.AccessCatalog" */
  updateAccessCatalogs?: qx_AccessCatalog_mutation_response;
  /** update single row of the table: "qx.eAccessDeniedReason" */
  updateAccessDeniedReasonEnum?: qx_eAccessDeniedReason;
  /** update data of the table: "qx.eAccessDeniedReason" */
  updateAccessDeniedReasonEnums?: qx_eAccessDeniedReason_mutation_response;
  /** update single row of the table: "qx.eAccessInterfaceType" */
  updateAccessInterfaceTypeEnum?: qx_eAccessInterfaceType;
  /** update data of the table: "qx.eAccessInterfaceType" */
  updateAccessInterfaceTypeEnums?: qx_eAccessInterfaceType_mutation_response;
  /** update data of the table: "qx.AccessInventory" */
  updateAccessInventories?: qx_AccessInventory_mutation_response;
  /** update single row of the table: "qx.AccessInventory" */
  updateAccessInventory?: qx_AccessInventory;
  /** update single row of the table: "qx.eAccessPointAction" */
  updateAccessPointActionEnum?: qx_eAccessPointAction;
  /** update data of the table: "qx.eAccessPointAction" */
  updateAccessPointActionEnums?: qx_eAccessPointAction_mutation_response;
  /** update single row of the table: "qx.eAccessPointDirection" */
  updateAccessPointDirectionEnum?: qx_eAccessPointDirection;
  /** update data of the table: "qx.eAccessPointDirection" */
  updateAccessPointDirectionEnums?: qx_eAccessPointDirection_mutation_response;
  /** update single row of the table: "qx.eAccessPointType" */
  updateAccessPointTypeEnum?: qx_eAccessPointType;
  /** update data of the table: "qx.eAccessPointType" */
  updateAccessPointTypeEnums?: qx_eAccessPointType_mutation_response;
  /** update single row of the table: "qx.AudioSource" */
  updateAudioSource?: qx_AudioSource;
  /** update data of the table: "qx.AudioSource" */
  updateAudioSources?: qx_AudioSource_mutation_response;
  /** update single row of the table: "qx.eAuthStrategy" */
  updateAuthStrategyEnum?: qx_eAuthStrategy;
  /** update data of the table: "qx.eAuthStrategy" */
  updateAuthStrategyEnums?: qx_eAuthStrategy_mutation_response;
  /** update single row of the table: "qx.eBatteryLevel" */
  updateBatteryLevelEnum?: qx_eBatteryLevel;
  /** update single row of the table: "qx.eBaudrate" */
  updateBaudrateEnum?: qx_eBaudrate;
  /** update data of the table: "qx.eBaudrate" */
  updateBaudrateEnums?: qx_eBaudrate_mutation_response;
  /** update single row of the table: "qx.BillingPeriod" */
  updateBillingPeriod?: qx_BillingPeriod;
  /** update single row of the table: "qx.eBillingTier" */
  updateBillingTierEnum?: qx_eBillingTier;
  /** update data of the table: "qx.eBillingTier" */
  updateBillingTierEnums?: qx_eBillingTier_mutation_response;
  /** update data of the table: "qx.ChatUsageHistory" */
  updateChatUsageHistories?: qx_ChatUsageHistory_mutation_response;
  /** update single row of the table: "qx.ChatUsageHistory" */
  updateChatUsageHistory?: qx_ChatUsageHistory;
  /** update single row of the table: "qx.Clip" */
  updateClip?: qx_Clip;
  /** update single row of the table: "qx.eClipStatus" */
  updateClipStatusEnum?: qx_eClipStatus;
  /** update data of the table: "qx.eClipStatus" */
  updateClipStatusEnums?: qx_eClipStatus_mutation_response;
  /** update single row of the table: "qx.eClipType" */
  updateClipTypeEnum?: qx_eClipType;
  /** update data of the table: "qx.eClipType" */
  updateClipTypeEnums?: qx_eClipType_mutation_response;
  /** update data of the table: "qx.Clip" */
  updateClips?: qx_Clip_mutation_response;
  /** update single row of the table: "qx.CloudStorageOptions" */
  updateCloudStorageOption?: qx_CloudStorageOptions;
  /** update single row of the table: "qx.Credential" */
  updateCredential?: qx_Credential;
  /** update single row of the table: "qx.eCredentialType" */
  updateCredentialTypeEnum?: qx_eCredentialType;
  /** update data of the table: "qx.eCredentialType" */
  updateCredentialTypeEnums?: qx_eCredentialType_mutation_response;
  /** update data of the table: "qx.Credential" */
  updateCredentials?: qx_Credential_mutation_response;
  updateCustomerCanSelfServe: any;
  /** update single row of the table: "qx.CustomerPermission" */
  updateCustomerPermission?: qx_CustomerPermission;
  /** update data of the table: "qx.CustomerPermission" */
  updateCustomerPermissions?: qx_CustomerPermission_mutation_response;
  updateCustomerPlacePrivileges: any;
  /** update single row of the table: "qx.eDIONormalState" */
  updateDIONormalStateEnum?: qx_eDIONormalState;
  /** update data of the table: "qx.eDIONormalState" */
  updateDIONormalStateEnums?: qx_eDIONormalState_mutation_response;
  /** update single row of the table: "qx.eDIOState" */
  updateDIOStateEnum?: qx_eDIOState;
  /** update data of the table: "qx.eDIOState" */
  updateDIOStateEnums?: qx_eDIOState_mutation_response;
  /** update single row of the table: "qx.eDIOType" */
  updateDIOTypeEnum?: qx_eDIOType;
  /** update data of the table: "qx.eDIOType" */
  updateDIOTypeEnums?: qx_eDIOType_mutation_response;
  /** update single row of the table: "qx.Device" */
  updateDevice?: qx_Device;
  /** update single row of the table: "qx.eDeviceConnectionStatus" */
  updateDeviceConnectionStatusEnum?: qx_eDeviceConnectionStatus;
  /** update data of the table: "qx.eDeviceConnectionStatus" */
  updateDeviceConnectionStatusEnums?: qx_eDeviceConnectionStatus_mutation_response;
  /** update single row of the table: "qx.DeviceDIO" */
  updateDeviceDIO?: qx_DeviceDIO;
  /** update data of the table: "qx.DeviceDIO" */
  updateDeviceDIOs?: qx_DeviceDIO_mutation_response;
  /** update single row of the table: "qx.eDeviceKind" */
  updateDeviceKindEnum?: qx_eDeviceKind;
  /** update data of the table: "qx.eDeviceKind" */
  updateDeviceKindEnums?: qx_eDeviceKind_mutation_response;
  updateDeviceWithConnection: SuccessOutput;
  /** update data of the table: "qx.Device" */
  updateDevices?: qx_Device_mutation_response;
  /** update single row of the table: "qx.Door" */
  updateDoor?: qx_Door;
  /** update single row of the table: "qx.eDoorAlarm" */
  updateDoorAlarmEnum?: qx_eDoorAlarm;
  /** update data of the table: "qx.eDoorAlarm" */
  updateDoorAlarmEnums?: qx_eDoorAlarm_mutation_response;
  /** update single row of the table: "qx.DoorConfiguration" */
  updateDoorConfiguration?: qx_DoorConfiguration;
  /** update data of the table: "qx.DoorConfiguration" */
  updateDoorConfigurations?: qx_DoorConfiguration_mutation_response;
  updateDoorContactSupervise: SuccessOutput;
  /** update single row of the table: "qx.DoorMeta" */
  updateDoorMeta?: qx_DoorMeta;
  /** update data of the table: "qx.DoorMeta" */
  updateDoorMetas?: qx_DoorMeta_mutation_response;
  /** update single row of the table: "qx.eDoorMode" */
  updateDoorModeEnum?: qx_eDoorMode;
  /** update data of the table: "qx.eDoorMode" */
  updateDoorModeEnums?: qx_eDoorMode_mutation_response;
  /** update single row of the table: "qx.eDoorMonitor" */
  updateDoorMonitorEnum?: qx_eDoorMonitor;
  /** update data of the table: "qx.eDoorMonitor" */
  updateDoorMonitorEnums?: qx_eDoorMonitor_mutation_response;
  updateDoorRexSupervise: SuccessOutput;
  /** update single row of the table: "qx.eDoorState" */
  updateDoorStateEnum?: qx_eDoorState;
  /** update data of the table: "qx.eDoorState" */
  updateDoorStateEnums?: qx_eDoorState_mutation_response;
  /** update single row of the table: "qx.DoorTemplate" */
  updateDoorTemplate?: qx_DoorTemplate;
  /** update data of the table: "qx.DoorTemplate" */
  updateDoorTemplates?: qx_DoorTemplate_mutation_response;
  /** update data of the table: "qx.Door" */
  updateDoors?: qx_Door_mutation_response;
  /** update single row of the table: "qx.Event" */
  updateEvent?: qx_Event;
  /** update data of the table: "qx.EventType" */
  updateEventTypes?: qx_EventType_mutation_response;
  /** update data of the table: "qx.Event" */
  updateEvents?: qx_Event_mutation_response;
  /** update single row of the table: "qx.Flow" */
  updateFlow?: qx_Flow;
  /** update single row of the table: "qx.eFlowNotificationType" */
  updateFlowNotificationTypeEnum?: qx_eFlowNotificationType;
  /** update data of the table: "qx.eFlowNotificationType" */
  updateFlowNotificationTypeEnums?: qx_eFlowNotificationType_mutation_response;
  /** update single row of the table: "qx.FlowTrace" */
  updateFlowTrace?: qx_FlowTrace;
  /** update data of the table: "qx.FlowTrace" */
  updateFlowTraces?: qx_FlowTrace_mutation_response;
  /** update data of the table: "qx.Flow" */
  updateFlows?: qx_Flow_mutation_response;
  /** update single row of the table: "qx.Gateway" */
  updateGateway?: qx_Gateway;
  /** update single row of the table: "qx.GatewayBandwidthSchedule" */
  updateGatewayBandwidthSchedule?: qx_GatewayBandwidthSchedule;
  /** update data of the table: "qx.GatewayBandwidthSchedule" */
  updateGatewayBandwidthSchedules?: qx_GatewayBandwidthSchedule_mutation_response;
  updateGatewayFeatures?: SuccessOutput;
  updateGatewayLicense: SuccessOutput;
  /** update single row of the table: "qx.eGatewayServiceType" */
  updateGatewayServiceTypeEnum?: qx_eGatewayServiceType;
  /** update data of the table: "qx.eGatewayServiceType" */
  updateGatewayServiceTypeEnums?: qx_eGatewayServiceType_mutation_response;
  /** update single row of the table: "qx.eGatewaySyncStatus" */
  updateGatewaySyncStatusEnum?: qx_eGatewaySyncStatus;
  /** update data of the table: "qx.eGatewaySyncStatus" */
  updateGatewaySyncStatusEnums?: qx_eGatewaySyncStatus_mutation_response;
  /** update data of the table: "qx.Gateway" */
  updateGateways?: qx_Gateway_mutation_response;
  /** update single row of the table: "qx.Group" */
  updateGroup?: qx_Group;
  /** update data of the table: "qx.Group" */
  updateGroups?: qx_Group_mutation_response;
  /** update single row of the table: "qx.HolidaySet" */
  updateHolidaySet?: qx_HolidaySet;
  /** update single row of the table: "qx._HolidaySetToScheduleBlock" */
  updateHolidaySetToScheduleBlock?: qx__HolidaySetToScheduleBlock;
  /** update data of the table: "qx._HolidaySetToScheduleBlock" */
  updateHolidaySetToScheduleBlocks?: qx__HolidaySetToScheduleBlock_mutation_response;
  /** update data of the table: "qx.HolidaySet" */
  updateHolidaySets?: qx_HolidaySet_mutation_response;
  /** update single row of the table: "qx.InputPoint" */
  updateInputPoint?: qx_InputPoint;
  /** update data of the table: "qx.InputPoint" */
  updateInputPoints?: qx_InputPoint_mutation_response;
  updateInputSupervise: SuccessOutput;
  /** update single row of the table: "qx.eKeypadMode" */
  updateKeyModeEnum?: qx_eKeypadMode;
  /** update data of the table: "qx.eKeypadMode" */
  updateKeyModeEnums?: qx_eKeypadMode_mutation_response;
  /** update single row of the table: "qx.Layout" */
  updateLayout?: qx_Layout;
  /** update data of the table: "qx.Layout" */
  updateLayouts?: qx_Layout_mutation_response;
  /** updateLdapConfiguration */
  updateLdapConfiguration?: SuccessOutput;
  /** update single row of the table: "qx.LensProfile" */
  updateLensProfile?: qx_LensProfile;
  /** update data of the table: "qx.LensProfile" */
  updateLensProfiles?: qx_LensProfile_mutation_response;
  /** update single row of the table: "qx.Lock" */
  updateLock?: qx_Lock;
  /** update single row of the table: "qx.eLockPowerMonitor" */
  updateLockPowerMonitorEnum?: qx_eLockPowerMonitor;
  /** update data of the table: "qx.eLockPowerMonitor" */
  updateLockPowerMonitorEnums?: qx_eLockPowerMonitor_mutation_response;
  /** update single row of the table: "qx.eLockRelayMonitor" */
  updateLockRelayMonitorEnum?: qx_eLockRelayMonitor;
  /** update data of the table: "qx.eLockRelayMonitor" */
  updateLockRelayMonitorEnums?: qx_eLockRelayMonitor_mutation_response;
  /** update single row of the table: "qx.eLockType" */
  updateLockTypeEnum?: qx_eLockType;
  /** update data of the table: "qx.eLockType" */
  updateLockTypeEnums?: qx_eLockType_mutation_response;
  /** update data of the table: "qx.Lock" */
  updateLocks?: qx_Lock_mutation_response;
  /** update single row of the table: "qx.MediaProfile" */
  updateMediaProfile?: qx_MediaProfile;
  /** update data of the table: "qx.MediaProfile" */
  updateMediaProfiles?: qx_MediaProfile_mutation_response;
  /** update single row of the table: "qx.MercuryControlPoint" */
  updateMercuryControlPoint?: qx_MercuryControlPoint;
  /** update data of the table: "qx.MercuryControlPoint" */
  updateMercuryControlPoints?: qx_MercuryControlPoint_mutation_response;
  /** update single row of the table: "qx.MercuryMonitorPoint" */
  updateMercuryMonitorPoint?: qx_MercuryMonitorPoint;
  /** update data of the table: "qx.MercuryMonitorPoint" */
  updateMercuryMonitorPoints?: qx_MercuryMonitorPoint_mutation_response;
  updateMinion: SuccessOutput;
  /** update single row of the table: "qx.eMonitorLockState" */
  updateMonitorLockStateEnum?: qx_eMonitorLockState;
  /** update data of the table: "qx.eMonitorLockState" */
  updateMonitorLockStateEnums?: qx_eMonitorLockState_mutation_response;
  /** update single row of the table: "qx.eMountPosition" */
  updateMountPositionEnum?: qx_eMountPosition;
  /** update data of the table: "qx.eMountPosition" */
  updateMountPositionEnums?: qx_eMountPosition_mutation_response;
  /** update single row of the table: "qx.eObjectAction" */
  updateObjectActionEnum?: qx_eObjectAction;
  /** update data of the table: "qx.eObjectAction" */
  updateObjectActionEnums?: qx_eObjectAction_mutation_response;
  /** update single row of the table: "qx.OssIdAssignment" */
  updateOssIdAssignment?: qx_OssIdAssignment;
  /** update data of the table: "qx.OssIdAssignment" */
  updateOssIdAssignments?: qx_OssIdAssignment_mutation_response;
  /** update single row of the table: "qx.OutputPoint" */
  updateOutputPoint?: qx_OutputPoint;
  /** update data of the table: "qx.OutputPoint" */
  updateOutputPoints?: qx_OutputPoint_mutation_response;
  /** update single row of the table: "qx.ePACSStatus" */
  updatePACSStatusEnum?: qx_ePACSStatus;
  /** update data of the table: "qx.ePACSStatus" */
  updatePACSStatusEnums?: qx_ePACSStatus_mutation_response;
  /** update data of the table: "qx.Person" */
  updatePeople?: qx_Person_mutation_response;
  /** update single row of the table: "qx.Permission" */
  updatePermission?: qx_Permission;
  /** Update a Permission and replace its IntrusionPartition assignments */
  updatePermissionWithPartitions: SuccessOutput;
  /** update data of the table: "qx.Permission" */
  updatePermissions?: qx_Permission_mutation_response;
  /** update single row of the table: "qx.Person" */
  updatePerson?: qx_Person;
  /** update single row of the table: "qx._PersonToGroup" */
  updatePersonGroup?: qx__PersonToGroup;
  /** update data of the table: "qx._PersonToGroup" */
  updatePersonGroups?: qx__PersonToGroup_mutation_response;
  /** update single row of the table: "qx.ePersonStatus" */
  updatePersonStatusEnum?: qx_ePersonStatus;
  /** update data of the table: "qx.ePersonStatus" */
  updatePersonStatusEnums?: qx_ePersonStatus_mutation_response;
  /** update single row of the table: "qx.Place" */
  updatePlace?: qx_Place;
  /** update single row of the table: "qx.ePlaceType" */
  updatePlaceTypeEnum?: qx_ePlaceType;
  /** update data of the table: "qx.ePlaceType" */
  updatePlaceTypeEnums?: qx_ePlaceType_mutation_response;
  /** update data of the table: "qx.Place" */
  updatePlaces?: qx_Place_mutation_response;
  /** update single row of the table: "qx.ePrivilege" */
  updatePrivilegeEnum?: qx_ePrivilege;
  /** update single row of the table: "qx._PrivilegeEnumToRole" */
  updatePrivilegeEnumToRole?: qx__PrivilegeEnumToRole;
  /** update data of the table: "qx._PrivilegeEnumToRole" */
  updatePrivilegeEnumToRoles?: qx__PrivilegeEnumToRole_mutation_response;
  /** update data of the table: "qx.ePrivilege" */
  updatePrivilegeEnums?: qx_ePrivilege_mutation_response;
  /** update single row of the table: "qx.Reader" */
  updateReader?: qx_Reader;
  /** update single row of the table: "qx.eReaderAccessType" */
  updateReaderAccessTypeEnum?: qx_eReaderAccessType;
  /** update data of the table: "qx.eReaderAccessType" */
  updateReaderAccessTypeEnums?: qx_eReaderAccessType_mutation_response;
  /** update single row of the table: "qx.eReaderProtocol" */
  updateReaderProtocolEnum?: qx_eReaderProtocol;
  /** update data of the table: "qx.eReaderProtocol" */
  updateReaderProtocolEnums?: qx_eReaderProtocol_mutation_response;
  /** update data of the table: "qx.Reader" */
  updateReaders?: qx_Reader_mutation_response;
  /** update single row of the table: "qx.eRexState" */
  updateRexStateEnum?: qx_eRexState;
  /** update data of the table: "qx.eRexState" */
  updateRexStateEnums?: qx_eRexState_mutation_response;
  /** update single row of the table: "qx.Role" */
  updateRole?: qx_Role;
  /** update data of the table: "qx.Role" */
  updateRoles?: qx_Role_mutation_response;
  /** update single row of the table: "qx.RosslareConnection" */
  updateRosslareConnection?: qx_RosslareConnection;
  /** update data of the table: "qx.RosslareConnection" */
  updateRosslareConnections?: qx_RosslareConnection_mutation_response;
  updateSavedClip: SuccessOutput;
  /** update single row of the table: "qx.Schedule" */
  updateSchedule?: qx_Schedule;
  /** update single row of the table: "qx.ScheduleBlock" */
  updateScheduleBlock?: qx_ScheduleBlock;
  /** update data of the table: "qx.ScheduleBlock" */
  updateScheduleBlocks?: qx_ScheduleBlock_mutation_response;
  /** update data of the table: "qx.Schedule" */
  updateSchedules?: qx_Schedule_mutation_response;
  /** update single row of the table: "qx.Segment" */
  updateSegment?: qx_Segment;
  /** update data of the table: "qx.Segment" */
  updateSegments?: qx_Segment_mutation_response;
  /** update single row of the table: "qx.Sensor" */
  updateSensor?: qx_Sensor;
  /** update single row of the table: "qx.eSensorAction" */
  updateSensorActionEnum?: qx_eSensorAction;
  /** update data of the table: "qx.eSensorAction" */
  updateSensorActionEnums?: qx_eSensorAction_mutation_response;
  /** update single row of the table: "qx.eSensorType" */
  updateSensorTypeEnum?: qx_eSensorType;
  /** update data of the table: "qx.eSensorType" */
  updateSensorTypeEnums?: qx_eSensorType_mutation_response;
  /** update data of the table: "qx.Sensor" */
  updateSensors?: qx_Sensor_mutation_response;
  /** update single row of the table: "qx.SharedLinks" */
  updateSharedLink?: qx_SharedLinks;
  updateSharedLinkDetails: SuccessOutput;
  /** update data of the table: "qx.SharedLinks" */
  updateSharedLinks?: qx_SharedLinks_mutation_response;
  /** update single row of the table: "qx.Snapshot" */
  updateSnapshot?: qx_Snapshot;
  /** update data of the table: "qx.Snapshot" */
  updateSnapshots?: qx_Snapshot_mutation_response;
  /** update single row of the table: "qx.eStreamStatus" */
  updateStreamStatusEnum?: qx_eStreamStatus;
  /** update data of the table: "qx.eStreamStatus" */
  updateStreamStatusEnums?: qx_eStreamStatus_mutation_response;
  /** update single row of the table: "qx.eSuperviseInputs" */
  updateSuperviseInputsEnum?: qx_eSuperviseInputs;
  /** update data of the table: "qx.eSuperviseInputs" */
  updateSuperviseInputsEnums?: qx_eSuperviseInputs_mutation_response;
  /** update single row of the table: "qx.TermsAgreement" */
  updateTermsAgreement?: qx_TermsAgreement;
  /** update data of the table: "qx.TermsAgreement" */
  updateTermsAgreements?: qx_TermsAgreement_mutation_response;
  /** update single row of the table: "qx.TimeZone" */
  updateTimeZone?: qx_TimeZone;
  /** update data of the table: "qx.TimeZone" */
  updateTimeZones?: qx_TimeZone_mutation_response;
  /** update single row of the table: "qx.UserSetting" */
  updateUserSetting?: qx_UserSetting;
  /** update data of the table: "qx.UserSetting" */
  updateUserSettings?: qx_UserSetting_mutation_response;
  /** update single row of the table: "qx.VideoSource" */
  updateVideoSource?: qx_VideoSource;
  /** update data of the table: "qx.VideoSource" */
  updateVideoSources?: qx_VideoSource_mutation_response;
  /** update single row of the table: "qx.View" */
  updateView?: qx_View;
  /** update data of the table: "qx.View" */
  updateViews?: qx_View_mutation_response;
  /** update single row of the table: "qx.WiegandCardFormat" */
  updateWiegandCardFormat?: qx_WiegandCardFormat;
  /** update data of the table: "qx.WiegandCardFormat" */
  updateWiegandCardFormats?: qx_WiegandCardFormat_mutation_response;
  /** update data of the table: "analytics.AnalyticSource" */
  update_AnalyticSources?: AnalyticSources_mutation_response;
  /** update single row of the table: "analytics.AnalyticSource" */
  update_AnalyticSources_by_pk?: AnalyticSources;
  /** update multiples rows of table: "analytics.AnalyticSource" */
  update_AnalyticSources_many?: Array<AnalyticSources_mutation_response>;
  /** update data of the table: "qx.ApplicationUserGatewayPassword" */
  update_ApplicationUserGatewayPassword?: ApplicationUserGatewayPassword_mutation_response;
  /** update single row of the table: "qx.ApplicationUserGatewayPassword" */
  update_ApplicationUserGatewayPassword_by_pk?: ApplicationUserGatewayPassword;
  /** update multiples rows of table: "qx.ApplicationUserGatewayPassword" */
  update_ApplicationUserGatewayPassword_many?: Array<ApplicationUserGatewayPassword_mutation_response>;
  /** update data of the table: "qx.ApplicationUserTwoFactor" */
  update_ApplicationUserTwoFactor?: ApplicationUserTwoFactor_mutation_response;
  /** update single row of the table: "qx.ApplicationUserTwoFactor" */
  update_ApplicationUserTwoFactor_by_pk?: ApplicationUserTwoFactor;
  /** update multiples rows of table: "qx.ApplicationUserTwoFactor" */
  update_ApplicationUserTwoFactor_many?: Array<ApplicationUserTwoFactor_mutation_response>;
  /** update data of the table: "qx.DSCConnection" */
  update_DSCConnection?: DSCConnection_mutation_response;
  /** update single row of the table: "qx.DSCConnection" */
  update_DSCConnection_by_pk?: DSCConnection;
  /** update multiples rows of table: "qx.DSCConnection" */
  update_DSCConnection_many?: Array<DSCConnection_mutation_response>;
  /** update data of the table: "qx.IntrusionAccessCode" */
  update_IntrusionAccessCode?: IntrusionAccessCode_mutation_response;
  /** update single row of the table: "qx.IntrusionAccessCode" */
  update_IntrusionAccessCode_by_pk?: IntrusionAccessCode;
  /** update multiples rows of table: "qx.IntrusionAccessCode" */
  update_IntrusionAccessCode_many?: Array<IntrusionAccessCode_mutation_response>;
  /** update data of the table: "qx.IntrusionPartition" */
  update_IntrusionPartition?: IntrusionPartition_mutation_response;
  /** update single row of the table: "qx.IntrusionPartition" */
  update_IntrusionPartition_by_pk?: IntrusionPartition;
  /** update multiples rows of table: "qx.IntrusionPartition" */
  update_IntrusionPartition_many?: Array<IntrusionPartition_mutation_response>;
  /** update data of the table: "qx.IntrusionZone" */
  update_IntrusionZone?: IntrusionZone_mutation_response;
  /** update single row of the table: "qx.IntrusionZone" */
  update_IntrusionZone_by_pk?: IntrusionZone;
  /** update multiples rows of table: "qx.IntrusionZone" */
  update_IntrusionZone_many?: Array<IntrusionZone_mutation_response>;
  /** update data of the table: "qx.PartitionZoneAssignments" */
  update_PartitionZoneAssignments?: PartitionZoneAssignments_mutation_response;
  /** update single row of the table: "qx.PartitionZoneAssignments" */
  update_PartitionZoneAssignments_by_pk?: PartitionZoneAssignments;
  /** update multiples rows of table: "qx.PartitionZoneAssignments" */
  update_PartitionZoneAssignments_many?: Array<PartitionZoneAssignments_mutation_response>;
  /** update data of the table: "qx.PassKeyProvider" */
  update_PassKeyProvider?: PassKeyProvider_mutation_response;
  /** update single row of the table: "qx.PassKeyProvider" */
  update_PassKeyProvider_by_pk?: PassKeyProvider;
  /** update multiples rows of table: "qx.PassKeyProvider" */
  update_PassKeyProvider_many?: Array<PassKeyProvider_mutation_response>;
  /** update data of the table: "qx.PermissionPartitionAssignments" */
  update_PermissionPartitionAssignments?: PermissionPartitionAssignments_mutation_response;
  /** update single row of the table: "qx.PermissionPartitionAssignments" */
  update_PermissionPartitionAssignments_by_pk?: PermissionPartitionAssignments;
  /** update multiples rows of table: "qx.PermissionPartitionAssignments" */
  update_PermissionPartitionAssignments_many?: Array<PermissionPartitionAssignments_mutation_response>;
  /** update data of the table: "qx.PersonTermsAgreement" */
  update_PersonTermsAgreement?: PersonTermsAgreement_mutation_response;
  /** update single row of the table: "qx.PersonTermsAgreement" */
  update_PersonTermsAgreement_by_pk?: PersonTermsAgreement;
  /** update multiples rows of table: "qx.PersonTermsAgreement" */
  update_PersonTermsAgreement_many?: Array<PersonTermsAgreement_mutation_response>;
  /** update data of the table: "analytics.AnalyticAttributeProperty" */
  update_analyticAttributeProperties?: analyticAttributeProperties_mutation_response;
  /** update single row of the table: "analytics.AnalyticAttributeProperty" */
  update_analyticAttributeProperties_by_pk?: analyticAttributeProperties;
  /** update multiples rows of table: "analytics.AnalyticAttributeProperty" */
  update_analyticAttributeProperties_many?: Array<analyticAttributeProperties_mutation_response>;
  /** update data of the table: "analytics.AnalyticAttribute" */
  update_analyticAttributes?: analyticAttributes_mutation_response;
  /** update single row of the table: "analytics.AnalyticAttribute" */
  update_analyticAttributes_by_pk?: analyticAttributes;
  /** update multiples rows of table: "analytics.AnalyticAttribute" */
  update_analyticAttributes_many?: Array<analyticAttributes_mutation_response>;
  /** update data of the table: "analytics.AnalyticPropertyDetected" */
  update_analyticDetectedProperties?: analyticDetectedProperties_mutation_response;
  /** update single row of the table: "analytics.AnalyticPropertyDetected" */
  update_analyticDetectedProperties_by_pk?: analyticDetectedProperties;
  /** update multiples rows of table: "analytics.AnalyticPropertyDetected" */
  update_analyticDetectedProperties_many?: Array<analyticDetectedProperties_mutation_response>;
  /** update data of the table: "analytics.AnalyticType" */
  update_analyticTypes?: analyticTypes_mutation_response;
  /** update single row of the table: "analytics.AnalyticType" */
  update_analyticTypes_by_pk?: analyticTypes;
  /** update multiples rows of table: "analytics.AnalyticType" */
  update_analyticTypes_many?: Array<analyticTypes_mutation_response>;
  /** update data of the table: "analytics.Analytic" */
  update_analytics?: analytics_mutation_response;
  /** update single row of the table: "analytics.Analytic" */
  update_analytics_by_pk?: analytics;
  /** update multiples rows of table: "analytics.Analytic" */
  update_analytics_many?: Array<analytics_mutation_response>;
  /** update data of the table: "qx.ApplicationUserAppPassword" */
  update_applicationUserAppPasswords?: applicationUserAppPasswords_mutation_response;
  /** update single row of the table: "qx.ApplicationUserAppPassword" */
  update_applicationUserAppPasswords_by_pk?: applicationUserAppPasswords;
  /** update multiples rows of table: "qx.ApplicationUserAppPassword" */
  update_applicationUserAppPasswords_many?: Array<applicationUserAppPasswords_mutation_response>;
  /** update data of the table: "qx.ApplicationUserDevice" */
  update_applicationUserDevices?: applicationUserDevices_mutation_response;
  /** update single row of the table: "qx.ApplicationUserDevice" */
  update_applicationUserDevices_by_pk?: applicationUserDevices;
  /** update multiples rows of table: "qx.ApplicationUserDevice" */
  update_applicationUserDevices_many?: Array<applicationUserDevices_mutation_response>;
  /** update data of the table: "analytics.AttributeProperty" */
  update_attributeProperties?: attributeProperties_mutation_response;
  /** update single row of the table: "analytics.AttributeProperty" */
  update_attributeProperties_by_pk?: attributeProperties;
  /** update multiples rows of table: "analytics.AttributeProperty" */
  update_attributeProperties_many?: Array<attributeProperties_mutation_response>;
  /** update data of the table: "analytics.Attribute" */
  update_attributes?: attributes_mutation_response;
  /** update single row of the table: "analytics.Attribute" */
  update_attributes_by_pk?: attributes;
  /** update multiples rows of table: "analytics.Attribute" */
  update_attributes_many?: Array<attributes_mutation_response>;
  /** update data of the table: "audit.vAudioSourceAudit" */
  update_audioSourceAudit?: audioSourceAudit_mutation_response;
  /** update multiples rows of table: "audit.vAudioSourceAudit" */
  update_audioSourceAudit_many?: Array<audioSourceAudit_mutation_response>;
  /** update data of the table: "audit.logged_actions" */
  update_audit_logged_actions?: audit_logged_actions_mutation_response;
  /** update single row of the table: "audit.logged_actions" */
  update_audit_logged_actions_by_pk?: audit_logged_actions;
  /** update multiples rows of table: "audit.logged_actions" */
  update_audit_logged_actions_many?: Array<audit_logged_actions_mutation_response>;
  /** update data of the table: "audit.vSensorAudit" */
  update_audit_vSensorAudit?: audit_vSensorAudit_mutation_response;
  /** update multiples rows of table: "audit.vSensorAudit" */
  update_audit_vSensorAudit_many?: Array<audit_vSensorAudit_mutation_response>;
  /** update data of the table: "qx.CloudStorageTimelapseOptions" */
  update_cloudStorageTimelapseOptions?: cloudStorageTimelapseOptions_mutation_response;
  /** update single row of the table: "qx.CloudStorageTimelapseOptions" */
  update_cloudStorageTimelapseOptions_by_pk?: cloudStorageTimelapseOptions;
  /** update multiples rows of table: "qx.CloudStorageTimelapseOptions" */
  update_cloudStorageTimelapseOptions_many?: Array<cloudStorageTimelapseOptions_mutation_response>;
  /** update data of the table: "audit.vCredentialAudit" */
  update_credentialAudit?: credentialAudit_mutation_response;
  /** update multiples rows of table: "audit.vCredentialAudit" */
  update_credentialAudit_many?: Array<credentialAudit_mutation_response>;
  /** update data of the table: "audit.vCustomerPermissionAudit" */
  update_customerPermissionAudit?: customerPermissionAudit_mutation_response;
  /** update multiples rows of table: "audit.vCustomerPermissionAudit" */
  update_customerPermissionAudit_many?: Array<customerPermissionAudit_mutation_response>;
  /** update data of the table: "qx.DeviceAnalyticSource" */
  update_deviceAnalyticSource?: deviceAnalyticSource_mutation_response;
  /** update single row of the table: "qx.DeviceAnalyticSource" */
  update_deviceAnalyticSource_by_pk?: deviceAnalyticSource;
  /** update multiples rows of table: "qx.DeviceAnalyticSource" */
  update_deviceAnalyticSource_many?: Array<deviceAnalyticSource_mutation_response>;
  /** update data of the table: "audit.vDeviceAudit" */
  update_deviceAudit?: deviceAudit_mutation_response;
  /** update multiples rows of table: "audit.vDeviceAudit" */
  update_deviceAudit_many?: Array<deviceAudit_mutation_response>;
  /** update data of the table: "audit.vDeviceDIOAudit" */
  update_deviceDIOAudit?: deviceDIOAudit_mutation_response;
  /** update multiples rows of table: "audit.vDeviceDIOAudit" */
  update_deviceDIOAudit_many?: Array<deviceDIOAudit_mutation_response>;
  /** update data of the table: "audit.vDoorAudit" */
  update_doorAudit?: doorAudit_mutation_response;
  /** update multiples rows of table: "audit.vDoorAudit" */
  update_doorAudit_many?: Array<doorAudit_mutation_response>;
  /** update data of the table: "analytics.eAnalyticIntegration" */
  update_eAnalyticIntegrations?: eAnalyticIntegrations_mutation_response;
  /** update single row of the table: "analytics.eAnalyticIntegration" */
  update_eAnalyticIntegrations_by_pk?: eAnalyticIntegrations;
  /** update multiples rows of table: "analytics.eAnalyticIntegration" */
  update_eAnalyticIntegrations_many?: Array<eAnalyticIntegrations_mutation_response>;
  /** update data of the table: "analytics.eAnalyticState" */
  update_eAnalyticStates?: eAnalyticStates_mutation_response;
  /** update single row of the table: "analytics.eAnalyticState" */
  update_eAnalyticStates_by_pk?: eAnalyticStates;
  /** update multiples rows of table: "analytics.eAnalyticState" */
  update_eAnalyticStates_many?: Array<eAnalyticStates_mutation_response>;
  /** update data of the table: "qx.eGatewayType" */
  update_eGatewayType?: eGatewayType_mutation_response;
  /** update single row of the table: "qx.eGatewayType" */
  update_eGatewayType_by_pk?: eGatewayType;
  /** update multiples rows of table: "qx.eGatewayType" */
  update_eGatewayType_many?: Array<eGatewayType_mutation_response>;
  /** update data of the table: "qx.eS3BucketType" */
  update_eS3BucketType?: eS3BucketType_mutation_response;
  /** update single row of the table: "qx.eS3BucketType" */
  update_eS3BucketType_by_pk?: eS3BucketType;
  /** update multiples rows of table: "qx.eS3BucketType" */
  update_eS3BucketType_many?: Array<eS3BucketType_mutation_response>;
  /** update data of the table: "audit.vFlowAudit" */
  update_flowAudit?: flowAudit_mutation_response;
  /** update multiples rows of table: "audit.vFlowAudit" */
  update_flowAudit_many?: Array<flowAudit_mutation_response>;
  /** update data of the table: "audit.vGatewayAudit" */
  update_gatewayAudit?: gatewayAudit_mutation_response;
  /** update multiples rows of table: "audit.vGatewayAudit" */
  update_gatewayAudit_many?: Array<gatewayAudit_mutation_response>;
  /** update data of the table: "audit.vGatewayBandwidthScheduleAudit" */
  update_gatewayBandwidthScheduleAudit?: gatewayBandwidthScheduleAudit_mutation_response;
  /** update multiples rows of table: "audit.vGatewayBandwidthScheduleAudit" */
  update_gatewayBandwidthScheduleAudit_many?: Array<gatewayBandwidthScheduleAudit_mutation_response>;
  /** update data of the table: "audit.vGroupAudit" */
  update_groupAudit?: groupAudit_mutation_response;
  /** update multiples rows of table: "audit.vGroupAudit" */
  update_groupAudit_many?: Array<groupAudit_mutation_response>;
  /** update data of the table: "qx.GuestAccess" */
  update_guestAccess?: guestAccess_mutation_response;
  /** update single row of the table: "qx.GuestAccess" */
  update_guestAccess_by_pk?: guestAccess;
  /** update multiples rows of table: "qx.GuestAccess" */
  update_guestAccess_many?: Array<guestAccess_mutation_response>;
  /** update data of the table: "audit.vHolidaySetAudit" */
  update_holidaySetAudit?: holidaySetAudit_mutation_response;
  /** update multiples rows of table: "audit.vHolidaySetAudit" */
  update_holidaySetAudit_many?: Array<holidaySetAudit_mutation_response>;
  /** update data of the table: "audit.v_HolidaySetToScheduleBlockAudit" */
  update_holidaySetToScheduleBlockAudit?: holidaySetToScheduleBlockAudit_mutation_response;
  /** update multiples rows of table: "audit.v_HolidaySetToScheduleBlockAudit" */
  update_holidaySetToScheduleBlockAudit_many?: Array<holidaySetToScheduleBlockAudit_mutation_response>;
  /** update data of the table: "audit.vInputPointAudit" */
  update_inputPointAudit?: inputPointAudit_mutation_response;
  /** update multiples rows of table: "audit.vInputPointAudit" */
  update_inputPointAudit_many?: Array<inputPointAudit_mutation_response>;
  /** update data of the table: "audit.vLockAudit" */
  update_lockAudit?: lockAudit_mutation_response;
  /** update multiples rows of table: "audit.vLockAudit" */
  update_lockAudit_many?: Array<lockAudit_mutation_response>;
  /** update data of the table: "audit.vMediaProfileAudit" */
  update_mediaProfileAudit?: mediaProfileAudit_mutation_response;
  /** update multiples rows of table: "audit.vMediaProfileAudit" */
  update_mediaProfileAudit_many?: Array<mediaProfileAudit_mutation_response>;
  /** update data of the table: "audit.vOutputPointAudit" */
  update_outputPointAudit?: outputPointAudit_mutation_response;
  /** update multiples rows of table: "audit.vOutputPointAudit" */
  update_outputPointAudit_many?: Array<outputPointAudit_mutation_response>;
  /** update data of the table: "audit.vPermissionAudit" */
  update_permissionAudit?: permissionAudit_mutation_response;
  /** update multiples rows of table: "audit.vPermissionAudit" */
  update_permissionAudit_many?: Array<permissionAudit_mutation_response>;
  /** update data of the table: "audit.vPersonAudit" */
  update_personAudit?: personAudit_mutation_response;
  /** update multiples rows of table: "audit.vPersonAudit" */
  update_personAudit_many?: Array<personAudit_mutation_response>;
  /** update data of the table: "qx.PersonDeviceAppPrivileges" */
  update_personDeviceAppPrivileges?: personDeviceAppPrivileges_mutation_response;
  /** update single row of the table: "qx.PersonDeviceAppPrivileges" */
  update_personDeviceAppPrivileges_by_pk?: personDeviceAppPrivileges;
  /** update multiples rows of table: "qx.PersonDeviceAppPrivileges" */
  update_personDeviceAppPrivileges_many?: Array<personDeviceAppPrivileges_mutation_response>;
  /** update data of the table: "qx.PersonDoorAppPrivileges" */
  update_personDoorAppPrivileges?: personDoorAppPrivileges_mutation_response;
  /** update single row of the table: "qx.PersonDoorAppPrivileges" */
  update_personDoorAppPrivileges_by_pk?: personDoorAppPrivileges;
  /** update multiples rows of table: "qx.PersonDoorAppPrivileges" */
  update_personDoorAppPrivileges_many?: Array<personDoorAppPrivileges_mutation_response>;
  /** update data of the table: "qx.PersonIntrusionPartitionAppPrivileges" */
  update_personIntrusionPartitionAppPrivileges?: personIntrusionPartitionAppPrivileges_mutation_response;
  /** update single row of the table: "qx.PersonIntrusionPartitionAppPrivileges" */
  update_personIntrusionPartitionAppPrivileges_by_pk?: personIntrusionPartitionAppPrivileges;
  /** update multiples rows of table: "qx.PersonIntrusionPartitionAppPrivileges" */
  update_personIntrusionPartitionAppPrivileges_many?: Array<personIntrusionPartitionAppPrivileges_mutation_response>;
  /** update data of the table: "qx.PersonPlaceAppPrivileges" */
  update_personPlaceAppPrivileges?: personPlaceAppPrivileges_mutation_response;
  /** update single row of the table: "qx.PersonPlaceAppPrivileges" */
  update_personPlaceAppPrivileges_by_pk?: personPlaceAppPrivileges;
  /** update multiples rows of table: "qx.PersonPlaceAppPrivileges" */
  update_personPlaceAppPrivileges_many?: Array<personPlaceAppPrivileges_mutation_response>;
  /** update data of the table: "audit.v_PersonToGroupAudit" */
  update_personToGroupAudit?: personToGroupAudit_mutation_response;
  /** update multiples rows of table: "audit.v_PersonToGroupAudit" */
  update_personToGroupAudit_many?: Array<personToGroupAudit_mutation_response>;
  /** update data of the table: "qx.PersonVideoSourceAppPrivileges" */
  update_personVideoSourceAppPrivileges?: personVideoSourceAppPrivileges_mutation_response;
  /** update single row of the table: "qx.PersonVideoSourceAppPrivileges" */
  update_personVideoSourceAppPrivileges_by_pk?: personVideoSourceAppPrivileges;
  /** update multiples rows of table: "qx.PersonVideoSourceAppPrivileges" */
  update_personVideoSourceAppPrivileges_many?: Array<personVideoSourceAppPrivileges_mutation_response>;
  /** update data of the table: "audit.vPlaceAudit" */
  update_placeAudit?: placeAudit_mutation_response;
  /** update multiples rows of table: "audit.vPlaceAudit" */
  update_placeAudit_many?: Array<placeAudit_mutation_response>;
  /** update data of the table: "qx.PlaceWhitelist" */
  update_placeWhiteLists?: placeWhiteLists_mutation_response;
  /** update single row of the table: "qx.PlaceWhitelist" */
  update_placeWhiteLists_by_pk?: placeWhiteLists;
  /** update multiples rows of table: "qx.PlaceWhitelist" */
  update_placeWhiteLists_many?: Array<placeWhiteLists_mutation_response>;
  /** update data of the table: "audit.v_PrivilegeEnumToRoleAudit" */
  update_privilegeEnumToRoleAudit?: privilegeEnumToRoleAudit_mutation_response;
  /** update multiples rows of table: "audit.v_PrivilegeEnumToRoleAudit" */
  update_privilegeEnumToRoleAudit_many?: Array<privilegeEnumToRoleAudit_mutation_response>;
  /** update data of the table: "qx.AccessCatalogCapabilities" */
  update_qx_AccessCatalogCapabilities?: qx_AccessCatalogCapabilities_mutation_response;
  /** update single row of the table: "qx.AccessCatalogCapabilities" */
  update_qx_AccessCatalogCapabilities_by_pk?: qx_AccessCatalogCapabilities;
  /** update multiples rows of table: "qx.AccessCatalogCapabilities" */
  update_qx_AccessCatalogCapabilities_many?: Array<qx_AccessCatalogCapabilities_mutation_response>;
  /** update multiples rows of table: "qx.AccessCatalog" */
  update_qx_AccessCatalog_many?: Array<qx_AccessCatalog_mutation_response>;
  /** update multiples rows of table: "qx.AccessInventory" */
  update_qx_AccessInventory_many?: Array<qx_AccessInventory_mutation_response>;
  /** update multiples rows of table: "qx.AudioSource" */
  update_qx_AudioSource_many?: Array<qx_AudioSource_mutation_response>;
  /** update data of the table: "qx.AuditLog" */
  update_qx_AuditLog?: qx_AuditLog_mutation_response;
  /** update single row of the table: "qx.AuditLog" */
  update_qx_AuditLog_by_pk?: qx_AuditLog;
  /** update multiples rows of table: "qx.AuditLog" */
  update_qx_AuditLog_many?: Array<qx_AuditLog_mutation_response>;
  /** update data of the table: "qx.AuditableAction" */
  update_qx_AuditableAction?: qx_AuditableAction_mutation_response;
  /** update single row of the table: "qx.AuditableAction" */
  update_qx_AuditableAction_by_pk?: qx_AuditableAction;
  /** update multiples rows of table: "qx.AuditableAction" */
  update_qx_AuditableAction_many?: Array<qx_AuditableAction_mutation_response>;
  /** update data of the table: "qx.AuditableType" */
  update_qx_AuditableType?: qx_AuditableType_mutation_response;
  /** update single row of the table: "qx.AuditableType" */
  update_qx_AuditableType_by_pk?: qx_AuditableType;
  /** update multiples rows of table: "qx.AuditableType" */
  update_qx_AuditableType_many?: Array<qx_AuditableType_mutation_response>;
  /** update data of the table: "qx.BillingPeriod" */
  update_qx_BillingPeriod?: qx_BillingPeriod_mutation_response;
  /** update multiples rows of table: "qx.BillingPeriod" */
  update_qx_BillingPeriod_many?: Array<qx_BillingPeriod_mutation_response>;
  /** update data of the table: "qx.CatalogProtocolOverride" */
  update_qx_CatalogProtocolOverride?: qx_CatalogProtocolOverride_mutation_response;
  /** update single row of the table: "qx.CatalogProtocolOverride" */
  update_qx_CatalogProtocolOverride_by_pk?: qx_CatalogProtocolOverride;
  /** update multiples rows of table: "qx.CatalogProtocolOverride" */
  update_qx_CatalogProtocolOverride_many?: Array<qx_CatalogProtocolOverride_mutation_response>;
  /** update multiples rows of table: "qx.ChatUsageHistory" */
  update_qx_ChatUsageHistory_many?: Array<qx_ChatUsageHistory_mutation_response>;
  /** update data of the table: "qx.ClipAuditLog" */
  update_qx_ClipAuditLog?: qx_ClipAuditLog_mutation_response;
  /** update multiples rows of table: "qx.ClipAuditLog" */
  update_qx_ClipAuditLog_many?: Array<qx_ClipAuditLog_mutation_response>;
  /** update multiples rows of table: "qx.Clip" */
  update_qx_Clip_many?: Array<qx_Clip_mutation_response>;
  /** update data of the table: "qx.CloudStorageOptions" */
  update_qx_CloudStorageOptions?: qx_CloudStorageOptions_mutation_response;
  /** update multiples rows of table: "qx.CloudStorageOptions" */
  update_qx_CloudStorageOptions_many?: Array<qx_CloudStorageOptions_mutation_response>;
  /** update multiples rows of table: "qx.Credential" */
  update_qx_Credential_many?: Array<qx_Credential_mutation_response>;
  /** update data of the table: "qx.CustomerAuthProvider" */
  update_qx_CustomerAuthProvider?: qx_CustomerAuthProvider_mutation_response;
  /** update single row of the table: "qx.CustomerAuthProvider" */
  update_qx_CustomerAuthProvider_by_pk?: qx_CustomerAuthProvider;
  /** update multiples rows of table: "qx.CustomerAuthProvider" */
  update_qx_CustomerAuthProvider_many?: Array<qx_CustomerAuthProvider_mutation_response>;
  /** update multiples rows of table: "qx.CustomerPermission" */
  update_qx_CustomerPermission_many?: Array<qx_CustomerPermission_mutation_response>;
  /** update multiples rows of table: "qx.DeviceDIO" */
  update_qx_DeviceDIO_many?: Array<qx_DeviceDIO_mutation_response>;
  /** update multiples rows of table: "qx.Device" */
  update_qx_Device_many?: Array<qx_Device_mutation_response>;
  /** update data of the table: "qx.DiscoveryType" */
  update_qx_DiscoveryType?: qx_DiscoveryType_mutation_response;
  /** update single row of the table: "qx.DiscoveryType" */
  update_qx_DiscoveryType_by_pk?: qx_DiscoveryType;
  /** update multiples rows of table: "qx.DiscoveryType" */
  update_qx_DiscoveryType_many?: Array<qx_DiscoveryType_mutation_response>;
  /** update multiples rows of table: "qx.DoorConfiguration" */
  update_qx_DoorConfiguration_many?: Array<qx_DoorConfiguration_mutation_response>;
  /** update multiples rows of table: "qx.DoorMeta" */
  update_qx_DoorMeta_many?: Array<qx_DoorMeta_mutation_response>;
  /** update multiples rows of table: "qx.DoorTemplate" */
  update_qx_DoorTemplate_many?: Array<qx_DoorTemplate_mutation_response>;
  /** update multiples rows of table: "qx.Door" */
  update_qx_Door_many?: Array<qx_Door_mutation_response>;
  /** update single row of the table: "qx.EventType" */
  update_qx_EventType_by_pk?: qx_EventType;
  /** update multiples rows of table: "qx.EventType" */
  update_qx_EventType_many?: Array<qx_EventType_mutation_response>;
  /** update multiples rows of table: "qx.Event" */
  update_qx_Event_many?: Array<qx_Event_mutation_response>;
  /** update multiples rows of table: "qx.FlowTrace" */
  update_qx_FlowTrace_many?: Array<qx_FlowTrace_mutation_response>;
  /** update multiples rows of table: "qx.Flow" */
  update_qx_Flow_many?: Array<qx_Flow_mutation_response>;
  /** update multiples rows of table: "qx.GatewayBandwidthSchedule" */
  update_qx_GatewayBandwidthSchedule_many?: Array<qx_GatewayBandwidthSchedule_mutation_response>;
  /** update multiples rows of table: "qx.Gateway" */
  update_qx_Gateway_many?: Array<qx_Gateway_mutation_response>;
  /** update multiples rows of table: "qx.Group" */
  update_qx_Group_many?: Array<qx_Group_mutation_response>;
  /** update multiples rows of table: "qx.HolidaySet" */
  update_qx_HolidaySet_many?: Array<qx_HolidaySet_mutation_response>;
  /** update multiples rows of table: "qx.InputPoint" */
  update_qx_InputPoint_many?: Array<qx_InputPoint_mutation_response>;
  /** update data of the table: "qx.IntrusionAlarm" */
  update_qx_IntrusionAlarm?: qx_IntrusionAlarm_mutation_response;
  /** update single row of the table: "qx.IntrusionAlarm" */
  update_qx_IntrusionAlarm_by_pk?: qx_IntrusionAlarm;
  /** update multiples rows of table: "qx.IntrusionAlarm" */
  update_qx_IntrusionAlarm_many?: Array<qx_IntrusionAlarm_mutation_response>;
  /** update data of the table: "qx.IntrusionPartitionState" */
  update_qx_IntrusionPartitionState?: qx_IntrusionPartitionState_mutation_response;
  /** update single row of the table: "qx.IntrusionPartitionState" */
  update_qx_IntrusionPartitionState_by_pk?: qx_IntrusionPartitionState;
  /** update multiples rows of table: "qx.IntrusionPartitionState" */
  update_qx_IntrusionPartitionState_many?: Array<qx_IntrusionPartitionState_mutation_response>;
  /** update data of the table: "qx.IntrusionZoneState" */
  update_qx_IntrusionZoneState?: qx_IntrusionZoneState_mutation_response;
  /** update single row of the table: "qx.IntrusionZoneState" */
  update_qx_IntrusionZoneState_by_pk?: qx_IntrusionZoneState;
  /** update multiples rows of table: "qx.IntrusionZoneState" */
  update_qx_IntrusionZoneState_many?: Array<qx_IntrusionZoneState_mutation_response>;
  /** update multiples rows of table: "qx.Layout" */
  update_qx_Layout_many?: Array<qx_Layout_mutation_response>;
  /** update multiples rows of table: "qx.LensProfile" */
  update_qx_LensProfile_many?: Array<qx_LensProfile_mutation_response>;
  /** update multiples rows of table: "qx.Lock" */
  update_qx_Lock_many?: Array<qx_Lock_mutation_response>;
  /** update data of the table: "qx.MediaProfileRecording" */
  update_qx_MediaProfileRecording?: qx_MediaProfileRecording_mutation_response;
  /** update single row of the table: "qx.MediaProfileRecording" */
  update_qx_MediaProfileRecording_by_pk?: qx_MediaProfileRecording;
  /** update multiples rows of table: "qx.MediaProfileRecording" */
  update_qx_MediaProfileRecording_many?: Array<qx_MediaProfileRecording_mutation_response>;
  /** update multiples rows of table: "qx.MediaProfile" */
  update_qx_MediaProfile_many?: Array<qx_MediaProfile_mutation_response>;
  /** update multiples rows of table: "qx.MercuryControlPoint" */
  update_qx_MercuryControlPoint_many?: Array<qx_MercuryControlPoint_mutation_response>;
  /** update multiples rows of table: "qx.MercuryMonitorPoint" */
  update_qx_MercuryMonitorPoint_many?: Array<qx_MercuryMonitorPoint_mutation_response>;
  /** update multiples rows of table: "qx.OssIdAssignment" */
  update_qx_OssIdAssignment_many?: Array<qx_OssIdAssignment_mutation_response>;
  /** update data of the table: "qx.OssKey" */
  update_qx_OssKey?: qx_OssKey_mutation_response;
  /** update single row of the table: "qx.OssKey" */
  update_qx_OssKey_by_pk?: qx_OssKey;
  /** update multiples rows of table: "qx.OssKey" */
  update_qx_OssKey_many?: Array<qx_OssKey_mutation_response>;
  /** update multiples rows of table: "qx.OutputPoint" */
  update_qx_OutputPoint_many?: Array<qx_OutputPoint_mutation_response>;
  /** update multiples rows of table: "qx.Permission" */
  update_qx_Permission_many?: Array<qx_Permission_mutation_response>;
  /** update multiples rows of table: "qx.Person" */
  update_qx_Person_many?: Array<qx_Person_mutation_response>;
  /** update multiples rows of table: "qx.Place" */
  update_qx_Place_many?: Array<qx_Place_mutation_response>;
  /** update multiples rows of table: "qx.Reader" */
  update_qx_Reader_many?: Array<qx_Reader_mutation_response>;
  /** update multiples rows of table: "qx.Role" */
  update_qx_Role_many?: Array<qx_Role_mutation_response>;
  /** update multiples rows of table: "qx.RosslareConnection" */
  update_qx_RosslareConnection_many?: Array<qx_RosslareConnection_mutation_response>;
  /** update multiples rows of table: "qx.ScheduleBlock" */
  update_qx_ScheduleBlock_many?: Array<qx_ScheduleBlock_mutation_response>;
  /** update multiples rows of table: "qx.Schedule" */
  update_qx_Schedule_many?: Array<qx_Schedule_mutation_response>;
  /** update multiples rows of table: "qx.Segment" */
  update_qx_Segment_many?: Array<qx_Segment_mutation_response>;
  /** update multiples rows of table: "qx.Sensor" */
  update_qx_Sensor_many?: Array<qx_Sensor_mutation_response>;
  /** update data of the table: "qx.SharedLinkAuditLog" */
  update_qx_SharedLinkAuditLog?: qx_SharedLinkAuditLog_mutation_response;
  /** update multiples rows of table: "qx.SharedLinkAuditLog" */
  update_qx_SharedLinkAuditLog_many?: Array<qx_SharedLinkAuditLog_mutation_response>;
  /** update data of the table: "qx.SharedLinkType" */
  update_qx_SharedLinkType?: qx_SharedLinkType_mutation_response;
  /** update single row of the table: "qx.SharedLinkType" */
  update_qx_SharedLinkType_by_pk?: qx_SharedLinkType;
  /** update multiples rows of table: "qx.SharedLinkType" */
  update_qx_SharedLinkType_many?: Array<qx_SharedLinkType_mutation_response>;
  /** update multiples rows of table: "qx.SharedLinks" */
  update_qx_SharedLinks_many?: Array<qx_SharedLinks_mutation_response>;
  /** update multiples rows of table: "qx.Snapshot" */
  update_qx_Snapshot_many?: Array<qx_Snapshot_mutation_response>;
  /** update multiples rows of table: "qx.TermsAgreement" */
  update_qx_TermsAgreement_many?: Array<qx_TermsAgreement_mutation_response>;
  /** update multiples rows of table: "qx.TimeZone" */
  update_qx_TimeZone_many?: Array<qx_TimeZone_mutation_response>;
  /** update multiples rows of table: "qx.UserSetting" */
  update_qx_UserSetting_many?: Array<qx_UserSetting_mutation_response>;
  /** update data of the table: "qx.VideoSourceStorageAudit" */
  update_qx_VideoSourceStorageAudit?: qx_VideoSourceStorageAudit_mutation_response;
  /** update single row of the table: "qx.VideoSourceStorageAudit" */
  update_qx_VideoSourceStorageAudit_by_pk?: qx_VideoSourceStorageAudit;
  /** update multiples rows of table: "qx.VideoSourceStorageAudit" */
  update_qx_VideoSourceStorageAudit_many?: Array<qx_VideoSourceStorageAudit_mutation_response>;
  /** update multiples rows of table: "qx.VideoSource" */
  update_qx_VideoSource_many?: Array<qx_VideoSource_mutation_response>;
  /** update multiples rows of table: "qx.View" */
  update_qx_View_many?: Array<qx_View_mutation_response>;
  /** update multiples rows of table: "qx.WiegandCardFormat" */
  update_qx_WiegandCardFormat_many?: Array<qx_WiegandCardFormat_mutation_response>;
  /** update multiples rows of table: "qx._HolidaySetToScheduleBlock" */
  update_qx__HolidaySetToScheduleBlock_many?: Array<qx__HolidaySetToScheduleBlock_mutation_response>;
  /** update multiples rows of table: "qx._PersonToGroup" */
  update_qx__PersonToGroup_many?: Array<qx__PersonToGroup_mutation_response>;
  /** update multiples rows of table: "qx._PrivilegeEnumToRole" */
  update_qx__PrivilegeEnumToRole_many?: Array<qx__PrivilegeEnumToRole_mutation_response>;
  /** update multiples rows of table: "qx.eAccessBoardType" */
  update_qx_eAccessBoardType_many?: Array<qx_eAccessBoardType_mutation_response>;
  /** update multiples rows of table: "qx.eAccessDeniedReason" */
  update_qx_eAccessDeniedReason_many?: Array<qx_eAccessDeniedReason_mutation_response>;
  /** update multiples rows of table: "qx.eAccessInterfaceType" */
  update_qx_eAccessInterfaceType_many?: Array<qx_eAccessInterfaceType_mutation_response>;
  /** update data of the table: "qx.eAccessMake" */
  update_qx_eAccessMake?: qx_eAccessMake_mutation_response;
  /** update single row of the table: "qx.eAccessMake" */
  update_qx_eAccessMake_by_pk?: qx_eAccessMake;
  /** update multiples rows of table: "qx.eAccessMake" */
  update_qx_eAccessMake_many?: Array<qx_eAccessMake_mutation_response>;
  /** update multiples rows of table: "qx.eAccessPointAction" */
  update_qx_eAccessPointAction_many?: Array<qx_eAccessPointAction_mutation_response>;
  /** update multiples rows of table: "qx.eAccessPointDirection" */
  update_qx_eAccessPointDirection_many?: Array<qx_eAccessPointDirection_mutation_response>;
  /** update multiples rows of table: "qx.eAccessPointType" */
  update_qx_eAccessPointType_many?: Array<qx_eAccessPointType_mutation_response>;
  /** update data of the table: "qx.eAppPrivilegeType" */
  update_qx_eAppPrivilegeType?: qx_eAppPrivilegeType_mutation_response;
  /** update single row of the table: "qx.eAppPrivilegeType" */
  update_qx_eAppPrivilegeType_by_pk?: qx_eAppPrivilegeType;
  /** update multiples rows of table: "qx.eAppPrivilegeType" */
  update_qx_eAppPrivilegeType_many?: Array<qx_eAppPrivilegeType_mutation_response>;
  /** update data of the table: "qx.eAuthProvider" */
  update_qx_eAuthProvider?: qx_eAuthProvider_mutation_response;
  /** update single row of the table: "qx.eAuthProvider" */
  update_qx_eAuthProvider_by_pk?: qx_eAuthProvider;
  /** update multiples rows of table: "qx.eAuthProvider" */
  update_qx_eAuthProvider_many?: Array<qx_eAuthProvider_mutation_response>;
  /** update multiples rows of table: "qx.eAuthStrategy" */
  update_qx_eAuthStrategy_many?: Array<qx_eAuthStrategy_mutation_response>;
  /** update multiples rows of table: "qx.eBatteryLevel" */
  update_qx_eBatteryLevel_many?: Array<qx_eBatteryLevel_mutation_response>;
  /** update multiples rows of table: "qx.eBaudrate" */
  update_qx_eBaudrate_many?: Array<qx_eBaudrate_mutation_response>;
  /** update multiples rows of table: "qx.eBillingTier" */
  update_qx_eBillingTier_many?: Array<qx_eBillingTier_mutation_response>;
  /** update multiples rows of table: "qx.eClipStatus" */
  update_qx_eClipStatus_many?: Array<qx_eClipStatus_mutation_response>;
  /** update multiples rows of table: "qx.eClipType" */
  update_qx_eClipType_many?: Array<qx_eClipType_mutation_response>;
  /** update multiples rows of table: "qx.eCredentialType" */
  update_qx_eCredentialType_many?: Array<qx_eCredentialType_mutation_response>;
  /** update multiples rows of table: "qx.eDIONormalState" */
  update_qx_eDIONormalState_many?: Array<qx_eDIONormalState_mutation_response>;
  /** update multiples rows of table: "qx.eDIOState" */
  update_qx_eDIOState_many?: Array<qx_eDIOState_mutation_response>;
  /** update multiples rows of table: "qx.eDIOType" */
  update_qx_eDIOType_many?: Array<qx_eDIOType_mutation_response>;
  /** update multiples rows of table: "qx.eDeviceConnectionStatus" */
  update_qx_eDeviceConnectionStatus_many?: Array<qx_eDeviceConnectionStatus_mutation_response>;
  /** update multiples rows of table: "qx.eDeviceKind" */
  update_qx_eDeviceKind_many?: Array<qx_eDeviceKind_mutation_response>;
  /** update multiples rows of table: "qx.eDoorAlarm" */
  update_qx_eDoorAlarm_many?: Array<qx_eDoorAlarm_mutation_response>;
  /** update multiples rows of table: "qx.eDoorMode" */
  update_qx_eDoorMode_many?: Array<qx_eDoorMode_mutation_response>;
  /** update multiples rows of table: "qx.eDoorMonitor" */
  update_qx_eDoorMonitor_many?: Array<qx_eDoorMonitor_mutation_response>;
  /** update multiples rows of table: "qx.eDoorState" */
  update_qx_eDoorState_many?: Array<qx_eDoorState_mutation_response>;
  /** update multiples rows of table: "qx.eFlowNotificationType" */
  update_qx_eFlowNotificationType_many?: Array<qx_eFlowNotificationType_mutation_response>;
  /** update data of the table: "qx.eFlowStatus" */
  update_qx_eFlowStatus?: qx_eFlowStatus_mutation_response;
  /** update single row of the table: "qx.eFlowStatus" */
  update_qx_eFlowStatus_by_pk?: qx_eFlowStatus;
  /** update multiples rows of table: "qx.eFlowStatus" */
  update_qx_eFlowStatus_many?: Array<qx_eFlowStatus_mutation_response>;
  /** update data of the table: "qx.eFlowTraceActionStatus" */
  update_qx_eFlowTraceActionStatus?: qx_eFlowTraceActionStatus_mutation_response;
  /** update single row of the table: "qx.eFlowTraceActionStatus" */
  update_qx_eFlowTraceActionStatus_by_pk?: qx_eFlowTraceActionStatus;
  /** update multiples rows of table: "qx.eFlowTraceActionStatus" */
  update_qx_eFlowTraceActionStatus_many?: Array<qx_eFlowTraceActionStatus_mutation_response>;
  /** update data of the table: "qx.eFlowTraceState" */
  update_qx_eFlowTraceState?: qx_eFlowTraceState_mutation_response;
  /** update single row of the table: "qx.eFlowTraceState" */
  update_qx_eFlowTraceState_by_pk?: qx_eFlowTraceState;
  /** update multiples rows of table: "qx.eFlowTraceState" */
  update_qx_eFlowTraceState_many?: Array<qx_eFlowTraceState_mutation_response>;
  /** update multiples rows of table: "qx.eGatewayServiceType" */
  update_qx_eGatewayServiceType_many?: Array<qx_eGatewayServiceType_mutation_response>;
  /** update multiples rows of table: "qx.eGatewaySyncStatus" */
  update_qx_eGatewaySyncStatus_many?: Array<qx_eGatewaySyncStatus_mutation_response>;
  /** update data of the table: "qx.eIntrusionZoneType" */
  update_qx_eIntrusionZoneType?: qx_eIntrusionZoneType_mutation_response;
  /** update single row of the table: "qx.eIntrusionZoneType" */
  update_qx_eIntrusionZoneType_by_pk?: qx_eIntrusionZoneType;
  /** update multiples rows of table: "qx.eIntrusionZoneType" */
  update_qx_eIntrusionZoneType_many?: Array<qx_eIntrusionZoneType_mutation_response>;
  /** update multiples rows of table: "qx.eKeypadMode" */
  update_qx_eKeypadMode_many?: Array<qx_eKeypadMode_mutation_response>;
  /** update data of the table: "qx.eLockMode" */
  update_qx_eLockMode?: qx_eLockMode_mutation_response;
  /** update single row of the table: "qx.eLockMode" */
  update_qx_eLockMode_by_pk?: qx_eLockMode;
  /** update multiples rows of table: "qx.eLockMode" */
  update_qx_eLockMode_many?: Array<qx_eLockMode_mutation_response>;
  /** update multiples rows of table: "qx.eLockPowerMonitor" */
  update_qx_eLockPowerMonitor_many?: Array<qx_eLockPowerMonitor_mutation_response>;
  /** update multiples rows of table: "qx.eLockRelayMonitor" */
  update_qx_eLockRelayMonitor_many?: Array<qx_eLockRelayMonitor_mutation_response>;
  /** update multiples rows of table: "qx.eLockType" */
  update_qx_eLockType_many?: Array<qx_eLockType_mutation_response>;
  /** update data of the table: "qx.eMercuryMonitorPointLatchModes" */
  update_qx_eMercuryMonitorPointLatchModes?: qx_eMercuryMonitorPointLatchModes_mutation_response;
  /** update single row of the table: "qx.eMercuryMonitorPointLatchModes" */
  update_qx_eMercuryMonitorPointLatchModes_by_pk?: qx_eMercuryMonitorPointLatchModes;
  /** update multiples rows of table: "qx.eMercuryMonitorPointLatchModes" */
  update_qx_eMercuryMonitorPointLatchModes_many?: Array<qx_eMercuryMonitorPointLatchModes_mutation_response>;
  /** update multiples rows of table: "qx.eMonitorLockState" */
  update_qx_eMonitorLockState_many?: Array<qx_eMonitorLockState_mutation_response>;
  /** update multiples rows of table: "qx.eMountPosition" */
  update_qx_eMountPosition_many?: Array<qx_eMountPosition_mutation_response>;
  /** update multiples rows of table: "qx.eObjectAction" */
  update_qx_eObjectAction_many?: Array<qx_eObjectAction_mutation_response>;
  /** update multiples rows of table: "qx.ePACSStatus" */
  update_qx_ePACSStatus_many?: Array<qx_ePACSStatus_mutation_response>;
  /** update multiples rows of table: "qx.ePersonStatus" */
  update_qx_ePersonStatus_many?: Array<qx_ePersonStatus_mutation_response>;
  /** update multiples rows of table: "qx.ePlaceType" */
  update_qx_ePlaceType_many?: Array<qx_ePlaceType_mutation_response>;
  /** update multiples rows of table: "qx.ePrivilege" */
  update_qx_ePrivilege_many?: Array<qx_ePrivilege_mutation_response>;
  /** update multiples rows of table: "qx.eReaderAccessType" */
  update_qx_eReaderAccessType_many?: Array<qx_eReaderAccessType_mutation_response>;
  /** update multiples rows of table: "qx.eReaderProtocol" */
  update_qx_eReaderProtocol_many?: Array<qx_eReaderProtocol_mutation_response>;
  /** update multiples rows of table: "qx.eRexState" */
  update_qx_eRexState_many?: Array<qx_eRexState_mutation_response>;
  /** update multiples rows of table: "qx.eSensorAction" */
  update_qx_eSensorAction_many?: Array<qx_eSensorAction_mutation_response>;
  /** update multiples rows of table: "qx.eSensorType" */
  update_qx_eSensorType_many?: Array<qx_eSensorType_mutation_response>;
  /** update multiples rows of table: "qx.eStreamStatus" */
  update_qx_eStreamStatus_many?: Array<qx_eStreamStatus_mutation_response>;
  /** update multiples rows of table: "qx.eSuperviseInputs" */
  update_qx_eSuperviseInputs_many?: Array<qx_eSuperviseInputs_mutation_response>;
  /** update data of the table: "qx.vPlacePrivilege" */
  update_qx_vPlacePrivilege?: qx_vPlacePrivilege_mutation_response;
  /** update multiples rows of table: "qx.vPlacePrivilege" */
  update_qx_vPlacePrivilege_many?: Array<qx_vPlacePrivilege_mutation_response>;
  /** update data of the table: "qx.vProfiles" */
  update_qx_vProfiles?: qx_vProfiles_mutation_response;
  /** update multiples rows of table: "qx.vProfiles" */
  update_qx_vProfiles_many?: Array<qx_vProfiles_mutation_response>;
  /** update data of the table: "qxanalytics.CloudUsage" */
  update_qxanalytics_CloudUsage?: qxanalytics_CloudUsage_mutation_response;
  /** update multiples rows of table: "qxanalytics.CloudUsage" */
  update_qxanalytics_CloudUsage_many?: Array<qxanalytics_CloudUsage_mutation_response>;
  /** update data of the table: "qx.ReaderAccessTypeCompatibility" */
  update_readerAccessTypeCompatibility?: readerAccessTypeCompatibility_mutation_response;
  /** update single row of the table: "qx.ReaderAccessTypeCompatibility" */
  update_readerAccessTypeCompatibility_by_pk?: readerAccessTypeCompatibility;
  /** update multiples rows of table: "qx.ReaderAccessTypeCompatibility" */
  update_readerAccessTypeCompatibility_many?: Array<readerAccessTypeCompatibility_mutation_response>;
  /** update data of the table: "audit.vReaderAudit" */
  update_readerAudit?: readerAudit_mutation_response;
  /** update multiples rows of table: "audit.vReaderAudit" */
  update_readerAudit_many?: Array<readerAudit_mutation_response>;
  /** update data of the table: "qx.ReaderProtocolCompatibility" */
  update_readerProtocolCompatibility?: readerProtocolCompatibility_mutation_response;
  /** update single row of the table: "qx.ReaderProtocolCompatibility" */
  update_readerProtocolCompatibility_by_pk?: readerProtocolCompatibility;
  /** update multiples rows of table: "qx.ReaderProtocolCompatibility" */
  update_readerProtocolCompatibility_many?: Array<readerProtocolCompatibility_mutation_response>;
  /** update data of the table: "qx.RoleAppPrivileges" */
  update_roleAppPrivileges?: roleAppPrivileges_mutation_response;
  /** update single row of the table: "qx.RoleAppPrivileges" */
  update_roleAppPrivileges_by_pk?: roleAppPrivileges;
  /** update multiples rows of table: "qx.RoleAppPrivileges" */
  update_roleAppPrivileges_many?: Array<roleAppPrivileges_mutation_response>;
  /** update data of the table: "audit.vRoleAudit" */
  update_roleAudit?: roleAudit_mutation_response;
  /** update multiples rows of table: "audit.vRoleAudit" */
  update_roleAudit_many?: Array<roleAudit_mutation_response>;
  /** update data of the table: "qx.RosslareCatalog" */
  update_rosslareCatalogs?: rosslareCatalogs_mutation_response;
  /** update single row of the table: "qx.RosslareCatalog" */
  update_rosslareCatalogs_by_pk?: rosslareCatalogs;
  /** update multiples rows of table: "qx.RosslareCatalog" */
  update_rosslareCatalogs_many?: Array<rosslareCatalogs_mutation_response>;
  /** update data of the table: "qx.S3BucketConfiguration" */
  update_s3BucketConfigurations?: s3BucketConfigurations_mutation_response;
  /** update single row of the table: "qx.S3BucketConfiguration" */
  update_s3BucketConfigurations_by_pk?: s3BucketConfigurations;
  /** update multiples rows of table: "qx.S3BucketConfiguration" */
  update_s3BucketConfigurations_many?: Array<s3BucketConfigurations_mutation_response>;
  /** update data of the table: "audit.vScheduleAudit" */
  update_scheduleAudit?: scheduleAudit_mutation_response;
  /** update multiples rows of table: "audit.vScheduleAudit" */
  update_scheduleAudit_many?: Array<scheduleAudit_mutation_response>;
  /** update data of the table: "audit.vScheduleBlockAudit" */
  update_scheduleBlockAudit?: scheduleBlockAudit_mutation_response;
  /** update multiples rows of table: "audit.vScheduleBlockAudit" */
  update_scheduleBlockAudit_many?: Array<scheduleBlockAudit_mutation_response>;
  /** update data of the table: "qx.SuperviseInputCompatibility" */
  update_superviseInputCompatibility?: superviseInputCompatibility_mutation_response;
  /** update single row of the table: "qx.SuperviseInputCompatibility" */
  update_superviseInputCompatibility_by_pk?: superviseInputCompatibility;
  /** update multiples rows of table: "qx.SuperviseInputCompatibility" */
  update_superviseInputCompatibility_many?: Array<superviseInputCompatibility_mutation_response>;
  /** update data of the table: "audit.vVideoSourceAudit" */
  update_videoSourceAudit?: videoSourceAudit_mutation_response;
  /** update multiples rows of table: "audit.vVideoSourceAudit" */
  update_videoSourceAudit_many?: Array<videoSourceAudit_mutation_response>;
  /** update data of the table: "qx.VideoSourceState" */
  update_videoSourceState?: videoSourceState_mutation_response;
  /** update single row of the table: "qx.VideoSourceState" */
  update_videoSourceState_by_pk?: videoSourceState;
  /** update multiples rows of table: "qx.VideoSourceState" */
  update_videoSourceState_many?: Array<videoSourceState_mutation_response>;
  upgradePremGateway: SuccessResponse;
  /** upgradeRosslareFirmware */
  upgradeRosslareFirmware: SuccessOutput;
  validateHardware: ValidateHardwareResult;
  /** validateSoftware */
  validateSoftware: ValidateHardwareResult;
};


/** mutation root */
export type mutation_root_deleteGatewayArgs = {
  id: string;
};


/** mutation root */
export type mutation_root_deleteGatewaysArgs = {
  where: qx_Gateway_bool_exp;
};


/** mutation root */
export type mutation_rootacceptTermsOfAgreementArgs = {
  termsID: string;
};


/** mutation root */
export type mutation_rootaccessDoorArgs = {
  accessTime?: string;
  doorID: string;
  extended?: boolean;
};


/** mutation root */
export type mutation_rootaccessReportArgs = {
  filter?: AccessReportFilterInput;
  limit?: number;
  offset?: number;
  options?: AccessReportOptionsInput;
  orderBy?: Array<AccessReportOrderByInput>;
  type: ReportType;
};


/** mutation root */
export type mutation_rootaccessReportInfoArgs = {
  type: ReportType;
};


/** mutation root */
export type mutation_rootactivateOutputArgs = {
  deviceDIORefID?: string;
  deviceID?: string;
  outputPointID?: string;
};


/** mutation root */
export type mutation_rootarmPartitionArgs = {
  armMode: IntrusionArmMode;
  deviceID: string;
  partitionID: string;
};


/** mutation root */
export type mutation_rootblockDoorArgs = {
  doorID: string;
};


/** mutation root */
export type mutation_rootbypassZoneArgs = {
  deviceID: string;
  zoneID: string;
};


/** mutation root */
export type mutation_rootcancelPendingBillingDowngradeArgs = {
  placeID: string;
};


/** mutation root */
export type mutation_rootclearFlowStatusArgs = {
  flowID: string;
};


/** mutation root */
export type mutation_rootcloudPeerOfferArgs = {
  gatewayID?: string;
  iceServers?: Array<IceServerInput>;
  sdp: string;
  trickle?: boolean;
};


/** mutation root */
export type mutation_rootcloudPushCandidateArgs = {
  candidate: string;
  gatewayID?: string;
  id: number;
};


/** mutation root */
export type mutation_rootcreateAccessBoardTypeEnumArgs = {
  object: qx_eAccessBoardType_insert_input;
  on_conflict?: qx_eAccessBoardType_on_conflict;
};


/** mutation root */
export type mutation_rootcreateAccessBoardTypeEnumsArgs = {
  objects: Array<qx_eAccessBoardType_insert_input>;
  on_conflict?: qx_eAccessBoardType_on_conflict;
};


/** mutation root */
export type mutation_rootcreateAccessCatalogArgs = {
  object: qx_AccessCatalog_insert_input;
  on_conflict?: qx_AccessCatalog_on_conflict;
};


/** mutation root */
export type mutation_rootcreateAccessCatalogsArgs = {
  objects: Array<qx_AccessCatalog_insert_input>;
  on_conflict?: qx_AccessCatalog_on_conflict;
};


/** mutation root */
export type mutation_rootcreateAccessDeniedReasonEnumArgs = {
  object: qx_eAccessDeniedReason_insert_input;
  on_conflict?: qx_eAccessDeniedReason_on_conflict;
};


/** mutation root */
export type mutation_rootcreateAccessDeniedReasonEnumsArgs = {
  objects: Array<qx_eAccessDeniedReason_insert_input>;
  on_conflict?: qx_eAccessDeniedReason_on_conflict;
};


/** mutation root */
export type mutation_rootcreateAccessInterfaceTypeEnumArgs = {
  object: qx_eAccessInterfaceType_insert_input;
  on_conflict?: qx_eAccessInterfaceType_on_conflict;
};


/** mutation root */
export type mutation_rootcreateAccessInterfaceTypeEnumsArgs = {
  objects: Array<qx_eAccessInterfaceType_insert_input>;
  on_conflict?: qx_eAccessInterfaceType_on_conflict;
};


/** mutation root */
export type mutation_rootcreateAccessInventoriesArgs = {
  objects: Array<qx_AccessInventory_insert_input>;
  on_conflict?: qx_AccessInventory_on_conflict;
};


/** mutation root */
export type mutation_rootcreateAccessInventoryArgs = {
  object: qx_AccessInventory_insert_input;
  on_conflict?: qx_AccessInventory_on_conflict;
};


/** mutation root */
export type mutation_rootcreateAccessPointActionEnumArgs = {
  object: qx_eAccessPointAction_insert_input;
  on_conflict?: qx_eAccessPointAction_on_conflict;
};


/** mutation root */
export type mutation_rootcreateAccessPointActionEnumsArgs = {
  objects: Array<qx_eAccessPointAction_insert_input>;
  on_conflict?: qx_eAccessPointAction_on_conflict;
};


/** mutation root */
export type mutation_rootcreateAccessPointDirectionEnumArgs = {
  object: qx_eAccessPointDirection_insert_input;
  on_conflict?: qx_eAccessPointDirection_on_conflict;
};


/** mutation root */
export type mutation_rootcreateAccessPointDirectionEnumsArgs = {
  objects: Array<qx_eAccessPointDirection_insert_input>;
  on_conflict?: qx_eAccessPointDirection_on_conflict;
};


/** mutation root */
export type mutation_rootcreateAccessPointTypeEnumArgs = {
  object: qx_eAccessPointType_insert_input;
  on_conflict?: qx_eAccessPointType_on_conflict;
};


/** mutation root */
export type mutation_rootcreateAccessPointTypeEnumsArgs = {
  objects: Array<qx_eAccessPointType_insert_input>;
  on_conflict?: qx_eAccessPointType_on_conflict;
};


/** mutation root */
export type mutation_rootcreateApiAppPasswordArgs = {
  label: string;
  personID: string;
};


/** mutation root */
export type mutation_rootcreateAppPasswordArgs = {
  label: string;
};


/** mutation root */
export type mutation_rootcreateAudioSourceArgs = {
  object: qx_AudioSource_insert_input;
  on_conflict?: qx_AudioSource_on_conflict;
};


/** mutation root */
export type mutation_rootcreateAudioSourcesArgs = {
  objects: Array<qx_AudioSource_insert_input>;
  on_conflict?: qx_AudioSource_on_conflict;
};


/** mutation root */
export type mutation_rootcreateAuthStrategyEnumArgs = {
  object: qx_eAuthStrategy_insert_input;
  on_conflict?: qx_eAuthStrategy_on_conflict;
};


/** mutation root */
export type mutation_rootcreateAuthStrategyEnumsArgs = {
  objects: Array<qx_eAuthStrategy_insert_input>;
  on_conflict?: qx_eAuthStrategy_on_conflict;
};


/** mutation root */
export type mutation_rootcreateBatteryLevelEnumArgs = {
  object: qx_eBatteryLevel_insert_input;
  on_conflict?: qx_eBatteryLevel_on_conflict;
};


/** mutation root */
export type mutation_rootcreateBatteryLevelEnumsArgs = {
  objects: Array<qx_eBatteryLevel_insert_input>;
  on_conflict?: qx_eBatteryLevel_on_conflict;
};


/** mutation root */
export type mutation_rootcreateBaudrateEnumArgs = {
  object: qx_eBaudrate_insert_input;
  on_conflict?: qx_eBaudrate_on_conflict;
};


/** mutation root */
export type mutation_rootcreateBaudrateEnumsArgs = {
  objects: Array<qx_eBaudrate_insert_input>;
  on_conflict?: qx_eBaudrate_on_conflict;
};


/** mutation root */
export type mutation_rootcreateBillingPeriodArgs = {
  object: qx_BillingPeriod_insert_input;
  on_conflict?: qx_BillingPeriod_on_conflict;
};


/** mutation root */
export type mutation_rootcreateBillingTierEnumArgs = {
  object: qx_eBillingTier_insert_input;
  on_conflict?: qx_eBillingTier_on_conflict;
};


/** mutation root */
export type mutation_rootcreateBillingTierEnumsArgs = {
  objects: Array<qx_eBillingTier_insert_input>;
  on_conflict?: qx_eBillingTier_on_conflict;
};


/** mutation root */
export type mutation_rootcreateChatUsageHistoriesArgs = {
  objects: Array<qx_ChatUsageHistory_insert_input>;
  on_conflict?: qx_ChatUsageHistory_on_conflict;
};


/** mutation root */
export type mutation_rootcreateChatUsageHistoryArgs = {
  object: qx_ChatUsageHistory_insert_input;
  on_conflict?: qx_ChatUsageHistory_on_conflict;
};


/** mutation root */
export type mutation_rootcreateClipArgs = {
  object: qx_Clip_insert_input;
  on_conflict?: qx_Clip_on_conflict;
};


/** mutation root */
export type mutation_rootcreateClipStatusEnumArgs = {
  object: qx_eClipStatus_insert_input;
  on_conflict?: qx_eClipStatus_on_conflict;
};


/** mutation root */
export type mutation_rootcreateClipStatusEnumsArgs = {
  objects: Array<qx_eClipStatus_insert_input>;
  on_conflict?: qx_eClipStatus_on_conflict;
};


/** mutation root */
export type mutation_rootcreateClipTypeEnumArgs = {
  object: qx_eClipType_insert_input;
  on_conflict?: qx_eClipType_on_conflict;
};


/** mutation root */
export type mutation_rootcreateClipTypeEnumsArgs = {
  objects: Array<qx_eClipType_insert_input>;
  on_conflict?: qx_eClipType_on_conflict;
};


/** mutation root */
export type mutation_rootcreateClipsArgs = {
  objects: Array<qx_Clip_insert_input>;
  on_conflict?: qx_Clip_on_conflict;
};


/** mutation root */
export type mutation_rootcreateCloudStorageOptionArgs = {
  object: qx_CloudStorageOptions_insert_input;
  on_conflict?: qx_CloudStorageOptions_on_conflict;
};


/** mutation root */
export type mutation_rootcreateCredentialArgs = {
  object: qx_Credential_insert_input;
  on_conflict?: qx_Credential_on_conflict;
};


/** mutation root */
export type mutation_rootcreateCredentialTypeEnumArgs = {
  object: qx_eCredentialType_insert_input;
  on_conflict?: qx_eCredentialType_on_conflict;
};


/** mutation root */
export type mutation_rootcreateCredentialTypeEnumsArgs = {
  objects: Array<qx_eCredentialType_insert_input>;
  on_conflict?: qx_eCredentialType_on_conflict;
};


/** mutation root */
export type mutation_rootcreateCredentialsArgs = {
  objects: Array<qx_Credential_insert_input>;
  on_conflict?: qx_Credential_on_conflict;
};


/** mutation root */
export type mutation_rootcreateCustomerPermissionArgs = {
  object: qx_CustomerPermission_insert_input;
  on_conflict?: qx_CustomerPermission_on_conflict;
};


/** mutation root */
export type mutation_rootcreateCustomerPermissionsArgs = {
  objects: Array<qx_CustomerPermission_insert_input>;
  on_conflict?: qx_CustomerPermission_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDIONormalStateEnumArgs = {
  object: qx_eDIONormalState_insert_input;
  on_conflict?: qx_eDIONormalState_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDIONormalStateEnumsArgs = {
  objects: Array<qx_eDIONormalState_insert_input>;
  on_conflict?: qx_eDIONormalState_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDIOStateEnumArgs = {
  object: qx_eDIOState_insert_input;
  on_conflict?: qx_eDIOState_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDIOStateEnumsArgs = {
  objects: Array<qx_eDIOState_insert_input>;
  on_conflict?: qx_eDIOState_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDIOTypeEnumArgs = {
  object: qx_eDIOType_insert_input;
  on_conflict?: qx_eDIOType_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDIOTypeEnumsArgs = {
  objects: Array<qx_eDIOType_insert_input>;
  on_conflict?: qx_eDIOType_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDeviceArgs = {
  object: CreateDeviceInput;
};


/** mutation root */
export type mutation_rootcreateDeviceConnectionStatusEnumArgs = {
  object: qx_eDeviceConnectionStatus_insert_input;
  on_conflict?: qx_eDeviceConnectionStatus_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDeviceConnectionStatusEnumsArgs = {
  objects: Array<qx_eDeviceConnectionStatus_insert_input>;
  on_conflict?: qx_eDeviceConnectionStatus_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDeviceDIOArgs = {
  object: qx_DeviceDIO_insert_input;
  on_conflict?: qx_DeviceDIO_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDeviceDIOsArgs = {
  objects: Array<qx_DeviceDIO_insert_input>;
  on_conflict?: qx_DeviceDIO_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDeviceKindEnumArgs = {
  object: qx_eDeviceKind_insert_input;
  on_conflict?: qx_eDeviceKind_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDeviceKindEnumsArgs = {
  objects: Array<qx_eDeviceKind_insert_input>;
  on_conflict?: qx_eDeviceKind_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDevicesArgs = {
  objects: Array<CreateDeviceInput>;
};


/** mutation root */
export type mutation_rootcreateDoorArgs = {
  object: qx_Door_insert_input;
  on_conflict?: qx_Door_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDoorAlarmEnumArgs = {
  object: qx_eDoorAlarm_insert_input;
  on_conflict?: qx_eDoorAlarm_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDoorAlarmEnumsArgs = {
  objects: Array<qx_eDoorAlarm_insert_input>;
  on_conflict?: qx_eDoorAlarm_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDoorConfigurationArgs = {
  object: qx_DoorConfiguration_insert_input;
  on_conflict?: qx_DoorConfiguration_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDoorConfigurationsArgs = {
  objects: Array<qx_DoorConfiguration_insert_input>;
  on_conflict?: qx_DoorConfiguration_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDoorMetaArgs = {
  object: qx_DoorMeta_insert_input;
  on_conflict?: qx_DoorMeta_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDoorMetasArgs = {
  objects: Array<qx_DoorMeta_insert_input>;
  on_conflict?: qx_DoorMeta_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDoorModeEnumArgs = {
  object: qx_eDoorMode_insert_input;
  on_conflict?: qx_eDoorMode_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDoorModeEnumsArgs = {
  objects: Array<qx_eDoorMode_insert_input>;
  on_conflict?: qx_eDoorMode_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDoorMonitorEnumArgs = {
  object: qx_eDoorMonitor_insert_input;
  on_conflict?: qx_eDoorMonitor_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDoorMonitorEnumsArgs = {
  objects: Array<qx_eDoorMonitor_insert_input>;
  on_conflict?: qx_eDoorMonitor_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDoorStateEnumArgs = {
  object: qx_eDoorState_insert_input;
  on_conflict?: qx_eDoorState_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDoorStateEnumsArgs = {
  objects: Array<qx_eDoorState_insert_input>;
  on_conflict?: qx_eDoorState_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDoorTemplateArgs = {
  object: qx_DoorTemplate_insert_input;
  on_conflict?: qx_DoorTemplate_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDoorTemplatesArgs = {
  objects: Array<qx_DoorTemplate_insert_input>;
  on_conflict?: qx_DoorTemplate_on_conflict;
};


/** mutation root */
export type mutation_rootcreateDoorsArgs = {
  objects: Array<qx_Door_insert_input>;
  on_conflict?: qx_Door_on_conflict;
};


/** mutation root */
export type mutation_rootcreateEventArgs = {
  object: qx_Event_insert_input;
  on_conflict?: qx_Event_on_conflict;
};


/** mutation root */
export type mutation_rootcreateEventTypesArgs = {
  objects: Array<qx_EventType_insert_input>;
  on_conflict?: qx_EventType_on_conflict;
};


/** mutation root */
export type mutation_rootcreateEventsArgs = {
  objects: Array<qx_Event_insert_input>;
  on_conflict?: qx_Event_on_conflict;
};


/** mutation root */
export type mutation_rootcreateFlowArgs = {
  object: qx_Flow_insert_input;
  on_conflict?: qx_Flow_on_conflict;
};


/** mutation root */
export type mutation_rootcreateFlowNotificationTypeEnumArgs = {
  object: qx_eFlowNotificationType_insert_input;
  on_conflict?: qx_eFlowNotificationType_on_conflict;
};


/** mutation root */
export type mutation_rootcreateFlowNotificationTypeEnumsArgs = {
  objects: Array<qx_eFlowNotificationType_insert_input>;
  on_conflict?: qx_eFlowNotificationType_on_conflict;
};


/** mutation root */
export type mutation_rootcreateFlowTraceArgs = {
  object: qx_FlowTrace_insert_input;
  on_conflict?: qx_FlowTrace_on_conflict;
};


/** mutation root */
export type mutation_rootcreateFlowTracesArgs = {
  objects: Array<qx_FlowTrace_insert_input>;
  on_conflict?: qx_FlowTrace_on_conflict;
};


/** mutation root */
export type mutation_rootcreateFlowsArgs = {
  objects: Array<qx_Flow_insert_input>;
  on_conflict?: qx_Flow_on_conflict;
};


/** mutation root */
export type mutation_rootcreateGatewayArgs = {
  object: qx_Gateway_insert_input;
  on_conflict?: qx_Gateway_on_conflict;
};


/** mutation root */
export type mutation_rootcreateGatewayBandwidthScheduleArgs = {
  object: qx_GatewayBandwidthSchedule_insert_input;
  on_conflict?: qx_GatewayBandwidthSchedule_on_conflict;
};


/** mutation root */
export type mutation_rootcreateGatewayBandwidthSchedulesArgs = {
  objects: Array<qx_GatewayBandwidthSchedule_insert_input>;
  on_conflict?: qx_GatewayBandwidthSchedule_on_conflict;
};


/** mutation root */
export type mutation_rootcreateGatewayServiceTypeEnumArgs = {
  object: qx_eGatewayServiceType_insert_input;
  on_conflict?: qx_eGatewayServiceType_on_conflict;
};


/** mutation root */
export type mutation_rootcreateGatewayServiceTypeEnumsArgs = {
  objects: Array<qx_eGatewayServiceType_insert_input>;
  on_conflict?: qx_eGatewayServiceType_on_conflict;
};


/** mutation root */
export type mutation_rootcreateGatewaySyncStatusEnumArgs = {
  object: qx_eGatewaySyncStatus_insert_input;
  on_conflict?: qx_eGatewaySyncStatus_on_conflict;
};


/** mutation root */
export type mutation_rootcreateGatewaySyncStatusEnumsArgs = {
  objects: Array<qx_eGatewaySyncStatus_insert_input>;
  on_conflict?: qx_eGatewaySyncStatus_on_conflict;
};


/** mutation root */
export type mutation_rootcreateGatewaysArgs = {
  objects: Array<qx_Gateway_insert_input>;
  on_conflict?: qx_Gateway_on_conflict;
};


/** mutation root */
export type mutation_rootcreateGroupArgs = {
  object: qx_Group_insert_input;
  on_conflict?: qx_Group_on_conflict;
};


/** mutation root */
export type mutation_rootcreateGroupsArgs = {
  objects: Array<qx_Group_insert_input>;
  on_conflict?: qx_Group_on_conflict;
};


/** mutation root */
export type mutation_rootcreateHolidaySetArgs = {
  object: qx_HolidaySet_insert_input;
  on_conflict?: qx_HolidaySet_on_conflict;
};


/** mutation root */
export type mutation_rootcreateHolidaySetToScheduleBlockArgs = {
  object: qx__HolidaySetToScheduleBlock_insert_input;
  on_conflict?: qx__HolidaySetToScheduleBlock_on_conflict;
};


/** mutation root */
export type mutation_rootcreateHolidaySetToScheduleBlocksArgs = {
  objects: Array<qx__HolidaySetToScheduleBlock_insert_input>;
  on_conflict?: qx__HolidaySetToScheduleBlock_on_conflict;
};


/** mutation root */
export type mutation_rootcreateHolidaySetsArgs = {
  objects: Array<qx_HolidaySet_insert_input>;
  on_conflict?: qx_HolidaySet_on_conflict;
};


/** mutation root */
export type mutation_rootcreateInputPointArgs = {
  object: qx_InputPoint_insert_input;
  on_conflict?: qx_InputPoint_on_conflict;
};


/** mutation root */
export type mutation_rootcreateInputPointsArgs = {
  objects: Array<qx_InputPoint_insert_input>;
  on_conflict?: qx_InputPoint_on_conflict;
};


/** mutation root */
export type mutation_rootcreateKeyModeEnumArgs = {
  object: qx_eKeypadMode_insert_input;
  on_conflict?: qx_eKeypadMode_on_conflict;
};


/** mutation root */
export type mutation_rootcreateKeyModeEnumsArgs = {
  objects: Array<qx_eKeypadMode_insert_input>;
  on_conflict?: qx_eKeypadMode_on_conflict;
};


/** mutation root */
export type mutation_rootcreateLayoutArgs = {
  object: qx_Layout_insert_input;
  on_conflict?: qx_Layout_on_conflict;
};


/** mutation root */
export type mutation_rootcreateLayoutsArgs = {
  objects: Array<qx_Layout_insert_input>;
  on_conflict?: qx_Layout_on_conflict;
};


/** mutation root */
export type mutation_rootcreateLensProfileArgs = {
  object: qx_LensProfile_insert_input;
  on_conflict?: qx_LensProfile_on_conflict;
};


/** mutation root */
export type mutation_rootcreateLensProfilesArgs = {
  objects: Array<qx_LensProfile_insert_input>;
  on_conflict?: qx_LensProfile_on_conflict;
};


/** mutation root */
export type mutation_rootcreateLockArgs = {
  object: qx_Lock_insert_input;
  on_conflict?: qx_Lock_on_conflict;
};


/** mutation root */
export type mutation_rootcreateLockPowerMonitorEnumArgs = {
  object: qx_eLockPowerMonitor_insert_input;
  on_conflict?: qx_eLockPowerMonitor_on_conflict;
};


/** mutation root */
export type mutation_rootcreateLockPowerMonitorEnumsArgs = {
  objects: Array<qx_eLockPowerMonitor_insert_input>;
  on_conflict?: qx_eLockPowerMonitor_on_conflict;
};


/** mutation root */
export type mutation_rootcreateLockRelayMonitorEnumArgs = {
  object: qx_eLockRelayMonitor_insert_input;
  on_conflict?: qx_eLockRelayMonitor_on_conflict;
};


/** mutation root */
export type mutation_rootcreateLockRelayMonitorEnumsArgs = {
  objects: Array<qx_eLockRelayMonitor_insert_input>;
  on_conflict?: qx_eLockRelayMonitor_on_conflict;
};


/** mutation root */
export type mutation_rootcreateLockTypeEnumArgs = {
  object: qx_eLockType_insert_input;
  on_conflict?: qx_eLockType_on_conflict;
};


/** mutation root */
export type mutation_rootcreateLockTypeEnumsArgs = {
  objects: Array<qx_eLockType_insert_input>;
  on_conflict?: qx_eLockType_on_conflict;
};


/** mutation root */
export type mutation_rootcreateLocksArgs = {
  objects: Array<qx_Lock_insert_input>;
  on_conflict?: qx_Lock_on_conflict;
};


/** mutation root */
export type mutation_rootcreateMediaProfileArgs = {
  object: qx_MediaProfile_insert_input;
  on_conflict?: qx_MediaProfile_on_conflict;
};


/** mutation root */
export type mutation_rootcreateMediaProfilesArgs = {
  objects: Array<qx_MediaProfile_insert_input>;
  on_conflict?: qx_MediaProfile_on_conflict;
};


/** mutation root */
export type mutation_rootcreateMercuryControlPointArgs = {
  object: qx_MercuryControlPoint_insert_input;
  on_conflict?: qx_MercuryControlPoint_on_conflict;
};


/** mutation root */
export type mutation_rootcreateMercuryControlPointsArgs = {
  objects: Array<qx_MercuryControlPoint_insert_input>;
  on_conflict?: qx_MercuryControlPoint_on_conflict;
};


/** mutation root */
export type mutation_rootcreateMercuryMonitorPointArgs = {
  object: qx_MercuryMonitorPoint_insert_input;
  on_conflict?: qx_MercuryMonitorPoint_on_conflict;
};


/** mutation root */
export type mutation_rootcreateMercuryMonitorPointsArgs = {
  objects: Array<qx_MercuryMonitorPoint_insert_input>;
  on_conflict?: qx_MercuryMonitorPoint_on_conflict;
};


/** mutation root */
export type mutation_rootcreateMonitorLockStateEnumArgs = {
  object: qx_eMonitorLockState_insert_input;
  on_conflict?: qx_eMonitorLockState_on_conflict;
};


/** mutation root */
export type mutation_rootcreateMonitorLockStateEnumsArgs = {
  objects: Array<qx_eMonitorLockState_insert_input>;
  on_conflict?: qx_eMonitorLockState_on_conflict;
};


/** mutation root */
export type mutation_rootcreateMountPositionEnumArgs = {
  object: qx_eMountPosition_insert_input;
  on_conflict?: qx_eMountPosition_on_conflict;
};


/** mutation root */
export type mutation_rootcreateMountPositionEnumsArgs = {
  objects: Array<qx_eMountPosition_insert_input>;
  on_conflict?: qx_eMountPosition_on_conflict;
};


/** mutation root */
export type mutation_rootcreateObjectActionEnumArgs = {
  object: qx_eObjectAction_insert_input;
  on_conflict?: qx_eObjectAction_on_conflict;
};


/** mutation root */
export type mutation_rootcreateObjectActionEnumsArgs = {
  objects: Array<qx_eObjectAction_insert_input>;
  on_conflict?: qx_eObjectAction_on_conflict;
};


/** mutation root */
export type mutation_rootcreateOssIdAssignmentArgs = {
  object: qx_OssIdAssignment_insert_input;
  on_conflict?: qx_OssIdAssignment_on_conflict;
};


/** mutation root */
export type mutation_rootcreateOssIdAssignmentsArgs = {
  objects: Array<qx_OssIdAssignment_insert_input>;
  on_conflict?: qx_OssIdAssignment_on_conflict;
};


/** mutation root */
export type mutation_rootcreateOutputPointArgs = {
  object: qx_OutputPoint_insert_input;
  on_conflict?: qx_OutputPoint_on_conflict;
};


/** mutation root */
export type mutation_rootcreateOutputPointsArgs = {
  objects: Array<qx_OutputPoint_insert_input>;
  on_conflict?: qx_OutputPoint_on_conflict;
};


/** mutation root */
export type mutation_rootcreatePACSStatusEnumArgs = {
  object: qx_ePACSStatus_insert_input;
  on_conflict?: qx_ePACSStatus_on_conflict;
};


/** mutation root */
export type mutation_rootcreatePACSStatusEnumsArgs = {
  objects: Array<qx_ePACSStatus_insert_input>;
  on_conflict?: qx_ePACSStatus_on_conflict;
};


/** mutation root */
export type mutation_rootcreatePeopleArgs = {
  objects: Array<qx_Person_insert_input>;
  on_conflict?: qx_Person_on_conflict;
};


/** mutation root */
export type mutation_rootcreatePermissionArgs = {
  object: qx_Permission_insert_input;
  on_conflict?: qx_Permission_on_conflict;
};


/** mutation root */
export type mutation_rootcreatePermissionWithPartitionsArgs = {
  partitionIds: Array<string>;
  permission: PermissionWithPartitionsInput;
};


/** mutation root */
export type mutation_rootcreatePermissionsArgs = {
  objects: Array<qx_Permission_insert_input>;
  on_conflict?: qx_Permission_on_conflict;
};


/** mutation root */
export type mutation_rootcreatePersonArgs = {
  object: qx_Person_insert_input;
  on_conflict?: qx_Person_on_conflict;
};


/** mutation root */
export type mutation_rootcreatePersonGroupArgs = {
  object: qx__PersonToGroup_insert_input;
  on_conflict?: qx__PersonToGroup_on_conflict;
};


/** mutation root */
export type mutation_rootcreatePersonGroupsArgs = {
  objects: Array<qx__PersonToGroup_insert_input>;
  on_conflict?: qx__PersonToGroup_on_conflict;
};


/** mutation root */
export type mutation_rootcreatePersonStatusEnumArgs = {
  object: qx_ePersonStatus_insert_input;
  on_conflict?: qx_ePersonStatus_on_conflict;
};


/** mutation root */
export type mutation_rootcreatePersonStatusEnumsArgs = {
  objects: Array<qx_ePersonStatus_insert_input>;
  on_conflict?: qx_ePersonStatus_on_conflict;
};


/** mutation root */
export type mutation_rootcreatePlaceArgs = {
  object: qx_Place_insert_input;
  on_conflict?: qx_Place_on_conflict;
};


/** mutation root */
export type mutation_rootcreatePlaceTypeEnumArgs = {
  object: qx_ePlaceType_insert_input;
  on_conflict?: qx_ePlaceType_on_conflict;
};


/** mutation root */
export type mutation_rootcreatePlaceTypeEnumsArgs = {
  objects: Array<qx_ePlaceType_insert_input>;
  on_conflict?: qx_ePlaceType_on_conflict;
};


/** mutation root */
export type mutation_rootcreatePlacesArgs = {
  objects: Array<qx_Place_insert_input>;
  on_conflict?: qx_Place_on_conflict;
};


/** mutation root */
export type mutation_rootcreatePrivilegeEnumArgs = {
  object: qx_ePrivilege_insert_input;
  on_conflict?: qx_ePrivilege_on_conflict;
};


/** mutation root */
export type mutation_rootcreatePrivilegeEnumToRoleArgs = {
  object: qx__PrivilegeEnumToRole_insert_input;
  on_conflict?: qx__PrivilegeEnumToRole_on_conflict;
};


/** mutation root */
export type mutation_rootcreatePrivilegeEnumToRolesArgs = {
  objects: Array<qx__PrivilegeEnumToRole_insert_input>;
  on_conflict?: qx__PrivilegeEnumToRole_on_conflict;
};


/** mutation root */
export type mutation_rootcreatePrivilegeEnumsArgs = {
  objects: Array<qx_ePrivilege_insert_input>;
  on_conflict?: qx_ePrivilege_on_conflict;
};


/** mutation root */
export type mutation_rootcreateReaderArgs = {
  object: qx_Reader_insert_input;
  on_conflict?: qx_Reader_on_conflict;
};


/** mutation root */
export type mutation_rootcreateReaderAccessTypeEnumArgs = {
  object: qx_eReaderAccessType_insert_input;
  on_conflict?: qx_eReaderAccessType_on_conflict;
};


/** mutation root */
export type mutation_rootcreateReaderAccessTypeEnumsArgs = {
  objects: Array<qx_eReaderAccessType_insert_input>;
  on_conflict?: qx_eReaderAccessType_on_conflict;
};


/** mutation root */
export type mutation_rootcreateReaderProtocolEnumArgs = {
  object: qx_eReaderProtocol_insert_input;
  on_conflict?: qx_eReaderProtocol_on_conflict;
};


/** mutation root */
export type mutation_rootcreateReaderProtocolEnumsArgs = {
  objects: Array<qx_eReaderProtocol_insert_input>;
  on_conflict?: qx_eReaderProtocol_on_conflict;
};


/** mutation root */
export type mutation_rootcreateReadersArgs = {
  objects: Array<qx_Reader_insert_input>;
  on_conflict?: qx_Reader_on_conflict;
};


/** mutation root */
export type mutation_rootcreateRexStateEnumArgs = {
  object: qx_eRexState_insert_input;
  on_conflict?: qx_eRexState_on_conflict;
};


/** mutation root */
export type mutation_rootcreateRexStateEnumsArgs = {
  objects: Array<qx_eRexState_insert_input>;
  on_conflict?: qx_eRexState_on_conflict;
};


/** mutation root */
export type mutation_rootcreateRoleArgs = {
  object: qx_Role_insert_input;
  on_conflict?: qx_Role_on_conflict;
};


/** mutation root */
export type mutation_rootcreateRolesArgs = {
  objects: Array<qx_Role_insert_input>;
  on_conflict?: qx_Role_on_conflict;
};


/** mutation root */
export type mutation_rootcreateRosslareConnectionArgs = {
  object: qx_RosslareConnection_insert_input;
  on_conflict?: qx_RosslareConnection_on_conflict;
};


/** mutation root */
export type mutation_rootcreateRosslareConnectionsArgs = {
  objects: Array<qx_RosslareConnection_insert_input>;
  on_conflict?: qx_RosslareConnection_on_conflict;
};


/** mutation root */
export type mutation_rootcreateScheduleArgs = {
  object: qx_Schedule_insert_input;
  on_conflict?: qx_Schedule_on_conflict;
};


/** mutation root */
export type mutation_rootcreateScheduleBlockArgs = {
  object: qx_ScheduleBlock_insert_input;
  on_conflict?: qx_ScheduleBlock_on_conflict;
};


/** mutation root */
export type mutation_rootcreateScheduleBlocksArgs = {
  objects: Array<qx_ScheduleBlock_insert_input>;
  on_conflict?: qx_ScheduleBlock_on_conflict;
};


/** mutation root */
export type mutation_rootcreateSchedulesArgs = {
  objects: Array<qx_Schedule_insert_input>;
  on_conflict?: qx_Schedule_on_conflict;
};


/** mutation root */
export type mutation_rootcreateSegmentArgs = {
  object: qx_Segment_insert_input;
  on_conflict?: qx_Segment_on_conflict;
};


/** mutation root */
export type mutation_rootcreateSegmentsArgs = {
  objects: Array<qx_Segment_insert_input>;
  on_conflict?: qx_Segment_on_conflict;
};


/** mutation root */
export type mutation_rootcreateSensorArgs = {
  object: qx_Sensor_insert_input;
  on_conflict?: qx_Sensor_on_conflict;
};


/** mutation root */
export type mutation_rootcreateSensorActionEnumArgs = {
  object: qx_eSensorAction_insert_input;
  on_conflict?: qx_eSensorAction_on_conflict;
};


/** mutation root */
export type mutation_rootcreateSensorActionEnumsArgs = {
  objects: Array<qx_eSensorAction_insert_input>;
  on_conflict?: qx_eSensorAction_on_conflict;
};


/** mutation root */
export type mutation_rootcreateSensorTypeEnumArgs = {
  object: qx_eSensorType_insert_input;
  on_conflict?: qx_eSensorType_on_conflict;
};


/** mutation root */
export type mutation_rootcreateSensorTypeEnumsArgs = {
  objects: Array<qx_eSensorType_insert_input>;
  on_conflict?: qx_eSensorType_on_conflict;
};


/** mutation root */
export type mutation_rootcreateSensorsArgs = {
  objects: Array<qx_Sensor_insert_input>;
  on_conflict?: qx_Sensor_on_conflict;
};


/** mutation root */
export type mutation_rootcreateSharedLinkArgs = {
  emails?: Array<string>;
  expiresAt?: string;
  linkableID: string;
  linkableType: SharedLinkType;
  persons?: Array<string>;
  singleUse: boolean;
};


/** mutation root */
export type mutation_rootcreateSnapshotArgs = {
  object: qx_Snapshot_insert_input;
  on_conflict?: qx_Snapshot_on_conflict;
};


/** mutation root */
export type mutation_rootcreateSnapshotsArgs = {
  objects: Array<qx_Snapshot_insert_input>;
  on_conflict?: qx_Snapshot_on_conflict;
};


/** mutation root */
export type mutation_rootcreateStreamStatusEnumArgs = {
  object: qx_eStreamStatus_insert_input;
  on_conflict?: qx_eStreamStatus_on_conflict;
};


/** mutation root */
export type mutation_rootcreateStreamStatusEnumsArgs = {
  objects: Array<qx_eStreamStatus_insert_input>;
  on_conflict?: qx_eStreamStatus_on_conflict;
};


/** mutation root */
export type mutation_rootcreateSuperviseInputsEnumArgs = {
  object: qx_eSuperviseInputs_insert_input;
  on_conflict?: qx_eSuperviseInputs_on_conflict;
};


/** mutation root */
export type mutation_rootcreateSuperviseInputsEnumsArgs = {
  objects: Array<qx_eSuperviseInputs_insert_input>;
  on_conflict?: qx_eSuperviseInputs_on_conflict;
};


/** mutation root */
export type mutation_rootcreateTermsAgreementArgs = {
  object: qx_TermsAgreement_insert_input;
  on_conflict?: qx_TermsAgreement_on_conflict;
};


/** mutation root */
export type mutation_rootcreateTermsAgreementsArgs = {
  objects: Array<qx_TermsAgreement_insert_input>;
  on_conflict?: qx_TermsAgreement_on_conflict;
};


/** mutation root */
export type mutation_rootcreateTimeZoneArgs = {
  object: qx_TimeZone_insert_input;
  on_conflict?: qx_TimeZone_on_conflict;
};


/** mutation root */
export type mutation_rootcreateTimeZonesArgs = {
  objects: Array<qx_TimeZone_insert_input>;
  on_conflict?: qx_TimeZone_on_conflict;
};


/** mutation root */
export type mutation_rootcreateUserSettingArgs = {
  object: qx_UserSetting_insert_input;
  on_conflict?: qx_UserSetting_on_conflict;
};


/** mutation root */
export type mutation_rootcreateUserSettingsArgs = {
  objects: Array<qx_UserSetting_insert_input>;
  on_conflict?: qx_UserSetting_on_conflict;
};


/** mutation root */
export type mutation_rootcreateVideoSourceArgs = {
  object: qx_VideoSource_insert_input;
  on_conflict?: qx_VideoSource_on_conflict;
};


/** mutation root */
export type mutation_rootcreateVideoSourcesArgs = {
  objects: Array<qx_VideoSource_insert_input>;
  on_conflict?: qx_VideoSource_on_conflict;
};


/** mutation root */
export type mutation_rootcreateViewArgs = {
  object: qx_View_insert_input;
  on_conflict?: qx_View_on_conflict;
};


/** mutation root */
export type mutation_rootcreateViewsArgs = {
  objects: Array<qx_View_insert_input>;
  on_conflict?: qx_View_on_conflict;
};


/** mutation root */
export type mutation_rootcreateWiegandCardFormatArgs = {
  object: qx_WiegandCardFormat_insert_input;
  on_conflict?: qx_WiegandCardFormat_on_conflict;
};


/** mutation root */
export type mutation_rootcreateWiegandCardFormatsArgs = {
  objects: Array<qx_WiegandCardFormat_insert_input>;
  on_conflict?: qx_WiegandCardFormat_on_conflict;
};


/** mutation root */
export type mutation_rootdeactivateOutputArgs = {
  deviceDIORefID?: string;
  deviceID?: string;
  outputPointID?: string;
};


/** mutation root */
export type mutation_rootdeleteAccessBoardTypeEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteAccessBoardTypeEnumsArgs = {
  where: qx_eAccessBoardType_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteAccessCatalogArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteAccessCatalogsArgs = {
  where: qx_AccessCatalog_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteAccessDeniedReasonEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteAccessDeniedReasonEnumsArgs = {
  where: qx_eAccessDeniedReason_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteAccessInterfaceTypeEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteAccessInterfaceTypeEnumsArgs = {
  where: qx_eAccessInterfaceType_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteAccessInventoriesArgs = {
  where: qx_AccessInventory_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteAccessInventoryArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteAccessPointActionEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteAccessPointActionEnumsArgs = {
  where: qx_eAccessPointAction_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteAccessPointDirectionEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteAccessPointDirectionEnumsArgs = {
  where: qx_eAccessPointDirection_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteAccessPointTypeEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteAccessPointTypeEnumsArgs = {
  where: qx_eAccessPointType_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteAudioSourceArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteAudioSourcesArgs = {
  where: qx_AudioSource_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteAuthStrategyEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteAuthStrategyEnumsArgs = {
  where: qx_eAuthStrategy_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteBatteryLevelEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteBatteryLevelEnumsArgs = {
  where: qx_eBatteryLevel_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteBaudrateEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteBaudrateEnumsArgs = {
  where: qx_eBaudrate_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteBillingPeriodArgs = {
  billingPeriodMonths: number;
};


/** mutation root */
export type mutation_rootdeleteBillingTierEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteBillingTierEnumsArgs = {
  where: qx_eBillingTier_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteChatUsageHistoriesArgs = {
  where: qx_ChatUsageHistory_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteChatUsageHistoryArgs = {
  id: any;
};


/** mutation root */
export type mutation_rootdeleteClipStatusEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteClipStatusEnumsArgs = {
  where: qx_eClipStatus_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteClipTypeEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteClipTypeEnumsArgs = {
  where: qx_eClipType_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteClipsArgs = {
  where: qx_Clip_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteCloudStorageOptionArgs = {
  cloudStorageDays: number;
};


/** mutation root */
export type mutation_rootdeleteCredentialArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteCredentialTypeEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteCredentialTypeEnumsArgs = {
  where: qx_eCredentialType_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteCredentialsArgs = {
  where: qx_Credential_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteCustomerPermissionArgs = {
  customerPlaceID: string;
};


/** mutation root */
export type mutation_rootdeleteCustomerPermissionsArgs = {
  where: qx_CustomerPermission_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteDIONormalStateEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteDIONormalStateEnumsArgs = {
  where: qx_eDIONormalState_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteDIOStateEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteDIOStateEnumsArgs = {
  where: qx_eDIOState_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteDIOTypeEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteDIOTypeEnumsArgs = {
  where: qx_eDIOType_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteDeviceArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteDeviceConnectionStatusEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteDeviceConnectionStatusEnumsArgs = {
  where: qx_eDeviceConnectionStatus_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteDeviceDIOArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteDeviceDIOsArgs = {
  where: qx_DeviceDIO_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteDeviceDioDataArgs = {
  deviceId: string;
  refId: string;
};


/** mutation root */
export type mutation_rootdeleteDeviceKindEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteDeviceKindEnumsArgs = {
  where: qx_eDeviceKind_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteDeviceVideoDataArgs = {
  deviceID: string;
};


/** mutation root */
export type mutation_rootdeleteDevicesArgs = {
  where: qx_Device_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteDoorArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteDoorAlarmEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteDoorAlarmEnumsArgs = {
  where: qx_eDoorAlarm_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteDoorConfigurationArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteDoorConfigurationsArgs = {
  where: qx_DoorConfiguration_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteDoorMetaArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteDoorMetasArgs = {
  where: qx_DoorMeta_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteDoorModeEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteDoorModeEnumsArgs = {
  where: qx_eDoorMode_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteDoorMonitorEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteDoorMonitorEnumsArgs = {
  where: qx_eDoorMonitor_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteDoorStateEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteDoorStateEnumsArgs = {
  where: qx_eDoorState_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteDoorTemplateArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteDoorTemplatesArgs = {
  where: qx_DoorTemplate_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteDoorsArgs = {
  where: qx_Door_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteEventArgs = {
  id: string;
  serverTime: string;
};


/** mutation root */
export type mutation_rootdeleteEventTypesArgs = {
  where: qx_EventType_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteEventsArgs = {
  where: qx_Event_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteFlowArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteFlowNotificationTypeEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteFlowNotificationTypeEnumsArgs = {
  where: qx_eFlowNotificationType_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteFlowTraceArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteFlowTracesArgs = {
  where: qx_FlowTrace_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteFlowsArgs = {
  where: qx_Flow_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteGatewayArgs = {
  gatewayID?: string;
};


/** mutation root */
export type mutation_rootdeleteGatewayBandwidthScheduleArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteGatewayBandwidthScshedulesArgs = {
  where: qx_GatewayBandwidthSchedule_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteGatewayServiceTypeEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteGatewayServiceTypeEnumsArgs = {
  where: qx_eGatewayServiceType_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteGatewaySyncStatusEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteGatewaySyncStatusEnumsArgs = {
  where: qx_eGatewaySyncStatus_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteGroupArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteGroupsArgs = {
  where: qx_Group_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteHolidaySetArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteHolidaySetToScheduleBlockArgs = {
  holidaySetID: string;
  scheduleBlockID: string;
};


/** mutation root */
export type mutation_rootdeleteHolidaySetToScheduleBlocksArgs = {
  where: qx__HolidaySetToScheduleBlock_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteHolidaySetsArgs = {
  where: qx_HolidaySet_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteInputPointArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteInputPointsArgs = {
  where: qx_InputPoint_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteKeyModeEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteKeyModeEnumsArgs = {
  where: qx_eKeypadMode_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteLayoutArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteLayoutsArgs = {
  where: qx_Layout_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteLensProfileArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteLensProfilesArgs = {
  where: qx_LensProfile_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteLockArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteLockPowerMonitorEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteLockPowerMonitorEnumsArgs = {
  where: qx_eLockPowerMonitor_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteLockRelayMonitorEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteLockRelayMonitorEnumsArgs = {
  where: qx_eLockRelayMonitor_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteLockTypeEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteLockTypeEnumsArgs = {
  where: qx_eLockType_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteLocksArgs = {
  where: qx_Lock_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteMediaProfileArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteMediaProfilesArgs = {
  where: qx_MediaProfile_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteMercuryControlPointArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteMercuryControlPointsArgs = {
  where: qx_MercuryControlPoint_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteMercuryMonitorPointArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteMercuryMonitorPointsArgs = {
  where: qx_MercuryMonitorPoint_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteMonitorLockStateEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteMonitorLockStateEnumsArgs = {
  where: qx_eMonitorLockState_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteMountPositionEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteMountPositionEnumsArgs = {
  where: qx_eMountPosition_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteObjectActionEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteObjectActionEnumsArgs = {
  where: qx_eObjectAction_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteOssIdAssignmentArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteOssIdAssignmentsArgs = {
  where: qx_OssIdAssignment_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteOutputPointArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteOutputPointsArgs = {
  where: qx_OutputPoint_bool_exp;
};


/** mutation root */
export type mutation_rootdeletePACSStatusEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeletePACSStatusEnumsArgs = {
  where: qx_ePACSStatus_bool_exp;
};


/** mutation root */
export type mutation_rootdeletePeopleArgs = {
  where: qx_Person_bool_exp;
};


/** mutation root */
export type mutation_rootdeletePermissionArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeletePermissionsArgs = {
  where: qx_Permission_bool_exp;
};


/** mutation root */
export type mutation_rootdeletePersonArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeletePersonGroupArgs = {
  groupID: string;
  personID: string;
};


/** mutation root */
export type mutation_rootdeletePersonGroupsArgs = {
  where: qx__PersonToGroup_bool_exp;
};


/** mutation root */
export type mutation_rootdeletePersonStatusEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeletePersonStatusEnumsArgs = {
  where: qx_ePersonStatus_bool_exp;
};


/** mutation root */
export type mutation_rootdeletePlaceArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeletePlaceTypeEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeletePlaceTypeEnumsArgs = {
  where: qx_ePlaceType_bool_exp;
};


/** mutation root */
export type mutation_rootdeletePlacesArgs = {
  where: qx_Place_bool_exp;
};


/** mutation root */
export type mutation_rootdeletePrivilegeEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeletePrivilegeEnumToRoleArgs = {
  privilege: qx_ePrivilege_enum;
  roleID: string;
};


/** mutation root */
export type mutation_rootdeletePrivilegeEnumToRolesArgs = {
  where: qx__PrivilegeEnumToRole_bool_exp;
};


/** mutation root */
export type mutation_rootdeletePrivilegeEnumsArgs = {
  where: qx_ePrivilege_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteReaderArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteReaderAccessTypeEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteReaderAccessTypeEnumsArgs = {
  where: qx_eReaderAccessType_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteReaderProtocolEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteReaderProtocolEnumsArgs = {
  where: qx_eReaderProtocol_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteReadersArgs = {
  where: qx_Reader_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteRexStateEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteRexStateEnumsArgs = {
  where: qx_eRexState_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteRoleArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteRolesArgs = {
  where: qx_Role_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteRosslareConnectionArgs = {
  deviceID: string;
};


/** mutation root */
export type mutation_rootdeleteRosslareConnectionsArgs = {
  where: qx_RosslareConnection_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteScheduleArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteScheduleBlockArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteScheduleBlocksArgs = {
  where: qx_ScheduleBlock_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteSchedulesArgs = {
  where: qx_Schedule_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteSegmentArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteSegmentsArgs = {
  where: qx_Segment_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteSensorArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteSensorActionEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteSensorActionEnumsArgs = {
  where: qx_eSensorAction_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteSensorTypeEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteSensorTypeEnumsArgs = {
  where: qx_eSensorType_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteSensorsArgs = {
  where: qx_Sensor_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteSharedLinkArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteSharedLinksArgs = {
  where: qx_SharedLinks_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteSnapshotArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteSnapshotsArgs = {
  where: qx_Snapshot_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteStreamStatusEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteStreamStatusEnumsArgs = {
  where: qx_eStreamStatus_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteSuperviseInputsEnumArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdeleteSuperviseInputsEnumsArgs = {
  where: qx_eSuperviseInputs_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteTermsAgreementArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteTermsAgreementsArgs = {
  where: qx_TermsAgreement_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteTimeZoneArgs = {
  name: string;
};


/** mutation root */
export type mutation_rootdeleteTimeZonesArgs = {
  where: qx_TimeZone_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteUserSettingArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteUserSettingsArgs = {
  where: qx_UserSetting_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteVideoSourceArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteVideoSourcesArgs = {
  where: qx_VideoSource_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteViewArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteViewsArgs = {
  where: qx_View_bool_exp;
};


/** mutation root */
export type mutation_rootdeleteWiegandCardFormatArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdeleteWiegandCardFormatsArgs = {
  where: qx_WiegandCardFormat_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_AnalyticSourcesArgs = {
  where: AnalyticSources_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_AnalyticSources_by_pkArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdelete_ApplicationUserGatewayPasswordArgs = {
  where: ApplicationUserGatewayPassword_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_ApplicationUserGatewayPassword_by_pkArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdelete_ApplicationUserTwoFactorArgs = {
  where: ApplicationUserTwoFactor_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_ApplicationUserTwoFactor_by_pkArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdelete_DSCConnectionArgs = {
  where: DSCConnection_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_DSCConnection_by_pkArgs = {
  deviceID: string;
};


/** mutation root */
export type mutation_rootdelete_IntrusionAccessCodeArgs = {
  where: IntrusionAccessCode_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_IntrusionAccessCode_by_pkArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdelete_IntrusionPartitionArgs = {
  where: IntrusionPartition_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_IntrusionPartition_by_pkArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdelete_IntrusionZoneArgs = {
  where: IntrusionZone_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_IntrusionZone_by_pkArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdelete_PartitionZoneAssignmentsArgs = {
  where: PartitionZoneAssignments_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_PartitionZoneAssignments_by_pkArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdelete_PassKeyProviderArgs = {
  where: PassKeyProvider_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_PassKeyProvider_by_pkArgs = {
  aaguid: string;
};


/** mutation root */
export type mutation_rootdelete_PermissionPartitionAssignmentsArgs = {
  where: PermissionPartitionAssignments_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_PermissionPartitionAssignments_by_pkArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdelete_PersonTermsAgreementArgs = {
  where: PersonTermsAgreement_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_PersonTermsAgreement_by_pkArgs = {
  email: string;
};


/** mutation root */
export type mutation_rootdelete_analyticAttributePropertiesArgs = {
  where: analyticAttributeProperties_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_analyticAttributeProperties_by_pkArgs = {
  analyticAttributeID: string;
  attributePropertyValue: string;
};


/** mutation root */
export type mutation_rootdelete_analyticAttributesArgs = {
  where: analyticAttributes_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_analyticAttributes_by_pkArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdelete_analyticDetectedPropertiesArgs = {
  where: analyticDetectedProperties_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_analyticDetectedProperties_by_pkArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdelete_analyticTypesArgs = {
  where: analyticTypes_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_analyticTypes_by_pkArgs = {
  type: string;
};


/** mutation root */
export type mutation_rootdelete_analyticsArgs = {
  where: analytics_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_analytics_by_pkArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdelete_applicationUserAppPasswordsArgs = {
  where: applicationUserAppPasswords_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_applicationUserAppPasswords_by_pkArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdelete_applicationUserDevicesArgs = {
  where: applicationUserDevices_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_applicationUserDevices_by_pkArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdelete_attributePropertiesArgs = {
  where: attributeProperties_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_attributeProperties_by_pkArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdelete_attributesArgs = {
  where: attributes_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_attributes_by_pkArgs = {
  type: string;
};


/** mutation root */
export type mutation_rootdelete_audioSourceAuditArgs = {
  where: audioSourceAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_audit_logged_actionsArgs = {
  where: audit_logged_actions_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_audit_logged_actions_by_pkArgs = {
  event_id: string;
};


/** mutation root */
export type mutation_rootdelete_audit_vSensorAuditArgs = {
  where: audit_vSensorAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_cloudStorageTimelapseOptionsArgs = {
  where: cloudStorageTimelapseOptions_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_cloudStorageTimelapseOptions_by_pkArgs = {
  cloudStorageDays: number;
};


/** mutation root */
export type mutation_rootdelete_credentialAuditArgs = {
  where: credentialAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_customerPermissionAuditArgs = {
  where: customerPermissionAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_deviceAnalyticSourceArgs = {
  where: deviceAnalyticSource_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_deviceAnalyticSource_by_pkArgs = {
  id: number;
};


/** mutation root */
export type mutation_rootdelete_deviceAuditArgs = {
  where: deviceAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_deviceDIOAuditArgs = {
  where: deviceDIOAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_doorAuditArgs = {
  where: doorAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_eAnalyticIntegrationsArgs = {
  where: eAnalyticIntegrations_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_eAnalyticIntegrations_by_pkArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdelete_eAnalyticStatesArgs = {
  where: eAnalyticStates_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_eAnalyticStates_by_pkArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdelete_eGatewayTypeArgs = {
  where: eGatewayType_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_eGatewayType_by_pkArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdelete_eS3BucketTypeArgs = {
  where: eS3BucketType_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_eS3BucketType_by_pkArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdelete_flowAuditArgs = {
  where: flowAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_gatewayAuditArgs = {
  where: gatewayAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_gatewayBandwidthScheduleAuditArgs = {
  where: gatewayBandwidthScheduleAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_groupAuditArgs = {
  where: groupAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_guestAccessArgs = {
  where: guestAccess_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_guestAccess_by_pkArgs = {
  personID: string;
};


/** mutation root */
export type mutation_rootdelete_holidaySetAuditArgs = {
  where: holidaySetAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_holidaySetToScheduleBlockAuditArgs = {
  where: holidaySetToScheduleBlockAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_inputPointAuditArgs = {
  where: inputPointAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_lockAuditArgs = {
  where: lockAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_mediaProfileAuditArgs = {
  where: mediaProfileAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_outputPointAuditArgs = {
  where: outputPointAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_permissionAuditArgs = {
  where: permissionAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_personAuditArgs = {
  where: personAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_personDeviceAppPrivilegesArgs = {
  where: personDeviceAppPrivileges_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_personDeviceAppPrivileges_by_pkArgs = {
  deviceID: string;
  personID: string;
};


/** mutation root */
export type mutation_rootdelete_personDoorAppPrivilegesArgs = {
  where: personDoorAppPrivileges_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_personDoorAppPrivileges_by_pkArgs = {
  doorID: string;
  personID: string;
};


/** mutation root */
export type mutation_rootdelete_personIntrusionPartitionAppPrivilegesArgs = {
  where: personIntrusionPartitionAppPrivileges_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_personIntrusionPartitionAppPrivileges_by_pkArgs = {
  partitionID: string;
  personID: string;
};


/** mutation root */
export type mutation_rootdelete_personPlaceAppPrivilegesArgs = {
  where: personPlaceAppPrivileges_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_personPlaceAppPrivileges_by_pkArgs = {
  personID: string;
  placeID: string;
};


/** mutation root */
export type mutation_rootdelete_personToGroupAuditArgs = {
  where: personToGroupAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_personVideoSourceAppPrivilegesArgs = {
  where: personVideoSourceAppPrivileges_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_personVideoSourceAppPrivileges_by_pkArgs = {
  personID: string;
  videoSourceID: string;
};


/** mutation root */
export type mutation_rootdelete_placeAuditArgs = {
  where: placeAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_placeWhiteListsArgs = {
  where: placeWhiteLists_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_placeWhiteLists_by_pkArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdelete_privilegeEnumToRoleAuditArgs = {
  where: privilegeEnumToRoleAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_AccessCatalogCapabilitiesArgs = {
  where: qx_AccessCatalogCapabilities_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_AccessCatalogCapabilities_by_pkArgs = {
  catalogID: string;
};


/** mutation root */
export type mutation_rootdelete_qx_AuditLogArgs = {
  where: qx_AuditLog_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_AuditLog_by_pkArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdelete_qx_AuditableActionArgs = {
  where: qx_AuditableAction_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_AuditableAction_by_pkArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdelete_qx_AuditableTypeArgs = {
  where: qx_AuditableType_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_AuditableType_by_pkArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdelete_qx_BillingPeriodArgs = {
  where: qx_BillingPeriod_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_CatalogProtocolOverrideArgs = {
  where: qx_CatalogProtocolOverride_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_CatalogProtocolOverride_by_pkArgs = {
  id: number;
};


/** mutation root */
export type mutation_rootdelete_qx_ClipAuditLogArgs = {
  where: qx_ClipAuditLog_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_Clip_by_pkArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdelete_qx_CloudStorageOptionsArgs = {
  where: qx_CloudStorageOptions_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_CustomerAuthProviderArgs = {
  where: qx_CustomerAuthProvider_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_CustomerAuthProvider_by_pkArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdelete_qx_DiscoveryTypeArgs = {
  where: qx_DiscoveryType_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_DiscoveryType_by_pkArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdelete_qx_EventType_by_pkArgs = {
  type: string;
};


/** mutation root */
export type mutation_rootdelete_qx_IntrusionAlarmArgs = {
  where: qx_IntrusionAlarm_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_IntrusionAlarm_by_pkArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdelete_qx_IntrusionPartitionStateArgs = {
  where: qx_IntrusionPartitionState_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_IntrusionPartitionState_by_pkArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdelete_qx_IntrusionZoneStateArgs = {
  where: qx_IntrusionZoneState_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_IntrusionZoneState_by_pkArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdelete_qx_MediaProfileRecordingArgs = {
  where: qx_MediaProfileRecording_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_MediaProfileRecording_by_pkArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdelete_qx_OssKeyArgs = {
  where: qx_OssKey_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_OssKey_by_pkArgs = {
  customerPlaceID: string;
};


/** mutation root */
export type mutation_rootdelete_qx_SharedLinkAuditLogArgs = {
  where: qx_SharedLinkAuditLog_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_SharedLinkTypeArgs = {
  where: qx_SharedLinkType_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_SharedLinkType_by_pkArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdelete_qx_VideoSourceStorageAuditArgs = {
  where: qx_VideoSourceStorageAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_VideoSourceStorageAudit_by_pkArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdelete_qx_eAccessMakeArgs = {
  where: qx_eAccessMake_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_eAccessMake_by_pkArgs = {
  name: string;
};


/** mutation root */
export type mutation_rootdelete_qx_eAppPrivilegeTypeArgs = {
  where: qx_eAppPrivilegeType_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_eAppPrivilegeType_by_pkArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdelete_qx_eAuthProviderArgs = {
  where: qx_eAuthProvider_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_eAuthProvider_by_pkArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdelete_qx_eFlowStatusArgs = {
  where: qx_eFlowStatus_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_eFlowStatus_by_pkArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdelete_qx_eFlowTraceActionStatusArgs = {
  where: qx_eFlowTraceActionStatus_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_eFlowTraceActionStatus_by_pkArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdelete_qx_eFlowTraceStateArgs = {
  where: qx_eFlowTraceState_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_eFlowTraceState_by_pkArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdelete_qx_eIntrusionZoneTypeArgs = {
  where: qx_eIntrusionZoneType_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_eIntrusionZoneType_by_pkArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdelete_qx_eLockModeArgs = {
  where: qx_eLockMode_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_eLockMode_by_pkArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdelete_qx_eMercuryMonitorPointLatchModesArgs = {
  where: qx_eMercuryMonitorPointLatchModes_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_eMercuryMonitorPointLatchModes_by_pkArgs = {
  value: string;
};


/** mutation root */
export type mutation_rootdelete_qx_vPlacePrivilegeArgs = {
  where: qx_vPlacePrivilege_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qx_vProfilesArgs = {
  where: qx_vProfiles_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_qxanalytics_CloudUsageArgs = {
  where: qxanalytics_CloudUsage_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_readerAccessTypeCompatibilityArgs = {
  where: readerAccessTypeCompatibility_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_readerAccessTypeCompatibility_by_pkArgs = {
  id: number;
};


/** mutation root */
export type mutation_rootdelete_readerAuditArgs = {
  where: readerAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_readerProtocolCompatibilityArgs = {
  where: readerProtocolCompatibility_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_readerProtocolCompatibility_by_pkArgs = {
  id: number;
};


/** mutation root */
export type mutation_rootdelete_roleAppPrivilegesArgs = {
  where: roleAppPrivileges_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_roleAppPrivileges_by_pkArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdelete_roleAuditArgs = {
  where: roleAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_rosslareCatalogsArgs = {
  where: rosslareCatalogs_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_rosslareCatalogs_by_pkArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootdelete_s3BucketConfigurationsArgs = {
  where: s3BucketConfigurations_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_s3BucketConfigurations_by_pkArgs = {
  id: number;
};


/** mutation root */
export type mutation_rootdelete_scheduleAuditArgs = {
  where: scheduleAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_scheduleBlockAuditArgs = {
  where: scheduleBlockAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_superviseInputCompatibilityArgs = {
  where: superviseInputCompatibility_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_superviseInputCompatibility_by_pkArgs = {
  id: number;
};


/** mutation root */
export type mutation_rootdelete_videoSourceAuditArgs = {
  where: videoSourceAudit_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_videoSourceStateArgs = {
  where: videoSourceState_bool_exp;
};


/** mutation root */
export type mutation_rootdelete_videoSourceState_by_pkArgs = {
  videoSourceID: string;
};


/** mutation root */
export type mutation_rootdetachDeviceArgs = {
  detach: boolean;
  id: string;
};


/** mutation root */
export type mutation_rootdoorStatesArgs = {
  doorID: string;
};


/** mutation root */
export type mutation_rootdoorStatesPlaceArgs = {
  placeID: string;
};


/** mutation root */
export type mutation_rootdoubleLockDoorArgs = {
  doorID: string;
};


/** mutation root */
export type mutation_rootflow_accessDoorArgs = {
  _data: any;
  _flow: any;
  accessTime?: string;
  doorID: string;
  extended?: boolean;
};


/** mutation root */
export type mutation_rootflow_awayArmPartitionArgs = {
  _data: any;
  _flow: any;
  partitionID: string;
};


/** mutation root */
export type mutation_rootflow_bypassZoneArgs = {
  _data: any;
  _flow: any;
  zoneID: string;
};


/** mutation root */
export type mutation_rootflow_disarmPartitionArgs = {
  _data: any;
  _flow: any;
  partitionID: string;
};


/** mutation root */
export type mutation_rootflow_email_notificationArgs = {
  _data: any;
  _flow: any;
  body: string;
  emails?: Array<string>;
  people?: Array<string>;
  runOnGateway?: boolean;
  subject: string;
};


/** mutation root */
export type mutation_rootflow_lockDoorArgs = {
  _data: any;
  _flow: any;
  doorID: string;
};


/** mutation root */
export type mutation_rootflow_lockDownDoorArgs = {
  _data: any;
  _flow: any;
  doorID: string;
};


/** mutation root */
export type mutation_rootflow_lockDownPlaceArgs = {
  _data: any;
  _flow: any;
  placeID: string;
};


/** mutation root */
export type mutation_rootflow_ptzMoveToPresetArgs = {
  _data?: any;
  _flow?: any;
  preset: string;
  videoSourceID: string;
};


/** mutation root */
export type mutation_rootflow_releaseLockDownDoorArgs = {
  _data: any;
  _flow: any;
  doorID: string;
};


/** mutation root */
export type mutation_rootflow_releaseLockDownPlaceArgs = {
  _data: any;
  _flow: any;
  placeID: string;
};


/** mutation root */
export type mutation_rootflow_resetOutputArgs = {
  _data: any;
  _flow: any;
  outputPointID: string;
};


/** mutation root */
export type mutation_rootflow_revertDoorArgs = {
  _data: any;
  _flow: any;
  doorID: string;
};


/** mutation root */
export type mutation_rootflow_sms_notificationArgs = {
  _data: any;
  _flow: any;
  message: string;
  people?: Array<string>;
  phoneNumbers?: Array<string>;
};


/** mutation root */
export type mutation_rootflow_stayArmPartitionArgs = {
  _data: any;
  _flow: any;
  partitionID: string;
};


/** mutation root */
export type mutation_rootflow_triggerOutputArgs = {
  _data: any;
  _flow: any;
  outputPointID: string;
};


/** mutation root */
export type mutation_rootflow_unlockDoorArgs = {
  _data: any;
  _flow: any;
  doorID: string;
};


/** mutation root */
export type mutation_rootflow_webhookArgs = {
  _data: any;
  _flow: any;
  body?: any;
  headers?: any;
  method?: string;
  runOnGateway?: boolean;
  url: string;
};


/** mutation root */
export type mutation_rootgenerateTwoFactorBackupCodesArgs = {
  token: string;
};


/** mutation root */
export type mutation_rootgetClipUrlArgs = {
  clipID: string;
};


/** mutation root */
export type mutation_rootgetDownloadAccessReportUrlArgs = {
  expiresAt?: string;
  filter?: AccessReportFilterInput;
  limit?: number;
  offset?: number;
  options?: AccessReportOptionsInput;
  orderBy?: Array<AccessReportOrderByInput>;
  type: ReportType;
};


/** mutation root */
export type mutation_rootgetDownloadClipUrlArgs = {
  clipID: string;
};


/** mutation root */
export type mutation_rootinsertAuditLogArgs = {
  object: qx_AuditLog_insert_input;
  on_conflict?: qx_AuditLog_on_conflict;
};


/** mutation root */
export type mutation_rootinsertAuditLogsArgs = {
  objects: Array<qx_AuditLog_insert_input>;
  on_conflict?: qx_AuditLog_on_conflict;
};


/** mutation root */
export type mutation_rootinsertSharedLinkArgs = {
  object: qx_SharedLinks_insert_input;
  on_conflict?: qx_SharedLinks_on_conflict;
};


/** mutation root */
export type mutation_rootinsertSharedLinksArgs = {
  objects: Array<qx_SharedLinks_insert_input>;
  on_conflict?: qx_SharedLinks_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_AnalyticSourcesArgs = {
  objects: Array<AnalyticSources_insert_input>;
  on_conflict?: AnalyticSources_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_AnalyticSources_oneArgs = {
  object: AnalyticSources_insert_input;
  on_conflict?: AnalyticSources_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_ApplicationUserGatewayPasswordArgs = {
  objects: Array<ApplicationUserGatewayPassword_insert_input>;
  on_conflict?: ApplicationUserGatewayPassword_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_ApplicationUserGatewayPassword_oneArgs = {
  object: ApplicationUserGatewayPassword_insert_input;
  on_conflict?: ApplicationUserGatewayPassword_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_ApplicationUserTwoFactorArgs = {
  objects: Array<ApplicationUserTwoFactor_insert_input>;
  on_conflict?: ApplicationUserTwoFactor_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_ApplicationUserTwoFactor_oneArgs = {
  object: ApplicationUserTwoFactor_insert_input;
  on_conflict?: ApplicationUserTwoFactor_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_DSCConnectionArgs = {
  objects: Array<DSCConnection_insert_input>;
  on_conflict?: DSCConnection_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_DSCConnection_oneArgs = {
  object: DSCConnection_insert_input;
  on_conflict?: DSCConnection_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_IntrusionAccessCodeArgs = {
  objects: Array<IntrusionAccessCode_insert_input>;
  on_conflict?: IntrusionAccessCode_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_IntrusionAccessCode_oneArgs = {
  object: IntrusionAccessCode_insert_input;
  on_conflict?: IntrusionAccessCode_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_IntrusionPartitionArgs = {
  objects: Array<IntrusionPartition_insert_input>;
  on_conflict?: IntrusionPartition_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_IntrusionPartition_oneArgs = {
  object: IntrusionPartition_insert_input;
  on_conflict?: IntrusionPartition_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_IntrusionZoneArgs = {
  objects: Array<IntrusionZone_insert_input>;
  on_conflict?: IntrusionZone_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_IntrusionZone_oneArgs = {
  object: IntrusionZone_insert_input;
  on_conflict?: IntrusionZone_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_PartitionZoneAssignmentsArgs = {
  objects: Array<PartitionZoneAssignments_insert_input>;
  on_conflict?: PartitionZoneAssignments_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_PartitionZoneAssignments_oneArgs = {
  object: PartitionZoneAssignments_insert_input;
  on_conflict?: PartitionZoneAssignments_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_PassKeyProviderArgs = {
  objects: Array<PassKeyProvider_insert_input>;
  on_conflict?: PassKeyProvider_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_PassKeyProvider_oneArgs = {
  object: PassKeyProvider_insert_input;
  on_conflict?: PassKeyProvider_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_PermissionPartitionAssignmentsArgs = {
  objects: Array<PermissionPartitionAssignments_insert_input>;
  on_conflict?: PermissionPartitionAssignments_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_PermissionPartitionAssignments_oneArgs = {
  object: PermissionPartitionAssignments_insert_input;
  on_conflict?: PermissionPartitionAssignments_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_PersonTermsAgreementArgs = {
  objects: Array<PersonTermsAgreement_insert_input>;
  on_conflict?: PersonTermsAgreement_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_PersonTermsAgreement_oneArgs = {
  object: PersonTermsAgreement_insert_input;
  on_conflict?: PersonTermsAgreement_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_analyticAttributePropertiesArgs = {
  objects: Array<analyticAttributeProperties_insert_input>;
  on_conflict?: analyticAttributeProperties_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_analyticAttributeProperties_oneArgs = {
  object: analyticAttributeProperties_insert_input;
  on_conflict?: analyticAttributeProperties_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_analyticAttributesArgs = {
  objects: Array<analyticAttributes_insert_input>;
  on_conflict?: analyticAttributes_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_analyticAttributes_oneArgs = {
  object: analyticAttributes_insert_input;
  on_conflict?: analyticAttributes_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_analyticDetectedPropertiesArgs = {
  objects: Array<analyticDetectedProperties_insert_input>;
  on_conflict?: analyticDetectedProperties_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_analyticDetectedProperties_oneArgs = {
  object: analyticDetectedProperties_insert_input;
  on_conflict?: analyticDetectedProperties_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_analyticTypesArgs = {
  objects: Array<analyticTypes_insert_input>;
  on_conflict?: analyticTypes_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_analyticTypes_oneArgs = {
  object: analyticTypes_insert_input;
  on_conflict?: analyticTypes_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_analyticsArgs = {
  objects: Array<analytics_insert_input>;
  on_conflict?: analytics_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_analytics_oneArgs = {
  object: analytics_insert_input;
  on_conflict?: analytics_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_applicationUserAppPasswordsArgs = {
  objects: Array<applicationUserAppPasswords_insert_input>;
  on_conflict?: applicationUserAppPasswords_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_applicationUserAppPasswords_oneArgs = {
  object: applicationUserAppPasswords_insert_input;
  on_conflict?: applicationUserAppPasswords_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_applicationUserDevicesArgs = {
  objects: Array<applicationUserDevices_insert_input>;
  on_conflict?: applicationUserDevices_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_applicationUserDevices_oneArgs = {
  object: applicationUserDevices_insert_input;
  on_conflict?: applicationUserDevices_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_attributePropertiesArgs = {
  objects: Array<attributeProperties_insert_input>;
  on_conflict?: attributeProperties_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_attributeProperties_oneArgs = {
  object: attributeProperties_insert_input;
  on_conflict?: attributeProperties_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_attributesArgs = {
  objects: Array<attributes_insert_input>;
  on_conflict?: attributes_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_attributes_oneArgs = {
  object: attributes_insert_input;
  on_conflict?: attributes_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_audioSourceAuditArgs = {
  objects: Array<audioSourceAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_audioSourceAudit_oneArgs = {
  object: audioSourceAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_audit_logged_actionsArgs = {
  objects: Array<audit_logged_actions_insert_input>;
  on_conflict?: audit_logged_actions_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_audit_logged_actions_oneArgs = {
  object: audit_logged_actions_insert_input;
  on_conflict?: audit_logged_actions_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_audit_vSensorAuditArgs = {
  objects: Array<audit_vSensorAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_audit_vSensorAudit_oneArgs = {
  object: audit_vSensorAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_cloudStorageTimelapseOptionsArgs = {
  objects: Array<cloudStorageTimelapseOptions_insert_input>;
  on_conflict?: cloudStorageTimelapseOptions_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_cloudStorageTimelapseOptions_oneArgs = {
  object: cloudStorageTimelapseOptions_insert_input;
  on_conflict?: cloudStorageTimelapseOptions_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_credentialAuditArgs = {
  objects: Array<credentialAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_credentialAudit_oneArgs = {
  object: credentialAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_customerPermissionAuditArgs = {
  objects: Array<customerPermissionAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_customerPermissionAudit_oneArgs = {
  object: customerPermissionAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_deviceAnalyticSourceArgs = {
  objects: Array<deviceAnalyticSource_insert_input>;
  on_conflict?: deviceAnalyticSource_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_deviceAnalyticSource_oneArgs = {
  object: deviceAnalyticSource_insert_input;
  on_conflict?: deviceAnalyticSource_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_deviceAuditArgs = {
  objects: Array<deviceAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_deviceAudit_oneArgs = {
  object: deviceAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_deviceDIOAuditArgs = {
  objects: Array<deviceDIOAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_deviceDIOAudit_oneArgs = {
  object: deviceDIOAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_doorAuditArgs = {
  objects: Array<doorAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_doorAudit_oneArgs = {
  object: doorAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_eAnalyticIntegrationsArgs = {
  objects: Array<eAnalyticIntegrations_insert_input>;
  on_conflict?: eAnalyticIntegrations_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_eAnalyticIntegrations_oneArgs = {
  object: eAnalyticIntegrations_insert_input;
  on_conflict?: eAnalyticIntegrations_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_eAnalyticStatesArgs = {
  objects: Array<eAnalyticStates_insert_input>;
  on_conflict?: eAnalyticStates_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_eAnalyticStates_oneArgs = {
  object: eAnalyticStates_insert_input;
  on_conflict?: eAnalyticStates_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_eGatewayTypeArgs = {
  objects: Array<eGatewayType_insert_input>;
  on_conflict?: eGatewayType_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_eGatewayType_oneArgs = {
  object: eGatewayType_insert_input;
  on_conflict?: eGatewayType_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_eS3BucketTypeArgs = {
  objects: Array<eS3BucketType_insert_input>;
  on_conflict?: eS3BucketType_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_eS3BucketType_oneArgs = {
  object: eS3BucketType_insert_input;
  on_conflict?: eS3BucketType_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_flowAuditArgs = {
  objects: Array<flowAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_flowAudit_oneArgs = {
  object: flowAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_gatewayAuditArgs = {
  objects: Array<gatewayAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_gatewayAudit_oneArgs = {
  object: gatewayAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_gatewayBandwidthScheduleAuditArgs = {
  objects: Array<gatewayBandwidthScheduleAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_gatewayBandwidthScheduleAudit_oneArgs = {
  object: gatewayBandwidthScheduleAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_groupAuditArgs = {
  objects: Array<groupAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_groupAudit_oneArgs = {
  object: groupAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_guestAccessArgs = {
  objects: Array<guestAccess_insert_input>;
  on_conflict?: guestAccess_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_guestAccess_oneArgs = {
  object: guestAccess_insert_input;
  on_conflict?: guestAccess_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_holidaySetAuditArgs = {
  objects: Array<holidaySetAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_holidaySetAudit_oneArgs = {
  object: holidaySetAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_holidaySetToScheduleBlockAuditArgs = {
  objects: Array<holidaySetToScheduleBlockAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_holidaySetToScheduleBlockAudit_oneArgs = {
  object: holidaySetToScheduleBlockAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_inputPointAuditArgs = {
  objects: Array<inputPointAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_inputPointAudit_oneArgs = {
  object: inputPointAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_lockAuditArgs = {
  objects: Array<lockAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_lockAudit_oneArgs = {
  object: lockAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_mediaProfileAuditArgs = {
  objects: Array<mediaProfileAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_mediaProfileAudit_oneArgs = {
  object: mediaProfileAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_outputPointAuditArgs = {
  objects: Array<outputPointAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_outputPointAudit_oneArgs = {
  object: outputPointAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_permissionAuditArgs = {
  objects: Array<permissionAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_permissionAudit_oneArgs = {
  object: permissionAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_personAuditArgs = {
  objects: Array<personAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_personAudit_oneArgs = {
  object: personAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_personDeviceAppPrivilegesArgs = {
  objects: Array<personDeviceAppPrivileges_insert_input>;
  on_conflict?: personDeviceAppPrivileges_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_personDeviceAppPrivileges_oneArgs = {
  object: personDeviceAppPrivileges_insert_input;
  on_conflict?: personDeviceAppPrivileges_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_personDoorAppPrivilegesArgs = {
  objects: Array<personDoorAppPrivileges_insert_input>;
  on_conflict?: personDoorAppPrivileges_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_personDoorAppPrivileges_oneArgs = {
  object: personDoorAppPrivileges_insert_input;
  on_conflict?: personDoorAppPrivileges_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_personIntrusionPartitionAppPrivilegesArgs = {
  objects: Array<personIntrusionPartitionAppPrivileges_insert_input>;
  on_conflict?: personIntrusionPartitionAppPrivileges_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_personIntrusionPartitionAppPrivileges_oneArgs = {
  object: personIntrusionPartitionAppPrivileges_insert_input;
  on_conflict?: personIntrusionPartitionAppPrivileges_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_personPlaceAppPrivilegesArgs = {
  objects: Array<personPlaceAppPrivileges_insert_input>;
  on_conflict?: personPlaceAppPrivileges_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_personPlaceAppPrivileges_oneArgs = {
  object: personPlaceAppPrivileges_insert_input;
  on_conflict?: personPlaceAppPrivileges_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_personToGroupAuditArgs = {
  objects: Array<personToGroupAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_personToGroupAudit_oneArgs = {
  object: personToGroupAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_personVideoSourceAppPrivilegesArgs = {
  objects: Array<personVideoSourceAppPrivileges_insert_input>;
  on_conflict?: personVideoSourceAppPrivileges_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_personVideoSourceAppPrivileges_oneArgs = {
  object: personVideoSourceAppPrivileges_insert_input;
  on_conflict?: personVideoSourceAppPrivileges_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_placeAuditArgs = {
  objects: Array<placeAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_placeAudit_oneArgs = {
  object: placeAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_placeWhiteListsArgs = {
  objects: Array<placeWhiteLists_insert_input>;
  on_conflict?: placeWhiteLists_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_placeWhiteLists_oneArgs = {
  object: placeWhiteLists_insert_input;
  on_conflict?: placeWhiteLists_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_privilegeEnumToRoleAuditArgs = {
  objects: Array<privilegeEnumToRoleAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_privilegeEnumToRoleAudit_oneArgs = {
  object: privilegeEnumToRoleAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_qx_AccessCatalogCapabilitiesArgs = {
  objects: Array<qx_AccessCatalogCapabilities_insert_input>;
  on_conflict?: qx_AccessCatalogCapabilities_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_AccessCatalogCapabilities_oneArgs = {
  object: qx_AccessCatalogCapabilities_insert_input;
  on_conflict?: qx_AccessCatalogCapabilities_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_AuditableActionArgs = {
  objects: Array<qx_AuditableAction_insert_input>;
  on_conflict?: qx_AuditableAction_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_AuditableAction_oneArgs = {
  object: qx_AuditableAction_insert_input;
  on_conflict?: qx_AuditableAction_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_AuditableTypeArgs = {
  objects: Array<qx_AuditableType_insert_input>;
  on_conflict?: qx_AuditableType_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_AuditableType_oneArgs = {
  object: qx_AuditableType_insert_input;
  on_conflict?: qx_AuditableType_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_BillingPeriodArgs = {
  objects: Array<qx_BillingPeriod_insert_input>;
  on_conflict?: qx_BillingPeriod_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_CatalogProtocolOverrideArgs = {
  objects: Array<qx_CatalogProtocolOverride_insert_input>;
  on_conflict?: qx_CatalogProtocolOverride_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_CatalogProtocolOverride_oneArgs = {
  object: qx_CatalogProtocolOverride_insert_input;
  on_conflict?: qx_CatalogProtocolOverride_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_ClipAuditLogArgs = {
  objects: Array<qx_ClipAuditLog_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_qx_ClipAuditLog_oneArgs = {
  object: qx_ClipAuditLog_insert_input;
};


/** mutation root */
export type mutation_rootinsert_qx_CloudStorageOptionsArgs = {
  objects: Array<qx_CloudStorageOptions_insert_input>;
  on_conflict?: qx_CloudStorageOptions_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_CustomerAuthProviderArgs = {
  objects: Array<qx_CustomerAuthProvider_insert_input>;
  on_conflict?: qx_CustomerAuthProvider_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_CustomerAuthProvider_oneArgs = {
  object: qx_CustomerAuthProvider_insert_input;
  on_conflict?: qx_CustomerAuthProvider_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_DiscoveryTypeArgs = {
  objects: Array<qx_DiscoveryType_insert_input>;
  on_conflict?: qx_DiscoveryType_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_DiscoveryType_oneArgs = {
  object: qx_DiscoveryType_insert_input;
  on_conflict?: qx_DiscoveryType_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_EventType_oneArgs = {
  object: qx_EventType_insert_input;
  on_conflict?: qx_EventType_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_IntrusionAlarmArgs = {
  objects: Array<qx_IntrusionAlarm_insert_input>;
  on_conflict?: qx_IntrusionAlarm_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_IntrusionAlarm_oneArgs = {
  object: qx_IntrusionAlarm_insert_input;
  on_conflict?: qx_IntrusionAlarm_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_IntrusionPartitionStateArgs = {
  objects: Array<qx_IntrusionPartitionState_insert_input>;
  on_conflict?: qx_IntrusionPartitionState_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_IntrusionPartitionState_oneArgs = {
  object: qx_IntrusionPartitionState_insert_input;
  on_conflict?: qx_IntrusionPartitionState_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_IntrusionZoneStateArgs = {
  objects: Array<qx_IntrusionZoneState_insert_input>;
  on_conflict?: qx_IntrusionZoneState_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_IntrusionZoneState_oneArgs = {
  object: qx_IntrusionZoneState_insert_input;
  on_conflict?: qx_IntrusionZoneState_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_MediaProfileRecordingArgs = {
  objects: Array<qx_MediaProfileRecording_insert_input>;
  on_conflict?: qx_MediaProfileRecording_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_MediaProfileRecording_oneArgs = {
  object: qx_MediaProfileRecording_insert_input;
  on_conflict?: qx_MediaProfileRecording_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_OssKeyArgs = {
  objects: Array<qx_OssKey_insert_input>;
  on_conflict?: qx_OssKey_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_OssKey_oneArgs = {
  object: qx_OssKey_insert_input;
  on_conflict?: qx_OssKey_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_SharedLinkAuditLogArgs = {
  objects: Array<qx_SharedLinkAuditLog_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_qx_SharedLinkAuditLog_oneArgs = {
  object: qx_SharedLinkAuditLog_insert_input;
};


/** mutation root */
export type mutation_rootinsert_qx_SharedLinkTypeArgs = {
  objects: Array<qx_SharedLinkType_insert_input>;
  on_conflict?: qx_SharedLinkType_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_SharedLinkType_oneArgs = {
  object: qx_SharedLinkType_insert_input;
  on_conflict?: qx_SharedLinkType_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_VideoSourceStorageAuditArgs = {
  objects: Array<qx_VideoSourceStorageAudit_insert_input>;
  on_conflict?: qx_VideoSourceStorageAudit_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_VideoSourceStorageAudit_oneArgs = {
  object: qx_VideoSourceStorageAudit_insert_input;
  on_conflict?: qx_VideoSourceStorageAudit_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_eAccessMakeArgs = {
  objects: Array<qx_eAccessMake_insert_input>;
  on_conflict?: qx_eAccessMake_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_eAccessMake_oneArgs = {
  object: qx_eAccessMake_insert_input;
  on_conflict?: qx_eAccessMake_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_eAppPrivilegeTypeArgs = {
  objects: Array<qx_eAppPrivilegeType_insert_input>;
  on_conflict?: qx_eAppPrivilegeType_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_eAppPrivilegeType_oneArgs = {
  object: qx_eAppPrivilegeType_insert_input;
  on_conflict?: qx_eAppPrivilegeType_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_eAuthProviderArgs = {
  objects: Array<qx_eAuthProvider_insert_input>;
  on_conflict?: qx_eAuthProvider_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_eAuthProvider_oneArgs = {
  object: qx_eAuthProvider_insert_input;
  on_conflict?: qx_eAuthProvider_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_eFlowStatusArgs = {
  objects: Array<qx_eFlowStatus_insert_input>;
  on_conflict?: qx_eFlowStatus_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_eFlowStatus_oneArgs = {
  object: qx_eFlowStatus_insert_input;
  on_conflict?: qx_eFlowStatus_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_eFlowTraceActionStatusArgs = {
  objects: Array<qx_eFlowTraceActionStatus_insert_input>;
  on_conflict?: qx_eFlowTraceActionStatus_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_eFlowTraceActionStatus_oneArgs = {
  object: qx_eFlowTraceActionStatus_insert_input;
  on_conflict?: qx_eFlowTraceActionStatus_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_eFlowTraceStateArgs = {
  objects: Array<qx_eFlowTraceState_insert_input>;
  on_conflict?: qx_eFlowTraceState_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_eFlowTraceState_oneArgs = {
  object: qx_eFlowTraceState_insert_input;
  on_conflict?: qx_eFlowTraceState_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_eIntrusionZoneTypeArgs = {
  objects: Array<qx_eIntrusionZoneType_insert_input>;
  on_conflict?: qx_eIntrusionZoneType_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_eIntrusionZoneType_oneArgs = {
  object: qx_eIntrusionZoneType_insert_input;
  on_conflict?: qx_eIntrusionZoneType_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_eLockModeArgs = {
  objects: Array<qx_eLockMode_insert_input>;
  on_conflict?: qx_eLockMode_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_eLockMode_oneArgs = {
  object: qx_eLockMode_insert_input;
  on_conflict?: qx_eLockMode_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_eMercuryMonitorPointLatchModesArgs = {
  objects: Array<qx_eMercuryMonitorPointLatchModes_insert_input>;
  on_conflict?: qx_eMercuryMonitorPointLatchModes_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_eMercuryMonitorPointLatchModes_oneArgs = {
  object: qx_eMercuryMonitorPointLatchModes_insert_input;
  on_conflict?: qx_eMercuryMonitorPointLatchModes_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_qx_vPlacePrivilegeArgs = {
  objects: Array<qx_vPlacePrivilege_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_qx_vPlacePrivilege_oneArgs = {
  object: qx_vPlacePrivilege_insert_input;
};


/** mutation root */
export type mutation_rootinsert_qx_vProfilesArgs = {
  objects: Array<qx_vProfiles_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_qx_vProfiles_oneArgs = {
  object: qx_vProfiles_insert_input;
};


/** mutation root */
export type mutation_rootinsert_qxanalytics_CloudUsageArgs = {
  objects: Array<qxanalytics_CloudUsage_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_qxanalytics_CloudUsage_oneArgs = {
  object: qxanalytics_CloudUsage_insert_input;
};


/** mutation root */
export type mutation_rootinsert_readerAccessTypeCompatibilityArgs = {
  objects: Array<readerAccessTypeCompatibility_insert_input>;
  on_conflict?: readerAccessTypeCompatibility_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_readerAccessTypeCompatibility_oneArgs = {
  object: readerAccessTypeCompatibility_insert_input;
  on_conflict?: readerAccessTypeCompatibility_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_readerAuditArgs = {
  objects: Array<readerAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_readerAudit_oneArgs = {
  object: readerAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_readerProtocolCompatibilityArgs = {
  objects: Array<readerProtocolCompatibility_insert_input>;
  on_conflict?: readerProtocolCompatibility_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_readerProtocolCompatibility_oneArgs = {
  object: readerProtocolCompatibility_insert_input;
  on_conflict?: readerProtocolCompatibility_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_roleAppPrivilegesArgs = {
  objects: Array<roleAppPrivileges_insert_input>;
  on_conflict?: roleAppPrivileges_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_roleAppPrivileges_oneArgs = {
  object: roleAppPrivileges_insert_input;
  on_conflict?: roleAppPrivileges_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_roleAuditArgs = {
  objects: Array<roleAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_roleAudit_oneArgs = {
  object: roleAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_rosslareCatalogsArgs = {
  objects: Array<rosslareCatalogs_insert_input>;
  on_conflict?: rosslareCatalogs_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_rosslareCatalogs_oneArgs = {
  object: rosslareCatalogs_insert_input;
  on_conflict?: rosslareCatalogs_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_s3BucketConfigurationsArgs = {
  objects: Array<s3BucketConfigurations_insert_input>;
  on_conflict?: s3BucketConfigurations_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_s3BucketConfigurations_oneArgs = {
  object: s3BucketConfigurations_insert_input;
  on_conflict?: s3BucketConfigurations_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_scheduleAuditArgs = {
  objects: Array<scheduleAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_scheduleAudit_oneArgs = {
  object: scheduleAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_scheduleBlockAuditArgs = {
  objects: Array<scheduleBlockAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_scheduleBlockAudit_oneArgs = {
  object: scheduleBlockAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_superviseInputCompatibilityArgs = {
  objects: Array<superviseInputCompatibility_insert_input>;
  on_conflict?: superviseInputCompatibility_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_superviseInputCompatibility_oneArgs = {
  object: superviseInputCompatibility_insert_input;
  on_conflict?: superviseInputCompatibility_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_videoSourceAuditArgs = {
  objects: Array<videoSourceAudit_insert_input>;
};


/** mutation root */
export type mutation_rootinsert_videoSourceAudit_oneArgs = {
  object: videoSourceAudit_insert_input;
};


/** mutation root */
export type mutation_rootinsert_videoSourceStateArgs = {
  objects: Array<videoSourceState_insert_input>;
  on_conflict?: videoSourceState_on_conflict;
};


/** mutation root */
export type mutation_rootinsert_videoSourceState_oneArgs = {
  object: videoSourceState_insert_input;
  on_conflict?: videoSourceState_on_conflict;
};


/** mutation root */
export type mutation_rootlockDoorArgs = {
  doorID: string;
};


/** mutation root */
export type mutation_rootlockDownDoorArgs = {
  doorID: string;
};


/** mutation root */
export type mutation_rootlockDownPlaceArgs = {
  placeID: string;
};


/** mutation root */
export type mutation_rootlockDownReleaseDoorArgs = {
  doorID: string;
};


/** mutation root */
export type mutation_rootlockDownReleasePlaceArgs = {
  placeID: string;
};


/** mutation root */
export type mutation_rootlockOpenDoorArgs = {
  doorID: string;
};


/** mutation root */
export type mutation_rootlockOpenReleaseDoorArgs = {
  doorID: string;
};


/** mutation root */
export type mutation_rootmovePlaceArgs = {
  parentPlaceID: string;
  placeID: string;
};


/** mutation root */
export type mutation_rootpacsConfigurationUpdatePlaceArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootpacsHardwareConfigurationArgs = {
  input: pacsSettings;
};


/** mutation root */
export type mutation_rootpacsUpdateArgs = {
  deviceID: string;
};


/** mutation root */
export type mutation_rootpeerOfferArgs = {
  gatewayID?: string;
  iceServers?: Array<IceServerInput>;
  sdp: string;
  trickle?: boolean;
};


/** mutation root */
export type mutation_rootpermanentlyDeletePersonArgs = {
  personID: string;
};


/** mutation root */
export type mutation_rootpostDevicesToGatewayFromCloudArgs = {
  input: MinionDevices;
};


/** mutation root */
export type mutation_rootpushCandidateArgs = {
  candidate: string;
  gatewayID?: string;
  id: number;
};


/** mutation root */
export type mutation_rootqx_createDeviceArgs = {
  object: qx_Device_insert_input;
  on_conflict?: qx_Device_on_conflict;
};


/** mutation root */
export type mutation_rootqx_createDevicesArgs = {
  objects: Array<qx_Device_insert_input>;
  on_conflict?: qx_Device_on_conflict;
};


/** mutation root */
export type mutation_rootrebootMinionArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootreconnectMinionArgs = {
  id: string;
};


/** mutation root */
export type mutation_rootrefreshDeviceConnectionStatusesArgs = {
  gatewayID: string;
};


/** mutation root */
export type mutation_rootremoveClipArgs = {
  clipID: string;
};


/** mutation root */
export type mutation_rootremoveSSOArgs = {
  customerPlaceID: string;
  strategy: string;
};


/** mutation root */
export type mutation_rootremoveSharedLinkArgs = {
  sharedLinkID: string;
};


/** mutation root */
export type mutation_rootremoveSharedLinksArgs = {
  linkableID: string;
  linkableType: SharedLinkType;
};


/** mutation root */
export type mutation_rootremoveTwoFactorArgs = {
  token: string;
};


/** mutation root */
export type mutation_rootrevertDoorArgs = {
  doorID: string;
};


/** mutation root */
export type mutation_rootsaveClipArgs = {
  cameraID?: string;
  description: string;
  endTime: string;
  eventID?: string;
  expiresAt?: string;
  name: string;
  onlyTimelapseSnapshots?: boolean;
  startTime: string;
  timelapse?: boolean;
  timelapseDuration?: number;
  videoSourceID?: string;
};


/** mutation root */
export type mutation_rootscanSegmentsArgs = {
  deviceID: string;
  drive?: number;
  gatewayID?: string;
  refID: string;
};


/** mutation root */
export type mutation_rootsetOSSKeysArgs = {
  overwrite?: boolean;
  placeID: string;
  read?: string;
  write?: string;
};


/** mutation root */
export type mutation_rootsetOfflinePasswordArgs = {
  password: string;
};


/** mutation root */
export type mutation_rootsetupCameraGatewayArgs = {
  code: string;
  deviceName: string;
  placeID: string;
};


/** mutation root */
export type mutation_rootsetupSSOArgs = {
  customerPlaceID: string;
  strategy: string;
};


/** mutation root */
export type mutation_rootsetupTwoFactorArgs = {
  token: string;
};


/** mutation root */
export type mutation_rootsignoutArgs = {
  allProfiles?: boolean;
  sessionID?: string;
};


/** mutation root */
export type mutation_rootsignoutEverywhereArgs = {
  staySignedInCurrentSession?: boolean;
};


/** mutation root */
export type mutation_rootsubmitHardwareArgs = {
  config?: any;
  deviceID: string;
};


/** mutation root */
export type mutation_rootswitchProfileArgs = {
  personID: string;
};


/** mutation root */
export type mutation_rootsyncArgs = {
  gatewayID: string;
};


/** mutation root */
export type mutation_rootsyncMediaProfileRecordingsArgs = {
  gatewayID: string;
  videoSourceID?: string;
};


/** mutation root */
export type mutation_rootsyncPeopleFromAuthProviderArgs = {
  customerPlaceID: string;
};


/** mutation root */
export type mutation_roottestDeviceConnectionArgs = {
  connectionSettings: MinionConnectionSettingsInput;
  gatewayID: string;
};


/** mutation root */
export type mutation_rootunlockDoorArgs = {
  doorID: string;
};


/** mutation root */
export type mutation_rootupateBatteryLevelEnumsArgs = {
  _set?: qx_eBatteryLevel_set_input;
  where: qx_eBatteryLevel_bool_exp;
};


/** mutation root */
export type mutation_rootupdateAccessBoardTypeEnumArgs = {
  _set?: qx_eAccessBoardType_set_input;
  pk_columns: qx_eAccessBoardType_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateAccessBoardTypeEnumsArgs = {
  _set?: qx_eAccessBoardType_set_input;
  where: qx_eAccessBoardType_bool_exp;
};


/** mutation root */
export type mutation_rootupdateAccessCatalogArgs = {
  _inc?: qx_AccessCatalog_inc_input;
  _set?: qx_AccessCatalog_set_input;
  pk_columns: qx_AccessCatalog_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateAccessCatalogsArgs = {
  _inc?: qx_AccessCatalog_inc_input;
  _set?: qx_AccessCatalog_set_input;
  where: qx_AccessCatalog_bool_exp;
};


/** mutation root */
export type mutation_rootupdateAccessDeniedReasonEnumArgs = {
  _set?: qx_eAccessDeniedReason_set_input;
  pk_columns: qx_eAccessDeniedReason_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateAccessDeniedReasonEnumsArgs = {
  _set?: qx_eAccessDeniedReason_set_input;
  where: qx_eAccessDeniedReason_bool_exp;
};


/** mutation root */
export type mutation_rootupdateAccessInterfaceTypeEnumArgs = {
  _set?: qx_eAccessInterfaceType_set_input;
  pk_columns: qx_eAccessInterfaceType_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateAccessInterfaceTypeEnumsArgs = {
  _set?: qx_eAccessInterfaceType_set_input;
  where: qx_eAccessInterfaceType_bool_exp;
};


/** mutation root */
export type mutation_rootupdateAccessInventoriesArgs = {
  _inc?: qx_AccessInventory_inc_input;
  _set?: qx_AccessInventory_set_input;
  where: qx_AccessInventory_bool_exp;
};


/** mutation root */
export type mutation_rootupdateAccessInventoryArgs = {
  _inc?: qx_AccessInventory_inc_input;
  _set?: qx_AccessInventory_set_input;
  pk_columns: qx_AccessInventory_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateAccessPointActionEnumArgs = {
  _set?: qx_eAccessPointAction_set_input;
  pk_columns: qx_eAccessPointAction_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateAccessPointActionEnumsArgs = {
  _set?: qx_eAccessPointAction_set_input;
  where: qx_eAccessPointAction_bool_exp;
};


/** mutation root */
export type mutation_rootupdateAccessPointDirectionEnumArgs = {
  _set?: qx_eAccessPointDirection_set_input;
  pk_columns: qx_eAccessPointDirection_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateAccessPointDirectionEnumsArgs = {
  _set?: qx_eAccessPointDirection_set_input;
  where: qx_eAccessPointDirection_bool_exp;
};


/** mutation root */
export type mutation_rootupdateAccessPointTypeEnumArgs = {
  _set?: qx_eAccessPointType_set_input;
  pk_columns: qx_eAccessPointType_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateAccessPointTypeEnumsArgs = {
  _set?: qx_eAccessPointType_set_input;
  where: qx_eAccessPointType_bool_exp;
};


/** mutation root */
export type mutation_rootupdateAudioSourceArgs = {
  _inc?: qx_AudioSource_inc_input;
  _set?: qx_AudioSource_set_input;
  pk_columns: qx_AudioSource_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateAudioSourcesArgs = {
  _inc?: qx_AudioSource_inc_input;
  _set?: qx_AudioSource_set_input;
  where: qx_AudioSource_bool_exp;
};


/** mutation root */
export type mutation_rootupdateAuthStrategyEnumArgs = {
  _set?: qx_eAuthStrategy_set_input;
  pk_columns: qx_eAuthStrategy_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateAuthStrategyEnumsArgs = {
  _set?: qx_eAuthStrategy_set_input;
  where: qx_eAuthStrategy_bool_exp;
};


/** mutation root */
export type mutation_rootupdateBatteryLevelEnumArgs = {
  _set?: qx_eBatteryLevel_set_input;
  pk_columns: qx_eBatteryLevel_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateBaudrateEnumArgs = {
  _set?: qx_eBaudrate_set_input;
  pk_columns: qx_eBaudrate_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateBaudrateEnumsArgs = {
  _set?: qx_eBaudrate_set_input;
  where: qx_eBaudrate_bool_exp;
};


/** mutation root */
export type mutation_rootupdateBillingPeriodArgs = {
  _inc?: qx_BillingPeriod_inc_input;
  _set?: qx_BillingPeriod_set_input;
  pk_columns: qx_BillingPeriod_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateBillingTierEnumArgs = {
  _inc?: qx_eBillingTier_inc_input;
  _set?: qx_eBillingTier_set_input;
  pk_columns: qx_eBillingTier_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateBillingTierEnumsArgs = {
  _inc?: qx_eBillingTier_inc_input;
  _set?: qx_eBillingTier_set_input;
  where: qx_eBillingTier_bool_exp;
};


/** mutation root */
export type mutation_rootupdateChatUsageHistoriesArgs = {
  _inc?: qx_ChatUsageHistory_inc_input;
  _set?: qx_ChatUsageHistory_set_input;
  where: qx_ChatUsageHistory_bool_exp;
};


/** mutation root */
export type mutation_rootupdateChatUsageHistoryArgs = {
  _inc?: qx_ChatUsageHistory_inc_input;
  _set?: qx_ChatUsageHistory_set_input;
  pk_columns: qx_ChatUsageHistory_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateClipArgs = {
  _append?: qx_Clip_append_input;
  _delete_at_path?: qx_Clip_delete_at_path_input;
  _delete_elem?: qx_Clip_delete_elem_input;
  _delete_key?: qx_Clip_delete_key_input;
  _inc?: qx_Clip_inc_input;
  _prepend?: qx_Clip_prepend_input;
  _set?: qx_Clip_set_input;
  pk_columns: qx_Clip_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateClipStatusEnumArgs = {
  _set?: qx_eClipStatus_set_input;
  pk_columns: qx_eClipStatus_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateClipStatusEnumsArgs = {
  _set?: qx_eClipStatus_set_input;
  where: qx_eClipStatus_bool_exp;
};


/** mutation root */
export type mutation_rootupdateClipTypeEnumArgs = {
  _set?: qx_eClipType_set_input;
  pk_columns: qx_eClipType_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateClipTypeEnumsArgs = {
  _set?: qx_eClipType_set_input;
  where: qx_eClipType_bool_exp;
};


/** mutation root */
export type mutation_rootupdateClipsArgs = {
  _append?: qx_Clip_append_input;
  _delete_at_path?: qx_Clip_delete_at_path_input;
  _delete_elem?: qx_Clip_delete_elem_input;
  _delete_key?: qx_Clip_delete_key_input;
  _inc?: qx_Clip_inc_input;
  _prepend?: qx_Clip_prepend_input;
  _set?: qx_Clip_set_input;
  where: qx_Clip_bool_exp;
};


/** mutation root */
export type mutation_rootupdateCloudStorageOptionArgs = {
  _inc?: qx_CloudStorageOptions_inc_input;
  _set?: qx_CloudStorageOptions_set_input;
  pk_columns: qx_CloudStorageOptions_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateCredentialArgs = {
  _set?: qx_Credential_set_input;
  pk_columns: qx_Credential_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateCredentialTypeEnumArgs = {
  _set?: qx_eCredentialType_set_input;
  pk_columns: qx_eCredentialType_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateCredentialTypeEnumsArgs = {
  _set?: qx_eCredentialType_set_input;
  where: qx_eCredentialType_bool_exp;
};


/** mutation root */
export type mutation_rootupdateCredentialsArgs = {
  _set?: qx_Credential_set_input;
  where: qx_Credential_bool_exp;
};


/** mutation root */
export type mutation_rootupdateCustomerCanSelfServeArgs = {
  canEnableServices?: boolean;
  customerPlaceID: string;
};


/** mutation root */
export type mutation_rootupdateCustomerPermissionArgs = {
  _set?: qx_CustomerPermission_set_input;
  pk_columns: qx_CustomerPermission_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateCustomerPermissionsArgs = {
  _set?: qx_CustomerPermission_set_input;
  where: qx_CustomerPermission_bool_exp;
};


/** mutation root */
export type mutation_rootupdateCustomerPlacePrivilegesArgs = {
  allowIntegratorAccessOperations?: boolean;
  allowIntegratorConfig?: boolean;
  allowIntegratorVideoOperations?: boolean;
  allowQxSupport?: boolean;
  customerPlaceID: string;
};


/** mutation root */
export type mutation_rootupdateDIONormalStateEnumArgs = {
  _set?: qx_eDIONormalState_set_input;
  pk_columns: qx_eDIONormalState_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateDIONormalStateEnumsArgs = {
  _set?: qx_eDIONormalState_set_input;
  where: qx_eDIONormalState_bool_exp;
};


/** mutation root */
export type mutation_rootupdateDIOStateEnumArgs = {
  _set?: qx_eDIOState_set_input;
  pk_columns: qx_eDIOState_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateDIOStateEnumsArgs = {
  _set?: qx_eDIOState_set_input;
  where: qx_eDIOState_bool_exp;
};


/** mutation root */
export type mutation_rootupdateDIOTypeEnumArgs = {
  _set?: qx_eDIOType_set_input;
  pk_columns: qx_eDIOType_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateDIOTypeEnumsArgs = {
  _set?: qx_eDIOType_set_input;
  where: qx_eDIOType_bool_exp;
};


/** mutation root */
export type mutation_rootupdateDeviceArgs = {
  _append?: qx_Device_append_input;
  _delete_at_path?: qx_Device_delete_at_path_input;
  _delete_elem?: qx_Device_delete_elem_input;
  _delete_key?: qx_Device_delete_key_input;
  _inc?: qx_Device_inc_input;
  _prepend?: qx_Device_prepend_input;
  _set?: qx_Device_set_input;
  pk_columns: qx_Device_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateDeviceConnectionStatusEnumArgs = {
  _set?: qx_eDeviceConnectionStatus_set_input;
  pk_columns: qx_eDeviceConnectionStatus_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateDeviceConnectionStatusEnumsArgs = {
  _set?: qx_eDeviceConnectionStatus_set_input;
  where: qx_eDeviceConnectionStatus_bool_exp;
};


/** mutation root */
export type mutation_rootupdateDeviceDIOArgs = {
  _inc?: qx_DeviceDIO_inc_input;
  _set?: qx_DeviceDIO_set_input;
  pk_columns: qx_DeviceDIO_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateDeviceDIOsArgs = {
  _inc?: qx_DeviceDIO_inc_input;
  _set?: qx_DeviceDIO_set_input;
  where: qx_DeviceDIO_bool_exp;
};


/** mutation root */
export type mutation_rootupdateDeviceKindEnumArgs = {
  _set?: qx_eDeviceKind_set_input;
  pk_columns: qx_eDeviceKind_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateDeviceKindEnumsArgs = {
  _set?: qx_eDeviceKind_set_input;
  where: qx_eDeviceKind_bool_exp;
};


/** mutation root */
export type mutation_rootupdateDeviceWithConnectionArgs = {
  input: UpdateDeviceWithConnectionInput;
};


/** mutation root */
export type mutation_rootupdateDevicesArgs = {
  _append?: qx_Device_append_input;
  _delete_at_path?: qx_Device_delete_at_path_input;
  _delete_elem?: qx_Device_delete_elem_input;
  _delete_key?: qx_Device_delete_key_input;
  _inc?: qx_Device_inc_input;
  _prepend?: qx_Device_prepend_input;
  _set?: qx_Device_set_input;
  where: qx_Device_bool_exp;
};


/** mutation root */
export type mutation_rootupdateDoorArgs = {
  _append?: qx_Door_append_input;
  _delete_at_path?: qx_Door_delete_at_path_input;
  _delete_elem?: qx_Door_delete_elem_input;
  _delete_key?: qx_Door_delete_key_input;
  _inc?: qx_Door_inc_input;
  _prepend?: qx_Door_prepend_input;
  _set?: qx_Door_set_input;
  pk_columns: qx_Door_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateDoorAlarmEnumArgs = {
  _set?: qx_eDoorAlarm_set_input;
  pk_columns: qx_eDoorAlarm_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateDoorAlarmEnumsArgs = {
  _set?: qx_eDoorAlarm_set_input;
  where: qx_eDoorAlarm_bool_exp;
};


/** mutation root */
export type mutation_rootupdateDoorConfigurationArgs = {
  _append?: qx_DoorConfiguration_append_input;
  _delete_at_path?: qx_DoorConfiguration_delete_at_path_input;
  _delete_elem?: qx_DoorConfiguration_delete_elem_input;
  _delete_key?: qx_DoorConfiguration_delete_key_input;
  _prepend?: qx_DoorConfiguration_prepend_input;
  _set?: qx_DoorConfiguration_set_input;
  pk_columns: qx_DoorConfiguration_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateDoorConfigurationsArgs = {
  _append?: qx_DoorConfiguration_append_input;
  _delete_at_path?: qx_DoorConfiguration_delete_at_path_input;
  _delete_elem?: qx_DoorConfiguration_delete_elem_input;
  _delete_key?: qx_DoorConfiguration_delete_key_input;
  _prepend?: qx_DoorConfiguration_prepend_input;
  _set?: qx_DoorConfiguration_set_input;
  where: qx_DoorConfiguration_bool_exp;
};


/** mutation root */
export type mutation_rootupdateDoorContactSuperviseArgs = {
  deviceID: string;
  doorID: string;
  supervise: string;
};


/** mutation root */
export type mutation_rootupdateDoorMetaArgs = {
  _inc?: qx_DoorMeta_inc_input;
  _set?: qx_DoorMeta_set_input;
  pk_columns: qx_DoorMeta_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateDoorMetasArgs = {
  _inc?: qx_DoorMeta_inc_input;
  _set?: qx_DoorMeta_set_input;
  where: qx_DoorMeta_bool_exp;
};


/** mutation root */
export type mutation_rootupdateDoorModeEnumArgs = {
  _set?: qx_eDoorMode_set_input;
  pk_columns: qx_eDoorMode_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateDoorModeEnumsArgs = {
  _set?: qx_eDoorMode_set_input;
  where: qx_eDoorMode_bool_exp;
};


/** mutation root */
export type mutation_rootupdateDoorMonitorEnumArgs = {
  _set?: qx_eDoorMonitor_set_input;
  pk_columns: qx_eDoorMonitor_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateDoorMonitorEnumsArgs = {
  _set?: qx_eDoorMonitor_set_input;
  where: qx_eDoorMonitor_bool_exp;
};


/** mutation root */
export type mutation_rootupdateDoorRexSuperviseArgs = {
  deviceID: string;
  readerID: string;
  supervise: string;
};


/** mutation root */
export type mutation_rootupdateDoorStateEnumArgs = {
  _set?: qx_eDoorState_set_input;
  pk_columns: qx_eDoorState_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateDoorStateEnumsArgs = {
  _set?: qx_eDoorState_set_input;
  where: qx_eDoorState_bool_exp;
};


/** mutation root */
export type mutation_rootupdateDoorTemplateArgs = {
  _set?: qx_DoorTemplate_set_input;
  pk_columns: qx_DoorTemplate_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateDoorTemplatesArgs = {
  _set?: qx_DoorTemplate_set_input;
  where: qx_DoorTemplate_bool_exp;
};


/** mutation root */
export type mutation_rootupdateDoorsArgs = {
  _append?: qx_Door_append_input;
  _delete_at_path?: qx_Door_delete_at_path_input;
  _delete_elem?: qx_Door_delete_elem_input;
  _delete_key?: qx_Door_delete_key_input;
  _inc?: qx_Door_inc_input;
  _prepend?: qx_Door_prepend_input;
  _set?: qx_Door_set_input;
  where: qx_Door_bool_exp;
};


/** mutation root */
export type mutation_rootupdateEventArgs = {
  _inc?: qx_Event_inc_input;
  _set?: qx_Event_set_input;
  pk_columns: qx_Event_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateEventTypesArgs = {
  _inc?: qx_EventType_inc_input;
  _set?: qx_EventType_set_input;
  where: qx_EventType_bool_exp;
};


/** mutation root */
export type mutation_rootupdateEventsArgs = {
  _inc?: qx_Event_inc_input;
  _set?: qx_Event_set_input;
  where: qx_Event_bool_exp;
};


/** mutation root */
export type mutation_rootupdateFlowArgs = {
  _append?: qx_Flow_append_input;
  _delete_at_path?: qx_Flow_delete_at_path_input;
  _delete_elem?: qx_Flow_delete_elem_input;
  _delete_key?: qx_Flow_delete_key_input;
  _inc?: qx_Flow_inc_input;
  _prepend?: qx_Flow_prepend_input;
  _set?: qx_Flow_set_input;
  pk_columns: qx_Flow_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateFlowNotificationTypeEnumArgs = {
  _set?: qx_eFlowNotificationType_set_input;
  pk_columns: qx_eFlowNotificationType_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateFlowNotificationTypeEnumsArgs = {
  _set?: qx_eFlowNotificationType_set_input;
  where: qx_eFlowNotificationType_bool_exp;
};


/** mutation root */
export type mutation_rootupdateFlowTraceArgs = {
  _append?: qx_FlowTrace_append_input;
  _delete_at_path?: qx_FlowTrace_delete_at_path_input;
  _delete_elem?: qx_FlowTrace_delete_elem_input;
  _delete_key?: qx_FlowTrace_delete_key_input;
  _inc?: qx_FlowTrace_inc_input;
  _prepend?: qx_FlowTrace_prepend_input;
  _set?: qx_FlowTrace_set_input;
  pk_columns: qx_FlowTrace_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateFlowTracesArgs = {
  _append?: qx_FlowTrace_append_input;
  _delete_at_path?: qx_FlowTrace_delete_at_path_input;
  _delete_elem?: qx_FlowTrace_delete_elem_input;
  _delete_key?: qx_FlowTrace_delete_key_input;
  _inc?: qx_FlowTrace_inc_input;
  _prepend?: qx_FlowTrace_prepend_input;
  _set?: qx_FlowTrace_set_input;
  where: qx_FlowTrace_bool_exp;
};


/** mutation root */
export type mutation_rootupdateFlowsArgs = {
  _append?: qx_Flow_append_input;
  _delete_at_path?: qx_Flow_delete_at_path_input;
  _delete_elem?: qx_Flow_delete_elem_input;
  _delete_key?: qx_Flow_delete_key_input;
  _inc?: qx_Flow_inc_input;
  _prepend?: qx_Flow_prepend_input;
  _set?: qx_Flow_set_input;
  where: qx_Flow_bool_exp;
};


/** mutation root */
export type mutation_rootupdateGatewayArgs = {
  _append?: qx_Gateway_append_input;
  _delete_at_path?: qx_Gateway_delete_at_path_input;
  _delete_elem?: qx_Gateway_delete_elem_input;
  _delete_key?: qx_Gateway_delete_key_input;
  _inc?: qx_Gateway_inc_input;
  _prepend?: qx_Gateway_prepend_input;
  _set?: qx_Gateway_set_input;
  pk_columns: qx_Gateway_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateGatewayBandwidthScheduleArgs = {
  _inc?: qx_GatewayBandwidthSchedule_inc_input;
  _set?: qx_GatewayBandwidthSchedule_set_input;
  pk_columns: qx_GatewayBandwidthSchedule_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateGatewayBandwidthSchedulesArgs = {
  _inc?: qx_GatewayBandwidthSchedule_inc_input;
  _set?: qx_GatewayBandwidthSchedule_set_input;
  where: qx_GatewayBandwidthSchedule_bool_exp;
};


/** mutation root */
export type mutation_rootupdateGatewayFeaturesArgs = {
  features?: any;
  gatewayID?: string;
};


/** mutation root */
export type mutation_rootupdateGatewayLicenseArgs = {
  gatewayID: string;
  licenseJWT: string;
};


/** mutation root */
export type mutation_rootupdateGatewayServiceTypeEnumArgs = {
  _set?: qx_eGatewayServiceType_set_input;
  pk_columns: qx_eGatewayServiceType_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateGatewayServiceTypeEnumsArgs = {
  _set?: qx_eGatewayServiceType_set_input;
  where: qx_eGatewayServiceType_bool_exp;
};


/** mutation root */
export type mutation_rootupdateGatewaySyncStatusEnumArgs = {
  _set?: qx_eGatewaySyncStatus_set_input;
  pk_columns: qx_eGatewaySyncStatus_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateGatewaySyncStatusEnumsArgs = {
  _set?: qx_eGatewaySyncStatus_set_input;
  where: qx_eGatewaySyncStatus_bool_exp;
};


/** mutation root */
export type mutation_rootupdateGatewaysArgs = {
  _append?: qx_Gateway_append_input;
  _delete_at_path?: qx_Gateway_delete_at_path_input;
  _delete_elem?: qx_Gateway_delete_elem_input;
  _delete_key?: qx_Gateway_delete_key_input;
  _inc?: qx_Gateway_inc_input;
  _prepend?: qx_Gateway_prepend_input;
  _set?: qx_Gateway_set_input;
  where: qx_Gateway_bool_exp;
};


/** mutation root */
export type mutation_rootupdateGroupArgs = {
  _set?: qx_Group_set_input;
  pk_columns: qx_Group_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateGroupsArgs = {
  _set?: qx_Group_set_input;
  where: qx_Group_bool_exp;
};


/** mutation root */
export type mutation_rootupdateHolidaySetArgs = {
  _append?: qx_HolidaySet_append_input;
  _delete_at_path?: qx_HolidaySet_delete_at_path_input;
  _delete_elem?: qx_HolidaySet_delete_elem_input;
  _delete_key?: qx_HolidaySet_delete_key_input;
  _prepend?: qx_HolidaySet_prepend_input;
  _set?: qx_HolidaySet_set_input;
  pk_columns: qx_HolidaySet_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateHolidaySetToScheduleBlockArgs = {
  _set?: qx__HolidaySetToScheduleBlock_set_input;
  pk_columns: qx__HolidaySetToScheduleBlock_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateHolidaySetToScheduleBlocksArgs = {
  _set?: qx__HolidaySetToScheduleBlock_set_input;
  where: qx__HolidaySetToScheduleBlock_bool_exp;
};


/** mutation root */
export type mutation_rootupdateHolidaySetsArgs = {
  _append?: qx_HolidaySet_append_input;
  _delete_at_path?: qx_HolidaySet_delete_at_path_input;
  _delete_elem?: qx_HolidaySet_delete_elem_input;
  _delete_key?: qx_HolidaySet_delete_key_input;
  _prepend?: qx_HolidaySet_prepend_input;
  _set?: qx_HolidaySet_set_input;
  where: qx_HolidaySet_bool_exp;
};


/** mutation root */
export type mutation_rootupdateInputPointArgs = {
  _inc?: qx_InputPoint_inc_input;
  _set?: qx_InputPoint_set_input;
  pk_columns: qx_InputPoint_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateInputPointsArgs = {
  _inc?: qx_InputPoint_inc_input;
  _set?: qx_InputPoint_set_input;
  where: qx_InputPoint_bool_exp;
};


/** mutation root */
export type mutation_rootupdateInputSuperviseArgs = {
  channel: number;
  deviceID: string;
  supervise: string;
};


/** mutation root */
export type mutation_rootupdateKeyModeEnumArgs = {
  _set?: qx_eKeypadMode_set_input;
  pk_columns: qx_eKeypadMode_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateKeyModeEnumsArgs = {
  _set?: qx_eKeypadMode_set_input;
  where: qx_eKeypadMode_bool_exp;
};


/** mutation root */
export type mutation_rootupdateLayoutArgs = {
  _append?: qx_Layout_append_input;
  _delete_at_path?: qx_Layout_delete_at_path_input;
  _delete_elem?: qx_Layout_delete_elem_input;
  _delete_key?: qx_Layout_delete_key_input;
  _prepend?: qx_Layout_prepend_input;
  _set?: qx_Layout_set_input;
  pk_columns: qx_Layout_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateLayoutsArgs = {
  _append?: qx_Layout_append_input;
  _delete_at_path?: qx_Layout_delete_at_path_input;
  _delete_elem?: qx_Layout_delete_elem_input;
  _delete_key?: qx_Layout_delete_key_input;
  _prepend?: qx_Layout_prepend_input;
  _set?: qx_Layout_set_input;
  where: qx_Layout_bool_exp;
};


/** mutation root */
export type mutation_rootupdateLdapConfigurationArgs = {
  ldapConfiguration?: LdapConfiguration;
  placeID: string;
  sync?: boolean;
};


/** mutation root */
export type mutation_rootupdateLensProfileArgs = {
  _append?: qx_LensProfile_append_input;
  _delete_at_path?: qx_LensProfile_delete_at_path_input;
  _delete_elem?: qx_LensProfile_delete_elem_input;
  _delete_key?: qx_LensProfile_delete_key_input;
  _inc?: qx_LensProfile_inc_input;
  _prepend?: qx_LensProfile_prepend_input;
  _set?: qx_LensProfile_set_input;
  pk_columns: qx_LensProfile_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateLensProfilesArgs = {
  _append?: qx_LensProfile_append_input;
  _delete_at_path?: qx_LensProfile_delete_at_path_input;
  _delete_elem?: qx_LensProfile_delete_elem_input;
  _delete_key?: qx_LensProfile_delete_key_input;
  _inc?: qx_LensProfile_inc_input;
  _prepend?: qx_LensProfile_prepend_input;
  _set?: qx_LensProfile_set_input;
  where: qx_LensProfile_bool_exp;
};


/** mutation root */
export type mutation_rootupdateLockArgs = {
  _inc?: qx_Lock_inc_input;
  _set?: qx_Lock_set_input;
  pk_columns: qx_Lock_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateLockPowerMonitorEnumArgs = {
  _set?: qx_eLockPowerMonitor_set_input;
  pk_columns: qx_eLockPowerMonitor_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateLockPowerMonitorEnumsArgs = {
  _set?: qx_eLockPowerMonitor_set_input;
  where: qx_eLockPowerMonitor_bool_exp;
};


/** mutation root */
export type mutation_rootupdateLockRelayMonitorEnumArgs = {
  _set?: qx_eLockRelayMonitor_set_input;
  pk_columns: qx_eLockRelayMonitor_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateLockRelayMonitorEnumsArgs = {
  _set?: qx_eLockRelayMonitor_set_input;
  where: qx_eLockRelayMonitor_bool_exp;
};


/** mutation root */
export type mutation_rootupdateLockTypeEnumArgs = {
  _set?: qx_eLockType_set_input;
  pk_columns: qx_eLockType_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateLockTypeEnumsArgs = {
  _set?: qx_eLockType_set_input;
  where: qx_eLockType_bool_exp;
};


/** mutation root */
export type mutation_rootupdateLocksArgs = {
  _inc?: qx_Lock_inc_input;
  _set?: qx_Lock_set_input;
  where: qx_Lock_bool_exp;
};


/** mutation root */
export type mutation_rootupdateMediaProfileArgs = {
  _append?: qx_MediaProfile_append_input;
  _delete_at_path?: qx_MediaProfile_delete_at_path_input;
  _delete_elem?: qx_MediaProfile_delete_elem_input;
  _delete_key?: qx_MediaProfile_delete_key_input;
  _inc?: qx_MediaProfile_inc_input;
  _prepend?: qx_MediaProfile_prepend_input;
  _set?: qx_MediaProfile_set_input;
  pk_columns: qx_MediaProfile_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateMediaProfilesArgs = {
  _append?: qx_MediaProfile_append_input;
  _delete_at_path?: qx_MediaProfile_delete_at_path_input;
  _delete_elem?: qx_MediaProfile_delete_elem_input;
  _delete_key?: qx_MediaProfile_delete_key_input;
  _inc?: qx_MediaProfile_inc_input;
  _prepend?: qx_MediaProfile_prepend_input;
  _set?: qx_MediaProfile_set_input;
  where: qx_MediaProfile_bool_exp;
};


/** mutation root */
export type mutation_rootupdateMercuryControlPointArgs = {
  _set?: qx_MercuryControlPoint_set_input;
  pk_columns: qx_MercuryControlPoint_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateMercuryControlPointsArgs = {
  _set?: qx_MercuryControlPoint_set_input;
  where: qx_MercuryControlPoint_bool_exp;
};


/** mutation root */
export type mutation_rootupdateMercuryMonitorPointArgs = {
  _inc?: qx_MercuryMonitorPoint_inc_input;
  _set?: qx_MercuryMonitorPoint_set_input;
  pk_columns: qx_MercuryMonitorPoint_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateMercuryMonitorPointsArgs = {
  _inc?: qx_MercuryMonitorPoint_inc_input;
  _set?: qx_MercuryMonitorPoint_set_input;
  where: qx_MercuryMonitorPoint_bool_exp;
};


/** mutation root */
export type mutation_rootupdateMinionArgs = {
  input: MinionDeviceInput;
};


/** mutation root */
export type mutation_rootupdateMonitorLockStateEnumArgs = {
  _set?: qx_eMonitorLockState_set_input;
  pk_columns: qx_eMonitorLockState_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateMonitorLockStateEnumsArgs = {
  _set?: qx_eMonitorLockState_set_input;
  where: qx_eMonitorLockState_bool_exp;
};


/** mutation root */
export type mutation_rootupdateMountPositionEnumArgs = {
  _set?: qx_eMountPosition_set_input;
  pk_columns: qx_eMountPosition_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateMountPositionEnumsArgs = {
  _set?: qx_eMountPosition_set_input;
  where: qx_eMountPosition_bool_exp;
};


/** mutation root */
export type mutation_rootupdateObjectActionEnumArgs = {
  _set?: qx_eObjectAction_set_input;
  pk_columns: qx_eObjectAction_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateObjectActionEnumsArgs = {
  _set?: qx_eObjectAction_set_input;
  where: qx_eObjectAction_bool_exp;
};


/** mutation root */
export type mutation_rootupdateOssIdAssignmentArgs = {
  _inc?: qx_OssIdAssignment_inc_input;
  _set?: qx_OssIdAssignment_set_input;
  pk_columns: qx_OssIdAssignment_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateOssIdAssignmentsArgs = {
  _inc?: qx_OssIdAssignment_inc_input;
  _set?: qx_OssIdAssignment_set_input;
  where: qx_OssIdAssignment_bool_exp;
};


/** mutation root */
export type mutation_rootupdateOutputPointArgs = {
  _inc?: qx_OutputPoint_inc_input;
  _set?: qx_OutputPoint_set_input;
  pk_columns: qx_OutputPoint_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateOutputPointsArgs = {
  _inc?: qx_OutputPoint_inc_input;
  _set?: qx_OutputPoint_set_input;
  where: qx_OutputPoint_bool_exp;
};


/** mutation root */
export type mutation_rootupdatePACSStatusEnumArgs = {
  _set?: qx_ePACSStatus_set_input;
  pk_columns: qx_ePACSStatus_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdatePACSStatusEnumsArgs = {
  _set?: qx_ePACSStatus_set_input;
  where: qx_ePACSStatus_bool_exp;
};


/** mutation root */
export type mutation_rootupdatePeopleArgs = {
  _append?: qx_Person_append_input;
  _delete_at_path?: qx_Person_delete_at_path_input;
  _delete_elem?: qx_Person_delete_elem_input;
  _delete_key?: qx_Person_delete_key_input;
  _prepend?: qx_Person_prepend_input;
  _set?: qx_Person_set_input;
  where: qx_Person_bool_exp;
};


/** mutation root */
export type mutation_rootupdatePermissionArgs = {
  _set?: qx_Permission_set_input;
  pk_columns: qx_Permission_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdatePermissionWithPartitionsArgs = {
  id: string;
  partitionIds: Array<string>;
  permission: PermissionWithPartitionsInput;
};


/** mutation root */
export type mutation_rootupdatePermissionsArgs = {
  _set?: qx_Permission_set_input;
  where: qx_Permission_bool_exp;
};


/** mutation root */
export type mutation_rootupdatePersonArgs = {
  _append?: qx_Person_append_input;
  _delete_at_path?: qx_Person_delete_at_path_input;
  _delete_elem?: qx_Person_delete_elem_input;
  _delete_key?: qx_Person_delete_key_input;
  _prepend?: qx_Person_prepend_input;
  _set?: qx_Person_set_input;
  pk_columns: qx_Person_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdatePersonGroupArgs = {
  _set?: qx__PersonToGroup_set_input;
  pk_columns: qx__PersonToGroup_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdatePersonGroupsArgs = {
  _set?: qx__PersonToGroup_set_input;
  where: qx__PersonToGroup_bool_exp;
};


/** mutation root */
export type mutation_rootupdatePersonStatusEnumArgs = {
  _set?: qx_ePersonStatus_set_input;
  pk_columns: qx_ePersonStatus_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdatePersonStatusEnumsArgs = {
  _set?: qx_ePersonStatus_set_input;
  where: qx_ePersonStatus_bool_exp;
};


/** mutation root */
export type mutation_rootupdatePlaceArgs = {
  _append?: qx_Place_append_input;
  _delete_at_path?: qx_Place_delete_at_path_input;
  _delete_elem?: qx_Place_delete_elem_input;
  _delete_key?: qx_Place_delete_key_input;
  _inc?: qx_Place_inc_input;
  _prepend?: qx_Place_prepend_input;
  _set?: qx_Place_set_input;
  pk_columns: qx_Place_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdatePlaceTypeEnumArgs = {
  _set?: qx_ePlaceType_set_input;
  pk_columns: qx_ePlaceType_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdatePlaceTypeEnumsArgs = {
  _set?: qx_ePlaceType_set_input;
  where: qx_ePlaceType_bool_exp;
};


/** mutation root */
export type mutation_rootupdatePlacesArgs = {
  _append?: qx_Place_append_input;
  _delete_at_path?: qx_Place_delete_at_path_input;
  _delete_elem?: qx_Place_delete_elem_input;
  _delete_key?: qx_Place_delete_key_input;
  _inc?: qx_Place_inc_input;
  _prepend?: qx_Place_prepend_input;
  _set?: qx_Place_set_input;
  where: qx_Place_bool_exp;
};


/** mutation root */
export type mutation_rootupdatePrivilegeEnumArgs = {
  _set?: qx_ePrivilege_set_input;
  pk_columns: qx_ePrivilege_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdatePrivilegeEnumToRoleArgs = {
  _set?: qx__PrivilegeEnumToRole_set_input;
  pk_columns: qx__PrivilegeEnumToRole_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdatePrivilegeEnumToRolesArgs = {
  _set?: qx__PrivilegeEnumToRole_set_input;
  where: qx__PrivilegeEnumToRole_bool_exp;
};


/** mutation root */
export type mutation_rootupdatePrivilegeEnumsArgs = {
  _set?: qx_ePrivilege_set_input;
  where: qx_ePrivilege_bool_exp;
};


/** mutation root */
export type mutation_rootupdateReaderArgs = {
  _append?: qx_Reader_append_input;
  _delete_at_path?: qx_Reader_delete_at_path_input;
  _delete_elem?: qx_Reader_delete_elem_input;
  _delete_key?: qx_Reader_delete_key_input;
  _inc?: qx_Reader_inc_input;
  _prepend?: qx_Reader_prepend_input;
  _set?: qx_Reader_set_input;
  pk_columns: qx_Reader_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateReaderAccessTypeEnumArgs = {
  _set?: qx_eReaderAccessType_set_input;
  pk_columns: qx_eReaderAccessType_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateReaderAccessTypeEnumsArgs = {
  _set?: qx_eReaderAccessType_set_input;
  where: qx_eReaderAccessType_bool_exp;
};


/** mutation root */
export type mutation_rootupdateReaderProtocolEnumArgs = {
  _set?: qx_eReaderProtocol_set_input;
  pk_columns: qx_eReaderProtocol_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateReaderProtocolEnumsArgs = {
  _set?: qx_eReaderProtocol_set_input;
  where: qx_eReaderProtocol_bool_exp;
};


/** mutation root */
export type mutation_rootupdateReadersArgs = {
  _append?: qx_Reader_append_input;
  _delete_at_path?: qx_Reader_delete_at_path_input;
  _delete_elem?: qx_Reader_delete_elem_input;
  _delete_key?: qx_Reader_delete_key_input;
  _inc?: qx_Reader_inc_input;
  _prepend?: qx_Reader_prepend_input;
  _set?: qx_Reader_set_input;
  where: qx_Reader_bool_exp;
};


/** mutation root */
export type mutation_rootupdateRexStateEnumArgs = {
  _set?: qx_eRexState_set_input;
  pk_columns: qx_eRexState_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateRexStateEnumsArgs = {
  _set?: qx_eRexState_set_input;
  where: qx_eRexState_bool_exp;
};


/** mutation root */
export type mutation_rootupdateRoleArgs = {
  _set?: qx_Role_set_input;
  pk_columns: qx_Role_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateRolesArgs = {
  _set?: qx_Role_set_input;
  where: qx_Role_bool_exp;
};


/** mutation root */
export type mutation_rootupdateRosslareConnectionArgs = {
  _set?: qx_RosslareConnection_set_input;
  pk_columns: qx_RosslareConnection_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateRosslareConnectionsArgs = {
  _set?: qx_RosslareConnection_set_input;
  where: qx_RosslareConnection_bool_exp;
};


/** mutation root */
export type mutation_rootupdateSavedClipArgs = {
  clipID: string;
  description?: string;
  expiresAt?: string;
  name?: string;
};


/** mutation root */
export type mutation_rootupdateScheduleArgs = {
  _inc?: qx_Schedule_inc_input;
  _set?: qx_Schedule_set_input;
  pk_columns: qx_Schedule_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateScheduleBlockArgs = {
  _set?: qx_ScheduleBlock_set_input;
  pk_columns: qx_ScheduleBlock_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateScheduleBlocksArgs = {
  _set?: qx_ScheduleBlock_set_input;
  where: qx_ScheduleBlock_bool_exp;
};


/** mutation root */
export type mutation_rootupdateSchedulesArgs = {
  _inc?: qx_Schedule_inc_input;
  _set?: qx_Schedule_set_input;
  where: qx_Schedule_bool_exp;
};


/** mutation root */
export type mutation_rootupdateSegmentArgs = {
  _inc?: qx_Segment_inc_input;
  _set?: qx_Segment_set_input;
  pk_columns: qx_Segment_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateSegmentsArgs = {
  _inc?: qx_Segment_inc_input;
  _set?: qx_Segment_set_input;
  where: qx_Segment_bool_exp;
};


/** mutation root */
export type mutation_rootupdateSensorArgs = {
  _inc?: qx_Sensor_inc_input;
  _set?: qx_Sensor_set_input;
  pk_columns: qx_Sensor_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateSensorActionEnumArgs = {
  _set?: qx_eSensorAction_set_input;
  pk_columns: qx_eSensorAction_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateSensorActionEnumsArgs = {
  _set?: qx_eSensorAction_set_input;
  where: qx_eSensorAction_bool_exp;
};


/** mutation root */
export type mutation_rootupdateSensorTypeEnumArgs = {
  _set?: qx_eSensorType_set_input;
  pk_columns: qx_eSensorType_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateSensorTypeEnumsArgs = {
  _set?: qx_eSensorType_set_input;
  where: qx_eSensorType_bool_exp;
};


/** mutation root */
export type mutation_rootupdateSensorsArgs = {
  _inc?: qx_Sensor_inc_input;
  _set?: qx_Sensor_set_input;
  where: qx_Sensor_bool_exp;
};


/** mutation root */
export type mutation_rootupdateSharedLinkArgs = {
  _inc?: qx_SharedLinks_inc_input;
  _set?: qx_SharedLinks_set_input;
  pk_columns: qx_SharedLinks_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateSharedLinkDetailsArgs = {
  emails?: Array<string>;
  expiresAt?: string;
  persons?: Array<string>;
  sharedLinkID: string;
  singleUse: boolean;
};


/** mutation root */
export type mutation_rootupdateSharedLinksArgs = {
  _inc?: qx_SharedLinks_inc_input;
  _set?: qx_SharedLinks_set_input;
  where: qx_SharedLinks_bool_exp;
};


/** mutation root */
export type mutation_rootupdateSnapshotArgs = {
  _inc?: qx_Snapshot_inc_input;
  _set?: qx_Snapshot_set_input;
  pk_columns: qx_Snapshot_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateSnapshotsArgs = {
  _inc?: qx_Snapshot_inc_input;
  _set?: qx_Snapshot_set_input;
  where: qx_Snapshot_bool_exp;
};


/** mutation root */
export type mutation_rootupdateStreamStatusEnumArgs = {
  _set?: qx_eStreamStatus_set_input;
  pk_columns: qx_eStreamStatus_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateStreamStatusEnumsArgs = {
  _set?: qx_eStreamStatus_set_input;
  where: qx_eStreamStatus_bool_exp;
};


/** mutation root */
export type mutation_rootupdateSuperviseInputsEnumArgs = {
  _set?: qx_eSuperviseInputs_set_input;
  pk_columns: qx_eSuperviseInputs_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateSuperviseInputsEnumsArgs = {
  _set?: qx_eSuperviseInputs_set_input;
  where: qx_eSuperviseInputs_bool_exp;
};


/** mutation root */
export type mutation_rootupdateTermsAgreementArgs = {
  _set?: qx_TermsAgreement_set_input;
  pk_columns: qx_TermsAgreement_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateTermsAgreementsArgs = {
  _set?: qx_TermsAgreement_set_input;
  where: qx_TermsAgreement_bool_exp;
};


/** mutation root */
export type mutation_rootupdateTimeZoneArgs = {
  _set?: qx_TimeZone_set_input;
  pk_columns: qx_TimeZone_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateTimeZonesArgs = {
  _set?: qx_TimeZone_set_input;
  where: qx_TimeZone_bool_exp;
};


/** mutation root */
export type mutation_rootupdateUserSettingArgs = {
  _append?: qx_UserSetting_append_input;
  _delete_at_path?: qx_UserSetting_delete_at_path_input;
  _delete_elem?: qx_UserSetting_delete_elem_input;
  _delete_key?: qx_UserSetting_delete_key_input;
  _prepend?: qx_UserSetting_prepend_input;
  _set?: qx_UserSetting_set_input;
  pk_columns: qx_UserSetting_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateUserSettingsArgs = {
  _append?: qx_UserSetting_append_input;
  _delete_at_path?: qx_UserSetting_delete_at_path_input;
  _delete_elem?: qx_UserSetting_delete_elem_input;
  _delete_key?: qx_UserSetting_delete_key_input;
  _prepend?: qx_UserSetting_prepend_input;
  _set?: qx_UserSetting_set_input;
  where: qx_UserSetting_bool_exp;
};


/** mutation root */
export type mutation_rootupdateVideoSourceArgs = {
  _append?: qx_VideoSource_append_input;
  _delete_at_path?: qx_VideoSource_delete_at_path_input;
  _delete_elem?: qx_VideoSource_delete_elem_input;
  _delete_key?: qx_VideoSource_delete_key_input;
  _inc?: qx_VideoSource_inc_input;
  _prepend?: qx_VideoSource_prepend_input;
  _set?: qx_VideoSource_set_input;
  pk_columns: qx_VideoSource_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateVideoSourcesArgs = {
  _append?: qx_VideoSource_append_input;
  _delete_at_path?: qx_VideoSource_delete_at_path_input;
  _delete_elem?: qx_VideoSource_delete_elem_input;
  _delete_key?: qx_VideoSource_delete_key_input;
  _inc?: qx_VideoSource_inc_input;
  _prepend?: qx_VideoSource_prepend_input;
  _set?: qx_VideoSource_set_input;
  where: qx_VideoSource_bool_exp;
};


/** mutation root */
export type mutation_rootupdateViewArgs = {
  _append?: qx_View_append_input;
  _delete_at_path?: qx_View_delete_at_path_input;
  _delete_elem?: qx_View_delete_elem_input;
  _delete_key?: qx_View_delete_key_input;
  _prepend?: qx_View_prepend_input;
  _set?: qx_View_set_input;
  pk_columns: qx_View_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateViewsArgs = {
  _append?: qx_View_append_input;
  _delete_at_path?: qx_View_delete_at_path_input;
  _delete_elem?: qx_View_delete_elem_input;
  _delete_key?: qx_View_delete_key_input;
  _prepend?: qx_View_prepend_input;
  _set?: qx_View_set_input;
  where: qx_View_bool_exp;
};


/** mutation root */
export type mutation_rootupdateWiegandCardFormatArgs = {
  _append?: qx_WiegandCardFormat_append_input;
  _delete_at_path?: qx_WiegandCardFormat_delete_at_path_input;
  _delete_elem?: qx_WiegandCardFormat_delete_elem_input;
  _delete_key?: qx_WiegandCardFormat_delete_key_input;
  _prepend?: qx_WiegandCardFormat_prepend_input;
  _set?: qx_WiegandCardFormat_set_input;
  pk_columns: qx_WiegandCardFormat_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdateWiegandCardFormatsArgs = {
  _append?: qx_WiegandCardFormat_append_input;
  _delete_at_path?: qx_WiegandCardFormat_delete_at_path_input;
  _delete_elem?: qx_WiegandCardFormat_delete_elem_input;
  _delete_key?: qx_WiegandCardFormat_delete_key_input;
  _prepend?: qx_WiegandCardFormat_prepend_input;
  _set?: qx_WiegandCardFormat_set_input;
  where: qx_WiegandCardFormat_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_AnalyticSourcesArgs = {
  _inc?: AnalyticSources_inc_input;
  _set?: AnalyticSources_set_input;
  where: AnalyticSources_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_AnalyticSources_by_pkArgs = {
  _inc?: AnalyticSources_inc_input;
  _set?: AnalyticSources_set_input;
  pk_columns: AnalyticSources_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_AnalyticSources_manyArgs = {
  updates: Array<AnalyticSources_updates>;
};


/** mutation root */
export type mutation_rootupdate_ApplicationUserGatewayPasswordArgs = {
  _set?: ApplicationUserGatewayPassword_set_input;
  where: ApplicationUserGatewayPassword_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_ApplicationUserGatewayPassword_by_pkArgs = {
  _set?: ApplicationUserGatewayPassword_set_input;
  pk_columns: ApplicationUserGatewayPassword_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_ApplicationUserGatewayPassword_manyArgs = {
  updates: Array<ApplicationUserGatewayPassword_updates>;
};


/** mutation root */
export type mutation_rootupdate_ApplicationUserTwoFactorArgs = {
  _set?: ApplicationUserTwoFactor_set_input;
  where: ApplicationUserTwoFactor_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_ApplicationUserTwoFactor_by_pkArgs = {
  _set?: ApplicationUserTwoFactor_set_input;
  pk_columns: ApplicationUserTwoFactor_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_ApplicationUserTwoFactor_manyArgs = {
  updates: Array<ApplicationUserTwoFactor_updates>;
};


/** mutation root */
export type mutation_rootupdate_DSCConnectionArgs = {
  _set?: DSCConnection_set_input;
  where: DSCConnection_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_DSCConnection_by_pkArgs = {
  _set?: DSCConnection_set_input;
  pk_columns: DSCConnection_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_DSCConnection_manyArgs = {
  updates: Array<DSCConnection_updates>;
};


/** mutation root */
export type mutation_rootupdate_IntrusionAccessCodeArgs = {
  _inc?: IntrusionAccessCode_inc_input;
  _set?: IntrusionAccessCode_set_input;
  where: IntrusionAccessCode_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_IntrusionAccessCode_by_pkArgs = {
  _inc?: IntrusionAccessCode_inc_input;
  _set?: IntrusionAccessCode_set_input;
  pk_columns: IntrusionAccessCode_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_IntrusionAccessCode_manyArgs = {
  updates: Array<IntrusionAccessCode_updates>;
};


/** mutation root */
export type mutation_rootupdate_IntrusionPartitionArgs = {
  _inc?: IntrusionPartition_inc_input;
  _set?: IntrusionPartition_set_input;
  where: IntrusionPartition_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_IntrusionPartition_by_pkArgs = {
  _inc?: IntrusionPartition_inc_input;
  _set?: IntrusionPartition_set_input;
  pk_columns: IntrusionPartition_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_IntrusionPartition_manyArgs = {
  updates: Array<IntrusionPartition_updates>;
};


/** mutation root */
export type mutation_rootupdate_IntrusionZoneArgs = {
  _inc?: IntrusionZone_inc_input;
  _set?: IntrusionZone_set_input;
  where: IntrusionZone_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_IntrusionZone_by_pkArgs = {
  _inc?: IntrusionZone_inc_input;
  _set?: IntrusionZone_set_input;
  pk_columns: IntrusionZone_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_IntrusionZone_manyArgs = {
  updates: Array<IntrusionZone_updates>;
};


/** mutation root */
export type mutation_rootupdate_PartitionZoneAssignmentsArgs = {
  _set?: PartitionZoneAssignments_set_input;
  where: PartitionZoneAssignments_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_PartitionZoneAssignments_by_pkArgs = {
  _set?: PartitionZoneAssignments_set_input;
  pk_columns: PartitionZoneAssignments_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_PartitionZoneAssignments_manyArgs = {
  updates: Array<PartitionZoneAssignments_updates>;
};


/** mutation root */
export type mutation_rootupdate_PassKeyProviderArgs = {
  _set?: PassKeyProvider_set_input;
  where: PassKeyProvider_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_PassKeyProvider_by_pkArgs = {
  _set?: PassKeyProvider_set_input;
  pk_columns: PassKeyProvider_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_PassKeyProvider_manyArgs = {
  updates: Array<PassKeyProvider_updates>;
};


/** mutation root */
export type mutation_rootupdate_PermissionPartitionAssignmentsArgs = {
  _set?: PermissionPartitionAssignments_set_input;
  where: PermissionPartitionAssignments_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_PermissionPartitionAssignments_by_pkArgs = {
  _set?: PermissionPartitionAssignments_set_input;
  pk_columns: PermissionPartitionAssignments_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_PermissionPartitionAssignments_manyArgs = {
  updates: Array<PermissionPartitionAssignments_updates>;
};


/** mutation root */
export type mutation_rootupdate_PersonTermsAgreementArgs = {
  _set?: PersonTermsAgreement_set_input;
  where: PersonTermsAgreement_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_PersonTermsAgreement_by_pkArgs = {
  _set?: PersonTermsAgreement_set_input;
  pk_columns: PersonTermsAgreement_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_PersonTermsAgreement_manyArgs = {
  updates: Array<PersonTermsAgreement_updates>;
};


/** mutation root */
export type mutation_rootupdate_analyticAttributePropertiesArgs = {
  _inc?: analyticAttributeProperties_inc_input;
  _set?: analyticAttributeProperties_set_input;
  where: analyticAttributeProperties_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_analyticAttributeProperties_by_pkArgs = {
  _inc?: analyticAttributeProperties_inc_input;
  _set?: analyticAttributeProperties_set_input;
  pk_columns: analyticAttributeProperties_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_analyticAttributeProperties_manyArgs = {
  updates: Array<analyticAttributeProperties_updates>;
};


/** mutation root */
export type mutation_rootupdate_analyticAttributesArgs = {
  _inc?: analyticAttributes_inc_input;
  _set?: analyticAttributes_set_input;
  where: analyticAttributes_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_analyticAttributes_by_pkArgs = {
  _inc?: analyticAttributes_inc_input;
  _set?: analyticAttributes_set_input;
  pk_columns: analyticAttributes_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_analyticAttributes_manyArgs = {
  updates: Array<analyticAttributes_updates>;
};


/** mutation root */
export type mutation_rootupdate_analyticDetectedPropertiesArgs = {
  _inc?: analyticDetectedProperties_inc_input;
  _set?: analyticDetectedProperties_set_input;
  where: analyticDetectedProperties_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_analyticDetectedProperties_by_pkArgs = {
  _inc?: analyticDetectedProperties_inc_input;
  _set?: analyticDetectedProperties_set_input;
  pk_columns: analyticDetectedProperties_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_analyticDetectedProperties_manyArgs = {
  updates: Array<analyticDetectedProperties_updates>;
};


/** mutation root */
export type mutation_rootupdate_analyticTypesArgs = {
  _inc?: analyticTypes_inc_input;
  _set?: analyticTypes_set_input;
  where: analyticTypes_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_analyticTypes_by_pkArgs = {
  _inc?: analyticTypes_inc_input;
  _set?: analyticTypes_set_input;
  pk_columns: analyticTypes_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_analyticTypes_manyArgs = {
  updates: Array<analyticTypes_updates>;
};


/** mutation root */
export type mutation_rootupdate_analyticsArgs = {
  _inc?: analytics_inc_input;
  _set?: analytics_set_input;
  where: analytics_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_analytics_by_pkArgs = {
  _inc?: analytics_inc_input;
  _set?: analytics_set_input;
  pk_columns: analytics_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_analytics_manyArgs = {
  updates: Array<analytics_updates>;
};


/** mutation root */
export type mutation_rootupdate_applicationUserAppPasswordsArgs = {
  _inc?: applicationUserAppPasswords_inc_input;
  _set?: applicationUserAppPasswords_set_input;
  where: applicationUserAppPasswords_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_applicationUserAppPasswords_by_pkArgs = {
  _inc?: applicationUserAppPasswords_inc_input;
  _set?: applicationUserAppPasswords_set_input;
  pk_columns: applicationUserAppPasswords_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_applicationUserAppPasswords_manyArgs = {
  updates: Array<applicationUserAppPasswords_updates>;
};


/** mutation root */
export type mutation_rootupdate_applicationUserDevicesArgs = {
  _append?: applicationUserDevices_append_input;
  _delete_at_path?: applicationUserDevices_delete_at_path_input;
  _delete_elem?: applicationUserDevices_delete_elem_input;
  _delete_key?: applicationUserDevices_delete_key_input;
  _inc?: applicationUserDevices_inc_input;
  _prepend?: applicationUserDevices_prepend_input;
  _set?: applicationUserDevices_set_input;
  where: applicationUserDevices_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_applicationUserDevices_by_pkArgs = {
  _append?: applicationUserDevices_append_input;
  _delete_at_path?: applicationUserDevices_delete_at_path_input;
  _delete_elem?: applicationUserDevices_delete_elem_input;
  _delete_key?: applicationUserDevices_delete_key_input;
  _inc?: applicationUserDevices_inc_input;
  _prepend?: applicationUserDevices_prepend_input;
  _set?: applicationUserDevices_set_input;
  pk_columns: applicationUserDevices_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_applicationUserDevices_manyArgs = {
  updates: Array<applicationUserDevices_updates>;
};


/** mutation root */
export type mutation_rootupdate_attributePropertiesArgs = {
  _set?: attributeProperties_set_input;
  where: attributeProperties_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_attributeProperties_by_pkArgs = {
  _set?: attributeProperties_set_input;
  pk_columns: attributeProperties_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_attributeProperties_manyArgs = {
  updates: Array<attributeProperties_updates>;
};


/** mutation root */
export type mutation_rootupdate_attributesArgs = {
  _set?: attributes_set_input;
  where: attributes_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_attributes_by_pkArgs = {
  _set?: attributes_set_input;
  pk_columns: attributes_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_attributes_manyArgs = {
  updates: Array<attributes_updates>;
};


/** mutation root */
export type mutation_rootupdate_audioSourceAuditArgs = {
  _append?: audioSourceAudit_append_input;
  _delete_at_path?: audioSourceAudit_delete_at_path_input;
  _delete_elem?: audioSourceAudit_delete_elem_input;
  _delete_key?: audioSourceAudit_delete_key_input;
  _inc?: audioSourceAudit_inc_input;
  _prepend?: audioSourceAudit_prepend_input;
  _set?: audioSourceAudit_set_input;
  where: audioSourceAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_audioSourceAudit_manyArgs = {
  updates: Array<audioSourceAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_audit_logged_actionsArgs = {
  _append?: audit_logged_actions_append_input;
  _delete_at_path?: audit_logged_actions_delete_at_path_input;
  _delete_elem?: audit_logged_actions_delete_elem_input;
  _delete_key?: audit_logged_actions_delete_key_input;
  _inc?: audit_logged_actions_inc_input;
  _prepend?: audit_logged_actions_prepend_input;
  _set?: audit_logged_actions_set_input;
  where: audit_logged_actions_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_audit_logged_actions_by_pkArgs = {
  _append?: audit_logged_actions_append_input;
  _delete_at_path?: audit_logged_actions_delete_at_path_input;
  _delete_elem?: audit_logged_actions_delete_elem_input;
  _delete_key?: audit_logged_actions_delete_key_input;
  _inc?: audit_logged_actions_inc_input;
  _prepend?: audit_logged_actions_prepend_input;
  _set?: audit_logged_actions_set_input;
  pk_columns: audit_logged_actions_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_audit_logged_actions_manyArgs = {
  updates: Array<audit_logged_actions_updates>;
};


/** mutation root */
export type mutation_rootupdate_audit_vSensorAuditArgs = {
  _append?: audit_vSensorAudit_append_input;
  _delete_at_path?: audit_vSensorAudit_delete_at_path_input;
  _delete_elem?: audit_vSensorAudit_delete_elem_input;
  _delete_key?: audit_vSensorAudit_delete_key_input;
  _inc?: audit_vSensorAudit_inc_input;
  _prepend?: audit_vSensorAudit_prepend_input;
  _set?: audit_vSensorAudit_set_input;
  where: audit_vSensorAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_audit_vSensorAudit_manyArgs = {
  updates: Array<audit_vSensorAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_cloudStorageTimelapseOptionsArgs = {
  _inc?: cloudStorageTimelapseOptions_inc_input;
  _set?: cloudStorageTimelapseOptions_set_input;
  where: cloudStorageTimelapseOptions_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_cloudStorageTimelapseOptions_by_pkArgs = {
  _inc?: cloudStorageTimelapseOptions_inc_input;
  _set?: cloudStorageTimelapseOptions_set_input;
  pk_columns: cloudStorageTimelapseOptions_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_cloudStorageTimelapseOptions_manyArgs = {
  updates: Array<cloudStorageTimelapseOptions_updates>;
};


/** mutation root */
export type mutation_rootupdate_credentialAuditArgs = {
  _append?: credentialAudit_append_input;
  _delete_at_path?: credentialAudit_delete_at_path_input;
  _delete_elem?: credentialAudit_delete_elem_input;
  _delete_key?: credentialAudit_delete_key_input;
  _inc?: credentialAudit_inc_input;
  _prepend?: credentialAudit_prepend_input;
  _set?: credentialAudit_set_input;
  where: credentialAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_credentialAudit_manyArgs = {
  updates: Array<credentialAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_customerPermissionAuditArgs = {
  _append?: customerPermissionAudit_append_input;
  _delete_at_path?: customerPermissionAudit_delete_at_path_input;
  _delete_elem?: customerPermissionAudit_delete_elem_input;
  _delete_key?: customerPermissionAudit_delete_key_input;
  _inc?: customerPermissionAudit_inc_input;
  _prepend?: customerPermissionAudit_prepend_input;
  _set?: customerPermissionAudit_set_input;
  where: customerPermissionAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_customerPermissionAudit_manyArgs = {
  updates: Array<customerPermissionAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_deviceAnalyticSourceArgs = {
  _inc?: deviceAnalyticSource_inc_input;
  _set?: deviceAnalyticSource_set_input;
  where: deviceAnalyticSource_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_deviceAnalyticSource_by_pkArgs = {
  _inc?: deviceAnalyticSource_inc_input;
  _set?: deviceAnalyticSource_set_input;
  pk_columns: deviceAnalyticSource_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_deviceAnalyticSource_manyArgs = {
  updates: Array<deviceAnalyticSource_updates>;
};


/** mutation root */
export type mutation_rootupdate_deviceAuditArgs = {
  _append?: deviceAudit_append_input;
  _delete_at_path?: deviceAudit_delete_at_path_input;
  _delete_elem?: deviceAudit_delete_elem_input;
  _delete_key?: deviceAudit_delete_key_input;
  _inc?: deviceAudit_inc_input;
  _prepend?: deviceAudit_prepend_input;
  _set?: deviceAudit_set_input;
  where: deviceAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_deviceAudit_manyArgs = {
  updates: Array<deviceAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_deviceDIOAuditArgs = {
  _append?: deviceDIOAudit_append_input;
  _delete_at_path?: deviceDIOAudit_delete_at_path_input;
  _delete_elem?: deviceDIOAudit_delete_elem_input;
  _delete_key?: deviceDIOAudit_delete_key_input;
  _inc?: deviceDIOAudit_inc_input;
  _prepend?: deviceDIOAudit_prepend_input;
  _set?: deviceDIOAudit_set_input;
  where: deviceDIOAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_deviceDIOAudit_manyArgs = {
  updates: Array<deviceDIOAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_doorAuditArgs = {
  _append?: doorAudit_append_input;
  _delete_at_path?: doorAudit_delete_at_path_input;
  _delete_elem?: doorAudit_delete_elem_input;
  _delete_key?: doorAudit_delete_key_input;
  _inc?: doorAudit_inc_input;
  _prepend?: doorAudit_prepend_input;
  _set?: doorAudit_set_input;
  where: doorAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_doorAudit_manyArgs = {
  updates: Array<doorAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_eAnalyticIntegrationsArgs = {
  _set?: eAnalyticIntegrations_set_input;
  where: eAnalyticIntegrations_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_eAnalyticIntegrations_by_pkArgs = {
  _set?: eAnalyticIntegrations_set_input;
  pk_columns: eAnalyticIntegrations_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_eAnalyticIntegrations_manyArgs = {
  updates: Array<eAnalyticIntegrations_updates>;
};


/** mutation root */
export type mutation_rootupdate_eAnalyticStatesArgs = {
  _set?: eAnalyticStates_set_input;
  where: eAnalyticStates_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_eAnalyticStates_by_pkArgs = {
  _set?: eAnalyticStates_set_input;
  pk_columns: eAnalyticStates_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_eAnalyticStates_manyArgs = {
  updates: Array<eAnalyticStates_updates>;
};


/** mutation root */
export type mutation_rootupdate_eGatewayTypeArgs = {
  _set?: eGatewayType_set_input;
  where: eGatewayType_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_eGatewayType_by_pkArgs = {
  _set?: eGatewayType_set_input;
  pk_columns: eGatewayType_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_eGatewayType_manyArgs = {
  updates: Array<eGatewayType_updates>;
};


/** mutation root */
export type mutation_rootupdate_eS3BucketTypeArgs = {
  _set?: eS3BucketType_set_input;
  where: eS3BucketType_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_eS3BucketType_by_pkArgs = {
  _set?: eS3BucketType_set_input;
  pk_columns: eS3BucketType_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_eS3BucketType_manyArgs = {
  updates: Array<eS3BucketType_updates>;
};


/** mutation root */
export type mutation_rootupdate_flowAuditArgs = {
  _append?: flowAudit_append_input;
  _delete_at_path?: flowAudit_delete_at_path_input;
  _delete_elem?: flowAudit_delete_elem_input;
  _delete_key?: flowAudit_delete_key_input;
  _inc?: flowAudit_inc_input;
  _prepend?: flowAudit_prepend_input;
  _set?: flowAudit_set_input;
  where: flowAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_flowAudit_manyArgs = {
  updates: Array<flowAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_gatewayAuditArgs = {
  _append?: gatewayAudit_append_input;
  _delete_at_path?: gatewayAudit_delete_at_path_input;
  _delete_elem?: gatewayAudit_delete_elem_input;
  _delete_key?: gatewayAudit_delete_key_input;
  _inc?: gatewayAudit_inc_input;
  _prepend?: gatewayAudit_prepend_input;
  _set?: gatewayAudit_set_input;
  where: gatewayAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_gatewayAudit_manyArgs = {
  updates: Array<gatewayAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_gatewayBandwidthScheduleAuditArgs = {
  _append?: gatewayBandwidthScheduleAudit_append_input;
  _delete_at_path?: gatewayBandwidthScheduleAudit_delete_at_path_input;
  _delete_elem?: gatewayBandwidthScheduleAudit_delete_elem_input;
  _delete_key?: gatewayBandwidthScheduleAudit_delete_key_input;
  _inc?: gatewayBandwidthScheduleAudit_inc_input;
  _prepend?: gatewayBandwidthScheduleAudit_prepend_input;
  _set?: gatewayBandwidthScheduleAudit_set_input;
  where: gatewayBandwidthScheduleAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_gatewayBandwidthScheduleAudit_manyArgs = {
  updates: Array<gatewayBandwidthScheduleAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_groupAuditArgs = {
  _append?: groupAudit_append_input;
  _delete_at_path?: groupAudit_delete_at_path_input;
  _delete_elem?: groupAudit_delete_elem_input;
  _delete_key?: groupAudit_delete_key_input;
  _inc?: groupAudit_inc_input;
  _prepend?: groupAudit_prepend_input;
  _set?: groupAudit_set_input;
  where: groupAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_groupAudit_manyArgs = {
  updates: Array<groupAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_guestAccessArgs = {
  _set?: guestAccess_set_input;
  where: guestAccess_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_guestAccess_by_pkArgs = {
  _set?: guestAccess_set_input;
  pk_columns: guestAccess_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_guestAccess_manyArgs = {
  updates: Array<guestAccess_updates>;
};


/** mutation root */
export type mutation_rootupdate_holidaySetAuditArgs = {
  _append?: holidaySetAudit_append_input;
  _delete_at_path?: holidaySetAudit_delete_at_path_input;
  _delete_elem?: holidaySetAudit_delete_elem_input;
  _delete_key?: holidaySetAudit_delete_key_input;
  _inc?: holidaySetAudit_inc_input;
  _prepend?: holidaySetAudit_prepend_input;
  _set?: holidaySetAudit_set_input;
  where: holidaySetAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_holidaySetAudit_manyArgs = {
  updates: Array<holidaySetAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_holidaySetToScheduleBlockAuditArgs = {
  _append?: holidaySetToScheduleBlockAudit_append_input;
  _delete_at_path?: holidaySetToScheduleBlockAudit_delete_at_path_input;
  _delete_elem?: holidaySetToScheduleBlockAudit_delete_elem_input;
  _delete_key?: holidaySetToScheduleBlockAudit_delete_key_input;
  _inc?: holidaySetToScheduleBlockAudit_inc_input;
  _prepend?: holidaySetToScheduleBlockAudit_prepend_input;
  _set?: holidaySetToScheduleBlockAudit_set_input;
  where: holidaySetToScheduleBlockAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_holidaySetToScheduleBlockAudit_manyArgs = {
  updates: Array<holidaySetToScheduleBlockAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_inputPointAuditArgs = {
  _append?: inputPointAudit_append_input;
  _delete_at_path?: inputPointAudit_delete_at_path_input;
  _delete_elem?: inputPointAudit_delete_elem_input;
  _delete_key?: inputPointAudit_delete_key_input;
  _inc?: inputPointAudit_inc_input;
  _prepend?: inputPointAudit_prepend_input;
  _set?: inputPointAudit_set_input;
  where: inputPointAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_inputPointAudit_manyArgs = {
  updates: Array<inputPointAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_lockAuditArgs = {
  _append?: lockAudit_append_input;
  _delete_at_path?: lockAudit_delete_at_path_input;
  _delete_elem?: lockAudit_delete_elem_input;
  _delete_key?: lockAudit_delete_key_input;
  _inc?: lockAudit_inc_input;
  _prepend?: lockAudit_prepend_input;
  _set?: lockAudit_set_input;
  where: lockAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_lockAudit_manyArgs = {
  updates: Array<lockAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_mediaProfileAuditArgs = {
  _append?: mediaProfileAudit_append_input;
  _delete_at_path?: mediaProfileAudit_delete_at_path_input;
  _delete_elem?: mediaProfileAudit_delete_elem_input;
  _delete_key?: mediaProfileAudit_delete_key_input;
  _inc?: mediaProfileAudit_inc_input;
  _prepend?: mediaProfileAudit_prepend_input;
  _set?: mediaProfileAudit_set_input;
  where: mediaProfileAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_mediaProfileAudit_manyArgs = {
  updates: Array<mediaProfileAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_outputPointAuditArgs = {
  _append?: outputPointAudit_append_input;
  _delete_at_path?: outputPointAudit_delete_at_path_input;
  _delete_elem?: outputPointAudit_delete_elem_input;
  _delete_key?: outputPointAudit_delete_key_input;
  _inc?: outputPointAudit_inc_input;
  _prepend?: outputPointAudit_prepend_input;
  _set?: outputPointAudit_set_input;
  where: outputPointAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_outputPointAudit_manyArgs = {
  updates: Array<outputPointAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_permissionAuditArgs = {
  _append?: permissionAudit_append_input;
  _delete_at_path?: permissionAudit_delete_at_path_input;
  _delete_elem?: permissionAudit_delete_elem_input;
  _delete_key?: permissionAudit_delete_key_input;
  _inc?: permissionAudit_inc_input;
  _prepend?: permissionAudit_prepend_input;
  _set?: permissionAudit_set_input;
  where: permissionAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_permissionAudit_manyArgs = {
  updates: Array<permissionAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_personAuditArgs = {
  _append?: personAudit_append_input;
  _delete_at_path?: personAudit_delete_at_path_input;
  _delete_elem?: personAudit_delete_elem_input;
  _delete_key?: personAudit_delete_key_input;
  _inc?: personAudit_inc_input;
  _prepend?: personAudit_prepend_input;
  _set?: personAudit_set_input;
  where: personAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_personAudit_manyArgs = {
  updates: Array<personAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_personDeviceAppPrivilegesArgs = {
  _set?: personDeviceAppPrivileges_set_input;
  where: personDeviceAppPrivileges_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_personDeviceAppPrivileges_by_pkArgs = {
  _set?: personDeviceAppPrivileges_set_input;
  pk_columns: personDeviceAppPrivileges_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_personDeviceAppPrivileges_manyArgs = {
  updates: Array<personDeviceAppPrivileges_updates>;
};


/** mutation root */
export type mutation_rootupdate_personDoorAppPrivilegesArgs = {
  _inc?: personDoorAppPrivileges_inc_input;
  _set?: personDoorAppPrivileges_set_input;
  where: personDoorAppPrivileges_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_personDoorAppPrivileges_by_pkArgs = {
  _inc?: personDoorAppPrivileges_inc_input;
  _set?: personDoorAppPrivileges_set_input;
  pk_columns: personDoorAppPrivileges_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_personDoorAppPrivileges_manyArgs = {
  updates: Array<personDoorAppPrivileges_updates>;
};


/** mutation root */
export type mutation_rootupdate_personIntrusionPartitionAppPrivilegesArgs = {
  _set?: personIntrusionPartitionAppPrivileges_set_input;
  where: personIntrusionPartitionAppPrivileges_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_personIntrusionPartitionAppPrivileges_by_pkArgs = {
  _set?: personIntrusionPartitionAppPrivileges_set_input;
  pk_columns: personIntrusionPartitionAppPrivileges_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_personIntrusionPartitionAppPrivileges_manyArgs = {
  updates: Array<personIntrusionPartitionAppPrivileges_updates>;
};


/** mutation root */
export type mutation_rootupdate_personPlaceAppPrivilegesArgs = {
  _set?: personPlaceAppPrivileges_set_input;
  where: personPlaceAppPrivileges_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_personPlaceAppPrivileges_by_pkArgs = {
  _set?: personPlaceAppPrivileges_set_input;
  pk_columns: personPlaceAppPrivileges_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_personPlaceAppPrivileges_manyArgs = {
  updates: Array<personPlaceAppPrivileges_updates>;
};


/** mutation root */
export type mutation_rootupdate_personToGroupAuditArgs = {
  _append?: personToGroupAudit_append_input;
  _delete_at_path?: personToGroupAudit_delete_at_path_input;
  _delete_elem?: personToGroupAudit_delete_elem_input;
  _delete_key?: personToGroupAudit_delete_key_input;
  _inc?: personToGroupAudit_inc_input;
  _prepend?: personToGroupAudit_prepend_input;
  _set?: personToGroupAudit_set_input;
  where: personToGroupAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_personToGroupAudit_manyArgs = {
  updates: Array<personToGroupAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_personVideoSourceAppPrivilegesArgs = {
  _inc?: personVideoSourceAppPrivileges_inc_input;
  _set?: personVideoSourceAppPrivileges_set_input;
  where: personVideoSourceAppPrivileges_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_personVideoSourceAppPrivileges_by_pkArgs = {
  _inc?: personVideoSourceAppPrivileges_inc_input;
  _set?: personVideoSourceAppPrivileges_set_input;
  pk_columns: personVideoSourceAppPrivileges_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_personVideoSourceAppPrivileges_manyArgs = {
  updates: Array<personVideoSourceAppPrivileges_updates>;
};


/** mutation root */
export type mutation_rootupdate_placeAuditArgs = {
  _append?: placeAudit_append_input;
  _delete_at_path?: placeAudit_delete_at_path_input;
  _delete_elem?: placeAudit_delete_elem_input;
  _delete_key?: placeAudit_delete_key_input;
  _inc?: placeAudit_inc_input;
  _prepend?: placeAudit_prepend_input;
  _set?: placeAudit_set_input;
  where: placeAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_placeAudit_manyArgs = {
  updates: Array<placeAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_placeWhiteListsArgs = {
  _inc?: placeWhiteLists_inc_input;
  _set?: placeWhiteLists_set_input;
  where: placeWhiteLists_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_placeWhiteLists_by_pkArgs = {
  _inc?: placeWhiteLists_inc_input;
  _set?: placeWhiteLists_set_input;
  pk_columns: placeWhiteLists_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_placeWhiteLists_manyArgs = {
  updates: Array<placeWhiteLists_updates>;
};


/** mutation root */
export type mutation_rootupdate_privilegeEnumToRoleAuditArgs = {
  _append?: privilegeEnumToRoleAudit_append_input;
  _delete_at_path?: privilegeEnumToRoleAudit_delete_at_path_input;
  _delete_elem?: privilegeEnumToRoleAudit_delete_elem_input;
  _delete_key?: privilegeEnumToRoleAudit_delete_key_input;
  _inc?: privilegeEnumToRoleAudit_inc_input;
  _prepend?: privilegeEnumToRoleAudit_prepend_input;
  _set?: privilegeEnumToRoleAudit_set_input;
  where: privilegeEnumToRoleAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_privilegeEnumToRoleAudit_manyArgs = {
  updates: Array<privilegeEnumToRoleAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_AccessCatalogCapabilitiesArgs = {
  _set?: qx_AccessCatalogCapabilities_set_input;
  where: qx_AccessCatalogCapabilities_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_AccessCatalogCapabilities_by_pkArgs = {
  _set?: qx_AccessCatalogCapabilities_set_input;
  pk_columns: qx_AccessCatalogCapabilities_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_qx_AccessCatalogCapabilities_manyArgs = {
  updates: Array<qx_AccessCatalogCapabilities_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_AccessCatalog_manyArgs = {
  updates: Array<qx_AccessCatalog_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_AccessInventory_manyArgs = {
  updates: Array<qx_AccessInventory_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_AudioSource_manyArgs = {
  updates: Array<qx_AudioSource_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_AuditLogArgs = {
  _append?: qx_AuditLog_append_input;
  _delete_at_path?: qx_AuditLog_delete_at_path_input;
  _delete_elem?: qx_AuditLog_delete_elem_input;
  _delete_key?: qx_AuditLog_delete_key_input;
  _inc?: qx_AuditLog_inc_input;
  _prepend?: qx_AuditLog_prepend_input;
  _set?: qx_AuditLog_set_input;
  where: qx_AuditLog_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_AuditLog_by_pkArgs = {
  _append?: qx_AuditLog_append_input;
  _delete_at_path?: qx_AuditLog_delete_at_path_input;
  _delete_elem?: qx_AuditLog_delete_elem_input;
  _delete_key?: qx_AuditLog_delete_key_input;
  _inc?: qx_AuditLog_inc_input;
  _prepend?: qx_AuditLog_prepend_input;
  _set?: qx_AuditLog_set_input;
  pk_columns: qx_AuditLog_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_qx_AuditLog_manyArgs = {
  updates: Array<qx_AuditLog_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_AuditableActionArgs = {
  _set?: qx_AuditableAction_set_input;
  where: qx_AuditableAction_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_AuditableAction_by_pkArgs = {
  _set?: qx_AuditableAction_set_input;
  pk_columns: qx_AuditableAction_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_qx_AuditableAction_manyArgs = {
  updates: Array<qx_AuditableAction_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_AuditableTypeArgs = {
  _set?: qx_AuditableType_set_input;
  where: qx_AuditableType_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_AuditableType_by_pkArgs = {
  _set?: qx_AuditableType_set_input;
  pk_columns: qx_AuditableType_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_qx_AuditableType_manyArgs = {
  updates: Array<qx_AuditableType_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_BillingPeriodArgs = {
  _inc?: qx_BillingPeriod_inc_input;
  _set?: qx_BillingPeriod_set_input;
  where: qx_BillingPeriod_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_BillingPeriod_manyArgs = {
  updates: Array<qx_BillingPeriod_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_CatalogProtocolOverrideArgs = {
  _inc?: qx_CatalogProtocolOverride_inc_input;
  _set?: qx_CatalogProtocolOverride_set_input;
  where: qx_CatalogProtocolOverride_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_CatalogProtocolOverride_by_pkArgs = {
  _inc?: qx_CatalogProtocolOverride_inc_input;
  _set?: qx_CatalogProtocolOverride_set_input;
  pk_columns: qx_CatalogProtocolOverride_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_qx_CatalogProtocolOverride_manyArgs = {
  updates: Array<qx_CatalogProtocolOverride_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_ChatUsageHistory_manyArgs = {
  updates: Array<qx_ChatUsageHistory_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_ClipAuditLogArgs = {
  _append?: qx_ClipAuditLog_append_input;
  _delete_at_path?: qx_ClipAuditLog_delete_at_path_input;
  _delete_elem?: qx_ClipAuditLog_delete_elem_input;
  _delete_key?: qx_ClipAuditLog_delete_key_input;
  _inc?: qx_ClipAuditLog_inc_input;
  _prepend?: qx_ClipAuditLog_prepend_input;
  _set?: qx_ClipAuditLog_set_input;
  where: qx_ClipAuditLog_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_ClipAuditLog_manyArgs = {
  updates: Array<qx_ClipAuditLog_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_Clip_manyArgs = {
  updates: Array<qx_Clip_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_CloudStorageOptionsArgs = {
  _inc?: qx_CloudStorageOptions_inc_input;
  _set?: qx_CloudStorageOptions_set_input;
  where: qx_CloudStorageOptions_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_CloudStorageOptions_manyArgs = {
  updates: Array<qx_CloudStorageOptions_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_Credential_manyArgs = {
  updates: Array<qx_Credential_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_CustomerAuthProviderArgs = {
  _append?: qx_CustomerAuthProvider_append_input;
  _delete_at_path?: qx_CustomerAuthProvider_delete_at_path_input;
  _delete_elem?: qx_CustomerAuthProvider_delete_elem_input;
  _delete_key?: qx_CustomerAuthProvider_delete_key_input;
  _inc?: qx_CustomerAuthProvider_inc_input;
  _prepend?: qx_CustomerAuthProvider_prepend_input;
  _set?: qx_CustomerAuthProvider_set_input;
  where: qx_CustomerAuthProvider_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_CustomerAuthProvider_by_pkArgs = {
  _append?: qx_CustomerAuthProvider_append_input;
  _delete_at_path?: qx_CustomerAuthProvider_delete_at_path_input;
  _delete_elem?: qx_CustomerAuthProvider_delete_elem_input;
  _delete_key?: qx_CustomerAuthProvider_delete_key_input;
  _inc?: qx_CustomerAuthProvider_inc_input;
  _prepend?: qx_CustomerAuthProvider_prepend_input;
  _set?: qx_CustomerAuthProvider_set_input;
  pk_columns: qx_CustomerAuthProvider_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_qx_CustomerAuthProvider_manyArgs = {
  updates: Array<qx_CustomerAuthProvider_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_CustomerPermission_manyArgs = {
  updates: Array<qx_CustomerPermission_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_DeviceDIO_manyArgs = {
  updates: Array<qx_DeviceDIO_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_Device_manyArgs = {
  updates: Array<qx_Device_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_DiscoveryTypeArgs = {
  _set?: qx_DiscoveryType_set_input;
  where: qx_DiscoveryType_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_DiscoveryType_by_pkArgs = {
  _set?: qx_DiscoveryType_set_input;
  pk_columns: qx_DiscoveryType_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_qx_DiscoveryType_manyArgs = {
  updates: Array<qx_DiscoveryType_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_DoorConfiguration_manyArgs = {
  updates: Array<qx_DoorConfiguration_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_DoorMeta_manyArgs = {
  updates: Array<qx_DoorMeta_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_DoorTemplate_manyArgs = {
  updates: Array<qx_DoorTemplate_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_Door_manyArgs = {
  updates: Array<qx_Door_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_EventType_by_pkArgs = {
  _inc?: qx_EventType_inc_input;
  _set?: qx_EventType_set_input;
  pk_columns: qx_EventType_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_qx_EventType_manyArgs = {
  updates: Array<qx_EventType_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_Event_manyArgs = {
  updates: Array<qx_Event_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_FlowTrace_manyArgs = {
  updates: Array<qx_FlowTrace_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_Flow_manyArgs = {
  updates: Array<qx_Flow_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_GatewayBandwidthSchedule_manyArgs = {
  updates: Array<qx_GatewayBandwidthSchedule_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_Gateway_manyArgs = {
  updates: Array<qx_Gateway_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_Group_manyArgs = {
  updates: Array<qx_Group_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_HolidaySet_manyArgs = {
  updates: Array<qx_HolidaySet_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_InputPoint_manyArgs = {
  updates: Array<qx_InputPoint_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_IntrusionAlarmArgs = {
  _inc?: qx_IntrusionAlarm_inc_input;
  _set?: qx_IntrusionAlarm_set_input;
  where: qx_IntrusionAlarm_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_IntrusionAlarm_by_pkArgs = {
  _inc?: qx_IntrusionAlarm_inc_input;
  _set?: qx_IntrusionAlarm_set_input;
  pk_columns: qx_IntrusionAlarm_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_qx_IntrusionAlarm_manyArgs = {
  updates: Array<qx_IntrusionAlarm_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_IntrusionPartitionStateArgs = {
  _inc?: qx_IntrusionPartitionState_inc_input;
  _set?: qx_IntrusionPartitionState_set_input;
  where: qx_IntrusionPartitionState_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_IntrusionPartitionState_by_pkArgs = {
  _inc?: qx_IntrusionPartitionState_inc_input;
  _set?: qx_IntrusionPartitionState_set_input;
  pk_columns: qx_IntrusionPartitionState_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_qx_IntrusionPartitionState_manyArgs = {
  updates: Array<qx_IntrusionPartitionState_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_IntrusionZoneStateArgs = {
  _inc?: qx_IntrusionZoneState_inc_input;
  _set?: qx_IntrusionZoneState_set_input;
  where: qx_IntrusionZoneState_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_IntrusionZoneState_by_pkArgs = {
  _inc?: qx_IntrusionZoneState_inc_input;
  _set?: qx_IntrusionZoneState_set_input;
  pk_columns: qx_IntrusionZoneState_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_qx_IntrusionZoneState_manyArgs = {
  updates: Array<qx_IntrusionZoneState_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_Layout_manyArgs = {
  updates: Array<qx_Layout_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_LensProfile_manyArgs = {
  updates: Array<qx_LensProfile_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_Lock_manyArgs = {
  updates: Array<qx_Lock_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_MediaProfileRecordingArgs = {
  _inc?: qx_MediaProfileRecording_inc_input;
  _set?: qx_MediaProfileRecording_set_input;
  where: qx_MediaProfileRecording_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_MediaProfileRecording_by_pkArgs = {
  _inc?: qx_MediaProfileRecording_inc_input;
  _set?: qx_MediaProfileRecording_set_input;
  pk_columns: qx_MediaProfileRecording_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_qx_MediaProfileRecording_manyArgs = {
  updates: Array<qx_MediaProfileRecording_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_MediaProfile_manyArgs = {
  updates: Array<qx_MediaProfile_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_MercuryControlPoint_manyArgs = {
  updates: Array<qx_MercuryControlPoint_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_MercuryMonitorPoint_manyArgs = {
  updates: Array<qx_MercuryMonitorPoint_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_OssIdAssignment_manyArgs = {
  updates: Array<qx_OssIdAssignment_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_OssKeyArgs = {
  _set?: qx_OssKey_set_input;
  where: qx_OssKey_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_OssKey_by_pkArgs = {
  _set?: qx_OssKey_set_input;
  pk_columns: qx_OssKey_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_qx_OssKey_manyArgs = {
  updates: Array<qx_OssKey_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_OutputPoint_manyArgs = {
  updates: Array<qx_OutputPoint_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_Permission_manyArgs = {
  updates: Array<qx_Permission_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_Person_manyArgs = {
  updates: Array<qx_Person_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_Place_manyArgs = {
  updates: Array<qx_Place_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_Reader_manyArgs = {
  updates: Array<qx_Reader_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_Role_manyArgs = {
  updates: Array<qx_Role_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_RosslareConnection_manyArgs = {
  updates: Array<qx_RosslareConnection_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_ScheduleBlock_manyArgs = {
  updates: Array<qx_ScheduleBlock_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_Schedule_manyArgs = {
  updates: Array<qx_Schedule_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_Segment_manyArgs = {
  updates: Array<qx_Segment_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_Sensor_manyArgs = {
  updates: Array<qx_Sensor_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_SharedLinkAuditLogArgs = {
  _append?: qx_SharedLinkAuditLog_append_input;
  _delete_at_path?: qx_SharedLinkAuditLog_delete_at_path_input;
  _delete_elem?: qx_SharedLinkAuditLog_delete_elem_input;
  _delete_key?: qx_SharedLinkAuditLog_delete_key_input;
  _inc?: qx_SharedLinkAuditLog_inc_input;
  _prepend?: qx_SharedLinkAuditLog_prepend_input;
  _set?: qx_SharedLinkAuditLog_set_input;
  where: qx_SharedLinkAuditLog_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_SharedLinkAuditLog_manyArgs = {
  updates: Array<qx_SharedLinkAuditLog_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_SharedLinkTypeArgs = {
  _set?: qx_SharedLinkType_set_input;
  where: qx_SharedLinkType_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_SharedLinkType_by_pkArgs = {
  _set?: qx_SharedLinkType_set_input;
  pk_columns: qx_SharedLinkType_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_qx_SharedLinkType_manyArgs = {
  updates: Array<qx_SharedLinkType_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_SharedLinks_manyArgs = {
  updates: Array<qx_SharedLinks_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_Snapshot_manyArgs = {
  updates: Array<qx_Snapshot_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_TermsAgreement_manyArgs = {
  updates: Array<qx_TermsAgreement_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_TimeZone_manyArgs = {
  updates: Array<qx_TimeZone_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_UserSetting_manyArgs = {
  updates: Array<qx_UserSetting_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_VideoSourceStorageAuditArgs = {
  _inc?: qx_VideoSourceStorageAudit_inc_input;
  _set?: qx_VideoSourceStorageAudit_set_input;
  where: qx_VideoSourceStorageAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_VideoSourceStorageAudit_by_pkArgs = {
  _inc?: qx_VideoSourceStorageAudit_inc_input;
  _set?: qx_VideoSourceStorageAudit_set_input;
  pk_columns: qx_VideoSourceStorageAudit_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_qx_VideoSourceStorageAudit_manyArgs = {
  updates: Array<qx_VideoSourceStorageAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_VideoSource_manyArgs = {
  updates: Array<qx_VideoSource_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_View_manyArgs = {
  updates: Array<qx_View_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_WiegandCardFormat_manyArgs = {
  updates: Array<qx_WiegandCardFormat_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx__HolidaySetToScheduleBlock_manyArgs = {
  updates: Array<qx__HolidaySetToScheduleBlock_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx__PersonToGroup_manyArgs = {
  updates: Array<qx__PersonToGroup_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx__PrivilegeEnumToRole_manyArgs = {
  updates: Array<qx__PrivilegeEnumToRole_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eAccessBoardType_manyArgs = {
  updates: Array<qx_eAccessBoardType_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eAccessDeniedReason_manyArgs = {
  updates: Array<qx_eAccessDeniedReason_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eAccessInterfaceType_manyArgs = {
  updates: Array<qx_eAccessInterfaceType_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eAccessMakeArgs = {
  _set?: qx_eAccessMake_set_input;
  where: qx_eAccessMake_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_eAccessMake_by_pkArgs = {
  _set?: qx_eAccessMake_set_input;
  pk_columns: qx_eAccessMake_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_qx_eAccessMake_manyArgs = {
  updates: Array<qx_eAccessMake_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eAccessPointAction_manyArgs = {
  updates: Array<qx_eAccessPointAction_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eAccessPointDirection_manyArgs = {
  updates: Array<qx_eAccessPointDirection_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eAccessPointType_manyArgs = {
  updates: Array<qx_eAccessPointType_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eAppPrivilegeTypeArgs = {
  _set?: qx_eAppPrivilegeType_set_input;
  where: qx_eAppPrivilegeType_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_eAppPrivilegeType_by_pkArgs = {
  _set?: qx_eAppPrivilegeType_set_input;
  pk_columns: qx_eAppPrivilegeType_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_qx_eAppPrivilegeType_manyArgs = {
  updates: Array<qx_eAppPrivilegeType_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eAuthProviderArgs = {
  _set?: qx_eAuthProvider_set_input;
  where: qx_eAuthProvider_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_eAuthProvider_by_pkArgs = {
  _set?: qx_eAuthProvider_set_input;
  pk_columns: qx_eAuthProvider_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_qx_eAuthProvider_manyArgs = {
  updates: Array<qx_eAuthProvider_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eAuthStrategy_manyArgs = {
  updates: Array<qx_eAuthStrategy_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eBatteryLevel_manyArgs = {
  updates: Array<qx_eBatteryLevel_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eBaudrate_manyArgs = {
  updates: Array<qx_eBaudrate_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eBillingTier_manyArgs = {
  updates: Array<qx_eBillingTier_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eClipStatus_manyArgs = {
  updates: Array<qx_eClipStatus_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eClipType_manyArgs = {
  updates: Array<qx_eClipType_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eCredentialType_manyArgs = {
  updates: Array<qx_eCredentialType_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eDIONormalState_manyArgs = {
  updates: Array<qx_eDIONormalState_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eDIOState_manyArgs = {
  updates: Array<qx_eDIOState_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eDIOType_manyArgs = {
  updates: Array<qx_eDIOType_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eDeviceConnectionStatus_manyArgs = {
  updates: Array<qx_eDeviceConnectionStatus_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eDeviceKind_manyArgs = {
  updates: Array<qx_eDeviceKind_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eDoorAlarm_manyArgs = {
  updates: Array<qx_eDoorAlarm_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eDoorMode_manyArgs = {
  updates: Array<qx_eDoorMode_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eDoorMonitor_manyArgs = {
  updates: Array<qx_eDoorMonitor_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eDoorState_manyArgs = {
  updates: Array<qx_eDoorState_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eFlowNotificationType_manyArgs = {
  updates: Array<qx_eFlowNotificationType_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eFlowStatusArgs = {
  _set?: qx_eFlowStatus_set_input;
  where: qx_eFlowStatus_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_eFlowStatus_by_pkArgs = {
  _set?: qx_eFlowStatus_set_input;
  pk_columns: qx_eFlowStatus_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_qx_eFlowStatus_manyArgs = {
  updates: Array<qx_eFlowStatus_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eFlowTraceActionStatusArgs = {
  _set?: qx_eFlowTraceActionStatus_set_input;
  where: qx_eFlowTraceActionStatus_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_eFlowTraceActionStatus_by_pkArgs = {
  _set?: qx_eFlowTraceActionStatus_set_input;
  pk_columns: qx_eFlowTraceActionStatus_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_qx_eFlowTraceActionStatus_manyArgs = {
  updates: Array<qx_eFlowTraceActionStatus_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eFlowTraceStateArgs = {
  _set?: qx_eFlowTraceState_set_input;
  where: qx_eFlowTraceState_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_eFlowTraceState_by_pkArgs = {
  _set?: qx_eFlowTraceState_set_input;
  pk_columns: qx_eFlowTraceState_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_qx_eFlowTraceState_manyArgs = {
  updates: Array<qx_eFlowTraceState_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eGatewayServiceType_manyArgs = {
  updates: Array<qx_eGatewayServiceType_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eGatewaySyncStatus_manyArgs = {
  updates: Array<qx_eGatewaySyncStatus_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eIntrusionZoneTypeArgs = {
  _set?: qx_eIntrusionZoneType_set_input;
  where: qx_eIntrusionZoneType_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_eIntrusionZoneType_by_pkArgs = {
  _set?: qx_eIntrusionZoneType_set_input;
  pk_columns: qx_eIntrusionZoneType_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_qx_eIntrusionZoneType_manyArgs = {
  updates: Array<qx_eIntrusionZoneType_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eKeypadMode_manyArgs = {
  updates: Array<qx_eKeypadMode_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eLockModeArgs = {
  _set?: qx_eLockMode_set_input;
  where: qx_eLockMode_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_eLockMode_by_pkArgs = {
  _set?: qx_eLockMode_set_input;
  pk_columns: qx_eLockMode_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_qx_eLockMode_manyArgs = {
  updates: Array<qx_eLockMode_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eLockPowerMonitor_manyArgs = {
  updates: Array<qx_eLockPowerMonitor_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eLockRelayMonitor_manyArgs = {
  updates: Array<qx_eLockRelayMonitor_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eLockType_manyArgs = {
  updates: Array<qx_eLockType_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eMercuryMonitorPointLatchModesArgs = {
  _set?: qx_eMercuryMonitorPointLatchModes_set_input;
  where: qx_eMercuryMonitorPointLatchModes_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_eMercuryMonitorPointLatchModes_by_pkArgs = {
  _set?: qx_eMercuryMonitorPointLatchModes_set_input;
  pk_columns: qx_eMercuryMonitorPointLatchModes_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_qx_eMercuryMonitorPointLatchModes_manyArgs = {
  updates: Array<qx_eMercuryMonitorPointLatchModes_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eMonitorLockState_manyArgs = {
  updates: Array<qx_eMonitorLockState_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eMountPosition_manyArgs = {
  updates: Array<qx_eMountPosition_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eObjectAction_manyArgs = {
  updates: Array<qx_eObjectAction_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_ePACSStatus_manyArgs = {
  updates: Array<qx_ePACSStatus_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_ePersonStatus_manyArgs = {
  updates: Array<qx_ePersonStatus_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_ePlaceType_manyArgs = {
  updates: Array<qx_ePlaceType_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_ePrivilege_manyArgs = {
  updates: Array<qx_ePrivilege_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eReaderAccessType_manyArgs = {
  updates: Array<qx_eReaderAccessType_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eReaderProtocol_manyArgs = {
  updates: Array<qx_eReaderProtocol_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eRexState_manyArgs = {
  updates: Array<qx_eRexState_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eSensorAction_manyArgs = {
  updates: Array<qx_eSensorAction_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eSensorType_manyArgs = {
  updates: Array<qx_eSensorType_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eStreamStatus_manyArgs = {
  updates: Array<qx_eStreamStatus_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_eSuperviseInputs_manyArgs = {
  updates: Array<qx_eSuperviseInputs_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_vPlacePrivilegeArgs = {
  _inc?: qx_vPlacePrivilege_inc_input;
  _set?: qx_vPlacePrivilege_set_input;
  where: qx_vPlacePrivilege_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_vPlacePrivilege_manyArgs = {
  updates: Array<qx_vPlacePrivilege_updates>;
};


/** mutation root */
export type mutation_rootupdate_qx_vProfilesArgs = {
  _append?: qx_vProfiles_append_input;
  _delete_at_path?: qx_vProfiles_delete_at_path_input;
  _delete_elem?: qx_vProfiles_delete_elem_input;
  _delete_key?: qx_vProfiles_delete_key_input;
  _prepend?: qx_vProfiles_prepend_input;
  _set?: qx_vProfiles_set_input;
  where: qx_vProfiles_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qx_vProfiles_manyArgs = {
  updates: Array<qx_vProfiles_updates>;
};


/** mutation root */
export type mutation_rootupdate_qxanalytics_CloudUsageArgs = {
  _inc?: qxanalytics_CloudUsage_inc_input;
  _set?: qxanalytics_CloudUsage_set_input;
  where: qxanalytics_CloudUsage_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_qxanalytics_CloudUsage_manyArgs = {
  updates: Array<qxanalytics_CloudUsage_updates>;
};


/** mutation root */
export type mutation_rootupdate_readerAccessTypeCompatibilityArgs = {
  _inc?: readerAccessTypeCompatibility_inc_input;
  _set?: readerAccessTypeCompatibility_set_input;
  where: readerAccessTypeCompatibility_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_readerAccessTypeCompatibility_by_pkArgs = {
  _inc?: readerAccessTypeCompatibility_inc_input;
  _set?: readerAccessTypeCompatibility_set_input;
  pk_columns: readerAccessTypeCompatibility_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_readerAccessTypeCompatibility_manyArgs = {
  updates: Array<readerAccessTypeCompatibility_updates>;
};


/** mutation root */
export type mutation_rootupdate_readerAuditArgs = {
  _append?: readerAudit_append_input;
  _delete_at_path?: readerAudit_delete_at_path_input;
  _delete_elem?: readerAudit_delete_elem_input;
  _delete_key?: readerAudit_delete_key_input;
  _inc?: readerAudit_inc_input;
  _prepend?: readerAudit_prepend_input;
  _set?: readerAudit_set_input;
  where: readerAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_readerAudit_manyArgs = {
  updates: Array<readerAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_readerProtocolCompatibilityArgs = {
  _inc?: readerProtocolCompatibility_inc_input;
  _set?: readerProtocolCompatibility_set_input;
  where: readerProtocolCompatibility_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_readerProtocolCompatibility_by_pkArgs = {
  _inc?: readerProtocolCompatibility_inc_input;
  _set?: readerProtocolCompatibility_set_input;
  pk_columns: readerProtocolCompatibility_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_readerProtocolCompatibility_manyArgs = {
  updates: Array<readerProtocolCompatibility_updates>;
};


/** mutation root */
export type mutation_rootupdate_roleAppPrivilegesArgs = {
  _append?: roleAppPrivileges_append_input;
  _delete_at_path?: roleAppPrivileges_delete_at_path_input;
  _delete_elem?: roleAppPrivileges_delete_elem_input;
  _delete_key?: roleAppPrivileges_delete_key_input;
  _inc?: roleAppPrivileges_inc_input;
  _prepend?: roleAppPrivileges_prepend_input;
  _set?: roleAppPrivileges_set_input;
  where: roleAppPrivileges_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_roleAppPrivileges_by_pkArgs = {
  _append?: roleAppPrivileges_append_input;
  _delete_at_path?: roleAppPrivileges_delete_at_path_input;
  _delete_elem?: roleAppPrivileges_delete_elem_input;
  _delete_key?: roleAppPrivileges_delete_key_input;
  _inc?: roleAppPrivileges_inc_input;
  _prepend?: roleAppPrivileges_prepend_input;
  _set?: roleAppPrivileges_set_input;
  pk_columns: roleAppPrivileges_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_roleAppPrivileges_manyArgs = {
  updates: Array<roleAppPrivileges_updates>;
};


/** mutation root */
export type mutation_rootupdate_roleAuditArgs = {
  _append?: roleAudit_append_input;
  _delete_at_path?: roleAudit_delete_at_path_input;
  _delete_elem?: roleAudit_delete_elem_input;
  _delete_key?: roleAudit_delete_key_input;
  _inc?: roleAudit_inc_input;
  _prepend?: roleAudit_prepend_input;
  _set?: roleAudit_set_input;
  where: roleAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_roleAudit_manyArgs = {
  updates: Array<roleAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_rosslareCatalogsArgs = {
  _inc?: rosslareCatalogs_inc_input;
  _set?: rosslareCatalogs_set_input;
  where: rosslareCatalogs_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_rosslareCatalogs_by_pkArgs = {
  _inc?: rosslareCatalogs_inc_input;
  _set?: rosslareCatalogs_set_input;
  pk_columns: rosslareCatalogs_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_rosslareCatalogs_manyArgs = {
  updates: Array<rosslareCatalogs_updates>;
};


/** mutation root */
export type mutation_rootupdate_s3BucketConfigurationsArgs = {
  _inc?: s3BucketConfigurations_inc_input;
  _set?: s3BucketConfigurations_set_input;
  where: s3BucketConfigurations_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_s3BucketConfigurations_by_pkArgs = {
  _inc?: s3BucketConfigurations_inc_input;
  _set?: s3BucketConfigurations_set_input;
  pk_columns: s3BucketConfigurations_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_s3BucketConfigurations_manyArgs = {
  updates: Array<s3BucketConfigurations_updates>;
};


/** mutation root */
export type mutation_rootupdate_scheduleAuditArgs = {
  _append?: scheduleAudit_append_input;
  _delete_at_path?: scheduleAudit_delete_at_path_input;
  _delete_elem?: scheduleAudit_delete_elem_input;
  _delete_key?: scheduleAudit_delete_key_input;
  _inc?: scheduleAudit_inc_input;
  _prepend?: scheduleAudit_prepend_input;
  _set?: scheduleAudit_set_input;
  where: scheduleAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_scheduleAudit_manyArgs = {
  updates: Array<scheduleAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_scheduleBlockAuditArgs = {
  _append?: scheduleBlockAudit_append_input;
  _delete_at_path?: scheduleBlockAudit_delete_at_path_input;
  _delete_elem?: scheduleBlockAudit_delete_elem_input;
  _delete_key?: scheduleBlockAudit_delete_key_input;
  _inc?: scheduleBlockAudit_inc_input;
  _prepend?: scheduleBlockAudit_prepend_input;
  _set?: scheduleBlockAudit_set_input;
  where: scheduleBlockAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_scheduleBlockAudit_manyArgs = {
  updates: Array<scheduleBlockAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_superviseInputCompatibilityArgs = {
  _inc?: superviseInputCompatibility_inc_input;
  _set?: superviseInputCompatibility_set_input;
  where: superviseInputCompatibility_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_superviseInputCompatibility_by_pkArgs = {
  _inc?: superviseInputCompatibility_inc_input;
  _set?: superviseInputCompatibility_set_input;
  pk_columns: superviseInputCompatibility_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_superviseInputCompatibility_manyArgs = {
  updates: Array<superviseInputCompatibility_updates>;
};


/** mutation root */
export type mutation_rootupdate_videoSourceAuditArgs = {
  _append?: videoSourceAudit_append_input;
  _delete_at_path?: videoSourceAudit_delete_at_path_input;
  _delete_elem?: videoSourceAudit_delete_elem_input;
  _delete_key?: videoSourceAudit_delete_key_input;
  _inc?: videoSourceAudit_inc_input;
  _prepend?: videoSourceAudit_prepend_input;
  _set?: videoSourceAudit_set_input;
  where: videoSourceAudit_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_videoSourceAudit_manyArgs = {
  updates: Array<videoSourceAudit_updates>;
};


/** mutation root */
export type mutation_rootupdate_videoSourceStateArgs = {
  _inc?: videoSourceState_inc_input;
  _set?: videoSourceState_set_input;
  where: videoSourceState_bool_exp;
};


/** mutation root */
export type mutation_rootupdate_videoSourceState_by_pkArgs = {
  _inc?: videoSourceState_inc_input;
  _set?: videoSourceState_set_input;
  pk_columns: videoSourceState_pk_columns_input;
};


/** mutation root */
export type mutation_rootupdate_videoSourceState_manyArgs = {
  updates: Array<videoSourceState_updates>;
};


/** mutation root */
export type mutation_rootupgradePremGatewayArgs = {
  gatewayID: string;
  migrationSitePlaceID: string;
  newShard: number;
};


/** mutation root */
export type mutation_rootupgradeRosslareFirmwareArgs = {
  deviceID: string;
  force?: boolean;
};


/** mutation root */
export type mutation_rootvalidateHardwareArgs = {
  config?: any;
  deviceID: string;
};


/** mutation root */
export type mutation_rootvalidateSoftwareArgs = {
  deviceID: string;
};

export type namevalue = {
  name?: string;
  value?: string;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type numeric_comparison_exp = {
  _eq?: any;
  _gt?: any;
  _gte?: any;
  _in?: Array<any>;
  _is_null?: boolean;
  _lt?: any;
  _lte?: any;
  _neq?: any;
  _nin?: Array<any>;
};

/** column ordering options */
export enum order_by {
  /** in ascending order, nulls last */
  asc = 'asc',
  /** in ascending order, nulls first */
  asc_nulls_first = 'asc_nulls_first',
  /** in ascending order, nulls last */
  asc_nulls_last = 'asc_nulls_last',
  /** in descending order, nulls first */
  desc = 'desc',
  /** in descending order, nulls first */
  desc_nulls_first = 'desc_nulls_first',
  /** in descending order, nulls last */
  desc_nulls_last = 'desc_nulls_last'
}

/** audit view tracking historical changes to output point configurations */
export type outputPointAudit = {
  __typename?: 'outputPointAudit';
  action?: string;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  id?: string;
  /** An object relationship */
  outputPoint?: qx_OutputPoint;
  /** An object relationship */
  person?: qx_Person;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  row_data?: any;
  time?: string;
};


/** audit view tracking historical changes to output point configurations */
export type outputPointAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes to output point configurations */
export type outputPointAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.vOutputPointAudit" */
export type outputPointAudit_aggregate = {
  __typename?: 'outputPointAudit_aggregate';
  aggregate?: outputPointAudit_aggregate_fields;
  nodes: Array<outputPointAudit>;
};

/** aggregate fields of "audit.vOutputPointAudit" */
export type outputPointAudit_aggregate_fields = {
  __typename?: 'outputPointAudit_aggregate_fields';
  avg?: outputPointAudit_avg_fields;
  count: number;
  max?: outputPointAudit_max_fields;
  min?: outputPointAudit_min_fields;
  stddev?: outputPointAudit_stddev_fields;
  stddev_pop?: outputPointAudit_stddev_pop_fields;
  stddev_samp?: outputPointAudit_stddev_samp_fields;
  sum?: outputPointAudit_sum_fields;
  var_pop?: outputPointAudit_var_pop_fields;
  var_samp?: outputPointAudit_var_samp_fields;
  variance?: outputPointAudit_variance_fields;
};


/** aggregate fields of "audit.vOutputPointAudit" */
export type outputPointAudit_aggregate_fieldscountArgs = {
  columns?: Array<outputPointAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type outputPointAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type outputPointAudit_avg_fields = {
  __typename?: 'outputPointAudit_avg_fields';
  auditID?: number;
};

/** Boolean expression to filter rows from the table "audit.vOutputPointAudit". All fields are combined with a logical 'AND'. */
export type outputPointAudit_bool_exp = {
  _and?: Array<outputPointAudit_bool_exp>;
  _not?: outputPointAudit_bool_exp;
  _or?: Array<outputPointAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  id?: String_comparison_exp;
  outputPoint?: qx_OutputPoint_bool_exp;
  person?: qx_Person_bool_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type outputPointAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type outputPointAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type outputPointAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.vOutputPointAudit" */
export type outputPointAudit_inc_input = {
  auditID?: string;
};

/** input type for inserting data into table "audit.vOutputPointAudit" */
export type outputPointAudit_insert_input = {
  action?: string;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  id?: string;
  outputPoint?: qx_OutputPoint_obj_rel_insert_input;
  person?: qx_Person_obj_rel_insert_input;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate max on columns */
export type outputPointAudit_max_fields = {
  __typename?: 'outputPointAudit_max_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** aggregate min on columns */
export type outputPointAudit_min_fields = {
  __typename?: 'outputPointAudit_min_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** response of any mutation on the table "audit.vOutputPointAudit" */
export type outputPointAudit_mutation_response = {
  __typename?: 'outputPointAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<outputPointAudit>;
};

/** Ordering options when selecting data from "audit.vOutputPointAudit". */
export type outputPointAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  id?: order_by;
  outputPoint?: qx_OutputPoint_order_by;
  person?: qx_Person_order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  row_data?: order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type outputPointAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.vOutputPointAudit" */
export enum outputPointAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  id = 'id',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.vOutputPointAudit" */
export type outputPointAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type outputPointAudit_stddev_fields = {
  __typename?: 'outputPointAudit_stddev_fields';
  auditID?: number;
};

/** aggregate stddev_pop on columns */
export type outputPointAudit_stddev_pop_fields = {
  __typename?: 'outputPointAudit_stddev_pop_fields';
  auditID?: number;
};

/** aggregate stddev_samp on columns */
export type outputPointAudit_stddev_samp_fields = {
  __typename?: 'outputPointAudit_stddev_samp_fields';
  auditID?: number;
};

/** Streaming cursor of the table "outputPointAudit" */
export type outputPointAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: outputPointAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type outputPointAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type outputPointAudit_sum_fields = {
  __typename?: 'outputPointAudit_sum_fields';
  auditID?: string;
};

export type outputPointAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: outputPointAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: outputPointAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: outputPointAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: outputPointAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: outputPointAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: outputPointAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: outputPointAudit_set_input;
  /** filter the rows which have to be updated */
  where: outputPointAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type outputPointAudit_var_pop_fields = {
  __typename?: 'outputPointAudit_var_pop_fields';
  auditID?: number;
};

/** aggregate var_samp on columns */
export type outputPointAudit_var_samp_fields = {
  __typename?: 'outputPointAudit_var_samp_fields';
  auditID?: number;
};

/** aggregate variance on columns */
export type outputPointAudit_variance_fields = {
  __typename?: 'outputPointAudit_variance_fields';
  auditID?: number;
};

export type pacsSettings = {
  connection?: connectionSettings;
  door?: Array<doorSettings>;
  id: string;
  lock?: Array<lockSettings>;
  make?: string;
  model?: string;
  pin?: Array<pinSettings>;
  priority?: Array<prioritySettings>;
  reader?: Array<readerSettings>;
};

/** audit view tracking historical changes to access permission grants */
export type permissionAudit = {
  __typename?: 'permissionAudit';
  action?: string;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  id?: string;
  /** An object relationship */
  permission?: qx_Permission;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  row_data?: any;
  time?: string;
};


/** audit view tracking historical changes to access permission grants */
export type permissionAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes to access permission grants */
export type permissionAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.vPermissionAudit" */
export type permissionAudit_aggregate = {
  __typename?: 'permissionAudit_aggregate';
  aggregate?: permissionAudit_aggregate_fields;
  nodes: Array<permissionAudit>;
};

/** aggregate fields of "audit.vPermissionAudit" */
export type permissionAudit_aggregate_fields = {
  __typename?: 'permissionAudit_aggregate_fields';
  avg?: permissionAudit_avg_fields;
  count: number;
  max?: permissionAudit_max_fields;
  min?: permissionAudit_min_fields;
  stddev?: permissionAudit_stddev_fields;
  stddev_pop?: permissionAudit_stddev_pop_fields;
  stddev_samp?: permissionAudit_stddev_samp_fields;
  sum?: permissionAudit_sum_fields;
  var_pop?: permissionAudit_var_pop_fields;
  var_samp?: permissionAudit_var_samp_fields;
  variance?: permissionAudit_variance_fields;
};


/** aggregate fields of "audit.vPermissionAudit" */
export type permissionAudit_aggregate_fieldscountArgs = {
  columns?: Array<permissionAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type permissionAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type permissionAudit_avg_fields = {
  __typename?: 'permissionAudit_avg_fields';
  auditID?: number;
};

/** Boolean expression to filter rows from the table "audit.vPermissionAudit". All fields are combined with a logical 'AND'. */
export type permissionAudit_bool_exp = {
  _and?: Array<permissionAudit_bool_exp>;
  _not?: permissionAudit_bool_exp;
  _or?: Array<permissionAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  id?: String_comparison_exp;
  permission?: qx_Permission_bool_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type permissionAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type permissionAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type permissionAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.vPermissionAudit" */
export type permissionAudit_inc_input = {
  auditID?: string;
};

/** input type for inserting data into table "audit.vPermissionAudit" */
export type permissionAudit_insert_input = {
  action?: string;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  id?: string;
  permission?: qx_Permission_obj_rel_insert_input;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate max on columns */
export type permissionAudit_max_fields = {
  __typename?: 'permissionAudit_max_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** aggregate min on columns */
export type permissionAudit_min_fields = {
  __typename?: 'permissionAudit_min_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** response of any mutation on the table "audit.vPermissionAudit" */
export type permissionAudit_mutation_response = {
  __typename?: 'permissionAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<permissionAudit>;
};

/** Ordering options when selecting data from "audit.vPermissionAudit". */
export type permissionAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  id?: order_by;
  permission?: qx_Permission_order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  row_data?: order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type permissionAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.vPermissionAudit" */
export enum permissionAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  id = 'id',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.vPermissionAudit" */
export type permissionAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type permissionAudit_stddev_fields = {
  __typename?: 'permissionAudit_stddev_fields';
  auditID?: number;
};

/** aggregate stddev_pop on columns */
export type permissionAudit_stddev_pop_fields = {
  __typename?: 'permissionAudit_stddev_pop_fields';
  auditID?: number;
};

/** aggregate stddev_samp on columns */
export type permissionAudit_stddev_samp_fields = {
  __typename?: 'permissionAudit_stddev_samp_fields';
  auditID?: number;
};

/** Streaming cursor of the table "permissionAudit" */
export type permissionAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: permissionAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type permissionAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type permissionAudit_sum_fields = {
  __typename?: 'permissionAudit_sum_fields';
  auditID?: string;
};

export type permissionAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: permissionAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: permissionAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: permissionAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: permissionAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: permissionAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: permissionAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: permissionAudit_set_input;
  /** filter the rows which have to be updated */
  where: permissionAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type permissionAudit_var_pop_fields = {
  __typename?: 'permissionAudit_var_pop_fields';
  auditID?: number;
};

/** aggregate var_samp on columns */
export type permissionAudit_var_samp_fields = {
  __typename?: 'permissionAudit_var_samp_fields';
  auditID?: number;
};

/** aggregate variance on columns */
export type permissionAudit_variance_fields = {
  __typename?: 'permissionAudit_variance_fields';
  auditID?: number;
};

/** columns and relationships of "qx.vPersonAudioSourceAppPrivileges" */
export type personAudioSourceAppPrivileges = {
  __typename?: 'personAudioSourceAppPrivileges';
  /** An object relationship */
  audioSource?: qx_AudioSource;
  audioSourceID?: string;
  canConfig?: boolean;
  canCreateClips?: boolean;
  canOperate?: boolean;
  canStream?: boolean;
  canView?: boolean;
  canViewRecordings?: boolean;
  canViewSnapshots?: boolean;
  /** An object relationship */
  person?: qx_Person;
  personID?: string;
  videoSourceID?: string;
};

/** aggregated selection of "qx.vPersonAudioSourceAppPrivileges" */
export type personAudioSourceAppPrivileges_aggregate = {
  __typename?: 'personAudioSourceAppPrivileges_aggregate';
  aggregate?: personAudioSourceAppPrivileges_aggregate_fields;
  nodes: Array<personAudioSourceAppPrivileges>;
};

export type personAudioSourceAppPrivileges_aggregate_bool_exp = {
  bool_and?: personAudioSourceAppPrivileges_aggregate_bool_exp_bool_and;
  bool_or?: personAudioSourceAppPrivileges_aggregate_bool_exp_bool_or;
  count?: personAudioSourceAppPrivileges_aggregate_bool_exp_count;
};

export type personAudioSourceAppPrivileges_aggregate_bool_exp_bool_and = {
  arguments: personAudioSourceAppPrivileges_select_column_personAudioSourceAppPrivileges_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: personAudioSourceAppPrivileges_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type personAudioSourceAppPrivileges_aggregate_bool_exp_bool_or = {
  arguments: personAudioSourceAppPrivileges_select_column_personAudioSourceAppPrivileges_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: personAudioSourceAppPrivileges_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type personAudioSourceAppPrivileges_aggregate_bool_exp_count = {
  arguments?: Array<personAudioSourceAppPrivileges_select_column>;
  distinct?: boolean;
  filter?: personAudioSourceAppPrivileges_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.vPersonAudioSourceAppPrivileges" */
export type personAudioSourceAppPrivileges_aggregate_fields = {
  __typename?: 'personAudioSourceAppPrivileges_aggregate_fields';
  avg?: personAudioSourceAppPrivileges_avg_fields;
  count: number;
  max?: personAudioSourceAppPrivileges_max_fields;
  min?: personAudioSourceAppPrivileges_min_fields;
  stddev?: personAudioSourceAppPrivileges_stddev_fields;
  stddev_pop?: personAudioSourceAppPrivileges_stddev_pop_fields;
  stddev_samp?: personAudioSourceAppPrivileges_stddev_samp_fields;
  sum?: personAudioSourceAppPrivileges_sum_fields;
  var_pop?: personAudioSourceAppPrivileges_var_pop_fields;
  var_samp?: personAudioSourceAppPrivileges_var_samp_fields;
  variance?: personAudioSourceAppPrivileges_variance_fields;
};


/** aggregate fields of "qx.vPersonAudioSourceAppPrivileges" */
export type personAudioSourceAppPrivileges_aggregate_fieldscountArgs = {
  columns?: Array<personAudioSourceAppPrivileges_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.vPersonAudioSourceAppPrivileges" */
export type personAudioSourceAppPrivileges_aggregate_order_by = {
  avg?: personAudioSourceAppPrivileges_avg_order_by;
  count?: order_by;
  max?: personAudioSourceAppPrivileges_max_order_by;
  min?: personAudioSourceAppPrivileges_min_order_by;
  stddev?: personAudioSourceAppPrivileges_stddev_order_by;
  stddev_pop?: personAudioSourceAppPrivileges_stddev_pop_order_by;
  stddev_samp?: personAudioSourceAppPrivileges_stddev_samp_order_by;
  sum?: personAudioSourceAppPrivileges_sum_order_by;
  var_pop?: personAudioSourceAppPrivileges_var_pop_order_by;
  var_samp?: personAudioSourceAppPrivileges_var_samp_order_by;
  variance?: personAudioSourceAppPrivileges_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.vPersonAudioSourceAppPrivileges" */
export type personAudioSourceAppPrivileges_arr_rel_insert_input = {
  data: Array<personAudioSourceAppPrivileges_insert_input>;
};

/** aggregate avg on columns */
export type personAudioSourceAppPrivileges_avg_fields = {
  __typename?: 'personAudioSourceAppPrivileges_avg_fields';
  audioSourceID?: number;
  videoSourceID?: number;
};

/** order by avg() on columns of table "qx.vPersonAudioSourceAppPrivileges" */
export type personAudioSourceAppPrivileges_avg_order_by = {
  audioSourceID?: order_by;
  videoSourceID?: order_by;
};

/** Boolean expression to filter rows from the table "qx.vPersonAudioSourceAppPrivileges". All fields are combined with a logical 'AND'. */
export type personAudioSourceAppPrivileges_bool_exp = {
  _and?: Array<personAudioSourceAppPrivileges_bool_exp>;
  _not?: personAudioSourceAppPrivileges_bool_exp;
  _or?: Array<personAudioSourceAppPrivileges_bool_exp>;
  audioSource?: qx_AudioSource_bool_exp;
  audioSourceID?: bigint_comparison_exp;
  canConfig?: Boolean_comparison_exp;
  canCreateClips?: Boolean_comparison_exp;
  canOperate?: Boolean_comparison_exp;
  canStream?: Boolean_comparison_exp;
  canView?: Boolean_comparison_exp;
  canViewRecordings?: Boolean_comparison_exp;
  canViewSnapshots?: Boolean_comparison_exp;
  person?: qx_Person_bool_exp;
  personID?: String_comparison_exp;
  videoSourceID?: bigint_comparison_exp;
};

/** input type for inserting data into table "qx.vPersonAudioSourceAppPrivileges" */
export type personAudioSourceAppPrivileges_insert_input = {
  audioSource?: qx_AudioSource_obj_rel_insert_input;
  audioSourceID?: string;
  canConfig?: boolean;
  canCreateClips?: boolean;
  canOperate?: boolean;
  canStream?: boolean;
  canView?: boolean;
  canViewRecordings?: boolean;
  canViewSnapshots?: boolean;
  person?: qx_Person_obj_rel_insert_input;
  personID?: string;
  videoSourceID?: string;
};

/** aggregate max on columns */
export type personAudioSourceAppPrivileges_max_fields = {
  __typename?: 'personAudioSourceAppPrivileges_max_fields';
  audioSourceID?: string;
  personID?: string;
  videoSourceID?: string;
};

/** order by max() on columns of table "qx.vPersonAudioSourceAppPrivileges" */
export type personAudioSourceAppPrivileges_max_order_by = {
  audioSourceID?: order_by;
  personID?: order_by;
  videoSourceID?: order_by;
};

/** aggregate min on columns */
export type personAudioSourceAppPrivileges_min_fields = {
  __typename?: 'personAudioSourceAppPrivileges_min_fields';
  audioSourceID?: string;
  personID?: string;
  videoSourceID?: string;
};

/** order by min() on columns of table "qx.vPersonAudioSourceAppPrivileges" */
export type personAudioSourceAppPrivileges_min_order_by = {
  audioSourceID?: order_by;
  personID?: order_by;
  videoSourceID?: order_by;
};

/** Ordering options when selecting data from "qx.vPersonAudioSourceAppPrivileges". */
export type personAudioSourceAppPrivileges_order_by = {
  audioSource?: qx_AudioSource_order_by;
  audioSourceID?: order_by;
  canConfig?: order_by;
  canCreateClips?: order_by;
  canOperate?: order_by;
  canStream?: order_by;
  canView?: order_by;
  canViewRecordings?: order_by;
  canViewSnapshots?: order_by;
  person?: qx_Person_order_by;
  personID?: order_by;
  videoSourceID?: order_by;
};

/** select columns of table "qx.vPersonAudioSourceAppPrivileges" */
export enum personAudioSourceAppPrivileges_select_column {
  /** column name */
  audioSourceID = 'audioSourceID',
  /** column name */
  canConfig = 'canConfig',
  /** column name */
  canCreateClips = 'canCreateClips',
  /** column name */
  canOperate = 'canOperate',
  /** column name */
  canStream = 'canStream',
  /** column name */
  canView = 'canView',
  /** column name */
  canViewRecordings = 'canViewRecordings',
  /** column name */
  canViewSnapshots = 'canViewSnapshots',
  /** column name */
  personID = 'personID',
  /** column name */
  videoSourceID = 'videoSourceID'
}

/** select "personAudioSourceAppPrivileges_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.vPersonAudioSourceAppPrivileges" */
export enum personAudioSourceAppPrivileges_select_column_personAudioSourceAppPrivileges_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  canConfig = 'canConfig',
  /** column name */
  canCreateClips = 'canCreateClips',
  /** column name */
  canOperate = 'canOperate',
  /** column name */
  canStream = 'canStream',
  /** column name */
  canView = 'canView',
  /** column name */
  canViewRecordings = 'canViewRecordings',
  /** column name */
  canViewSnapshots = 'canViewSnapshots'
}

/** select "personAudioSourceAppPrivileges_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.vPersonAudioSourceAppPrivileges" */
export enum personAudioSourceAppPrivileges_select_column_personAudioSourceAppPrivileges_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  canConfig = 'canConfig',
  /** column name */
  canCreateClips = 'canCreateClips',
  /** column name */
  canOperate = 'canOperate',
  /** column name */
  canStream = 'canStream',
  /** column name */
  canView = 'canView',
  /** column name */
  canViewRecordings = 'canViewRecordings',
  /** column name */
  canViewSnapshots = 'canViewSnapshots'
}

/** aggregate stddev on columns */
export type personAudioSourceAppPrivileges_stddev_fields = {
  __typename?: 'personAudioSourceAppPrivileges_stddev_fields';
  audioSourceID?: number;
  videoSourceID?: number;
};

/** order by stddev() on columns of table "qx.vPersonAudioSourceAppPrivileges" */
export type personAudioSourceAppPrivileges_stddev_order_by = {
  audioSourceID?: order_by;
  videoSourceID?: order_by;
};

/** aggregate stddev_pop on columns */
export type personAudioSourceAppPrivileges_stddev_pop_fields = {
  __typename?: 'personAudioSourceAppPrivileges_stddev_pop_fields';
  audioSourceID?: number;
  videoSourceID?: number;
};

/** order by stddev_pop() on columns of table "qx.vPersonAudioSourceAppPrivileges" */
export type personAudioSourceAppPrivileges_stddev_pop_order_by = {
  audioSourceID?: order_by;
  videoSourceID?: order_by;
};

/** aggregate stddev_samp on columns */
export type personAudioSourceAppPrivileges_stddev_samp_fields = {
  __typename?: 'personAudioSourceAppPrivileges_stddev_samp_fields';
  audioSourceID?: number;
  videoSourceID?: number;
};

/** order by stddev_samp() on columns of table "qx.vPersonAudioSourceAppPrivileges" */
export type personAudioSourceAppPrivileges_stddev_samp_order_by = {
  audioSourceID?: order_by;
  videoSourceID?: order_by;
};

/** Streaming cursor of the table "personAudioSourceAppPrivileges" */
export type personAudioSourceAppPrivileges_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: personAudioSourceAppPrivileges_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type personAudioSourceAppPrivileges_stream_cursor_value_input = {
  audioSourceID?: string;
  canConfig?: boolean;
  canCreateClips?: boolean;
  canOperate?: boolean;
  canStream?: boolean;
  canView?: boolean;
  canViewRecordings?: boolean;
  canViewSnapshots?: boolean;
  personID?: string;
  videoSourceID?: string;
};

/** aggregate sum on columns */
export type personAudioSourceAppPrivileges_sum_fields = {
  __typename?: 'personAudioSourceAppPrivileges_sum_fields';
  audioSourceID?: string;
  videoSourceID?: string;
};

/** order by sum() on columns of table "qx.vPersonAudioSourceAppPrivileges" */
export type personAudioSourceAppPrivileges_sum_order_by = {
  audioSourceID?: order_by;
  videoSourceID?: order_by;
};

/** aggregate var_pop on columns */
export type personAudioSourceAppPrivileges_var_pop_fields = {
  __typename?: 'personAudioSourceAppPrivileges_var_pop_fields';
  audioSourceID?: number;
  videoSourceID?: number;
};

/** order by var_pop() on columns of table "qx.vPersonAudioSourceAppPrivileges" */
export type personAudioSourceAppPrivileges_var_pop_order_by = {
  audioSourceID?: order_by;
  videoSourceID?: order_by;
};

/** aggregate var_samp on columns */
export type personAudioSourceAppPrivileges_var_samp_fields = {
  __typename?: 'personAudioSourceAppPrivileges_var_samp_fields';
  audioSourceID?: number;
  videoSourceID?: number;
};

/** order by var_samp() on columns of table "qx.vPersonAudioSourceAppPrivileges" */
export type personAudioSourceAppPrivileges_var_samp_order_by = {
  audioSourceID?: order_by;
  videoSourceID?: order_by;
};

/** aggregate variance on columns */
export type personAudioSourceAppPrivileges_variance_fields = {
  __typename?: 'personAudioSourceAppPrivileges_variance_fields';
  audioSourceID?: number;
  videoSourceID?: number;
};

/** order by variance() on columns of table "qx.vPersonAudioSourceAppPrivileges" */
export type personAudioSourceAppPrivileges_variance_order_by = {
  audioSourceID?: order_by;
  videoSourceID?: order_by;
};

/** audit view tracking historical changes to person records (profile updates, role changes, etc.) */
export type personAudit = {
  __typename?: 'personAudit';
  action?: string;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  id?: string;
  /** An object relationship */
  person?: qx_Person;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  row_data?: any;
  time?: string;
};


/** audit view tracking historical changes to person records (profile updates, role changes, etc.) */
export type personAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes to person records (profile updates, role changes, etc.) */
export type personAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.vPersonAudit" */
export type personAudit_aggregate = {
  __typename?: 'personAudit_aggregate';
  aggregate?: personAudit_aggregate_fields;
  nodes: Array<personAudit>;
};

/** aggregate fields of "audit.vPersonAudit" */
export type personAudit_aggregate_fields = {
  __typename?: 'personAudit_aggregate_fields';
  avg?: personAudit_avg_fields;
  count: number;
  max?: personAudit_max_fields;
  min?: personAudit_min_fields;
  stddev?: personAudit_stddev_fields;
  stddev_pop?: personAudit_stddev_pop_fields;
  stddev_samp?: personAudit_stddev_samp_fields;
  sum?: personAudit_sum_fields;
  var_pop?: personAudit_var_pop_fields;
  var_samp?: personAudit_var_samp_fields;
  variance?: personAudit_variance_fields;
};


/** aggregate fields of "audit.vPersonAudit" */
export type personAudit_aggregate_fieldscountArgs = {
  columns?: Array<personAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type personAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type personAudit_avg_fields = {
  __typename?: 'personAudit_avg_fields';
  auditID?: number;
};

/** Boolean expression to filter rows from the table "audit.vPersonAudit". All fields are combined with a logical 'AND'. */
export type personAudit_bool_exp = {
  _and?: Array<personAudit_bool_exp>;
  _not?: personAudit_bool_exp;
  _or?: Array<personAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  id?: String_comparison_exp;
  person?: qx_Person_bool_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type personAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type personAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type personAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.vPersonAudit" */
export type personAudit_inc_input = {
  auditID?: string;
};

/** input type for inserting data into table "audit.vPersonAudit" */
export type personAudit_insert_input = {
  action?: string;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  id?: string;
  person?: qx_Person_obj_rel_insert_input;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate max on columns */
export type personAudit_max_fields = {
  __typename?: 'personAudit_max_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** aggregate min on columns */
export type personAudit_min_fields = {
  __typename?: 'personAudit_min_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** response of any mutation on the table "audit.vPersonAudit" */
export type personAudit_mutation_response = {
  __typename?: 'personAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<personAudit>;
};

/** Ordering options when selecting data from "audit.vPersonAudit". */
export type personAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  id?: order_by;
  person?: qx_Person_order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  row_data?: order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type personAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.vPersonAudit" */
export enum personAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  id = 'id',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.vPersonAudit" */
export type personAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type personAudit_stddev_fields = {
  __typename?: 'personAudit_stddev_fields';
  auditID?: number;
};

/** aggregate stddev_pop on columns */
export type personAudit_stddev_pop_fields = {
  __typename?: 'personAudit_stddev_pop_fields';
  auditID?: number;
};

/** aggregate stddev_samp on columns */
export type personAudit_stddev_samp_fields = {
  __typename?: 'personAudit_stddev_samp_fields';
  auditID?: number;
};

/** Streaming cursor of the table "personAudit" */
export type personAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: personAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type personAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type personAudit_sum_fields = {
  __typename?: 'personAudit_sum_fields';
  auditID?: string;
};

export type personAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: personAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: personAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: personAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: personAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: personAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: personAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: personAudit_set_input;
  /** filter the rows which have to be updated */
  where: personAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type personAudit_var_pop_fields = {
  __typename?: 'personAudit_var_pop_fields';
  auditID?: number;
};

/** aggregate var_samp on columns */
export type personAudit_var_samp_fields = {
  __typename?: 'personAudit_var_samp_fields';
  auditID?: number;
};

/** aggregate variance on columns */
export type personAudit_variance_fields = {
  __typename?: 'personAudit_variance_fields';
  auditID?: number;
};

/** columns and relationships of "qx.PersonDeviceAppPrivileges" */
export type personDeviceAppPrivileges = {
  __typename?: 'personDeviceAppPrivileges';
  canConfig?: boolean;
  canOperate?: boolean;
  canView?: boolean;
  /** An object relationship */
  device: qx_Device;
  deviceID: string;
  /** An object relationship */
  person: qx_Person;
  personID: string;
};

/** aggregated selection of "qx.PersonDeviceAppPrivileges" */
export type personDeviceAppPrivileges_aggregate = {
  __typename?: 'personDeviceAppPrivileges_aggregate';
  aggregate?: personDeviceAppPrivileges_aggregate_fields;
  nodes: Array<personDeviceAppPrivileges>;
};

export type personDeviceAppPrivileges_aggregate_bool_exp = {
  bool_and?: personDeviceAppPrivileges_aggregate_bool_exp_bool_and;
  bool_or?: personDeviceAppPrivileges_aggregate_bool_exp_bool_or;
  count?: personDeviceAppPrivileges_aggregate_bool_exp_count;
};

export type personDeviceAppPrivileges_aggregate_bool_exp_bool_and = {
  arguments: personDeviceAppPrivileges_select_column_personDeviceAppPrivileges_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: personDeviceAppPrivileges_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type personDeviceAppPrivileges_aggregate_bool_exp_bool_or = {
  arguments: personDeviceAppPrivileges_select_column_personDeviceAppPrivileges_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: personDeviceAppPrivileges_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type personDeviceAppPrivileges_aggregate_bool_exp_count = {
  arguments?: Array<personDeviceAppPrivileges_select_column>;
  distinct?: boolean;
  filter?: personDeviceAppPrivileges_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.PersonDeviceAppPrivileges" */
export type personDeviceAppPrivileges_aggregate_fields = {
  __typename?: 'personDeviceAppPrivileges_aggregate_fields';
  count: number;
  max?: personDeviceAppPrivileges_max_fields;
  min?: personDeviceAppPrivileges_min_fields;
};


/** aggregate fields of "qx.PersonDeviceAppPrivileges" */
export type personDeviceAppPrivileges_aggregate_fieldscountArgs = {
  columns?: Array<personDeviceAppPrivileges_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.PersonDeviceAppPrivileges" */
export type personDeviceAppPrivileges_aggregate_order_by = {
  count?: order_by;
  max?: personDeviceAppPrivileges_max_order_by;
  min?: personDeviceAppPrivileges_min_order_by;
};

/** input type for inserting array relation for remote table "qx.PersonDeviceAppPrivileges" */
export type personDeviceAppPrivileges_arr_rel_insert_input = {
  data: Array<personDeviceAppPrivileges_insert_input>;
  /** upsert condition */
  on_conflict?: personDeviceAppPrivileges_on_conflict;
};

/** Boolean expression to filter rows from the table "qx.PersonDeviceAppPrivileges". All fields are combined with a logical 'AND'. */
export type personDeviceAppPrivileges_bool_exp = {
  _and?: Array<personDeviceAppPrivileges_bool_exp>;
  _not?: personDeviceAppPrivileges_bool_exp;
  _or?: Array<personDeviceAppPrivileges_bool_exp>;
  canConfig?: Boolean_comparison_exp;
  canOperate?: Boolean_comparison_exp;
  canView?: Boolean_comparison_exp;
  device?: qx_Device_bool_exp;
  deviceID?: String_comparison_exp;
  person?: qx_Person_bool_exp;
  personID?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.PersonDeviceAppPrivileges" */
export enum personDeviceAppPrivileges_constraint {
  /** unique or primary key constraint on columns "deviceID", "personID" */
  PersonDeviceAppPrivileges_pkey = 'PersonDeviceAppPrivileges_pkey',
  /** unique or primary key constraint on columns "deviceID", "personID" */
  idx_person_unique_device_person = 'idx_person_unique_device_person'
}

/** input type for inserting data into table "qx.PersonDeviceAppPrivileges" */
export type personDeviceAppPrivileges_insert_input = {
  canConfig?: boolean;
  canOperate?: boolean;
  canView?: boolean;
  device?: qx_Device_obj_rel_insert_input;
  deviceID?: string;
  person?: qx_Person_obj_rel_insert_input;
  personID?: string;
};

/** aggregate max on columns */
export type personDeviceAppPrivileges_max_fields = {
  __typename?: 'personDeviceAppPrivileges_max_fields';
  deviceID?: string;
  personID?: string;
};

/** order by max() on columns of table "qx.PersonDeviceAppPrivileges" */
export type personDeviceAppPrivileges_max_order_by = {
  deviceID?: order_by;
  personID?: order_by;
};

/** aggregate min on columns */
export type personDeviceAppPrivileges_min_fields = {
  __typename?: 'personDeviceAppPrivileges_min_fields';
  deviceID?: string;
  personID?: string;
};

/** order by min() on columns of table "qx.PersonDeviceAppPrivileges" */
export type personDeviceAppPrivileges_min_order_by = {
  deviceID?: order_by;
  personID?: order_by;
};

/** response of any mutation on the table "qx.PersonDeviceAppPrivileges" */
export type personDeviceAppPrivileges_mutation_response = {
  __typename?: 'personDeviceAppPrivileges_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<personDeviceAppPrivileges>;
};

/** on_conflict condition type for table "qx.PersonDeviceAppPrivileges" */
export type personDeviceAppPrivileges_on_conflict = {
  constraint: personDeviceAppPrivileges_constraint;
  update_columns?: Array<personDeviceAppPrivileges_update_column>;
  where?: personDeviceAppPrivileges_bool_exp;
};

/** Ordering options when selecting data from "qx.PersonDeviceAppPrivileges". */
export type personDeviceAppPrivileges_order_by = {
  canConfig?: order_by;
  canOperate?: order_by;
  canView?: order_by;
  device?: qx_Device_order_by;
  deviceID?: order_by;
  person?: qx_Person_order_by;
  personID?: order_by;
};

/** primary key columns input for table: qx.PersonDeviceAppPrivileges */
export type personDeviceAppPrivileges_pk_columns_input = {
  deviceID: string;
  personID: string;
};

/** select columns of table "qx.PersonDeviceAppPrivileges" */
export enum personDeviceAppPrivileges_select_column {
  /** column name */
  canConfig = 'canConfig',
  /** column name */
  canOperate = 'canOperate',
  /** column name */
  canView = 'canView',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  personID = 'personID'
}

/** select "personDeviceAppPrivileges_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.PersonDeviceAppPrivileges" */
export enum personDeviceAppPrivileges_select_column_personDeviceAppPrivileges_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  canConfig = 'canConfig',
  /** column name */
  canOperate = 'canOperate',
  /** column name */
  canView = 'canView'
}

/** select "personDeviceAppPrivileges_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.PersonDeviceAppPrivileges" */
export enum personDeviceAppPrivileges_select_column_personDeviceAppPrivileges_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  canConfig = 'canConfig',
  /** column name */
  canOperate = 'canOperate',
  /** column name */
  canView = 'canView'
}

/** input type for updating data in table "qx.PersonDeviceAppPrivileges" */
export type personDeviceAppPrivileges_set_input = {
  canConfig?: boolean;
  canOperate?: boolean;
  canView?: boolean;
  deviceID?: string;
  personID?: string;
};

/** Streaming cursor of the table "personDeviceAppPrivileges" */
export type personDeviceAppPrivileges_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: personDeviceAppPrivileges_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type personDeviceAppPrivileges_stream_cursor_value_input = {
  canConfig?: boolean;
  canOperate?: boolean;
  canView?: boolean;
  deviceID?: string;
  personID?: string;
};

/** update columns of table "qx.PersonDeviceAppPrivileges" */
export enum personDeviceAppPrivileges_update_column {
  /** column name */
  canConfig = 'canConfig',
  /** column name */
  canOperate = 'canOperate',
  /** column name */
  canView = 'canView',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  personID = 'personID'
}

export type personDeviceAppPrivileges_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: personDeviceAppPrivileges_set_input;
  /** filter the rows which have to be updated */
  where: personDeviceAppPrivileges_bool_exp;
};

/** columns and relationships of "qx.PersonDoorAppPrivileges" */
export type personDoorAppPrivileges = {
  __typename?: 'personDoorAppPrivileges';
  canConfig?: boolean;
  canOperate?: boolean;
  canView?: boolean;
  /** An object relationship */
  door: qx_Door;
  doorID: string;
  /** An object relationship */
  person: qx_Person;
  personID: string;
};

/** aggregated selection of "qx.PersonDoorAppPrivileges" */
export type personDoorAppPrivileges_aggregate = {
  __typename?: 'personDoorAppPrivileges_aggregate';
  aggregate?: personDoorAppPrivileges_aggregate_fields;
  nodes: Array<personDoorAppPrivileges>;
};

export type personDoorAppPrivileges_aggregate_bool_exp = {
  bool_and?: personDoorAppPrivileges_aggregate_bool_exp_bool_and;
  bool_or?: personDoorAppPrivileges_aggregate_bool_exp_bool_or;
  count?: personDoorAppPrivileges_aggregate_bool_exp_count;
};

export type personDoorAppPrivileges_aggregate_bool_exp_bool_and = {
  arguments: personDoorAppPrivileges_select_column_personDoorAppPrivileges_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: personDoorAppPrivileges_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type personDoorAppPrivileges_aggregate_bool_exp_bool_or = {
  arguments: personDoorAppPrivileges_select_column_personDoorAppPrivileges_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: personDoorAppPrivileges_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type personDoorAppPrivileges_aggregate_bool_exp_count = {
  arguments?: Array<personDoorAppPrivileges_select_column>;
  distinct?: boolean;
  filter?: personDoorAppPrivileges_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.PersonDoorAppPrivileges" */
export type personDoorAppPrivileges_aggregate_fields = {
  __typename?: 'personDoorAppPrivileges_aggregate_fields';
  avg?: personDoorAppPrivileges_avg_fields;
  count: number;
  max?: personDoorAppPrivileges_max_fields;
  min?: personDoorAppPrivileges_min_fields;
  stddev?: personDoorAppPrivileges_stddev_fields;
  stddev_pop?: personDoorAppPrivileges_stddev_pop_fields;
  stddev_samp?: personDoorAppPrivileges_stddev_samp_fields;
  sum?: personDoorAppPrivileges_sum_fields;
  var_pop?: personDoorAppPrivileges_var_pop_fields;
  var_samp?: personDoorAppPrivileges_var_samp_fields;
  variance?: personDoorAppPrivileges_variance_fields;
};


/** aggregate fields of "qx.PersonDoorAppPrivileges" */
export type personDoorAppPrivileges_aggregate_fieldscountArgs = {
  columns?: Array<personDoorAppPrivileges_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.PersonDoorAppPrivileges" */
export type personDoorAppPrivileges_aggregate_order_by = {
  avg?: personDoorAppPrivileges_avg_order_by;
  count?: order_by;
  max?: personDoorAppPrivileges_max_order_by;
  min?: personDoorAppPrivileges_min_order_by;
  stddev?: personDoorAppPrivileges_stddev_order_by;
  stddev_pop?: personDoorAppPrivileges_stddev_pop_order_by;
  stddev_samp?: personDoorAppPrivileges_stddev_samp_order_by;
  sum?: personDoorAppPrivileges_sum_order_by;
  var_pop?: personDoorAppPrivileges_var_pop_order_by;
  var_samp?: personDoorAppPrivileges_var_samp_order_by;
  variance?: personDoorAppPrivileges_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.PersonDoorAppPrivileges" */
export type personDoorAppPrivileges_arr_rel_insert_input = {
  data: Array<personDoorAppPrivileges_insert_input>;
  /** upsert condition */
  on_conflict?: personDoorAppPrivileges_on_conflict;
};

/** aggregate avg on columns */
export type personDoorAppPrivileges_avg_fields = {
  __typename?: 'personDoorAppPrivileges_avg_fields';
  doorID?: number;
};

/** order by avg() on columns of table "qx.PersonDoorAppPrivileges" */
export type personDoorAppPrivileges_avg_order_by = {
  doorID?: order_by;
};

/** Boolean expression to filter rows from the table "qx.PersonDoorAppPrivileges". All fields are combined with a logical 'AND'. */
export type personDoorAppPrivileges_bool_exp = {
  _and?: Array<personDoorAppPrivileges_bool_exp>;
  _not?: personDoorAppPrivileges_bool_exp;
  _or?: Array<personDoorAppPrivileges_bool_exp>;
  canConfig?: Boolean_comparison_exp;
  canOperate?: Boolean_comparison_exp;
  canView?: Boolean_comparison_exp;
  door?: qx_Door_bool_exp;
  doorID?: bigint_comparison_exp;
  person?: qx_Person_bool_exp;
  personID?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.PersonDoorAppPrivileges" */
export enum personDoorAppPrivileges_constraint {
  /** unique or primary key constraint on columns "doorID", "personID" */
  PersonDoorAppPrivileges_pkey = 'PersonDoorAppPrivileges_pkey',
  /** unique or primary key constraint on columns "doorID", "personID" */
  idx_person_unique_door_person = 'idx_person_unique_door_person'
}

/** input type for incrementing numeric columns in table "qx.PersonDoorAppPrivileges" */
export type personDoorAppPrivileges_inc_input = {
  doorID?: string;
};

/** input type for inserting data into table "qx.PersonDoorAppPrivileges" */
export type personDoorAppPrivileges_insert_input = {
  canConfig?: boolean;
  canOperate?: boolean;
  canView?: boolean;
  door?: qx_Door_obj_rel_insert_input;
  doorID?: string;
  person?: qx_Person_obj_rel_insert_input;
  personID?: string;
};

/** aggregate max on columns */
export type personDoorAppPrivileges_max_fields = {
  __typename?: 'personDoorAppPrivileges_max_fields';
  doorID?: string;
  personID?: string;
};

/** order by max() on columns of table "qx.PersonDoorAppPrivileges" */
export type personDoorAppPrivileges_max_order_by = {
  doorID?: order_by;
  personID?: order_by;
};

/** aggregate min on columns */
export type personDoorAppPrivileges_min_fields = {
  __typename?: 'personDoorAppPrivileges_min_fields';
  doorID?: string;
  personID?: string;
};

/** order by min() on columns of table "qx.PersonDoorAppPrivileges" */
export type personDoorAppPrivileges_min_order_by = {
  doorID?: order_by;
  personID?: order_by;
};

/** response of any mutation on the table "qx.PersonDoorAppPrivileges" */
export type personDoorAppPrivileges_mutation_response = {
  __typename?: 'personDoorAppPrivileges_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<personDoorAppPrivileges>;
};

/** on_conflict condition type for table "qx.PersonDoorAppPrivileges" */
export type personDoorAppPrivileges_on_conflict = {
  constraint: personDoorAppPrivileges_constraint;
  update_columns?: Array<personDoorAppPrivileges_update_column>;
  where?: personDoorAppPrivileges_bool_exp;
};

/** Ordering options when selecting data from "qx.PersonDoorAppPrivileges". */
export type personDoorAppPrivileges_order_by = {
  canConfig?: order_by;
  canOperate?: order_by;
  canView?: order_by;
  door?: qx_Door_order_by;
  doorID?: order_by;
  person?: qx_Person_order_by;
  personID?: order_by;
};

/** primary key columns input for table: qx.PersonDoorAppPrivileges */
export type personDoorAppPrivileges_pk_columns_input = {
  doorID: string;
  personID: string;
};

/** select columns of table "qx.PersonDoorAppPrivileges" */
export enum personDoorAppPrivileges_select_column {
  /** column name */
  canConfig = 'canConfig',
  /** column name */
  canOperate = 'canOperate',
  /** column name */
  canView = 'canView',
  /** column name */
  doorID = 'doorID',
  /** column name */
  personID = 'personID'
}

/** select "personDoorAppPrivileges_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.PersonDoorAppPrivileges" */
export enum personDoorAppPrivileges_select_column_personDoorAppPrivileges_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  canConfig = 'canConfig',
  /** column name */
  canOperate = 'canOperate',
  /** column name */
  canView = 'canView'
}

/** select "personDoorAppPrivileges_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.PersonDoorAppPrivileges" */
export enum personDoorAppPrivileges_select_column_personDoorAppPrivileges_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  canConfig = 'canConfig',
  /** column name */
  canOperate = 'canOperate',
  /** column name */
  canView = 'canView'
}

/** input type for updating data in table "qx.PersonDoorAppPrivileges" */
export type personDoorAppPrivileges_set_input = {
  canConfig?: boolean;
  canOperate?: boolean;
  canView?: boolean;
  doorID?: string;
  personID?: string;
};

/** aggregate stddev on columns */
export type personDoorAppPrivileges_stddev_fields = {
  __typename?: 'personDoorAppPrivileges_stddev_fields';
  doorID?: number;
};

/** order by stddev() on columns of table "qx.PersonDoorAppPrivileges" */
export type personDoorAppPrivileges_stddev_order_by = {
  doorID?: order_by;
};

/** aggregate stddev_pop on columns */
export type personDoorAppPrivileges_stddev_pop_fields = {
  __typename?: 'personDoorAppPrivileges_stddev_pop_fields';
  doorID?: number;
};

/** order by stddev_pop() on columns of table "qx.PersonDoorAppPrivileges" */
export type personDoorAppPrivileges_stddev_pop_order_by = {
  doorID?: order_by;
};

/** aggregate stddev_samp on columns */
export type personDoorAppPrivileges_stddev_samp_fields = {
  __typename?: 'personDoorAppPrivileges_stddev_samp_fields';
  doorID?: number;
};

/** order by stddev_samp() on columns of table "qx.PersonDoorAppPrivileges" */
export type personDoorAppPrivileges_stddev_samp_order_by = {
  doorID?: order_by;
};

/** Streaming cursor of the table "personDoorAppPrivileges" */
export type personDoorAppPrivileges_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: personDoorAppPrivileges_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type personDoorAppPrivileges_stream_cursor_value_input = {
  canConfig?: boolean;
  canOperate?: boolean;
  canView?: boolean;
  doorID?: string;
  personID?: string;
};

/** aggregate sum on columns */
export type personDoorAppPrivileges_sum_fields = {
  __typename?: 'personDoorAppPrivileges_sum_fields';
  doorID?: string;
};

/** order by sum() on columns of table "qx.PersonDoorAppPrivileges" */
export type personDoorAppPrivileges_sum_order_by = {
  doorID?: order_by;
};

/** update columns of table "qx.PersonDoorAppPrivileges" */
export enum personDoorAppPrivileges_update_column {
  /** column name */
  canConfig = 'canConfig',
  /** column name */
  canOperate = 'canOperate',
  /** column name */
  canView = 'canView',
  /** column name */
  doorID = 'doorID',
  /** column name */
  personID = 'personID'
}

export type personDoorAppPrivileges_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: personDoorAppPrivileges_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: personDoorAppPrivileges_set_input;
  /** filter the rows which have to be updated */
  where: personDoorAppPrivileges_bool_exp;
};

/** aggregate var_pop on columns */
export type personDoorAppPrivileges_var_pop_fields = {
  __typename?: 'personDoorAppPrivileges_var_pop_fields';
  doorID?: number;
};

/** order by var_pop() on columns of table "qx.PersonDoorAppPrivileges" */
export type personDoorAppPrivileges_var_pop_order_by = {
  doorID?: order_by;
};

/** aggregate var_samp on columns */
export type personDoorAppPrivileges_var_samp_fields = {
  __typename?: 'personDoorAppPrivileges_var_samp_fields';
  doorID?: number;
};

/** order by var_samp() on columns of table "qx.PersonDoorAppPrivileges" */
export type personDoorAppPrivileges_var_samp_order_by = {
  doorID?: order_by;
};

/** aggregate variance on columns */
export type personDoorAppPrivileges_variance_fields = {
  __typename?: 'personDoorAppPrivileges_variance_fields';
  doorID?: number;
};

/** order by variance() on columns of table "qx.PersonDoorAppPrivileges" */
export type personDoorAppPrivileges_variance_order_by = {
  doorID?: order_by;
};

/** columns and relationships of "qx.PersonIntrusionPartitionAppPrivileges" */
export type personIntrusionPartitionAppPrivileges = {
  __typename?: 'personIntrusionPartitionAppPrivileges';
  canConfig?: boolean;
  canOperate?: boolean;
  canView?: boolean;
  /** An object relationship */
  partition: IntrusionPartition;
  partitionID: string;
  /** An object relationship */
  person: qx_Person;
  personID: string;
};

/** aggregated selection of "qx.PersonIntrusionPartitionAppPrivileges" */
export type personIntrusionPartitionAppPrivileges_aggregate = {
  __typename?: 'personIntrusionPartitionAppPrivileges_aggregate';
  aggregate?: personIntrusionPartitionAppPrivileges_aggregate_fields;
  nodes: Array<personIntrusionPartitionAppPrivileges>;
};

export type personIntrusionPartitionAppPrivileges_aggregate_bool_exp = {
  bool_and?: personIntrusionPartitionAppPrivileges_aggregate_bool_exp_bool_and;
  bool_or?: personIntrusionPartitionAppPrivileges_aggregate_bool_exp_bool_or;
  count?: personIntrusionPartitionAppPrivileges_aggregate_bool_exp_count;
};

export type personIntrusionPartitionAppPrivileges_aggregate_bool_exp_bool_and = {
  arguments: personIntrusionPartitionAppPrivileges_select_column_personIntrusionPartitionAppPrivileges_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: personIntrusionPartitionAppPrivileges_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type personIntrusionPartitionAppPrivileges_aggregate_bool_exp_bool_or = {
  arguments: personIntrusionPartitionAppPrivileges_select_column_personIntrusionPartitionAppPrivileges_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: personIntrusionPartitionAppPrivileges_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type personIntrusionPartitionAppPrivileges_aggregate_bool_exp_count = {
  arguments?: Array<personIntrusionPartitionAppPrivileges_select_column>;
  distinct?: boolean;
  filter?: personIntrusionPartitionAppPrivileges_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.PersonIntrusionPartitionAppPrivileges" */
export type personIntrusionPartitionAppPrivileges_aggregate_fields = {
  __typename?: 'personIntrusionPartitionAppPrivileges_aggregate_fields';
  count: number;
  max?: personIntrusionPartitionAppPrivileges_max_fields;
  min?: personIntrusionPartitionAppPrivileges_min_fields;
};


/** aggregate fields of "qx.PersonIntrusionPartitionAppPrivileges" */
export type personIntrusionPartitionAppPrivileges_aggregate_fieldscountArgs = {
  columns?: Array<personIntrusionPartitionAppPrivileges_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.PersonIntrusionPartitionAppPrivileges" */
export type personIntrusionPartitionAppPrivileges_aggregate_order_by = {
  count?: order_by;
  max?: personIntrusionPartitionAppPrivileges_max_order_by;
  min?: personIntrusionPartitionAppPrivileges_min_order_by;
};

/** input type for inserting array relation for remote table "qx.PersonIntrusionPartitionAppPrivileges" */
export type personIntrusionPartitionAppPrivileges_arr_rel_insert_input = {
  data: Array<personIntrusionPartitionAppPrivileges_insert_input>;
  /** upsert condition */
  on_conflict?: personIntrusionPartitionAppPrivileges_on_conflict;
};

/** Boolean expression to filter rows from the table "qx.PersonIntrusionPartitionAppPrivileges". All fields are combined with a logical 'AND'. */
export type personIntrusionPartitionAppPrivileges_bool_exp = {
  _and?: Array<personIntrusionPartitionAppPrivileges_bool_exp>;
  _not?: personIntrusionPartitionAppPrivileges_bool_exp;
  _or?: Array<personIntrusionPartitionAppPrivileges_bool_exp>;
  canConfig?: Boolean_comparison_exp;
  canOperate?: Boolean_comparison_exp;
  canView?: Boolean_comparison_exp;
  partition?: IntrusionPartition_bool_exp;
  partitionID?: String_comparison_exp;
  person?: qx_Person_bool_exp;
  personID?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.PersonIntrusionPartitionAppPrivileges" */
export enum personIntrusionPartitionAppPrivileges_constraint {
  /** unique or primary key constraint on columns "partitionID", "personID" */
  PersonIntrusionPartitionAppPrivileges_pkey = 'PersonIntrusionPartitionAppPrivileges_pkey'
}

/** input type for inserting data into table "qx.PersonIntrusionPartitionAppPrivileges" */
export type personIntrusionPartitionAppPrivileges_insert_input = {
  canConfig?: boolean;
  canOperate?: boolean;
  canView?: boolean;
  partition?: IntrusionPartition_obj_rel_insert_input;
  partitionID?: string;
  person?: qx_Person_obj_rel_insert_input;
  personID?: string;
};

/** aggregate max on columns */
export type personIntrusionPartitionAppPrivileges_max_fields = {
  __typename?: 'personIntrusionPartitionAppPrivileges_max_fields';
  partitionID?: string;
  personID?: string;
};

/** order by max() on columns of table "qx.PersonIntrusionPartitionAppPrivileges" */
export type personIntrusionPartitionAppPrivileges_max_order_by = {
  partitionID?: order_by;
  personID?: order_by;
};

/** aggregate min on columns */
export type personIntrusionPartitionAppPrivileges_min_fields = {
  __typename?: 'personIntrusionPartitionAppPrivileges_min_fields';
  partitionID?: string;
  personID?: string;
};

/** order by min() on columns of table "qx.PersonIntrusionPartitionAppPrivileges" */
export type personIntrusionPartitionAppPrivileges_min_order_by = {
  partitionID?: order_by;
  personID?: order_by;
};

/** response of any mutation on the table "qx.PersonIntrusionPartitionAppPrivileges" */
export type personIntrusionPartitionAppPrivileges_mutation_response = {
  __typename?: 'personIntrusionPartitionAppPrivileges_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<personIntrusionPartitionAppPrivileges>;
};

/** on_conflict condition type for table "qx.PersonIntrusionPartitionAppPrivileges" */
export type personIntrusionPartitionAppPrivileges_on_conflict = {
  constraint: personIntrusionPartitionAppPrivileges_constraint;
  update_columns?: Array<personIntrusionPartitionAppPrivileges_update_column>;
  where?: personIntrusionPartitionAppPrivileges_bool_exp;
};

/** Ordering options when selecting data from "qx.PersonIntrusionPartitionAppPrivileges". */
export type personIntrusionPartitionAppPrivileges_order_by = {
  canConfig?: order_by;
  canOperate?: order_by;
  canView?: order_by;
  partition?: IntrusionPartition_order_by;
  partitionID?: order_by;
  person?: qx_Person_order_by;
  personID?: order_by;
};

/** primary key columns input for table: qx.PersonIntrusionPartitionAppPrivileges */
export type personIntrusionPartitionAppPrivileges_pk_columns_input = {
  partitionID: string;
  personID: string;
};

/** select columns of table "qx.PersonIntrusionPartitionAppPrivileges" */
export enum personIntrusionPartitionAppPrivileges_select_column {
  /** column name */
  canConfig = 'canConfig',
  /** column name */
  canOperate = 'canOperate',
  /** column name */
  canView = 'canView',
  /** column name */
  partitionID = 'partitionID',
  /** column name */
  personID = 'personID'
}

/** select "personIntrusionPartitionAppPrivileges_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.PersonIntrusionPartitionAppPrivileges" */
export enum personIntrusionPartitionAppPrivileges_select_column_personIntrusionPartitionAppPrivileges_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  canConfig = 'canConfig',
  /** column name */
  canOperate = 'canOperate',
  /** column name */
  canView = 'canView'
}

/** select "personIntrusionPartitionAppPrivileges_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.PersonIntrusionPartitionAppPrivileges" */
export enum personIntrusionPartitionAppPrivileges_select_column_personIntrusionPartitionAppPrivileges_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  canConfig = 'canConfig',
  /** column name */
  canOperate = 'canOperate',
  /** column name */
  canView = 'canView'
}

/** input type for updating data in table "qx.PersonIntrusionPartitionAppPrivileges" */
export type personIntrusionPartitionAppPrivileges_set_input = {
  canConfig?: boolean;
  canOperate?: boolean;
  canView?: boolean;
  partitionID?: string;
  personID?: string;
};

/** Streaming cursor of the table "personIntrusionPartitionAppPrivileges" */
export type personIntrusionPartitionAppPrivileges_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: personIntrusionPartitionAppPrivileges_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type personIntrusionPartitionAppPrivileges_stream_cursor_value_input = {
  canConfig?: boolean;
  canOperate?: boolean;
  canView?: boolean;
  partitionID?: string;
  personID?: string;
};

/** update columns of table "qx.PersonIntrusionPartitionAppPrivileges" */
export enum personIntrusionPartitionAppPrivileges_update_column {
  /** column name */
  canConfig = 'canConfig',
  /** column name */
  canOperate = 'canOperate',
  /** column name */
  canView = 'canView',
  /** column name */
  partitionID = 'partitionID',
  /** column name */
  personID = 'personID'
}

export type personIntrusionPartitionAppPrivileges_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: personIntrusionPartitionAppPrivileges_set_input;
  /** filter the rows which have to be updated */
  where: personIntrusionPartitionAppPrivileges_bool_exp;
};

/** columns and relationships of "qx.PersonPlaceAppPrivileges" */
export type personPlaceAppPrivileges = {
  __typename?: 'personPlaceAppPrivileges';
  AIAssistant?: boolean;
  AIBilling?: boolean;
  AccessReports?: boolean;
  Audit?: boolean;
  BandwidthConfig?: boolean;
  CameraConfig?: boolean;
  CameraOperator?: boolean;
  CameraView?: boolean;
  ClipManagement?: boolean;
  DeviceConfig?: boolean;
  DeviceOperator?: boolean;
  DeviceView?: boolean;
  DoorConfig?: boolean;
  DoorOperator?: boolean;
  DoorView?: boolean;
  GatewayConfig?: boolean;
  GatewayView?: boolean;
  IntrusionConfig?: boolean;
  IntrusionOperator?: boolean;
  IntrusionView?: boolean;
  LiveEvents?: boolean;
  LiveVideo?: boolean;
  LockDown?: boolean;
  PeopleConfig?: boolean;
  PeopleView?: boolean;
  PlaceConfig?: boolean;
  RecordedVideo?: boolean;
  RoleConfig?: boolean;
  RulesConfig?: boolean;
  RulesView?: boolean;
  ScheduleConfig?: boolean;
  Search?: boolean;
  Snapshots?: boolean;
  Unknown?: boolean;
  UserCreation?: boolean;
  View?: boolean;
  ViewConfig?: boolean;
  /** An object relationship */
  person: qx_Person;
  personID: string;
  /** An object relationship */
  place: qx_Place;
  placeID: string;
};

/** aggregated selection of "qx.PersonPlaceAppPrivileges" */
export type personPlaceAppPrivileges_aggregate = {
  __typename?: 'personPlaceAppPrivileges_aggregate';
  aggregate?: personPlaceAppPrivileges_aggregate_fields;
  nodes: Array<personPlaceAppPrivileges>;
};

export type personPlaceAppPrivileges_aggregate_bool_exp = {
  bool_and?: personPlaceAppPrivileges_aggregate_bool_exp_bool_and;
  bool_or?: personPlaceAppPrivileges_aggregate_bool_exp_bool_or;
  count?: personPlaceAppPrivileges_aggregate_bool_exp_count;
};

export type personPlaceAppPrivileges_aggregate_bool_exp_bool_and = {
  arguments: personPlaceAppPrivileges_select_column_personPlaceAppPrivileges_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: personPlaceAppPrivileges_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type personPlaceAppPrivileges_aggregate_bool_exp_bool_or = {
  arguments: personPlaceAppPrivileges_select_column_personPlaceAppPrivileges_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: personPlaceAppPrivileges_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type personPlaceAppPrivileges_aggregate_bool_exp_count = {
  arguments?: Array<personPlaceAppPrivileges_select_column>;
  distinct?: boolean;
  filter?: personPlaceAppPrivileges_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.PersonPlaceAppPrivileges" */
export type personPlaceAppPrivileges_aggregate_fields = {
  __typename?: 'personPlaceAppPrivileges_aggregate_fields';
  count: number;
  max?: personPlaceAppPrivileges_max_fields;
  min?: personPlaceAppPrivileges_min_fields;
};


/** aggregate fields of "qx.PersonPlaceAppPrivileges" */
export type personPlaceAppPrivileges_aggregate_fieldscountArgs = {
  columns?: Array<personPlaceAppPrivileges_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.PersonPlaceAppPrivileges" */
export type personPlaceAppPrivileges_aggregate_order_by = {
  count?: order_by;
  max?: personPlaceAppPrivileges_max_order_by;
  min?: personPlaceAppPrivileges_min_order_by;
};

/** input type for inserting array relation for remote table "qx.PersonPlaceAppPrivileges" */
export type personPlaceAppPrivileges_arr_rel_insert_input = {
  data: Array<personPlaceAppPrivileges_insert_input>;
  /** upsert condition */
  on_conflict?: personPlaceAppPrivileges_on_conflict;
};

/** Boolean expression to filter rows from the table "qx.PersonPlaceAppPrivileges". All fields are combined with a logical 'AND'. */
export type personPlaceAppPrivileges_bool_exp = {
  AIAssistant?: Boolean_comparison_exp;
  AIBilling?: Boolean_comparison_exp;
  AccessReports?: Boolean_comparison_exp;
  Audit?: Boolean_comparison_exp;
  BandwidthConfig?: Boolean_comparison_exp;
  CameraConfig?: Boolean_comparison_exp;
  CameraOperator?: Boolean_comparison_exp;
  CameraView?: Boolean_comparison_exp;
  ClipManagement?: Boolean_comparison_exp;
  DeviceConfig?: Boolean_comparison_exp;
  DeviceOperator?: Boolean_comparison_exp;
  DeviceView?: Boolean_comparison_exp;
  DoorConfig?: Boolean_comparison_exp;
  DoorOperator?: Boolean_comparison_exp;
  DoorView?: Boolean_comparison_exp;
  GatewayConfig?: Boolean_comparison_exp;
  GatewayView?: Boolean_comparison_exp;
  IntrusionConfig?: Boolean_comparison_exp;
  IntrusionOperator?: Boolean_comparison_exp;
  IntrusionView?: Boolean_comparison_exp;
  LiveEvents?: Boolean_comparison_exp;
  LiveVideo?: Boolean_comparison_exp;
  LockDown?: Boolean_comparison_exp;
  PeopleConfig?: Boolean_comparison_exp;
  PeopleView?: Boolean_comparison_exp;
  PlaceConfig?: Boolean_comparison_exp;
  RecordedVideo?: Boolean_comparison_exp;
  RoleConfig?: Boolean_comparison_exp;
  RulesConfig?: Boolean_comparison_exp;
  RulesView?: Boolean_comparison_exp;
  ScheduleConfig?: Boolean_comparison_exp;
  Search?: Boolean_comparison_exp;
  Snapshots?: Boolean_comparison_exp;
  Unknown?: Boolean_comparison_exp;
  UserCreation?: Boolean_comparison_exp;
  View?: Boolean_comparison_exp;
  ViewConfig?: Boolean_comparison_exp;
  _and?: Array<personPlaceAppPrivileges_bool_exp>;
  _not?: personPlaceAppPrivileges_bool_exp;
  _or?: Array<personPlaceAppPrivileges_bool_exp>;
  person?: qx_Person_bool_exp;
  personID?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.PersonPlaceAppPrivileges" */
export enum personPlaceAppPrivileges_constraint {
  /** unique or primary key constraint on columns "placeID", "personID" */
  PersonPlaceAppPrivileges_pkey = 'PersonPlaceAppPrivileges_pkey',
  /** unique or primary key constraint on columns "placeID", "personID" */
  idx_person_place_unique_place_person = 'idx_person_place_unique_place_person'
}

/** input type for inserting data into table "qx.PersonPlaceAppPrivileges" */
export type personPlaceAppPrivileges_insert_input = {
  AIAssistant?: boolean;
  AIBilling?: boolean;
  AccessReports?: boolean;
  Audit?: boolean;
  BandwidthConfig?: boolean;
  CameraConfig?: boolean;
  CameraOperator?: boolean;
  CameraView?: boolean;
  ClipManagement?: boolean;
  DeviceConfig?: boolean;
  DeviceOperator?: boolean;
  DeviceView?: boolean;
  DoorConfig?: boolean;
  DoorOperator?: boolean;
  DoorView?: boolean;
  GatewayConfig?: boolean;
  GatewayView?: boolean;
  IntrusionConfig?: boolean;
  IntrusionOperator?: boolean;
  IntrusionView?: boolean;
  LiveEvents?: boolean;
  LiveVideo?: boolean;
  LockDown?: boolean;
  PeopleConfig?: boolean;
  PeopleView?: boolean;
  PlaceConfig?: boolean;
  RecordedVideo?: boolean;
  RoleConfig?: boolean;
  RulesConfig?: boolean;
  RulesView?: boolean;
  ScheduleConfig?: boolean;
  Search?: boolean;
  Snapshots?: boolean;
  Unknown?: boolean;
  UserCreation?: boolean;
  View?: boolean;
  ViewConfig?: boolean;
  person?: qx_Person_obj_rel_insert_input;
  personID?: string;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
};

/** aggregate max on columns */
export type personPlaceAppPrivileges_max_fields = {
  __typename?: 'personPlaceAppPrivileges_max_fields';
  personID?: string;
  placeID?: string;
};

/** order by max() on columns of table "qx.PersonPlaceAppPrivileges" */
export type personPlaceAppPrivileges_max_order_by = {
  personID?: order_by;
  placeID?: order_by;
};

/** aggregate min on columns */
export type personPlaceAppPrivileges_min_fields = {
  __typename?: 'personPlaceAppPrivileges_min_fields';
  personID?: string;
  placeID?: string;
};

/** order by min() on columns of table "qx.PersonPlaceAppPrivileges" */
export type personPlaceAppPrivileges_min_order_by = {
  personID?: order_by;
  placeID?: order_by;
};

/** response of any mutation on the table "qx.PersonPlaceAppPrivileges" */
export type personPlaceAppPrivileges_mutation_response = {
  __typename?: 'personPlaceAppPrivileges_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<personPlaceAppPrivileges>;
};

/** on_conflict condition type for table "qx.PersonPlaceAppPrivileges" */
export type personPlaceAppPrivileges_on_conflict = {
  constraint: personPlaceAppPrivileges_constraint;
  update_columns?: Array<personPlaceAppPrivileges_update_column>;
  where?: personPlaceAppPrivileges_bool_exp;
};

/** Ordering options when selecting data from "qx.PersonPlaceAppPrivileges". */
export type personPlaceAppPrivileges_order_by = {
  AIAssistant?: order_by;
  AIBilling?: order_by;
  AccessReports?: order_by;
  Audit?: order_by;
  BandwidthConfig?: order_by;
  CameraConfig?: order_by;
  CameraOperator?: order_by;
  CameraView?: order_by;
  ClipManagement?: order_by;
  DeviceConfig?: order_by;
  DeviceOperator?: order_by;
  DeviceView?: order_by;
  DoorConfig?: order_by;
  DoorOperator?: order_by;
  DoorView?: order_by;
  GatewayConfig?: order_by;
  GatewayView?: order_by;
  IntrusionConfig?: order_by;
  IntrusionOperator?: order_by;
  IntrusionView?: order_by;
  LiveEvents?: order_by;
  LiveVideo?: order_by;
  LockDown?: order_by;
  PeopleConfig?: order_by;
  PeopleView?: order_by;
  PlaceConfig?: order_by;
  RecordedVideo?: order_by;
  RoleConfig?: order_by;
  RulesConfig?: order_by;
  RulesView?: order_by;
  ScheduleConfig?: order_by;
  Search?: order_by;
  Snapshots?: order_by;
  Unknown?: order_by;
  UserCreation?: order_by;
  View?: order_by;
  ViewConfig?: order_by;
  person?: qx_Person_order_by;
  personID?: order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
};

/** primary key columns input for table: qx.PersonPlaceAppPrivileges */
export type personPlaceAppPrivileges_pk_columns_input = {
  personID: string;
  placeID: string;
};

/** select columns of table "qx.PersonPlaceAppPrivileges" */
export enum personPlaceAppPrivileges_select_column {
  /** column name */
  AIAssistant = 'AIAssistant',
  /** column name */
  AIBilling = 'AIBilling',
  /** column name */
  AccessReports = 'AccessReports',
  /** column name */
  Audit = 'Audit',
  /** column name */
  BandwidthConfig = 'BandwidthConfig',
  /** column name */
  CameraConfig = 'CameraConfig',
  /** column name */
  CameraOperator = 'CameraOperator',
  /** column name */
  CameraView = 'CameraView',
  /** column name */
  ClipManagement = 'ClipManagement',
  /** column name */
  DeviceConfig = 'DeviceConfig',
  /** column name */
  DeviceOperator = 'DeviceOperator',
  /** column name */
  DeviceView = 'DeviceView',
  /** column name */
  DoorConfig = 'DoorConfig',
  /** column name */
  DoorOperator = 'DoorOperator',
  /** column name */
  DoorView = 'DoorView',
  /** column name */
  GatewayConfig = 'GatewayConfig',
  /** column name */
  GatewayView = 'GatewayView',
  /** column name */
  IntrusionConfig = 'IntrusionConfig',
  /** column name */
  IntrusionOperator = 'IntrusionOperator',
  /** column name */
  IntrusionView = 'IntrusionView',
  /** column name */
  LiveEvents = 'LiveEvents',
  /** column name */
  LiveVideo = 'LiveVideo',
  /** column name */
  LockDown = 'LockDown',
  /** column name */
  PeopleConfig = 'PeopleConfig',
  /** column name */
  PeopleView = 'PeopleView',
  /** column name */
  PlaceConfig = 'PlaceConfig',
  /** column name */
  RecordedVideo = 'RecordedVideo',
  /** column name */
  RoleConfig = 'RoleConfig',
  /** column name */
  RulesConfig = 'RulesConfig',
  /** column name */
  RulesView = 'RulesView',
  /** column name */
  ScheduleConfig = 'ScheduleConfig',
  /** column name */
  Search = 'Search',
  /** column name */
  Snapshots = 'Snapshots',
  /** column name */
  Unknown = 'Unknown',
  /** column name */
  UserCreation = 'UserCreation',
  /** column name */
  View = 'View',
  /** column name */
  ViewConfig = 'ViewConfig',
  /** column name */
  personID = 'personID',
  /** column name */
  placeID = 'placeID'
}

/** select "personPlaceAppPrivileges_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.PersonPlaceAppPrivileges" */
export enum personPlaceAppPrivileges_select_column_personPlaceAppPrivileges_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  AIAssistant = 'AIAssistant',
  /** column name */
  AIBilling = 'AIBilling',
  /** column name */
  AccessReports = 'AccessReports',
  /** column name */
  Audit = 'Audit',
  /** column name */
  BandwidthConfig = 'BandwidthConfig',
  /** column name */
  CameraConfig = 'CameraConfig',
  /** column name */
  CameraOperator = 'CameraOperator',
  /** column name */
  CameraView = 'CameraView',
  /** column name */
  ClipManagement = 'ClipManagement',
  /** column name */
  DeviceConfig = 'DeviceConfig',
  /** column name */
  DeviceOperator = 'DeviceOperator',
  /** column name */
  DeviceView = 'DeviceView',
  /** column name */
  DoorConfig = 'DoorConfig',
  /** column name */
  DoorOperator = 'DoorOperator',
  /** column name */
  DoorView = 'DoorView',
  /** column name */
  GatewayConfig = 'GatewayConfig',
  /** column name */
  GatewayView = 'GatewayView',
  /** column name */
  IntrusionConfig = 'IntrusionConfig',
  /** column name */
  IntrusionOperator = 'IntrusionOperator',
  /** column name */
  IntrusionView = 'IntrusionView',
  /** column name */
  LiveEvents = 'LiveEvents',
  /** column name */
  LiveVideo = 'LiveVideo',
  /** column name */
  LockDown = 'LockDown',
  /** column name */
  PeopleConfig = 'PeopleConfig',
  /** column name */
  PeopleView = 'PeopleView',
  /** column name */
  PlaceConfig = 'PlaceConfig',
  /** column name */
  RecordedVideo = 'RecordedVideo',
  /** column name */
  RoleConfig = 'RoleConfig',
  /** column name */
  RulesConfig = 'RulesConfig',
  /** column name */
  RulesView = 'RulesView',
  /** column name */
  ScheduleConfig = 'ScheduleConfig',
  /** column name */
  Search = 'Search',
  /** column name */
  Snapshots = 'Snapshots',
  /** column name */
  Unknown = 'Unknown',
  /** column name */
  UserCreation = 'UserCreation',
  /** column name */
  View = 'View',
  /** column name */
  ViewConfig = 'ViewConfig'
}

/** select "personPlaceAppPrivileges_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.PersonPlaceAppPrivileges" */
export enum personPlaceAppPrivileges_select_column_personPlaceAppPrivileges_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  AIAssistant = 'AIAssistant',
  /** column name */
  AIBilling = 'AIBilling',
  /** column name */
  AccessReports = 'AccessReports',
  /** column name */
  Audit = 'Audit',
  /** column name */
  BandwidthConfig = 'BandwidthConfig',
  /** column name */
  CameraConfig = 'CameraConfig',
  /** column name */
  CameraOperator = 'CameraOperator',
  /** column name */
  CameraView = 'CameraView',
  /** column name */
  ClipManagement = 'ClipManagement',
  /** column name */
  DeviceConfig = 'DeviceConfig',
  /** column name */
  DeviceOperator = 'DeviceOperator',
  /** column name */
  DeviceView = 'DeviceView',
  /** column name */
  DoorConfig = 'DoorConfig',
  /** column name */
  DoorOperator = 'DoorOperator',
  /** column name */
  DoorView = 'DoorView',
  /** column name */
  GatewayConfig = 'GatewayConfig',
  /** column name */
  GatewayView = 'GatewayView',
  /** column name */
  IntrusionConfig = 'IntrusionConfig',
  /** column name */
  IntrusionOperator = 'IntrusionOperator',
  /** column name */
  IntrusionView = 'IntrusionView',
  /** column name */
  LiveEvents = 'LiveEvents',
  /** column name */
  LiveVideo = 'LiveVideo',
  /** column name */
  LockDown = 'LockDown',
  /** column name */
  PeopleConfig = 'PeopleConfig',
  /** column name */
  PeopleView = 'PeopleView',
  /** column name */
  PlaceConfig = 'PlaceConfig',
  /** column name */
  RecordedVideo = 'RecordedVideo',
  /** column name */
  RoleConfig = 'RoleConfig',
  /** column name */
  RulesConfig = 'RulesConfig',
  /** column name */
  RulesView = 'RulesView',
  /** column name */
  ScheduleConfig = 'ScheduleConfig',
  /** column name */
  Search = 'Search',
  /** column name */
  Snapshots = 'Snapshots',
  /** column name */
  Unknown = 'Unknown',
  /** column name */
  UserCreation = 'UserCreation',
  /** column name */
  View = 'View',
  /** column name */
  ViewConfig = 'ViewConfig'
}

/** input type for updating data in table "qx.PersonPlaceAppPrivileges" */
export type personPlaceAppPrivileges_set_input = {
  AIAssistant?: boolean;
  AIBilling?: boolean;
  AccessReports?: boolean;
  Audit?: boolean;
  BandwidthConfig?: boolean;
  CameraConfig?: boolean;
  CameraOperator?: boolean;
  CameraView?: boolean;
  ClipManagement?: boolean;
  DeviceConfig?: boolean;
  DeviceOperator?: boolean;
  DeviceView?: boolean;
  DoorConfig?: boolean;
  DoorOperator?: boolean;
  DoorView?: boolean;
  GatewayConfig?: boolean;
  GatewayView?: boolean;
  IntrusionConfig?: boolean;
  IntrusionOperator?: boolean;
  IntrusionView?: boolean;
  LiveEvents?: boolean;
  LiveVideo?: boolean;
  LockDown?: boolean;
  PeopleConfig?: boolean;
  PeopleView?: boolean;
  PlaceConfig?: boolean;
  RecordedVideo?: boolean;
  RoleConfig?: boolean;
  RulesConfig?: boolean;
  RulesView?: boolean;
  ScheduleConfig?: boolean;
  Search?: boolean;
  Snapshots?: boolean;
  Unknown?: boolean;
  UserCreation?: boolean;
  View?: boolean;
  ViewConfig?: boolean;
  personID?: string;
  placeID?: string;
};

/** Streaming cursor of the table "personPlaceAppPrivileges" */
export type personPlaceAppPrivileges_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: personPlaceAppPrivileges_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type personPlaceAppPrivileges_stream_cursor_value_input = {
  AIAssistant?: boolean;
  AIBilling?: boolean;
  AccessReports?: boolean;
  Audit?: boolean;
  BandwidthConfig?: boolean;
  CameraConfig?: boolean;
  CameraOperator?: boolean;
  CameraView?: boolean;
  ClipManagement?: boolean;
  DeviceConfig?: boolean;
  DeviceOperator?: boolean;
  DeviceView?: boolean;
  DoorConfig?: boolean;
  DoorOperator?: boolean;
  DoorView?: boolean;
  GatewayConfig?: boolean;
  GatewayView?: boolean;
  IntrusionConfig?: boolean;
  IntrusionOperator?: boolean;
  IntrusionView?: boolean;
  LiveEvents?: boolean;
  LiveVideo?: boolean;
  LockDown?: boolean;
  PeopleConfig?: boolean;
  PeopleView?: boolean;
  PlaceConfig?: boolean;
  RecordedVideo?: boolean;
  RoleConfig?: boolean;
  RulesConfig?: boolean;
  RulesView?: boolean;
  ScheduleConfig?: boolean;
  Search?: boolean;
  Snapshots?: boolean;
  Unknown?: boolean;
  UserCreation?: boolean;
  View?: boolean;
  ViewConfig?: boolean;
  personID?: string;
  placeID?: string;
};

/** update columns of table "qx.PersonPlaceAppPrivileges" */
export enum personPlaceAppPrivileges_update_column {
  /** column name */
  AIAssistant = 'AIAssistant',
  /** column name */
  AIBilling = 'AIBilling',
  /** column name */
  AccessReports = 'AccessReports',
  /** column name */
  Audit = 'Audit',
  /** column name */
  BandwidthConfig = 'BandwidthConfig',
  /** column name */
  CameraConfig = 'CameraConfig',
  /** column name */
  CameraOperator = 'CameraOperator',
  /** column name */
  CameraView = 'CameraView',
  /** column name */
  ClipManagement = 'ClipManagement',
  /** column name */
  DeviceConfig = 'DeviceConfig',
  /** column name */
  DeviceOperator = 'DeviceOperator',
  /** column name */
  DeviceView = 'DeviceView',
  /** column name */
  DoorConfig = 'DoorConfig',
  /** column name */
  DoorOperator = 'DoorOperator',
  /** column name */
  DoorView = 'DoorView',
  /** column name */
  GatewayConfig = 'GatewayConfig',
  /** column name */
  GatewayView = 'GatewayView',
  /** column name */
  IntrusionConfig = 'IntrusionConfig',
  /** column name */
  IntrusionOperator = 'IntrusionOperator',
  /** column name */
  IntrusionView = 'IntrusionView',
  /** column name */
  LiveEvents = 'LiveEvents',
  /** column name */
  LiveVideo = 'LiveVideo',
  /** column name */
  LockDown = 'LockDown',
  /** column name */
  PeopleConfig = 'PeopleConfig',
  /** column name */
  PeopleView = 'PeopleView',
  /** column name */
  PlaceConfig = 'PlaceConfig',
  /** column name */
  RecordedVideo = 'RecordedVideo',
  /** column name */
  RoleConfig = 'RoleConfig',
  /** column name */
  RulesConfig = 'RulesConfig',
  /** column name */
  RulesView = 'RulesView',
  /** column name */
  ScheduleConfig = 'ScheduleConfig',
  /** column name */
  Search = 'Search',
  /** column name */
  Snapshots = 'Snapshots',
  /** column name */
  Unknown = 'Unknown',
  /** column name */
  UserCreation = 'UserCreation',
  /** column name */
  View = 'View',
  /** column name */
  ViewConfig = 'ViewConfig',
  /** column name */
  personID = 'personID',
  /** column name */
  placeID = 'placeID'
}

export type personPlaceAppPrivileges_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: personPlaceAppPrivileges_set_input;
  /** filter the rows which have to be updated */
  where: personPlaceAppPrivileges_bool_exp;
};

/** audit view tracking historical changes to person-to-group membership assignments */
export type personToGroupAudit = {
  __typename?: 'personToGroupAudit';
  action?: string;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  /** An object relationship */
  group?: qx_Group;
  groupID?: string;
  /** An object relationship */
  person?: qx_Person;
  personID?: string;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  row_data?: any;
  time?: string;
};


/** audit view tracking historical changes to person-to-group membership assignments */
export type personToGroupAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes to person-to-group membership assignments */
export type personToGroupAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.v_PersonToGroupAudit" */
export type personToGroupAudit_aggregate = {
  __typename?: 'personToGroupAudit_aggregate';
  aggregate?: personToGroupAudit_aggregate_fields;
  nodes: Array<personToGroupAudit>;
};

/** aggregate fields of "audit.v_PersonToGroupAudit" */
export type personToGroupAudit_aggregate_fields = {
  __typename?: 'personToGroupAudit_aggregate_fields';
  avg?: personToGroupAudit_avg_fields;
  count: number;
  max?: personToGroupAudit_max_fields;
  min?: personToGroupAudit_min_fields;
  stddev?: personToGroupAudit_stddev_fields;
  stddev_pop?: personToGroupAudit_stddev_pop_fields;
  stddev_samp?: personToGroupAudit_stddev_samp_fields;
  sum?: personToGroupAudit_sum_fields;
  var_pop?: personToGroupAudit_var_pop_fields;
  var_samp?: personToGroupAudit_var_samp_fields;
  variance?: personToGroupAudit_variance_fields;
};


/** aggregate fields of "audit.v_PersonToGroupAudit" */
export type personToGroupAudit_aggregate_fieldscountArgs = {
  columns?: Array<personToGroupAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type personToGroupAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type personToGroupAudit_avg_fields = {
  __typename?: 'personToGroupAudit_avg_fields';
  auditID?: number;
};

/** Boolean expression to filter rows from the table "audit.v_PersonToGroupAudit". All fields are combined with a logical 'AND'. */
export type personToGroupAudit_bool_exp = {
  _and?: Array<personToGroupAudit_bool_exp>;
  _not?: personToGroupAudit_bool_exp;
  _or?: Array<personToGroupAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  group?: qx_Group_bool_exp;
  groupID?: String_comparison_exp;
  person?: qx_Person_bool_exp;
  personID?: String_comparison_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type personToGroupAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type personToGroupAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type personToGroupAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.v_PersonToGroupAudit" */
export type personToGroupAudit_inc_input = {
  auditID?: string;
};

/** input type for inserting data into table "audit.v_PersonToGroupAudit" */
export type personToGroupAudit_insert_input = {
  action?: string;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  group?: qx_Group_obj_rel_insert_input;
  groupID?: string;
  person?: qx_Person_obj_rel_insert_input;
  personID?: string;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate max on columns */
export type personToGroupAudit_max_fields = {
  __typename?: 'personToGroupAudit_max_fields';
  action?: string;
  auditID?: string;
  groupID?: string;
  personID?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** aggregate min on columns */
export type personToGroupAudit_min_fields = {
  __typename?: 'personToGroupAudit_min_fields';
  action?: string;
  auditID?: string;
  groupID?: string;
  personID?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** response of any mutation on the table "audit.v_PersonToGroupAudit" */
export type personToGroupAudit_mutation_response = {
  __typename?: 'personToGroupAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<personToGroupAudit>;
};

/** Ordering options when selecting data from "audit.v_PersonToGroupAudit". */
export type personToGroupAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  group?: qx_Group_order_by;
  groupID?: order_by;
  person?: qx_Person_order_by;
  personID?: order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  row_data?: order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type personToGroupAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.v_PersonToGroupAudit" */
export enum personToGroupAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  groupID = 'groupID',
  /** column name */
  personID = 'personID',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.v_PersonToGroupAudit" */
export type personToGroupAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  groupID?: string;
  personID?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type personToGroupAudit_stddev_fields = {
  __typename?: 'personToGroupAudit_stddev_fields';
  auditID?: number;
};

/** aggregate stddev_pop on columns */
export type personToGroupAudit_stddev_pop_fields = {
  __typename?: 'personToGroupAudit_stddev_pop_fields';
  auditID?: number;
};

/** aggregate stddev_samp on columns */
export type personToGroupAudit_stddev_samp_fields = {
  __typename?: 'personToGroupAudit_stddev_samp_fields';
  auditID?: number;
};

/** Streaming cursor of the table "personToGroupAudit" */
export type personToGroupAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: personToGroupAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type personToGroupAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  groupID?: string;
  personID?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type personToGroupAudit_sum_fields = {
  __typename?: 'personToGroupAudit_sum_fields';
  auditID?: string;
};

export type personToGroupAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: personToGroupAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: personToGroupAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: personToGroupAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: personToGroupAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: personToGroupAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: personToGroupAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: personToGroupAudit_set_input;
  /** filter the rows which have to be updated */
  where: personToGroupAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type personToGroupAudit_var_pop_fields = {
  __typename?: 'personToGroupAudit_var_pop_fields';
  auditID?: number;
};

/** aggregate var_samp on columns */
export type personToGroupAudit_var_samp_fields = {
  __typename?: 'personToGroupAudit_var_samp_fields';
  auditID?: number;
};

/** aggregate variance on columns */
export type personToGroupAudit_variance_fields = {
  __typename?: 'personToGroupAudit_variance_fields';
  auditID?: number;
};

/** columns and relationships of "qx.PersonVideoSourceAppPrivileges" */
export type personVideoSourceAppPrivileges = {
  __typename?: 'personVideoSourceAppPrivileges';
  canConfig?: boolean;
  canCreateClips?: boolean;
  canOperate?: boolean;
  canStream?: boolean;
  canView?: boolean;
  canViewRecordings?: boolean;
  canViewSnapshots?: boolean;
  /** An object relationship */
  person: qx_Person;
  personID: string;
  /** An object relationship */
  videoSource: qx_VideoSource;
  videoSourceID: string;
};

/** aggregated selection of "qx.PersonVideoSourceAppPrivileges" */
export type personVideoSourceAppPrivileges_aggregate = {
  __typename?: 'personVideoSourceAppPrivileges_aggregate';
  aggregate?: personVideoSourceAppPrivileges_aggregate_fields;
  nodes: Array<personVideoSourceAppPrivileges>;
};

export type personVideoSourceAppPrivileges_aggregate_bool_exp = {
  bool_and?: personVideoSourceAppPrivileges_aggregate_bool_exp_bool_and;
  bool_or?: personVideoSourceAppPrivileges_aggregate_bool_exp_bool_or;
  count?: personVideoSourceAppPrivileges_aggregate_bool_exp_count;
};

export type personVideoSourceAppPrivileges_aggregate_bool_exp_bool_and = {
  arguments: personVideoSourceAppPrivileges_select_column_personVideoSourceAppPrivileges_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: personVideoSourceAppPrivileges_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type personVideoSourceAppPrivileges_aggregate_bool_exp_bool_or = {
  arguments: personVideoSourceAppPrivileges_select_column_personVideoSourceAppPrivileges_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: personVideoSourceAppPrivileges_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type personVideoSourceAppPrivileges_aggregate_bool_exp_count = {
  arguments?: Array<personVideoSourceAppPrivileges_select_column>;
  distinct?: boolean;
  filter?: personVideoSourceAppPrivileges_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.PersonVideoSourceAppPrivileges" */
export type personVideoSourceAppPrivileges_aggregate_fields = {
  __typename?: 'personVideoSourceAppPrivileges_aggregate_fields';
  avg?: personVideoSourceAppPrivileges_avg_fields;
  count: number;
  max?: personVideoSourceAppPrivileges_max_fields;
  min?: personVideoSourceAppPrivileges_min_fields;
  stddev?: personVideoSourceAppPrivileges_stddev_fields;
  stddev_pop?: personVideoSourceAppPrivileges_stddev_pop_fields;
  stddev_samp?: personVideoSourceAppPrivileges_stddev_samp_fields;
  sum?: personVideoSourceAppPrivileges_sum_fields;
  var_pop?: personVideoSourceAppPrivileges_var_pop_fields;
  var_samp?: personVideoSourceAppPrivileges_var_samp_fields;
  variance?: personVideoSourceAppPrivileges_variance_fields;
};


/** aggregate fields of "qx.PersonVideoSourceAppPrivileges" */
export type personVideoSourceAppPrivileges_aggregate_fieldscountArgs = {
  columns?: Array<personVideoSourceAppPrivileges_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.PersonVideoSourceAppPrivileges" */
export type personVideoSourceAppPrivileges_aggregate_order_by = {
  avg?: personVideoSourceAppPrivileges_avg_order_by;
  count?: order_by;
  max?: personVideoSourceAppPrivileges_max_order_by;
  min?: personVideoSourceAppPrivileges_min_order_by;
  stddev?: personVideoSourceAppPrivileges_stddev_order_by;
  stddev_pop?: personVideoSourceAppPrivileges_stddev_pop_order_by;
  stddev_samp?: personVideoSourceAppPrivileges_stddev_samp_order_by;
  sum?: personVideoSourceAppPrivileges_sum_order_by;
  var_pop?: personVideoSourceAppPrivileges_var_pop_order_by;
  var_samp?: personVideoSourceAppPrivileges_var_samp_order_by;
  variance?: personVideoSourceAppPrivileges_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.PersonVideoSourceAppPrivileges" */
export type personVideoSourceAppPrivileges_arr_rel_insert_input = {
  data: Array<personVideoSourceAppPrivileges_insert_input>;
  /** upsert condition */
  on_conflict?: personVideoSourceAppPrivileges_on_conflict;
};

/** aggregate avg on columns */
export type personVideoSourceAppPrivileges_avg_fields = {
  __typename?: 'personVideoSourceAppPrivileges_avg_fields';
  videoSourceID?: number;
};

/** order by avg() on columns of table "qx.PersonVideoSourceAppPrivileges" */
export type personVideoSourceAppPrivileges_avg_order_by = {
  videoSourceID?: order_by;
};

/** Boolean expression to filter rows from the table "qx.PersonVideoSourceAppPrivileges". All fields are combined with a logical 'AND'. */
export type personVideoSourceAppPrivileges_bool_exp = {
  _and?: Array<personVideoSourceAppPrivileges_bool_exp>;
  _not?: personVideoSourceAppPrivileges_bool_exp;
  _or?: Array<personVideoSourceAppPrivileges_bool_exp>;
  canConfig?: Boolean_comparison_exp;
  canCreateClips?: Boolean_comparison_exp;
  canOperate?: Boolean_comparison_exp;
  canStream?: Boolean_comparison_exp;
  canView?: Boolean_comparison_exp;
  canViewRecordings?: Boolean_comparison_exp;
  canViewSnapshots?: Boolean_comparison_exp;
  person?: qx_Person_bool_exp;
  personID?: String_comparison_exp;
  videoSource?: qx_VideoSource_bool_exp;
  videoSourceID?: bigint_comparison_exp;
};

/** unique or primary key constraints on table "qx.PersonVideoSourceAppPrivileges" */
export enum personVideoSourceAppPrivileges_constraint {
  /** unique or primary key constraint on columns "videoSourceID", "personID" */
  PersonVideoSourceAppPrivileges_pkey = 'PersonVideoSourceAppPrivileges_pkey',
  /** unique or primary key constraint on columns "videoSourceID", "personID" */
  idx_person_unique_videosource_person = 'idx_person_unique_videosource_person'
}

/** input type for incrementing numeric columns in table "qx.PersonVideoSourceAppPrivileges" */
export type personVideoSourceAppPrivileges_inc_input = {
  videoSourceID?: string;
};

/** input type for inserting data into table "qx.PersonVideoSourceAppPrivileges" */
export type personVideoSourceAppPrivileges_insert_input = {
  canConfig?: boolean;
  canCreateClips?: boolean;
  canOperate?: boolean;
  canStream?: boolean;
  canView?: boolean;
  canViewRecordings?: boolean;
  canViewSnapshots?: boolean;
  person?: qx_Person_obj_rel_insert_input;
  personID?: string;
  videoSource?: qx_VideoSource_obj_rel_insert_input;
  videoSourceID?: string;
};

/** aggregate max on columns */
export type personVideoSourceAppPrivileges_max_fields = {
  __typename?: 'personVideoSourceAppPrivileges_max_fields';
  personID?: string;
  videoSourceID?: string;
};

/** order by max() on columns of table "qx.PersonVideoSourceAppPrivileges" */
export type personVideoSourceAppPrivileges_max_order_by = {
  personID?: order_by;
  videoSourceID?: order_by;
};

/** aggregate min on columns */
export type personVideoSourceAppPrivileges_min_fields = {
  __typename?: 'personVideoSourceAppPrivileges_min_fields';
  personID?: string;
  videoSourceID?: string;
};

/** order by min() on columns of table "qx.PersonVideoSourceAppPrivileges" */
export type personVideoSourceAppPrivileges_min_order_by = {
  personID?: order_by;
  videoSourceID?: order_by;
};

/** response of any mutation on the table "qx.PersonVideoSourceAppPrivileges" */
export type personVideoSourceAppPrivileges_mutation_response = {
  __typename?: 'personVideoSourceAppPrivileges_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<personVideoSourceAppPrivileges>;
};

/** on_conflict condition type for table "qx.PersonVideoSourceAppPrivileges" */
export type personVideoSourceAppPrivileges_on_conflict = {
  constraint: personVideoSourceAppPrivileges_constraint;
  update_columns?: Array<personVideoSourceAppPrivileges_update_column>;
  where?: personVideoSourceAppPrivileges_bool_exp;
};

/** Ordering options when selecting data from "qx.PersonVideoSourceAppPrivileges". */
export type personVideoSourceAppPrivileges_order_by = {
  canConfig?: order_by;
  canCreateClips?: order_by;
  canOperate?: order_by;
  canStream?: order_by;
  canView?: order_by;
  canViewRecordings?: order_by;
  canViewSnapshots?: order_by;
  person?: qx_Person_order_by;
  personID?: order_by;
  videoSource?: qx_VideoSource_order_by;
  videoSourceID?: order_by;
};

/** primary key columns input for table: qx.PersonVideoSourceAppPrivileges */
export type personVideoSourceAppPrivileges_pk_columns_input = {
  personID: string;
  videoSourceID: string;
};

/** select columns of table "qx.PersonVideoSourceAppPrivileges" */
export enum personVideoSourceAppPrivileges_select_column {
  /** column name */
  canConfig = 'canConfig',
  /** column name */
  canCreateClips = 'canCreateClips',
  /** column name */
  canOperate = 'canOperate',
  /** column name */
  canStream = 'canStream',
  /** column name */
  canView = 'canView',
  /** column name */
  canViewRecordings = 'canViewRecordings',
  /** column name */
  canViewSnapshots = 'canViewSnapshots',
  /** column name */
  personID = 'personID',
  /** column name */
  videoSourceID = 'videoSourceID'
}

/** select "personVideoSourceAppPrivileges_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.PersonVideoSourceAppPrivileges" */
export enum personVideoSourceAppPrivileges_select_column_personVideoSourceAppPrivileges_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  canConfig = 'canConfig',
  /** column name */
  canCreateClips = 'canCreateClips',
  /** column name */
  canOperate = 'canOperate',
  /** column name */
  canStream = 'canStream',
  /** column name */
  canView = 'canView',
  /** column name */
  canViewRecordings = 'canViewRecordings',
  /** column name */
  canViewSnapshots = 'canViewSnapshots'
}

/** select "personVideoSourceAppPrivileges_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.PersonVideoSourceAppPrivileges" */
export enum personVideoSourceAppPrivileges_select_column_personVideoSourceAppPrivileges_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  canConfig = 'canConfig',
  /** column name */
  canCreateClips = 'canCreateClips',
  /** column name */
  canOperate = 'canOperate',
  /** column name */
  canStream = 'canStream',
  /** column name */
  canView = 'canView',
  /** column name */
  canViewRecordings = 'canViewRecordings',
  /** column name */
  canViewSnapshots = 'canViewSnapshots'
}

/** input type for updating data in table "qx.PersonVideoSourceAppPrivileges" */
export type personVideoSourceAppPrivileges_set_input = {
  canConfig?: boolean;
  canCreateClips?: boolean;
  canOperate?: boolean;
  canStream?: boolean;
  canView?: boolean;
  canViewRecordings?: boolean;
  canViewSnapshots?: boolean;
  personID?: string;
  videoSourceID?: string;
};

/** aggregate stddev on columns */
export type personVideoSourceAppPrivileges_stddev_fields = {
  __typename?: 'personVideoSourceAppPrivileges_stddev_fields';
  videoSourceID?: number;
};

/** order by stddev() on columns of table "qx.PersonVideoSourceAppPrivileges" */
export type personVideoSourceAppPrivileges_stddev_order_by = {
  videoSourceID?: order_by;
};

/** aggregate stddev_pop on columns */
export type personVideoSourceAppPrivileges_stddev_pop_fields = {
  __typename?: 'personVideoSourceAppPrivileges_stddev_pop_fields';
  videoSourceID?: number;
};

/** order by stddev_pop() on columns of table "qx.PersonVideoSourceAppPrivileges" */
export type personVideoSourceAppPrivileges_stddev_pop_order_by = {
  videoSourceID?: order_by;
};

/** aggregate stddev_samp on columns */
export type personVideoSourceAppPrivileges_stddev_samp_fields = {
  __typename?: 'personVideoSourceAppPrivileges_stddev_samp_fields';
  videoSourceID?: number;
};

/** order by stddev_samp() on columns of table "qx.PersonVideoSourceAppPrivileges" */
export type personVideoSourceAppPrivileges_stddev_samp_order_by = {
  videoSourceID?: order_by;
};

/** Streaming cursor of the table "personVideoSourceAppPrivileges" */
export type personVideoSourceAppPrivileges_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: personVideoSourceAppPrivileges_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type personVideoSourceAppPrivileges_stream_cursor_value_input = {
  canConfig?: boolean;
  canCreateClips?: boolean;
  canOperate?: boolean;
  canStream?: boolean;
  canView?: boolean;
  canViewRecordings?: boolean;
  canViewSnapshots?: boolean;
  personID?: string;
  videoSourceID?: string;
};

/** aggregate sum on columns */
export type personVideoSourceAppPrivileges_sum_fields = {
  __typename?: 'personVideoSourceAppPrivileges_sum_fields';
  videoSourceID?: string;
};

/** order by sum() on columns of table "qx.PersonVideoSourceAppPrivileges" */
export type personVideoSourceAppPrivileges_sum_order_by = {
  videoSourceID?: order_by;
};

/** update columns of table "qx.PersonVideoSourceAppPrivileges" */
export enum personVideoSourceAppPrivileges_update_column {
  /** column name */
  canConfig = 'canConfig',
  /** column name */
  canCreateClips = 'canCreateClips',
  /** column name */
  canOperate = 'canOperate',
  /** column name */
  canStream = 'canStream',
  /** column name */
  canView = 'canView',
  /** column name */
  canViewRecordings = 'canViewRecordings',
  /** column name */
  canViewSnapshots = 'canViewSnapshots',
  /** column name */
  personID = 'personID',
  /** column name */
  videoSourceID = 'videoSourceID'
}

export type personVideoSourceAppPrivileges_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: personVideoSourceAppPrivileges_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: personVideoSourceAppPrivileges_set_input;
  /** filter the rows which have to be updated */
  where: personVideoSourceAppPrivileges_bool_exp;
};

/** aggregate var_pop on columns */
export type personVideoSourceAppPrivileges_var_pop_fields = {
  __typename?: 'personVideoSourceAppPrivileges_var_pop_fields';
  videoSourceID?: number;
};

/** order by var_pop() on columns of table "qx.PersonVideoSourceAppPrivileges" */
export type personVideoSourceAppPrivileges_var_pop_order_by = {
  videoSourceID?: order_by;
};

/** aggregate var_samp on columns */
export type personVideoSourceAppPrivileges_var_samp_fields = {
  __typename?: 'personVideoSourceAppPrivileges_var_samp_fields';
  videoSourceID?: number;
};

/** order by var_samp() on columns of table "qx.PersonVideoSourceAppPrivileges" */
export type personVideoSourceAppPrivileges_var_samp_order_by = {
  videoSourceID?: order_by;
};

/** aggregate variance on columns */
export type personVideoSourceAppPrivileges_variance_fields = {
  __typename?: 'personVideoSourceAppPrivileges_variance_fields';
  videoSourceID?: number;
};

/** order by variance() on columns of table "qx.PersonVideoSourceAppPrivileges" */
export type personVideoSourceAppPrivileges_variance_order_by = {
  videoSourceID?: order_by;
};

export type pinSettings = {
  defaultState?: string;
  enabled?: boolean;
  refId?: string;
  type?: string;
};

/** audit view tracking historical changes to place/location records */
export type placeAudit = {
  __typename?: 'placeAudit';
  action?: string;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  row_data?: any;
  time?: string;
};


/** audit view tracking historical changes to place/location records */
export type placeAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes to place/location records */
export type placeAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.vPlaceAudit" */
export type placeAudit_aggregate = {
  __typename?: 'placeAudit_aggregate';
  aggregate?: placeAudit_aggregate_fields;
  nodes: Array<placeAudit>;
};

/** aggregate fields of "audit.vPlaceAudit" */
export type placeAudit_aggregate_fields = {
  __typename?: 'placeAudit_aggregate_fields';
  avg?: placeAudit_avg_fields;
  count: number;
  max?: placeAudit_max_fields;
  min?: placeAudit_min_fields;
  stddev?: placeAudit_stddev_fields;
  stddev_pop?: placeAudit_stddev_pop_fields;
  stddev_samp?: placeAudit_stddev_samp_fields;
  sum?: placeAudit_sum_fields;
  var_pop?: placeAudit_var_pop_fields;
  var_samp?: placeAudit_var_samp_fields;
  variance?: placeAudit_variance_fields;
};


/** aggregate fields of "audit.vPlaceAudit" */
export type placeAudit_aggregate_fieldscountArgs = {
  columns?: Array<placeAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type placeAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type placeAudit_avg_fields = {
  __typename?: 'placeAudit_avg_fields';
  auditID?: number;
};

/** Boolean expression to filter rows from the table "audit.vPlaceAudit". All fields are combined with a logical 'AND'. */
export type placeAudit_bool_exp = {
  _and?: Array<placeAudit_bool_exp>;
  _not?: placeAudit_bool_exp;
  _or?: Array<placeAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  id?: String_comparison_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type placeAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type placeAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type placeAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.vPlaceAudit" */
export type placeAudit_inc_input = {
  auditID?: string;
};

/** input type for inserting data into table "audit.vPlaceAudit" */
export type placeAudit_insert_input = {
  action?: string;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate max on columns */
export type placeAudit_max_fields = {
  __typename?: 'placeAudit_max_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** aggregate min on columns */
export type placeAudit_min_fields = {
  __typename?: 'placeAudit_min_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** response of any mutation on the table "audit.vPlaceAudit" */
export type placeAudit_mutation_response = {
  __typename?: 'placeAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<placeAudit>;
};

/** Ordering options when selecting data from "audit.vPlaceAudit". */
export type placeAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  id?: order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  row_data?: order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type placeAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.vPlaceAudit" */
export enum placeAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  id = 'id',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.vPlaceAudit" */
export type placeAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type placeAudit_stddev_fields = {
  __typename?: 'placeAudit_stddev_fields';
  auditID?: number;
};

/** aggregate stddev_pop on columns */
export type placeAudit_stddev_pop_fields = {
  __typename?: 'placeAudit_stddev_pop_fields';
  auditID?: number;
};

/** aggregate stddev_samp on columns */
export type placeAudit_stddev_samp_fields = {
  __typename?: 'placeAudit_stddev_samp_fields';
  auditID?: number;
};

/** Streaming cursor of the table "placeAudit" */
export type placeAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: placeAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type placeAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type placeAudit_sum_fields = {
  __typename?: 'placeAudit_sum_fields';
  auditID?: string;
};

export type placeAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: placeAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: placeAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: placeAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: placeAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: placeAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: placeAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: placeAudit_set_input;
  /** filter the rows which have to be updated */
  where: placeAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type placeAudit_var_pop_fields = {
  __typename?: 'placeAudit_var_pop_fields';
  auditID?: number;
};

/** aggregate var_samp on columns */
export type placeAudit_var_samp_fields = {
  __typename?: 'placeAudit_var_samp_fields';
  auditID?: number;
};

/** aggregate variance on columns */
export type placeAudit_variance_fields = {
  __typename?: 'placeAudit_variance_fields';
  auditID?: number;
};

/** columns and relationships of "qx.PlaceWhitelist" */
export type placeWhiteLists = {
  __typename?: 'placeWhiteLists';
  alias: string;
  id: string;
  ip: Scalars['inet']['output'];
  /** An object relationship */
  place?: qx_Place;
  placeID: string;
};

/** aggregated selection of "qx.PlaceWhitelist" */
export type placeWhiteLists_aggregate = {
  __typename?: 'placeWhiteLists_aggregate';
  aggregate?: placeWhiteLists_aggregate_fields;
  nodes: Array<placeWhiteLists>;
};

export type placeWhiteLists_aggregate_bool_exp = {
  count?: placeWhiteLists_aggregate_bool_exp_count;
};

export type placeWhiteLists_aggregate_bool_exp_count = {
  arguments?: Array<placeWhiteLists_select_column>;
  distinct?: boolean;
  filter?: placeWhiteLists_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.PlaceWhitelist" */
export type placeWhiteLists_aggregate_fields = {
  __typename?: 'placeWhiteLists_aggregate_fields';
  avg?: placeWhiteLists_avg_fields;
  count: number;
  max?: placeWhiteLists_max_fields;
  min?: placeWhiteLists_min_fields;
  stddev?: placeWhiteLists_stddev_fields;
  stddev_pop?: placeWhiteLists_stddev_pop_fields;
  stddev_samp?: placeWhiteLists_stddev_samp_fields;
  sum?: placeWhiteLists_sum_fields;
  var_pop?: placeWhiteLists_var_pop_fields;
  var_samp?: placeWhiteLists_var_samp_fields;
  variance?: placeWhiteLists_variance_fields;
};


/** aggregate fields of "qx.PlaceWhitelist" */
export type placeWhiteLists_aggregate_fieldscountArgs = {
  columns?: Array<placeWhiteLists_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.PlaceWhitelist" */
export type placeWhiteLists_aggregate_order_by = {
  avg?: placeWhiteLists_avg_order_by;
  count?: order_by;
  max?: placeWhiteLists_max_order_by;
  min?: placeWhiteLists_min_order_by;
  stddev?: placeWhiteLists_stddev_order_by;
  stddev_pop?: placeWhiteLists_stddev_pop_order_by;
  stddev_samp?: placeWhiteLists_stddev_samp_order_by;
  sum?: placeWhiteLists_sum_order_by;
  var_pop?: placeWhiteLists_var_pop_order_by;
  var_samp?: placeWhiteLists_var_samp_order_by;
  variance?: placeWhiteLists_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.PlaceWhitelist" */
export type placeWhiteLists_arr_rel_insert_input = {
  data: Array<placeWhiteLists_insert_input>;
  /** upsert condition */
  on_conflict?: placeWhiteLists_on_conflict;
};

/** aggregate avg on columns */
export type placeWhiteLists_avg_fields = {
  __typename?: 'placeWhiteLists_avg_fields';
  id?: number;
};

/** order by avg() on columns of table "qx.PlaceWhitelist" */
export type placeWhiteLists_avg_order_by = {
  id?: order_by;
};

/** Boolean expression to filter rows from the table "qx.PlaceWhitelist". All fields are combined with a logical 'AND'. */
export type placeWhiteLists_bool_exp = {
  _and?: Array<placeWhiteLists_bool_exp>;
  _not?: placeWhiteLists_bool_exp;
  _or?: Array<placeWhiteLists_bool_exp>;
  alias?: String_comparison_exp;
  id?: bigint_comparison_exp;
  ip?: inet_comparison_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.PlaceWhitelist" */
export enum placeWhiteLists_constraint {
  /** unique or primary key constraint on columns "id" */
  PlaceWhitelist_pkey = 'PlaceWhitelist_pkey'
}

/** input type for incrementing numeric columns in table "qx.PlaceWhitelist" */
export type placeWhiteLists_inc_input = {
  id?: string;
};

/** input type for inserting data into table "qx.PlaceWhitelist" */
export type placeWhiteLists_insert_input = {
  alias?: string;
  id?: string;
  ip?: Scalars['inet']['input'];
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
};

/** aggregate max on columns */
export type placeWhiteLists_max_fields = {
  __typename?: 'placeWhiteLists_max_fields';
  alias?: string;
  id?: string;
  placeID?: string;
};

/** order by max() on columns of table "qx.PlaceWhitelist" */
export type placeWhiteLists_max_order_by = {
  alias?: order_by;
  id?: order_by;
  placeID?: order_by;
};

/** aggregate min on columns */
export type placeWhiteLists_min_fields = {
  __typename?: 'placeWhiteLists_min_fields';
  alias?: string;
  id?: string;
  placeID?: string;
};

/** order by min() on columns of table "qx.PlaceWhitelist" */
export type placeWhiteLists_min_order_by = {
  alias?: order_by;
  id?: order_by;
  placeID?: order_by;
};

/** response of any mutation on the table "qx.PlaceWhitelist" */
export type placeWhiteLists_mutation_response = {
  __typename?: 'placeWhiteLists_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<placeWhiteLists>;
};

/** on_conflict condition type for table "qx.PlaceWhitelist" */
export type placeWhiteLists_on_conflict = {
  constraint: placeWhiteLists_constraint;
  update_columns?: Array<placeWhiteLists_update_column>;
  where?: placeWhiteLists_bool_exp;
};

/** Ordering options when selecting data from "qx.PlaceWhitelist". */
export type placeWhiteLists_order_by = {
  alias?: order_by;
  id?: order_by;
  ip?: order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
};

/** primary key columns input for table: qx.PlaceWhitelist */
export type placeWhiteLists_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.PlaceWhitelist" */
export enum placeWhiteLists_select_column {
  /** column name */
  alias = 'alias',
  /** column name */
  id = 'id',
  /** column name */
  ip = 'ip',
  /** column name */
  placeID = 'placeID'
}

/** input type for updating data in table "qx.PlaceWhitelist" */
export type placeWhiteLists_set_input = {
  alias?: string;
  id?: string;
  ip?: Scalars['inet']['input'];
  placeID?: string;
};

/** aggregate stddev on columns */
export type placeWhiteLists_stddev_fields = {
  __typename?: 'placeWhiteLists_stddev_fields';
  id?: number;
};

/** order by stddev() on columns of table "qx.PlaceWhitelist" */
export type placeWhiteLists_stddev_order_by = {
  id?: order_by;
};

/** aggregate stddev_pop on columns */
export type placeWhiteLists_stddev_pop_fields = {
  __typename?: 'placeWhiteLists_stddev_pop_fields';
  id?: number;
};

/** order by stddev_pop() on columns of table "qx.PlaceWhitelist" */
export type placeWhiteLists_stddev_pop_order_by = {
  id?: order_by;
};

/** aggregate stddev_samp on columns */
export type placeWhiteLists_stddev_samp_fields = {
  __typename?: 'placeWhiteLists_stddev_samp_fields';
  id?: number;
};

/** order by stddev_samp() on columns of table "qx.PlaceWhitelist" */
export type placeWhiteLists_stddev_samp_order_by = {
  id?: order_by;
};

/** Streaming cursor of the table "placeWhiteLists" */
export type placeWhiteLists_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: placeWhiteLists_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type placeWhiteLists_stream_cursor_value_input = {
  alias?: string;
  id?: string;
  ip?: Scalars['inet']['input'];
  placeID?: string;
};

/** aggregate sum on columns */
export type placeWhiteLists_sum_fields = {
  __typename?: 'placeWhiteLists_sum_fields';
  id?: string;
};

/** order by sum() on columns of table "qx.PlaceWhitelist" */
export type placeWhiteLists_sum_order_by = {
  id?: order_by;
};

/** update columns of table "qx.PlaceWhitelist" */
export enum placeWhiteLists_update_column {
  /** column name */
  alias = 'alias',
  /** column name */
  id = 'id',
  /** column name */
  ip = 'ip',
  /** column name */
  placeID = 'placeID'
}

export type placeWhiteLists_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: placeWhiteLists_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: placeWhiteLists_set_input;
  /** filter the rows which have to be updated */
  where: placeWhiteLists_bool_exp;
};

/** aggregate var_pop on columns */
export type placeWhiteLists_var_pop_fields = {
  __typename?: 'placeWhiteLists_var_pop_fields';
  id?: number;
};

/** order by var_pop() on columns of table "qx.PlaceWhitelist" */
export type placeWhiteLists_var_pop_order_by = {
  id?: order_by;
};

/** aggregate var_samp on columns */
export type placeWhiteLists_var_samp_fields = {
  __typename?: 'placeWhiteLists_var_samp_fields';
  id?: number;
};

/** order by var_samp() on columns of table "qx.PlaceWhitelist" */
export type placeWhiteLists_var_samp_order_by = {
  id?: order_by;
};

/** aggregate variance on columns */
export type placeWhiteLists_variance_fields = {
  __typename?: 'placeWhiteLists_variance_fields';
  id?: number;
};

/** order by variance() on columns of table "qx.PlaceWhitelist" */
export type placeWhiteLists_variance_order_by = {
  id?: order_by;
};

export type prioritySettings = {
  configuration?: Array<namevalue>;
  level?: string;
  refId?: string;
};

/** audit view tracking historical changes to privilege-to-role mappings */
export type privilegeEnumToRoleAudit = {
  __typename?: 'privilegeEnumToRoleAudit';
  action?: string;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  privilege?: string;
  /** An object relationship */
  role?: qx_Role;
  roleID?: string;
  row_data?: any;
  time?: string;
};


/** audit view tracking historical changes to privilege-to-role mappings */
export type privilegeEnumToRoleAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes to privilege-to-role mappings */
export type privilegeEnumToRoleAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.v_PrivilegeEnumToRoleAudit" */
export type privilegeEnumToRoleAudit_aggregate = {
  __typename?: 'privilegeEnumToRoleAudit_aggregate';
  aggregate?: privilegeEnumToRoleAudit_aggregate_fields;
  nodes: Array<privilegeEnumToRoleAudit>;
};

/** aggregate fields of "audit.v_PrivilegeEnumToRoleAudit" */
export type privilegeEnumToRoleAudit_aggregate_fields = {
  __typename?: 'privilegeEnumToRoleAudit_aggregate_fields';
  avg?: privilegeEnumToRoleAudit_avg_fields;
  count: number;
  max?: privilegeEnumToRoleAudit_max_fields;
  min?: privilegeEnumToRoleAudit_min_fields;
  stddev?: privilegeEnumToRoleAudit_stddev_fields;
  stddev_pop?: privilegeEnumToRoleAudit_stddev_pop_fields;
  stddev_samp?: privilegeEnumToRoleAudit_stddev_samp_fields;
  sum?: privilegeEnumToRoleAudit_sum_fields;
  var_pop?: privilegeEnumToRoleAudit_var_pop_fields;
  var_samp?: privilegeEnumToRoleAudit_var_samp_fields;
  variance?: privilegeEnumToRoleAudit_variance_fields;
};


/** aggregate fields of "audit.v_PrivilegeEnumToRoleAudit" */
export type privilegeEnumToRoleAudit_aggregate_fieldscountArgs = {
  columns?: Array<privilegeEnumToRoleAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type privilegeEnumToRoleAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type privilegeEnumToRoleAudit_avg_fields = {
  __typename?: 'privilegeEnumToRoleAudit_avg_fields';
  auditID?: number;
};

/** Boolean expression to filter rows from the table "audit.v_PrivilegeEnumToRoleAudit". All fields are combined with a logical 'AND'. */
export type privilegeEnumToRoleAudit_bool_exp = {
  _and?: Array<privilegeEnumToRoleAudit_bool_exp>;
  _not?: privilegeEnumToRoleAudit_bool_exp;
  _or?: Array<privilegeEnumToRoleAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  privilege?: String_comparison_exp;
  role?: qx_Role_bool_exp;
  roleID?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type privilegeEnumToRoleAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type privilegeEnumToRoleAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type privilegeEnumToRoleAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.v_PrivilegeEnumToRoleAudit" */
export type privilegeEnumToRoleAudit_inc_input = {
  auditID?: string;
};

/** input type for inserting data into table "audit.v_PrivilegeEnumToRoleAudit" */
export type privilegeEnumToRoleAudit_insert_input = {
  action?: string;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  privilege?: string;
  role?: qx_Role_obj_rel_insert_input;
  roleID?: string;
  row_data?: any;
  time?: string;
};

/** aggregate max on columns */
export type privilegeEnumToRoleAudit_max_fields = {
  __typename?: 'privilegeEnumToRoleAudit_max_fields';
  action?: string;
  auditID?: string;
  person_id?: string;
  place_id?: string;
  privilege?: string;
  roleID?: string;
  time?: string;
};

/** aggregate min on columns */
export type privilegeEnumToRoleAudit_min_fields = {
  __typename?: 'privilegeEnumToRoleAudit_min_fields';
  action?: string;
  auditID?: string;
  person_id?: string;
  place_id?: string;
  privilege?: string;
  roleID?: string;
  time?: string;
};

/** response of any mutation on the table "audit.v_PrivilegeEnumToRoleAudit" */
export type privilegeEnumToRoleAudit_mutation_response = {
  __typename?: 'privilegeEnumToRoleAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<privilegeEnumToRoleAudit>;
};

/** Ordering options when selecting data from "audit.v_PrivilegeEnumToRoleAudit". */
export type privilegeEnumToRoleAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  privilege?: order_by;
  role?: qx_Role_order_by;
  roleID?: order_by;
  row_data?: order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type privilegeEnumToRoleAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.v_PrivilegeEnumToRoleAudit" */
export enum privilegeEnumToRoleAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  privilege = 'privilege',
  /** column name */
  roleID = 'roleID',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.v_PrivilegeEnumToRoleAudit" */
export type privilegeEnumToRoleAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  person_id?: string;
  place_id?: string;
  privilege?: string;
  roleID?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type privilegeEnumToRoleAudit_stddev_fields = {
  __typename?: 'privilegeEnumToRoleAudit_stddev_fields';
  auditID?: number;
};

/** aggregate stddev_pop on columns */
export type privilegeEnumToRoleAudit_stddev_pop_fields = {
  __typename?: 'privilegeEnumToRoleAudit_stddev_pop_fields';
  auditID?: number;
};

/** aggregate stddev_samp on columns */
export type privilegeEnumToRoleAudit_stddev_samp_fields = {
  __typename?: 'privilegeEnumToRoleAudit_stddev_samp_fields';
  auditID?: number;
};

/** Streaming cursor of the table "privilegeEnumToRoleAudit" */
export type privilegeEnumToRoleAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: privilegeEnumToRoleAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type privilegeEnumToRoleAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  person_id?: string;
  place_id?: string;
  privilege?: string;
  roleID?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type privilegeEnumToRoleAudit_sum_fields = {
  __typename?: 'privilegeEnumToRoleAudit_sum_fields';
  auditID?: string;
};

export type privilegeEnumToRoleAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: privilegeEnumToRoleAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: privilegeEnumToRoleAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: privilegeEnumToRoleAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: privilegeEnumToRoleAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: privilegeEnumToRoleAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: privilegeEnumToRoleAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: privilegeEnumToRoleAudit_set_input;
  /** filter the rows which have to be updated */
  where: privilegeEnumToRoleAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type privilegeEnumToRoleAudit_var_pop_fields = {
  __typename?: 'privilegeEnumToRoleAudit_var_pop_fields';
  auditID?: number;
};

/** aggregate var_samp on columns */
export type privilegeEnumToRoleAudit_var_samp_fields = {
  __typename?: 'privilegeEnumToRoleAudit_var_samp_fields';
  auditID?: number;
};

/** aggregate variance on columns */
export type privilegeEnumToRoleAudit_variance_fields = {
  __typename?: 'privilegeEnumToRoleAudit_variance_fields';
  auditID?: number;
};

export type query_root = {
  __typename?: 'query_root';
  /** fetch data from the table: "analytics.AnalyticSource" */
  AnalyticSources: Array<AnalyticSources>;
  /** fetch aggregated fields from the table: "analytics.AnalyticSource" */
  AnalyticSources_aggregate: AnalyticSources_aggregate;
  /** fetch data from the table: "analytics.AnalyticSource" using primary key columns */
  AnalyticSources_by_pk?: AnalyticSources;
  /** fetch data from the table: "qx.ApplicationUserGatewayPassword" */
  ApplicationUserGatewayPassword: Array<ApplicationUserGatewayPassword>;
  /** fetch aggregated fields from the table: "qx.ApplicationUserGatewayPassword" */
  ApplicationUserGatewayPassword_aggregate: ApplicationUserGatewayPassword_aggregate;
  /** fetch data from the table: "qx.ApplicationUserGatewayPassword" using primary key columns */
  ApplicationUserGatewayPassword_by_pk?: ApplicationUserGatewayPassword;
  /** fetch data from the table: "qx.ApplicationUserTwoFactor" */
  ApplicationUserTwoFactor: Array<ApplicationUserTwoFactor>;
  /** fetch aggregated fields from the table: "qx.ApplicationUserTwoFactor" */
  ApplicationUserTwoFactor_aggregate: ApplicationUserTwoFactor_aggregate;
  /** fetch data from the table: "qx.ApplicationUserTwoFactor" using primary key columns */
  ApplicationUserTwoFactor_by_pk?: ApplicationUserTwoFactor;
  /** fetch data from the table: "qx.AuditLog" using primary key columns */
  AuditLog?: qx_AuditLog;
  /** fetch aggregated fields from the table: "qx.AuditLog" */
  AuditLogAggregate: qx_AuditLog_aggregate;
  /** An array relationship */
  AuditLogs: Array<qx_AuditLog>;
  /** fetch data from the table: "qx.DSCConnection" */
  DSCConnection: Array<DSCConnection>;
  /** fetch aggregated fields from the table: "qx.DSCConnection" */
  DSCConnection_aggregate: DSCConnection_aggregate;
  /** fetch data from the table: "qx.DSCConnection" using primary key columns */
  DSCConnection_by_pk?: DSCConnection;
  /** fetch data from the table: "qx.DeviceDIO" using primary key columns */
  DeviceDIO?: qx_DeviceDIO;
  /** An array relationship */
  DeviceDIOs: Array<qx_DeviceDIO>;
  /** fetch aggregated fields from the table: "qx.DeviceDIO" */
  DeviceDioAggregate: qx_DeviceDIO_aggregate;
  /** fetch data from the table: "qx.IntrusionAccessCode" */
  IntrusionAccessCode: Array<IntrusionAccessCode>;
  /** fetch aggregated fields from the table: "qx.IntrusionAccessCode" */
  IntrusionAccessCode_aggregate: IntrusionAccessCode_aggregate;
  /** fetch data from the table: "qx.IntrusionAccessCode" using primary key columns */
  IntrusionAccessCode_by_pk?: IntrusionAccessCode;
  /** fetch data from the table: "qx.IntrusionPartition" */
  IntrusionPartition: Array<IntrusionPartition>;
  /** fetch aggregated fields from the table: "qx.IntrusionPartition" */
  IntrusionPartition_aggregate: IntrusionPartition_aggregate;
  /** fetch data from the table: "qx.IntrusionPartition" using primary key columns */
  IntrusionPartition_by_pk?: IntrusionPartition;
  /** fetch data from the table: "qx.IntrusionZone" */
  IntrusionZone: Array<IntrusionZone>;
  /** fetch aggregated fields from the table: "qx.IntrusionZone" */
  IntrusionZone_aggregate: IntrusionZone_aggregate;
  /** fetch data from the table: "qx.IntrusionZone" using primary key columns */
  IntrusionZone_by_pk?: IntrusionZone;
  /** An array relationship */
  PartitionZoneAssignments: Array<PartitionZoneAssignments>;
  /** An aggregate relationship */
  PartitionZoneAssignments_aggregate: PartitionZoneAssignments_aggregate;
  /** fetch data from the table: "qx.PartitionZoneAssignments" using primary key columns */
  PartitionZoneAssignments_by_pk?: PartitionZoneAssignments;
  /** fetch data from the table: "qx.PassKeyProvider" */
  PassKeyProvider: Array<PassKeyProvider>;
  /** fetch aggregated fields from the table: "qx.PassKeyProvider" */
  PassKeyProvider_aggregate: PassKeyProvider_aggregate;
  /** fetch data from the table: "qx.PassKeyProvider" using primary key columns */
  PassKeyProvider_by_pk?: PassKeyProvider;
  /** An array relationship */
  PermissionPartitionAssignments: Array<PermissionPartitionAssignments>;
  /** An aggregate relationship */
  PermissionPartitionAssignments_aggregate: PermissionPartitionAssignments_aggregate;
  /** fetch data from the table: "qx.PermissionPartitionAssignments" using primary key columns */
  PermissionPartitionAssignments_by_pk?: PermissionPartitionAssignments;
  /** fetch data from the table: "qx.PersonTermsAgreement" */
  PersonTermsAgreement: Array<PersonTermsAgreement>;
  /** fetch aggregated fields from the table: "qx.PersonTermsAgreement" */
  PersonTermsAgreement_aggregate: PersonTermsAgreement_aggregate;
  /** fetch data from the table: "qx.PersonTermsAgreement" using primary key columns */
  PersonTermsAgreement_by_pk?: PersonTermsAgreement;
  /** fetch data from the table: "qx.eAccessBoardType" using primary key columns */
  accessBoardTypeEnum?: qx_eAccessBoardType;
  /** fetch aggregated fields from the table: "qx.eAccessBoardType" */
  accessBoardTypeEnumAggregate: qx_eAccessBoardType_aggregate;
  /** fetch data from the table: "qx.eAccessBoardType" */
  accessBoardTypeEnums: Array<qx_eAccessBoardType>;
  /** fetch data from the table: "qx.AccessCatalog" using primary key columns */
  accessCatalog?: qx_AccessCatalog;
  /** fetch aggregated fields from the table: "qx.AccessCatalog" */
  accessCatalogAggregate: qx_AccessCatalog_aggregate;
  /** fetch data from the table: "qx.AccessCatalog" */
  accessCatalogs: Array<qx_AccessCatalog>;
  /** fetch data from the table: "qx.eAccessDeniedReason" using primary key columns */
  accessDeniedReasonEnum?: qx_eAccessDeniedReason;
  /** fetch aggregated fields from the table: "qx.eAccessDeniedReason" */
  accessDeniedReasonEnumAggregate: qx_eAccessDeniedReason_aggregate;
  /** fetch data from the table: "qx.eAccessDeniedReason" */
  accessDeniedReasonEnums: Array<qx_eAccessDeniedReason>;
  /** fetch data from the table: "qx.eAccessInterfaceType" using primary key columns */
  accessInterfaceTypeEnum?: qx_eAccessInterfaceType;
  /** fetch aggregated fields from the table: "qx.eAccessInterfaceType" */
  accessInterfaceTypeEnumAggregate: qx_eAccessInterfaceType_aggregate;
  /** fetch data from the table: "qx.eAccessInterfaceType" */
  accessInterfaceTypeEnums: Array<qx_eAccessInterfaceType>;
  /** An array relationship */
  accessInventories: Array<qx_AccessInventory>;
  /** fetch data from the table: "qx.AccessInventory" using primary key columns */
  accessInventory?: qx_AccessInventory;
  /** fetch aggregated fields from the table: "qx.AccessInventory" */
  accessInventoryAggregate: qx_AccessInventory_aggregate;
  /** fetch data from the table: "qx.eAccessPointAction" using primary key columns */
  accessPointActionEnum?: qx_eAccessPointAction;
  /** fetch aggregated fields from the table: "qx.eAccessPointAction" */
  accessPointActionEnumAggregate: qx_eAccessPointAction_aggregate;
  /** fetch data from the table: "qx.eAccessPointAction" */
  accessPointActionEnums: Array<qx_eAccessPointAction>;
  /** fetch data from the table: "qx.eAccessPointDirection" using primary key columns */
  accessPointDirectionEnum?: qx_eAccessPointDirection;
  /** fetch aggregated fields from the table: "qx.eAccessPointDirection" */
  accessPointDirectionEnumAggregate: qx_eAccessPointDirection_aggregate;
  /** fetch data from the table: "qx.eAccessPointDirection" */
  accessPointDirectionEnums: Array<qx_eAccessPointDirection>;
  /** fetch data from the table: "qx.eAccessPointType" using primary key columns */
  accessPointTypeEnum?: qx_eAccessPointType;
  /** fetch aggregated fields from the table: "qx.eAccessPointType" */
  accessPointTypeEnumAggregate: qx_eAccessPointType_aggregate;
  /** fetch data from the table: "qx.eAccessPointType" */
  accessPointTypeEnums: Array<qx_eAccessPointType>;
  /** An array relationship */
  analyticAttributeProperties: Array<analyticAttributeProperties>;
  /** An aggregate relationship */
  analyticAttributeProperties_aggregate: analyticAttributeProperties_aggregate;
  /** fetch data from the table: "analytics.AnalyticAttributeProperty" using primary key columns */
  analyticAttributeProperties_by_pk?: analyticAttributeProperties;
  /** fetch data from the table: "analytics.AnalyticAttribute" */
  analyticAttributes: Array<analyticAttributes>;
  /** fetch aggregated fields from the table: "analytics.AnalyticAttribute" */
  analyticAttributes_aggregate: analyticAttributes_aggregate;
  /** fetch data from the table: "analytics.AnalyticAttribute" using primary key columns */
  analyticAttributes_by_pk?: analyticAttributes;
  /** An array relationship */
  analyticDetectedProperties: Array<analyticDetectedProperties>;
  /** An aggregate relationship */
  analyticDetectedProperties_aggregate: analyticDetectedProperties_aggregate;
  /** fetch data from the table: "analytics.AnalyticPropertyDetected" using primary key columns */
  analyticDetectedProperties_by_pk?: analyticDetectedProperties;
  /** fetch data from the table: "analytics.AnalyticType" */
  analyticTypes: Array<analyticTypes>;
  /** fetch aggregated fields from the table: "analytics.AnalyticType" */
  analyticTypes_aggregate: analyticTypes_aggregate;
  /** fetch data from the table: "analytics.AnalyticType" using primary key columns */
  analyticTypes_by_pk?: analyticTypes;
  /** An array relationship */
  analytics: Array<analytics>;
  /** An aggregate relationship */
  analytics_aggregate: analytics_aggregate;
  /** fetch data from the table: "analytics.Analytic" using primary key columns */
  analytics_by_pk?: analytics;
  /** fetch data from the table: "qx.ApplicationUserAppPassword" */
  applicationUserAppPasswords: Array<applicationUserAppPasswords>;
  /** fetch aggregated fields from the table: "qx.ApplicationUserAppPassword" */
  applicationUserAppPasswords_aggregate: applicationUserAppPasswords_aggregate;
  /** fetch data from the table: "qx.ApplicationUserAppPassword" using primary key columns */
  applicationUserAppPasswords_by_pk?: applicationUserAppPasswords;
  /** fetch data from the table: "qx.ApplicationUserDevice" */
  applicationUserDevices: Array<applicationUserDevices>;
  /** fetch aggregated fields from the table: "qx.ApplicationUserDevice" */
  applicationUserDevices_aggregate: applicationUserDevices_aggregate;
  /** fetch data from the table: "qx.ApplicationUserDevice" using primary key columns */
  applicationUserDevices_by_pk?: applicationUserDevices;
  /** fetch data from the table: "analytics.AttributeProperty" */
  attributeProperties: Array<attributeProperties>;
  /** fetch aggregated fields from the table: "analytics.AttributeProperty" */
  attributeProperties_aggregate: attributeProperties_aggregate;
  /** fetch data from the table: "analytics.AttributeProperty" using primary key columns */
  attributeProperties_by_pk?: attributeProperties;
  /** fetch data from the table: "analytics.Attribute" */
  attributes: Array<attributes>;
  /** fetch aggregated fields from the table: "analytics.Attribute" */
  attributes_aggregate: attributes_aggregate;
  /** fetch data from the table: "analytics.Attribute" using primary key columns */
  attributes_by_pk?: attributes;
  /** fetch data from the table: "qx.AudioSource" using primary key columns */
  audioSource?: qx_AudioSource;
  /** fetch aggregated fields from the table: "qx.AudioSource" */
  audioSourceAggregate: qx_AudioSource_aggregate;
  /** fetch data from the table: "audit.vAudioSourceAudit" */
  audioSourceAudit: Array<audioSourceAudit>;
  /** fetch aggregated fields from the table: "audit.vAudioSourceAudit" */
  audioSourceAudit_aggregate: audioSourceAudit_aggregate;
  /** fetch data from the table: "qx.vAudioSourceVideoSource" */
  audioSourceVideoSource: Array<audioSourceVideoSource>;
  /** fetch aggregated fields from the table: "qx.vAudioSourceVideoSource" */
  audioSourceVideoSource_aggregate: audioSourceVideoSource_aggregate;
  /** An array relationship */
  audioSources: Array<qx_AudioSource>;
  /** fetch data from the table: "audit.logged_actions" */
  audit_logged_actions: Array<audit_logged_actions>;
  /** fetch aggregated fields from the table: "audit.logged_actions" */
  audit_logged_actions_aggregate: audit_logged_actions_aggregate;
  /** fetch data from the table: "audit.logged_actions" using primary key columns */
  audit_logged_actions_by_pk?: audit_logged_actions;
  /** fetch data from the table: "audit.vSensorAudit" */
  audit_vSensorAudit: Array<audit_vSensorAudit>;
  /** fetch aggregated fields from the table: "audit.vSensorAudit" */
  audit_vSensorAudit_aggregate: audit_vSensorAudit_aggregate;
  /** fetch data from the table: "qx.AuditableAction" */
  auditableActions: Array<qx_AuditableAction>;
  /** fetch data from the table: "qx.AuditableType" */
  auditableTypes: Array<qx_AuditableType>;
  authHealth: SuccessResponse;
  authSessions: Array<AuthSession>;
  /** fetch data from the table: "qx.eAuthStrategy" using primary key columns */
  authStrategyEnum?: qx_eAuthStrategy;
  /** fetch aggregated fields from the table: "qx.eAuthStrategy" */
  authStrategyEnumAggregate: qx_eAuthStrategy_aggregate;
  /** fetch data from the table: "qx.eAuthStrategy" */
  authStrategyEnums: Array<qx_eAuthStrategy>;
  axisBodyWornUserList: Array<AxisBodyWornUser>;
  /** fetch data from the table: "qx.eBatteryLevel" using primary key columns */
  batteryLevelEnum?: qx_eBatteryLevel;
  /** fetch aggregated fields from the table: "qx.eBatteryLevel" */
  batteryLevelEnumAggregate: qx_eBatteryLevel_aggregate;
  /** fetch data from the table: "qx.eBatteryLevel" */
  batteryLevelEnums: Array<qx_eBatteryLevel>;
  /** fetch data from the table: "qx.eBaudrate" using primary key columns */
  baudrateEnum?: qx_eBaudrate;
  /** fetch aggregated fields from the table: "qx.eBaudrate" */
  baudrateEnumAggregate: qx_eBaudrate_aggregate;
  /** fetch data from the table: "qx.eBaudrate" */
  baudrateEnums: Array<qx_eBaudrate>;
  /** fetch data from the table: "qx.BillingPeriod" using primary key columns */
  billingPeriod?: qx_BillingPeriod;
  /** fetch aggregated fields from the table: "qx.BillingPeriod" */
  billingPeriodAggregate: qx_BillingPeriod_aggregate;
  /** fetch data from the table: "qx.BillingPeriod" */
  billingPeriods: Array<qx_BillingPeriod>;
  /** fetch data from the table: "qx.eBillingTier" using primary key columns */
  billingTierEnum?: qx_eBillingTier;
  /** fetch aggregated fields from the table: "qx.eBillingTier" */
  billingTierEnumAggregate: qx_eBillingTier_aggregate;
  /** fetch data from the table: "qx.eBillingTier" */
  billingTierEnums: Array<qx_eBillingTier>;
  /** fetch aggregated fields from the table: "qx.vChatBillingByModel" */
  chatBillingByModelAggregate: qx_vChatBillingByModel_aggregate;
  /** fetch data from the table: "qx.vChatBillingByModel" */
  chatBillingByModels: Array<qx_vChatBillingByModel>;
  /** fetch data from the table: "qx.vChatBillingSummary" */
  chatBillingSummaries: Array<qx_vChatBillingSummary>;
  /** fetch aggregated fields from the table: "qx.vChatBillingSummary" */
  chatBillingSummaryAggregate: qx_vChatBillingSummary_aggregate;
  /** fetch aggregated fields from the table: "qx.vChatPromptUsage" */
  chatPromptUsageAggregate: qx_vChatPromptUsage_aggregate;
  /** fetch data from the table: "qx.vChatPromptUsage" */
  chatPromptUsages: Array<qx_vChatPromptUsage>;
  /** fetch data from the table: "qx.ChatUsageHistory" */
  chatUsageHistories: Array<qx_ChatUsageHistory>;
  /** fetch data from the table: "qx.ChatUsageHistory" using primary key columns */
  chatUsageHistory?: qx_ChatUsageHistory;
  /** fetch aggregated fields from the table: "qx.ChatUsageHistory" */
  chatUsageHistoryAggregate: qx_ChatUsageHistory_aggregate;
  /** execute function "qx.chat_usage_per_model" which returns "qx.vChatUsagePerModel" */
  chat_usage_per_model: Array<qx_vChatUsagePerModel>;
  /** execute function "qx.chat_usage_series" which returns "qx.vChatUsageSeries" */
  chat_usage_series: Array<qx_vChatUsageSeries>;
  /** fetch data from the table: "qx.Clip" using primary key columns */
  clip?: qx_Clip;
  /** fetch aggregated fields from the table: "qx.Clip" */
  clipAggregate: qx_Clip_aggregate;
  /** fetch aggregated fields from the table: "qx.ClipAuditLog" */
  clipAuditLogAggregate: qx_ClipAuditLog_aggregate;
  /** fetch data from the table: "qx.ClipAuditLog" */
  clipAuditLogs: Array<qx_ClipAuditLog>;
  /** fetch data from the table: "qx.eClipStatus" using primary key columns */
  clipStatusReasonEnum?: qx_eClipStatus;
  /** fetch aggregated fields from the table: "qx.eClipStatus" */
  clipStatusReasonEnumAggregate: qx_eClipStatus_aggregate;
  /** fetch data from the table: "qx.eClipStatus" */
  clipStatusReasonEnums: Array<qx_eClipStatus>;
  /** fetch data from the table: "qx.eClipType" using primary key columns */
  clipTypeEnum?: qx_eClipType;
  /** fetch aggregated fields from the table: "qx.eClipType" */
  clipTypeEnumAggregate: qx_eClipType_aggregate;
  /** fetch data from the table: "qx.eClipType" */
  clipTypeEnums: Array<qx_eClipType>;
  /** An array relationship */
  clips: Array<qx_Clip>;
  cloudPeers: Array<Peer>;
  /** fetch data from the table: "qx.CloudStorageOptions" using primary key columns */
  cloudStorageOption?: qx_CloudStorageOptions;
  /** fetch data from the table: "qx.CloudStorageOptions" */
  cloudStorageOptions: Array<qx_CloudStorageOptions>;
  /** fetch aggregated fields from the table: "qx.CloudStorageOptions" */
  cloudStorageOptionsAggregate: qx_CloudStorageOptions_aggregate;
  /** fetch data from the table: "qx.CloudStorageTimelapseOptions" */
  cloudStorageTimelapseOptions: Array<cloudStorageTimelapseOptions>;
  /** fetch aggregated fields from the table: "qx.CloudStorageTimelapseOptions" */
  cloudStorageTimelapseOptions_aggregate: cloudStorageTimelapseOptions_aggregate;
  /** fetch data from the table: "qx.CloudStorageTimelapseOptions" using primary key columns */
  cloudStorageTimelapseOptions_by_pk?: cloudStorageTimelapseOptions;
  /** fetch data from the table: "qx.Credential" using primary key columns */
  credential?: qx_Credential;
  /** fetch aggregated fields from the table: "qx.Credential" */
  credentialAggregate: qx_Credential_aggregate;
  /** fetch data from the table: "audit.vCredentialAudit" */
  credentialAudit: Array<credentialAudit>;
  /** fetch aggregated fields from the table: "audit.vCredentialAudit" */
  credentialAudit_aggregate: credentialAudit_aggregate;
  /** fetch data from the table: "qx.eCredentialType" using primary key columns */
  credentialTypeEnum?: qx_eCredentialType;
  /** fetch aggregated fields from the table: "qx.eCredentialType" */
  credentialTypeEnumAggregate: qx_eCredentialType_aggregate;
  /** fetch data from the table: "qx.eCredentialType" */
  credentialTypeEnums: Array<qx_eCredentialType>;
  /** An array relationship */
  credentials: Array<qx_Credential>;
  /** fetch data from the table: "qx.CustomerPermission" using primary key columns */
  customerPermission?: qx_CustomerPermission;
  /** fetch aggregated fields from the table: "qx.CustomerPermission" */
  customerPermissionAggregate: qx_CustomerPermission_aggregate;
  /** fetch data from the table: "audit.vCustomerPermissionAudit" */
  customerPermissionAudit: Array<customerPermissionAudit>;
  /** fetch aggregated fields from the table: "audit.vCustomerPermissionAudit" */
  customerPermissionAudit_aggregate: customerPermissionAudit_aggregate;
  /** fetch data from the table: "qx.CustomerPermission" */
  customerPermissions: Array<qx_CustomerPermission>;
  /** fetch data from the table: "qx.Device" using primary key columns */
  device?: qx_Device;
  /** fetch aggregated fields from the table: "qx.Device" */
  deviceAggregate: qx_Device_aggregate;
  /** fetch data from the table: "qx.DeviceAnalyticSource" */
  deviceAnalyticSource: Array<deviceAnalyticSource>;
  /** fetch aggregated fields from the table: "qx.DeviceAnalyticSource" */
  deviceAnalyticSource_aggregate: deviceAnalyticSource_aggregate;
  /** fetch data from the table: "qx.DeviceAnalyticSource" using primary key columns */
  deviceAnalyticSource_by_pk?: deviceAnalyticSource;
  /** fetch data from the table: "audit.vDeviceAudit" */
  deviceAudit: Array<deviceAudit>;
  /** fetch aggregated fields from the table: "audit.vDeviceAudit" */
  deviceAudit_aggregate: deviceAudit_aggregate;
  /** fetch data from the table: "qx.eDeviceConnectionStatus" using primary key columns */
  deviceConnectionStatusEnum?: qx_eDeviceConnectionStatus;
  /** fetch aggregated fields from the table: "qx.eDeviceConnectionStatus" */
  deviceConnectionStatusEnumAggregate: qx_eDeviceConnectionStatus_aggregate;
  /** fetch data from the table: "qx.eDeviceConnectionStatus" */
  deviceConnectionStatusEnums: Array<qx_eDeviceConnectionStatus>;
  /** fetch data from the table: "audit.vDeviceDIOAudit" */
  deviceDIOAudit: Array<deviceDIOAudit>;
  /** fetch aggregated fields from the table: "audit.vDeviceDIOAudit" */
  deviceDIOAudit_aggregate: deviceDIOAudit_aggregate;
  /** fetch data from the table: "qx.eDeviceKind" using primary key columns */
  deviceKindEnum?: qx_eDeviceKind;
  /** fetch aggregated fields from the table: "qx.eDeviceKind" */
  deviceKindEnumAggregate: qx_eDeviceKind_aggregate;
  /** fetch data from the table: "qx.eDeviceKind" */
  deviceKindEnums: Array<qx_eDeviceKind>;
  /** An array relationship */
  devices: Array<qx_Device>;
  /** fetch data from the table: "qx.eDIONormalState" using primary key columns */
  dioNormalStateEnum?: qx_eDIONormalState;
  /** fetch aggregated fields from the table: "qx.eDIONormalState" */
  dioNormalStateEnumAggregate: qx_eDIONormalState_aggregate;
  /** fetch data from the table: "qx.eDIONormalState" */
  dioNormalStateEnums: Array<qx_eDIONormalState>;
  /** fetch data from the table: "qx.eDIOState" using primary key columns */
  dioStateEnum?: qx_eDIOState;
  /** fetch aggregated fields from the table: "qx.eDIOState" */
  dioStateEnumAggregate: qx_eDIOState_aggregate;
  /** fetch data from the table: "qx.eDIOState" */
  dioStateEnums: Array<qx_eDIOState>;
  /** fetch data from the table: "qx.eDIOType" using primary key columns */
  dioTypeEnum?: qx_eDIOType;
  /** fetch aggregated fields from the table: "qx.eDIOType" */
  dioTypeEnumAggregate: qx_eDIOType_aggregate;
  /** fetch data from the table: "qx.eDIOType" */
  dioTypeEnums: Array<qx_eDIOType>;
  discover: Array<DiscoveredDevice>;
  /** fetch data from the table: "qx.DiscoveryType" */
  discoveryTypes: Array<qx_DiscoveryType>;
  diskStorageStats: Array<StorageDriveStats>;
  /** fetch data from the table: "qx.Door" using primary key columns */
  door?: qx_Door;
  /** fetch aggregated fields from the table: "qx.Door" */
  doorAggregate: qx_Door_aggregate;
  /** fetch data from the table: "qx.eDoorAlarm" using primary key columns */
  doorAlarmEnum?: qx_eDoorAlarm;
  /** fetch aggregated fields from the table: "qx.eDoorAlarm" */
  doorAlarmEnumAggregate: qx_eDoorAlarm_aggregate;
  /** fetch data from the table: "qx.eDoorAlarm" */
  doorAlarmEnums: Array<qx_eDoorAlarm>;
  /** fetch data from the table: "audit.vDoorAudit" */
  doorAudit: Array<doorAudit>;
  /** fetch aggregated fields from the table: "audit.vDoorAudit" */
  doorAudit_aggregate: doorAudit_aggregate;
  /** fetch data from the table: "qx.DoorConfiguration" using primary key columns */
  doorConfiguration?: qx_DoorConfiguration;
  /** fetch aggregated fields from the table: "qx.DoorConfiguration" */
  doorConfigurationAggregate: qx_DoorConfiguration_aggregate;
  /** fetch data from the table: "qx.DoorConfiguration" */
  doorConfigurations: Array<qx_DoorConfiguration>;
  /** fetch data from the table: "qx.DoorMeta" using primary key columns */
  doorMeta?: qx_DoorMeta;
  /** fetch aggregated fields from the table: "qx.DoorMeta" */
  doorMetaAggregate: qx_DoorMeta_aggregate;
  /** fetch data from the table: "qx.DoorMeta" */
  doorMetas: Array<qx_DoorMeta>;
  /** fetch data from the table: "qx.eDoorMode" using primary key columns */
  doorModeEnum?: qx_eDoorMode;
  /** fetch aggregated fields from the table: "qx.eDoorMode" */
  doorModeEnumAggregate: qx_eDoorMode_aggregate;
  /** fetch data from the table: "qx.eDoorMode" */
  doorModeEnums: Array<qx_eDoorMode>;
  /** fetch data from the table: "qx.eDoorMonitor" using primary key columns */
  doorMonitorEnum?: qx_eDoorMonitor;
  /** fetch aggregated fields from the table: "qx.eDoorMonitor" */
  doorMonitorEnumAggregate: qx_eDoorMonitor_aggregate;
  /** fetch data from the table: "qx.eDoorMonitor" */
  doorMonitorEnums: Array<qx_eDoorMonitor>;
  /** fetch data from the table: "qx.eDoorState" using primary key columns */
  doorStateEnum?: qx_eDoorState;
  /** fetch aggregated fields from the table: "qx.eDoorState" */
  doorStateEnumAggregate: qx_eDoorState_aggregate;
  /** fetch data from the table: "qx.eDoorState" */
  doorStateEnums: Array<qx_eDoorState>;
  /** fetch data from the table: "qx.DoorTemplate" using primary key columns */
  doorTemplate?: qx_DoorTemplate;
  /** fetch aggregated fields from the table: "qx.DoorTemplate" */
  doorTemplateAggregate: qx_DoorTemplate_aggregate;
  /** fetch data from the table: "qx.DoorTemplate" */
  doorTemplates: Array<qx_DoorTemplate>;
  /** An array relationship */
  doors: Array<qx_Door>;
  /** fetch data from the table: "analytics.eAnalyticIntegration" */
  eAnalyticIntegrations: Array<eAnalyticIntegrations>;
  /** fetch aggregated fields from the table: "analytics.eAnalyticIntegration" */
  eAnalyticIntegrations_aggregate: eAnalyticIntegrations_aggregate;
  /** fetch data from the table: "analytics.eAnalyticIntegration" using primary key columns */
  eAnalyticIntegrations_by_pk?: eAnalyticIntegrations;
  /** fetch data from the table: "analytics.eAnalyticState" */
  eAnalyticStates: Array<eAnalyticStates>;
  /** fetch aggregated fields from the table: "analytics.eAnalyticState" */
  eAnalyticStates_aggregate: eAnalyticStates_aggregate;
  /** fetch data from the table: "analytics.eAnalyticState" using primary key columns */
  eAnalyticStates_by_pk?: eAnalyticStates;
  /** fetch data from the table: "qx.eGatewayType" */
  eGatewayType: Array<eGatewayType>;
  /** fetch aggregated fields from the table: "qx.eGatewayType" */
  eGatewayType_aggregate: eGatewayType_aggregate;
  /** fetch data from the table: "qx.eGatewayType" using primary key columns */
  eGatewayType_by_pk?: eGatewayType;
  /** fetch data from the table: "qx.eS3BucketType" */
  eS3BucketType: Array<eS3BucketType>;
  /** fetch aggregated fields from the table: "qx.eS3BucketType" */
  eS3BucketType_aggregate: eS3BucketType_aggregate;
  /** fetch data from the table: "qx.eS3BucketType" using primary key columns */
  eS3BucketType_by_pk?: eS3BucketType;
  /** fetch data from the table: "qx.Event" using primary key columns */
  event?: qx_Event;
  /** fetch aggregated fields from the table: "qx.Event" */
  eventAggregate: qx_Event_aggregate;
  /** fetch data from the table: "qx.EventType" using primary key columns */
  eventType?: qx_EventType;
  /** fetch aggregated fields from the table: "qx.EventType" */
  eventTypeAggregate: qx_EventType_aggregate;
  /** fetch data from the table: "qx.EventType" */
  eventTypes: Array<qx_EventType>;
  /** An array relationship */
  events: Array<qx_Event>;
  /** fetch data from the table: "qx.Flow" using primary key columns */
  flow?: qx_Flow;
  /** fetch aggregated fields from the table: "qx.Flow" */
  flowAggregate: qx_Flow_aggregate;
  /** fetch data from the table: "audit.vFlowAudit" */
  flowAudit: Array<flowAudit>;
  /** fetch aggregated fields from the table: "audit.vFlowAudit" */
  flowAudit_aggregate: flowAudit_aggregate;
  /** fetch data from the table: "qx.FlowTrace" using primary key columns */
  flowTrace?: qx_FlowTrace;
  /** fetch aggregated fields from the table: "qx.FlowTrace" */
  flowTraceAggregate: qx_FlowTrace_aggregate;
  /** fetch data from the table: "qx.FlowTrace" */
  flowTraces: Array<qx_FlowTrace>;
  /** An array relationship */
  flows: Array<qx_Flow>;
  /** fetch data from the table: "qx.Gateway" using primary key columns */
  gateway?: qx_Gateway;
  /** fetch aggregated fields from the table: "qx.Gateway" */
  gatewayAggregate: qx_Gateway_aggregate;
  /** fetch data from the table: "audit.vGatewayAudit" */
  gatewayAudit: Array<gatewayAudit>;
  /** fetch aggregated fields from the table: "audit.vGatewayAudit" */
  gatewayAudit_aggregate: gatewayAudit_aggregate;
  /** fetch data from the table: "qx.GatewayBandwidthSchedule" using primary key columns */
  gatewayBandwidthSchedule?: qx_GatewayBandwidthSchedule;
  /** fetch aggregated fields from the table: "qx.GatewayBandwidthSchedule" */
  gatewayBandwidthScheduleAggregate: qx_GatewayBandwidthSchedule_aggregate;
  /** fetch data from the table: "audit.vGatewayBandwidthScheduleAudit" */
  gatewayBandwidthScheduleAudit: Array<gatewayBandwidthScheduleAudit>;
  /** fetch aggregated fields from the table: "audit.vGatewayBandwidthScheduleAudit" */
  gatewayBandwidthScheduleAudit_aggregate: gatewayBandwidthScheduleAudit_aggregate;
  /** An array relationship */
  gatewayBandwidthSchedules: Array<qx_GatewayBandwidthSchedule>;
  /** fetch data from the table: "qx.eGatewayServiceType" */
  gatewayServiceEnums: Array<qx_eGatewayServiceType>;
  /** fetch data from the table: "qx.eGatewayServiceType" using primary key columns */
  gatewayServiceTypeEnum?: qx_eGatewayServiceType;
  /** fetch aggregated fields from the table: "qx.eGatewayServiceType" */
  gatewayServiceTypeEnumAggregate: qx_eGatewayServiceType_aggregate;
  /** fetch data from the table: "qx.eGatewaySyncStatus" using primary key columns */
  gatewaySyncStatusEnum?: qx_eGatewaySyncStatus;
  /** fetch aggregated fields from the table: "qx.eGatewaySyncStatus" */
  gatewaySyncStatusEnumAggregate: qx_eGatewaySyncStatus_aggregate;
  /** fetch data from the table: "qx.eGatewaySyncStatus" */
  gatewaySyncStatusEnums: Array<qx_eGatewaySyncStatus>;
  /** An array relationship */
  gateways: Array<qx_Gateway>;
  generateTwoFactorQr: QrResponse;
  getBandwidthMetrics?: Array<BandwidthMetricResponse>;
  getDeviceDIOUsage: Array<DIOType>;
  getFlowActions: Array<FlowAction>;
  getFlowEvents: Array<FlowEvent>;
  getFlowFiringData: JsonOutput;
  getGatewayNodeMetrics: Array<NodeMetrics>;
  /** getGatewayServiceMetrics */
  getGatewayServiceMetrics: Array<PodMetrics>;
  getICEConfig: StringOutput;
  getMediaProfileRecording: Array<MediaProfileRecordingItem>;
  getMediaProfileRecordingDates: Array<MediaProfileRecordingDateItem>;
  getMercuryDIOUsage: MercuryDIOUsageOutput;
  getMercuryDIOUsages: Array<MercuryDIOUsageOutput>;
  getNetworkInterfaces?: Array<NetworkInterfaceSimple>;
  /** getOSSCredentialData */
  getOSSCredentialData: OSSCredentialDataOutput;
  /** getOSSData */
  getOSSData: OSSDataOutput;
  /** getOSSDoorData */
  getOSSDoorData: OSSDoorDataOutput;
  /** getOSSKeys */
  getOSSKeys: OSSKeysOutput;
  /** getReaderAccessTypes */
  getReaderAccessTypes: Array<ReaderAccessType>;
  /** getReaderProtocols */
  getReaderProtocols: Array<ReaderProtocol>;
  /** getSuperviseInputs */
  getSuperviseInputs: Array<SuperviseInputs>;
  getTwoFactorBackupCodes: BackupCodes;
  getUploadSegmentMetrics?: UploadSegmentMetricResponse;
  getValidator: any;
  /** fetch data from the table: "qx.Group" using primary key columns */
  group?: qx_Group;
  /** fetch aggregated fields from the table: "qx.Group" */
  groupAggregate: qx_Group_aggregate;
  /** fetch data from the table: "audit.vGroupAudit" */
  groupAudit: Array<groupAudit>;
  /** fetch aggregated fields from the table: "audit.vGroupAudit" */
  groupAudit_aggregate: groupAudit_aggregate;
  /** An array relationship */
  groups: Array<qx_Group>;
  /** fetch data from the table: "qx.GuestAccess" */
  guestAccess: Array<guestAccess>;
  /** fetch aggregated fields from the table: "qx.GuestAccess" */
  guestAccess_aggregate: guestAccess_aggregate;
  /** fetch data from the table: "qx.GuestAccess" using primary key columns */
  guestAccess_by_pk?: guestAccess;
  /** fetch data from the table: "qx.HolidaySet" using primary key columns */
  holidaySet?: qx_HolidaySet;
  /** fetch aggregated fields from the table: "qx.HolidaySet" */
  holidaySetAggregate: qx_HolidaySet_aggregate;
  /** fetch data from the table: "audit.vHolidaySetAudit" */
  holidaySetAudit: Array<holidaySetAudit>;
  /** fetch aggregated fields from the table: "audit.vHolidaySetAudit" */
  holidaySetAudit_aggregate: holidaySetAudit_aggregate;
  /** fetch data from the table: "qx._HolidaySetToScheduleBlock" using primary key columns */
  holidaySetToScheduleBlock?: qx__HolidaySetToScheduleBlock;
  /** fetch aggregated fields from the table: "qx._HolidaySetToScheduleBlock" */
  holidaySetToScheduleBlockAggregate: qx__HolidaySetToScheduleBlock_aggregate;
  /** fetch data from the table: "audit.v_HolidaySetToScheduleBlockAudit" */
  holidaySetToScheduleBlockAudit: Array<holidaySetToScheduleBlockAudit>;
  /** fetch aggregated fields from the table: "audit.v_HolidaySetToScheduleBlockAudit" */
  holidaySetToScheduleBlockAudit_aggregate: holidaySetToScheduleBlockAudit_aggregate;
  /** fetch data from the table: "qx._HolidaySetToScheduleBlock" */
  holidaySetToScheduleBlocks: Array<qx__HolidaySetToScheduleBlock>;
  /** An array relationship */
  holidaySets: Array<qx_HolidaySet>;
  /** fetch data from the table: "qx.InputPoint" using primary key columns */
  inputPoint?: qx_InputPoint;
  /** fetch aggregated fields from the table: "qx.InputPoint" */
  inputPointAggregate: qx_InputPoint_aggregate;
  /** fetch data from the table: "audit.vInputPointAudit" */
  inputPointAudit: Array<inputPointAudit>;
  /** fetch aggregated fields from the table: "audit.vInputPointAudit" */
  inputPointAudit_aggregate: inputPointAudit_aggregate;
  /** fetch data from the table: "qx.InputPoint" */
  inputPoints: Array<qx_InputPoint>;
  /** fetch data from the table: "qx.eKeypadMode" using primary key columns */
  keyModeEnum?: qx_eKeypadMode;
  /** fetch aggregated fields from the table: "qx.eKeypadMode" */
  keyModeEnumAggregate: qx_eKeypadMode_aggregate;
  /** fetch data from the table: "qx.eKeypadMode" */
  keyModeEnums: Array<qx_eKeypadMode>;
  /** fetch data from the table: "qx.Layout" using primary key columns */
  layout?: qx_Layout;
  /** An array relationship */
  layouts: Array<qx_Layout>;
  /** fetch aggregated fields from the table: "qx.Layout" */
  layoutsAggregate: qx_Layout_aggregate;
  /** fetch data from the table: "qx.LensProfile" using primary key columns */
  lensProfile?: qx_LensProfile;
  /** fetch aggregated fields from the table: "qx.LensProfile" */
  lensProfileAggregate: qx_LensProfile_aggregate;
  /** fetch data from the table: "qx.LensProfile" */
  lensProfiles: Array<qx_LensProfile>;
  /** fetch data from the table: "qx.SharedLinkType" */
  linkableTypes: Array<qx_SharedLinkType>;
  /** fetch data from the table: "qx.Lock" using primary key columns */
  lock?: qx_Lock;
  /** fetch aggregated fields from the table: "qx.Lock" */
  lockAggregate: qx_Lock_aggregate;
  /** fetch data from the table: "audit.vLockAudit" */
  lockAudit: Array<lockAudit>;
  /** fetch aggregated fields from the table: "audit.vLockAudit" */
  lockAudit_aggregate: lockAudit_aggregate;
  /** fetch data from the table: "qx.eLockPowerMonitor" using primary key columns */
  lockPowerMonitorEnum?: qx_eLockPowerMonitor;
  /** fetch aggregated fields from the table: "qx.eLockPowerMonitor" */
  lockPowerMonitorEnumAggregate: qx_eLockPowerMonitor_aggregate;
  /** fetch data from the table: "qx.eLockPowerMonitor" */
  lockPowerMonitorEnums: Array<qx_eLockPowerMonitor>;
  /** fetch data from the table: "qx.eLockRelayMonitor" using primary key columns */
  lockRelayMonitorEnum?: qx_eLockRelayMonitor;
  /** fetch aggregated fields from the table: "qx.eLockRelayMonitor" */
  lockRelayMonitorEnumAggregate: qx_eLockRelayMonitor_aggregate;
  /** fetch data from the table: "qx.eLockRelayMonitor" */
  lockRelayMonitorEnums: Array<qx_eLockRelayMonitor>;
  /** fetch data from the table: "qx.eLockType" using primary key columns */
  lockTypeEnum?: qx_eLockType;
  /** fetch aggregated fields from the table: "qx.eLockType" */
  lockTypeEnumAggregate: qx_eLockType_aggregate;
  /** fetch data from the table: "qx.eLockType" */
  lockTypeEnums: Array<qx_eLockType>;
  /** An array relationship */
  locks: Array<qx_Lock>;
  /** fetch data from the table: "qx.MediaProfile" using primary key columns */
  mediaProfile?: qx_MediaProfile;
  /** fetch aggregated fields from the table: "qx.MediaProfile" */
  mediaProfileAggregate: qx_MediaProfile_aggregate;
  /** fetch data from the table: "audit.vMediaProfileAudit" */
  mediaProfileAudit: Array<mediaProfileAudit>;
  /** fetch aggregated fields from the table: "audit.vMediaProfileAudit" */
  mediaProfileAudit_aggregate: mediaProfileAudit_aggregate;
  /** An array relationship */
  mediaProfiles: Array<qx_MediaProfile>;
  /** fetch data from the table: "qx.MercuryControlPoint" using primary key columns */
  mercuryControlPoint?: qx_MercuryControlPoint;
  /** fetch aggregated fields from the table: "qx.MercuryControlPoint" */
  mercuryControlPointAggregate: qx_MercuryControlPoint_aggregate;
  /** fetch data from the table: "qx.MercuryControlPoint" */
  mercuryControlPoints: Array<qx_MercuryControlPoint>;
  /** fetch data from the table: "qx.MercuryMonitorPoint" using primary key columns */
  mercuryMonitorPoint?: qx_MercuryMonitorPoint;
  /** fetch aggregated fields from the table: "qx.MercuryMonitorPoint" */
  mercuryMonitorPointAggregate: qx_MercuryMonitorPoint_aggregate;
  /** fetch data from the table: "qx.MercuryMonitorPoint" */
  mercuryMonitorPoints: Array<qx_MercuryMonitorPoint>;
  /** fetch data from the table: "qx.eMonitorLockState" using primary key columns */
  monitorLockStateEnum?: qx_eMonitorLockState;
  /** fetch aggregated fields from the table: "qx.eMonitorLockState" */
  monitorLockStateEnumAggregate: qx_eMonitorLockState_aggregate;
  /** fetch data from the table: "qx.eMonitorLockState" */
  monitorLockStateEnums: Array<qx_eMonitorLockState>;
  /** fetch data from the table: "qx.eMountPosition" using primary key columns */
  mountPositionEnum?: qx_eMountPosition;
  /** fetch aggregated fields from the table: "qx.eMountPosition" */
  mountPositionEnumAggregate: qx_eMountPosition_aggregate;
  /** fetch data from the table: "qx.eMountPosition" */
  mountPositionEnums: Array<qx_eMountPosition>;
  /** fetch data from the table: "qx.eFlowNotificationType" using primary key columns */
  notificationTypeEnum?: qx_eFlowNotificationType;
  /** fetch aggregated fields from the table: "qx.eFlowNotificationType" */
  notificationTypeEnumAggregate: qx_eFlowNotificationType_aggregate;
  /** fetch data from the table: "qx.eFlowNotificationType" */
  notificationTypeEnums: Array<qx_eFlowNotificationType>;
  /** fetch data from the table: "qx.eObjectAction" using primary key columns */
  objectActionEnum?: qx_eObjectAction;
  /** fetch aggregated fields from the table: "qx.eObjectAction" */
  objectActionEnumAggregate: qx_eObjectAction_aggregate;
  /** fetch data from the table: "qx.eObjectAction" */
  objectActionEnums: Array<qx_eObjectAction>;
  /** fetch data from the table: "qx.OssIdAssignment" using primary key columns */
  ossIdAssignment?: qx_OssIdAssignment;
  /** fetch aggregated fields from the table: "qx.OssIdAssignment" */
  ossIdAssignmentAggregate: qx_OssIdAssignment_aggregate;
  /** fetch data from the table: "qx.OssIdAssignment" */
  ossIdAssignments: Array<qx_OssIdAssignment>;
  /** fetch data from the table: "qx.OutputPoint" using primary key columns */
  outputPoint?: qx_OutputPoint;
  /** fetch aggregated fields from the table: "qx.OutputPoint" */
  outputPointAggregate: qx_OutputPoint_aggregate;
  /** fetch data from the table: "audit.vOutputPointAudit" */
  outputPointAudit: Array<outputPointAudit>;
  /** fetch aggregated fields from the table: "audit.vOutputPointAudit" */
  outputPointAudit_aggregate: outputPointAudit_aggregate;
  /** fetch data from the table: "qx.OutputPoint" */
  outputPoints: Array<qx_OutputPoint>;
  /** fetch data from the table: "qx.ePACSStatus" using primary key columns */
  pacsStatusEnum?: qx_ePACSStatus;
  /** fetch aggregated fields from the table: "qx.ePACSStatus" */
  pacsStatusEnumAggregate: qx_ePACSStatus_aggregate;
  /** fetch data from the table: "qx.ePACSStatus" */
  pacsStatusEnums: Array<qx_ePACSStatus>;
  peers: Array<Peer>;
  /** An array relationship */
  people: Array<qx_Person>;
  /** fetch data from the table: "qx.Permission" using primary key columns */
  permission?: qx_Permission;
  /** fetch aggregated fields from the table: "qx.Permission" */
  permissionAggregate: qx_Permission_aggregate;
  /** fetch data from the table: "audit.vPermissionAudit" */
  permissionAudit: Array<permissionAudit>;
  /** fetch aggregated fields from the table: "audit.vPermissionAudit" */
  permissionAudit_aggregate: permissionAudit_aggregate;
  /** An array relationship */
  permissions: Array<qx_Permission>;
  /** fetch data from the table: "qx.Person" using primary key columns */
  person?: qx_Person;
  /** fetch aggregated fields from the table: "qx.Person" */
  personAggregate: qx_Person_aggregate;
  /** fetch data from the table: "qx.vPersonAudioSourceAppPrivileges" */
  personAudioSourceAppPrivileges: Array<personAudioSourceAppPrivileges>;
  /** fetch aggregated fields from the table: "qx.vPersonAudioSourceAppPrivileges" */
  personAudioSourceAppPrivileges_aggregate: personAudioSourceAppPrivileges_aggregate;
  /** fetch data from the table: "audit.vPersonAudit" */
  personAudit: Array<personAudit>;
  /** fetch aggregated fields from the table: "audit.vPersonAudit" */
  personAudit_aggregate: personAudit_aggregate;
  /** An array relationship */
  personDeviceAppPrivileges: Array<personDeviceAppPrivileges>;
  /** An aggregate relationship */
  personDeviceAppPrivileges_aggregate: personDeviceAppPrivileges_aggregate;
  /** fetch data from the table: "qx.PersonDeviceAppPrivileges" using primary key columns */
  personDeviceAppPrivileges_by_pk?: personDeviceAppPrivileges;
  /** An array relationship */
  personDoorAppPrivileges: Array<personDoorAppPrivileges>;
  /** An aggregate relationship */
  personDoorAppPrivileges_aggregate: personDoorAppPrivileges_aggregate;
  /** fetch data from the table: "qx.PersonDoorAppPrivileges" using primary key columns */
  personDoorAppPrivileges_by_pk?: personDoorAppPrivileges;
  /** fetch data from the table: "qx._PersonToGroup" using primary key columns */
  personGroup?: qx__PersonToGroup;
  /** fetch aggregated fields from the table: "qx._PersonToGroup" */
  personGroupAggregate: qx__PersonToGroup_aggregate;
  /** fetch data from the table: "qx._PersonToGroup" */
  personGroups: Array<qx__PersonToGroup>;
  /** fetch data from the table: "qx.PersonIntrusionPartitionAppPrivileges" */
  personIntrusionPartitionAppPrivileges: Array<personIntrusionPartitionAppPrivileges>;
  /** fetch aggregated fields from the table: "qx.PersonIntrusionPartitionAppPrivileges" */
  personIntrusionPartitionAppPrivileges_aggregate: personIntrusionPartitionAppPrivileges_aggregate;
  /** fetch data from the table: "qx.PersonIntrusionPartitionAppPrivileges" using primary key columns */
  personIntrusionPartitionAppPrivileges_by_pk?: personIntrusionPartitionAppPrivileges;
  /** An array relationship */
  personPlaceAppPrivileges: Array<personPlaceAppPrivileges>;
  /** An aggregate relationship */
  personPlaceAppPrivileges_aggregate: personPlaceAppPrivileges_aggregate;
  /** fetch data from the table: "qx.PersonPlaceAppPrivileges" using primary key columns */
  personPlaceAppPrivileges_by_pk?: personPlaceAppPrivileges;
  /** fetch data from the table: "qx.ePersonStatus" using primary key columns */
  personStatusEnum?: qx_ePersonStatus;
  /** fetch aggregated fields from the table: "qx.ePersonStatus" */
  personStatusEnumAggregate: qx_ePersonStatus_aggregate;
  /** fetch data from the table: "qx.ePersonStatus" */
  personStatusEnums: Array<qx_ePersonStatus>;
  /** fetch data from the table: "audit.v_PersonToGroupAudit" */
  personToGroupAudit: Array<personToGroupAudit>;
  /** fetch aggregated fields from the table: "audit.v_PersonToGroupAudit" */
  personToGroupAudit_aggregate: personToGroupAudit_aggregate;
  /** An array relationship */
  personVideoSourceAppPrivileges: Array<personVideoSourceAppPrivileges>;
  /** An aggregate relationship */
  personVideoSourceAppPrivileges_aggregate: personVideoSourceAppPrivileges_aggregate;
  /** fetch data from the table: "qx.PersonVideoSourceAppPrivileges" using primary key columns */
  personVideoSourceAppPrivileges_by_pk?: personVideoSourceAppPrivileges;
  /** fetch data from the table: "qx.Place" using primary key columns */
  place?: qx_Place;
  /** fetch aggregated fields from the table: "qx.Place" */
  placeAggregate: qx_Place_aggregate;
  /** fetch data from the table: "audit.vPlaceAudit" */
  placeAudit: Array<placeAudit>;
  /** fetch aggregated fields from the table: "audit.vPlaceAudit" */
  placeAudit_aggregate: placeAudit_aggregate;
  /** fetch data from the table: "qx.ePlaceType" using primary key columns */
  placeTypeEnum?: qx_ePlaceType;
  /** fetch aggregated fields from the table: "qx.ePlaceType" */
  placeTypeEnumAggregate: qx_ePlaceType_aggregate;
  /** fetch data from the table: "qx.ePlaceType" */
  placeTypeEnums: Array<qx_ePlaceType>;
  /** fetch data from the table: "qx.PlaceWhitelist" */
  placeWhiteLists: Array<placeWhiteLists>;
  /** fetch aggregated fields from the table: "qx.PlaceWhitelist" */
  placeWhiteLists_aggregate: placeWhiteLists_aggregate;
  /** fetch data from the table: "qx.PlaceWhitelist" using primary key columns */
  placeWhiteLists_by_pk?: placeWhiteLists;
  /** An array relationship */
  places: Array<qx_Place>;
  /** fetch data from the table: "qx.ePrivilege" using primary key columns */
  privilegeEnum?: qx_ePrivilege;
  /** fetch aggregated fields from the table: "qx.ePrivilege" */
  privilegeEnumAggregate: qx_ePrivilege_aggregate;
  /** fetch data from the table: "qx._PrivilegeEnumToRole" using primary key columns */
  privilegeEnumToRole?: qx__PrivilegeEnumToRole;
  /** fetch aggregated fields from the table: "qx._PrivilegeEnumToRole" */
  privilegeEnumToRoleAggregate: qx__PrivilegeEnumToRole_aggregate;
  /** fetch data from the table: "audit.v_PrivilegeEnumToRoleAudit" */
  privilegeEnumToRoleAudit: Array<privilegeEnumToRoleAudit>;
  /** fetch aggregated fields from the table: "audit.v_PrivilegeEnumToRoleAudit" */
  privilegeEnumToRoleAudit_aggregate: privilegeEnumToRoleAudit_aggregate;
  /** fetch data from the table: "qx._PrivilegeEnumToRole" */
  privilegeEnumToRoles: Array<qx__PrivilegeEnumToRole>;
  /** fetch data from the table: "qx.ePrivilege" */
  privilegeEnums: Array<qx_ePrivilege>;
  /** fetch data from the table: "qx.AccessCatalogCapabilities" */
  qx_AccessCatalogCapabilities: Array<qx_AccessCatalogCapabilities>;
  /** fetch aggregated fields from the table: "qx.AccessCatalogCapabilities" */
  qx_AccessCatalogCapabilities_aggregate: qx_AccessCatalogCapabilities_aggregate;
  /** fetch data from the table: "qx.AccessCatalogCapabilities" using primary key columns */
  qx_AccessCatalogCapabilities_by_pk?: qx_AccessCatalogCapabilities;
  /** fetch aggregated fields from the table: "qx.AuditableAction" */
  qx_AuditableAction_aggregate: qx_AuditableAction_aggregate;
  /** fetch data from the table: "qx.AuditableAction" using primary key columns */
  qx_AuditableAction_by_pk?: qx_AuditableAction;
  /** fetch aggregated fields from the table: "qx.AuditableType" */
  qx_AuditableType_aggregate: qx_AuditableType_aggregate;
  /** fetch data from the table: "qx.AuditableType" using primary key columns */
  qx_AuditableType_by_pk?: qx_AuditableType;
  /** fetch data from the table: "qx.CatalogProtocolOverride" */
  qx_CatalogProtocolOverride: Array<qx_CatalogProtocolOverride>;
  /** fetch aggregated fields from the table: "qx.CatalogProtocolOverride" */
  qx_CatalogProtocolOverride_aggregate: qx_CatalogProtocolOverride_aggregate;
  /** fetch data from the table: "qx.CatalogProtocolOverride" using primary key columns */
  qx_CatalogProtocolOverride_by_pk?: qx_CatalogProtocolOverride;
  /** fetch data from the table: "qx.CustomerAuthProvider" */
  qx_CustomerAuthProvider: Array<qx_CustomerAuthProvider>;
  /** fetch aggregated fields from the table: "qx.CustomerAuthProvider" */
  qx_CustomerAuthProvider_aggregate: qx_CustomerAuthProvider_aggregate;
  /** fetch data from the table: "qx.CustomerAuthProvider" using primary key columns */
  qx_CustomerAuthProvider_by_pk?: qx_CustomerAuthProvider;
  /** fetch aggregated fields from the table: "qx.DiscoveryType" */
  qx_DiscoveryType_aggregate: qx_DiscoveryType_aggregate;
  /** fetch data from the table: "qx.DiscoveryType" using primary key columns */
  qx_DiscoveryType_by_pk?: qx_DiscoveryType;
  /** fetch data from the table: "qx.IntrusionAlarm" */
  qx_IntrusionAlarm: Array<qx_IntrusionAlarm>;
  /** fetch aggregated fields from the table: "qx.IntrusionAlarm" */
  qx_IntrusionAlarm_aggregate: qx_IntrusionAlarm_aggregate;
  /** fetch data from the table: "qx.IntrusionAlarm" using primary key columns */
  qx_IntrusionAlarm_by_pk?: qx_IntrusionAlarm;
  /** fetch data from the table: "qx.IntrusionPartitionState" */
  qx_IntrusionPartitionState: Array<qx_IntrusionPartitionState>;
  /** fetch aggregated fields from the table: "qx.IntrusionPartitionState" */
  qx_IntrusionPartitionState_aggregate: qx_IntrusionPartitionState_aggregate;
  /** fetch data from the table: "qx.IntrusionPartitionState" using primary key columns */
  qx_IntrusionPartitionState_by_pk?: qx_IntrusionPartitionState;
  /** fetch data from the table: "qx.IntrusionZoneState" */
  qx_IntrusionZoneState: Array<qx_IntrusionZoneState>;
  /** fetch aggregated fields from the table: "qx.IntrusionZoneState" */
  qx_IntrusionZoneState_aggregate: qx_IntrusionZoneState_aggregate;
  /** fetch data from the table: "qx.IntrusionZoneState" using primary key columns */
  qx_IntrusionZoneState_by_pk?: qx_IntrusionZoneState;
  /** fetch data from the table: "qx.MediaProfileRecording" */
  qx_MediaProfileRecording: Array<qx_MediaProfileRecording>;
  /** fetch aggregated fields from the table: "qx.MediaProfileRecording" */
  qx_MediaProfileRecording_aggregate: qx_MediaProfileRecording_aggregate;
  /** fetch data from the table: "qx.MediaProfileRecording" using primary key columns */
  qx_MediaProfileRecording_by_pk?: qx_MediaProfileRecording;
  /** fetch data from the table: "qx.OssKey" */
  qx_OssKey: Array<qx_OssKey>;
  /** fetch aggregated fields from the table: "qx.OssKey" */
  qx_OssKey_aggregate: qx_OssKey_aggregate;
  /** fetch data from the table: "qx.OssKey" using primary key columns */
  qx_OssKey_by_pk?: qx_OssKey;
  /** fetch aggregated fields from the table: "qx.SharedLinkType" */
  qx_SharedLinkType_aggregate: qx_SharedLinkType_aggregate;
  /** fetch data from the table: "qx.SharedLinkType" using primary key columns */
  qx_SharedLinkType_by_pk?: qx_SharedLinkType;
  /** fetch data from the table: "qx.VideoSourceStorageAudit" */
  qx_VideoSourceStorageAudit: Array<qx_VideoSourceStorageAudit>;
  /** fetch aggregated fields from the table: "qx.VideoSourceStorageAudit" */
  qx_VideoSourceStorageAudit_aggregate: qx_VideoSourceStorageAudit_aggregate;
  /** fetch data from the table: "qx.VideoSourceStorageAudit" using primary key columns */
  qx_VideoSourceStorageAudit_by_pk?: qx_VideoSourceStorageAudit;
  /** fetch data from the table: "qx._PlaceToHomePlaces" */
  qx__PlaceToHomePlaces: Array<qx__PlaceToHomePlaces>;
  /** fetch aggregated fields from the table: "qx._PlaceToHomePlaces" */
  qx__PlaceToHomePlaces_aggregate: qx__PlaceToHomePlaces_aggregate;
  /** execute function "qx.chat_usage_per_model" and query aggregates on result of table type "qx.vChatUsagePerModel" */
  qx_chat_usage_per_model_aggregate: qx_vChatUsagePerModel_aggregate;
  /** execute function "qx.chat_usage_series" and query aggregates on result of table type "qx.vChatUsageSeries" */
  qx_chat_usage_series_aggregate: qx_vChatUsageSeries_aggregate;
  /** execute function "qx.device_oldest_media" which returns "qx.vOldestMedia" */
  qx_device_oldest_media: Array<qx_vOldestMedia>;
  /** execute function "qx.device_oldest_media" and query aggregates on result of table type "qx.vOldestMedia" */
  qx_device_oldest_media_aggregate: qx_vOldestMedia_aggregate;
  /** fetch data from the table: "qx.eAccessMake" */
  qx_eAccessMake: Array<qx_eAccessMake>;
  /** fetch aggregated fields from the table: "qx.eAccessMake" */
  qx_eAccessMake_aggregate: qx_eAccessMake_aggregate;
  /** fetch data from the table: "qx.eAccessMake" using primary key columns */
  qx_eAccessMake_by_pk?: qx_eAccessMake;
  /** fetch data from the table: "qx.eAppPrivilegeType" */
  qx_eAppPrivilegeType: Array<qx_eAppPrivilegeType>;
  /** fetch aggregated fields from the table: "qx.eAppPrivilegeType" */
  qx_eAppPrivilegeType_aggregate: qx_eAppPrivilegeType_aggregate;
  /** fetch data from the table: "qx.eAppPrivilegeType" using primary key columns */
  qx_eAppPrivilegeType_by_pk?: qx_eAppPrivilegeType;
  /** fetch data from the table: "qx.eAuthProvider" */
  qx_eAuthProvider: Array<qx_eAuthProvider>;
  /** fetch aggregated fields from the table: "qx.eAuthProvider" */
  qx_eAuthProvider_aggregate: qx_eAuthProvider_aggregate;
  /** fetch data from the table: "qx.eAuthProvider" using primary key columns */
  qx_eAuthProvider_by_pk?: qx_eAuthProvider;
  /** fetch data from the table: "qx.eFlowStatus" */
  qx_eFlowStatus: Array<qx_eFlowStatus>;
  /** fetch aggregated fields from the table: "qx.eFlowStatus" */
  qx_eFlowStatus_aggregate: qx_eFlowStatus_aggregate;
  /** fetch data from the table: "qx.eFlowStatus" using primary key columns */
  qx_eFlowStatus_by_pk?: qx_eFlowStatus;
  /** fetch data from the table: "qx.eFlowTraceActionStatus" */
  qx_eFlowTraceActionStatus: Array<qx_eFlowTraceActionStatus>;
  /** fetch aggregated fields from the table: "qx.eFlowTraceActionStatus" */
  qx_eFlowTraceActionStatus_aggregate: qx_eFlowTraceActionStatus_aggregate;
  /** fetch data from the table: "qx.eFlowTraceActionStatus" using primary key columns */
  qx_eFlowTraceActionStatus_by_pk?: qx_eFlowTraceActionStatus;
  /** fetch data from the table: "qx.eFlowTraceState" */
  qx_eFlowTraceState: Array<qx_eFlowTraceState>;
  /** fetch aggregated fields from the table: "qx.eFlowTraceState" */
  qx_eFlowTraceState_aggregate: qx_eFlowTraceState_aggregate;
  /** fetch data from the table: "qx.eFlowTraceState" using primary key columns */
  qx_eFlowTraceState_by_pk?: qx_eFlowTraceState;
  /** fetch data from the table: "qx.eIntrusionZoneType" */
  qx_eIntrusionZoneType: Array<qx_eIntrusionZoneType>;
  /** fetch aggregated fields from the table: "qx.eIntrusionZoneType" */
  qx_eIntrusionZoneType_aggregate: qx_eIntrusionZoneType_aggregate;
  /** fetch data from the table: "qx.eIntrusionZoneType" using primary key columns */
  qx_eIntrusionZoneType_by_pk?: qx_eIntrusionZoneType;
  /** fetch data from the table: "qx.eLockMode" */
  qx_eLockMode: Array<qx_eLockMode>;
  /** fetch aggregated fields from the table: "qx.eLockMode" */
  qx_eLockMode_aggregate: qx_eLockMode_aggregate;
  /** fetch data from the table: "qx.eLockMode" using primary key columns */
  qx_eLockMode_by_pk?: qx_eLockMode;
  /** fetch data from the table: "qx.eMercuryMonitorPointLatchModes" */
  qx_eMercuryMonitorPointLatchModes: Array<qx_eMercuryMonitorPointLatchModes>;
  /** fetch aggregated fields from the table: "qx.eMercuryMonitorPointLatchModes" */
  qx_eMercuryMonitorPointLatchModes_aggregate: qx_eMercuryMonitorPointLatchModes_aggregate;
  /** fetch data from the table: "qx.eMercuryMonitorPointLatchModes" using primary key columns */
  qx_eMercuryMonitorPointLatchModes_by_pk?: qx_eMercuryMonitorPointLatchModes;
  /** execute function "qx.event_type_status_values" which returns "qx.eDeviceConnectionStatus" */
  qx_event_type_status_values: Array<qx_eDeviceConnectionStatus>;
  /** execute function "qx.event_type_status_values" and query aggregates on result of table type "qx.eDeviceConnectionStatus" */
  qx_event_type_status_values_aggregate: qx_eDeviceConnectionStatus_aggregate;
  /** execute function "qx.events_by_hour" which returns "qx.vEventsByHour" */
  qx_events_by_hour: Array<qx_vEventsByHour>;
  /** execute function "qx.events_by_hour" and query aggregates on result of table type "qx.vEventsByHour" */
  qx_events_by_hour_aggregate: qx_vEventsByHour_aggregate;
  /** execute function "qx.find_credential_from_place" which returns "qx.Credential" */
  qx_find_credential_from_place: Array<qx_Credential>;
  /** execute function "qx.find_credential_from_place" and query aggregates on result of table type "qx.Credential" */
  qx_find_credential_from_place_aggregate: qx_Credential_aggregate;
  /** execute function "qx.media_profile_oldest_media" which returns "qx.vOldestMedia" */
  qx_media_profile_oldest_media: Array<qx_vOldestMedia>;
  /** execute function "qx.media_profile_oldest_media" and query aggregates on result of table type "qx.vOldestMedia" */
  qx_media_profile_oldest_media_aggregate: qx_vOldestMedia_aggregate;
  /** execute function "qx.place_hierarchy" which returns "qx.vPlaceHierarchy" */
  qx_place_hierarchy: Array<qx_vPlaceHierarchy>;
  /** execute function "qx.place_hierarchy" and query aggregates on result of table type "qx.vPlaceHierarchy" */
  qx_place_hierarchy_aggregate: qx_vPlaceHierarchy_aggregate;
  /** execute function "qx.search_segments" which returns "qx.Segment" */
  qx_search_segments: Array<qx_Segment>;
  /** execute function "qx.search_segments" and query aggregates on result of table type "qx.Segment" */
  qx_search_segments_aggregate: qx_Segment_aggregate;
  /** execute function "qx.search_snapshots" which returns "qx.Snapshot" */
  qx_search_snapshots: Array<qx_Snapshot>;
  /** execute function "qx.search_snapshots" and query aggregates on result of table type "qx.Snapshot" */
  qx_search_snapshots_aggregate: qx_Snapshot_aggregate;
  /** execute function "qx.search_timeline" which returns "qx.vSearchTimeline" */
  qx_search_timeline: Array<qx_vSearchTimeline>;
  /** execute function "qx.search_timeline" and query aggregates on result of table type "qx.vSearchTimeline" */
  qx_search_timeline_aggregate: qx_vSearchTimeline_aggregate;
  /** fetch data from the table: "qx.vChatUsagePerModel" */
  qx_vChatUsagePerModel: Array<qx_vChatUsagePerModel>;
  /** fetch aggregated fields from the table: "qx.vChatUsagePerModel" */
  qx_vChatUsagePerModel_aggregate: qx_vChatUsagePerModel_aggregate;
  /** fetch data from the table: "qx.vChatUsageSeries" */
  qx_vChatUsageSeries: Array<qx_vChatUsageSeries>;
  /** fetch aggregated fields from the table: "qx.vChatUsageSeries" */
  qx_vChatUsageSeries_aggregate: qx_vChatUsageSeries_aggregate;
  /** fetch data from the table: "qx.vDevicePlace" */
  qx_vDevicePlace: Array<qx_vDevicePlace>;
  /** fetch aggregated fields from the table: "qx.vDevicePlace" */
  qx_vDevicePlace_aggregate: qx_vDevicePlace_aggregate;
  /** fetch data from the table: "qx.vDoorAccessByPerson" */
  qx_vDoorAccessByPerson: Array<qx_vDoorAccessByPerson>;
  /** fetch aggregated fields from the table: "qx.vDoorAccessByPerson" */
  qx_vDoorAccessByPerson_aggregate: qx_vDoorAccessByPerson_aggregate;
  /** fetch data from the table: "qx.vEventsByHour" */
  qx_vEventsByHour: Array<qx_vEventsByHour>;
  /** fetch aggregated fields from the table: "qx.vEventsByHour" */
  qx_vEventsByHour_aggregate: qx_vEventsByHour_aggregate;
  /** fetch data from the table: "qx.vNewestMedia" */
  qx_vNewestMedia: Array<qx_vNewestMedia>;
  /** fetch aggregated fields from the table: "qx.vNewestMedia" */
  qx_vNewestMedia_aggregate: qx_vNewestMedia_aggregate;
  /** fetch data from the table: "qx.vOldestMedia" */
  qx_vOldestMedia: Array<qx_vOldestMedia>;
  /** fetch aggregated fields from the table: "qx.vOldestMedia" */
  qx_vOldestMedia_aggregate: qx_vOldestMedia_aggregate;
  /** fetch data from the table: "qx.vPersonAccessHistory" */
  qx_vPersonAccessHistory: Array<qx_vPersonAccessHistory>;
  /** fetch aggregated fields from the table: "qx.vPersonAccessHistory" */
  qx_vPersonAccessHistory_aggregate: qx_vPersonAccessHistory_aggregate;
  /** fetch data from the table: "qx.vPlaceAiBillingSummary" */
  qx_vPlaceAiBillingSummary: Array<qx_vPlaceAiBillingSummary>;
  /** fetch aggregated fields from the table: "qx.vPlaceAiBillingSummary" */
  qx_vPlaceAiBillingSummary_aggregate: qx_vPlaceAiBillingSummary_aggregate;
  /** fetch data from the table: "qx.vPlaceHierarchy" */
  qx_vPlaceHierarchy: Array<qx_vPlaceHierarchy>;
  /** fetch aggregated fields from the table: "qx.vPlaceHierarchy" */
  qx_vPlaceHierarchy_aggregate: qx_vPlaceHierarchy_aggregate;
  /** fetch data from the table: "qx.vPlacePrivilege" */
  qx_vPlacePrivilege: Array<qx_vPlacePrivilege>;
  /** fetch aggregated fields from the table: "qx.vPlacePrivilege" */
  qx_vPlacePrivilege_aggregate: qx_vPlacePrivilege_aggregate;
  /** fetch data from the table: "qx.vProfiles" */
  qx_vProfiles: Array<qx_vProfiles>;
  /** fetch aggregated fields from the table: "qx.vProfiles" */
  qx_vProfiles_aggregate: qx_vProfiles_aggregate;
  /** fetch data from the table: "qx.vSearchTimeline" */
  qx_vSearchTimeline: Array<qx_vSearchTimeline>;
  /** fetch aggregated fields from the table: "qx.vSearchTimeline" */
  qx_vSearchTimeline_aggregate: qx_vSearchTimeline_aggregate;
  /** execute function "qx.video_source_oldest_media" which returns "qx.vOldestMedia" */
  qx_video_source_oldest_media: Array<qx_vOldestMedia>;
  /** execute function "qx.video_source_oldest_media" and query aggregates on result of table type "qx.vOldestMedia" */
  qx_video_source_oldest_media_aggregate: qx_vOldestMedia_aggregate;
  /** fetch data from the table: "qxanalytics.CloudUsage" */
  qxanalytics_CloudUsage: Array<qxanalytics_CloudUsage>;
  /** fetch aggregated fields from the table: "qxanalytics.CloudUsage" */
  qxanalytics_CloudUsage_aggregate: qxanalytics_CloudUsage_aggregate;
  /** fetch data from the table: "qx.Reader" using primary key columns */
  reader?: qx_Reader;
  /** fetch data from the table: "qx.ReaderAccessTypeCompatibility" */
  readerAccessTypeCompatibility: Array<readerAccessTypeCompatibility>;
  /** fetch aggregated fields from the table: "qx.ReaderAccessTypeCompatibility" */
  readerAccessTypeCompatibility_aggregate: readerAccessTypeCompatibility_aggregate;
  /** fetch data from the table: "qx.ReaderAccessTypeCompatibility" using primary key columns */
  readerAccessTypeCompatibility_by_pk?: readerAccessTypeCompatibility;
  /** fetch data from the table: "qx.eReaderAccessType" using primary key columns */
  readerAccessTypeEnum?: qx_eReaderAccessType;
  /** fetch aggregated fields from the table: "qx.eReaderAccessType" */
  readerAccessTypeEnumAggregate: qx_eReaderAccessType_aggregate;
  /** fetch data from the table: "qx.eReaderAccessType" */
  readerAccessTypeEnums: Array<qx_eReaderAccessType>;
  /** fetch aggregated fields from the table: "qx.Reader" */
  readerAggregate: qx_Reader_aggregate;
  /** fetch data from the table: "audit.vReaderAudit" */
  readerAudit: Array<readerAudit>;
  /** fetch aggregated fields from the table: "audit.vReaderAudit" */
  readerAudit_aggregate: readerAudit_aggregate;
  /** fetch data from the table: "qx.ReaderProtocolCompatibility" */
  readerProtocolCompatibility: Array<readerProtocolCompatibility>;
  /** fetch aggregated fields from the table: "qx.ReaderProtocolCompatibility" */
  readerProtocolCompatibility_aggregate: readerProtocolCompatibility_aggregate;
  /** fetch data from the table: "qx.ReaderProtocolCompatibility" using primary key columns */
  readerProtocolCompatibility_by_pk?: readerProtocolCompatibility;
  /** fetch data from the table: "qx.eReaderProtocol" using primary key columns */
  readerProtocolEnum?: qx_eReaderProtocol;
  /** fetch aggregated fields from the table: "qx.eReaderProtocol" */
  readerProtocolEnumAggregate: qx_eReaderProtocol_aggregate;
  /** fetch data from the table: "qx.eReaderProtocol" */
  readerProtocolEnums: Array<qx_eReaderProtocol>;
  /** An array relationship */
  readers: Array<qx_Reader>;
  replicationHealth: SuccessResponse;
  /** fetch data from the table: "qx.eRexState" using primary key columns */
  rexStateEnum?: qx_eRexState;
  /** fetch aggregated fields from the table: "qx.eRexState" */
  rexStateEnumAggregate: qx_eRexState_aggregate;
  /** fetch data from the table: "qx.eRexState" */
  rexStateEnums: Array<qx_eRexState>;
  /** fetch data from the table: "qx.Role" using primary key columns */
  role?: qx_Role;
  /** fetch aggregated fields from the table: "qx.Role" */
  roleAggregate: qx_Role_aggregate;
  /** fetch data from the table: "qx.RoleAppPrivileges" */
  roleAppPrivileges: Array<roleAppPrivileges>;
  /** fetch aggregated fields from the table: "qx.RoleAppPrivileges" */
  roleAppPrivileges_aggregate: roleAppPrivileges_aggregate;
  /** fetch data from the table: "qx.RoleAppPrivileges" using primary key columns */
  roleAppPrivileges_by_pk?: roleAppPrivileges;
  /** fetch data from the table: "audit.vRoleAudit" */
  roleAudit: Array<roleAudit>;
  /** fetch aggregated fields from the table: "audit.vRoleAudit" */
  roleAudit_aggregate: roleAudit_aggregate;
  /** An array relationship */
  roles: Array<qx_Role>;
  /** fetch data from the table: "qx.RosslareCatalog" */
  rosslareCatalogs: Array<rosslareCatalogs>;
  /** fetch aggregated fields from the table: "qx.RosslareCatalog" */
  rosslareCatalogs_aggregate: rosslareCatalogs_aggregate;
  /** fetch data from the table: "qx.RosslareCatalog" using primary key columns */
  rosslareCatalogs_by_pk?: rosslareCatalogs;
  /** fetch data from the table: "qx.RosslareConnection" using primary key columns */
  rosslareConnection?: qx_RosslareConnection;
  /** fetch aggregated fields from the table: "qx.RosslareConnection" */
  rosslareConnectionAggregate: qx_RosslareConnection_aggregate;
  /** fetch data from the table: "qx.RosslareConnection" */
  rosslareConnections: Array<qx_RosslareConnection>;
  /** fetch data from the table: "qx.S3BucketConfiguration" */
  s3BucketConfigurations: Array<s3BucketConfigurations>;
  /** fetch aggregated fields from the table: "qx.S3BucketConfiguration" */
  s3BucketConfigurations_aggregate: s3BucketConfigurations_aggregate;
  /** fetch data from the table: "qx.S3BucketConfiguration" using primary key columns */
  s3BucketConfigurations_by_pk?: s3BucketConfigurations;
  scanSegments?: scanSegments;
  /** fetch data from the table: "qx.Schedule" using primary key columns */
  schedule?: qx_Schedule;
  /** fetch aggregated fields from the table: "qx.Schedule" */
  scheduleAggregate: qx_Schedule_aggregate;
  /** fetch data from the table: "audit.vScheduleAudit" */
  scheduleAudit: Array<scheduleAudit>;
  /** fetch aggregated fields from the table: "audit.vScheduleAudit" */
  scheduleAudit_aggregate: scheduleAudit_aggregate;
  /** fetch data from the table: "qx.ScheduleBlock" using primary key columns */
  scheduleBlock?: qx_ScheduleBlock;
  /** fetch aggregated fields from the table: "qx.ScheduleBlock" */
  scheduleBlockAggregate: qx_ScheduleBlock_aggregate;
  /** fetch data from the table: "audit.vScheduleBlockAudit" */
  scheduleBlockAudit: Array<scheduleBlockAudit>;
  /** fetch aggregated fields from the table: "audit.vScheduleBlockAudit" */
  scheduleBlockAudit_aggregate: scheduleBlockAudit_aggregate;
  /** fetch data from the table: "qx.ScheduleBlock" */
  scheduleBlocks: Array<qx_ScheduleBlock>;
  /** An array relationship */
  schedules: Array<qx_Schedule>;
  /** searchCredentials */
  searchCredentials: CredentialSearchOutput;
  searchSegments: Array<SearchSegmentsOutput>;
  /** searchSnapshots */
  searchSnapshots: Array<SearchSnapshotsOutput>;
  /** fetch data from the table: "qx.Segment" using primary key columns */
  segment?: qx_Segment;
  /** fetch aggregated fields from the table: "qx.Segment" */
  segmentAggregate: qx_Segment_aggregate;
  /** An array relationship */
  segments: Array<qx_Segment>;
  /** fetch data from the table: "qx.Sensor" using primary key columns */
  sensor?: qx_Sensor;
  /** fetch data from the table: "qx.eSensorAction" using primary key columns */
  sensorActionEnum?: qx_eSensorAction;
  /** fetch data from the table: "qx.eSensorAction" */
  sensorActionEnums: Array<qx_eSensorAction>;
  /** fetch aggregated fields from the table: "qx.eSensorAction" */
  sensorActionEnumsAggregate: qx_eSensorAction_aggregate;
  /** fetch aggregated fields from the table: "qx.Sensor" */
  sensorAggregate: qx_Sensor_aggregate;
  /** fetch data from the table: "qx.eSensorType" using primary key columns */
  sensorTypeEnum?: qx_eSensorType;
  /** fetch data from the table: "qx.eSensorType" */
  sensorTypeEnums: Array<qx_eSensorType>;
  /** fetch aggregated fields from the table: "qx.eSensorType" */
  sensorTypeEnumsAggregate: qx_eSensorType_aggregate;
  /** An array relationship */
  sensors: Array<qx_Sensor>;
  setupCameraGateway?: setupCameraGateway;
  /** fetch data from the table: "qx.SharedLinks" using primary key columns */
  sharedLink?: qx_SharedLinks;
  /** fetch aggregated fields from the table: "qx.SharedLinks" */
  sharedLinkAggregate: qx_SharedLinks_aggregate;
  /** fetch aggregated fields from the table: "qx.SharedLinkAuditLog" */
  sharedLinkAuditLogAggregate: qx_SharedLinkAuditLog_aggregate;
  /** fetch data from the table: "qx.SharedLinkAuditLog" */
  sharedLinkAuditLogs: Array<qx_SharedLinkAuditLog>;
  /** An array relationship */
  sharedLinks: Array<qx_SharedLinks>;
  /** fetch data from the table: "qx.Snapshot" using primary key columns */
  snapshot?: qx_Snapshot;
  /** fetch aggregated fields from the table: "qx.Snapshot" */
  snapshotAggregate: qx_Snapshot_aggregate;
  /** An array relationship */
  snapshots: Array<qx_Snapshot>;
  /** fetch data from the table: "qx.eStreamStatus" using primary key columns */
  streamStatusEnum?: qx_eStreamStatus;
  /** fetch aggregated fields from the table: "qx.eStreamStatus" */
  streamStatusEnumAggregate: qx_eStreamStatus_aggregate;
  /** fetch data from the table: "qx.eStreamStatus" */
  streamStatusEnums: Array<qx_eStreamStatus>;
  streamStorageStats: StorageDriveStats;
  /** fetch data from the table: "qx.SuperviseInputCompatibility" */
  superviseInputCompatibility: Array<superviseInputCompatibility>;
  /** fetch aggregated fields from the table: "qx.SuperviseInputCompatibility" */
  superviseInputCompatibility_aggregate: superviseInputCompatibility_aggregate;
  /** fetch data from the table: "qx.SuperviseInputCompatibility" using primary key columns */
  superviseInputCompatibility_by_pk?: superviseInputCompatibility;
  /** fetch data from the table: "qx.eSuperviseInputs" using primary key columns */
  superviseInputsEnum?: qx_eSuperviseInputs;
  /** fetch aggregated fields from the table: "qx.eSuperviseInputs" */
  superviseInputsEnumAggregate: qx_eSuperviseInputs_aggregate;
  /** fetch data from the table: "qx.eSuperviseInputs" */
  superviseInputsEnums: Array<qx_eSuperviseInputs>;
  systemInformation: Array<SysInfo>;
  /** fetch data from the table: "qx.TermsAgreement" using primary key columns */
  termsAgreement?: qx_TermsAgreement;
  /** fetch aggregated fields from the table: "qx.TermsAgreement" */
  termsAgreementAggregate: qx_TermsAgreement_aggregate;
  /** fetch data from the table: "qx.TermsAgreement" */
  termsAgreements: Array<qx_TermsAgreement>;
  /** fetch data from the table: "qx.TimeZone" using primary key columns */
  timeZone?: qx_TimeZone;
  /** fetch aggregated fields from the table: "qx.TimeZone" */
  timeZoneAggregate: qx_TimeZone_aggregate;
  /** fetch data from the table: "qx.TimeZone" */
  timeZones: Array<qx_TimeZone>;
  updateCustomerCanSelfServe?: updateCustomerCanSelfServe;
  updateCustomerPlacePrivileges?: updateCustomerPlacePrivileges;
  uploadStats: UploadStatsResponse;
  /** fetch data from the table: "qx.UserSetting" using primary key columns */
  userSetting?: qx_UserSetting;
  /** An array relationship */
  userSettings: Array<qx_UserSetting>;
  /** fetch aggregated fields from the table: "qx.UserSetting" */
  userSettingsAggregate: qx_UserSetting_aggregate;
  /** fetch data from the table: "qx.vEventStatus" */
  vEventStatuses: Array<vEventStatuses>;
  /** fetch aggregated fields from the table: "qx.vEventStatus" */
  vEventStatuses_aggregate: vEventStatuses_aggregate;
  /** fetch data from the table: "qx.vEvents" */
  vEvents: Array<vEvents>;
  /** fetch aggregated fields from the table: "qx.vEvents" */
  vEvents_aggregate: vEvents_aggregate;
  /** fetch data from the table: "qx.VideoSource" using primary key columns */
  videoSource?: qx_VideoSource;
  /** fetch aggregated fields from the table: "qx.VideoSource" */
  videoSourceAggregate: qx_VideoSource_aggregate;
  /** fetch data from the table: "audit.vVideoSourceAudit" */
  videoSourceAudit: Array<videoSourceAudit>;
  /** fetch aggregated fields from the table: "audit.vVideoSourceAudit" */
  videoSourceAudit_aggregate: videoSourceAudit_aggregate;
  /** fetch data from the table: "qx.VideoSourceState" */
  videoSourceState: Array<videoSourceState>;
  /** fetch aggregated fields from the table: "qx.VideoSourceState" */
  videoSourceState_aggregate: videoSourceState_aggregate;
  /** fetch data from the table: "qx.VideoSourceState" using primary key columns */
  videoSourceState_by_pk?: videoSourceState;
  /** An array relationship */
  videoSources: Array<qx_VideoSource>;
  /** fetch data from the table: "qx.View" using primary key columns */
  view?: qx_View;
  /** An array relationship */
  views: Array<qx_View>;
  /** fetch aggregated fields from the table: "qx.View" */
  viewsAggregate: qx_View_aggregate;
  /** fetch data from the table: "qx.WiegandCardFormat" using primary key columns */
  wiegandCardFormat?: qx_WiegandCardFormat;
  /** fetch aggregated fields from the table: "qx.WiegandCardFormat" */
  wiegandCardFormatAggregate: qx_WiegandCardFormat_aggregate;
  /** fetch data from the table: "qx.WiegandCardFormat" */
  wiegandCardFormats: Array<qx_WiegandCardFormat>;
};


export type query_rootAnalyticSourcesArgs = {
  distinct_on?: Array<AnalyticSources_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<AnalyticSources_order_by>;
  where?: AnalyticSources_bool_exp;
};


export type query_rootAnalyticSources_aggregateArgs = {
  distinct_on?: Array<AnalyticSources_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<AnalyticSources_order_by>;
  where?: AnalyticSources_bool_exp;
};


export type query_rootAnalyticSources_by_pkArgs = {
  value: string;
};


export type query_rootApplicationUserGatewayPasswordArgs = {
  distinct_on?: Array<ApplicationUserGatewayPassword_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<ApplicationUserGatewayPassword_order_by>;
  where?: ApplicationUserGatewayPassword_bool_exp;
};


export type query_rootApplicationUserGatewayPassword_aggregateArgs = {
  distinct_on?: Array<ApplicationUserGatewayPassword_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<ApplicationUserGatewayPassword_order_by>;
  where?: ApplicationUserGatewayPassword_bool_exp;
};


export type query_rootApplicationUserGatewayPassword_by_pkArgs = {
  id: string;
};


export type query_rootApplicationUserTwoFactorArgs = {
  distinct_on?: Array<ApplicationUserTwoFactor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<ApplicationUserTwoFactor_order_by>;
  where?: ApplicationUserTwoFactor_bool_exp;
};


export type query_rootApplicationUserTwoFactor_aggregateArgs = {
  distinct_on?: Array<ApplicationUserTwoFactor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<ApplicationUserTwoFactor_order_by>;
  where?: ApplicationUserTwoFactor_bool_exp;
};


export type query_rootApplicationUserTwoFactor_by_pkArgs = {
  id: string;
};


export type query_rootAuditLogArgs = {
  id: string;
};


export type query_rootAuditLogAggregateArgs = {
  distinct_on?: Array<qx_AuditLog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AuditLog_order_by>;
  where?: qx_AuditLog_bool_exp;
};


export type query_rootAuditLogsArgs = {
  distinct_on?: Array<qx_AuditLog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AuditLog_order_by>;
  where?: qx_AuditLog_bool_exp;
};


export type query_rootDSCConnectionArgs = {
  distinct_on?: Array<DSCConnection_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<DSCConnection_order_by>;
  where?: DSCConnection_bool_exp;
};


export type query_rootDSCConnection_aggregateArgs = {
  distinct_on?: Array<DSCConnection_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<DSCConnection_order_by>;
  where?: DSCConnection_bool_exp;
};


export type query_rootDSCConnection_by_pkArgs = {
  deviceID: string;
};


export type query_rootDeviceDIOArgs = {
  id: string;
};


export type query_rootDeviceDIOsArgs = {
  distinct_on?: Array<qx_DeviceDIO_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DeviceDIO_order_by>;
  where?: qx_DeviceDIO_bool_exp;
};


export type query_rootDeviceDioAggregateArgs = {
  distinct_on?: Array<qx_DeviceDIO_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DeviceDIO_order_by>;
  where?: qx_DeviceDIO_bool_exp;
};


export type query_rootIntrusionAccessCodeArgs = {
  distinct_on?: Array<IntrusionAccessCode_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<IntrusionAccessCode_order_by>;
  where?: IntrusionAccessCode_bool_exp;
};


export type query_rootIntrusionAccessCode_aggregateArgs = {
  distinct_on?: Array<IntrusionAccessCode_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<IntrusionAccessCode_order_by>;
  where?: IntrusionAccessCode_bool_exp;
};


export type query_rootIntrusionAccessCode_by_pkArgs = {
  id: string;
};


export type query_rootIntrusionPartitionArgs = {
  distinct_on?: Array<IntrusionPartition_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<IntrusionPartition_order_by>;
  where?: IntrusionPartition_bool_exp;
};


export type query_rootIntrusionPartition_aggregateArgs = {
  distinct_on?: Array<IntrusionPartition_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<IntrusionPartition_order_by>;
  where?: IntrusionPartition_bool_exp;
};


export type query_rootIntrusionPartition_by_pkArgs = {
  id: string;
};


export type query_rootIntrusionZoneArgs = {
  distinct_on?: Array<IntrusionZone_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<IntrusionZone_order_by>;
  where?: IntrusionZone_bool_exp;
};


export type query_rootIntrusionZone_aggregateArgs = {
  distinct_on?: Array<IntrusionZone_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<IntrusionZone_order_by>;
  where?: IntrusionZone_bool_exp;
};


export type query_rootIntrusionZone_by_pkArgs = {
  id: string;
};


export type query_rootPartitionZoneAssignmentsArgs = {
  distinct_on?: Array<PartitionZoneAssignments_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<PartitionZoneAssignments_order_by>;
  where?: PartitionZoneAssignments_bool_exp;
};


export type query_rootPartitionZoneAssignments_aggregateArgs = {
  distinct_on?: Array<PartitionZoneAssignments_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<PartitionZoneAssignments_order_by>;
  where?: PartitionZoneAssignments_bool_exp;
};


export type query_rootPartitionZoneAssignments_by_pkArgs = {
  id: string;
};


export type query_rootPassKeyProviderArgs = {
  distinct_on?: Array<PassKeyProvider_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<PassKeyProvider_order_by>;
  where?: PassKeyProvider_bool_exp;
};


export type query_rootPassKeyProvider_aggregateArgs = {
  distinct_on?: Array<PassKeyProvider_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<PassKeyProvider_order_by>;
  where?: PassKeyProvider_bool_exp;
};


export type query_rootPassKeyProvider_by_pkArgs = {
  aaguid: string;
};


export type query_rootPermissionPartitionAssignmentsArgs = {
  distinct_on?: Array<PermissionPartitionAssignments_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<PermissionPartitionAssignments_order_by>;
  where?: PermissionPartitionAssignments_bool_exp;
};


export type query_rootPermissionPartitionAssignments_aggregateArgs = {
  distinct_on?: Array<PermissionPartitionAssignments_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<PermissionPartitionAssignments_order_by>;
  where?: PermissionPartitionAssignments_bool_exp;
};


export type query_rootPermissionPartitionAssignments_by_pkArgs = {
  id: string;
};


export type query_rootPersonTermsAgreementArgs = {
  distinct_on?: Array<PersonTermsAgreement_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<PersonTermsAgreement_order_by>;
  where?: PersonTermsAgreement_bool_exp;
};


export type query_rootPersonTermsAgreement_aggregateArgs = {
  distinct_on?: Array<PersonTermsAgreement_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<PersonTermsAgreement_order_by>;
  where?: PersonTermsAgreement_bool_exp;
};


export type query_rootPersonTermsAgreement_by_pkArgs = {
  email: string;
};


export type query_rootaccessBoardTypeEnumArgs = {
  value: string;
};


export type query_rootaccessBoardTypeEnumAggregateArgs = {
  distinct_on?: Array<qx_eAccessBoardType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessBoardType_order_by>;
  where?: qx_eAccessBoardType_bool_exp;
};


export type query_rootaccessBoardTypeEnumsArgs = {
  distinct_on?: Array<qx_eAccessBoardType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessBoardType_order_by>;
  where?: qx_eAccessBoardType_bool_exp;
};


export type query_rootaccessCatalogArgs = {
  id: string;
};


export type query_rootaccessCatalogAggregateArgs = {
  distinct_on?: Array<qx_AccessCatalog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessCatalog_order_by>;
  where?: qx_AccessCatalog_bool_exp;
};


export type query_rootaccessCatalogsArgs = {
  distinct_on?: Array<qx_AccessCatalog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessCatalog_order_by>;
  where?: qx_AccessCatalog_bool_exp;
};


export type query_rootaccessDeniedReasonEnumArgs = {
  value: string;
};


export type query_rootaccessDeniedReasonEnumAggregateArgs = {
  distinct_on?: Array<qx_eAccessDeniedReason_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessDeniedReason_order_by>;
  where?: qx_eAccessDeniedReason_bool_exp;
};


export type query_rootaccessDeniedReasonEnumsArgs = {
  distinct_on?: Array<qx_eAccessDeniedReason_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessDeniedReason_order_by>;
  where?: qx_eAccessDeniedReason_bool_exp;
};


export type query_rootaccessInterfaceTypeEnumArgs = {
  value: string;
};


export type query_rootaccessInterfaceTypeEnumAggregateArgs = {
  distinct_on?: Array<qx_eAccessInterfaceType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessInterfaceType_order_by>;
  where?: qx_eAccessInterfaceType_bool_exp;
};


export type query_rootaccessInterfaceTypeEnumsArgs = {
  distinct_on?: Array<qx_eAccessInterfaceType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessInterfaceType_order_by>;
  where?: qx_eAccessInterfaceType_bool_exp;
};


export type query_rootaccessInventoriesArgs = {
  distinct_on?: Array<qx_AccessInventory_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessInventory_order_by>;
  where?: qx_AccessInventory_bool_exp;
};


export type query_rootaccessInventoryArgs = {
  id: string;
};


export type query_rootaccessInventoryAggregateArgs = {
  distinct_on?: Array<qx_AccessInventory_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessInventory_order_by>;
  where?: qx_AccessInventory_bool_exp;
};


export type query_rootaccessPointActionEnumArgs = {
  value: string;
};


export type query_rootaccessPointActionEnumAggregateArgs = {
  distinct_on?: Array<qx_eAccessPointAction_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessPointAction_order_by>;
  where?: qx_eAccessPointAction_bool_exp;
};


export type query_rootaccessPointActionEnumsArgs = {
  distinct_on?: Array<qx_eAccessPointAction_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessPointAction_order_by>;
  where?: qx_eAccessPointAction_bool_exp;
};


export type query_rootaccessPointDirectionEnumArgs = {
  value: string;
};


export type query_rootaccessPointDirectionEnumAggregateArgs = {
  distinct_on?: Array<qx_eAccessPointDirection_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessPointDirection_order_by>;
  where?: qx_eAccessPointDirection_bool_exp;
};


export type query_rootaccessPointDirectionEnumsArgs = {
  distinct_on?: Array<qx_eAccessPointDirection_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessPointDirection_order_by>;
  where?: qx_eAccessPointDirection_bool_exp;
};


export type query_rootaccessPointTypeEnumArgs = {
  value: string;
};


export type query_rootaccessPointTypeEnumAggregateArgs = {
  distinct_on?: Array<qx_eAccessPointType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessPointType_order_by>;
  where?: qx_eAccessPointType_bool_exp;
};


export type query_rootaccessPointTypeEnumsArgs = {
  distinct_on?: Array<qx_eAccessPointType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessPointType_order_by>;
  where?: qx_eAccessPointType_bool_exp;
};


export type query_rootanalyticAttributePropertiesArgs = {
  distinct_on?: Array<analyticAttributeProperties_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticAttributeProperties_order_by>;
  where?: analyticAttributeProperties_bool_exp;
};


export type query_rootanalyticAttributeProperties_aggregateArgs = {
  distinct_on?: Array<analyticAttributeProperties_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticAttributeProperties_order_by>;
  where?: analyticAttributeProperties_bool_exp;
};


export type query_rootanalyticAttributeProperties_by_pkArgs = {
  analyticAttributeID: string;
  attributePropertyValue: string;
};


export type query_rootanalyticAttributesArgs = {
  distinct_on?: Array<analyticAttributes_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticAttributes_order_by>;
  where?: analyticAttributes_bool_exp;
};


export type query_rootanalyticAttributes_aggregateArgs = {
  distinct_on?: Array<analyticAttributes_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticAttributes_order_by>;
  where?: analyticAttributes_bool_exp;
};


export type query_rootanalyticAttributes_by_pkArgs = {
  id: string;
};


export type query_rootanalyticDetectedPropertiesArgs = {
  distinct_on?: Array<analyticDetectedProperties_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticDetectedProperties_order_by>;
  where?: analyticDetectedProperties_bool_exp;
};


export type query_rootanalyticDetectedProperties_aggregateArgs = {
  distinct_on?: Array<analyticDetectedProperties_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticDetectedProperties_order_by>;
  where?: analyticDetectedProperties_bool_exp;
};


export type query_rootanalyticDetectedProperties_by_pkArgs = {
  id: string;
};


export type query_rootanalyticTypesArgs = {
  distinct_on?: Array<analyticTypes_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticTypes_order_by>;
  where?: analyticTypes_bool_exp;
};


export type query_rootanalyticTypes_aggregateArgs = {
  distinct_on?: Array<analyticTypes_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticTypes_order_by>;
  where?: analyticTypes_bool_exp;
};


export type query_rootanalyticTypes_by_pkArgs = {
  type: string;
};


export type query_rootanalyticsArgs = {
  distinct_on?: Array<analytics_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analytics_order_by>;
  where?: analytics_bool_exp;
};


export type query_rootanalytics_aggregateArgs = {
  distinct_on?: Array<analytics_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analytics_order_by>;
  where?: analytics_bool_exp;
};


export type query_rootanalytics_by_pkArgs = {
  id: string;
};


export type query_rootapplicationUserAppPasswordsArgs = {
  distinct_on?: Array<applicationUserAppPasswords_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<applicationUserAppPasswords_order_by>;
  where?: applicationUserAppPasswords_bool_exp;
};


export type query_rootapplicationUserAppPasswords_aggregateArgs = {
  distinct_on?: Array<applicationUserAppPasswords_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<applicationUserAppPasswords_order_by>;
  where?: applicationUserAppPasswords_bool_exp;
};


export type query_rootapplicationUserAppPasswords_by_pkArgs = {
  id: string;
};


export type query_rootapplicationUserDevicesArgs = {
  distinct_on?: Array<applicationUserDevices_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<applicationUserDevices_order_by>;
  where?: applicationUserDevices_bool_exp;
};


export type query_rootapplicationUserDevices_aggregateArgs = {
  distinct_on?: Array<applicationUserDevices_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<applicationUserDevices_order_by>;
  where?: applicationUserDevices_bool_exp;
};


export type query_rootapplicationUserDevices_by_pkArgs = {
  id: string;
};


export type query_rootattributePropertiesArgs = {
  distinct_on?: Array<attributeProperties_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<attributeProperties_order_by>;
  where?: attributeProperties_bool_exp;
};


export type query_rootattributeProperties_aggregateArgs = {
  distinct_on?: Array<attributeProperties_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<attributeProperties_order_by>;
  where?: attributeProperties_bool_exp;
};


export type query_rootattributeProperties_by_pkArgs = {
  value: string;
};


export type query_rootattributesArgs = {
  distinct_on?: Array<attributes_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<attributes_order_by>;
  where?: attributes_bool_exp;
};


export type query_rootattributes_aggregateArgs = {
  distinct_on?: Array<attributes_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<attributes_order_by>;
  where?: attributes_bool_exp;
};


export type query_rootattributes_by_pkArgs = {
  type: string;
};


export type query_rootaudioSourceArgs = {
  id: string;
};


export type query_rootaudioSourceAggregateArgs = {
  distinct_on?: Array<qx_AudioSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AudioSource_order_by>;
  where?: qx_AudioSource_bool_exp;
};


export type query_rootaudioSourceAuditArgs = {
  distinct_on?: Array<audioSourceAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<audioSourceAudit_order_by>;
  where?: audioSourceAudit_bool_exp;
};


export type query_rootaudioSourceAudit_aggregateArgs = {
  distinct_on?: Array<audioSourceAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<audioSourceAudit_order_by>;
  where?: audioSourceAudit_bool_exp;
};


export type query_rootaudioSourceVideoSourceArgs = {
  distinct_on?: Array<audioSourceVideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<audioSourceVideoSource_order_by>;
  where?: audioSourceVideoSource_bool_exp;
};


export type query_rootaudioSourceVideoSource_aggregateArgs = {
  distinct_on?: Array<audioSourceVideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<audioSourceVideoSource_order_by>;
  where?: audioSourceVideoSource_bool_exp;
};


export type query_rootaudioSourcesArgs = {
  distinct_on?: Array<qx_AudioSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AudioSource_order_by>;
  where?: qx_AudioSource_bool_exp;
};


export type query_rootaudit_logged_actionsArgs = {
  distinct_on?: Array<audit_logged_actions_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<audit_logged_actions_order_by>;
  where?: audit_logged_actions_bool_exp;
};


export type query_rootaudit_logged_actions_aggregateArgs = {
  distinct_on?: Array<audit_logged_actions_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<audit_logged_actions_order_by>;
  where?: audit_logged_actions_bool_exp;
};


export type query_rootaudit_logged_actions_by_pkArgs = {
  event_id: string;
};


export type query_rootaudit_vSensorAuditArgs = {
  distinct_on?: Array<audit_vSensorAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<audit_vSensorAudit_order_by>;
  where?: audit_vSensorAudit_bool_exp;
};


export type query_rootaudit_vSensorAudit_aggregateArgs = {
  distinct_on?: Array<audit_vSensorAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<audit_vSensorAudit_order_by>;
  where?: audit_vSensorAudit_bool_exp;
};


export type query_rootauditableActionsArgs = {
  distinct_on?: Array<qx_AuditableAction_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AuditableAction_order_by>;
  where?: qx_AuditableAction_bool_exp;
};


export type query_rootauditableTypesArgs = {
  distinct_on?: Array<qx_AuditableType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AuditableType_order_by>;
  where?: qx_AuditableType_bool_exp;
};


export type query_rootauthStrategyEnumArgs = {
  value: string;
};


export type query_rootauthStrategyEnumAggregateArgs = {
  distinct_on?: Array<qx_eAuthStrategy_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAuthStrategy_order_by>;
  where?: qx_eAuthStrategy_bool_exp;
};


export type query_rootauthStrategyEnumsArgs = {
  distinct_on?: Array<qx_eAuthStrategy_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAuthStrategy_order_by>;
  where?: qx_eAuthStrategy_bool_exp;
};


export type query_rootaxisBodyWornUserListArgs = {
  deviceID: string;
};


export type query_rootbatteryLevelEnumArgs = {
  value: string;
};


export type query_rootbatteryLevelEnumAggregateArgs = {
  distinct_on?: Array<qx_eBatteryLevel_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eBatteryLevel_order_by>;
  where?: qx_eBatteryLevel_bool_exp;
};


export type query_rootbatteryLevelEnumsArgs = {
  distinct_on?: Array<qx_eBatteryLevel_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eBatteryLevel_order_by>;
  where?: qx_eBatteryLevel_bool_exp;
};


export type query_rootbaudrateEnumArgs = {
  value: string;
};


export type query_rootbaudrateEnumAggregateArgs = {
  distinct_on?: Array<qx_eBaudrate_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eBaudrate_order_by>;
  where?: qx_eBaudrate_bool_exp;
};


export type query_rootbaudrateEnumsArgs = {
  distinct_on?: Array<qx_eBaudrate_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eBaudrate_order_by>;
  where?: qx_eBaudrate_bool_exp;
};


export type query_rootbillingPeriodArgs = {
  billingPeriodMonths: number;
};


export type query_rootbillingPeriodAggregateArgs = {
  distinct_on?: Array<qx_BillingPeriod_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_BillingPeriod_order_by>;
  where?: qx_BillingPeriod_bool_exp;
};


export type query_rootbillingPeriodsArgs = {
  distinct_on?: Array<qx_BillingPeriod_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_BillingPeriod_order_by>;
  where?: qx_BillingPeriod_bool_exp;
};


export type query_rootbillingTierEnumArgs = {
  value: string;
};


export type query_rootbillingTierEnumAggregateArgs = {
  distinct_on?: Array<qx_eBillingTier_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eBillingTier_order_by>;
  where?: qx_eBillingTier_bool_exp;
};


export type query_rootbillingTierEnumsArgs = {
  distinct_on?: Array<qx_eBillingTier_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eBillingTier_order_by>;
  where?: qx_eBillingTier_bool_exp;
};


export type query_rootchatBillingByModelAggregateArgs = {
  distinct_on?: Array<qx_vChatBillingByModel_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatBillingByModel_order_by>;
  where?: qx_vChatBillingByModel_bool_exp;
};


export type query_rootchatBillingByModelsArgs = {
  distinct_on?: Array<qx_vChatBillingByModel_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatBillingByModel_order_by>;
  where?: qx_vChatBillingByModel_bool_exp;
};


export type query_rootchatBillingSummariesArgs = {
  distinct_on?: Array<qx_vChatBillingSummary_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatBillingSummary_order_by>;
  where?: qx_vChatBillingSummary_bool_exp;
};


export type query_rootchatBillingSummaryAggregateArgs = {
  distinct_on?: Array<qx_vChatBillingSummary_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatBillingSummary_order_by>;
  where?: qx_vChatBillingSummary_bool_exp;
};


export type query_rootchatPromptUsageAggregateArgs = {
  distinct_on?: Array<qx_vChatPromptUsage_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatPromptUsage_order_by>;
  where?: qx_vChatPromptUsage_bool_exp;
};


export type query_rootchatPromptUsagesArgs = {
  distinct_on?: Array<qx_vChatPromptUsage_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatPromptUsage_order_by>;
  where?: qx_vChatPromptUsage_bool_exp;
};


export type query_rootchatUsageHistoriesArgs = {
  distinct_on?: Array<qx_ChatUsageHistory_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ChatUsageHistory_order_by>;
  where?: qx_ChatUsageHistory_bool_exp;
};


export type query_rootchatUsageHistoryArgs = {
  id: any;
};


export type query_rootchatUsageHistoryAggregateArgs = {
  distinct_on?: Array<qx_ChatUsageHistory_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ChatUsageHistory_order_by>;
  where?: qx_ChatUsageHistory_bool_exp;
};


export type query_rootchat_usage_per_modelArgs = {
  args?: qx_chat_usage_per_model_args;
  distinct_on?: Array<qx_vChatUsagePerModel_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatUsagePerModel_order_by>;
  where?: qx_vChatUsagePerModel_bool_exp;
};


export type query_rootchat_usage_seriesArgs = {
  args: qx_chat_usage_series_args;
  distinct_on?: Array<qx_vChatUsageSeries_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatUsageSeries_order_by>;
  where?: qx_vChatUsageSeries_bool_exp;
};


export type query_rootclipArgs = {
  id: string;
};


export type query_rootclipAggregateArgs = {
  distinct_on?: Array<qx_Clip_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Clip_order_by>;
  where?: qx_Clip_bool_exp;
};


export type query_rootclipAuditLogAggregateArgs = {
  distinct_on?: Array<qx_ClipAuditLog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ClipAuditLog_order_by>;
  where?: qx_ClipAuditLog_bool_exp;
};


export type query_rootclipAuditLogsArgs = {
  distinct_on?: Array<qx_ClipAuditLog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ClipAuditLog_order_by>;
  where?: qx_ClipAuditLog_bool_exp;
};


export type query_rootclipStatusReasonEnumArgs = {
  value: string;
};


export type query_rootclipStatusReasonEnumAggregateArgs = {
  distinct_on?: Array<qx_eClipStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eClipStatus_order_by>;
  where?: qx_eClipStatus_bool_exp;
};


export type query_rootclipStatusReasonEnumsArgs = {
  distinct_on?: Array<qx_eClipStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eClipStatus_order_by>;
  where?: qx_eClipStatus_bool_exp;
};


export type query_rootclipTypeEnumArgs = {
  value: string;
};


export type query_rootclipTypeEnumAggregateArgs = {
  distinct_on?: Array<qx_eClipType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eClipType_order_by>;
  where?: qx_eClipType_bool_exp;
};


export type query_rootclipTypeEnumsArgs = {
  distinct_on?: Array<qx_eClipType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eClipType_order_by>;
  where?: qx_eClipType_bool_exp;
};


export type query_rootclipsArgs = {
  distinct_on?: Array<qx_Clip_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Clip_order_by>;
  where?: qx_Clip_bool_exp;
};


export type query_rootcloudPeersArgs = {
  gatewayID?: string;
};


export type query_rootcloudStorageOptionArgs = {
  cloudStorageDays: number;
};


export type query_rootcloudStorageOptionsArgs = {
  distinct_on?: Array<qx_CloudStorageOptions_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_CloudStorageOptions_order_by>;
  where?: qx_CloudStorageOptions_bool_exp;
};


export type query_rootcloudStorageOptionsAggregateArgs = {
  distinct_on?: Array<qx_CloudStorageOptions_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_CloudStorageOptions_order_by>;
  where?: qx_CloudStorageOptions_bool_exp;
};


export type query_rootcloudStorageTimelapseOptionsArgs = {
  distinct_on?: Array<cloudStorageTimelapseOptions_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<cloudStorageTimelapseOptions_order_by>;
  where?: cloudStorageTimelapseOptions_bool_exp;
};


export type query_rootcloudStorageTimelapseOptions_aggregateArgs = {
  distinct_on?: Array<cloudStorageTimelapseOptions_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<cloudStorageTimelapseOptions_order_by>;
  where?: cloudStorageTimelapseOptions_bool_exp;
};


export type query_rootcloudStorageTimelapseOptions_by_pkArgs = {
  cloudStorageDays: number;
};


export type query_rootcredentialArgs = {
  id: string;
};


export type query_rootcredentialAggregateArgs = {
  distinct_on?: Array<qx_Credential_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Credential_order_by>;
  where?: qx_Credential_bool_exp;
};


export type query_rootcredentialAuditArgs = {
  distinct_on?: Array<credentialAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<credentialAudit_order_by>;
  where?: credentialAudit_bool_exp;
};


export type query_rootcredentialAudit_aggregateArgs = {
  distinct_on?: Array<credentialAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<credentialAudit_order_by>;
  where?: credentialAudit_bool_exp;
};


export type query_rootcredentialTypeEnumArgs = {
  value: string;
};


export type query_rootcredentialTypeEnumAggregateArgs = {
  distinct_on?: Array<qx_eCredentialType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eCredentialType_order_by>;
  where?: qx_eCredentialType_bool_exp;
};


export type query_rootcredentialTypeEnumsArgs = {
  distinct_on?: Array<qx_eCredentialType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eCredentialType_order_by>;
  where?: qx_eCredentialType_bool_exp;
};


export type query_rootcredentialsArgs = {
  distinct_on?: Array<qx_Credential_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Credential_order_by>;
  where?: qx_Credential_bool_exp;
};


export type query_rootcustomerPermissionArgs = {
  customerPlaceID: string;
};


export type query_rootcustomerPermissionAggregateArgs = {
  distinct_on?: Array<qx_CustomerPermission_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_CustomerPermission_order_by>;
  where?: qx_CustomerPermission_bool_exp;
};


export type query_rootcustomerPermissionAuditArgs = {
  distinct_on?: Array<customerPermissionAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<customerPermissionAudit_order_by>;
  where?: customerPermissionAudit_bool_exp;
};


export type query_rootcustomerPermissionAudit_aggregateArgs = {
  distinct_on?: Array<customerPermissionAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<customerPermissionAudit_order_by>;
  where?: customerPermissionAudit_bool_exp;
};


export type query_rootcustomerPermissionsArgs = {
  distinct_on?: Array<qx_CustomerPermission_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_CustomerPermission_order_by>;
  where?: qx_CustomerPermission_bool_exp;
};


export type query_rootdeviceArgs = {
  id: string;
};


export type query_rootdeviceAggregateArgs = {
  distinct_on?: Array<qx_Device_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Device_order_by>;
  where?: qx_Device_bool_exp;
};


export type query_rootdeviceAnalyticSourceArgs = {
  distinct_on?: Array<deviceAnalyticSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<deviceAnalyticSource_order_by>;
  where?: deviceAnalyticSource_bool_exp;
};


export type query_rootdeviceAnalyticSource_aggregateArgs = {
  distinct_on?: Array<deviceAnalyticSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<deviceAnalyticSource_order_by>;
  where?: deviceAnalyticSource_bool_exp;
};


export type query_rootdeviceAnalyticSource_by_pkArgs = {
  id: number;
};


export type query_rootdeviceAuditArgs = {
  distinct_on?: Array<deviceAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<deviceAudit_order_by>;
  where?: deviceAudit_bool_exp;
};


export type query_rootdeviceAudit_aggregateArgs = {
  distinct_on?: Array<deviceAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<deviceAudit_order_by>;
  where?: deviceAudit_bool_exp;
};


export type query_rootdeviceConnectionStatusEnumArgs = {
  value: string;
};


export type query_rootdeviceConnectionStatusEnumAggregateArgs = {
  distinct_on?: Array<qx_eDeviceConnectionStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDeviceConnectionStatus_order_by>;
  where?: qx_eDeviceConnectionStatus_bool_exp;
};


export type query_rootdeviceConnectionStatusEnumsArgs = {
  distinct_on?: Array<qx_eDeviceConnectionStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDeviceConnectionStatus_order_by>;
  where?: qx_eDeviceConnectionStatus_bool_exp;
};


export type query_rootdeviceDIOAuditArgs = {
  distinct_on?: Array<deviceDIOAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<deviceDIOAudit_order_by>;
  where?: deviceDIOAudit_bool_exp;
};


export type query_rootdeviceDIOAudit_aggregateArgs = {
  distinct_on?: Array<deviceDIOAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<deviceDIOAudit_order_by>;
  where?: deviceDIOAudit_bool_exp;
};


export type query_rootdeviceKindEnumArgs = {
  value: string;
};


export type query_rootdeviceKindEnumAggregateArgs = {
  distinct_on?: Array<qx_eDeviceKind_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDeviceKind_order_by>;
  where?: qx_eDeviceKind_bool_exp;
};


export type query_rootdeviceKindEnumsArgs = {
  distinct_on?: Array<qx_eDeviceKind_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDeviceKind_order_by>;
  where?: qx_eDeviceKind_bool_exp;
};


export type query_rootdevicesArgs = {
  distinct_on?: Array<qx_Device_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Device_order_by>;
  where?: qx_Device_bool_exp;
};


export type query_rootdioNormalStateEnumArgs = {
  value: string;
};


export type query_rootdioNormalStateEnumAggregateArgs = {
  distinct_on?: Array<qx_eDIONormalState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDIONormalState_order_by>;
  where?: qx_eDIONormalState_bool_exp;
};


export type query_rootdioNormalStateEnumsArgs = {
  distinct_on?: Array<qx_eDIONormalState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDIONormalState_order_by>;
  where?: qx_eDIONormalState_bool_exp;
};


export type query_rootdioStateEnumArgs = {
  value: string;
};


export type query_rootdioStateEnumAggregateArgs = {
  distinct_on?: Array<qx_eDIOState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDIOState_order_by>;
  where?: qx_eDIOState_bool_exp;
};


export type query_rootdioStateEnumsArgs = {
  distinct_on?: Array<qx_eDIOState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDIOState_order_by>;
  where?: qx_eDIOState_bool_exp;
};


export type query_rootdioTypeEnumArgs = {
  value: string;
};


export type query_rootdioTypeEnumAggregateArgs = {
  distinct_on?: Array<qx_eDIOType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDIOType_order_by>;
  where?: qx_eDIOType_bool_exp;
};


export type query_rootdioTypeEnumsArgs = {
  distinct_on?: Array<qx_eDIOType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDIOType_order_by>;
  where?: qx_eDIOType_bool_exp;
};


export type query_rootdiscoverArgs = {
  driver: DiscoveryType;
  forceRefresh?: boolean;
  gatewayID?: string;
};


export type query_rootdiscoveryTypesArgs = {
  distinct_on?: Array<qx_DiscoveryType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DiscoveryType_order_by>;
  where?: qx_DiscoveryType_bool_exp;
};


export type query_rootdiskStorageStatsArgs = {
  gatewayID?: string;
};


export type query_rootdoorArgs = {
  id: string;
};


export type query_rootdoorAggregateArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


export type query_rootdoorAlarmEnumArgs = {
  value: string;
};


export type query_rootdoorAlarmEnumAggregateArgs = {
  distinct_on?: Array<qx_eDoorAlarm_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDoorAlarm_order_by>;
  where?: qx_eDoorAlarm_bool_exp;
};


export type query_rootdoorAlarmEnumsArgs = {
  distinct_on?: Array<qx_eDoorAlarm_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDoorAlarm_order_by>;
  where?: qx_eDoorAlarm_bool_exp;
};


export type query_rootdoorAuditArgs = {
  distinct_on?: Array<doorAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<doorAudit_order_by>;
  where?: doorAudit_bool_exp;
};


export type query_rootdoorAudit_aggregateArgs = {
  distinct_on?: Array<doorAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<doorAudit_order_by>;
  where?: doorAudit_bool_exp;
};


export type query_rootdoorConfigurationArgs = {
  id: string;
};


export type query_rootdoorConfigurationAggregateArgs = {
  distinct_on?: Array<qx_DoorConfiguration_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DoorConfiguration_order_by>;
  where?: qx_DoorConfiguration_bool_exp;
};


export type query_rootdoorConfigurationsArgs = {
  distinct_on?: Array<qx_DoorConfiguration_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DoorConfiguration_order_by>;
  where?: qx_DoorConfiguration_bool_exp;
};


export type query_rootdoorMetaArgs = {
  id: string;
};


export type query_rootdoorMetaAggregateArgs = {
  distinct_on?: Array<qx_DoorMeta_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DoorMeta_order_by>;
  where?: qx_DoorMeta_bool_exp;
};


export type query_rootdoorMetasArgs = {
  distinct_on?: Array<qx_DoorMeta_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DoorMeta_order_by>;
  where?: qx_DoorMeta_bool_exp;
};


export type query_rootdoorModeEnumArgs = {
  value: string;
};


export type query_rootdoorModeEnumAggregateArgs = {
  distinct_on?: Array<qx_eDoorMode_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDoorMode_order_by>;
  where?: qx_eDoorMode_bool_exp;
};


export type query_rootdoorModeEnumsArgs = {
  distinct_on?: Array<qx_eDoorMode_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDoorMode_order_by>;
  where?: qx_eDoorMode_bool_exp;
};


export type query_rootdoorMonitorEnumArgs = {
  value: string;
};


export type query_rootdoorMonitorEnumAggregateArgs = {
  distinct_on?: Array<qx_eDoorMonitor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDoorMonitor_order_by>;
  where?: qx_eDoorMonitor_bool_exp;
};


export type query_rootdoorMonitorEnumsArgs = {
  distinct_on?: Array<qx_eDoorMonitor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDoorMonitor_order_by>;
  where?: qx_eDoorMonitor_bool_exp;
};


export type query_rootdoorStateEnumArgs = {
  value: string;
};


export type query_rootdoorStateEnumAggregateArgs = {
  distinct_on?: Array<qx_eDoorState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDoorState_order_by>;
  where?: qx_eDoorState_bool_exp;
};


export type query_rootdoorStateEnumsArgs = {
  distinct_on?: Array<qx_eDoorState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDoorState_order_by>;
  where?: qx_eDoorState_bool_exp;
};


export type query_rootdoorTemplateArgs = {
  id: string;
};


export type query_rootdoorTemplateAggregateArgs = {
  distinct_on?: Array<qx_DoorTemplate_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DoorTemplate_order_by>;
  where?: qx_DoorTemplate_bool_exp;
};


export type query_rootdoorTemplatesArgs = {
  distinct_on?: Array<qx_DoorTemplate_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DoorTemplate_order_by>;
  where?: qx_DoorTemplate_bool_exp;
};


export type query_rootdoorsArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


export type query_rooteAnalyticIntegrationsArgs = {
  distinct_on?: Array<eAnalyticIntegrations_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<eAnalyticIntegrations_order_by>;
  where?: eAnalyticIntegrations_bool_exp;
};


export type query_rooteAnalyticIntegrations_aggregateArgs = {
  distinct_on?: Array<eAnalyticIntegrations_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<eAnalyticIntegrations_order_by>;
  where?: eAnalyticIntegrations_bool_exp;
};


export type query_rooteAnalyticIntegrations_by_pkArgs = {
  value: string;
};


export type query_rooteAnalyticStatesArgs = {
  distinct_on?: Array<eAnalyticStates_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<eAnalyticStates_order_by>;
  where?: eAnalyticStates_bool_exp;
};


export type query_rooteAnalyticStates_aggregateArgs = {
  distinct_on?: Array<eAnalyticStates_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<eAnalyticStates_order_by>;
  where?: eAnalyticStates_bool_exp;
};


export type query_rooteAnalyticStates_by_pkArgs = {
  value: string;
};


export type query_rooteGatewayTypeArgs = {
  distinct_on?: Array<eGatewayType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<eGatewayType_order_by>;
  where?: eGatewayType_bool_exp;
};


export type query_rooteGatewayType_aggregateArgs = {
  distinct_on?: Array<eGatewayType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<eGatewayType_order_by>;
  where?: eGatewayType_bool_exp;
};


export type query_rooteGatewayType_by_pkArgs = {
  value: string;
};


export type query_rooteS3BucketTypeArgs = {
  distinct_on?: Array<eS3BucketType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<eS3BucketType_order_by>;
  where?: eS3BucketType_bool_exp;
};


export type query_rooteS3BucketType_aggregateArgs = {
  distinct_on?: Array<eS3BucketType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<eS3BucketType_order_by>;
  where?: eS3BucketType_bool_exp;
};


export type query_rooteS3BucketType_by_pkArgs = {
  value: string;
};


export type query_rooteventArgs = {
  id: string;
  serverTime: string;
};


export type query_rooteventAggregateArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};


export type query_rooteventTypeArgs = {
  type: string;
};


export type query_rooteventTypeAggregateArgs = {
  distinct_on?: Array<qx_EventType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_EventType_order_by>;
  where?: qx_EventType_bool_exp;
};


export type query_rooteventTypesArgs = {
  distinct_on?: Array<qx_EventType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_EventType_order_by>;
  where?: qx_EventType_bool_exp;
};


export type query_rooteventsArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};


export type query_rootflowArgs = {
  id: string;
};


export type query_rootflowAggregateArgs = {
  distinct_on?: Array<qx_Flow_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Flow_order_by>;
  where?: qx_Flow_bool_exp;
};


export type query_rootflowAuditArgs = {
  distinct_on?: Array<flowAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<flowAudit_order_by>;
  where?: flowAudit_bool_exp;
};


export type query_rootflowAudit_aggregateArgs = {
  distinct_on?: Array<flowAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<flowAudit_order_by>;
  where?: flowAudit_bool_exp;
};


export type query_rootflowTraceArgs = {
  id: string;
};


export type query_rootflowTraceAggregateArgs = {
  distinct_on?: Array<qx_FlowTrace_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_FlowTrace_order_by>;
  where?: qx_FlowTrace_bool_exp;
};


export type query_rootflowTracesArgs = {
  distinct_on?: Array<qx_FlowTrace_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_FlowTrace_order_by>;
  where?: qx_FlowTrace_bool_exp;
};


export type query_rootflowsArgs = {
  distinct_on?: Array<qx_Flow_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Flow_order_by>;
  where?: qx_Flow_bool_exp;
};


export type query_rootgatewayArgs = {
  id: string;
};


export type query_rootgatewayAggregateArgs = {
  distinct_on?: Array<qx_Gateway_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Gateway_order_by>;
  where?: qx_Gateway_bool_exp;
};


export type query_rootgatewayAuditArgs = {
  distinct_on?: Array<gatewayAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<gatewayAudit_order_by>;
  where?: gatewayAudit_bool_exp;
};


export type query_rootgatewayAudit_aggregateArgs = {
  distinct_on?: Array<gatewayAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<gatewayAudit_order_by>;
  where?: gatewayAudit_bool_exp;
};


export type query_rootgatewayBandwidthScheduleArgs = {
  id: string;
};


export type query_rootgatewayBandwidthScheduleAggregateArgs = {
  distinct_on?: Array<qx_GatewayBandwidthSchedule_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_GatewayBandwidthSchedule_order_by>;
  where?: qx_GatewayBandwidthSchedule_bool_exp;
};


export type query_rootgatewayBandwidthScheduleAuditArgs = {
  distinct_on?: Array<gatewayBandwidthScheduleAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<gatewayBandwidthScheduleAudit_order_by>;
  where?: gatewayBandwidthScheduleAudit_bool_exp;
};


export type query_rootgatewayBandwidthScheduleAudit_aggregateArgs = {
  distinct_on?: Array<gatewayBandwidthScheduleAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<gatewayBandwidthScheduleAudit_order_by>;
  where?: gatewayBandwidthScheduleAudit_bool_exp;
};


export type query_rootgatewayBandwidthSchedulesArgs = {
  distinct_on?: Array<qx_GatewayBandwidthSchedule_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_GatewayBandwidthSchedule_order_by>;
  where?: qx_GatewayBandwidthSchedule_bool_exp;
};


export type query_rootgatewayServiceEnumsArgs = {
  distinct_on?: Array<qx_eGatewayServiceType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eGatewayServiceType_order_by>;
  where?: qx_eGatewayServiceType_bool_exp;
};


export type query_rootgatewayServiceTypeEnumArgs = {
  value: string;
};


export type query_rootgatewayServiceTypeEnumAggregateArgs = {
  distinct_on?: Array<qx_eGatewayServiceType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eGatewayServiceType_order_by>;
  where?: qx_eGatewayServiceType_bool_exp;
};


export type query_rootgatewaySyncStatusEnumArgs = {
  value: string;
};


export type query_rootgatewaySyncStatusEnumAggregateArgs = {
  distinct_on?: Array<qx_eGatewaySyncStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eGatewaySyncStatus_order_by>;
  where?: qx_eGatewaySyncStatus_bool_exp;
};


export type query_rootgatewaySyncStatusEnumsArgs = {
  distinct_on?: Array<qx_eGatewaySyncStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eGatewaySyncStatus_order_by>;
  where?: qx_eGatewaySyncStatus_bool_exp;
};


export type query_rootgatewaysArgs = {
  distinct_on?: Array<qx_Gateway_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Gateway_order_by>;
  where?: qx_Gateway_bool_exp;
};


export type query_rootgetBandwidthMetricsArgs = {
  gatewayID?: string;
  nic?: string;
  unitOfTime: string;
};


export type query_rootgetDeviceDIOUsageArgs = {
  deviceId: string;
};


export type query_rootgetFlowFiringDataArgs = {
  flowID: string;
};


export type query_rootgetGatewayNodeMetricsArgs = {
  gatewayID?: string;
};


export type query_rootgetGatewayServiceMetricsArgs = {
  gatewayID?: string;
  service?: string;
};


export type query_rootgetICEConfigArgs = {
  username: string;
};


export type query_rootgetMediaProfileRecordingArgs = {
  endTime: string;
  startTime: string;
  type: Array<string>;
  unit: string;
  videoSourceID: string;
};


export type query_rootgetMediaProfileRecordingDatesArgs = {
  endTime: string;
  startTime: string;
  type: Array<string>;
  unit?: string;
  videoSourceID: string;
};


export type query_rootgetMercuryDIOUsageArgs = {
  inventoryId: string;
};


export type query_rootgetMercuryDIOUsagesArgs = {
  deviceId: string;
};


export type query_rootgetNetworkInterfacesArgs = {
  gatewayID?: string;
};


export type query_rootgetOSSCredentialDataArgs = {
  credentialID: string;
  gatewayID: string;
};


export type query_rootgetOSSDataArgs = {
  placeID: string;
};


export type query_rootgetOSSDoorDataArgs = {
  deviceID: string;
};


export type query_rootgetOSSKeysArgs = {
  placeID: string;
};


export type query_rootgetReaderAccessTypesArgs = {
  brandType: string;
};


export type query_rootgetReaderProtocolsArgs = {
  brandType: string;
};


export type query_rootgetSuperviseInputsArgs = {
  brandType: string;
};


export type query_rootgetTwoFactorBackupCodesArgs = {
  token: string;
};


export type query_rootgetUploadSegmentMetricsArgs = {
  gatewayID?: string;
  unitOfTime: string;
};


export type query_rootgetValidatorArgs = {
  validator: string;
};


export type query_rootgroupArgs = {
  id: string;
};


export type query_rootgroupAggregateArgs = {
  distinct_on?: Array<qx_Group_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Group_order_by>;
  where?: qx_Group_bool_exp;
};


export type query_rootgroupAuditArgs = {
  distinct_on?: Array<groupAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<groupAudit_order_by>;
  where?: groupAudit_bool_exp;
};


export type query_rootgroupAudit_aggregateArgs = {
  distinct_on?: Array<groupAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<groupAudit_order_by>;
  where?: groupAudit_bool_exp;
};


export type query_rootgroupsArgs = {
  distinct_on?: Array<qx_Group_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Group_order_by>;
  where?: qx_Group_bool_exp;
};


export type query_rootguestAccessArgs = {
  distinct_on?: Array<guestAccess_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<guestAccess_order_by>;
  where?: guestAccess_bool_exp;
};


export type query_rootguestAccess_aggregateArgs = {
  distinct_on?: Array<guestAccess_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<guestAccess_order_by>;
  where?: guestAccess_bool_exp;
};


export type query_rootguestAccess_by_pkArgs = {
  personID: string;
};


export type query_rootholidaySetArgs = {
  id: string;
};


export type query_rootholidaySetAggregateArgs = {
  distinct_on?: Array<qx_HolidaySet_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_HolidaySet_order_by>;
  where?: qx_HolidaySet_bool_exp;
};


export type query_rootholidaySetAuditArgs = {
  distinct_on?: Array<holidaySetAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<holidaySetAudit_order_by>;
  where?: holidaySetAudit_bool_exp;
};


export type query_rootholidaySetAudit_aggregateArgs = {
  distinct_on?: Array<holidaySetAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<holidaySetAudit_order_by>;
  where?: holidaySetAudit_bool_exp;
};


export type query_rootholidaySetToScheduleBlockArgs = {
  holidaySetID: string;
  scheduleBlockID: string;
};


export type query_rootholidaySetToScheduleBlockAggregateArgs = {
  distinct_on?: Array<qx__HolidaySetToScheduleBlock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__HolidaySetToScheduleBlock_order_by>;
  where?: qx__HolidaySetToScheduleBlock_bool_exp;
};


export type query_rootholidaySetToScheduleBlockAuditArgs = {
  distinct_on?: Array<holidaySetToScheduleBlockAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<holidaySetToScheduleBlockAudit_order_by>;
  where?: holidaySetToScheduleBlockAudit_bool_exp;
};


export type query_rootholidaySetToScheduleBlockAudit_aggregateArgs = {
  distinct_on?: Array<holidaySetToScheduleBlockAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<holidaySetToScheduleBlockAudit_order_by>;
  where?: holidaySetToScheduleBlockAudit_bool_exp;
};


export type query_rootholidaySetToScheduleBlocksArgs = {
  distinct_on?: Array<qx__HolidaySetToScheduleBlock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__HolidaySetToScheduleBlock_order_by>;
  where?: qx__HolidaySetToScheduleBlock_bool_exp;
};


export type query_rootholidaySetsArgs = {
  distinct_on?: Array<qx_HolidaySet_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_HolidaySet_order_by>;
  where?: qx_HolidaySet_bool_exp;
};


export type query_rootinputPointArgs = {
  id: string;
};


export type query_rootinputPointAggregateArgs = {
  distinct_on?: Array<qx_InputPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_InputPoint_order_by>;
  where?: qx_InputPoint_bool_exp;
};


export type query_rootinputPointAuditArgs = {
  distinct_on?: Array<inputPointAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<inputPointAudit_order_by>;
  where?: inputPointAudit_bool_exp;
};


export type query_rootinputPointAudit_aggregateArgs = {
  distinct_on?: Array<inputPointAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<inputPointAudit_order_by>;
  where?: inputPointAudit_bool_exp;
};


export type query_rootinputPointsArgs = {
  distinct_on?: Array<qx_InputPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_InputPoint_order_by>;
  where?: qx_InputPoint_bool_exp;
};


export type query_rootkeyModeEnumArgs = {
  value: string;
};


export type query_rootkeyModeEnumAggregateArgs = {
  distinct_on?: Array<qx_eKeypadMode_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eKeypadMode_order_by>;
  where?: qx_eKeypadMode_bool_exp;
};


export type query_rootkeyModeEnumsArgs = {
  distinct_on?: Array<qx_eKeypadMode_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eKeypadMode_order_by>;
  where?: qx_eKeypadMode_bool_exp;
};


export type query_rootlayoutArgs = {
  id: string;
};


export type query_rootlayoutsArgs = {
  distinct_on?: Array<qx_Layout_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Layout_order_by>;
  where?: qx_Layout_bool_exp;
};


export type query_rootlayoutsAggregateArgs = {
  distinct_on?: Array<qx_Layout_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Layout_order_by>;
  where?: qx_Layout_bool_exp;
};


export type query_rootlensProfileArgs = {
  id: string;
};


export type query_rootlensProfileAggregateArgs = {
  distinct_on?: Array<qx_LensProfile_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_LensProfile_order_by>;
  where?: qx_LensProfile_bool_exp;
};


export type query_rootlensProfilesArgs = {
  distinct_on?: Array<qx_LensProfile_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_LensProfile_order_by>;
  where?: qx_LensProfile_bool_exp;
};


export type query_rootlinkableTypesArgs = {
  distinct_on?: Array<qx_SharedLinkType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_SharedLinkType_order_by>;
  where?: qx_SharedLinkType_bool_exp;
};


export type query_rootlockArgs = {
  id: string;
};


export type query_rootlockAggregateArgs = {
  distinct_on?: Array<qx_Lock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Lock_order_by>;
  where?: qx_Lock_bool_exp;
};


export type query_rootlockAuditArgs = {
  distinct_on?: Array<lockAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<lockAudit_order_by>;
  where?: lockAudit_bool_exp;
};


export type query_rootlockAudit_aggregateArgs = {
  distinct_on?: Array<lockAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<lockAudit_order_by>;
  where?: lockAudit_bool_exp;
};


export type query_rootlockPowerMonitorEnumArgs = {
  value: string;
};


export type query_rootlockPowerMonitorEnumAggregateArgs = {
  distinct_on?: Array<qx_eLockPowerMonitor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eLockPowerMonitor_order_by>;
  where?: qx_eLockPowerMonitor_bool_exp;
};


export type query_rootlockPowerMonitorEnumsArgs = {
  distinct_on?: Array<qx_eLockPowerMonitor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eLockPowerMonitor_order_by>;
  where?: qx_eLockPowerMonitor_bool_exp;
};


export type query_rootlockRelayMonitorEnumArgs = {
  value: string;
};


export type query_rootlockRelayMonitorEnumAggregateArgs = {
  distinct_on?: Array<qx_eLockRelayMonitor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eLockRelayMonitor_order_by>;
  where?: qx_eLockRelayMonitor_bool_exp;
};


export type query_rootlockRelayMonitorEnumsArgs = {
  distinct_on?: Array<qx_eLockRelayMonitor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eLockRelayMonitor_order_by>;
  where?: qx_eLockRelayMonitor_bool_exp;
};


export type query_rootlockTypeEnumArgs = {
  value: string;
};


export type query_rootlockTypeEnumAggregateArgs = {
  distinct_on?: Array<qx_eLockType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eLockType_order_by>;
  where?: qx_eLockType_bool_exp;
};


export type query_rootlockTypeEnumsArgs = {
  distinct_on?: Array<qx_eLockType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eLockType_order_by>;
  where?: qx_eLockType_bool_exp;
};


export type query_rootlocksArgs = {
  distinct_on?: Array<qx_Lock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Lock_order_by>;
  where?: qx_Lock_bool_exp;
};


export type query_rootmediaProfileArgs = {
  id: string;
};


export type query_rootmediaProfileAggregateArgs = {
  distinct_on?: Array<qx_MediaProfile_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MediaProfile_order_by>;
  where?: qx_MediaProfile_bool_exp;
};


export type query_rootmediaProfileAuditArgs = {
  distinct_on?: Array<mediaProfileAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<mediaProfileAudit_order_by>;
  where?: mediaProfileAudit_bool_exp;
};


export type query_rootmediaProfileAudit_aggregateArgs = {
  distinct_on?: Array<mediaProfileAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<mediaProfileAudit_order_by>;
  where?: mediaProfileAudit_bool_exp;
};


export type query_rootmediaProfilesArgs = {
  distinct_on?: Array<qx_MediaProfile_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MediaProfile_order_by>;
  where?: qx_MediaProfile_bool_exp;
};


export type query_rootmercuryControlPointArgs = {
  id: string;
};


export type query_rootmercuryControlPointAggregateArgs = {
  distinct_on?: Array<qx_MercuryControlPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MercuryControlPoint_order_by>;
  where?: qx_MercuryControlPoint_bool_exp;
};


export type query_rootmercuryControlPointsArgs = {
  distinct_on?: Array<qx_MercuryControlPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MercuryControlPoint_order_by>;
  where?: qx_MercuryControlPoint_bool_exp;
};


export type query_rootmercuryMonitorPointArgs = {
  id: string;
};


export type query_rootmercuryMonitorPointAggregateArgs = {
  distinct_on?: Array<qx_MercuryMonitorPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MercuryMonitorPoint_order_by>;
  where?: qx_MercuryMonitorPoint_bool_exp;
};


export type query_rootmercuryMonitorPointsArgs = {
  distinct_on?: Array<qx_MercuryMonitorPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MercuryMonitorPoint_order_by>;
  where?: qx_MercuryMonitorPoint_bool_exp;
};


export type query_rootmonitorLockStateEnumArgs = {
  value: string;
};


export type query_rootmonitorLockStateEnumAggregateArgs = {
  distinct_on?: Array<qx_eMonitorLockState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eMonitorLockState_order_by>;
  where?: qx_eMonitorLockState_bool_exp;
};


export type query_rootmonitorLockStateEnumsArgs = {
  distinct_on?: Array<qx_eMonitorLockState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eMonitorLockState_order_by>;
  where?: qx_eMonitorLockState_bool_exp;
};


export type query_rootmountPositionEnumArgs = {
  value: string;
};


export type query_rootmountPositionEnumAggregateArgs = {
  distinct_on?: Array<qx_eMountPosition_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eMountPosition_order_by>;
  where?: qx_eMountPosition_bool_exp;
};


export type query_rootmountPositionEnumsArgs = {
  distinct_on?: Array<qx_eMountPosition_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eMountPosition_order_by>;
  where?: qx_eMountPosition_bool_exp;
};


export type query_rootnotificationTypeEnumArgs = {
  value: string;
};


export type query_rootnotificationTypeEnumAggregateArgs = {
  distinct_on?: Array<qx_eFlowNotificationType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eFlowNotificationType_order_by>;
  where?: qx_eFlowNotificationType_bool_exp;
};


export type query_rootnotificationTypeEnumsArgs = {
  distinct_on?: Array<qx_eFlowNotificationType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eFlowNotificationType_order_by>;
  where?: qx_eFlowNotificationType_bool_exp;
};


export type query_rootobjectActionEnumArgs = {
  value: string;
};


export type query_rootobjectActionEnumAggregateArgs = {
  distinct_on?: Array<qx_eObjectAction_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eObjectAction_order_by>;
  where?: qx_eObjectAction_bool_exp;
};


export type query_rootobjectActionEnumsArgs = {
  distinct_on?: Array<qx_eObjectAction_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eObjectAction_order_by>;
  where?: qx_eObjectAction_bool_exp;
};


export type query_rootossIdAssignmentArgs = {
  id: string;
};


export type query_rootossIdAssignmentAggregateArgs = {
  distinct_on?: Array<qx_OssIdAssignment_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_OssIdAssignment_order_by>;
  where?: qx_OssIdAssignment_bool_exp;
};


export type query_rootossIdAssignmentsArgs = {
  distinct_on?: Array<qx_OssIdAssignment_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_OssIdAssignment_order_by>;
  where?: qx_OssIdAssignment_bool_exp;
};


export type query_rootoutputPointArgs = {
  id: string;
};


export type query_rootoutputPointAggregateArgs = {
  distinct_on?: Array<qx_OutputPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_OutputPoint_order_by>;
  where?: qx_OutputPoint_bool_exp;
};


export type query_rootoutputPointAuditArgs = {
  distinct_on?: Array<outputPointAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<outputPointAudit_order_by>;
  where?: outputPointAudit_bool_exp;
};


export type query_rootoutputPointAudit_aggregateArgs = {
  distinct_on?: Array<outputPointAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<outputPointAudit_order_by>;
  where?: outputPointAudit_bool_exp;
};


export type query_rootoutputPointsArgs = {
  distinct_on?: Array<qx_OutputPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_OutputPoint_order_by>;
  where?: qx_OutputPoint_bool_exp;
};


export type query_rootpacsStatusEnumArgs = {
  value: string;
};


export type query_rootpacsStatusEnumAggregateArgs = {
  distinct_on?: Array<qx_ePACSStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ePACSStatus_order_by>;
  where?: qx_ePACSStatus_bool_exp;
};


export type query_rootpacsStatusEnumsArgs = {
  distinct_on?: Array<qx_ePACSStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ePACSStatus_order_by>;
  where?: qx_ePACSStatus_bool_exp;
};


export type query_rootpeersArgs = {
  gatewayID?: string;
};


export type query_rootpeopleArgs = {
  distinct_on?: Array<qx_Person_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Person_order_by>;
  where?: qx_Person_bool_exp;
};


export type query_rootpermissionArgs = {
  id: string;
};


export type query_rootpermissionAggregateArgs = {
  distinct_on?: Array<qx_Permission_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Permission_order_by>;
  where?: qx_Permission_bool_exp;
};


export type query_rootpermissionAuditArgs = {
  distinct_on?: Array<permissionAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<permissionAudit_order_by>;
  where?: permissionAudit_bool_exp;
};


export type query_rootpermissionAudit_aggregateArgs = {
  distinct_on?: Array<permissionAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<permissionAudit_order_by>;
  where?: permissionAudit_bool_exp;
};


export type query_rootpermissionsArgs = {
  distinct_on?: Array<qx_Permission_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Permission_order_by>;
  where?: qx_Permission_bool_exp;
};


export type query_rootpersonArgs = {
  id: string;
};


export type query_rootpersonAggregateArgs = {
  distinct_on?: Array<qx_Person_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Person_order_by>;
  where?: qx_Person_bool_exp;
};


export type query_rootpersonAudioSourceAppPrivilegesArgs = {
  distinct_on?: Array<personAudioSourceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personAudioSourceAppPrivileges_order_by>;
  where?: personAudioSourceAppPrivileges_bool_exp;
};


export type query_rootpersonAudioSourceAppPrivileges_aggregateArgs = {
  distinct_on?: Array<personAudioSourceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personAudioSourceAppPrivileges_order_by>;
  where?: personAudioSourceAppPrivileges_bool_exp;
};


export type query_rootpersonAuditArgs = {
  distinct_on?: Array<personAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personAudit_order_by>;
  where?: personAudit_bool_exp;
};


export type query_rootpersonAudit_aggregateArgs = {
  distinct_on?: Array<personAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personAudit_order_by>;
  where?: personAudit_bool_exp;
};


export type query_rootpersonDeviceAppPrivilegesArgs = {
  distinct_on?: Array<personDeviceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personDeviceAppPrivileges_order_by>;
  where?: personDeviceAppPrivileges_bool_exp;
};


export type query_rootpersonDeviceAppPrivileges_aggregateArgs = {
  distinct_on?: Array<personDeviceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personDeviceAppPrivileges_order_by>;
  where?: personDeviceAppPrivileges_bool_exp;
};


export type query_rootpersonDeviceAppPrivileges_by_pkArgs = {
  deviceID: string;
  personID: string;
};


export type query_rootpersonDoorAppPrivilegesArgs = {
  distinct_on?: Array<personDoorAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personDoorAppPrivileges_order_by>;
  where?: personDoorAppPrivileges_bool_exp;
};


export type query_rootpersonDoorAppPrivileges_aggregateArgs = {
  distinct_on?: Array<personDoorAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personDoorAppPrivileges_order_by>;
  where?: personDoorAppPrivileges_bool_exp;
};


export type query_rootpersonDoorAppPrivileges_by_pkArgs = {
  doorID: string;
  personID: string;
};


export type query_rootpersonGroupArgs = {
  groupID: string;
  personID: string;
};


export type query_rootpersonGroupAggregateArgs = {
  distinct_on?: Array<qx__PersonToGroup_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__PersonToGroup_order_by>;
  where?: qx__PersonToGroup_bool_exp;
};


export type query_rootpersonGroupsArgs = {
  distinct_on?: Array<qx__PersonToGroup_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__PersonToGroup_order_by>;
  where?: qx__PersonToGroup_bool_exp;
};


export type query_rootpersonIntrusionPartitionAppPrivilegesArgs = {
  distinct_on?: Array<personIntrusionPartitionAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personIntrusionPartitionAppPrivileges_order_by>;
  where?: personIntrusionPartitionAppPrivileges_bool_exp;
};


export type query_rootpersonIntrusionPartitionAppPrivileges_aggregateArgs = {
  distinct_on?: Array<personIntrusionPartitionAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personIntrusionPartitionAppPrivileges_order_by>;
  where?: personIntrusionPartitionAppPrivileges_bool_exp;
};


export type query_rootpersonIntrusionPartitionAppPrivileges_by_pkArgs = {
  partitionID: string;
  personID: string;
};


export type query_rootpersonPlaceAppPrivilegesArgs = {
  distinct_on?: Array<personPlaceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personPlaceAppPrivileges_order_by>;
  where?: personPlaceAppPrivileges_bool_exp;
};


export type query_rootpersonPlaceAppPrivileges_aggregateArgs = {
  distinct_on?: Array<personPlaceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personPlaceAppPrivileges_order_by>;
  where?: personPlaceAppPrivileges_bool_exp;
};


export type query_rootpersonPlaceAppPrivileges_by_pkArgs = {
  personID: string;
  placeID: string;
};


export type query_rootpersonStatusEnumArgs = {
  value: string;
};


export type query_rootpersonStatusEnumAggregateArgs = {
  distinct_on?: Array<qx_ePersonStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ePersonStatus_order_by>;
  where?: qx_ePersonStatus_bool_exp;
};


export type query_rootpersonStatusEnumsArgs = {
  distinct_on?: Array<qx_ePersonStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ePersonStatus_order_by>;
  where?: qx_ePersonStatus_bool_exp;
};


export type query_rootpersonToGroupAuditArgs = {
  distinct_on?: Array<personToGroupAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personToGroupAudit_order_by>;
  where?: personToGroupAudit_bool_exp;
};


export type query_rootpersonToGroupAudit_aggregateArgs = {
  distinct_on?: Array<personToGroupAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personToGroupAudit_order_by>;
  where?: personToGroupAudit_bool_exp;
};


export type query_rootpersonVideoSourceAppPrivilegesArgs = {
  distinct_on?: Array<personVideoSourceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personVideoSourceAppPrivileges_order_by>;
  where?: personVideoSourceAppPrivileges_bool_exp;
};


export type query_rootpersonVideoSourceAppPrivileges_aggregateArgs = {
  distinct_on?: Array<personVideoSourceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personVideoSourceAppPrivileges_order_by>;
  where?: personVideoSourceAppPrivileges_bool_exp;
};


export type query_rootpersonVideoSourceAppPrivileges_by_pkArgs = {
  personID: string;
  videoSourceID: string;
};


export type query_rootplaceArgs = {
  id: string;
};


export type query_rootplaceAggregateArgs = {
  distinct_on?: Array<qx_Place_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Place_order_by>;
  where?: qx_Place_bool_exp;
};


export type query_rootplaceAuditArgs = {
  distinct_on?: Array<placeAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<placeAudit_order_by>;
  where?: placeAudit_bool_exp;
};


export type query_rootplaceAudit_aggregateArgs = {
  distinct_on?: Array<placeAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<placeAudit_order_by>;
  where?: placeAudit_bool_exp;
};


export type query_rootplaceTypeEnumArgs = {
  value: string;
};


export type query_rootplaceTypeEnumAggregateArgs = {
  distinct_on?: Array<qx_ePlaceType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ePlaceType_order_by>;
  where?: qx_ePlaceType_bool_exp;
};


export type query_rootplaceTypeEnumsArgs = {
  distinct_on?: Array<qx_ePlaceType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ePlaceType_order_by>;
  where?: qx_ePlaceType_bool_exp;
};


export type query_rootplaceWhiteListsArgs = {
  distinct_on?: Array<placeWhiteLists_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<placeWhiteLists_order_by>;
  where?: placeWhiteLists_bool_exp;
};


export type query_rootplaceWhiteLists_aggregateArgs = {
  distinct_on?: Array<placeWhiteLists_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<placeWhiteLists_order_by>;
  where?: placeWhiteLists_bool_exp;
};


export type query_rootplaceWhiteLists_by_pkArgs = {
  id: string;
};


export type query_rootplacesArgs = {
  distinct_on?: Array<qx_Place_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Place_order_by>;
  where?: qx_Place_bool_exp;
};


export type query_rootprivilegeEnumArgs = {
  value: string;
};


export type query_rootprivilegeEnumAggregateArgs = {
  distinct_on?: Array<qx_ePrivilege_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ePrivilege_order_by>;
  where?: qx_ePrivilege_bool_exp;
};


export type query_rootprivilegeEnumToRoleArgs = {
  privilege: qx_ePrivilege_enum;
  roleID: string;
};


export type query_rootprivilegeEnumToRoleAggregateArgs = {
  distinct_on?: Array<qx__PrivilegeEnumToRole_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__PrivilegeEnumToRole_order_by>;
  where?: qx__PrivilegeEnumToRole_bool_exp;
};


export type query_rootprivilegeEnumToRoleAuditArgs = {
  distinct_on?: Array<privilegeEnumToRoleAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<privilegeEnumToRoleAudit_order_by>;
  where?: privilegeEnumToRoleAudit_bool_exp;
};


export type query_rootprivilegeEnumToRoleAudit_aggregateArgs = {
  distinct_on?: Array<privilegeEnumToRoleAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<privilegeEnumToRoleAudit_order_by>;
  where?: privilegeEnumToRoleAudit_bool_exp;
};


export type query_rootprivilegeEnumToRolesArgs = {
  distinct_on?: Array<qx__PrivilegeEnumToRole_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__PrivilegeEnumToRole_order_by>;
  where?: qx__PrivilegeEnumToRole_bool_exp;
};


export type query_rootprivilegeEnumsArgs = {
  distinct_on?: Array<qx_ePrivilege_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ePrivilege_order_by>;
  where?: qx_ePrivilege_bool_exp;
};


export type query_rootqx_AccessCatalogCapabilitiesArgs = {
  distinct_on?: Array<qx_AccessCatalogCapabilities_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessCatalogCapabilities_order_by>;
  where?: qx_AccessCatalogCapabilities_bool_exp;
};


export type query_rootqx_AccessCatalogCapabilities_aggregateArgs = {
  distinct_on?: Array<qx_AccessCatalogCapabilities_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessCatalogCapabilities_order_by>;
  where?: qx_AccessCatalogCapabilities_bool_exp;
};


export type query_rootqx_AccessCatalogCapabilities_by_pkArgs = {
  catalogID: string;
};


export type query_rootqx_AuditableAction_aggregateArgs = {
  distinct_on?: Array<qx_AuditableAction_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AuditableAction_order_by>;
  where?: qx_AuditableAction_bool_exp;
};


export type query_rootqx_AuditableAction_by_pkArgs = {
  value: string;
};


export type query_rootqx_AuditableType_aggregateArgs = {
  distinct_on?: Array<qx_AuditableType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AuditableType_order_by>;
  where?: qx_AuditableType_bool_exp;
};


export type query_rootqx_AuditableType_by_pkArgs = {
  value: string;
};


export type query_rootqx_CatalogProtocolOverrideArgs = {
  distinct_on?: Array<qx_CatalogProtocolOverride_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_CatalogProtocolOverride_order_by>;
  where?: qx_CatalogProtocolOverride_bool_exp;
};


export type query_rootqx_CatalogProtocolOverride_aggregateArgs = {
  distinct_on?: Array<qx_CatalogProtocolOverride_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_CatalogProtocolOverride_order_by>;
  where?: qx_CatalogProtocolOverride_bool_exp;
};


export type query_rootqx_CatalogProtocolOverride_by_pkArgs = {
  id: number;
};


export type query_rootqx_CustomerAuthProviderArgs = {
  distinct_on?: Array<qx_CustomerAuthProvider_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_CustomerAuthProvider_order_by>;
  where?: qx_CustomerAuthProvider_bool_exp;
};


export type query_rootqx_CustomerAuthProvider_aggregateArgs = {
  distinct_on?: Array<qx_CustomerAuthProvider_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_CustomerAuthProvider_order_by>;
  where?: qx_CustomerAuthProvider_bool_exp;
};


export type query_rootqx_CustomerAuthProvider_by_pkArgs = {
  id: string;
};


export type query_rootqx_DiscoveryType_aggregateArgs = {
  distinct_on?: Array<qx_DiscoveryType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DiscoveryType_order_by>;
  where?: qx_DiscoveryType_bool_exp;
};


export type query_rootqx_DiscoveryType_by_pkArgs = {
  value: string;
};


export type query_rootqx_IntrusionAlarmArgs = {
  distinct_on?: Array<qx_IntrusionAlarm_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_IntrusionAlarm_order_by>;
  where?: qx_IntrusionAlarm_bool_exp;
};


export type query_rootqx_IntrusionAlarm_aggregateArgs = {
  distinct_on?: Array<qx_IntrusionAlarm_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_IntrusionAlarm_order_by>;
  where?: qx_IntrusionAlarm_bool_exp;
};


export type query_rootqx_IntrusionAlarm_by_pkArgs = {
  value: string;
};


export type query_rootqx_IntrusionPartitionStateArgs = {
  distinct_on?: Array<qx_IntrusionPartitionState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_IntrusionPartitionState_order_by>;
  where?: qx_IntrusionPartitionState_bool_exp;
};


export type query_rootqx_IntrusionPartitionState_aggregateArgs = {
  distinct_on?: Array<qx_IntrusionPartitionState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_IntrusionPartitionState_order_by>;
  where?: qx_IntrusionPartitionState_bool_exp;
};


export type query_rootqx_IntrusionPartitionState_by_pkArgs = {
  value: string;
};


export type query_rootqx_IntrusionZoneStateArgs = {
  distinct_on?: Array<qx_IntrusionZoneState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_IntrusionZoneState_order_by>;
  where?: qx_IntrusionZoneState_bool_exp;
};


export type query_rootqx_IntrusionZoneState_aggregateArgs = {
  distinct_on?: Array<qx_IntrusionZoneState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_IntrusionZoneState_order_by>;
  where?: qx_IntrusionZoneState_bool_exp;
};


export type query_rootqx_IntrusionZoneState_by_pkArgs = {
  value: string;
};


export type query_rootqx_MediaProfileRecordingArgs = {
  distinct_on?: Array<qx_MediaProfileRecording_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MediaProfileRecording_order_by>;
  where?: qx_MediaProfileRecording_bool_exp;
};


export type query_rootqx_MediaProfileRecording_aggregateArgs = {
  distinct_on?: Array<qx_MediaProfileRecording_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MediaProfileRecording_order_by>;
  where?: qx_MediaProfileRecording_bool_exp;
};


export type query_rootqx_MediaProfileRecording_by_pkArgs = {
  id: string;
};


export type query_rootqx_OssKeyArgs = {
  distinct_on?: Array<qx_OssKey_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_OssKey_order_by>;
  where?: qx_OssKey_bool_exp;
};


export type query_rootqx_OssKey_aggregateArgs = {
  distinct_on?: Array<qx_OssKey_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_OssKey_order_by>;
  where?: qx_OssKey_bool_exp;
};


export type query_rootqx_OssKey_by_pkArgs = {
  customerPlaceID: string;
};


export type query_rootqx_SharedLinkType_aggregateArgs = {
  distinct_on?: Array<qx_SharedLinkType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_SharedLinkType_order_by>;
  where?: qx_SharedLinkType_bool_exp;
};


export type query_rootqx_SharedLinkType_by_pkArgs = {
  value: string;
};


export type query_rootqx_VideoSourceStorageAuditArgs = {
  distinct_on?: Array<qx_VideoSourceStorageAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_VideoSourceStorageAudit_order_by>;
  where?: qx_VideoSourceStorageAudit_bool_exp;
};


export type query_rootqx_VideoSourceStorageAudit_aggregateArgs = {
  distinct_on?: Array<qx_VideoSourceStorageAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_VideoSourceStorageAudit_order_by>;
  where?: qx_VideoSourceStorageAudit_bool_exp;
};


export type query_rootqx_VideoSourceStorageAudit_by_pkArgs = {
  id: string;
};


export type query_rootqx__PlaceToHomePlacesArgs = {
  distinct_on?: Array<qx__PlaceToHomePlaces_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__PlaceToHomePlaces_order_by>;
  where?: qx__PlaceToHomePlaces_bool_exp;
};


export type query_rootqx__PlaceToHomePlaces_aggregateArgs = {
  distinct_on?: Array<qx__PlaceToHomePlaces_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__PlaceToHomePlaces_order_by>;
  where?: qx__PlaceToHomePlaces_bool_exp;
};


export type query_rootqx_chat_usage_per_model_aggregateArgs = {
  args?: qx_chat_usage_per_model_args;
  distinct_on?: Array<qx_vChatUsagePerModel_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatUsagePerModel_order_by>;
  where?: qx_vChatUsagePerModel_bool_exp;
};


export type query_rootqx_chat_usage_series_aggregateArgs = {
  args: qx_chat_usage_series_args;
  distinct_on?: Array<qx_vChatUsageSeries_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatUsageSeries_order_by>;
  where?: qx_vChatUsageSeries_bool_exp;
};


export type query_rootqx_device_oldest_mediaArgs = {
  args: qx_device_oldest_media_args;
  distinct_on?: Array<qx_vOldestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vOldestMedia_order_by>;
  where?: qx_vOldestMedia_bool_exp;
};


export type query_rootqx_device_oldest_media_aggregateArgs = {
  args: qx_device_oldest_media_args;
  distinct_on?: Array<qx_vOldestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vOldestMedia_order_by>;
  where?: qx_vOldestMedia_bool_exp;
};


export type query_rootqx_eAccessMakeArgs = {
  distinct_on?: Array<qx_eAccessMake_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessMake_order_by>;
  where?: qx_eAccessMake_bool_exp;
};


export type query_rootqx_eAccessMake_aggregateArgs = {
  distinct_on?: Array<qx_eAccessMake_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessMake_order_by>;
  where?: qx_eAccessMake_bool_exp;
};


export type query_rootqx_eAccessMake_by_pkArgs = {
  name: string;
};


export type query_rootqx_eAppPrivilegeTypeArgs = {
  distinct_on?: Array<qx_eAppPrivilegeType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAppPrivilegeType_order_by>;
  where?: qx_eAppPrivilegeType_bool_exp;
};


export type query_rootqx_eAppPrivilegeType_aggregateArgs = {
  distinct_on?: Array<qx_eAppPrivilegeType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAppPrivilegeType_order_by>;
  where?: qx_eAppPrivilegeType_bool_exp;
};


export type query_rootqx_eAppPrivilegeType_by_pkArgs = {
  value: string;
};


export type query_rootqx_eAuthProviderArgs = {
  distinct_on?: Array<qx_eAuthProvider_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAuthProvider_order_by>;
  where?: qx_eAuthProvider_bool_exp;
};


export type query_rootqx_eAuthProvider_aggregateArgs = {
  distinct_on?: Array<qx_eAuthProvider_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAuthProvider_order_by>;
  where?: qx_eAuthProvider_bool_exp;
};


export type query_rootqx_eAuthProvider_by_pkArgs = {
  value: string;
};


export type query_rootqx_eFlowStatusArgs = {
  distinct_on?: Array<qx_eFlowStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eFlowStatus_order_by>;
  where?: qx_eFlowStatus_bool_exp;
};


export type query_rootqx_eFlowStatus_aggregateArgs = {
  distinct_on?: Array<qx_eFlowStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eFlowStatus_order_by>;
  where?: qx_eFlowStatus_bool_exp;
};


export type query_rootqx_eFlowStatus_by_pkArgs = {
  value: string;
};


export type query_rootqx_eFlowTraceActionStatusArgs = {
  distinct_on?: Array<qx_eFlowTraceActionStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eFlowTraceActionStatus_order_by>;
  where?: qx_eFlowTraceActionStatus_bool_exp;
};


export type query_rootqx_eFlowTraceActionStatus_aggregateArgs = {
  distinct_on?: Array<qx_eFlowTraceActionStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eFlowTraceActionStatus_order_by>;
  where?: qx_eFlowTraceActionStatus_bool_exp;
};


export type query_rootqx_eFlowTraceActionStatus_by_pkArgs = {
  value: string;
};


export type query_rootqx_eFlowTraceStateArgs = {
  distinct_on?: Array<qx_eFlowTraceState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eFlowTraceState_order_by>;
  where?: qx_eFlowTraceState_bool_exp;
};


export type query_rootqx_eFlowTraceState_aggregateArgs = {
  distinct_on?: Array<qx_eFlowTraceState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eFlowTraceState_order_by>;
  where?: qx_eFlowTraceState_bool_exp;
};


export type query_rootqx_eFlowTraceState_by_pkArgs = {
  value: string;
};


export type query_rootqx_eIntrusionZoneTypeArgs = {
  distinct_on?: Array<qx_eIntrusionZoneType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eIntrusionZoneType_order_by>;
  where?: qx_eIntrusionZoneType_bool_exp;
};


export type query_rootqx_eIntrusionZoneType_aggregateArgs = {
  distinct_on?: Array<qx_eIntrusionZoneType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eIntrusionZoneType_order_by>;
  where?: qx_eIntrusionZoneType_bool_exp;
};


export type query_rootqx_eIntrusionZoneType_by_pkArgs = {
  value: string;
};


export type query_rootqx_eLockModeArgs = {
  distinct_on?: Array<qx_eLockMode_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eLockMode_order_by>;
  where?: qx_eLockMode_bool_exp;
};


export type query_rootqx_eLockMode_aggregateArgs = {
  distinct_on?: Array<qx_eLockMode_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eLockMode_order_by>;
  where?: qx_eLockMode_bool_exp;
};


export type query_rootqx_eLockMode_by_pkArgs = {
  value: string;
};


export type query_rootqx_eMercuryMonitorPointLatchModesArgs = {
  distinct_on?: Array<qx_eMercuryMonitorPointLatchModes_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eMercuryMonitorPointLatchModes_order_by>;
  where?: qx_eMercuryMonitorPointLatchModes_bool_exp;
};


export type query_rootqx_eMercuryMonitorPointLatchModes_aggregateArgs = {
  distinct_on?: Array<qx_eMercuryMonitorPointLatchModes_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eMercuryMonitorPointLatchModes_order_by>;
  where?: qx_eMercuryMonitorPointLatchModes_bool_exp;
};


export type query_rootqx_eMercuryMonitorPointLatchModes_by_pkArgs = {
  value: string;
};


export type query_rootqx_event_type_status_valuesArgs = {
  args: qx_event_type_status_values_args;
  distinct_on?: Array<qx_eDeviceConnectionStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDeviceConnectionStatus_order_by>;
  where?: qx_eDeviceConnectionStatus_bool_exp;
};


export type query_rootqx_event_type_status_values_aggregateArgs = {
  args: qx_event_type_status_values_args;
  distinct_on?: Array<qx_eDeviceConnectionStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDeviceConnectionStatus_order_by>;
  where?: qx_eDeviceConnectionStatus_bool_exp;
};


export type query_rootqx_events_by_hourArgs = {
  args: qx_events_by_hour_args;
  distinct_on?: Array<qx_vEventsByHour_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vEventsByHour_order_by>;
  where?: qx_vEventsByHour_bool_exp;
};


export type query_rootqx_events_by_hour_aggregateArgs = {
  args: qx_events_by_hour_args;
  distinct_on?: Array<qx_vEventsByHour_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vEventsByHour_order_by>;
  where?: qx_vEventsByHour_bool_exp;
};


export type query_rootqx_find_credential_from_placeArgs = {
  args: qx_find_credential_from_place_args;
  distinct_on?: Array<qx_Credential_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Credential_order_by>;
  where?: qx_Credential_bool_exp;
};


export type query_rootqx_find_credential_from_place_aggregateArgs = {
  args: qx_find_credential_from_place_args;
  distinct_on?: Array<qx_Credential_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Credential_order_by>;
  where?: qx_Credential_bool_exp;
};


export type query_rootqx_media_profile_oldest_mediaArgs = {
  args: qx_media_profile_oldest_media_args;
  distinct_on?: Array<qx_vOldestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vOldestMedia_order_by>;
  where?: qx_vOldestMedia_bool_exp;
};


export type query_rootqx_media_profile_oldest_media_aggregateArgs = {
  args: qx_media_profile_oldest_media_args;
  distinct_on?: Array<qx_vOldestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vOldestMedia_order_by>;
  where?: qx_vOldestMedia_bool_exp;
};


export type query_rootqx_place_hierarchyArgs = {
  args: qx_place_hierarchy_args;
  distinct_on?: Array<qx_vPlaceHierarchy_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vPlaceHierarchy_order_by>;
  where?: qx_vPlaceHierarchy_bool_exp;
};


export type query_rootqx_place_hierarchy_aggregateArgs = {
  args: qx_place_hierarchy_args;
  distinct_on?: Array<qx_vPlaceHierarchy_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vPlaceHierarchy_order_by>;
  where?: qx_vPlaceHierarchy_bool_exp;
};


export type query_rootqx_search_segmentsArgs = {
  args: qx_search_segments_args;
  distinct_on?: Array<qx_Segment_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Segment_order_by>;
  where?: qx_Segment_bool_exp;
};


export type query_rootqx_search_segments_aggregateArgs = {
  args: qx_search_segments_args;
  distinct_on?: Array<qx_Segment_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Segment_order_by>;
  where?: qx_Segment_bool_exp;
};


export type query_rootqx_search_snapshotsArgs = {
  args: qx_search_snapshots_args;
  distinct_on?: Array<qx_Snapshot_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Snapshot_order_by>;
  where?: qx_Snapshot_bool_exp;
};


export type query_rootqx_search_snapshots_aggregateArgs = {
  args: qx_search_snapshots_args;
  distinct_on?: Array<qx_Snapshot_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Snapshot_order_by>;
  where?: qx_Snapshot_bool_exp;
};


export type query_rootqx_search_timelineArgs = {
  args: qx_search_timeline_args;
  distinct_on?: Array<qx_vSearchTimeline_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vSearchTimeline_order_by>;
  where?: qx_vSearchTimeline_bool_exp;
};


export type query_rootqx_search_timeline_aggregateArgs = {
  args: qx_search_timeline_args;
  distinct_on?: Array<qx_vSearchTimeline_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vSearchTimeline_order_by>;
  where?: qx_vSearchTimeline_bool_exp;
};


export type query_rootqx_vChatUsagePerModelArgs = {
  distinct_on?: Array<qx_vChatUsagePerModel_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatUsagePerModel_order_by>;
  where?: qx_vChatUsagePerModel_bool_exp;
};


export type query_rootqx_vChatUsagePerModel_aggregateArgs = {
  distinct_on?: Array<qx_vChatUsagePerModel_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatUsagePerModel_order_by>;
  where?: qx_vChatUsagePerModel_bool_exp;
};


export type query_rootqx_vChatUsageSeriesArgs = {
  distinct_on?: Array<qx_vChatUsageSeries_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatUsageSeries_order_by>;
  where?: qx_vChatUsageSeries_bool_exp;
};


export type query_rootqx_vChatUsageSeries_aggregateArgs = {
  distinct_on?: Array<qx_vChatUsageSeries_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatUsageSeries_order_by>;
  where?: qx_vChatUsageSeries_bool_exp;
};


export type query_rootqx_vDevicePlaceArgs = {
  distinct_on?: Array<qx_vDevicePlace_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vDevicePlace_order_by>;
  where?: qx_vDevicePlace_bool_exp;
};


export type query_rootqx_vDevicePlace_aggregateArgs = {
  distinct_on?: Array<qx_vDevicePlace_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vDevicePlace_order_by>;
  where?: qx_vDevicePlace_bool_exp;
};


export type query_rootqx_vDoorAccessByPersonArgs = {
  distinct_on?: Array<qx_vDoorAccessByPerson_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vDoorAccessByPerson_order_by>;
  where?: qx_vDoorAccessByPerson_bool_exp;
};


export type query_rootqx_vDoorAccessByPerson_aggregateArgs = {
  distinct_on?: Array<qx_vDoorAccessByPerson_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vDoorAccessByPerson_order_by>;
  where?: qx_vDoorAccessByPerson_bool_exp;
};


export type query_rootqx_vEventsByHourArgs = {
  distinct_on?: Array<qx_vEventsByHour_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vEventsByHour_order_by>;
  where?: qx_vEventsByHour_bool_exp;
};


export type query_rootqx_vEventsByHour_aggregateArgs = {
  distinct_on?: Array<qx_vEventsByHour_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vEventsByHour_order_by>;
  where?: qx_vEventsByHour_bool_exp;
};


export type query_rootqx_vNewestMediaArgs = {
  distinct_on?: Array<qx_vNewestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vNewestMedia_order_by>;
  where?: qx_vNewestMedia_bool_exp;
};


export type query_rootqx_vNewestMedia_aggregateArgs = {
  distinct_on?: Array<qx_vNewestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vNewestMedia_order_by>;
  where?: qx_vNewestMedia_bool_exp;
};


export type query_rootqx_vOldestMediaArgs = {
  distinct_on?: Array<qx_vOldestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vOldestMedia_order_by>;
  where?: qx_vOldestMedia_bool_exp;
};


export type query_rootqx_vOldestMedia_aggregateArgs = {
  distinct_on?: Array<qx_vOldestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vOldestMedia_order_by>;
  where?: qx_vOldestMedia_bool_exp;
};


export type query_rootqx_vPersonAccessHistoryArgs = {
  distinct_on?: Array<qx_vPersonAccessHistory_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vPersonAccessHistory_order_by>;
  where?: qx_vPersonAccessHistory_bool_exp;
};


export type query_rootqx_vPersonAccessHistory_aggregateArgs = {
  distinct_on?: Array<qx_vPersonAccessHistory_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vPersonAccessHistory_order_by>;
  where?: qx_vPersonAccessHistory_bool_exp;
};


export type query_rootqx_vPlaceAiBillingSummaryArgs = {
  distinct_on?: Array<qx_vPlaceAiBillingSummary_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vPlaceAiBillingSummary_order_by>;
  where?: qx_vPlaceAiBillingSummary_bool_exp;
};


export type query_rootqx_vPlaceAiBillingSummary_aggregateArgs = {
  distinct_on?: Array<qx_vPlaceAiBillingSummary_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vPlaceAiBillingSummary_order_by>;
  where?: qx_vPlaceAiBillingSummary_bool_exp;
};


export type query_rootqx_vPlaceHierarchyArgs = {
  distinct_on?: Array<qx_vPlaceHierarchy_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vPlaceHierarchy_order_by>;
  where?: qx_vPlaceHierarchy_bool_exp;
};


export type query_rootqx_vPlaceHierarchy_aggregateArgs = {
  distinct_on?: Array<qx_vPlaceHierarchy_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vPlaceHierarchy_order_by>;
  where?: qx_vPlaceHierarchy_bool_exp;
};


export type query_rootqx_vPlacePrivilegeArgs = {
  distinct_on?: Array<qx_vPlacePrivilege_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vPlacePrivilege_order_by>;
  where?: qx_vPlacePrivilege_bool_exp;
};


export type query_rootqx_vPlacePrivilege_aggregateArgs = {
  distinct_on?: Array<qx_vPlacePrivilege_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vPlacePrivilege_order_by>;
  where?: qx_vPlacePrivilege_bool_exp;
};


export type query_rootqx_vProfilesArgs = {
  distinct_on?: Array<qx_vProfiles_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vProfiles_order_by>;
  where?: qx_vProfiles_bool_exp;
};


export type query_rootqx_vProfiles_aggregateArgs = {
  distinct_on?: Array<qx_vProfiles_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vProfiles_order_by>;
  where?: qx_vProfiles_bool_exp;
};


export type query_rootqx_vSearchTimelineArgs = {
  distinct_on?: Array<qx_vSearchTimeline_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vSearchTimeline_order_by>;
  where?: qx_vSearchTimeline_bool_exp;
};


export type query_rootqx_vSearchTimeline_aggregateArgs = {
  distinct_on?: Array<qx_vSearchTimeline_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vSearchTimeline_order_by>;
  where?: qx_vSearchTimeline_bool_exp;
};


export type query_rootqx_video_source_oldest_mediaArgs = {
  args: qx_video_source_oldest_media_args;
  distinct_on?: Array<qx_vOldestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vOldestMedia_order_by>;
  where?: qx_vOldestMedia_bool_exp;
};


export type query_rootqx_video_source_oldest_media_aggregateArgs = {
  args: qx_video_source_oldest_media_args;
  distinct_on?: Array<qx_vOldestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vOldestMedia_order_by>;
  where?: qx_vOldestMedia_bool_exp;
};


export type query_rootqxanalytics_CloudUsageArgs = {
  distinct_on?: Array<qxanalytics_CloudUsage_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qxanalytics_CloudUsage_order_by>;
  where?: qxanalytics_CloudUsage_bool_exp;
};


export type query_rootqxanalytics_CloudUsage_aggregateArgs = {
  distinct_on?: Array<qxanalytics_CloudUsage_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qxanalytics_CloudUsage_order_by>;
  where?: qxanalytics_CloudUsage_bool_exp;
};


export type query_rootreaderArgs = {
  id: string;
};


export type query_rootreaderAccessTypeCompatibilityArgs = {
  distinct_on?: Array<readerAccessTypeCompatibility_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<readerAccessTypeCompatibility_order_by>;
  where?: readerAccessTypeCompatibility_bool_exp;
};


export type query_rootreaderAccessTypeCompatibility_aggregateArgs = {
  distinct_on?: Array<readerAccessTypeCompatibility_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<readerAccessTypeCompatibility_order_by>;
  where?: readerAccessTypeCompatibility_bool_exp;
};


export type query_rootreaderAccessTypeCompatibility_by_pkArgs = {
  id: number;
};


export type query_rootreaderAccessTypeEnumArgs = {
  value: string;
};


export type query_rootreaderAccessTypeEnumAggregateArgs = {
  distinct_on?: Array<qx_eReaderAccessType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eReaderAccessType_order_by>;
  where?: qx_eReaderAccessType_bool_exp;
};


export type query_rootreaderAccessTypeEnumsArgs = {
  distinct_on?: Array<qx_eReaderAccessType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eReaderAccessType_order_by>;
  where?: qx_eReaderAccessType_bool_exp;
};


export type query_rootreaderAggregateArgs = {
  distinct_on?: Array<qx_Reader_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Reader_order_by>;
  where?: qx_Reader_bool_exp;
};


export type query_rootreaderAuditArgs = {
  distinct_on?: Array<readerAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<readerAudit_order_by>;
  where?: readerAudit_bool_exp;
};


export type query_rootreaderAudit_aggregateArgs = {
  distinct_on?: Array<readerAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<readerAudit_order_by>;
  where?: readerAudit_bool_exp;
};


export type query_rootreaderProtocolCompatibilityArgs = {
  distinct_on?: Array<readerProtocolCompatibility_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<readerProtocolCompatibility_order_by>;
  where?: readerProtocolCompatibility_bool_exp;
};


export type query_rootreaderProtocolCompatibility_aggregateArgs = {
  distinct_on?: Array<readerProtocolCompatibility_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<readerProtocolCompatibility_order_by>;
  where?: readerProtocolCompatibility_bool_exp;
};


export type query_rootreaderProtocolCompatibility_by_pkArgs = {
  id: number;
};


export type query_rootreaderProtocolEnumArgs = {
  value: string;
};


export type query_rootreaderProtocolEnumAggregateArgs = {
  distinct_on?: Array<qx_eReaderProtocol_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eReaderProtocol_order_by>;
  where?: qx_eReaderProtocol_bool_exp;
};


export type query_rootreaderProtocolEnumsArgs = {
  distinct_on?: Array<qx_eReaderProtocol_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eReaderProtocol_order_by>;
  where?: qx_eReaderProtocol_bool_exp;
};


export type query_rootreadersArgs = {
  distinct_on?: Array<qx_Reader_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Reader_order_by>;
  where?: qx_Reader_bool_exp;
};


export type query_rootrexStateEnumArgs = {
  value: string;
};


export type query_rootrexStateEnumAggregateArgs = {
  distinct_on?: Array<qx_eRexState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eRexState_order_by>;
  where?: qx_eRexState_bool_exp;
};


export type query_rootrexStateEnumsArgs = {
  distinct_on?: Array<qx_eRexState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eRexState_order_by>;
  where?: qx_eRexState_bool_exp;
};


export type query_rootroleArgs = {
  id: string;
};


export type query_rootroleAggregateArgs = {
  distinct_on?: Array<qx_Role_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Role_order_by>;
  where?: qx_Role_bool_exp;
};


export type query_rootroleAppPrivilegesArgs = {
  distinct_on?: Array<roleAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<roleAppPrivileges_order_by>;
  where?: roleAppPrivileges_bool_exp;
};


export type query_rootroleAppPrivileges_aggregateArgs = {
  distinct_on?: Array<roleAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<roleAppPrivileges_order_by>;
  where?: roleAppPrivileges_bool_exp;
};


export type query_rootroleAppPrivileges_by_pkArgs = {
  id: string;
};


export type query_rootroleAuditArgs = {
  distinct_on?: Array<roleAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<roleAudit_order_by>;
  where?: roleAudit_bool_exp;
};


export type query_rootroleAudit_aggregateArgs = {
  distinct_on?: Array<roleAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<roleAudit_order_by>;
  where?: roleAudit_bool_exp;
};


export type query_rootrolesArgs = {
  distinct_on?: Array<qx_Role_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Role_order_by>;
  where?: qx_Role_bool_exp;
};


export type query_rootrosslareCatalogsArgs = {
  distinct_on?: Array<rosslareCatalogs_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<rosslareCatalogs_order_by>;
  where?: rosslareCatalogs_bool_exp;
};


export type query_rootrosslareCatalogs_aggregateArgs = {
  distinct_on?: Array<rosslareCatalogs_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<rosslareCatalogs_order_by>;
  where?: rosslareCatalogs_bool_exp;
};


export type query_rootrosslareCatalogs_by_pkArgs = {
  id: string;
};


export type query_rootrosslareConnectionArgs = {
  deviceID: string;
};


export type query_rootrosslareConnectionAggregateArgs = {
  distinct_on?: Array<qx_RosslareConnection_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_RosslareConnection_order_by>;
  where?: qx_RosslareConnection_bool_exp;
};


export type query_rootrosslareConnectionsArgs = {
  distinct_on?: Array<qx_RosslareConnection_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_RosslareConnection_order_by>;
  where?: qx_RosslareConnection_bool_exp;
};


export type query_roots3BucketConfigurationsArgs = {
  distinct_on?: Array<s3BucketConfigurations_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<s3BucketConfigurations_order_by>;
  where?: s3BucketConfigurations_bool_exp;
};


export type query_roots3BucketConfigurations_aggregateArgs = {
  distinct_on?: Array<s3BucketConfigurations_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<s3BucketConfigurations_order_by>;
  where?: s3BucketConfigurations_bool_exp;
};


export type query_roots3BucketConfigurations_by_pkArgs = {
  id: number;
};


export type query_rootscanSegmentsArgs = {
  id: any;
};


export type query_rootscheduleArgs = {
  id: string;
};


export type query_rootscheduleAggregateArgs = {
  distinct_on?: Array<qx_Schedule_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Schedule_order_by>;
  where?: qx_Schedule_bool_exp;
};


export type query_rootscheduleAuditArgs = {
  distinct_on?: Array<scheduleAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<scheduleAudit_order_by>;
  where?: scheduleAudit_bool_exp;
};


export type query_rootscheduleAudit_aggregateArgs = {
  distinct_on?: Array<scheduleAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<scheduleAudit_order_by>;
  where?: scheduleAudit_bool_exp;
};


export type query_rootscheduleBlockArgs = {
  id: string;
};


export type query_rootscheduleBlockAggregateArgs = {
  distinct_on?: Array<qx_ScheduleBlock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ScheduleBlock_order_by>;
  where?: qx_ScheduleBlock_bool_exp;
};


export type query_rootscheduleBlockAuditArgs = {
  distinct_on?: Array<scheduleBlockAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<scheduleBlockAudit_order_by>;
  where?: scheduleBlockAudit_bool_exp;
};


export type query_rootscheduleBlockAudit_aggregateArgs = {
  distinct_on?: Array<scheduleBlockAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<scheduleBlockAudit_order_by>;
  where?: scheduleBlockAudit_bool_exp;
};


export type query_rootscheduleBlocksArgs = {
  distinct_on?: Array<qx_ScheduleBlock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ScheduleBlock_order_by>;
  where?: qx_ScheduleBlock_bool_exp;
};


export type query_rootschedulesArgs = {
  distinct_on?: Array<qx_Schedule_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Schedule_order_by>;
  where?: qx_Schedule_bool_exp;
};


export type query_rootsearchCredentialsArgs = {
  customerPlaceID?: string;
  limit?: number;
  offset?: number;
  orderBy?: Array<CredentialOrderByInput>;
  personID?: string;
  search?: string;
};


export type query_rootsearchSegmentsArgs = {
  cloudOnly?: boolean;
  deviceID: string;
  refID: string;
  searchSegments?: string;
  videoEnd: string;
  videoSourceID?: string;
  videoStart: string;
};


export type query_rootsearchSnapshotsArgs = {
  timelapse?: boolean;
  videoEnd: string;
  videoSourceID: string;
  videoStart: string;
};


export type query_rootsegmentArgs = {
  id: string;
};


export type query_rootsegmentAggregateArgs = {
  distinct_on?: Array<qx_Segment_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Segment_order_by>;
  where?: qx_Segment_bool_exp;
};


export type query_rootsegmentsArgs = {
  distinct_on?: Array<qx_Segment_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Segment_order_by>;
  where?: qx_Segment_bool_exp;
};


export type query_rootsensorArgs = {
  id: string;
};


export type query_rootsensorActionEnumArgs = {
  value: string;
};


export type query_rootsensorActionEnumsArgs = {
  distinct_on?: Array<qx_eSensorAction_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eSensorAction_order_by>;
  where?: qx_eSensorAction_bool_exp;
};


export type query_rootsensorActionEnumsAggregateArgs = {
  distinct_on?: Array<qx_eSensorAction_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eSensorAction_order_by>;
  where?: qx_eSensorAction_bool_exp;
};


export type query_rootsensorAggregateArgs = {
  distinct_on?: Array<qx_Sensor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Sensor_order_by>;
  where?: qx_Sensor_bool_exp;
};


export type query_rootsensorTypeEnumArgs = {
  value: string;
};


export type query_rootsensorTypeEnumsArgs = {
  distinct_on?: Array<qx_eSensorType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eSensorType_order_by>;
  where?: qx_eSensorType_bool_exp;
};


export type query_rootsensorTypeEnumsAggregateArgs = {
  distinct_on?: Array<qx_eSensorType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eSensorType_order_by>;
  where?: qx_eSensorType_bool_exp;
};


export type query_rootsensorsArgs = {
  distinct_on?: Array<qx_Sensor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Sensor_order_by>;
  where?: qx_Sensor_bool_exp;
};


export type query_rootsetupCameraGatewayArgs = {
  id: any;
};


export type query_rootsharedLinkArgs = {
  id: string;
};


export type query_rootsharedLinkAggregateArgs = {
  distinct_on?: Array<qx_SharedLinks_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_SharedLinks_order_by>;
  where?: qx_SharedLinks_bool_exp;
};


export type query_rootsharedLinkAuditLogAggregateArgs = {
  distinct_on?: Array<qx_SharedLinkAuditLog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_SharedLinkAuditLog_order_by>;
  where?: qx_SharedLinkAuditLog_bool_exp;
};


export type query_rootsharedLinkAuditLogsArgs = {
  distinct_on?: Array<qx_SharedLinkAuditLog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_SharedLinkAuditLog_order_by>;
  where?: qx_SharedLinkAuditLog_bool_exp;
};


export type query_rootsharedLinksArgs = {
  distinct_on?: Array<qx_SharedLinks_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_SharedLinks_order_by>;
  where?: qx_SharedLinks_bool_exp;
};


export type query_rootsnapshotArgs = {
  id: string;
};


export type query_rootsnapshotAggregateArgs = {
  distinct_on?: Array<qx_Snapshot_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Snapshot_order_by>;
  where?: qx_Snapshot_bool_exp;
};


export type query_rootsnapshotsArgs = {
  distinct_on?: Array<qx_Snapshot_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Snapshot_order_by>;
  where?: qx_Snapshot_bool_exp;
};


export type query_rootstreamStatusEnumArgs = {
  value: string;
};


export type query_rootstreamStatusEnumAggregateArgs = {
  distinct_on?: Array<qx_eStreamStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eStreamStatus_order_by>;
  where?: qx_eStreamStatus_bool_exp;
};


export type query_rootstreamStatusEnumsArgs = {
  distinct_on?: Array<qx_eStreamStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eStreamStatus_order_by>;
  where?: qx_eStreamStatus_bool_exp;
};


export type query_rootstreamStorageStatsArgs = {
  gatewayID?: string;
};


export type query_rootsuperviseInputCompatibilityArgs = {
  distinct_on?: Array<superviseInputCompatibility_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<superviseInputCompatibility_order_by>;
  where?: superviseInputCompatibility_bool_exp;
};


export type query_rootsuperviseInputCompatibility_aggregateArgs = {
  distinct_on?: Array<superviseInputCompatibility_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<superviseInputCompatibility_order_by>;
  where?: superviseInputCompatibility_bool_exp;
};


export type query_rootsuperviseInputCompatibility_by_pkArgs = {
  id: number;
};


export type query_rootsuperviseInputsEnumArgs = {
  value: string;
};


export type query_rootsuperviseInputsEnumAggregateArgs = {
  distinct_on?: Array<qx_eSuperviseInputs_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eSuperviseInputs_order_by>;
  where?: qx_eSuperviseInputs_bool_exp;
};


export type query_rootsuperviseInputsEnumsArgs = {
  distinct_on?: Array<qx_eSuperviseInputs_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eSuperviseInputs_order_by>;
  where?: qx_eSuperviseInputs_bool_exp;
};


export type query_rootsystemInformationArgs = {
  gatewayID?: string;
};


export type query_roottermsAgreementArgs = {
  id: string;
};


export type query_roottermsAgreementAggregateArgs = {
  distinct_on?: Array<qx_TermsAgreement_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_TermsAgreement_order_by>;
  where?: qx_TermsAgreement_bool_exp;
};


export type query_roottermsAgreementsArgs = {
  distinct_on?: Array<qx_TermsAgreement_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_TermsAgreement_order_by>;
  where?: qx_TermsAgreement_bool_exp;
};


export type query_roottimeZoneArgs = {
  name: string;
};


export type query_roottimeZoneAggregateArgs = {
  distinct_on?: Array<qx_TimeZone_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_TimeZone_order_by>;
  where?: qx_TimeZone_bool_exp;
};


export type query_roottimeZonesArgs = {
  distinct_on?: Array<qx_TimeZone_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_TimeZone_order_by>;
  where?: qx_TimeZone_bool_exp;
};


export type query_rootupdateCustomerCanSelfServeArgs = {
  id: any;
};


export type query_rootupdateCustomerPlacePrivilegesArgs = {
  id: any;
};


export type query_rootuploadStatsArgs = {
  gatewayID: string;
};


export type query_rootuserSettingArgs = {
  id: string;
};


export type query_rootuserSettingsArgs = {
  distinct_on?: Array<qx_UserSetting_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_UserSetting_order_by>;
  where?: qx_UserSetting_bool_exp;
};


export type query_rootuserSettingsAggregateArgs = {
  distinct_on?: Array<qx_UserSetting_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_UserSetting_order_by>;
  where?: qx_UserSetting_bool_exp;
};


export type query_rootvEventStatusesArgs = {
  distinct_on?: Array<vEventStatuses_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<vEventStatuses_order_by>;
  where?: vEventStatuses_bool_exp;
};


export type query_rootvEventStatuses_aggregateArgs = {
  distinct_on?: Array<vEventStatuses_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<vEventStatuses_order_by>;
  where?: vEventStatuses_bool_exp;
};


export type query_rootvEventsArgs = {
  distinct_on?: Array<vEvents_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<vEvents_order_by>;
  where?: vEvents_bool_exp;
};


export type query_rootvEvents_aggregateArgs = {
  distinct_on?: Array<vEvents_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<vEvents_order_by>;
  where?: vEvents_bool_exp;
};


export type query_rootvideoSourceArgs = {
  id: string;
};


export type query_rootvideoSourceAggregateArgs = {
  distinct_on?: Array<qx_VideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_VideoSource_order_by>;
  where?: qx_VideoSource_bool_exp;
};


export type query_rootvideoSourceAuditArgs = {
  distinct_on?: Array<videoSourceAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<videoSourceAudit_order_by>;
  where?: videoSourceAudit_bool_exp;
};


export type query_rootvideoSourceAudit_aggregateArgs = {
  distinct_on?: Array<videoSourceAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<videoSourceAudit_order_by>;
  where?: videoSourceAudit_bool_exp;
};


export type query_rootvideoSourceStateArgs = {
  distinct_on?: Array<videoSourceState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<videoSourceState_order_by>;
  where?: videoSourceState_bool_exp;
};


export type query_rootvideoSourceState_aggregateArgs = {
  distinct_on?: Array<videoSourceState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<videoSourceState_order_by>;
  where?: videoSourceState_bool_exp;
};


export type query_rootvideoSourceState_by_pkArgs = {
  videoSourceID: string;
};


export type query_rootvideoSourcesArgs = {
  distinct_on?: Array<qx_VideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_VideoSource_order_by>;
  where?: qx_VideoSource_bool_exp;
};


export type query_rootviewArgs = {
  id: string;
};


export type query_rootviewsArgs = {
  distinct_on?: Array<qx_View_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_View_order_by>;
  where?: qx_View_bool_exp;
};


export type query_rootviewsAggregateArgs = {
  distinct_on?: Array<qx_View_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_View_order_by>;
  where?: qx_View_bool_exp;
};


export type query_rootwiegandCardFormatArgs = {
  id: string;
};


export type query_rootwiegandCardFormatAggregateArgs = {
  distinct_on?: Array<qx_WiegandCardFormat_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_WiegandCardFormat_order_by>;
  where?: qx_WiegandCardFormat_bool_exp;
};


export type query_rootwiegandCardFormatsArgs = {
  distinct_on?: Array<qx_WiegandCardFormat_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_WiegandCardFormat_order_by>;
  where?: qx_WiegandCardFormat_bool_exp;
};

/** columns and relationships of "qx.AccessCatalog" */
export type qx_AccessCatalog = {
  __typename?: 'qx_AccessCatalog';
  /** An object relationship */
  AccessCatalogCapabilities?: qx_AccessCatalogCapabilities;
  /** An array relationship */
  CatalogProtocolOverrides: Array<qx_CatalogProtocolOverride>;
  /** An aggregate relationship */
  CatalogProtocolOverrides_aggregate: qx_CatalogProtocolOverride_aggregate;
  /** An array relationship */
  MercuryInventories: Array<qx_AccessInventory>;
  /** An aggregate relationship */
  MercuryInventories_aggregate: qx_AccessInventory_aggregate;
  /** An object relationship */
  Place: qx_Place;
  /** An object relationship */
  eMercuryBoardType: qx_eAccessBoardType;
  /** An object relationship */
  eMercuryInterfaceType: qx_eAccessInterfaceType;
  id: string;
  interface: qx_eAccessInterfaceType_enum;
  make: string;
  model: number;
  nInputs: number;
  nOutputs: number;
  nReaders: number;
  name: string;
  placeID: string;
  type: qx_eAccessBoardType_enum;
  updatedAt?: string;
};


/** columns and relationships of "qx.AccessCatalog" */
export type qx_AccessCatalogCatalogProtocolOverridesArgs = {
  distinct_on?: Array<qx_CatalogProtocolOverride_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_CatalogProtocolOverride_order_by>;
  where?: qx_CatalogProtocolOverride_bool_exp;
};


/** columns and relationships of "qx.AccessCatalog" */
export type qx_AccessCatalogCatalogProtocolOverrides_aggregateArgs = {
  distinct_on?: Array<qx_CatalogProtocolOverride_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_CatalogProtocolOverride_order_by>;
  where?: qx_CatalogProtocolOverride_bool_exp;
};


/** columns and relationships of "qx.AccessCatalog" */
export type qx_AccessCatalogMercuryInventoriesArgs = {
  distinct_on?: Array<qx_AccessInventory_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessInventory_order_by>;
  where?: qx_AccessInventory_bool_exp;
};


/** columns and relationships of "qx.AccessCatalog" */
export type qx_AccessCatalogMercuryInventories_aggregateArgs = {
  distinct_on?: Array<qx_AccessInventory_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessInventory_order_by>;
  where?: qx_AccessInventory_bool_exp;
};

/** columns and relationships of "qx.AccessCatalogCapabilities" */
export type qx_AccessCatalogCapabilities = {
  __typename?: 'qx_AccessCatalogCapabilities';
  /** An object relationship */
  AccessCatalog: qx_AccessCatalog;
  catalogID: string;
  hasLockModes: boolean;
  hasWirelessReaders: boolean;
};

/** aggregated selection of "qx.AccessCatalogCapabilities" */
export type qx_AccessCatalogCapabilities_aggregate = {
  __typename?: 'qx_AccessCatalogCapabilities_aggregate';
  aggregate?: qx_AccessCatalogCapabilities_aggregate_fields;
  nodes: Array<qx_AccessCatalogCapabilities>;
};

/** aggregate fields of "qx.AccessCatalogCapabilities" */
export type qx_AccessCatalogCapabilities_aggregate_fields = {
  __typename?: 'qx_AccessCatalogCapabilities_aggregate_fields';
  count: number;
  max?: qx_AccessCatalogCapabilities_max_fields;
  min?: qx_AccessCatalogCapabilities_min_fields;
};


/** aggregate fields of "qx.AccessCatalogCapabilities" */
export type qx_AccessCatalogCapabilities_aggregate_fieldscountArgs = {
  columns?: Array<qx_AccessCatalogCapabilities_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.AccessCatalogCapabilities". All fields are combined with a logical 'AND'. */
export type qx_AccessCatalogCapabilities_bool_exp = {
  AccessCatalog?: qx_AccessCatalog_bool_exp;
  _and?: Array<qx_AccessCatalogCapabilities_bool_exp>;
  _not?: qx_AccessCatalogCapabilities_bool_exp;
  _or?: Array<qx_AccessCatalogCapabilities_bool_exp>;
  catalogID?: String_comparison_exp;
  hasLockModes?: Boolean_comparison_exp;
  hasWirelessReaders?: Boolean_comparison_exp;
};

/** unique or primary key constraints on table "qx.AccessCatalogCapabilities" */
export enum qx_AccessCatalogCapabilities_constraint {
  /** unique or primary key constraint on columns "catalogID" */
  AccessCatalogCapabilities_pkey = 'AccessCatalogCapabilities_pkey'
}

/** input type for inserting data into table "qx.AccessCatalogCapabilities" */
export type qx_AccessCatalogCapabilities_insert_input = {
  AccessCatalog?: qx_AccessCatalog_obj_rel_insert_input;
  catalogID?: string;
  hasLockModes?: boolean;
  hasWirelessReaders?: boolean;
};

/** aggregate max on columns */
export type qx_AccessCatalogCapabilities_max_fields = {
  __typename?: 'qx_AccessCatalogCapabilities_max_fields';
  catalogID?: string;
};

/** aggregate min on columns */
export type qx_AccessCatalogCapabilities_min_fields = {
  __typename?: 'qx_AccessCatalogCapabilities_min_fields';
  catalogID?: string;
};

/** response of any mutation on the table "qx.AccessCatalogCapabilities" */
export type qx_AccessCatalogCapabilities_mutation_response = {
  __typename?: 'qx_AccessCatalogCapabilities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_AccessCatalogCapabilities>;
};

/** input type for inserting object relation for remote table "qx.AccessCatalogCapabilities" */
export type qx_AccessCatalogCapabilities_obj_rel_insert_input = {
  data: qx_AccessCatalogCapabilities_insert_input;
  /** upsert condition */
  on_conflict?: qx_AccessCatalogCapabilities_on_conflict;
};

/** on_conflict condition type for table "qx.AccessCatalogCapabilities" */
export type qx_AccessCatalogCapabilities_on_conflict = {
  constraint: qx_AccessCatalogCapabilities_constraint;
  update_columns?: Array<qx_AccessCatalogCapabilities_update_column>;
  where?: qx_AccessCatalogCapabilities_bool_exp;
};

/** Ordering options when selecting data from "qx.AccessCatalogCapabilities". */
export type qx_AccessCatalogCapabilities_order_by = {
  AccessCatalog?: qx_AccessCatalog_order_by;
  catalogID?: order_by;
  hasLockModes?: order_by;
  hasWirelessReaders?: order_by;
};

/** primary key columns input for table: qx.AccessCatalogCapabilities */
export type qx_AccessCatalogCapabilities_pk_columns_input = {
  catalogID: string;
};

/** select columns of table "qx.AccessCatalogCapabilities" */
export enum qx_AccessCatalogCapabilities_select_column {
  /** column name */
  catalogID = 'catalogID',
  /** column name */
  hasLockModes = 'hasLockModes',
  /** column name */
  hasWirelessReaders = 'hasWirelessReaders'
}

/** input type for updating data in table "qx.AccessCatalogCapabilities" */
export type qx_AccessCatalogCapabilities_set_input = {
  catalogID?: string;
  hasLockModes?: boolean;
  hasWirelessReaders?: boolean;
};

/** Streaming cursor of the table "qx_AccessCatalogCapabilities" */
export type qx_AccessCatalogCapabilities_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_AccessCatalogCapabilities_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_AccessCatalogCapabilities_stream_cursor_value_input = {
  catalogID?: string;
  hasLockModes?: boolean;
  hasWirelessReaders?: boolean;
};

/** update columns of table "qx.AccessCatalogCapabilities" */
export enum qx_AccessCatalogCapabilities_update_column {
  /** column name */
  catalogID = 'catalogID',
  /** column name */
  hasLockModes = 'hasLockModes',
  /** column name */
  hasWirelessReaders = 'hasWirelessReaders'
}

export type qx_AccessCatalogCapabilities_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_AccessCatalogCapabilities_set_input;
  /** filter the rows which have to be updated */
  where: qx_AccessCatalogCapabilities_bool_exp;
};

/** aggregated selection of "qx.AccessCatalog" */
export type qx_AccessCatalog_aggregate = {
  __typename?: 'qx_AccessCatalog_aggregate';
  aggregate?: qx_AccessCatalog_aggregate_fields;
  nodes: Array<qx_AccessCatalog>;
};

export type qx_AccessCatalog_aggregate_bool_exp = {
  count?: qx_AccessCatalog_aggregate_bool_exp_count;
};

export type qx_AccessCatalog_aggregate_bool_exp_count = {
  arguments?: Array<qx_AccessCatalog_select_column>;
  distinct?: boolean;
  filter?: qx_AccessCatalog_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.AccessCatalog" */
export type qx_AccessCatalog_aggregate_fields = {
  __typename?: 'qx_AccessCatalog_aggregate_fields';
  avg?: qx_AccessCatalog_avg_fields;
  count: number;
  max?: qx_AccessCatalog_max_fields;
  min?: qx_AccessCatalog_min_fields;
  stddev?: qx_AccessCatalog_stddev_fields;
  stddev_pop?: qx_AccessCatalog_stddev_pop_fields;
  stddev_samp?: qx_AccessCatalog_stddev_samp_fields;
  sum?: qx_AccessCatalog_sum_fields;
  var_pop?: qx_AccessCatalog_var_pop_fields;
  var_samp?: qx_AccessCatalog_var_samp_fields;
  variance?: qx_AccessCatalog_variance_fields;
};


/** aggregate fields of "qx.AccessCatalog" */
export type qx_AccessCatalog_aggregate_fieldscountArgs = {
  columns?: Array<qx_AccessCatalog_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.AccessCatalog" */
export type qx_AccessCatalog_aggregate_order_by = {
  avg?: qx_AccessCatalog_avg_order_by;
  count?: order_by;
  max?: qx_AccessCatalog_max_order_by;
  min?: qx_AccessCatalog_min_order_by;
  stddev?: qx_AccessCatalog_stddev_order_by;
  stddev_pop?: qx_AccessCatalog_stddev_pop_order_by;
  stddev_samp?: qx_AccessCatalog_stddev_samp_order_by;
  sum?: qx_AccessCatalog_sum_order_by;
  var_pop?: qx_AccessCatalog_var_pop_order_by;
  var_samp?: qx_AccessCatalog_var_samp_order_by;
  variance?: qx_AccessCatalog_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.AccessCatalog" */
export type qx_AccessCatalog_arr_rel_insert_input = {
  data: Array<qx_AccessCatalog_insert_input>;
  /** upsert condition */
  on_conflict?: qx_AccessCatalog_on_conflict;
};

/** aggregate avg on columns */
export type qx_AccessCatalog_avg_fields = {
  __typename?: 'qx_AccessCatalog_avg_fields';
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
};

/** order by avg() on columns of table "qx.AccessCatalog" */
export type qx_AccessCatalog_avg_order_by = {
  model?: order_by;
  nInputs?: order_by;
  nOutputs?: order_by;
  nReaders?: order_by;
};

/** Boolean expression to filter rows from the table "qx.AccessCatalog". All fields are combined with a logical 'AND'. */
export type qx_AccessCatalog_bool_exp = {
  AccessCatalogCapabilities?: qx_AccessCatalogCapabilities_bool_exp;
  CatalogProtocolOverrides?: qx_CatalogProtocolOverride_bool_exp;
  CatalogProtocolOverrides_aggregate?: qx_CatalogProtocolOverride_aggregate_bool_exp;
  MercuryInventories?: qx_AccessInventory_bool_exp;
  MercuryInventories_aggregate?: qx_AccessInventory_aggregate_bool_exp;
  Place?: qx_Place_bool_exp;
  _and?: Array<qx_AccessCatalog_bool_exp>;
  _not?: qx_AccessCatalog_bool_exp;
  _or?: Array<qx_AccessCatalog_bool_exp>;
  eMercuryBoardType?: qx_eAccessBoardType_bool_exp;
  eMercuryInterfaceType?: qx_eAccessInterfaceType_bool_exp;
  id?: String_comparison_exp;
  interface?: qx_eAccessInterfaceType_enum_comparison_exp;
  make?: String_comparison_exp;
  model?: Int_comparison_exp;
  nInputs?: Int_comparison_exp;
  nOutputs?: Int_comparison_exp;
  nReaders?: Int_comparison_exp;
  name?: String_comparison_exp;
  placeID?: String_comparison_exp;
  type?: qx_eAccessBoardType_enum_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
};

/** unique or primary key constraints on table "qx.AccessCatalog" */
export enum qx_AccessCatalog_constraint {
  /** unique or primary key constraint on columns "id" */
  MercuryCatalog_pkey = 'MercuryCatalog_pkey'
}

/** input type for incrementing numeric columns in table "qx.AccessCatalog" */
export type qx_AccessCatalog_inc_input = {
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
};

/** input type for inserting data into table "qx.AccessCatalog" */
export type qx_AccessCatalog_insert_input = {
  AccessCatalogCapabilities?: qx_AccessCatalogCapabilities_obj_rel_insert_input;
  CatalogProtocolOverrides?: qx_CatalogProtocolOverride_arr_rel_insert_input;
  MercuryInventories?: qx_AccessInventory_arr_rel_insert_input;
  Place?: qx_Place_obj_rel_insert_input;
  eMercuryBoardType?: qx_eAccessBoardType_obj_rel_insert_input;
  eMercuryInterfaceType?: qx_eAccessInterfaceType_obj_rel_insert_input;
  id?: string;
  interface?: qx_eAccessInterfaceType_enum;
  make?: string;
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
  name?: string;
  placeID?: string;
  type?: qx_eAccessBoardType_enum;
  updatedAt?: string;
};

/** aggregate max on columns */
export type qx_AccessCatalog_max_fields = {
  __typename?: 'qx_AccessCatalog_max_fields';
  id?: string;
  make?: string;
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
  name?: string;
  placeID?: string;
  updatedAt?: string;
};

/** order by max() on columns of table "qx.AccessCatalog" */
export type qx_AccessCatalog_max_order_by = {
  id?: order_by;
  make?: order_by;
  model?: order_by;
  nInputs?: order_by;
  nOutputs?: order_by;
  nReaders?: order_by;
  name?: order_by;
  placeID?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type qx_AccessCatalog_min_fields = {
  __typename?: 'qx_AccessCatalog_min_fields';
  id?: string;
  make?: string;
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
  name?: string;
  placeID?: string;
  updatedAt?: string;
};

/** order by min() on columns of table "qx.AccessCatalog" */
export type qx_AccessCatalog_min_order_by = {
  id?: order_by;
  make?: order_by;
  model?: order_by;
  nInputs?: order_by;
  nOutputs?: order_by;
  nReaders?: order_by;
  name?: order_by;
  placeID?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.AccessCatalog" */
export type qx_AccessCatalog_mutation_response = {
  __typename?: 'qx_AccessCatalog_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_AccessCatalog>;
};

/** input type for inserting object relation for remote table "qx.AccessCatalog" */
export type qx_AccessCatalog_obj_rel_insert_input = {
  data: qx_AccessCatalog_insert_input;
  /** upsert condition */
  on_conflict?: qx_AccessCatalog_on_conflict;
};

/** on_conflict condition type for table "qx.AccessCatalog" */
export type qx_AccessCatalog_on_conflict = {
  constraint: qx_AccessCatalog_constraint;
  update_columns?: Array<qx_AccessCatalog_update_column>;
  where?: qx_AccessCatalog_bool_exp;
};

/** Ordering options when selecting data from "qx.AccessCatalog". */
export type qx_AccessCatalog_order_by = {
  AccessCatalogCapabilities?: qx_AccessCatalogCapabilities_order_by;
  CatalogProtocolOverrides_aggregate?: qx_CatalogProtocolOverride_aggregate_order_by;
  MercuryInventories_aggregate?: qx_AccessInventory_aggregate_order_by;
  Place?: qx_Place_order_by;
  eMercuryBoardType?: qx_eAccessBoardType_order_by;
  eMercuryInterfaceType?: qx_eAccessInterfaceType_order_by;
  id?: order_by;
  interface?: order_by;
  make?: order_by;
  model?: order_by;
  nInputs?: order_by;
  nOutputs?: order_by;
  nReaders?: order_by;
  name?: order_by;
  placeID?: order_by;
  type?: order_by;
  updatedAt?: order_by;
};

/** primary key columns input for table: qx.AccessCatalog */
export type qx_AccessCatalog_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.AccessCatalog" */
export enum qx_AccessCatalog_select_column {
  /** column name */
  id = 'id',
  /** column name */
  interface = 'interface',
  /** column name */
  make = 'make',
  /** column name */
  model = 'model',
  /** column name */
  nInputs = 'nInputs',
  /** column name */
  nOutputs = 'nOutputs',
  /** column name */
  nReaders = 'nReaders',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  type = 'type',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "qx.AccessCatalog" */
export type qx_AccessCatalog_set_input = {
  id?: string;
  interface?: qx_eAccessInterfaceType_enum;
  make?: string;
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
  name?: string;
  placeID?: string;
  type?: qx_eAccessBoardType_enum;
  updatedAt?: string;
};

/** aggregate stddev on columns */
export type qx_AccessCatalog_stddev_fields = {
  __typename?: 'qx_AccessCatalog_stddev_fields';
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
};

/** order by stddev() on columns of table "qx.AccessCatalog" */
export type qx_AccessCatalog_stddev_order_by = {
  model?: order_by;
  nInputs?: order_by;
  nOutputs?: order_by;
  nReaders?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_AccessCatalog_stddev_pop_fields = {
  __typename?: 'qx_AccessCatalog_stddev_pop_fields';
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
};

/** order by stddev_pop() on columns of table "qx.AccessCatalog" */
export type qx_AccessCatalog_stddev_pop_order_by = {
  model?: order_by;
  nInputs?: order_by;
  nOutputs?: order_by;
  nReaders?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_AccessCatalog_stddev_samp_fields = {
  __typename?: 'qx_AccessCatalog_stddev_samp_fields';
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
};

/** order by stddev_samp() on columns of table "qx.AccessCatalog" */
export type qx_AccessCatalog_stddev_samp_order_by = {
  model?: order_by;
  nInputs?: order_by;
  nOutputs?: order_by;
  nReaders?: order_by;
};

/** Streaming cursor of the table "qx_AccessCatalog" */
export type qx_AccessCatalog_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_AccessCatalog_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_AccessCatalog_stream_cursor_value_input = {
  id?: string;
  interface?: qx_eAccessInterfaceType_enum;
  make?: string;
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
  name?: string;
  placeID?: string;
  type?: qx_eAccessBoardType_enum;
  updatedAt?: string;
};

/** aggregate sum on columns */
export type qx_AccessCatalog_sum_fields = {
  __typename?: 'qx_AccessCatalog_sum_fields';
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
};

/** order by sum() on columns of table "qx.AccessCatalog" */
export type qx_AccessCatalog_sum_order_by = {
  model?: order_by;
  nInputs?: order_by;
  nOutputs?: order_by;
  nReaders?: order_by;
};

/** update columns of table "qx.AccessCatalog" */
export enum qx_AccessCatalog_update_column {
  /** column name */
  id = 'id',
  /** column name */
  interface = 'interface',
  /** column name */
  make = 'make',
  /** column name */
  model = 'model',
  /** column name */
  nInputs = 'nInputs',
  /** column name */
  nOutputs = 'nOutputs',
  /** column name */
  nReaders = 'nReaders',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  type = 'type',
  /** column name */
  updatedAt = 'updatedAt'
}

export type qx_AccessCatalog_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_AccessCatalog_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_AccessCatalog_set_input;
  /** filter the rows which have to be updated */
  where: qx_AccessCatalog_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_AccessCatalog_var_pop_fields = {
  __typename?: 'qx_AccessCatalog_var_pop_fields';
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
};

/** order by var_pop() on columns of table "qx.AccessCatalog" */
export type qx_AccessCatalog_var_pop_order_by = {
  model?: order_by;
  nInputs?: order_by;
  nOutputs?: order_by;
  nReaders?: order_by;
};

/** aggregate var_samp on columns */
export type qx_AccessCatalog_var_samp_fields = {
  __typename?: 'qx_AccessCatalog_var_samp_fields';
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
};

/** order by var_samp() on columns of table "qx.AccessCatalog" */
export type qx_AccessCatalog_var_samp_order_by = {
  model?: order_by;
  nInputs?: order_by;
  nOutputs?: order_by;
  nReaders?: order_by;
};

/** aggregate variance on columns */
export type qx_AccessCatalog_variance_fields = {
  __typename?: 'qx_AccessCatalog_variance_fields';
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
};

/** order by variance() on columns of table "qx.AccessCatalog" */
export type qx_AccessCatalog_variance_order_by = {
  model?: order_by;
  nInputs?: order_by;
  nOutputs?: order_by;
  nReaders?: order_by;
};

/** columns and relationships of "qx.AccessInventory" */
export type qx_AccessInventory = {
  __typename?: 'qx_AccessInventory';
  /** An array relationship */
  MercuryControlPoints: Array<qx_MercuryControlPoint>;
  /** An aggregate relationship */
  MercuryControlPoints_aggregate: qx_MercuryControlPoint_aggregate;
  /** An array relationship */
  MercuryMonitorPoints: Array<qx_MercuryMonitorPoint>;
  /** An aggregate relationship */
  MercuryMonitorPoints_aggregate: qx_MercuryMonitorPoint_aggregate;
  baudrate: qx_eBaudrate_enum;
  /** An object relationship */
  catalog: qx_AccessCatalog;
  catalogID: string;
  connectionStatus: qx_eDeviceConnectionStatus_enum;
  /** An object relationship */
  device: qx_Device;
  /** An array relationship */
  deviceDIOs: Array<qx_DeviceDIO>;
  /** An aggregate relationship */
  deviceDIOs_aggregate: qx_DeviceDIO_aggregate;
  deviceID: string;
  /** An array relationship */
  doors: Array<qx_Door>;
  /** An aggregate relationship */
  doors_aggregate: qx_Door_aggregate;
  /** An object relationship */
  eBaudrate: qx_eBaudrate;
  /** An object relationship */
  eDeviceConnectionStatus: qx_eDeviceConnectionStatus;
  /** An object relationship */
  eDoorAlarm: qx_eDoorAlarm;
  host: string;
  id: string;
  inputsAvail: number;
  isEncrypted: boolean;
  /** An array relationship */
  locks: Array<qx_Lock>;
  /** An aggregate relationship */
  locks_aggregate: qx_Lock_aggregate;
  outputsAvail: number;
  password?: string;
  port: number;
  /** An array relationship */
  readers: Array<qx_Reader>;
  readersAvail: number;
  readersPerDoor?: number;
  /** An aggregate relationship */
  readers_aggregate: qx_Reader_aggregate;
  serialPortsAvail: number;
  sioAddress: number;
  sioDriverId: number;
  sioNumber: number;
  sioPort: number;
  state: qx_eDoorAlarm_enum;
  updatedAt?: string;
  username?: string;
};


/** columns and relationships of "qx.AccessInventory" */
export type qx_AccessInventoryMercuryControlPointsArgs = {
  distinct_on?: Array<qx_MercuryControlPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MercuryControlPoint_order_by>;
  where?: qx_MercuryControlPoint_bool_exp;
};


/** columns and relationships of "qx.AccessInventory" */
export type qx_AccessInventoryMercuryControlPoints_aggregateArgs = {
  distinct_on?: Array<qx_MercuryControlPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MercuryControlPoint_order_by>;
  where?: qx_MercuryControlPoint_bool_exp;
};


/** columns and relationships of "qx.AccessInventory" */
export type qx_AccessInventoryMercuryMonitorPointsArgs = {
  distinct_on?: Array<qx_MercuryMonitorPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MercuryMonitorPoint_order_by>;
  where?: qx_MercuryMonitorPoint_bool_exp;
};


/** columns and relationships of "qx.AccessInventory" */
export type qx_AccessInventoryMercuryMonitorPoints_aggregateArgs = {
  distinct_on?: Array<qx_MercuryMonitorPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MercuryMonitorPoint_order_by>;
  where?: qx_MercuryMonitorPoint_bool_exp;
};


/** columns and relationships of "qx.AccessInventory" */
export type qx_AccessInventorydeviceDIOsArgs = {
  distinct_on?: Array<qx_DeviceDIO_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DeviceDIO_order_by>;
  where?: qx_DeviceDIO_bool_exp;
};


/** columns and relationships of "qx.AccessInventory" */
export type qx_AccessInventorydeviceDIOs_aggregateArgs = {
  distinct_on?: Array<qx_DeviceDIO_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DeviceDIO_order_by>;
  where?: qx_DeviceDIO_bool_exp;
};


/** columns and relationships of "qx.AccessInventory" */
export type qx_AccessInventorydoorsArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


/** columns and relationships of "qx.AccessInventory" */
export type qx_AccessInventorydoors_aggregateArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


/** columns and relationships of "qx.AccessInventory" */
export type qx_AccessInventorylocksArgs = {
  distinct_on?: Array<qx_Lock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Lock_order_by>;
  where?: qx_Lock_bool_exp;
};


/** columns and relationships of "qx.AccessInventory" */
export type qx_AccessInventorylocks_aggregateArgs = {
  distinct_on?: Array<qx_Lock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Lock_order_by>;
  where?: qx_Lock_bool_exp;
};


/** columns and relationships of "qx.AccessInventory" */
export type qx_AccessInventoryreadersArgs = {
  distinct_on?: Array<qx_Reader_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Reader_order_by>;
  where?: qx_Reader_bool_exp;
};


/** columns and relationships of "qx.AccessInventory" */
export type qx_AccessInventoryreaders_aggregateArgs = {
  distinct_on?: Array<qx_Reader_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Reader_order_by>;
  where?: qx_Reader_bool_exp;
};

/** aggregated selection of "qx.AccessInventory" */
export type qx_AccessInventory_aggregate = {
  __typename?: 'qx_AccessInventory_aggregate';
  aggregate?: qx_AccessInventory_aggregate_fields;
  nodes: Array<qx_AccessInventory>;
};

export type qx_AccessInventory_aggregate_bool_exp = {
  bool_and?: qx_AccessInventory_aggregate_bool_exp_bool_and;
  bool_or?: qx_AccessInventory_aggregate_bool_exp_bool_or;
  count?: qx_AccessInventory_aggregate_bool_exp_count;
};

export type qx_AccessInventory_aggregate_bool_exp_bool_and = {
  arguments: qx_AccessInventory_select_column_qx_AccessInventory_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: qx_AccessInventory_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_AccessInventory_aggregate_bool_exp_bool_or = {
  arguments: qx_AccessInventory_select_column_qx_AccessInventory_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: qx_AccessInventory_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_AccessInventory_aggregate_bool_exp_count = {
  arguments?: Array<qx_AccessInventory_select_column>;
  distinct?: boolean;
  filter?: qx_AccessInventory_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.AccessInventory" */
export type qx_AccessInventory_aggregate_fields = {
  __typename?: 'qx_AccessInventory_aggregate_fields';
  avg?: qx_AccessInventory_avg_fields;
  count: number;
  max?: qx_AccessInventory_max_fields;
  min?: qx_AccessInventory_min_fields;
  stddev?: qx_AccessInventory_stddev_fields;
  stddev_pop?: qx_AccessInventory_stddev_pop_fields;
  stddev_samp?: qx_AccessInventory_stddev_samp_fields;
  sum?: qx_AccessInventory_sum_fields;
  var_pop?: qx_AccessInventory_var_pop_fields;
  var_samp?: qx_AccessInventory_var_samp_fields;
  variance?: qx_AccessInventory_variance_fields;
};


/** aggregate fields of "qx.AccessInventory" */
export type qx_AccessInventory_aggregate_fieldscountArgs = {
  columns?: Array<qx_AccessInventory_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.AccessInventory" */
export type qx_AccessInventory_aggregate_order_by = {
  avg?: qx_AccessInventory_avg_order_by;
  count?: order_by;
  max?: qx_AccessInventory_max_order_by;
  min?: qx_AccessInventory_min_order_by;
  stddev?: qx_AccessInventory_stddev_order_by;
  stddev_pop?: qx_AccessInventory_stddev_pop_order_by;
  stddev_samp?: qx_AccessInventory_stddev_samp_order_by;
  sum?: qx_AccessInventory_sum_order_by;
  var_pop?: qx_AccessInventory_var_pop_order_by;
  var_samp?: qx_AccessInventory_var_samp_order_by;
  variance?: qx_AccessInventory_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.AccessInventory" */
export type qx_AccessInventory_arr_rel_insert_input = {
  data: Array<qx_AccessInventory_insert_input>;
  /** upsert condition */
  on_conflict?: qx_AccessInventory_on_conflict;
};

/** aggregate avg on columns */
export type qx_AccessInventory_avg_fields = {
  __typename?: 'qx_AccessInventory_avg_fields';
  inputsAvail?: number;
  outputsAvail?: number;
  port?: number;
  readersAvail?: number;
  readersPerDoor?: number;
  serialPortsAvail?: number;
  sioAddress?: number;
  sioDriverId?: number;
  sioNumber?: number;
  sioPort?: number;
};

/** order by avg() on columns of table "qx.AccessInventory" */
export type qx_AccessInventory_avg_order_by = {
  inputsAvail?: order_by;
  outputsAvail?: order_by;
  port?: order_by;
  readersAvail?: order_by;
  readersPerDoor?: order_by;
  serialPortsAvail?: order_by;
  sioAddress?: order_by;
  sioDriverId?: order_by;
  sioNumber?: order_by;
  sioPort?: order_by;
};

/** Boolean expression to filter rows from the table "qx.AccessInventory". All fields are combined with a logical 'AND'. */
export type qx_AccessInventory_bool_exp = {
  MercuryControlPoints?: qx_MercuryControlPoint_bool_exp;
  MercuryControlPoints_aggregate?: qx_MercuryControlPoint_aggregate_bool_exp;
  MercuryMonitorPoints?: qx_MercuryMonitorPoint_bool_exp;
  MercuryMonitorPoints_aggregate?: qx_MercuryMonitorPoint_aggregate_bool_exp;
  _and?: Array<qx_AccessInventory_bool_exp>;
  _not?: qx_AccessInventory_bool_exp;
  _or?: Array<qx_AccessInventory_bool_exp>;
  baudrate?: qx_eBaudrate_enum_comparison_exp;
  catalog?: qx_AccessCatalog_bool_exp;
  catalogID?: String_comparison_exp;
  connectionStatus?: qx_eDeviceConnectionStatus_enum_comparison_exp;
  device?: qx_Device_bool_exp;
  deviceDIOs?: qx_DeviceDIO_bool_exp;
  deviceDIOs_aggregate?: qx_DeviceDIO_aggregate_bool_exp;
  deviceID?: String_comparison_exp;
  doors?: qx_Door_bool_exp;
  doors_aggregate?: qx_Door_aggregate_bool_exp;
  eBaudrate?: qx_eBaudrate_bool_exp;
  eDeviceConnectionStatus?: qx_eDeviceConnectionStatus_bool_exp;
  eDoorAlarm?: qx_eDoorAlarm_bool_exp;
  host?: String_comparison_exp;
  id?: String_comparison_exp;
  inputsAvail?: Int_comparison_exp;
  isEncrypted?: Boolean_comparison_exp;
  locks?: qx_Lock_bool_exp;
  locks_aggregate?: qx_Lock_aggregate_bool_exp;
  outputsAvail?: Int_comparison_exp;
  password?: String_comparison_exp;
  port?: Int_comparison_exp;
  readers?: qx_Reader_bool_exp;
  readersAvail?: Int_comparison_exp;
  readersPerDoor?: Int_comparison_exp;
  readers_aggregate?: qx_Reader_aggregate_bool_exp;
  serialPortsAvail?: Int_comparison_exp;
  sioAddress?: Int_comparison_exp;
  sioDriverId?: Int_comparison_exp;
  sioNumber?: Int_comparison_exp;
  sioPort?: Int_comparison_exp;
  state?: qx_eDoorAlarm_enum_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
  username?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.AccessInventory" */
export enum qx_AccessInventory_constraint {
  /** unique or primary key constraint on columns "sioNumber", "sioPort", "deviceID" */
  MercuryInventory_deviceID_sioPort_sioAddress_constraint = 'MercuryInventory_deviceID_sioPort_sioAddress_constraint',
  /** unique or primary key constraint on columns "sioPort", "deviceID", "sioAddress" */
  MercuryInventory_deviceID_sioPort_sioNumber_constraint = 'MercuryInventory_deviceID_sioPort_sioNumber_constraint',
  /** unique or primary key constraint on columns "id" */
  MercuryInventory_pkey = 'MercuryInventory_pkey'
}

/** input type for incrementing numeric columns in table "qx.AccessInventory" */
export type qx_AccessInventory_inc_input = {
  inputsAvail?: number;
  outputsAvail?: number;
  port?: number;
  readersAvail?: number;
  readersPerDoor?: number;
  serialPortsAvail?: number;
  sioAddress?: number;
  sioDriverId?: number;
  sioNumber?: number;
  sioPort?: number;
};

/** input type for inserting data into table "qx.AccessInventory" */
export type qx_AccessInventory_insert_input = {
  MercuryControlPoints?: qx_MercuryControlPoint_arr_rel_insert_input;
  MercuryMonitorPoints?: qx_MercuryMonitorPoint_arr_rel_insert_input;
  baudrate?: qx_eBaudrate_enum;
  catalog?: qx_AccessCatalog_obj_rel_insert_input;
  catalogID?: string;
  connectionStatus?: qx_eDeviceConnectionStatus_enum;
  device?: qx_Device_obj_rel_insert_input;
  deviceDIOs?: qx_DeviceDIO_arr_rel_insert_input;
  deviceID?: string;
  doors?: qx_Door_arr_rel_insert_input;
  eBaudrate?: qx_eBaudrate_obj_rel_insert_input;
  eDeviceConnectionStatus?: qx_eDeviceConnectionStatus_obj_rel_insert_input;
  eDoorAlarm?: qx_eDoorAlarm_obj_rel_insert_input;
  host?: string;
  id?: string;
  inputsAvail?: number;
  isEncrypted?: boolean;
  locks?: qx_Lock_arr_rel_insert_input;
  outputsAvail?: number;
  password?: string;
  port?: number;
  readers?: qx_Reader_arr_rel_insert_input;
  readersAvail?: number;
  readersPerDoor?: number;
  serialPortsAvail?: number;
  sioAddress?: number;
  sioDriverId?: number;
  sioNumber?: number;
  sioPort?: number;
  state?: qx_eDoorAlarm_enum;
  updatedAt?: string;
  username?: string;
};

/** aggregate max on columns */
export type qx_AccessInventory_max_fields = {
  __typename?: 'qx_AccessInventory_max_fields';
  catalogID?: string;
  deviceID?: string;
  host?: string;
  id?: string;
  inputsAvail?: number;
  outputsAvail?: number;
  password?: string;
  port?: number;
  readersAvail?: number;
  readersPerDoor?: number;
  serialPortsAvail?: number;
  sioAddress?: number;
  sioDriverId?: number;
  sioNumber?: number;
  sioPort?: number;
  updatedAt?: string;
  username?: string;
};

/** order by max() on columns of table "qx.AccessInventory" */
export type qx_AccessInventory_max_order_by = {
  catalogID?: order_by;
  deviceID?: order_by;
  host?: order_by;
  id?: order_by;
  inputsAvail?: order_by;
  outputsAvail?: order_by;
  password?: order_by;
  port?: order_by;
  readersAvail?: order_by;
  readersPerDoor?: order_by;
  serialPortsAvail?: order_by;
  sioAddress?: order_by;
  sioDriverId?: order_by;
  sioNumber?: order_by;
  sioPort?: order_by;
  updatedAt?: order_by;
  username?: order_by;
};

/** aggregate min on columns */
export type qx_AccessInventory_min_fields = {
  __typename?: 'qx_AccessInventory_min_fields';
  catalogID?: string;
  deviceID?: string;
  host?: string;
  id?: string;
  inputsAvail?: number;
  outputsAvail?: number;
  password?: string;
  port?: number;
  readersAvail?: number;
  readersPerDoor?: number;
  serialPortsAvail?: number;
  sioAddress?: number;
  sioDriverId?: number;
  sioNumber?: number;
  sioPort?: number;
  updatedAt?: string;
  username?: string;
};

/** order by min() on columns of table "qx.AccessInventory" */
export type qx_AccessInventory_min_order_by = {
  catalogID?: order_by;
  deviceID?: order_by;
  host?: order_by;
  id?: order_by;
  inputsAvail?: order_by;
  outputsAvail?: order_by;
  password?: order_by;
  port?: order_by;
  readersAvail?: order_by;
  readersPerDoor?: order_by;
  serialPortsAvail?: order_by;
  sioAddress?: order_by;
  sioDriverId?: order_by;
  sioNumber?: order_by;
  sioPort?: order_by;
  updatedAt?: order_by;
  username?: order_by;
};

/** response of any mutation on the table "qx.AccessInventory" */
export type qx_AccessInventory_mutation_response = {
  __typename?: 'qx_AccessInventory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_AccessInventory>;
};

/** input type for inserting object relation for remote table "qx.AccessInventory" */
export type qx_AccessInventory_obj_rel_insert_input = {
  data: qx_AccessInventory_insert_input;
  /** upsert condition */
  on_conflict?: qx_AccessInventory_on_conflict;
};

/** on_conflict condition type for table "qx.AccessInventory" */
export type qx_AccessInventory_on_conflict = {
  constraint: qx_AccessInventory_constraint;
  update_columns?: Array<qx_AccessInventory_update_column>;
  where?: qx_AccessInventory_bool_exp;
};

/** Ordering options when selecting data from "qx.AccessInventory". */
export type qx_AccessInventory_order_by = {
  MercuryControlPoints_aggregate?: qx_MercuryControlPoint_aggregate_order_by;
  MercuryMonitorPoints_aggregate?: qx_MercuryMonitorPoint_aggregate_order_by;
  baudrate?: order_by;
  catalog?: qx_AccessCatalog_order_by;
  catalogID?: order_by;
  connectionStatus?: order_by;
  device?: qx_Device_order_by;
  deviceDIOs_aggregate?: qx_DeviceDIO_aggregate_order_by;
  deviceID?: order_by;
  doors_aggregate?: qx_Door_aggregate_order_by;
  eBaudrate?: qx_eBaudrate_order_by;
  eDeviceConnectionStatus?: qx_eDeviceConnectionStatus_order_by;
  eDoorAlarm?: qx_eDoorAlarm_order_by;
  host?: order_by;
  id?: order_by;
  inputsAvail?: order_by;
  isEncrypted?: order_by;
  locks_aggregate?: qx_Lock_aggregate_order_by;
  outputsAvail?: order_by;
  password?: order_by;
  port?: order_by;
  readersAvail?: order_by;
  readersPerDoor?: order_by;
  readers_aggregate?: qx_Reader_aggregate_order_by;
  serialPortsAvail?: order_by;
  sioAddress?: order_by;
  sioDriverId?: order_by;
  sioNumber?: order_by;
  sioPort?: order_by;
  state?: order_by;
  updatedAt?: order_by;
  username?: order_by;
};

/** primary key columns input for table: qx.AccessInventory */
export type qx_AccessInventory_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.AccessInventory" */
export enum qx_AccessInventory_select_column {
  /** column name */
  baudrate = 'baudrate',
  /** column name */
  catalogID = 'catalogID',
  /** column name */
  connectionStatus = 'connectionStatus',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  host = 'host',
  /** column name */
  id = 'id',
  /** column name */
  inputsAvail = 'inputsAvail',
  /** column name */
  isEncrypted = 'isEncrypted',
  /** column name */
  outputsAvail = 'outputsAvail',
  /** column name */
  password = 'password',
  /** column name */
  port = 'port',
  /** column name */
  readersAvail = 'readersAvail',
  /** column name */
  readersPerDoor = 'readersPerDoor',
  /** column name */
  serialPortsAvail = 'serialPortsAvail',
  /** column name */
  sioAddress = 'sioAddress',
  /** column name */
  sioDriverId = 'sioDriverId',
  /** column name */
  sioNumber = 'sioNumber',
  /** column name */
  sioPort = 'sioPort',
  /** column name */
  state = 'state',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  username = 'username'
}

/** select "qx_AccessInventory_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.AccessInventory" */
export enum qx_AccessInventory_select_column_qx_AccessInventory_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  isEncrypted = 'isEncrypted'
}

/** select "qx_AccessInventory_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.AccessInventory" */
export enum qx_AccessInventory_select_column_qx_AccessInventory_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  isEncrypted = 'isEncrypted'
}

/** input type for updating data in table "qx.AccessInventory" */
export type qx_AccessInventory_set_input = {
  baudrate?: qx_eBaudrate_enum;
  catalogID?: string;
  connectionStatus?: qx_eDeviceConnectionStatus_enum;
  deviceID?: string;
  host?: string;
  id?: string;
  inputsAvail?: number;
  isEncrypted?: boolean;
  outputsAvail?: number;
  password?: string;
  port?: number;
  readersAvail?: number;
  readersPerDoor?: number;
  serialPortsAvail?: number;
  sioAddress?: number;
  sioDriverId?: number;
  sioNumber?: number;
  sioPort?: number;
  state?: qx_eDoorAlarm_enum;
  updatedAt?: string;
  username?: string;
};

/** aggregate stddev on columns */
export type qx_AccessInventory_stddev_fields = {
  __typename?: 'qx_AccessInventory_stddev_fields';
  inputsAvail?: number;
  outputsAvail?: number;
  port?: number;
  readersAvail?: number;
  readersPerDoor?: number;
  serialPortsAvail?: number;
  sioAddress?: number;
  sioDriverId?: number;
  sioNumber?: number;
  sioPort?: number;
};

/** order by stddev() on columns of table "qx.AccessInventory" */
export type qx_AccessInventory_stddev_order_by = {
  inputsAvail?: order_by;
  outputsAvail?: order_by;
  port?: order_by;
  readersAvail?: order_by;
  readersPerDoor?: order_by;
  serialPortsAvail?: order_by;
  sioAddress?: order_by;
  sioDriverId?: order_by;
  sioNumber?: order_by;
  sioPort?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_AccessInventory_stddev_pop_fields = {
  __typename?: 'qx_AccessInventory_stddev_pop_fields';
  inputsAvail?: number;
  outputsAvail?: number;
  port?: number;
  readersAvail?: number;
  readersPerDoor?: number;
  serialPortsAvail?: number;
  sioAddress?: number;
  sioDriverId?: number;
  sioNumber?: number;
  sioPort?: number;
};

/** order by stddev_pop() on columns of table "qx.AccessInventory" */
export type qx_AccessInventory_stddev_pop_order_by = {
  inputsAvail?: order_by;
  outputsAvail?: order_by;
  port?: order_by;
  readersAvail?: order_by;
  readersPerDoor?: order_by;
  serialPortsAvail?: order_by;
  sioAddress?: order_by;
  sioDriverId?: order_by;
  sioNumber?: order_by;
  sioPort?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_AccessInventory_stddev_samp_fields = {
  __typename?: 'qx_AccessInventory_stddev_samp_fields';
  inputsAvail?: number;
  outputsAvail?: number;
  port?: number;
  readersAvail?: number;
  readersPerDoor?: number;
  serialPortsAvail?: number;
  sioAddress?: number;
  sioDriverId?: number;
  sioNumber?: number;
  sioPort?: number;
};

/** order by stddev_samp() on columns of table "qx.AccessInventory" */
export type qx_AccessInventory_stddev_samp_order_by = {
  inputsAvail?: order_by;
  outputsAvail?: order_by;
  port?: order_by;
  readersAvail?: order_by;
  readersPerDoor?: order_by;
  serialPortsAvail?: order_by;
  sioAddress?: order_by;
  sioDriverId?: order_by;
  sioNumber?: order_by;
  sioPort?: order_by;
};

/** Streaming cursor of the table "qx_AccessInventory" */
export type qx_AccessInventory_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_AccessInventory_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_AccessInventory_stream_cursor_value_input = {
  baudrate?: qx_eBaudrate_enum;
  catalogID?: string;
  connectionStatus?: qx_eDeviceConnectionStatus_enum;
  deviceID?: string;
  host?: string;
  id?: string;
  inputsAvail?: number;
  isEncrypted?: boolean;
  outputsAvail?: number;
  password?: string;
  port?: number;
  readersAvail?: number;
  readersPerDoor?: number;
  serialPortsAvail?: number;
  sioAddress?: number;
  sioDriverId?: number;
  sioNumber?: number;
  sioPort?: number;
  state?: qx_eDoorAlarm_enum;
  updatedAt?: string;
  username?: string;
};

/** aggregate sum on columns */
export type qx_AccessInventory_sum_fields = {
  __typename?: 'qx_AccessInventory_sum_fields';
  inputsAvail?: number;
  outputsAvail?: number;
  port?: number;
  readersAvail?: number;
  readersPerDoor?: number;
  serialPortsAvail?: number;
  sioAddress?: number;
  sioDriverId?: number;
  sioNumber?: number;
  sioPort?: number;
};

/** order by sum() on columns of table "qx.AccessInventory" */
export type qx_AccessInventory_sum_order_by = {
  inputsAvail?: order_by;
  outputsAvail?: order_by;
  port?: order_by;
  readersAvail?: order_by;
  readersPerDoor?: order_by;
  serialPortsAvail?: order_by;
  sioAddress?: order_by;
  sioDriverId?: order_by;
  sioNumber?: order_by;
  sioPort?: order_by;
};

/** update columns of table "qx.AccessInventory" */
export enum qx_AccessInventory_update_column {
  /** column name */
  baudrate = 'baudrate',
  /** column name */
  catalogID = 'catalogID',
  /** column name */
  connectionStatus = 'connectionStatus',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  host = 'host',
  /** column name */
  id = 'id',
  /** column name */
  inputsAvail = 'inputsAvail',
  /** column name */
  isEncrypted = 'isEncrypted',
  /** column name */
  outputsAvail = 'outputsAvail',
  /** column name */
  password = 'password',
  /** column name */
  port = 'port',
  /** column name */
  readersAvail = 'readersAvail',
  /** column name */
  readersPerDoor = 'readersPerDoor',
  /** column name */
  serialPortsAvail = 'serialPortsAvail',
  /** column name */
  sioAddress = 'sioAddress',
  /** column name */
  sioDriverId = 'sioDriverId',
  /** column name */
  sioNumber = 'sioNumber',
  /** column name */
  sioPort = 'sioPort',
  /** column name */
  state = 'state',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  username = 'username'
}

export type qx_AccessInventory_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_AccessInventory_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_AccessInventory_set_input;
  /** filter the rows which have to be updated */
  where: qx_AccessInventory_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_AccessInventory_var_pop_fields = {
  __typename?: 'qx_AccessInventory_var_pop_fields';
  inputsAvail?: number;
  outputsAvail?: number;
  port?: number;
  readersAvail?: number;
  readersPerDoor?: number;
  serialPortsAvail?: number;
  sioAddress?: number;
  sioDriverId?: number;
  sioNumber?: number;
  sioPort?: number;
};

/** order by var_pop() on columns of table "qx.AccessInventory" */
export type qx_AccessInventory_var_pop_order_by = {
  inputsAvail?: order_by;
  outputsAvail?: order_by;
  port?: order_by;
  readersAvail?: order_by;
  readersPerDoor?: order_by;
  serialPortsAvail?: order_by;
  sioAddress?: order_by;
  sioDriverId?: order_by;
  sioNumber?: order_by;
  sioPort?: order_by;
};

/** aggregate var_samp on columns */
export type qx_AccessInventory_var_samp_fields = {
  __typename?: 'qx_AccessInventory_var_samp_fields';
  inputsAvail?: number;
  outputsAvail?: number;
  port?: number;
  readersAvail?: number;
  readersPerDoor?: number;
  serialPortsAvail?: number;
  sioAddress?: number;
  sioDriverId?: number;
  sioNumber?: number;
  sioPort?: number;
};

/** order by var_samp() on columns of table "qx.AccessInventory" */
export type qx_AccessInventory_var_samp_order_by = {
  inputsAvail?: order_by;
  outputsAvail?: order_by;
  port?: order_by;
  readersAvail?: order_by;
  readersPerDoor?: order_by;
  serialPortsAvail?: order_by;
  sioAddress?: order_by;
  sioDriverId?: order_by;
  sioNumber?: order_by;
  sioPort?: order_by;
};

/** aggregate variance on columns */
export type qx_AccessInventory_variance_fields = {
  __typename?: 'qx_AccessInventory_variance_fields';
  inputsAvail?: number;
  outputsAvail?: number;
  port?: number;
  readersAvail?: number;
  readersPerDoor?: number;
  serialPortsAvail?: number;
  sioAddress?: number;
  sioDriverId?: number;
  sioNumber?: number;
  sioPort?: number;
};

/** order by variance() on columns of table "qx.AccessInventory" */
export type qx_AccessInventory_variance_order_by = {
  inputsAvail?: order_by;
  outputsAvail?: order_by;
  port?: order_by;
  readersAvail?: order_by;
  readersPerDoor?: order_by;
  serialPortsAvail?: order_by;
  sioAddress?: order_by;
  sioDriverId?: order_by;
  sioNumber?: order_by;
  sioPort?: order_by;
};

/** columns and relationships of "qx.AudioSource" */
export type qx_AudioSource = {
  __typename?: 'qx_AudioSource';
  channels?: Scalars['smallint']['output'];
  createdAt: string;
  description?: string;
  /** An object relationship */
  device: qx_Device;
  /** A computed field, executes function "qx.get_audio_source_device_connectionStatus" */
  deviceConnectionStatus?: string;
  deviceID: string;
  /** A computed field, executes function "qx.get_audio_source_device_pacsStatus" */
  devicePacStatus?: string;
  /** A computed field, executes function "qx.get_audio_source_device_pacsHWUpdate" */
  devicePacsHWUpdate?: string;
  enabled: boolean;
  /** A computed field, executes function "qx.get_audio_source_gateway_connectionStatus" */
  gatewayConnectionStatus?: boolean;
  /** A computed field, executes function "qx.get_audio_source_gateway_id" */
  gatewayID?: string;
  /** A computed field, executes function "qx.get_audio_source_gateway_placeID" */
  gatewayPlaceID?: string;
  /** A computed field, executes function "qx.get_audio_source_gateway_syncStatus" */
  gatewaySyncStatus?: string;
  id: string;
  /** An array relationship */
  mediaProfiles: Array<qx_MediaProfile>;
  /** An aggregate relationship */
  mediaProfiles_aggregate: qx_MediaProfile_aggregate;
  name: string;
  /** An array relationship */
  privileges: Array<personAudioSourceAppPrivileges>;
  /** An aggregate relationship */
  privileges_aggregate: personAudioSourceAppPrivileges_aggregate;
  refID: string;
  updatedAt?: string;
  /** An array relationship */
  videoSources: Array<audioSourceVideoSource>;
  /** An aggregate relationship */
  videoSources_aggregate: audioSourceVideoSource_aggregate;
};


/** columns and relationships of "qx.AudioSource" */
export type qx_AudioSourcemediaProfilesArgs = {
  distinct_on?: Array<qx_MediaProfile_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MediaProfile_order_by>;
  where?: qx_MediaProfile_bool_exp;
};


/** columns and relationships of "qx.AudioSource" */
export type qx_AudioSourcemediaProfiles_aggregateArgs = {
  distinct_on?: Array<qx_MediaProfile_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MediaProfile_order_by>;
  where?: qx_MediaProfile_bool_exp;
};


/** columns and relationships of "qx.AudioSource" */
export type qx_AudioSourceprivilegesArgs = {
  distinct_on?: Array<personAudioSourceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personAudioSourceAppPrivileges_order_by>;
  where?: personAudioSourceAppPrivileges_bool_exp;
};


/** columns and relationships of "qx.AudioSource" */
export type qx_AudioSourceprivileges_aggregateArgs = {
  distinct_on?: Array<personAudioSourceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personAudioSourceAppPrivileges_order_by>;
  where?: personAudioSourceAppPrivileges_bool_exp;
};


/** columns and relationships of "qx.AudioSource" */
export type qx_AudioSourcevideoSourcesArgs = {
  distinct_on?: Array<audioSourceVideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<audioSourceVideoSource_order_by>;
  where?: audioSourceVideoSource_bool_exp;
};


/** columns and relationships of "qx.AudioSource" */
export type qx_AudioSourcevideoSources_aggregateArgs = {
  distinct_on?: Array<audioSourceVideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<audioSourceVideoSource_order_by>;
  where?: audioSourceVideoSource_bool_exp;
};

/** aggregated selection of "qx.AudioSource" */
export type qx_AudioSource_aggregate = {
  __typename?: 'qx_AudioSource_aggregate';
  aggregate?: qx_AudioSource_aggregate_fields;
  nodes: Array<qx_AudioSource>;
};

export type qx_AudioSource_aggregate_bool_exp = {
  bool_and?: qx_AudioSource_aggregate_bool_exp_bool_and;
  bool_or?: qx_AudioSource_aggregate_bool_exp_bool_or;
  count?: qx_AudioSource_aggregate_bool_exp_count;
};

export type qx_AudioSource_aggregate_bool_exp_bool_and = {
  arguments: qx_AudioSource_select_column_qx_AudioSource_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: qx_AudioSource_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_AudioSource_aggregate_bool_exp_bool_or = {
  arguments: qx_AudioSource_select_column_qx_AudioSource_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: qx_AudioSource_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_AudioSource_aggregate_bool_exp_count = {
  arguments?: Array<qx_AudioSource_select_column>;
  distinct?: boolean;
  filter?: qx_AudioSource_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.AudioSource" */
export type qx_AudioSource_aggregate_fields = {
  __typename?: 'qx_AudioSource_aggregate_fields';
  avg?: qx_AudioSource_avg_fields;
  count: number;
  max?: qx_AudioSource_max_fields;
  min?: qx_AudioSource_min_fields;
  stddev?: qx_AudioSource_stddev_fields;
  stddev_pop?: qx_AudioSource_stddev_pop_fields;
  stddev_samp?: qx_AudioSource_stddev_samp_fields;
  sum?: qx_AudioSource_sum_fields;
  var_pop?: qx_AudioSource_var_pop_fields;
  var_samp?: qx_AudioSource_var_samp_fields;
  variance?: qx_AudioSource_variance_fields;
};


/** aggregate fields of "qx.AudioSource" */
export type qx_AudioSource_aggregate_fieldscountArgs = {
  columns?: Array<qx_AudioSource_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.AudioSource" */
export type qx_AudioSource_aggregate_order_by = {
  avg?: qx_AudioSource_avg_order_by;
  count?: order_by;
  max?: qx_AudioSource_max_order_by;
  min?: qx_AudioSource_min_order_by;
  stddev?: qx_AudioSource_stddev_order_by;
  stddev_pop?: qx_AudioSource_stddev_pop_order_by;
  stddev_samp?: qx_AudioSource_stddev_samp_order_by;
  sum?: qx_AudioSource_sum_order_by;
  var_pop?: qx_AudioSource_var_pop_order_by;
  var_samp?: qx_AudioSource_var_samp_order_by;
  variance?: qx_AudioSource_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.AudioSource" */
export type qx_AudioSource_arr_rel_insert_input = {
  data: Array<qx_AudioSource_insert_input>;
  /** upsert condition */
  on_conflict?: qx_AudioSource_on_conflict;
};

/** aggregate avg on columns */
export type qx_AudioSource_avg_fields = {
  __typename?: 'qx_AudioSource_avg_fields';
  channels?: number;
  id?: number;
};

/** order by avg() on columns of table "qx.AudioSource" */
export type qx_AudioSource_avg_order_by = {
  channels?: order_by;
  id?: order_by;
};

/** Boolean expression to filter rows from the table "qx.AudioSource". All fields are combined with a logical 'AND'. */
export type qx_AudioSource_bool_exp = {
  _and?: Array<qx_AudioSource_bool_exp>;
  _not?: qx_AudioSource_bool_exp;
  _or?: Array<qx_AudioSource_bool_exp>;
  channels?: smallint_comparison_exp;
  createdAt?: timestamptz_comparison_exp;
  description?: String_comparison_exp;
  device?: qx_Device_bool_exp;
  deviceConnectionStatus?: String_comparison_exp;
  deviceID?: String_comparison_exp;
  devicePacStatus?: String_comparison_exp;
  devicePacsHWUpdate?: String_comparison_exp;
  enabled?: Boolean_comparison_exp;
  gatewayConnectionStatus?: Boolean_comparison_exp;
  gatewayID?: String_comparison_exp;
  gatewayPlaceID?: String_comparison_exp;
  gatewaySyncStatus?: String_comparison_exp;
  id?: bigint_comparison_exp;
  mediaProfiles?: qx_MediaProfile_bool_exp;
  mediaProfiles_aggregate?: qx_MediaProfile_aggregate_bool_exp;
  name?: String_comparison_exp;
  privileges?: personAudioSourceAppPrivileges_bool_exp;
  privileges_aggregate?: personAudioSourceAppPrivileges_aggregate_bool_exp;
  refID?: String_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
  videoSources?: audioSourceVideoSource_bool_exp;
  videoSources_aggregate?: audioSourceVideoSource_aggregate_bool_exp;
};

/** unique or primary key constraints on table "qx.AudioSource" */
export enum qx_AudioSource_constraint {
  /** unique or primary key constraint on columns "refID", "deviceID" */
  AudioSource_deviceID_refID_constraint = 'AudioSource_deviceID_refID_constraint',
  /** unique or primary key constraint on columns "id" */
  AudioSource_pkey = 'AudioSource_pkey'
}

/** input type for incrementing numeric columns in table "qx.AudioSource" */
export type qx_AudioSource_inc_input = {
  channels?: Scalars['smallint']['input'];
  id?: string;
};

/** input type for inserting data into table "qx.AudioSource" */
export type qx_AudioSource_insert_input = {
  channels?: Scalars['smallint']['input'];
  createdAt?: string;
  description?: string;
  device?: qx_Device_obj_rel_insert_input;
  deviceID?: string;
  enabled?: boolean;
  id?: string;
  mediaProfiles?: qx_MediaProfile_arr_rel_insert_input;
  name?: string;
  privileges?: personAudioSourceAppPrivileges_arr_rel_insert_input;
  refID?: string;
  updatedAt?: string;
  videoSources?: audioSourceVideoSource_arr_rel_insert_input;
};

/** aggregate max on columns */
export type qx_AudioSource_max_fields = {
  __typename?: 'qx_AudioSource_max_fields';
  channels?: Scalars['smallint']['output'];
  createdAt?: string;
  description?: string;
  /** A computed field, executes function "qx.get_audio_source_device_connectionStatus" */
  deviceConnectionStatus?: string;
  deviceID?: string;
  /** A computed field, executes function "qx.get_audio_source_device_pacsStatus" */
  devicePacStatus?: string;
  /** A computed field, executes function "qx.get_audio_source_device_pacsHWUpdate" */
  devicePacsHWUpdate?: string;
  /** A computed field, executes function "qx.get_audio_source_gateway_id" */
  gatewayID?: string;
  /** A computed field, executes function "qx.get_audio_source_gateway_placeID" */
  gatewayPlaceID?: string;
  /** A computed field, executes function "qx.get_audio_source_gateway_syncStatus" */
  gatewaySyncStatus?: string;
  id?: string;
  name?: string;
  refID?: string;
  updatedAt?: string;
};

/** order by max() on columns of table "qx.AudioSource" */
export type qx_AudioSource_max_order_by = {
  channels?: order_by;
  createdAt?: order_by;
  description?: order_by;
  deviceID?: order_by;
  id?: order_by;
  name?: order_by;
  refID?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type qx_AudioSource_min_fields = {
  __typename?: 'qx_AudioSource_min_fields';
  channels?: Scalars['smallint']['output'];
  createdAt?: string;
  description?: string;
  /** A computed field, executes function "qx.get_audio_source_device_connectionStatus" */
  deviceConnectionStatus?: string;
  deviceID?: string;
  /** A computed field, executes function "qx.get_audio_source_device_pacsStatus" */
  devicePacStatus?: string;
  /** A computed field, executes function "qx.get_audio_source_device_pacsHWUpdate" */
  devicePacsHWUpdate?: string;
  /** A computed field, executes function "qx.get_audio_source_gateway_id" */
  gatewayID?: string;
  /** A computed field, executes function "qx.get_audio_source_gateway_placeID" */
  gatewayPlaceID?: string;
  /** A computed field, executes function "qx.get_audio_source_gateway_syncStatus" */
  gatewaySyncStatus?: string;
  id?: string;
  name?: string;
  refID?: string;
  updatedAt?: string;
};

/** order by min() on columns of table "qx.AudioSource" */
export type qx_AudioSource_min_order_by = {
  channels?: order_by;
  createdAt?: order_by;
  description?: order_by;
  deviceID?: order_by;
  id?: order_by;
  name?: order_by;
  refID?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.AudioSource" */
export type qx_AudioSource_mutation_response = {
  __typename?: 'qx_AudioSource_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_AudioSource>;
};

/** input type for inserting object relation for remote table "qx.AudioSource" */
export type qx_AudioSource_obj_rel_insert_input = {
  data: qx_AudioSource_insert_input;
  /** upsert condition */
  on_conflict?: qx_AudioSource_on_conflict;
};

/** on_conflict condition type for table "qx.AudioSource" */
export type qx_AudioSource_on_conflict = {
  constraint: qx_AudioSource_constraint;
  update_columns?: Array<qx_AudioSource_update_column>;
  where?: qx_AudioSource_bool_exp;
};

/** Ordering options when selecting data from "qx.AudioSource". */
export type qx_AudioSource_order_by = {
  channels?: order_by;
  createdAt?: order_by;
  description?: order_by;
  device?: qx_Device_order_by;
  deviceConnectionStatus?: order_by;
  deviceID?: order_by;
  devicePacStatus?: order_by;
  devicePacsHWUpdate?: order_by;
  enabled?: order_by;
  gatewayConnectionStatus?: order_by;
  gatewayID?: order_by;
  gatewayPlaceID?: order_by;
  gatewaySyncStatus?: order_by;
  id?: order_by;
  mediaProfiles_aggregate?: qx_MediaProfile_aggregate_order_by;
  name?: order_by;
  privileges_aggregate?: personAudioSourceAppPrivileges_aggregate_order_by;
  refID?: order_by;
  updatedAt?: order_by;
  videoSources_aggregate?: audioSourceVideoSource_aggregate_order_by;
};

/** primary key columns input for table: qx.AudioSource */
export type qx_AudioSource_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.AudioSource" */
export enum qx_AudioSource_select_column {
  /** column name */
  channels = 'channels',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  description = 'description',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  enabled = 'enabled',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  refID = 'refID',
  /** column name */
  updatedAt = 'updatedAt'
}

/** select "qx_AudioSource_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.AudioSource" */
export enum qx_AudioSource_select_column_qx_AudioSource_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  enabled = 'enabled'
}

/** select "qx_AudioSource_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.AudioSource" */
export enum qx_AudioSource_select_column_qx_AudioSource_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  enabled = 'enabled'
}

/** input type for updating data in table "qx.AudioSource" */
export type qx_AudioSource_set_input = {
  channels?: Scalars['smallint']['input'];
  createdAt?: string;
  description?: string;
  deviceID?: string;
  enabled?: boolean;
  id?: string;
  name?: string;
  refID?: string;
  updatedAt?: string;
};

/** aggregate stddev on columns */
export type qx_AudioSource_stddev_fields = {
  __typename?: 'qx_AudioSource_stddev_fields';
  channels?: number;
  id?: number;
};

/** order by stddev() on columns of table "qx.AudioSource" */
export type qx_AudioSource_stddev_order_by = {
  channels?: order_by;
  id?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_AudioSource_stddev_pop_fields = {
  __typename?: 'qx_AudioSource_stddev_pop_fields';
  channels?: number;
  id?: number;
};

/** order by stddev_pop() on columns of table "qx.AudioSource" */
export type qx_AudioSource_stddev_pop_order_by = {
  channels?: order_by;
  id?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_AudioSource_stddev_samp_fields = {
  __typename?: 'qx_AudioSource_stddev_samp_fields';
  channels?: number;
  id?: number;
};

/** order by stddev_samp() on columns of table "qx.AudioSource" */
export type qx_AudioSource_stddev_samp_order_by = {
  channels?: order_by;
  id?: order_by;
};

/** Streaming cursor of the table "qx_AudioSource" */
export type qx_AudioSource_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_AudioSource_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_AudioSource_stream_cursor_value_input = {
  channels?: Scalars['smallint']['input'];
  createdAt?: string;
  description?: string;
  deviceID?: string;
  enabled?: boolean;
  id?: string;
  name?: string;
  refID?: string;
  updatedAt?: string;
};

/** aggregate sum on columns */
export type qx_AudioSource_sum_fields = {
  __typename?: 'qx_AudioSource_sum_fields';
  channels?: Scalars['smallint']['output'];
  id?: string;
};

/** order by sum() on columns of table "qx.AudioSource" */
export type qx_AudioSource_sum_order_by = {
  channels?: order_by;
  id?: order_by;
};

/** update columns of table "qx.AudioSource" */
export enum qx_AudioSource_update_column {
  /** column name */
  channels = 'channels',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  description = 'description',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  enabled = 'enabled',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  refID = 'refID',
  /** column name */
  updatedAt = 'updatedAt'
}

export type qx_AudioSource_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_AudioSource_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_AudioSource_set_input;
  /** filter the rows which have to be updated */
  where: qx_AudioSource_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_AudioSource_var_pop_fields = {
  __typename?: 'qx_AudioSource_var_pop_fields';
  channels?: number;
  id?: number;
};

/** order by var_pop() on columns of table "qx.AudioSource" */
export type qx_AudioSource_var_pop_order_by = {
  channels?: order_by;
  id?: order_by;
};

/** aggregate var_samp on columns */
export type qx_AudioSource_var_samp_fields = {
  __typename?: 'qx_AudioSource_var_samp_fields';
  channels?: number;
  id?: number;
};

/** order by var_samp() on columns of table "qx.AudioSource" */
export type qx_AudioSource_var_samp_order_by = {
  channels?: order_by;
  id?: order_by;
};

/** aggregate variance on columns */
export type qx_AudioSource_variance_fields = {
  __typename?: 'qx_AudioSource_variance_fields';
  channels?: number;
  id?: number;
};

/** order by variance() on columns of table "qx.AudioSource" */
export type qx_AudioSource_variance_order_by = {
  channels?: order_by;
  id?: order_by;
};

/** columns and relationships of "qx.AuditLog" */
export type qx_AuditLog = {
  __typename?: 'qx_AuditLog';
  /** An object relationship */
  AuditableAction: qx_AuditableAction;
  /** An object relationship */
  AuditableType: qx_AuditableType;
  action: qx_AuditableAction_enum;
  alternateID?: string;
  auditableID: string;
  auditableType: qx_AuditableType_enum;
  changes?: any;
  createdAt?: string;
  id: string;
  /** An object relationship */
  person?: qx_Person;
  personID?: string;
  /** An object relationship */
  place?: qx_Place;
  placeID: string;
};


/** columns and relationships of "qx.AuditLog" */
export type qx_AuditLogchangesArgs = {
  path?: string;
};

/** aggregated selection of "qx.AuditLog" */
export type qx_AuditLog_aggregate = {
  __typename?: 'qx_AuditLog_aggregate';
  aggregate?: qx_AuditLog_aggregate_fields;
  nodes: Array<qx_AuditLog>;
};

export type qx_AuditLog_aggregate_bool_exp = {
  count?: qx_AuditLog_aggregate_bool_exp_count;
};

export type qx_AuditLog_aggregate_bool_exp_count = {
  arguments?: Array<qx_AuditLog_select_column>;
  distinct?: boolean;
  filter?: qx_AuditLog_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.AuditLog" */
export type qx_AuditLog_aggregate_fields = {
  __typename?: 'qx_AuditLog_aggregate_fields';
  avg?: qx_AuditLog_avg_fields;
  count: number;
  max?: qx_AuditLog_max_fields;
  min?: qx_AuditLog_min_fields;
  stddev?: qx_AuditLog_stddev_fields;
  stddev_pop?: qx_AuditLog_stddev_pop_fields;
  stddev_samp?: qx_AuditLog_stddev_samp_fields;
  sum?: qx_AuditLog_sum_fields;
  var_pop?: qx_AuditLog_var_pop_fields;
  var_samp?: qx_AuditLog_var_samp_fields;
  variance?: qx_AuditLog_variance_fields;
};


/** aggregate fields of "qx.AuditLog" */
export type qx_AuditLog_aggregate_fieldscountArgs = {
  columns?: Array<qx_AuditLog_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.AuditLog" */
export type qx_AuditLog_aggregate_order_by = {
  avg?: qx_AuditLog_avg_order_by;
  count?: order_by;
  max?: qx_AuditLog_max_order_by;
  min?: qx_AuditLog_min_order_by;
  stddev?: qx_AuditLog_stddev_order_by;
  stddev_pop?: qx_AuditLog_stddev_pop_order_by;
  stddev_samp?: qx_AuditLog_stddev_samp_order_by;
  sum?: qx_AuditLog_sum_order_by;
  var_pop?: qx_AuditLog_var_pop_order_by;
  var_samp?: qx_AuditLog_var_samp_order_by;
  variance?: qx_AuditLog_variance_order_by;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type qx_AuditLog_append_input = {
  changes?: any;
};

/** input type for inserting array relation for remote table "qx.AuditLog" */
export type qx_AuditLog_arr_rel_insert_input = {
  data: Array<qx_AuditLog_insert_input>;
  /** upsert condition */
  on_conflict?: qx_AuditLog_on_conflict;
};

/** aggregate avg on columns */
export type qx_AuditLog_avg_fields = {
  __typename?: 'qx_AuditLog_avg_fields';
  auditableID?: number;
};

/** order by avg() on columns of table "qx.AuditLog" */
export type qx_AuditLog_avg_order_by = {
  auditableID?: order_by;
};

/** Boolean expression to filter rows from the table "qx.AuditLog". All fields are combined with a logical 'AND'. */
export type qx_AuditLog_bool_exp = {
  AuditableAction?: qx_AuditableAction_bool_exp;
  AuditableType?: qx_AuditableType_bool_exp;
  _and?: Array<qx_AuditLog_bool_exp>;
  _not?: qx_AuditLog_bool_exp;
  _or?: Array<qx_AuditLog_bool_exp>;
  action?: qx_AuditableAction_enum_comparison_exp;
  alternateID?: String_comparison_exp;
  auditableID?: bigint_comparison_exp;
  auditableType?: qx_AuditableType_enum_comparison_exp;
  changes?: jsonb_comparison_exp;
  createdAt?: timestamptz_comparison_exp;
  id?: String_comparison_exp;
  person?: qx_Person_bool_exp;
  personID?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.AuditLog" */
export enum qx_AuditLog_constraint {
  /** unique or primary key constraint on columns "id" */
  AuditLog_pkey = 'AuditLog_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type qx_AuditLog_delete_at_path_input = {
  changes?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type qx_AuditLog_delete_elem_input = {
  changes?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type qx_AuditLog_delete_key_input = {
  changes?: string;
};

/** input type for incrementing numeric columns in table "qx.AuditLog" */
export type qx_AuditLog_inc_input = {
  auditableID?: string;
};

/** input type for inserting data into table "qx.AuditLog" */
export type qx_AuditLog_insert_input = {
  AuditableAction?: qx_AuditableAction_obj_rel_insert_input;
  AuditableType?: qx_AuditableType_obj_rel_insert_input;
  action?: qx_AuditableAction_enum;
  alternateID?: string;
  auditableID?: string;
  auditableType?: qx_AuditableType_enum;
  changes?: any;
  createdAt?: string;
  id?: string;
  person?: qx_Person_obj_rel_insert_input;
  personID?: string;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
};

/** aggregate max on columns */
export type qx_AuditLog_max_fields = {
  __typename?: 'qx_AuditLog_max_fields';
  alternateID?: string;
  auditableID?: string;
  createdAt?: string;
  id?: string;
  personID?: string;
  placeID?: string;
};

/** order by max() on columns of table "qx.AuditLog" */
export type qx_AuditLog_max_order_by = {
  alternateID?: order_by;
  auditableID?: order_by;
  createdAt?: order_by;
  id?: order_by;
  personID?: order_by;
  placeID?: order_by;
};

/** aggregate min on columns */
export type qx_AuditLog_min_fields = {
  __typename?: 'qx_AuditLog_min_fields';
  alternateID?: string;
  auditableID?: string;
  createdAt?: string;
  id?: string;
  personID?: string;
  placeID?: string;
};

/** order by min() on columns of table "qx.AuditLog" */
export type qx_AuditLog_min_order_by = {
  alternateID?: order_by;
  auditableID?: order_by;
  createdAt?: order_by;
  id?: order_by;
  personID?: order_by;
  placeID?: order_by;
};

/** response of any mutation on the table "qx.AuditLog" */
export type qx_AuditLog_mutation_response = {
  __typename?: 'qx_AuditLog_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_AuditLog>;
};

/** on_conflict condition type for table "qx.AuditLog" */
export type qx_AuditLog_on_conflict = {
  constraint: qx_AuditLog_constraint;
  update_columns?: Array<qx_AuditLog_update_column>;
  where?: qx_AuditLog_bool_exp;
};

/** Ordering options when selecting data from "qx.AuditLog". */
export type qx_AuditLog_order_by = {
  AuditableAction?: qx_AuditableAction_order_by;
  AuditableType?: qx_AuditableType_order_by;
  action?: order_by;
  alternateID?: order_by;
  auditableID?: order_by;
  auditableType?: order_by;
  changes?: order_by;
  createdAt?: order_by;
  id?: order_by;
  person?: qx_Person_order_by;
  personID?: order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
};

/** primary key columns input for table: qx.AuditLog */
export type qx_AuditLog_pk_columns_input = {
  id: string;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type qx_AuditLog_prepend_input = {
  changes?: any;
};

/** select columns of table "qx.AuditLog" */
export enum qx_AuditLog_select_column {
  /** column name */
  action = 'action',
  /** column name */
  alternateID = 'alternateID',
  /** column name */
  auditableID = 'auditableID',
  /** column name */
  auditableType = 'auditableType',
  /** column name */
  changes = 'changes',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  personID = 'personID',
  /** column name */
  placeID = 'placeID'
}

/** input type for updating data in table "qx.AuditLog" */
export type qx_AuditLog_set_input = {
  action?: qx_AuditableAction_enum;
  alternateID?: string;
  auditableID?: string;
  auditableType?: qx_AuditableType_enum;
  changes?: any;
  createdAt?: string;
  id?: string;
  personID?: string;
  placeID?: string;
};

/** aggregate stddev on columns */
export type qx_AuditLog_stddev_fields = {
  __typename?: 'qx_AuditLog_stddev_fields';
  auditableID?: number;
};

/** order by stddev() on columns of table "qx.AuditLog" */
export type qx_AuditLog_stddev_order_by = {
  auditableID?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_AuditLog_stddev_pop_fields = {
  __typename?: 'qx_AuditLog_stddev_pop_fields';
  auditableID?: number;
};

/** order by stddev_pop() on columns of table "qx.AuditLog" */
export type qx_AuditLog_stddev_pop_order_by = {
  auditableID?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_AuditLog_stddev_samp_fields = {
  __typename?: 'qx_AuditLog_stddev_samp_fields';
  auditableID?: number;
};

/** order by stddev_samp() on columns of table "qx.AuditLog" */
export type qx_AuditLog_stddev_samp_order_by = {
  auditableID?: order_by;
};

/** Streaming cursor of the table "qx_AuditLog" */
export type qx_AuditLog_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_AuditLog_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_AuditLog_stream_cursor_value_input = {
  action?: qx_AuditableAction_enum;
  alternateID?: string;
  auditableID?: string;
  auditableType?: qx_AuditableType_enum;
  changes?: any;
  createdAt?: string;
  id?: string;
  personID?: string;
  placeID?: string;
};

/** aggregate sum on columns */
export type qx_AuditLog_sum_fields = {
  __typename?: 'qx_AuditLog_sum_fields';
  auditableID?: string;
};

/** order by sum() on columns of table "qx.AuditLog" */
export type qx_AuditLog_sum_order_by = {
  auditableID?: order_by;
};

/** update columns of table "qx.AuditLog" */
export enum qx_AuditLog_update_column {
  /** column name */
  action = 'action',
  /** column name */
  alternateID = 'alternateID',
  /** column name */
  auditableID = 'auditableID',
  /** column name */
  auditableType = 'auditableType',
  /** column name */
  changes = 'changes',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  personID = 'personID',
  /** column name */
  placeID = 'placeID'
}

export type qx_AuditLog_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: qx_AuditLog_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: qx_AuditLog_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: qx_AuditLog_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: qx_AuditLog_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_AuditLog_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: qx_AuditLog_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_AuditLog_set_input;
  /** filter the rows which have to be updated */
  where: qx_AuditLog_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_AuditLog_var_pop_fields = {
  __typename?: 'qx_AuditLog_var_pop_fields';
  auditableID?: number;
};

/** order by var_pop() on columns of table "qx.AuditLog" */
export type qx_AuditLog_var_pop_order_by = {
  auditableID?: order_by;
};

/** aggregate var_samp on columns */
export type qx_AuditLog_var_samp_fields = {
  __typename?: 'qx_AuditLog_var_samp_fields';
  auditableID?: number;
};

/** order by var_samp() on columns of table "qx.AuditLog" */
export type qx_AuditLog_var_samp_order_by = {
  auditableID?: order_by;
};

/** aggregate variance on columns */
export type qx_AuditLog_variance_fields = {
  __typename?: 'qx_AuditLog_variance_fields';
  auditableID?: number;
};

/** order by variance() on columns of table "qx.AuditLog" */
export type qx_AuditLog_variance_order_by = {
  auditableID?: order_by;
};

/** columns and relationships of "qx.AuditableAction" */
export type qx_AuditableAction = {
  __typename?: 'qx_AuditableAction';
  /** An array relationship */
  AuditLogs: Array<qx_AuditLog>;
  /** An aggregate relationship */
  AuditLogs_aggregate: qx_AuditLog_aggregate;
  comment?: string;
  value: string;
};


/** columns and relationships of "qx.AuditableAction" */
export type qx_AuditableActionAuditLogsArgs = {
  distinct_on?: Array<qx_AuditLog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AuditLog_order_by>;
  where?: qx_AuditLog_bool_exp;
};


/** columns and relationships of "qx.AuditableAction" */
export type qx_AuditableActionAuditLogs_aggregateArgs = {
  distinct_on?: Array<qx_AuditLog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AuditLog_order_by>;
  where?: qx_AuditLog_bool_exp;
};

/** aggregated selection of "qx.AuditableAction" */
export type qx_AuditableAction_aggregate = {
  __typename?: 'qx_AuditableAction_aggregate';
  aggregate?: qx_AuditableAction_aggregate_fields;
  nodes: Array<qx_AuditableAction>;
};

/** aggregate fields of "qx.AuditableAction" */
export type qx_AuditableAction_aggregate_fields = {
  __typename?: 'qx_AuditableAction_aggregate_fields';
  count: number;
  max?: qx_AuditableAction_max_fields;
  min?: qx_AuditableAction_min_fields;
};


/** aggregate fields of "qx.AuditableAction" */
export type qx_AuditableAction_aggregate_fieldscountArgs = {
  columns?: Array<qx_AuditableAction_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.AuditableAction". All fields are combined with a logical 'AND'. */
export type qx_AuditableAction_bool_exp = {
  AuditLogs?: qx_AuditLog_bool_exp;
  AuditLogs_aggregate?: qx_AuditLog_aggregate_bool_exp;
  _and?: Array<qx_AuditableAction_bool_exp>;
  _not?: qx_AuditableAction_bool_exp;
  _or?: Array<qx_AuditableAction_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.AuditableAction" */
export enum qx_AuditableAction_constraint {
  /** unique or primary key constraint on columns "value" */
  AuditableAction_pkey = 'AuditableAction_pkey'
}

export enum qx_AuditableAction_enum {
  /** Accessed Shared Link */
  AccessSharedLink = 'AccessSharedLink',
  /** Created Shared Link */
  CreateSharedLink = 'CreateSharedLink',
  /** Deleted Clip */
  DeleteClip = 'DeleteClip',
  /** Deleted Shared Link */
  DeleteSharedLink = 'DeleteSharedLink',
  /** Clip Download */
  DownloadClip = 'DownloadClip',
  /** Clip Updated */
  UpdateClip = 'UpdateClip',
  /** Updated Shared Link */
  UpdatedSharedLink = 'UpdatedSharedLink',
  /** Viewed Clip */
  ViewClip = 'ViewClip'
}

/** Boolean expression to compare columns of type "qx_AuditableAction_enum". All fields are combined with logical 'AND'. */
export type qx_AuditableAction_enum_comparison_exp = {
  _eq?: qx_AuditableAction_enum;
  _in?: Array<qx_AuditableAction_enum>;
  _is_null?: boolean;
  _neq?: qx_AuditableAction_enum;
  _nin?: Array<qx_AuditableAction_enum>;
};

/** input type for inserting data into table "qx.AuditableAction" */
export type qx_AuditableAction_insert_input = {
  AuditLogs?: qx_AuditLog_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_AuditableAction_max_fields = {
  __typename?: 'qx_AuditableAction_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_AuditableAction_min_fields = {
  __typename?: 'qx_AuditableAction_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.AuditableAction" */
export type qx_AuditableAction_mutation_response = {
  __typename?: 'qx_AuditableAction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_AuditableAction>;
};

/** input type for inserting object relation for remote table "qx.AuditableAction" */
export type qx_AuditableAction_obj_rel_insert_input = {
  data: qx_AuditableAction_insert_input;
  /** upsert condition */
  on_conflict?: qx_AuditableAction_on_conflict;
};

/** on_conflict condition type for table "qx.AuditableAction" */
export type qx_AuditableAction_on_conflict = {
  constraint: qx_AuditableAction_constraint;
  update_columns?: Array<qx_AuditableAction_update_column>;
  where?: qx_AuditableAction_bool_exp;
};

/** Ordering options when selecting data from "qx.AuditableAction". */
export type qx_AuditableAction_order_by = {
  AuditLogs_aggregate?: qx_AuditLog_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.AuditableAction */
export type qx_AuditableAction_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.AuditableAction" */
export enum qx_AuditableAction_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.AuditableAction" */
export type qx_AuditableAction_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_AuditableAction" */
export type qx_AuditableAction_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_AuditableAction_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_AuditableAction_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.AuditableAction" */
export enum qx_AuditableAction_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_AuditableAction_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_AuditableAction_set_input;
  /** filter the rows which have to be updated */
  where: qx_AuditableAction_bool_exp;
};

/** columns and relationships of "qx.AuditableType" */
export type qx_AuditableType = {
  __typename?: 'qx_AuditableType';
  /** An array relationship */
  AuditLogs: Array<qx_AuditLog>;
  /** An aggregate relationship */
  AuditLogs_aggregate: qx_AuditLog_aggregate;
  comment?: string;
  value: string;
};


/** columns and relationships of "qx.AuditableType" */
export type qx_AuditableTypeAuditLogsArgs = {
  distinct_on?: Array<qx_AuditLog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AuditLog_order_by>;
  where?: qx_AuditLog_bool_exp;
};


/** columns and relationships of "qx.AuditableType" */
export type qx_AuditableTypeAuditLogs_aggregateArgs = {
  distinct_on?: Array<qx_AuditLog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AuditLog_order_by>;
  where?: qx_AuditLog_bool_exp;
};

/** aggregated selection of "qx.AuditableType" */
export type qx_AuditableType_aggregate = {
  __typename?: 'qx_AuditableType_aggregate';
  aggregate?: qx_AuditableType_aggregate_fields;
  nodes: Array<qx_AuditableType>;
};

/** aggregate fields of "qx.AuditableType" */
export type qx_AuditableType_aggregate_fields = {
  __typename?: 'qx_AuditableType_aggregate_fields';
  count: number;
  max?: qx_AuditableType_max_fields;
  min?: qx_AuditableType_min_fields;
};


/** aggregate fields of "qx.AuditableType" */
export type qx_AuditableType_aggregate_fieldscountArgs = {
  columns?: Array<qx_AuditableType_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.AuditableType". All fields are combined with a logical 'AND'. */
export type qx_AuditableType_bool_exp = {
  AuditLogs?: qx_AuditLog_bool_exp;
  AuditLogs_aggregate?: qx_AuditLog_aggregate_bool_exp;
  _and?: Array<qx_AuditableType_bool_exp>;
  _not?: qx_AuditableType_bool_exp;
  _or?: Array<qx_AuditableType_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.AuditableType" */
export enum qx_AuditableType_constraint {
  /** unique or primary key constraint on columns "value" */
  AuditableType_pkey = 'AuditableType_pkey'
}

export enum qx_AuditableType_enum {
  /** Clips */
  Clip = 'Clip',
  /** Shared Links */
  SharedLink = 'SharedLink'
}

/** Boolean expression to compare columns of type "qx_AuditableType_enum". All fields are combined with logical 'AND'. */
export type qx_AuditableType_enum_comparison_exp = {
  _eq?: qx_AuditableType_enum;
  _in?: Array<qx_AuditableType_enum>;
  _is_null?: boolean;
  _neq?: qx_AuditableType_enum;
  _nin?: Array<qx_AuditableType_enum>;
};

/** input type for inserting data into table "qx.AuditableType" */
export type qx_AuditableType_insert_input = {
  AuditLogs?: qx_AuditLog_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_AuditableType_max_fields = {
  __typename?: 'qx_AuditableType_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_AuditableType_min_fields = {
  __typename?: 'qx_AuditableType_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.AuditableType" */
export type qx_AuditableType_mutation_response = {
  __typename?: 'qx_AuditableType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_AuditableType>;
};

/** input type for inserting object relation for remote table "qx.AuditableType" */
export type qx_AuditableType_obj_rel_insert_input = {
  data: qx_AuditableType_insert_input;
  /** upsert condition */
  on_conflict?: qx_AuditableType_on_conflict;
};

/** on_conflict condition type for table "qx.AuditableType" */
export type qx_AuditableType_on_conflict = {
  constraint: qx_AuditableType_constraint;
  update_columns?: Array<qx_AuditableType_update_column>;
  where?: qx_AuditableType_bool_exp;
};

/** Ordering options when selecting data from "qx.AuditableType". */
export type qx_AuditableType_order_by = {
  AuditLogs_aggregate?: qx_AuditLog_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.AuditableType */
export type qx_AuditableType_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.AuditableType" */
export enum qx_AuditableType_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.AuditableType" */
export type qx_AuditableType_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_AuditableType" */
export type qx_AuditableType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_AuditableType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_AuditableType_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.AuditableType" */
export enum qx_AuditableType_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_AuditableType_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_AuditableType_set_input;
  /** filter the rows which have to be updated */
  where: qx_AuditableType_bool_exp;
};

/** columns and relationships of "qx.BillingPeriod" */
export type qx_BillingPeriod = {
  __typename?: 'qx_BillingPeriod';
  billingPeriodMonths: number;
  name: string;
  /** An array relationship */
  places: Array<qx_Place>;
  /** An aggregate relationship */
  places_aggregate: qx_Place_aggregate;
};


/** columns and relationships of "qx.BillingPeriod" */
export type qx_BillingPeriodplacesArgs = {
  distinct_on?: Array<qx_Place_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Place_order_by>;
  where?: qx_Place_bool_exp;
};


/** columns and relationships of "qx.BillingPeriod" */
export type qx_BillingPeriodplaces_aggregateArgs = {
  distinct_on?: Array<qx_Place_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Place_order_by>;
  where?: qx_Place_bool_exp;
};

/** aggregated selection of "qx.BillingPeriod" */
export type qx_BillingPeriod_aggregate = {
  __typename?: 'qx_BillingPeriod_aggregate';
  aggregate?: qx_BillingPeriod_aggregate_fields;
  nodes: Array<qx_BillingPeriod>;
};

/** aggregate fields of "qx.BillingPeriod" */
export type qx_BillingPeriod_aggregate_fields = {
  __typename?: 'qx_BillingPeriod_aggregate_fields';
  avg?: qx_BillingPeriod_avg_fields;
  count: number;
  max?: qx_BillingPeriod_max_fields;
  min?: qx_BillingPeriod_min_fields;
  stddev?: qx_BillingPeriod_stddev_fields;
  stddev_pop?: qx_BillingPeriod_stddev_pop_fields;
  stddev_samp?: qx_BillingPeriod_stddev_samp_fields;
  sum?: qx_BillingPeriod_sum_fields;
  var_pop?: qx_BillingPeriod_var_pop_fields;
  var_samp?: qx_BillingPeriod_var_samp_fields;
  variance?: qx_BillingPeriod_variance_fields;
};


/** aggregate fields of "qx.BillingPeriod" */
export type qx_BillingPeriod_aggregate_fieldscountArgs = {
  columns?: Array<qx_BillingPeriod_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type qx_BillingPeriod_avg_fields = {
  __typename?: 'qx_BillingPeriod_avg_fields';
  billingPeriodMonths?: number;
};

/** Boolean expression to filter rows from the table "qx.BillingPeriod". All fields are combined with a logical 'AND'. */
export type qx_BillingPeriod_bool_exp = {
  _and?: Array<qx_BillingPeriod_bool_exp>;
  _not?: qx_BillingPeriod_bool_exp;
  _or?: Array<qx_BillingPeriod_bool_exp>;
  billingPeriodMonths?: Int_comparison_exp;
  name?: String_comparison_exp;
  places?: qx_Place_bool_exp;
  places_aggregate?: qx_Place_aggregate_bool_exp;
};

/** unique or primary key constraints on table "qx.BillingPeriod" */
export enum qx_BillingPeriod_constraint {
  /** unique or primary key constraint on columns "billingPeriodMonths" */
  BillingPeriod_pkey = 'BillingPeriod_pkey'
}

/** input type for incrementing numeric columns in table "qx.BillingPeriod" */
export type qx_BillingPeriod_inc_input = {
  billingPeriodMonths?: number;
};

/** input type for inserting data into table "qx.BillingPeriod" */
export type qx_BillingPeriod_insert_input = {
  billingPeriodMonths?: number;
  name?: string;
  places?: qx_Place_arr_rel_insert_input;
};

/** aggregate max on columns */
export type qx_BillingPeriod_max_fields = {
  __typename?: 'qx_BillingPeriod_max_fields';
  billingPeriodMonths?: number;
  name?: string;
};

/** aggregate min on columns */
export type qx_BillingPeriod_min_fields = {
  __typename?: 'qx_BillingPeriod_min_fields';
  billingPeriodMonths?: number;
  name?: string;
};

/** response of any mutation on the table "qx.BillingPeriod" */
export type qx_BillingPeriod_mutation_response = {
  __typename?: 'qx_BillingPeriod_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_BillingPeriod>;
};

/** input type for inserting object relation for remote table "qx.BillingPeriod" */
export type qx_BillingPeriod_obj_rel_insert_input = {
  data: qx_BillingPeriod_insert_input;
  /** upsert condition */
  on_conflict?: qx_BillingPeriod_on_conflict;
};

/** on_conflict condition type for table "qx.BillingPeriod" */
export type qx_BillingPeriod_on_conflict = {
  constraint: qx_BillingPeriod_constraint;
  update_columns?: Array<qx_BillingPeriod_update_column>;
  where?: qx_BillingPeriod_bool_exp;
};

/** Ordering options when selecting data from "qx.BillingPeriod". */
export type qx_BillingPeriod_order_by = {
  billingPeriodMonths?: order_by;
  name?: order_by;
  places_aggregate?: qx_Place_aggregate_order_by;
};

/** primary key columns input for table: qx.BillingPeriod */
export type qx_BillingPeriod_pk_columns_input = {
  billingPeriodMonths: number;
};

/** select columns of table "qx.BillingPeriod" */
export enum qx_BillingPeriod_select_column {
  /** column name */
  billingPeriodMonths = 'billingPeriodMonths',
  /** column name */
  name = 'name'
}

/** input type for updating data in table "qx.BillingPeriod" */
export type qx_BillingPeriod_set_input = {
  billingPeriodMonths?: number;
  name?: string;
};

/** aggregate stddev on columns */
export type qx_BillingPeriod_stddev_fields = {
  __typename?: 'qx_BillingPeriod_stddev_fields';
  billingPeriodMonths?: number;
};

/** aggregate stddev_pop on columns */
export type qx_BillingPeriod_stddev_pop_fields = {
  __typename?: 'qx_BillingPeriod_stddev_pop_fields';
  billingPeriodMonths?: number;
};

/** aggregate stddev_samp on columns */
export type qx_BillingPeriod_stddev_samp_fields = {
  __typename?: 'qx_BillingPeriod_stddev_samp_fields';
  billingPeriodMonths?: number;
};

/** Streaming cursor of the table "qx_BillingPeriod" */
export type qx_BillingPeriod_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_BillingPeriod_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_BillingPeriod_stream_cursor_value_input = {
  billingPeriodMonths?: number;
  name?: string;
};

/** aggregate sum on columns */
export type qx_BillingPeriod_sum_fields = {
  __typename?: 'qx_BillingPeriod_sum_fields';
  billingPeriodMonths?: number;
};

/** update columns of table "qx.BillingPeriod" */
export enum qx_BillingPeriod_update_column {
  /** column name */
  billingPeriodMonths = 'billingPeriodMonths',
  /** column name */
  name = 'name'
}

export type qx_BillingPeriod_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_BillingPeriod_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_BillingPeriod_set_input;
  /** filter the rows which have to be updated */
  where: qx_BillingPeriod_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_BillingPeriod_var_pop_fields = {
  __typename?: 'qx_BillingPeriod_var_pop_fields';
  billingPeriodMonths?: number;
};

/** aggregate var_samp on columns */
export type qx_BillingPeriod_var_samp_fields = {
  __typename?: 'qx_BillingPeriod_var_samp_fields';
  billingPeriodMonths?: number;
};

/** aggregate variance on columns */
export type qx_BillingPeriod_variance_fields = {
  __typename?: 'qx_BillingPeriod_variance_fields';
  billingPeriodMonths?: number;
};

/** columns and relationships of "qx.CatalogProtocolOverride" */
export type qx_CatalogProtocolOverride = {
  __typename?: 'qx_CatalogProtocolOverride';
  /** An object relationship */
  AccessCatalog: qx_AccessCatalog;
  catalogID: string;
  /** An object relationship */
  eReaderProtocol: qx_eReaderProtocol;
  enabled: boolean;
  id: number;
  protocol: qx_eReaderProtocol_enum;
};

/** aggregated selection of "qx.CatalogProtocolOverride" */
export type qx_CatalogProtocolOverride_aggregate = {
  __typename?: 'qx_CatalogProtocolOverride_aggregate';
  aggregate?: qx_CatalogProtocolOverride_aggregate_fields;
  nodes: Array<qx_CatalogProtocolOverride>;
};

export type qx_CatalogProtocolOverride_aggregate_bool_exp = {
  bool_and?: qx_CatalogProtocolOverride_aggregate_bool_exp_bool_and;
  bool_or?: qx_CatalogProtocolOverride_aggregate_bool_exp_bool_or;
  count?: qx_CatalogProtocolOverride_aggregate_bool_exp_count;
};

export type qx_CatalogProtocolOverride_aggregate_bool_exp_bool_and = {
  arguments: qx_CatalogProtocolOverride_select_column_qx_CatalogProtocolOverride_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: qx_CatalogProtocolOverride_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_CatalogProtocolOverride_aggregate_bool_exp_bool_or = {
  arguments: qx_CatalogProtocolOverride_select_column_qx_CatalogProtocolOverride_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: qx_CatalogProtocolOverride_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_CatalogProtocolOverride_aggregate_bool_exp_count = {
  arguments?: Array<qx_CatalogProtocolOverride_select_column>;
  distinct?: boolean;
  filter?: qx_CatalogProtocolOverride_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.CatalogProtocolOverride" */
export type qx_CatalogProtocolOverride_aggregate_fields = {
  __typename?: 'qx_CatalogProtocolOverride_aggregate_fields';
  avg?: qx_CatalogProtocolOverride_avg_fields;
  count: number;
  max?: qx_CatalogProtocolOverride_max_fields;
  min?: qx_CatalogProtocolOverride_min_fields;
  stddev?: qx_CatalogProtocolOverride_stddev_fields;
  stddev_pop?: qx_CatalogProtocolOverride_stddev_pop_fields;
  stddev_samp?: qx_CatalogProtocolOverride_stddev_samp_fields;
  sum?: qx_CatalogProtocolOverride_sum_fields;
  var_pop?: qx_CatalogProtocolOverride_var_pop_fields;
  var_samp?: qx_CatalogProtocolOverride_var_samp_fields;
  variance?: qx_CatalogProtocolOverride_variance_fields;
};


/** aggregate fields of "qx.CatalogProtocolOverride" */
export type qx_CatalogProtocolOverride_aggregate_fieldscountArgs = {
  columns?: Array<qx_CatalogProtocolOverride_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.CatalogProtocolOverride" */
export type qx_CatalogProtocolOverride_aggregate_order_by = {
  avg?: qx_CatalogProtocolOverride_avg_order_by;
  count?: order_by;
  max?: qx_CatalogProtocolOverride_max_order_by;
  min?: qx_CatalogProtocolOverride_min_order_by;
  stddev?: qx_CatalogProtocolOverride_stddev_order_by;
  stddev_pop?: qx_CatalogProtocolOverride_stddev_pop_order_by;
  stddev_samp?: qx_CatalogProtocolOverride_stddev_samp_order_by;
  sum?: qx_CatalogProtocolOverride_sum_order_by;
  var_pop?: qx_CatalogProtocolOverride_var_pop_order_by;
  var_samp?: qx_CatalogProtocolOverride_var_samp_order_by;
  variance?: qx_CatalogProtocolOverride_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.CatalogProtocolOverride" */
export type qx_CatalogProtocolOverride_arr_rel_insert_input = {
  data: Array<qx_CatalogProtocolOverride_insert_input>;
  /** upsert condition */
  on_conflict?: qx_CatalogProtocolOverride_on_conflict;
};

/** aggregate avg on columns */
export type qx_CatalogProtocolOverride_avg_fields = {
  __typename?: 'qx_CatalogProtocolOverride_avg_fields';
  id?: number;
};

/** order by avg() on columns of table "qx.CatalogProtocolOverride" */
export type qx_CatalogProtocolOverride_avg_order_by = {
  id?: order_by;
};

/** Boolean expression to filter rows from the table "qx.CatalogProtocolOverride". All fields are combined with a logical 'AND'. */
export type qx_CatalogProtocolOverride_bool_exp = {
  AccessCatalog?: qx_AccessCatalog_bool_exp;
  _and?: Array<qx_CatalogProtocolOverride_bool_exp>;
  _not?: qx_CatalogProtocolOverride_bool_exp;
  _or?: Array<qx_CatalogProtocolOverride_bool_exp>;
  catalogID?: String_comparison_exp;
  eReaderProtocol?: qx_eReaderProtocol_bool_exp;
  enabled?: Boolean_comparison_exp;
  id?: Int_comparison_exp;
  protocol?: qx_eReaderProtocol_enum_comparison_exp;
};

/** unique or primary key constraints on table "qx.CatalogProtocolOverride" */
export enum qx_CatalogProtocolOverride_constraint {
  /** unique or primary key constraint on columns "protocol", "catalogID" */
  CatalogProtocolOverride_catalogID_protocol_key = 'CatalogProtocolOverride_catalogID_protocol_key',
  /** unique or primary key constraint on columns "id" */
  CatalogProtocolOverride_pkey = 'CatalogProtocolOverride_pkey'
}

/** input type for incrementing numeric columns in table "qx.CatalogProtocolOverride" */
export type qx_CatalogProtocolOverride_inc_input = {
  id?: number;
};

/** input type for inserting data into table "qx.CatalogProtocolOverride" */
export type qx_CatalogProtocolOverride_insert_input = {
  AccessCatalog?: qx_AccessCatalog_obj_rel_insert_input;
  catalogID?: string;
  eReaderProtocol?: qx_eReaderProtocol_obj_rel_insert_input;
  enabled?: boolean;
  id?: number;
  protocol?: qx_eReaderProtocol_enum;
};

/** aggregate max on columns */
export type qx_CatalogProtocolOverride_max_fields = {
  __typename?: 'qx_CatalogProtocolOverride_max_fields';
  catalogID?: string;
  id?: number;
};

/** order by max() on columns of table "qx.CatalogProtocolOverride" */
export type qx_CatalogProtocolOverride_max_order_by = {
  catalogID?: order_by;
  id?: order_by;
};

/** aggregate min on columns */
export type qx_CatalogProtocolOverride_min_fields = {
  __typename?: 'qx_CatalogProtocolOverride_min_fields';
  catalogID?: string;
  id?: number;
};

/** order by min() on columns of table "qx.CatalogProtocolOverride" */
export type qx_CatalogProtocolOverride_min_order_by = {
  catalogID?: order_by;
  id?: order_by;
};

/** response of any mutation on the table "qx.CatalogProtocolOverride" */
export type qx_CatalogProtocolOverride_mutation_response = {
  __typename?: 'qx_CatalogProtocolOverride_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_CatalogProtocolOverride>;
};

/** on_conflict condition type for table "qx.CatalogProtocolOverride" */
export type qx_CatalogProtocolOverride_on_conflict = {
  constraint: qx_CatalogProtocolOverride_constraint;
  update_columns?: Array<qx_CatalogProtocolOverride_update_column>;
  where?: qx_CatalogProtocolOverride_bool_exp;
};

/** Ordering options when selecting data from "qx.CatalogProtocolOverride". */
export type qx_CatalogProtocolOverride_order_by = {
  AccessCatalog?: qx_AccessCatalog_order_by;
  catalogID?: order_by;
  eReaderProtocol?: qx_eReaderProtocol_order_by;
  enabled?: order_by;
  id?: order_by;
  protocol?: order_by;
};

/** primary key columns input for table: qx.CatalogProtocolOverride */
export type qx_CatalogProtocolOverride_pk_columns_input = {
  id: number;
};

/** select columns of table "qx.CatalogProtocolOverride" */
export enum qx_CatalogProtocolOverride_select_column {
  /** column name */
  catalogID = 'catalogID',
  /** column name */
  enabled = 'enabled',
  /** column name */
  id = 'id',
  /** column name */
  protocol = 'protocol'
}

/** select "qx_CatalogProtocolOverride_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.CatalogProtocolOverride" */
export enum qx_CatalogProtocolOverride_select_column_qx_CatalogProtocolOverride_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  enabled = 'enabled'
}

/** select "qx_CatalogProtocolOverride_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.CatalogProtocolOverride" */
export enum qx_CatalogProtocolOverride_select_column_qx_CatalogProtocolOverride_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  enabled = 'enabled'
}

/** input type for updating data in table "qx.CatalogProtocolOverride" */
export type qx_CatalogProtocolOverride_set_input = {
  catalogID?: string;
  enabled?: boolean;
  id?: number;
  protocol?: qx_eReaderProtocol_enum;
};

/** aggregate stddev on columns */
export type qx_CatalogProtocolOverride_stddev_fields = {
  __typename?: 'qx_CatalogProtocolOverride_stddev_fields';
  id?: number;
};

/** order by stddev() on columns of table "qx.CatalogProtocolOverride" */
export type qx_CatalogProtocolOverride_stddev_order_by = {
  id?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_CatalogProtocolOverride_stddev_pop_fields = {
  __typename?: 'qx_CatalogProtocolOverride_stddev_pop_fields';
  id?: number;
};

/** order by stddev_pop() on columns of table "qx.CatalogProtocolOverride" */
export type qx_CatalogProtocolOverride_stddev_pop_order_by = {
  id?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_CatalogProtocolOverride_stddev_samp_fields = {
  __typename?: 'qx_CatalogProtocolOverride_stddev_samp_fields';
  id?: number;
};

/** order by stddev_samp() on columns of table "qx.CatalogProtocolOverride" */
export type qx_CatalogProtocolOverride_stddev_samp_order_by = {
  id?: order_by;
};

/** Streaming cursor of the table "qx_CatalogProtocolOverride" */
export type qx_CatalogProtocolOverride_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_CatalogProtocolOverride_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_CatalogProtocolOverride_stream_cursor_value_input = {
  catalogID?: string;
  enabled?: boolean;
  id?: number;
  protocol?: qx_eReaderProtocol_enum;
};

/** aggregate sum on columns */
export type qx_CatalogProtocolOverride_sum_fields = {
  __typename?: 'qx_CatalogProtocolOverride_sum_fields';
  id?: number;
};

/** order by sum() on columns of table "qx.CatalogProtocolOverride" */
export type qx_CatalogProtocolOverride_sum_order_by = {
  id?: order_by;
};

/** update columns of table "qx.CatalogProtocolOverride" */
export enum qx_CatalogProtocolOverride_update_column {
  /** column name */
  catalogID = 'catalogID',
  /** column name */
  enabled = 'enabled',
  /** column name */
  id = 'id',
  /** column name */
  protocol = 'protocol'
}

export type qx_CatalogProtocolOverride_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_CatalogProtocolOverride_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_CatalogProtocolOverride_set_input;
  /** filter the rows which have to be updated */
  where: qx_CatalogProtocolOverride_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_CatalogProtocolOverride_var_pop_fields = {
  __typename?: 'qx_CatalogProtocolOverride_var_pop_fields';
  id?: number;
};

/** order by var_pop() on columns of table "qx.CatalogProtocolOverride" */
export type qx_CatalogProtocolOverride_var_pop_order_by = {
  id?: order_by;
};

/** aggregate var_samp on columns */
export type qx_CatalogProtocolOverride_var_samp_fields = {
  __typename?: 'qx_CatalogProtocolOverride_var_samp_fields';
  id?: number;
};

/** order by var_samp() on columns of table "qx.CatalogProtocolOverride" */
export type qx_CatalogProtocolOverride_var_samp_order_by = {
  id?: order_by;
};

/** aggregate variance on columns */
export type qx_CatalogProtocolOverride_variance_fields = {
  __typename?: 'qx_CatalogProtocolOverride_variance_fields';
  id?: number;
};

/** order by variance() on columns of table "qx.CatalogProtocolOverride" */
export type qx_CatalogProtocolOverride_variance_order_by = {
  id?: order_by;
};

/** columns and relationships of "qx.ChatUsageHistory" */
export type qx_ChatUsageHistory = {
  __typename?: 'qx_ChatUsageHistory';
  actualCostCents: number;
  billableTokens: number;
  billingPeriodStart: string;
  billingTier: string;
  cachedInputTokens: number;
  costCents?: number;
  createdAt: string;
  id: any;
  inputTokens: number;
  model?: string;
  outputTokens: number;
  overageTokens: number;
  /** An object relationship */
  person?: qx_Person;
  personId?: string;
  /** An object relationship */
  place?: qx_Place;
  placeId?: string;
  runId: string;
  threadId: string;
  /** An object relationship */
  tier: qx_eBillingTier;
  totalTokens: number;
};

/** aggregated selection of "qx.ChatUsageHistory" */
export type qx_ChatUsageHistory_aggregate = {
  __typename?: 'qx_ChatUsageHistory_aggregate';
  aggregate?: qx_ChatUsageHistory_aggregate_fields;
  nodes: Array<qx_ChatUsageHistory>;
};

/** aggregate fields of "qx.ChatUsageHistory" */
export type qx_ChatUsageHistory_aggregate_fields = {
  __typename?: 'qx_ChatUsageHistory_aggregate_fields';
  avg?: qx_ChatUsageHistory_avg_fields;
  count: number;
  max?: qx_ChatUsageHistory_max_fields;
  min?: qx_ChatUsageHistory_min_fields;
  stddev?: qx_ChatUsageHistory_stddev_fields;
  stddev_pop?: qx_ChatUsageHistory_stddev_pop_fields;
  stddev_samp?: qx_ChatUsageHistory_stddev_samp_fields;
  sum?: qx_ChatUsageHistory_sum_fields;
  var_pop?: qx_ChatUsageHistory_var_pop_fields;
  var_samp?: qx_ChatUsageHistory_var_samp_fields;
  variance?: qx_ChatUsageHistory_variance_fields;
};


/** aggregate fields of "qx.ChatUsageHistory" */
export type qx_ChatUsageHistory_aggregate_fieldscountArgs = {
  columns?: Array<qx_ChatUsageHistory_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type qx_ChatUsageHistory_avg_fields = {
  __typename?: 'qx_ChatUsageHistory_avg_fields';
  actualCostCents?: number;
  billableTokens?: number;
  cachedInputTokens?: number;
  costCents?: number;
  inputTokens?: number;
  outputTokens?: number;
  overageTokens?: number;
  totalTokens?: number;
};

/** Boolean expression to filter rows from the table "qx.ChatUsageHistory". All fields are combined with a logical 'AND'. */
export type qx_ChatUsageHistory_bool_exp = {
  _and?: Array<qx_ChatUsageHistory_bool_exp>;
  _not?: qx_ChatUsageHistory_bool_exp;
  _or?: Array<qx_ChatUsageHistory_bool_exp>;
  actualCostCents?: Int_comparison_exp;
  billableTokens?: Int_comparison_exp;
  billingPeriodStart?: date_comparison_exp;
  billingTier?: String_comparison_exp;
  cachedInputTokens?: Int_comparison_exp;
  costCents?: Int_comparison_exp;
  createdAt?: timestamptz_comparison_exp;
  id?: uuid_comparison_exp;
  inputTokens?: Int_comparison_exp;
  model?: String_comparison_exp;
  outputTokens?: Int_comparison_exp;
  overageTokens?: Int_comparison_exp;
  person?: qx_Person_bool_exp;
  personId?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  placeId?: String_comparison_exp;
  runId?: String_comparison_exp;
  threadId?: String_comparison_exp;
  tier?: qx_eBillingTier_bool_exp;
  totalTokens?: Int_comparison_exp;
};

/** unique or primary key constraints on table "qx.ChatUsageHistory" */
export enum qx_ChatUsageHistory_constraint {
  /** unique or primary key constraint on columns "id" */
  ChatUsageHistory_pkey = 'ChatUsageHistory_pkey',
  /** unique or primary key constraint on columns "runId" */
  ChatUsageHistory_runId_key = 'ChatUsageHistory_runId_key'
}

/** input type for incrementing numeric columns in table "qx.ChatUsageHistory" */
export type qx_ChatUsageHistory_inc_input = {
  actualCostCents?: number;
  billableTokens?: number;
  cachedInputTokens?: number;
  costCents?: number;
  inputTokens?: number;
  outputTokens?: number;
  overageTokens?: number;
  totalTokens?: number;
};

/** input type for inserting data into table "qx.ChatUsageHistory" */
export type qx_ChatUsageHistory_insert_input = {
  actualCostCents?: number;
  billableTokens?: number;
  billingPeriodStart?: string;
  billingTier?: string;
  cachedInputTokens?: number;
  costCents?: number;
  createdAt?: string;
  id?: any;
  inputTokens?: number;
  model?: string;
  outputTokens?: number;
  overageTokens?: number;
  person?: qx_Person_obj_rel_insert_input;
  personId?: string;
  place?: qx_Place_obj_rel_insert_input;
  placeId?: string;
  runId?: string;
  threadId?: string;
  tier?: qx_eBillingTier_obj_rel_insert_input;
  totalTokens?: number;
};

/** aggregate max on columns */
export type qx_ChatUsageHistory_max_fields = {
  __typename?: 'qx_ChatUsageHistory_max_fields';
  actualCostCents?: number;
  billableTokens?: number;
  billingPeriodStart?: string;
  billingTier?: string;
  cachedInputTokens?: number;
  costCents?: number;
  createdAt?: string;
  id?: any;
  inputTokens?: number;
  model?: string;
  outputTokens?: number;
  overageTokens?: number;
  personId?: string;
  placeId?: string;
  runId?: string;
  threadId?: string;
  totalTokens?: number;
};

/** aggregate min on columns */
export type qx_ChatUsageHistory_min_fields = {
  __typename?: 'qx_ChatUsageHistory_min_fields';
  actualCostCents?: number;
  billableTokens?: number;
  billingPeriodStart?: string;
  billingTier?: string;
  cachedInputTokens?: number;
  costCents?: number;
  createdAt?: string;
  id?: any;
  inputTokens?: number;
  model?: string;
  outputTokens?: number;
  overageTokens?: number;
  personId?: string;
  placeId?: string;
  runId?: string;
  threadId?: string;
  totalTokens?: number;
};

/** response of any mutation on the table "qx.ChatUsageHistory" */
export type qx_ChatUsageHistory_mutation_response = {
  __typename?: 'qx_ChatUsageHistory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_ChatUsageHistory>;
};

/** on_conflict condition type for table "qx.ChatUsageHistory" */
export type qx_ChatUsageHistory_on_conflict = {
  constraint: qx_ChatUsageHistory_constraint;
  update_columns?: Array<qx_ChatUsageHistory_update_column>;
  where?: qx_ChatUsageHistory_bool_exp;
};

/** Ordering options when selecting data from "qx.ChatUsageHistory". */
export type qx_ChatUsageHistory_order_by = {
  actualCostCents?: order_by;
  billableTokens?: order_by;
  billingPeriodStart?: order_by;
  billingTier?: order_by;
  cachedInputTokens?: order_by;
  costCents?: order_by;
  createdAt?: order_by;
  id?: order_by;
  inputTokens?: order_by;
  model?: order_by;
  outputTokens?: order_by;
  overageTokens?: order_by;
  person?: qx_Person_order_by;
  personId?: order_by;
  place?: qx_Place_order_by;
  placeId?: order_by;
  runId?: order_by;
  threadId?: order_by;
  tier?: qx_eBillingTier_order_by;
  totalTokens?: order_by;
};

/** primary key columns input for table: qx.ChatUsageHistory */
export type qx_ChatUsageHistory_pk_columns_input = {
  id: any;
};

/** select columns of table "qx.ChatUsageHistory" */
export enum qx_ChatUsageHistory_select_column {
  /** column name */
  actualCostCents = 'actualCostCents',
  /** column name */
  billableTokens = 'billableTokens',
  /** column name */
  billingPeriodStart = 'billingPeriodStart',
  /** column name */
  billingTier = 'billingTier',
  /** column name */
  cachedInputTokens = 'cachedInputTokens',
  /** column name */
  costCents = 'costCents',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  inputTokens = 'inputTokens',
  /** column name */
  model = 'model',
  /** column name */
  outputTokens = 'outputTokens',
  /** column name */
  overageTokens = 'overageTokens',
  /** column name */
  personId = 'personId',
  /** column name */
  placeId = 'placeId',
  /** column name */
  runId = 'runId',
  /** column name */
  threadId = 'threadId',
  /** column name */
  totalTokens = 'totalTokens'
}

/** input type for updating data in table "qx.ChatUsageHistory" */
export type qx_ChatUsageHistory_set_input = {
  actualCostCents?: number;
  billableTokens?: number;
  billingPeriodStart?: string;
  billingTier?: string;
  cachedInputTokens?: number;
  costCents?: number;
  createdAt?: string;
  id?: any;
  inputTokens?: number;
  model?: string;
  outputTokens?: number;
  overageTokens?: number;
  personId?: string;
  placeId?: string;
  runId?: string;
  threadId?: string;
  totalTokens?: number;
};

/** aggregate stddev on columns */
export type qx_ChatUsageHistory_stddev_fields = {
  __typename?: 'qx_ChatUsageHistory_stddev_fields';
  actualCostCents?: number;
  billableTokens?: number;
  cachedInputTokens?: number;
  costCents?: number;
  inputTokens?: number;
  outputTokens?: number;
  overageTokens?: number;
  totalTokens?: number;
};

/** aggregate stddev_pop on columns */
export type qx_ChatUsageHistory_stddev_pop_fields = {
  __typename?: 'qx_ChatUsageHistory_stddev_pop_fields';
  actualCostCents?: number;
  billableTokens?: number;
  cachedInputTokens?: number;
  costCents?: number;
  inputTokens?: number;
  outputTokens?: number;
  overageTokens?: number;
  totalTokens?: number;
};

/** aggregate stddev_samp on columns */
export type qx_ChatUsageHistory_stddev_samp_fields = {
  __typename?: 'qx_ChatUsageHistory_stddev_samp_fields';
  actualCostCents?: number;
  billableTokens?: number;
  cachedInputTokens?: number;
  costCents?: number;
  inputTokens?: number;
  outputTokens?: number;
  overageTokens?: number;
  totalTokens?: number;
};

/** Streaming cursor of the table "qx_ChatUsageHistory" */
export type qx_ChatUsageHistory_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_ChatUsageHistory_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_ChatUsageHistory_stream_cursor_value_input = {
  actualCostCents?: number;
  billableTokens?: number;
  billingPeriodStart?: string;
  billingTier?: string;
  cachedInputTokens?: number;
  costCents?: number;
  createdAt?: string;
  id?: any;
  inputTokens?: number;
  model?: string;
  outputTokens?: number;
  overageTokens?: number;
  personId?: string;
  placeId?: string;
  runId?: string;
  threadId?: string;
  totalTokens?: number;
};

/** aggregate sum on columns */
export type qx_ChatUsageHistory_sum_fields = {
  __typename?: 'qx_ChatUsageHistory_sum_fields';
  actualCostCents?: number;
  billableTokens?: number;
  cachedInputTokens?: number;
  costCents?: number;
  inputTokens?: number;
  outputTokens?: number;
  overageTokens?: number;
  totalTokens?: number;
};

/** update columns of table "qx.ChatUsageHistory" */
export enum qx_ChatUsageHistory_update_column {
  /** column name */
  actualCostCents = 'actualCostCents',
  /** column name */
  billableTokens = 'billableTokens',
  /** column name */
  billingPeriodStart = 'billingPeriodStart',
  /** column name */
  billingTier = 'billingTier',
  /** column name */
  cachedInputTokens = 'cachedInputTokens',
  /** column name */
  costCents = 'costCents',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  inputTokens = 'inputTokens',
  /** column name */
  model = 'model',
  /** column name */
  outputTokens = 'outputTokens',
  /** column name */
  overageTokens = 'overageTokens',
  /** column name */
  personId = 'personId',
  /** column name */
  placeId = 'placeId',
  /** column name */
  runId = 'runId',
  /** column name */
  threadId = 'threadId',
  /** column name */
  totalTokens = 'totalTokens'
}

export type qx_ChatUsageHistory_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_ChatUsageHistory_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_ChatUsageHistory_set_input;
  /** filter the rows which have to be updated */
  where: qx_ChatUsageHistory_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_ChatUsageHistory_var_pop_fields = {
  __typename?: 'qx_ChatUsageHistory_var_pop_fields';
  actualCostCents?: number;
  billableTokens?: number;
  cachedInputTokens?: number;
  costCents?: number;
  inputTokens?: number;
  outputTokens?: number;
  overageTokens?: number;
  totalTokens?: number;
};

/** aggregate var_samp on columns */
export type qx_ChatUsageHistory_var_samp_fields = {
  __typename?: 'qx_ChatUsageHistory_var_samp_fields';
  actualCostCents?: number;
  billableTokens?: number;
  cachedInputTokens?: number;
  costCents?: number;
  inputTokens?: number;
  outputTokens?: number;
  overageTokens?: number;
  totalTokens?: number;
};

/** aggregate variance on columns */
export type qx_ChatUsageHistory_variance_fields = {
  __typename?: 'qx_ChatUsageHistory_variance_fields';
  actualCostCents?: number;
  billableTokens?: number;
  cachedInputTokens?: number;
  costCents?: number;
  inputTokens?: number;
  outputTokens?: number;
  overageTokens?: number;
  totalTokens?: number;
};

/** columns and relationships of "qx.Clip" */
export type qx_Clip = {
  __typename?: 'qx_Clip';
  /** An array relationship */
  auditLog: Array<qx_ClipAuditLog>;
  /** An aggregate relationship */
  auditLog_aggregate: qx_ClipAuditLog_aggregate;
  base64?: string;
  bucketConfigurationID?: number;
  checksum?: string;
  createdAt: string;
  createdBy?: string;
  deletedAt?: string;
  description?: string;
  duration?: number;
  /** An object relationship */
  eClipStatus: qx_eClipStatus;
  /** An object relationship */
  eClipType: qx_eClipType;
  endTime: string;
  error?: string;
  /** An object relationship */
  event?: qx_Event;
  eventID?: string;
  expiresAt?: string;
  filePath?: string;
  id: string;
  metadata?: any;
  name?: string;
  /** An object relationship */
  person?: qx_Person;
  personID: string;
  /** An object relationship */
  place?: qx_Place;
  placeID: string;
  progress: any;
  searchText?: string;
  /** An array relationship */
  sharedLinks: Array<qx_SharedLinks>;
  /** An aggregate relationship */
  sharedLinks_aggregate: qx_SharedLinks_aggregate;
  /** A computed field, executes function "qx.clip_storage_url" */
  signedUrl?: string;
  size?: string;
  snapshot?: any;
  startTime: string;
  status: qx_eClipStatus_enum;
  type: qx_eClipType_enum;
  /** An object relationship */
  videoSource?: qx_VideoSource;
  videoSourceID?: string;
};


/** columns and relationships of "qx.Clip" */
export type qx_ClipauditLogArgs = {
  distinct_on?: Array<qx_ClipAuditLog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ClipAuditLog_order_by>;
  where?: qx_ClipAuditLog_bool_exp;
};


/** columns and relationships of "qx.Clip" */
export type qx_ClipauditLog_aggregateArgs = {
  distinct_on?: Array<qx_ClipAuditLog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ClipAuditLog_order_by>;
  where?: qx_ClipAuditLog_bool_exp;
};


/** columns and relationships of "qx.Clip" */
export type qx_ClipmetadataArgs = {
  path?: string;
};


/** columns and relationships of "qx.Clip" */
export type qx_ClipsharedLinksArgs = {
  distinct_on?: Array<qx_SharedLinks_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_SharedLinks_order_by>;
  where?: qx_SharedLinks_bool_exp;
};


/** columns and relationships of "qx.Clip" */
export type qx_ClipsharedLinks_aggregateArgs = {
  distinct_on?: Array<qx_SharedLinks_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_SharedLinks_order_by>;
  where?: qx_SharedLinks_bool_exp;
};

/** columns and relationships of "qx.ClipAuditLog" */
export type qx_ClipAuditLog = {
  __typename?: 'qx_ClipAuditLog';
  action?: string;
  alternateID?: string;
  auditableID?: string;
  auditableType?: string;
  changes?: any;
  /** An object relationship */
  clip?: qx_Clip;
  createdAt?: string;
  id?: string;
  /** An object relationship */
  person?: qx_Person;
  personID?: string;
  /** An object relationship */
  place?: qx_Place;
  placeID?: string;
};


/** columns and relationships of "qx.ClipAuditLog" */
export type qx_ClipAuditLogchangesArgs = {
  path?: string;
};

/** aggregated selection of "qx.ClipAuditLog" */
export type qx_ClipAuditLog_aggregate = {
  __typename?: 'qx_ClipAuditLog_aggregate';
  aggregate?: qx_ClipAuditLog_aggregate_fields;
  nodes: Array<qx_ClipAuditLog>;
};

export type qx_ClipAuditLog_aggregate_bool_exp = {
  count?: qx_ClipAuditLog_aggregate_bool_exp_count;
};

export type qx_ClipAuditLog_aggregate_bool_exp_count = {
  arguments?: Array<qx_ClipAuditLog_select_column>;
  distinct?: boolean;
  filter?: qx_ClipAuditLog_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.ClipAuditLog" */
export type qx_ClipAuditLog_aggregate_fields = {
  __typename?: 'qx_ClipAuditLog_aggregate_fields';
  avg?: qx_ClipAuditLog_avg_fields;
  count: number;
  max?: qx_ClipAuditLog_max_fields;
  min?: qx_ClipAuditLog_min_fields;
  stddev?: qx_ClipAuditLog_stddev_fields;
  stddev_pop?: qx_ClipAuditLog_stddev_pop_fields;
  stddev_samp?: qx_ClipAuditLog_stddev_samp_fields;
  sum?: qx_ClipAuditLog_sum_fields;
  var_pop?: qx_ClipAuditLog_var_pop_fields;
  var_samp?: qx_ClipAuditLog_var_samp_fields;
  variance?: qx_ClipAuditLog_variance_fields;
};


/** aggregate fields of "qx.ClipAuditLog" */
export type qx_ClipAuditLog_aggregate_fieldscountArgs = {
  columns?: Array<qx_ClipAuditLog_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.ClipAuditLog" */
export type qx_ClipAuditLog_aggregate_order_by = {
  avg?: qx_ClipAuditLog_avg_order_by;
  count?: order_by;
  max?: qx_ClipAuditLog_max_order_by;
  min?: qx_ClipAuditLog_min_order_by;
  stddev?: qx_ClipAuditLog_stddev_order_by;
  stddev_pop?: qx_ClipAuditLog_stddev_pop_order_by;
  stddev_samp?: qx_ClipAuditLog_stddev_samp_order_by;
  sum?: qx_ClipAuditLog_sum_order_by;
  var_pop?: qx_ClipAuditLog_var_pop_order_by;
  var_samp?: qx_ClipAuditLog_var_samp_order_by;
  variance?: qx_ClipAuditLog_variance_order_by;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type qx_ClipAuditLog_append_input = {
  changes?: any;
};

/** input type for inserting array relation for remote table "qx.ClipAuditLog" */
export type qx_ClipAuditLog_arr_rel_insert_input = {
  data: Array<qx_ClipAuditLog_insert_input>;
};

/** aggregate avg on columns */
export type qx_ClipAuditLog_avg_fields = {
  __typename?: 'qx_ClipAuditLog_avg_fields';
  auditableID?: number;
};

/** order by avg() on columns of table "qx.ClipAuditLog" */
export type qx_ClipAuditLog_avg_order_by = {
  auditableID?: order_by;
};

/** Boolean expression to filter rows from the table "qx.ClipAuditLog". All fields are combined with a logical 'AND'. */
export type qx_ClipAuditLog_bool_exp = {
  _and?: Array<qx_ClipAuditLog_bool_exp>;
  _not?: qx_ClipAuditLog_bool_exp;
  _or?: Array<qx_ClipAuditLog_bool_exp>;
  action?: String_comparison_exp;
  alternateID?: String_comparison_exp;
  auditableID?: bigint_comparison_exp;
  auditableType?: String_comparison_exp;
  changes?: jsonb_comparison_exp;
  clip?: qx_Clip_bool_exp;
  createdAt?: timestamptz_comparison_exp;
  id?: String_comparison_exp;
  person?: qx_Person_bool_exp;
  personID?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type qx_ClipAuditLog_delete_at_path_input = {
  changes?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type qx_ClipAuditLog_delete_elem_input = {
  changes?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type qx_ClipAuditLog_delete_key_input = {
  changes?: string;
};

/** input type for incrementing numeric columns in table "qx.ClipAuditLog" */
export type qx_ClipAuditLog_inc_input = {
  auditableID?: string;
};

/** input type for inserting data into table "qx.ClipAuditLog" */
export type qx_ClipAuditLog_insert_input = {
  action?: string;
  alternateID?: string;
  auditableID?: string;
  auditableType?: string;
  changes?: any;
  clip?: qx_Clip_obj_rel_insert_input;
  createdAt?: string;
  id?: string;
  person?: qx_Person_obj_rel_insert_input;
  personID?: string;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
};

/** aggregate max on columns */
export type qx_ClipAuditLog_max_fields = {
  __typename?: 'qx_ClipAuditLog_max_fields';
  action?: string;
  alternateID?: string;
  auditableID?: string;
  auditableType?: string;
  createdAt?: string;
  id?: string;
  personID?: string;
  placeID?: string;
};

/** order by max() on columns of table "qx.ClipAuditLog" */
export type qx_ClipAuditLog_max_order_by = {
  action?: order_by;
  alternateID?: order_by;
  auditableID?: order_by;
  auditableType?: order_by;
  createdAt?: order_by;
  id?: order_by;
  personID?: order_by;
  placeID?: order_by;
};

/** aggregate min on columns */
export type qx_ClipAuditLog_min_fields = {
  __typename?: 'qx_ClipAuditLog_min_fields';
  action?: string;
  alternateID?: string;
  auditableID?: string;
  auditableType?: string;
  createdAt?: string;
  id?: string;
  personID?: string;
  placeID?: string;
};

/** order by min() on columns of table "qx.ClipAuditLog" */
export type qx_ClipAuditLog_min_order_by = {
  action?: order_by;
  alternateID?: order_by;
  auditableID?: order_by;
  auditableType?: order_by;
  createdAt?: order_by;
  id?: order_by;
  personID?: order_by;
  placeID?: order_by;
};

/** response of any mutation on the table "qx.ClipAuditLog" */
export type qx_ClipAuditLog_mutation_response = {
  __typename?: 'qx_ClipAuditLog_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_ClipAuditLog>;
};

/** Ordering options when selecting data from "qx.ClipAuditLog". */
export type qx_ClipAuditLog_order_by = {
  action?: order_by;
  alternateID?: order_by;
  auditableID?: order_by;
  auditableType?: order_by;
  changes?: order_by;
  clip?: qx_Clip_order_by;
  createdAt?: order_by;
  id?: order_by;
  person?: qx_Person_order_by;
  personID?: order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type qx_ClipAuditLog_prepend_input = {
  changes?: any;
};

/** select columns of table "qx.ClipAuditLog" */
export enum qx_ClipAuditLog_select_column {
  /** column name */
  action = 'action',
  /** column name */
  alternateID = 'alternateID',
  /** column name */
  auditableID = 'auditableID',
  /** column name */
  auditableType = 'auditableType',
  /** column name */
  changes = 'changes',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  personID = 'personID',
  /** column name */
  placeID = 'placeID'
}

/** input type for updating data in table "qx.ClipAuditLog" */
export type qx_ClipAuditLog_set_input = {
  action?: string;
  alternateID?: string;
  auditableID?: string;
  auditableType?: string;
  changes?: any;
  createdAt?: string;
  id?: string;
  personID?: string;
  placeID?: string;
};

/** aggregate stddev on columns */
export type qx_ClipAuditLog_stddev_fields = {
  __typename?: 'qx_ClipAuditLog_stddev_fields';
  auditableID?: number;
};

/** order by stddev() on columns of table "qx.ClipAuditLog" */
export type qx_ClipAuditLog_stddev_order_by = {
  auditableID?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_ClipAuditLog_stddev_pop_fields = {
  __typename?: 'qx_ClipAuditLog_stddev_pop_fields';
  auditableID?: number;
};

/** order by stddev_pop() on columns of table "qx.ClipAuditLog" */
export type qx_ClipAuditLog_stddev_pop_order_by = {
  auditableID?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_ClipAuditLog_stddev_samp_fields = {
  __typename?: 'qx_ClipAuditLog_stddev_samp_fields';
  auditableID?: number;
};

/** order by stddev_samp() on columns of table "qx.ClipAuditLog" */
export type qx_ClipAuditLog_stddev_samp_order_by = {
  auditableID?: order_by;
};

/** Streaming cursor of the table "qx_ClipAuditLog" */
export type qx_ClipAuditLog_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_ClipAuditLog_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_ClipAuditLog_stream_cursor_value_input = {
  action?: string;
  alternateID?: string;
  auditableID?: string;
  auditableType?: string;
  changes?: any;
  createdAt?: string;
  id?: string;
  personID?: string;
  placeID?: string;
};

/** aggregate sum on columns */
export type qx_ClipAuditLog_sum_fields = {
  __typename?: 'qx_ClipAuditLog_sum_fields';
  auditableID?: string;
};

/** order by sum() on columns of table "qx.ClipAuditLog" */
export type qx_ClipAuditLog_sum_order_by = {
  auditableID?: order_by;
};

export type qx_ClipAuditLog_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: qx_ClipAuditLog_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: qx_ClipAuditLog_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: qx_ClipAuditLog_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: qx_ClipAuditLog_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_ClipAuditLog_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: qx_ClipAuditLog_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_ClipAuditLog_set_input;
  /** filter the rows which have to be updated */
  where: qx_ClipAuditLog_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_ClipAuditLog_var_pop_fields = {
  __typename?: 'qx_ClipAuditLog_var_pop_fields';
  auditableID?: number;
};

/** order by var_pop() on columns of table "qx.ClipAuditLog" */
export type qx_ClipAuditLog_var_pop_order_by = {
  auditableID?: order_by;
};

/** aggregate var_samp on columns */
export type qx_ClipAuditLog_var_samp_fields = {
  __typename?: 'qx_ClipAuditLog_var_samp_fields';
  auditableID?: number;
};

/** order by var_samp() on columns of table "qx.ClipAuditLog" */
export type qx_ClipAuditLog_var_samp_order_by = {
  auditableID?: order_by;
};

/** aggregate variance on columns */
export type qx_ClipAuditLog_variance_fields = {
  __typename?: 'qx_ClipAuditLog_variance_fields';
  auditableID?: number;
};

/** order by variance() on columns of table "qx.ClipAuditLog" */
export type qx_ClipAuditLog_variance_order_by = {
  auditableID?: order_by;
};

/** aggregated selection of "qx.Clip" */
export type qx_Clip_aggregate = {
  __typename?: 'qx_Clip_aggregate';
  aggregate?: qx_Clip_aggregate_fields;
  nodes: Array<qx_Clip>;
};

export type qx_Clip_aggregate_bool_exp = {
  count?: qx_Clip_aggregate_bool_exp_count;
};

export type qx_Clip_aggregate_bool_exp_count = {
  arguments?: Array<qx_Clip_select_column>;
  distinct?: boolean;
  filter?: qx_Clip_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.Clip" */
export type qx_Clip_aggregate_fields = {
  __typename?: 'qx_Clip_aggregate_fields';
  avg?: qx_Clip_avg_fields;
  count: number;
  max?: qx_Clip_max_fields;
  min?: qx_Clip_min_fields;
  stddev?: qx_Clip_stddev_fields;
  stddev_pop?: qx_Clip_stddev_pop_fields;
  stddev_samp?: qx_Clip_stddev_samp_fields;
  sum?: qx_Clip_sum_fields;
  var_pop?: qx_Clip_var_pop_fields;
  var_samp?: qx_Clip_var_samp_fields;
  variance?: qx_Clip_variance_fields;
};


/** aggregate fields of "qx.Clip" */
export type qx_Clip_aggregate_fieldscountArgs = {
  columns?: Array<qx_Clip_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.Clip" */
export type qx_Clip_aggregate_order_by = {
  avg?: qx_Clip_avg_order_by;
  count?: order_by;
  max?: qx_Clip_max_order_by;
  min?: qx_Clip_min_order_by;
  stddev?: qx_Clip_stddev_order_by;
  stddev_pop?: qx_Clip_stddev_pop_order_by;
  stddev_samp?: qx_Clip_stddev_samp_order_by;
  sum?: qx_Clip_sum_order_by;
  var_pop?: qx_Clip_var_pop_order_by;
  var_samp?: qx_Clip_var_samp_order_by;
  variance?: qx_Clip_variance_order_by;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type qx_Clip_append_input = {
  metadata?: any;
};

/** input type for inserting array relation for remote table "qx.Clip" */
export type qx_Clip_arr_rel_insert_input = {
  data: Array<qx_Clip_insert_input>;
  /** upsert condition */
  on_conflict?: qx_Clip_on_conflict;
};

/** aggregate avg on columns */
export type qx_Clip_avg_fields = {
  __typename?: 'qx_Clip_avg_fields';
  bucketConfigurationID?: number;
  duration?: number;
  eventID?: number;
  id?: number;
  progress?: number;
  size?: number;
  videoSourceID?: number;
};

/** order by avg() on columns of table "qx.Clip" */
export type qx_Clip_avg_order_by = {
  bucketConfigurationID?: order_by;
  duration?: order_by;
  eventID?: order_by;
  id?: order_by;
  progress?: order_by;
  size?: order_by;
  videoSourceID?: order_by;
};

/** Boolean expression to filter rows from the table "qx.Clip". All fields are combined with a logical 'AND'. */
export type qx_Clip_bool_exp = {
  _and?: Array<qx_Clip_bool_exp>;
  _not?: qx_Clip_bool_exp;
  _or?: Array<qx_Clip_bool_exp>;
  auditLog?: qx_ClipAuditLog_bool_exp;
  auditLog_aggregate?: qx_ClipAuditLog_aggregate_bool_exp;
  base64?: String_comparison_exp;
  bucketConfigurationID?: Int_comparison_exp;
  checksum?: String_comparison_exp;
  createdAt?: timestamptz_comparison_exp;
  createdBy?: String_comparison_exp;
  deletedAt?: timestamptz_comparison_exp;
  description?: String_comparison_exp;
  duration?: Int_comparison_exp;
  eClipStatus?: qx_eClipStatus_bool_exp;
  eClipType?: qx_eClipType_bool_exp;
  endTime?: timestamptz_comparison_exp;
  error?: String_comparison_exp;
  event?: qx_Event_bool_exp;
  eventID?: bigint_comparison_exp;
  expiresAt?: timestamptz_comparison_exp;
  filePath?: String_comparison_exp;
  id?: bigint_comparison_exp;
  metadata?: jsonb_comparison_exp;
  name?: String_comparison_exp;
  person?: qx_Person_bool_exp;
  personID?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
  progress?: numeric_comparison_exp;
  searchText?: String_comparison_exp;
  sharedLinks?: qx_SharedLinks_bool_exp;
  sharedLinks_aggregate?: qx_SharedLinks_aggregate_bool_exp;
  signedUrl?: String_comparison_exp;
  size?: bigint_comparison_exp;
  snapshot?: bytea_comparison_exp;
  startTime?: timestamptz_comparison_exp;
  status?: qx_eClipStatus_enum_comparison_exp;
  type?: qx_eClipType_enum_comparison_exp;
  videoSource?: qx_VideoSource_bool_exp;
  videoSourceID?: bigint_comparison_exp;
};

/** unique or primary key constraints on table "qx.Clip" */
export enum qx_Clip_constraint {
  /** unique or primary key constraint on columns "id" */
  Clip_pkey = 'Clip_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type qx_Clip_delete_at_path_input = {
  metadata?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type qx_Clip_delete_elem_input = {
  metadata?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type qx_Clip_delete_key_input = {
  metadata?: string;
};

/** input type for incrementing numeric columns in table "qx.Clip" */
export type qx_Clip_inc_input = {
  bucketConfigurationID?: number;
  duration?: number;
  eventID?: string;
  id?: string;
  progress?: any;
  size?: string;
  videoSourceID?: string;
};

/** input type for inserting data into table "qx.Clip" */
export type qx_Clip_insert_input = {
  auditLog?: qx_ClipAuditLog_arr_rel_insert_input;
  bucketConfigurationID?: number;
  checksum?: string;
  createdAt?: string;
  createdBy?: string;
  deletedAt?: string;
  description?: string;
  duration?: number;
  eClipStatus?: qx_eClipStatus_obj_rel_insert_input;
  eClipType?: qx_eClipType_obj_rel_insert_input;
  endTime?: string;
  error?: string;
  event?: qx_Event_obj_rel_insert_input;
  eventID?: string;
  expiresAt?: string;
  filePath?: string;
  id?: string;
  metadata?: any;
  name?: string;
  person?: qx_Person_obj_rel_insert_input;
  personID?: string;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
  progress?: any;
  searchText?: string;
  sharedLinks?: qx_SharedLinks_arr_rel_insert_input;
  size?: string;
  snapshot?: any;
  startTime?: string;
  status?: qx_eClipStatus_enum;
  type?: qx_eClipType_enum;
  videoSource?: qx_VideoSource_obj_rel_insert_input;
  videoSourceID?: string;
};

/** aggregate max on columns */
export type qx_Clip_max_fields = {
  __typename?: 'qx_Clip_max_fields';
  base64?: string;
  bucketConfigurationID?: number;
  checksum?: string;
  createdAt?: string;
  createdBy?: string;
  deletedAt?: string;
  description?: string;
  duration?: number;
  endTime?: string;
  error?: string;
  eventID?: string;
  expiresAt?: string;
  filePath?: string;
  id?: string;
  name?: string;
  personID?: string;
  placeID?: string;
  progress?: any;
  searchText?: string;
  /** A computed field, executes function "qx.clip_storage_url" */
  signedUrl?: string;
  size?: string;
  startTime?: string;
  videoSourceID?: string;
};

/** order by max() on columns of table "qx.Clip" */
export type qx_Clip_max_order_by = {
  bucketConfigurationID?: order_by;
  checksum?: order_by;
  createdAt?: order_by;
  createdBy?: order_by;
  deletedAt?: order_by;
  description?: order_by;
  duration?: order_by;
  endTime?: order_by;
  error?: order_by;
  eventID?: order_by;
  expiresAt?: order_by;
  filePath?: order_by;
  id?: order_by;
  name?: order_by;
  personID?: order_by;
  placeID?: order_by;
  progress?: order_by;
  searchText?: order_by;
  size?: order_by;
  startTime?: order_by;
  videoSourceID?: order_by;
};

/** aggregate min on columns */
export type qx_Clip_min_fields = {
  __typename?: 'qx_Clip_min_fields';
  base64?: string;
  bucketConfigurationID?: number;
  checksum?: string;
  createdAt?: string;
  createdBy?: string;
  deletedAt?: string;
  description?: string;
  duration?: number;
  endTime?: string;
  error?: string;
  eventID?: string;
  expiresAt?: string;
  filePath?: string;
  id?: string;
  name?: string;
  personID?: string;
  placeID?: string;
  progress?: any;
  searchText?: string;
  /** A computed field, executes function "qx.clip_storage_url" */
  signedUrl?: string;
  size?: string;
  startTime?: string;
  videoSourceID?: string;
};

/** order by min() on columns of table "qx.Clip" */
export type qx_Clip_min_order_by = {
  bucketConfigurationID?: order_by;
  checksum?: order_by;
  createdAt?: order_by;
  createdBy?: order_by;
  deletedAt?: order_by;
  description?: order_by;
  duration?: order_by;
  endTime?: order_by;
  error?: order_by;
  eventID?: order_by;
  expiresAt?: order_by;
  filePath?: order_by;
  id?: order_by;
  name?: order_by;
  personID?: order_by;
  placeID?: order_by;
  progress?: order_by;
  searchText?: order_by;
  size?: order_by;
  startTime?: order_by;
  videoSourceID?: order_by;
};

/** response of any mutation on the table "qx.Clip" */
export type qx_Clip_mutation_response = {
  __typename?: 'qx_Clip_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_Clip>;
};

/** input type for inserting object relation for remote table "qx.Clip" */
export type qx_Clip_obj_rel_insert_input = {
  data: qx_Clip_insert_input;
  /** upsert condition */
  on_conflict?: qx_Clip_on_conflict;
};

/** on_conflict condition type for table "qx.Clip" */
export type qx_Clip_on_conflict = {
  constraint: qx_Clip_constraint;
  update_columns?: Array<qx_Clip_update_column>;
  where?: qx_Clip_bool_exp;
};

/** Ordering options when selecting data from "qx.Clip". */
export type qx_Clip_order_by = {
  auditLog_aggregate?: qx_ClipAuditLog_aggregate_order_by;
  base64?: order_by;
  bucketConfigurationID?: order_by;
  checksum?: order_by;
  createdAt?: order_by;
  createdBy?: order_by;
  deletedAt?: order_by;
  description?: order_by;
  duration?: order_by;
  eClipStatus?: qx_eClipStatus_order_by;
  eClipType?: qx_eClipType_order_by;
  endTime?: order_by;
  error?: order_by;
  event?: qx_Event_order_by;
  eventID?: order_by;
  expiresAt?: order_by;
  filePath?: order_by;
  id?: order_by;
  metadata?: order_by;
  name?: order_by;
  person?: qx_Person_order_by;
  personID?: order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
  progress?: order_by;
  searchText?: order_by;
  sharedLinks_aggregate?: qx_SharedLinks_aggregate_order_by;
  signedUrl?: order_by;
  size?: order_by;
  snapshot?: order_by;
  startTime?: order_by;
  status?: order_by;
  type?: order_by;
  videoSource?: qx_VideoSource_order_by;
  videoSourceID?: order_by;
};

/** primary key columns input for table: qx.Clip */
export type qx_Clip_pk_columns_input = {
  id: string;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type qx_Clip_prepend_input = {
  metadata?: any;
};

/** select columns of table "qx.Clip" */
export enum qx_Clip_select_column {
  /** column name */
  bucketConfigurationID = 'bucketConfigurationID',
  /** column name */
  checksum = 'checksum',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdBy = 'createdBy',
  /** column name */
  deletedAt = 'deletedAt',
  /** column name */
  description = 'description',
  /** column name */
  duration = 'duration',
  /** column name */
  endTime = 'endTime',
  /** column name */
  error = 'error',
  /** column name */
  eventID = 'eventID',
  /** column name */
  expiresAt = 'expiresAt',
  /** column name */
  filePath = 'filePath',
  /** column name */
  id = 'id',
  /** column name */
  metadata = 'metadata',
  /** column name */
  name = 'name',
  /** column name */
  personID = 'personID',
  /** column name */
  placeID = 'placeID',
  /** column name */
  progress = 'progress',
  /** column name */
  searchText = 'searchText',
  /** column name */
  size = 'size',
  /** column name */
  snapshot = 'snapshot',
  /** column name */
  startTime = 'startTime',
  /** column name */
  status = 'status',
  /** column name */
  type = 'type',
  /** column name */
  videoSourceID = 'videoSourceID'
}

/** input type for updating data in table "qx.Clip" */
export type qx_Clip_set_input = {
  bucketConfigurationID?: number;
  checksum?: string;
  createdAt?: string;
  createdBy?: string;
  deletedAt?: string;
  description?: string;
  duration?: number;
  endTime?: string;
  error?: string;
  eventID?: string;
  expiresAt?: string;
  filePath?: string;
  id?: string;
  metadata?: any;
  name?: string;
  personID?: string;
  placeID?: string;
  progress?: any;
  searchText?: string;
  size?: string;
  snapshot?: any;
  startTime?: string;
  status?: qx_eClipStatus_enum;
  type?: qx_eClipType_enum;
  videoSourceID?: string;
};

/** aggregate stddev on columns */
export type qx_Clip_stddev_fields = {
  __typename?: 'qx_Clip_stddev_fields';
  bucketConfigurationID?: number;
  duration?: number;
  eventID?: number;
  id?: number;
  progress?: number;
  size?: number;
  videoSourceID?: number;
};

/** order by stddev() on columns of table "qx.Clip" */
export type qx_Clip_stddev_order_by = {
  bucketConfigurationID?: order_by;
  duration?: order_by;
  eventID?: order_by;
  id?: order_by;
  progress?: order_by;
  size?: order_by;
  videoSourceID?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_Clip_stddev_pop_fields = {
  __typename?: 'qx_Clip_stddev_pop_fields';
  bucketConfigurationID?: number;
  duration?: number;
  eventID?: number;
  id?: number;
  progress?: number;
  size?: number;
  videoSourceID?: number;
};

/** order by stddev_pop() on columns of table "qx.Clip" */
export type qx_Clip_stddev_pop_order_by = {
  bucketConfigurationID?: order_by;
  duration?: order_by;
  eventID?: order_by;
  id?: order_by;
  progress?: order_by;
  size?: order_by;
  videoSourceID?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_Clip_stddev_samp_fields = {
  __typename?: 'qx_Clip_stddev_samp_fields';
  bucketConfigurationID?: number;
  duration?: number;
  eventID?: number;
  id?: number;
  progress?: number;
  size?: number;
  videoSourceID?: number;
};

/** order by stddev_samp() on columns of table "qx.Clip" */
export type qx_Clip_stddev_samp_order_by = {
  bucketConfigurationID?: order_by;
  duration?: order_by;
  eventID?: order_by;
  id?: order_by;
  progress?: order_by;
  size?: order_by;
  videoSourceID?: order_by;
};

/** Streaming cursor of the table "qx_Clip" */
export type qx_Clip_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_Clip_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_Clip_stream_cursor_value_input = {
  bucketConfigurationID?: number;
  checksum?: string;
  createdAt?: string;
  createdBy?: string;
  deletedAt?: string;
  description?: string;
  duration?: number;
  endTime?: string;
  error?: string;
  eventID?: string;
  expiresAt?: string;
  filePath?: string;
  id?: string;
  metadata?: any;
  name?: string;
  personID?: string;
  placeID?: string;
  progress?: any;
  searchText?: string;
  size?: string;
  snapshot?: any;
  startTime?: string;
  status?: qx_eClipStatus_enum;
  type?: qx_eClipType_enum;
  videoSourceID?: string;
};

/** aggregate sum on columns */
export type qx_Clip_sum_fields = {
  __typename?: 'qx_Clip_sum_fields';
  bucketConfigurationID?: number;
  duration?: number;
  eventID?: string;
  id?: string;
  progress?: any;
  size?: string;
  videoSourceID?: string;
};

/** order by sum() on columns of table "qx.Clip" */
export type qx_Clip_sum_order_by = {
  bucketConfigurationID?: order_by;
  duration?: order_by;
  eventID?: order_by;
  id?: order_by;
  progress?: order_by;
  size?: order_by;
  videoSourceID?: order_by;
};

/** update columns of table "qx.Clip" */
export enum qx_Clip_update_column {
  /** column name */
  bucketConfigurationID = 'bucketConfigurationID',
  /** column name */
  checksum = 'checksum',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdBy = 'createdBy',
  /** column name */
  deletedAt = 'deletedAt',
  /** column name */
  description = 'description',
  /** column name */
  duration = 'duration',
  /** column name */
  endTime = 'endTime',
  /** column name */
  error = 'error',
  /** column name */
  eventID = 'eventID',
  /** column name */
  expiresAt = 'expiresAt',
  /** column name */
  filePath = 'filePath',
  /** column name */
  id = 'id',
  /** column name */
  metadata = 'metadata',
  /** column name */
  name = 'name',
  /** column name */
  personID = 'personID',
  /** column name */
  placeID = 'placeID',
  /** column name */
  progress = 'progress',
  /** column name */
  searchText = 'searchText',
  /** column name */
  size = 'size',
  /** column name */
  snapshot = 'snapshot',
  /** column name */
  startTime = 'startTime',
  /** column name */
  status = 'status',
  /** column name */
  type = 'type',
  /** column name */
  videoSourceID = 'videoSourceID'
}

export type qx_Clip_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: qx_Clip_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: qx_Clip_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: qx_Clip_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: qx_Clip_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_Clip_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: qx_Clip_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_Clip_set_input;
  /** filter the rows which have to be updated */
  where: qx_Clip_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_Clip_var_pop_fields = {
  __typename?: 'qx_Clip_var_pop_fields';
  bucketConfigurationID?: number;
  duration?: number;
  eventID?: number;
  id?: number;
  progress?: number;
  size?: number;
  videoSourceID?: number;
};

/** order by var_pop() on columns of table "qx.Clip" */
export type qx_Clip_var_pop_order_by = {
  bucketConfigurationID?: order_by;
  duration?: order_by;
  eventID?: order_by;
  id?: order_by;
  progress?: order_by;
  size?: order_by;
  videoSourceID?: order_by;
};

/** aggregate var_samp on columns */
export type qx_Clip_var_samp_fields = {
  __typename?: 'qx_Clip_var_samp_fields';
  bucketConfigurationID?: number;
  duration?: number;
  eventID?: number;
  id?: number;
  progress?: number;
  size?: number;
  videoSourceID?: number;
};

/** order by var_samp() on columns of table "qx.Clip" */
export type qx_Clip_var_samp_order_by = {
  bucketConfigurationID?: order_by;
  duration?: order_by;
  eventID?: order_by;
  id?: order_by;
  progress?: order_by;
  size?: order_by;
  videoSourceID?: order_by;
};

/** aggregate variance on columns */
export type qx_Clip_variance_fields = {
  __typename?: 'qx_Clip_variance_fields';
  bucketConfigurationID?: number;
  duration?: number;
  eventID?: number;
  id?: number;
  progress?: number;
  size?: number;
  videoSourceID?: number;
};

/** order by variance() on columns of table "qx.Clip" */
export type qx_Clip_variance_order_by = {
  bucketConfigurationID?: order_by;
  duration?: order_by;
  eventID?: order_by;
  id?: order_by;
  progress?: order_by;
  size?: order_by;
  videoSourceID?: order_by;
};

/** columns and relationships of "qx.CloudStorageOptions" */
export type qx_CloudStorageOptions = {
  __typename?: 'qx_CloudStorageOptions';
  cloudStorageDays: number;
  partName?: string;
  /** An array relationship */
  videoSources: Array<qx_VideoSource>;
  /** An aggregate relationship */
  videoSources_aggregate: qx_VideoSource_aggregate;
};


/** columns and relationships of "qx.CloudStorageOptions" */
export type qx_CloudStorageOptionsvideoSourcesArgs = {
  distinct_on?: Array<qx_VideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_VideoSource_order_by>;
  where?: qx_VideoSource_bool_exp;
};


/** columns and relationships of "qx.CloudStorageOptions" */
export type qx_CloudStorageOptionsvideoSources_aggregateArgs = {
  distinct_on?: Array<qx_VideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_VideoSource_order_by>;
  where?: qx_VideoSource_bool_exp;
};

/** aggregated selection of "qx.CloudStorageOptions" */
export type qx_CloudStorageOptions_aggregate = {
  __typename?: 'qx_CloudStorageOptions_aggregate';
  aggregate?: qx_CloudStorageOptions_aggregate_fields;
  nodes: Array<qx_CloudStorageOptions>;
};

/** aggregate fields of "qx.CloudStorageOptions" */
export type qx_CloudStorageOptions_aggregate_fields = {
  __typename?: 'qx_CloudStorageOptions_aggregate_fields';
  avg?: qx_CloudStorageOptions_avg_fields;
  count: number;
  max?: qx_CloudStorageOptions_max_fields;
  min?: qx_CloudStorageOptions_min_fields;
  stddev?: qx_CloudStorageOptions_stddev_fields;
  stddev_pop?: qx_CloudStorageOptions_stddev_pop_fields;
  stddev_samp?: qx_CloudStorageOptions_stddev_samp_fields;
  sum?: qx_CloudStorageOptions_sum_fields;
  var_pop?: qx_CloudStorageOptions_var_pop_fields;
  var_samp?: qx_CloudStorageOptions_var_samp_fields;
  variance?: qx_CloudStorageOptions_variance_fields;
};


/** aggregate fields of "qx.CloudStorageOptions" */
export type qx_CloudStorageOptions_aggregate_fieldscountArgs = {
  columns?: Array<qx_CloudStorageOptions_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type qx_CloudStorageOptions_avg_fields = {
  __typename?: 'qx_CloudStorageOptions_avg_fields';
  cloudStorageDays?: number;
};

/** Boolean expression to filter rows from the table "qx.CloudStorageOptions". All fields are combined with a logical 'AND'. */
export type qx_CloudStorageOptions_bool_exp = {
  _and?: Array<qx_CloudStorageOptions_bool_exp>;
  _not?: qx_CloudStorageOptions_bool_exp;
  _or?: Array<qx_CloudStorageOptions_bool_exp>;
  cloudStorageDays?: Int_comparison_exp;
  partName?: String_comparison_exp;
  videoSources?: qx_VideoSource_bool_exp;
  videoSources_aggregate?: qx_VideoSource_aggregate_bool_exp;
};

/** unique or primary key constraints on table "qx.CloudStorageOptions" */
export enum qx_CloudStorageOptions_constraint {
  /** unique or primary key constraint on columns "cloudStorageDays" */
  CloudStorageOptions_pkey = 'CloudStorageOptions_pkey'
}

/** input type for incrementing numeric columns in table "qx.CloudStorageOptions" */
export type qx_CloudStorageOptions_inc_input = {
  cloudStorageDays?: number;
};

/** input type for inserting data into table "qx.CloudStorageOptions" */
export type qx_CloudStorageOptions_insert_input = {
  cloudStorageDays?: number;
  partName?: string;
  videoSources?: qx_VideoSource_arr_rel_insert_input;
};

/** aggregate max on columns */
export type qx_CloudStorageOptions_max_fields = {
  __typename?: 'qx_CloudStorageOptions_max_fields';
  cloudStorageDays?: number;
  partName?: string;
};

/** aggregate min on columns */
export type qx_CloudStorageOptions_min_fields = {
  __typename?: 'qx_CloudStorageOptions_min_fields';
  cloudStorageDays?: number;
  partName?: string;
};

/** response of any mutation on the table "qx.CloudStorageOptions" */
export type qx_CloudStorageOptions_mutation_response = {
  __typename?: 'qx_CloudStorageOptions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_CloudStorageOptions>;
};

/** input type for inserting object relation for remote table "qx.CloudStorageOptions" */
export type qx_CloudStorageOptions_obj_rel_insert_input = {
  data: qx_CloudStorageOptions_insert_input;
  /** upsert condition */
  on_conflict?: qx_CloudStorageOptions_on_conflict;
};

/** on_conflict condition type for table "qx.CloudStorageOptions" */
export type qx_CloudStorageOptions_on_conflict = {
  constraint: qx_CloudStorageOptions_constraint;
  update_columns?: Array<qx_CloudStorageOptions_update_column>;
  where?: qx_CloudStorageOptions_bool_exp;
};

/** Ordering options when selecting data from "qx.CloudStorageOptions". */
export type qx_CloudStorageOptions_order_by = {
  cloudStorageDays?: order_by;
  partName?: order_by;
  videoSources_aggregate?: qx_VideoSource_aggregate_order_by;
};

/** primary key columns input for table: qx.CloudStorageOptions */
export type qx_CloudStorageOptions_pk_columns_input = {
  cloudStorageDays: number;
};

/** select columns of table "qx.CloudStorageOptions" */
export enum qx_CloudStorageOptions_select_column {
  /** column name */
  cloudStorageDays = 'cloudStorageDays',
  /** column name */
  partName = 'partName'
}

/** input type for updating data in table "qx.CloudStorageOptions" */
export type qx_CloudStorageOptions_set_input = {
  cloudStorageDays?: number;
  partName?: string;
};

/** aggregate stddev on columns */
export type qx_CloudStorageOptions_stddev_fields = {
  __typename?: 'qx_CloudStorageOptions_stddev_fields';
  cloudStorageDays?: number;
};

/** aggregate stddev_pop on columns */
export type qx_CloudStorageOptions_stddev_pop_fields = {
  __typename?: 'qx_CloudStorageOptions_stddev_pop_fields';
  cloudStorageDays?: number;
};

/** aggregate stddev_samp on columns */
export type qx_CloudStorageOptions_stddev_samp_fields = {
  __typename?: 'qx_CloudStorageOptions_stddev_samp_fields';
  cloudStorageDays?: number;
};

/** Streaming cursor of the table "qx_CloudStorageOptions" */
export type qx_CloudStorageOptions_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_CloudStorageOptions_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_CloudStorageOptions_stream_cursor_value_input = {
  cloudStorageDays?: number;
  partName?: string;
};

/** aggregate sum on columns */
export type qx_CloudStorageOptions_sum_fields = {
  __typename?: 'qx_CloudStorageOptions_sum_fields';
  cloudStorageDays?: number;
};

/** update columns of table "qx.CloudStorageOptions" */
export enum qx_CloudStorageOptions_update_column {
  /** column name */
  cloudStorageDays = 'cloudStorageDays',
  /** column name */
  partName = 'partName'
}

export type qx_CloudStorageOptions_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_CloudStorageOptions_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_CloudStorageOptions_set_input;
  /** filter the rows which have to be updated */
  where: qx_CloudStorageOptions_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_CloudStorageOptions_var_pop_fields = {
  __typename?: 'qx_CloudStorageOptions_var_pop_fields';
  cloudStorageDays?: number;
};

/** aggregate var_samp on columns */
export type qx_CloudStorageOptions_var_samp_fields = {
  __typename?: 'qx_CloudStorageOptions_var_samp_fields';
  cloudStorageDays?: number;
};

/** aggregate variance on columns */
export type qx_CloudStorageOptions_variance_fields = {
  __typename?: 'qx_CloudStorageOptions_variance_fields';
  cloudStorageDays?: number;
};

/** access credential (card, PIN, mobile key) assigned to a person and used to authenticate at readers */
export type qx_Credential = {
  __typename?: 'qx_Credential';
  createdAt: string;
  /** An object relationship */
  customerPlace: qx_Place;
  customerPlaceID: string;
  enabled: boolean;
  extendedTimeEnabled: boolean;
  externalSync: boolean;
  id: string;
  legacyDuplicate?: boolean;
  ossPayload?: string;
  /** An object relationship */
  person: qx_Person;
  personID: string;
  pin?: string;
  reason?: string;
  status?: string;
  /** An object relationship */
  toType: qx_eCredentialType;
  type: qx_eCredentialType_enum;
  updatedAt?: string;
  validFrom?: string;
  validTo?: string;
  value: string;
};

/** aggregated selection of "qx.Credential" */
export type qx_Credential_aggregate = {
  __typename?: 'qx_Credential_aggregate';
  aggregate?: qx_Credential_aggregate_fields;
  nodes: Array<qx_Credential>;
};

export type qx_Credential_aggregate_bool_exp = {
  bool_and?: qx_Credential_aggregate_bool_exp_bool_and;
  bool_or?: qx_Credential_aggregate_bool_exp_bool_or;
  count?: qx_Credential_aggregate_bool_exp_count;
};

export type qx_Credential_aggregate_bool_exp_bool_and = {
  arguments: qx_Credential_select_column_qx_Credential_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: qx_Credential_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_Credential_aggregate_bool_exp_bool_or = {
  arguments: qx_Credential_select_column_qx_Credential_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: qx_Credential_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_Credential_aggregate_bool_exp_count = {
  arguments?: Array<qx_Credential_select_column>;
  distinct?: boolean;
  filter?: qx_Credential_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.Credential" */
export type qx_Credential_aggregate_fields = {
  __typename?: 'qx_Credential_aggregate_fields';
  count: number;
  max?: qx_Credential_max_fields;
  min?: qx_Credential_min_fields;
};


/** aggregate fields of "qx.Credential" */
export type qx_Credential_aggregate_fieldscountArgs = {
  columns?: Array<qx_Credential_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.Credential" */
export type qx_Credential_aggregate_order_by = {
  count?: order_by;
  max?: qx_Credential_max_order_by;
  min?: qx_Credential_min_order_by;
};

/** input type for inserting array relation for remote table "qx.Credential" */
export type qx_Credential_arr_rel_insert_input = {
  data: Array<qx_Credential_insert_input>;
  /** upsert condition */
  on_conflict?: qx_Credential_on_conflict;
};

/** Boolean expression to filter rows from the table "qx.Credential". All fields are combined with a logical 'AND'. */
export type qx_Credential_bool_exp = {
  _and?: Array<qx_Credential_bool_exp>;
  _not?: qx_Credential_bool_exp;
  _or?: Array<qx_Credential_bool_exp>;
  createdAt?: timestamptz_comparison_exp;
  customerPlace?: qx_Place_bool_exp;
  customerPlaceID?: String_comparison_exp;
  enabled?: Boolean_comparison_exp;
  extendedTimeEnabled?: Boolean_comparison_exp;
  externalSync?: Boolean_comparison_exp;
  id?: String_comparison_exp;
  legacyDuplicate?: Boolean_comparison_exp;
  ossPayload?: String_comparison_exp;
  person?: qx_Person_bool_exp;
  personID?: String_comparison_exp;
  pin?: String_comparison_exp;
  reason?: String_comparison_exp;
  status?: String_comparison_exp;
  toType?: qx_eCredentialType_bool_exp;
  type?: qx_eCredentialType_enum_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
  validFrom?: timestamptz_comparison_exp;
  validTo?: timestamptz_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.Credential" */
export enum qx_Credential_constraint {
  /** unique or primary key constraint on columns "id" */
  Credential_pkey = 'Credential_pkey',
  /** unique or primary key constraint on columns "customerPlaceID", "pin", "value" */
  idx_credential_customerPlaceID_pin = 'idx_credential_customerPlaceID_pin',
  /** unique or primary key constraint on columns "customerPlaceID", "value" */
  idx_credential_customerPlaceID_value = 'idx_credential_customerPlaceID_value'
}

/** input type for inserting data into table "qx.Credential" */
export type qx_Credential_insert_input = {
  createdAt?: string;
  customerPlace?: qx_Place_obj_rel_insert_input;
  customerPlaceID?: string;
  enabled?: boolean;
  extendedTimeEnabled?: boolean;
  externalSync?: boolean;
  id?: string;
  legacyDuplicate?: boolean;
  ossPayload?: string;
  person?: qx_Person_obj_rel_insert_input;
  personID?: string;
  pin?: string;
  reason?: string;
  toType?: qx_eCredentialType_obj_rel_insert_input;
  type?: qx_eCredentialType_enum;
  updatedAt?: string;
  validFrom?: string;
  validTo?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_Credential_max_fields = {
  __typename?: 'qx_Credential_max_fields';
  createdAt?: string;
  customerPlaceID?: string;
  id?: string;
  ossPayload?: string;
  personID?: string;
  pin?: string;
  reason?: string;
  status?: string;
  updatedAt?: string;
  validFrom?: string;
  validTo?: string;
  value?: string;
};

/** order by max() on columns of table "qx.Credential" */
export type qx_Credential_max_order_by = {
  createdAt?: order_by;
  customerPlaceID?: order_by;
  id?: order_by;
  ossPayload?: order_by;
  personID?: order_by;
  pin?: order_by;
  reason?: order_by;
  updatedAt?: order_by;
  validFrom?: order_by;
  validTo?: order_by;
  value?: order_by;
};

/** aggregate min on columns */
export type qx_Credential_min_fields = {
  __typename?: 'qx_Credential_min_fields';
  createdAt?: string;
  customerPlaceID?: string;
  id?: string;
  ossPayload?: string;
  personID?: string;
  pin?: string;
  reason?: string;
  status?: string;
  updatedAt?: string;
  validFrom?: string;
  validTo?: string;
  value?: string;
};

/** order by min() on columns of table "qx.Credential" */
export type qx_Credential_min_order_by = {
  createdAt?: order_by;
  customerPlaceID?: order_by;
  id?: order_by;
  ossPayload?: order_by;
  personID?: order_by;
  pin?: order_by;
  reason?: order_by;
  updatedAt?: order_by;
  validFrom?: order_by;
  validTo?: order_by;
  value?: order_by;
};

/** response of any mutation on the table "qx.Credential" */
export type qx_Credential_mutation_response = {
  __typename?: 'qx_Credential_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_Credential>;
};

/** input type for inserting object relation for remote table "qx.Credential" */
export type qx_Credential_obj_rel_insert_input = {
  data: qx_Credential_insert_input;
  /** upsert condition */
  on_conflict?: qx_Credential_on_conflict;
};

/** on_conflict condition type for table "qx.Credential" */
export type qx_Credential_on_conflict = {
  constraint: qx_Credential_constraint;
  update_columns?: Array<qx_Credential_update_column>;
  where?: qx_Credential_bool_exp;
};

/** Ordering options when selecting data from "qx.Credential". */
export type qx_Credential_order_by = {
  createdAt?: order_by;
  customerPlace?: qx_Place_order_by;
  customerPlaceID?: order_by;
  enabled?: order_by;
  extendedTimeEnabled?: order_by;
  externalSync?: order_by;
  id?: order_by;
  legacyDuplicate?: order_by;
  ossPayload?: order_by;
  person?: qx_Person_order_by;
  personID?: order_by;
  pin?: order_by;
  reason?: order_by;
  status?: order_by;
  toType?: qx_eCredentialType_order_by;
  type?: order_by;
  updatedAt?: order_by;
  validFrom?: order_by;
  validTo?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.Credential */
export type qx_Credential_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.Credential" */
export enum qx_Credential_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  customerPlaceID = 'customerPlaceID',
  /** column name */
  enabled = 'enabled',
  /** column name */
  extendedTimeEnabled = 'extendedTimeEnabled',
  /** column name */
  externalSync = 'externalSync',
  /** column name */
  id = 'id',
  /** column name */
  legacyDuplicate = 'legacyDuplicate',
  /** column name */
  ossPayload = 'ossPayload',
  /** column name */
  personID = 'personID',
  /** column name */
  pin = 'pin',
  /** column name */
  reason = 'reason',
  /** column name */
  type = 'type',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  validFrom = 'validFrom',
  /** column name */
  validTo = 'validTo',
  /** column name */
  value = 'value'
}

/** select "qx_Credential_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.Credential" */
export enum qx_Credential_select_column_qx_Credential_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  enabled = 'enabled',
  /** column name */
  extendedTimeEnabled = 'extendedTimeEnabled',
  /** column name */
  externalSync = 'externalSync',
  /** column name */
  legacyDuplicate = 'legacyDuplicate'
}

/** select "qx_Credential_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.Credential" */
export enum qx_Credential_select_column_qx_Credential_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  enabled = 'enabled',
  /** column name */
  extendedTimeEnabled = 'extendedTimeEnabled',
  /** column name */
  externalSync = 'externalSync',
  /** column name */
  legacyDuplicate = 'legacyDuplicate'
}

/** input type for updating data in table "qx.Credential" */
export type qx_Credential_set_input = {
  createdAt?: string;
  customerPlaceID?: string;
  enabled?: boolean;
  extendedTimeEnabled?: boolean;
  externalSync?: boolean;
  id?: string;
  legacyDuplicate?: boolean;
  ossPayload?: string;
  personID?: string;
  pin?: string;
  reason?: string;
  type?: qx_eCredentialType_enum;
  updatedAt?: string;
  validFrom?: string;
  validTo?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_Credential" */
export type qx_Credential_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_Credential_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_Credential_stream_cursor_value_input = {
  createdAt?: string;
  customerPlaceID?: string;
  enabled?: boolean;
  extendedTimeEnabled?: boolean;
  externalSync?: boolean;
  id?: string;
  legacyDuplicate?: boolean;
  ossPayload?: string;
  personID?: string;
  pin?: string;
  reason?: string;
  type?: qx_eCredentialType_enum;
  updatedAt?: string;
  validFrom?: string;
  validTo?: string;
  value?: string;
};

/** update columns of table "qx.Credential" */
export enum qx_Credential_update_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  customerPlaceID = 'customerPlaceID',
  /** column name */
  enabled = 'enabled',
  /** column name */
  extendedTimeEnabled = 'extendedTimeEnabled',
  /** column name */
  externalSync = 'externalSync',
  /** column name */
  id = 'id',
  /** column name */
  legacyDuplicate = 'legacyDuplicate',
  /** column name */
  ossPayload = 'ossPayload',
  /** column name */
  personID = 'personID',
  /** column name */
  pin = 'pin',
  /** column name */
  reason = 'reason',
  /** column name */
  type = 'type',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  validFrom = 'validFrom',
  /** column name */
  validTo = 'validTo',
  /** column name */
  value = 'value'
}

export type qx_Credential_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_Credential_set_input;
  /** filter the rows which have to be updated */
  where: qx_Credential_bool_exp;
};

/** columns and relationships of "qx.CustomerAuthProvider" */
export type qx_CustomerAuthProvider = {
  __typename?: 'qx_CustomerAuthProvider';
  config?: any;
  credentials?: any;
  customerPlaceID: string;
  error?: string;
  id: string;
  lastSynced?: string;
  /** An object relationship */
  place: qx_Place;
  provider: qx_eAuthProvider_enum;
  sso: boolean;
  sync: boolean;
  syncedByPersonID?: string;
  /** An object relationship */
  syncedSetupBy?: qx_Person;
};


/** columns and relationships of "qx.CustomerAuthProvider" */
export type qx_CustomerAuthProviderconfigArgs = {
  path?: string;
};


/** columns and relationships of "qx.CustomerAuthProvider" */
export type qx_CustomerAuthProvidercredentialsArgs = {
  path?: string;
};

/** aggregated selection of "qx.CustomerAuthProvider" */
export type qx_CustomerAuthProvider_aggregate = {
  __typename?: 'qx_CustomerAuthProvider_aggregate';
  aggregate?: qx_CustomerAuthProvider_aggregate_fields;
  nodes: Array<qx_CustomerAuthProvider>;
};

/** aggregate fields of "qx.CustomerAuthProvider" */
export type qx_CustomerAuthProvider_aggregate_fields = {
  __typename?: 'qx_CustomerAuthProvider_aggregate_fields';
  avg?: qx_CustomerAuthProvider_avg_fields;
  count: number;
  max?: qx_CustomerAuthProvider_max_fields;
  min?: qx_CustomerAuthProvider_min_fields;
  stddev?: qx_CustomerAuthProvider_stddev_fields;
  stddev_pop?: qx_CustomerAuthProvider_stddev_pop_fields;
  stddev_samp?: qx_CustomerAuthProvider_stddev_samp_fields;
  sum?: qx_CustomerAuthProvider_sum_fields;
  var_pop?: qx_CustomerAuthProvider_var_pop_fields;
  var_samp?: qx_CustomerAuthProvider_var_samp_fields;
  variance?: qx_CustomerAuthProvider_variance_fields;
};


/** aggregate fields of "qx.CustomerAuthProvider" */
export type qx_CustomerAuthProvider_aggregate_fieldscountArgs = {
  columns?: Array<qx_CustomerAuthProvider_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type qx_CustomerAuthProvider_append_input = {
  config?: any;
  credentials?: any;
};

/** aggregate avg on columns */
export type qx_CustomerAuthProvider_avg_fields = {
  __typename?: 'qx_CustomerAuthProvider_avg_fields';
  id?: number;
};

/** Boolean expression to filter rows from the table "qx.CustomerAuthProvider". All fields are combined with a logical 'AND'. */
export type qx_CustomerAuthProvider_bool_exp = {
  _and?: Array<qx_CustomerAuthProvider_bool_exp>;
  _not?: qx_CustomerAuthProvider_bool_exp;
  _or?: Array<qx_CustomerAuthProvider_bool_exp>;
  config?: jsonb_comparison_exp;
  credentials?: jsonb_comparison_exp;
  customerPlaceID?: String_comparison_exp;
  error?: String_comparison_exp;
  id?: bigint_comparison_exp;
  lastSynced?: timestamptz_comparison_exp;
  place?: qx_Place_bool_exp;
  provider?: qx_eAuthProvider_enum_comparison_exp;
  sso?: Boolean_comparison_exp;
  sync?: Boolean_comparison_exp;
  syncedByPersonID?: String_comparison_exp;
  syncedSetupBy?: qx_Person_bool_exp;
};

/** unique or primary key constraints on table "qx.CustomerAuthProvider" */
export enum qx_CustomerAuthProvider_constraint {
  /** unique or primary key constraint on columns "customerPlaceID" */
  CustomerAuthProvider_customerPlaceID_key = 'CustomerAuthProvider_customerPlaceID_key',
  /** unique or primary key constraint on columns "id" */
  CustomerAuthProvider_pkey = 'CustomerAuthProvider_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type qx_CustomerAuthProvider_delete_at_path_input = {
  config?: Array<string>;
  credentials?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type qx_CustomerAuthProvider_delete_elem_input = {
  config?: number;
  credentials?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type qx_CustomerAuthProvider_delete_key_input = {
  config?: string;
  credentials?: string;
};

/** input type for incrementing numeric columns in table "qx.CustomerAuthProvider" */
export type qx_CustomerAuthProvider_inc_input = {
  id?: string;
};

/** input type for inserting data into table "qx.CustomerAuthProvider" */
export type qx_CustomerAuthProvider_insert_input = {
  config?: any;
  credentials?: any;
  customerPlaceID?: string;
  error?: string;
  id?: string;
  lastSynced?: string;
  place?: qx_Place_obj_rel_insert_input;
  provider?: qx_eAuthProvider_enum;
  sso?: boolean;
  sync?: boolean;
  syncedByPersonID?: string;
  syncedSetupBy?: qx_Person_obj_rel_insert_input;
};

/** aggregate max on columns */
export type qx_CustomerAuthProvider_max_fields = {
  __typename?: 'qx_CustomerAuthProvider_max_fields';
  customerPlaceID?: string;
  error?: string;
  id?: string;
  lastSynced?: string;
  syncedByPersonID?: string;
};

/** aggregate min on columns */
export type qx_CustomerAuthProvider_min_fields = {
  __typename?: 'qx_CustomerAuthProvider_min_fields';
  customerPlaceID?: string;
  error?: string;
  id?: string;
  lastSynced?: string;
  syncedByPersonID?: string;
};

/** response of any mutation on the table "qx.CustomerAuthProvider" */
export type qx_CustomerAuthProvider_mutation_response = {
  __typename?: 'qx_CustomerAuthProvider_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_CustomerAuthProvider>;
};

/** input type for inserting object relation for remote table "qx.CustomerAuthProvider" */
export type qx_CustomerAuthProvider_obj_rel_insert_input = {
  data: qx_CustomerAuthProvider_insert_input;
  /** upsert condition */
  on_conflict?: qx_CustomerAuthProvider_on_conflict;
};

/** on_conflict condition type for table "qx.CustomerAuthProvider" */
export type qx_CustomerAuthProvider_on_conflict = {
  constraint: qx_CustomerAuthProvider_constraint;
  update_columns?: Array<qx_CustomerAuthProvider_update_column>;
  where?: qx_CustomerAuthProvider_bool_exp;
};

/** Ordering options when selecting data from "qx.CustomerAuthProvider". */
export type qx_CustomerAuthProvider_order_by = {
  config?: order_by;
  credentials?: order_by;
  customerPlaceID?: order_by;
  error?: order_by;
  id?: order_by;
  lastSynced?: order_by;
  place?: qx_Place_order_by;
  provider?: order_by;
  sso?: order_by;
  sync?: order_by;
  syncedByPersonID?: order_by;
  syncedSetupBy?: qx_Person_order_by;
};

/** primary key columns input for table: qx.CustomerAuthProvider */
export type qx_CustomerAuthProvider_pk_columns_input = {
  id: string;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type qx_CustomerAuthProvider_prepend_input = {
  config?: any;
  credentials?: any;
};

/** select columns of table "qx.CustomerAuthProvider" */
export enum qx_CustomerAuthProvider_select_column {
  /** column name */
  config = 'config',
  /** column name */
  credentials = 'credentials',
  /** column name */
  customerPlaceID = 'customerPlaceID',
  /** column name */
  error = 'error',
  /** column name */
  id = 'id',
  /** column name */
  lastSynced = 'lastSynced',
  /** column name */
  provider = 'provider',
  /** column name */
  sso = 'sso',
  /** column name */
  sync = 'sync',
  /** column name */
  syncedByPersonID = 'syncedByPersonID'
}

/** input type for updating data in table "qx.CustomerAuthProvider" */
export type qx_CustomerAuthProvider_set_input = {
  config?: any;
  credentials?: any;
  customerPlaceID?: string;
  error?: string;
  id?: string;
  lastSynced?: string;
  provider?: qx_eAuthProvider_enum;
  sso?: boolean;
  sync?: boolean;
  syncedByPersonID?: string;
};

/** aggregate stddev on columns */
export type qx_CustomerAuthProvider_stddev_fields = {
  __typename?: 'qx_CustomerAuthProvider_stddev_fields';
  id?: number;
};

/** aggregate stddev_pop on columns */
export type qx_CustomerAuthProvider_stddev_pop_fields = {
  __typename?: 'qx_CustomerAuthProvider_stddev_pop_fields';
  id?: number;
};

/** aggregate stddev_samp on columns */
export type qx_CustomerAuthProvider_stddev_samp_fields = {
  __typename?: 'qx_CustomerAuthProvider_stddev_samp_fields';
  id?: number;
};

/** Streaming cursor of the table "qx_CustomerAuthProvider" */
export type qx_CustomerAuthProvider_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_CustomerAuthProvider_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_CustomerAuthProvider_stream_cursor_value_input = {
  config?: any;
  credentials?: any;
  customerPlaceID?: string;
  error?: string;
  id?: string;
  lastSynced?: string;
  provider?: qx_eAuthProvider_enum;
  sso?: boolean;
  sync?: boolean;
  syncedByPersonID?: string;
};

/** aggregate sum on columns */
export type qx_CustomerAuthProvider_sum_fields = {
  __typename?: 'qx_CustomerAuthProvider_sum_fields';
  id?: string;
};

/** update columns of table "qx.CustomerAuthProvider" */
export enum qx_CustomerAuthProvider_update_column {
  /** column name */
  config = 'config',
  /** column name */
  credentials = 'credentials',
  /** column name */
  customerPlaceID = 'customerPlaceID',
  /** column name */
  error = 'error',
  /** column name */
  id = 'id',
  /** column name */
  lastSynced = 'lastSynced',
  /** column name */
  provider = 'provider',
  /** column name */
  sso = 'sso',
  /** column name */
  sync = 'sync',
  /** column name */
  syncedByPersonID = 'syncedByPersonID'
}

export type qx_CustomerAuthProvider_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: qx_CustomerAuthProvider_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: qx_CustomerAuthProvider_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: qx_CustomerAuthProvider_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: qx_CustomerAuthProvider_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_CustomerAuthProvider_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: qx_CustomerAuthProvider_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_CustomerAuthProvider_set_input;
  /** filter the rows which have to be updated */
  where: qx_CustomerAuthProvider_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_CustomerAuthProvider_var_pop_fields = {
  __typename?: 'qx_CustomerAuthProvider_var_pop_fields';
  id?: number;
};

/** aggregate var_samp on columns */
export type qx_CustomerAuthProvider_var_samp_fields = {
  __typename?: 'qx_CustomerAuthProvider_var_samp_fields';
  id?: number;
};

/** aggregate variance on columns */
export type qx_CustomerAuthProvider_variance_fields = {
  __typename?: 'qx_CustomerAuthProvider_variance_fields';
  id?: number;
};

/** columns and relationships of "qx.CustomerPermission" */
export type qx_CustomerPermission = {
  __typename?: 'qx_CustomerPermission';
  allowIntegratorAccessOperations?: boolean;
  allowIntegratorConfig: boolean;
  allowIntegratorVideoOperations: boolean;
  allowQxSupport: boolean;
  canEnableServices?: boolean;
  /** An object relationship */
  customerPlace: qx_Place;
  customerPlaceID: string;
};

/** aggregated selection of "qx.CustomerPermission" */
export type qx_CustomerPermission_aggregate = {
  __typename?: 'qx_CustomerPermission_aggregate';
  aggregate?: qx_CustomerPermission_aggregate_fields;
  nodes: Array<qx_CustomerPermission>;
};

/** aggregate fields of "qx.CustomerPermission" */
export type qx_CustomerPermission_aggregate_fields = {
  __typename?: 'qx_CustomerPermission_aggregate_fields';
  count: number;
  max?: qx_CustomerPermission_max_fields;
  min?: qx_CustomerPermission_min_fields;
};


/** aggregate fields of "qx.CustomerPermission" */
export type qx_CustomerPermission_aggregate_fieldscountArgs = {
  columns?: Array<qx_CustomerPermission_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.CustomerPermission". All fields are combined with a logical 'AND'. */
export type qx_CustomerPermission_bool_exp = {
  _and?: Array<qx_CustomerPermission_bool_exp>;
  _not?: qx_CustomerPermission_bool_exp;
  _or?: Array<qx_CustomerPermission_bool_exp>;
  allowIntegratorAccessOperations?: Boolean_comparison_exp;
  allowIntegratorConfig?: Boolean_comparison_exp;
  allowIntegratorVideoOperations?: Boolean_comparison_exp;
  allowQxSupport?: Boolean_comparison_exp;
  canEnableServices?: Boolean_comparison_exp;
  customerPlace?: qx_Place_bool_exp;
  customerPlaceID?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.CustomerPermission" */
export enum qx_CustomerPermission_constraint {
  /** unique or primary key constraint on columns "customerPlaceID" */
  CustomerPermission_pkey = 'CustomerPermission_pkey',
  /** unique or primary key constraint on columns "customerPlaceID" */
  CustomerSelfServiceAuthorization_customerPlaceID_key = 'CustomerSelfServiceAuthorization_customerPlaceID_key'
}

/** input type for inserting data into table "qx.CustomerPermission" */
export type qx_CustomerPermission_insert_input = {
  allowIntegratorAccessOperations?: boolean;
  allowIntegratorConfig?: boolean;
  allowIntegratorVideoOperations?: boolean;
  allowQxSupport?: boolean;
  canEnableServices?: boolean;
  customerPlace?: qx_Place_obj_rel_insert_input;
  customerPlaceID?: string;
};

/** aggregate max on columns */
export type qx_CustomerPermission_max_fields = {
  __typename?: 'qx_CustomerPermission_max_fields';
  customerPlaceID?: string;
};

/** aggregate min on columns */
export type qx_CustomerPermission_min_fields = {
  __typename?: 'qx_CustomerPermission_min_fields';
  customerPlaceID?: string;
};

/** response of any mutation on the table "qx.CustomerPermission" */
export type qx_CustomerPermission_mutation_response = {
  __typename?: 'qx_CustomerPermission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_CustomerPermission>;
};

/** input type for inserting object relation for remote table "qx.CustomerPermission" */
export type qx_CustomerPermission_obj_rel_insert_input = {
  data: qx_CustomerPermission_insert_input;
  /** upsert condition */
  on_conflict?: qx_CustomerPermission_on_conflict;
};

/** on_conflict condition type for table "qx.CustomerPermission" */
export type qx_CustomerPermission_on_conflict = {
  constraint: qx_CustomerPermission_constraint;
  update_columns?: Array<qx_CustomerPermission_update_column>;
  where?: qx_CustomerPermission_bool_exp;
};

/** Ordering options when selecting data from "qx.CustomerPermission". */
export type qx_CustomerPermission_order_by = {
  allowIntegratorAccessOperations?: order_by;
  allowIntegratorConfig?: order_by;
  allowIntegratorVideoOperations?: order_by;
  allowQxSupport?: order_by;
  canEnableServices?: order_by;
  customerPlace?: qx_Place_order_by;
  customerPlaceID?: order_by;
};

/** primary key columns input for table: qx.CustomerPermission */
export type qx_CustomerPermission_pk_columns_input = {
  customerPlaceID: string;
};

/** select columns of table "qx.CustomerPermission" */
export enum qx_CustomerPermission_select_column {
  /** column name */
  allowIntegratorAccessOperations = 'allowIntegratorAccessOperations',
  /** column name */
  allowIntegratorConfig = 'allowIntegratorConfig',
  /** column name */
  allowIntegratorVideoOperations = 'allowIntegratorVideoOperations',
  /** column name */
  allowQxSupport = 'allowQxSupport',
  /** column name */
  canEnableServices = 'canEnableServices',
  /** column name */
  customerPlaceID = 'customerPlaceID'
}

/** input type for updating data in table "qx.CustomerPermission" */
export type qx_CustomerPermission_set_input = {
  allowIntegratorAccessOperations?: boolean;
  allowIntegratorConfig?: boolean;
  allowIntegratorVideoOperations?: boolean;
  allowQxSupport?: boolean;
  canEnableServices?: boolean;
  customerPlaceID?: string;
};

/** Streaming cursor of the table "qx_CustomerPermission" */
export type qx_CustomerPermission_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_CustomerPermission_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_CustomerPermission_stream_cursor_value_input = {
  allowIntegratorAccessOperations?: boolean;
  allowIntegratorConfig?: boolean;
  allowIntegratorVideoOperations?: boolean;
  allowQxSupport?: boolean;
  canEnableServices?: boolean;
  customerPlaceID?: string;
};

/** update columns of table "qx.CustomerPermission" */
export enum qx_CustomerPermission_update_column {
  /** column name */
  allowIntegratorAccessOperations = 'allowIntegratorAccessOperations',
  /** column name */
  allowIntegratorConfig = 'allowIntegratorConfig',
  /** column name */
  allowIntegratorVideoOperations = 'allowIntegratorVideoOperations',
  /** column name */
  allowQxSupport = 'allowQxSupport',
  /** column name */
  canEnableServices = 'canEnableServices',
  /** column name */
  customerPlaceID = 'customerPlaceID'
}

export type qx_CustomerPermission_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_CustomerPermission_set_input;
  /** filter the rows which have to be updated */
  where: qx_CustomerPermission_bool_exp;
};

/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_Device = {
  __typename?: 'qx_Device';
  /** An array relationship */
  DeviceDIOs: Array<qx_DeviceDIO>;
  /** An aggregate relationship */
  DeviceDIOs_aggregate: qx_DeviceDIO_aggregate;
  /** An object relationship */
  DoorTemplate?: qx_DoorTemplate;
  /** An array relationship */
  InputPoints: Array<qx_InputPoint>;
  /** An aggregate relationship */
  InputPoints_aggregate: qx_InputPoint_aggregate;
  /** An array relationship */
  IntrusionPartitions: Array<IntrusionPartition>;
  /** An aggregate relationship */
  IntrusionPartitions_aggregate: IntrusionPartition_aggregate;
  /** An array relationship */
  IntrusionZones: Array<IntrusionZone>;
  /** An aggregate relationship */
  IntrusionZones_aggregate: IntrusionZone_aggregate;
  /** An array relationship */
  Locks: Array<qx_Lock>;
  /** An aggregate relationship */
  Locks_aggregate: qx_Lock_aggregate;
  /** An array relationship */
  MercuryInventories: Array<qx_AccessInventory>;
  /** An aggregate relationship */
  MercuryInventories_aggregate: qx_AccessInventory_aggregate;
  /** An array relationship */
  OutputPoints: Array<qx_OutputPoint>;
  /** An aggregate relationship */
  OutputPoints_aggregate: qx_OutputPoint_aggregate;
  address: string;
  /** An array relationship */
  audioSources: Array<qx_AudioSource>;
  /** An aggregate relationship */
  audioSources_aggregate: qx_AudioSource_aggregate;
  connectionStatus: qx_eDeviceConnectionStatus_enum;
  createdAt: string;
  description?: string;
  /** A computed field, executes function "qx.get_device_address" */
  deviceAddress?: string;
  /** An array relationship */
  deviceAnalyticSources: Array<deviceAnalyticSource>;
  /** An aggregate relationship */
  deviceAnalyticSources_aggregate: deviceAnalyticSource_aggregate;
  /** A computed field, executes function "qx.get_device_mac" */
  deviceMac?: string;
  /** A computed field, executes function "qx.get_device_password" */
  devicePassword?: string;
  /** An object relationship */
  devicePlace?: qx_vDevicePlace;
  /** A computed field, executes function "qx.get_device_username" */
  deviceUsername?: string;
  disabledByLicense: boolean;
  /** An array relationship */
  doors: Array<qx_Door>;
  /** An aggregate relationship */
  doors_aggregate: qx_Door_aggregate;
  /** An array relationship */
  dscConnections: Array<DSCConnection>;
  /** An aggregate relationship */
  dscConnections_aggregate: DSCConnection_aggregate;
  dst?: boolean;
  dynamicDNSServers?: any;
  dynamicNTPServers?: any;
  enabled: boolean;
  /** An array relationship */
  events: Array<qx_Event>;
  /** An aggregate relationship */
  events_aggregate: qx_Event_aggregate;
  firmware?: string;
  /** An object relationship */
  gateway: qx_Gateway;
  gatewayID: string;
  hostname?: string;
  id: string;
  kind: qx_eDeviceKind_enum;
  mac?: string;
  make?: string;
  /** An array relationship */
  mediaProfiles: Array<qx_MediaProfile>;
  /** An aggregate relationship */
  mediaProfiles_aggregate: qx_MediaProfile_aggregate;
  meta?: any;
  model?: string;
  name: string;
  newestMedia?: Array<qx_vNewestMedia>;
  ntp?: boolean;
  /** A computed field, executes function "qx.device_oldest_media" */
  oldestMedia?: Array<qx_vOldestMedia>;
  pacsBlob: string;
  pacsConfigurationID?: string;
  pacsHWUpdate: qx_ePACSStatus_enum;
  pacsStatus: qx_ePACSStatus_enum;
  pacsUpdate: string;
  pacsUpdateTime: string;
  password: string;
  port: number;
  /** An array relationship */
  privileges: Array<personDeviceAppPrivileges>;
  /** An aggregate relationship */
  privileges_aggregate: personDeviceAppPrivileges_aggregate;
  profileMSupported?: boolean;
  proxyUrl?: string;
  /** An object relationship */
  rosslareConnection?: qx_RosslareConnection;
  searchText?: string;
  /** An array relationship */
  sensors: Array<qx_Sensor>;
  /** An aggregate relationship */
  sensors_aggregate: qx_Sensor_aggregate;
  serial?: string;
  staticDNSServers?: any;
  staticNTPServers?: any;
  timezone?: string;
  tls: boolean;
  /** An object relationship */
  toConnectionStatus: qx_eDeviceConnectionStatus;
  /** An object relationship */
  toKind: qx_eDeviceKind;
  /** An object relationship */
  toPACSHWStatus: qx_ePACSStatus;
  /** An object relationship */
  toPACSStatus: qx_ePACSStatus;
  updatedAt?: string;
  username: string;
  /** An array relationship */
  videoSources: Array<qx_VideoSource>;
  /** An aggregate relationship */
  videoSources_aggregate: qx_VideoSource_aggregate;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DeviceDeviceDIOsArgs = {
  distinct_on?: Array<qx_DeviceDIO_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DeviceDIO_order_by>;
  where?: qx_DeviceDIO_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DeviceDeviceDIOs_aggregateArgs = {
  distinct_on?: Array<qx_DeviceDIO_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DeviceDIO_order_by>;
  where?: qx_DeviceDIO_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DeviceInputPointsArgs = {
  distinct_on?: Array<qx_InputPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_InputPoint_order_by>;
  where?: qx_InputPoint_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DeviceInputPoints_aggregateArgs = {
  distinct_on?: Array<qx_InputPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_InputPoint_order_by>;
  where?: qx_InputPoint_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DeviceIntrusionPartitionsArgs = {
  distinct_on?: Array<IntrusionPartition_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<IntrusionPartition_order_by>;
  where?: IntrusionPartition_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DeviceIntrusionPartitions_aggregateArgs = {
  distinct_on?: Array<IntrusionPartition_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<IntrusionPartition_order_by>;
  where?: IntrusionPartition_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DeviceIntrusionZonesArgs = {
  distinct_on?: Array<IntrusionZone_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<IntrusionZone_order_by>;
  where?: IntrusionZone_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DeviceIntrusionZones_aggregateArgs = {
  distinct_on?: Array<IntrusionZone_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<IntrusionZone_order_by>;
  where?: IntrusionZone_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DeviceLocksArgs = {
  distinct_on?: Array<qx_Lock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Lock_order_by>;
  where?: qx_Lock_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DeviceLocks_aggregateArgs = {
  distinct_on?: Array<qx_Lock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Lock_order_by>;
  where?: qx_Lock_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DeviceMercuryInventoriesArgs = {
  distinct_on?: Array<qx_AccessInventory_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessInventory_order_by>;
  where?: qx_AccessInventory_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DeviceMercuryInventories_aggregateArgs = {
  distinct_on?: Array<qx_AccessInventory_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessInventory_order_by>;
  where?: qx_AccessInventory_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DeviceOutputPointsArgs = {
  distinct_on?: Array<qx_OutputPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_OutputPoint_order_by>;
  where?: qx_OutputPoint_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DeviceOutputPoints_aggregateArgs = {
  distinct_on?: Array<qx_OutputPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_OutputPoint_order_by>;
  where?: qx_OutputPoint_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DeviceaudioSourcesArgs = {
  distinct_on?: Array<qx_AudioSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AudioSource_order_by>;
  where?: qx_AudioSource_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DeviceaudioSources_aggregateArgs = {
  distinct_on?: Array<qx_AudioSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AudioSource_order_by>;
  where?: qx_AudioSource_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DevicedeviceAnalyticSourcesArgs = {
  distinct_on?: Array<deviceAnalyticSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<deviceAnalyticSource_order_by>;
  where?: deviceAnalyticSource_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DevicedeviceAnalyticSources_aggregateArgs = {
  distinct_on?: Array<deviceAnalyticSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<deviceAnalyticSource_order_by>;
  where?: deviceAnalyticSource_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DevicedoorsArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_Devicedoors_aggregateArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DevicedscConnectionsArgs = {
  distinct_on?: Array<DSCConnection_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<DSCConnection_order_by>;
  where?: DSCConnection_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DevicedscConnections_aggregateArgs = {
  distinct_on?: Array<DSCConnection_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<DSCConnection_order_by>;
  where?: DSCConnection_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DevicedynamicDNSServersArgs = {
  path?: string;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DevicedynamicNTPServersArgs = {
  path?: string;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DeviceeventsArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_Deviceevents_aggregateArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DevicemediaProfilesArgs = {
  distinct_on?: Array<qx_MediaProfile_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MediaProfile_order_by>;
  where?: qx_MediaProfile_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DevicemediaProfiles_aggregateArgs = {
  distinct_on?: Array<qx_MediaProfile_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MediaProfile_order_by>;
  where?: qx_MediaProfile_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DevicemetaArgs = {
  path?: string;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DevicenewestMediaArgs = {
  distinct_on?: Array<qx_vNewestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vNewestMedia_order_by>;
  where?: qx_vNewestMedia_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DeviceoldestMediaArgs = {
  distinct_on?: Array<qx_vOldestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vOldestMedia_order_by>;
  where?: qx_vOldestMedia_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DeviceprivilegesArgs = {
  distinct_on?: Array<personDeviceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personDeviceAppPrivileges_order_by>;
  where?: personDeviceAppPrivileges_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_Deviceprivileges_aggregateArgs = {
  distinct_on?: Array<personDeviceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personDeviceAppPrivileges_order_by>;
  where?: personDeviceAppPrivileges_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DevicesensorsArgs = {
  distinct_on?: Array<qx_Sensor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Sensor_order_by>;
  where?: qx_Sensor_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_Devicesensors_aggregateArgs = {
  distinct_on?: Array<qx_Sensor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Sensor_order_by>;
  where?: qx_Sensor_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DevicestaticDNSServersArgs = {
  path?: string;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DevicestaticNTPServersArgs = {
  path?: string;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DevicevideoSourcesArgs = {
  distinct_on?: Array<qx_VideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_VideoSource_order_by>;
  where?: qx_VideoSource_bool_exp;
};


/** physical hardware device (camera, access control board, sensor unit) managed by a gateway */
export type qx_DevicevideoSources_aggregateArgs = {
  distinct_on?: Array<qx_VideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_VideoSource_order_by>;
  where?: qx_VideoSource_bool_exp;
};

/** digital input or output channel on a device, linking to a door, lock, or reader for monitoring and control */
export type qx_DeviceDIO = {
  __typename?: 'qx_DeviceDIO';
  /** An object relationship */
  Device: qx_Device;
  /** An object relationship */
  Door?: qx_Door;
  /** An array relationship */
  InputPoints: Array<qx_InputPoint>;
  /** An aggregate relationship */
  InputPoints_aggregate: qx_InputPoint_aggregate;
  /** An object relationship */
  Lock?: qx_Lock;
  /** An array relationship */
  OutputPoints: Array<qx_OutputPoint>;
  /** An aggregate relationship */
  OutputPoints_aggregate: qx_OutputPoint_aggregate;
  /** An object relationship */
  Reader?: qx_Reader;
  /** An object relationship */
  accessInventory?: qx_AccessInventory;
  defaultState?: qx_eDIONormalState_enum;
  deviceID: string;
  doorID?: string;
  /** An object relationship */
  eDIONormalState?: qx_eDIONormalState;
  /** An object relationship */
  eDIOState?: qx_eDIOState;
  /** An object relationship */
  eDIOType?: qx_eDIOType;
  /** An object relationship */
  eSuperviseInputs: qx_eSuperviseInputs;
  enabled: boolean;
  id: string;
  inventoryID?: string;
  lockID?: string;
  name: string;
  readerID?: string;
  refID: string;
  state?: qx_eDIOState_enum;
  superviseInput: qx_eSuperviseInputs_enum;
  type?: qx_eDIOType_enum;
  updatedAt?: string;
};


/** digital input or output channel on a device, linking to a door, lock, or reader for monitoring and control */
export type qx_DeviceDIOInputPointsArgs = {
  distinct_on?: Array<qx_InputPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_InputPoint_order_by>;
  where?: qx_InputPoint_bool_exp;
};


/** digital input or output channel on a device, linking to a door, lock, or reader for monitoring and control */
export type qx_DeviceDIOInputPoints_aggregateArgs = {
  distinct_on?: Array<qx_InputPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_InputPoint_order_by>;
  where?: qx_InputPoint_bool_exp;
};


/** digital input or output channel on a device, linking to a door, lock, or reader for monitoring and control */
export type qx_DeviceDIOOutputPointsArgs = {
  distinct_on?: Array<qx_OutputPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_OutputPoint_order_by>;
  where?: qx_OutputPoint_bool_exp;
};


/** digital input or output channel on a device, linking to a door, lock, or reader for monitoring and control */
export type qx_DeviceDIOOutputPoints_aggregateArgs = {
  distinct_on?: Array<qx_OutputPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_OutputPoint_order_by>;
  where?: qx_OutputPoint_bool_exp;
};

/** aggregated selection of "qx.DeviceDIO" */
export type qx_DeviceDIO_aggregate = {
  __typename?: 'qx_DeviceDIO_aggregate';
  aggregate?: qx_DeviceDIO_aggregate_fields;
  nodes: Array<qx_DeviceDIO>;
};

export type qx_DeviceDIO_aggregate_bool_exp = {
  bool_and?: qx_DeviceDIO_aggregate_bool_exp_bool_and;
  bool_or?: qx_DeviceDIO_aggregate_bool_exp_bool_or;
  count?: qx_DeviceDIO_aggregate_bool_exp_count;
};

export type qx_DeviceDIO_aggregate_bool_exp_bool_and = {
  arguments: qx_DeviceDIO_select_column_qx_DeviceDIO_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: qx_DeviceDIO_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_DeviceDIO_aggregate_bool_exp_bool_or = {
  arguments: qx_DeviceDIO_select_column_qx_DeviceDIO_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: qx_DeviceDIO_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_DeviceDIO_aggregate_bool_exp_count = {
  arguments?: Array<qx_DeviceDIO_select_column>;
  distinct?: boolean;
  filter?: qx_DeviceDIO_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.DeviceDIO" */
export type qx_DeviceDIO_aggregate_fields = {
  __typename?: 'qx_DeviceDIO_aggregate_fields';
  avg?: qx_DeviceDIO_avg_fields;
  count: number;
  max?: qx_DeviceDIO_max_fields;
  min?: qx_DeviceDIO_min_fields;
  stddev?: qx_DeviceDIO_stddev_fields;
  stddev_pop?: qx_DeviceDIO_stddev_pop_fields;
  stddev_samp?: qx_DeviceDIO_stddev_samp_fields;
  sum?: qx_DeviceDIO_sum_fields;
  var_pop?: qx_DeviceDIO_var_pop_fields;
  var_samp?: qx_DeviceDIO_var_samp_fields;
  variance?: qx_DeviceDIO_variance_fields;
};


/** aggregate fields of "qx.DeviceDIO" */
export type qx_DeviceDIO_aggregate_fieldscountArgs = {
  columns?: Array<qx_DeviceDIO_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.DeviceDIO" */
export type qx_DeviceDIO_aggregate_order_by = {
  avg?: qx_DeviceDIO_avg_order_by;
  count?: order_by;
  max?: qx_DeviceDIO_max_order_by;
  min?: qx_DeviceDIO_min_order_by;
  stddev?: qx_DeviceDIO_stddev_order_by;
  stddev_pop?: qx_DeviceDIO_stddev_pop_order_by;
  stddev_samp?: qx_DeviceDIO_stddev_samp_order_by;
  sum?: qx_DeviceDIO_sum_order_by;
  var_pop?: qx_DeviceDIO_var_pop_order_by;
  var_samp?: qx_DeviceDIO_var_samp_order_by;
  variance?: qx_DeviceDIO_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.DeviceDIO" */
export type qx_DeviceDIO_arr_rel_insert_input = {
  data: Array<qx_DeviceDIO_insert_input>;
  /** upsert condition */
  on_conflict?: qx_DeviceDIO_on_conflict;
};

/** aggregate avg on columns */
export type qx_DeviceDIO_avg_fields = {
  __typename?: 'qx_DeviceDIO_avg_fields';
  doorID?: number;
};

/** order by avg() on columns of table "qx.DeviceDIO" */
export type qx_DeviceDIO_avg_order_by = {
  doorID?: order_by;
};

/** Boolean expression to filter rows from the table "qx.DeviceDIO". All fields are combined with a logical 'AND'. */
export type qx_DeviceDIO_bool_exp = {
  Device?: qx_Device_bool_exp;
  Door?: qx_Door_bool_exp;
  InputPoints?: qx_InputPoint_bool_exp;
  InputPoints_aggregate?: qx_InputPoint_aggregate_bool_exp;
  Lock?: qx_Lock_bool_exp;
  OutputPoints?: qx_OutputPoint_bool_exp;
  OutputPoints_aggregate?: qx_OutputPoint_aggregate_bool_exp;
  Reader?: qx_Reader_bool_exp;
  _and?: Array<qx_DeviceDIO_bool_exp>;
  _not?: qx_DeviceDIO_bool_exp;
  _or?: Array<qx_DeviceDIO_bool_exp>;
  accessInventory?: qx_AccessInventory_bool_exp;
  defaultState?: qx_eDIONormalState_enum_comparison_exp;
  deviceID?: String_comparison_exp;
  doorID?: bigint_comparison_exp;
  eDIONormalState?: qx_eDIONormalState_bool_exp;
  eDIOState?: qx_eDIOState_bool_exp;
  eDIOType?: qx_eDIOType_bool_exp;
  eSuperviseInputs?: qx_eSuperviseInputs_bool_exp;
  enabled?: Boolean_comparison_exp;
  id?: String_comparison_exp;
  inventoryID?: String_comparison_exp;
  lockID?: String_comparison_exp;
  name?: String_comparison_exp;
  readerID?: String_comparison_exp;
  refID?: String_comparison_exp;
  state?: qx_eDIOState_enum_comparison_exp;
  superviseInput?: qx_eSuperviseInputs_enum_comparison_exp;
  type?: qx_eDIOType_enum_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
};

/** unique or primary key constraints on table "qx.DeviceDIO" */
export enum qx_DeviceDIO_constraint {
  /** unique or primary key constraint on columns "refID", "deviceID" */
  DeviceDIO_deviceID_refID_constraint = 'DeviceDIO_deviceID_refID_constraint',
  /** unique or primary key constraint on columns "id" */
  DeviceDIO_pkey = 'DeviceDIO_pkey'
}

/** input type for incrementing numeric columns in table "qx.DeviceDIO" */
export type qx_DeviceDIO_inc_input = {
  doorID?: string;
};

/** input type for inserting data into table "qx.DeviceDIO" */
export type qx_DeviceDIO_insert_input = {
  Device?: qx_Device_obj_rel_insert_input;
  Door?: qx_Door_obj_rel_insert_input;
  InputPoints?: qx_InputPoint_arr_rel_insert_input;
  Lock?: qx_Lock_obj_rel_insert_input;
  OutputPoints?: qx_OutputPoint_arr_rel_insert_input;
  Reader?: qx_Reader_obj_rel_insert_input;
  accessInventory?: qx_AccessInventory_obj_rel_insert_input;
  defaultState?: qx_eDIONormalState_enum;
  deviceID?: string;
  doorID?: string;
  eDIONormalState?: qx_eDIONormalState_obj_rel_insert_input;
  eDIOState?: qx_eDIOState_obj_rel_insert_input;
  eDIOType?: qx_eDIOType_obj_rel_insert_input;
  eSuperviseInputs?: qx_eSuperviseInputs_obj_rel_insert_input;
  enabled?: boolean;
  id?: string;
  inventoryID?: string;
  lockID?: string;
  name?: string;
  readerID?: string;
  refID?: string;
  state?: qx_eDIOState_enum;
  superviseInput?: qx_eSuperviseInputs_enum;
  type?: qx_eDIOType_enum;
  updatedAt?: string;
};

/** aggregate max on columns */
export type qx_DeviceDIO_max_fields = {
  __typename?: 'qx_DeviceDIO_max_fields';
  deviceID?: string;
  doorID?: string;
  id?: string;
  inventoryID?: string;
  lockID?: string;
  name?: string;
  readerID?: string;
  refID?: string;
  updatedAt?: string;
};

/** order by max() on columns of table "qx.DeviceDIO" */
export type qx_DeviceDIO_max_order_by = {
  deviceID?: order_by;
  doorID?: order_by;
  id?: order_by;
  inventoryID?: order_by;
  lockID?: order_by;
  name?: order_by;
  readerID?: order_by;
  refID?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type qx_DeviceDIO_min_fields = {
  __typename?: 'qx_DeviceDIO_min_fields';
  deviceID?: string;
  doorID?: string;
  id?: string;
  inventoryID?: string;
  lockID?: string;
  name?: string;
  readerID?: string;
  refID?: string;
  updatedAt?: string;
};

/** order by min() on columns of table "qx.DeviceDIO" */
export type qx_DeviceDIO_min_order_by = {
  deviceID?: order_by;
  doorID?: order_by;
  id?: order_by;
  inventoryID?: order_by;
  lockID?: order_by;
  name?: order_by;
  readerID?: order_by;
  refID?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.DeviceDIO" */
export type qx_DeviceDIO_mutation_response = {
  __typename?: 'qx_DeviceDIO_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_DeviceDIO>;
};

/** input type for inserting object relation for remote table "qx.DeviceDIO" */
export type qx_DeviceDIO_obj_rel_insert_input = {
  data: qx_DeviceDIO_insert_input;
  /** upsert condition */
  on_conflict?: qx_DeviceDIO_on_conflict;
};

/** on_conflict condition type for table "qx.DeviceDIO" */
export type qx_DeviceDIO_on_conflict = {
  constraint: qx_DeviceDIO_constraint;
  update_columns?: Array<qx_DeviceDIO_update_column>;
  where?: qx_DeviceDIO_bool_exp;
};

/** Ordering options when selecting data from "qx.DeviceDIO". */
export type qx_DeviceDIO_order_by = {
  Device?: qx_Device_order_by;
  Door?: qx_Door_order_by;
  InputPoints_aggregate?: qx_InputPoint_aggregate_order_by;
  Lock?: qx_Lock_order_by;
  OutputPoints_aggregate?: qx_OutputPoint_aggregate_order_by;
  Reader?: qx_Reader_order_by;
  accessInventory?: qx_AccessInventory_order_by;
  defaultState?: order_by;
  deviceID?: order_by;
  doorID?: order_by;
  eDIONormalState?: qx_eDIONormalState_order_by;
  eDIOState?: qx_eDIOState_order_by;
  eDIOType?: qx_eDIOType_order_by;
  eSuperviseInputs?: qx_eSuperviseInputs_order_by;
  enabled?: order_by;
  id?: order_by;
  inventoryID?: order_by;
  lockID?: order_by;
  name?: order_by;
  readerID?: order_by;
  refID?: order_by;
  state?: order_by;
  superviseInput?: order_by;
  type?: order_by;
  updatedAt?: order_by;
};

/** primary key columns input for table: qx.DeviceDIO */
export type qx_DeviceDIO_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.DeviceDIO" */
export enum qx_DeviceDIO_select_column {
  /** column name */
  defaultState = 'defaultState',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  doorID = 'doorID',
  /** column name */
  enabled = 'enabled',
  /** column name */
  id = 'id',
  /** column name */
  inventoryID = 'inventoryID',
  /** column name */
  lockID = 'lockID',
  /** column name */
  name = 'name',
  /** column name */
  readerID = 'readerID',
  /** column name */
  refID = 'refID',
  /** column name */
  state = 'state',
  /** column name */
  superviseInput = 'superviseInput',
  /** column name */
  type = 'type',
  /** column name */
  updatedAt = 'updatedAt'
}

/** select "qx_DeviceDIO_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.DeviceDIO" */
export enum qx_DeviceDIO_select_column_qx_DeviceDIO_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  enabled = 'enabled'
}

/** select "qx_DeviceDIO_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.DeviceDIO" */
export enum qx_DeviceDIO_select_column_qx_DeviceDIO_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  enabled = 'enabled'
}

/** input type for updating data in table "qx.DeviceDIO" */
export type qx_DeviceDIO_set_input = {
  defaultState?: qx_eDIONormalState_enum;
  deviceID?: string;
  doorID?: string;
  enabled?: boolean;
  id?: string;
  inventoryID?: string;
  lockID?: string;
  name?: string;
  readerID?: string;
  refID?: string;
  state?: qx_eDIOState_enum;
  superviseInput?: qx_eSuperviseInputs_enum;
  type?: qx_eDIOType_enum;
  updatedAt?: string;
};

/** aggregate stddev on columns */
export type qx_DeviceDIO_stddev_fields = {
  __typename?: 'qx_DeviceDIO_stddev_fields';
  doorID?: number;
};

/** order by stddev() on columns of table "qx.DeviceDIO" */
export type qx_DeviceDIO_stddev_order_by = {
  doorID?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_DeviceDIO_stddev_pop_fields = {
  __typename?: 'qx_DeviceDIO_stddev_pop_fields';
  doorID?: number;
};

/** order by stddev_pop() on columns of table "qx.DeviceDIO" */
export type qx_DeviceDIO_stddev_pop_order_by = {
  doorID?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_DeviceDIO_stddev_samp_fields = {
  __typename?: 'qx_DeviceDIO_stddev_samp_fields';
  doorID?: number;
};

/** order by stddev_samp() on columns of table "qx.DeviceDIO" */
export type qx_DeviceDIO_stddev_samp_order_by = {
  doorID?: order_by;
};

/** Streaming cursor of the table "qx_DeviceDIO" */
export type qx_DeviceDIO_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_DeviceDIO_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_DeviceDIO_stream_cursor_value_input = {
  defaultState?: qx_eDIONormalState_enum;
  deviceID?: string;
  doorID?: string;
  enabled?: boolean;
  id?: string;
  inventoryID?: string;
  lockID?: string;
  name?: string;
  readerID?: string;
  refID?: string;
  state?: qx_eDIOState_enum;
  superviseInput?: qx_eSuperviseInputs_enum;
  type?: qx_eDIOType_enum;
  updatedAt?: string;
};

/** aggregate sum on columns */
export type qx_DeviceDIO_sum_fields = {
  __typename?: 'qx_DeviceDIO_sum_fields';
  doorID?: string;
};

/** order by sum() on columns of table "qx.DeviceDIO" */
export type qx_DeviceDIO_sum_order_by = {
  doorID?: order_by;
};

/** update columns of table "qx.DeviceDIO" */
export enum qx_DeviceDIO_update_column {
  /** column name */
  defaultState = 'defaultState',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  doorID = 'doorID',
  /** column name */
  enabled = 'enabled',
  /** column name */
  id = 'id',
  /** column name */
  inventoryID = 'inventoryID',
  /** column name */
  lockID = 'lockID',
  /** column name */
  name = 'name',
  /** column name */
  readerID = 'readerID',
  /** column name */
  refID = 'refID',
  /** column name */
  state = 'state',
  /** column name */
  superviseInput = 'superviseInput',
  /** column name */
  type = 'type',
  /** column name */
  updatedAt = 'updatedAt'
}

export type qx_DeviceDIO_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_DeviceDIO_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_DeviceDIO_set_input;
  /** filter the rows which have to be updated */
  where: qx_DeviceDIO_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_DeviceDIO_var_pop_fields = {
  __typename?: 'qx_DeviceDIO_var_pop_fields';
  doorID?: number;
};

/** order by var_pop() on columns of table "qx.DeviceDIO" */
export type qx_DeviceDIO_var_pop_order_by = {
  doorID?: order_by;
};

/** aggregate var_samp on columns */
export type qx_DeviceDIO_var_samp_fields = {
  __typename?: 'qx_DeviceDIO_var_samp_fields';
  doorID?: number;
};

/** order by var_samp() on columns of table "qx.DeviceDIO" */
export type qx_DeviceDIO_var_samp_order_by = {
  doorID?: order_by;
};

/** aggregate variance on columns */
export type qx_DeviceDIO_variance_fields = {
  __typename?: 'qx_DeviceDIO_variance_fields';
  doorID?: number;
};

/** order by variance() on columns of table "qx.DeviceDIO" */
export type qx_DeviceDIO_variance_order_by = {
  doorID?: order_by;
};

/** aggregated selection of "qx.Device" */
export type qx_Device_aggregate = {
  __typename?: 'qx_Device_aggregate';
  aggregate?: qx_Device_aggregate_fields;
  nodes: Array<qx_Device>;
};

export type qx_Device_aggregate_bool_exp = {
  bool_and?: qx_Device_aggregate_bool_exp_bool_and;
  bool_or?: qx_Device_aggregate_bool_exp_bool_or;
  count?: qx_Device_aggregate_bool_exp_count;
};

export type qx_Device_aggregate_bool_exp_bool_and = {
  arguments: qx_Device_select_column_qx_Device_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: qx_Device_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_Device_aggregate_bool_exp_bool_or = {
  arguments: qx_Device_select_column_qx_Device_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: qx_Device_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_Device_aggregate_bool_exp_count = {
  arguments?: Array<qx_Device_select_column>;
  distinct?: boolean;
  filter?: qx_Device_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.Device" */
export type qx_Device_aggregate_fields = {
  __typename?: 'qx_Device_aggregate_fields';
  avg?: qx_Device_avg_fields;
  count: number;
  max?: qx_Device_max_fields;
  min?: qx_Device_min_fields;
  stddev?: qx_Device_stddev_fields;
  stddev_pop?: qx_Device_stddev_pop_fields;
  stddev_samp?: qx_Device_stddev_samp_fields;
  sum?: qx_Device_sum_fields;
  var_pop?: qx_Device_var_pop_fields;
  var_samp?: qx_Device_var_samp_fields;
  variance?: qx_Device_variance_fields;
};


/** aggregate fields of "qx.Device" */
export type qx_Device_aggregate_fieldscountArgs = {
  columns?: Array<qx_Device_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.Device" */
export type qx_Device_aggregate_order_by = {
  avg?: qx_Device_avg_order_by;
  count?: order_by;
  max?: qx_Device_max_order_by;
  min?: qx_Device_min_order_by;
  stddev?: qx_Device_stddev_order_by;
  stddev_pop?: qx_Device_stddev_pop_order_by;
  stddev_samp?: qx_Device_stddev_samp_order_by;
  sum?: qx_Device_sum_order_by;
  var_pop?: qx_Device_var_pop_order_by;
  var_samp?: qx_Device_var_samp_order_by;
  variance?: qx_Device_variance_order_by;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type qx_Device_append_input = {
  dynamicDNSServers?: any;
  dynamicNTPServers?: any;
  meta?: any;
  staticDNSServers?: any;
  staticNTPServers?: any;
};

/** input type for inserting array relation for remote table "qx.Device" */
export type qx_Device_arr_rel_insert_input = {
  data: Array<qx_Device_insert_input>;
  /** upsert condition */
  on_conflict?: qx_Device_on_conflict;
};

/** aggregate avg on columns */
export type qx_Device_avg_fields = {
  __typename?: 'qx_Device_avg_fields';
  port?: number;
};

/** order by avg() on columns of table "qx.Device" */
export type qx_Device_avg_order_by = {
  port?: order_by;
};

/** Boolean expression to filter rows from the table "qx.Device". All fields are combined with a logical 'AND'. */
export type qx_Device_bool_exp = {
  DeviceDIOs?: qx_DeviceDIO_bool_exp;
  DeviceDIOs_aggregate?: qx_DeviceDIO_aggregate_bool_exp;
  DoorTemplate?: qx_DoorTemplate_bool_exp;
  InputPoints?: qx_InputPoint_bool_exp;
  InputPoints_aggregate?: qx_InputPoint_aggregate_bool_exp;
  IntrusionPartitions?: IntrusionPartition_bool_exp;
  IntrusionPartitions_aggregate?: IntrusionPartition_aggregate_bool_exp;
  IntrusionZones?: IntrusionZone_bool_exp;
  IntrusionZones_aggregate?: IntrusionZone_aggregate_bool_exp;
  Locks?: qx_Lock_bool_exp;
  Locks_aggregate?: qx_Lock_aggregate_bool_exp;
  MercuryInventories?: qx_AccessInventory_bool_exp;
  MercuryInventories_aggregate?: qx_AccessInventory_aggregate_bool_exp;
  OutputPoints?: qx_OutputPoint_bool_exp;
  OutputPoints_aggregate?: qx_OutputPoint_aggregate_bool_exp;
  _and?: Array<qx_Device_bool_exp>;
  _not?: qx_Device_bool_exp;
  _or?: Array<qx_Device_bool_exp>;
  address?: String_comparison_exp;
  audioSources?: qx_AudioSource_bool_exp;
  audioSources_aggregate?: qx_AudioSource_aggregate_bool_exp;
  connectionStatus?: qx_eDeviceConnectionStatus_enum_comparison_exp;
  createdAt?: timestamptz_comparison_exp;
  description?: String_comparison_exp;
  deviceAddress?: String_comparison_exp;
  deviceAnalyticSources?: deviceAnalyticSource_bool_exp;
  deviceAnalyticSources_aggregate?: deviceAnalyticSource_aggregate_bool_exp;
  deviceMac?: String_comparison_exp;
  devicePassword?: String_comparison_exp;
  devicePlace?: qx_vDevicePlace_bool_exp;
  deviceUsername?: String_comparison_exp;
  disabledByLicense?: Boolean_comparison_exp;
  doors?: qx_Door_bool_exp;
  doors_aggregate?: qx_Door_aggregate_bool_exp;
  dscConnections?: DSCConnection_bool_exp;
  dscConnections_aggregate?: DSCConnection_aggregate_bool_exp;
  dst?: Boolean_comparison_exp;
  dynamicDNSServers?: jsonb_comparison_exp;
  dynamicNTPServers?: jsonb_comparison_exp;
  enabled?: Boolean_comparison_exp;
  events?: qx_Event_bool_exp;
  events_aggregate?: qx_Event_aggregate_bool_exp;
  firmware?: String_comparison_exp;
  gateway?: qx_Gateway_bool_exp;
  gatewayID?: String_comparison_exp;
  hostname?: String_comparison_exp;
  id?: String_comparison_exp;
  kind?: qx_eDeviceKind_enum_comparison_exp;
  mac?: String_comparison_exp;
  make?: String_comparison_exp;
  mediaProfiles?: qx_MediaProfile_bool_exp;
  mediaProfiles_aggregate?: qx_MediaProfile_aggregate_bool_exp;
  meta?: jsonb_comparison_exp;
  model?: String_comparison_exp;
  name?: String_comparison_exp;
  newestMedia?: qx_vNewestMedia_bool_exp;
  ntp?: Boolean_comparison_exp;
  oldestMedia?: qx_vOldestMedia_bool_exp;
  pacsBlob?: String_comparison_exp;
  pacsConfigurationID?: String_comparison_exp;
  pacsHWUpdate?: qx_ePACSStatus_enum_comparison_exp;
  pacsStatus?: qx_ePACSStatus_enum_comparison_exp;
  pacsUpdate?: String_comparison_exp;
  pacsUpdateTime?: timestamptz_comparison_exp;
  password?: String_comparison_exp;
  port?: Int_comparison_exp;
  privileges?: personDeviceAppPrivileges_bool_exp;
  privileges_aggregate?: personDeviceAppPrivileges_aggregate_bool_exp;
  profileMSupported?: Boolean_comparison_exp;
  proxyUrl?: String_comparison_exp;
  rosslareConnection?: qx_RosslareConnection_bool_exp;
  searchText?: String_comparison_exp;
  sensors?: qx_Sensor_bool_exp;
  sensors_aggregate?: qx_Sensor_aggregate_bool_exp;
  serial?: String_comparison_exp;
  staticDNSServers?: jsonb_comparison_exp;
  staticNTPServers?: jsonb_comparison_exp;
  timezone?: String_comparison_exp;
  tls?: Boolean_comparison_exp;
  toConnectionStatus?: qx_eDeviceConnectionStatus_bool_exp;
  toKind?: qx_eDeviceKind_bool_exp;
  toPACSHWStatus?: qx_ePACSStatus_bool_exp;
  toPACSStatus?: qx_ePACSStatus_bool_exp;
  updatedAt?: timestamptz_comparison_exp;
  username?: String_comparison_exp;
  videoSources?: qx_VideoSource_bool_exp;
  videoSources_aggregate?: qx_VideoSource_aggregate_bool_exp;
};

/** unique or primary key constraints on table "qx.Device" */
export enum qx_Device_constraint {
  /** unique or primary key constraint on columns "gatewayID", "address", "port" */
  Device_gatewayID_address_port_key = 'Device_gatewayID_address_port_key',
  /** unique or primary key constraint on columns "id" */
  Device_pkey = 'Device_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type qx_Device_delete_at_path_input = {
  dynamicDNSServers?: Array<string>;
  dynamicNTPServers?: Array<string>;
  meta?: Array<string>;
  staticDNSServers?: Array<string>;
  staticNTPServers?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type qx_Device_delete_elem_input = {
  dynamicDNSServers?: number;
  dynamicNTPServers?: number;
  meta?: number;
  staticDNSServers?: number;
  staticNTPServers?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type qx_Device_delete_key_input = {
  dynamicDNSServers?: string;
  dynamicNTPServers?: string;
  meta?: string;
  staticDNSServers?: string;
  staticNTPServers?: string;
};

/** input type for incrementing numeric columns in table "qx.Device" */
export type qx_Device_inc_input = {
  port?: number;
};

/** input type for inserting data into table "qx.Device" */
export type qx_Device_insert_input = {
  DeviceDIOs?: qx_DeviceDIO_arr_rel_insert_input;
  DoorTemplate?: qx_DoorTemplate_obj_rel_insert_input;
  InputPoints?: qx_InputPoint_arr_rel_insert_input;
  IntrusionPartitions?: IntrusionPartition_arr_rel_insert_input;
  IntrusionZones?: IntrusionZone_arr_rel_insert_input;
  Locks?: qx_Lock_arr_rel_insert_input;
  MercuryInventories?: qx_AccessInventory_arr_rel_insert_input;
  OutputPoints?: qx_OutputPoint_arr_rel_insert_input;
  address?: string;
  audioSources?: qx_AudioSource_arr_rel_insert_input;
  connectionStatus?: qx_eDeviceConnectionStatus_enum;
  createdAt?: string;
  description?: string;
  deviceAnalyticSources?: deviceAnalyticSource_arr_rel_insert_input;
  devicePlace?: qx_vDevicePlace_obj_rel_insert_input;
  disabledByLicense?: boolean;
  doors?: qx_Door_arr_rel_insert_input;
  dscConnections?: DSCConnection_arr_rel_insert_input;
  dst?: boolean;
  dynamicDNSServers?: any;
  dynamicNTPServers?: any;
  enabled?: boolean;
  events?: qx_Event_arr_rel_insert_input;
  firmware?: string;
  gateway?: qx_Gateway_obj_rel_insert_input;
  gatewayID?: string;
  hostname?: string;
  id?: string;
  kind?: qx_eDeviceKind_enum;
  mac?: string;
  make?: string;
  mediaProfiles?: qx_MediaProfile_arr_rel_insert_input;
  meta?: any;
  model?: string;
  name?: string;
  ntp?: boolean;
  pacsBlob?: string;
  pacsConfigurationID?: string;
  pacsHWUpdate?: qx_ePACSStatus_enum;
  pacsStatus?: qx_ePACSStatus_enum;
  pacsUpdate?: string;
  pacsUpdateTime?: string;
  password?: string;
  port?: number;
  privileges?: personDeviceAppPrivileges_arr_rel_insert_input;
  profileMSupported?: boolean;
  rosslareConnection?: qx_RosslareConnection_obj_rel_insert_input;
  searchText?: string;
  sensors?: qx_Sensor_arr_rel_insert_input;
  serial?: string;
  staticDNSServers?: any;
  staticNTPServers?: any;
  timezone?: string;
  tls?: boolean;
  toConnectionStatus?: qx_eDeviceConnectionStatus_obj_rel_insert_input;
  toKind?: qx_eDeviceKind_obj_rel_insert_input;
  toPACSHWStatus?: qx_ePACSStatus_obj_rel_insert_input;
  toPACSStatus?: qx_ePACSStatus_obj_rel_insert_input;
  updatedAt?: string;
  username?: string;
  videoSources?: qx_VideoSource_arr_rel_insert_input;
};

/** aggregate max on columns */
export type qx_Device_max_fields = {
  __typename?: 'qx_Device_max_fields';
  address?: string;
  createdAt?: string;
  description?: string;
  /** A computed field, executes function "qx.get_device_address" */
  deviceAddress?: string;
  /** A computed field, executes function "qx.get_device_mac" */
  deviceMac?: string;
  /** A computed field, executes function "qx.get_device_password" */
  devicePassword?: string;
  /** A computed field, executes function "qx.get_device_username" */
  deviceUsername?: string;
  firmware?: string;
  gatewayID?: string;
  hostname?: string;
  id?: string;
  mac?: string;
  make?: string;
  model?: string;
  name?: string;
  pacsBlob?: string;
  pacsConfigurationID?: string;
  pacsUpdate?: string;
  pacsUpdateTime?: string;
  password?: string;
  port?: number;
  proxyUrl?: string;
  searchText?: string;
  serial?: string;
  timezone?: string;
  updatedAt?: string;
  username?: string;
};

/** order by max() on columns of table "qx.Device" */
export type qx_Device_max_order_by = {
  address?: order_by;
  createdAt?: order_by;
  description?: order_by;
  firmware?: order_by;
  gatewayID?: order_by;
  hostname?: order_by;
  id?: order_by;
  mac?: order_by;
  make?: order_by;
  model?: order_by;
  name?: order_by;
  pacsBlob?: order_by;
  pacsConfigurationID?: order_by;
  pacsUpdate?: order_by;
  pacsUpdateTime?: order_by;
  password?: order_by;
  port?: order_by;
  searchText?: order_by;
  serial?: order_by;
  timezone?: order_by;
  updatedAt?: order_by;
  username?: order_by;
};

/** aggregate min on columns */
export type qx_Device_min_fields = {
  __typename?: 'qx_Device_min_fields';
  address?: string;
  createdAt?: string;
  description?: string;
  /** A computed field, executes function "qx.get_device_address" */
  deviceAddress?: string;
  /** A computed field, executes function "qx.get_device_mac" */
  deviceMac?: string;
  /** A computed field, executes function "qx.get_device_password" */
  devicePassword?: string;
  /** A computed field, executes function "qx.get_device_username" */
  deviceUsername?: string;
  firmware?: string;
  gatewayID?: string;
  hostname?: string;
  id?: string;
  mac?: string;
  make?: string;
  model?: string;
  name?: string;
  pacsBlob?: string;
  pacsConfigurationID?: string;
  pacsUpdate?: string;
  pacsUpdateTime?: string;
  password?: string;
  port?: number;
  proxyUrl?: string;
  searchText?: string;
  serial?: string;
  timezone?: string;
  updatedAt?: string;
  username?: string;
};

/** order by min() on columns of table "qx.Device" */
export type qx_Device_min_order_by = {
  address?: order_by;
  createdAt?: order_by;
  description?: order_by;
  firmware?: order_by;
  gatewayID?: order_by;
  hostname?: order_by;
  id?: order_by;
  mac?: order_by;
  make?: order_by;
  model?: order_by;
  name?: order_by;
  pacsBlob?: order_by;
  pacsConfigurationID?: order_by;
  pacsUpdate?: order_by;
  pacsUpdateTime?: order_by;
  password?: order_by;
  port?: order_by;
  searchText?: order_by;
  serial?: order_by;
  timezone?: order_by;
  updatedAt?: order_by;
  username?: order_by;
};

/** response of any mutation on the table "qx.Device" */
export type qx_Device_mutation_response = {
  __typename?: 'qx_Device_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_Device>;
};

/** input type for inserting object relation for remote table "qx.Device" */
export type qx_Device_obj_rel_insert_input = {
  data: qx_Device_insert_input;
  /** upsert condition */
  on_conflict?: qx_Device_on_conflict;
};

/** on_conflict condition type for table "qx.Device" */
export type qx_Device_on_conflict = {
  constraint: qx_Device_constraint;
  update_columns?: Array<qx_Device_update_column>;
  where?: qx_Device_bool_exp;
};

/** Ordering options when selecting data from "qx.Device". */
export type qx_Device_order_by = {
  DeviceDIOs_aggregate?: qx_DeviceDIO_aggregate_order_by;
  DoorTemplate?: qx_DoorTemplate_order_by;
  InputPoints_aggregate?: qx_InputPoint_aggregate_order_by;
  IntrusionPartitions_aggregate?: IntrusionPartition_aggregate_order_by;
  IntrusionZones_aggregate?: IntrusionZone_aggregate_order_by;
  Locks_aggregate?: qx_Lock_aggregate_order_by;
  MercuryInventories_aggregate?: qx_AccessInventory_aggregate_order_by;
  OutputPoints_aggregate?: qx_OutputPoint_aggregate_order_by;
  address?: order_by;
  audioSources_aggregate?: qx_AudioSource_aggregate_order_by;
  connectionStatus?: order_by;
  createdAt?: order_by;
  description?: order_by;
  deviceAddress?: order_by;
  deviceAnalyticSources_aggregate?: deviceAnalyticSource_aggregate_order_by;
  deviceMac?: order_by;
  devicePassword?: order_by;
  devicePlace?: qx_vDevicePlace_order_by;
  deviceUsername?: order_by;
  disabledByLicense?: order_by;
  doors_aggregate?: qx_Door_aggregate_order_by;
  dscConnections_aggregate?: DSCConnection_aggregate_order_by;
  dst?: order_by;
  dynamicDNSServers?: order_by;
  dynamicNTPServers?: order_by;
  enabled?: order_by;
  events_aggregate?: qx_Event_aggregate_order_by;
  firmware?: order_by;
  gateway?: qx_Gateway_order_by;
  gatewayID?: order_by;
  hostname?: order_by;
  id?: order_by;
  kind?: order_by;
  mac?: order_by;
  make?: order_by;
  mediaProfiles_aggregate?: qx_MediaProfile_aggregate_order_by;
  meta?: order_by;
  model?: order_by;
  name?: order_by;
  newestMedia_aggregate?: qx_vNewestMedia_aggregate_order_by;
  ntp?: order_by;
  oldestMedia_aggregate?: qx_vOldestMedia_aggregate_order_by;
  pacsBlob?: order_by;
  pacsConfigurationID?: order_by;
  pacsHWUpdate?: order_by;
  pacsStatus?: order_by;
  pacsUpdate?: order_by;
  pacsUpdateTime?: order_by;
  password?: order_by;
  port?: order_by;
  privileges_aggregate?: personDeviceAppPrivileges_aggregate_order_by;
  profileMSupported?: order_by;
  proxyUrl?: order_by;
  rosslareConnection?: qx_RosslareConnection_order_by;
  searchText?: order_by;
  sensors_aggregate?: qx_Sensor_aggregate_order_by;
  serial?: order_by;
  staticDNSServers?: order_by;
  staticNTPServers?: order_by;
  timezone?: order_by;
  tls?: order_by;
  toConnectionStatus?: qx_eDeviceConnectionStatus_order_by;
  toKind?: qx_eDeviceKind_order_by;
  toPACSHWStatus?: qx_ePACSStatus_order_by;
  toPACSStatus?: qx_ePACSStatus_order_by;
  updatedAt?: order_by;
  username?: order_by;
  videoSources_aggregate?: qx_VideoSource_aggregate_order_by;
};

/** primary key columns input for table: qx.Device */
export type qx_Device_pk_columns_input = {
  id: string;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type qx_Device_prepend_input = {
  dynamicDNSServers?: any;
  dynamicNTPServers?: any;
  meta?: any;
  staticDNSServers?: any;
  staticNTPServers?: any;
};

/** select columns of table "qx.Device" */
export enum qx_Device_select_column {
  /** column name */
  address = 'address',
  /** column name */
  connectionStatus = 'connectionStatus',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  description = 'description',
  /** column name */
  disabledByLicense = 'disabledByLicense',
  /** column name */
  dst = 'dst',
  /** column name */
  dynamicDNSServers = 'dynamicDNSServers',
  /** column name */
  dynamicNTPServers = 'dynamicNTPServers',
  /** column name */
  enabled = 'enabled',
  /** column name */
  firmware = 'firmware',
  /** column name */
  gatewayID = 'gatewayID',
  /** column name */
  hostname = 'hostname',
  /** column name */
  id = 'id',
  /** column name */
  kind = 'kind',
  /** column name */
  mac = 'mac',
  /** column name */
  make = 'make',
  /** column name */
  meta = 'meta',
  /** column name */
  model = 'model',
  /** column name */
  name = 'name',
  /** column name */
  ntp = 'ntp',
  /** column name */
  pacsBlob = 'pacsBlob',
  /** column name */
  pacsConfigurationID = 'pacsConfigurationID',
  /** column name */
  pacsHWUpdate = 'pacsHWUpdate',
  /** column name */
  pacsStatus = 'pacsStatus',
  /** column name */
  pacsUpdate = 'pacsUpdate',
  /** column name */
  pacsUpdateTime = 'pacsUpdateTime',
  /** column name */
  password = 'password',
  /** column name */
  port = 'port',
  /** column name */
  profileMSupported = 'profileMSupported',
  /** column name */
  searchText = 'searchText',
  /** column name */
  serial = 'serial',
  /** column name */
  staticDNSServers = 'staticDNSServers',
  /** column name */
  staticNTPServers = 'staticNTPServers',
  /** column name */
  timezone = 'timezone',
  /** column name */
  tls = 'tls',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  username = 'username'
}

/** select "qx_Device_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.Device" */
export enum qx_Device_select_column_qx_Device_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  disabledByLicense = 'disabledByLicense',
  /** column name */
  dst = 'dst',
  /** column name */
  enabled = 'enabled',
  /** column name */
  ntp = 'ntp',
  /** column name */
  profileMSupported = 'profileMSupported',
  /** column name */
  tls = 'tls'
}

/** select "qx_Device_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.Device" */
export enum qx_Device_select_column_qx_Device_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  disabledByLicense = 'disabledByLicense',
  /** column name */
  dst = 'dst',
  /** column name */
  enabled = 'enabled',
  /** column name */
  ntp = 'ntp',
  /** column name */
  profileMSupported = 'profileMSupported',
  /** column name */
  tls = 'tls'
}

/** input type for updating data in table "qx.Device" */
export type qx_Device_set_input = {
  address?: string;
  connectionStatus?: qx_eDeviceConnectionStatus_enum;
  createdAt?: string;
  description?: string;
  disabledByLicense?: boolean;
  dst?: boolean;
  dynamicDNSServers?: any;
  dynamicNTPServers?: any;
  enabled?: boolean;
  firmware?: string;
  gatewayID?: string;
  hostname?: string;
  id?: string;
  kind?: qx_eDeviceKind_enum;
  mac?: string;
  make?: string;
  meta?: any;
  model?: string;
  name?: string;
  ntp?: boolean;
  pacsBlob?: string;
  pacsConfigurationID?: string;
  pacsHWUpdate?: qx_ePACSStatus_enum;
  pacsStatus?: qx_ePACSStatus_enum;
  pacsUpdate?: string;
  pacsUpdateTime?: string;
  password?: string;
  port?: number;
  profileMSupported?: boolean;
  searchText?: string;
  serial?: string;
  staticDNSServers?: any;
  staticNTPServers?: any;
  timezone?: string;
  tls?: boolean;
  updatedAt?: string;
  username?: string;
};

/** aggregate stddev on columns */
export type qx_Device_stddev_fields = {
  __typename?: 'qx_Device_stddev_fields';
  port?: number;
};

/** order by stddev() on columns of table "qx.Device" */
export type qx_Device_stddev_order_by = {
  port?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_Device_stddev_pop_fields = {
  __typename?: 'qx_Device_stddev_pop_fields';
  port?: number;
};

/** order by stddev_pop() on columns of table "qx.Device" */
export type qx_Device_stddev_pop_order_by = {
  port?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_Device_stddev_samp_fields = {
  __typename?: 'qx_Device_stddev_samp_fields';
  port?: number;
};

/** order by stddev_samp() on columns of table "qx.Device" */
export type qx_Device_stddev_samp_order_by = {
  port?: order_by;
};

/** Streaming cursor of the table "qx_Device" */
export type qx_Device_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_Device_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_Device_stream_cursor_value_input = {
  address?: string;
  connectionStatus?: qx_eDeviceConnectionStatus_enum;
  createdAt?: string;
  description?: string;
  disabledByLicense?: boolean;
  dst?: boolean;
  dynamicDNSServers?: any;
  dynamicNTPServers?: any;
  enabled?: boolean;
  firmware?: string;
  gatewayID?: string;
  hostname?: string;
  id?: string;
  kind?: qx_eDeviceKind_enum;
  mac?: string;
  make?: string;
  meta?: any;
  model?: string;
  name?: string;
  ntp?: boolean;
  pacsBlob?: string;
  pacsConfigurationID?: string;
  pacsHWUpdate?: qx_ePACSStatus_enum;
  pacsStatus?: qx_ePACSStatus_enum;
  pacsUpdate?: string;
  pacsUpdateTime?: string;
  password?: string;
  port?: number;
  profileMSupported?: boolean;
  searchText?: string;
  serial?: string;
  staticDNSServers?: any;
  staticNTPServers?: any;
  timezone?: string;
  tls?: boolean;
  updatedAt?: string;
  username?: string;
};

/** aggregate sum on columns */
export type qx_Device_sum_fields = {
  __typename?: 'qx_Device_sum_fields';
  port?: number;
};

/** order by sum() on columns of table "qx.Device" */
export type qx_Device_sum_order_by = {
  port?: order_by;
};

/** update columns of table "qx.Device" */
export enum qx_Device_update_column {
  /** column name */
  address = 'address',
  /** column name */
  connectionStatus = 'connectionStatus',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  description = 'description',
  /** column name */
  disabledByLicense = 'disabledByLicense',
  /** column name */
  dst = 'dst',
  /** column name */
  dynamicDNSServers = 'dynamicDNSServers',
  /** column name */
  dynamicNTPServers = 'dynamicNTPServers',
  /** column name */
  enabled = 'enabled',
  /** column name */
  firmware = 'firmware',
  /** column name */
  gatewayID = 'gatewayID',
  /** column name */
  hostname = 'hostname',
  /** column name */
  id = 'id',
  /** column name */
  kind = 'kind',
  /** column name */
  mac = 'mac',
  /** column name */
  make = 'make',
  /** column name */
  meta = 'meta',
  /** column name */
  model = 'model',
  /** column name */
  name = 'name',
  /** column name */
  ntp = 'ntp',
  /** column name */
  pacsBlob = 'pacsBlob',
  /** column name */
  pacsConfigurationID = 'pacsConfigurationID',
  /** column name */
  pacsHWUpdate = 'pacsHWUpdate',
  /** column name */
  pacsStatus = 'pacsStatus',
  /** column name */
  pacsUpdate = 'pacsUpdate',
  /** column name */
  pacsUpdateTime = 'pacsUpdateTime',
  /** column name */
  password = 'password',
  /** column name */
  port = 'port',
  /** column name */
  profileMSupported = 'profileMSupported',
  /** column name */
  searchText = 'searchText',
  /** column name */
  serial = 'serial',
  /** column name */
  staticDNSServers = 'staticDNSServers',
  /** column name */
  staticNTPServers = 'staticNTPServers',
  /** column name */
  timezone = 'timezone',
  /** column name */
  tls = 'tls',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  username = 'username'
}

export type qx_Device_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: qx_Device_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: qx_Device_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: qx_Device_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: qx_Device_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_Device_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: qx_Device_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_Device_set_input;
  /** filter the rows which have to be updated */
  where: qx_Device_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_Device_var_pop_fields = {
  __typename?: 'qx_Device_var_pop_fields';
  port?: number;
};

/** order by var_pop() on columns of table "qx.Device" */
export type qx_Device_var_pop_order_by = {
  port?: order_by;
};

/** aggregate var_samp on columns */
export type qx_Device_var_samp_fields = {
  __typename?: 'qx_Device_var_samp_fields';
  port?: number;
};

/** order by var_samp() on columns of table "qx.Device" */
export type qx_Device_var_samp_order_by = {
  port?: order_by;
};

/** aggregate variance on columns */
export type qx_Device_variance_fields = {
  __typename?: 'qx_Device_variance_fields';
  port?: number;
};

/** order by variance() on columns of table "qx.Device" */
export type qx_Device_variance_order_by = {
  port?: order_by;
};

/** columns and relationships of "qx.DiscoveryType" */
export type qx_DiscoveryType = {
  __typename?: 'qx_DiscoveryType';
  comment?: string;
  value: string;
};

/** aggregated selection of "qx.DiscoveryType" */
export type qx_DiscoveryType_aggregate = {
  __typename?: 'qx_DiscoveryType_aggregate';
  aggregate?: qx_DiscoveryType_aggregate_fields;
  nodes: Array<qx_DiscoveryType>;
};

/** aggregate fields of "qx.DiscoveryType" */
export type qx_DiscoveryType_aggregate_fields = {
  __typename?: 'qx_DiscoveryType_aggregate_fields';
  count: number;
  max?: qx_DiscoveryType_max_fields;
  min?: qx_DiscoveryType_min_fields;
};


/** aggregate fields of "qx.DiscoveryType" */
export type qx_DiscoveryType_aggregate_fieldscountArgs = {
  columns?: Array<qx_DiscoveryType_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.DiscoveryType". All fields are combined with a logical 'AND'. */
export type qx_DiscoveryType_bool_exp = {
  _and?: Array<qx_DiscoveryType_bool_exp>;
  _not?: qx_DiscoveryType_bool_exp;
  _or?: Array<qx_DiscoveryType_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.DiscoveryType" */
export enum qx_DiscoveryType_constraint {
  /** unique or primary key constraint on columns "value" */
  DiscoveryType_pkey = 'DiscoveryType_pkey'
}

/** input type for inserting data into table "qx.DiscoveryType" */
export type qx_DiscoveryType_insert_input = {
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_DiscoveryType_max_fields = {
  __typename?: 'qx_DiscoveryType_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_DiscoveryType_min_fields = {
  __typename?: 'qx_DiscoveryType_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.DiscoveryType" */
export type qx_DiscoveryType_mutation_response = {
  __typename?: 'qx_DiscoveryType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_DiscoveryType>;
};

/** on_conflict condition type for table "qx.DiscoveryType" */
export type qx_DiscoveryType_on_conflict = {
  constraint: qx_DiscoveryType_constraint;
  update_columns?: Array<qx_DiscoveryType_update_column>;
  where?: qx_DiscoveryType_bool_exp;
};

/** Ordering options when selecting data from "qx.DiscoveryType". */
export type qx_DiscoveryType_order_by = {
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.DiscoveryType */
export type qx_DiscoveryType_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.DiscoveryType" */
export enum qx_DiscoveryType_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.DiscoveryType" */
export type qx_DiscoveryType_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_DiscoveryType" */
export type qx_DiscoveryType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_DiscoveryType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_DiscoveryType_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.DiscoveryType" */
export enum qx_DiscoveryType_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_DiscoveryType_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_DiscoveryType_set_input;
  /** filter the rows which have to be updated */
  where: qx_DiscoveryType_bool_exp;
};

/** access point (door, gate, turnstile) with its hardware configuration, operating schedule, alarm state, and current door state */
export type qx_Door = {
  __typename?: 'qx_Door';
  /** An array relationship */
  DeviceDIOs: Array<qx_DeviceDIO>;
  /** An aggregate relationship */
  DeviceDIOs_aggregate: qx_DeviceDIO_aggregate;
  /** An array relationship */
  Locks: Array<qx_Lock>;
  /** An aggregate relationship */
  Locks_aggregate: qx_Lock_aggregate;
  /** An array relationship */
  Readers: Array<qx_Reader>;
  /** An aggregate relationship */
  Readers_aggregate: qx_Reader_aggregate;
  /** An object relationship */
  VideoSource?: qx_VideoSource;
  /** An object relationship */
  accessInventory?: qx_AccessInventory;
  accessTime?: string;
  alarm: qx_eDoorAlarm_enum;
  batteryLevel: qx_eBatteryLevel_enum;
  /** A computed field, executes function "qx.can_operate_door" */
  canOperate?: boolean;
  createdAt: string;
  defaultVideoSourceID?: string;
  description?: string;
  /** An object relationship */
  device: qx_Device;
  /** A computed field, executes function "qx.get_door_device_connectionStatus" */
  deviceConnectionStatus?: string;
  deviceID: string;
  /** A computed field, executes function "qx.get_door_device_kind" */
  deviceKind?: string;
  /** A computed field, executes function "qx.get_door_device_pacsHWUpdate" */
  devicePacsHWUpdate?: string;
  /** A computed field, executes function "qx.get_door_device_pacsStatus" */
  devicePacsStatus?: string;
  disabledByLicense: boolean;
  doorMonitor: qx_eDoorMonitor_enum;
  doorMonitorAddress?: string;
  doorMonitorAlarm: boolean;
  /** A computed field, executes function "qx.dps_supervise_value" */
  doorMonitorSupervise?: string;
  /** An object relationship */
  eBatteryLevel: qx_eBatteryLevel;
  /** An object relationship */
  eDoorMonitor: qx_eDoorMonitor;
  /** An object relationship */
  eMonitorLockState: qx_eMonitorLockState;
  enabled: boolean;
  /** An array relationship */
  events: Array<qx_Event>;
  /** An aggregate relationship */
  events_aggregate: qx_Event_aggregate;
  extendedAccessTime?: string;
  extendedOpenTime?: string;
  /** A computed field, executes function "qx.get_door_device_gateway_connectionStatus" */
  gatewayConnectionStatus?: boolean;
  /** A computed field, executes function "qx.get_door_gateway_placeID" */
  gatewayPlaceID?: string;
  /** A computed field, executes function "qx.get_door_device_gateway_syncStatus" */
  gatewaySyncStatus?: string;
  id: string;
  /** An object relationship */
  inside: qx_Place;
  inventoryID?: string;
  isBillable: boolean;
  lockAddress?: string;
  lockdownImmunity?: boolean;
  meta?: any;
  mode: qx_eDoorMode_enum;
  monitorLockID?: string;
  monitorLockState: qx_eMonitorLockState_enum;
  name: string;
  openTime?: string;
  /** An object relationship */
  outside?: qx_Place;
  outsideID?: string;
  /** An object relationship */
  place: qx_Place;
  placeID: string;
  preAlarmTime?: string;
  /** An array relationship */
  privileges: Array<personDoorAppPrivileges>;
  /** An aggregate relationship */
  privileges_aggregate: personDoorAppPrivileges_aggregate;
  refID: string;
  searchText?: string;
  state: qx_eDoorState_enum;
  thumbnail?: string;
  thumbnail_lg?: string;
  thumbnail_md?: string;
  thumbnail_sm?: string;
  thumbnail_xl?: string;
  /** A computed field, executes function "qx.get_door_timezone" */
  timezone?: string;
  /** An object relationship */
  toAlarm: qx_eDoorAlarm;
  /** An object relationship */
  toMode: qx_eDoorMode;
  /** An object relationship */
  toState: qx_eDoorState;
  type?: string;
  /** An object relationship */
  unlockSchedule?: qx_Schedule;
  unlockScheduleID?: string;
  updatedAt?: string;
};


/** access point (door, gate, turnstile) with its hardware configuration, operating schedule, alarm state, and current door state */
export type qx_DoorDeviceDIOsArgs = {
  distinct_on?: Array<qx_DeviceDIO_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DeviceDIO_order_by>;
  where?: qx_DeviceDIO_bool_exp;
};


/** access point (door, gate, turnstile) with its hardware configuration, operating schedule, alarm state, and current door state */
export type qx_DoorDeviceDIOs_aggregateArgs = {
  distinct_on?: Array<qx_DeviceDIO_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DeviceDIO_order_by>;
  where?: qx_DeviceDIO_bool_exp;
};


/** access point (door, gate, turnstile) with its hardware configuration, operating schedule, alarm state, and current door state */
export type qx_DoorLocksArgs = {
  distinct_on?: Array<qx_Lock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Lock_order_by>;
  where?: qx_Lock_bool_exp;
};


/** access point (door, gate, turnstile) with its hardware configuration, operating schedule, alarm state, and current door state */
export type qx_DoorLocks_aggregateArgs = {
  distinct_on?: Array<qx_Lock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Lock_order_by>;
  where?: qx_Lock_bool_exp;
};


/** access point (door, gate, turnstile) with its hardware configuration, operating schedule, alarm state, and current door state */
export type qx_DoorReadersArgs = {
  distinct_on?: Array<qx_Reader_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Reader_order_by>;
  where?: qx_Reader_bool_exp;
};


/** access point (door, gate, turnstile) with its hardware configuration, operating schedule, alarm state, and current door state */
export type qx_DoorReaders_aggregateArgs = {
  distinct_on?: Array<qx_Reader_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Reader_order_by>;
  where?: qx_Reader_bool_exp;
};


/** access point (door, gate, turnstile) with its hardware configuration, operating schedule, alarm state, and current door state */
export type qx_DooreventsArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};


/** access point (door, gate, turnstile) with its hardware configuration, operating schedule, alarm state, and current door state */
export type qx_Doorevents_aggregateArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};


/** access point (door, gate, turnstile) with its hardware configuration, operating schedule, alarm state, and current door state */
export type qx_DoormetaArgs = {
  path?: string;
};


/** access point (door, gate, turnstile) with its hardware configuration, operating schedule, alarm state, and current door state */
export type qx_DoorprivilegesArgs = {
  distinct_on?: Array<personDoorAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personDoorAppPrivileges_order_by>;
  where?: personDoorAppPrivileges_bool_exp;
};


/** access point (door, gate, turnstile) with its hardware configuration, operating schedule, alarm state, and current door state */
export type qx_Doorprivileges_aggregateArgs = {
  distinct_on?: Array<personDoorAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personDoorAppPrivileges_order_by>;
  where?: personDoorAppPrivileges_bool_exp;
};

/** hardware-specific configuration payload (e.g., Mercury panel settings) sent to the door controller during provisioning, separate from logical Door settings */
export type qx_DoorConfiguration = {
  __typename?: 'qx_DoorConfiguration';
  /** An array relationship */
  DoorTemplates: Array<qx_DoorTemplate>;
  /** An aggregate relationship */
  DoorTemplates_aggregate: qx_DoorTemplate_aggregate;
  configuration?: any;
  /** An array relationship */
  doorTemplatesByHardwareconfigurationid: Array<qx_DoorTemplate>;
  /** An aggregate relationship */
  doorTemplatesByHardwareconfigurationid_aggregate: qx_DoorTemplate_aggregate;
  id: string;
  updatedAt?: string;
};


/** hardware-specific configuration payload (e.g., Mercury panel settings) sent to the door controller during provisioning, separate from logical Door settings */
export type qx_DoorConfigurationDoorTemplatesArgs = {
  distinct_on?: Array<qx_DoorTemplate_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DoorTemplate_order_by>;
  where?: qx_DoorTemplate_bool_exp;
};


/** hardware-specific configuration payload (e.g., Mercury panel settings) sent to the door controller during provisioning, separate from logical Door settings */
export type qx_DoorConfigurationDoorTemplates_aggregateArgs = {
  distinct_on?: Array<qx_DoorTemplate_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DoorTemplate_order_by>;
  where?: qx_DoorTemplate_bool_exp;
};


/** hardware-specific configuration payload (e.g., Mercury panel settings) sent to the door controller during provisioning, separate from logical Door settings */
export type qx_DoorConfigurationconfigurationArgs = {
  path?: string;
};


/** hardware-specific configuration payload (e.g., Mercury panel settings) sent to the door controller during provisioning, separate from logical Door settings */
export type qx_DoorConfigurationdoorTemplatesByHardwareconfigurationidArgs = {
  distinct_on?: Array<qx_DoorTemplate_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DoorTemplate_order_by>;
  where?: qx_DoorTemplate_bool_exp;
};


/** hardware-specific configuration payload (e.g., Mercury panel settings) sent to the door controller during provisioning, separate from logical Door settings */
export type qx_DoorConfigurationdoorTemplatesByHardwareconfigurationid_aggregateArgs = {
  distinct_on?: Array<qx_DoorTemplate_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DoorTemplate_order_by>;
  where?: qx_DoorTemplate_bool_exp;
};

/** aggregated selection of "qx.DoorConfiguration" */
export type qx_DoorConfiguration_aggregate = {
  __typename?: 'qx_DoorConfiguration_aggregate';
  aggregate?: qx_DoorConfiguration_aggregate_fields;
  nodes: Array<qx_DoorConfiguration>;
};

/** aggregate fields of "qx.DoorConfiguration" */
export type qx_DoorConfiguration_aggregate_fields = {
  __typename?: 'qx_DoorConfiguration_aggregate_fields';
  count: number;
  max?: qx_DoorConfiguration_max_fields;
  min?: qx_DoorConfiguration_min_fields;
};


/** aggregate fields of "qx.DoorConfiguration" */
export type qx_DoorConfiguration_aggregate_fieldscountArgs = {
  columns?: Array<qx_DoorConfiguration_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type qx_DoorConfiguration_append_input = {
  configuration?: any;
};

/** Boolean expression to filter rows from the table "qx.DoorConfiguration". All fields are combined with a logical 'AND'. */
export type qx_DoorConfiguration_bool_exp = {
  DoorTemplates?: qx_DoorTemplate_bool_exp;
  DoorTemplates_aggregate?: qx_DoorTemplate_aggregate_bool_exp;
  _and?: Array<qx_DoorConfiguration_bool_exp>;
  _not?: qx_DoorConfiguration_bool_exp;
  _or?: Array<qx_DoorConfiguration_bool_exp>;
  configuration?: jsonb_comparison_exp;
  doorTemplatesByHardwareconfigurationid?: qx_DoorTemplate_bool_exp;
  doorTemplatesByHardwareconfigurationid_aggregate?: qx_DoorTemplate_aggregate_bool_exp;
  id?: String_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
};

/** unique or primary key constraints on table "qx.DoorConfiguration" */
export enum qx_DoorConfiguration_constraint {
  /** unique or primary key constraint on columns "id" */
  DoorConfiguration_pkey = 'DoorConfiguration_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type qx_DoorConfiguration_delete_at_path_input = {
  configuration?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type qx_DoorConfiguration_delete_elem_input = {
  configuration?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type qx_DoorConfiguration_delete_key_input = {
  configuration?: string;
};

/** input type for inserting data into table "qx.DoorConfiguration" */
export type qx_DoorConfiguration_insert_input = {
  DoorTemplates?: qx_DoorTemplate_arr_rel_insert_input;
  configuration?: any;
  doorTemplatesByHardwareconfigurationid?: qx_DoorTemplate_arr_rel_insert_input;
  id?: string;
  updatedAt?: string;
};

/** aggregate max on columns */
export type qx_DoorConfiguration_max_fields = {
  __typename?: 'qx_DoorConfiguration_max_fields';
  id?: string;
  updatedAt?: string;
};

/** aggregate min on columns */
export type qx_DoorConfiguration_min_fields = {
  __typename?: 'qx_DoorConfiguration_min_fields';
  id?: string;
  updatedAt?: string;
};

/** response of any mutation on the table "qx.DoorConfiguration" */
export type qx_DoorConfiguration_mutation_response = {
  __typename?: 'qx_DoorConfiguration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_DoorConfiguration>;
};

/** input type for inserting object relation for remote table "qx.DoorConfiguration" */
export type qx_DoorConfiguration_obj_rel_insert_input = {
  data: qx_DoorConfiguration_insert_input;
  /** upsert condition */
  on_conflict?: qx_DoorConfiguration_on_conflict;
};

/** on_conflict condition type for table "qx.DoorConfiguration" */
export type qx_DoorConfiguration_on_conflict = {
  constraint: qx_DoorConfiguration_constraint;
  update_columns?: Array<qx_DoorConfiguration_update_column>;
  where?: qx_DoorConfiguration_bool_exp;
};

/** Ordering options when selecting data from "qx.DoorConfiguration". */
export type qx_DoorConfiguration_order_by = {
  DoorTemplates_aggregate?: qx_DoorTemplate_aggregate_order_by;
  configuration?: order_by;
  doorTemplatesByHardwareconfigurationid_aggregate?: qx_DoorTemplate_aggregate_order_by;
  id?: order_by;
  updatedAt?: order_by;
};

/** primary key columns input for table: qx.DoorConfiguration */
export type qx_DoorConfiguration_pk_columns_input = {
  id: string;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type qx_DoorConfiguration_prepend_input = {
  configuration?: any;
};

/** select columns of table "qx.DoorConfiguration" */
export enum qx_DoorConfiguration_select_column {
  /** column name */
  configuration = 'configuration',
  /** column name */
  id = 'id',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "qx.DoorConfiguration" */
export type qx_DoorConfiguration_set_input = {
  configuration?: any;
  id?: string;
  updatedAt?: string;
};

/** Streaming cursor of the table "qx_DoorConfiguration" */
export type qx_DoorConfiguration_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_DoorConfiguration_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_DoorConfiguration_stream_cursor_value_input = {
  configuration?: any;
  id?: string;
  updatedAt?: string;
};

/** update columns of table "qx.DoorConfiguration" */
export enum qx_DoorConfiguration_update_column {
  /** column name */
  configuration = 'configuration',
  /** column name */
  id = 'id',
  /** column name */
  updatedAt = 'updatedAt'
}

export type qx_DoorConfiguration_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: qx_DoorConfiguration_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: qx_DoorConfiguration_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: qx_DoorConfiguration_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: qx_DoorConfiguration_delete_key_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: qx_DoorConfiguration_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_DoorConfiguration_set_input;
  /** filter the rows which have to be updated */
  where: qx_DoorConfiguration_bool_exp;
};

/** columns and relationships of "qx.DoorMeta" */
export type qx_DoorMeta = {
  __typename?: 'qx_DoorMeta';
  /** An object relationship */
  door?: qx_Door;
  doorID?: string;
  id: string;
  key: string;
  name: string;
  updatedAt?: string;
  value: string;
};

/** aggregated selection of "qx.DoorMeta" */
export type qx_DoorMeta_aggregate = {
  __typename?: 'qx_DoorMeta_aggregate';
  aggregate?: qx_DoorMeta_aggregate_fields;
  nodes: Array<qx_DoorMeta>;
};

/** aggregate fields of "qx.DoorMeta" */
export type qx_DoorMeta_aggregate_fields = {
  __typename?: 'qx_DoorMeta_aggregate_fields';
  avg?: qx_DoorMeta_avg_fields;
  count: number;
  max?: qx_DoorMeta_max_fields;
  min?: qx_DoorMeta_min_fields;
  stddev?: qx_DoorMeta_stddev_fields;
  stddev_pop?: qx_DoorMeta_stddev_pop_fields;
  stddev_samp?: qx_DoorMeta_stddev_samp_fields;
  sum?: qx_DoorMeta_sum_fields;
  var_pop?: qx_DoorMeta_var_pop_fields;
  var_samp?: qx_DoorMeta_var_samp_fields;
  variance?: qx_DoorMeta_variance_fields;
};


/** aggregate fields of "qx.DoorMeta" */
export type qx_DoorMeta_aggregate_fieldscountArgs = {
  columns?: Array<qx_DoorMeta_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type qx_DoorMeta_avg_fields = {
  __typename?: 'qx_DoorMeta_avg_fields';
  doorID?: number;
};

/** Boolean expression to filter rows from the table "qx.DoorMeta". All fields are combined with a logical 'AND'. */
export type qx_DoorMeta_bool_exp = {
  _and?: Array<qx_DoorMeta_bool_exp>;
  _not?: qx_DoorMeta_bool_exp;
  _or?: Array<qx_DoorMeta_bool_exp>;
  door?: qx_Door_bool_exp;
  doorID?: bigint_comparison_exp;
  id?: String_comparison_exp;
  key?: String_comparison_exp;
  name?: String_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.DoorMeta" */
export enum qx_DoorMeta_constraint {
  /** unique or primary key constraint on columns "id" */
  DoorMeta_pkey = 'DoorMeta_pkey',
  /** unique or primary key constraint on columns "key" */
  key_unique = 'key_unique'
}

/** input type for incrementing numeric columns in table "qx.DoorMeta" */
export type qx_DoorMeta_inc_input = {
  doorID?: string;
};

/** input type for inserting data into table "qx.DoorMeta" */
export type qx_DoorMeta_insert_input = {
  door?: qx_Door_obj_rel_insert_input;
  doorID?: string;
  id?: string;
  key?: string;
  name?: string;
  updatedAt?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_DoorMeta_max_fields = {
  __typename?: 'qx_DoorMeta_max_fields';
  doorID?: string;
  id?: string;
  key?: string;
  name?: string;
  updatedAt?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_DoorMeta_min_fields = {
  __typename?: 'qx_DoorMeta_min_fields';
  doorID?: string;
  id?: string;
  key?: string;
  name?: string;
  updatedAt?: string;
  value?: string;
};

/** response of any mutation on the table "qx.DoorMeta" */
export type qx_DoorMeta_mutation_response = {
  __typename?: 'qx_DoorMeta_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_DoorMeta>;
};

/** on_conflict condition type for table "qx.DoorMeta" */
export type qx_DoorMeta_on_conflict = {
  constraint: qx_DoorMeta_constraint;
  update_columns?: Array<qx_DoorMeta_update_column>;
  where?: qx_DoorMeta_bool_exp;
};

/** Ordering options when selecting data from "qx.DoorMeta". */
export type qx_DoorMeta_order_by = {
  door?: qx_Door_order_by;
  doorID?: order_by;
  id?: order_by;
  key?: order_by;
  name?: order_by;
  updatedAt?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.DoorMeta */
export type qx_DoorMeta_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.DoorMeta" */
export enum qx_DoorMeta_select_column {
  /** column name */
  doorID = 'doorID',
  /** column name */
  id = 'id',
  /** column name */
  key = 'key',
  /** column name */
  name = 'name',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.DoorMeta" */
export type qx_DoorMeta_set_input = {
  doorID?: string;
  id?: string;
  key?: string;
  name?: string;
  updatedAt?: string;
  value?: string;
};

/** aggregate stddev on columns */
export type qx_DoorMeta_stddev_fields = {
  __typename?: 'qx_DoorMeta_stddev_fields';
  doorID?: number;
};

/** aggregate stddev_pop on columns */
export type qx_DoorMeta_stddev_pop_fields = {
  __typename?: 'qx_DoorMeta_stddev_pop_fields';
  doorID?: number;
};

/** aggregate stddev_samp on columns */
export type qx_DoorMeta_stddev_samp_fields = {
  __typename?: 'qx_DoorMeta_stddev_samp_fields';
  doorID?: number;
};

/** Streaming cursor of the table "qx_DoorMeta" */
export type qx_DoorMeta_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_DoorMeta_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_DoorMeta_stream_cursor_value_input = {
  doorID?: string;
  id?: string;
  key?: string;
  name?: string;
  updatedAt?: string;
  value?: string;
};

/** aggregate sum on columns */
export type qx_DoorMeta_sum_fields = {
  __typename?: 'qx_DoorMeta_sum_fields';
  doorID?: string;
};

/** update columns of table "qx.DoorMeta" */
export enum qx_DoorMeta_update_column {
  /** column name */
  doorID = 'doorID',
  /** column name */
  id = 'id',
  /** column name */
  key = 'key',
  /** column name */
  name = 'name',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  value = 'value'
}

export type qx_DoorMeta_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_DoorMeta_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_DoorMeta_set_input;
  /** filter the rows which have to be updated */
  where: qx_DoorMeta_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_DoorMeta_var_pop_fields = {
  __typename?: 'qx_DoorMeta_var_pop_fields';
  doorID?: number;
};

/** aggregate var_samp on columns */
export type qx_DoorMeta_var_samp_fields = {
  __typename?: 'qx_DoorMeta_var_samp_fields';
  doorID?: number;
};

/** aggregate variance on columns */
export type qx_DoorMeta_variance_fields = {
  __typename?: 'qx_DoorMeta_variance_fields';
  doorID?: number;
};

/** columns and relationships of "qx.DoorTemplate" */
export type qx_DoorTemplate = {
  __typename?: 'qx_DoorTemplate';
  /** An array relationship */
  Devices: Array<qx_Device>;
  /** An aggregate relationship */
  Devices_aggregate: qx_Device_aggregate;
  /** An object relationship */
  DoorConfiguration: qx_DoorConfiguration;
  /** An object relationship */
  Place: qx_Place;
  configurationID: string;
  diagram?: string;
  /** An object relationship */
  doorConfigurationByHardwareconfigurationid: qx_DoorConfiguration;
  hardwareConfigurationID: string;
  id: string;
  make: string;
  model: string;
  name: string;
  placeID: string;
  updatedAt?: string;
};


/** columns and relationships of "qx.DoorTemplate" */
export type qx_DoorTemplateDevicesArgs = {
  distinct_on?: Array<qx_Device_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Device_order_by>;
  where?: qx_Device_bool_exp;
};


/** columns and relationships of "qx.DoorTemplate" */
export type qx_DoorTemplateDevices_aggregateArgs = {
  distinct_on?: Array<qx_Device_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Device_order_by>;
  where?: qx_Device_bool_exp;
};

/** aggregated selection of "qx.DoorTemplate" */
export type qx_DoorTemplate_aggregate = {
  __typename?: 'qx_DoorTemplate_aggregate';
  aggregate?: qx_DoorTemplate_aggregate_fields;
  nodes: Array<qx_DoorTemplate>;
};

export type qx_DoorTemplate_aggregate_bool_exp = {
  count?: qx_DoorTemplate_aggregate_bool_exp_count;
};

export type qx_DoorTemplate_aggregate_bool_exp_count = {
  arguments?: Array<qx_DoorTemplate_select_column>;
  distinct?: boolean;
  filter?: qx_DoorTemplate_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.DoorTemplate" */
export type qx_DoorTemplate_aggregate_fields = {
  __typename?: 'qx_DoorTemplate_aggregate_fields';
  count: number;
  max?: qx_DoorTemplate_max_fields;
  min?: qx_DoorTemplate_min_fields;
};


/** aggregate fields of "qx.DoorTemplate" */
export type qx_DoorTemplate_aggregate_fieldscountArgs = {
  columns?: Array<qx_DoorTemplate_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.DoorTemplate" */
export type qx_DoorTemplate_aggregate_order_by = {
  count?: order_by;
  max?: qx_DoorTemplate_max_order_by;
  min?: qx_DoorTemplate_min_order_by;
};

/** input type for inserting array relation for remote table "qx.DoorTemplate" */
export type qx_DoorTemplate_arr_rel_insert_input = {
  data: Array<qx_DoorTemplate_insert_input>;
  /** upsert condition */
  on_conflict?: qx_DoorTemplate_on_conflict;
};

/** Boolean expression to filter rows from the table "qx.DoorTemplate". All fields are combined with a logical 'AND'. */
export type qx_DoorTemplate_bool_exp = {
  Devices?: qx_Device_bool_exp;
  Devices_aggregate?: qx_Device_aggregate_bool_exp;
  DoorConfiguration?: qx_DoorConfiguration_bool_exp;
  Place?: qx_Place_bool_exp;
  _and?: Array<qx_DoorTemplate_bool_exp>;
  _not?: qx_DoorTemplate_bool_exp;
  _or?: Array<qx_DoorTemplate_bool_exp>;
  configurationID?: String_comparison_exp;
  diagram?: String_comparison_exp;
  doorConfigurationByHardwareconfigurationid?: qx_DoorConfiguration_bool_exp;
  hardwareConfigurationID?: String_comparison_exp;
  id?: String_comparison_exp;
  make?: String_comparison_exp;
  model?: String_comparison_exp;
  name?: String_comparison_exp;
  placeID?: String_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
};

/** unique or primary key constraints on table "qx.DoorTemplate" */
export enum qx_DoorTemplate_constraint {
  /** unique or primary key constraint on columns "id" */
  DoorTemplate_pkey = 'DoorTemplate_pkey'
}

/** input type for inserting data into table "qx.DoorTemplate" */
export type qx_DoorTemplate_insert_input = {
  Devices?: qx_Device_arr_rel_insert_input;
  DoorConfiguration?: qx_DoorConfiguration_obj_rel_insert_input;
  Place?: qx_Place_obj_rel_insert_input;
  configurationID?: string;
  diagram?: string;
  doorConfigurationByHardwareconfigurationid?: qx_DoorConfiguration_obj_rel_insert_input;
  hardwareConfigurationID?: string;
  id?: string;
  make?: string;
  model?: string;
  name?: string;
  placeID?: string;
  updatedAt?: string;
};

/** aggregate max on columns */
export type qx_DoorTemplate_max_fields = {
  __typename?: 'qx_DoorTemplate_max_fields';
  configurationID?: string;
  diagram?: string;
  hardwareConfigurationID?: string;
  id?: string;
  make?: string;
  model?: string;
  name?: string;
  placeID?: string;
  updatedAt?: string;
};

/** order by max() on columns of table "qx.DoorTemplate" */
export type qx_DoorTemplate_max_order_by = {
  configurationID?: order_by;
  diagram?: order_by;
  hardwareConfigurationID?: order_by;
  id?: order_by;
  make?: order_by;
  model?: order_by;
  name?: order_by;
  placeID?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type qx_DoorTemplate_min_fields = {
  __typename?: 'qx_DoorTemplate_min_fields';
  configurationID?: string;
  diagram?: string;
  hardwareConfigurationID?: string;
  id?: string;
  make?: string;
  model?: string;
  name?: string;
  placeID?: string;
  updatedAt?: string;
};

/** order by min() on columns of table "qx.DoorTemplate" */
export type qx_DoorTemplate_min_order_by = {
  configurationID?: order_by;
  diagram?: order_by;
  hardwareConfigurationID?: order_by;
  id?: order_by;
  make?: order_by;
  model?: order_by;
  name?: order_by;
  placeID?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.DoorTemplate" */
export type qx_DoorTemplate_mutation_response = {
  __typename?: 'qx_DoorTemplate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_DoorTemplate>;
};

/** input type for inserting object relation for remote table "qx.DoorTemplate" */
export type qx_DoorTemplate_obj_rel_insert_input = {
  data: qx_DoorTemplate_insert_input;
  /** upsert condition */
  on_conflict?: qx_DoorTemplate_on_conflict;
};

/** on_conflict condition type for table "qx.DoorTemplate" */
export type qx_DoorTemplate_on_conflict = {
  constraint: qx_DoorTemplate_constraint;
  update_columns?: Array<qx_DoorTemplate_update_column>;
  where?: qx_DoorTemplate_bool_exp;
};

/** Ordering options when selecting data from "qx.DoorTemplate". */
export type qx_DoorTemplate_order_by = {
  Devices_aggregate?: qx_Device_aggregate_order_by;
  DoorConfiguration?: qx_DoorConfiguration_order_by;
  Place?: qx_Place_order_by;
  configurationID?: order_by;
  diagram?: order_by;
  doorConfigurationByHardwareconfigurationid?: qx_DoorConfiguration_order_by;
  hardwareConfigurationID?: order_by;
  id?: order_by;
  make?: order_by;
  model?: order_by;
  name?: order_by;
  placeID?: order_by;
  updatedAt?: order_by;
};

/** primary key columns input for table: qx.DoorTemplate */
export type qx_DoorTemplate_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.DoorTemplate" */
export enum qx_DoorTemplate_select_column {
  /** column name */
  configurationID = 'configurationID',
  /** column name */
  diagram = 'diagram',
  /** column name */
  hardwareConfigurationID = 'hardwareConfigurationID',
  /** column name */
  id = 'id',
  /** column name */
  make = 'make',
  /** column name */
  model = 'model',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "qx.DoorTemplate" */
export type qx_DoorTemplate_set_input = {
  configurationID?: string;
  diagram?: string;
  hardwareConfigurationID?: string;
  id?: string;
  make?: string;
  model?: string;
  name?: string;
  placeID?: string;
  updatedAt?: string;
};

/** Streaming cursor of the table "qx_DoorTemplate" */
export type qx_DoorTemplate_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_DoorTemplate_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_DoorTemplate_stream_cursor_value_input = {
  configurationID?: string;
  diagram?: string;
  hardwareConfigurationID?: string;
  id?: string;
  make?: string;
  model?: string;
  name?: string;
  placeID?: string;
  updatedAt?: string;
};

/** update columns of table "qx.DoorTemplate" */
export enum qx_DoorTemplate_update_column {
  /** column name */
  configurationID = 'configurationID',
  /** column name */
  diagram = 'diagram',
  /** column name */
  hardwareConfigurationID = 'hardwareConfigurationID',
  /** column name */
  id = 'id',
  /** column name */
  make = 'make',
  /** column name */
  model = 'model',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  updatedAt = 'updatedAt'
}

export type qx_DoorTemplate_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_DoorTemplate_set_input;
  /** filter the rows which have to be updated */
  where: qx_DoorTemplate_bool_exp;
};

/** aggregated selection of "qx.Door" */
export type qx_Door_aggregate = {
  __typename?: 'qx_Door_aggregate';
  aggregate?: qx_Door_aggregate_fields;
  nodes: Array<qx_Door>;
};

export type qx_Door_aggregate_bool_exp = {
  bool_and?: qx_Door_aggregate_bool_exp_bool_and;
  bool_or?: qx_Door_aggregate_bool_exp_bool_or;
  count?: qx_Door_aggregate_bool_exp_count;
};

export type qx_Door_aggregate_bool_exp_bool_and = {
  arguments: qx_Door_select_column_qx_Door_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: qx_Door_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_Door_aggregate_bool_exp_bool_or = {
  arguments: qx_Door_select_column_qx_Door_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: qx_Door_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_Door_aggregate_bool_exp_count = {
  arguments?: Array<qx_Door_select_column>;
  distinct?: boolean;
  filter?: qx_Door_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.Door" */
export type qx_Door_aggregate_fields = {
  __typename?: 'qx_Door_aggregate_fields';
  avg?: qx_Door_avg_fields;
  count: number;
  max?: qx_Door_max_fields;
  min?: qx_Door_min_fields;
  stddev?: qx_Door_stddev_fields;
  stddev_pop?: qx_Door_stddev_pop_fields;
  stddev_samp?: qx_Door_stddev_samp_fields;
  sum?: qx_Door_sum_fields;
  var_pop?: qx_Door_var_pop_fields;
  var_samp?: qx_Door_var_samp_fields;
  variance?: qx_Door_variance_fields;
};


/** aggregate fields of "qx.Door" */
export type qx_Door_aggregate_fieldscountArgs = {
  columns?: Array<qx_Door_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.Door" */
export type qx_Door_aggregate_order_by = {
  avg?: qx_Door_avg_order_by;
  count?: order_by;
  max?: qx_Door_max_order_by;
  min?: qx_Door_min_order_by;
  stddev?: qx_Door_stddev_order_by;
  stddev_pop?: qx_Door_stddev_pop_order_by;
  stddev_samp?: qx_Door_stddev_samp_order_by;
  sum?: qx_Door_sum_order_by;
  var_pop?: qx_Door_var_pop_order_by;
  var_samp?: qx_Door_var_samp_order_by;
  variance?: qx_Door_variance_order_by;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type qx_Door_append_input = {
  meta?: any;
};

/** input type for inserting array relation for remote table "qx.Door" */
export type qx_Door_arr_rel_insert_input = {
  data: Array<qx_Door_insert_input>;
  /** upsert condition */
  on_conflict?: qx_Door_on_conflict;
};

/** aggregate avg on columns */
export type qx_Door_avg_fields = {
  __typename?: 'qx_Door_avg_fields';
  defaultVideoSourceID?: number;
  id?: number;
};

/** order by avg() on columns of table "qx.Door" */
export type qx_Door_avg_order_by = {
  defaultVideoSourceID?: order_by;
  id?: order_by;
};

/** Boolean expression to filter rows from the table "qx.Door". All fields are combined with a logical 'AND'. */
export type qx_Door_bool_exp = {
  DeviceDIOs?: qx_DeviceDIO_bool_exp;
  DeviceDIOs_aggregate?: qx_DeviceDIO_aggregate_bool_exp;
  Locks?: qx_Lock_bool_exp;
  Locks_aggregate?: qx_Lock_aggregate_bool_exp;
  Readers?: qx_Reader_bool_exp;
  Readers_aggregate?: qx_Reader_aggregate_bool_exp;
  VideoSource?: qx_VideoSource_bool_exp;
  _and?: Array<qx_Door_bool_exp>;
  _not?: qx_Door_bool_exp;
  _or?: Array<qx_Door_bool_exp>;
  accessInventory?: qx_AccessInventory_bool_exp;
  accessTime?: String_comparison_exp;
  alarm?: qx_eDoorAlarm_enum_comparison_exp;
  batteryLevel?: qx_eBatteryLevel_enum_comparison_exp;
  canOperate?: Boolean_comparison_exp;
  createdAt?: timestamptz_comparison_exp;
  defaultVideoSourceID?: bigint_comparison_exp;
  description?: String_comparison_exp;
  device?: qx_Device_bool_exp;
  deviceConnectionStatus?: String_comparison_exp;
  deviceID?: String_comparison_exp;
  deviceKind?: String_comparison_exp;
  devicePacsHWUpdate?: String_comparison_exp;
  devicePacsStatus?: String_comparison_exp;
  disabledByLicense?: Boolean_comparison_exp;
  doorMonitor?: qx_eDoorMonitor_enum_comparison_exp;
  doorMonitorAddress?: String_comparison_exp;
  doorMonitorAlarm?: Boolean_comparison_exp;
  doorMonitorSupervise?: String_comparison_exp;
  eBatteryLevel?: qx_eBatteryLevel_bool_exp;
  eDoorMonitor?: qx_eDoorMonitor_bool_exp;
  eMonitorLockState?: qx_eMonitorLockState_bool_exp;
  enabled?: Boolean_comparison_exp;
  events?: qx_Event_bool_exp;
  events_aggregate?: qx_Event_aggregate_bool_exp;
  extendedAccessTime?: String_comparison_exp;
  extendedOpenTime?: String_comparison_exp;
  gatewayConnectionStatus?: Boolean_comparison_exp;
  gatewayPlaceID?: String_comparison_exp;
  gatewaySyncStatus?: String_comparison_exp;
  id?: bigint_comparison_exp;
  inside?: qx_Place_bool_exp;
  inventoryID?: String_comparison_exp;
  isBillable?: Boolean_comparison_exp;
  lockAddress?: String_comparison_exp;
  lockdownImmunity?: Boolean_comparison_exp;
  meta?: jsonb_comparison_exp;
  mode?: qx_eDoorMode_enum_comparison_exp;
  monitorLockID?: String_comparison_exp;
  monitorLockState?: qx_eMonitorLockState_enum_comparison_exp;
  name?: String_comparison_exp;
  openTime?: String_comparison_exp;
  outside?: qx_Place_bool_exp;
  outsideID?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
  preAlarmTime?: String_comparison_exp;
  privileges?: personDoorAppPrivileges_bool_exp;
  privileges_aggregate?: personDoorAppPrivileges_aggregate_bool_exp;
  refID?: String_comparison_exp;
  searchText?: String_comparison_exp;
  state?: qx_eDoorState_enum_comparison_exp;
  thumbnail?: String_comparison_exp;
  thumbnail_lg?: String_comparison_exp;
  thumbnail_md?: String_comparison_exp;
  thumbnail_sm?: String_comparison_exp;
  thumbnail_xl?: String_comparison_exp;
  timezone?: String_comparison_exp;
  toAlarm?: qx_eDoorAlarm_bool_exp;
  toMode?: qx_eDoorMode_bool_exp;
  toState?: qx_eDoorState_bool_exp;
  type?: String_comparison_exp;
  unlockSchedule?: qx_Schedule_bool_exp;
  unlockScheduleID?: String_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
};

/** unique or primary key constraints on table "qx.Door" */
export enum qx_Door_constraint {
  /** unique or primary key constraint on columns "refID", "deviceID" */
  Door_deviceID_refID_constraint = 'Door_deviceID_refID_constraint',
  /** unique or primary key constraint on columns "id" */
  Door_pkey = 'Door_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type qx_Door_delete_at_path_input = {
  meta?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type qx_Door_delete_elem_input = {
  meta?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type qx_Door_delete_key_input = {
  meta?: string;
};

/** input type for incrementing numeric columns in table "qx.Door" */
export type qx_Door_inc_input = {
  defaultVideoSourceID?: string;
  id?: string;
};

/** input type for inserting data into table "qx.Door" */
export type qx_Door_insert_input = {
  DeviceDIOs?: qx_DeviceDIO_arr_rel_insert_input;
  Locks?: qx_Lock_arr_rel_insert_input;
  Readers?: qx_Reader_arr_rel_insert_input;
  VideoSource?: qx_VideoSource_obj_rel_insert_input;
  accessInventory?: qx_AccessInventory_obj_rel_insert_input;
  accessTime?: string;
  alarm?: qx_eDoorAlarm_enum;
  batteryLevel?: qx_eBatteryLevel_enum;
  createdAt?: string;
  defaultVideoSourceID?: string;
  description?: string;
  device?: qx_Device_obj_rel_insert_input;
  deviceID?: string;
  disabledByLicense?: boolean;
  doorMonitor?: qx_eDoorMonitor_enum;
  doorMonitorAddress?: string;
  doorMonitorAlarm?: boolean;
  eBatteryLevel?: qx_eBatteryLevel_obj_rel_insert_input;
  eDoorMonitor?: qx_eDoorMonitor_obj_rel_insert_input;
  eMonitorLockState?: qx_eMonitorLockState_obj_rel_insert_input;
  enabled?: boolean;
  events?: qx_Event_arr_rel_insert_input;
  extendedAccessTime?: string;
  extendedOpenTime?: string;
  id?: string;
  inside?: qx_Place_obj_rel_insert_input;
  inventoryID?: string;
  isBillable?: boolean;
  lockAddress?: string;
  lockdownImmunity?: boolean;
  meta?: any;
  mode?: qx_eDoorMode_enum;
  monitorLockID?: string;
  monitorLockState?: qx_eMonitorLockState_enum;
  name?: string;
  openTime?: string;
  outside?: qx_Place_obj_rel_insert_input;
  outsideID?: string;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
  preAlarmTime?: string;
  privileges?: personDoorAppPrivileges_arr_rel_insert_input;
  refID?: string;
  searchText?: string;
  state?: qx_eDoorState_enum;
  thumbnail?: string;
  thumbnail_lg?: string;
  thumbnail_md?: string;
  thumbnail_sm?: string;
  thumbnail_xl?: string;
  toAlarm?: qx_eDoorAlarm_obj_rel_insert_input;
  toMode?: qx_eDoorMode_obj_rel_insert_input;
  toState?: qx_eDoorState_obj_rel_insert_input;
  type?: string;
  unlockSchedule?: qx_Schedule_obj_rel_insert_input;
  unlockScheduleID?: string;
  updatedAt?: string;
};

/** aggregate max on columns */
export type qx_Door_max_fields = {
  __typename?: 'qx_Door_max_fields';
  accessTime?: string;
  createdAt?: string;
  defaultVideoSourceID?: string;
  description?: string;
  /** A computed field, executes function "qx.get_door_device_connectionStatus" */
  deviceConnectionStatus?: string;
  deviceID?: string;
  /** A computed field, executes function "qx.get_door_device_kind" */
  deviceKind?: string;
  /** A computed field, executes function "qx.get_door_device_pacsHWUpdate" */
  devicePacsHWUpdate?: string;
  /** A computed field, executes function "qx.get_door_device_pacsStatus" */
  devicePacsStatus?: string;
  doorMonitorAddress?: string;
  /** A computed field, executes function "qx.dps_supervise_value" */
  doorMonitorSupervise?: string;
  extendedAccessTime?: string;
  extendedOpenTime?: string;
  /** A computed field, executes function "qx.get_door_gateway_placeID" */
  gatewayPlaceID?: string;
  /** A computed field, executes function "qx.get_door_device_gateway_syncStatus" */
  gatewaySyncStatus?: string;
  id?: string;
  inventoryID?: string;
  lockAddress?: string;
  monitorLockID?: string;
  name?: string;
  openTime?: string;
  outsideID?: string;
  placeID?: string;
  preAlarmTime?: string;
  refID?: string;
  searchText?: string;
  thumbnail?: string;
  thumbnail_lg?: string;
  thumbnail_md?: string;
  thumbnail_sm?: string;
  thumbnail_xl?: string;
  /** A computed field, executes function "qx.get_door_timezone" */
  timezone?: string;
  type?: string;
  unlockScheduleID?: string;
  updatedAt?: string;
};

/** order by max() on columns of table "qx.Door" */
export type qx_Door_max_order_by = {
  accessTime?: order_by;
  createdAt?: order_by;
  defaultVideoSourceID?: order_by;
  description?: order_by;
  deviceID?: order_by;
  doorMonitorAddress?: order_by;
  extendedAccessTime?: order_by;
  extendedOpenTime?: order_by;
  id?: order_by;
  inventoryID?: order_by;
  lockAddress?: order_by;
  monitorLockID?: order_by;
  name?: order_by;
  openTime?: order_by;
  outsideID?: order_by;
  placeID?: order_by;
  preAlarmTime?: order_by;
  refID?: order_by;
  searchText?: order_by;
  thumbnail?: order_by;
  thumbnail_lg?: order_by;
  thumbnail_md?: order_by;
  thumbnail_sm?: order_by;
  thumbnail_xl?: order_by;
  type?: order_by;
  unlockScheduleID?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type qx_Door_min_fields = {
  __typename?: 'qx_Door_min_fields';
  accessTime?: string;
  createdAt?: string;
  defaultVideoSourceID?: string;
  description?: string;
  /** A computed field, executes function "qx.get_door_device_connectionStatus" */
  deviceConnectionStatus?: string;
  deviceID?: string;
  /** A computed field, executes function "qx.get_door_device_kind" */
  deviceKind?: string;
  /** A computed field, executes function "qx.get_door_device_pacsHWUpdate" */
  devicePacsHWUpdate?: string;
  /** A computed field, executes function "qx.get_door_device_pacsStatus" */
  devicePacsStatus?: string;
  doorMonitorAddress?: string;
  /** A computed field, executes function "qx.dps_supervise_value" */
  doorMonitorSupervise?: string;
  extendedAccessTime?: string;
  extendedOpenTime?: string;
  /** A computed field, executes function "qx.get_door_gateway_placeID" */
  gatewayPlaceID?: string;
  /** A computed field, executes function "qx.get_door_device_gateway_syncStatus" */
  gatewaySyncStatus?: string;
  id?: string;
  inventoryID?: string;
  lockAddress?: string;
  monitorLockID?: string;
  name?: string;
  openTime?: string;
  outsideID?: string;
  placeID?: string;
  preAlarmTime?: string;
  refID?: string;
  searchText?: string;
  thumbnail?: string;
  thumbnail_lg?: string;
  thumbnail_md?: string;
  thumbnail_sm?: string;
  thumbnail_xl?: string;
  /** A computed field, executes function "qx.get_door_timezone" */
  timezone?: string;
  type?: string;
  unlockScheduleID?: string;
  updatedAt?: string;
};

/** order by min() on columns of table "qx.Door" */
export type qx_Door_min_order_by = {
  accessTime?: order_by;
  createdAt?: order_by;
  defaultVideoSourceID?: order_by;
  description?: order_by;
  deviceID?: order_by;
  doorMonitorAddress?: order_by;
  extendedAccessTime?: order_by;
  extendedOpenTime?: order_by;
  id?: order_by;
  inventoryID?: order_by;
  lockAddress?: order_by;
  monitorLockID?: order_by;
  name?: order_by;
  openTime?: order_by;
  outsideID?: order_by;
  placeID?: order_by;
  preAlarmTime?: order_by;
  refID?: order_by;
  searchText?: order_by;
  thumbnail?: order_by;
  thumbnail_lg?: order_by;
  thumbnail_md?: order_by;
  thumbnail_sm?: order_by;
  thumbnail_xl?: order_by;
  type?: order_by;
  unlockScheduleID?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.Door" */
export type qx_Door_mutation_response = {
  __typename?: 'qx_Door_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_Door>;
};

/** input type for inserting object relation for remote table "qx.Door" */
export type qx_Door_obj_rel_insert_input = {
  data: qx_Door_insert_input;
  /** upsert condition */
  on_conflict?: qx_Door_on_conflict;
};

/** on_conflict condition type for table "qx.Door" */
export type qx_Door_on_conflict = {
  constraint: qx_Door_constraint;
  update_columns?: Array<qx_Door_update_column>;
  where?: qx_Door_bool_exp;
};

/** Ordering options when selecting data from "qx.Door". */
export type qx_Door_order_by = {
  DeviceDIOs_aggregate?: qx_DeviceDIO_aggregate_order_by;
  Locks_aggregate?: qx_Lock_aggregate_order_by;
  Readers_aggregate?: qx_Reader_aggregate_order_by;
  VideoSource?: qx_VideoSource_order_by;
  accessInventory?: qx_AccessInventory_order_by;
  accessTime?: order_by;
  alarm?: order_by;
  batteryLevel?: order_by;
  canOperate?: order_by;
  createdAt?: order_by;
  defaultVideoSourceID?: order_by;
  description?: order_by;
  device?: qx_Device_order_by;
  deviceConnectionStatus?: order_by;
  deviceID?: order_by;
  deviceKind?: order_by;
  devicePacsHWUpdate?: order_by;
  devicePacsStatus?: order_by;
  disabledByLicense?: order_by;
  doorMonitor?: order_by;
  doorMonitorAddress?: order_by;
  doorMonitorAlarm?: order_by;
  doorMonitorSupervise?: order_by;
  eBatteryLevel?: qx_eBatteryLevel_order_by;
  eDoorMonitor?: qx_eDoorMonitor_order_by;
  eMonitorLockState?: qx_eMonitorLockState_order_by;
  enabled?: order_by;
  events_aggregate?: qx_Event_aggregate_order_by;
  extendedAccessTime?: order_by;
  extendedOpenTime?: order_by;
  gatewayConnectionStatus?: order_by;
  gatewayPlaceID?: order_by;
  gatewaySyncStatus?: order_by;
  id?: order_by;
  inside?: qx_Place_order_by;
  inventoryID?: order_by;
  isBillable?: order_by;
  lockAddress?: order_by;
  lockdownImmunity?: order_by;
  meta?: order_by;
  mode?: order_by;
  monitorLockID?: order_by;
  monitorLockState?: order_by;
  name?: order_by;
  openTime?: order_by;
  outside?: qx_Place_order_by;
  outsideID?: order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
  preAlarmTime?: order_by;
  privileges_aggregate?: personDoorAppPrivileges_aggregate_order_by;
  refID?: order_by;
  searchText?: order_by;
  state?: order_by;
  thumbnail?: order_by;
  thumbnail_lg?: order_by;
  thumbnail_md?: order_by;
  thumbnail_sm?: order_by;
  thumbnail_xl?: order_by;
  timezone?: order_by;
  toAlarm?: qx_eDoorAlarm_order_by;
  toMode?: qx_eDoorMode_order_by;
  toState?: qx_eDoorState_order_by;
  type?: order_by;
  unlockSchedule?: qx_Schedule_order_by;
  unlockScheduleID?: order_by;
  updatedAt?: order_by;
};

/** primary key columns input for table: qx.Door */
export type qx_Door_pk_columns_input = {
  id: string;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type qx_Door_prepend_input = {
  meta?: any;
};

/** select columns of table "qx.Door" */
export enum qx_Door_select_column {
  /** column name */
  accessTime = 'accessTime',
  /** column name */
  alarm = 'alarm',
  /** column name */
  batteryLevel = 'batteryLevel',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  defaultVideoSourceID = 'defaultVideoSourceID',
  /** column name */
  description = 'description',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  disabledByLicense = 'disabledByLicense',
  /** column name */
  doorMonitor = 'doorMonitor',
  /** column name */
  doorMonitorAddress = 'doorMonitorAddress',
  /** column name */
  doorMonitorAlarm = 'doorMonitorAlarm',
  /** column name */
  enabled = 'enabled',
  /** column name */
  extendedAccessTime = 'extendedAccessTime',
  /** column name */
  extendedOpenTime = 'extendedOpenTime',
  /** column name */
  id = 'id',
  /** column name */
  inventoryID = 'inventoryID',
  /** column name */
  isBillable = 'isBillable',
  /** column name */
  lockAddress = 'lockAddress',
  /** column name */
  lockdownImmunity = 'lockdownImmunity',
  /** column name */
  meta = 'meta',
  /** column name */
  mode = 'mode',
  /** column name */
  monitorLockID = 'monitorLockID',
  /** column name */
  monitorLockState = 'monitorLockState',
  /** column name */
  name = 'name',
  /** column name */
  openTime = 'openTime',
  /** column name */
  outsideID = 'outsideID',
  /** column name */
  placeID = 'placeID',
  /** column name */
  preAlarmTime = 'preAlarmTime',
  /** column name */
  refID = 'refID',
  /** column name */
  searchText = 'searchText',
  /** column name */
  state = 'state',
  /** column name */
  thumbnail = 'thumbnail',
  /** column name */
  thumbnail_lg = 'thumbnail_lg',
  /** column name */
  thumbnail_md = 'thumbnail_md',
  /** column name */
  thumbnail_sm = 'thumbnail_sm',
  /** column name */
  thumbnail_xl = 'thumbnail_xl',
  /** column name */
  type = 'type',
  /** column name */
  unlockScheduleID = 'unlockScheduleID',
  /** column name */
  updatedAt = 'updatedAt'
}

/** select "qx_Door_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.Door" */
export enum qx_Door_select_column_qx_Door_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  disabledByLicense = 'disabledByLicense',
  /** column name */
  doorMonitorAlarm = 'doorMonitorAlarm',
  /** column name */
  enabled = 'enabled',
  /** column name */
  isBillable = 'isBillable',
  /** column name */
  lockdownImmunity = 'lockdownImmunity'
}

/** select "qx_Door_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.Door" */
export enum qx_Door_select_column_qx_Door_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  disabledByLicense = 'disabledByLicense',
  /** column name */
  doorMonitorAlarm = 'doorMonitorAlarm',
  /** column name */
  enabled = 'enabled',
  /** column name */
  isBillable = 'isBillable',
  /** column name */
  lockdownImmunity = 'lockdownImmunity'
}

/** input type for updating data in table "qx.Door" */
export type qx_Door_set_input = {
  accessTime?: string;
  alarm?: qx_eDoorAlarm_enum;
  batteryLevel?: qx_eBatteryLevel_enum;
  createdAt?: string;
  defaultVideoSourceID?: string;
  description?: string;
  deviceID?: string;
  disabledByLicense?: boolean;
  doorMonitor?: qx_eDoorMonitor_enum;
  doorMonitorAddress?: string;
  doorMonitorAlarm?: boolean;
  enabled?: boolean;
  extendedAccessTime?: string;
  extendedOpenTime?: string;
  id?: string;
  inventoryID?: string;
  isBillable?: boolean;
  lockAddress?: string;
  lockdownImmunity?: boolean;
  meta?: any;
  mode?: qx_eDoorMode_enum;
  monitorLockID?: string;
  monitorLockState?: qx_eMonitorLockState_enum;
  name?: string;
  openTime?: string;
  outsideID?: string;
  placeID?: string;
  preAlarmTime?: string;
  refID?: string;
  searchText?: string;
  state?: qx_eDoorState_enum;
  thumbnail?: string;
  thumbnail_lg?: string;
  thumbnail_md?: string;
  thumbnail_sm?: string;
  thumbnail_xl?: string;
  type?: string;
  unlockScheduleID?: string;
  updatedAt?: string;
};

/** aggregate stddev on columns */
export type qx_Door_stddev_fields = {
  __typename?: 'qx_Door_stddev_fields';
  defaultVideoSourceID?: number;
  id?: number;
};

/** order by stddev() on columns of table "qx.Door" */
export type qx_Door_stddev_order_by = {
  defaultVideoSourceID?: order_by;
  id?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_Door_stddev_pop_fields = {
  __typename?: 'qx_Door_stddev_pop_fields';
  defaultVideoSourceID?: number;
  id?: number;
};

/** order by stddev_pop() on columns of table "qx.Door" */
export type qx_Door_stddev_pop_order_by = {
  defaultVideoSourceID?: order_by;
  id?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_Door_stddev_samp_fields = {
  __typename?: 'qx_Door_stddev_samp_fields';
  defaultVideoSourceID?: number;
  id?: number;
};

/** order by stddev_samp() on columns of table "qx.Door" */
export type qx_Door_stddev_samp_order_by = {
  defaultVideoSourceID?: order_by;
  id?: order_by;
};

/** Streaming cursor of the table "qx_Door" */
export type qx_Door_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_Door_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_Door_stream_cursor_value_input = {
  accessTime?: string;
  alarm?: qx_eDoorAlarm_enum;
  batteryLevel?: qx_eBatteryLevel_enum;
  createdAt?: string;
  defaultVideoSourceID?: string;
  description?: string;
  deviceID?: string;
  disabledByLicense?: boolean;
  doorMonitor?: qx_eDoorMonitor_enum;
  doorMonitorAddress?: string;
  doorMonitorAlarm?: boolean;
  enabled?: boolean;
  extendedAccessTime?: string;
  extendedOpenTime?: string;
  id?: string;
  inventoryID?: string;
  isBillable?: boolean;
  lockAddress?: string;
  lockdownImmunity?: boolean;
  meta?: any;
  mode?: qx_eDoorMode_enum;
  monitorLockID?: string;
  monitorLockState?: qx_eMonitorLockState_enum;
  name?: string;
  openTime?: string;
  outsideID?: string;
  placeID?: string;
  preAlarmTime?: string;
  refID?: string;
  searchText?: string;
  state?: qx_eDoorState_enum;
  thumbnail?: string;
  thumbnail_lg?: string;
  thumbnail_md?: string;
  thumbnail_sm?: string;
  thumbnail_xl?: string;
  type?: string;
  unlockScheduleID?: string;
  updatedAt?: string;
};

/** aggregate sum on columns */
export type qx_Door_sum_fields = {
  __typename?: 'qx_Door_sum_fields';
  defaultVideoSourceID?: string;
  id?: string;
};

/** order by sum() on columns of table "qx.Door" */
export type qx_Door_sum_order_by = {
  defaultVideoSourceID?: order_by;
  id?: order_by;
};

/** update columns of table "qx.Door" */
export enum qx_Door_update_column {
  /** column name */
  accessTime = 'accessTime',
  /** column name */
  alarm = 'alarm',
  /** column name */
  batteryLevel = 'batteryLevel',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  defaultVideoSourceID = 'defaultVideoSourceID',
  /** column name */
  description = 'description',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  disabledByLicense = 'disabledByLicense',
  /** column name */
  doorMonitor = 'doorMonitor',
  /** column name */
  doorMonitorAddress = 'doorMonitorAddress',
  /** column name */
  doorMonitorAlarm = 'doorMonitorAlarm',
  /** column name */
  enabled = 'enabled',
  /** column name */
  extendedAccessTime = 'extendedAccessTime',
  /** column name */
  extendedOpenTime = 'extendedOpenTime',
  /** column name */
  id = 'id',
  /** column name */
  inventoryID = 'inventoryID',
  /** column name */
  isBillable = 'isBillable',
  /** column name */
  lockAddress = 'lockAddress',
  /** column name */
  lockdownImmunity = 'lockdownImmunity',
  /** column name */
  meta = 'meta',
  /** column name */
  mode = 'mode',
  /** column name */
  monitorLockID = 'monitorLockID',
  /** column name */
  monitorLockState = 'monitorLockState',
  /** column name */
  name = 'name',
  /** column name */
  openTime = 'openTime',
  /** column name */
  outsideID = 'outsideID',
  /** column name */
  placeID = 'placeID',
  /** column name */
  preAlarmTime = 'preAlarmTime',
  /** column name */
  refID = 'refID',
  /** column name */
  searchText = 'searchText',
  /** column name */
  state = 'state',
  /** column name */
  thumbnail = 'thumbnail',
  /** column name */
  thumbnail_lg = 'thumbnail_lg',
  /** column name */
  thumbnail_md = 'thumbnail_md',
  /** column name */
  thumbnail_sm = 'thumbnail_sm',
  /** column name */
  thumbnail_xl = 'thumbnail_xl',
  /** column name */
  type = 'type',
  /** column name */
  unlockScheduleID = 'unlockScheduleID',
  /** column name */
  updatedAt = 'updatedAt'
}

export type qx_Door_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: qx_Door_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: qx_Door_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: qx_Door_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: qx_Door_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_Door_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: qx_Door_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_Door_set_input;
  /** filter the rows which have to be updated */
  where: qx_Door_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_Door_var_pop_fields = {
  __typename?: 'qx_Door_var_pop_fields';
  defaultVideoSourceID?: number;
  id?: number;
};

/** order by var_pop() on columns of table "qx.Door" */
export type qx_Door_var_pop_order_by = {
  defaultVideoSourceID?: order_by;
  id?: order_by;
};

/** aggregate var_samp on columns */
export type qx_Door_var_samp_fields = {
  __typename?: 'qx_Door_var_samp_fields';
  defaultVideoSourceID?: number;
  id?: number;
};

/** order by var_samp() on columns of table "qx.Door" */
export type qx_Door_var_samp_order_by = {
  defaultVideoSourceID?: order_by;
  id?: order_by;
};

/** aggregate variance on columns */
export type qx_Door_variance_fields = {
  __typename?: 'qx_Door_variance_fields';
  defaultVideoSourceID?: number;
  id?: number;
};

/** order by variance() on columns of table "qx.Door" */
export type qx_Door_variance_order_by = {
  defaultVideoSourceID?: order_by;
  id?: order_by;
};

/** columns and relationships of "qx.Event" */
export type qx_Event = {
  __typename?: 'qx_Event';
  active?: boolean;
  bits?: number;
  card?: string;
  cloudTime?: string;
  /** An object relationship */
  device?: qx_Device;
  deviceDIOID?: string;
  deviceID?: string;
  /** An object relationship */
  door?: qx_Door;
  doorID?: string;
  /** An object relationship */
  end?: qx_Event;
  /** An object relationship */
  gateway?: qx_Gateway;
  gatewayID?: string;
  id: string;
  /** An object relationship */
  mediaProfile?: qx_MediaProfile;
  mediaProfileID?: string;
  /** An object relationship */
  partition?: IntrusionPartition;
  partitionID?: string;
  /** An object relationship */
  person?: qx_Person;
  personID?: string;
  /** An object relationship */
  place?: qx_Place;
  placeID?: string;
  profile?: string;
  /** An object relationship */
  reader?: qx_Reader;
  readerID?: string;
  /** An object relationship */
  sensor?: qx_Sensor;
  sensorID?: string;
  serverTime: string;
  /** An object relationship */
  snapshot?: qx_Snapshot;
  snapshotID?: string;
  /** An object relationship */
  start?: qx_Event;
  startID?: string;
  status?: string;
  time: string;
  /** An object relationship */
  toType?: qx_EventType;
  type?: string;
  typeStatusActiveID?: string;
  /** An object relationship */
  videoSource?: qx_VideoSource;
  videoSourceID?: string;
  /** An object relationship */
  zone?: IntrusionZone;
  zoneID?: string;
};

/** reference table of event type codes and their human-readable labels used to categorize system events */
export type qx_EventType = {
  __typename?: 'qx_EventType';
  /** An array relationship */
  events: Array<qx_Event>;
  /** An aggregate relationship */
  events_aggregate: qx_Event_aggregate;
  maxAlarm: any;
  postAlarm: any;
  preAlarm: any;
  priority: number;
  stateful: boolean;
  statusTable?: string;
  statusValues?: Array<qx_eDeviceConnectionStatus>;
  type: string;
  uniqueID: string;
  usesActive: boolean;
};


/** reference table of event type codes and their human-readable labels used to categorize system events */
export type qx_EventTypeeventsArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};


/** reference table of event type codes and their human-readable labels used to categorize system events */
export type qx_EventTypeevents_aggregateArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};


/** reference table of event type codes and their human-readable labels used to categorize system events */
export type qx_EventTypestatusValuesArgs = {
  distinct_on?: Array<qx_eDeviceConnectionStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDeviceConnectionStatus_order_by>;
  where?: qx_eDeviceConnectionStatus_bool_exp;
};

/** aggregated selection of "qx.EventType" */
export type qx_EventType_aggregate = {
  __typename?: 'qx_EventType_aggregate';
  aggregate?: qx_EventType_aggregate_fields;
  nodes: Array<qx_EventType>;
};

/** aggregate fields of "qx.EventType" */
export type qx_EventType_aggregate_fields = {
  __typename?: 'qx_EventType_aggregate_fields';
  avg?: qx_EventType_avg_fields;
  count: number;
  max?: qx_EventType_max_fields;
  min?: qx_EventType_min_fields;
  stddev?: qx_EventType_stddev_fields;
  stddev_pop?: qx_EventType_stddev_pop_fields;
  stddev_samp?: qx_EventType_stddev_samp_fields;
  sum?: qx_EventType_sum_fields;
  var_pop?: qx_EventType_var_pop_fields;
  var_samp?: qx_EventType_var_samp_fields;
  variance?: qx_EventType_variance_fields;
};


/** aggregate fields of "qx.EventType" */
export type qx_EventType_aggregate_fieldscountArgs = {
  columns?: Array<qx_EventType_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type qx_EventType_avg_fields = {
  __typename?: 'qx_EventType_avg_fields';
  priority?: number;
};

/** Boolean expression to filter rows from the table "qx.EventType". All fields are combined with a logical 'AND'. */
export type qx_EventType_bool_exp = {
  _and?: Array<qx_EventType_bool_exp>;
  _not?: qx_EventType_bool_exp;
  _or?: Array<qx_EventType_bool_exp>;
  events?: qx_Event_bool_exp;
  events_aggregate?: qx_Event_aggregate_bool_exp;
  maxAlarm?: interval_comparison_exp;
  postAlarm?: interval_comparison_exp;
  preAlarm?: interval_comparison_exp;
  priority?: Int_comparison_exp;
  stateful?: Boolean_comparison_exp;
  statusTable?: String_comparison_exp;
  statusValues?: qx_eDeviceConnectionStatus_bool_exp;
  type?: String_comparison_exp;
  uniqueID?: String_comparison_exp;
  usesActive?: Boolean_comparison_exp;
};

/** unique or primary key constraints on table "qx.EventType" */
export enum qx_EventType_constraint {
  /** unique or primary key constraint on columns "type" */
  EventType_pkey = 'EventType_pkey'
}

/** input type for incrementing numeric columns in table "qx.EventType" */
export type qx_EventType_inc_input = {
  priority?: number;
};

/** input type for inserting data into table "qx.EventType" */
export type qx_EventType_insert_input = {
  events?: qx_Event_arr_rel_insert_input;
  maxAlarm?: any;
  postAlarm?: any;
  preAlarm?: any;
  priority?: number;
  stateful?: boolean;
  statusTable?: string;
  type?: string;
  uniqueID?: string;
  usesActive?: boolean;
};

/** aggregate max on columns */
export type qx_EventType_max_fields = {
  __typename?: 'qx_EventType_max_fields';
  priority?: number;
  statusTable?: string;
  type?: string;
  uniqueID?: string;
};

/** aggregate min on columns */
export type qx_EventType_min_fields = {
  __typename?: 'qx_EventType_min_fields';
  priority?: number;
  statusTable?: string;
  type?: string;
  uniqueID?: string;
};

/** response of any mutation on the table "qx.EventType" */
export type qx_EventType_mutation_response = {
  __typename?: 'qx_EventType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_EventType>;
};

/** input type for inserting object relation for remote table "qx.EventType" */
export type qx_EventType_obj_rel_insert_input = {
  data: qx_EventType_insert_input;
  /** upsert condition */
  on_conflict?: qx_EventType_on_conflict;
};

/** on_conflict condition type for table "qx.EventType" */
export type qx_EventType_on_conflict = {
  constraint: qx_EventType_constraint;
  update_columns?: Array<qx_EventType_update_column>;
  where?: qx_EventType_bool_exp;
};

/** Ordering options when selecting data from "qx.EventType". */
export type qx_EventType_order_by = {
  events_aggregate?: qx_Event_aggregate_order_by;
  maxAlarm?: order_by;
  postAlarm?: order_by;
  preAlarm?: order_by;
  priority?: order_by;
  stateful?: order_by;
  statusTable?: order_by;
  statusValues_aggregate?: qx_eDeviceConnectionStatus_aggregate_order_by;
  type?: order_by;
  uniqueID?: order_by;
  usesActive?: order_by;
};

/** primary key columns input for table: qx.EventType */
export type qx_EventType_pk_columns_input = {
  type: string;
};

/** select columns of table "qx.EventType" */
export enum qx_EventType_select_column {
  /** column name */
  maxAlarm = 'maxAlarm',
  /** column name */
  postAlarm = 'postAlarm',
  /** column name */
  preAlarm = 'preAlarm',
  /** column name */
  priority = 'priority',
  /** column name */
  stateful = 'stateful',
  /** column name */
  statusTable = 'statusTable',
  /** column name */
  type = 'type',
  /** column name */
  uniqueID = 'uniqueID',
  /** column name */
  usesActive = 'usesActive'
}

/** input type for updating data in table "qx.EventType" */
export type qx_EventType_set_input = {
  maxAlarm?: any;
  postAlarm?: any;
  preAlarm?: any;
  priority?: number;
  stateful?: boolean;
  statusTable?: string;
  type?: string;
  uniqueID?: string;
  usesActive?: boolean;
};

/** aggregate stddev on columns */
export type qx_EventType_stddev_fields = {
  __typename?: 'qx_EventType_stddev_fields';
  priority?: number;
};

/** aggregate stddev_pop on columns */
export type qx_EventType_stddev_pop_fields = {
  __typename?: 'qx_EventType_stddev_pop_fields';
  priority?: number;
};

/** aggregate stddev_samp on columns */
export type qx_EventType_stddev_samp_fields = {
  __typename?: 'qx_EventType_stddev_samp_fields';
  priority?: number;
};

/** Streaming cursor of the table "qx_EventType" */
export type qx_EventType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_EventType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_EventType_stream_cursor_value_input = {
  maxAlarm?: any;
  postAlarm?: any;
  preAlarm?: any;
  priority?: number;
  stateful?: boolean;
  statusTable?: string;
  type?: string;
  uniqueID?: string;
  usesActive?: boolean;
};

/** aggregate sum on columns */
export type qx_EventType_sum_fields = {
  __typename?: 'qx_EventType_sum_fields';
  priority?: number;
};

/** update columns of table "qx.EventType" */
export enum qx_EventType_update_column {
  /** column name */
  maxAlarm = 'maxAlarm',
  /** column name */
  postAlarm = 'postAlarm',
  /** column name */
  preAlarm = 'preAlarm',
  /** column name */
  priority = 'priority',
  /** column name */
  stateful = 'stateful',
  /** column name */
  statusTable = 'statusTable',
  /** column name */
  type = 'type',
  /** column name */
  uniqueID = 'uniqueID',
  /** column name */
  usesActive = 'usesActive'
}

export type qx_EventType_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_EventType_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_EventType_set_input;
  /** filter the rows which have to be updated */
  where: qx_EventType_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_EventType_var_pop_fields = {
  __typename?: 'qx_EventType_var_pop_fields';
  priority?: number;
};

/** aggregate var_samp on columns */
export type qx_EventType_var_samp_fields = {
  __typename?: 'qx_EventType_var_samp_fields';
  priority?: number;
};

/** aggregate variance on columns */
export type qx_EventType_variance_fields = {
  __typename?: 'qx_EventType_variance_fields';
  priority?: number;
};

/** aggregated selection of "qx.Event" */
export type qx_Event_aggregate = {
  __typename?: 'qx_Event_aggregate';
  aggregate?: qx_Event_aggregate_fields;
  nodes: Array<qx_Event>;
};

export type qx_Event_aggregate_bool_exp = {
  bool_and?: qx_Event_aggregate_bool_exp_bool_and;
  bool_or?: qx_Event_aggregate_bool_exp_bool_or;
  count?: qx_Event_aggregate_bool_exp_count;
};

export type qx_Event_aggregate_bool_exp_bool_and = {
  arguments: qx_Event_select_column_qx_Event_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: qx_Event_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_Event_aggregate_bool_exp_bool_or = {
  arguments: qx_Event_select_column_qx_Event_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: qx_Event_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_Event_aggregate_bool_exp_count = {
  arguments?: Array<qx_Event_select_column>;
  distinct?: boolean;
  filter?: qx_Event_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.Event" */
export type qx_Event_aggregate_fields = {
  __typename?: 'qx_Event_aggregate_fields';
  avg?: qx_Event_avg_fields;
  count: number;
  max?: qx_Event_max_fields;
  min?: qx_Event_min_fields;
  stddev?: qx_Event_stddev_fields;
  stddev_pop?: qx_Event_stddev_pop_fields;
  stddev_samp?: qx_Event_stddev_samp_fields;
  sum?: qx_Event_sum_fields;
  var_pop?: qx_Event_var_pop_fields;
  var_samp?: qx_Event_var_samp_fields;
  variance?: qx_Event_variance_fields;
};


/** aggregate fields of "qx.Event" */
export type qx_Event_aggregate_fieldscountArgs = {
  columns?: Array<qx_Event_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.Event" */
export type qx_Event_aggregate_order_by = {
  avg?: qx_Event_avg_order_by;
  count?: order_by;
  max?: qx_Event_max_order_by;
  min?: qx_Event_min_order_by;
  stddev?: qx_Event_stddev_order_by;
  stddev_pop?: qx_Event_stddev_pop_order_by;
  stddev_samp?: qx_Event_stddev_samp_order_by;
  sum?: qx_Event_sum_order_by;
  var_pop?: qx_Event_var_pop_order_by;
  var_samp?: qx_Event_var_samp_order_by;
  variance?: qx_Event_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.Event" */
export type qx_Event_arr_rel_insert_input = {
  data: Array<qx_Event_insert_input>;
  /** upsert condition */
  on_conflict?: qx_Event_on_conflict;
};

/** aggregate avg on columns */
export type qx_Event_avg_fields = {
  __typename?: 'qx_Event_avg_fields';
  bits?: number;
  doorID?: number;
  id?: number;
  mediaProfileID?: number;
  sensorID?: number;
  startID?: number;
  typeStatusActiveID?: number;
  videoSourceID?: number;
};

/** order by avg() on columns of table "qx.Event" */
export type qx_Event_avg_order_by = {
  bits?: order_by;
  doorID?: order_by;
  id?: order_by;
  mediaProfileID?: order_by;
  sensorID?: order_by;
  startID?: order_by;
  typeStatusActiveID?: order_by;
  videoSourceID?: order_by;
};

/** Boolean expression to filter rows from the table "qx.Event". All fields are combined with a logical 'AND'. */
export type qx_Event_bool_exp = {
  _and?: Array<qx_Event_bool_exp>;
  _not?: qx_Event_bool_exp;
  _or?: Array<qx_Event_bool_exp>;
  active?: Boolean_comparison_exp;
  bits?: Int_comparison_exp;
  card?: String_comparison_exp;
  cloudTime?: timestamptz_comparison_exp;
  device?: qx_Device_bool_exp;
  deviceDIOID?: String_comparison_exp;
  deviceID?: String_comparison_exp;
  door?: qx_Door_bool_exp;
  doorID?: bigint_comparison_exp;
  end?: qx_Event_bool_exp;
  gateway?: qx_Gateway_bool_exp;
  gatewayID?: String_comparison_exp;
  id?: bigint_comparison_exp;
  mediaProfile?: qx_MediaProfile_bool_exp;
  mediaProfileID?: bigint_comparison_exp;
  partition?: IntrusionPartition_bool_exp;
  partitionID?: String_comparison_exp;
  person?: qx_Person_bool_exp;
  personID?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
  profile?: String_comparison_exp;
  reader?: qx_Reader_bool_exp;
  readerID?: String_comparison_exp;
  sensor?: qx_Sensor_bool_exp;
  sensorID?: bigint_comparison_exp;
  serverTime?: timestamptz_comparison_exp;
  snapshot?: qx_Snapshot_bool_exp;
  snapshotID?: String_comparison_exp;
  start?: qx_Event_bool_exp;
  startID?: bigint_comparison_exp;
  status?: String_comparison_exp;
  time?: timestamptz_comparison_exp;
  toType?: qx_EventType_bool_exp;
  type?: String_comparison_exp;
  typeStatusActiveID?: bigint_comparison_exp;
  videoSource?: qx_VideoSource_bool_exp;
  videoSourceID?: bigint_comparison_exp;
  zone?: IntrusionZone_bool_exp;
  zoneID?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.Event" */
export enum qx_Event_constraint {
  /** unique or primary key constraint on columns "id", "serverTime" */
  Event_pkey = 'Event_pkey',
  /** unique or primary key constraint on columns "id", "serverTime" */
  event_subscriber_match_idx = 'event_subscriber_match_idx',
  /** unique or primary key constraint on columns "serverTime", "startID" */
  idx_event_startid_servertime = 'idx_event_startid_servertime'
}

/** input type for incrementing numeric columns in table "qx.Event" */
export type qx_Event_inc_input = {
  bits?: number;
  doorID?: string;
  id?: string;
  mediaProfileID?: string;
  sensorID?: string;
  startID?: string;
  typeStatusActiveID?: string;
  videoSourceID?: string;
};

/** input type for inserting data into table "qx.Event" */
export type qx_Event_insert_input = {
  active?: boolean;
  bits?: number;
  card?: string;
  cloudTime?: string;
  device?: qx_Device_obj_rel_insert_input;
  deviceDIOID?: string;
  deviceID?: string;
  door?: qx_Door_obj_rel_insert_input;
  doorID?: string;
  end?: qx_Event_obj_rel_insert_input;
  gateway?: qx_Gateway_obj_rel_insert_input;
  gatewayID?: string;
  id?: string;
  mediaProfile?: qx_MediaProfile_obj_rel_insert_input;
  mediaProfileID?: string;
  partition?: IntrusionPartition_obj_rel_insert_input;
  partitionID?: string;
  person?: qx_Person_obj_rel_insert_input;
  personID?: string;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
  profile?: string;
  reader?: qx_Reader_obj_rel_insert_input;
  readerID?: string;
  sensor?: qx_Sensor_obj_rel_insert_input;
  sensorID?: string;
  serverTime?: string;
  snapshot?: qx_Snapshot_obj_rel_insert_input;
  snapshotID?: string;
  start?: qx_Event_obj_rel_insert_input;
  startID?: string;
  status?: string;
  time?: string;
  toType?: qx_EventType_obj_rel_insert_input;
  type?: string;
  typeStatusActiveID?: string;
  videoSource?: qx_VideoSource_obj_rel_insert_input;
  videoSourceID?: string;
  zone?: IntrusionZone_obj_rel_insert_input;
  zoneID?: string;
};

/** aggregate max on columns */
export type qx_Event_max_fields = {
  __typename?: 'qx_Event_max_fields';
  bits?: number;
  card?: string;
  cloudTime?: string;
  deviceDIOID?: string;
  deviceID?: string;
  doorID?: string;
  gatewayID?: string;
  id?: string;
  mediaProfileID?: string;
  partitionID?: string;
  personID?: string;
  placeID?: string;
  profile?: string;
  readerID?: string;
  sensorID?: string;
  serverTime?: string;
  snapshotID?: string;
  startID?: string;
  status?: string;
  time?: string;
  type?: string;
  typeStatusActiveID?: string;
  videoSourceID?: string;
  zoneID?: string;
};

/** order by max() on columns of table "qx.Event" */
export type qx_Event_max_order_by = {
  bits?: order_by;
  card?: order_by;
  cloudTime?: order_by;
  deviceDIOID?: order_by;
  deviceID?: order_by;
  doorID?: order_by;
  gatewayID?: order_by;
  id?: order_by;
  mediaProfileID?: order_by;
  partitionID?: order_by;
  personID?: order_by;
  placeID?: order_by;
  profile?: order_by;
  readerID?: order_by;
  sensorID?: order_by;
  serverTime?: order_by;
  snapshotID?: order_by;
  startID?: order_by;
  status?: order_by;
  time?: order_by;
  type?: order_by;
  typeStatusActiveID?: order_by;
  videoSourceID?: order_by;
  zoneID?: order_by;
};

/** aggregate min on columns */
export type qx_Event_min_fields = {
  __typename?: 'qx_Event_min_fields';
  bits?: number;
  card?: string;
  cloudTime?: string;
  deviceDIOID?: string;
  deviceID?: string;
  doorID?: string;
  gatewayID?: string;
  id?: string;
  mediaProfileID?: string;
  partitionID?: string;
  personID?: string;
  placeID?: string;
  profile?: string;
  readerID?: string;
  sensorID?: string;
  serverTime?: string;
  snapshotID?: string;
  startID?: string;
  status?: string;
  time?: string;
  type?: string;
  typeStatusActiveID?: string;
  videoSourceID?: string;
  zoneID?: string;
};

/** order by min() on columns of table "qx.Event" */
export type qx_Event_min_order_by = {
  bits?: order_by;
  card?: order_by;
  cloudTime?: order_by;
  deviceDIOID?: order_by;
  deviceID?: order_by;
  doorID?: order_by;
  gatewayID?: order_by;
  id?: order_by;
  mediaProfileID?: order_by;
  partitionID?: order_by;
  personID?: order_by;
  placeID?: order_by;
  profile?: order_by;
  readerID?: order_by;
  sensorID?: order_by;
  serverTime?: order_by;
  snapshotID?: order_by;
  startID?: order_by;
  status?: order_by;
  time?: order_by;
  type?: order_by;
  typeStatusActiveID?: order_by;
  videoSourceID?: order_by;
  zoneID?: order_by;
};

/** response of any mutation on the table "qx.Event" */
export type qx_Event_mutation_response = {
  __typename?: 'qx_Event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_Event>;
};

/** input type for inserting object relation for remote table "qx.Event" */
export type qx_Event_obj_rel_insert_input = {
  data: qx_Event_insert_input;
  /** upsert condition */
  on_conflict?: qx_Event_on_conflict;
};

/** on_conflict condition type for table "qx.Event" */
export type qx_Event_on_conflict = {
  constraint: qx_Event_constraint;
  update_columns?: Array<qx_Event_update_column>;
  where?: qx_Event_bool_exp;
};

/** Ordering options when selecting data from "qx.Event". */
export type qx_Event_order_by = {
  active?: order_by;
  bits?: order_by;
  card?: order_by;
  cloudTime?: order_by;
  device?: qx_Device_order_by;
  deviceDIOID?: order_by;
  deviceID?: order_by;
  door?: qx_Door_order_by;
  doorID?: order_by;
  end?: qx_Event_order_by;
  gateway?: qx_Gateway_order_by;
  gatewayID?: order_by;
  id?: order_by;
  mediaProfile?: qx_MediaProfile_order_by;
  mediaProfileID?: order_by;
  partition?: IntrusionPartition_order_by;
  partitionID?: order_by;
  person?: qx_Person_order_by;
  personID?: order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
  profile?: order_by;
  reader?: qx_Reader_order_by;
  readerID?: order_by;
  sensor?: qx_Sensor_order_by;
  sensorID?: order_by;
  serverTime?: order_by;
  snapshot?: qx_Snapshot_order_by;
  snapshotID?: order_by;
  start?: qx_Event_order_by;
  startID?: order_by;
  status?: order_by;
  time?: order_by;
  toType?: qx_EventType_order_by;
  type?: order_by;
  typeStatusActiveID?: order_by;
  videoSource?: qx_VideoSource_order_by;
  videoSourceID?: order_by;
  zone?: IntrusionZone_order_by;
  zoneID?: order_by;
};

/** primary key columns input for table: qx.Event */
export type qx_Event_pk_columns_input = {
  id: string;
  serverTime: string;
};

/** select columns of table "qx.Event" */
export enum qx_Event_select_column {
  /** column name */
  active = 'active',
  /** column name */
  bits = 'bits',
  /** column name */
  card = 'card',
  /** column name */
  cloudTime = 'cloudTime',
  /** column name */
  deviceDIOID = 'deviceDIOID',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  doorID = 'doorID',
  /** column name */
  gatewayID = 'gatewayID',
  /** column name */
  id = 'id',
  /** column name */
  mediaProfileID = 'mediaProfileID',
  /** column name */
  partitionID = 'partitionID',
  /** column name */
  personID = 'personID',
  /** column name */
  placeID = 'placeID',
  /** column name */
  profile = 'profile',
  /** column name */
  readerID = 'readerID',
  /** column name */
  sensorID = 'sensorID',
  /** column name */
  serverTime = 'serverTime',
  /** column name */
  snapshotID = 'snapshotID',
  /** column name */
  startID = 'startID',
  /** column name */
  status = 'status',
  /** column name */
  time = 'time',
  /** column name */
  type = 'type',
  /** column name */
  typeStatusActiveID = 'typeStatusActiveID',
  /** column name */
  videoSourceID = 'videoSourceID',
  /** column name */
  zoneID = 'zoneID'
}

/** select "qx_Event_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.Event" */
export enum qx_Event_select_column_qx_Event_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  active = 'active'
}

/** select "qx_Event_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.Event" */
export enum qx_Event_select_column_qx_Event_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  active = 'active'
}

/** input type for updating data in table "qx.Event" */
export type qx_Event_set_input = {
  active?: boolean;
  bits?: number;
  card?: string;
  cloudTime?: string;
  deviceDIOID?: string;
  deviceID?: string;
  doorID?: string;
  gatewayID?: string;
  id?: string;
  mediaProfileID?: string;
  partitionID?: string;
  personID?: string;
  placeID?: string;
  profile?: string;
  readerID?: string;
  sensorID?: string;
  serverTime?: string;
  snapshotID?: string;
  startID?: string;
  status?: string;
  time?: string;
  type?: string;
  typeStatusActiveID?: string;
  videoSourceID?: string;
  zoneID?: string;
};

/** aggregate stddev on columns */
export type qx_Event_stddev_fields = {
  __typename?: 'qx_Event_stddev_fields';
  bits?: number;
  doorID?: number;
  id?: number;
  mediaProfileID?: number;
  sensorID?: number;
  startID?: number;
  typeStatusActiveID?: number;
  videoSourceID?: number;
};

/** order by stddev() on columns of table "qx.Event" */
export type qx_Event_stddev_order_by = {
  bits?: order_by;
  doorID?: order_by;
  id?: order_by;
  mediaProfileID?: order_by;
  sensorID?: order_by;
  startID?: order_by;
  typeStatusActiveID?: order_by;
  videoSourceID?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_Event_stddev_pop_fields = {
  __typename?: 'qx_Event_stddev_pop_fields';
  bits?: number;
  doorID?: number;
  id?: number;
  mediaProfileID?: number;
  sensorID?: number;
  startID?: number;
  typeStatusActiveID?: number;
  videoSourceID?: number;
};

/** order by stddev_pop() on columns of table "qx.Event" */
export type qx_Event_stddev_pop_order_by = {
  bits?: order_by;
  doorID?: order_by;
  id?: order_by;
  mediaProfileID?: order_by;
  sensorID?: order_by;
  startID?: order_by;
  typeStatusActiveID?: order_by;
  videoSourceID?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_Event_stddev_samp_fields = {
  __typename?: 'qx_Event_stddev_samp_fields';
  bits?: number;
  doorID?: number;
  id?: number;
  mediaProfileID?: number;
  sensorID?: number;
  startID?: number;
  typeStatusActiveID?: number;
  videoSourceID?: number;
};

/** order by stddev_samp() on columns of table "qx.Event" */
export type qx_Event_stddev_samp_order_by = {
  bits?: order_by;
  doorID?: order_by;
  id?: order_by;
  mediaProfileID?: order_by;
  sensorID?: order_by;
  startID?: order_by;
  typeStatusActiveID?: order_by;
  videoSourceID?: order_by;
};

/** Streaming cursor of the table "qx_Event" */
export type qx_Event_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_Event_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_Event_stream_cursor_value_input = {
  active?: boolean;
  bits?: number;
  card?: string;
  cloudTime?: string;
  deviceDIOID?: string;
  deviceID?: string;
  doorID?: string;
  gatewayID?: string;
  id?: string;
  mediaProfileID?: string;
  partitionID?: string;
  personID?: string;
  placeID?: string;
  profile?: string;
  readerID?: string;
  sensorID?: string;
  serverTime?: string;
  snapshotID?: string;
  startID?: string;
  status?: string;
  time?: string;
  type?: string;
  typeStatusActiveID?: string;
  videoSourceID?: string;
  zoneID?: string;
};

/** aggregate sum on columns */
export type qx_Event_sum_fields = {
  __typename?: 'qx_Event_sum_fields';
  bits?: number;
  doorID?: string;
  id?: string;
  mediaProfileID?: string;
  sensorID?: string;
  startID?: string;
  typeStatusActiveID?: string;
  videoSourceID?: string;
};

/** order by sum() on columns of table "qx.Event" */
export type qx_Event_sum_order_by = {
  bits?: order_by;
  doorID?: order_by;
  id?: order_by;
  mediaProfileID?: order_by;
  sensorID?: order_by;
  startID?: order_by;
  typeStatusActiveID?: order_by;
  videoSourceID?: order_by;
};

/** update columns of table "qx.Event" */
export enum qx_Event_update_column {
  /** column name */
  active = 'active',
  /** column name */
  bits = 'bits',
  /** column name */
  card = 'card',
  /** column name */
  cloudTime = 'cloudTime',
  /** column name */
  deviceDIOID = 'deviceDIOID',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  doorID = 'doorID',
  /** column name */
  gatewayID = 'gatewayID',
  /** column name */
  id = 'id',
  /** column name */
  mediaProfileID = 'mediaProfileID',
  /** column name */
  partitionID = 'partitionID',
  /** column name */
  personID = 'personID',
  /** column name */
  placeID = 'placeID',
  /** column name */
  profile = 'profile',
  /** column name */
  readerID = 'readerID',
  /** column name */
  sensorID = 'sensorID',
  /** column name */
  serverTime = 'serverTime',
  /** column name */
  snapshotID = 'snapshotID',
  /** column name */
  startID = 'startID',
  /** column name */
  status = 'status',
  /** column name */
  time = 'time',
  /** column name */
  type = 'type',
  /** column name */
  typeStatusActiveID = 'typeStatusActiveID',
  /** column name */
  videoSourceID = 'videoSourceID',
  /** column name */
  zoneID = 'zoneID'
}

export type qx_Event_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_Event_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_Event_set_input;
  /** filter the rows which have to be updated */
  where: qx_Event_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_Event_var_pop_fields = {
  __typename?: 'qx_Event_var_pop_fields';
  bits?: number;
  doorID?: number;
  id?: number;
  mediaProfileID?: number;
  sensorID?: number;
  startID?: number;
  typeStatusActiveID?: number;
  videoSourceID?: number;
};

/** order by var_pop() on columns of table "qx.Event" */
export type qx_Event_var_pop_order_by = {
  bits?: order_by;
  doorID?: order_by;
  id?: order_by;
  mediaProfileID?: order_by;
  sensorID?: order_by;
  startID?: order_by;
  typeStatusActiveID?: order_by;
  videoSourceID?: order_by;
};

/** aggregate var_samp on columns */
export type qx_Event_var_samp_fields = {
  __typename?: 'qx_Event_var_samp_fields';
  bits?: number;
  doorID?: number;
  id?: number;
  mediaProfileID?: number;
  sensorID?: number;
  startID?: number;
  typeStatusActiveID?: number;
  videoSourceID?: number;
};

/** order by var_samp() on columns of table "qx.Event" */
export type qx_Event_var_samp_order_by = {
  bits?: order_by;
  doorID?: order_by;
  id?: order_by;
  mediaProfileID?: order_by;
  sensorID?: order_by;
  startID?: order_by;
  typeStatusActiveID?: order_by;
  videoSourceID?: order_by;
};

/** aggregate variance on columns */
export type qx_Event_variance_fields = {
  __typename?: 'qx_Event_variance_fields';
  bits?: number;
  doorID?: number;
  id?: number;
  mediaProfileID?: number;
  sensorID?: number;
  startID?: number;
  typeStatusActiveID?: number;
  videoSourceID?: number;
};

/** order by variance() on columns of table "qx.Event" */
export type qx_Event_variance_order_by = {
  bits?: order_by;
  doorID?: order_by;
  id?: order_by;
  mediaProfileID?: order_by;
  sensorID?: order_by;
  startID?: order_by;
  typeStatusActiveID?: order_by;
  videoSourceID?: order_by;
};

/** automated rule or workflow that triggers actions (notifications, door commands, output activations) in response to system events */
export type qx_Flow = {
  __typename?: 'qx_Flow';
  /** A computed field, executes function "qx.check_can_flow_run_on_gateway" */
  canRunOnGateway?: boolean;
  createdAt: string;
  deletedAt?: string;
  description?: string;
  /** An object relationship */
  eFlowStatus: qx_eFlowStatus;
  enabled?: boolean;
  flow?: any;
  id: string;
  name: string;
  /** An object relationship */
  place: qx_Place;
  placeID: string;
  /** An object relationship */
  schedule?: qx_Schedule;
  scheduleID?: string;
  searchText?: string;
  status: qx_eFlowStatus_enum;
  /** An array relationship */
  traces: Array<qx_FlowTrace>;
  /** An aggregate relationship */
  traces_aggregate: qx_FlowTrace_aggregate;
  updatedAt?: string;
};


/** automated rule or workflow that triggers actions (notifications, door commands, output activations) in response to system events */
export type qx_FlowflowArgs = {
  path?: string;
};


/** automated rule or workflow that triggers actions (notifications, door commands, output activations) in response to system events */
export type qx_FlowtracesArgs = {
  distinct_on?: Array<qx_FlowTrace_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_FlowTrace_order_by>;
  where?: qx_FlowTrace_bool_exp;
};


/** automated rule or workflow that triggers actions (notifications, door commands, output activations) in response to system events */
export type qx_Flowtraces_aggregateArgs = {
  distinct_on?: Array<qx_FlowTrace_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_FlowTrace_order_by>;
  where?: qx_FlowTrace_bool_exp;
};

/** execution log for a single triggered run of a Flow, recording each action step and its outcome */
export type qx_FlowTrace = {
  __typename?: 'qx_FlowTrace';
  createdAt: string;
  error?: string;
  finishedAt?: string;
  /** An object relationship */
  flow: qx_Flow;
  flowID: string;
  id: string;
  state?: qx_eFlowTraceState_enum;
  trace?: any;
  triggerData?: any;
  triggeredType: string;
};


/** execution log for a single triggered run of a Flow, recording each action step and its outcome */
export type qx_FlowTracetraceArgs = {
  path?: string;
};


/** execution log for a single triggered run of a Flow, recording each action step and its outcome */
export type qx_FlowTracetriggerDataArgs = {
  path?: string;
};

/** aggregated selection of "qx.FlowTrace" */
export type qx_FlowTrace_aggregate = {
  __typename?: 'qx_FlowTrace_aggregate';
  aggregate?: qx_FlowTrace_aggregate_fields;
  nodes: Array<qx_FlowTrace>;
};

export type qx_FlowTrace_aggregate_bool_exp = {
  count?: qx_FlowTrace_aggregate_bool_exp_count;
};

export type qx_FlowTrace_aggregate_bool_exp_count = {
  arguments?: Array<qx_FlowTrace_select_column>;
  distinct?: boolean;
  filter?: qx_FlowTrace_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.FlowTrace" */
export type qx_FlowTrace_aggregate_fields = {
  __typename?: 'qx_FlowTrace_aggregate_fields';
  avg?: qx_FlowTrace_avg_fields;
  count: number;
  max?: qx_FlowTrace_max_fields;
  min?: qx_FlowTrace_min_fields;
  stddev?: qx_FlowTrace_stddev_fields;
  stddev_pop?: qx_FlowTrace_stddev_pop_fields;
  stddev_samp?: qx_FlowTrace_stddev_samp_fields;
  sum?: qx_FlowTrace_sum_fields;
  var_pop?: qx_FlowTrace_var_pop_fields;
  var_samp?: qx_FlowTrace_var_samp_fields;
  variance?: qx_FlowTrace_variance_fields;
};


/** aggregate fields of "qx.FlowTrace" */
export type qx_FlowTrace_aggregate_fieldscountArgs = {
  columns?: Array<qx_FlowTrace_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.FlowTrace" */
export type qx_FlowTrace_aggregate_order_by = {
  avg?: qx_FlowTrace_avg_order_by;
  count?: order_by;
  max?: qx_FlowTrace_max_order_by;
  min?: qx_FlowTrace_min_order_by;
  stddev?: qx_FlowTrace_stddev_order_by;
  stddev_pop?: qx_FlowTrace_stddev_pop_order_by;
  stddev_samp?: qx_FlowTrace_stddev_samp_order_by;
  sum?: qx_FlowTrace_sum_order_by;
  var_pop?: qx_FlowTrace_var_pop_order_by;
  var_samp?: qx_FlowTrace_var_samp_order_by;
  variance?: qx_FlowTrace_variance_order_by;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type qx_FlowTrace_append_input = {
  trace?: any;
  triggerData?: any;
};

/** input type for inserting array relation for remote table "qx.FlowTrace" */
export type qx_FlowTrace_arr_rel_insert_input = {
  data: Array<qx_FlowTrace_insert_input>;
  /** upsert condition */
  on_conflict?: qx_FlowTrace_on_conflict;
};

/** aggregate avg on columns */
export type qx_FlowTrace_avg_fields = {
  __typename?: 'qx_FlowTrace_avg_fields';
  flowID?: number;
  id?: number;
};

/** order by avg() on columns of table "qx.FlowTrace" */
export type qx_FlowTrace_avg_order_by = {
  flowID?: order_by;
  id?: order_by;
};

/** Boolean expression to filter rows from the table "qx.FlowTrace". All fields are combined with a logical 'AND'. */
export type qx_FlowTrace_bool_exp = {
  _and?: Array<qx_FlowTrace_bool_exp>;
  _not?: qx_FlowTrace_bool_exp;
  _or?: Array<qx_FlowTrace_bool_exp>;
  createdAt?: timestamptz_comparison_exp;
  error?: String_comparison_exp;
  finishedAt?: timestamptz_comparison_exp;
  flow?: qx_Flow_bool_exp;
  flowID?: bigint_comparison_exp;
  id?: bigint_comparison_exp;
  state?: qx_eFlowTraceState_enum_comparison_exp;
  trace?: jsonb_comparison_exp;
  triggerData?: jsonb_comparison_exp;
  triggeredType?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.FlowTrace" */
export enum qx_FlowTrace_constraint {
  /** unique or primary key constraint on columns "id" */
  FlowTrace_pkey = 'FlowTrace_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type qx_FlowTrace_delete_at_path_input = {
  trace?: Array<string>;
  triggerData?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type qx_FlowTrace_delete_elem_input = {
  trace?: number;
  triggerData?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type qx_FlowTrace_delete_key_input = {
  trace?: string;
  triggerData?: string;
};

/** input type for incrementing numeric columns in table "qx.FlowTrace" */
export type qx_FlowTrace_inc_input = {
  flowID?: string;
  id?: string;
};

/** input type for inserting data into table "qx.FlowTrace" */
export type qx_FlowTrace_insert_input = {
  createdAt?: string;
  error?: string;
  finishedAt?: string;
  flow?: qx_Flow_obj_rel_insert_input;
  flowID?: string;
  id?: string;
  state?: qx_eFlowTraceState_enum;
  trace?: any;
  triggerData?: any;
  triggeredType?: string;
};

/** aggregate max on columns */
export type qx_FlowTrace_max_fields = {
  __typename?: 'qx_FlowTrace_max_fields';
  createdAt?: string;
  error?: string;
  finishedAt?: string;
  flowID?: string;
  id?: string;
  triggeredType?: string;
};

/** order by max() on columns of table "qx.FlowTrace" */
export type qx_FlowTrace_max_order_by = {
  createdAt?: order_by;
  error?: order_by;
  finishedAt?: order_by;
  flowID?: order_by;
  id?: order_by;
  triggeredType?: order_by;
};

/** aggregate min on columns */
export type qx_FlowTrace_min_fields = {
  __typename?: 'qx_FlowTrace_min_fields';
  createdAt?: string;
  error?: string;
  finishedAt?: string;
  flowID?: string;
  id?: string;
  triggeredType?: string;
};

/** order by min() on columns of table "qx.FlowTrace" */
export type qx_FlowTrace_min_order_by = {
  createdAt?: order_by;
  error?: order_by;
  finishedAt?: order_by;
  flowID?: order_by;
  id?: order_by;
  triggeredType?: order_by;
};

/** response of any mutation on the table "qx.FlowTrace" */
export type qx_FlowTrace_mutation_response = {
  __typename?: 'qx_FlowTrace_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_FlowTrace>;
};

/** on_conflict condition type for table "qx.FlowTrace" */
export type qx_FlowTrace_on_conflict = {
  constraint: qx_FlowTrace_constraint;
  update_columns?: Array<qx_FlowTrace_update_column>;
  where?: qx_FlowTrace_bool_exp;
};

/** Ordering options when selecting data from "qx.FlowTrace". */
export type qx_FlowTrace_order_by = {
  createdAt?: order_by;
  error?: order_by;
  finishedAt?: order_by;
  flow?: qx_Flow_order_by;
  flowID?: order_by;
  id?: order_by;
  state?: order_by;
  trace?: order_by;
  triggerData?: order_by;
  triggeredType?: order_by;
};

/** primary key columns input for table: qx.FlowTrace */
export type qx_FlowTrace_pk_columns_input = {
  id: string;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type qx_FlowTrace_prepend_input = {
  trace?: any;
  triggerData?: any;
};

/** select columns of table "qx.FlowTrace" */
export enum qx_FlowTrace_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  error = 'error',
  /** column name */
  finishedAt = 'finishedAt',
  /** column name */
  flowID = 'flowID',
  /** column name */
  id = 'id',
  /** column name */
  state = 'state',
  /** column name */
  trace = 'trace',
  /** column name */
  triggerData = 'triggerData',
  /** column name */
  triggeredType = 'triggeredType'
}

/** input type for updating data in table "qx.FlowTrace" */
export type qx_FlowTrace_set_input = {
  createdAt?: string;
  error?: string;
  finishedAt?: string;
  flowID?: string;
  id?: string;
  state?: qx_eFlowTraceState_enum;
  trace?: any;
  triggerData?: any;
  triggeredType?: string;
};

/** aggregate stddev on columns */
export type qx_FlowTrace_stddev_fields = {
  __typename?: 'qx_FlowTrace_stddev_fields';
  flowID?: number;
  id?: number;
};

/** order by stddev() on columns of table "qx.FlowTrace" */
export type qx_FlowTrace_stddev_order_by = {
  flowID?: order_by;
  id?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_FlowTrace_stddev_pop_fields = {
  __typename?: 'qx_FlowTrace_stddev_pop_fields';
  flowID?: number;
  id?: number;
};

/** order by stddev_pop() on columns of table "qx.FlowTrace" */
export type qx_FlowTrace_stddev_pop_order_by = {
  flowID?: order_by;
  id?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_FlowTrace_stddev_samp_fields = {
  __typename?: 'qx_FlowTrace_stddev_samp_fields';
  flowID?: number;
  id?: number;
};

/** order by stddev_samp() on columns of table "qx.FlowTrace" */
export type qx_FlowTrace_stddev_samp_order_by = {
  flowID?: order_by;
  id?: order_by;
};

/** Streaming cursor of the table "qx_FlowTrace" */
export type qx_FlowTrace_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_FlowTrace_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_FlowTrace_stream_cursor_value_input = {
  createdAt?: string;
  error?: string;
  finishedAt?: string;
  flowID?: string;
  id?: string;
  state?: qx_eFlowTraceState_enum;
  trace?: any;
  triggerData?: any;
  triggeredType?: string;
};

/** aggregate sum on columns */
export type qx_FlowTrace_sum_fields = {
  __typename?: 'qx_FlowTrace_sum_fields';
  flowID?: string;
  id?: string;
};

/** order by sum() on columns of table "qx.FlowTrace" */
export type qx_FlowTrace_sum_order_by = {
  flowID?: order_by;
  id?: order_by;
};

/** update columns of table "qx.FlowTrace" */
export enum qx_FlowTrace_update_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  error = 'error',
  /** column name */
  finishedAt = 'finishedAt',
  /** column name */
  flowID = 'flowID',
  /** column name */
  id = 'id',
  /** column name */
  state = 'state',
  /** column name */
  trace = 'trace',
  /** column name */
  triggerData = 'triggerData',
  /** column name */
  triggeredType = 'triggeredType'
}

export type qx_FlowTrace_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: qx_FlowTrace_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: qx_FlowTrace_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: qx_FlowTrace_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: qx_FlowTrace_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_FlowTrace_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: qx_FlowTrace_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_FlowTrace_set_input;
  /** filter the rows which have to be updated */
  where: qx_FlowTrace_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_FlowTrace_var_pop_fields = {
  __typename?: 'qx_FlowTrace_var_pop_fields';
  flowID?: number;
  id?: number;
};

/** order by var_pop() on columns of table "qx.FlowTrace" */
export type qx_FlowTrace_var_pop_order_by = {
  flowID?: order_by;
  id?: order_by;
};

/** aggregate var_samp on columns */
export type qx_FlowTrace_var_samp_fields = {
  __typename?: 'qx_FlowTrace_var_samp_fields';
  flowID?: number;
  id?: number;
};

/** order by var_samp() on columns of table "qx.FlowTrace" */
export type qx_FlowTrace_var_samp_order_by = {
  flowID?: order_by;
  id?: order_by;
};

/** aggregate variance on columns */
export type qx_FlowTrace_variance_fields = {
  __typename?: 'qx_FlowTrace_variance_fields';
  flowID?: number;
  id?: number;
};

/** order by variance() on columns of table "qx.FlowTrace" */
export type qx_FlowTrace_variance_order_by = {
  flowID?: order_by;
  id?: order_by;
};

/** aggregated selection of "qx.Flow" */
export type qx_Flow_aggregate = {
  __typename?: 'qx_Flow_aggregate';
  aggregate?: qx_Flow_aggregate_fields;
  nodes: Array<qx_Flow>;
};

export type qx_Flow_aggregate_bool_exp = {
  bool_and?: qx_Flow_aggregate_bool_exp_bool_and;
  bool_or?: qx_Flow_aggregate_bool_exp_bool_or;
  count?: qx_Flow_aggregate_bool_exp_count;
};

export type qx_Flow_aggregate_bool_exp_bool_and = {
  arguments: qx_Flow_select_column_qx_Flow_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: qx_Flow_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_Flow_aggregate_bool_exp_bool_or = {
  arguments: qx_Flow_select_column_qx_Flow_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: qx_Flow_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_Flow_aggregate_bool_exp_count = {
  arguments?: Array<qx_Flow_select_column>;
  distinct?: boolean;
  filter?: qx_Flow_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.Flow" */
export type qx_Flow_aggregate_fields = {
  __typename?: 'qx_Flow_aggregate_fields';
  avg?: qx_Flow_avg_fields;
  count: number;
  max?: qx_Flow_max_fields;
  min?: qx_Flow_min_fields;
  stddev?: qx_Flow_stddev_fields;
  stddev_pop?: qx_Flow_stddev_pop_fields;
  stddev_samp?: qx_Flow_stddev_samp_fields;
  sum?: qx_Flow_sum_fields;
  var_pop?: qx_Flow_var_pop_fields;
  var_samp?: qx_Flow_var_samp_fields;
  variance?: qx_Flow_variance_fields;
};


/** aggregate fields of "qx.Flow" */
export type qx_Flow_aggregate_fieldscountArgs = {
  columns?: Array<qx_Flow_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.Flow" */
export type qx_Flow_aggregate_order_by = {
  avg?: qx_Flow_avg_order_by;
  count?: order_by;
  max?: qx_Flow_max_order_by;
  min?: qx_Flow_min_order_by;
  stddev?: qx_Flow_stddev_order_by;
  stddev_pop?: qx_Flow_stddev_pop_order_by;
  stddev_samp?: qx_Flow_stddev_samp_order_by;
  sum?: qx_Flow_sum_order_by;
  var_pop?: qx_Flow_var_pop_order_by;
  var_samp?: qx_Flow_var_samp_order_by;
  variance?: qx_Flow_variance_order_by;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type qx_Flow_append_input = {
  flow?: any;
};

/** input type for inserting array relation for remote table "qx.Flow" */
export type qx_Flow_arr_rel_insert_input = {
  data: Array<qx_Flow_insert_input>;
  /** upsert condition */
  on_conflict?: qx_Flow_on_conflict;
};

/** aggregate avg on columns */
export type qx_Flow_avg_fields = {
  __typename?: 'qx_Flow_avg_fields';
  id?: number;
};

/** order by avg() on columns of table "qx.Flow" */
export type qx_Flow_avg_order_by = {
  id?: order_by;
};

/** Boolean expression to filter rows from the table "qx.Flow". All fields are combined with a logical 'AND'. */
export type qx_Flow_bool_exp = {
  _and?: Array<qx_Flow_bool_exp>;
  _not?: qx_Flow_bool_exp;
  _or?: Array<qx_Flow_bool_exp>;
  canRunOnGateway?: Boolean_comparison_exp;
  createdAt?: timestamptz_comparison_exp;
  deletedAt?: timestamptz_comparison_exp;
  description?: String_comparison_exp;
  eFlowStatus?: qx_eFlowStatus_bool_exp;
  enabled?: Boolean_comparison_exp;
  flow?: jsonb_comparison_exp;
  id?: bigint_comparison_exp;
  name?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
  schedule?: qx_Schedule_bool_exp;
  scheduleID?: String_comparison_exp;
  searchText?: String_comparison_exp;
  status?: qx_eFlowStatus_enum_comparison_exp;
  traces?: qx_FlowTrace_bool_exp;
  traces_aggregate?: qx_FlowTrace_aggregate_bool_exp;
  updatedAt?: timestamptz_comparison_exp;
};

/** unique or primary key constraints on table "qx.Flow" */
export enum qx_Flow_constraint {
  /** unique or primary key constraint on columns "id" */
  Flow_pkey = 'Flow_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type qx_Flow_delete_at_path_input = {
  flow?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type qx_Flow_delete_elem_input = {
  flow?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type qx_Flow_delete_key_input = {
  flow?: string;
};

/** input type for incrementing numeric columns in table "qx.Flow" */
export type qx_Flow_inc_input = {
  id?: string;
};

/** input type for inserting data into table "qx.Flow" */
export type qx_Flow_insert_input = {
  createdAt?: string;
  deletedAt?: string;
  description?: string;
  eFlowStatus?: qx_eFlowStatus_obj_rel_insert_input;
  enabled?: boolean;
  flow?: any;
  id?: string;
  name?: string;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
  schedule?: qx_Schedule_obj_rel_insert_input;
  scheduleID?: string;
  searchText?: string;
  status?: qx_eFlowStatus_enum;
  traces?: qx_FlowTrace_arr_rel_insert_input;
  updatedAt?: string;
};

/** aggregate max on columns */
export type qx_Flow_max_fields = {
  __typename?: 'qx_Flow_max_fields';
  createdAt?: string;
  deletedAt?: string;
  description?: string;
  id?: string;
  name?: string;
  placeID?: string;
  scheduleID?: string;
  searchText?: string;
  updatedAt?: string;
};

/** order by max() on columns of table "qx.Flow" */
export type qx_Flow_max_order_by = {
  createdAt?: order_by;
  deletedAt?: order_by;
  description?: order_by;
  id?: order_by;
  name?: order_by;
  placeID?: order_by;
  scheduleID?: order_by;
  searchText?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type qx_Flow_min_fields = {
  __typename?: 'qx_Flow_min_fields';
  createdAt?: string;
  deletedAt?: string;
  description?: string;
  id?: string;
  name?: string;
  placeID?: string;
  scheduleID?: string;
  searchText?: string;
  updatedAt?: string;
};

/** order by min() on columns of table "qx.Flow" */
export type qx_Flow_min_order_by = {
  createdAt?: order_by;
  deletedAt?: order_by;
  description?: order_by;
  id?: order_by;
  name?: order_by;
  placeID?: order_by;
  scheduleID?: order_by;
  searchText?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.Flow" */
export type qx_Flow_mutation_response = {
  __typename?: 'qx_Flow_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_Flow>;
};

/** input type for inserting object relation for remote table "qx.Flow" */
export type qx_Flow_obj_rel_insert_input = {
  data: qx_Flow_insert_input;
  /** upsert condition */
  on_conflict?: qx_Flow_on_conflict;
};

/** on_conflict condition type for table "qx.Flow" */
export type qx_Flow_on_conflict = {
  constraint: qx_Flow_constraint;
  update_columns?: Array<qx_Flow_update_column>;
  where?: qx_Flow_bool_exp;
};

/** Ordering options when selecting data from "qx.Flow". */
export type qx_Flow_order_by = {
  canRunOnGateway?: order_by;
  createdAt?: order_by;
  deletedAt?: order_by;
  description?: order_by;
  eFlowStatus?: qx_eFlowStatus_order_by;
  enabled?: order_by;
  flow?: order_by;
  id?: order_by;
  name?: order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
  schedule?: qx_Schedule_order_by;
  scheduleID?: order_by;
  searchText?: order_by;
  status?: order_by;
  traces_aggregate?: qx_FlowTrace_aggregate_order_by;
  updatedAt?: order_by;
};

/** primary key columns input for table: qx.Flow */
export type qx_Flow_pk_columns_input = {
  id: string;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type qx_Flow_prepend_input = {
  flow?: any;
};

/** select columns of table "qx.Flow" */
export enum qx_Flow_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  deletedAt = 'deletedAt',
  /** column name */
  description = 'description',
  /** column name */
  enabled = 'enabled',
  /** column name */
  flow = 'flow',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  scheduleID = 'scheduleID',
  /** column name */
  searchText = 'searchText',
  /** column name */
  status = 'status',
  /** column name */
  updatedAt = 'updatedAt'
}

/** select "qx_Flow_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.Flow" */
export enum qx_Flow_select_column_qx_Flow_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  enabled = 'enabled'
}

/** select "qx_Flow_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.Flow" */
export enum qx_Flow_select_column_qx_Flow_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  enabled = 'enabled'
}

/** input type for updating data in table "qx.Flow" */
export type qx_Flow_set_input = {
  createdAt?: string;
  deletedAt?: string;
  description?: string;
  enabled?: boolean;
  flow?: any;
  id?: string;
  name?: string;
  placeID?: string;
  scheduleID?: string;
  searchText?: string;
  status?: qx_eFlowStatus_enum;
  updatedAt?: string;
};

/** aggregate stddev on columns */
export type qx_Flow_stddev_fields = {
  __typename?: 'qx_Flow_stddev_fields';
  id?: number;
};

/** order by stddev() on columns of table "qx.Flow" */
export type qx_Flow_stddev_order_by = {
  id?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_Flow_stddev_pop_fields = {
  __typename?: 'qx_Flow_stddev_pop_fields';
  id?: number;
};

/** order by stddev_pop() on columns of table "qx.Flow" */
export type qx_Flow_stddev_pop_order_by = {
  id?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_Flow_stddev_samp_fields = {
  __typename?: 'qx_Flow_stddev_samp_fields';
  id?: number;
};

/** order by stddev_samp() on columns of table "qx.Flow" */
export type qx_Flow_stddev_samp_order_by = {
  id?: order_by;
};

/** Streaming cursor of the table "qx_Flow" */
export type qx_Flow_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_Flow_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_Flow_stream_cursor_value_input = {
  createdAt?: string;
  deletedAt?: string;
  description?: string;
  enabled?: boolean;
  flow?: any;
  id?: string;
  name?: string;
  placeID?: string;
  scheduleID?: string;
  searchText?: string;
  status?: qx_eFlowStatus_enum;
  updatedAt?: string;
};

/** aggregate sum on columns */
export type qx_Flow_sum_fields = {
  __typename?: 'qx_Flow_sum_fields';
  id?: string;
};

/** order by sum() on columns of table "qx.Flow" */
export type qx_Flow_sum_order_by = {
  id?: order_by;
};

/** update columns of table "qx.Flow" */
export enum qx_Flow_update_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  deletedAt = 'deletedAt',
  /** column name */
  description = 'description',
  /** column name */
  enabled = 'enabled',
  /** column name */
  flow = 'flow',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  scheduleID = 'scheduleID',
  /** column name */
  searchText = 'searchText',
  /** column name */
  status = 'status',
  /** column name */
  updatedAt = 'updatedAt'
}

export type qx_Flow_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: qx_Flow_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: qx_Flow_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: qx_Flow_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: qx_Flow_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_Flow_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: qx_Flow_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_Flow_set_input;
  /** filter the rows which have to be updated */
  where: qx_Flow_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_Flow_var_pop_fields = {
  __typename?: 'qx_Flow_var_pop_fields';
  id?: number;
};

/** order by var_pop() on columns of table "qx.Flow" */
export type qx_Flow_var_pop_order_by = {
  id?: order_by;
};

/** aggregate var_samp on columns */
export type qx_Flow_var_samp_fields = {
  __typename?: 'qx_Flow_var_samp_fields';
  id?: number;
};

/** order by var_samp() on columns of table "qx.Flow" */
export type qx_Flow_var_samp_order_by = {
  id?: order_by;
};

/** aggregate variance on columns */
export type qx_Flow_variance_fields = {
  __typename?: 'qx_Flow_variance_fields';
  id?: number;
};

/** order by variance() on columns of table "qx.Flow" */
export type qx_Flow_variance_order_by = {
  id?: order_by;
};

/** edge hardware unit that connects access control and video devices at a site to the cloud */
export type qx_Gateway = {
  __typename?: 'qx_Gateway';
  /** An array relationship */
  bandwidthSchedules: Array<qx_GatewayBandwidthSchedule>;
  /** An aggregate relationship */
  bandwidthSchedules_aggregate: qx_GatewayBandwidthSchedule_aggregate;
  cockpitUrl?: string;
  connectionStatus: boolean;
  createdAt: string;
  description?: string;
  /** An array relationship */
  devices: Array<qx_Device>;
  /** An aggregate relationship */
  devices_aggregate: qx_Device_aggregate;
  disks?: any;
  /** An object relationship */
  eGatewaySyncStatus: qx_eGatewaySyncStatus;
  features: any;
  firmware?: string;
  gatewayDrives?: Array<number>;
  gatewayStorageDays?: number;
  hostname?: string;
  id: string;
  lanIP?: string;
  /** A computed field, executes function "qx.license_details" */
  licenseDetails?: any;
  /** A computed field, executes function "qx.license_expiration" */
  licenseExpiration?: string;
  licenseJWT?: string;
  macAddresses?: any;
  model?: string;
  name: string;
  nics?: any;
  oldestMedia?: string;
  ossSiteID?: number;
  /** An object relationship */
  place: qx_Place;
  placeID: string;
  searchText?: string;
  sequence?: string;
  serial?: string;
  services?: any;
  syncError?: string;
  syncStatus: qx_eGatewaySyncStatus_enum;
  thumbnail?: string;
  thumbnail_lg?: string;
  thumbnail_md?: string;
  thumbnail_sm?: string;
  thumbnail_xl?: string;
  /** A computed field, executes function "qx.gateway_timezone" */
  timezone?: string;
  type: eGatewayType_enum;
  updatedAt?: string;
  uploadDepth?: number;
  version?: string;
  wireguardIP?: string;
  wireguardUUID?: string;
};


/** edge hardware unit that connects access control and video devices at a site to the cloud */
export type qx_GatewaybandwidthSchedulesArgs = {
  distinct_on?: Array<qx_GatewayBandwidthSchedule_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_GatewayBandwidthSchedule_order_by>;
  where?: qx_GatewayBandwidthSchedule_bool_exp;
};


/** edge hardware unit that connects access control and video devices at a site to the cloud */
export type qx_GatewaybandwidthSchedules_aggregateArgs = {
  distinct_on?: Array<qx_GatewayBandwidthSchedule_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_GatewayBandwidthSchedule_order_by>;
  where?: qx_GatewayBandwidthSchedule_bool_exp;
};


/** edge hardware unit that connects access control and video devices at a site to the cloud */
export type qx_GatewaydevicesArgs = {
  distinct_on?: Array<qx_Device_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Device_order_by>;
  where?: qx_Device_bool_exp;
};


/** edge hardware unit that connects access control and video devices at a site to the cloud */
export type qx_Gatewaydevices_aggregateArgs = {
  distinct_on?: Array<qx_Device_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Device_order_by>;
  where?: qx_Device_bool_exp;
};


/** edge hardware unit that connects access control and video devices at a site to the cloud */
export type qx_GatewaydisksArgs = {
  path?: string;
};


/** edge hardware unit that connects access control and video devices at a site to the cloud */
export type qx_GatewayfeaturesArgs = {
  path?: string;
};


/** edge hardware unit that connects access control and video devices at a site to the cloud */
export type qx_GatewaylicenseDetailsArgs = {
  path?: string;
};


/** edge hardware unit that connects access control and video devices at a site to the cloud */
export type qx_GatewaymacAddressesArgs = {
  path?: string;
};


/** edge hardware unit that connects access control and video devices at a site to the cloud */
export type qx_GatewaynicsArgs = {
  path?: string;
};


/** edge hardware unit that connects access control and video devices at a site to the cloud */
export type qx_GatewayservicesArgs = {
  path?: string;
};

/** time-based bandwidth cap applied to a gateway, limiting upload/download speed during specified schedule windows */
export type qx_GatewayBandwidthSchedule = {
  __typename?: 'qx_GatewayBandwidthSchedule';
  active: boolean;
  enabled: boolean;
  /** An object relationship */
  gateway: qx_Gateway;
  gatewayID: string;
  id: string;
  limitMbps: number;
  /** An object relationship */
  schedule: qx_Schedule;
  scheduleID: string;
};

/** aggregated selection of "qx.GatewayBandwidthSchedule" */
export type qx_GatewayBandwidthSchedule_aggregate = {
  __typename?: 'qx_GatewayBandwidthSchedule_aggregate';
  aggregate?: qx_GatewayBandwidthSchedule_aggregate_fields;
  nodes: Array<qx_GatewayBandwidthSchedule>;
};

export type qx_GatewayBandwidthSchedule_aggregate_bool_exp = {
  bool_and?: qx_GatewayBandwidthSchedule_aggregate_bool_exp_bool_and;
  bool_or?: qx_GatewayBandwidthSchedule_aggregate_bool_exp_bool_or;
  count?: qx_GatewayBandwidthSchedule_aggregate_bool_exp_count;
};

export type qx_GatewayBandwidthSchedule_aggregate_bool_exp_bool_and = {
  arguments: qx_GatewayBandwidthSchedule_select_column_qx_GatewayBandwidthSchedule_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: qx_GatewayBandwidthSchedule_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_GatewayBandwidthSchedule_aggregate_bool_exp_bool_or = {
  arguments: qx_GatewayBandwidthSchedule_select_column_qx_GatewayBandwidthSchedule_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: qx_GatewayBandwidthSchedule_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_GatewayBandwidthSchedule_aggregate_bool_exp_count = {
  arguments?: Array<qx_GatewayBandwidthSchedule_select_column>;
  distinct?: boolean;
  filter?: qx_GatewayBandwidthSchedule_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.GatewayBandwidthSchedule" */
export type qx_GatewayBandwidthSchedule_aggregate_fields = {
  __typename?: 'qx_GatewayBandwidthSchedule_aggregate_fields';
  avg?: qx_GatewayBandwidthSchedule_avg_fields;
  count: number;
  max?: qx_GatewayBandwidthSchedule_max_fields;
  min?: qx_GatewayBandwidthSchedule_min_fields;
  stddev?: qx_GatewayBandwidthSchedule_stddev_fields;
  stddev_pop?: qx_GatewayBandwidthSchedule_stddev_pop_fields;
  stddev_samp?: qx_GatewayBandwidthSchedule_stddev_samp_fields;
  sum?: qx_GatewayBandwidthSchedule_sum_fields;
  var_pop?: qx_GatewayBandwidthSchedule_var_pop_fields;
  var_samp?: qx_GatewayBandwidthSchedule_var_samp_fields;
  variance?: qx_GatewayBandwidthSchedule_variance_fields;
};


/** aggregate fields of "qx.GatewayBandwidthSchedule" */
export type qx_GatewayBandwidthSchedule_aggregate_fieldscountArgs = {
  columns?: Array<qx_GatewayBandwidthSchedule_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.GatewayBandwidthSchedule" */
export type qx_GatewayBandwidthSchedule_aggregate_order_by = {
  avg?: qx_GatewayBandwidthSchedule_avg_order_by;
  count?: order_by;
  max?: qx_GatewayBandwidthSchedule_max_order_by;
  min?: qx_GatewayBandwidthSchedule_min_order_by;
  stddev?: qx_GatewayBandwidthSchedule_stddev_order_by;
  stddev_pop?: qx_GatewayBandwidthSchedule_stddev_pop_order_by;
  stddev_samp?: qx_GatewayBandwidthSchedule_stddev_samp_order_by;
  sum?: qx_GatewayBandwidthSchedule_sum_order_by;
  var_pop?: qx_GatewayBandwidthSchedule_var_pop_order_by;
  var_samp?: qx_GatewayBandwidthSchedule_var_samp_order_by;
  variance?: qx_GatewayBandwidthSchedule_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.GatewayBandwidthSchedule" */
export type qx_GatewayBandwidthSchedule_arr_rel_insert_input = {
  data: Array<qx_GatewayBandwidthSchedule_insert_input>;
  /** upsert condition */
  on_conflict?: qx_GatewayBandwidthSchedule_on_conflict;
};

/** aggregate avg on columns */
export type qx_GatewayBandwidthSchedule_avg_fields = {
  __typename?: 'qx_GatewayBandwidthSchedule_avg_fields';
  id?: number;
  limitMbps?: number;
};

/** order by avg() on columns of table "qx.GatewayBandwidthSchedule" */
export type qx_GatewayBandwidthSchedule_avg_order_by = {
  id?: order_by;
  limitMbps?: order_by;
};

/** Boolean expression to filter rows from the table "qx.GatewayBandwidthSchedule". All fields are combined with a logical 'AND'. */
export type qx_GatewayBandwidthSchedule_bool_exp = {
  _and?: Array<qx_GatewayBandwidthSchedule_bool_exp>;
  _not?: qx_GatewayBandwidthSchedule_bool_exp;
  _or?: Array<qx_GatewayBandwidthSchedule_bool_exp>;
  active?: Boolean_comparison_exp;
  enabled?: Boolean_comparison_exp;
  gateway?: qx_Gateway_bool_exp;
  gatewayID?: String_comparison_exp;
  id?: bigint_comparison_exp;
  limitMbps?: Int_comparison_exp;
  schedule?: qx_Schedule_bool_exp;
  scheduleID?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.GatewayBandwidthSchedule" */
export enum qx_GatewayBandwidthSchedule_constraint {
  /** unique or primary key constraint on columns "id" */
  GatewayBandwidthSchedule_pk = 'GatewayBandwidthSchedule_pk',
  /** unique or primary key constraint on columns "gatewayID", "scheduleID" */
  unique_schedule_id_gateway_id = 'unique_schedule_id_gateway_id'
}

/** input type for incrementing numeric columns in table "qx.GatewayBandwidthSchedule" */
export type qx_GatewayBandwidthSchedule_inc_input = {
  id?: string;
  limitMbps?: number;
};

/** input type for inserting data into table "qx.GatewayBandwidthSchedule" */
export type qx_GatewayBandwidthSchedule_insert_input = {
  active?: boolean;
  enabled?: boolean;
  gateway?: qx_Gateway_obj_rel_insert_input;
  gatewayID?: string;
  id?: string;
  limitMbps?: number;
  schedule?: qx_Schedule_obj_rel_insert_input;
  scheduleID?: string;
};

/** aggregate max on columns */
export type qx_GatewayBandwidthSchedule_max_fields = {
  __typename?: 'qx_GatewayBandwidthSchedule_max_fields';
  gatewayID?: string;
  id?: string;
  limitMbps?: number;
  scheduleID?: string;
};

/** order by max() on columns of table "qx.GatewayBandwidthSchedule" */
export type qx_GatewayBandwidthSchedule_max_order_by = {
  gatewayID?: order_by;
  id?: order_by;
  limitMbps?: order_by;
  scheduleID?: order_by;
};

/** aggregate min on columns */
export type qx_GatewayBandwidthSchedule_min_fields = {
  __typename?: 'qx_GatewayBandwidthSchedule_min_fields';
  gatewayID?: string;
  id?: string;
  limitMbps?: number;
  scheduleID?: string;
};

/** order by min() on columns of table "qx.GatewayBandwidthSchedule" */
export type qx_GatewayBandwidthSchedule_min_order_by = {
  gatewayID?: order_by;
  id?: order_by;
  limitMbps?: order_by;
  scheduleID?: order_by;
};

/** response of any mutation on the table "qx.GatewayBandwidthSchedule" */
export type qx_GatewayBandwidthSchedule_mutation_response = {
  __typename?: 'qx_GatewayBandwidthSchedule_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_GatewayBandwidthSchedule>;
};

/** on_conflict condition type for table "qx.GatewayBandwidthSchedule" */
export type qx_GatewayBandwidthSchedule_on_conflict = {
  constraint: qx_GatewayBandwidthSchedule_constraint;
  update_columns?: Array<qx_GatewayBandwidthSchedule_update_column>;
  where?: qx_GatewayBandwidthSchedule_bool_exp;
};

/** Ordering options when selecting data from "qx.GatewayBandwidthSchedule". */
export type qx_GatewayBandwidthSchedule_order_by = {
  active?: order_by;
  enabled?: order_by;
  gateway?: qx_Gateway_order_by;
  gatewayID?: order_by;
  id?: order_by;
  limitMbps?: order_by;
  schedule?: qx_Schedule_order_by;
  scheduleID?: order_by;
};

/** primary key columns input for table: qx.GatewayBandwidthSchedule */
export type qx_GatewayBandwidthSchedule_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.GatewayBandwidthSchedule" */
export enum qx_GatewayBandwidthSchedule_select_column {
  /** column name */
  active = 'active',
  /** column name */
  enabled = 'enabled',
  /** column name */
  gatewayID = 'gatewayID',
  /** column name */
  id = 'id',
  /** column name */
  limitMbps = 'limitMbps',
  /** column name */
  scheduleID = 'scheduleID'
}

/** select "qx_GatewayBandwidthSchedule_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.GatewayBandwidthSchedule" */
export enum qx_GatewayBandwidthSchedule_select_column_qx_GatewayBandwidthSchedule_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  active = 'active',
  /** column name */
  enabled = 'enabled'
}

/** select "qx_GatewayBandwidthSchedule_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.GatewayBandwidthSchedule" */
export enum qx_GatewayBandwidthSchedule_select_column_qx_GatewayBandwidthSchedule_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  active = 'active',
  /** column name */
  enabled = 'enabled'
}

/** input type for updating data in table "qx.GatewayBandwidthSchedule" */
export type qx_GatewayBandwidthSchedule_set_input = {
  active?: boolean;
  enabled?: boolean;
  gatewayID?: string;
  id?: string;
  limitMbps?: number;
  scheduleID?: string;
};

/** aggregate stddev on columns */
export type qx_GatewayBandwidthSchedule_stddev_fields = {
  __typename?: 'qx_GatewayBandwidthSchedule_stddev_fields';
  id?: number;
  limitMbps?: number;
};

/** order by stddev() on columns of table "qx.GatewayBandwidthSchedule" */
export type qx_GatewayBandwidthSchedule_stddev_order_by = {
  id?: order_by;
  limitMbps?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_GatewayBandwidthSchedule_stddev_pop_fields = {
  __typename?: 'qx_GatewayBandwidthSchedule_stddev_pop_fields';
  id?: number;
  limitMbps?: number;
};

/** order by stddev_pop() on columns of table "qx.GatewayBandwidthSchedule" */
export type qx_GatewayBandwidthSchedule_stddev_pop_order_by = {
  id?: order_by;
  limitMbps?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_GatewayBandwidthSchedule_stddev_samp_fields = {
  __typename?: 'qx_GatewayBandwidthSchedule_stddev_samp_fields';
  id?: number;
  limitMbps?: number;
};

/** order by stddev_samp() on columns of table "qx.GatewayBandwidthSchedule" */
export type qx_GatewayBandwidthSchedule_stddev_samp_order_by = {
  id?: order_by;
  limitMbps?: order_by;
};

/** Streaming cursor of the table "qx_GatewayBandwidthSchedule" */
export type qx_GatewayBandwidthSchedule_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_GatewayBandwidthSchedule_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_GatewayBandwidthSchedule_stream_cursor_value_input = {
  active?: boolean;
  enabled?: boolean;
  gatewayID?: string;
  id?: string;
  limitMbps?: number;
  scheduleID?: string;
};

/** aggregate sum on columns */
export type qx_GatewayBandwidthSchedule_sum_fields = {
  __typename?: 'qx_GatewayBandwidthSchedule_sum_fields';
  id?: string;
  limitMbps?: number;
};

/** order by sum() on columns of table "qx.GatewayBandwidthSchedule" */
export type qx_GatewayBandwidthSchedule_sum_order_by = {
  id?: order_by;
  limitMbps?: order_by;
};

/** update columns of table "qx.GatewayBandwidthSchedule" */
export enum qx_GatewayBandwidthSchedule_update_column {
  /** column name */
  active = 'active',
  /** column name */
  enabled = 'enabled',
  /** column name */
  gatewayID = 'gatewayID',
  /** column name */
  id = 'id',
  /** column name */
  limitMbps = 'limitMbps',
  /** column name */
  scheduleID = 'scheduleID'
}

export type qx_GatewayBandwidthSchedule_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_GatewayBandwidthSchedule_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_GatewayBandwidthSchedule_set_input;
  /** filter the rows which have to be updated */
  where: qx_GatewayBandwidthSchedule_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_GatewayBandwidthSchedule_var_pop_fields = {
  __typename?: 'qx_GatewayBandwidthSchedule_var_pop_fields';
  id?: number;
  limitMbps?: number;
};

/** order by var_pop() on columns of table "qx.GatewayBandwidthSchedule" */
export type qx_GatewayBandwidthSchedule_var_pop_order_by = {
  id?: order_by;
  limitMbps?: order_by;
};

/** aggregate var_samp on columns */
export type qx_GatewayBandwidthSchedule_var_samp_fields = {
  __typename?: 'qx_GatewayBandwidthSchedule_var_samp_fields';
  id?: number;
  limitMbps?: number;
};

/** order by var_samp() on columns of table "qx.GatewayBandwidthSchedule" */
export type qx_GatewayBandwidthSchedule_var_samp_order_by = {
  id?: order_by;
  limitMbps?: order_by;
};

/** aggregate variance on columns */
export type qx_GatewayBandwidthSchedule_variance_fields = {
  __typename?: 'qx_GatewayBandwidthSchedule_variance_fields';
  id?: number;
  limitMbps?: number;
};

/** order by variance() on columns of table "qx.GatewayBandwidthSchedule" */
export type qx_GatewayBandwidthSchedule_variance_order_by = {
  id?: order_by;
  limitMbps?: order_by;
};

/** aggregated selection of "qx.Gateway" */
export type qx_Gateway_aggregate = {
  __typename?: 'qx_Gateway_aggregate';
  aggregate?: qx_Gateway_aggregate_fields;
  nodes: Array<qx_Gateway>;
};

export type qx_Gateway_aggregate_bool_exp = {
  bool_and?: qx_Gateway_aggregate_bool_exp_bool_and;
  bool_or?: qx_Gateway_aggregate_bool_exp_bool_or;
  count?: qx_Gateway_aggregate_bool_exp_count;
};

export type qx_Gateway_aggregate_bool_exp_bool_and = {
  arguments: qx_Gateway_select_column_qx_Gateway_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: qx_Gateway_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_Gateway_aggregate_bool_exp_bool_or = {
  arguments: qx_Gateway_select_column_qx_Gateway_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: qx_Gateway_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_Gateway_aggregate_bool_exp_count = {
  arguments?: Array<qx_Gateway_select_column>;
  distinct?: boolean;
  filter?: qx_Gateway_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.Gateway" */
export type qx_Gateway_aggregate_fields = {
  __typename?: 'qx_Gateway_aggregate_fields';
  avg?: qx_Gateway_avg_fields;
  count: number;
  max?: qx_Gateway_max_fields;
  min?: qx_Gateway_min_fields;
  stddev?: qx_Gateway_stddev_fields;
  stddev_pop?: qx_Gateway_stddev_pop_fields;
  stddev_samp?: qx_Gateway_stddev_samp_fields;
  sum?: qx_Gateway_sum_fields;
  var_pop?: qx_Gateway_var_pop_fields;
  var_samp?: qx_Gateway_var_samp_fields;
  variance?: qx_Gateway_variance_fields;
};


/** aggregate fields of "qx.Gateway" */
export type qx_Gateway_aggregate_fieldscountArgs = {
  columns?: Array<qx_Gateway_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.Gateway" */
export type qx_Gateway_aggregate_order_by = {
  avg?: qx_Gateway_avg_order_by;
  count?: order_by;
  max?: qx_Gateway_max_order_by;
  min?: qx_Gateway_min_order_by;
  stddev?: qx_Gateway_stddev_order_by;
  stddev_pop?: qx_Gateway_stddev_pop_order_by;
  stddev_samp?: qx_Gateway_stddev_samp_order_by;
  sum?: qx_Gateway_sum_order_by;
  var_pop?: qx_Gateway_var_pop_order_by;
  var_samp?: qx_Gateway_var_samp_order_by;
  variance?: qx_Gateway_variance_order_by;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type qx_Gateway_append_input = {
  disks?: any;
  features?: any;
  macAddresses?: any;
  nics?: any;
  services?: any;
};

/** input type for inserting array relation for remote table "qx.Gateway" */
export type qx_Gateway_arr_rel_insert_input = {
  data: Array<qx_Gateway_insert_input>;
  /** upsert condition */
  on_conflict?: qx_Gateway_on_conflict;
};

/** aggregate avg on columns */
export type qx_Gateway_avg_fields = {
  __typename?: 'qx_Gateway_avg_fields';
  gatewayStorageDays?: number;
  ossSiteID?: number;
  sequence?: number;
  uploadDepth?: number;
};

/** order by avg() on columns of table "qx.Gateway" */
export type qx_Gateway_avg_order_by = {
  gatewayStorageDays?: order_by;
  ossSiteID?: order_by;
  sequence?: order_by;
  uploadDepth?: order_by;
};

/** Boolean expression to filter rows from the table "qx.Gateway". All fields are combined with a logical 'AND'. */
export type qx_Gateway_bool_exp = {
  _and?: Array<qx_Gateway_bool_exp>;
  _not?: qx_Gateway_bool_exp;
  _or?: Array<qx_Gateway_bool_exp>;
  bandwidthSchedules?: qx_GatewayBandwidthSchedule_bool_exp;
  bandwidthSchedules_aggregate?: qx_GatewayBandwidthSchedule_aggregate_bool_exp;
  cockpitUrl?: String_comparison_exp;
  connectionStatus?: Boolean_comparison_exp;
  createdAt?: timestamptz_comparison_exp;
  description?: String_comparison_exp;
  devices?: qx_Device_bool_exp;
  devices_aggregate?: qx_Device_aggregate_bool_exp;
  disks?: jsonb_comparison_exp;
  eGatewaySyncStatus?: qx_eGatewaySyncStatus_bool_exp;
  features?: jsonb_comparison_exp;
  firmware?: String_comparison_exp;
  gatewayDrives?: Int_array_comparison_exp;
  gatewayStorageDays?: Int_comparison_exp;
  hostname?: String_comparison_exp;
  id?: String_comparison_exp;
  lanIP?: String_comparison_exp;
  licenseDetails?: json_comparison_exp;
  licenseExpiration?: timestamp_comparison_exp;
  licenseJWT?: String_comparison_exp;
  macAddresses?: jsonb_comparison_exp;
  model?: String_comparison_exp;
  name?: String_comparison_exp;
  nics?: jsonb_comparison_exp;
  oldestMedia?: timestamptz_comparison_exp;
  ossSiteID?: Int_comparison_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
  searchText?: String_comparison_exp;
  sequence?: bigint_comparison_exp;
  serial?: String_comparison_exp;
  services?: jsonb_comparison_exp;
  syncError?: String_comparison_exp;
  syncStatus?: qx_eGatewaySyncStatus_enum_comparison_exp;
  thumbnail?: String_comparison_exp;
  thumbnail_lg?: String_comparison_exp;
  thumbnail_md?: String_comparison_exp;
  thumbnail_sm?: String_comparison_exp;
  thumbnail_xl?: String_comparison_exp;
  timezone?: String_comparison_exp;
  type?: eGatewayType_enum_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
  uploadDepth?: Int_comparison_exp;
  version?: String_comparison_exp;
  wireguardIP?: String_comparison_exp;
  wireguardUUID?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.Gateway" */
export enum qx_Gateway_constraint {
  /** unique or primary key constraint on columns "id" */
  Gateway_pkey = 'Gateway_pkey',
  /** unique or primary key constraint on columns "wireguardIP" */
  Gateway_wireguardIP_key = 'Gateway_wireguardIP_key',
  /** unique or primary key constraint on columns "wireguardUUID" */
  Gateway_wireguardUUID_key = 'Gateway_wireguardUUID_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type qx_Gateway_delete_at_path_input = {
  disks?: Array<string>;
  features?: Array<string>;
  macAddresses?: Array<string>;
  nics?: Array<string>;
  services?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type qx_Gateway_delete_elem_input = {
  disks?: number;
  features?: number;
  macAddresses?: number;
  nics?: number;
  services?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type qx_Gateway_delete_key_input = {
  disks?: string;
  features?: string;
  macAddresses?: string;
  nics?: string;
  services?: string;
};

/** input type for incrementing numeric columns in table "qx.Gateway" */
export type qx_Gateway_inc_input = {
  gatewayStorageDays?: number;
  ossSiteID?: number;
  sequence?: string;
  uploadDepth?: number;
};

/** input type for inserting data into table "qx.Gateway" */
export type qx_Gateway_insert_input = {
  bandwidthSchedules?: qx_GatewayBandwidthSchedule_arr_rel_insert_input;
  connectionStatus?: boolean;
  createdAt?: string;
  description?: string;
  devices?: qx_Device_arr_rel_insert_input;
  disks?: any;
  eGatewaySyncStatus?: qx_eGatewaySyncStatus_obj_rel_insert_input;
  features?: any;
  firmware?: string;
  gatewayDrives?: Array<number>;
  gatewayStorageDays?: number;
  id?: string;
  lanIP?: string;
  licenseJWT?: string;
  macAddresses?: any;
  model?: string;
  name?: string;
  nics?: any;
  oldestMedia?: string;
  ossSiteID?: number;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
  searchText?: string;
  sequence?: string;
  serial?: string;
  services?: any;
  syncError?: string;
  syncStatus?: qx_eGatewaySyncStatus_enum;
  thumbnail?: string;
  thumbnail_lg?: string;
  thumbnail_md?: string;
  thumbnail_sm?: string;
  thumbnail_xl?: string;
  type?: eGatewayType_enum;
  updatedAt?: string;
  uploadDepth?: number;
  version?: string;
  wireguardIP?: string;
  wireguardUUID?: string;
};

/** aggregate max on columns */
export type qx_Gateway_max_fields = {
  __typename?: 'qx_Gateway_max_fields';
  cockpitUrl?: string;
  createdAt?: string;
  description?: string;
  firmware?: string;
  gatewayDrives?: Array<number>;
  gatewayStorageDays?: number;
  hostname?: string;
  id?: string;
  lanIP?: string;
  /** A computed field, executes function "qx.license_expiration" */
  licenseExpiration?: string;
  licenseJWT?: string;
  model?: string;
  name?: string;
  oldestMedia?: string;
  ossSiteID?: number;
  placeID?: string;
  searchText?: string;
  sequence?: string;
  serial?: string;
  syncError?: string;
  thumbnail?: string;
  thumbnail_lg?: string;
  thumbnail_md?: string;
  thumbnail_sm?: string;
  thumbnail_xl?: string;
  /** A computed field, executes function "qx.gateway_timezone" */
  timezone?: string;
  updatedAt?: string;
  uploadDepth?: number;
  version?: string;
  wireguardIP?: string;
  wireguardUUID?: string;
};

/** order by max() on columns of table "qx.Gateway" */
export type qx_Gateway_max_order_by = {
  createdAt?: order_by;
  description?: order_by;
  firmware?: order_by;
  gatewayDrives?: order_by;
  gatewayStorageDays?: order_by;
  id?: order_by;
  lanIP?: order_by;
  licenseJWT?: order_by;
  model?: order_by;
  name?: order_by;
  oldestMedia?: order_by;
  ossSiteID?: order_by;
  placeID?: order_by;
  searchText?: order_by;
  sequence?: order_by;
  serial?: order_by;
  syncError?: order_by;
  thumbnail?: order_by;
  thumbnail_lg?: order_by;
  thumbnail_md?: order_by;
  thumbnail_sm?: order_by;
  thumbnail_xl?: order_by;
  updatedAt?: order_by;
  uploadDepth?: order_by;
  version?: order_by;
  wireguardIP?: order_by;
  wireguardUUID?: order_by;
};

/** aggregate min on columns */
export type qx_Gateway_min_fields = {
  __typename?: 'qx_Gateway_min_fields';
  cockpitUrl?: string;
  createdAt?: string;
  description?: string;
  firmware?: string;
  gatewayDrives?: Array<number>;
  gatewayStorageDays?: number;
  hostname?: string;
  id?: string;
  lanIP?: string;
  /** A computed field, executes function "qx.license_expiration" */
  licenseExpiration?: string;
  licenseJWT?: string;
  model?: string;
  name?: string;
  oldestMedia?: string;
  ossSiteID?: number;
  placeID?: string;
  searchText?: string;
  sequence?: string;
  serial?: string;
  syncError?: string;
  thumbnail?: string;
  thumbnail_lg?: string;
  thumbnail_md?: string;
  thumbnail_sm?: string;
  thumbnail_xl?: string;
  /** A computed field, executes function "qx.gateway_timezone" */
  timezone?: string;
  updatedAt?: string;
  uploadDepth?: number;
  version?: string;
  wireguardIP?: string;
  wireguardUUID?: string;
};

/** order by min() on columns of table "qx.Gateway" */
export type qx_Gateway_min_order_by = {
  createdAt?: order_by;
  description?: order_by;
  firmware?: order_by;
  gatewayDrives?: order_by;
  gatewayStorageDays?: order_by;
  id?: order_by;
  lanIP?: order_by;
  licenseJWT?: order_by;
  model?: order_by;
  name?: order_by;
  oldestMedia?: order_by;
  ossSiteID?: order_by;
  placeID?: order_by;
  searchText?: order_by;
  sequence?: order_by;
  serial?: order_by;
  syncError?: order_by;
  thumbnail?: order_by;
  thumbnail_lg?: order_by;
  thumbnail_md?: order_by;
  thumbnail_sm?: order_by;
  thumbnail_xl?: order_by;
  updatedAt?: order_by;
  uploadDepth?: order_by;
  version?: order_by;
  wireguardIP?: order_by;
  wireguardUUID?: order_by;
};

/** response of any mutation on the table "qx.Gateway" */
export type qx_Gateway_mutation_response = {
  __typename?: 'qx_Gateway_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_Gateway>;
};

/** input type for inserting object relation for remote table "qx.Gateway" */
export type qx_Gateway_obj_rel_insert_input = {
  data: qx_Gateway_insert_input;
  /** upsert condition */
  on_conflict?: qx_Gateway_on_conflict;
};

/** on_conflict condition type for table "qx.Gateway" */
export type qx_Gateway_on_conflict = {
  constraint: qx_Gateway_constraint;
  update_columns?: Array<qx_Gateway_update_column>;
  where?: qx_Gateway_bool_exp;
};

/** Ordering options when selecting data from "qx.Gateway". */
export type qx_Gateway_order_by = {
  bandwidthSchedules_aggregate?: qx_GatewayBandwidthSchedule_aggregate_order_by;
  cockpitUrl?: order_by;
  connectionStatus?: order_by;
  createdAt?: order_by;
  description?: order_by;
  devices_aggregate?: qx_Device_aggregate_order_by;
  disks?: order_by;
  eGatewaySyncStatus?: qx_eGatewaySyncStatus_order_by;
  features?: order_by;
  firmware?: order_by;
  gatewayDrives?: order_by;
  gatewayStorageDays?: order_by;
  hostname?: order_by;
  id?: order_by;
  lanIP?: order_by;
  licenseDetails?: order_by;
  licenseExpiration?: order_by;
  licenseJWT?: order_by;
  macAddresses?: order_by;
  model?: order_by;
  name?: order_by;
  nics?: order_by;
  oldestMedia?: order_by;
  ossSiteID?: order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
  searchText?: order_by;
  sequence?: order_by;
  serial?: order_by;
  services?: order_by;
  syncError?: order_by;
  syncStatus?: order_by;
  thumbnail?: order_by;
  thumbnail_lg?: order_by;
  thumbnail_md?: order_by;
  thumbnail_sm?: order_by;
  thumbnail_xl?: order_by;
  timezone?: order_by;
  type?: order_by;
  updatedAt?: order_by;
  uploadDepth?: order_by;
  version?: order_by;
  wireguardIP?: order_by;
  wireguardUUID?: order_by;
};

/** primary key columns input for table: qx.Gateway */
export type qx_Gateway_pk_columns_input = {
  id: string;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type qx_Gateway_prepend_input = {
  disks?: any;
  features?: any;
  macAddresses?: any;
  nics?: any;
  services?: any;
};

/** select columns of table "qx.Gateway" */
export enum qx_Gateway_select_column {
  /** column name */
  connectionStatus = 'connectionStatus',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  description = 'description',
  /** column name */
  disks = 'disks',
  /** column name */
  features = 'features',
  /** column name */
  firmware = 'firmware',
  /** column name */
  gatewayDrives = 'gatewayDrives',
  /** column name */
  gatewayStorageDays = 'gatewayStorageDays',
  /** column name */
  id = 'id',
  /** column name */
  lanIP = 'lanIP',
  /** column name */
  licenseJWT = 'licenseJWT',
  /** column name */
  macAddresses = 'macAddresses',
  /** column name */
  model = 'model',
  /** column name */
  name = 'name',
  /** column name */
  nics = 'nics',
  /** column name */
  oldestMedia = 'oldestMedia',
  /** column name */
  ossSiteID = 'ossSiteID',
  /** column name */
  placeID = 'placeID',
  /** column name */
  searchText = 'searchText',
  /** column name */
  sequence = 'sequence',
  /** column name */
  serial = 'serial',
  /** column name */
  services = 'services',
  /** column name */
  syncError = 'syncError',
  /** column name */
  syncStatus = 'syncStatus',
  /** column name */
  thumbnail = 'thumbnail',
  /** column name */
  thumbnail_lg = 'thumbnail_lg',
  /** column name */
  thumbnail_md = 'thumbnail_md',
  /** column name */
  thumbnail_sm = 'thumbnail_sm',
  /** column name */
  thumbnail_xl = 'thumbnail_xl',
  /** column name */
  type = 'type',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  uploadDepth = 'uploadDepth',
  /** column name */
  version = 'version',
  /** column name */
  wireguardIP = 'wireguardIP',
  /** column name */
  wireguardUUID = 'wireguardUUID'
}

/** select "qx_Gateway_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.Gateway" */
export enum qx_Gateway_select_column_qx_Gateway_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  connectionStatus = 'connectionStatus'
}

/** select "qx_Gateway_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.Gateway" */
export enum qx_Gateway_select_column_qx_Gateway_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  connectionStatus = 'connectionStatus'
}

/** input type for updating data in table "qx.Gateway" */
export type qx_Gateway_set_input = {
  connectionStatus?: boolean;
  createdAt?: string;
  description?: string;
  disks?: any;
  features?: any;
  firmware?: string;
  gatewayDrives?: Array<number>;
  gatewayStorageDays?: number;
  id?: string;
  lanIP?: string;
  licenseJWT?: string;
  macAddresses?: any;
  model?: string;
  name?: string;
  nics?: any;
  oldestMedia?: string;
  ossSiteID?: number;
  placeID?: string;
  searchText?: string;
  sequence?: string;
  serial?: string;
  services?: any;
  syncError?: string;
  syncStatus?: qx_eGatewaySyncStatus_enum;
  thumbnail?: string;
  thumbnail_lg?: string;
  thumbnail_md?: string;
  thumbnail_sm?: string;
  thumbnail_xl?: string;
  type?: eGatewayType_enum;
  updatedAt?: string;
  uploadDepth?: number;
  version?: string;
  wireguardIP?: string;
  wireguardUUID?: string;
};

/** aggregate stddev on columns */
export type qx_Gateway_stddev_fields = {
  __typename?: 'qx_Gateway_stddev_fields';
  gatewayStorageDays?: number;
  ossSiteID?: number;
  sequence?: number;
  uploadDepth?: number;
};

/** order by stddev() on columns of table "qx.Gateway" */
export type qx_Gateway_stddev_order_by = {
  gatewayStorageDays?: order_by;
  ossSiteID?: order_by;
  sequence?: order_by;
  uploadDepth?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_Gateway_stddev_pop_fields = {
  __typename?: 'qx_Gateway_stddev_pop_fields';
  gatewayStorageDays?: number;
  ossSiteID?: number;
  sequence?: number;
  uploadDepth?: number;
};

/** order by stddev_pop() on columns of table "qx.Gateway" */
export type qx_Gateway_stddev_pop_order_by = {
  gatewayStorageDays?: order_by;
  ossSiteID?: order_by;
  sequence?: order_by;
  uploadDepth?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_Gateway_stddev_samp_fields = {
  __typename?: 'qx_Gateway_stddev_samp_fields';
  gatewayStorageDays?: number;
  ossSiteID?: number;
  sequence?: number;
  uploadDepth?: number;
};

/** order by stddev_samp() on columns of table "qx.Gateway" */
export type qx_Gateway_stddev_samp_order_by = {
  gatewayStorageDays?: order_by;
  ossSiteID?: order_by;
  sequence?: order_by;
  uploadDepth?: order_by;
};

/** Streaming cursor of the table "qx_Gateway" */
export type qx_Gateway_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_Gateway_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_Gateway_stream_cursor_value_input = {
  connectionStatus?: boolean;
  createdAt?: string;
  description?: string;
  disks?: any;
  features?: any;
  firmware?: string;
  gatewayDrives?: Array<number>;
  gatewayStorageDays?: number;
  id?: string;
  lanIP?: string;
  licenseJWT?: string;
  macAddresses?: any;
  model?: string;
  name?: string;
  nics?: any;
  oldestMedia?: string;
  ossSiteID?: number;
  placeID?: string;
  searchText?: string;
  sequence?: string;
  serial?: string;
  services?: any;
  syncError?: string;
  syncStatus?: qx_eGatewaySyncStatus_enum;
  thumbnail?: string;
  thumbnail_lg?: string;
  thumbnail_md?: string;
  thumbnail_sm?: string;
  thumbnail_xl?: string;
  type?: eGatewayType_enum;
  updatedAt?: string;
  uploadDepth?: number;
  version?: string;
  wireguardIP?: string;
  wireguardUUID?: string;
};

/** aggregate sum on columns */
export type qx_Gateway_sum_fields = {
  __typename?: 'qx_Gateway_sum_fields';
  gatewayStorageDays?: number;
  ossSiteID?: number;
  sequence?: string;
  uploadDepth?: number;
};

/** order by sum() on columns of table "qx.Gateway" */
export type qx_Gateway_sum_order_by = {
  gatewayStorageDays?: order_by;
  ossSiteID?: order_by;
  sequence?: order_by;
  uploadDepth?: order_by;
};

/** update columns of table "qx.Gateway" */
export enum qx_Gateway_update_column {
  /** column name */
  connectionStatus = 'connectionStatus',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  description = 'description',
  /** column name */
  disks = 'disks',
  /** column name */
  features = 'features',
  /** column name */
  firmware = 'firmware',
  /** column name */
  gatewayDrives = 'gatewayDrives',
  /** column name */
  gatewayStorageDays = 'gatewayStorageDays',
  /** column name */
  id = 'id',
  /** column name */
  lanIP = 'lanIP',
  /** column name */
  licenseJWT = 'licenseJWT',
  /** column name */
  macAddresses = 'macAddresses',
  /** column name */
  model = 'model',
  /** column name */
  name = 'name',
  /** column name */
  nics = 'nics',
  /** column name */
  oldestMedia = 'oldestMedia',
  /** column name */
  ossSiteID = 'ossSiteID',
  /** column name */
  placeID = 'placeID',
  /** column name */
  searchText = 'searchText',
  /** column name */
  sequence = 'sequence',
  /** column name */
  serial = 'serial',
  /** column name */
  services = 'services',
  /** column name */
  syncError = 'syncError',
  /** column name */
  syncStatus = 'syncStatus',
  /** column name */
  thumbnail = 'thumbnail',
  /** column name */
  thumbnail_lg = 'thumbnail_lg',
  /** column name */
  thumbnail_md = 'thumbnail_md',
  /** column name */
  thumbnail_sm = 'thumbnail_sm',
  /** column name */
  thumbnail_xl = 'thumbnail_xl',
  /** column name */
  type = 'type',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  uploadDepth = 'uploadDepth',
  /** column name */
  version = 'version',
  /** column name */
  wireguardIP = 'wireguardIP',
  /** column name */
  wireguardUUID = 'wireguardUUID'
}

export type qx_Gateway_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: qx_Gateway_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: qx_Gateway_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: qx_Gateway_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: qx_Gateway_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_Gateway_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: qx_Gateway_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_Gateway_set_input;
  /** filter the rows which have to be updated */
  where: qx_Gateway_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_Gateway_var_pop_fields = {
  __typename?: 'qx_Gateway_var_pop_fields';
  gatewayStorageDays?: number;
  ossSiteID?: number;
  sequence?: number;
  uploadDepth?: number;
};

/** order by var_pop() on columns of table "qx.Gateway" */
export type qx_Gateway_var_pop_order_by = {
  gatewayStorageDays?: order_by;
  ossSiteID?: order_by;
  sequence?: order_by;
  uploadDepth?: order_by;
};

/** aggregate var_samp on columns */
export type qx_Gateway_var_samp_fields = {
  __typename?: 'qx_Gateway_var_samp_fields';
  gatewayStorageDays?: number;
  ossSiteID?: number;
  sequence?: number;
  uploadDepth?: number;
};

/** order by var_samp() on columns of table "qx.Gateway" */
export type qx_Gateway_var_samp_order_by = {
  gatewayStorageDays?: order_by;
  ossSiteID?: order_by;
  sequence?: order_by;
  uploadDepth?: order_by;
};

/** aggregate variance on columns */
export type qx_Gateway_variance_fields = {
  __typename?: 'qx_Gateway_variance_fields';
  gatewayStorageDays?: number;
  ossSiteID?: number;
  sequence?: number;
  uploadDepth?: number;
};

/** order by variance() on columns of table "qx.Gateway" */
export type qx_Gateway_variance_order_by = {
  gatewayStorageDays?: order_by;
  ossSiteID?: order_by;
  sequence?: order_by;
  uploadDepth?: order_by;
};

/** named collection of persons used for bulk access permission assignment */
export type qx_Group = {
  __typename?: 'qx_Group';
  createdAt: string;
  description?: string;
  externalGroupID?: string;
  id: string;
  name: string;
  /** An array relationship */
  permissions: Array<qx_Permission>;
  /** An aggregate relationship */
  permissions_aggregate: qx_Permission_aggregate;
  /** An object relationship */
  place: qx_Place;
  placeID: string;
  thumbnail?: string;
  thumbnail_lg?: string;
  thumbnail_md?: string;
  thumbnail_sm?: string;
  thumbnail_xl?: string;
  /** An array relationship */
  toPeople: Array<qx__PersonToGroup>;
  /** An aggregate relationship */
  toPeople_aggregate: qx__PersonToGroup_aggregate;
  updatedAt?: string;
};


/** named collection of persons used for bulk access permission assignment */
export type qx_GrouppermissionsArgs = {
  distinct_on?: Array<qx_Permission_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Permission_order_by>;
  where?: qx_Permission_bool_exp;
};


/** named collection of persons used for bulk access permission assignment */
export type qx_Grouppermissions_aggregateArgs = {
  distinct_on?: Array<qx_Permission_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Permission_order_by>;
  where?: qx_Permission_bool_exp;
};


/** named collection of persons used for bulk access permission assignment */
export type qx_GrouptoPeopleArgs = {
  distinct_on?: Array<qx__PersonToGroup_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__PersonToGroup_order_by>;
  where?: qx__PersonToGroup_bool_exp;
};


/** named collection of persons used for bulk access permission assignment */
export type qx_GrouptoPeople_aggregateArgs = {
  distinct_on?: Array<qx__PersonToGroup_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__PersonToGroup_order_by>;
  where?: qx__PersonToGroup_bool_exp;
};

/** aggregated selection of "qx.Group" */
export type qx_Group_aggregate = {
  __typename?: 'qx_Group_aggregate';
  aggregate?: qx_Group_aggregate_fields;
  nodes: Array<qx_Group>;
};

export type qx_Group_aggregate_bool_exp = {
  count?: qx_Group_aggregate_bool_exp_count;
};

export type qx_Group_aggregate_bool_exp_count = {
  arguments?: Array<qx_Group_select_column>;
  distinct?: boolean;
  filter?: qx_Group_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.Group" */
export type qx_Group_aggregate_fields = {
  __typename?: 'qx_Group_aggregate_fields';
  count: number;
  max?: qx_Group_max_fields;
  min?: qx_Group_min_fields;
};


/** aggregate fields of "qx.Group" */
export type qx_Group_aggregate_fieldscountArgs = {
  columns?: Array<qx_Group_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.Group" */
export type qx_Group_aggregate_order_by = {
  count?: order_by;
  max?: qx_Group_max_order_by;
  min?: qx_Group_min_order_by;
};

/** input type for inserting array relation for remote table "qx.Group" */
export type qx_Group_arr_rel_insert_input = {
  data: Array<qx_Group_insert_input>;
  /** upsert condition */
  on_conflict?: qx_Group_on_conflict;
};

/** Boolean expression to filter rows from the table "qx.Group". All fields are combined with a logical 'AND'. */
export type qx_Group_bool_exp = {
  _and?: Array<qx_Group_bool_exp>;
  _not?: qx_Group_bool_exp;
  _or?: Array<qx_Group_bool_exp>;
  createdAt?: timestamptz_comparison_exp;
  description?: String_comparison_exp;
  externalGroupID?: String_comparison_exp;
  id?: String_comparison_exp;
  name?: String_comparison_exp;
  permissions?: qx_Permission_bool_exp;
  permissions_aggregate?: qx_Permission_aggregate_bool_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
  thumbnail?: String_comparison_exp;
  thumbnail_lg?: String_comparison_exp;
  thumbnail_md?: String_comparison_exp;
  thumbnail_sm?: String_comparison_exp;
  thumbnail_xl?: String_comparison_exp;
  toPeople?: qx__PersonToGroup_bool_exp;
  toPeople_aggregate?: qx__PersonToGroup_aggregate_bool_exp;
  updatedAt?: timestamptz_comparison_exp;
};

/** unique or primary key constraints on table "qx.Group" */
export enum qx_Group_constraint {
  /** unique or primary key constraint on columns "id" */
  Group_pkey = 'Group_pkey'
}

/** input type for inserting data into table "qx.Group" */
export type qx_Group_insert_input = {
  createdAt?: string;
  description?: string;
  externalGroupID?: string;
  id?: string;
  name?: string;
  permissions?: qx_Permission_arr_rel_insert_input;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
  thumbnail?: string;
  thumbnail_lg?: string;
  thumbnail_md?: string;
  thumbnail_sm?: string;
  thumbnail_xl?: string;
  toPeople?: qx__PersonToGroup_arr_rel_insert_input;
  updatedAt?: string;
};

/** aggregate max on columns */
export type qx_Group_max_fields = {
  __typename?: 'qx_Group_max_fields';
  createdAt?: string;
  description?: string;
  externalGroupID?: string;
  id?: string;
  name?: string;
  placeID?: string;
  thumbnail?: string;
  thumbnail_lg?: string;
  thumbnail_md?: string;
  thumbnail_sm?: string;
  thumbnail_xl?: string;
  updatedAt?: string;
};

/** order by max() on columns of table "qx.Group" */
export type qx_Group_max_order_by = {
  createdAt?: order_by;
  description?: order_by;
  externalGroupID?: order_by;
  id?: order_by;
  name?: order_by;
  placeID?: order_by;
  thumbnail?: order_by;
  thumbnail_lg?: order_by;
  thumbnail_md?: order_by;
  thumbnail_sm?: order_by;
  thumbnail_xl?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type qx_Group_min_fields = {
  __typename?: 'qx_Group_min_fields';
  createdAt?: string;
  description?: string;
  externalGroupID?: string;
  id?: string;
  name?: string;
  placeID?: string;
  thumbnail?: string;
  thumbnail_lg?: string;
  thumbnail_md?: string;
  thumbnail_sm?: string;
  thumbnail_xl?: string;
  updatedAt?: string;
};

/** order by min() on columns of table "qx.Group" */
export type qx_Group_min_order_by = {
  createdAt?: order_by;
  description?: order_by;
  externalGroupID?: order_by;
  id?: order_by;
  name?: order_by;
  placeID?: order_by;
  thumbnail?: order_by;
  thumbnail_lg?: order_by;
  thumbnail_md?: order_by;
  thumbnail_sm?: order_by;
  thumbnail_xl?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.Group" */
export type qx_Group_mutation_response = {
  __typename?: 'qx_Group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_Group>;
};

/** input type for inserting object relation for remote table "qx.Group" */
export type qx_Group_obj_rel_insert_input = {
  data: qx_Group_insert_input;
  /** upsert condition */
  on_conflict?: qx_Group_on_conflict;
};

/** on_conflict condition type for table "qx.Group" */
export type qx_Group_on_conflict = {
  constraint: qx_Group_constraint;
  update_columns?: Array<qx_Group_update_column>;
  where?: qx_Group_bool_exp;
};

/** Ordering options when selecting data from "qx.Group". */
export type qx_Group_order_by = {
  createdAt?: order_by;
  description?: order_by;
  externalGroupID?: order_by;
  id?: order_by;
  name?: order_by;
  permissions_aggregate?: qx_Permission_aggregate_order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
  thumbnail?: order_by;
  thumbnail_lg?: order_by;
  thumbnail_md?: order_by;
  thumbnail_sm?: order_by;
  thumbnail_xl?: order_by;
  toPeople_aggregate?: qx__PersonToGroup_aggregate_order_by;
  updatedAt?: order_by;
};

/** primary key columns input for table: qx.Group */
export type qx_Group_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.Group" */
export enum qx_Group_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  description = 'description',
  /** column name */
  externalGroupID = 'externalGroupID',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  thumbnail = 'thumbnail',
  /** column name */
  thumbnail_lg = 'thumbnail_lg',
  /** column name */
  thumbnail_md = 'thumbnail_md',
  /** column name */
  thumbnail_sm = 'thumbnail_sm',
  /** column name */
  thumbnail_xl = 'thumbnail_xl',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "qx.Group" */
export type qx_Group_set_input = {
  createdAt?: string;
  description?: string;
  externalGroupID?: string;
  id?: string;
  name?: string;
  placeID?: string;
  thumbnail?: string;
  thumbnail_lg?: string;
  thumbnail_md?: string;
  thumbnail_sm?: string;
  thumbnail_xl?: string;
  updatedAt?: string;
};

/** Streaming cursor of the table "qx_Group" */
export type qx_Group_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_Group_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_Group_stream_cursor_value_input = {
  createdAt?: string;
  description?: string;
  externalGroupID?: string;
  id?: string;
  name?: string;
  placeID?: string;
  thumbnail?: string;
  thumbnail_lg?: string;
  thumbnail_md?: string;
  thumbnail_sm?: string;
  thumbnail_xl?: string;
  updatedAt?: string;
};

/** update columns of table "qx.Group" */
export enum qx_Group_update_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  description = 'description',
  /** column name */
  externalGroupID = 'externalGroupID',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  thumbnail = 'thumbnail',
  /** column name */
  thumbnail_lg = 'thumbnail_lg',
  /** column name */
  thumbnail_md = 'thumbnail_md',
  /** column name */
  thumbnail_sm = 'thumbnail_sm',
  /** column name */
  thumbnail_xl = 'thumbnail_xl',
  /** column name */
  updatedAt = 'updatedAt'
}

export type qx_Group_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_Group_set_input;
  /** filter the rows which have to be updated */
  where: qx_Group_bool_exp;
};

/** named list of holiday dates that override normal schedule behavior for access control */
export type qx_HolidaySet = {
  __typename?: 'qx_HolidaySet';
  createdAt: string;
  dates?: any;
  description?: string;
  id: string;
  name: string;
  /** An object relationship */
  place: qx_Place;
  placeID: string;
  /** An array relationship */
  toScheduleBlocks: Array<qx__HolidaySetToScheduleBlock>;
  /** An aggregate relationship */
  toScheduleBlocks_aggregate: qx__HolidaySetToScheduleBlock_aggregate;
  updatedAt?: string;
};


/** named list of holiday dates that override normal schedule behavior for access control */
export type qx_HolidaySetdatesArgs = {
  path?: string;
};


/** named list of holiday dates that override normal schedule behavior for access control */
export type qx_HolidaySettoScheduleBlocksArgs = {
  distinct_on?: Array<qx__HolidaySetToScheduleBlock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__HolidaySetToScheduleBlock_order_by>;
  where?: qx__HolidaySetToScheduleBlock_bool_exp;
};


/** named list of holiday dates that override normal schedule behavior for access control */
export type qx_HolidaySettoScheduleBlocks_aggregateArgs = {
  distinct_on?: Array<qx__HolidaySetToScheduleBlock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__HolidaySetToScheduleBlock_order_by>;
  where?: qx__HolidaySetToScheduleBlock_bool_exp;
};

/** aggregated selection of "qx.HolidaySet" */
export type qx_HolidaySet_aggregate = {
  __typename?: 'qx_HolidaySet_aggregate';
  aggregate?: qx_HolidaySet_aggregate_fields;
  nodes: Array<qx_HolidaySet>;
};

export type qx_HolidaySet_aggregate_bool_exp = {
  count?: qx_HolidaySet_aggregate_bool_exp_count;
};

export type qx_HolidaySet_aggregate_bool_exp_count = {
  arguments?: Array<qx_HolidaySet_select_column>;
  distinct?: boolean;
  filter?: qx_HolidaySet_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.HolidaySet" */
export type qx_HolidaySet_aggregate_fields = {
  __typename?: 'qx_HolidaySet_aggregate_fields';
  count: number;
  max?: qx_HolidaySet_max_fields;
  min?: qx_HolidaySet_min_fields;
};


/** aggregate fields of "qx.HolidaySet" */
export type qx_HolidaySet_aggregate_fieldscountArgs = {
  columns?: Array<qx_HolidaySet_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.HolidaySet" */
export type qx_HolidaySet_aggregate_order_by = {
  count?: order_by;
  max?: qx_HolidaySet_max_order_by;
  min?: qx_HolidaySet_min_order_by;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type qx_HolidaySet_append_input = {
  dates?: any;
};

/** input type for inserting array relation for remote table "qx.HolidaySet" */
export type qx_HolidaySet_arr_rel_insert_input = {
  data: Array<qx_HolidaySet_insert_input>;
  /** upsert condition */
  on_conflict?: qx_HolidaySet_on_conflict;
};

/** Boolean expression to filter rows from the table "qx.HolidaySet". All fields are combined with a logical 'AND'. */
export type qx_HolidaySet_bool_exp = {
  _and?: Array<qx_HolidaySet_bool_exp>;
  _not?: qx_HolidaySet_bool_exp;
  _or?: Array<qx_HolidaySet_bool_exp>;
  createdAt?: timestamptz_comparison_exp;
  dates?: jsonb_comparison_exp;
  description?: String_comparison_exp;
  id?: String_comparison_exp;
  name?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
  toScheduleBlocks?: qx__HolidaySetToScheduleBlock_bool_exp;
  toScheduleBlocks_aggregate?: qx__HolidaySetToScheduleBlock_aggregate_bool_exp;
  updatedAt?: timestamptz_comparison_exp;
};

/** unique or primary key constraints on table "qx.HolidaySet" */
export enum qx_HolidaySet_constraint {
  /** unique or primary key constraint on columns "id" */
  HolidaySet_pkey = 'HolidaySet_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type qx_HolidaySet_delete_at_path_input = {
  dates?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type qx_HolidaySet_delete_elem_input = {
  dates?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type qx_HolidaySet_delete_key_input = {
  dates?: string;
};

/** input type for inserting data into table "qx.HolidaySet" */
export type qx_HolidaySet_insert_input = {
  createdAt?: string;
  dates?: any;
  description?: string;
  id?: string;
  name?: string;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
  toScheduleBlocks?: qx__HolidaySetToScheduleBlock_arr_rel_insert_input;
  updatedAt?: string;
};

/** aggregate max on columns */
export type qx_HolidaySet_max_fields = {
  __typename?: 'qx_HolidaySet_max_fields';
  createdAt?: string;
  description?: string;
  id?: string;
  name?: string;
  placeID?: string;
  updatedAt?: string;
};

/** order by max() on columns of table "qx.HolidaySet" */
export type qx_HolidaySet_max_order_by = {
  createdAt?: order_by;
  description?: order_by;
  id?: order_by;
  name?: order_by;
  placeID?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type qx_HolidaySet_min_fields = {
  __typename?: 'qx_HolidaySet_min_fields';
  createdAt?: string;
  description?: string;
  id?: string;
  name?: string;
  placeID?: string;
  updatedAt?: string;
};

/** order by min() on columns of table "qx.HolidaySet" */
export type qx_HolidaySet_min_order_by = {
  createdAt?: order_by;
  description?: order_by;
  id?: order_by;
  name?: order_by;
  placeID?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.HolidaySet" */
export type qx_HolidaySet_mutation_response = {
  __typename?: 'qx_HolidaySet_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_HolidaySet>;
};

/** input type for inserting object relation for remote table "qx.HolidaySet" */
export type qx_HolidaySet_obj_rel_insert_input = {
  data: qx_HolidaySet_insert_input;
  /** upsert condition */
  on_conflict?: qx_HolidaySet_on_conflict;
};

/** on_conflict condition type for table "qx.HolidaySet" */
export type qx_HolidaySet_on_conflict = {
  constraint: qx_HolidaySet_constraint;
  update_columns?: Array<qx_HolidaySet_update_column>;
  where?: qx_HolidaySet_bool_exp;
};

/** Ordering options when selecting data from "qx.HolidaySet". */
export type qx_HolidaySet_order_by = {
  createdAt?: order_by;
  dates?: order_by;
  description?: order_by;
  id?: order_by;
  name?: order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
  toScheduleBlocks_aggregate?: qx__HolidaySetToScheduleBlock_aggregate_order_by;
  updatedAt?: order_by;
};

/** primary key columns input for table: qx.HolidaySet */
export type qx_HolidaySet_pk_columns_input = {
  id: string;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type qx_HolidaySet_prepend_input = {
  dates?: any;
};

/** select columns of table "qx.HolidaySet" */
export enum qx_HolidaySet_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  dates = 'dates',
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "qx.HolidaySet" */
export type qx_HolidaySet_set_input = {
  createdAt?: string;
  dates?: any;
  description?: string;
  id?: string;
  name?: string;
  placeID?: string;
  updatedAt?: string;
};

/** Streaming cursor of the table "qx_HolidaySet" */
export type qx_HolidaySet_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_HolidaySet_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_HolidaySet_stream_cursor_value_input = {
  createdAt?: string;
  dates?: any;
  description?: string;
  id?: string;
  name?: string;
  placeID?: string;
  updatedAt?: string;
};

/** update columns of table "qx.HolidaySet" */
export enum qx_HolidaySet_update_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  dates = 'dates',
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  updatedAt = 'updatedAt'
}

export type qx_HolidaySet_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: qx_HolidaySet_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: qx_HolidaySet_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: qx_HolidaySet_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: qx_HolidaySet_delete_key_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: qx_HolidaySet_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_HolidaySet_set_input;
  /** filter the rows which have to be updated */
  where: qx_HolidaySet_bool_exp;
};

/** monitored digital input (door contact, motion sensor, tamper switch) wired to a device DIO channel */
export type qx_InputPoint = {
  __typename?: 'qx_InputPoint';
  /** An object relationship */
  Device: qx_Device;
  /** An object relationship */
  DeviceDIO: qx_DeviceDIO;
  /** An array relationship */
  MercuryMonitorPoints: Array<qx_MercuryMonitorPoint>;
  /** An aggregate relationship */
  MercuryMonitorPoints_aggregate: qx_MercuryMonitorPoint_aggregate;
  channel?: number;
  deviceDioID: string;
  deviceID: string;
  id: string;
  /** A computed field, executes function "qx.input_supervise_value" */
  supervise?: string;
};


/** monitored digital input (door contact, motion sensor, tamper switch) wired to a device DIO channel */
export type qx_InputPointMercuryMonitorPointsArgs = {
  distinct_on?: Array<qx_MercuryMonitorPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MercuryMonitorPoint_order_by>;
  where?: qx_MercuryMonitorPoint_bool_exp;
};


/** monitored digital input (door contact, motion sensor, tamper switch) wired to a device DIO channel */
export type qx_InputPointMercuryMonitorPoints_aggregateArgs = {
  distinct_on?: Array<qx_MercuryMonitorPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MercuryMonitorPoint_order_by>;
  where?: qx_MercuryMonitorPoint_bool_exp;
};

/** aggregated selection of "qx.InputPoint" */
export type qx_InputPoint_aggregate = {
  __typename?: 'qx_InputPoint_aggregate';
  aggregate?: qx_InputPoint_aggregate_fields;
  nodes: Array<qx_InputPoint>;
};

export type qx_InputPoint_aggregate_bool_exp = {
  count?: qx_InputPoint_aggregate_bool_exp_count;
};

export type qx_InputPoint_aggregate_bool_exp_count = {
  arguments?: Array<qx_InputPoint_select_column>;
  distinct?: boolean;
  filter?: qx_InputPoint_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.InputPoint" */
export type qx_InputPoint_aggregate_fields = {
  __typename?: 'qx_InputPoint_aggregate_fields';
  avg?: qx_InputPoint_avg_fields;
  count: number;
  max?: qx_InputPoint_max_fields;
  min?: qx_InputPoint_min_fields;
  stddev?: qx_InputPoint_stddev_fields;
  stddev_pop?: qx_InputPoint_stddev_pop_fields;
  stddev_samp?: qx_InputPoint_stddev_samp_fields;
  sum?: qx_InputPoint_sum_fields;
  var_pop?: qx_InputPoint_var_pop_fields;
  var_samp?: qx_InputPoint_var_samp_fields;
  variance?: qx_InputPoint_variance_fields;
};


/** aggregate fields of "qx.InputPoint" */
export type qx_InputPoint_aggregate_fieldscountArgs = {
  columns?: Array<qx_InputPoint_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.InputPoint" */
export type qx_InputPoint_aggregate_order_by = {
  avg?: qx_InputPoint_avg_order_by;
  count?: order_by;
  max?: qx_InputPoint_max_order_by;
  min?: qx_InputPoint_min_order_by;
  stddev?: qx_InputPoint_stddev_order_by;
  stddev_pop?: qx_InputPoint_stddev_pop_order_by;
  stddev_samp?: qx_InputPoint_stddev_samp_order_by;
  sum?: qx_InputPoint_sum_order_by;
  var_pop?: qx_InputPoint_var_pop_order_by;
  var_samp?: qx_InputPoint_var_samp_order_by;
  variance?: qx_InputPoint_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.InputPoint" */
export type qx_InputPoint_arr_rel_insert_input = {
  data: Array<qx_InputPoint_insert_input>;
  /** upsert condition */
  on_conflict?: qx_InputPoint_on_conflict;
};

/** aggregate avg on columns */
export type qx_InputPoint_avg_fields = {
  __typename?: 'qx_InputPoint_avg_fields';
  channel?: number;
};

/** order by avg() on columns of table "qx.InputPoint" */
export type qx_InputPoint_avg_order_by = {
  channel?: order_by;
};

/** Boolean expression to filter rows from the table "qx.InputPoint". All fields are combined with a logical 'AND'. */
export type qx_InputPoint_bool_exp = {
  Device?: qx_Device_bool_exp;
  DeviceDIO?: qx_DeviceDIO_bool_exp;
  MercuryMonitorPoints?: qx_MercuryMonitorPoint_bool_exp;
  MercuryMonitorPoints_aggregate?: qx_MercuryMonitorPoint_aggregate_bool_exp;
  _and?: Array<qx_InputPoint_bool_exp>;
  _not?: qx_InputPoint_bool_exp;
  _or?: Array<qx_InputPoint_bool_exp>;
  channel?: Int_comparison_exp;
  deviceDioID?: String_comparison_exp;
  deviceID?: String_comparison_exp;
  id?: String_comparison_exp;
  supervise?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.InputPoint" */
export enum qx_InputPoint_constraint {
  /** unique or primary key constraint on columns "channel", "deviceDioID" */
  InputPoint_DeviceDioID_channel_contraint = 'InputPoint_DeviceDioID_channel_contraint',
  /** unique or primary key constraint on columns "id" */
  InputPoint_pkey = 'InputPoint_pkey'
}

/** input type for incrementing numeric columns in table "qx.InputPoint" */
export type qx_InputPoint_inc_input = {
  channel?: number;
};

/** input type for inserting data into table "qx.InputPoint" */
export type qx_InputPoint_insert_input = {
  Device?: qx_Device_obj_rel_insert_input;
  DeviceDIO?: qx_DeviceDIO_obj_rel_insert_input;
  MercuryMonitorPoints?: qx_MercuryMonitorPoint_arr_rel_insert_input;
  channel?: number;
  deviceDioID?: string;
  deviceID?: string;
  id?: string;
};

/** aggregate max on columns */
export type qx_InputPoint_max_fields = {
  __typename?: 'qx_InputPoint_max_fields';
  channel?: number;
  deviceDioID?: string;
  deviceID?: string;
  id?: string;
  /** A computed field, executes function "qx.input_supervise_value" */
  supervise?: string;
};

/** order by max() on columns of table "qx.InputPoint" */
export type qx_InputPoint_max_order_by = {
  channel?: order_by;
  deviceDioID?: order_by;
  deviceID?: order_by;
  id?: order_by;
};

/** aggregate min on columns */
export type qx_InputPoint_min_fields = {
  __typename?: 'qx_InputPoint_min_fields';
  channel?: number;
  deviceDioID?: string;
  deviceID?: string;
  id?: string;
  /** A computed field, executes function "qx.input_supervise_value" */
  supervise?: string;
};

/** order by min() on columns of table "qx.InputPoint" */
export type qx_InputPoint_min_order_by = {
  channel?: order_by;
  deviceDioID?: order_by;
  deviceID?: order_by;
  id?: order_by;
};

/** response of any mutation on the table "qx.InputPoint" */
export type qx_InputPoint_mutation_response = {
  __typename?: 'qx_InputPoint_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_InputPoint>;
};

/** input type for inserting object relation for remote table "qx.InputPoint" */
export type qx_InputPoint_obj_rel_insert_input = {
  data: qx_InputPoint_insert_input;
  /** upsert condition */
  on_conflict?: qx_InputPoint_on_conflict;
};

/** on_conflict condition type for table "qx.InputPoint" */
export type qx_InputPoint_on_conflict = {
  constraint: qx_InputPoint_constraint;
  update_columns?: Array<qx_InputPoint_update_column>;
  where?: qx_InputPoint_bool_exp;
};

/** Ordering options when selecting data from "qx.InputPoint". */
export type qx_InputPoint_order_by = {
  Device?: qx_Device_order_by;
  DeviceDIO?: qx_DeviceDIO_order_by;
  MercuryMonitorPoints_aggregate?: qx_MercuryMonitorPoint_aggregate_order_by;
  channel?: order_by;
  deviceDioID?: order_by;
  deviceID?: order_by;
  id?: order_by;
  supervise?: order_by;
};

/** primary key columns input for table: qx.InputPoint */
export type qx_InputPoint_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.InputPoint" */
export enum qx_InputPoint_select_column {
  /** column name */
  channel = 'channel',
  /** column name */
  deviceDioID = 'deviceDioID',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  id = 'id'
}

/** input type for updating data in table "qx.InputPoint" */
export type qx_InputPoint_set_input = {
  channel?: number;
  deviceDioID?: string;
  deviceID?: string;
  id?: string;
};

/** aggregate stddev on columns */
export type qx_InputPoint_stddev_fields = {
  __typename?: 'qx_InputPoint_stddev_fields';
  channel?: number;
};

/** order by stddev() on columns of table "qx.InputPoint" */
export type qx_InputPoint_stddev_order_by = {
  channel?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_InputPoint_stddev_pop_fields = {
  __typename?: 'qx_InputPoint_stddev_pop_fields';
  channel?: number;
};

/** order by stddev_pop() on columns of table "qx.InputPoint" */
export type qx_InputPoint_stddev_pop_order_by = {
  channel?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_InputPoint_stddev_samp_fields = {
  __typename?: 'qx_InputPoint_stddev_samp_fields';
  channel?: number;
};

/** order by stddev_samp() on columns of table "qx.InputPoint" */
export type qx_InputPoint_stddev_samp_order_by = {
  channel?: order_by;
};

/** Streaming cursor of the table "qx_InputPoint" */
export type qx_InputPoint_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_InputPoint_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_InputPoint_stream_cursor_value_input = {
  channel?: number;
  deviceDioID?: string;
  deviceID?: string;
  id?: string;
};

/** aggregate sum on columns */
export type qx_InputPoint_sum_fields = {
  __typename?: 'qx_InputPoint_sum_fields';
  channel?: number;
};

/** order by sum() on columns of table "qx.InputPoint" */
export type qx_InputPoint_sum_order_by = {
  channel?: order_by;
};

/** update columns of table "qx.InputPoint" */
export enum qx_InputPoint_update_column {
  /** column name */
  channel = 'channel',
  /** column name */
  deviceDioID = 'deviceDioID',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  id = 'id'
}

export type qx_InputPoint_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_InputPoint_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_InputPoint_set_input;
  /** filter the rows which have to be updated */
  where: qx_InputPoint_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_InputPoint_var_pop_fields = {
  __typename?: 'qx_InputPoint_var_pop_fields';
  channel?: number;
};

/** order by var_pop() on columns of table "qx.InputPoint" */
export type qx_InputPoint_var_pop_order_by = {
  channel?: order_by;
};

/** aggregate var_samp on columns */
export type qx_InputPoint_var_samp_fields = {
  __typename?: 'qx_InputPoint_var_samp_fields';
  channel?: number;
};

/** order by var_samp() on columns of table "qx.InputPoint" */
export type qx_InputPoint_var_samp_order_by = {
  channel?: order_by;
};

/** aggregate variance on columns */
export type qx_InputPoint_variance_fields = {
  __typename?: 'qx_InputPoint_variance_fields';
  channel?: number;
};

/** order by variance() on columns of table "qx.InputPoint" */
export type qx_InputPoint_variance_order_by = {
  channel?: order_by;
};

/** Alarms for an intrusion device */
export type qx_IntrusionAlarm = {
  __typename?: 'qx_IntrusionAlarm';
  bit: number;
  comment: string;
  value: string;
};

/** aggregated selection of "qx.IntrusionAlarm" */
export type qx_IntrusionAlarm_aggregate = {
  __typename?: 'qx_IntrusionAlarm_aggregate';
  aggregate?: qx_IntrusionAlarm_aggregate_fields;
  nodes: Array<qx_IntrusionAlarm>;
};

/** aggregate fields of "qx.IntrusionAlarm" */
export type qx_IntrusionAlarm_aggregate_fields = {
  __typename?: 'qx_IntrusionAlarm_aggregate_fields';
  avg?: qx_IntrusionAlarm_avg_fields;
  count: number;
  max?: qx_IntrusionAlarm_max_fields;
  min?: qx_IntrusionAlarm_min_fields;
  stddev?: qx_IntrusionAlarm_stddev_fields;
  stddev_pop?: qx_IntrusionAlarm_stddev_pop_fields;
  stddev_samp?: qx_IntrusionAlarm_stddev_samp_fields;
  sum?: qx_IntrusionAlarm_sum_fields;
  var_pop?: qx_IntrusionAlarm_var_pop_fields;
  var_samp?: qx_IntrusionAlarm_var_samp_fields;
  variance?: qx_IntrusionAlarm_variance_fields;
};


/** aggregate fields of "qx.IntrusionAlarm" */
export type qx_IntrusionAlarm_aggregate_fieldscountArgs = {
  columns?: Array<qx_IntrusionAlarm_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type qx_IntrusionAlarm_avg_fields = {
  __typename?: 'qx_IntrusionAlarm_avg_fields';
  bit?: number;
};

/** Boolean expression to filter rows from the table "qx.IntrusionAlarm". All fields are combined with a logical 'AND'. */
export type qx_IntrusionAlarm_bool_exp = {
  _and?: Array<qx_IntrusionAlarm_bool_exp>;
  _not?: qx_IntrusionAlarm_bool_exp;
  _or?: Array<qx_IntrusionAlarm_bool_exp>;
  bit?: Int_comparison_exp;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.IntrusionAlarm" */
export enum qx_IntrusionAlarm_constraint {
  /** unique or primary key constraint on columns "value" */
  IntrusionAlarm_pkey = 'IntrusionAlarm_pkey'
}

/** input type for incrementing numeric columns in table "qx.IntrusionAlarm" */
export type qx_IntrusionAlarm_inc_input = {
  bit?: number;
};

/** input type for inserting data into table "qx.IntrusionAlarm" */
export type qx_IntrusionAlarm_insert_input = {
  bit?: number;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_IntrusionAlarm_max_fields = {
  __typename?: 'qx_IntrusionAlarm_max_fields';
  bit?: number;
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_IntrusionAlarm_min_fields = {
  __typename?: 'qx_IntrusionAlarm_min_fields';
  bit?: number;
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.IntrusionAlarm" */
export type qx_IntrusionAlarm_mutation_response = {
  __typename?: 'qx_IntrusionAlarm_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_IntrusionAlarm>;
};

/** on_conflict condition type for table "qx.IntrusionAlarm" */
export type qx_IntrusionAlarm_on_conflict = {
  constraint: qx_IntrusionAlarm_constraint;
  update_columns?: Array<qx_IntrusionAlarm_update_column>;
  where?: qx_IntrusionAlarm_bool_exp;
};

/** Ordering options when selecting data from "qx.IntrusionAlarm". */
export type qx_IntrusionAlarm_order_by = {
  bit?: order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.IntrusionAlarm */
export type qx_IntrusionAlarm_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.IntrusionAlarm" */
export enum qx_IntrusionAlarm_select_column {
  /** column name */
  bit = 'bit',
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.IntrusionAlarm" */
export type qx_IntrusionAlarm_set_input = {
  bit?: number;
  comment?: string;
  value?: string;
};

/** aggregate stddev on columns */
export type qx_IntrusionAlarm_stddev_fields = {
  __typename?: 'qx_IntrusionAlarm_stddev_fields';
  bit?: number;
};

/** aggregate stddev_pop on columns */
export type qx_IntrusionAlarm_stddev_pop_fields = {
  __typename?: 'qx_IntrusionAlarm_stddev_pop_fields';
  bit?: number;
};

/** aggregate stddev_samp on columns */
export type qx_IntrusionAlarm_stddev_samp_fields = {
  __typename?: 'qx_IntrusionAlarm_stddev_samp_fields';
  bit?: number;
};

/** Streaming cursor of the table "qx_IntrusionAlarm" */
export type qx_IntrusionAlarm_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_IntrusionAlarm_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_IntrusionAlarm_stream_cursor_value_input = {
  bit?: number;
  comment?: string;
  value?: string;
};

/** aggregate sum on columns */
export type qx_IntrusionAlarm_sum_fields = {
  __typename?: 'qx_IntrusionAlarm_sum_fields';
  bit?: number;
};

/** update columns of table "qx.IntrusionAlarm" */
export enum qx_IntrusionAlarm_update_column {
  /** column name */
  bit = 'bit',
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_IntrusionAlarm_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_IntrusionAlarm_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_IntrusionAlarm_set_input;
  /** filter the rows which have to be updated */
  where: qx_IntrusionAlarm_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_IntrusionAlarm_var_pop_fields = {
  __typename?: 'qx_IntrusionAlarm_var_pop_fields';
  bit?: number;
};

/** aggregate var_samp on columns */
export type qx_IntrusionAlarm_var_samp_fields = {
  __typename?: 'qx_IntrusionAlarm_var_samp_fields';
  bit?: number;
};

/** aggregate variance on columns */
export type qx_IntrusionAlarm_variance_fields = {
  __typename?: 'qx_IntrusionAlarm_variance_fields';
  bit?: number;
};

/** columns and relationships of "qx.IntrusionPartitionState" */
export type qx_IntrusionPartitionState = {
  __typename?: 'qx_IntrusionPartitionState';
  bit: number;
  comment: string;
  value: string;
};

/** aggregated selection of "qx.IntrusionPartitionState" */
export type qx_IntrusionPartitionState_aggregate = {
  __typename?: 'qx_IntrusionPartitionState_aggregate';
  aggregate?: qx_IntrusionPartitionState_aggregate_fields;
  nodes: Array<qx_IntrusionPartitionState>;
};

/** aggregate fields of "qx.IntrusionPartitionState" */
export type qx_IntrusionPartitionState_aggregate_fields = {
  __typename?: 'qx_IntrusionPartitionState_aggregate_fields';
  avg?: qx_IntrusionPartitionState_avg_fields;
  count: number;
  max?: qx_IntrusionPartitionState_max_fields;
  min?: qx_IntrusionPartitionState_min_fields;
  stddev?: qx_IntrusionPartitionState_stddev_fields;
  stddev_pop?: qx_IntrusionPartitionState_stddev_pop_fields;
  stddev_samp?: qx_IntrusionPartitionState_stddev_samp_fields;
  sum?: qx_IntrusionPartitionState_sum_fields;
  var_pop?: qx_IntrusionPartitionState_var_pop_fields;
  var_samp?: qx_IntrusionPartitionState_var_samp_fields;
  variance?: qx_IntrusionPartitionState_variance_fields;
};


/** aggregate fields of "qx.IntrusionPartitionState" */
export type qx_IntrusionPartitionState_aggregate_fieldscountArgs = {
  columns?: Array<qx_IntrusionPartitionState_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type qx_IntrusionPartitionState_avg_fields = {
  __typename?: 'qx_IntrusionPartitionState_avg_fields';
  bit?: number;
};

/** Boolean expression to filter rows from the table "qx.IntrusionPartitionState". All fields are combined with a logical 'AND'. */
export type qx_IntrusionPartitionState_bool_exp = {
  _and?: Array<qx_IntrusionPartitionState_bool_exp>;
  _not?: qx_IntrusionPartitionState_bool_exp;
  _or?: Array<qx_IntrusionPartitionState_bool_exp>;
  bit?: Int_comparison_exp;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.IntrusionPartitionState" */
export enum qx_IntrusionPartitionState_constraint {
  /** unique or primary key constraint on columns "value" */
  IntrusionPartitionState_pkey = 'IntrusionPartitionState_pkey'
}

/** input type for incrementing numeric columns in table "qx.IntrusionPartitionState" */
export type qx_IntrusionPartitionState_inc_input = {
  bit?: number;
};

/** input type for inserting data into table "qx.IntrusionPartitionState" */
export type qx_IntrusionPartitionState_insert_input = {
  bit?: number;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_IntrusionPartitionState_max_fields = {
  __typename?: 'qx_IntrusionPartitionState_max_fields';
  bit?: number;
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_IntrusionPartitionState_min_fields = {
  __typename?: 'qx_IntrusionPartitionState_min_fields';
  bit?: number;
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.IntrusionPartitionState" */
export type qx_IntrusionPartitionState_mutation_response = {
  __typename?: 'qx_IntrusionPartitionState_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_IntrusionPartitionState>;
};

/** on_conflict condition type for table "qx.IntrusionPartitionState" */
export type qx_IntrusionPartitionState_on_conflict = {
  constraint: qx_IntrusionPartitionState_constraint;
  update_columns?: Array<qx_IntrusionPartitionState_update_column>;
  where?: qx_IntrusionPartitionState_bool_exp;
};

/** Ordering options when selecting data from "qx.IntrusionPartitionState". */
export type qx_IntrusionPartitionState_order_by = {
  bit?: order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.IntrusionPartitionState */
export type qx_IntrusionPartitionState_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.IntrusionPartitionState" */
export enum qx_IntrusionPartitionState_select_column {
  /** column name */
  bit = 'bit',
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.IntrusionPartitionState" */
export type qx_IntrusionPartitionState_set_input = {
  bit?: number;
  comment?: string;
  value?: string;
};

/** aggregate stddev on columns */
export type qx_IntrusionPartitionState_stddev_fields = {
  __typename?: 'qx_IntrusionPartitionState_stddev_fields';
  bit?: number;
};

/** aggregate stddev_pop on columns */
export type qx_IntrusionPartitionState_stddev_pop_fields = {
  __typename?: 'qx_IntrusionPartitionState_stddev_pop_fields';
  bit?: number;
};

/** aggregate stddev_samp on columns */
export type qx_IntrusionPartitionState_stddev_samp_fields = {
  __typename?: 'qx_IntrusionPartitionState_stddev_samp_fields';
  bit?: number;
};

/** Streaming cursor of the table "qx_IntrusionPartitionState" */
export type qx_IntrusionPartitionState_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_IntrusionPartitionState_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_IntrusionPartitionState_stream_cursor_value_input = {
  bit?: number;
  comment?: string;
  value?: string;
};

/** aggregate sum on columns */
export type qx_IntrusionPartitionState_sum_fields = {
  __typename?: 'qx_IntrusionPartitionState_sum_fields';
  bit?: number;
};

/** update columns of table "qx.IntrusionPartitionState" */
export enum qx_IntrusionPartitionState_update_column {
  /** column name */
  bit = 'bit',
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_IntrusionPartitionState_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_IntrusionPartitionState_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_IntrusionPartitionState_set_input;
  /** filter the rows which have to be updated */
  where: qx_IntrusionPartitionState_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_IntrusionPartitionState_var_pop_fields = {
  __typename?: 'qx_IntrusionPartitionState_var_pop_fields';
  bit?: number;
};

/** aggregate var_samp on columns */
export type qx_IntrusionPartitionState_var_samp_fields = {
  __typename?: 'qx_IntrusionPartitionState_var_samp_fields';
  bit?: number;
};

/** aggregate variance on columns */
export type qx_IntrusionPartitionState_variance_fields = {
  __typename?: 'qx_IntrusionPartitionState_variance_fields';
  bit?: number;
};

/** columns and relationships of "qx.IntrusionZoneState" */
export type qx_IntrusionZoneState = {
  __typename?: 'qx_IntrusionZoneState';
  bit: number;
  comment: string;
  value: string;
};

/** aggregated selection of "qx.IntrusionZoneState" */
export type qx_IntrusionZoneState_aggregate = {
  __typename?: 'qx_IntrusionZoneState_aggregate';
  aggregate?: qx_IntrusionZoneState_aggregate_fields;
  nodes: Array<qx_IntrusionZoneState>;
};

/** aggregate fields of "qx.IntrusionZoneState" */
export type qx_IntrusionZoneState_aggregate_fields = {
  __typename?: 'qx_IntrusionZoneState_aggregate_fields';
  avg?: qx_IntrusionZoneState_avg_fields;
  count: number;
  max?: qx_IntrusionZoneState_max_fields;
  min?: qx_IntrusionZoneState_min_fields;
  stddev?: qx_IntrusionZoneState_stddev_fields;
  stddev_pop?: qx_IntrusionZoneState_stddev_pop_fields;
  stddev_samp?: qx_IntrusionZoneState_stddev_samp_fields;
  sum?: qx_IntrusionZoneState_sum_fields;
  var_pop?: qx_IntrusionZoneState_var_pop_fields;
  var_samp?: qx_IntrusionZoneState_var_samp_fields;
  variance?: qx_IntrusionZoneState_variance_fields;
};


/** aggregate fields of "qx.IntrusionZoneState" */
export type qx_IntrusionZoneState_aggregate_fieldscountArgs = {
  columns?: Array<qx_IntrusionZoneState_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type qx_IntrusionZoneState_avg_fields = {
  __typename?: 'qx_IntrusionZoneState_avg_fields';
  bit?: number;
};

/** Boolean expression to filter rows from the table "qx.IntrusionZoneState". All fields are combined with a logical 'AND'. */
export type qx_IntrusionZoneState_bool_exp = {
  _and?: Array<qx_IntrusionZoneState_bool_exp>;
  _not?: qx_IntrusionZoneState_bool_exp;
  _or?: Array<qx_IntrusionZoneState_bool_exp>;
  bit?: Int_comparison_exp;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.IntrusionZoneState" */
export enum qx_IntrusionZoneState_constraint {
  /** unique or primary key constraint on columns "value" */
  IntrusionZoneState_pkey = 'IntrusionZoneState_pkey'
}

/** input type for incrementing numeric columns in table "qx.IntrusionZoneState" */
export type qx_IntrusionZoneState_inc_input = {
  bit?: number;
};

/** input type for inserting data into table "qx.IntrusionZoneState" */
export type qx_IntrusionZoneState_insert_input = {
  bit?: number;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_IntrusionZoneState_max_fields = {
  __typename?: 'qx_IntrusionZoneState_max_fields';
  bit?: number;
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_IntrusionZoneState_min_fields = {
  __typename?: 'qx_IntrusionZoneState_min_fields';
  bit?: number;
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.IntrusionZoneState" */
export type qx_IntrusionZoneState_mutation_response = {
  __typename?: 'qx_IntrusionZoneState_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_IntrusionZoneState>;
};

/** on_conflict condition type for table "qx.IntrusionZoneState" */
export type qx_IntrusionZoneState_on_conflict = {
  constraint: qx_IntrusionZoneState_constraint;
  update_columns?: Array<qx_IntrusionZoneState_update_column>;
  where?: qx_IntrusionZoneState_bool_exp;
};

/** Ordering options when selecting data from "qx.IntrusionZoneState". */
export type qx_IntrusionZoneState_order_by = {
  bit?: order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.IntrusionZoneState */
export type qx_IntrusionZoneState_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.IntrusionZoneState" */
export enum qx_IntrusionZoneState_select_column {
  /** column name */
  bit = 'bit',
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.IntrusionZoneState" */
export type qx_IntrusionZoneState_set_input = {
  bit?: number;
  comment?: string;
  value?: string;
};

/** aggregate stddev on columns */
export type qx_IntrusionZoneState_stddev_fields = {
  __typename?: 'qx_IntrusionZoneState_stddev_fields';
  bit?: number;
};

/** aggregate stddev_pop on columns */
export type qx_IntrusionZoneState_stddev_pop_fields = {
  __typename?: 'qx_IntrusionZoneState_stddev_pop_fields';
  bit?: number;
};

/** aggregate stddev_samp on columns */
export type qx_IntrusionZoneState_stddev_samp_fields = {
  __typename?: 'qx_IntrusionZoneState_stddev_samp_fields';
  bit?: number;
};

/** Streaming cursor of the table "qx_IntrusionZoneState" */
export type qx_IntrusionZoneState_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_IntrusionZoneState_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_IntrusionZoneState_stream_cursor_value_input = {
  bit?: number;
  comment?: string;
  value?: string;
};

/** aggregate sum on columns */
export type qx_IntrusionZoneState_sum_fields = {
  __typename?: 'qx_IntrusionZoneState_sum_fields';
  bit?: number;
};

/** update columns of table "qx.IntrusionZoneState" */
export enum qx_IntrusionZoneState_update_column {
  /** column name */
  bit = 'bit',
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_IntrusionZoneState_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_IntrusionZoneState_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_IntrusionZoneState_set_input;
  /** filter the rows which have to be updated */
  where: qx_IntrusionZoneState_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_IntrusionZoneState_var_pop_fields = {
  __typename?: 'qx_IntrusionZoneState_var_pop_fields';
  bit?: number;
};

/** aggregate var_samp on columns */
export type qx_IntrusionZoneState_var_samp_fields = {
  __typename?: 'qx_IntrusionZoneState_var_samp_fields';
  bit?: number;
};

/** aggregate variance on columns */
export type qx_IntrusionZoneState_variance_fields = {
  __typename?: 'qx_IntrusionZoneState_variance_fields';
  bit?: number;
};

/** columns and relationships of "qx.Layout" */
export type qx_Layout = {
  __typename?: 'qx_Layout';
  id: string;
  name: string;
  /** An object relationship */
  place: qx_Place;
  placeID: string;
  settings: any;
  updatedAt?: string;
};


/** columns and relationships of "qx.Layout" */
export type qx_LayoutsettingsArgs = {
  path?: string;
};

/** aggregated selection of "qx.Layout" */
export type qx_Layout_aggregate = {
  __typename?: 'qx_Layout_aggregate';
  aggregate?: qx_Layout_aggregate_fields;
  nodes: Array<qx_Layout>;
};

export type qx_Layout_aggregate_bool_exp = {
  count?: qx_Layout_aggregate_bool_exp_count;
};

export type qx_Layout_aggregate_bool_exp_count = {
  arguments?: Array<qx_Layout_select_column>;
  distinct?: boolean;
  filter?: qx_Layout_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.Layout" */
export type qx_Layout_aggregate_fields = {
  __typename?: 'qx_Layout_aggregate_fields';
  count: number;
  max?: qx_Layout_max_fields;
  min?: qx_Layout_min_fields;
};


/** aggregate fields of "qx.Layout" */
export type qx_Layout_aggregate_fieldscountArgs = {
  columns?: Array<qx_Layout_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.Layout" */
export type qx_Layout_aggregate_order_by = {
  count?: order_by;
  max?: qx_Layout_max_order_by;
  min?: qx_Layout_min_order_by;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type qx_Layout_append_input = {
  settings?: any;
};

/** input type for inserting array relation for remote table "qx.Layout" */
export type qx_Layout_arr_rel_insert_input = {
  data: Array<qx_Layout_insert_input>;
  /** upsert condition */
  on_conflict?: qx_Layout_on_conflict;
};

/** Boolean expression to filter rows from the table "qx.Layout". All fields are combined with a logical 'AND'. */
export type qx_Layout_bool_exp = {
  _and?: Array<qx_Layout_bool_exp>;
  _not?: qx_Layout_bool_exp;
  _or?: Array<qx_Layout_bool_exp>;
  id?: String_comparison_exp;
  name?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
  settings?: jsonb_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
};

/** unique or primary key constraints on table "qx.Layout" */
export enum qx_Layout_constraint {
  /** unique or primary key constraint on columns "name", "placeID" */
  Layout_name_placeID_key = 'Layout_name_placeID_key',
  /** unique or primary key constraint on columns "id" */
  Layout_pkey = 'Layout_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type qx_Layout_delete_at_path_input = {
  settings?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type qx_Layout_delete_elem_input = {
  settings?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type qx_Layout_delete_key_input = {
  settings?: string;
};

/** input type for inserting data into table "qx.Layout" */
export type qx_Layout_insert_input = {
  id?: string;
  name?: string;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
  settings?: any;
  updatedAt?: string;
};

/** aggregate max on columns */
export type qx_Layout_max_fields = {
  __typename?: 'qx_Layout_max_fields';
  id?: string;
  name?: string;
  placeID?: string;
  updatedAt?: string;
};

/** order by max() on columns of table "qx.Layout" */
export type qx_Layout_max_order_by = {
  id?: order_by;
  name?: order_by;
  placeID?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type qx_Layout_min_fields = {
  __typename?: 'qx_Layout_min_fields';
  id?: string;
  name?: string;
  placeID?: string;
  updatedAt?: string;
};

/** order by min() on columns of table "qx.Layout" */
export type qx_Layout_min_order_by = {
  id?: order_by;
  name?: order_by;
  placeID?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.Layout" */
export type qx_Layout_mutation_response = {
  __typename?: 'qx_Layout_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_Layout>;
};

/** on_conflict condition type for table "qx.Layout" */
export type qx_Layout_on_conflict = {
  constraint: qx_Layout_constraint;
  update_columns?: Array<qx_Layout_update_column>;
  where?: qx_Layout_bool_exp;
};

/** Ordering options when selecting data from "qx.Layout". */
export type qx_Layout_order_by = {
  id?: order_by;
  name?: order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
  settings?: order_by;
  updatedAt?: order_by;
};

/** primary key columns input for table: qx.Layout */
export type qx_Layout_pk_columns_input = {
  id: string;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type qx_Layout_prepend_input = {
  settings?: any;
};

/** select columns of table "qx.Layout" */
export enum qx_Layout_select_column {
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  settings = 'settings',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "qx.Layout" */
export type qx_Layout_set_input = {
  id?: string;
  name?: string;
  placeID?: string;
  settings?: any;
  updatedAt?: string;
};

/** Streaming cursor of the table "qx_Layout" */
export type qx_Layout_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_Layout_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_Layout_stream_cursor_value_input = {
  id?: string;
  name?: string;
  placeID?: string;
  settings?: any;
  updatedAt?: string;
};

/** update columns of table "qx.Layout" */
export enum qx_Layout_update_column {
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  settings = 'settings',
  /** column name */
  updatedAt = 'updatedAt'
}

export type qx_Layout_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: qx_Layout_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: qx_Layout_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: qx_Layout_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: qx_Layout_delete_key_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: qx_Layout_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_Layout_set_input;
  /** filter the rows which have to be updated */
  where: qx_Layout_bool_exp;
};

/** columns and relationships of "qx.LensProfile" */
export type qx_LensProfile = {
  __typename?: 'qx_LensProfile';
  createdAt: string;
  dewarpParameters: any;
  id: string;
  make?: string;
  model?: string;
  updatedAt: string;
};


/** columns and relationships of "qx.LensProfile" */
export type qx_LensProfiledewarpParametersArgs = {
  path?: string;
};

/** aggregated selection of "qx.LensProfile" */
export type qx_LensProfile_aggregate = {
  __typename?: 'qx_LensProfile_aggregate';
  aggregate?: qx_LensProfile_aggregate_fields;
  nodes: Array<qx_LensProfile>;
};

/** aggregate fields of "qx.LensProfile" */
export type qx_LensProfile_aggregate_fields = {
  __typename?: 'qx_LensProfile_aggregate_fields';
  avg?: qx_LensProfile_avg_fields;
  count: number;
  max?: qx_LensProfile_max_fields;
  min?: qx_LensProfile_min_fields;
  stddev?: qx_LensProfile_stddev_fields;
  stddev_pop?: qx_LensProfile_stddev_pop_fields;
  stddev_samp?: qx_LensProfile_stddev_samp_fields;
  sum?: qx_LensProfile_sum_fields;
  var_pop?: qx_LensProfile_var_pop_fields;
  var_samp?: qx_LensProfile_var_samp_fields;
  variance?: qx_LensProfile_variance_fields;
};


/** aggregate fields of "qx.LensProfile" */
export type qx_LensProfile_aggregate_fieldscountArgs = {
  columns?: Array<qx_LensProfile_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.LensProfile" */
export type qx_LensProfile_aggregate_order_by = {
  avg?: qx_LensProfile_avg_order_by;
  count?: order_by;
  max?: qx_LensProfile_max_order_by;
  min?: qx_LensProfile_min_order_by;
  stddev?: qx_LensProfile_stddev_order_by;
  stddev_pop?: qx_LensProfile_stddev_pop_order_by;
  stddev_samp?: qx_LensProfile_stddev_samp_order_by;
  sum?: qx_LensProfile_sum_order_by;
  var_pop?: qx_LensProfile_var_pop_order_by;
  var_samp?: qx_LensProfile_var_samp_order_by;
  variance?: qx_LensProfile_variance_order_by;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type qx_LensProfile_append_input = {
  dewarpParameters?: any;
};

/** aggregate avg on columns */
export type qx_LensProfile_avg_fields = {
  __typename?: 'qx_LensProfile_avg_fields';
  id?: number;
};

/** order by avg() on columns of table "qx.LensProfile" */
export type qx_LensProfile_avg_order_by = {
  id?: order_by;
};

/** Boolean expression to filter rows from the table "qx.LensProfile". All fields are combined with a logical 'AND'. */
export type qx_LensProfile_bool_exp = {
  _and?: Array<qx_LensProfile_bool_exp>;
  _not?: qx_LensProfile_bool_exp;
  _or?: Array<qx_LensProfile_bool_exp>;
  createdAt?: timestamptz_comparison_exp;
  dewarpParameters?: jsonb_comparison_exp;
  id?: bigint_comparison_exp;
  make?: String_comparison_exp;
  model?: String_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
};

/** unique or primary key constraints on table "qx.LensProfile" */
export enum qx_LensProfile_constraint {
  /** unique or primary key constraint on columns  */
  LensProfile_make_model_key = 'LensProfile_make_model_key',
  /** unique or primary key constraint on columns "id" */
  LensProfile_pkey = 'LensProfile_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type qx_LensProfile_delete_at_path_input = {
  dewarpParameters?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type qx_LensProfile_delete_elem_input = {
  dewarpParameters?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type qx_LensProfile_delete_key_input = {
  dewarpParameters?: string;
};

/** input type for incrementing numeric columns in table "qx.LensProfile" */
export type qx_LensProfile_inc_input = {
  id?: string;
};

/** input type for inserting data into table "qx.LensProfile" */
export type qx_LensProfile_insert_input = {
  createdAt?: string;
  dewarpParameters?: any;
  id?: string;
  make?: string;
  model?: string;
  updatedAt?: string;
};

/** aggregate max on columns */
export type qx_LensProfile_max_fields = {
  __typename?: 'qx_LensProfile_max_fields';
  createdAt?: string;
  id?: string;
  make?: string;
  model?: string;
  updatedAt?: string;
};

/** order by max() on columns of table "qx.LensProfile" */
export type qx_LensProfile_max_order_by = {
  createdAt?: order_by;
  id?: order_by;
  make?: order_by;
  model?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type qx_LensProfile_min_fields = {
  __typename?: 'qx_LensProfile_min_fields';
  createdAt?: string;
  id?: string;
  make?: string;
  model?: string;
  updatedAt?: string;
};

/** order by min() on columns of table "qx.LensProfile" */
export type qx_LensProfile_min_order_by = {
  createdAt?: order_by;
  id?: order_by;
  make?: order_by;
  model?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.LensProfile" */
export type qx_LensProfile_mutation_response = {
  __typename?: 'qx_LensProfile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_LensProfile>;
};

/** on_conflict condition type for table "qx.LensProfile" */
export type qx_LensProfile_on_conflict = {
  constraint: qx_LensProfile_constraint;
  update_columns?: Array<qx_LensProfile_update_column>;
  where?: qx_LensProfile_bool_exp;
};

/** Ordering options when selecting data from "qx.LensProfile". */
export type qx_LensProfile_order_by = {
  createdAt?: order_by;
  dewarpParameters?: order_by;
  id?: order_by;
  make?: order_by;
  model?: order_by;
  updatedAt?: order_by;
};

/** primary key columns input for table: qx.LensProfile */
export type qx_LensProfile_pk_columns_input = {
  id: string;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type qx_LensProfile_prepend_input = {
  dewarpParameters?: any;
};

/** select columns of table "qx.LensProfile" */
export enum qx_LensProfile_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  dewarpParameters = 'dewarpParameters',
  /** column name */
  id = 'id',
  /** column name */
  make = 'make',
  /** column name */
  model = 'model',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "qx.LensProfile" */
export type qx_LensProfile_set_input = {
  createdAt?: string;
  dewarpParameters?: any;
  id?: string;
  make?: string;
  model?: string;
  updatedAt?: string;
};

/** aggregate stddev on columns */
export type qx_LensProfile_stddev_fields = {
  __typename?: 'qx_LensProfile_stddev_fields';
  id?: number;
};

/** order by stddev() on columns of table "qx.LensProfile" */
export type qx_LensProfile_stddev_order_by = {
  id?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_LensProfile_stddev_pop_fields = {
  __typename?: 'qx_LensProfile_stddev_pop_fields';
  id?: number;
};

/** order by stddev_pop() on columns of table "qx.LensProfile" */
export type qx_LensProfile_stddev_pop_order_by = {
  id?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_LensProfile_stddev_samp_fields = {
  __typename?: 'qx_LensProfile_stddev_samp_fields';
  id?: number;
};

/** order by stddev_samp() on columns of table "qx.LensProfile" */
export type qx_LensProfile_stddev_samp_order_by = {
  id?: order_by;
};

/** Streaming cursor of the table "qx_LensProfile" */
export type qx_LensProfile_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_LensProfile_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_LensProfile_stream_cursor_value_input = {
  createdAt?: string;
  dewarpParameters?: any;
  id?: string;
  make?: string;
  model?: string;
  updatedAt?: string;
};

/** aggregate sum on columns */
export type qx_LensProfile_sum_fields = {
  __typename?: 'qx_LensProfile_sum_fields';
  id?: string;
};

/** order by sum() on columns of table "qx.LensProfile" */
export type qx_LensProfile_sum_order_by = {
  id?: order_by;
};

/** update columns of table "qx.LensProfile" */
export enum qx_LensProfile_update_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  dewarpParameters = 'dewarpParameters',
  /** column name */
  id = 'id',
  /** column name */
  make = 'make',
  /** column name */
  model = 'model',
  /** column name */
  updatedAt = 'updatedAt'
}

export type qx_LensProfile_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: qx_LensProfile_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: qx_LensProfile_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: qx_LensProfile_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: qx_LensProfile_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_LensProfile_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: qx_LensProfile_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_LensProfile_set_input;
  /** filter the rows which have to be updated */
  where: qx_LensProfile_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_LensProfile_var_pop_fields = {
  __typename?: 'qx_LensProfile_var_pop_fields';
  id?: number;
};

/** order by var_pop() on columns of table "qx.LensProfile" */
export type qx_LensProfile_var_pop_order_by = {
  id?: order_by;
};

/** aggregate var_samp on columns */
export type qx_LensProfile_var_samp_fields = {
  __typename?: 'qx_LensProfile_var_samp_fields';
  id?: number;
};

/** order by var_samp() on columns of table "qx.LensProfile" */
export type qx_LensProfile_var_samp_order_by = {
  id?: order_by;
};

/** aggregate variance on columns */
export type qx_LensProfile_variance_fields = {
  __typename?: 'qx_LensProfile_variance_fields';
  id?: number;
};

/** order by variance() on columns of table "qx.LensProfile" */
export type qx_LensProfile_variance_order_by = {
  id?: order_by;
};

/** electromechanical lock hardware (electric strike, maglock, or bolt) associated with a door */
export type qx_Lock = {
  __typename?: 'qx_Lock';
  /** An object relationship */
  Device: qx_Device;
  /** An array relationship */
  DeviceDIOs: Array<qx_DeviceDIO>;
  /** An aggregate relationship */
  DeviceDIOs_aggregate: qx_DeviceDIO_aggregate;
  /** An object relationship */
  Door?: qx_Door;
  /** An object relationship */
  accessInventory?: qx_AccessInventory;
  delay?: string;
  deviceID: string;
  direction: qx_eAccessPointDirection_enum;
  doorID?: string;
  /** An object relationship */
  eAccessPointDirection: qx_eAccessPointDirection;
  /** An object relationship */
  eLockMode?: qx_eLockMode;
  /** An object relationship */
  eLockPowerMonitor?: qx_eLockPowerMonitor;
  /** An object relationship */
  eLockRelayMonitor?: qx_eLockRelayMonitor;
  /** An object relationship */
  eLockType: qx_eLockType;
  enabled: boolean;
  id: string;
  inventoryID?: string;
  mode?: qx_eLockMode_enum;
  name: string;
  powerMonitor?: qx_eLockPowerMonitor_enum;
  refID: string;
  relayMonitor?: qx_eLockRelayMonitor_enum;
  type: qx_eLockType_enum;
  updatedAt?: string;
};


/** electromechanical lock hardware (electric strike, maglock, or bolt) associated with a door */
export type qx_LockDeviceDIOsArgs = {
  distinct_on?: Array<qx_DeviceDIO_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DeviceDIO_order_by>;
  where?: qx_DeviceDIO_bool_exp;
};


/** electromechanical lock hardware (electric strike, maglock, or bolt) associated with a door */
export type qx_LockDeviceDIOs_aggregateArgs = {
  distinct_on?: Array<qx_DeviceDIO_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DeviceDIO_order_by>;
  where?: qx_DeviceDIO_bool_exp;
};

/** aggregated selection of "qx.Lock" */
export type qx_Lock_aggregate = {
  __typename?: 'qx_Lock_aggregate';
  aggregate?: qx_Lock_aggregate_fields;
  nodes: Array<qx_Lock>;
};

export type qx_Lock_aggregate_bool_exp = {
  bool_and?: qx_Lock_aggregate_bool_exp_bool_and;
  bool_or?: qx_Lock_aggregate_bool_exp_bool_or;
  count?: qx_Lock_aggregate_bool_exp_count;
};

export type qx_Lock_aggregate_bool_exp_bool_and = {
  arguments: qx_Lock_select_column_qx_Lock_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: qx_Lock_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_Lock_aggregate_bool_exp_bool_or = {
  arguments: qx_Lock_select_column_qx_Lock_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: qx_Lock_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_Lock_aggregate_bool_exp_count = {
  arguments?: Array<qx_Lock_select_column>;
  distinct?: boolean;
  filter?: qx_Lock_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.Lock" */
export type qx_Lock_aggregate_fields = {
  __typename?: 'qx_Lock_aggregate_fields';
  avg?: qx_Lock_avg_fields;
  count: number;
  max?: qx_Lock_max_fields;
  min?: qx_Lock_min_fields;
  stddev?: qx_Lock_stddev_fields;
  stddev_pop?: qx_Lock_stddev_pop_fields;
  stddev_samp?: qx_Lock_stddev_samp_fields;
  sum?: qx_Lock_sum_fields;
  var_pop?: qx_Lock_var_pop_fields;
  var_samp?: qx_Lock_var_samp_fields;
  variance?: qx_Lock_variance_fields;
};


/** aggregate fields of "qx.Lock" */
export type qx_Lock_aggregate_fieldscountArgs = {
  columns?: Array<qx_Lock_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.Lock" */
export type qx_Lock_aggregate_order_by = {
  avg?: qx_Lock_avg_order_by;
  count?: order_by;
  max?: qx_Lock_max_order_by;
  min?: qx_Lock_min_order_by;
  stddev?: qx_Lock_stddev_order_by;
  stddev_pop?: qx_Lock_stddev_pop_order_by;
  stddev_samp?: qx_Lock_stddev_samp_order_by;
  sum?: qx_Lock_sum_order_by;
  var_pop?: qx_Lock_var_pop_order_by;
  var_samp?: qx_Lock_var_samp_order_by;
  variance?: qx_Lock_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.Lock" */
export type qx_Lock_arr_rel_insert_input = {
  data: Array<qx_Lock_insert_input>;
  /** upsert condition */
  on_conflict?: qx_Lock_on_conflict;
};

/** aggregate avg on columns */
export type qx_Lock_avg_fields = {
  __typename?: 'qx_Lock_avg_fields';
  doorID?: number;
};

/** order by avg() on columns of table "qx.Lock" */
export type qx_Lock_avg_order_by = {
  doorID?: order_by;
};

/** Boolean expression to filter rows from the table "qx.Lock". All fields are combined with a logical 'AND'. */
export type qx_Lock_bool_exp = {
  Device?: qx_Device_bool_exp;
  DeviceDIOs?: qx_DeviceDIO_bool_exp;
  DeviceDIOs_aggregate?: qx_DeviceDIO_aggregate_bool_exp;
  Door?: qx_Door_bool_exp;
  _and?: Array<qx_Lock_bool_exp>;
  _not?: qx_Lock_bool_exp;
  _or?: Array<qx_Lock_bool_exp>;
  accessInventory?: qx_AccessInventory_bool_exp;
  delay?: String_comparison_exp;
  deviceID?: String_comparison_exp;
  direction?: qx_eAccessPointDirection_enum_comparison_exp;
  doorID?: bigint_comparison_exp;
  eAccessPointDirection?: qx_eAccessPointDirection_bool_exp;
  eLockMode?: qx_eLockMode_bool_exp;
  eLockPowerMonitor?: qx_eLockPowerMonitor_bool_exp;
  eLockRelayMonitor?: qx_eLockRelayMonitor_bool_exp;
  eLockType?: qx_eLockType_bool_exp;
  enabled?: Boolean_comparison_exp;
  id?: String_comparison_exp;
  inventoryID?: String_comparison_exp;
  mode?: qx_eLockMode_enum_comparison_exp;
  name?: String_comparison_exp;
  powerMonitor?: qx_eLockPowerMonitor_enum_comparison_exp;
  refID?: String_comparison_exp;
  relayMonitor?: qx_eLockRelayMonitor_enum_comparison_exp;
  type?: qx_eLockType_enum_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
};

/** unique or primary key constraints on table "qx.Lock" */
export enum qx_Lock_constraint {
  /** unique or primary key constraint on columns "refID", "deviceID" */
  Lock_deviceID_refID_constraint = 'Lock_deviceID_refID_constraint',
  /** unique or primary key constraint on columns "id" */
  Lock_pkey = 'Lock_pkey'
}

/** input type for incrementing numeric columns in table "qx.Lock" */
export type qx_Lock_inc_input = {
  doorID?: string;
};

/** input type for inserting data into table "qx.Lock" */
export type qx_Lock_insert_input = {
  Device?: qx_Device_obj_rel_insert_input;
  DeviceDIOs?: qx_DeviceDIO_arr_rel_insert_input;
  Door?: qx_Door_obj_rel_insert_input;
  accessInventory?: qx_AccessInventory_obj_rel_insert_input;
  delay?: string;
  deviceID?: string;
  direction?: qx_eAccessPointDirection_enum;
  doorID?: string;
  eAccessPointDirection?: qx_eAccessPointDirection_obj_rel_insert_input;
  eLockMode?: qx_eLockMode_obj_rel_insert_input;
  eLockPowerMonitor?: qx_eLockPowerMonitor_obj_rel_insert_input;
  eLockRelayMonitor?: qx_eLockRelayMonitor_obj_rel_insert_input;
  eLockType?: qx_eLockType_obj_rel_insert_input;
  enabled?: boolean;
  id?: string;
  inventoryID?: string;
  mode?: qx_eLockMode_enum;
  name?: string;
  powerMonitor?: qx_eLockPowerMonitor_enum;
  refID?: string;
  relayMonitor?: qx_eLockRelayMonitor_enum;
  type?: qx_eLockType_enum;
  updatedAt?: string;
};

/** aggregate max on columns */
export type qx_Lock_max_fields = {
  __typename?: 'qx_Lock_max_fields';
  delay?: string;
  deviceID?: string;
  doorID?: string;
  id?: string;
  inventoryID?: string;
  name?: string;
  refID?: string;
  updatedAt?: string;
};

/** order by max() on columns of table "qx.Lock" */
export type qx_Lock_max_order_by = {
  delay?: order_by;
  deviceID?: order_by;
  doorID?: order_by;
  id?: order_by;
  inventoryID?: order_by;
  name?: order_by;
  refID?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type qx_Lock_min_fields = {
  __typename?: 'qx_Lock_min_fields';
  delay?: string;
  deviceID?: string;
  doorID?: string;
  id?: string;
  inventoryID?: string;
  name?: string;
  refID?: string;
  updatedAt?: string;
};

/** order by min() on columns of table "qx.Lock" */
export type qx_Lock_min_order_by = {
  delay?: order_by;
  deviceID?: order_by;
  doorID?: order_by;
  id?: order_by;
  inventoryID?: order_by;
  name?: order_by;
  refID?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.Lock" */
export type qx_Lock_mutation_response = {
  __typename?: 'qx_Lock_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_Lock>;
};

/** input type for inserting object relation for remote table "qx.Lock" */
export type qx_Lock_obj_rel_insert_input = {
  data: qx_Lock_insert_input;
  /** upsert condition */
  on_conflict?: qx_Lock_on_conflict;
};

/** on_conflict condition type for table "qx.Lock" */
export type qx_Lock_on_conflict = {
  constraint: qx_Lock_constraint;
  update_columns?: Array<qx_Lock_update_column>;
  where?: qx_Lock_bool_exp;
};

/** Ordering options when selecting data from "qx.Lock". */
export type qx_Lock_order_by = {
  Device?: qx_Device_order_by;
  DeviceDIOs_aggregate?: qx_DeviceDIO_aggregate_order_by;
  Door?: qx_Door_order_by;
  accessInventory?: qx_AccessInventory_order_by;
  delay?: order_by;
  deviceID?: order_by;
  direction?: order_by;
  doorID?: order_by;
  eAccessPointDirection?: qx_eAccessPointDirection_order_by;
  eLockMode?: qx_eLockMode_order_by;
  eLockPowerMonitor?: qx_eLockPowerMonitor_order_by;
  eLockRelayMonitor?: qx_eLockRelayMonitor_order_by;
  eLockType?: qx_eLockType_order_by;
  enabled?: order_by;
  id?: order_by;
  inventoryID?: order_by;
  mode?: order_by;
  name?: order_by;
  powerMonitor?: order_by;
  refID?: order_by;
  relayMonitor?: order_by;
  type?: order_by;
  updatedAt?: order_by;
};

/** primary key columns input for table: qx.Lock */
export type qx_Lock_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.Lock" */
export enum qx_Lock_select_column {
  /** column name */
  delay = 'delay',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  direction = 'direction',
  /** column name */
  doorID = 'doorID',
  /** column name */
  enabled = 'enabled',
  /** column name */
  id = 'id',
  /** column name */
  inventoryID = 'inventoryID',
  /** column name */
  mode = 'mode',
  /** column name */
  name = 'name',
  /** column name */
  powerMonitor = 'powerMonitor',
  /** column name */
  refID = 'refID',
  /** column name */
  relayMonitor = 'relayMonitor',
  /** column name */
  type = 'type',
  /** column name */
  updatedAt = 'updatedAt'
}

/** select "qx_Lock_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.Lock" */
export enum qx_Lock_select_column_qx_Lock_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  enabled = 'enabled'
}

/** select "qx_Lock_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.Lock" */
export enum qx_Lock_select_column_qx_Lock_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  enabled = 'enabled'
}

/** input type for updating data in table "qx.Lock" */
export type qx_Lock_set_input = {
  delay?: string;
  deviceID?: string;
  direction?: qx_eAccessPointDirection_enum;
  doorID?: string;
  enabled?: boolean;
  id?: string;
  inventoryID?: string;
  mode?: qx_eLockMode_enum;
  name?: string;
  powerMonitor?: qx_eLockPowerMonitor_enum;
  refID?: string;
  relayMonitor?: qx_eLockRelayMonitor_enum;
  type?: qx_eLockType_enum;
  updatedAt?: string;
};

/** aggregate stddev on columns */
export type qx_Lock_stddev_fields = {
  __typename?: 'qx_Lock_stddev_fields';
  doorID?: number;
};

/** order by stddev() on columns of table "qx.Lock" */
export type qx_Lock_stddev_order_by = {
  doorID?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_Lock_stddev_pop_fields = {
  __typename?: 'qx_Lock_stddev_pop_fields';
  doorID?: number;
};

/** order by stddev_pop() on columns of table "qx.Lock" */
export type qx_Lock_stddev_pop_order_by = {
  doorID?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_Lock_stddev_samp_fields = {
  __typename?: 'qx_Lock_stddev_samp_fields';
  doorID?: number;
};

/** order by stddev_samp() on columns of table "qx.Lock" */
export type qx_Lock_stddev_samp_order_by = {
  doorID?: order_by;
};

/** Streaming cursor of the table "qx_Lock" */
export type qx_Lock_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_Lock_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_Lock_stream_cursor_value_input = {
  delay?: string;
  deviceID?: string;
  direction?: qx_eAccessPointDirection_enum;
  doorID?: string;
  enabled?: boolean;
  id?: string;
  inventoryID?: string;
  mode?: qx_eLockMode_enum;
  name?: string;
  powerMonitor?: qx_eLockPowerMonitor_enum;
  refID?: string;
  relayMonitor?: qx_eLockRelayMonitor_enum;
  type?: qx_eLockType_enum;
  updatedAt?: string;
};

/** aggregate sum on columns */
export type qx_Lock_sum_fields = {
  __typename?: 'qx_Lock_sum_fields';
  doorID?: string;
};

/** order by sum() on columns of table "qx.Lock" */
export type qx_Lock_sum_order_by = {
  doorID?: order_by;
};

/** update columns of table "qx.Lock" */
export enum qx_Lock_update_column {
  /** column name */
  delay = 'delay',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  direction = 'direction',
  /** column name */
  doorID = 'doorID',
  /** column name */
  enabled = 'enabled',
  /** column name */
  id = 'id',
  /** column name */
  inventoryID = 'inventoryID',
  /** column name */
  mode = 'mode',
  /** column name */
  name = 'name',
  /** column name */
  powerMonitor = 'powerMonitor',
  /** column name */
  refID = 'refID',
  /** column name */
  relayMonitor = 'relayMonitor',
  /** column name */
  type = 'type',
  /** column name */
  updatedAt = 'updatedAt'
}

export type qx_Lock_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_Lock_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_Lock_set_input;
  /** filter the rows which have to be updated */
  where: qx_Lock_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_Lock_var_pop_fields = {
  __typename?: 'qx_Lock_var_pop_fields';
  doorID?: number;
};

/** order by var_pop() on columns of table "qx.Lock" */
export type qx_Lock_var_pop_order_by = {
  doorID?: order_by;
};

/** aggregate var_samp on columns */
export type qx_Lock_var_samp_fields = {
  __typename?: 'qx_Lock_var_samp_fields';
  doorID?: number;
};

/** order by var_samp() on columns of table "qx.Lock" */
export type qx_Lock_var_samp_order_by = {
  doorID?: order_by;
};

/** aggregate variance on columns */
export type qx_Lock_variance_fields = {
  __typename?: 'qx_Lock_variance_fields';
  doorID?: number;
};

/** order by variance() on columns of table "qx.Lock" */
export type qx_Lock_variance_order_by = {
  doorID?: order_by;
};

/** video recording configuration (resolution, frame rate, retention period, recording schedule) for a video source */
export type qx_MediaProfile = {
  __typename?: 'qx_MediaProfile';
  /** An array relationship */
  MediaProfileRecordings: Array<qx_MediaProfileRecording>;
  /** An aggregate relationship */
  MediaProfileRecordings_aggregate: qx_MediaProfileRecording_aggregate;
  audioCodec?: string;
  audioEncoderOptions?: any;
  audioEncoderSettings?: any;
  /** An object relationship */
  audioSource?: qx_AudioSource;
  audioSourceID?: string;
  cloudSnapshotToken?: string;
  /** A computed field, executes function "qx.cloud_view_token" */
  cloudViewToken?: string;
  createdAt: string;
  deletedAt?: string;
  /** An object relationship */
  device: qx_Device;
  deviceID: string;
  /** An array relationship */
  events: Array<qx_Event>;
  /** An aggregate relationship */
  events_aggregate: qx_Event_aggregate;
  httpUrl?: string;
  id: string;
  liveToken?: string;
  name: string;
  newestMedia?: Array<qx_vNewestMedia>;
  oldestMedia?: Array<qx_vOldestMedia>;
  /** An object relationship */
  place: qx_Place;
  placeID: string;
  ptzPresets?: any;
  ptzToken?: string;
  refID: string;
  rtspUrl?: string;
  /** An array relationship */
  segments: Array<qx_Segment>;
  /** An aggregate relationship */
  segments_aggregate: qx_Segment_aggregate;
  snapshotToken?: string;
  snapshotUrl?: string;
  streamEnabled: boolean;
  streamFile: string;
  streamStatus: qx_eStreamStatus_enum;
  /** An object relationship */
  toStreamStatus: qx_eStreamStatus;
  updatedAt?: string;
  videoEncoderOptions?: any;
  videoEncoderSettings?: any;
  /** An object relationship */
  videoSource: qx_VideoSource;
  videoSourceID: string;
  viewToken?: string;
  warped: boolean;
};


/** video recording configuration (resolution, frame rate, retention period, recording schedule) for a video source */
export type qx_MediaProfileMediaProfileRecordingsArgs = {
  distinct_on?: Array<qx_MediaProfileRecording_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MediaProfileRecording_order_by>;
  where?: qx_MediaProfileRecording_bool_exp;
};


/** video recording configuration (resolution, frame rate, retention period, recording schedule) for a video source */
export type qx_MediaProfileMediaProfileRecordings_aggregateArgs = {
  distinct_on?: Array<qx_MediaProfileRecording_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MediaProfileRecording_order_by>;
  where?: qx_MediaProfileRecording_bool_exp;
};


/** video recording configuration (resolution, frame rate, retention period, recording schedule) for a video source */
export type qx_MediaProfileaudioEncoderOptionsArgs = {
  path?: string;
};


/** video recording configuration (resolution, frame rate, retention period, recording schedule) for a video source */
export type qx_MediaProfileaudioEncoderSettingsArgs = {
  path?: string;
};


/** video recording configuration (resolution, frame rate, retention period, recording schedule) for a video source */
export type qx_MediaProfileeventsArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};


/** video recording configuration (resolution, frame rate, retention period, recording schedule) for a video source */
export type qx_MediaProfileevents_aggregateArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};


/** video recording configuration (resolution, frame rate, retention period, recording schedule) for a video source */
export type qx_MediaProfilenewestMediaArgs = {
  distinct_on?: Array<qx_vNewestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vNewestMedia_order_by>;
  where?: qx_vNewestMedia_bool_exp;
};


/** video recording configuration (resolution, frame rate, retention period, recording schedule) for a video source */
export type qx_MediaProfileoldestMediaArgs = {
  distinct_on?: Array<qx_vOldestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vOldestMedia_order_by>;
  where?: qx_vOldestMedia_bool_exp;
};


/** video recording configuration (resolution, frame rate, retention period, recording schedule) for a video source */
export type qx_MediaProfileptzPresetsArgs = {
  path?: string;
};


/** video recording configuration (resolution, frame rate, retention period, recording schedule) for a video source */
export type qx_MediaProfilesegmentsArgs = {
  distinct_on?: Array<qx_Segment_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Segment_order_by>;
  where?: qx_Segment_bool_exp;
};


/** video recording configuration (resolution, frame rate, retention period, recording schedule) for a video source */
export type qx_MediaProfilesegments_aggregateArgs = {
  distinct_on?: Array<qx_Segment_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Segment_order_by>;
  where?: qx_Segment_bool_exp;
};


/** video recording configuration (resolution, frame rate, retention period, recording schedule) for a video source */
export type qx_MediaProfilevideoEncoderOptionsArgs = {
  path?: string;
};


/** video recording configuration (resolution, frame rate, retention period, recording schedule) for a video source */
export type qx_MediaProfilevideoEncoderSettingsArgs = {
  path?: string;
};

/** columns and relationships of "qx.MediaProfileRecording" */
export type qx_MediaProfileRecording = {
  __typename?: 'qx_MediaProfileRecording';
  baseDate: string;
  createdAt: string;
  id: string;
  /** An object relationship */
  mediaProfile: qx_MediaProfile;
  mediaProfileID: string;
  recordings?: any;
  type: string;
};

/** aggregated selection of "qx.MediaProfileRecording" */
export type qx_MediaProfileRecording_aggregate = {
  __typename?: 'qx_MediaProfileRecording_aggregate';
  aggregate?: qx_MediaProfileRecording_aggregate_fields;
  nodes: Array<qx_MediaProfileRecording>;
};

export type qx_MediaProfileRecording_aggregate_bool_exp = {
  count?: qx_MediaProfileRecording_aggregate_bool_exp_count;
};

export type qx_MediaProfileRecording_aggregate_bool_exp_count = {
  arguments?: Array<qx_MediaProfileRecording_select_column>;
  distinct?: boolean;
  filter?: qx_MediaProfileRecording_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.MediaProfileRecording" */
export type qx_MediaProfileRecording_aggregate_fields = {
  __typename?: 'qx_MediaProfileRecording_aggregate_fields';
  avg?: qx_MediaProfileRecording_avg_fields;
  count: number;
  max?: qx_MediaProfileRecording_max_fields;
  min?: qx_MediaProfileRecording_min_fields;
  stddev?: qx_MediaProfileRecording_stddev_fields;
  stddev_pop?: qx_MediaProfileRecording_stddev_pop_fields;
  stddev_samp?: qx_MediaProfileRecording_stddev_samp_fields;
  sum?: qx_MediaProfileRecording_sum_fields;
  var_pop?: qx_MediaProfileRecording_var_pop_fields;
  var_samp?: qx_MediaProfileRecording_var_samp_fields;
  variance?: qx_MediaProfileRecording_variance_fields;
};


/** aggregate fields of "qx.MediaProfileRecording" */
export type qx_MediaProfileRecording_aggregate_fieldscountArgs = {
  columns?: Array<qx_MediaProfileRecording_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.MediaProfileRecording" */
export type qx_MediaProfileRecording_aggregate_order_by = {
  avg?: qx_MediaProfileRecording_avg_order_by;
  count?: order_by;
  max?: qx_MediaProfileRecording_max_order_by;
  min?: qx_MediaProfileRecording_min_order_by;
  stddev?: qx_MediaProfileRecording_stddev_order_by;
  stddev_pop?: qx_MediaProfileRecording_stddev_pop_order_by;
  stddev_samp?: qx_MediaProfileRecording_stddev_samp_order_by;
  sum?: qx_MediaProfileRecording_sum_order_by;
  var_pop?: qx_MediaProfileRecording_var_pop_order_by;
  var_samp?: qx_MediaProfileRecording_var_samp_order_by;
  variance?: qx_MediaProfileRecording_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.MediaProfileRecording" */
export type qx_MediaProfileRecording_arr_rel_insert_input = {
  data: Array<qx_MediaProfileRecording_insert_input>;
  /** upsert condition */
  on_conflict?: qx_MediaProfileRecording_on_conflict;
};

/** aggregate avg on columns */
export type qx_MediaProfileRecording_avg_fields = {
  __typename?: 'qx_MediaProfileRecording_avg_fields';
  id?: number;
  mediaProfileID?: number;
};

/** order by avg() on columns of table "qx.MediaProfileRecording" */
export type qx_MediaProfileRecording_avg_order_by = {
  id?: order_by;
  mediaProfileID?: order_by;
};

/** Boolean expression to filter rows from the table "qx.MediaProfileRecording". All fields are combined with a logical 'AND'. */
export type qx_MediaProfileRecording_bool_exp = {
  _and?: Array<qx_MediaProfileRecording_bool_exp>;
  _not?: qx_MediaProfileRecording_bool_exp;
  _or?: Array<qx_MediaProfileRecording_bool_exp>;
  baseDate?: timestamp_comparison_exp;
  createdAt?: timestamptz_comparison_exp;
  id?: bigint_comparison_exp;
  mediaProfile?: qx_MediaProfile_bool_exp;
  mediaProfileID?: bigint_comparison_exp;
  recordings?: bytea_comparison_exp;
  type?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.MediaProfileRecording" */
export enum qx_MediaProfileRecording_constraint {
  /** unique or primary key constraint on columns "id" */
  MediaProfileRecording_pk = 'MediaProfileRecording_pk',
  /** unique or primary key constraint on columns "type", "baseDate", "mediaProfileID" */
  idx_MediaProfileRecording_unique = 'idx_MediaProfileRecording_unique'
}

/** input type for incrementing numeric columns in table "qx.MediaProfileRecording" */
export type qx_MediaProfileRecording_inc_input = {
  mediaProfileID?: string;
};

/** input type for inserting data into table "qx.MediaProfileRecording" */
export type qx_MediaProfileRecording_insert_input = {
  baseDate?: string;
  createdAt?: string;
  mediaProfile?: qx_MediaProfile_obj_rel_insert_input;
  mediaProfileID?: string;
  recordings?: any;
  type?: string;
};

/** aggregate max on columns */
export type qx_MediaProfileRecording_max_fields = {
  __typename?: 'qx_MediaProfileRecording_max_fields';
  baseDate?: string;
  createdAt?: string;
  id?: string;
  mediaProfileID?: string;
  type?: string;
};

/** order by max() on columns of table "qx.MediaProfileRecording" */
export type qx_MediaProfileRecording_max_order_by = {
  baseDate?: order_by;
  createdAt?: order_by;
  id?: order_by;
  mediaProfileID?: order_by;
  type?: order_by;
};

/** aggregate min on columns */
export type qx_MediaProfileRecording_min_fields = {
  __typename?: 'qx_MediaProfileRecording_min_fields';
  baseDate?: string;
  createdAt?: string;
  id?: string;
  mediaProfileID?: string;
  type?: string;
};

/** order by min() on columns of table "qx.MediaProfileRecording" */
export type qx_MediaProfileRecording_min_order_by = {
  baseDate?: order_by;
  createdAt?: order_by;
  id?: order_by;
  mediaProfileID?: order_by;
  type?: order_by;
};

/** response of any mutation on the table "qx.MediaProfileRecording" */
export type qx_MediaProfileRecording_mutation_response = {
  __typename?: 'qx_MediaProfileRecording_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_MediaProfileRecording>;
};

/** on_conflict condition type for table "qx.MediaProfileRecording" */
export type qx_MediaProfileRecording_on_conflict = {
  constraint: qx_MediaProfileRecording_constraint;
  update_columns?: Array<qx_MediaProfileRecording_update_column>;
  where?: qx_MediaProfileRecording_bool_exp;
};

/** Ordering options when selecting data from "qx.MediaProfileRecording". */
export type qx_MediaProfileRecording_order_by = {
  baseDate?: order_by;
  createdAt?: order_by;
  id?: order_by;
  mediaProfile?: qx_MediaProfile_order_by;
  mediaProfileID?: order_by;
  recordings?: order_by;
  type?: order_by;
};

/** primary key columns input for table: qx.MediaProfileRecording */
export type qx_MediaProfileRecording_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.MediaProfileRecording" */
export enum qx_MediaProfileRecording_select_column {
  /** column name */
  baseDate = 'baseDate',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  mediaProfileID = 'mediaProfileID',
  /** column name */
  recordings = 'recordings',
  /** column name */
  type = 'type'
}

/** input type for updating data in table "qx.MediaProfileRecording" */
export type qx_MediaProfileRecording_set_input = {
  baseDate?: string;
  createdAt?: string;
  mediaProfileID?: string;
  recordings?: any;
  type?: string;
};

/** aggregate stddev on columns */
export type qx_MediaProfileRecording_stddev_fields = {
  __typename?: 'qx_MediaProfileRecording_stddev_fields';
  id?: number;
  mediaProfileID?: number;
};

/** order by stddev() on columns of table "qx.MediaProfileRecording" */
export type qx_MediaProfileRecording_stddev_order_by = {
  id?: order_by;
  mediaProfileID?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_MediaProfileRecording_stddev_pop_fields = {
  __typename?: 'qx_MediaProfileRecording_stddev_pop_fields';
  id?: number;
  mediaProfileID?: number;
};

/** order by stddev_pop() on columns of table "qx.MediaProfileRecording" */
export type qx_MediaProfileRecording_stddev_pop_order_by = {
  id?: order_by;
  mediaProfileID?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_MediaProfileRecording_stddev_samp_fields = {
  __typename?: 'qx_MediaProfileRecording_stddev_samp_fields';
  id?: number;
  mediaProfileID?: number;
};

/** order by stddev_samp() on columns of table "qx.MediaProfileRecording" */
export type qx_MediaProfileRecording_stddev_samp_order_by = {
  id?: order_by;
  mediaProfileID?: order_by;
};

/** Streaming cursor of the table "qx_MediaProfileRecording" */
export type qx_MediaProfileRecording_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_MediaProfileRecording_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_MediaProfileRecording_stream_cursor_value_input = {
  baseDate?: string;
  createdAt?: string;
  id?: string;
  mediaProfileID?: string;
  recordings?: any;
  type?: string;
};

/** aggregate sum on columns */
export type qx_MediaProfileRecording_sum_fields = {
  __typename?: 'qx_MediaProfileRecording_sum_fields';
  id?: string;
  mediaProfileID?: string;
};

/** order by sum() on columns of table "qx.MediaProfileRecording" */
export type qx_MediaProfileRecording_sum_order_by = {
  id?: order_by;
  mediaProfileID?: order_by;
};

/** update columns of table "qx.MediaProfileRecording" */
export enum qx_MediaProfileRecording_update_column {
  /** column name */
  baseDate = 'baseDate',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  mediaProfileID = 'mediaProfileID',
  /** column name */
  recordings = 'recordings',
  /** column name */
  type = 'type'
}

export type qx_MediaProfileRecording_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_MediaProfileRecording_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_MediaProfileRecording_set_input;
  /** filter the rows which have to be updated */
  where: qx_MediaProfileRecording_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_MediaProfileRecording_var_pop_fields = {
  __typename?: 'qx_MediaProfileRecording_var_pop_fields';
  id?: number;
  mediaProfileID?: number;
};

/** order by var_pop() on columns of table "qx.MediaProfileRecording" */
export type qx_MediaProfileRecording_var_pop_order_by = {
  id?: order_by;
  mediaProfileID?: order_by;
};

/** aggregate var_samp on columns */
export type qx_MediaProfileRecording_var_samp_fields = {
  __typename?: 'qx_MediaProfileRecording_var_samp_fields';
  id?: number;
  mediaProfileID?: number;
};

/** order by var_samp() on columns of table "qx.MediaProfileRecording" */
export type qx_MediaProfileRecording_var_samp_order_by = {
  id?: order_by;
  mediaProfileID?: order_by;
};

/** aggregate variance on columns */
export type qx_MediaProfileRecording_variance_fields = {
  __typename?: 'qx_MediaProfileRecording_variance_fields';
  id?: number;
  mediaProfileID?: number;
};

/** order by variance() on columns of table "qx.MediaProfileRecording" */
export type qx_MediaProfileRecording_variance_order_by = {
  id?: order_by;
  mediaProfileID?: order_by;
};

/** aggregated selection of "qx.MediaProfile" */
export type qx_MediaProfile_aggregate = {
  __typename?: 'qx_MediaProfile_aggregate';
  aggregate?: qx_MediaProfile_aggregate_fields;
  nodes: Array<qx_MediaProfile>;
};

export type qx_MediaProfile_aggregate_bool_exp = {
  bool_and?: qx_MediaProfile_aggregate_bool_exp_bool_and;
  bool_or?: qx_MediaProfile_aggregate_bool_exp_bool_or;
  count?: qx_MediaProfile_aggregate_bool_exp_count;
};

export type qx_MediaProfile_aggregate_bool_exp_bool_and = {
  arguments: qx_MediaProfile_select_column_qx_MediaProfile_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: qx_MediaProfile_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_MediaProfile_aggregate_bool_exp_bool_or = {
  arguments: qx_MediaProfile_select_column_qx_MediaProfile_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: qx_MediaProfile_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_MediaProfile_aggregate_bool_exp_count = {
  arguments?: Array<qx_MediaProfile_select_column>;
  distinct?: boolean;
  filter?: qx_MediaProfile_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.MediaProfile" */
export type qx_MediaProfile_aggregate_fields = {
  __typename?: 'qx_MediaProfile_aggregate_fields';
  avg?: qx_MediaProfile_avg_fields;
  count: number;
  max?: qx_MediaProfile_max_fields;
  min?: qx_MediaProfile_min_fields;
  stddev?: qx_MediaProfile_stddev_fields;
  stddev_pop?: qx_MediaProfile_stddev_pop_fields;
  stddev_samp?: qx_MediaProfile_stddev_samp_fields;
  sum?: qx_MediaProfile_sum_fields;
  var_pop?: qx_MediaProfile_var_pop_fields;
  var_samp?: qx_MediaProfile_var_samp_fields;
  variance?: qx_MediaProfile_variance_fields;
};


/** aggregate fields of "qx.MediaProfile" */
export type qx_MediaProfile_aggregate_fieldscountArgs = {
  columns?: Array<qx_MediaProfile_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.MediaProfile" */
export type qx_MediaProfile_aggregate_order_by = {
  avg?: qx_MediaProfile_avg_order_by;
  count?: order_by;
  max?: qx_MediaProfile_max_order_by;
  min?: qx_MediaProfile_min_order_by;
  stddev?: qx_MediaProfile_stddev_order_by;
  stddev_pop?: qx_MediaProfile_stddev_pop_order_by;
  stddev_samp?: qx_MediaProfile_stddev_samp_order_by;
  sum?: qx_MediaProfile_sum_order_by;
  var_pop?: qx_MediaProfile_var_pop_order_by;
  var_samp?: qx_MediaProfile_var_samp_order_by;
  variance?: qx_MediaProfile_variance_order_by;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type qx_MediaProfile_append_input = {
  audioEncoderOptions?: any;
  audioEncoderSettings?: any;
  ptzPresets?: any;
  videoEncoderOptions?: any;
  videoEncoderSettings?: any;
};

/** input type for inserting array relation for remote table "qx.MediaProfile" */
export type qx_MediaProfile_arr_rel_insert_input = {
  data: Array<qx_MediaProfile_insert_input>;
  /** upsert condition */
  on_conflict?: qx_MediaProfile_on_conflict;
};

/** aggregate avg on columns */
export type qx_MediaProfile_avg_fields = {
  __typename?: 'qx_MediaProfile_avg_fields';
  audioSourceID?: number;
  id?: number;
  videoSourceID?: number;
};

/** order by avg() on columns of table "qx.MediaProfile" */
export type qx_MediaProfile_avg_order_by = {
  audioSourceID?: order_by;
  id?: order_by;
  videoSourceID?: order_by;
};

/** Boolean expression to filter rows from the table "qx.MediaProfile". All fields are combined with a logical 'AND'. */
export type qx_MediaProfile_bool_exp = {
  MediaProfileRecordings?: qx_MediaProfileRecording_bool_exp;
  MediaProfileRecordings_aggregate?: qx_MediaProfileRecording_aggregate_bool_exp;
  _and?: Array<qx_MediaProfile_bool_exp>;
  _not?: qx_MediaProfile_bool_exp;
  _or?: Array<qx_MediaProfile_bool_exp>;
  audioCodec?: String_comparison_exp;
  audioEncoderOptions?: jsonb_comparison_exp;
  audioEncoderSettings?: jsonb_comparison_exp;
  audioSource?: qx_AudioSource_bool_exp;
  audioSourceID?: bigint_comparison_exp;
  cloudSnapshotToken?: String_comparison_exp;
  cloudViewToken?: String_comparison_exp;
  createdAt?: timestamptz_comparison_exp;
  deletedAt?: timestamptz_comparison_exp;
  device?: qx_Device_bool_exp;
  deviceID?: String_comparison_exp;
  events?: qx_Event_bool_exp;
  events_aggregate?: qx_Event_aggregate_bool_exp;
  httpUrl?: String_comparison_exp;
  id?: bigint_comparison_exp;
  liveToken?: String_comparison_exp;
  name?: String_comparison_exp;
  newestMedia?: qx_vNewestMedia_bool_exp;
  oldestMedia?: qx_vOldestMedia_bool_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
  ptzPresets?: jsonb_comparison_exp;
  ptzToken?: String_comparison_exp;
  refID?: String_comparison_exp;
  rtspUrl?: String_comparison_exp;
  segments?: qx_Segment_bool_exp;
  segments_aggregate?: qx_Segment_aggregate_bool_exp;
  snapshotToken?: String_comparison_exp;
  snapshotUrl?: String_comparison_exp;
  streamEnabled?: Boolean_comparison_exp;
  streamFile?: String_comparison_exp;
  streamStatus?: qx_eStreamStatus_enum_comparison_exp;
  toStreamStatus?: qx_eStreamStatus_bool_exp;
  updatedAt?: timestamptz_comparison_exp;
  videoEncoderOptions?: jsonb_comparison_exp;
  videoEncoderSettings?: jsonb_comparison_exp;
  videoSource?: qx_VideoSource_bool_exp;
  videoSourceID?: bigint_comparison_exp;
  viewToken?: String_comparison_exp;
  warped?: Boolean_comparison_exp;
};

/** unique or primary key constraints on table "qx.MediaProfile" */
export enum qx_MediaProfile_constraint {
  /** unique or primary key constraint on columns "refID", "deviceID" */
  MediaProfile_deviceID_refID_constraint = 'MediaProfile_deviceID_refID_constraint',
  /** unique or primary key constraint on columns "id" */
  MediaProfile_pkey = 'MediaProfile_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type qx_MediaProfile_delete_at_path_input = {
  audioEncoderOptions?: Array<string>;
  audioEncoderSettings?: Array<string>;
  ptzPresets?: Array<string>;
  videoEncoderOptions?: Array<string>;
  videoEncoderSettings?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type qx_MediaProfile_delete_elem_input = {
  audioEncoderOptions?: number;
  audioEncoderSettings?: number;
  ptzPresets?: number;
  videoEncoderOptions?: number;
  videoEncoderSettings?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type qx_MediaProfile_delete_key_input = {
  audioEncoderOptions?: string;
  audioEncoderSettings?: string;
  ptzPresets?: string;
  videoEncoderOptions?: string;
  videoEncoderSettings?: string;
};

/** input type for incrementing numeric columns in table "qx.MediaProfile" */
export type qx_MediaProfile_inc_input = {
  audioSourceID?: string;
  id?: string;
  videoSourceID?: string;
};

/** input type for inserting data into table "qx.MediaProfile" */
export type qx_MediaProfile_insert_input = {
  MediaProfileRecordings?: qx_MediaProfileRecording_arr_rel_insert_input;
  audioEncoderOptions?: any;
  audioEncoderSettings?: any;
  audioSource?: qx_AudioSource_obj_rel_insert_input;
  audioSourceID?: string;
  createdAt?: string;
  deletedAt?: string;
  device?: qx_Device_obj_rel_insert_input;
  deviceID?: string;
  events?: qx_Event_arr_rel_insert_input;
  httpUrl?: string;
  id?: string;
  name?: string;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
  ptzPresets?: any;
  refID?: string;
  rtspUrl?: string;
  segments?: qx_Segment_arr_rel_insert_input;
  snapshotUrl?: string;
  streamEnabled?: boolean;
  streamFile?: string;
  streamStatus?: qx_eStreamStatus_enum;
  toStreamStatus?: qx_eStreamStatus_obj_rel_insert_input;
  updatedAt?: string;
  videoEncoderOptions?: any;
  videoEncoderSettings?: any;
  videoSource?: qx_VideoSource_obj_rel_insert_input;
  videoSourceID?: string;
  warped?: boolean;
};

/** aggregate max on columns */
export type qx_MediaProfile_max_fields = {
  __typename?: 'qx_MediaProfile_max_fields';
  audioCodec?: string;
  audioSourceID?: string;
  cloudSnapshotToken?: string;
  /** A computed field, executes function "qx.cloud_view_token" */
  cloudViewToken?: string;
  createdAt?: string;
  deletedAt?: string;
  deviceID?: string;
  httpUrl?: string;
  id?: string;
  liveToken?: string;
  name?: string;
  placeID?: string;
  ptzToken?: string;
  refID?: string;
  rtspUrl?: string;
  snapshotToken?: string;
  snapshotUrl?: string;
  streamFile?: string;
  updatedAt?: string;
  videoSourceID?: string;
  viewToken?: string;
};

/** order by max() on columns of table "qx.MediaProfile" */
export type qx_MediaProfile_max_order_by = {
  audioSourceID?: order_by;
  createdAt?: order_by;
  deletedAt?: order_by;
  deviceID?: order_by;
  httpUrl?: order_by;
  id?: order_by;
  name?: order_by;
  placeID?: order_by;
  refID?: order_by;
  rtspUrl?: order_by;
  snapshotUrl?: order_by;
  streamFile?: order_by;
  updatedAt?: order_by;
  videoSourceID?: order_by;
};

/** aggregate min on columns */
export type qx_MediaProfile_min_fields = {
  __typename?: 'qx_MediaProfile_min_fields';
  audioCodec?: string;
  audioSourceID?: string;
  cloudSnapshotToken?: string;
  /** A computed field, executes function "qx.cloud_view_token" */
  cloudViewToken?: string;
  createdAt?: string;
  deletedAt?: string;
  deviceID?: string;
  httpUrl?: string;
  id?: string;
  liveToken?: string;
  name?: string;
  placeID?: string;
  ptzToken?: string;
  refID?: string;
  rtspUrl?: string;
  snapshotToken?: string;
  snapshotUrl?: string;
  streamFile?: string;
  updatedAt?: string;
  videoSourceID?: string;
  viewToken?: string;
};

/** order by min() on columns of table "qx.MediaProfile" */
export type qx_MediaProfile_min_order_by = {
  audioSourceID?: order_by;
  createdAt?: order_by;
  deletedAt?: order_by;
  deviceID?: order_by;
  httpUrl?: order_by;
  id?: order_by;
  name?: order_by;
  placeID?: order_by;
  refID?: order_by;
  rtspUrl?: order_by;
  snapshotUrl?: order_by;
  streamFile?: order_by;
  updatedAt?: order_by;
  videoSourceID?: order_by;
};

/** response of any mutation on the table "qx.MediaProfile" */
export type qx_MediaProfile_mutation_response = {
  __typename?: 'qx_MediaProfile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_MediaProfile>;
};

/** input type for inserting object relation for remote table "qx.MediaProfile" */
export type qx_MediaProfile_obj_rel_insert_input = {
  data: qx_MediaProfile_insert_input;
  /** upsert condition */
  on_conflict?: qx_MediaProfile_on_conflict;
};

/** on_conflict condition type for table "qx.MediaProfile" */
export type qx_MediaProfile_on_conflict = {
  constraint: qx_MediaProfile_constraint;
  update_columns?: Array<qx_MediaProfile_update_column>;
  where?: qx_MediaProfile_bool_exp;
};

/** Ordering options when selecting data from "qx.MediaProfile". */
export type qx_MediaProfile_order_by = {
  MediaProfileRecordings_aggregate?: qx_MediaProfileRecording_aggregate_order_by;
  audioCodec?: order_by;
  audioEncoderOptions?: order_by;
  audioEncoderSettings?: order_by;
  audioSource?: qx_AudioSource_order_by;
  audioSourceID?: order_by;
  cloudSnapshotToken?: order_by;
  cloudViewToken?: order_by;
  createdAt?: order_by;
  deletedAt?: order_by;
  device?: qx_Device_order_by;
  deviceID?: order_by;
  events_aggregate?: qx_Event_aggregate_order_by;
  httpUrl?: order_by;
  id?: order_by;
  liveToken?: order_by;
  name?: order_by;
  newestMedia_aggregate?: qx_vNewestMedia_aggregate_order_by;
  oldestMedia_aggregate?: qx_vOldestMedia_aggregate_order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
  ptzPresets?: order_by;
  ptzToken?: order_by;
  refID?: order_by;
  rtspUrl?: order_by;
  segments_aggregate?: qx_Segment_aggregate_order_by;
  snapshotToken?: order_by;
  snapshotUrl?: order_by;
  streamEnabled?: order_by;
  streamFile?: order_by;
  streamStatus?: order_by;
  toStreamStatus?: qx_eStreamStatus_order_by;
  updatedAt?: order_by;
  videoEncoderOptions?: order_by;
  videoEncoderSettings?: order_by;
  videoSource?: qx_VideoSource_order_by;
  videoSourceID?: order_by;
  viewToken?: order_by;
  warped?: order_by;
};

/** primary key columns input for table: qx.MediaProfile */
export type qx_MediaProfile_pk_columns_input = {
  id: string;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type qx_MediaProfile_prepend_input = {
  audioEncoderOptions?: any;
  audioEncoderSettings?: any;
  ptzPresets?: any;
  videoEncoderOptions?: any;
  videoEncoderSettings?: any;
};

/** select columns of table "qx.MediaProfile" */
export enum qx_MediaProfile_select_column {
  /** column name */
  audioEncoderOptions = 'audioEncoderOptions',
  /** column name */
  audioEncoderSettings = 'audioEncoderSettings',
  /** column name */
  audioSourceID = 'audioSourceID',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  deletedAt = 'deletedAt',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  httpUrl = 'httpUrl',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  ptzPresets = 'ptzPresets',
  /** column name */
  refID = 'refID',
  /** column name */
  rtspUrl = 'rtspUrl',
  /** column name */
  snapshotUrl = 'snapshotUrl',
  /** column name */
  streamEnabled = 'streamEnabled',
  /** column name */
  streamFile = 'streamFile',
  /** column name */
  streamStatus = 'streamStatus',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  videoEncoderOptions = 'videoEncoderOptions',
  /** column name */
  videoEncoderSettings = 'videoEncoderSettings',
  /** column name */
  videoSourceID = 'videoSourceID',
  /** column name */
  warped = 'warped'
}

/** select "qx_MediaProfile_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.MediaProfile" */
export enum qx_MediaProfile_select_column_qx_MediaProfile_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  streamEnabled = 'streamEnabled',
  /** column name */
  warped = 'warped'
}

/** select "qx_MediaProfile_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.MediaProfile" */
export enum qx_MediaProfile_select_column_qx_MediaProfile_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  streamEnabled = 'streamEnabled',
  /** column name */
  warped = 'warped'
}

/** input type for updating data in table "qx.MediaProfile" */
export type qx_MediaProfile_set_input = {
  audioEncoderOptions?: any;
  audioEncoderSettings?: any;
  audioSourceID?: string;
  createdAt?: string;
  deletedAt?: string;
  deviceID?: string;
  httpUrl?: string;
  id?: string;
  name?: string;
  placeID?: string;
  ptzPresets?: any;
  refID?: string;
  rtspUrl?: string;
  snapshotUrl?: string;
  streamEnabled?: boolean;
  streamFile?: string;
  streamStatus?: qx_eStreamStatus_enum;
  updatedAt?: string;
  videoEncoderOptions?: any;
  videoEncoderSettings?: any;
  videoSourceID?: string;
  warped?: boolean;
};

/** aggregate stddev on columns */
export type qx_MediaProfile_stddev_fields = {
  __typename?: 'qx_MediaProfile_stddev_fields';
  audioSourceID?: number;
  id?: number;
  videoSourceID?: number;
};

/** order by stddev() on columns of table "qx.MediaProfile" */
export type qx_MediaProfile_stddev_order_by = {
  audioSourceID?: order_by;
  id?: order_by;
  videoSourceID?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_MediaProfile_stddev_pop_fields = {
  __typename?: 'qx_MediaProfile_stddev_pop_fields';
  audioSourceID?: number;
  id?: number;
  videoSourceID?: number;
};

/** order by stddev_pop() on columns of table "qx.MediaProfile" */
export type qx_MediaProfile_stddev_pop_order_by = {
  audioSourceID?: order_by;
  id?: order_by;
  videoSourceID?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_MediaProfile_stddev_samp_fields = {
  __typename?: 'qx_MediaProfile_stddev_samp_fields';
  audioSourceID?: number;
  id?: number;
  videoSourceID?: number;
};

/** order by stddev_samp() on columns of table "qx.MediaProfile" */
export type qx_MediaProfile_stddev_samp_order_by = {
  audioSourceID?: order_by;
  id?: order_by;
  videoSourceID?: order_by;
};

/** Streaming cursor of the table "qx_MediaProfile" */
export type qx_MediaProfile_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_MediaProfile_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_MediaProfile_stream_cursor_value_input = {
  audioEncoderOptions?: any;
  audioEncoderSettings?: any;
  audioSourceID?: string;
  createdAt?: string;
  deletedAt?: string;
  deviceID?: string;
  httpUrl?: string;
  id?: string;
  name?: string;
  placeID?: string;
  ptzPresets?: any;
  refID?: string;
  rtspUrl?: string;
  snapshotUrl?: string;
  streamEnabled?: boolean;
  streamFile?: string;
  streamStatus?: qx_eStreamStatus_enum;
  updatedAt?: string;
  videoEncoderOptions?: any;
  videoEncoderSettings?: any;
  videoSourceID?: string;
  warped?: boolean;
};

/** aggregate sum on columns */
export type qx_MediaProfile_sum_fields = {
  __typename?: 'qx_MediaProfile_sum_fields';
  audioSourceID?: string;
  id?: string;
  videoSourceID?: string;
};

/** order by sum() on columns of table "qx.MediaProfile" */
export type qx_MediaProfile_sum_order_by = {
  audioSourceID?: order_by;
  id?: order_by;
  videoSourceID?: order_by;
};

/** update columns of table "qx.MediaProfile" */
export enum qx_MediaProfile_update_column {
  /** column name */
  audioEncoderOptions = 'audioEncoderOptions',
  /** column name */
  audioEncoderSettings = 'audioEncoderSettings',
  /** column name */
  audioSourceID = 'audioSourceID',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  deletedAt = 'deletedAt',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  httpUrl = 'httpUrl',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  ptzPresets = 'ptzPresets',
  /** column name */
  refID = 'refID',
  /** column name */
  rtspUrl = 'rtspUrl',
  /** column name */
  snapshotUrl = 'snapshotUrl',
  /** column name */
  streamEnabled = 'streamEnabled',
  /** column name */
  streamFile = 'streamFile',
  /** column name */
  streamStatus = 'streamStatus',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  videoEncoderOptions = 'videoEncoderOptions',
  /** column name */
  videoEncoderSettings = 'videoEncoderSettings',
  /** column name */
  videoSourceID = 'videoSourceID',
  /** column name */
  warped = 'warped'
}

export type qx_MediaProfile_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: qx_MediaProfile_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: qx_MediaProfile_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: qx_MediaProfile_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: qx_MediaProfile_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_MediaProfile_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: qx_MediaProfile_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_MediaProfile_set_input;
  /** filter the rows which have to be updated */
  where: qx_MediaProfile_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_MediaProfile_var_pop_fields = {
  __typename?: 'qx_MediaProfile_var_pop_fields';
  audioSourceID?: number;
  id?: number;
  videoSourceID?: number;
};

/** order by var_pop() on columns of table "qx.MediaProfile" */
export type qx_MediaProfile_var_pop_order_by = {
  audioSourceID?: order_by;
  id?: order_by;
  videoSourceID?: order_by;
};

/** aggregate var_samp on columns */
export type qx_MediaProfile_var_samp_fields = {
  __typename?: 'qx_MediaProfile_var_samp_fields';
  audioSourceID?: number;
  id?: number;
  videoSourceID?: number;
};

/** order by var_samp() on columns of table "qx.MediaProfile" */
export type qx_MediaProfile_var_samp_order_by = {
  audioSourceID?: order_by;
  id?: order_by;
  videoSourceID?: order_by;
};

/** aggregate variance on columns */
export type qx_MediaProfile_variance_fields = {
  __typename?: 'qx_MediaProfile_variance_fields';
  audioSourceID?: number;
  id?: number;
  videoSourceID?: number;
};

/** order by variance() on columns of table "qx.MediaProfile" */
export type qx_MediaProfile_variance_order_by = {
  audioSourceID?: order_by;
  id?: order_by;
  videoSourceID?: order_by;
};

/** columns and relationships of "qx.MercuryControlPoint" */
export type qx_MercuryControlPoint = {
  __typename?: 'qx_MercuryControlPoint';
  /** An object relationship */
  OutputPoint: qx_OutputPoint;
  /** An object relationship */
  accessInventory: qx_AccessInventory;
  id: string;
  inventoryID: string;
  offTime?: string;
  onTime?: string;
  outputPointID: string;
  repeat?: boolean;
};

/** aggregated selection of "qx.MercuryControlPoint" */
export type qx_MercuryControlPoint_aggregate = {
  __typename?: 'qx_MercuryControlPoint_aggregate';
  aggregate?: qx_MercuryControlPoint_aggregate_fields;
  nodes: Array<qx_MercuryControlPoint>;
};

export type qx_MercuryControlPoint_aggregate_bool_exp = {
  bool_and?: qx_MercuryControlPoint_aggregate_bool_exp_bool_and;
  bool_or?: qx_MercuryControlPoint_aggregate_bool_exp_bool_or;
  count?: qx_MercuryControlPoint_aggregate_bool_exp_count;
};

export type qx_MercuryControlPoint_aggregate_bool_exp_bool_and = {
  arguments: qx_MercuryControlPoint_select_column_qx_MercuryControlPoint_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: qx_MercuryControlPoint_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_MercuryControlPoint_aggregate_bool_exp_bool_or = {
  arguments: qx_MercuryControlPoint_select_column_qx_MercuryControlPoint_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: qx_MercuryControlPoint_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_MercuryControlPoint_aggregate_bool_exp_count = {
  arguments?: Array<qx_MercuryControlPoint_select_column>;
  distinct?: boolean;
  filter?: qx_MercuryControlPoint_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.MercuryControlPoint" */
export type qx_MercuryControlPoint_aggregate_fields = {
  __typename?: 'qx_MercuryControlPoint_aggregate_fields';
  count: number;
  max?: qx_MercuryControlPoint_max_fields;
  min?: qx_MercuryControlPoint_min_fields;
};


/** aggregate fields of "qx.MercuryControlPoint" */
export type qx_MercuryControlPoint_aggregate_fieldscountArgs = {
  columns?: Array<qx_MercuryControlPoint_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.MercuryControlPoint" */
export type qx_MercuryControlPoint_aggregate_order_by = {
  count?: order_by;
  max?: qx_MercuryControlPoint_max_order_by;
  min?: qx_MercuryControlPoint_min_order_by;
};

/** input type for inserting array relation for remote table "qx.MercuryControlPoint" */
export type qx_MercuryControlPoint_arr_rel_insert_input = {
  data: Array<qx_MercuryControlPoint_insert_input>;
  /** upsert condition */
  on_conflict?: qx_MercuryControlPoint_on_conflict;
};

/** Boolean expression to filter rows from the table "qx.MercuryControlPoint". All fields are combined with a logical 'AND'. */
export type qx_MercuryControlPoint_bool_exp = {
  OutputPoint?: qx_OutputPoint_bool_exp;
  _and?: Array<qx_MercuryControlPoint_bool_exp>;
  _not?: qx_MercuryControlPoint_bool_exp;
  _or?: Array<qx_MercuryControlPoint_bool_exp>;
  accessInventory?: qx_AccessInventory_bool_exp;
  id?: String_comparison_exp;
  inventoryID?: String_comparison_exp;
  offTime?: String_comparison_exp;
  onTime?: String_comparison_exp;
  outputPointID?: String_comparison_exp;
  repeat?: Boolean_comparison_exp;
};

/** unique or primary key constraints on table "qx.MercuryControlPoint" */
export enum qx_MercuryControlPoint_constraint {
  /** unique or primary key constraint on columns "id" */
  MercuryControlPoint_pkey = 'MercuryControlPoint_pkey'
}

/** input type for inserting data into table "qx.MercuryControlPoint" */
export type qx_MercuryControlPoint_insert_input = {
  OutputPoint?: qx_OutputPoint_obj_rel_insert_input;
  accessInventory?: qx_AccessInventory_obj_rel_insert_input;
  id?: string;
  inventoryID?: string;
  offTime?: string;
  onTime?: string;
  outputPointID?: string;
  repeat?: boolean;
};

/** aggregate max on columns */
export type qx_MercuryControlPoint_max_fields = {
  __typename?: 'qx_MercuryControlPoint_max_fields';
  id?: string;
  inventoryID?: string;
  offTime?: string;
  onTime?: string;
  outputPointID?: string;
};

/** order by max() on columns of table "qx.MercuryControlPoint" */
export type qx_MercuryControlPoint_max_order_by = {
  id?: order_by;
  inventoryID?: order_by;
  offTime?: order_by;
  onTime?: order_by;
  outputPointID?: order_by;
};

/** aggregate min on columns */
export type qx_MercuryControlPoint_min_fields = {
  __typename?: 'qx_MercuryControlPoint_min_fields';
  id?: string;
  inventoryID?: string;
  offTime?: string;
  onTime?: string;
  outputPointID?: string;
};

/** order by min() on columns of table "qx.MercuryControlPoint" */
export type qx_MercuryControlPoint_min_order_by = {
  id?: order_by;
  inventoryID?: order_by;
  offTime?: order_by;
  onTime?: order_by;
  outputPointID?: order_by;
};

/** response of any mutation on the table "qx.MercuryControlPoint" */
export type qx_MercuryControlPoint_mutation_response = {
  __typename?: 'qx_MercuryControlPoint_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_MercuryControlPoint>;
};

/** on_conflict condition type for table "qx.MercuryControlPoint" */
export type qx_MercuryControlPoint_on_conflict = {
  constraint: qx_MercuryControlPoint_constraint;
  update_columns?: Array<qx_MercuryControlPoint_update_column>;
  where?: qx_MercuryControlPoint_bool_exp;
};

/** Ordering options when selecting data from "qx.MercuryControlPoint". */
export type qx_MercuryControlPoint_order_by = {
  OutputPoint?: qx_OutputPoint_order_by;
  accessInventory?: qx_AccessInventory_order_by;
  id?: order_by;
  inventoryID?: order_by;
  offTime?: order_by;
  onTime?: order_by;
  outputPointID?: order_by;
  repeat?: order_by;
};

/** primary key columns input for table: qx.MercuryControlPoint */
export type qx_MercuryControlPoint_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.MercuryControlPoint" */
export enum qx_MercuryControlPoint_select_column {
  /** column name */
  id = 'id',
  /** column name */
  inventoryID = 'inventoryID',
  /** column name */
  offTime = 'offTime',
  /** column name */
  onTime = 'onTime',
  /** column name */
  outputPointID = 'outputPointID',
  /** column name */
  repeat = 'repeat'
}

/** select "qx_MercuryControlPoint_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.MercuryControlPoint" */
export enum qx_MercuryControlPoint_select_column_qx_MercuryControlPoint_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  repeat = 'repeat'
}

/** select "qx_MercuryControlPoint_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.MercuryControlPoint" */
export enum qx_MercuryControlPoint_select_column_qx_MercuryControlPoint_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  repeat = 'repeat'
}

/** input type for updating data in table "qx.MercuryControlPoint" */
export type qx_MercuryControlPoint_set_input = {
  id?: string;
  inventoryID?: string;
  offTime?: string;
  onTime?: string;
  outputPointID?: string;
  repeat?: boolean;
};

/** Streaming cursor of the table "qx_MercuryControlPoint" */
export type qx_MercuryControlPoint_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_MercuryControlPoint_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_MercuryControlPoint_stream_cursor_value_input = {
  id?: string;
  inventoryID?: string;
  offTime?: string;
  onTime?: string;
  outputPointID?: string;
  repeat?: boolean;
};

/** update columns of table "qx.MercuryControlPoint" */
export enum qx_MercuryControlPoint_update_column {
  /** column name */
  id = 'id',
  /** column name */
  inventoryID = 'inventoryID',
  /** column name */
  offTime = 'offTime',
  /** column name */
  onTime = 'onTime',
  /** column name */
  outputPointID = 'outputPointID',
  /** column name */
  repeat = 'repeat'
}

export type qx_MercuryControlPoint_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_MercuryControlPoint_set_input;
  /** filter the rows which have to be updated */
  where: qx_MercuryControlPoint_bool_exp;
};

/** columns and relationships of "qx.MercuryMonitorPoint" */
export type qx_MercuryMonitorPoint = {
  __typename?: 'qx_MercuryMonitorPoint';
  /** An object relationship */
  InputPoint: qx_InputPoint;
  /** An object relationship */
  accessInventory: qx_AccessInventory;
  debounce?: number;
  delayEntry?: string;
  delayExit?: string;
  /** An object relationship */
  eMercuryMonitorPointLatchMode?: qx_eMercuryMonitorPointLatchModes;
  holdTime?: string;
  id: string;
  inputPointID: string;
  inventoryID: string;
  mask?: number;
  mode?: qx_eMercuryMonitorPointLatchModes_enum;
};

/** aggregated selection of "qx.MercuryMonitorPoint" */
export type qx_MercuryMonitorPoint_aggregate = {
  __typename?: 'qx_MercuryMonitorPoint_aggregate';
  aggregate?: qx_MercuryMonitorPoint_aggregate_fields;
  nodes: Array<qx_MercuryMonitorPoint>;
};

export type qx_MercuryMonitorPoint_aggregate_bool_exp = {
  count?: qx_MercuryMonitorPoint_aggregate_bool_exp_count;
};

export type qx_MercuryMonitorPoint_aggregate_bool_exp_count = {
  arguments?: Array<qx_MercuryMonitorPoint_select_column>;
  distinct?: boolean;
  filter?: qx_MercuryMonitorPoint_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.MercuryMonitorPoint" */
export type qx_MercuryMonitorPoint_aggregate_fields = {
  __typename?: 'qx_MercuryMonitorPoint_aggregate_fields';
  avg?: qx_MercuryMonitorPoint_avg_fields;
  count: number;
  max?: qx_MercuryMonitorPoint_max_fields;
  min?: qx_MercuryMonitorPoint_min_fields;
  stddev?: qx_MercuryMonitorPoint_stddev_fields;
  stddev_pop?: qx_MercuryMonitorPoint_stddev_pop_fields;
  stddev_samp?: qx_MercuryMonitorPoint_stddev_samp_fields;
  sum?: qx_MercuryMonitorPoint_sum_fields;
  var_pop?: qx_MercuryMonitorPoint_var_pop_fields;
  var_samp?: qx_MercuryMonitorPoint_var_samp_fields;
  variance?: qx_MercuryMonitorPoint_variance_fields;
};


/** aggregate fields of "qx.MercuryMonitorPoint" */
export type qx_MercuryMonitorPoint_aggregate_fieldscountArgs = {
  columns?: Array<qx_MercuryMonitorPoint_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.MercuryMonitorPoint" */
export type qx_MercuryMonitorPoint_aggregate_order_by = {
  avg?: qx_MercuryMonitorPoint_avg_order_by;
  count?: order_by;
  max?: qx_MercuryMonitorPoint_max_order_by;
  min?: qx_MercuryMonitorPoint_min_order_by;
  stddev?: qx_MercuryMonitorPoint_stddev_order_by;
  stddev_pop?: qx_MercuryMonitorPoint_stddev_pop_order_by;
  stddev_samp?: qx_MercuryMonitorPoint_stddev_samp_order_by;
  sum?: qx_MercuryMonitorPoint_sum_order_by;
  var_pop?: qx_MercuryMonitorPoint_var_pop_order_by;
  var_samp?: qx_MercuryMonitorPoint_var_samp_order_by;
  variance?: qx_MercuryMonitorPoint_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.MercuryMonitorPoint" */
export type qx_MercuryMonitorPoint_arr_rel_insert_input = {
  data: Array<qx_MercuryMonitorPoint_insert_input>;
  /** upsert condition */
  on_conflict?: qx_MercuryMonitorPoint_on_conflict;
};

/** aggregate avg on columns */
export type qx_MercuryMonitorPoint_avg_fields = {
  __typename?: 'qx_MercuryMonitorPoint_avg_fields';
  debounce?: number;
  mask?: number;
};

/** order by avg() on columns of table "qx.MercuryMonitorPoint" */
export type qx_MercuryMonitorPoint_avg_order_by = {
  debounce?: order_by;
  mask?: order_by;
};

/** Boolean expression to filter rows from the table "qx.MercuryMonitorPoint". All fields are combined with a logical 'AND'. */
export type qx_MercuryMonitorPoint_bool_exp = {
  InputPoint?: qx_InputPoint_bool_exp;
  _and?: Array<qx_MercuryMonitorPoint_bool_exp>;
  _not?: qx_MercuryMonitorPoint_bool_exp;
  _or?: Array<qx_MercuryMonitorPoint_bool_exp>;
  accessInventory?: qx_AccessInventory_bool_exp;
  debounce?: Int_comparison_exp;
  delayEntry?: String_comparison_exp;
  delayExit?: String_comparison_exp;
  eMercuryMonitorPointLatchMode?: qx_eMercuryMonitorPointLatchModes_bool_exp;
  holdTime?: String_comparison_exp;
  id?: String_comparison_exp;
  inputPointID?: String_comparison_exp;
  inventoryID?: String_comparison_exp;
  mask?: Int_comparison_exp;
  mode?: qx_eMercuryMonitorPointLatchModes_enum_comparison_exp;
};

/** unique or primary key constraints on table "qx.MercuryMonitorPoint" */
export enum qx_MercuryMonitorPoint_constraint {
  /** unique or primary key constraint on columns "id" */
  MercuryMonitorPoint_pkey = 'MercuryMonitorPoint_pkey'
}

/** input type for incrementing numeric columns in table "qx.MercuryMonitorPoint" */
export type qx_MercuryMonitorPoint_inc_input = {
  debounce?: number;
  mask?: number;
};

/** input type for inserting data into table "qx.MercuryMonitorPoint" */
export type qx_MercuryMonitorPoint_insert_input = {
  InputPoint?: qx_InputPoint_obj_rel_insert_input;
  accessInventory?: qx_AccessInventory_obj_rel_insert_input;
  debounce?: number;
  delayEntry?: string;
  delayExit?: string;
  eMercuryMonitorPointLatchMode?: qx_eMercuryMonitorPointLatchModes_obj_rel_insert_input;
  holdTime?: string;
  id?: string;
  inputPointID?: string;
  inventoryID?: string;
  mask?: number;
  mode?: qx_eMercuryMonitorPointLatchModes_enum;
};

/** aggregate max on columns */
export type qx_MercuryMonitorPoint_max_fields = {
  __typename?: 'qx_MercuryMonitorPoint_max_fields';
  debounce?: number;
  delayEntry?: string;
  delayExit?: string;
  holdTime?: string;
  id?: string;
  inputPointID?: string;
  inventoryID?: string;
  mask?: number;
};

/** order by max() on columns of table "qx.MercuryMonitorPoint" */
export type qx_MercuryMonitorPoint_max_order_by = {
  debounce?: order_by;
  delayEntry?: order_by;
  delayExit?: order_by;
  holdTime?: order_by;
  id?: order_by;
  inputPointID?: order_by;
  inventoryID?: order_by;
  mask?: order_by;
};

/** aggregate min on columns */
export type qx_MercuryMonitorPoint_min_fields = {
  __typename?: 'qx_MercuryMonitorPoint_min_fields';
  debounce?: number;
  delayEntry?: string;
  delayExit?: string;
  holdTime?: string;
  id?: string;
  inputPointID?: string;
  inventoryID?: string;
  mask?: number;
};

/** order by min() on columns of table "qx.MercuryMonitorPoint" */
export type qx_MercuryMonitorPoint_min_order_by = {
  debounce?: order_by;
  delayEntry?: order_by;
  delayExit?: order_by;
  holdTime?: order_by;
  id?: order_by;
  inputPointID?: order_by;
  inventoryID?: order_by;
  mask?: order_by;
};

/** response of any mutation on the table "qx.MercuryMonitorPoint" */
export type qx_MercuryMonitorPoint_mutation_response = {
  __typename?: 'qx_MercuryMonitorPoint_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_MercuryMonitorPoint>;
};

/** on_conflict condition type for table "qx.MercuryMonitorPoint" */
export type qx_MercuryMonitorPoint_on_conflict = {
  constraint: qx_MercuryMonitorPoint_constraint;
  update_columns?: Array<qx_MercuryMonitorPoint_update_column>;
  where?: qx_MercuryMonitorPoint_bool_exp;
};

/** Ordering options when selecting data from "qx.MercuryMonitorPoint". */
export type qx_MercuryMonitorPoint_order_by = {
  InputPoint?: qx_InputPoint_order_by;
  accessInventory?: qx_AccessInventory_order_by;
  debounce?: order_by;
  delayEntry?: order_by;
  delayExit?: order_by;
  eMercuryMonitorPointLatchMode?: qx_eMercuryMonitorPointLatchModes_order_by;
  holdTime?: order_by;
  id?: order_by;
  inputPointID?: order_by;
  inventoryID?: order_by;
  mask?: order_by;
  mode?: order_by;
};

/** primary key columns input for table: qx.MercuryMonitorPoint */
export type qx_MercuryMonitorPoint_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.MercuryMonitorPoint" */
export enum qx_MercuryMonitorPoint_select_column {
  /** column name */
  debounce = 'debounce',
  /** column name */
  delayEntry = 'delayEntry',
  /** column name */
  delayExit = 'delayExit',
  /** column name */
  holdTime = 'holdTime',
  /** column name */
  id = 'id',
  /** column name */
  inputPointID = 'inputPointID',
  /** column name */
  inventoryID = 'inventoryID',
  /** column name */
  mask = 'mask',
  /** column name */
  mode = 'mode'
}

/** input type for updating data in table "qx.MercuryMonitorPoint" */
export type qx_MercuryMonitorPoint_set_input = {
  debounce?: number;
  delayEntry?: string;
  delayExit?: string;
  holdTime?: string;
  id?: string;
  inputPointID?: string;
  inventoryID?: string;
  mask?: number;
  mode?: qx_eMercuryMonitorPointLatchModes_enum;
};

/** aggregate stddev on columns */
export type qx_MercuryMonitorPoint_stddev_fields = {
  __typename?: 'qx_MercuryMonitorPoint_stddev_fields';
  debounce?: number;
  mask?: number;
};

/** order by stddev() on columns of table "qx.MercuryMonitorPoint" */
export type qx_MercuryMonitorPoint_stddev_order_by = {
  debounce?: order_by;
  mask?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_MercuryMonitorPoint_stddev_pop_fields = {
  __typename?: 'qx_MercuryMonitorPoint_stddev_pop_fields';
  debounce?: number;
  mask?: number;
};

/** order by stddev_pop() on columns of table "qx.MercuryMonitorPoint" */
export type qx_MercuryMonitorPoint_stddev_pop_order_by = {
  debounce?: order_by;
  mask?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_MercuryMonitorPoint_stddev_samp_fields = {
  __typename?: 'qx_MercuryMonitorPoint_stddev_samp_fields';
  debounce?: number;
  mask?: number;
};

/** order by stddev_samp() on columns of table "qx.MercuryMonitorPoint" */
export type qx_MercuryMonitorPoint_stddev_samp_order_by = {
  debounce?: order_by;
  mask?: order_by;
};

/** Streaming cursor of the table "qx_MercuryMonitorPoint" */
export type qx_MercuryMonitorPoint_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_MercuryMonitorPoint_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_MercuryMonitorPoint_stream_cursor_value_input = {
  debounce?: number;
  delayEntry?: string;
  delayExit?: string;
  holdTime?: string;
  id?: string;
  inputPointID?: string;
  inventoryID?: string;
  mask?: number;
  mode?: qx_eMercuryMonitorPointLatchModes_enum;
};

/** aggregate sum on columns */
export type qx_MercuryMonitorPoint_sum_fields = {
  __typename?: 'qx_MercuryMonitorPoint_sum_fields';
  debounce?: number;
  mask?: number;
};

/** order by sum() on columns of table "qx.MercuryMonitorPoint" */
export type qx_MercuryMonitorPoint_sum_order_by = {
  debounce?: order_by;
  mask?: order_by;
};

/** update columns of table "qx.MercuryMonitorPoint" */
export enum qx_MercuryMonitorPoint_update_column {
  /** column name */
  debounce = 'debounce',
  /** column name */
  delayEntry = 'delayEntry',
  /** column name */
  delayExit = 'delayExit',
  /** column name */
  holdTime = 'holdTime',
  /** column name */
  id = 'id',
  /** column name */
  inputPointID = 'inputPointID',
  /** column name */
  inventoryID = 'inventoryID',
  /** column name */
  mask = 'mask',
  /** column name */
  mode = 'mode'
}

export type qx_MercuryMonitorPoint_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_MercuryMonitorPoint_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_MercuryMonitorPoint_set_input;
  /** filter the rows which have to be updated */
  where: qx_MercuryMonitorPoint_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_MercuryMonitorPoint_var_pop_fields = {
  __typename?: 'qx_MercuryMonitorPoint_var_pop_fields';
  debounce?: number;
  mask?: number;
};

/** order by var_pop() on columns of table "qx.MercuryMonitorPoint" */
export type qx_MercuryMonitorPoint_var_pop_order_by = {
  debounce?: order_by;
  mask?: order_by;
};

/** aggregate var_samp on columns */
export type qx_MercuryMonitorPoint_var_samp_fields = {
  __typename?: 'qx_MercuryMonitorPoint_var_samp_fields';
  debounce?: number;
  mask?: number;
};

/** order by var_samp() on columns of table "qx.MercuryMonitorPoint" */
export type qx_MercuryMonitorPoint_var_samp_order_by = {
  debounce?: order_by;
  mask?: order_by;
};

/** aggregate variance on columns */
export type qx_MercuryMonitorPoint_variance_fields = {
  __typename?: 'qx_MercuryMonitorPoint_variance_fields';
  debounce?: number;
  mask?: number;
};

/** order by variance() on columns of table "qx.MercuryMonitorPoint" */
export type qx_MercuryMonitorPoint_variance_order_by = {
  debounce?: order_by;
  mask?: order_by;
};

/** columns and relationships of "qx.OssIdAssignment" */
export type qx_OssIdAssignment = {
  __typename?: 'qx_OssIdAssignment';
  /** An object relationship */
  gateway: qx_Gateway;
  gatewayID: string;
  id: string;
  ossID: number;
  /** A computed field, executes function "qx.get_oss_id_assignment_site_placeID" */
  sitePlaceID?: string;
  targetID: string;
  targetType: string;
  updatedAt: string;
};

/** aggregated selection of "qx.OssIdAssignment" */
export type qx_OssIdAssignment_aggregate = {
  __typename?: 'qx_OssIdAssignment_aggregate';
  aggregate?: qx_OssIdAssignment_aggregate_fields;
  nodes: Array<qx_OssIdAssignment>;
};

/** aggregate fields of "qx.OssIdAssignment" */
export type qx_OssIdAssignment_aggregate_fields = {
  __typename?: 'qx_OssIdAssignment_aggregate_fields';
  avg?: qx_OssIdAssignment_avg_fields;
  count: number;
  max?: qx_OssIdAssignment_max_fields;
  min?: qx_OssIdAssignment_min_fields;
  stddev?: qx_OssIdAssignment_stddev_fields;
  stddev_pop?: qx_OssIdAssignment_stddev_pop_fields;
  stddev_samp?: qx_OssIdAssignment_stddev_samp_fields;
  sum?: qx_OssIdAssignment_sum_fields;
  var_pop?: qx_OssIdAssignment_var_pop_fields;
  var_samp?: qx_OssIdAssignment_var_samp_fields;
  variance?: qx_OssIdAssignment_variance_fields;
};


/** aggregate fields of "qx.OssIdAssignment" */
export type qx_OssIdAssignment_aggregate_fieldscountArgs = {
  columns?: Array<qx_OssIdAssignment_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type qx_OssIdAssignment_avg_fields = {
  __typename?: 'qx_OssIdAssignment_avg_fields';
  ossID?: number;
};

/** Boolean expression to filter rows from the table "qx.OssIdAssignment". All fields are combined with a logical 'AND'. */
export type qx_OssIdAssignment_bool_exp = {
  _and?: Array<qx_OssIdAssignment_bool_exp>;
  _not?: qx_OssIdAssignment_bool_exp;
  _or?: Array<qx_OssIdAssignment_bool_exp>;
  gateway?: qx_Gateway_bool_exp;
  gatewayID?: String_comparison_exp;
  id?: String_comparison_exp;
  ossID?: Int_comparison_exp;
  sitePlaceID?: String_comparison_exp;
  targetID?: String_comparison_exp;
  targetType?: String_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
};

/** unique or primary key constraints on table "qx.OssIdAssignment" */
export enum qx_OssIdAssignment_constraint {
  /** unique or primary key constraint on columns "gatewayID", "ossID" */
  OssIdAssignment_gateway_ossID = 'OssIdAssignment_gateway_ossID',
  /** unique or primary key constraint on columns "gatewayID", "targetID", "targetType" */
  OssIdAssignment_gateway_target = 'OssIdAssignment_gateway_target',
  /** unique or primary key constraint on columns "id" */
  OssIdAssignment_pkey = 'OssIdAssignment_pkey'
}

/** input type for incrementing numeric columns in table "qx.OssIdAssignment" */
export type qx_OssIdAssignment_inc_input = {
  ossID?: number;
};

/** input type for inserting data into table "qx.OssIdAssignment" */
export type qx_OssIdAssignment_insert_input = {
  gateway?: qx_Gateway_obj_rel_insert_input;
  gatewayID?: string;
  id?: string;
  ossID?: number;
  targetID?: string;
  targetType?: string;
  updatedAt?: string;
};

/** aggregate max on columns */
export type qx_OssIdAssignment_max_fields = {
  __typename?: 'qx_OssIdAssignment_max_fields';
  gatewayID?: string;
  id?: string;
  ossID?: number;
  /** A computed field, executes function "qx.get_oss_id_assignment_site_placeID" */
  sitePlaceID?: string;
  targetID?: string;
  targetType?: string;
  updatedAt?: string;
};

/** aggregate min on columns */
export type qx_OssIdAssignment_min_fields = {
  __typename?: 'qx_OssIdAssignment_min_fields';
  gatewayID?: string;
  id?: string;
  ossID?: number;
  /** A computed field, executes function "qx.get_oss_id_assignment_site_placeID" */
  sitePlaceID?: string;
  targetID?: string;
  targetType?: string;
  updatedAt?: string;
};

/** response of any mutation on the table "qx.OssIdAssignment" */
export type qx_OssIdAssignment_mutation_response = {
  __typename?: 'qx_OssIdAssignment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_OssIdAssignment>;
};

/** on_conflict condition type for table "qx.OssIdAssignment" */
export type qx_OssIdAssignment_on_conflict = {
  constraint: qx_OssIdAssignment_constraint;
  update_columns?: Array<qx_OssIdAssignment_update_column>;
  where?: qx_OssIdAssignment_bool_exp;
};

/** Ordering options when selecting data from "qx.OssIdAssignment". */
export type qx_OssIdAssignment_order_by = {
  gateway?: qx_Gateway_order_by;
  gatewayID?: order_by;
  id?: order_by;
  ossID?: order_by;
  sitePlaceID?: order_by;
  targetID?: order_by;
  targetType?: order_by;
  updatedAt?: order_by;
};

/** primary key columns input for table: qx.OssIdAssignment */
export type qx_OssIdAssignment_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.OssIdAssignment" */
export enum qx_OssIdAssignment_select_column {
  /** column name */
  gatewayID = 'gatewayID',
  /** column name */
  id = 'id',
  /** column name */
  ossID = 'ossID',
  /** column name */
  targetID = 'targetID',
  /** column name */
  targetType = 'targetType',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "qx.OssIdAssignment" */
export type qx_OssIdAssignment_set_input = {
  gatewayID?: string;
  id?: string;
  ossID?: number;
  targetID?: string;
  targetType?: string;
  updatedAt?: string;
};

/** aggregate stddev on columns */
export type qx_OssIdAssignment_stddev_fields = {
  __typename?: 'qx_OssIdAssignment_stddev_fields';
  ossID?: number;
};

/** aggregate stddev_pop on columns */
export type qx_OssIdAssignment_stddev_pop_fields = {
  __typename?: 'qx_OssIdAssignment_stddev_pop_fields';
  ossID?: number;
};

/** aggregate stddev_samp on columns */
export type qx_OssIdAssignment_stddev_samp_fields = {
  __typename?: 'qx_OssIdAssignment_stddev_samp_fields';
  ossID?: number;
};

/** Streaming cursor of the table "qx_OssIdAssignment" */
export type qx_OssIdAssignment_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_OssIdAssignment_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_OssIdAssignment_stream_cursor_value_input = {
  gatewayID?: string;
  id?: string;
  ossID?: number;
  targetID?: string;
  targetType?: string;
  updatedAt?: string;
};

/** aggregate sum on columns */
export type qx_OssIdAssignment_sum_fields = {
  __typename?: 'qx_OssIdAssignment_sum_fields';
  ossID?: number;
};

/** update columns of table "qx.OssIdAssignment" */
export enum qx_OssIdAssignment_update_column {
  /** column name */
  gatewayID = 'gatewayID',
  /** column name */
  id = 'id',
  /** column name */
  ossID = 'ossID',
  /** column name */
  targetID = 'targetID',
  /** column name */
  targetType = 'targetType',
  /** column name */
  updatedAt = 'updatedAt'
}

export type qx_OssIdAssignment_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_OssIdAssignment_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_OssIdAssignment_set_input;
  /** filter the rows which have to be updated */
  where: qx_OssIdAssignment_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_OssIdAssignment_var_pop_fields = {
  __typename?: 'qx_OssIdAssignment_var_pop_fields';
  ossID?: number;
};

/** aggregate var_samp on columns */
export type qx_OssIdAssignment_var_samp_fields = {
  __typename?: 'qx_OssIdAssignment_var_samp_fields';
  ossID?: number;
};

/** aggregate variance on columns */
export type qx_OssIdAssignment_variance_fields = {
  __typename?: 'qx_OssIdAssignment_variance_fields';
  ossID?: number;
};

/** columns and relationships of "qx.OssKey" */
export type qx_OssKey = {
  __typename?: 'qx_OssKey';
  createdAt: string;
  customerPlaceID: string;
  keys: string;
  updatedAt: string;
  updatedByPersonID?: string;
};

/** aggregated selection of "qx.OssKey" */
export type qx_OssKey_aggregate = {
  __typename?: 'qx_OssKey_aggregate';
  aggregate?: qx_OssKey_aggregate_fields;
  nodes: Array<qx_OssKey>;
};

/** aggregate fields of "qx.OssKey" */
export type qx_OssKey_aggregate_fields = {
  __typename?: 'qx_OssKey_aggregate_fields';
  count: number;
  max?: qx_OssKey_max_fields;
  min?: qx_OssKey_min_fields;
};


/** aggregate fields of "qx.OssKey" */
export type qx_OssKey_aggregate_fieldscountArgs = {
  columns?: Array<qx_OssKey_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.OssKey". All fields are combined with a logical 'AND'. */
export type qx_OssKey_bool_exp = {
  _and?: Array<qx_OssKey_bool_exp>;
  _not?: qx_OssKey_bool_exp;
  _or?: Array<qx_OssKey_bool_exp>;
  createdAt?: timestamptz_comparison_exp;
  customerPlaceID?: String_comparison_exp;
  keys?: String_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
  updatedByPersonID?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.OssKey" */
export enum qx_OssKey_constraint {
  /** unique or primary key constraint on columns "customerPlaceID" */
  OssKey_pkey = 'OssKey_pkey'
}

/** input type for inserting data into table "qx.OssKey" */
export type qx_OssKey_insert_input = {
  createdAt?: string;
  customerPlaceID?: string;
  keys?: string;
  updatedAt?: string;
  updatedByPersonID?: string;
};

/** aggregate max on columns */
export type qx_OssKey_max_fields = {
  __typename?: 'qx_OssKey_max_fields';
  createdAt?: string;
  customerPlaceID?: string;
  keys?: string;
  updatedAt?: string;
  updatedByPersonID?: string;
};

/** aggregate min on columns */
export type qx_OssKey_min_fields = {
  __typename?: 'qx_OssKey_min_fields';
  createdAt?: string;
  customerPlaceID?: string;
  keys?: string;
  updatedAt?: string;
  updatedByPersonID?: string;
};

/** response of any mutation on the table "qx.OssKey" */
export type qx_OssKey_mutation_response = {
  __typename?: 'qx_OssKey_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_OssKey>;
};

/** on_conflict condition type for table "qx.OssKey" */
export type qx_OssKey_on_conflict = {
  constraint: qx_OssKey_constraint;
  update_columns?: Array<qx_OssKey_update_column>;
  where?: qx_OssKey_bool_exp;
};

/** Ordering options when selecting data from "qx.OssKey". */
export type qx_OssKey_order_by = {
  createdAt?: order_by;
  customerPlaceID?: order_by;
  keys?: order_by;
  updatedAt?: order_by;
  updatedByPersonID?: order_by;
};

/** primary key columns input for table: qx.OssKey */
export type qx_OssKey_pk_columns_input = {
  customerPlaceID: string;
};

/** select columns of table "qx.OssKey" */
export enum qx_OssKey_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  customerPlaceID = 'customerPlaceID',
  /** column name */
  keys = 'keys',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  updatedByPersonID = 'updatedByPersonID'
}

/** input type for updating data in table "qx.OssKey" */
export type qx_OssKey_set_input = {
  createdAt?: string;
  customerPlaceID?: string;
  keys?: string;
  updatedAt?: string;
  updatedByPersonID?: string;
};

/** Streaming cursor of the table "qx_OssKey" */
export type qx_OssKey_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_OssKey_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_OssKey_stream_cursor_value_input = {
  createdAt?: string;
  customerPlaceID?: string;
  keys?: string;
  updatedAt?: string;
  updatedByPersonID?: string;
};

/** update columns of table "qx.OssKey" */
export enum qx_OssKey_update_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  customerPlaceID = 'customerPlaceID',
  /** column name */
  keys = 'keys',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  updatedByPersonID = 'updatedByPersonID'
}

export type qx_OssKey_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_OssKey_set_input;
  /** filter the rows which have to be updated */
  where: qx_OssKey_bool_exp;
};

/** digital output (relay, buzzer, LED indicator) wired to a device DIO channel, activated by door events or flows */
export type qx_OutputPoint = {
  __typename?: 'qx_OutputPoint';
  /** An object relationship */
  Device: qx_Device;
  /** An object relationship */
  DeviceDIO: qx_DeviceDIO;
  /** An array relationship */
  MercuryControlPoints: Array<qx_MercuryControlPoint>;
  /** An aggregate relationship */
  MercuryControlPoints_aggregate: qx_MercuryControlPoint_aggregate;
  channel?: number;
  deviceDioID: string;
  deviceID: string;
  id: string;
  pulse?: string;
};


/** digital output (relay, buzzer, LED indicator) wired to a device DIO channel, activated by door events or flows */
export type qx_OutputPointMercuryControlPointsArgs = {
  distinct_on?: Array<qx_MercuryControlPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MercuryControlPoint_order_by>;
  where?: qx_MercuryControlPoint_bool_exp;
};


/** digital output (relay, buzzer, LED indicator) wired to a device DIO channel, activated by door events or flows */
export type qx_OutputPointMercuryControlPoints_aggregateArgs = {
  distinct_on?: Array<qx_MercuryControlPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MercuryControlPoint_order_by>;
  where?: qx_MercuryControlPoint_bool_exp;
};

/** aggregated selection of "qx.OutputPoint" */
export type qx_OutputPoint_aggregate = {
  __typename?: 'qx_OutputPoint_aggregate';
  aggregate?: qx_OutputPoint_aggregate_fields;
  nodes: Array<qx_OutputPoint>;
};

export type qx_OutputPoint_aggregate_bool_exp = {
  count?: qx_OutputPoint_aggregate_bool_exp_count;
};

export type qx_OutputPoint_aggregate_bool_exp_count = {
  arguments?: Array<qx_OutputPoint_select_column>;
  distinct?: boolean;
  filter?: qx_OutputPoint_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.OutputPoint" */
export type qx_OutputPoint_aggregate_fields = {
  __typename?: 'qx_OutputPoint_aggregate_fields';
  avg?: qx_OutputPoint_avg_fields;
  count: number;
  max?: qx_OutputPoint_max_fields;
  min?: qx_OutputPoint_min_fields;
  stddev?: qx_OutputPoint_stddev_fields;
  stddev_pop?: qx_OutputPoint_stddev_pop_fields;
  stddev_samp?: qx_OutputPoint_stddev_samp_fields;
  sum?: qx_OutputPoint_sum_fields;
  var_pop?: qx_OutputPoint_var_pop_fields;
  var_samp?: qx_OutputPoint_var_samp_fields;
  variance?: qx_OutputPoint_variance_fields;
};


/** aggregate fields of "qx.OutputPoint" */
export type qx_OutputPoint_aggregate_fieldscountArgs = {
  columns?: Array<qx_OutputPoint_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.OutputPoint" */
export type qx_OutputPoint_aggregate_order_by = {
  avg?: qx_OutputPoint_avg_order_by;
  count?: order_by;
  max?: qx_OutputPoint_max_order_by;
  min?: qx_OutputPoint_min_order_by;
  stddev?: qx_OutputPoint_stddev_order_by;
  stddev_pop?: qx_OutputPoint_stddev_pop_order_by;
  stddev_samp?: qx_OutputPoint_stddev_samp_order_by;
  sum?: qx_OutputPoint_sum_order_by;
  var_pop?: qx_OutputPoint_var_pop_order_by;
  var_samp?: qx_OutputPoint_var_samp_order_by;
  variance?: qx_OutputPoint_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.OutputPoint" */
export type qx_OutputPoint_arr_rel_insert_input = {
  data: Array<qx_OutputPoint_insert_input>;
  /** upsert condition */
  on_conflict?: qx_OutputPoint_on_conflict;
};

/** aggregate avg on columns */
export type qx_OutputPoint_avg_fields = {
  __typename?: 'qx_OutputPoint_avg_fields';
  channel?: number;
};

/** order by avg() on columns of table "qx.OutputPoint" */
export type qx_OutputPoint_avg_order_by = {
  channel?: order_by;
};

/** Boolean expression to filter rows from the table "qx.OutputPoint". All fields are combined with a logical 'AND'. */
export type qx_OutputPoint_bool_exp = {
  Device?: qx_Device_bool_exp;
  DeviceDIO?: qx_DeviceDIO_bool_exp;
  MercuryControlPoints?: qx_MercuryControlPoint_bool_exp;
  MercuryControlPoints_aggregate?: qx_MercuryControlPoint_aggregate_bool_exp;
  _and?: Array<qx_OutputPoint_bool_exp>;
  _not?: qx_OutputPoint_bool_exp;
  _or?: Array<qx_OutputPoint_bool_exp>;
  channel?: Int_comparison_exp;
  deviceDioID?: String_comparison_exp;
  deviceID?: String_comparison_exp;
  id?: String_comparison_exp;
  pulse?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.OutputPoint" */
export enum qx_OutputPoint_constraint {
  /** unique or primary key constraint on columns "channel", "deviceDioID" */
  OutputPoint_DeviceDioID_channel_contraint = 'OutputPoint_DeviceDioID_channel_contraint',
  /** unique or primary key constraint on columns "id" */
  OutputPoint_pkey = 'OutputPoint_pkey'
}

/** input type for incrementing numeric columns in table "qx.OutputPoint" */
export type qx_OutputPoint_inc_input = {
  channel?: number;
};

/** input type for inserting data into table "qx.OutputPoint" */
export type qx_OutputPoint_insert_input = {
  Device?: qx_Device_obj_rel_insert_input;
  DeviceDIO?: qx_DeviceDIO_obj_rel_insert_input;
  MercuryControlPoints?: qx_MercuryControlPoint_arr_rel_insert_input;
  channel?: number;
  deviceDioID?: string;
  deviceID?: string;
  id?: string;
  pulse?: string;
};

/** aggregate max on columns */
export type qx_OutputPoint_max_fields = {
  __typename?: 'qx_OutputPoint_max_fields';
  channel?: number;
  deviceDioID?: string;
  deviceID?: string;
  id?: string;
  pulse?: string;
};

/** order by max() on columns of table "qx.OutputPoint" */
export type qx_OutputPoint_max_order_by = {
  channel?: order_by;
  deviceDioID?: order_by;
  deviceID?: order_by;
  id?: order_by;
  pulse?: order_by;
};

/** aggregate min on columns */
export type qx_OutputPoint_min_fields = {
  __typename?: 'qx_OutputPoint_min_fields';
  channel?: number;
  deviceDioID?: string;
  deviceID?: string;
  id?: string;
  pulse?: string;
};

/** order by min() on columns of table "qx.OutputPoint" */
export type qx_OutputPoint_min_order_by = {
  channel?: order_by;
  deviceDioID?: order_by;
  deviceID?: order_by;
  id?: order_by;
  pulse?: order_by;
};

/** response of any mutation on the table "qx.OutputPoint" */
export type qx_OutputPoint_mutation_response = {
  __typename?: 'qx_OutputPoint_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_OutputPoint>;
};

/** input type for inserting object relation for remote table "qx.OutputPoint" */
export type qx_OutputPoint_obj_rel_insert_input = {
  data: qx_OutputPoint_insert_input;
  /** upsert condition */
  on_conflict?: qx_OutputPoint_on_conflict;
};

/** on_conflict condition type for table "qx.OutputPoint" */
export type qx_OutputPoint_on_conflict = {
  constraint: qx_OutputPoint_constraint;
  update_columns?: Array<qx_OutputPoint_update_column>;
  where?: qx_OutputPoint_bool_exp;
};

/** Ordering options when selecting data from "qx.OutputPoint". */
export type qx_OutputPoint_order_by = {
  Device?: qx_Device_order_by;
  DeviceDIO?: qx_DeviceDIO_order_by;
  MercuryControlPoints_aggregate?: qx_MercuryControlPoint_aggregate_order_by;
  channel?: order_by;
  deviceDioID?: order_by;
  deviceID?: order_by;
  id?: order_by;
  pulse?: order_by;
};

/** primary key columns input for table: qx.OutputPoint */
export type qx_OutputPoint_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.OutputPoint" */
export enum qx_OutputPoint_select_column {
  /** column name */
  channel = 'channel',
  /** column name */
  deviceDioID = 'deviceDioID',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  id = 'id',
  /** column name */
  pulse = 'pulse'
}

/** input type for updating data in table "qx.OutputPoint" */
export type qx_OutputPoint_set_input = {
  channel?: number;
  deviceDioID?: string;
  deviceID?: string;
  id?: string;
  pulse?: string;
};

/** aggregate stddev on columns */
export type qx_OutputPoint_stddev_fields = {
  __typename?: 'qx_OutputPoint_stddev_fields';
  channel?: number;
};

/** order by stddev() on columns of table "qx.OutputPoint" */
export type qx_OutputPoint_stddev_order_by = {
  channel?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_OutputPoint_stddev_pop_fields = {
  __typename?: 'qx_OutputPoint_stddev_pop_fields';
  channel?: number;
};

/** order by stddev_pop() on columns of table "qx.OutputPoint" */
export type qx_OutputPoint_stddev_pop_order_by = {
  channel?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_OutputPoint_stddev_samp_fields = {
  __typename?: 'qx_OutputPoint_stddev_samp_fields';
  channel?: number;
};

/** order by stddev_samp() on columns of table "qx.OutputPoint" */
export type qx_OutputPoint_stddev_samp_order_by = {
  channel?: order_by;
};

/** Streaming cursor of the table "qx_OutputPoint" */
export type qx_OutputPoint_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_OutputPoint_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_OutputPoint_stream_cursor_value_input = {
  channel?: number;
  deviceDioID?: string;
  deviceID?: string;
  id?: string;
  pulse?: string;
};

/** aggregate sum on columns */
export type qx_OutputPoint_sum_fields = {
  __typename?: 'qx_OutputPoint_sum_fields';
  channel?: number;
};

/** order by sum() on columns of table "qx.OutputPoint" */
export type qx_OutputPoint_sum_order_by = {
  channel?: order_by;
};

/** update columns of table "qx.OutputPoint" */
export enum qx_OutputPoint_update_column {
  /** column name */
  channel = 'channel',
  /** column name */
  deviceDioID = 'deviceDioID',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  id = 'id',
  /** column name */
  pulse = 'pulse'
}

export type qx_OutputPoint_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_OutputPoint_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_OutputPoint_set_input;
  /** filter the rows which have to be updated */
  where: qx_OutputPoint_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_OutputPoint_var_pop_fields = {
  __typename?: 'qx_OutputPoint_var_pop_fields';
  channel?: number;
};

/** order by var_pop() on columns of table "qx.OutputPoint" */
export type qx_OutputPoint_var_pop_order_by = {
  channel?: order_by;
};

/** aggregate var_samp on columns */
export type qx_OutputPoint_var_samp_fields = {
  __typename?: 'qx_OutputPoint_var_samp_fields';
  channel?: number;
};

/** order by var_samp() on columns of table "qx.OutputPoint" */
export type qx_OutputPoint_var_samp_order_by = {
  channel?: order_by;
};

/** aggregate variance on columns */
export type qx_OutputPoint_variance_fields = {
  __typename?: 'qx_OutputPoint_variance_fields';
  channel?: number;
};

/** order by variance() on columns of table "qx.OutputPoint" */
export type qx_OutputPoint_variance_order_by = {
  channel?: order_by;
};

/** grants a person or group the ability to access through a specific door, optionally restricted to a schedule */
export type qx_Permission = {
  __typename?: 'qx_Permission';
  /** An array relationship */
  PermissionPartitionAssignments: Array<PermissionPartitionAssignments>;
  /** An aggregate relationship */
  PermissionPartitionAssignments_aggregate: PermissionPartitionAssignments_aggregate;
  createdAt: string;
  description?: string;
  /** An object relationship */
  group: qx_Group;
  groupID: string;
  id: string;
  name: string;
  /** An object relationship */
  place: qx_Place;
  placeID: string;
  /** An object relationship */
  schedule: qx_Schedule;
  scheduleID: string;
  thumbnail?: string;
  thumbnail_lg?: string;
  thumbnail_md?: string;
  thumbnail_sm?: string;
  thumbnail_xl?: string;
  updatedAt?: string;
};


/** grants a person or group the ability to access through a specific door, optionally restricted to a schedule */
export type qx_PermissionPermissionPartitionAssignmentsArgs = {
  distinct_on?: Array<PermissionPartitionAssignments_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<PermissionPartitionAssignments_order_by>;
  where?: PermissionPartitionAssignments_bool_exp;
};


/** grants a person or group the ability to access through a specific door, optionally restricted to a schedule */
export type qx_PermissionPermissionPartitionAssignments_aggregateArgs = {
  distinct_on?: Array<PermissionPartitionAssignments_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<PermissionPartitionAssignments_order_by>;
  where?: PermissionPartitionAssignments_bool_exp;
};

/** aggregated selection of "qx.Permission" */
export type qx_Permission_aggregate = {
  __typename?: 'qx_Permission_aggregate';
  aggregate?: qx_Permission_aggregate_fields;
  nodes: Array<qx_Permission>;
};

export type qx_Permission_aggregate_bool_exp = {
  count?: qx_Permission_aggregate_bool_exp_count;
};

export type qx_Permission_aggregate_bool_exp_count = {
  arguments?: Array<qx_Permission_select_column>;
  distinct?: boolean;
  filter?: qx_Permission_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.Permission" */
export type qx_Permission_aggregate_fields = {
  __typename?: 'qx_Permission_aggregate_fields';
  count: number;
  max?: qx_Permission_max_fields;
  min?: qx_Permission_min_fields;
};


/** aggregate fields of "qx.Permission" */
export type qx_Permission_aggregate_fieldscountArgs = {
  columns?: Array<qx_Permission_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.Permission" */
export type qx_Permission_aggregate_order_by = {
  count?: order_by;
  max?: qx_Permission_max_order_by;
  min?: qx_Permission_min_order_by;
};

/** input type for inserting array relation for remote table "qx.Permission" */
export type qx_Permission_arr_rel_insert_input = {
  data: Array<qx_Permission_insert_input>;
  /** upsert condition */
  on_conflict?: qx_Permission_on_conflict;
};

/** Boolean expression to filter rows from the table "qx.Permission". All fields are combined with a logical 'AND'. */
export type qx_Permission_bool_exp = {
  PermissionPartitionAssignments?: PermissionPartitionAssignments_bool_exp;
  PermissionPartitionAssignments_aggregate?: PermissionPartitionAssignments_aggregate_bool_exp;
  _and?: Array<qx_Permission_bool_exp>;
  _not?: qx_Permission_bool_exp;
  _or?: Array<qx_Permission_bool_exp>;
  createdAt?: timestamptz_comparison_exp;
  description?: String_comparison_exp;
  group?: qx_Group_bool_exp;
  groupID?: String_comparison_exp;
  id?: String_comparison_exp;
  name?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
  schedule?: qx_Schedule_bool_exp;
  scheduleID?: String_comparison_exp;
  thumbnail?: String_comparison_exp;
  thumbnail_lg?: String_comparison_exp;
  thumbnail_md?: String_comparison_exp;
  thumbnail_sm?: String_comparison_exp;
  thumbnail_xl?: String_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
};

/** unique or primary key constraints on table "qx.Permission" */
export enum qx_Permission_constraint {
  /** unique or primary key constraint on columns "groupID", "placeID" */
  Permission_groupID_placeID_key = 'Permission_groupID_placeID_key',
  /** unique or primary key constraint on columns "id" */
  Permission_pkey = 'Permission_pkey'
}

/** input type for inserting data into table "qx.Permission" */
export type qx_Permission_insert_input = {
  PermissionPartitionAssignments?: PermissionPartitionAssignments_arr_rel_insert_input;
  createdAt?: string;
  description?: string;
  group?: qx_Group_obj_rel_insert_input;
  groupID?: string;
  id?: string;
  name?: string;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
  schedule?: qx_Schedule_obj_rel_insert_input;
  scheduleID?: string;
  thumbnail?: string;
  thumbnail_lg?: string;
  thumbnail_md?: string;
  thumbnail_sm?: string;
  thumbnail_xl?: string;
  updatedAt?: string;
};

/** aggregate max on columns */
export type qx_Permission_max_fields = {
  __typename?: 'qx_Permission_max_fields';
  createdAt?: string;
  description?: string;
  groupID?: string;
  id?: string;
  name?: string;
  placeID?: string;
  scheduleID?: string;
  thumbnail?: string;
  thumbnail_lg?: string;
  thumbnail_md?: string;
  thumbnail_sm?: string;
  thumbnail_xl?: string;
  updatedAt?: string;
};

/** order by max() on columns of table "qx.Permission" */
export type qx_Permission_max_order_by = {
  createdAt?: order_by;
  description?: order_by;
  groupID?: order_by;
  id?: order_by;
  name?: order_by;
  placeID?: order_by;
  scheduleID?: order_by;
  thumbnail?: order_by;
  thumbnail_lg?: order_by;
  thumbnail_md?: order_by;
  thumbnail_sm?: order_by;
  thumbnail_xl?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type qx_Permission_min_fields = {
  __typename?: 'qx_Permission_min_fields';
  createdAt?: string;
  description?: string;
  groupID?: string;
  id?: string;
  name?: string;
  placeID?: string;
  scheduleID?: string;
  thumbnail?: string;
  thumbnail_lg?: string;
  thumbnail_md?: string;
  thumbnail_sm?: string;
  thumbnail_xl?: string;
  updatedAt?: string;
};

/** order by min() on columns of table "qx.Permission" */
export type qx_Permission_min_order_by = {
  createdAt?: order_by;
  description?: order_by;
  groupID?: order_by;
  id?: order_by;
  name?: order_by;
  placeID?: order_by;
  scheduleID?: order_by;
  thumbnail?: order_by;
  thumbnail_lg?: order_by;
  thumbnail_md?: order_by;
  thumbnail_sm?: order_by;
  thumbnail_xl?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.Permission" */
export type qx_Permission_mutation_response = {
  __typename?: 'qx_Permission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_Permission>;
};

/** input type for inserting object relation for remote table "qx.Permission" */
export type qx_Permission_obj_rel_insert_input = {
  data: qx_Permission_insert_input;
  /** upsert condition */
  on_conflict?: qx_Permission_on_conflict;
};

/** on_conflict condition type for table "qx.Permission" */
export type qx_Permission_on_conflict = {
  constraint: qx_Permission_constraint;
  update_columns?: Array<qx_Permission_update_column>;
  where?: qx_Permission_bool_exp;
};

/** Ordering options when selecting data from "qx.Permission". */
export type qx_Permission_order_by = {
  PermissionPartitionAssignments_aggregate?: PermissionPartitionAssignments_aggregate_order_by;
  createdAt?: order_by;
  description?: order_by;
  group?: qx_Group_order_by;
  groupID?: order_by;
  id?: order_by;
  name?: order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
  schedule?: qx_Schedule_order_by;
  scheduleID?: order_by;
  thumbnail?: order_by;
  thumbnail_lg?: order_by;
  thumbnail_md?: order_by;
  thumbnail_sm?: order_by;
  thumbnail_xl?: order_by;
  updatedAt?: order_by;
};

/** primary key columns input for table: qx.Permission */
export type qx_Permission_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.Permission" */
export enum qx_Permission_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  description = 'description',
  /** column name */
  groupID = 'groupID',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  scheduleID = 'scheduleID',
  /** column name */
  thumbnail = 'thumbnail',
  /** column name */
  thumbnail_lg = 'thumbnail_lg',
  /** column name */
  thumbnail_md = 'thumbnail_md',
  /** column name */
  thumbnail_sm = 'thumbnail_sm',
  /** column name */
  thumbnail_xl = 'thumbnail_xl',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "qx.Permission" */
export type qx_Permission_set_input = {
  createdAt?: string;
  description?: string;
  groupID?: string;
  id?: string;
  name?: string;
  placeID?: string;
  scheduleID?: string;
  thumbnail?: string;
  thumbnail_lg?: string;
  thumbnail_md?: string;
  thumbnail_sm?: string;
  thumbnail_xl?: string;
  updatedAt?: string;
};

/** Streaming cursor of the table "qx_Permission" */
export type qx_Permission_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_Permission_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_Permission_stream_cursor_value_input = {
  createdAt?: string;
  description?: string;
  groupID?: string;
  id?: string;
  name?: string;
  placeID?: string;
  scheduleID?: string;
  thumbnail?: string;
  thumbnail_lg?: string;
  thumbnail_md?: string;
  thumbnail_sm?: string;
  thumbnail_xl?: string;
  updatedAt?: string;
};

/** update columns of table "qx.Permission" */
export enum qx_Permission_update_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  description = 'description',
  /** column name */
  groupID = 'groupID',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  scheduleID = 'scheduleID',
  /** column name */
  thumbnail = 'thumbnail',
  /** column name */
  thumbnail_lg = 'thumbnail_lg',
  /** column name */
  thumbnail_md = 'thumbnail_md',
  /** column name */
  thumbnail_sm = 'thumbnail_sm',
  /** column name */
  thumbnail_xl = 'thumbnail_xl',
  /** column name */
  updatedAt = 'updatedAt'
}

export type qx_Permission_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_Permission_set_input;
  /** filter the rows which have to be updated */
  where: qx_Permission_bool_exp;
};

/** user or cardholder in the system, with profile data, role, place assignment, and associated credentials */
export type qx_Person = {
  __typename?: 'qx_Person';
  /** An object relationship */
  acceptedTerms?: PersonTermsAgreement;
  /** An array relationship */
  accessCodes: Array<IntrusionAccessCode>;
  /** An aggregate relationship */
  accessCodes_aggregate: IntrusionAccessCode_aggregate;
  /** A computed field, executes function "qx.person_access_history" */
  accessHistory?: Array<qx_vPersonAccessHistory>;
  /** An array relationship */
  appPasswords: Array<applicationUserAppPasswords>;
  /** An aggregate relationship */
  appPasswords_aggregate: applicationUserAppPasswords_aggregate;
  avatar?: string;
  avatar_lg?: string;
  avatar_md?: string;
  avatar_sm?: string;
  avatar_xl?: string;
  certification?: string;
  createdAt: string;
  /** An array relationship */
  credentials: Array<qx_Credential>;
  /** An aggregate relationship */
  credentials_aggregate: qx_Credential_aggregate;
  deletedAt?: string;
  department?: string;
  email?: string;
  employeeID?: string;
  /** An array relationship */
  events: Array<qx_Event>;
  /** An aggregate relationship */
  events_aggregate: qx_Event_aggregate;
  externalPersonID?: string;
  firstName?: string;
  /** An object relationship */
  gatewayPassword?: ApplicationUserGatewayPassword;
  id: string;
  lastLogin?: string;
  lastName?: string;
  licensePlate?: string;
  lockdownImmunity?: boolean;
  /** An array relationship */
  personDeviceAppPrivileges: Array<personDeviceAppPrivileges>;
  /** An aggregate relationship */
  personDeviceAppPrivileges_aggregate: personDeviceAppPrivileges_aggregate;
  /** An array relationship */
  personDoorAppPrivileges: Array<personDoorAppPrivileges>;
  /** An aggregate relationship */
  personDoorAppPrivileges_aggregate: personDoorAppPrivileges_aggregate;
  /** An array relationship */
  personPlaceAppPrivileges: Array<personPlaceAppPrivileges>;
  /** An aggregate relationship */
  personPlaceAppPrivileges_aggregate: personPlaceAppPrivileges_aggregate;
  /** An array relationship */
  personVideoSourceAppPrivileges: Array<personVideoSourceAppPrivileges>;
  /** An aggregate relationship */
  personVideoSourceAppPrivileges_aggregate: personVideoSourceAppPrivileges_aggregate;
  phoneNumbers?: any;
  /** An object relationship */
  place: qx_Place;
  placeID: string;
  /** An object relationship */
  role?: qx_Role;
  roleExternalSync: boolean;
  roleID?: string;
  salutation?: string;
  searchText?: string;
  status?: string;
  suffix?: string;
  title?: string;
  /** An array relationship */
  toGroups: Array<qx__PersonToGroup>;
  /** An aggregate relationship */
  toGroups_aggregate: qx__PersonToGroup_aggregate;
  /** An object relationship */
  twoFactor?: ApplicationUserTwoFactor;
  updatedAt?: string;
  /** An array relationship */
  userSettings: Array<qx_UserSetting>;
  /** An aggregate relationship */
  userSettings_aggregate: qx_UserSetting_aggregate;
  /** An array relationship */
  views: Array<qx_View>;
  /** An aggregate relationship */
  views_aggregate: qx_View_aggregate;
};


/** user or cardholder in the system, with profile data, role, place assignment, and associated credentials */
export type qx_PersonaccessCodesArgs = {
  distinct_on?: Array<IntrusionAccessCode_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<IntrusionAccessCode_order_by>;
  where?: IntrusionAccessCode_bool_exp;
};


/** user or cardholder in the system, with profile data, role, place assignment, and associated credentials */
export type qx_PersonaccessCodes_aggregateArgs = {
  distinct_on?: Array<IntrusionAccessCode_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<IntrusionAccessCode_order_by>;
  where?: IntrusionAccessCode_bool_exp;
};


/** user or cardholder in the system, with profile data, role, place assignment, and associated credentials */
export type qx_PersonaccessHistoryArgs = {
  distinct_on?: Array<qx_vPersonAccessHistory_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vPersonAccessHistory_order_by>;
  where?: qx_vPersonAccessHistory_bool_exp;
};


/** user or cardholder in the system, with profile data, role, place assignment, and associated credentials */
export type qx_PersonappPasswordsArgs = {
  distinct_on?: Array<applicationUserAppPasswords_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<applicationUserAppPasswords_order_by>;
  where?: applicationUserAppPasswords_bool_exp;
};


/** user or cardholder in the system, with profile data, role, place assignment, and associated credentials */
export type qx_PersonappPasswords_aggregateArgs = {
  distinct_on?: Array<applicationUserAppPasswords_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<applicationUserAppPasswords_order_by>;
  where?: applicationUserAppPasswords_bool_exp;
};


/** user or cardholder in the system, with profile data, role, place assignment, and associated credentials */
export type qx_PersoncredentialsArgs = {
  distinct_on?: Array<qx_Credential_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Credential_order_by>;
  where?: qx_Credential_bool_exp;
};


/** user or cardholder in the system, with profile data, role, place assignment, and associated credentials */
export type qx_Personcredentials_aggregateArgs = {
  distinct_on?: Array<qx_Credential_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Credential_order_by>;
  where?: qx_Credential_bool_exp;
};


/** user or cardholder in the system, with profile data, role, place assignment, and associated credentials */
export type qx_PersoneventsArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};


/** user or cardholder in the system, with profile data, role, place assignment, and associated credentials */
export type qx_Personevents_aggregateArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};


/** user or cardholder in the system, with profile data, role, place assignment, and associated credentials */
export type qx_PersonpersonDeviceAppPrivilegesArgs = {
  distinct_on?: Array<personDeviceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personDeviceAppPrivileges_order_by>;
  where?: personDeviceAppPrivileges_bool_exp;
};


/** user or cardholder in the system, with profile data, role, place assignment, and associated credentials */
export type qx_PersonpersonDeviceAppPrivileges_aggregateArgs = {
  distinct_on?: Array<personDeviceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personDeviceAppPrivileges_order_by>;
  where?: personDeviceAppPrivileges_bool_exp;
};


/** user or cardholder in the system, with profile data, role, place assignment, and associated credentials */
export type qx_PersonpersonDoorAppPrivilegesArgs = {
  distinct_on?: Array<personDoorAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personDoorAppPrivileges_order_by>;
  where?: personDoorAppPrivileges_bool_exp;
};


/** user or cardholder in the system, with profile data, role, place assignment, and associated credentials */
export type qx_PersonpersonDoorAppPrivileges_aggregateArgs = {
  distinct_on?: Array<personDoorAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personDoorAppPrivileges_order_by>;
  where?: personDoorAppPrivileges_bool_exp;
};


/** user or cardholder in the system, with profile data, role, place assignment, and associated credentials */
export type qx_PersonpersonPlaceAppPrivilegesArgs = {
  distinct_on?: Array<personPlaceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personPlaceAppPrivileges_order_by>;
  where?: personPlaceAppPrivileges_bool_exp;
};


/** user or cardholder in the system, with profile data, role, place assignment, and associated credentials */
export type qx_PersonpersonPlaceAppPrivileges_aggregateArgs = {
  distinct_on?: Array<personPlaceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personPlaceAppPrivileges_order_by>;
  where?: personPlaceAppPrivileges_bool_exp;
};


/** user or cardholder in the system, with profile data, role, place assignment, and associated credentials */
export type qx_PersonpersonVideoSourceAppPrivilegesArgs = {
  distinct_on?: Array<personVideoSourceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personVideoSourceAppPrivileges_order_by>;
  where?: personVideoSourceAppPrivileges_bool_exp;
};


/** user or cardholder in the system, with profile data, role, place assignment, and associated credentials */
export type qx_PersonpersonVideoSourceAppPrivileges_aggregateArgs = {
  distinct_on?: Array<personVideoSourceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personVideoSourceAppPrivileges_order_by>;
  where?: personVideoSourceAppPrivileges_bool_exp;
};


/** user or cardholder in the system, with profile data, role, place assignment, and associated credentials */
export type qx_PersonphoneNumbersArgs = {
  path?: string;
};


/** user or cardholder in the system, with profile data, role, place assignment, and associated credentials */
export type qx_PersontoGroupsArgs = {
  distinct_on?: Array<qx__PersonToGroup_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__PersonToGroup_order_by>;
  where?: qx__PersonToGroup_bool_exp;
};


/** user or cardholder in the system, with profile data, role, place assignment, and associated credentials */
export type qx_PersontoGroups_aggregateArgs = {
  distinct_on?: Array<qx__PersonToGroup_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__PersonToGroup_order_by>;
  where?: qx__PersonToGroup_bool_exp;
};


/** user or cardholder in the system, with profile data, role, place assignment, and associated credentials */
export type qx_PersonuserSettingsArgs = {
  distinct_on?: Array<qx_UserSetting_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_UserSetting_order_by>;
  where?: qx_UserSetting_bool_exp;
};


/** user or cardholder in the system, with profile data, role, place assignment, and associated credentials */
export type qx_PersonuserSettings_aggregateArgs = {
  distinct_on?: Array<qx_UserSetting_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_UserSetting_order_by>;
  where?: qx_UserSetting_bool_exp;
};


/** user or cardholder in the system, with profile data, role, place assignment, and associated credentials */
export type qx_PersonviewsArgs = {
  distinct_on?: Array<qx_View_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_View_order_by>;
  where?: qx_View_bool_exp;
};


/** user or cardholder in the system, with profile data, role, place assignment, and associated credentials */
export type qx_Personviews_aggregateArgs = {
  distinct_on?: Array<qx_View_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_View_order_by>;
  where?: qx_View_bool_exp;
};

/** aggregated selection of "qx.Person" */
export type qx_Person_aggregate = {
  __typename?: 'qx_Person_aggregate';
  aggregate?: qx_Person_aggregate_fields;
  nodes: Array<qx_Person>;
};

export type qx_Person_aggregate_bool_exp = {
  bool_and?: qx_Person_aggregate_bool_exp_bool_and;
  bool_or?: qx_Person_aggregate_bool_exp_bool_or;
  count?: qx_Person_aggregate_bool_exp_count;
};

export type qx_Person_aggregate_bool_exp_bool_and = {
  arguments: qx_Person_select_column_qx_Person_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: qx_Person_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_Person_aggregate_bool_exp_bool_or = {
  arguments: qx_Person_select_column_qx_Person_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: qx_Person_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_Person_aggregate_bool_exp_count = {
  arguments?: Array<qx_Person_select_column>;
  distinct?: boolean;
  filter?: qx_Person_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.Person" */
export type qx_Person_aggregate_fields = {
  __typename?: 'qx_Person_aggregate_fields';
  count: number;
  max?: qx_Person_max_fields;
  min?: qx_Person_min_fields;
};


/** aggregate fields of "qx.Person" */
export type qx_Person_aggregate_fieldscountArgs = {
  columns?: Array<qx_Person_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.Person" */
export type qx_Person_aggregate_order_by = {
  count?: order_by;
  max?: qx_Person_max_order_by;
  min?: qx_Person_min_order_by;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type qx_Person_append_input = {
  phoneNumbers?: any;
};

/** input type for inserting array relation for remote table "qx.Person" */
export type qx_Person_arr_rel_insert_input = {
  data: Array<qx_Person_insert_input>;
  /** upsert condition */
  on_conflict?: qx_Person_on_conflict;
};

/** Boolean expression to filter rows from the table "qx.Person". All fields are combined with a logical 'AND'. */
export type qx_Person_bool_exp = {
  _and?: Array<qx_Person_bool_exp>;
  _not?: qx_Person_bool_exp;
  _or?: Array<qx_Person_bool_exp>;
  acceptedTerms?: PersonTermsAgreement_bool_exp;
  accessCodes?: IntrusionAccessCode_bool_exp;
  accessCodes_aggregate?: IntrusionAccessCode_aggregate_bool_exp;
  accessHistory?: qx_vPersonAccessHistory_bool_exp;
  appPasswords?: applicationUserAppPasswords_bool_exp;
  appPasswords_aggregate?: applicationUserAppPasswords_aggregate_bool_exp;
  avatar?: String_comparison_exp;
  avatar_lg?: String_comparison_exp;
  avatar_md?: String_comparison_exp;
  avatar_sm?: String_comparison_exp;
  avatar_xl?: String_comparison_exp;
  certification?: String_comparison_exp;
  createdAt?: timestamptz_comparison_exp;
  credentials?: qx_Credential_bool_exp;
  credentials_aggregate?: qx_Credential_aggregate_bool_exp;
  deletedAt?: timestamptz_comparison_exp;
  department?: String_comparison_exp;
  email?: String_comparison_exp;
  employeeID?: String_comparison_exp;
  events?: qx_Event_bool_exp;
  events_aggregate?: qx_Event_aggregate_bool_exp;
  externalPersonID?: String_comparison_exp;
  firstName?: String_comparison_exp;
  gatewayPassword?: ApplicationUserGatewayPassword_bool_exp;
  id?: String_comparison_exp;
  lastLogin?: timestamptz_comparison_exp;
  lastName?: String_comparison_exp;
  licensePlate?: String_comparison_exp;
  lockdownImmunity?: Boolean_comparison_exp;
  personDeviceAppPrivileges?: personDeviceAppPrivileges_bool_exp;
  personDeviceAppPrivileges_aggregate?: personDeviceAppPrivileges_aggregate_bool_exp;
  personDoorAppPrivileges?: personDoorAppPrivileges_bool_exp;
  personDoorAppPrivileges_aggregate?: personDoorAppPrivileges_aggregate_bool_exp;
  personPlaceAppPrivileges?: personPlaceAppPrivileges_bool_exp;
  personPlaceAppPrivileges_aggregate?: personPlaceAppPrivileges_aggregate_bool_exp;
  personVideoSourceAppPrivileges?: personVideoSourceAppPrivileges_bool_exp;
  personVideoSourceAppPrivileges_aggregate?: personVideoSourceAppPrivileges_aggregate_bool_exp;
  phoneNumbers?: jsonb_comparison_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
  role?: qx_Role_bool_exp;
  roleExternalSync?: Boolean_comparison_exp;
  roleID?: String_comparison_exp;
  salutation?: String_comparison_exp;
  searchText?: String_comparison_exp;
  status?: String_comparison_exp;
  suffix?: String_comparison_exp;
  title?: String_comparison_exp;
  toGroups?: qx__PersonToGroup_bool_exp;
  toGroups_aggregate?: qx__PersonToGroup_aggregate_bool_exp;
  twoFactor?: ApplicationUserTwoFactor_bool_exp;
  updatedAt?: timestamptz_comparison_exp;
  userSettings?: qx_UserSetting_bool_exp;
  userSettings_aggregate?: qx_UserSetting_aggregate_bool_exp;
  views?: qx_View_bool_exp;
  views_aggregate?: qx_View_aggregate_bool_exp;
};

/** unique or primary key constraints on table "qx.Person" */
export enum qx_Person_constraint {
  /** unique or primary key constraint on columns "id" */
  Person_pkey = 'Person_pkey',
  /** unique or primary key constraint on columns "email", "placeID" */
  person_email_placeid_unique_not_deleted = 'person_email_placeid_unique_not_deleted'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type qx_Person_delete_at_path_input = {
  phoneNumbers?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type qx_Person_delete_elem_input = {
  phoneNumbers?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type qx_Person_delete_key_input = {
  phoneNumbers?: string;
};

/** input type for inserting data into table "qx.Person" */
export type qx_Person_insert_input = {
  acceptedTerms?: PersonTermsAgreement_obj_rel_insert_input;
  accessCodes?: IntrusionAccessCode_arr_rel_insert_input;
  appPasswords?: applicationUserAppPasswords_arr_rel_insert_input;
  avatar?: string;
  avatar_lg?: string;
  avatar_md?: string;
  avatar_sm?: string;
  avatar_xl?: string;
  certification?: string;
  createdAt?: string;
  credentials?: qx_Credential_arr_rel_insert_input;
  deletedAt?: string;
  department?: string;
  email?: string;
  employeeID?: string;
  events?: qx_Event_arr_rel_insert_input;
  externalPersonID?: string;
  firstName?: string;
  gatewayPassword?: ApplicationUserGatewayPassword_obj_rel_insert_input;
  id?: string;
  lastLogin?: string;
  lastName?: string;
  licensePlate?: string;
  lockdownImmunity?: boolean;
  personDeviceAppPrivileges?: personDeviceAppPrivileges_arr_rel_insert_input;
  personDoorAppPrivileges?: personDoorAppPrivileges_arr_rel_insert_input;
  personPlaceAppPrivileges?: personPlaceAppPrivileges_arr_rel_insert_input;
  personVideoSourceAppPrivileges?: personVideoSourceAppPrivileges_arr_rel_insert_input;
  phoneNumbers?: any;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
  role?: qx_Role_obj_rel_insert_input;
  roleExternalSync?: boolean;
  roleID?: string;
  salutation?: string;
  searchText?: string;
  suffix?: string;
  title?: string;
  toGroups?: qx__PersonToGroup_arr_rel_insert_input;
  twoFactor?: ApplicationUserTwoFactor_obj_rel_insert_input;
  updatedAt?: string;
  userSettings?: qx_UserSetting_arr_rel_insert_input;
  views?: qx_View_arr_rel_insert_input;
};

/** aggregate max on columns */
export type qx_Person_max_fields = {
  __typename?: 'qx_Person_max_fields';
  avatar?: string;
  avatar_lg?: string;
  avatar_md?: string;
  avatar_sm?: string;
  avatar_xl?: string;
  certification?: string;
  createdAt?: string;
  deletedAt?: string;
  department?: string;
  email?: string;
  employeeID?: string;
  externalPersonID?: string;
  firstName?: string;
  id?: string;
  lastLogin?: string;
  lastName?: string;
  licensePlate?: string;
  placeID?: string;
  roleID?: string;
  salutation?: string;
  searchText?: string;
  status?: string;
  suffix?: string;
  title?: string;
  updatedAt?: string;
};

/** order by max() on columns of table "qx.Person" */
export type qx_Person_max_order_by = {
  avatar?: order_by;
  avatar_lg?: order_by;
  avatar_md?: order_by;
  avatar_sm?: order_by;
  avatar_xl?: order_by;
  certification?: order_by;
  createdAt?: order_by;
  deletedAt?: order_by;
  department?: order_by;
  email?: order_by;
  employeeID?: order_by;
  externalPersonID?: order_by;
  firstName?: order_by;
  id?: order_by;
  lastLogin?: order_by;
  lastName?: order_by;
  licensePlate?: order_by;
  placeID?: order_by;
  roleID?: order_by;
  salutation?: order_by;
  searchText?: order_by;
  suffix?: order_by;
  title?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type qx_Person_min_fields = {
  __typename?: 'qx_Person_min_fields';
  avatar?: string;
  avatar_lg?: string;
  avatar_md?: string;
  avatar_sm?: string;
  avatar_xl?: string;
  certification?: string;
  createdAt?: string;
  deletedAt?: string;
  department?: string;
  email?: string;
  employeeID?: string;
  externalPersonID?: string;
  firstName?: string;
  id?: string;
  lastLogin?: string;
  lastName?: string;
  licensePlate?: string;
  placeID?: string;
  roleID?: string;
  salutation?: string;
  searchText?: string;
  status?: string;
  suffix?: string;
  title?: string;
  updatedAt?: string;
};

/** order by min() on columns of table "qx.Person" */
export type qx_Person_min_order_by = {
  avatar?: order_by;
  avatar_lg?: order_by;
  avatar_md?: order_by;
  avatar_sm?: order_by;
  avatar_xl?: order_by;
  certification?: order_by;
  createdAt?: order_by;
  deletedAt?: order_by;
  department?: order_by;
  email?: order_by;
  employeeID?: order_by;
  externalPersonID?: order_by;
  firstName?: order_by;
  id?: order_by;
  lastLogin?: order_by;
  lastName?: order_by;
  licensePlate?: order_by;
  placeID?: order_by;
  roleID?: order_by;
  salutation?: order_by;
  searchText?: order_by;
  suffix?: order_by;
  title?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.Person" */
export type qx_Person_mutation_response = {
  __typename?: 'qx_Person_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_Person>;
};

/** input type for inserting object relation for remote table "qx.Person" */
export type qx_Person_obj_rel_insert_input = {
  data: qx_Person_insert_input;
  /** upsert condition */
  on_conflict?: qx_Person_on_conflict;
};

/** on_conflict condition type for table "qx.Person" */
export type qx_Person_on_conflict = {
  constraint: qx_Person_constraint;
  update_columns?: Array<qx_Person_update_column>;
  where?: qx_Person_bool_exp;
};

/** Ordering options when selecting data from "qx.Person". */
export type qx_Person_order_by = {
  acceptedTerms?: PersonTermsAgreement_order_by;
  accessCodes_aggregate?: IntrusionAccessCode_aggregate_order_by;
  accessHistory_aggregate?: qx_vPersonAccessHistory_aggregate_order_by;
  appPasswords_aggregate?: applicationUserAppPasswords_aggregate_order_by;
  avatar?: order_by;
  avatar_lg?: order_by;
  avatar_md?: order_by;
  avatar_sm?: order_by;
  avatar_xl?: order_by;
  certification?: order_by;
  createdAt?: order_by;
  credentials_aggregate?: qx_Credential_aggregate_order_by;
  deletedAt?: order_by;
  department?: order_by;
  email?: order_by;
  employeeID?: order_by;
  events_aggregate?: qx_Event_aggregate_order_by;
  externalPersonID?: order_by;
  firstName?: order_by;
  gatewayPassword?: ApplicationUserGatewayPassword_order_by;
  id?: order_by;
  lastLogin?: order_by;
  lastName?: order_by;
  licensePlate?: order_by;
  lockdownImmunity?: order_by;
  personDeviceAppPrivileges_aggregate?: personDeviceAppPrivileges_aggregate_order_by;
  personDoorAppPrivileges_aggregate?: personDoorAppPrivileges_aggregate_order_by;
  personPlaceAppPrivileges_aggregate?: personPlaceAppPrivileges_aggregate_order_by;
  personVideoSourceAppPrivileges_aggregate?: personVideoSourceAppPrivileges_aggregate_order_by;
  phoneNumbers?: order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
  role?: qx_Role_order_by;
  roleExternalSync?: order_by;
  roleID?: order_by;
  salutation?: order_by;
  searchText?: order_by;
  status?: order_by;
  suffix?: order_by;
  title?: order_by;
  toGroups_aggregate?: qx__PersonToGroup_aggregate_order_by;
  twoFactor?: ApplicationUserTwoFactor_order_by;
  updatedAt?: order_by;
  userSettings_aggregate?: qx_UserSetting_aggregate_order_by;
  views_aggregate?: qx_View_aggregate_order_by;
};

/** primary key columns input for table: qx.Person */
export type qx_Person_pk_columns_input = {
  id: string;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type qx_Person_prepend_input = {
  phoneNumbers?: any;
};

/** select columns of table "qx.Person" */
export enum qx_Person_select_column {
  /** column name */
  avatar = 'avatar',
  /** column name */
  avatar_lg = 'avatar_lg',
  /** column name */
  avatar_md = 'avatar_md',
  /** column name */
  avatar_sm = 'avatar_sm',
  /** column name */
  avatar_xl = 'avatar_xl',
  /** column name */
  certification = 'certification',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  deletedAt = 'deletedAt',
  /** column name */
  department = 'department',
  /** column name */
  email = 'email',
  /** column name */
  employeeID = 'employeeID',
  /** column name */
  externalPersonID = 'externalPersonID',
  /** column name */
  firstName = 'firstName',
  /** column name */
  id = 'id',
  /** column name */
  lastLogin = 'lastLogin',
  /** column name */
  lastName = 'lastName',
  /** column name */
  licensePlate = 'licensePlate',
  /** column name */
  lockdownImmunity = 'lockdownImmunity',
  /** column name */
  phoneNumbers = 'phoneNumbers',
  /** column name */
  placeID = 'placeID',
  /** column name */
  roleExternalSync = 'roleExternalSync',
  /** column name */
  roleID = 'roleID',
  /** column name */
  salutation = 'salutation',
  /** column name */
  searchText = 'searchText',
  /** column name */
  suffix = 'suffix',
  /** column name */
  title = 'title',
  /** column name */
  updatedAt = 'updatedAt'
}

/** select "qx_Person_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.Person" */
export enum qx_Person_select_column_qx_Person_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  lockdownImmunity = 'lockdownImmunity',
  /** column name */
  roleExternalSync = 'roleExternalSync'
}

/** select "qx_Person_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.Person" */
export enum qx_Person_select_column_qx_Person_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  lockdownImmunity = 'lockdownImmunity',
  /** column name */
  roleExternalSync = 'roleExternalSync'
}

/** input type for updating data in table "qx.Person" */
export type qx_Person_set_input = {
  avatar?: string;
  avatar_lg?: string;
  avatar_md?: string;
  avatar_sm?: string;
  avatar_xl?: string;
  certification?: string;
  createdAt?: string;
  deletedAt?: string;
  department?: string;
  email?: string;
  employeeID?: string;
  externalPersonID?: string;
  firstName?: string;
  id?: string;
  lastLogin?: string;
  lastName?: string;
  licensePlate?: string;
  lockdownImmunity?: boolean;
  phoneNumbers?: any;
  placeID?: string;
  roleExternalSync?: boolean;
  roleID?: string;
  salutation?: string;
  searchText?: string;
  suffix?: string;
  title?: string;
  updatedAt?: string;
};

/** Streaming cursor of the table "qx_Person" */
export type qx_Person_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_Person_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_Person_stream_cursor_value_input = {
  avatar?: string;
  avatar_lg?: string;
  avatar_md?: string;
  avatar_sm?: string;
  avatar_xl?: string;
  certification?: string;
  createdAt?: string;
  deletedAt?: string;
  department?: string;
  email?: string;
  employeeID?: string;
  externalPersonID?: string;
  firstName?: string;
  id?: string;
  lastLogin?: string;
  lastName?: string;
  licensePlate?: string;
  lockdownImmunity?: boolean;
  phoneNumbers?: any;
  placeID?: string;
  roleExternalSync?: boolean;
  roleID?: string;
  salutation?: string;
  searchText?: string;
  suffix?: string;
  title?: string;
  updatedAt?: string;
};

/** update columns of table "qx.Person" */
export enum qx_Person_update_column {
  /** column name */
  avatar = 'avatar',
  /** column name */
  avatar_lg = 'avatar_lg',
  /** column name */
  avatar_md = 'avatar_md',
  /** column name */
  avatar_sm = 'avatar_sm',
  /** column name */
  avatar_xl = 'avatar_xl',
  /** column name */
  certification = 'certification',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  deletedAt = 'deletedAt',
  /** column name */
  department = 'department',
  /** column name */
  email = 'email',
  /** column name */
  employeeID = 'employeeID',
  /** column name */
  externalPersonID = 'externalPersonID',
  /** column name */
  firstName = 'firstName',
  /** column name */
  id = 'id',
  /** column name */
  lastLogin = 'lastLogin',
  /** column name */
  lastName = 'lastName',
  /** column name */
  licensePlate = 'licensePlate',
  /** column name */
  lockdownImmunity = 'lockdownImmunity',
  /** column name */
  phoneNumbers = 'phoneNumbers',
  /** column name */
  placeID = 'placeID',
  /** column name */
  roleExternalSync = 'roleExternalSync',
  /** column name */
  roleID = 'roleID',
  /** column name */
  salutation = 'salutation',
  /** column name */
  searchText = 'searchText',
  /** column name */
  suffix = 'suffix',
  /** column name */
  title = 'title',
  /** column name */
  updatedAt = 'updatedAt'
}

export type qx_Person_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: qx_Person_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: qx_Person_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: qx_Person_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: qx_Person_delete_key_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: qx_Person_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_Person_set_input;
  /** filter the rows which have to be updated */
  where: qx_Person_bool_exp;
};

/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_Place = {
  __typename?: 'qx_Place';
  /** An array relationship */
  AuditLogs: Array<qx_AuditLog>;
  /** An aggregate relationship */
  AuditLogs_aggregate: qx_AuditLog_aggregate;
  /** An array relationship */
  Clips: Array<qx_Clip>;
  /** An aggregate relationship */
  Clips_aggregate: qx_Clip_aggregate;
  /** An array relationship */
  DoorTemplates: Array<qx_DoorTemplate>;
  /** An aggregate relationship */
  DoorTemplates_aggregate: qx_DoorTemplate_aggregate;
  /** An array relationship */
  RosslareCatalogs: Array<rosslareCatalogs>;
  /** An aggregate relationship */
  RosslareCatalogs_aggregate: rosslareCatalogs_aggregate;
  /** An array relationship */
  WiegandCardFormats: Array<qx_WiegandCardFormat>;
  /** An aggregate relationship */
  WiegandCardFormats_aggregate: qx_WiegandCardFormat_aggregate;
  accountNumber?: string;
  addresses?: any;
  /** An object relationship */
  aiBillingSummary?: qx_vPlaceAiBillingSummary;
  aiBillingTier: string;
  aiOverageBudgetCents?: number;
  /** A computed field, executes function "qx.allowsQxSupport" */
  allowsQxSupport?: boolean;
  anniversaryDate?: string;
  /** An object relationship */
  authProvider?: qx_CustomerAuthProvider;
  /** An object relationship */
  billingPeriod?: qx_BillingPeriod;
  billingPeriodMonths?: number;
  billingStartDate?: string;
  /** An object relationship */
  billingTier: qx_eBillingTier;
  /** A computed field, executes function "qx.getCanEnableServicesForPlace" */
  canSelfServe?: boolean;
  /** An array relationship */
  children: Array<qx_Place>;
  /** An aggregate relationship */
  children_aggregate: qx_Place_aggregate;
  createdAt: string;
  /** An array relationship */
  credentials: Array<qx_Credential>;
  /** An aggregate relationship */
  credentials_aggregate: qx_Credential_aggregate;
  /** An object relationship */
  customerPermissions?: qx_CustomerPermission;
  /** An object relationship */
  defaultView?: qx_View;
  defaultViewID?: string;
  description?: string;
  /** An array relationship */
  doors: Array<qx_Door>;
  /** An aggregate relationship */
  doors_aggregate: qx_Door_aggregate;
  /** A computed field, executes function "qx.place_effective_billing_tier" */
  effectiveBillingTier?: string;
  /** An array relationship */
  events: Array<qx_Event>;
  /** An aggregate relationship */
  events_aggregate: qx_Event_aggregate;
  /** An array relationship */
  flows: Array<qx_Flow>;
  /** An aggregate relationship */
  flows_aggregate: qx_Flow_aggregate;
  /** An object relationship */
  gateway?: qx_Gateway;
  /** An array relationship */
  gateways: Array<qx_Gateway>;
  /** An aggregate relationship */
  gateways_aggregate: qx_Gateway_aggregate;
  /** An array relationship */
  groups: Array<qx_Group>;
  /** An aggregate relationship */
  groups_aggregate: qx_Group_aggregate;
  /** A computed field, executes function "qx.place_hierarchy" */
  hierarchy?: Array<qx_vPlaceHierarchy>;
  /** An array relationship */
  holidaySets: Array<qx_HolidaySet>;
  /** An aggregate relationship */
  holidaySets_aggregate: qx_HolidaySet_aggregate;
  id: string;
  /** An array relationship */
  indoors: Array<qx_Door>;
  /** An aggregate relationship */
  indoors_aggregate: qx_Door_aggregate;
  /** A computed field, executes function "qx.integratorHasAccessOperations" */
  integratorHasAccessOperations?: boolean;
  /** A computed field, executes function "qx.integratorHasConfigOperations" */
  integratorHasConfigOperations?: boolean;
  /** A computed field, executes function "qx.integratorHasVideoOperations" */
  integratorHasVideoOperations?: boolean;
  isLockedDown: boolean;
  /** An array relationship */
  layouts: Array<qx_Layout>;
  /** An aggregate relationship */
  layouts_aggregate: qx_Layout_aggregate;
  logo?: any;
  /** An array relationship */
  mediaProfiles: Array<qx_MediaProfile>;
  /** An aggregate relationship */
  mediaProfiles_aggregate: qx_MediaProfile_aggregate;
  /** An array relationship */
  mercuryCatalog: Array<qx_AccessCatalog>;
  /** An aggregate relationship */
  mercuryCatalog_aggregate: qx_AccessCatalog_aggregate;
  name: string;
  /** An array relationship */
  outdoors: Array<qx_Door>;
  /** An aggregate relationship */
  outdoors_aggregate: qx_Door_aggregate;
  /** An object relationship */
  parentPlace?: qx_Place;
  parentPlaceID?: string;
  path: string;
  pendingBillingTier?: string;
  pendingBillingTierStartsAt?: string;
  /** An array relationship */
  people: Array<qx_Person>;
  /** An aggregate relationship */
  people_aggregate: qx_Person_aggregate;
  /** An array relationship */
  permissions: Array<qx_Permission>;
  /** An aggregate relationship */
  permissions_aggregate: qx_Permission_aggregate;
  /** An array relationship */
  privileges: Array<personPlaceAppPrivileges>;
  /** An aggregate relationship */
  privileges_aggregate: personPlaceAppPrivileges_aggregate;
  qxCustomerID?: string;
  requireTwoFactor: boolean;
  /** A computed field, executes function "qx.roleCanConfig" */
  roleCanConfig?: boolean;
  /** An array relationship */
  roles: Array<qx_Role>;
  /** An aggregate relationship */
  roles_aggregate: qx_Role_aggregate;
  /** An array relationship */
  schedules: Array<qx_Schedule>;
  /** An aggregate relationship */
  schedules_aggregate: qx_Schedule_aggregate;
  /** An array relationship */
  sensors: Array<qx_Sensor>;
  /** An aggregate relationship */
  sensors_aggregate: qx_Sensor_aggregate;
  services?: any;
  /** An object relationship */
  timeZone?: qx_TimeZone;
  timezone?: string;
  /** An object relationship */
  toHomePlaces?: qx__PlaceToHomePlaces;
  /** An object relationship */
  toType: qx_ePlaceType;
  type: qx_ePlaceType_enum;
  updatedAt?: string;
  /** An object relationship */
  vPrivileges?: qx_vPlacePrivilege;
  /** An array relationship */
  videoSources: Array<qx_VideoSource>;
  /** An aggregate relationship */
  videoSources_aggregate: qx_VideoSource_aggregate;
  /** An array relationship */
  views: Array<qx_View>;
  /** An aggregate relationship */
  views_aggregate: qx_View_aggregate;
  /** An array relationship */
  whitelists: Array<placeWhiteLists>;
  /** An aggregate relationship */
  whitelists_aggregate: placeWhiteLists_aggregate;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlaceAuditLogsArgs = {
  distinct_on?: Array<qx_AuditLog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AuditLog_order_by>;
  where?: qx_AuditLog_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlaceAuditLogs_aggregateArgs = {
  distinct_on?: Array<qx_AuditLog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AuditLog_order_by>;
  where?: qx_AuditLog_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlaceClipsArgs = {
  distinct_on?: Array<qx_Clip_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Clip_order_by>;
  where?: qx_Clip_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlaceClips_aggregateArgs = {
  distinct_on?: Array<qx_Clip_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Clip_order_by>;
  where?: qx_Clip_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlaceDoorTemplatesArgs = {
  distinct_on?: Array<qx_DoorTemplate_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DoorTemplate_order_by>;
  where?: qx_DoorTemplate_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlaceDoorTemplates_aggregateArgs = {
  distinct_on?: Array<qx_DoorTemplate_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DoorTemplate_order_by>;
  where?: qx_DoorTemplate_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlaceRosslareCatalogsArgs = {
  distinct_on?: Array<rosslareCatalogs_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<rosslareCatalogs_order_by>;
  where?: rosslareCatalogs_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlaceRosslareCatalogs_aggregateArgs = {
  distinct_on?: Array<rosslareCatalogs_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<rosslareCatalogs_order_by>;
  where?: rosslareCatalogs_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlaceWiegandCardFormatsArgs = {
  distinct_on?: Array<qx_WiegandCardFormat_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_WiegandCardFormat_order_by>;
  where?: qx_WiegandCardFormat_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlaceWiegandCardFormats_aggregateArgs = {
  distinct_on?: Array<qx_WiegandCardFormat_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_WiegandCardFormat_order_by>;
  where?: qx_WiegandCardFormat_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlaceaddressesArgs = {
  path?: string;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlacechildrenArgs = {
  distinct_on?: Array<qx_Place_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Place_order_by>;
  where?: qx_Place_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_Placechildren_aggregateArgs = {
  distinct_on?: Array<qx_Place_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Place_order_by>;
  where?: qx_Place_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlacecredentialsArgs = {
  distinct_on?: Array<qx_Credential_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Credential_order_by>;
  where?: qx_Credential_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_Placecredentials_aggregateArgs = {
  distinct_on?: Array<qx_Credential_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Credential_order_by>;
  where?: qx_Credential_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlacedoorsArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_Placedoors_aggregateArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlaceeventsArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_Placeevents_aggregateArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlaceflowsArgs = {
  distinct_on?: Array<qx_Flow_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Flow_order_by>;
  where?: qx_Flow_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_Placeflows_aggregateArgs = {
  distinct_on?: Array<qx_Flow_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Flow_order_by>;
  where?: qx_Flow_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlacegatewaysArgs = {
  distinct_on?: Array<qx_Gateway_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Gateway_order_by>;
  where?: qx_Gateway_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_Placegateways_aggregateArgs = {
  distinct_on?: Array<qx_Gateway_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Gateway_order_by>;
  where?: qx_Gateway_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlacegroupsArgs = {
  distinct_on?: Array<qx_Group_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Group_order_by>;
  where?: qx_Group_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_Placegroups_aggregateArgs = {
  distinct_on?: Array<qx_Group_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Group_order_by>;
  where?: qx_Group_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlacehierarchyArgs = {
  distinct_on?: Array<qx_vPlaceHierarchy_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vPlaceHierarchy_order_by>;
  where?: qx_vPlaceHierarchy_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlaceholidaySetsArgs = {
  distinct_on?: Array<qx_HolidaySet_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_HolidaySet_order_by>;
  where?: qx_HolidaySet_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlaceholidaySets_aggregateArgs = {
  distinct_on?: Array<qx_HolidaySet_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_HolidaySet_order_by>;
  where?: qx_HolidaySet_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlaceindoorsArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_Placeindoors_aggregateArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlacelayoutsArgs = {
  distinct_on?: Array<qx_Layout_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Layout_order_by>;
  where?: qx_Layout_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_Placelayouts_aggregateArgs = {
  distinct_on?: Array<qx_Layout_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Layout_order_by>;
  where?: qx_Layout_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlacemediaProfilesArgs = {
  distinct_on?: Array<qx_MediaProfile_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MediaProfile_order_by>;
  where?: qx_MediaProfile_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlacemediaProfiles_aggregateArgs = {
  distinct_on?: Array<qx_MediaProfile_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MediaProfile_order_by>;
  where?: qx_MediaProfile_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlacemercuryCatalogArgs = {
  distinct_on?: Array<qx_AccessCatalog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessCatalog_order_by>;
  where?: qx_AccessCatalog_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlacemercuryCatalog_aggregateArgs = {
  distinct_on?: Array<qx_AccessCatalog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessCatalog_order_by>;
  where?: qx_AccessCatalog_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlaceoutdoorsArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_Placeoutdoors_aggregateArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlacepeopleArgs = {
  distinct_on?: Array<qx_Person_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Person_order_by>;
  where?: qx_Person_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_Placepeople_aggregateArgs = {
  distinct_on?: Array<qx_Person_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Person_order_by>;
  where?: qx_Person_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlacepermissionsArgs = {
  distinct_on?: Array<qx_Permission_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Permission_order_by>;
  where?: qx_Permission_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_Placepermissions_aggregateArgs = {
  distinct_on?: Array<qx_Permission_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Permission_order_by>;
  where?: qx_Permission_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlaceprivilegesArgs = {
  distinct_on?: Array<personPlaceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personPlaceAppPrivileges_order_by>;
  where?: personPlaceAppPrivileges_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_Placeprivileges_aggregateArgs = {
  distinct_on?: Array<personPlaceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personPlaceAppPrivileges_order_by>;
  where?: personPlaceAppPrivileges_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlacerolesArgs = {
  distinct_on?: Array<qx_Role_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Role_order_by>;
  where?: qx_Role_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_Placeroles_aggregateArgs = {
  distinct_on?: Array<qx_Role_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Role_order_by>;
  where?: qx_Role_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlaceschedulesArgs = {
  distinct_on?: Array<qx_Schedule_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Schedule_order_by>;
  where?: qx_Schedule_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_Placeschedules_aggregateArgs = {
  distinct_on?: Array<qx_Schedule_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Schedule_order_by>;
  where?: qx_Schedule_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlacesensorsArgs = {
  distinct_on?: Array<qx_Sensor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Sensor_order_by>;
  where?: qx_Sensor_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_Placesensors_aggregateArgs = {
  distinct_on?: Array<qx_Sensor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Sensor_order_by>;
  where?: qx_Sensor_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlaceservicesArgs = {
  path?: string;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlacevideoSourcesArgs = {
  distinct_on?: Array<qx_VideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_VideoSource_order_by>;
  where?: qx_VideoSource_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlacevideoSources_aggregateArgs = {
  distinct_on?: Array<qx_VideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_VideoSource_order_by>;
  where?: qx_VideoSource_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlaceviewsArgs = {
  distinct_on?: Array<qx_View_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_View_order_by>;
  where?: qx_View_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_Placeviews_aggregateArgs = {
  distinct_on?: Array<qx_View_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_View_order_by>;
  where?: qx_View_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_PlacewhitelistsArgs = {
  distinct_on?: Array<placeWhiteLists_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<placeWhiteLists_order_by>;
  where?: placeWhiteLists_bool_exp;
};


/** organizational node in the location hierarchy (root, customer, integrator, site, area, etc.), where doors, cameras, and persons belong */
export type qx_Placewhitelists_aggregateArgs = {
  distinct_on?: Array<placeWhiteLists_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<placeWhiteLists_order_by>;
  where?: placeWhiteLists_bool_exp;
};

/** aggregated selection of "qx.Place" */
export type qx_Place_aggregate = {
  __typename?: 'qx_Place_aggregate';
  aggregate?: qx_Place_aggregate_fields;
  nodes: Array<qx_Place>;
};

export type qx_Place_aggregate_bool_exp = {
  bool_and?: qx_Place_aggregate_bool_exp_bool_and;
  bool_or?: qx_Place_aggregate_bool_exp_bool_or;
  count?: qx_Place_aggregate_bool_exp_count;
};

export type qx_Place_aggregate_bool_exp_bool_and = {
  arguments: qx_Place_select_column_qx_Place_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: qx_Place_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_Place_aggregate_bool_exp_bool_or = {
  arguments: qx_Place_select_column_qx_Place_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: qx_Place_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_Place_aggregate_bool_exp_count = {
  arguments?: Array<qx_Place_select_column>;
  distinct?: boolean;
  filter?: qx_Place_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.Place" */
export type qx_Place_aggregate_fields = {
  __typename?: 'qx_Place_aggregate_fields';
  avg?: qx_Place_avg_fields;
  count: number;
  max?: qx_Place_max_fields;
  min?: qx_Place_min_fields;
  stddev?: qx_Place_stddev_fields;
  stddev_pop?: qx_Place_stddev_pop_fields;
  stddev_samp?: qx_Place_stddev_samp_fields;
  sum?: qx_Place_sum_fields;
  var_pop?: qx_Place_var_pop_fields;
  var_samp?: qx_Place_var_samp_fields;
  variance?: qx_Place_variance_fields;
};


/** aggregate fields of "qx.Place" */
export type qx_Place_aggregate_fieldscountArgs = {
  columns?: Array<qx_Place_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.Place" */
export type qx_Place_aggregate_order_by = {
  avg?: qx_Place_avg_order_by;
  count?: order_by;
  max?: qx_Place_max_order_by;
  min?: qx_Place_min_order_by;
  stddev?: qx_Place_stddev_order_by;
  stddev_pop?: qx_Place_stddev_pop_order_by;
  stddev_samp?: qx_Place_stddev_samp_order_by;
  sum?: qx_Place_sum_order_by;
  var_pop?: qx_Place_var_pop_order_by;
  var_samp?: qx_Place_var_samp_order_by;
  variance?: qx_Place_variance_order_by;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type qx_Place_append_input = {
  addresses?: any;
  services?: any;
};

/** input type for inserting array relation for remote table "qx.Place" */
export type qx_Place_arr_rel_insert_input = {
  data: Array<qx_Place_insert_input>;
  /** upsert condition */
  on_conflict?: qx_Place_on_conflict;
};

/** aggregate avg on columns */
export type qx_Place_avg_fields = {
  __typename?: 'qx_Place_avg_fields';
  aiOverageBudgetCents?: number;
  billingPeriodMonths?: number;
};

/** order by avg() on columns of table "qx.Place" */
export type qx_Place_avg_order_by = {
  aiOverageBudgetCents?: order_by;
  billingPeriodMonths?: order_by;
};

/** Boolean expression to filter rows from the table "qx.Place". All fields are combined with a logical 'AND'. */
export type qx_Place_bool_exp = {
  AuditLogs?: qx_AuditLog_bool_exp;
  AuditLogs_aggregate?: qx_AuditLog_aggregate_bool_exp;
  Clips?: qx_Clip_bool_exp;
  Clips_aggregate?: qx_Clip_aggregate_bool_exp;
  DoorTemplates?: qx_DoorTemplate_bool_exp;
  DoorTemplates_aggregate?: qx_DoorTemplate_aggregate_bool_exp;
  RosslareCatalogs?: rosslareCatalogs_bool_exp;
  RosslareCatalogs_aggregate?: rosslareCatalogs_aggregate_bool_exp;
  WiegandCardFormats?: qx_WiegandCardFormat_bool_exp;
  WiegandCardFormats_aggregate?: qx_WiegandCardFormat_aggregate_bool_exp;
  _and?: Array<qx_Place_bool_exp>;
  _not?: qx_Place_bool_exp;
  _or?: Array<qx_Place_bool_exp>;
  accountNumber?: String_comparison_exp;
  addresses?: jsonb_comparison_exp;
  aiBillingSummary?: qx_vPlaceAiBillingSummary_bool_exp;
  aiBillingTier?: String_comparison_exp;
  aiOverageBudgetCents?: Int_comparison_exp;
  allowsQxSupport?: Boolean_comparison_exp;
  anniversaryDate?: timestamptz_comparison_exp;
  authProvider?: qx_CustomerAuthProvider_bool_exp;
  billingPeriod?: qx_BillingPeriod_bool_exp;
  billingPeriodMonths?: Int_comparison_exp;
  billingStartDate?: timestamptz_comparison_exp;
  billingTier?: qx_eBillingTier_bool_exp;
  canSelfServe?: Boolean_comparison_exp;
  children?: qx_Place_bool_exp;
  children_aggregate?: qx_Place_aggregate_bool_exp;
  createdAt?: timestamptz_comparison_exp;
  credentials?: qx_Credential_bool_exp;
  credentials_aggregate?: qx_Credential_aggregate_bool_exp;
  customerPermissions?: qx_CustomerPermission_bool_exp;
  defaultView?: qx_View_bool_exp;
  defaultViewID?: String_comparison_exp;
  description?: String_comparison_exp;
  doors?: qx_Door_bool_exp;
  doors_aggregate?: qx_Door_aggregate_bool_exp;
  effectiveBillingTier?: String_comparison_exp;
  events?: qx_Event_bool_exp;
  events_aggregate?: qx_Event_aggregate_bool_exp;
  flows?: qx_Flow_bool_exp;
  flows_aggregate?: qx_Flow_aggregate_bool_exp;
  gateway?: qx_Gateway_bool_exp;
  gateways?: qx_Gateway_bool_exp;
  gateways_aggregate?: qx_Gateway_aggregate_bool_exp;
  groups?: qx_Group_bool_exp;
  groups_aggregate?: qx_Group_aggregate_bool_exp;
  hierarchy?: qx_vPlaceHierarchy_bool_exp;
  holidaySets?: qx_HolidaySet_bool_exp;
  holidaySets_aggregate?: qx_HolidaySet_aggregate_bool_exp;
  id?: String_comparison_exp;
  indoors?: qx_Door_bool_exp;
  indoors_aggregate?: qx_Door_aggregate_bool_exp;
  integratorHasAccessOperations?: Boolean_comparison_exp;
  integratorHasConfigOperations?: Boolean_comparison_exp;
  integratorHasVideoOperations?: Boolean_comparison_exp;
  isLockedDown?: Boolean_comparison_exp;
  layouts?: qx_Layout_bool_exp;
  layouts_aggregate?: qx_Layout_aggregate_bool_exp;
  logo?: bytea_comparison_exp;
  mediaProfiles?: qx_MediaProfile_bool_exp;
  mediaProfiles_aggregate?: qx_MediaProfile_aggregate_bool_exp;
  mercuryCatalog?: qx_AccessCatalog_bool_exp;
  mercuryCatalog_aggregate?: qx_AccessCatalog_aggregate_bool_exp;
  name?: String_comparison_exp;
  outdoors?: qx_Door_bool_exp;
  outdoors_aggregate?: qx_Door_aggregate_bool_exp;
  parentPlace?: qx_Place_bool_exp;
  parentPlaceID?: String_comparison_exp;
  path?: String_comparison_exp;
  pendingBillingTier?: String_comparison_exp;
  pendingBillingTierStartsAt?: date_comparison_exp;
  people?: qx_Person_bool_exp;
  people_aggregate?: qx_Person_aggregate_bool_exp;
  permissions?: qx_Permission_bool_exp;
  permissions_aggregate?: qx_Permission_aggregate_bool_exp;
  privileges?: personPlaceAppPrivileges_bool_exp;
  privileges_aggregate?: personPlaceAppPrivileges_aggregate_bool_exp;
  qxCustomerID?: String_comparison_exp;
  requireTwoFactor?: Boolean_comparison_exp;
  roleCanConfig?: Boolean_comparison_exp;
  roles?: qx_Role_bool_exp;
  roles_aggregate?: qx_Role_aggregate_bool_exp;
  schedules?: qx_Schedule_bool_exp;
  schedules_aggregate?: qx_Schedule_aggregate_bool_exp;
  sensors?: qx_Sensor_bool_exp;
  sensors_aggregate?: qx_Sensor_aggregate_bool_exp;
  services?: jsonb_comparison_exp;
  timeZone?: qx_TimeZone_bool_exp;
  timezone?: String_comparison_exp;
  toHomePlaces?: qx__PlaceToHomePlaces_bool_exp;
  toType?: qx_ePlaceType_bool_exp;
  type?: qx_ePlaceType_enum_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
  vPrivileges?: qx_vPlacePrivilege_bool_exp;
  videoSources?: qx_VideoSource_bool_exp;
  videoSources_aggregate?: qx_VideoSource_aggregate_bool_exp;
  views?: qx_View_bool_exp;
  views_aggregate?: qx_View_aggregate_bool_exp;
  whitelists?: placeWhiteLists_bool_exp;
  whitelists_aggregate?: placeWhiteLists_aggregate_bool_exp;
};

/** unique or primary key constraints on table "qx.Place" */
export enum qx_Place_constraint {
  /** unique or primary key constraint on columns "id" */
  Place_pkey = 'Place_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type qx_Place_delete_at_path_input = {
  addresses?: Array<string>;
  services?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type qx_Place_delete_elem_input = {
  addresses?: number;
  services?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type qx_Place_delete_key_input = {
  addresses?: string;
  services?: string;
};

/** input type for incrementing numeric columns in table "qx.Place" */
export type qx_Place_inc_input = {
  aiOverageBudgetCents?: number;
  billingPeriodMonths?: number;
};

/** input type for inserting data into table "qx.Place" */
export type qx_Place_insert_input = {
  AuditLogs?: qx_AuditLog_arr_rel_insert_input;
  Clips?: qx_Clip_arr_rel_insert_input;
  DoorTemplates?: qx_DoorTemplate_arr_rel_insert_input;
  RosslareCatalogs?: rosslareCatalogs_arr_rel_insert_input;
  WiegandCardFormats?: qx_WiegandCardFormat_arr_rel_insert_input;
  accountNumber?: string;
  addresses?: any;
  aiBillingSummary?: qx_vPlaceAiBillingSummary_obj_rel_insert_input;
  aiBillingTier?: string;
  aiOverageBudgetCents?: number;
  anniversaryDate?: string;
  authProvider?: qx_CustomerAuthProvider_obj_rel_insert_input;
  billingPeriod?: qx_BillingPeriod_obj_rel_insert_input;
  billingPeriodMonths?: number;
  billingStartDate?: string;
  billingTier?: qx_eBillingTier_obj_rel_insert_input;
  children?: qx_Place_arr_rel_insert_input;
  createdAt?: string;
  credentials?: qx_Credential_arr_rel_insert_input;
  customerPermissions?: qx_CustomerPermission_obj_rel_insert_input;
  defaultView?: qx_View_obj_rel_insert_input;
  defaultViewID?: string;
  description?: string;
  doors?: qx_Door_arr_rel_insert_input;
  events?: qx_Event_arr_rel_insert_input;
  flows?: qx_Flow_arr_rel_insert_input;
  gateway?: qx_Gateway_obj_rel_insert_input;
  gateways?: qx_Gateway_arr_rel_insert_input;
  groups?: qx_Group_arr_rel_insert_input;
  holidaySets?: qx_HolidaySet_arr_rel_insert_input;
  id?: string;
  indoors?: qx_Door_arr_rel_insert_input;
  isLockedDown?: boolean;
  layouts?: qx_Layout_arr_rel_insert_input;
  logo?: any;
  mediaProfiles?: qx_MediaProfile_arr_rel_insert_input;
  mercuryCatalog?: qx_AccessCatalog_arr_rel_insert_input;
  name?: string;
  outdoors?: qx_Door_arr_rel_insert_input;
  parentPlace?: qx_Place_obj_rel_insert_input;
  parentPlaceID?: string;
  path?: string;
  pendingBillingTier?: string;
  pendingBillingTierStartsAt?: string;
  people?: qx_Person_arr_rel_insert_input;
  permissions?: qx_Permission_arr_rel_insert_input;
  privileges?: personPlaceAppPrivileges_arr_rel_insert_input;
  qxCustomerID?: string;
  requireTwoFactor?: boolean;
  roles?: qx_Role_arr_rel_insert_input;
  schedules?: qx_Schedule_arr_rel_insert_input;
  sensors?: qx_Sensor_arr_rel_insert_input;
  services?: any;
  timeZone?: qx_TimeZone_obj_rel_insert_input;
  timezone?: string;
  toHomePlaces?: qx__PlaceToHomePlaces_obj_rel_insert_input;
  toType?: qx_ePlaceType_obj_rel_insert_input;
  type?: qx_ePlaceType_enum;
  updatedAt?: string;
  vPrivileges?: qx_vPlacePrivilege_obj_rel_insert_input;
  videoSources?: qx_VideoSource_arr_rel_insert_input;
  views?: qx_View_arr_rel_insert_input;
  whitelists?: placeWhiteLists_arr_rel_insert_input;
};

/** aggregate max on columns */
export type qx_Place_max_fields = {
  __typename?: 'qx_Place_max_fields';
  accountNumber?: string;
  aiBillingTier?: string;
  aiOverageBudgetCents?: number;
  anniversaryDate?: string;
  billingPeriodMonths?: number;
  billingStartDate?: string;
  createdAt?: string;
  defaultViewID?: string;
  description?: string;
  /** A computed field, executes function "qx.place_effective_billing_tier" */
  effectiveBillingTier?: string;
  id?: string;
  name?: string;
  parentPlaceID?: string;
  path?: string;
  pendingBillingTier?: string;
  pendingBillingTierStartsAt?: string;
  qxCustomerID?: string;
  timezone?: string;
  updatedAt?: string;
};

/** order by max() on columns of table "qx.Place" */
export type qx_Place_max_order_by = {
  accountNumber?: order_by;
  aiBillingTier?: order_by;
  aiOverageBudgetCents?: order_by;
  anniversaryDate?: order_by;
  billingPeriodMonths?: order_by;
  billingStartDate?: order_by;
  createdAt?: order_by;
  defaultViewID?: order_by;
  description?: order_by;
  id?: order_by;
  name?: order_by;
  parentPlaceID?: order_by;
  path?: order_by;
  pendingBillingTier?: order_by;
  pendingBillingTierStartsAt?: order_by;
  qxCustomerID?: order_by;
  timezone?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type qx_Place_min_fields = {
  __typename?: 'qx_Place_min_fields';
  accountNumber?: string;
  aiBillingTier?: string;
  aiOverageBudgetCents?: number;
  anniversaryDate?: string;
  billingPeriodMonths?: number;
  billingStartDate?: string;
  createdAt?: string;
  defaultViewID?: string;
  description?: string;
  /** A computed field, executes function "qx.place_effective_billing_tier" */
  effectiveBillingTier?: string;
  id?: string;
  name?: string;
  parentPlaceID?: string;
  path?: string;
  pendingBillingTier?: string;
  pendingBillingTierStartsAt?: string;
  qxCustomerID?: string;
  timezone?: string;
  updatedAt?: string;
};

/** order by min() on columns of table "qx.Place" */
export type qx_Place_min_order_by = {
  accountNumber?: order_by;
  aiBillingTier?: order_by;
  aiOverageBudgetCents?: order_by;
  anniversaryDate?: order_by;
  billingPeriodMonths?: order_by;
  billingStartDate?: order_by;
  createdAt?: order_by;
  defaultViewID?: order_by;
  description?: order_by;
  id?: order_by;
  name?: order_by;
  parentPlaceID?: order_by;
  path?: order_by;
  pendingBillingTier?: order_by;
  pendingBillingTierStartsAt?: order_by;
  qxCustomerID?: order_by;
  timezone?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.Place" */
export type qx_Place_mutation_response = {
  __typename?: 'qx_Place_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_Place>;
};

/** input type for inserting object relation for remote table "qx.Place" */
export type qx_Place_obj_rel_insert_input = {
  data: qx_Place_insert_input;
  /** upsert condition */
  on_conflict?: qx_Place_on_conflict;
};

/** on_conflict condition type for table "qx.Place" */
export type qx_Place_on_conflict = {
  constraint: qx_Place_constraint;
  update_columns?: Array<qx_Place_update_column>;
  where?: qx_Place_bool_exp;
};

/** Ordering options when selecting data from "qx.Place". */
export type qx_Place_order_by = {
  AuditLogs_aggregate?: qx_AuditLog_aggregate_order_by;
  Clips_aggregate?: qx_Clip_aggregate_order_by;
  DoorTemplates_aggregate?: qx_DoorTemplate_aggregate_order_by;
  RosslareCatalogs_aggregate?: rosslareCatalogs_aggregate_order_by;
  WiegandCardFormats_aggregate?: qx_WiegandCardFormat_aggregate_order_by;
  accountNumber?: order_by;
  addresses?: order_by;
  aiBillingSummary?: qx_vPlaceAiBillingSummary_order_by;
  aiBillingTier?: order_by;
  aiOverageBudgetCents?: order_by;
  allowsQxSupport?: order_by;
  anniversaryDate?: order_by;
  authProvider?: qx_CustomerAuthProvider_order_by;
  billingPeriod?: qx_BillingPeriod_order_by;
  billingPeriodMonths?: order_by;
  billingStartDate?: order_by;
  billingTier?: qx_eBillingTier_order_by;
  canSelfServe?: order_by;
  children_aggregate?: qx_Place_aggregate_order_by;
  createdAt?: order_by;
  credentials_aggregate?: qx_Credential_aggregate_order_by;
  customerPermissions?: qx_CustomerPermission_order_by;
  defaultView?: qx_View_order_by;
  defaultViewID?: order_by;
  description?: order_by;
  doors_aggregate?: qx_Door_aggregate_order_by;
  effectiveBillingTier?: order_by;
  events_aggregate?: qx_Event_aggregate_order_by;
  flows_aggregate?: qx_Flow_aggregate_order_by;
  gateway?: qx_Gateway_order_by;
  gateways_aggregate?: qx_Gateway_aggregate_order_by;
  groups_aggregate?: qx_Group_aggregate_order_by;
  hierarchy_aggregate?: qx_vPlaceHierarchy_aggregate_order_by;
  holidaySets_aggregate?: qx_HolidaySet_aggregate_order_by;
  id?: order_by;
  indoors_aggregate?: qx_Door_aggregate_order_by;
  integratorHasAccessOperations?: order_by;
  integratorHasConfigOperations?: order_by;
  integratorHasVideoOperations?: order_by;
  isLockedDown?: order_by;
  layouts_aggregate?: qx_Layout_aggregate_order_by;
  logo?: order_by;
  mediaProfiles_aggregate?: qx_MediaProfile_aggregate_order_by;
  mercuryCatalog_aggregate?: qx_AccessCatalog_aggregate_order_by;
  name?: order_by;
  outdoors_aggregate?: qx_Door_aggregate_order_by;
  parentPlace?: qx_Place_order_by;
  parentPlaceID?: order_by;
  path?: order_by;
  pendingBillingTier?: order_by;
  pendingBillingTierStartsAt?: order_by;
  people_aggregate?: qx_Person_aggregate_order_by;
  permissions_aggregate?: qx_Permission_aggregate_order_by;
  privileges_aggregate?: personPlaceAppPrivileges_aggregate_order_by;
  qxCustomerID?: order_by;
  requireTwoFactor?: order_by;
  roleCanConfig?: order_by;
  roles_aggregate?: qx_Role_aggregate_order_by;
  schedules_aggregate?: qx_Schedule_aggregate_order_by;
  sensors_aggregate?: qx_Sensor_aggregate_order_by;
  services?: order_by;
  timeZone?: qx_TimeZone_order_by;
  timezone?: order_by;
  toHomePlaces?: qx__PlaceToHomePlaces_order_by;
  toType?: qx_ePlaceType_order_by;
  type?: order_by;
  updatedAt?: order_by;
  vPrivileges?: qx_vPlacePrivilege_order_by;
  videoSources_aggregate?: qx_VideoSource_aggregate_order_by;
  views_aggregate?: qx_View_aggregate_order_by;
  whitelists_aggregate?: placeWhiteLists_aggregate_order_by;
};

/** primary key columns input for table: qx.Place */
export type qx_Place_pk_columns_input = {
  id: string;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type qx_Place_prepend_input = {
  addresses?: any;
  services?: any;
};

/** select columns of table "qx.Place" */
export enum qx_Place_select_column {
  /** column name */
  accountNumber = 'accountNumber',
  /** column name */
  addresses = 'addresses',
  /** column name */
  aiBillingTier = 'aiBillingTier',
  /** column name */
  aiOverageBudgetCents = 'aiOverageBudgetCents',
  /** column name */
  anniversaryDate = 'anniversaryDate',
  /** column name */
  billingPeriodMonths = 'billingPeriodMonths',
  /** column name */
  billingStartDate = 'billingStartDate',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  defaultViewID = 'defaultViewID',
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  isLockedDown = 'isLockedDown',
  /** column name */
  logo = 'logo',
  /** column name */
  name = 'name',
  /** column name */
  parentPlaceID = 'parentPlaceID',
  /** column name */
  path = 'path',
  /** column name */
  pendingBillingTier = 'pendingBillingTier',
  /** column name */
  pendingBillingTierStartsAt = 'pendingBillingTierStartsAt',
  /** column name */
  qxCustomerID = 'qxCustomerID',
  /** column name */
  requireTwoFactor = 'requireTwoFactor',
  /** column name */
  services = 'services',
  /** column name */
  timezone = 'timezone',
  /** column name */
  type = 'type',
  /** column name */
  updatedAt = 'updatedAt'
}

/** select "qx_Place_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.Place" */
export enum qx_Place_select_column_qx_Place_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  isLockedDown = 'isLockedDown',
  /** column name */
  requireTwoFactor = 'requireTwoFactor'
}

/** select "qx_Place_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.Place" */
export enum qx_Place_select_column_qx_Place_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  isLockedDown = 'isLockedDown',
  /** column name */
  requireTwoFactor = 'requireTwoFactor'
}

/** input type for updating data in table "qx.Place" */
export type qx_Place_set_input = {
  accountNumber?: string;
  addresses?: any;
  aiBillingTier?: string;
  aiOverageBudgetCents?: number;
  anniversaryDate?: string;
  billingPeriodMonths?: number;
  billingStartDate?: string;
  createdAt?: string;
  defaultViewID?: string;
  description?: string;
  id?: string;
  isLockedDown?: boolean;
  logo?: any;
  name?: string;
  parentPlaceID?: string;
  path?: string;
  pendingBillingTier?: string;
  pendingBillingTierStartsAt?: string;
  qxCustomerID?: string;
  requireTwoFactor?: boolean;
  services?: any;
  timezone?: string;
  type?: qx_ePlaceType_enum;
  updatedAt?: string;
};

/** aggregate stddev on columns */
export type qx_Place_stddev_fields = {
  __typename?: 'qx_Place_stddev_fields';
  aiOverageBudgetCents?: number;
  billingPeriodMonths?: number;
};

/** order by stddev() on columns of table "qx.Place" */
export type qx_Place_stddev_order_by = {
  aiOverageBudgetCents?: order_by;
  billingPeriodMonths?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_Place_stddev_pop_fields = {
  __typename?: 'qx_Place_stddev_pop_fields';
  aiOverageBudgetCents?: number;
  billingPeriodMonths?: number;
};

/** order by stddev_pop() on columns of table "qx.Place" */
export type qx_Place_stddev_pop_order_by = {
  aiOverageBudgetCents?: order_by;
  billingPeriodMonths?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_Place_stddev_samp_fields = {
  __typename?: 'qx_Place_stddev_samp_fields';
  aiOverageBudgetCents?: number;
  billingPeriodMonths?: number;
};

/** order by stddev_samp() on columns of table "qx.Place" */
export type qx_Place_stddev_samp_order_by = {
  aiOverageBudgetCents?: order_by;
  billingPeriodMonths?: order_by;
};

/** Streaming cursor of the table "qx_Place" */
export type qx_Place_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_Place_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_Place_stream_cursor_value_input = {
  accountNumber?: string;
  addresses?: any;
  aiBillingTier?: string;
  aiOverageBudgetCents?: number;
  anniversaryDate?: string;
  billingPeriodMonths?: number;
  billingStartDate?: string;
  createdAt?: string;
  defaultViewID?: string;
  description?: string;
  id?: string;
  isLockedDown?: boolean;
  logo?: any;
  name?: string;
  parentPlaceID?: string;
  path?: string;
  pendingBillingTier?: string;
  pendingBillingTierStartsAt?: string;
  qxCustomerID?: string;
  requireTwoFactor?: boolean;
  services?: any;
  timezone?: string;
  type?: qx_ePlaceType_enum;
  updatedAt?: string;
};

/** aggregate sum on columns */
export type qx_Place_sum_fields = {
  __typename?: 'qx_Place_sum_fields';
  aiOverageBudgetCents?: number;
  billingPeriodMonths?: number;
};

/** order by sum() on columns of table "qx.Place" */
export type qx_Place_sum_order_by = {
  aiOverageBudgetCents?: order_by;
  billingPeriodMonths?: order_by;
};

/** update columns of table "qx.Place" */
export enum qx_Place_update_column {
  /** column name */
  accountNumber = 'accountNumber',
  /** column name */
  addresses = 'addresses',
  /** column name */
  aiBillingTier = 'aiBillingTier',
  /** column name */
  aiOverageBudgetCents = 'aiOverageBudgetCents',
  /** column name */
  anniversaryDate = 'anniversaryDate',
  /** column name */
  billingPeriodMonths = 'billingPeriodMonths',
  /** column name */
  billingStartDate = 'billingStartDate',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  defaultViewID = 'defaultViewID',
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  isLockedDown = 'isLockedDown',
  /** column name */
  logo = 'logo',
  /** column name */
  name = 'name',
  /** column name */
  parentPlaceID = 'parentPlaceID',
  /** column name */
  path = 'path',
  /** column name */
  pendingBillingTier = 'pendingBillingTier',
  /** column name */
  pendingBillingTierStartsAt = 'pendingBillingTierStartsAt',
  /** column name */
  qxCustomerID = 'qxCustomerID',
  /** column name */
  requireTwoFactor = 'requireTwoFactor',
  /** column name */
  services = 'services',
  /** column name */
  timezone = 'timezone',
  /** column name */
  type = 'type',
  /** column name */
  updatedAt = 'updatedAt'
}

export type qx_Place_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: qx_Place_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: qx_Place_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: qx_Place_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: qx_Place_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_Place_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: qx_Place_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_Place_set_input;
  /** filter the rows which have to be updated */
  where: qx_Place_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_Place_var_pop_fields = {
  __typename?: 'qx_Place_var_pop_fields';
  aiOverageBudgetCents?: number;
  billingPeriodMonths?: number;
};

/** order by var_pop() on columns of table "qx.Place" */
export type qx_Place_var_pop_order_by = {
  aiOverageBudgetCents?: order_by;
  billingPeriodMonths?: order_by;
};

/** aggregate var_samp on columns */
export type qx_Place_var_samp_fields = {
  __typename?: 'qx_Place_var_samp_fields';
  aiOverageBudgetCents?: number;
  billingPeriodMonths?: number;
};

/** order by var_samp() on columns of table "qx.Place" */
export type qx_Place_var_samp_order_by = {
  aiOverageBudgetCents?: order_by;
  billingPeriodMonths?: order_by;
};

/** aggregate variance on columns */
export type qx_Place_variance_fields = {
  __typename?: 'qx_Place_variance_fields';
  aiOverageBudgetCents?: number;
  billingPeriodMonths?: number;
};

/** order by variance() on columns of table "qx.Place" */
export type qx_Place_variance_order_by = {
  aiOverageBudgetCents?: order_by;
  billingPeriodMonths?: order_by;
};

/** credential reader (card reader or keypad) attached to a door for presenting access credentials */
export type qx_Reader = {
  __typename?: 'qx_Reader';
  /** An array relationship */
  DeviceDIOs: Array<qx_DeviceDIO>;
  /** An aggregate relationship */
  DeviceDIOs_aggregate: qx_DeviceDIO_aggregate;
  /** An object relationship */
  Door?: qx_Door;
  /** An object relationship */
  accessInventory?: qx_AccessInventory;
  accessType: qx_eReaderAccessType_enum;
  action: qx_eAccessPointAction_enum;
  address: number;
  baudrateID?: qx_eBaudrate_enum;
  /** An object relationship */
  device?: qx_Device;
  deviceID: string;
  direction: qx_eAccessPointDirection_enum;
  doorID?: string;
  /** An object relationship */
  eAccessPointAction: qx_eAccessPointAction;
  /** An object relationship */
  eAccessPointDirection: qx_eAccessPointDirection;
  /** An object relationship */
  eAccessPointType: qx_eAccessPointType;
  /** An object relationship */
  eBaudrate?: qx_eBaudrate;
  /** An object relationship */
  eKeypadMode?: qx_eKeypadMode;
  /** An object relationship */
  eReaderAccessType: qx_eReaderAccessType;
  /** An object relationship */
  eReaderProtocol: qx_eReaderProtocol;
  /** An object relationship */
  eRexState: qx_eRexState;
  enabled: boolean;
  id: string;
  inventoryID?: string;
  keypadModeID?: qx_eKeypadMode_enum;
  name: string;
  protocol: qx_eReaderProtocol_enum;
  refID: string;
  rexBypass: boolean;
  rexState: qx_eRexState_enum;
  /** A computed field, executes function "qx.rex_supervise_value" */
  supervise?: string;
  type: qx_eAccessPointType_enum;
  updatedAt?: string;
  wiegandFormats?: any;
};


/** credential reader (card reader or keypad) attached to a door for presenting access credentials */
export type qx_ReaderDeviceDIOsArgs = {
  distinct_on?: Array<qx_DeviceDIO_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DeviceDIO_order_by>;
  where?: qx_DeviceDIO_bool_exp;
};


/** credential reader (card reader or keypad) attached to a door for presenting access credentials */
export type qx_ReaderDeviceDIOs_aggregateArgs = {
  distinct_on?: Array<qx_DeviceDIO_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DeviceDIO_order_by>;
  where?: qx_DeviceDIO_bool_exp;
};


/** credential reader (card reader or keypad) attached to a door for presenting access credentials */
export type qx_ReaderwiegandFormatsArgs = {
  path?: string;
};

/** aggregated selection of "qx.Reader" */
export type qx_Reader_aggregate = {
  __typename?: 'qx_Reader_aggregate';
  aggregate?: qx_Reader_aggregate_fields;
  nodes: Array<qx_Reader>;
};

export type qx_Reader_aggregate_bool_exp = {
  bool_and?: qx_Reader_aggregate_bool_exp_bool_and;
  bool_or?: qx_Reader_aggregate_bool_exp_bool_or;
  count?: qx_Reader_aggregate_bool_exp_count;
};

export type qx_Reader_aggregate_bool_exp_bool_and = {
  arguments: qx_Reader_select_column_qx_Reader_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: qx_Reader_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_Reader_aggregate_bool_exp_bool_or = {
  arguments: qx_Reader_select_column_qx_Reader_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: qx_Reader_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_Reader_aggregate_bool_exp_count = {
  arguments?: Array<qx_Reader_select_column>;
  distinct?: boolean;
  filter?: qx_Reader_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.Reader" */
export type qx_Reader_aggregate_fields = {
  __typename?: 'qx_Reader_aggregate_fields';
  avg?: qx_Reader_avg_fields;
  count: number;
  max?: qx_Reader_max_fields;
  min?: qx_Reader_min_fields;
  stddev?: qx_Reader_stddev_fields;
  stddev_pop?: qx_Reader_stddev_pop_fields;
  stddev_samp?: qx_Reader_stddev_samp_fields;
  sum?: qx_Reader_sum_fields;
  var_pop?: qx_Reader_var_pop_fields;
  var_samp?: qx_Reader_var_samp_fields;
  variance?: qx_Reader_variance_fields;
};


/** aggregate fields of "qx.Reader" */
export type qx_Reader_aggregate_fieldscountArgs = {
  columns?: Array<qx_Reader_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.Reader" */
export type qx_Reader_aggregate_order_by = {
  avg?: qx_Reader_avg_order_by;
  count?: order_by;
  max?: qx_Reader_max_order_by;
  min?: qx_Reader_min_order_by;
  stddev?: qx_Reader_stddev_order_by;
  stddev_pop?: qx_Reader_stddev_pop_order_by;
  stddev_samp?: qx_Reader_stddev_samp_order_by;
  sum?: qx_Reader_sum_order_by;
  var_pop?: qx_Reader_var_pop_order_by;
  var_samp?: qx_Reader_var_samp_order_by;
  variance?: qx_Reader_variance_order_by;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type qx_Reader_append_input = {
  wiegandFormats?: any;
};

/** input type for inserting array relation for remote table "qx.Reader" */
export type qx_Reader_arr_rel_insert_input = {
  data: Array<qx_Reader_insert_input>;
  /** upsert condition */
  on_conflict?: qx_Reader_on_conflict;
};

/** aggregate avg on columns */
export type qx_Reader_avg_fields = {
  __typename?: 'qx_Reader_avg_fields';
  address?: number;
  doorID?: number;
};

/** order by avg() on columns of table "qx.Reader" */
export type qx_Reader_avg_order_by = {
  address?: order_by;
  doorID?: order_by;
};

/** Boolean expression to filter rows from the table "qx.Reader". All fields are combined with a logical 'AND'. */
export type qx_Reader_bool_exp = {
  DeviceDIOs?: qx_DeviceDIO_bool_exp;
  DeviceDIOs_aggregate?: qx_DeviceDIO_aggregate_bool_exp;
  Door?: qx_Door_bool_exp;
  _and?: Array<qx_Reader_bool_exp>;
  _not?: qx_Reader_bool_exp;
  _or?: Array<qx_Reader_bool_exp>;
  accessInventory?: qx_AccessInventory_bool_exp;
  accessType?: qx_eReaderAccessType_enum_comparison_exp;
  action?: qx_eAccessPointAction_enum_comparison_exp;
  address?: Int_comparison_exp;
  baudrateID?: qx_eBaudrate_enum_comparison_exp;
  device?: qx_Device_bool_exp;
  deviceID?: String_comparison_exp;
  direction?: qx_eAccessPointDirection_enum_comparison_exp;
  doorID?: bigint_comparison_exp;
  eAccessPointAction?: qx_eAccessPointAction_bool_exp;
  eAccessPointDirection?: qx_eAccessPointDirection_bool_exp;
  eAccessPointType?: qx_eAccessPointType_bool_exp;
  eBaudrate?: qx_eBaudrate_bool_exp;
  eKeypadMode?: qx_eKeypadMode_bool_exp;
  eReaderAccessType?: qx_eReaderAccessType_bool_exp;
  eReaderProtocol?: qx_eReaderProtocol_bool_exp;
  eRexState?: qx_eRexState_bool_exp;
  enabled?: Boolean_comparison_exp;
  id?: String_comparison_exp;
  inventoryID?: String_comparison_exp;
  keypadModeID?: qx_eKeypadMode_enum_comparison_exp;
  name?: String_comparison_exp;
  protocol?: qx_eReaderProtocol_enum_comparison_exp;
  refID?: String_comparison_exp;
  rexBypass?: Boolean_comparison_exp;
  rexState?: qx_eRexState_enum_comparison_exp;
  supervise?: String_comparison_exp;
  type?: qx_eAccessPointType_enum_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
  wiegandFormats?: jsonb_comparison_exp;
};

/** unique or primary key constraints on table "qx.Reader" */
export enum qx_Reader_constraint {
  /** unique or primary key constraint on columns "refID", "deviceID" */
  Reader_deviceID_refID_constraint = 'Reader_deviceID_refID_constraint',
  /** unique or primary key constraint on columns "id" */
  Reader_pkey = 'Reader_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type qx_Reader_delete_at_path_input = {
  wiegandFormats?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type qx_Reader_delete_elem_input = {
  wiegandFormats?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type qx_Reader_delete_key_input = {
  wiegandFormats?: string;
};

/** input type for incrementing numeric columns in table "qx.Reader" */
export type qx_Reader_inc_input = {
  address?: number;
  doorID?: string;
};

/** input type for inserting data into table "qx.Reader" */
export type qx_Reader_insert_input = {
  DeviceDIOs?: qx_DeviceDIO_arr_rel_insert_input;
  Door?: qx_Door_obj_rel_insert_input;
  accessInventory?: qx_AccessInventory_obj_rel_insert_input;
  accessType?: qx_eReaderAccessType_enum;
  action?: qx_eAccessPointAction_enum;
  address?: number;
  baudrateID?: qx_eBaudrate_enum;
  device?: qx_Device_obj_rel_insert_input;
  deviceID?: string;
  direction?: qx_eAccessPointDirection_enum;
  doorID?: string;
  eAccessPointAction?: qx_eAccessPointAction_obj_rel_insert_input;
  eAccessPointDirection?: qx_eAccessPointDirection_obj_rel_insert_input;
  eAccessPointType?: qx_eAccessPointType_obj_rel_insert_input;
  eBaudrate?: qx_eBaudrate_obj_rel_insert_input;
  eKeypadMode?: qx_eKeypadMode_obj_rel_insert_input;
  eReaderAccessType?: qx_eReaderAccessType_obj_rel_insert_input;
  eReaderProtocol?: qx_eReaderProtocol_obj_rel_insert_input;
  eRexState?: qx_eRexState_obj_rel_insert_input;
  enabled?: boolean;
  id?: string;
  inventoryID?: string;
  keypadModeID?: qx_eKeypadMode_enum;
  name?: string;
  protocol?: qx_eReaderProtocol_enum;
  refID?: string;
  rexBypass?: boolean;
  rexState?: qx_eRexState_enum;
  type?: qx_eAccessPointType_enum;
  updatedAt?: string;
  wiegandFormats?: any;
};

/** aggregate max on columns */
export type qx_Reader_max_fields = {
  __typename?: 'qx_Reader_max_fields';
  address?: number;
  deviceID?: string;
  doorID?: string;
  id?: string;
  inventoryID?: string;
  name?: string;
  refID?: string;
  /** A computed field, executes function "qx.rex_supervise_value" */
  supervise?: string;
  updatedAt?: string;
};

/** order by max() on columns of table "qx.Reader" */
export type qx_Reader_max_order_by = {
  address?: order_by;
  deviceID?: order_by;
  doorID?: order_by;
  id?: order_by;
  inventoryID?: order_by;
  name?: order_by;
  refID?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type qx_Reader_min_fields = {
  __typename?: 'qx_Reader_min_fields';
  address?: number;
  deviceID?: string;
  doorID?: string;
  id?: string;
  inventoryID?: string;
  name?: string;
  refID?: string;
  /** A computed field, executes function "qx.rex_supervise_value" */
  supervise?: string;
  updatedAt?: string;
};

/** order by min() on columns of table "qx.Reader" */
export type qx_Reader_min_order_by = {
  address?: order_by;
  deviceID?: order_by;
  doorID?: order_by;
  id?: order_by;
  inventoryID?: order_by;
  name?: order_by;
  refID?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.Reader" */
export type qx_Reader_mutation_response = {
  __typename?: 'qx_Reader_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_Reader>;
};

/** input type for inserting object relation for remote table "qx.Reader" */
export type qx_Reader_obj_rel_insert_input = {
  data: qx_Reader_insert_input;
  /** upsert condition */
  on_conflict?: qx_Reader_on_conflict;
};

/** on_conflict condition type for table "qx.Reader" */
export type qx_Reader_on_conflict = {
  constraint: qx_Reader_constraint;
  update_columns?: Array<qx_Reader_update_column>;
  where?: qx_Reader_bool_exp;
};

/** Ordering options when selecting data from "qx.Reader". */
export type qx_Reader_order_by = {
  DeviceDIOs_aggregate?: qx_DeviceDIO_aggregate_order_by;
  Door?: qx_Door_order_by;
  accessInventory?: qx_AccessInventory_order_by;
  accessType?: order_by;
  action?: order_by;
  address?: order_by;
  baudrateID?: order_by;
  device?: qx_Device_order_by;
  deviceID?: order_by;
  direction?: order_by;
  doorID?: order_by;
  eAccessPointAction?: qx_eAccessPointAction_order_by;
  eAccessPointDirection?: qx_eAccessPointDirection_order_by;
  eAccessPointType?: qx_eAccessPointType_order_by;
  eBaudrate?: qx_eBaudrate_order_by;
  eKeypadMode?: qx_eKeypadMode_order_by;
  eReaderAccessType?: qx_eReaderAccessType_order_by;
  eReaderProtocol?: qx_eReaderProtocol_order_by;
  eRexState?: qx_eRexState_order_by;
  enabled?: order_by;
  id?: order_by;
  inventoryID?: order_by;
  keypadModeID?: order_by;
  name?: order_by;
  protocol?: order_by;
  refID?: order_by;
  rexBypass?: order_by;
  rexState?: order_by;
  supervise?: order_by;
  type?: order_by;
  updatedAt?: order_by;
  wiegandFormats?: order_by;
};

/** primary key columns input for table: qx.Reader */
export type qx_Reader_pk_columns_input = {
  id: string;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type qx_Reader_prepend_input = {
  wiegandFormats?: any;
};

/** select columns of table "qx.Reader" */
export enum qx_Reader_select_column {
  /** column name */
  accessType = 'accessType',
  /** column name */
  action = 'action',
  /** column name */
  address = 'address',
  /** column name */
  baudrateID = 'baudrateID',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  direction = 'direction',
  /** column name */
  doorID = 'doorID',
  /** column name */
  enabled = 'enabled',
  /** column name */
  id = 'id',
  /** column name */
  inventoryID = 'inventoryID',
  /** column name */
  keypadModeID = 'keypadModeID',
  /** column name */
  name = 'name',
  /** column name */
  protocol = 'protocol',
  /** column name */
  refID = 'refID',
  /** column name */
  rexBypass = 'rexBypass',
  /** column name */
  rexState = 'rexState',
  /** column name */
  type = 'type',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  wiegandFormats = 'wiegandFormats'
}

/** select "qx_Reader_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.Reader" */
export enum qx_Reader_select_column_qx_Reader_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  enabled = 'enabled',
  /** column name */
  rexBypass = 'rexBypass'
}

/** select "qx_Reader_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.Reader" */
export enum qx_Reader_select_column_qx_Reader_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  enabled = 'enabled',
  /** column name */
  rexBypass = 'rexBypass'
}

/** input type for updating data in table "qx.Reader" */
export type qx_Reader_set_input = {
  accessType?: qx_eReaderAccessType_enum;
  action?: qx_eAccessPointAction_enum;
  address?: number;
  baudrateID?: qx_eBaudrate_enum;
  deviceID?: string;
  direction?: qx_eAccessPointDirection_enum;
  doorID?: string;
  enabled?: boolean;
  id?: string;
  inventoryID?: string;
  keypadModeID?: qx_eKeypadMode_enum;
  name?: string;
  protocol?: qx_eReaderProtocol_enum;
  refID?: string;
  rexBypass?: boolean;
  rexState?: qx_eRexState_enum;
  type?: qx_eAccessPointType_enum;
  updatedAt?: string;
  wiegandFormats?: any;
};

/** aggregate stddev on columns */
export type qx_Reader_stddev_fields = {
  __typename?: 'qx_Reader_stddev_fields';
  address?: number;
  doorID?: number;
};

/** order by stddev() on columns of table "qx.Reader" */
export type qx_Reader_stddev_order_by = {
  address?: order_by;
  doorID?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_Reader_stddev_pop_fields = {
  __typename?: 'qx_Reader_stddev_pop_fields';
  address?: number;
  doorID?: number;
};

/** order by stddev_pop() on columns of table "qx.Reader" */
export type qx_Reader_stddev_pop_order_by = {
  address?: order_by;
  doorID?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_Reader_stddev_samp_fields = {
  __typename?: 'qx_Reader_stddev_samp_fields';
  address?: number;
  doorID?: number;
};

/** order by stddev_samp() on columns of table "qx.Reader" */
export type qx_Reader_stddev_samp_order_by = {
  address?: order_by;
  doorID?: order_by;
};

/** Streaming cursor of the table "qx_Reader" */
export type qx_Reader_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_Reader_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_Reader_stream_cursor_value_input = {
  accessType?: qx_eReaderAccessType_enum;
  action?: qx_eAccessPointAction_enum;
  address?: number;
  baudrateID?: qx_eBaudrate_enum;
  deviceID?: string;
  direction?: qx_eAccessPointDirection_enum;
  doorID?: string;
  enabled?: boolean;
  id?: string;
  inventoryID?: string;
  keypadModeID?: qx_eKeypadMode_enum;
  name?: string;
  protocol?: qx_eReaderProtocol_enum;
  refID?: string;
  rexBypass?: boolean;
  rexState?: qx_eRexState_enum;
  type?: qx_eAccessPointType_enum;
  updatedAt?: string;
  wiegandFormats?: any;
};

/** aggregate sum on columns */
export type qx_Reader_sum_fields = {
  __typename?: 'qx_Reader_sum_fields';
  address?: number;
  doorID?: string;
};

/** order by sum() on columns of table "qx.Reader" */
export type qx_Reader_sum_order_by = {
  address?: order_by;
  doorID?: order_by;
};

/** update columns of table "qx.Reader" */
export enum qx_Reader_update_column {
  /** column name */
  accessType = 'accessType',
  /** column name */
  action = 'action',
  /** column name */
  address = 'address',
  /** column name */
  baudrateID = 'baudrateID',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  direction = 'direction',
  /** column name */
  doorID = 'doorID',
  /** column name */
  enabled = 'enabled',
  /** column name */
  id = 'id',
  /** column name */
  inventoryID = 'inventoryID',
  /** column name */
  keypadModeID = 'keypadModeID',
  /** column name */
  name = 'name',
  /** column name */
  protocol = 'protocol',
  /** column name */
  refID = 'refID',
  /** column name */
  rexBypass = 'rexBypass',
  /** column name */
  rexState = 'rexState',
  /** column name */
  type = 'type',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  wiegandFormats = 'wiegandFormats'
}

export type qx_Reader_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: qx_Reader_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: qx_Reader_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: qx_Reader_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: qx_Reader_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_Reader_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: qx_Reader_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_Reader_set_input;
  /** filter the rows which have to be updated */
  where: qx_Reader_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_Reader_var_pop_fields = {
  __typename?: 'qx_Reader_var_pop_fields';
  address?: number;
  doorID?: number;
};

/** order by var_pop() on columns of table "qx.Reader" */
export type qx_Reader_var_pop_order_by = {
  address?: order_by;
  doorID?: order_by;
};

/** aggregate var_samp on columns */
export type qx_Reader_var_samp_fields = {
  __typename?: 'qx_Reader_var_samp_fields';
  address?: number;
  doorID?: number;
};

/** order by var_samp() on columns of table "qx.Reader" */
export type qx_Reader_var_samp_order_by = {
  address?: order_by;
  doorID?: order_by;
};

/** aggregate variance on columns */
export type qx_Reader_variance_fields = {
  __typename?: 'qx_Reader_variance_fields';
  address?: number;
  doorID?: number;
};

/** order by variance() on columns of table "qx.Reader" */
export type qx_Reader_variance_order_by = {
  address?: order_by;
  doorID?: order_by;
};

/** set of application privileges assigned to a person, controlling which features and data they can access in the app */
export type qx_Role = {
  __typename?: 'qx_Role';
  /** An array relationship */
  RoleAppPrivileges: Array<roleAppPrivileges>;
  /** An aggregate relationship */
  RoleAppPrivileges_aggregate: roleAppPrivileges_aggregate;
  createdAt: string;
  description?: string;
  icon?: string;
  id: string;
  name: string;
  /** An array relationship */
  people: Array<qx_Person>;
  /** An aggregate relationship */
  people_aggregate: qx_Person_aggregate;
  /** An object relationship */
  place: qx_Place;
  placeID: string;
  /** An array relationship */
  toPrivileges: Array<qx__PrivilegeEnumToRole>;
  /** An aggregate relationship */
  toPrivileges_aggregate: qx__PrivilegeEnumToRole_aggregate;
  updatedAt?: string;
};


/** set of application privileges assigned to a person, controlling which features and data they can access in the app */
export type qx_RoleRoleAppPrivilegesArgs = {
  distinct_on?: Array<roleAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<roleAppPrivileges_order_by>;
  where?: roleAppPrivileges_bool_exp;
};


/** set of application privileges assigned to a person, controlling which features and data they can access in the app */
export type qx_RoleRoleAppPrivileges_aggregateArgs = {
  distinct_on?: Array<roleAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<roleAppPrivileges_order_by>;
  where?: roleAppPrivileges_bool_exp;
};


/** set of application privileges assigned to a person, controlling which features and data they can access in the app */
export type qx_RolepeopleArgs = {
  distinct_on?: Array<qx_Person_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Person_order_by>;
  where?: qx_Person_bool_exp;
};


/** set of application privileges assigned to a person, controlling which features and data they can access in the app */
export type qx_Rolepeople_aggregateArgs = {
  distinct_on?: Array<qx_Person_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Person_order_by>;
  where?: qx_Person_bool_exp;
};


/** set of application privileges assigned to a person, controlling which features and data they can access in the app */
export type qx_RoletoPrivilegesArgs = {
  distinct_on?: Array<qx__PrivilegeEnumToRole_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__PrivilegeEnumToRole_order_by>;
  where?: qx__PrivilegeEnumToRole_bool_exp;
};


/** set of application privileges assigned to a person, controlling which features and data they can access in the app */
export type qx_RoletoPrivileges_aggregateArgs = {
  distinct_on?: Array<qx__PrivilegeEnumToRole_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__PrivilegeEnumToRole_order_by>;
  where?: qx__PrivilegeEnumToRole_bool_exp;
};

/** aggregated selection of "qx.Role" */
export type qx_Role_aggregate = {
  __typename?: 'qx_Role_aggregate';
  aggregate?: qx_Role_aggregate_fields;
  nodes: Array<qx_Role>;
};

export type qx_Role_aggregate_bool_exp = {
  count?: qx_Role_aggregate_bool_exp_count;
};

export type qx_Role_aggregate_bool_exp_count = {
  arguments?: Array<qx_Role_select_column>;
  distinct?: boolean;
  filter?: qx_Role_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.Role" */
export type qx_Role_aggregate_fields = {
  __typename?: 'qx_Role_aggregate_fields';
  count: number;
  max?: qx_Role_max_fields;
  min?: qx_Role_min_fields;
};


/** aggregate fields of "qx.Role" */
export type qx_Role_aggregate_fieldscountArgs = {
  columns?: Array<qx_Role_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.Role" */
export type qx_Role_aggregate_order_by = {
  count?: order_by;
  max?: qx_Role_max_order_by;
  min?: qx_Role_min_order_by;
};

/** input type for inserting array relation for remote table "qx.Role" */
export type qx_Role_arr_rel_insert_input = {
  data: Array<qx_Role_insert_input>;
  /** upsert condition */
  on_conflict?: qx_Role_on_conflict;
};

/** Boolean expression to filter rows from the table "qx.Role". All fields are combined with a logical 'AND'. */
export type qx_Role_bool_exp = {
  RoleAppPrivileges?: roleAppPrivileges_bool_exp;
  RoleAppPrivileges_aggregate?: roleAppPrivileges_aggregate_bool_exp;
  _and?: Array<qx_Role_bool_exp>;
  _not?: qx_Role_bool_exp;
  _or?: Array<qx_Role_bool_exp>;
  createdAt?: timestamptz_comparison_exp;
  description?: String_comparison_exp;
  icon?: String_comparison_exp;
  id?: String_comparison_exp;
  name?: String_comparison_exp;
  people?: qx_Person_bool_exp;
  people_aggregate?: qx_Person_aggregate_bool_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
  toPrivileges?: qx__PrivilegeEnumToRole_bool_exp;
  toPrivileges_aggregate?: qx__PrivilegeEnumToRole_aggregate_bool_exp;
  updatedAt?: timestamptz_comparison_exp;
};

/** unique or primary key constraints on table "qx.Role" */
export enum qx_Role_constraint {
  /** unique or primary key constraint on columns "id" */
  Role_pkey = 'Role_pkey'
}

/** input type for inserting data into table "qx.Role" */
export type qx_Role_insert_input = {
  RoleAppPrivileges?: roleAppPrivileges_arr_rel_insert_input;
  createdAt?: string;
  description?: string;
  icon?: string;
  id?: string;
  name?: string;
  people?: qx_Person_arr_rel_insert_input;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
  toPrivileges?: qx__PrivilegeEnumToRole_arr_rel_insert_input;
  updatedAt?: string;
};

/** aggregate max on columns */
export type qx_Role_max_fields = {
  __typename?: 'qx_Role_max_fields';
  createdAt?: string;
  description?: string;
  icon?: string;
  id?: string;
  name?: string;
  placeID?: string;
  updatedAt?: string;
};

/** order by max() on columns of table "qx.Role" */
export type qx_Role_max_order_by = {
  createdAt?: order_by;
  description?: order_by;
  icon?: order_by;
  id?: order_by;
  name?: order_by;
  placeID?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type qx_Role_min_fields = {
  __typename?: 'qx_Role_min_fields';
  createdAt?: string;
  description?: string;
  icon?: string;
  id?: string;
  name?: string;
  placeID?: string;
  updatedAt?: string;
};

/** order by min() on columns of table "qx.Role" */
export type qx_Role_min_order_by = {
  createdAt?: order_by;
  description?: order_by;
  icon?: order_by;
  id?: order_by;
  name?: order_by;
  placeID?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.Role" */
export type qx_Role_mutation_response = {
  __typename?: 'qx_Role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_Role>;
};

/** input type for inserting object relation for remote table "qx.Role" */
export type qx_Role_obj_rel_insert_input = {
  data: qx_Role_insert_input;
  /** upsert condition */
  on_conflict?: qx_Role_on_conflict;
};

/** on_conflict condition type for table "qx.Role" */
export type qx_Role_on_conflict = {
  constraint: qx_Role_constraint;
  update_columns?: Array<qx_Role_update_column>;
  where?: qx_Role_bool_exp;
};

/** Ordering options when selecting data from "qx.Role". */
export type qx_Role_order_by = {
  RoleAppPrivileges_aggregate?: roleAppPrivileges_aggregate_order_by;
  createdAt?: order_by;
  description?: order_by;
  icon?: order_by;
  id?: order_by;
  name?: order_by;
  people_aggregate?: qx_Person_aggregate_order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
  toPrivileges_aggregate?: qx__PrivilegeEnumToRole_aggregate_order_by;
  updatedAt?: order_by;
};

/** primary key columns input for table: qx.Role */
export type qx_Role_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.Role" */
export enum qx_Role_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  description = 'description',
  /** column name */
  icon = 'icon',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "qx.Role" */
export type qx_Role_set_input = {
  createdAt?: string;
  description?: string;
  icon?: string;
  id?: string;
  name?: string;
  placeID?: string;
  updatedAt?: string;
};

/** Streaming cursor of the table "qx_Role" */
export type qx_Role_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_Role_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_Role_stream_cursor_value_input = {
  createdAt?: string;
  description?: string;
  icon?: string;
  id?: string;
  name?: string;
  placeID?: string;
  updatedAt?: string;
};

/** update columns of table "qx.Role" */
export enum qx_Role_update_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  description = 'description',
  /** column name */
  icon = 'icon',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  updatedAt = 'updatedAt'
}

export type qx_Role_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_Role_set_input;
  /** filter the rows which have to be updated */
  where: qx_Role_bool_exp;
};

/** columns and relationships of "qx.RosslareConnection" */
export type qx_RosslareConnection = {
  __typename?: 'qx_RosslareConnection';
  createdAt: string;
  /** An object relationship */
  device: qx_Device;
  deviceID: string;
  gateway: string;
  subnet: string;
  updatedAt?: string;
};

/** aggregated selection of "qx.RosslareConnection" */
export type qx_RosslareConnection_aggregate = {
  __typename?: 'qx_RosslareConnection_aggregate';
  aggregate?: qx_RosslareConnection_aggregate_fields;
  nodes: Array<qx_RosslareConnection>;
};

/** aggregate fields of "qx.RosslareConnection" */
export type qx_RosslareConnection_aggregate_fields = {
  __typename?: 'qx_RosslareConnection_aggregate_fields';
  count: number;
  max?: qx_RosslareConnection_max_fields;
  min?: qx_RosslareConnection_min_fields;
};


/** aggregate fields of "qx.RosslareConnection" */
export type qx_RosslareConnection_aggregate_fieldscountArgs = {
  columns?: Array<qx_RosslareConnection_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.RosslareConnection". All fields are combined with a logical 'AND'. */
export type qx_RosslareConnection_bool_exp = {
  _and?: Array<qx_RosslareConnection_bool_exp>;
  _not?: qx_RosslareConnection_bool_exp;
  _or?: Array<qx_RosslareConnection_bool_exp>;
  createdAt?: timestamptz_comparison_exp;
  device?: qx_Device_bool_exp;
  deviceID?: String_comparison_exp;
  gateway?: String_comparison_exp;
  subnet?: String_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
};

/** unique or primary key constraints on table "qx.RosslareConnection" */
export enum qx_RosslareConnection_constraint {
  /** unique or primary key constraint on columns "deviceID" */
  RosslareConnection_pkey = 'RosslareConnection_pkey'
}

/** input type for inserting data into table "qx.RosslareConnection" */
export type qx_RosslareConnection_insert_input = {
  createdAt?: string;
  device?: qx_Device_obj_rel_insert_input;
  deviceID?: string;
  gateway?: string;
  subnet?: string;
  updatedAt?: string;
};

/** aggregate max on columns */
export type qx_RosslareConnection_max_fields = {
  __typename?: 'qx_RosslareConnection_max_fields';
  createdAt?: string;
  deviceID?: string;
  gateway?: string;
  subnet?: string;
  updatedAt?: string;
};

/** aggregate min on columns */
export type qx_RosslareConnection_min_fields = {
  __typename?: 'qx_RosslareConnection_min_fields';
  createdAt?: string;
  deviceID?: string;
  gateway?: string;
  subnet?: string;
  updatedAt?: string;
};

/** response of any mutation on the table "qx.RosslareConnection" */
export type qx_RosslareConnection_mutation_response = {
  __typename?: 'qx_RosslareConnection_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_RosslareConnection>;
};

/** input type for inserting object relation for remote table "qx.RosslareConnection" */
export type qx_RosslareConnection_obj_rel_insert_input = {
  data: qx_RosslareConnection_insert_input;
  /** upsert condition */
  on_conflict?: qx_RosslareConnection_on_conflict;
};

/** on_conflict condition type for table "qx.RosslareConnection" */
export type qx_RosslareConnection_on_conflict = {
  constraint: qx_RosslareConnection_constraint;
  update_columns?: Array<qx_RosslareConnection_update_column>;
  where?: qx_RosslareConnection_bool_exp;
};

/** Ordering options when selecting data from "qx.RosslareConnection". */
export type qx_RosslareConnection_order_by = {
  createdAt?: order_by;
  device?: qx_Device_order_by;
  deviceID?: order_by;
  gateway?: order_by;
  subnet?: order_by;
  updatedAt?: order_by;
};

/** primary key columns input for table: qx.RosslareConnection */
export type qx_RosslareConnection_pk_columns_input = {
  deviceID: string;
};

/** select columns of table "qx.RosslareConnection" */
export enum qx_RosslareConnection_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  gateway = 'gateway',
  /** column name */
  subnet = 'subnet',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "qx.RosslareConnection" */
export type qx_RosslareConnection_set_input = {
  createdAt?: string;
  deviceID?: string;
  gateway?: string;
  subnet?: string;
  updatedAt?: string;
};

/** Streaming cursor of the table "qx_RosslareConnection" */
export type qx_RosslareConnection_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_RosslareConnection_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_RosslareConnection_stream_cursor_value_input = {
  createdAt?: string;
  deviceID?: string;
  gateway?: string;
  subnet?: string;
  updatedAt?: string;
};

/** update columns of table "qx.RosslareConnection" */
export enum qx_RosslareConnection_update_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  gateway = 'gateway',
  /** column name */
  subnet = 'subnet',
  /** column name */
  updatedAt = 'updatedAt'
}

export type qx_RosslareConnection_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_RosslareConnection_set_input;
  /** filter the rows which have to be updated */
  where: qx_RosslareConnection_bool_exp;
};

/** weekly time schedule composed of schedule blocks, used to restrict access permissions and video recording */
export type qx_Schedule = {
  __typename?: 'qx_Schedule';
  /** An array relationship */
  blocks: Array<qx_ScheduleBlock>;
  /** An aggregate relationship */
  blocks_aggregate: qx_ScheduleBlock_aggregate;
  bucketConfigurationID?: number;
  createdAt: string;
  description?: string;
  /** An array relationship */
  doors: Array<qx_Door>;
  /** An aggregate relationship */
  doors_aggregate: qx_Door_aggregate;
  filepath?: string;
  /** An array relationship */
  flows: Array<qx_Flow>;
  /** An aggregate relationship */
  flows_aggregate: qx_Flow_aggregate;
  /** An array relationship */
  gatewayBandwidthSchedules: Array<qx_GatewayBandwidthSchedule>;
  /** An aggregate relationship */
  gatewayBandwidthSchedules_aggregate: qx_GatewayBandwidthSchedule_aggregate;
  /** A computed field, executes function "qx.schedule_holiday_active" */
  holidayActive?: string;
  id: string;
  /** A computed field, executes function "qx.schedule_is_active" */
  isActive?: boolean;
  name: string;
  /** An array relationship */
  permissions: Array<qx_Permission>;
  /** An aggregate relationship */
  permissions_aggregate: qx_Permission_aggregate;
  /** An object relationship */
  place: qx_Place;
  placeID: string;
  thumbnail?: string;
  updatedAt?: string;
  /** An array relationship */
  videoSources: Array<qx_VideoSource>;
  /** An aggregate relationship */
  videoSources_aggregate: qx_VideoSource_aggregate;
};


/** weekly time schedule composed of schedule blocks, used to restrict access permissions and video recording */
export type qx_ScheduleblocksArgs = {
  distinct_on?: Array<qx_ScheduleBlock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ScheduleBlock_order_by>;
  where?: qx_ScheduleBlock_bool_exp;
};


/** weekly time schedule composed of schedule blocks, used to restrict access permissions and video recording */
export type qx_Scheduleblocks_aggregateArgs = {
  distinct_on?: Array<qx_ScheduleBlock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ScheduleBlock_order_by>;
  where?: qx_ScheduleBlock_bool_exp;
};


/** weekly time schedule composed of schedule blocks, used to restrict access permissions and video recording */
export type qx_ScheduledoorsArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


/** weekly time schedule composed of schedule blocks, used to restrict access permissions and video recording */
export type qx_Scheduledoors_aggregateArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


/** weekly time schedule composed of schedule blocks, used to restrict access permissions and video recording */
export type qx_ScheduleflowsArgs = {
  distinct_on?: Array<qx_Flow_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Flow_order_by>;
  where?: qx_Flow_bool_exp;
};


/** weekly time schedule composed of schedule blocks, used to restrict access permissions and video recording */
export type qx_Scheduleflows_aggregateArgs = {
  distinct_on?: Array<qx_Flow_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Flow_order_by>;
  where?: qx_Flow_bool_exp;
};


/** weekly time schedule composed of schedule blocks, used to restrict access permissions and video recording */
export type qx_SchedulegatewayBandwidthSchedulesArgs = {
  distinct_on?: Array<qx_GatewayBandwidthSchedule_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_GatewayBandwidthSchedule_order_by>;
  where?: qx_GatewayBandwidthSchedule_bool_exp;
};


/** weekly time schedule composed of schedule blocks, used to restrict access permissions and video recording */
export type qx_SchedulegatewayBandwidthSchedules_aggregateArgs = {
  distinct_on?: Array<qx_GatewayBandwidthSchedule_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_GatewayBandwidthSchedule_order_by>;
  where?: qx_GatewayBandwidthSchedule_bool_exp;
};


/** weekly time schedule composed of schedule blocks, used to restrict access permissions and video recording */
export type qx_ScheduleholidayActiveArgs = {
  args?: holidayActive_qx_Schedule_args;
};


/** weekly time schedule composed of schedule blocks, used to restrict access permissions and video recording */
export type qx_ScheduleisActiveArgs = {
  args?: isActive_qx_Schedule_args;
};


/** weekly time schedule composed of schedule blocks, used to restrict access permissions and video recording */
export type qx_SchedulepermissionsArgs = {
  distinct_on?: Array<qx_Permission_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Permission_order_by>;
  where?: qx_Permission_bool_exp;
};


/** weekly time schedule composed of schedule blocks, used to restrict access permissions and video recording */
export type qx_Schedulepermissions_aggregateArgs = {
  distinct_on?: Array<qx_Permission_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Permission_order_by>;
  where?: qx_Permission_bool_exp;
};


/** weekly time schedule composed of schedule blocks, used to restrict access permissions and video recording */
export type qx_SchedulevideoSourcesArgs = {
  distinct_on?: Array<qx_VideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_VideoSource_order_by>;
  where?: qx_VideoSource_bool_exp;
};


/** weekly time schedule composed of schedule blocks, used to restrict access permissions and video recording */
export type qx_SchedulevideoSources_aggregateArgs = {
  distinct_on?: Array<qx_VideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_VideoSource_order_by>;
  where?: qx_VideoSource_bool_exp;
};

/** a single time window within a schedule, defined by day of week, start time, and end time */
export type qx_ScheduleBlock = {
  __typename?: 'qx_ScheduleBlock';
  date: string;
  duration: string;
  id: string;
  /** An object relationship */
  schedule: qx_Schedule;
  scheduleID: string;
  /** An array relationship */
  toHolidaySets: Array<qx__HolidaySetToScheduleBlock>;
  /** An aggregate relationship */
  toHolidaySets_aggregate: qx__HolidaySetToScheduleBlock_aggregate;
  updatedAt?: string;
  weekdays?: string;
};


/** a single time window within a schedule, defined by day of week, start time, and end time */
export type qx_ScheduleBlocktoHolidaySetsArgs = {
  distinct_on?: Array<qx__HolidaySetToScheduleBlock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__HolidaySetToScheduleBlock_order_by>;
  where?: qx__HolidaySetToScheduleBlock_bool_exp;
};


/** a single time window within a schedule, defined by day of week, start time, and end time */
export type qx_ScheduleBlocktoHolidaySets_aggregateArgs = {
  distinct_on?: Array<qx__HolidaySetToScheduleBlock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__HolidaySetToScheduleBlock_order_by>;
  where?: qx__HolidaySetToScheduleBlock_bool_exp;
};

/** aggregated selection of "qx.ScheduleBlock" */
export type qx_ScheduleBlock_aggregate = {
  __typename?: 'qx_ScheduleBlock_aggregate';
  aggregate?: qx_ScheduleBlock_aggregate_fields;
  nodes: Array<qx_ScheduleBlock>;
};

export type qx_ScheduleBlock_aggregate_bool_exp = {
  count?: qx_ScheduleBlock_aggregate_bool_exp_count;
};

export type qx_ScheduleBlock_aggregate_bool_exp_count = {
  arguments?: Array<qx_ScheduleBlock_select_column>;
  distinct?: boolean;
  filter?: qx_ScheduleBlock_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.ScheduleBlock" */
export type qx_ScheduleBlock_aggregate_fields = {
  __typename?: 'qx_ScheduleBlock_aggregate_fields';
  count: number;
  max?: qx_ScheduleBlock_max_fields;
  min?: qx_ScheduleBlock_min_fields;
};


/** aggregate fields of "qx.ScheduleBlock" */
export type qx_ScheduleBlock_aggregate_fieldscountArgs = {
  columns?: Array<qx_ScheduleBlock_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.ScheduleBlock" */
export type qx_ScheduleBlock_aggregate_order_by = {
  count?: order_by;
  max?: qx_ScheduleBlock_max_order_by;
  min?: qx_ScheduleBlock_min_order_by;
};

/** input type for inserting array relation for remote table "qx.ScheduleBlock" */
export type qx_ScheduleBlock_arr_rel_insert_input = {
  data: Array<qx_ScheduleBlock_insert_input>;
  /** upsert condition */
  on_conflict?: qx_ScheduleBlock_on_conflict;
};

/** Boolean expression to filter rows from the table "qx.ScheduleBlock". All fields are combined with a logical 'AND'. */
export type qx_ScheduleBlock_bool_exp = {
  _and?: Array<qx_ScheduleBlock_bool_exp>;
  _not?: qx_ScheduleBlock_bool_exp;
  _or?: Array<qx_ScheduleBlock_bool_exp>;
  date?: timestamp_comparison_exp;
  duration?: String_comparison_exp;
  id?: String_comparison_exp;
  schedule?: qx_Schedule_bool_exp;
  scheduleID?: String_comparison_exp;
  toHolidaySets?: qx__HolidaySetToScheduleBlock_bool_exp;
  toHolidaySets_aggregate?: qx__HolidaySetToScheduleBlock_aggregate_bool_exp;
  updatedAt?: timestamptz_comparison_exp;
  weekdays?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.ScheduleBlock" */
export enum qx_ScheduleBlock_constraint {
  /** unique or primary key constraint on columns "id" */
  ScheduleBlock_pkey = 'ScheduleBlock_pkey'
}

/** input type for inserting data into table "qx.ScheduleBlock" */
export type qx_ScheduleBlock_insert_input = {
  date?: string;
  duration?: string;
  id?: string;
  schedule?: qx_Schedule_obj_rel_insert_input;
  scheduleID?: string;
  toHolidaySets?: qx__HolidaySetToScheduleBlock_arr_rel_insert_input;
  updatedAt?: string;
  weekdays?: string;
};

/** aggregate max on columns */
export type qx_ScheduleBlock_max_fields = {
  __typename?: 'qx_ScheduleBlock_max_fields';
  date?: string;
  duration?: string;
  id?: string;
  scheduleID?: string;
  updatedAt?: string;
  weekdays?: string;
};

/** order by max() on columns of table "qx.ScheduleBlock" */
export type qx_ScheduleBlock_max_order_by = {
  date?: order_by;
  duration?: order_by;
  id?: order_by;
  scheduleID?: order_by;
  updatedAt?: order_by;
  weekdays?: order_by;
};

/** aggregate min on columns */
export type qx_ScheduleBlock_min_fields = {
  __typename?: 'qx_ScheduleBlock_min_fields';
  date?: string;
  duration?: string;
  id?: string;
  scheduleID?: string;
  updatedAt?: string;
  weekdays?: string;
};

/** order by min() on columns of table "qx.ScheduleBlock" */
export type qx_ScheduleBlock_min_order_by = {
  date?: order_by;
  duration?: order_by;
  id?: order_by;
  scheduleID?: order_by;
  updatedAt?: order_by;
  weekdays?: order_by;
};

/** response of any mutation on the table "qx.ScheduleBlock" */
export type qx_ScheduleBlock_mutation_response = {
  __typename?: 'qx_ScheduleBlock_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_ScheduleBlock>;
};

/** input type for inserting object relation for remote table "qx.ScheduleBlock" */
export type qx_ScheduleBlock_obj_rel_insert_input = {
  data: qx_ScheduleBlock_insert_input;
  /** upsert condition */
  on_conflict?: qx_ScheduleBlock_on_conflict;
};

/** on_conflict condition type for table "qx.ScheduleBlock" */
export type qx_ScheduleBlock_on_conflict = {
  constraint: qx_ScheduleBlock_constraint;
  update_columns?: Array<qx_ScheduleBlock_update_column>;
  where?: qx_ScheduleBlock_bool_exp;
};

/** Ordering options when selecting data from "qx.ScheduleBlock". */
export type qx_ScheduleBlock_order_by = {
  date?: order_by;
  duration?: order_by;
  id?: order_by;
  schedule?: qx_Schedule_order_by;
  scheduleID?: order_by;
  toHolidaySets_aggregate?: qx__HolidaySetToScheduleBlock_aggregate_order_by;
  updatedAt?: order_by;
  weekdays?: order_by;
};

/** primary key columns input for table: qx.ScheduleBlock */
export type qx_ScheduleBlock_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.ScheduleBlock" */
export enum qx_ScheduleBlock_select_column {
  /** column name */
  date = 'date',
  /** column name */
  duration = 'duration',
  /** column name */
  id = 'id',
  /** column name */
  scheduleID = 'scheduleID',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  weekdays = 'weekdays'
}

/** input type for updating data in table "qx.ScheduleBlock" */
export type qx_ScheduleBlock_set_input = {
  date?: string;
  duration?: string;
  id?: string;
  scheduleID?: string;
  updatedAt?: string;
  weekdays?: string;
};

/** Streaming cursor of the table "qx_ScheduleBlock" */
export type qx_ScheduleBlock_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_ScheduleBlock_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_ScheduleBlock_stream_cursor_value_input = {
  date?: string;
  duration?: string;
  id?: string;
  scheduleID?: string;
  updatedAt?: string;
  weekdays?: string;
};

/** update columns of table "qx.ScheduleBlock" */
export enum qx_ScheduleBlock_update_column {
  /** column name */
  date = 'date',
  /** column name */
  duration = 'duration',
  /** column name */
  id = 'id',
  /** column name */
  scheduleID = 'scheduleID',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  weekdays = 'weekdays'
}

export type qx_ScheduleBlock_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_ScheduleBlock_set_input;
  /** filter the rows which have to be updated */
  where: qx_ScheduleBlock_bool_exp;
};

/** aggregated selection of "qx.Schedule" */
export type qx_Schedule_aggregate = {
  __typename?: 'qx_Schedule_aggregate';
  aggregate?: qx_Schedule_aggregate_fields;
  nodes: Array<qx_Schedule>;
};

export type qx_Schedule_aggregate_bool_exp = {
  count?: qx_Schedule_aggregate_bool_exp_count;
};

export type qx_Schedule_aggregate_bool_exp_count = {
  arguments?: Array<qx_Schedule_select_column>;
  distinct?: boolean;
  filter?: qx_Schedule_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.Schedule" */
export type qx_Schedule_aggregate_fields = {
  __typename?: 'qx_Schedule_aggregate_fields';
  avg?: qx_Schedule_avg_fields;
  count: number;
  max?: qx_Schedule_max_fields;
  min?: qx_Schedule_min_fields;
  stddev?: qx_Schedule_stddev_fields;
  stddev_pop?: qx_Schedule_stddev_pop_fields;
  stddev_samp?: qx_Schedule_stddev_samp_fields;
  sum?: qx_Schedule_sum_fields;
  var_pop?: qx_Schedule_var_pop_fields;
  var_samp?: qx_Schedule_var_samp_fields;
  variance?: qx_Schedule_variance_fields;
};


/** aggregate fields of "qx.Schedule" */
export type qx_Schedule_aggregate_fieldscountArgs = {
  columns?: Array<qx_Schedule_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.Schedule" */
export type qx_Schedule_aggregate_order_by = {
  avg?: qx_Schedule_avg_order_by;
  count?: order_by;
  max?: qx_Schedule_max_order_by;
  min?: qx_Schedule_min_order_by;
  stddev?: qx_Schedule_stddev_order_by;
  stddev_pop?: qx_Schedule_stddev_pop_order_by;
  stddev_samp?: qx_Schedule_stddev_samp_order_by;
  sum?: qx_Schedule_sum_order_by;
  var_pop?: qx_Schedule_var_pop_order_by;
  var_samp?: qx_Schedule_var_samp_order_by;
  variance?: qx_Schedule_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.Schedule" */
export type qx_Schedule_arr_rel_insert_input = {
  data: Array<qx_Schedule_insert_input>;
  /** upsert condition */
  on_conflict?: qx_Schedule_on_conflict;
};

/** aggregate avg on columns */
export type qx_Schedule_avg_fields = {
  __typename?: 'qx_Schedule_avg_fields';
  bucketConfigurationID?: number;
};

/** order by avg() on columns of table "qx.Schedule" */
export type qx_Schedule_avg_order_by = {
  bucketConfigurationID?: order_by;
};

/** Boolean expression to filter rows from the table "qx.Schedule". All fields are combined with a logical 'AND'. */
export type qx_Schedule_bool_exp = {
  _and?: Array<qx_Schedule_bool_exp>;
  _not?: qx_Schedule_bool_exp;
  _or?: Array<qx_Schedule_bool_exp>;
  blocks?: qx_ScheduleBlock_bool_exp;
  blocks_aggregate?: qx_ScheduleBlock_aggregate_bool_exp;
  bucketConfigurationID?: Int_comparison_exp;
  createdAt?: timestamptz_comparison_exp;
  description?: String_comparison_exp;
  doors?: qx_Door_bool_exp;
  doors_aggregate?: qx_Door_aggregate_bool_exp;
  filepath?: String_comparison_exp;
  flows?: qx_Flow_bool_exp;
  flows_aggregate?: qx_Flow_aggregate_bool_exp;
  gatewayBandwidthSchedules?: qx_GatewayBandwidthSchedule_bool_exp;
  gatewayBandwidthSchedules_aggregate?: qx_GatewayBandwidthSchedule_aggregate_bool_exp;
  id?: String_comparison_exp;
  name?: String_comparison_exp;
  permissions?: qx_Permission_bool_exp;
  permissions_aggregate?: qx_Permission_aggregate_bool_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
  thumbnail?: String_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
  videoSources?: qx_VideoSource_bool_exp;
  videoSources_aggregate?: qx_VideoSource_aggregate_bool_exp;
};

/** unique or primary key constraints on table "qx.Schedule" */
export enum qx_Schedule_constraint {
  /** unique or primary key constraint on columns "id" */
  Schedule_pkey = 'Schedule_pkey'
}

/** input type for incrementing numeric columns in table "qx.Schedule" */
export type qx_Schedule_inc_input = {
  bucketConfigurationID?: number;
};

/** input type for inserting data into table "qx.Schedule" */
export type qx_Schedule_insert_input = {
  blocks?: qx_ScheduleBlock_arr_rel_insert_input;
  bucketConfigurationID?: number;
  createdAt?: string;
  description?: string;
  doors?: qx_Door_arr_rel_insert_input;
  filepath?: string;
  flows?: qx_Flow_arr_rel_insert_input;
  gatewayBandwidthSchedules?: qx_GatewayBandwidthSchedule_arr_rel_insert_input;
  id?: string;
  name?: string;
  permissions?: qx_Permission_arr_rel_insert_input;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
  updatedAt?: string;
  videoSources?: qx_VideoSource_arr_rel_insert_input;
};

/** aggregate max on columns */
export type qx_Schedule_max_fields = {
  __typename?: 'qx_Schedule_max_fields';
  bucketConfigurationID?: number;
  createdAt?: string;
  description?: string;
  filepath?: string;
  /** A computed field, executes function "qx.schedule_holiday_active" */
  holidayActive?: string;
  id?: string;
  name?: string;
  placeID?: string;
  thumbnail?: string;
  updatedAt?: string;
};


/** aggregate max on columns */
export type qx_Schedule_max_fieldsholidayActiveArgs = {
  args?: holidayActive_qx_Schedule_args;
};

/** order by max() on columns of table "qx.Schedule" */
export type qx_Schedule_max_order_by = {
  bucketConfigurationID?: order_by;
  createdAt?: order_by;
  description?: order_by;
  filepath?: order_by;
  id?: order_by;
  name?: order_by;
  placeID?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type qx_Schedule_min_fields = {
  __typename?: 'qx_Schedule_min_fields';
  bucketConfigurationID?: number;
  createdAt?: string;
  description?: string;
  filepath?: string;
  /** A computed field, executes function "qx.schedule_holiday_active" */
  holidayActive?: string;
  id?: string;
  name?: string;
  placeID?: string;
  thumbnail?: string;
  updatedAt?: string;
};


/** aggregate min on columns */
export type qx_Schedule_min_fieldsholidayActiveArgs = {
  args?: holidayActive_qx_Schedule_args;
};

/** order by min() on columns of table "qx.Schedule" */
export type qx_Schedule_min_order_by = {
  bucketConfigurationID?: order_by;
  createdAt?: order_by;
  description?: order_by;
  filepath?: order_by;
  id?: order_by;
  name?: order_by;
  placeID?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.Schedule" */
export type qx_Schedule_mutation_response = {
  __typename?: 'qx_Schedule_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_Schedule>;
};

/** input type for inserting object relation for remote table "qx.Schedule" */
export type qx_Schedule_obj_rel_insert_input = {
  data: qx_Schedule_insert_input;
  /** upsert condition */
  on_conflict?: qx_Schedule_on_conflict;
};

/** on_conflict condition type for table "qx.Schedule" */
export type qx_Schedule_on_conflict = {
  constraint: qx_Schedule_constraint;
  update_columns?: Array<qx_Schedule_update_column>;
  where?: qx_Schedule_bool_exp;
};

/** Ordering options when selecting data from "qx.Schedule". */
export type qx_Schedule_order_by = {
  blocks_aggregate?: qx_ScheduleBlock_aggregate_order_by;
  bucketConfigurationID?: order_by;
  createdAt?: order_by;
  description?: order_by;
  doors_aggregate?: qx_Door_aggregate_order_by;
  filepath?: order_by;
  flows_aggregate?: qx_Flow_aggregate_order_by;
  gatewayBandwidthSchedules_aggregate?: qx_GatewayBandwidthSchedule_aggregate_order_by;
  id?: order_by;
  name?: order_by;
  permissions_aggregate?: qx_Permission_aggregate_order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
  thumbnail?: order_by;
  updatedAt?: order_by;
  videoSources_aggregate?: qx_VideoSource_aggregate_order_by;
};

/** primary key columns input for table: qx.Schedule */
export type qx_Schedule_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.Schedule" */
export enum qx_Schedule_select_column {
  /** column name */
  bucketConfigurationID = 'bucketConfigurationID',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  description = 'description',
  /** column name */
  filepath = 'filepath',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "qx.Schedule" */
export type qx_Schedule_set_input = {
  bucketConfigurationID?: number;
  createdAt?: string;
  description?: string;
  filepath?: string;
  id?: string;
  name?: string;
  placeID?: string;
  updatedAt?: string;
};

/** aggregate stddev on columns */
export type qx_Schedule_stddev_fields = {
  __typename?: 'qx_Schedule_stddev_fields';
  bucketConfigurationID?: number;
};

/** order by stddev() on columns of table "qx.Schedule" */
export type qx_Schedule_stddev_order_by = {
  bucketConfigurationID?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_Schedule_stddev_pop_fields = {
  __typename?: 'qx_Schedule_stddev_pop_fields';
  bucketConfigurationID?: number;
};

/** order by stddev_pop() on columns of table "qx.Schedule" */
export type qx_Schedule_stddev_pop_order_by = {
  bucketConfigurationID?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_Schedule_stddev_samp_fields = {
  __typename?: 'qx_Schedule_stddev_samp_fields';
  bucketConfigurationID?: number;
};

/** order by stddev_samp() on columns of table "qx.Schedule" */
export type qx_Schedule_stddev_samp_order_by = {
  bucketConfigurationID?: order_by;
};

/** Streaming cursor of the table "qx_Schedule" */
export type qx_Schedule_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_Schedule_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_Schedule_stream_cursor_value_input = {
  bucketConfigurationID?: number;
  createdAt?: string;
  description?: string;
  filepath?: string;
  id?: string;
  name?: string;
  placeID?: string;
  updatedAt?: string;
};

/** aggregate sum on columns */
export type qx_Schedule_sum_fields = {
  __typename?: 'qx_Schedule_sum_fields';
  bucketConfigurationID?: number;
};

/** order by sum() on columns of table "qx.Schedule" */
export type qx_Schedule_sum_order_by = {
  bucketConfigurationID?: order_by;
};

/** update columns of table "qx.Schedule" */
export enum qx_Schedule_update_column {
  /** column name */
  bucketConfigurationID = 'bucketConfigurationID',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  description = 'description',
  /** column name */
  filepath = 'filepath',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  updatedAt = 'updatedAt'
}

export type qx_Schedule_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_Schedule_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_Schedule_set_input;
  /** filter the rows which have to be updated */
  where: qx_Schedule_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_Schedule_var_pop_fields = {
  __typename?: 'qx_Schedule_var_pop_fields';
  bucketConfigurationID?: number;
};

/** order by var_pop() on columns of table "qx.Schedule" */
export type qx_Schedule_var_pop_order_by = {
  bucketConfigurationID?: order_by;
};

/** aggregate var_samp on columns */
export type qx_Schedule_var_samp_fields = {
  __typename?: 'qx_Schedule_var_samp_fields';
  bucketConfigurationID?: number;
};

/** order by var_samp() on columns of table "qx.Schedule" */
export type qx_Schedule_var_samp_order_by = {
  bucketConfigurationID?: order_by;
};

/** aggregate variance on columns */
export type qx_Schedule_variance_fields = {
  __typename?: 'qx_Schedule_variance_fields';
  bucketConfigurationID?: number;
};

/** order by variance() on columns of table "qx.Schedule" */
export type qx_Schedule_variance_order_by = {
  bucketConfigurationID?: order_by;
};

/** columns and relationships of "qx.Segment" */
export type qx_Segment = {
  __typename?: 'qx_Segment';
  bucketConfigurationID?: number;
  drive?: number;
  duration: number;
  expiration?: string;
  id: string;
  /** An object relationship */
  mediaProfile?: qx_MediaProfile;
  mediaProfileID?: string;
  offset: string;
  partialPath?: string;
  path?: string;
  priority: number;
  signedUrl?: string;
  size: number;
  time: string;
};

/** aggregated selection of "qx.Segment" */
export type qx_Segment_aggregate = {
  __typename?: 'qx_Segment_aggregate';
  aggregate?: qx_Segment_aggregate_fields;
  nodes: Array<qx_Segment>;
};

export type qx_Segment_aggregate_bool_exp = {
  count?: qx_Segment_aggregate_bool_exp_count;
};

export type qx_Segment_aggregate_bool_exp_count = {
  arguments?: Array<qx_Segment_select_column>;
  distinct?: boolean;
  filter?: qx_Segment_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.Segment" */
export type qx_Segment_aggregate_fields = {
  __typename?: 'qx_Segment_aggregate_fields';
  avg?: qx_Segment_avg_fields;
  count: number;
  max?: qx_Segment_max_fields;
  min?: qx_Segment_min_fields;
  stddev?: qx_Segment_stddev_fields;
  stddev_pop?: qx_Segment_stddev_pop_fields;
  stddev_samp?: qx_Segment_stddev_samp_fields;
  sum?: qx_Segment_sum_fields;
  var_pop?: qx_Segment_var_pop_fields;
  var_samp?: qx_Segment_var_samp_fields;
  variance?: qx_Segment_variance_fields;
};


/** aggregate fields of "qx.Segment" */
export type qx_Segment_aggregate_fieldscountArgs = {
  columns?: Array<qx_Segment_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.Segment" */
export type qx_Segment_aggregate_order_by = {
  avg?: qx_Segment_avg_order_by;
  count?: order_by;
  max?: qx_Segment_max_order_by;
  min?: qx_Segment_min_order_by;
  stddev?: qx_Segment_stddev_order_by;
  stddev_pop?: qx_Segment_stddev_pop_order_by;
  stddev_samp?: qx_Segment_stddev_samp_order_by;
  sum?: qx_Segment_sum_order_by;
  var_pop?: qx_Segment_var_pop_order_by;
  var_samp?: qx_Segment_var_samp_order_by;
  variance?: qx_Segment_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.Segment" */
export type qx_Segment_arr_rel_insert_input = {
  data: Array<qx_Segment_insert_input>;
  /** upsert condition */
  on_conflict?: qx_Segment_on_conflict;
};

/** aggregate avg on columns */
export type qx_Segment_avg_fields = {
  __typename?: 'qx_Segment_avg_fields';
  bucketConfigurationID?: number;
  drive?: number;
  duration?: number;
  id?: number;
  mediaProfileID?: number;
  offset?: number;
  priority?: number;
  size?: number;
};

/** order by avg() on columns of table "qx.Segment" */
export type qx_Segment_avg_order_by = {
  bucketConfigurationID?: order_by;
  drive?: order_by;
  duration?: order_by;
  id?: order_by;
  mediaProfileID?: order_by;
  offset?: order_by;
  priority?: order_by;
  size?: order_by;
};

/** Boolean expression to filter rows from the table "qx.Segment". All fields are combined with a logical 'AND'. */
export type qx_Segment_bool_exp = {
  _and?: Array<qx_Segment_bool_exp>;
  _not?: qx_Segment_bool_exp;
  _or?: Array<qx_Segment_bool_exp>;
  bucketConfigurationID?: Int_comparison_exp;
  drive?: Int_comparison_exp;
  duration?: Float_comparison_exp;
  expiration?: timestamptz_comparison_exp;
  id?: bigint_comparison_exp;
  mediaProfile?: qx_MediaProfile_bool_exp;
  mediaProfileID?: bigint_comparison_exp;
  offset?: bigint_comparison_exp;
  partialPath?: String_comparison_exp;
  path?: String_comparison_exp;
  priority?: Int_comparison_exp;
  signedUrl?: String_comparison_exp;
  size?: Int_comparison_exp;
  time?: timestamptz_comparison_exp;
};

/** unique or primary key constraints on table "qx.Segment" */
export enum qx_Segment_constraint {
  /** unique or primary key constraint on columns "id" */
  Segment_pkey = 'Segment_pkey'
}

/** input type for incrementing numeric columns in table "qx.Segment" */
export type qx_Segment_inc_input = {
  bucketConfigurationID?: number;
  drive?: number;
  duration?: number;
  id?: string;
  mediaProfileID?: string;
  offset?: string;
  priority?: number;
  size?: number;
};

/** input type for inserting data into table "qx.Segment" */
export type qx_Segment_insert_input = {
  bucketConfigurationID?: number;
  drive?: number;
  duration?: number;
  expiration?: string;
  id?: string;
  mediaProfile?: qx_MediaProfile_obj_rel_insert_input;
  mediaProfileID?: string;
  offset?: string;
  partialPath?: string;
  priority?: number;
  size?: number;
  time?: string;
};

/** aggregate max on columns */
export type qx_Segment_max_fields = {
  __typename?: 'qx_Segment_max_fields';
  bucketConfigurationID?: number;
  drive?: number;
  duration?: number;
  expiration?: string;
  id?: string;
  mediaProfileID?: string;
  offset?: string;
  partialPath?: string;
  path?: string;
  priority?: number;
  signedUrl?: string;
  size?: number;
  time?: string;
};

/** order by max() on columns of table "qx.Segment" */
export type qx_Segment_max_order_by = {
  bucketConfigurationID?: order_by;
  drive?: order_by;
  duration?: order_by;
  expiration?: order_by;
  id?: order_by;
  mediaProfileID?: order_by;
  offset?: order_by;
  partialPath?: order_by;
  priority?: order_by;
  size?: order_by;
  time?: order_by;
};

/** aggregate min on columns */
export type qx_Segment_min_fields = {
  __typename?: 'qx_Segment_min_fields';
  bucketConfigurationID?: number;
  drive?: number;
  duration?: number;
  expiration?: string;
  id?: string;
  mediaProfileID?: string;
  offset?: string;
  partialPath?: string;
  path?: string;
  priority?: number;
  signedUrl?: string;
  size?: number;
  time?: string;
};

/** order by min() on columns of table "qx.Segment" */
export type qx_Segment_min_order_by = {
  bucketConfigurationID?: order_by;
  drive?: order_by;
  duration?: order_by;
  expiration?: order_by;
  id?: order_by;
  mediaProfileID?: order_by;
  offset?: order_by;
  partialPath?: order_by;
  priority?: order_by;
  size?: order_by;
  time?: order_by;
};

/** response of any mutation on the table "qx.Segment" */
export type qx_Segment_mutation_response = {
  __typename?: 'qx_Segment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_Segment>;
};

/** on_conflict condition type for table "qx.Segment" */
export type qx_Segment_on_conflict = {
  constraint: qx_Segment_constraint;
  update_columns?: Array<qx_Segment_update_column>;
  where?: qx_Segment_bool_exp;
};

/** Ordering options when selecting data from "qx.Segment". */
export type qx_Segment_order_by = {
  bucketConfigurationID?: order_by;
  drive?: order_by;
  duration?: order_by;
  expiration?: order_by;
  id?: order_by;
  mediaProfile?: qx_MediaProfile_order_by;
  mediaProfileID?: order_by;
  offset?: order_by;
  partialPath?: order_by;
  path?: order_by;
  priority?: order_by;
  signedUrl?: order_by;
  size?: order_by;
  time?: order_by;
};

/** primary key columns input for table: qx.Segment */
export type qx_Segment_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.Segment" */
export enum qx_Segment_select_column {
  /** column name */
  bucketConfigurationID = 'bucketConfigurationID',
  /** column name */
  drive = 'drive',
  /** column name */
  duration = 'duration',
  /** column name */
  expiration = 'expiration',
  /** column name */
  id = 'id',
  /** column name */
  mediaProfileID = 'mediaProfileID',
  /** column name */
  offset = 'offset',
  /** column name */
  partialPath = 'partialPath',
  /** column name */
  priority = 'priority',
  /** column name */
  size = 'size',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "qx.Segment" */
export type qx_Segment_set_input = {
  bucketConfigurationID?: number;
  drive?: number;
  duration?: number;
  expiration?: string;
  id?: string;
  mediaProfileID?: string;
  offset?: string;
  partialPath?: string;
  priority?: number;
  size?: number;
  time?: string;
};

/** aggregate stddev on columns */
export type qx_Segment_stddev_fields = {
  __typename?: 'qx_Segment_stddev_fields';
  bucketConfigurationID?: number;
  drive?: number;
  duration?: number;
  id?: number;
  mediaProfileID?: number;
  offset?: number;
  priority?: number;
  size?: number;
};

/** order by stddev() on columns of table "qx.Segment" */
export type qx_Segment_stddev_order_by = {
  bucketConfigurationID?: order_by;
  drive?: order_by;
  duration?: order_by;
  id?: order_by;
  mediaProfileID?: order_by;
  offset?: order_by;
  priority?: order_by;
  size?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_Segment_stddev_pop_fields = {
  __typename?: 'qx_Segment_stddev_pop_fields';
  bucketConfigurationID?: number;
  drive?: number;
  duration?: number;
  id?: number;
  mediaProfileID?: number;
  offset?: number;
  priority?: number;
  size?: number;
};

/** order by stddev_pop() on columns of table "qx.Segment" */
export type qx_Segment_stddev_pop_order_by = {
  bucketConfigurationID?: order_by;
  drive?: order_by;
  duration?: order_by;
  id?: order_by;
  mediaProfileID?: order_by;
  offset?: order_by;
  priority?: order_by;
  size?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_Segment_stddev_samp_fields = {
  __typename?: 'qx_Segment_stddev_samp_fields';
  bucketConfigurationID?: number;
  drive?: number;
  duration?: number;
  id?: number;
  mediaProfileID?: number;
  offset?: number;
  priority?: number;
  size?: number;
};

/** order by stddev_samp() on columns of table "qx.Segment" */
export type qx_Segment_stddev_samp_order_by = {
  bucketConfigurationID?: order_by;
  drive?: order_by;
  duration?: order_by;
  id?: order_by;
  mediaProfileID?: order_by;
  offset?: order_by;
  priority?: order_by;
  size?: order_by;
};

/** Streaming cursor of the table "qx_Segment" */
export type qx_Segment_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_Segment_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_Segment_stream_cursor_value_input = {
  bucketConfigurationID?: number;
  drive?: number;
  duration?: number;
  expiration?: string;
  id?: string;
  mediaProfileID?: string;
  offset?: string;
  partialPath?: string;
  priority?: number;
  size?: number;
  time?: string;
};

/** aggregate sum on columns */
export type qx_Segment_sum_fields = {
  __typename?: 'qx_Segment_sum_fields';
  bucketConfigurationID?: number;
  drive?: number;
  duration?: number;
  id?: string;
  mediaProfileID?: string;
  offset?: string;
  priority?: number;
  size?: number;
};

/** order by sum() on columns of table "qx.Segment" */
export type qx_Segment_sum_order_by = {
  bucketConfigurationID?: order_by;
  drive?: order_by;
  duration?: order_by;
  id?: order_by;
  mediaProfileID?: order_by;
  offset?: order_by;
  priority?: order_by;
  size?: order_by;
};

/** update columns of table "qx.Segment" */
export enum qx_Segment_update_column {
  /** column name */
  bucketConfigurationID = 'bucketConfigurationID',
  /** column name */
  drive = 'drive',
  /** column name */
  duration = 'duration',
  /** column name */
  expiration = 'expiration',
  /** column name */
  id = 'id',
  /** column name */
  mediaProfileID = 'mediaProfileID',
  /** column name */
  offset = 'offset',
  /** column name */
  partialPath = 'partialPath',
  /** column name */
  priority = 'priority',
  /** column name */
  size = 'size',
  /** column name */
  time = 'time'
}

export type qx_Segment_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_Segment_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_Segment_set_input;
  /** filter the rows which have to be updated */
  where: qx_Segment_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_Segment_var_pop_fields = {
  __typename?: 'qx_Segment_var_pop_fields';
  bucketConfigurationID?: number;
  drive?: number;
  duration?: number;
  id?: number;
  mediaProfileID?: number;
  offset?: number;
  priority?: number;
  size?: number;
};

/** order by var_pop() on columns of table "qx.Segment" */
export type qx_Segment_var_pop_order_by = {
  bucketConfigurationID?: order_by;
  drive?: order_by;
  duration?: order_by;
  id?: order_by;
  mediaProfileID?: order_by;
  offset?: order_by;
  priority?: order_by;
  size?: order_by;
};

/** aggregate var_samp on columns */
export type qx_Segment_var_samp_fields = {
  __typename?: 'qx_Segment_var_samp_fields';
  bucketConfigurationID?: number;
  drive?: number;
  duration?: number;
  id?: number;
  mediaProfileID?: number;
  offset?: number;
  priority?: number;
  size?: number;
};

/** order by var_samp() on columns of table "qx.Segment" */
export type qx_Segment_var_samp_order_by = {
  bucketConfigurationID?: order_by;
  drive?: order_by;
  duration?: order_by;
  id?: order_by;
  mediaProfileID?: order_by;
  offset?: order_by;
  priority?: order_by;
  size?: order_by;
};

/** aggregate variance on columns */
export type qx_Segment_variance_fields = {
  __typename?: 'qx_Segment_variance_fields';
  bucketConfigurationID?: number;
  drive?: number;
  duration?: number;
  id?: number;
  mediaProfileID?: number;
  offset?: number;
  priority?: number;
  size?: number;
};

/** order by variance() on columns of table "qx.Segment" */
export type qx_Segment_variance_order_by = {
  bucketConfigurationID?: order_by;
  drive?: order_by;
  duration?: order_by;
  id?: order_by;
  mediaProfileID?: order_by;
  offset?: order_by;
  priority?: order_by;
  size?: order_by;
};

/** environmental or intrusion sensor (motion, temperature, smoke) connected to the system */
export type qx_Sensor = {
  __typename?: 'qx_Sensor';
  batteryLevel: qx_eBatteryLevel_enum;
  connectionStatus: qx_eDeviceConnectionStatus_enum;
  createdAt?: string;
  defaultVideoSourceID?: string;
  description?: string;
  /** An object relationship */
  device: qx_Device;
  /** A computed field, executes function "qx.get_sensor_device_connectionStatus" */
  deviceConnectionStatus?: string;
  deviceID: string;
  disabledByLicense: boolean;
  /** An object relationship */
  eBatteryLevel: qx_eBatteryLevel;
  /** An object relationship */
  eDIOState: qx_eDIOState;
  /** An object relationship */
  eDeviceConnectionStatus: qx_eDeviceConnectionStatus;
  /** An object relationship */
  eSensorType: qx_eSensorType;
  enabled: boolean;
  /** A computed field, executes function "qx.get_sensor_device_gateway_connectionStatus" */
  gatewayConnectionStatus?: boolean;
  id: string;
  name: string;
  /** An object relationship */
  place: qx_Place;
  placeID: string;
  searchText?: string;
  serial: string;
  state: qx_eDIOState_enum;
  type: qx_eSensorType_enum;
  updatedAt?: string;
  /** An object relationship */
  videoSource?: qx_VideoSource;
};

/** aggregated selection of "qx.Sensor" */
export type qx_Sensor_aggregate = {
  __typename?: 'qx_Sensor_aggregate';
  aggregate?: qx_Sensor_aggregate_fields;
  nodes: Array<qx_Sensor>;
};

export type qx_Sensor_aggregate_bool_exp = {
  bool_and?: qx_Sensor_aggregate_bool_exp_bool_and;
  bool_or?: qx_Sensor_aggregate_bool_exp_bool_or;
  count?: qx_Sensor_aggregate_bool_exp_count;
};

export type qx_Sensor_aggregate_bool_exp_bool_and = {
  arguments: qx_Sensor_select_column_qx_Sensor_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: qx_Sensor_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_Sensor_aggregate_bool_exp_bool_or = {
  arguments: qx_Sensor_select_column_qx_Sensor_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: qx_Sensor_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_Sensor_aggregate_bool_exp_count = {
  arguments?: Array<qx_Sensor_select_column>;
  distinct?: boolean;
  filter?: qx_Sensor_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.Sensor" */
export type qx_Sensor_aggregate_fields = {
  __typename?: 'qx_Sensor_aggregate_fields';
  avg?: qx_Sensor_avg_fields;
  count: number;
  max?: qx_Sensor_max_fields;
  min?: qx_Sensor_min_fields;
  stddev?: qx_Sensor_stddev_fields;
  stddev_pop?: qx_Sensor_stddev_pop_fields;
  stddev_samp?: qx_Sensor_stddev_samp_fields;
  sum?: qx_Sensor_sum_fields;
  var_pop?: qx_Sensor_var_pop_fields;
  var_samp?: qx_Sensor_var_samp_fields;
  variance?: qx_Sensor_variance_fields;
};


/** aggregate fields of "qx.Sensor" */
export type qx_Sensor_aggregate_fieldscountArgs = {
  columns?: Array<qx_Sensor_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.Sensor" */
export type qx_Sensor_aggregate_order_by = {
  avg?: qx_Sensor_avg_order_by;
  count?: order_by;
  max?: qx_Sensor_max_order_by;
  min?: qx_Sensor_min_order_by;
  stddev?: qx_Sensor_stddev_order_by;
  stddev_pop?: qx_Sensor_stddev_pop_order_by;
  stddev_samp?: qx_Sensor_stddev_samp_order_by;
  sum?: qx_Sensor_sum_order_by;
  var_pop?: qx_Sensor_var_pop_order_by;
  var_samp?: qx_Sensor_var_samp_order_by;
  variance?: qx_Sensor_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.Sensor" */
export type qx_Sensor_arr_rel_insert_input = {
  data: Array<qx_Sensor_insert_input>;
  /** upsert condition */
  on_conflict?: qx_Sensor_on_conflict;
};

/** aggregate avg on columns */
export type qx_Sensor_avg_fields = {
  __typename?: 'qx_Sensor_avg_fields';
  defaultVideoSourceID?: number;
  id?: number;
};

/** order by avg() on columns of table "qx.Sensor" */
export type qx_Sensor_avg_order_by = {
  defaultVideoSourceID?: order_by;
  id?: order_by;
};

/** Boolean expression to filter rows from the table "qx.Sensor". All fields are combined with a logical 'AND'. */
export type qx_Sensor_bool_exp = {
  _and?: Array<qx_Sensor_bool_exp>;
  _not?: qx_Sensor_bool_exp;
  _or?: Array<qx_Sensor_bool_exp>;
  batteryLevel?: qx_eBatteryLevel_enum_comparison_exp;
  connectionStatus?: qx_eDeviceConnectionStatus_enum_comparison_exp;
  createdAt?: timestamptz_comparison_exp;
  defaultVideoSourceID?: bigint_comparison_exp;
  description?: String_comparison_exp;
  device?: qx_Device_bool_exp;
  deviceConnectionStatus?: String_comparison_exp;
  deviceID?: String_comparison_exp;
  disabledByLicense?: Boolean_comparison_exp;
  eBatteryLevel?: qx_eBatteryLevel_bool_exp;
  eDIOState?: qx_eDIOState_bool_exp;
  eDeviceConnectionStatus?: qx_eDeviceConnectionStatus_bool_exp;
  eSensorType?: qx_eSensorType_bool_exp;
  enabled?: Boolean_comparison_exp;
  gatewayConnectionStatus?: Boolean_comparison_exp;
  id?: bigint_comparison_exp;
  name?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
  searchText?: String_comparison_exp;
  serial?: String_comparison_exp;
  state?: qx_eDIOState_enum_comparison_exp;
  type?: qx_eSensorType_enum_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
  videoSource?: qx_VideoSource_bool_exp;
};

/** unique or primary key constraints on table "qx.Sensor" */
export enum qx_Sensor_constraint {
  /** unique or primary key constraint on columns "serial", "deviceID" */
  Sensor_deviceID_serial_constraint = 'Sensor_deviceID_serial_constraint',
  /** unique or primary key constraint on columns "id" */
  Sensor_pkey = 'Sensor_pkey'
}

/** input type for incrementing numeric columns in table "qx.Sensor" */
export type qx_Sensor_inc_input = {
  defaultVideoSourceID?: string;
  id?: string;
};

/** input type for inserting data into table "qx.Sensor" */
export type qx_Sensor_insert_input = {
  batteryLevel?: qx_eBatteryLevel_enum;
  connectionStatus?: qx_eDeviceConnectionStatus_enum;
  createdAt?: string;
  defaultVideoSourceID?: string;
  description?: string;
  device?: qx_Device_obj_rel_insert_input;
  deviceID?: string;
  disabledByLicense?: boolean;
  eBatteryLevel?: qx_eBatteryLevel_obj_rel_insert_input;
  eDIOState?: qx_eDIOState_obj_rel_insert_input;
  eDeviceConnectionStatus?: qx_eDeviceConnectionStatus_obj_rel_insert_input;
  eSensorType?: qx_eSensorType_obj_rel_insert_input;
  enabled?: boolean;
  id?: string;
  name?: string;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
  searchText?: string;
  serial?: string;
  state?: qx_eDIOState_enum;
  type?: qx_eSensorType_enum;
  updatedAt?: string;
  videoSource?: qx_VideoSource_obj_rel_insert_input;
};

/** aggregate max on columns */
export type qx_Sensor_max_fields = {
  __typename?: 'qx_Sensor_max_fields';
  createdAt?: string;
  defaultVideoSourceID?: string;
  description?: string;
  /** A computed field, executes function "qx.get_sensor_device_connectionStatus" */
  deviceConnectionStatus?: string;
  deviceID?: string;
  id?: string;
  name?: string;
  placeID?: string;
  searchText?: string;
  serial?: string;
  updatedAt?: string;
};

/** order by max() on columns of table "qx.Sensor" */
export type qx_Sensor_max_order_by = {
  createdAt?: order_by;
  defaultVideoSourceID?: order_by;
  description?: order_by;
  deviceID?: order_by;
  id?: order_by;
  name?: order_by;
  placeID?: order_by;
  searchText?: order_by;
  serial?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type qx_Sensor_min_fields = {
  __typename?: 'qx_Sensor_min_fields';
  createdAt?: string;
  defaultVideoSourceID?: string;
  description?: string;
  /** A computed field, executes function "qx.get_sensor_device_connectionStatus" */
  deviceConnectionStatus?: string;
  deviceID?: string;
  id?: string;
  name?: string;
  placeID?: string;
  searchText?: string;
  serial?: string;
  updatedAt?: string;
};

/** order by min() on columns of table "qx.Sensor" */
export type qx_Sensor_min_order_by = {
  createdAt?: order_by;
  defaultVideoSourceID?: order_by;
  description?: order_by;
  deviceID?: order_by;
  id?: order_by;
  name?: order_by;
  placeID?: order_by;
  searchText?: order_by;
  serial?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.Sensor" */
export type qx_Sensor_mutation_response = {
  __typename?: 'qx_Sensor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_Sensor>;
};

/** input type for inserting object relation for remote table "qx.Sensor" */
export type qx_Sensor_obj_rel_insert_input = {
  data: qx_Sensor_insert_input;
  /** upsert condition */
  on_conflict?: qx_Sensor_on_conflict;
};

/** on_conflict condition type for table "qx.Sensor" */
export type qx_Sensor_on_conflict = {
  constraint: qx_Sensor_constraint;
  update_columns?: Array<qx_Sensor_update_column>;
  where?: qx_Sensor_bool_exp;
};

/** Ordering options when selecting data from "qx.Sensor". */
export type qx_Sensor_order_by = {
  batteryLevel?: order_by;
  connectionStatus?: order_by;
  createdAt?: order_by;
  defaultVideoSourceID?: order_by;
  description?: order_by;
  device?: qx_Device_order_by;
  deviceConnectionStatus?: order_by;
  deviceID?: order_by;
  disabledByLicense?: order_by;
  eBatteryLevel?: qx_eBatteryLevel_order_by;
  eDIOState?: qx_eDIOState_order_by;
  eDeviceConnectionStatus?: qx_eDeviceConnectionStatus_order_by;
  eSensorType?: qx_eSensorType_order_by;
  enabled?: order_by;
  gatewayConnectionStatus?: order_by;
  id?: order_by;
  name?: order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
  searchText?: order_by;
  serial?: order_by;
  state?: order_by;
  type?: order_by;
  updatedAt?: order_by;
  videoSource?: qx_VideoSource_order_by;
};

/** primary key columns input for table: qx.Sensor */
export type qx_Sensor_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.Sensor" */
export enum qx_Sensor_select_column {
  /** column name */
  batteryLevel = 'batteryLevel',
  /** column name */
  connectionStatus = 'connectionStatus',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  defaultVideoSourceID = 'defaultVideoSourceID',
  /** column name */
  description = 'description',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  disabledByLicense = 'disabledByLicense',
  /** column name */
  enabled = 'enabled',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  searchText = 'searchText',
  /** column name */
  serial = 'serial',
  /** column name */
  state = 'state',
  /** column name */
  type = 'type',
  /** column name */
  updatedAt = 'updatedAt'
}

/** select "qx_Sensor_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.Sensor" */
export enum qx_Sensor_select_column_qx_Sensor_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  disabledByLicense = 'disabledByLicense',
  /** column name */
  enabled = 'enabled'
}

/** select "qx_Sensor_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.Sensor" */
export enum qx_Sensor_select_column_qx_Sensor_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  disabledByLicense = 'disabledByLicense',
  /** column name */
  enabled = 'enabled'
}

/** input type for updating data in table "qx.Sensor" */
export type qx_Sensor_set_input = {
  batteryLevel?: qx_eBatteryLevel_enum;
  connectionStatus?: qx_eDeviceConnectionStatus_enum;
  createdAt?: string;
  defaultVideoSourceID?: string;
  description?: string;
  deviceID?: string;
  disabledByLicense?: boolean;
  enabled?: boolean;
  id?: string;
  name?: string;
  placeID?: string;
  searchText?: string;
  serial?: string;
  state?: qx_eDIOState_enum;
  type?: qx_eSensorType_enum;
  updatedAt?: string;
};

/** aggregate stddev on columns */
export type qx_Sensor_stddev_fields = {
  __typename?: 'qx_Sensor_stddev_fields';
  defaultVideoSourceID?: number;
  id?: number;
};

/** order by stddev() on columns of table "qx.Sensor" */
export type qx_Sensor_stddev_order_by = {
  defaultVideoSourceID?: order_by;
  id?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_Sensor_stddev_pop_fields = {
  __typename?: 'qx_Sensor_stddev_pop_fields';
  defaultVideoSourceID?: number;
  id?: number;
};

/** order by stddev_pop() on columns of table "qx.Sensor" */
export type qx_Sensor_stddev_pop_order_by = {
  defaultVideoSourceID?: order_by;
  id?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_Sensor_stddev_samp_fields = {
  __typename?: 'qx_Sensor_stddev_samp_fields';
  defaultVideoSourceID?: number;
  id?: number;
};

/** order by stddev_samp() on columns of table "qx.Sensor" */
export type qx_Sensor_stddev_samp_order_by = {
  defaultVideoSourceID?: order_by;
  id?: order_by;
};

/** Streaming cursor of the table "qx_Sensor" */
export type qx_Sensor_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_Sensor_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_Sensor_stream_cursor_value_input = {
  batteryLevel?: qx_eBatteryLevel_enum;
  connectionStatus?: qx_eDeviceConnectionStatus_enum;
  createdAt?: string;
  defaultVideoSourceID?: string;
  description?: string;
  deviceID?: string;
  disabledByLicense?: boolean;
  enabled?: boolean;
  id?: string;
  name?: string;
  placeID?: string;
  searchText?: string;
  serial?: string;
  state?: qx_eDIOState_enum;
  type?: qx_eSensorType_enum;
  updatedAt?: string;
};

/** aggregate sum on columns */
export type qx_Sensor_sum_fields = {
  __typename?: 'qx_Sensor_sum_fields';
  defaultVideoSourceID?: string;
  id?: string;
};

/** order by sum() on columns of table "qx.Sensor" */
export type qx_Sensor_sum_order_by = {
  defaultVideoSourceID?: order_by;
  id?: order_by;
};

/** update columns of table "qx.Sensor" */
export enum qx_Sensor_update_column {
  /** column name */
  batteryLevel = 'batteryLevel',
  /** column name */
  connectionStatus = 'connectionStatus',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  defaultVideoSourceID = 'defaultVideoSourceID',
  /** column name */
  description = 'description',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  disabledByLicense = 'disabledByLicense',
  /** column name */
  enabled = 'enabled',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  searchText = 'searchText',
  /** column name */
  serial = 'serial',
  /** column name */
  state = 'state',
  /** column name */
  type = 'type',
  /** column name */
  updatedAt = 'updatedAt'
}

export type qx_Sensor_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_Sensor_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_Sensor_set_input;
  /** filter the rows which have to be updated */
  where: qx_Sensor_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_Sensor_var_pop_fields = {
  __typename?: 'qx_Sensor_var_pop_fields';
  defaultVideoSourceID?: number;
  id?: number;
};

/** order by var_pop() on columns of table "qx.Sensor" */
export type qx_Sensor_var_pop_order_by = {
  defaultVideoSourceID?: order_by;
  id?: order_by;
};

/** aggregate var_samp on columns */
export type qx_Sensor_var_samp_fields = {
  __typename?: 'qx_Sensor_var_samp_fields';
  defaultVideoSourceID?: number;
  id?: number;
};

/** order by var_samp() on columns of table "qx.Sensor" */
export type qx_Sensor_var_samp_order_by = {
  defaultVideoSourceID?: order_by;
  id?: order_by;
};

/** aggregate variance on columns */
export type qx_Sensor_variance_fields = {
  __typename?: 'qx_Sensor_variance_fields';
  defaultVideoSourceID?: number;
  id?: number;
};

/** order by variance() on columns of table "qx.Sensor" */
export type qx_Sensor_variance_order_by = {
  defaultVideoSourceID?: order_by;
  id?: order_by;
};

/** columns and relationships of "qx.SharedLinkAuditLog" */
export type qx_SharedLinkAuditLog = {
  __typename?: 'qx_SharedLinkAuditLog';
  action?: string;
  alternateID?: string;
  auditableID?: string;
  auditableType?: string;
  changes?: any;
  createdAt?: string;
  id?: string;
  /** An object relationship */
  person?: qx_Person;
  personID?: string;
  /** An object relationship */
  place?: qx_Place;
  placeID?: string;
};


/** columns and relationships of "qx.SharedLinkAuditLog" */
export type qx_SharedLinkAuditLogchangesArgs = {
  path?: string;
};

/** aggregated selection of "qx.SharedLinkAuditLog" */
export type qx_SharedLinkAuditLog_aggregate = {
  __typename?: 'qx_SharedLinkAuditLog_aggregate';
  aggregate?: qx_SharedLinkAuditLog_aggregate_fields;
  nodes: Array<qx_SharedLinkAuditLog>;
};

export type qx_SharedLinkAuditLog_aggregate_bool_exp = {
  count?: qx_SharedLinkAuditLog_aggregate_bool_exp_count;
};

export type qx_SharedLinkAuditLog_aggregate_bool_exp_count = {
  arguments?: Array<qx_SharedLinkAuditLog_select_column>;
  distinct?: boolean;
  filter?: qx_SharedLinkAuditLog_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.SharedLinkAuditLog" */
export type qx_SharedLinkAuditLog_aggregate_fields = {
  __typename?: 'qx_SharedLinkAuditLog_aggregate_fields';
  avg?: qx_SharedLinkAuditLog_avg_fields;
  count: number;
  max?: qx_SharedLinkAuditLog_max_fields;
  min?: qx_SharedLinkAuditLog_min_fields;
  stddev?: qx_SharedLinkAuditLog_stddev_fields;
  stddev_pop?: qx_SharedLinkAuditLog_stddev_pop_fields;
  stddev_samp?: qx_SharedLinkAuditLog_stddev_samp_fields;
  sum?: qx_SharedLinkAuditLog_sum_fields;
  var_pop?: qx_SharedLinkAuditLog_var_pop_fields;
  var_samp?: qx_SharedLinkAuditLog_var_samp_fields;
  variance?: qx_SharedLinkAuditLog_variance_fields;
};


/** aggregate fields of "qx.SharedLinkAuditLog" */
export type qx_SharedLinkAuditLog_aggregate_fieldscountArgs = {
  columns?: Array<qx_SharedLinkAuditLog_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.SharedLinkAuditLog" */
export type qx_SharedLinkAuditLog_aggregate_order_by = {
  avg?: qx_SharedLinkAuditLog_avg_order_by;
  count?: order_by;
  max?: qx_SharedLinkAuditLog_max_order_by;
  min?: qx_SharedLinkAuditLog_min_order_by;
  stddev?: qx_SharedLinkAuditLog_stddev_order_by;
  stddev_pop?: qx_SharedLinkAuditLog_stddev_pop_order_by;
  stddev_samp?: qx_SharedLinkAuditLog_stddev_samp_order_by;
  sum?: qx_SharedLinkAuditLog_sum_order_by;
  var_pop?: qx_SharedLinkAuditLog_var_pop_order_by;
  var_samp?: qx_SharedLinkAuditLog_var_samp_order_by;
  variance?: qx_SharedLinkAuditLog_variance_order_by;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type qx_SharedLinkAuditLog_append_input = {
  changes?: any;
};

/** input type for inserting array relation for remote table "qx.SharedLinkAuditLog" */
export type qx_SharedLinkAuditLog_arr_rel_insert_input = {
  data: Array<qx_SharedLinkAuditLog_insert_input>;
};

/** aggregate avg on columns */
export type qx_SharedLinkAuditLog_avg_fields = {
  __typename?: 'qx_SharedLinkAuditLog_avg_fields';
  auditableID?: number;
};

/** order by avg() on columns of table "qx.SharedLinkAuditLog" */
export type qx_SharedLinkAuditLog_avg_order_by = {
  auditableID?: order_by;
};

/** Boolean expression to filter rows from the table "qx.SharedLinkAuditLog". All fields are combined with a logical 'AND'. */
export type qx_SharedLinkAuditLog_bool_exp = {
  _and?: Array<qx_SharedLinkAuditLog_bool_exp>;
  _not?: qx_SharedLinkAuditLog_bool_exp;
  _or?: Array<qx_SharedLinkAuditLog_bool_exp>;
  action?: String_comparison_exp;
  alternateID?: String_comparison_exp;
  auditableID?: bigint_comparison_exp;
  auditableType?: String_comparison_exp;
  changes?: jsonb_comparison_exp;
  createdAt?: timestamptz_comparison_exp;
  id?: String_comparison_exp;
  person?: qx_Person_bool_exp;
  personID?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type qx_SharedLinkAuditLog_delete_at_path_input = {
  changes?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type qx_SharedLinkAuditLog_delete_elem_input = {
  changes?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type qx_SharedLinkAuditLog_delete_key_input = {
  changes?: string;
};

/** input type for incrementing numeric columns in table "qx.SharedLinkAuditLog" */
export type qx_SharedLinkAuditLog_inc_input = {
  auditableID?: string;
};

/** input type for inserting data into table "qx.SharedLinkAuditLog" */
export type qx_SharedLinkAuditLog_insert_input = {
  action?: string;
  alternateID?: string;
  auditableID?: string;
  auditableType?: string;
  changes?: any;
  createdAt?: string;
  id?: string;
  person?: qx_Person_obj_rel_insert_input;
  personID?: string;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
};

/** aggregate max on columns */
export type qx_SharedLinkAuditLog_max_fields = {
  __typename?: 'qx_SharedLinkAuditLog_max_fields';
  action?: string;
  alternateID?: string;
  auditableID?: string;
  auditableType?: string;
  createdAt?: string;
  id?: string;
  personID?: string;
  placeID?: string;
};

/** order by max() on columns of table "qx.SharedLinkAuditLog" */
export type qx_SharedLinkAuditLog_max_order_by = {
  action?: order_by;
  alternateID?: order_by;
  auditableID?: order_by;
  auditableType?: order_by;
  createdAt?: order_by;
  id?: order_by;
  personID?: order_by;
  placeID?: order_by;
};

/** aggregate min on columns */
export type qx_SharedLinkAuditLog_min_fields = {
  __typename?: 'qx_SharedLinkAuditLog_min_fields';
  action?: string;
  alternateID?: string;
  auditableID?: string;
  auditableType?: string;
  createdAt?: string;
  id?: string;
  personID?: string;
  placeID?: string;
};

/** order by min() on columns of table "qx.SharedLinkAuditLog" */
export type qx_SharedLinkAuditLog_min_order_by = {
  action?: order_by;
  alternateID?: order_by;
  auditableID?: order_by;
  auditableType?: order_by;
  createdAt?: order_by;
  id?: order_by;
  personID?: order_by;
  placeID?: order_by;
};

/** response of any mutation on the table "qx.SharedLinkAuditLog" */
export type qx_SharedLinkAuditLog_mutation_response = {
  __typename?: 'qx_SharedLinkAuditLog_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_SharedLinkAuditLog>;
};

/** Ordering options when selecting data from "qx.SharedLinkAuditLog". */
export type qx_SharedLinkAuditLog_order_by = {
  action?: order_by;
  alternateID?: order_by;
  auditableID?: order_by;
  auditableType?: order_by;
  changes?: order_by;
  createdAt?: order_by;
  id?: order_by;
  person?: qx_Person_order_by;
  personID?: order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type qx_SharedLinkAuditLog_prepend_input = {
  changes?: any;
};

/** select columns of table "qx.SharedLinkAuditLog" */
export enum qx_SharedLinkAuditLog_select_column {
  /** column name */
  action = 'action',
  /** column name */
  alternateID = 'alternateID',
  /** column name */
  auditableID = 'auditableID',
  /** column name */
  auditableType = 'auditableType',
  /** column name */
  changes = 'changes',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  personID = 'personID',
  /** column name */
  placeID = 'placeID'
}

/** input type for updating data in table "qx.SharedLinkAuditLog" */
export type qx_SharedLinkAuditLog_set_input = {
  action?: string;
  alternateID?: string;
  auditableID?: string;
  auditableType?: string;
  changes?: any;
  createdAt?: string;
  id?: string;
  personID?: string;
  placeID?: string;
};

/** aggregate stddev on columns */
export type qx_SharedLinkAuditLog_stddev_fields = {
  __typename?: 'qx_SharedLinkAuditLog_stddev_fields';
  auditableID?: number;
};

/** order by stddev() on columns of table "qx.SharedLinkAuditLog" */
export type qx_SharedLinkAuditLog_stddev_order_by = {
  auditableID?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_SharedLinkAuditLog_stddev_pop_fields = {
  __typename?: 'qx_SharedLinkAuditLog_stddev_pop_fields';
  auditableID?: number;
};

/** order by stddev_pop() on columns of table "qx.SharedLinkAuditLog" */
export type qx_SharedLinkAuditLog_stddev_pop_order_by = {
  auditableID?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_SharedLinkAuditLog_stddev_samp_fields = {
  __typename?: 'qx_SharedLinkAuditLog_stddev_samp_fields';
  auditableID?: number;
};

/** order by stddev_samp() on columns of table "qx.SharedLinkAuditLog" */
export type qx_SharedLinkAuditLog_stddev_samp_order_by = {
  auditableID?: order_by;
};

/** Streaming cursor of the table "qx_SharedLinkAuditLog" */
export type qx_SharedLinkAuditLog_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_SharedLinkAuditLog_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_SharedLinkAuditLog_stream_cursor_value_input = {
  action?: string;
  alternateID?: string;
  auditableID?: string;
  auditableType?: string;
  changes?: any;
  createdAt?: string;
  id?: string;
  personID?: string;
  placeID?: string;
};

/** aggregate sum on columns */
export type qx_SharedLinkAuditLog_sum_fields = {
  __typename?: 'qx_SharedLinkAuditLog_sum_fields';
  auditableID?: string;
};

/** order by sum() on columns of table "qx.SharedLinkAuditLog" */
export type qx_SharedLinkAuditLog_sum_order_by = {
  auditableID?: order_by;
};

export type qx_SharedLinkAuditLog_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: qx_SharedLinkAuditLog_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: qx_SharedLinkAuditLog_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: qx_SharedLinkAuditLog_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: qx_SharedLinkAuditLog_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_SharedLinkAuditLog_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: qx_SharedLinkAuditLog_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_SharedLinkAuditLog_set_input;
  /** filter the rows which have to be updated */
  where: qx_SharedLinkAuditLog_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_SharedLinkAuditLog_var_pop_fields = {
  __typename?: 'qx_SharedLinkAuditLog_var_pop_fields';
  auditableID?: number;
};

/** order by var_pop() on columns of table "qx.SharedLinkAuditLog" */
export type qx_SharedLinkAuditLog_var_pop_order_by = {
  auditableID?: order_by;
};

/** aggregate var_samp on columns */
export type qx_SharedLinkAuditLog_var_samp_fields = {
  __typename?: 'qx_SharedLinkAuditLog_var_samp_fields';
  auditableID?: number;
};

/** order by var_samp() on columns of table "qx.SharedLinkAuditLog" */
export type qx_SharedLinkAuditLog_var_samp_order_by = {
  auditableID?: order_by;
};

/** aggregate variance on columns */
export type qx_SharedLinkAuditLog_variance_fields = {
  __typename?: 'qx_SharedLinkAuditLog_variance_fields';
  auditableID?: number;
};

/** order by variance() on columns of table "qx.SharedLinkAuditLog" */
export type qx_SharedLinkAuditLog_variance_order_by = {
  auditableID?: order_by;
};

/** columns and relationships of "qx.SharedLinkType" */
export type qx_SharedLinkType = {
  __typename?: 'qx_SharedLinkType';
  /** An array relationship */
  SharedLinks: Array<qx_SharedLinks>;
  /** An aggregate relationship */
  SharedLinks_aggregate: qx_SharedLinks_aggregate;
  comment?: string;
  value: string;
};


/** columns and relationships of "qx.SharedLinkType" */
export type qx_SharedLinkTypeSharedLinksArgs = {
  distinct_on?: Array<qx_SharedLinks_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_SharedLinks_order_by>;
  where?: qx_SharedLinks_bool_exp;
};


/** columns and relationships of "qx.SharedLinkType" */
export type qx_SharedLinkTypeSharedLinks_aggregateArgs = {
  distinct_on?: Array<qx_SharedLinks_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_SharedLinks_order_by>;
  where?: qx_SharedLinks_bool_exp;
};

/** aggregated selection of "qx.SharedLinkType" */
export type qx_SharedLinkType_aggregate = {
  __typename?: 'qx_SharedLinkType_aggregate';
  aggregate?: qx_SharedLinkType_aggregate_fields;
  nodes: Array<qx_SharedLinkType>;
};

/** aggregate fields of "qx.SharedLinkType" */
export type qx_SharedLinkType_aggregate_fields = {
  __typename?: 'qx_SharedLinkType_aggregate_fields';
  count: number;
  max?: qx_SharedLinkType_max_fields;
  min?: qx_SharedLinkType_min_fields;
};


/** aggregate fields of "qx.SharedLinkType" */
export type qx_SharedLinkType_aggregate_fieldscountArgs = {
  columns?: Array<qx_SharedLinkType_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.SharedLinkType". All fields are combined with a logical 'AND'. */
export type qx_SharedLinkType_bool_exp = {
  SharedLinks?: qx_SharedLinks_bool_exp;
  SharedLinks_aggregate?: qx_SharedLinks_aggregate_bool_exp;
  _and?: Array<qx_SharedLinkType_bool_exp>;
  _not?: qx_SharedLinkType_bool_exp;
  _or?: Array<qx_SharedLinkType_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.SharedLinkType" */
export enum qx_SharedLinkType_constraint {
  /** unique or primary key constraint on columns "value" */
  SharedLinkType_pkey = 'SharedLinkType_pkey'
}

export enum qx_SharedLinkType_enum {
  /** Clips */
  Clip = 'Clip'
}

/** Boolean expression to compare columns of type "qx_SharedLinkType_enum". All fields are combined with logical 'AND'. */
export type qx_SharedLinkType_enum_comparison_exp = {
  _eq?: qx_SharedLinkType_enum;
  _in?: Array<qx_SharedLinkType_enum>;
  _is_null?: boolean;
  _neq?: qx_SharedLinkType_enum;
  _nin?: Array<qx_SharedLinkType_enum>;
};

/** input type for inserting data into table "qx.SharedLinkType" */
export type qx_SharedLinkType_insert_input = {
  SharedLinks?: qx_SharedLinks_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_SharedLinkType_max_fields = {
  __typename?: 'qx_SharedLinkType_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_SharedLinkType_min_fields = {
  __typename?: 'qx_SharedLinkType_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.SharedLinkType" */
export type qx_SharedLinkType_mutation_response = {
  __typename?: 'qx_SharedLinkType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_SharedLinkType>;
};

/** input type for inserting object relation for remote table "qx.SharedLinkType" */
export type qx_SharedLinkType_obj_rel_insert_input = {
  data: qx_SharedLinkType_insert_input;
  /** upsert condition */
  on_conflict?: qx_SharedLinkType_on_conflict;
};

/** on_conflict condition type for table "qx.SharedLinkType" */
export type qx_SharedLinkType_on_conflict = {
  constraint: qx_SharedLinkType_constraint;
  update_columns?: Array<qx_SharedLinkType_update_column>;
  where?: qx_SharedLinkType_bool_exp;
};

/** Ordering options when selecting data from "qx.SharedLinkType". */
export type qx_SharedLinkType_order_by = {
  SharedLinks_aggregate?: qx_SharedLinks_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.SharedLinkType */
export type qx_SharedLinkType_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.SharedLinkType" */
export enum qx_SharedLinkType_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.SharedLinkType" */
export type qx_SharedLinkType_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_SharedLinkType" */
export type qx_SharedLinkType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_SharedLinkType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_SharedLinkType_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.SharedLinkType" */
export enum qx_SharedLinkType_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_SharedLinkType_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_SharedLinkType_set_input;
  /** filter the rows which have to be updated */
  where: qx_SharedLinkType_bool_exp;
};

/** columns and relationships of "qx.SharedLinks" */
export type qx_SharedLinks = {
  __typename?: 'qx_SharedLinks';
  /** An object relationship */
  SharedLinkType: qx_SharedLinkType;
  /** An array relationship */
  auditLog: Array<qx_SharedLinkAuditLog>;
  /** An aggregate relationship */
  auditLog_aggregate: qx_SharedLinkAuditLog_aggregate;
  /** An object relationship */
  clip?: qx_Clip;
  createdAt?: string;
  /** An object relationship */
  createdBy?: qx_Person;
  deletedAt?: string;
  emails?: Array<string>;
  expiresAt?: string;
  id: string;
  linkableID: string;
  linkableType: qx_SharedLinkType_enum;
  ownerID: string;
  persons?: Array<string>;
  /** An object relationship */
  place?: qx_Place;
  placeID: string;
  searchText?: string;
  singleUse?: boolean;
  updatedAt?: string;
  url?: string;
  uses?: number;
};


/** columns and relationships of "qx.SharedLinks" */
export type qx_SharedLinksauditLogArgs = {
  distinct_on?: Array<qx_SharedLinkAuditLog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_SharedLinkAuditLog_order_by>;
  where?: qx_SharedLinkAuditLog_bool_exp;
};


/** columns and relationships of "qx.SharedLinks" */
export type qx_SharedLinksauditLog_aggregateArgs = {
  distinct_on?: Array<qx_SharedLinkAuditLog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_SharedLinkAuditLog_order_by>;
  where?: qx_SharedLinkAuditLog_bool_exp;
};

/** aggregated selection of "qx.SharedLinks" */
export type qx_SharedLinks_aggregate = {
  __typename?: 'qx_SharedLinks_aggregate';
  aggregate?: qx_SharedLinks_aggregate_fields;
  nodes: Array<qx_SharedLinks>;
};

export type qx_SharedLinks_aggregate_bool_exp = {
  bool_and?: qx_SharedLinks_aggregate_bool_exp_bool_and;
  bool_or?: qx_SharedLinks_aggregate_bool_exp_bool_or;
  count?: qx_SharedLinks_aggregate_bool_exp_count;
};

export type qx_SharedLinks_aggregate_bool_exp_bool_and = {
  arguments: qx_SharedLinks_select_column_qx_SharedLinks_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: qx_SharedLinks_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_SharedLinks_aggregate_bool_exp_bool_or = {
  arguments: qx_SharedLinks_select_column_qx_SharedLinks_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: qx_SharedLinks_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_SharedLinks_aggregate_bool_exp_count = {
  arguments?: Array<qx_SharedLinks_select_column>;
  distinct?: boolean;
  filter?: qx_SharedLinks_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.SharedLinks" */
export type qx_SharedLinks_aggregate_fields = {
  __typename?: 'qx_SharedLinks_aggregate_fields';
  avg?: qx_SharedLinks_avg_fields;
  count: number;
  max?: qx_SharedLinks_max_fields;
  min?: qx_SharedLinks_min_fields;
  stddev?: qx_SharedLinks_stddev_fields;
  stddev_pop?: qx_SharedLinks_stddev_pop_fields;
  stddev_samp?: qx_SharedLinks_stddev_samp_fields;
  sum?: qx_SharedLinks_sum_fields;
  var_pop?: qx_SharedLinks_var_pop_fields;
  var_samp?: qx_SharedLinks_var_samp_fields;
  variance?: qx_SharedLinks_variance_fields;
};


/** aggregate fields of "qx.SharedLinks" */
export type qx_SharedLinks_aggregate_fieldscountArgs = {
  columns?: Array<qx_SharedLinks_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.SharedLinks" */
export type qx_SharedLinks_aggregate_order_by = {
  avg?: qx_SharedLinks_avg_order_by;
  count?: order_by;
  max?: qx_SharedLinks_max_order_by;
  min?: qx_SharedLinks_min_order_by;
  stddev?: qx_SharedLinks_stddev_order_by;
  stddev_pop?: qx_SharedLinks_stddev_pop_order_by;
  stddev_samp?: qx_SharedLinks_stddev_samp_order_by;
  sum?: qx_SharedLinks_sum_order_by;
  var_pop?: qx_SharedLinks_var_pop_order_by;
  var_samp?: qx_SharedLinks_var_samp_order_by;
  variance?: qx_SharedLinks_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.SharedLinks" */
export type qx_SharedLinks_arr_rel_insert_input = {
  data: Array<qx_SharedLinks_insert_input>;
  /** upsert condition */
  on_conflict?: qx_SharedLinks_on_conflict;
};

/** aggregate avg on columns */
export type qx_SharedLinks_avg_fields = {
  __typename?: 'qx_SharedLinks_avg_fields';
  id?: number;
  linkableID?: number;
  uses?: number;
};

/** order by avg() on columns of table "qx.SharedLinks" */
export type qx_SharedLinks_avg_order_by = {
  id?: order_by;
  linkableID?: order_by;
  uses?: order_by;
};

/** Boolean expression to filter rows from the table "qx.SharedLinks". All fields are combined with a logical 'AND'. */
export type qx_SharedLinks_bool_exp = {
  SharedLinkType?: qx_SharedLinkType_bool_exp;
  _and?: Array<qx_SharedLinks_bool_exp>;
  _not?: qx_SharedLinks_bool_exp;
  _or?: Array<qx_SharedLinks_bool_exp>;
  auditLog?: qx_SharedLinkAuditLog_bool_exp;
  auditLog_aggregate?: qx_SharedLinkAuditLog_aggregate_bool_exp;
  clip?: qx_Clip_bool_exp;
  createdAt?: timestamptz_comparison_exp;
  createdBy?: qx_Person_bool_exp;
  deletedAt?: timestamptz_comparison_exp;
  emails?: String_array_comparison_exp;
  expiresAt?: timestamptz_comparison_exp;
  id?: bigint_comparison_exp;
  linkableID?: bigint_comparison_exp;
  linkableType?: qx_SharedLinkType_enum_comparison_exp;
  ownerID?: String_comparison_exp;
  persons?: String_array_comparison_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
  searchText?: String_comparison_exp;
  singleUse?: Boolean_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
  url?: String_comparison_exp;
  uses?: Int_comparison_exp;
};

/** unique or primary key constraints on table "qx.SharedLinks" */
export enum qx_SharedLinks_constraint {
  /** unique or primary key constraint on columns "id" */
  SharedLinks_pkey = 'SharedLinks_pkey'
}

/** input type for incrementing numeric columns in table "qx.SharedLinks" */
export type qx_SharedLinks_inc_input = {
  id?: string;
  linkableID?: string;
  uses?: number;
};

/** input type for inserting data into table "qx.SharedLinks" */
export type qx_SharedLinks_insert_input = {
  SharedLinkType?: qx_SharedLinkType_obj_rel_insert_input;
  auditLog?: qx_SharedLinkAuditLog_arr_rel_insert_input;
  clip?: qx_Clip_obj_rel_insert_input;
  createdAt?: string;
  createdBy?: qx_Person_obj_rel_insert_input;
  deletedAt?: string;
  emails?: Array<string>;
  expiresAt?: string;
  id?: string;
  linkableID?: string;
  linkableType?: qx_SharedLinkType_enum;
  ownerID?: string;
  persons?: Array<string>;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
  searchText?: string;
  singleUse?: boolean;
  updatedAt?: string;
  uses?: number;
};

/** aggregate max on columns */
export type qx_SharedLinks_max_fields = {
  __typename?: 'qx_SharedLinks_max_fields';
  createdAt?: string;
  deletedAt?: string;
  emails?: Array<string>;
  expiresAt?: string;
  id?: string;
  linkableID?: string;
  ownerID?: string;
  persons?: Array<string>;
  placeID?: string;
  searchText?: string;
  updatedAt?: string;
  url?: string;
  uses?: number;
};

/** order by max() on columns of table "qx.SharedLinks" */
export type qx_SharedLinks_max_order_by = {
  createdAt?: order_by;
  deletedAt?: order_by;
  emails?: order_by;
  expiresAt?: order_by;
  id?: order_by;
  linkableID?: order_by;
  ownerID?: order_by;
  persons?: order_by;
  placeID?: order_by;
  searchText?: order_by;
  updatedAt?: order_by;
  uses?: order_by;
};

/** aggregate min on columns */
export type qx_SharedLinks_min_fields = {
  __typename?: 'qx_SharedLinks_min_fields';
  createdAt?: string;
  deletedAt?: string;
  emails?: Array<string>;
  expiresAt?: string;
  id?: string;
  linkableID?: string;
  ownerID?: string;
  persons?: Array<string>;
  placeID?: string;
  searchText?: string;
  updatedAt?: string;
  url?: string;
  uses?: number;
};

/** order by min() on columns of table "qx.SharedLinks" */
export type qx_SharedLinks_min_order_by = {
  createdAt?: order_by;
  deletedAt?: order_by;
  emails?: order_by;
  expiresAt?: order_by;
  id?: order_by;
  linkableID?: order_by;
  ownerID?: order_by;
  persons?: order_by;
  placeID?: order_by;
  searchText?: order_by;
  updatedAt?: order_by;
  uses?: order_by;
};

/** response of any mutation on the table "qx.SharedLinks" */
export type qx_SharedLinks_mutation_response = {
  __typename?: 'qx_SharedLinks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_SharedLinks>;
};

/** on_conflict condition type for table "qx.SharedLinks" */
export type qx_SharedLinks_on_conflict = {
  constraint: qx_SharedLinks_constraint;
  update_columns?: Array<qx_SharedLinks_update_column>;
  where?: qx_SharedLinks_bool_exp;
};

/** Ordering options when selecting data from "qx.SharedLinks". */
export type qx_SharedLinks_order_by = {
  SharedLinkType?: qx_SharedLinkType_order_by;
  auditLog_aggregate?: qx_SharedLinkAuditLog_aggregate_order_by;
  clip?: qx_Clip_order_by;
  createdAt?: order_by;
  createdBy?: qx_Person_order_by;
  deletedAt?: order_by;
  emails?: order_by;
  expiresAt?: order_by;
  id?: order_by;
  linkableID?: order_by;
  linkableType?: order_by;
  ownerID?: order_by;
  persons?: order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
  searchText?: order_by;
  singleUse?: order_by;
  updatedAt?: order_by;
  url?: order_by;
  uses?: order_by;
};

/** primary key columns input for table: qx.SharedLinks */
export type qx_SharedLinks_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.SharedLinks" */
export enum qx_SharedLinks_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  deletedAt = 'deletedAt',
  /** column name */
  emails = 'emails',
  /** column name */
  expiresAt = 'expiresAt',
  /** column name */
  id = 'id',
  /** column name */
  linkableID = 'linkableID',
  /** column name */
  linkableType = 'linkableType',
  /** column name */
  ownerID = 'ownerID',
  /** column name */
  persons = 'persons',
  /** column name */
  placeID = 'placeID',
  /** column name */
  searchText = 'searchText',
  /** column name */
  singleUse = 'singleUse',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  uses = 'uses'
}

/** select "qx_SharedLinks_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.SharedLinks" */
export enum qx_SharedLinks_select_column_qx_SharedLinks_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  singleUse = 'singleUse'
}

/** select "qx_SharedLinks_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.SharedLinks" */
export enum qx_SharedLinks_select_column_qx_SharedLinks_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  singleUse = 'singleUse'
}

/** input type for updating data in table "qx.SharedLinks" */
export type qx_SharedLinks_set_input = {
  createdAt?: string;
  deletedAt?: string;
  emails?: Array<string>;
  expiresAt?: string;
  id?: string;
  linkableID?: string;
  linkableType?: qx_SharedLinkType_enum;
  ownerID?: string;
  persons?: Array<string>;
  placeID?: string;
  searchText?: string;
  singleUse?: boolean;
  updatedAt?: string;
  uses?: number;
};

/** aggregate stddev on columns */
export type qx_SharedLinks_stddev_fields = {
  __typename?: 'qx_SharedLinks_stddev_fields';
  id?: number;
  linkableID?: number;
  uses?: number;
};

/** order by stddev() on columns of table "qx.SharedLinks" */
export type qx_SharedLinks_stddev_order_by = {
  id?: order_by;
  linkableID?: order_by;
  uses?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_SharedLinks_stddev_pop_fields = {
  __typename?: 'qx_SharedLinks_stddev_pop_fields';
  id?: number;
  linkableID?: number;
  uses?: number;
};

/** order by stddev_pop() on columns of table "qx.SharedLinks" */
export type qx_SharedLinks_stddev_pop_order_by = {
  id?: order_by;
  linkableID?: order_by;
  uses?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_SharedLinks_stddev_samp_fields = {
  __typename?: 'qx_SharedLinks_stddev_samp_fields';
  id?: number;
  linkableID?: number;
  uses?: number;
};

/** order by stddev_samp() on columns of table "qx.SharedLinks" */
export type qx_SharedLinks_stddev_samp_order_by = {
  id?: order_by;
  linkableID?: order_by;
  uses?: order_by;
};

/** Streaming cursor of the table "qx_SharedLinks" */
export type qx_SharedLinks_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_SharedLinks_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_SharedLinks_stream_cursor_value_input = {
  createdAt?: string;
  deletedAt?: string;
  emails?: Array<string>;
  expiresAt?: string;
  id?: string;
  linkableID?: string;
  linkableType?: qx_SharedLinkType_enum;
  ownerID?: string;
  persons?: Array<string>;
  placeID?: string;
  searchText?: string;
  singleUse?: boolean;
  updatedAt?: string;
  uses?: number;
};

/** aggregate sum on columns */
export type qx_SharedLinks_sum_fields = {
  __typename?: 'qx_SharedLinks_sum_fields';
  id?: string;
  linkableID?: string;
  uses?: number;
};

/** order by sum() on columns of table "qx.SharedLinks" */
export type qx_SharedLinks_sum_order_by = {
  id?: order_by;
  linkableID?: order_by;
  uses?: order_by;
};

/** update columns of table "qx.SharedLinks" */
export enum qx_SharedLinks_update_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  deletedAt = 'deletedAt',
  /** column name */
  emails = 'emails',
  /** column name */
  expiresAt = 'expiresAt',
  /** column name */
  id = 'id',
  /** column name */
  linkableID = 'linkableID',
  /** column name */
  linkableType = 'linkableType',
  /** column name */
  ownerID = 'ownerID',
  /** column name */
  persons = 'persons',
  /** column name */
  placeID = 'placeID',
  /** column name */
  searchText = 'searchText',
  /** column name */
  singleUse = 'singleUse',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  uses = 'uses'
}

export type qx_SharedLinks_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_SharedLinks_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_SharedLinks_set_input;
  /** filter the rows which have to be updated */
  where: qx_SharedLinks_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_SharedLinks_var_pop_fields = {
  __typename?: 'qx_SharedLinks_var_pop_fields';
  id?: number;
  linkableID?: number;
  uses?: number;
};

/** order by var_pop() on columns of table "qx.SharedLinks" */
export type qx_SharedLinks_var_pop_order_by = {
  id?: order_by;
  linkableID?: order_by;
  uses?: order_by;
};

/** aggregate var_samp on columns */
export type qx_SharedLinks_var_samp_fields = {
  __typename?: 'qx_SharedLinks_var_samp_fields';
  id?: number;
  linkableID?: number;
  uses?: number;
};

/** order by var_samp() on columns of table "qx.SharedLinks" */
export type qx_SharedLinks_var_samp_order_by = {
  id?: order_by;
  linkableID?: order_by;
  uses?: order_by;
};

/** aggregate variance on columns */
export type qx_SharedLinks_variance_fields = {
  __typename?: 'qx_SharedLinks_variance_fields';
  id?: number;
  linkableID?: number;
  uses?: number;
};

/** order by variance() on columns of table "qx.SharedLinks" */
export type qx_SharedLinks_variance_order_by = {
  id?: order_by;
  linkableID?: order_by;
  uses?: order_by;
};

/** columns and relationships of "qx.Snapshot" */
export type qx_Snapshot = {
  __typename?: 'qx_Snapshot';
  aspectRatio?: any;
  base64?: string;
  bucketConfigurationID?: number;
  cropped: boolean;
  data?: any;
  drive?: number;
  /** An array relationship */
  events: Array<qx_Event>;
  /** An aggregate relationship */
  events_aggregate: qx_Event_aggregate;
  expiration?: string;
  filename?: string;
  id: string;
  signedUrl?: string;
  time: string;
  timelapse: boolean;
  /** An object relationship */
  videoSource?: qx_VideoSource;
  videoSourceID?: string;
};


/** columns and relationships of "qx.Snapshot" */
export type qx_SnapshoteventsArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};


/** columns and relationships of "qx.Snapshot" */
export type qx_Snapshotevents_aggregateArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};

/** aggregated selection of "qx.Snapshot" */
export type qx_Snapshot_aggregate = {
  __typename?: 'qx_Snapshot_aggregate';
  aggregate?: qx_Snapshot_aggregate_fields;
  nodes: Array<qx_Snapshot>;
};

export type qx_Snapshot_aggregate_bool_exp = {
  bool_and?: qx_Snapshot_aggregate_bool_exp_bool_and;
  bool_or?: qx_Snapshot_aggregate_bool_exp_bool_or;
  count?: qx_Snapshot_aggregate_bool_exp_count;
};

export type qx_Snapshot_aggregate_bool_exp_bool_and = {
  arguments: qx_Snapshot_select_column_qx_Snapshot_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: qx_Snapshot_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_Snapshot_aggregate_bool_exp_bool_or = {
  arguments: qx_Snapshot_select_column_qx_Snapshot_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: qx_Snapshot_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_Snapshot_aggregate_bool_exp_count = {
  arguments?: Array<qx_Snapshot_select_column>;
  distinct?: boolean;
  filter?: qx_Snapshot_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.Snapshot" */
export type qx_Snapshot_aggregate_fields = {
  __typename?: 'qx_Snapshot_aggregate_fields';
  avg?: qx_Snapshot_avg_fields;
  count: number;
  max?: qx_Snapshot_max_fields;
  min?: qx_Snapshot_min_fields;
  stddev?: qx_Snapshot_stddev_fields;
  stddev_pop?: qx_Snapshot_stddev_pop_fields;
  stddev_samp?: qx_Snapshot_stddev_samp_fields;
  sum?: qx_Snapshot_sum_fields;
  var_pop?: qx_Snapshot_var_pop_fields;
  var_samp?: qx_Snapshot_var_samp_fields;
  variance?: qx_Snapshot_variance_fields;
};


/** aggregate fields of "qx.Snapshot" */
export type qx_Snapshot_aggregate_fieldscountArgs = {
  columns?: Array<qx_Snapshot_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.Snapshot" */
export type qx_Snapshot_aggregate_order_by = {
  avg?: qx_Snapshot_avg_order_by;
  count?: order_by;
  max?: qx_Snapshot_max_order_by;
  min?: qx_Snapshot_min_order_by;
  stddev?: qx_Snapshot_stddev_order_by;
  stddev_pop?: qx_Snapshot_stddev_pop_order_by;
  stddev_samp?: qx_Snapshot_stddev_samp_order_by;
  sum?: qx_Snapshot_sum_order_by;
  var_pop?: qx_Snapshot_var_pop_order_by;
  var_samp?: qx_Snapshot_var_samp_order_by;
  variance?: qx_Snapshot_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.Snapshot" */
export type qx_Snapshot_arr_rel_insert_input = {
  data: Array<qx_Snapshot_insert_input>;
  /** upsert condition */
  on_conflict?: qx_Snapshot_on_conflict;
};

/** aggregate avg on columns */
export type qx_Snapshot_avg_fields = {
  __typename?: 'qx_Snapshot_avg_fields';
  aspectRatio?: number;
  bucketConfigurationID?: number;
  drive?: number;
  videoSourceID?: number;
};

/** order by avg() on columns of table "qx.Snapshot" */
export type qx_Snapshot_avg_order_by = {
  aspectRatio?: order_by;
  bucketConfigurationID?: order_by;
  drive?: order_by;
  videoSourceID?: order_by;
};

/** Boolean expression to filter rows from the table "qx.Snapshot". All fields are combined with a logical 'AND'. */
export type qx_Snapshot_bool_exp = {
  _and?: Array<qx_Snapshot_bool_exp>;
  _not?: qx_Snapshot_bool_exp;
  _or?: Array<qx_Snapshot_bool_exp>;
  aspectRatio?: numeric_comparison_exp;
  base64?: String_comparison_exp;
  bucketConfigurationID?: Int_comparison_exp;
  cropped?: Boolean_comparison_exp;
  data?: bytea_comparison_exp;
  drive?: Int_comparison_exp;
  events?: qx_Event_bool_exp;
  events_aggregate?: qx_Event_aggregate_bool_exp;
  expiration?: timestamptz_comparison_exp;
  filename?: String_comparison_exp;
  id?: String_comparison_exp;
  signedUrl?: String_comparison_exp;
  time?: timestamptz_comparison_exp;
  timelapse?: Boolean_comparison_exp;
  videoSource?: qx_VideoSource_bool_exp;
  videoSourceID?: bigint_comparison_exp;
};

/** unique or primary key constraints on table "qx.Snapshot" */
export enum qx_Snapshot_constraint {
  /** unique or primary key constraint on columns "id" */
  Snapshot_pkey = 'Snapshot_pkey'
}

/** input type for incrementing numeric columns in table "qx.Snapshot" */
export type qx_Snapshot_inc_input = {
  aspectRatio?: any;
  bucketConfigurationID?: number;
  drive?: number;
  videoSourceID?: string;
};

/** input type for inserting data into table "qx.Snapshot" */
export type qx_Snapshot_insert_input = {
  aspectRatio?: any;
  bucketConfigurationID?: number;
  cropped?: boolean;
  data?: any;
  drive?: number;
  events?: qx_Event_arr_rel_insert_input;
  expiration?: string;
  filename?: string;
  id?: string;
  time?: string;
  timelapse?: boolean;
  videoSource?: qx_VideoSource_obj_rel_insert_input;
  videoSourceID?: string;
};

/** aggregate max on columns */
export type qx_Snapshot_max_fields = {
  __typename?: 'qx_Snapshot_max_fields';
  aspectRatio?: any;
  base64?: string;
  bucketConfigurationID?: number;
  drive?: number;
  expiration?: string;
  filename?: string;
  id?: string;
  signedUrl?: string;
  time?: string;
  videoSourceID?: string;
};

/** order by max() on columns of table "qx.Snapshot" */
export type qx_Snapshot_max_order_by = {
  aspectRatio?: order_by;
  bucketConfigurationID?: order_by;
  drive?: order_by;
  expiration?: order_by;
  filename?: order_by;
  id?: order_by;
  time?: order_by;
  videoSourceID?: order_by;
};

/** aggregate min on columns */
export type qx_Snapshot_min_fields = {
  __typename?: 'qx_Snapshot_min_fields';
  aspectRatio?: any;
  base64?: string;
  bucketConfigurationID?: number;
  drive?: number;
  expiration?: string;
  filename?: string;
  id?: string;
  signedUrl?: string;
  time?: string;
  videoSourceID?: string;
};

/** order by min() on columns of table "qx.Snapshot" */
export type qx_Snapshot_min_order_by = {
  aspectRatio?: order_by;
  bucketConfigurationID?: order_by;
  drive?: order_by;
  expiration?: order_by;
  filename?: order_by;
  id?: order_by;
  time?: order_by;
  videoSourceID?: order_by;
};

/** response of any mutation on the table "qx.Snapshot" */
export type qx_Snapshot_mutation_response = {
  __typename?: 'qx_Snapshot_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_Snapshot>;
};

/** input type for inserting object relation for remote table "qx.Snapshot" */
export type qx_Snapshot_obj_rel_insert_input = {
  data: qx_Snapshot_insert_input;
  /** upsert condition */
  on_conflict?: qx_Snapshot_on_conflict;
};

/** on_conflict condition type for table "qx.Snapshot" */
export type qx_Snapshot_on_conflict = {
  constraint: qx_Snapshot_constraint;
  update_columns?: Array<qx_Snapshot_update_column>;
  where?: qx_Snapshot_bool_exp;
};

/** Ordering options when selecting data from "qx.Snapshot". */
export type qx_Snapshot_order_by = {
  aspectRatio?: order_by;
  base64?: order_by;
  bucketConfigurationID?: order_by;
  cropped?: order_by;
  data?: order_by;
  drive?: order_by;
  events_aggregate?: qx_Event_aggregate_order_by;
  expiration?: order_by;
  filename?: order_by;
  id?: order_by;
  signedUrl?: order_by;
  time?: order_by;
  timelapse?: order_by;
  videoSource?: qx_VideoSource_order_by;
  videoSourceID?: order_by;
};

/** primary key columns input for table: qx.Snapshot */
export type qx_Snapshot_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.Snapshot" */
export enum qx_Snapshot_select_column {
  /** column name */
  aspectRatio = 'aspectRatio',
  /** column name */
  bucketConfigurationID = 'bucketConfigurationID',
  /** column name */
  cropped = 'cropped',
  /** column name */
  data = 'data',
  /** column name */
  drive = 'drive',
  /** column name */
  expiration = 'expiration',
  /** column name */
  filename = 'filename',
  /** column name */
  id = 'id',
  /** column name */
  time = 'time',
  /** column name */
  timelapse = 'timelapse',
  /** column name */
  videoSourceID = 'videoSourceID'
}

/** select "qx_Snapshot_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.Snapshot" */
export enum qx_Snapshot_select_column_qx_Snapshot_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  cropped = 'cropped',
  /** column name */
  timelapse = 'timelapse'
}

/** select "qx_Snapshot_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.Snapshot" */
export enum qx_Snapshot_select_column_qx_Snapshot_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  cropped = 'cropped',
  /** column name */
  timelapse = 'timelapse'
}

/** input type for updating data in table "qx.Snapshot" */
export type qx_Snapshot_set_input = {
  aspectRatio?: any;
  bucketConfigurationID?: number;
  cropped?: boolean;
  data?: any;
  drive?: number;
  expiration?: string;
  filename?: string;
  id?: string;
  time?: string;
  timelapse?: boolean;
  videoSourceID?: string;
};

/** aggregate stddev on columns */
export type qx_Snapshot_stddev_fields = {
  __typename?: 'qx_Snapshot_stddev_fields';
  aspectRatio?: number;
  bucketConfigurationID?: number;
  drive?: number;
  videoSourceID?: number;
};

/** order by stddev() on columns of table "qx.Snapshot" */
export type qx_Snapshot_stddev_order_by = {
  aspectRatio?: order_by;
  bucketConfigurationID?: order_by;
  drive?: order_by;
  videoSourceID?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_Snapshot_stddev_pop_fields = {
  __typename?: 'qx_Snapshot_stddev_pop_fields';
  aspectRatio?: number;
  bucketConfigurationID?: number;
  drive?: number;
  videoSourceID?: number;
};

/** order by stddev_pop() on columns of table "qx.Snapshot" */
export type qx_Snapshot_stddev_pop_order_by = {
  aspectRatio?: order_by;
  bucketConfigurationID?: order_by;
  drive?: order_by;
  videoSourceID?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_Snapshot_stddev_samp_fields = {
  __typename?: 'qx_Snapshot_stddev_samp_fields';
  aspectRatio?: number;
  bucketConfigurationID?: number;
  drive?: number;
  videoSourceID?: number;
};

/** order by stddev_samp() on columns of table "qx.Snapshot" */
export type qx_Snapshot_stddev_samp_order_by = {
  aspectRatio?: order_by;
  bucketConfigurationID?: order_by;
  drive?: order_by;
  videoSourceID?: order_by;
};

/** Streaming cursor of the table "qx_Snapshot" */
export type qx_Snapshot_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_Snapshot_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_Snapshot_stream_cursor_value_input = {
  aspectRatio?: any;
  bucketConfigurationID?: number;
  cropped?: boolean;
  data?: any;
  drive?: number;
  expiration?: string;
  filename?: string;
  id?: string;
  time?: string;
  timelapse?: boolean;
  videoSourceID?: string;
};

/** aggregate sum on columns */
export type qx_Snapshot_sum_fields = {
  __typename?: 'qx_Snapshot_sum_fields';
  aspectRatio?: any;
  bucketConfigurationID?: number;
  drive?: number;
  videoSourceID?: string;
};

/** order by sum() on columns of table "qx.Snapshot" */
export type qx_Snapshot_sum_order_by = {
  aspectRatio?: order_by;
  bucketConfigurationID?: order_by;
  drive?: order_by;
  videoSourceID?: order_by;
};

/** update columns of table "qx.Snapshot" */
export enum qx_Snapshot_update_column {
  /** column name */
  aspectRatio = 'aspectRatio',
  /** column name */
  bucketConfigurationID = 'bucketConfigurationID',
  /** column name */
  cropped = 'cropped',
  /** column name */
  data = 'data',
  /** column name */
  drive = 'drive',
  /** column name */
  expiration = 'expiration',
  /** column name */
  filename = 'filename',
  /** column name */
  id = 'id',
  /** column name */
  time = 'time',
  /** column name */
  timelapse = 'timelapse',
  /** column name */
  videoSourceID = 'videoSourceID'
}

export type qx_Snapshot_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_Snapshot_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_Snapshot_set_input;
  /** filter the rows which have to be updated */
  where: qx_Snapshot_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_Snapshot_var_pop_fields = {
  __typename?: 'qx_Snapshot_var_pop_fields';
  aspectRatio?: number;
  bucketConfigurationID?: number;
  drive?: number;
  videoSourceID?: number;
};

/** order by var_pop() on columns of table "qx.Snapshot" */
export type qx_Snapshot_var_pop_order_by = {
  aspectRatio?: order_by;
  bucketConfigurationID?: order_by;
  drive?: order_by;
  videoSourceID?: order_by;
};

/** aggregate var_samp on columns */
export type qx_Snapshot_var_samp_fields = {
  __typename?: 'qx_Snapshot_var_samp_fields';
  aspectRatio?: number;
  bucketConfigurationID?: number;
  drive?: number;
  videoSourceID?: number;
};

/** order by var_samp() on columns of table "qx.Snapshot" */
export type qx_Snapshot_var_samp_order_by = {
  aspectRatio?: order_by;
  bucketConfigurationID?: order_by;
  drive?: order_by;
  videoSourceID?: order_by;
};

/** aggregate variance on columns */
export type qx_Snapshot_variance_fields = {
  __typename?: 'qx_Snapshot_variance_fields';
  aspectRatio?: number;
  bucketConfigurationID?: number;
  drive?: number;
  videoSourceID?: number;
};

/** order by variance() on columns of table "qx.Snapshot" */
export type qx_Snapshot_variance_order_by = {
  aspectRatio?: order_by;
  bucketConfigurationID?: order_by;
  drive?: order_by;
  videoSourceID?: order_by;
};

/** columns and relationships of "qx.TermsAgreement" */
export type qx_TermsAgreement = {
  __typename?: 'qx_TermsAgreement';
  dateOfAgreement?: string;
  id: string;
  termsReference?: string;
  updatedAt?: string;
  validUntil?: string;
};

/** aggregated selection of "qx.TermsAgreement" */
export type qx_TermsAgreement_aggregate = {
  __typename?: 'qx_TermsAgreement_aggregate';
  aggregate?: qx_TermsAgreement_aggregate_fields;
  nodes: Array<qx_TermsAgreement>;
};

/** aggregate fields of "qx.TermsAgreement" */
export type qx_TermsAgreement_aggregate_fields = {
  __typename?: 'qx_TermsAgreement_aggregate_fields';
  count: number;
  max?: qx_TermsAgreement_max_fields;
  min?: qx_TermsAgreement_min_fields;
};


/** aggregate fields of "qx.TermsAgreement" */
export type qx_TermsAgreement_aggregate_fieldscountArgs = {
  columns?: Array<qx_TermsAgreement_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.TermsAgreement". All fields are combined with a logical 'AND'. */
export type qx_TermsAgreement_bool_exp = {
  _and?: Array<qx_TermsAgreement_bool_exp>;
  _not?: qx_TermsAgreement_bool_exp;
  _or?: Array<qx_TermsAgreement_bool_exp>;
  dateOfAgreement?: timestamp_comparison_exp;
  id?: String_comparison_exp;
  termsReference?: String_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
  validUntil?: timestamp_comparison_exp;
};

/** unique or primary key constraints on table "qx.TermsAgreement" */
export enum qx_TermsAgreement_constraint {
  /** unique or primary key constraint on columns "id" */
  TermsAgreement_pkey = 'TermsAgreement_pkey'
}

/** input type for inserting data into table "qx.TermsAgreement" */
export type qx_TermsAgreement_insert_input = {
  dateOfAgreement?: string;
  id?: string;
  termsReference?: string;
  updatedAt?: string;
  validUntil?: string;
};

/** aggregate max on columns */
export type qx_TermsAgreement_max_fields = {
  __typename?: 'qx_TermsAgreement_max_fields';
  dateOfAgreement?: string;
  id?: string;
  termsReference?: string;
  updatedAt?: string;
  validUntil?: string;
};

/** aggregate min on columns */
export type qx_TermsAgreement_min_fields = {
  __typename?: 'qx_TermsAgreement_min_fields';
  dateOfAgreement?: string;
  id?: string;
  termsReference?: string;
  updatedAt?: string;
  validUntil?: string;
};

/** response of any mutation on the table "qx.TermsAgreement" */
export type qx_TermsAgreement_mutation_response = {
  __typename?: 'qx_TermsAgreement_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_TermsAgreement>;
};

/** on_conflict condition type for table "qx.TermsAgreement" */
export type qx_TermsAgreement_on_conflict = {
  constraint: qx_TermsAgreement_constraint;
  update_columns?: Array<qx_TermsAgreement_update_column>;
  where?: qx_TermsAgreement_bool_exp;
};

/** Ordering options when selecting data from "qx.TermsAgreement". */
export type qx_TermsAgreement_order_by = {
  dateOfAgreement?: order_by;
  id?: order_by;
  termsReference?: order_by;
  updatedAt?: order_by;
  validUntil?: order_by;
};

/** primary key columns input for table: qx.TermsAgreement */
export type qx_TermsAgreement_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.TermsAgreement" */
export enum qx_TermsAgreement_select_column {
  /** column name */
  dateOfAgreement = 'dateOfAgreement',
  /** column name */
  id = 'id',
  /** column name */
  termsReference = 'termsReference',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  validUntil = 'validUntil'
}

/** input type for updating data in table "qx.TermsAgreement" */
export type qx_TermsAgreement_set_input = {
  dateOfAgreement?: string;
  id?: string;
  termsReference?: string;
  updatedAt?: string;
  validUntil?: string;
};

/** Streaming cursor of the table "qx_TermsAgreement" */
export type qx_TermsAgreement_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_TermsAgreement_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_TermsAgreement_stream_cursor_value_input = {
  dateOfAgreement?: string;
  id?: string;
  termsReference?: string;
  updatedAt?: string;
  validUntil?: string;
};

/** update columns of table "qx.TermsAgreement" */
export enum qx_TermsAgreement_update_column {
  /** column name */
  dateOfAgreement = 'dateOfAgreement',
  /** column name */
  id = 'id',
  /** column name */
  termsReference = 'termsReference',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  validUntil = 'validUntil'
}

export type qx_TermsAgreement_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_TermsAgreement_set_input;
  /** filter the rows which have to be updated */
  where: qx_TermsAgreement_bool_exp;
};

/** columns and relationships of "qx.TimeZone" */
export type qx_TimeZone = {
  __typename?: 'qx_TimeZone';
  description: string;
  dst?: boolean;
  iana?: string;
  name: string;
  /** An array relationship */
  places: Array<qx_Place>;
  /** An aggregate relationship */
  places_aggregate: qx_Place_aggregate;
  tz?: string;
  tzoffset?: any;
};


/** columns and relationships of "qx.TimeZone" */
export type qx_TimeZoneplacesArgs = {
  distinct_on?: Array<qx_Place_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Place_order_by>;
  where?: qx_Place_bool_exp;
};


/** columns and relationships of "qx.TimeZone" */
export type qx_TimeZoneplaces_aggregateArgs = {
  distinct_on?: Array<qx_Place_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Place_order_by>;
  where?: qx_Place_bool_exp;
};

/** aggregated selection of "qx.TimeZone" */
export type qx_TimeZone_aggregate = {
  __typename?: 'qx_TimeZone_aggregate';
  aggregate?: qx_TimeZone_aggregate_fields;
  nodes: Array<qx_TimeZone>;
};

/** aggregate fields of "qx.TimeZone" */
export type qx_TimeZone_aggregate_fields = {
  __typename?: 'qx_TimeZone_aggregate_fields';
  count: number;
  max?: qx_TimeZone_max_fields;
  min?: qx_TimeZone_min_fields;
};


/** aggregate fields of "qx.TimeZone" */
export type qx_TimeZone_aggregate_fieldscountArgs = {
  columns?: Array<qx_TimeZone_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.TimeZone". All fields are combined with a logical 'AND'. */
export type qx_TimeZone_bool_exp = {
  _and?: Array<qx_TimeZone_bool_exp>;
  _not?: qx_TimeZone_bool_exp;
  _or?: Array<qx_TimeZone_bool_exp>;
  description?: String_comparison_exp;
  dst?: Boolean_comparison_exp;
  iana?: String_comparison_exp;
  name?: String_comparison_exp;
  places?: qx_Place_bool_exp;
  places_aggregate?: qx_Place_aggregate_bool_exp;
  tz?: String_comparison_exp;
  tzoffset?: interval_comparison_exp;
};

/** unique or primary key constraints on table "qx.TimeZone" */
export enum qx_TimeZone_constraint {
  /** unique or primary key constraint on columns "name" */
  TimeZone_pkey = 'TimeZone_pkey',
  /** unique or primary key constraint on columns "iana" */
  UK_iana = 'UK_iana'
}

/** input type for inserting data into table "qx.TimeZone" */
export type qx_TimeZone_insert_input = {
  description?: string;
  dst?: boolean;
  iana?: string;
  name?: string;
  places?: qx_Place_arr_rel_insert_input;
  tz?: string;
  tzoffset?: any;
};

/** aggregate max on columns */
export type qx_TimeZone_max_fields = {
  __typename?: 'qx_TimeZone_max_fields';
  description?: string;
  iana?: string;
  name?: string;
  tz?: string;
};

/** aggregate min on columns */
export type qx_TimeZone_min_fields = {
  __typename?: 'qx_TimeZone_min_fields';
  description?: string;
  iana?: string;
  name?: string;
  tz?: string;
};

/** response of any mutation on the table "qx.TimeZone" */
export type qx_TimeZone_mutation_response = {
  __typename?: 'qx_TimeZone_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_TimeZone>;
};

/** input type for inserting object relation for remote table "qx.TimeZone" */
export type qx_TimeZone_obj_rel_insert_input = {
  data: qx_TimeZone_insert_input;
  /** upsert condition */
  on_conflict?: qx_TimeZone_on_conflict;
};

/** on_conflict condition type for table "qx.TimeZone" */
export type qx_TimeZone_on_conflict = {
  constraint: qx_TimeZone_constraint;
  update_columns?: Array<qx_TimeZone_update_column>;
  where?: qx_TimeZone_bool_exp;
};

/** Ordering options when selecting data from "qx.TimeZone". */
export type qx_TimeZone_order_by = {
  description?: order_by;
  dst?: order_by;
  iana?: order_by;
  name?: order_by;
  places_aggregate?: qx_Place_aggregate_order_by;
  tz?: order_by;
  tzoffset?: order_by;
};

/** primary key columns input for table: qx.TimeZone */
export type qx_TimeZone_pk_columns_input = {
  name: string;
};

/** select columns of table "qx.TimeZone" */
export enum qx_TimeZone_select_column {
  /** column name */
  description = 'description',
  /** column name */
  dst = 'dst',
  /** column name */
  iana = 'iana',
  /** column name */
  name = 'name',
  /** column name */
  tz = 'tz',
  /** column name */
  tzoffset = 'tzoffset'
}

/** input type for updating data in table "qx.TimeZone" */
export type qx_TimeZone_set_input = {
  description?: string;
  dst?: boolean;
  iana?: string;
  name?: string;
  tz?: string;
  tzoffset?: any;
};

/** Streaming cursor of the table "qx_TimeZone" */
export type qx_TimeZone_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_TimeZone_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_TimeZone_stream_cursor_value_input = {
  description?: string;
  dst?: boolean;
  iana?: string;
  name?: string;
  tz?: string;
  tzoffset?: any;
};

/** update columns of table "qx.TimeZone" */
export enum qx_TimeZone_update_column {
  /** column name */
  description = 'description',
  /** column name */
  dst = 'dst',
  /** column name */
  iana = 'iana',
  /** column name */
  name = 'name',
  /** column name */
  tz = 'tz',
  /** column name */
  tzoffset = 'tzoffset'
}

export type qx_TimeZone_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_TimeZone_set_input;
  /** filter the rows which have to be updated */
  where: qx_TimeZone_bool_exp;
};

/** columns and relationships of "qx.UserSetting" */
export type qx_UserSetting = {
  __typename?: 'qx_UserSetting';
  id: string;
  name: string;
  /** An object relationship */
  person: qx_Person;
  personID: string;
  updatedAt?: string;
  value: any;
};


/** columns and relationships of "qx.UserSetting" */
export type qx_UserSettingvalueArgs = {
  path?: string;
};

/** aggregated selection of "qx.UserSetting" */
export type qx_UserSetting_aggregate = {
  __typename?: 'qx_UserSetting_aggregate';
  aggregate?: qx_UserSetting_aggregate_fields;
  nodes: Array<qx_UserSetting>;
};

export type qx_UserSetting_aggregate_bool_exp = {
  count?: qx_UserSetting_aggregate_bool_exp_count;
};

export type qx_UserSetting_aggregate_bool_exp_count = {
  arguments?: Array<qx_UserSetting_select_column>;
  distinct?: boolean;
  filter?: qx_UserSetting_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.UserSetting" */
export type qx_UserSetting_aggregate_fields = {
  __typename?: 'qx_UserSetting_aggregate_fields';
  count: number;
  max?: qx_UserSetting_max_fields;
  min?: qx_UserSetting_min_fields;
};


/** aggregate fields of "qx.UserSetting" */
export type qx_UserSetting_aggregate_fieldscountArgs = {
  columns?: Array<qx_UserSetting_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.UserSetting" */
export type qx_UserSetting_aggregate_order_by = {
  count?: order_by;
  max?: qx_UserSetting_max_order_by;
  min?: qx_UserSetting_min_order_by;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type qx_UserSetting_append_input = {
  value?: any;
};

/** input type for inserting array relation for remote table "qx.UserSetting" */
export type qx_UserSetting_arr_rel_insert_input = {
  data: Array<qx_UserSetting_insert_input>;
  /** upsert condition */
  on_conflict?: qx_UserSetting_on_conflict;
};

/** Boolean expression to filter rows from the table "qx.UserSetting". All fields are combined with a logical 'AND'. */
export type qx_UserSetting_bool_exp = {
  _and?: Array<qx_UserSetting_bool_exp>;
  _not?: qx_UserSetting_bool_exp;
  _or?: Array<qx_UserSetting_bool_exp>;
  id?: String_comparison_exp;
  name?: String_comparison_exp;
  person?: qx_Person_bool_exp;
  personID?: String_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
  value?: jsonb_comparison_exp;
};

/** unique or primary key constraints on table "qx.UserSetting" */
export enum qx_UserSetting_constraint {
  /** unique or primary key constraint on columns "name", "personID" */
  UserSetting_personID_name_key = 'UserSetting_personID_name_key',
  /** unique or primary key constraint on columns "id" */
  UserSetting_pkey = 'UserSetting_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type qx_UserSetting_delete_at_path_input = {
  value?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type qx_UserSetting_delete_elem_input = {
  value?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type qx_UserSetting_delete_key_input = {
  value?: string;
};

/** input type for inserting data into table "qx.UserSetting" */
export type qx_UserSetting_insert_input = {
  id?: string;
  name?: string;
  person?: qx_Person_obj_rel_insert_input;
  personID?: string;
  updatedAt?: string;
  value?: any;
};

/** aggregate max on columns */
export type qx_UserSetting_max_fields = {
  __typename?: 'qx_UserSetting_max_fields';
  id?: string;
  name?: string;
  personID?: string;
  updatedAt?: string;
};

/** order by max() on columns of table "qx.UserSetting" */
export type qx_UserSetting_max_order_by = {
  id?: order_by;
  name?: order_by;
  personID?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type qx_UserSetting_min_fields = {
  __typename?: 'qx_UserSetting_min_fields';
  id?: string;
  name?: string;
  personID?: string;
  updatedAt?: string;
};

/** order by min() on columns of table "qx.UserSetting" */
export type qx_UserSetting_min_order_by = {
  id?: order_by;
  name?: order_by;
  personID?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.UserSetting" */
export type qx_UserSetting_mutation_response = {
  __typename?: 'qx_UserSetting_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_UserSetting>;
};

/** on_conflict condition type for table "qx.UserSetting" */
export type qx_UserSetting_on_conflict = {
  constraint: qx_UserSetting_constraint;
  update_columns?: Array<qx_UserSetting_update_column>;
  where?: qx_UserSetting_bool_exp;
};

/** Ordering options when selecting data from "qx.UserSetting". */
export type qx_UserSetting_order_by = {
  id?: order_by;
  name?: order_by;
  person?: qx_Person_order_by;
  personID?: order_by;
  updatedAt?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.UserSetting */
export type qx_UserSetting_pk_columns_input = {
  id: string;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type qx_UserSetting_prepend_input = {
  value?: any;
};

/** select columns of table "qx.UserSetting" */
export enum qx_UserSetting_select_column {
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  personID = 'personID',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.UserSetting" */
export type qx_UserSetting_set_input = {
  id?: string;
  name?: string;
  personID?: string;
  updatedAt?: string;
  value?: any;
};

/** Streaming cursor of the table "qx_UserSetting" */
export type qx_UserSetting_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_UserSetting_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_UserSetting_stream_cursor_value_input = {
  id?: string;
  name?: string;
  personID?: string;
  updatedAt?: string;
  value?: any;
};

/** update columns of table "qx.UserSetting" */
export enum qx_UserSetting_update_column {
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  personID = 'personID',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  value = 'value'
}

export type qx_UserSetting_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: qx_UserSetting_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: qx_UserSetting_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: qx_UserSetting_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: qx_UserSetting_delete_key_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: qx_UserSetting_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_UserSetting_set_input;
  /** filter the rows which have to be updated */
  where: qx_UserSetting_bool_exp;
};

/** IP camera or video encoder providing a live stream and recordings, associated with a place */
export type qx_VideoSource = {
  __typename?: 'qx_VideoSource';
  /** An object relationship */
  CloudStorageOption: qx_CloudStorageOptions;
  /** An array relationship */
  Doors: Array<qx_Door>;
  /** An aggregate relationship */
  Doors_aggregate: qx_Door_aggregate;
  /** An array relationship */
  audioSources: Array<audioSourceVideoSource>;
  /** An aggregate relationship */
  audioSources_aggregate: audioSourceVideoSource_aggregate;
  /** A computed field, executes function "qx.can_operate_video_source" */
  canOperate?: boolean;
  cloudStorageAvailable?: string;
  cloudStorageDays: number;
  cloudStorageMax?: string;
  cloudStorageTimelapseDays: number;
  cloudStorageUsed?: string;
  createdAt: string;
  description?: string;
  /** An object relationship */
  device: qx_Device;
  /** A computed field, executes function "qx.get_video_source_device_connectionStatus" */
  deviceConnectionStatus?: string;
  deviceID: string;
  /** A computed field, executes function "qx.get_video_source_device_pacsStatus" */
  devicePacStatus?: string;
  /** A computed field, executes function "qx.get_video_source_device_pacsHWUpdate" */
  devicePacsHWUpdate?: string;
  dewarpProfile?: Array<qx_LensProfile>;
  disabledByLicense: boolean;
  displaySettings?: any;
  /** An object relationship */
  eMountPosition?: qx_eMountPosition;
  enabled: boolean;
  /** An array relationship */
  events: Array<qx_Event>;
  /** An aggregate relationship */
  events_aggregate: qx_Event_aggregate;
  fps?: number;
  /** A computed field, executes function "qx.get_video_source_device_gateway_connectionStatus" */
  gatewayConnectionStatus?: boolean;
  /** A computed field, executes function "qx.get_video_source_gateway_id" */
  gatewayID?: string;
  /** A computed field, executes function "qx.get_video_source_gateway_placeID" */
  gatewayPlaceID?: string;
  /** A computed field, executes function "qx.get_video_source_device_gateway_syncStatus" */
  gatewaySyncStatus?: string;
  id: string;
  imageSize?: string;
  imagingOptions?: any;
  imagingSettings?: any;
  isBillable: boolean;
  /** A computed field, executes function "qx.latest_snapshots_for_video_source" */
  latestSnapshots?: Array<qx_Snapshot>;
  localStorageDays?: number;
  /** An array relationship */
  mediaProfiles: Array<qx_MediaProfile>;
  /** An aggregate relationship */
  mediaProfiles_aggregate: qx_MediaProfile_aggregate;
  metadataEnabled?: boolean;
  minLikelihood: number;
  mountPosition?: qx_eMountPosition_enum;
  name: string;
  newestMedia?: Array<qx_vNewestMedia>;
  /** A computed field, executes function "qx.video_source_oldest_media" */
  oldestMedia?: Array<qx_vOldestMedia>;
  /** An object relationship */
  place: qx_Place;
  placeID: string;
  /** An array relationship */
  privileges: Array<personVideoSourceAppPrivileges>;
  /** An aggregate relationship */
  privileges_aggregate: personVideoSourceAppPrivileges_aggregate;
  /** A computed field, executes function "qx.profile_m_supported" */
  profileMSupported?: boolean;
  ptzSettings?: any;
  refID: string;
  /** An object relationship */
  schedule?: qx_Schedule;
  scheduleID?: string;
  searchText?: string;
  snapshotMediaProfileID?: string;
  /** An array relationship */
  snapshots: Array<qx_Snapshot>;
  /** An aggregate relationship */
  snapshots_aggregate: qx_Snapshot_aggregate;
  /** An object relationship */
  state?: videoSourceState;
  tamperActive: boolean;
  timelapseInterval: number;
  /** A computed field, executes function "qx.get_video_source_timezone" */
  timezone?: string;
  updatedAt?: string;
  /** An array relationship */
  videoSourceStorageAudits: Array<qx_VideoSourceStorageAudit>;
  /** An aggregate relationship */
  videoSourceStorageAudits_aggregate: qx_VideoSourceStorageAudit_aggregate;
};


/** IP camera or video encoder providing a live stream and recordings, associated with a place */
export type qx_VideoSourceDoorsArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


/** IP camera or video encoder providing a live stream and recordings, associated with a place */
export type qx_VideoSourceDoors_aggregateArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


/** IP camera or video encoder providing a live stream and recordings, associated with a place */
export type qx_VideoSourceaudioSourcesArgs = {
  distinct_on?: Array<audioSourceVideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<audioSourceVideoSource_order_by>;
  where?: audioSourceVideoSource_bool_exp;
};


/** IP camera or video encoder providing a live stream and recordings, associated with a place */
export type qx_VideoSourceaudioSources_aggregateArgs = {
  distinct_on?: Array<audioSourceVideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<audioSourceVideoSource_order_by>;
  where?: audioSourceVideoSource_bool_exp;
};


/** IP camera or video encoder providing a live stream and recordings, associated with a place */
export type qx_VideoSourcedewarpProfileArgs = {
  distinct_on?: Array<qx_LensProfile_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_LensProfile_order_by>;
  where?: qx_LensProfile_bool_exp;
};


/** IP camera or video encoder providing a live stream and recordings, associated with a place */
export type qx_VideoSourcedisplaySettingsArgs = {
  path?: string;
};


/** IP camera or video encoder providing a live stream and recordings, associated with a place */
export type qx_VideoSourceeventsArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};


/** IP camera or video encoder providing a live stream and recordings, associated with a place */
export type qx_VideoSourceevents_aggregateArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};


/** IP camera or video encoder providing a live stream and recordings, associated with a place */
export type qx_VideoSourceimagingOptionsArgs = {
  path?: string;
};


/** IP camera or video encoder providing a live stream and recordings, associated with a place */
export type qx_VideoSourceimagingSettingsArgs = {
  path?: string;
};


/** IP camera or video encoder providing a live stream and recordings, associated with a place */
export type qx_VideoSourcelatestSnapshotsArgs = {
  distinct_on?: Array<qx_Snapshot_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Snapshot_order_by>;
  where?: qx_Snapshot_bool_exp;
};


/** IP camera or video encoder providing a live stream and recordings, associated with a place */
export type qx_VideoSourcemediaProfilesArgs = {
  distinct_on?: Array<qx_MediaProfile_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MediaProfile_order_by>;
  where?: qx_MediaProfile_bool_exp;
};


/** IP camera or video encoder providing a live stream and recordings, associated with a place */
export type qx_VideoSourcemediaProfiles_aggregateArgs = {
  distinct_on?: Array<qx_MediaProfile_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MediaProfile_order_by>;
  where?: qx_MediaProfile_bool_exp;
};


/** IP camera or video encoder providing a live stream and recordings, associated with a place */
export type qx_VideoSourcenewestMediaArgs = {
  distinct_on?: Array<qx_vNewestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vNewestMedia_order_by>;
  where?: qx_vNewestMedia_bool_exp;
};


/** IP camera or video encoder providing a live stream and recordings, associated with a place */
export type qx_VideoSourceoldestMediaArgs = {
  distinct_on?: Array<qx_vOldestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vOldestMedia_order_by>;
  where?: qx_vOldestMedia_bool_exp;
};


/** IP camera or video encoder providing a live stream and recordings, associated with a place */
export type qx_VideoSourceprivilegesArgs = {
  distinct_on?: Array<personVideoSourceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personVideoSourceAppPrivileges_order_by>;
  where?: personVideoSourceAppPrivileges_bool_exp;
};


/** IP camera or video encoder providing a live stream and recordings, associated with a place */
export type qx_VideoSourceprivileges_aggregateArgs = {
  distinct_on?: Array<personVideoSourceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personVideoSourceAppPrivileges_order_by>;
  where?: personVideoSourceAppPrivileges_bool_exp;
};


/** IP camera or video encoder providing a live stream and recordings, associated with a place */
export type qx_VideoSourceptzSettingsArgs = {
  path?: string;
};


/** IP camera or video encoder providing a live stream and recordings, associated with a place */
export type qx_VideoSourcesnapshotsArgs = {
  distinct_on?: Array<qx_Snapshot_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Snapshot_order_by>;
  where?: qx_Snapshot_bool_exp;
};


/** IP camera or video encoder providing a live stream and recordings, associated with a place */
export type qx_VideoSourcesnapshots_aggregateArgs = {
  distinct_on?: Array<qx_Snapshot_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Snapshot_order_by>;
  where?: qx_Snapshot_bool_exp;
};


/** IP camera or video encoder providing a live stream and recordings, associated with a place */
export type qx_VideoSourcevideoSourceStorageAuditsArgs = {
  distinct_on?: Array<qx_VideoSourceStorageAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_VideoSourceStorageAudit_order_by>;
  where?: qx_VideoSourceStorageAudit_bool_exp;
};


/** IP camera or video encoder providing a live stream and recordings, associated with a place */
export type qx_VideoSourcevideoSourceStorageAudits_aggregateArgs = {
  distinct_on?: Array<qx_VideoSourceStorageAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_VideoSourceStorageAudit_order_by>;
  where?: qx_VideoSourceStorageAudit_bool_exp;
};

/** historical record of cloud storage retention setting changes for a video source, including the effective date range and storage duration values */
export type qx_VideoSourceStorageAudit = {
  __typename?: 'qx_VideoSourceStorageAudit';
  cloudStorageDays: number;
  cloudStorageTimelapseDays: number;
  createdAt: string;
  createdBy?: string;
  end?: string;
  id: string;
  start: string;
  /** An object relationship */
  videoSource: qx_VideoSource;
  videoSourceID: string;
};

/** aggregated selection of "qx.VideoSourceStorageAudit" */
export type qx_VideoSourceStorageAudit_aggregate = {
  __typename?: 'qx_VideoSourceStorageAudit_aggregate';
  aggregate?: qx_VideoSourceStorageAudit_aggregate_fields;
  nodes: Array<qx_VideoSourceStorageAudit>;
};

export type qx_VideoSourceStorageAudit_aggregate_bool_exp = {
  count?: qx_VideoSourceStorageAudit_aggregate_bool_exp_count;
};

export type qx_VideoSourceStorageAudit_aggregate_bool_exp_count = {
  arguments?: Array<qx_VideoSourceStorageAudit_select_column>;
  distinct?: boolean;
  filter?: qx_VideoSourceStorageAudit_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.VideoSourceStorageAudit" */
export type qx_VideoSourceStorageAudit_aggregate_fields = {
  __typename?: 'qx_VideoSourceStorageAudit_aggregate_fields';
  avg?: qx_VideoSourceStorageAudit_avg_fields;
  count: number;
  max?: qx_VideoSourceStorageAudit_max_fields;
  min?: qx_VideoSourceStorageAudit_min_fields;
  stddev?: qx_VideoSourceStorageAudit_stddev_fields;
  stddev_pop?: qx_VideoSourceStorageAudit_stddev_pop_fields;
  stddev_samp?: qx_VideoSourceStorageAudit_stddev_samp_fields;
  sum?: qx_VideoSourceStorageAudit_sum_fields;
  var_pop?: qx_VideoSourceStorageAudit_var_pop_fields;
  var_samp?: qx_VideoSourceStorageAudit_var_samp_fields;
  variance?: qx_VideoSourceStorageAudit_variance_fields;
};


/** aggregate fields of "qx.VideoSourceStorageAudit" */
export type qx_VideoSourceStorageAudit_aggregate_fieldscountArgs = {
  columns?: Array<qx_VideoSourceStorageAudit_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.VideoSourceStorageAudit" */
export type qx_VideoSourceStorageAudit_aggregate_order_by = {
  avg?: qx_VideoSourceStorageAudit_avg_order_by;
  count?: order_by;
  max?: qx_VideoSourceStorageAudit_max_order_by;
  min?: qx_VideoSourceStorageAudit_min_order_by;
  stddev?: qx_VideoSourceStorageAudit_stddev_order_by;
  stddev_pop?: qx_VideoSourceStorageAudit_stddev_pop_order_by;
  stddev_samp?: qx_VideoSourceStorageAudit_stddev_samp_order_by;
  sum?: qx_VideoSourceStorageAudit_sum_order_by;
  var_pop?: qx_VideoSourceStorageAudit_var_pop_order_by;
  var_samp?: qx_VideoSourceStorageAudit_var_samp_order_by;
  variance?: qx_VideoSourceStorageAudit_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.VideoSourceStorageAudit" */
export type qx_VideoSourceStorageAudit_arr_rel_insert_input = {
  data: Array<qx_VideoSourceStorageAudit_insert_input>;
  /** upsert condition */
  on_conflict?: qx_VideoSourceStorageAudit_on_conflict;
};

/** aggregate avg on columns */
export type qx_VideoSourceStorageAudit_avg_fields = {
  __typename?: 'qx_VideoSourceStorageAudit_avg_fields';
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  videoSourceID?: number;
};

/** order by avg() on columns of table "qx.VideoSourceStorageAudit" */
export type qx_VideoSourceStorageAudit_avg_order_by = {
  cloudStorageDays?: order_by;
  cloudStorageTimelapseDays?: order_by;
  videoSourceID?: order_by;
};

/** Boolean expression to filter rows from the table "qx.VideoSourceStorageAudit". All fields are combined with a logical 'AND'. */
export type qx_VideoSourceStorageAudit_bool_exp = {
  _and?: Array<qx_VideoSourceStorageAudit_bool_exp>;
  _not?: qx_VideoSourceStorageAudit_bool_exp;
  _or?: Array<qx_VideoSourceStorageAudit_bool_exp>;
  cloudStorageDays?: Int_comparison_exp;
  cloudStorageTimelapseDays?: Int_comparison_exp;
  createdAt?: timestamptz_comparison_exp;
  createdBy?: String_comparison_exp;
  end?: timestamptz_comparison_exp;
  id?: String_comparison_exp;
  start?: timestamptz_comparison_exp;
  videoSource?: qx_VideoSource_bool_exp;
  videoSourceID?: bigint_comparison_exp;
};

/** unique or primary key constraints on table "qx.VideoSourceStorageAudit" */
export enum qx_VideoSourceStorageAudit_constraint {
  /** unique or primary key constraint on columns "id" */
  VideoSourceStorageAudit_pk = 'VideoSourceStorageAudit_pk',
  /** unique or primary key constraint on columns "videoSourceID" */
  idx_VideoSourceStorageAudit_null_start = 'idx_VideoSourceStorageAudit_null_start'
}

/** input type for incrementing numeric columns in table "qx.VideoSourceStorageAudit" */
export type qx_VideoSourceStorageAudit_inc_input = {
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  videoSourceID?: string;
};

/** input type for inserting data into table "qx.VideoSourceStorageAudit" */
export type qx_VideoSourceStorageAudit_insert_input = {
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  createdAt?: string;
  createdBy?: string;
  end?: string;
  id?: string;
  start?: string;
  videoSource?: qx_VideoSource_obj_rel_insert_input;
  videoSourceID?: string;
};

/** aggregate max on columns */
export type qx_VideoSourceStorageAudit_max_fields = {
  __typename?: 'qx_VideoSourceStorageAudit_max_fields';
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  createdAt?: string;
  createdBy?: string;
  end?: string;
  id?: string;
  start?: string;
  videoSourceID?: string;
};

/** order by max() on columns of table "qx.VideoSourceStorageAudit" */
export type qx_VideoSourceStorageAudit_max_order_by = {
  cloudStorageDays?: order_by;
  cloudStorageTimelapseDays?: order_by;
  createdAt?: order_by;
  createdBy?: order_by;
  end?: order_by;
  id?: order_by;
  start?: order_by;
  videoSourceID?: order_by;
};

/** aggregate min on columns */
export type qx_VideoSourceStorageAudit_min_fields = {
  __typename?: 'qx_VideoSourceStorageAudit_min_fields';
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  createdAt?: string;
  createdBy?: string;
  end?: string;
  id?: string;
  start?: string;
  videoSourceID?: string;
};

/** order by min() on columns of table "qx.VideoSourceStorageAudit" */
export type qx_VideoSourceStorageAudit_min_order_by = {
  cloudStorageDays?: order_by;
  cloudStorageTimelapseDays?: order_by;
  createdAt?: order_by;
  createdBy?: order_by;
  end?: order_by;
  id?: order_by;
  start?: order_by;
  videoSourceID?: order_by;
};

/** response of any mutation on the table "qx.VideoSourceStorageAudit" */
export type qx_VideoSourceStorageAudit_mutation_response = {
  __typename?: 'qx_VideoSourceStorageAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_VideoSourceStorageAudit>;
};

/** on_conflict condition type for table "qx.VideoSourceStorageAudit" */
export type qx_VideoSourceStorageAudit_on_conflict = {
  constraint: qx_VideoSourceStorageAudit_constraint;
  update_columns?: Array<qx_VideoSourceStorageAudit_update_column>;
  where?: qx_VideoSourceStorageAudit_bool_exp;
};

/** Ordering options when selecting data from "qx.VideoSourceStorageAudit". */
export type qx_VideoSourceStorageAudit_order_by = {
  cloudStorageDays?: order_by;
  cloudStorageTimelapseDays?: order_by;
  createdAt?: order_by;
  createdBy?: order_by;
  end?: order_by;
  id?: order_by;
  start?: order_by;
  videoSource?: qx_VideoSource_order_by;
  videoSourceID?: order_by;
};

/** primary key columns input for table: qx.VideoSourceStorageAudit */
export type qx_VideoSourceStorageAudit_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.VideoSourceStorageAudit" */
export enum qx_VideoSourceStorageAudit_select_column {
  /** column name */
  cloudStorageDays = 'cloudStorageDays',
  /** column name */
  cloudStorageTimelapseDays = 'cloudStorageTimelapseDays',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdBy = 'createdBy',
  /** column name */
  end = 'end',
  /** column name */
  id = 'id',
  /** column name */
  start = 'start',
  /** column name */
  videoSourceID = 'videoSourceID'
}

/** input type for updating data in table "qx.VideoSourceStorageAudit" */
export type qx_VideoSourceStorageAudit_set_input = {
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  createdAt?: string;
  createdBy?: string;
  end?: string;
  id?: string;
  start?: string;
  videoSourceID?: string;
};

/** aggregate stddev on columns */
export type qx_VideoSourceStorageAudit_stddev_fields = {
  __typename?: 'qx_VideoSourceStorageAudit_stddev_fields';
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  videoSourceID?: number;
};

/** order by stddev() on columns of table "qx.VideoSourceStorageAudit" */
export type qx_VideoSourceStorageAudit_stddev_order_by = {
  cloudStorageDays?: order_by;
  cloudStorageTimelapseDays?: order_by;
  videoSourceID?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_VideoSourceStorageAudit_stddev_pop_fields = {
  __typename?: 'qx_VideoSourceStorageAudit_stddev_pop_fields';
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  videoSourceID?: number;
};

/** order by stddev_pop() on columns of table "qx.VideoSourceStorageAudit" */
export type qx_VideoSourceStorageAudit_stddev_pop_order_by = {
  cloudStorageDays?: order_by;
  cloudStorageTimelapseDays?: order_by;
  videoSourceID?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_VideoSourceStorageAudit_stddev_samp_fields = {
  __typename?: 'qx_VideoSourceStorageAudit_stddev_samp_fields';
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  videoSourceID?: number;
};

/** order by stddev_samp() on columns of table "qx.VideoSourceStorageAudit" */
export type qx_VideoSourceStorageAudit_stddev_samp_order_by = {
  cloudStorageDays?: order_by;
  cloudStorageTimelapseDays?: order_by;
  videoSourceID?: order_by;
};

/** Streaming cursor of the table "qx_VideoSourceStorageAudit" */
export type qx_VideoSourceStorageAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_VideoSourceStorageAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_VideoSourceStorageAudit_stream_cursor_value_input = {
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  createdAt?: string;
  createdBy?: string;
  end?: string;
  id?: string;
  start?: string;
  videoSourceID?: string;
};

/** aggregate sum on columns */
export type qx_VideoSourceStorageAudit_sum_fields = {
  __typename?: 'qx_VideoSourceStorageAudit_sum_fields';
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  videoSourceID?: string;
};

/** order by sum() on columns of table "qx.VideoSourceStorageAudit" */
export type qx_VideoSourceStorageAudit_sum_order_by = {
  cloudStorageDays?: order_by;
  cloudStorageTimelapseDays?: order_by;
  videoSourceID?: order_by;
};

/** update columns of table "qx.VideoSourceStorageAudit" */
export enum qx_VideoSourceStorageAudit_update_column {
  /** column name */
  cloudStorageDays = 'cloudStorageDays',
  /** column name */
  cloudStorageTimelapseDays = 'cloudStorageTimelapseDays',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  createdBy = 'createdBy',
  /** column name */
  end = 'end',
  /** column name */
  id = 'id',
  /** column name */
  start = 'start',
  /** column name */
  videoSourceID = 'videoSourceID'
}

export type qx_VideoSourceStorageAudit_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_VideoSourceStorageAudit_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_VideoSourceStorageAudit_set_input;
  /** filter the rows which have to be updated */
  where: qx_VideoSourceStorageAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_VideoSourceStorageAudit_var_pop_fields = {
  __typename?: 'qx_VideoSourceStorageAudit_var_pop_fields';
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  videoSourceID?: number;
};

/** order by var_pop() on columns of table "qx.VideoSourceStorageAudit" */
export type qx_VideoSourceStorageAudit_var_pop_order_by = {
  cloudStorageDays?: order_by;
  cloudStorageTimelapseDays?: order_by;
  videoSourceID?: order_by;
};

/** aggregate var_samp on columns */
export type qx_VideoSourceStorageAudit_var_samp_fields = {
  __typename?: 'qx_VideoSourceStorageAudit_var_samp_fields';
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  videoSourceID?: number;
};

/** order by var_samp() on columns of table "qx.VideoSourceStorageAudit" */
export type qx_VideoSourceStorageAudit_var_samp_order_by = {
  cloudStorageDays?: order_by;
  cloudStorageTimelapseDays?: order_by;
  videoSourceID?: order_by;
};

/** aggregate variance on columns */
export type qx_VideoSourceStorageAudit_variance_fields = {
  __typename?: 'qx_VideoSourceStorageAudit_variance_fields';
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  videoSourceID?: number;
};

/** order by variance() on columns of table "qx.VideoSourceStorageAudit" */
export type qx_VideoSourceStorageAudit_variance_order_by = {
  cloudStorageDays?: order_by;
  cloudStorageTimelapseDays?: order_by;
  videoSourceID?: order_by;
};

/** aggregated selection of "qx.VideoSource" */
export type qx_VideoSource_aggregate = {
  __typename?: 'qx_VideoSource_aggregate';
  aggregate?: qx_VideoSource_aggregate_fields;
  nodes: Array<qx_VideoSource>;
};

export type qx_VideoSource_aggregate_bool_exp = {
  bool_and?: qx_VideoSource_aggregate_bool_exp_bool_and;
  bool_or?: qx_VideoSource_aggregate_bool_exp_bool_or;
  count?: qx_VideoSource_aggregate_bool_exp_count;
};

export type qx_VideoSource_aggregate_bool_exp_bool_and = {
  arguments: qx_VideoSource_select_column_qx_VideoSource_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: boolean;
  filter?: qx_VideoSource_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_VideoSource_aggregate_bool_exp_bool_or = {
  arguments: qx_VideoSource_select_column_qx_VideoSource_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: boolean;
  filter?: qx_VideoSource_bool_exp;
  predicate: Boolean_comparison_exp;
};

export type qx_VideoSource_aggregate_bool_exp_count = {
  arguments?: Array<qx_VideoSource_select_column>;
  distinct?: boolean;
  filter?: qx_VideoSource_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.VideoSource" */
export type qx_VideoSource_aggregate_fields = {
  __typename?: 'qx_VideoSource_aggregate_fields';
  avg?: qx_VideoSource_avg_fields;
  count: number;
  max?: qx_VideoSource_max_fields;
  min?: qx_VideoSource_min_fields;
  stddev?: qx_VideoSource_stddev_fields;
  stddev_pop?: qx_VideoSource_stddev_pop_fields;
  stddev_samp?: qx_VideoSource_stddev_samp_fields;
  sum?: qx_VideoSource_sum_fields;
  var_pop?: qx_VideoSource_var_pop_fields;
  var_samp?: qx_VideoSource_var_samp_fields;
  variance?: qx_VideoSource_variance_fields;
};


/** aggregate fields of "qx.VideoSource" */
export type qx_VideoSource_aggregate_fieldscountArgs = {
  columns?: Array<qx_VideoSource_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.VideoSource" */
export type qx_VideoSource_aggregate_order_by = {
  avg?: qx_VideoSource_avg_order_by;
  count?: order_by;
  max?: qx_VideoSource_max_order_by;
  min?: qx_VideoSource_min_order_by;
  stddev?: qx_VideoSource_stddev_order_by;
  stddev_pop?: qx_VideoSource_stddev_pop_order_by;
  stddev_samp?: qx_VideoSource_stddev_samp_order_by;
  sum?: qx_VideoSource_sum_order_by;
  var_pop?: qx_VideoSource_var_pop_order_by;
  var_samp?: qx_VideoSource_var_samp_order_by;
  variance?: qx_VideoSource_variance_order_by;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type qx_VideoSource_append_input = {
  displaySettings?: any;
  imagingOptions?: any;
  imagingSettings?: any;
  ptzSettings?: any;
};

/** input type for inserting array relation for remote table "qx.VideoSource" */
export type qx_VideoSource_arr_rel_insert_input = {
  data: Array<qx_VideoSource_insert_input>;
  /** upsert condition */
  on_conflict?: qx_VideoSource_on_conflict;
};

/** aggregate avg on columns */
export type qx_VideoSource_avg_fields = {
  __typename?: 'qx_VideoSource_avg_fields';
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  fps?: number;
  id?: number;
  localStorageDays?: number;
  minLikelihood?: number;
  snapshotMediaProfileID?: number;
  timelapseInterval?: number;
};

/** order by avg() on columns of table "qx.VideoSource" */
export type qx_VideoSource_avg_order_by = {
  cloudStorageDays?: order_by;
  cloudStorageTimelapseDays?: order_by;
  fps?: order_by;
  id?: order_by;
  localStorageDays?: order_by;
  minLikelihood?: order_by;
  snapshotMediaProfileID?: order_by;
  timelapseInterval?: order_by;
};

/** Boolean expression to filter rows from the table "qx.VideoSource". All fields are combined with a logical 'AND'. */
export type qx_VideoSource_bool_exp = {
  CloudStorageOption?: qx_CloudStorageOptions_bool_exp;
  Doors?: qx_Door_bool_exp;
  Doors_aggregate?: qx_Door_aggregate_bool_exp;
  _and?: Array<qx_VideoSource_bool_exp>;
  _not?: qx_VideoSource_bool_exp;
  _or?: Array<qx_VideoSource_bool_exp>;
  audioSources?: audioSourceVideoSource_bool_exp;
  audioSources_aggregate?: audioSourceVideoSource_aggregate_bool_exp;
  canOperate?: Boolean_comparison_exp;
  cloudStorageAvailable?: String_comparison_exp;
  cloudStorageDays?: Int_comparison_exp;
  cloudStorageMax?: String_comparison_exp;
  cloudStorageTimelapseDays?: Int_comparison_exp;
  cloudStorageUsed?: String_comparison_exp;
  createdAt?: timestamptz_comparison_exp;
  description?: String_comparison_exp;
  device?: qx_Device_bool_exp;
  deviceConnectionStatus?: String_comparison_exp;
  deviceID?: String_comparison_exp;
  devicePacStatus?: String_comparison_exp;
  devicePacsHWUpdate?: String_comparison_exp;
  dewarpProfile?: qx_LensProfile_bool_exp;
  disabledByLicense?: Boolean_comparison_exp;
  displaySettings?: jsonb_comparison_exp;
  eMountPosition?: qx_eMountPosition_bool_exp;
  enabled?: Boolean_comparison_exp;
  events?: qx_Event_bool_exp;
  events_aggregate?: qx_Event_aggregate_bool_exp;
  fps?: Float_comparison_exp;
  gatewayConnectionStatus?: Boolean_comparison_exp;
  gatewayID?: String_comparison_exp;
  gatewayPlaceID?: String_comparison_exp;
  gatewaySyncStatus?: String_comparison_exp;
  id?: bigint_comparison_exp;
  imageSize?: String_comparison_exp;
  imagingOptions?: jsonb_comparison_exp;
  imagingSettings?: jsonb_comparison_exp;
  isBillable?: Boolean_comparison_exp;
  latestSnapshots?: qx_Snapshot_bool_exp;
  localStorageDays?: Int_comparison_exp;
  mediaProfiles?: qx_MediaProfile_bool_exp;
  mediaProfiles_aggregate?: qx_MediaProfile_aggregate_bool_exp;
  metadataEnabled?: Boolean_comparison_exp;
  minLikelihood?: Int_comparison_exp;
  mountPosition?: qx_eMountPosition_enum_comparison_exp;
  name?: String_comparison_exp;
  newestMedia?: qx_vNewestMedia_bool_exp;
  oldestMedia?: qx_vOldestMedia_bool_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
  privileges?: personVideoSourceAppPrivileges_bool_exp;
  privileges_aggregate?: personVideoSourceAppPrivileges_aggregate_bool_exp;
  profileMSupported?: Boolean_comparison_exp;
  ptzSettings?: jsonb_comparison_exp;
  refID?: String_comparison_exp;
  schedule?: qx_Schedule_bool_exp;
  scheduleID?: String_comparison_exp;
  searchText?: String_comparison_exp;
  snapshotMediaProfileID?: bigint_comparison_exp;
  snapshots?: qx_Snapshot_bool_exp;
  snapshots_aggregate?: qx_Snapshot_aggregate_bool_exp;
  state?: videoSourceState_bool_exp;
  tamperActive?: Boolean_comparison_exp;
  timelapseInterval?: Int_comparison_exp;
  timezone?: String_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
  videoSourceStorageAudits?: qx_VideoSourceStorageAudit_bool_exp;
  videoSourceStorageAudits_aggregate?: qx_VideoSourceStorageAudit_aggregate_bool_exp;
};

/** unique or primary key constraints on table "qx.VideoSource" */
export enum qx_VideoSource_constraint {
  /** unique or primary key constraint on columns "refID", "deviceID" */
  VideoSource_deviceID_refID_constraint = 'VideoSource_deviceID_refID_constraint',
  /** unique or primary key constraint on columns "id" */
  VideoSource_pkey = 'VideoSource_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type qx_VideoSource_delete_at_path_input = {
  displaySettings?: Array<string>;
  imagingOptions?: Array<string>;
  imagingSettings?: Array<string>;
  ptzSettings?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type qx_VideoSource_delete_elem_input = {
  displaySettings?: number;
  imagingOptions?: number;
  imagingSettings?: number;
  ptzSettings?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type qx_VideoSource_delete_key_input = {
  displaySettings?: string;
  imagingOptions?: string;
  imagingSettings?: string;
  ptzSettings?: string;
};

/** input type for incrementing numeric columns in table "qx.VideoSource" */
export type qx_VideoSource_inc_input = {
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  fps?: number;
  id?: string;
  localStorageDays?: number;
  minLikelihood?: number;
  snapshotMediaProfileID?: string;
  timelapseInterval?: number;
};

/** input type for inserting data into table "qx.VideoSource" */
export type qx_VideoSource_insert_input = {
  CloudStorageOption?: qx_CloudStorageOptions_obj_rel_insert_input;
  Doors?: qx_Door_arr_rel_insert_input;
  audioSources?: audioSourceVideoSource_arr_rel_insert_input;
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  createdAt?: string;
  description?: string;
  device?: qx_Device_obj_rel_insert_input;
  deviceID?: string;
  disabledByLicense?: boolean;
  displaySettings?: any;
  eMountPosition?: qx_eMountPosition_obj_rel_insert_input;
  enabled?: boolean;
  events?: qx_Event_arr_rel_insert_input;
  fps?: number;
  id?: string;
  imageSize?: string;
  imagingOptions?: any;
  imagingSettings?: any;
  isBillable?: boolean;
  localStorageDays?: number;
  mediaProfiles?: qx_MediaProfile_arr_rel_insert_input;
  metadataEnabled?: boolean;
  minLikelihood?: number;
  mountPosition?: qx_eMountPosition_enum;
  name?: string;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
  privileges?: personVideoSourceAppPrivileges_arr_rel_insert_input;
  ptzSettings?: any;
  refID?: string;
  schedule?: qx_Schedule_obj_rel_insert_input;
  scheduleID?: string;
  searchText?: string;
  snapshotMediaProfileID?: string;
  snapshots?: qx_Snapshot_arr_rel_insert_input;
  state?: videoSourceState_obj_rel_insert_input;
  tamperActive?: boolean;
  timelapseInterval?: number;
  updatedAt?: string;
  videoSourceStorageAudits?: qx_VideoSourceStorageAudit_arr_rel_insert_input;
};

/** aggregate max on columns */
export type qx_VideoSource_max_fields = {
  __typename?: 'qx_VideoSource_max_fields';
  cloudStorageAvailable?: string;
  cloudStorageDays?: number;
  cloudStorageMax?: string;
  cloudStorageTimelapseDays?: number;
  cloudStorageUsed?: string;
  createdAt?: string;
  description?: string;
  /** A computed field, executes function "qx.get_video_source_device_connectionStatus" */
  deviceConnectionStatus?: string;
  deviceID?: string;
  /** A computed field, executes function "qx.get_video_source_device_pacsStatus" */
  devicePacStatus?: string;
  /** A computed field, executes function "qx.get_video_source_device_pacsHWUpdate" */
  devicePacsHWUpdate?: string;
  fps?: number;
  /** A computed field, executes function "qx.get_video_source_gateway_id" */
  gatewayID?: string;
  /** A computed field, executes function "qx.get_video_source_gateway_placeID" */
  gatewayPlaceID?: string;
  /** A computed field, executes function "qx.get_video_source_device_gateway_syncStatus" */
  gatewaySyncStatus?: string;
  id?: string;
  imageSize?: string;
  localStorageDays?: number;
  minLikelihood?: number;
  name?: string;
  placeID?: string;
  refID?: string;
  scheduleID?: string;
  searchText?: string;
  snapshotMediaProfileID?: string;
  timelapseInterval?: number;
  /** A computed field, executes function "qx.get_video_source_timezone" */
  timezone?: string;
  updatedAt?: string;
};

/** order by max() on columns of table "qx.VideoSource" */
export type qx_VideoSource_max_order_by = {
  cloudStorageDays?: order_by;
  cloudStorageTimelapseDays?: order_by;
  createdAt?: order_by;
  description?: order_by;
  deviceID?: order_by;
  fps?: order_by;
  id?: order_by;
  imageSize?: order_by;
  localStorageDays?: order_by;
  minLikelihood?: order_by;
  name?: order_by;
  placeID?: order_by;
  refID?: order_by;
  scheduleID?: order_by;
  searchText?: order_by;
  snapshotMediaProfileID?: order_by;
  timelapseInterval?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type qx_VideoSource_min_fields = {
  __typename?: 'qx_VideoSource_min_fields';
  cloudStorageAvailable?: string;
  cloudStorageDays?: number;
  cloudStorageMax?: string;
  cloudStorageTimelapseDays?: number;
  cloudStorageUsed?: string;
  createdAt?: string;
  description?: string;
  /** A computed field, executes function "qx.get_video_source_device_connectionStatus" */
  deviceConnectionStatus?: string;
  deviceID?: string;
  /** A computed field, executes function "qx.get_video_source_device_pacsStatus" */
  devicePacStatus?: string;
  /** A computed field, executes function "qx.get_video_source_device_pacsHWUpdate" */
  devicePacsHWUpdate?: string;
  fps?: number;
  /** A computed field, executes function "qx.get_video_source_gateway_id" */
  gatewayID?: string;
  /** A computed field, executes function "qx.get_video_source_gateway_placeID" */
  gatewayPlaceID?: string;
  /** A computed field, executes function "qx.get_video_source_device_gateway_syncStatus" */
  gatewaySyncStatus?: string;
  id?: string;
  imageSize?: string;
  localStorageDays?: number;
  minLikelihood?: number;
  name?: string;
  placeID?: string;
  refID?: string;
  scheduleID?: string;
  searchText?: string;
  snapshotMediaProfileID?: string;
  timelapseInterval?: number;
  /** A computed field, executes function "qx.get_video_source_timezone" */
  timezone?: string;
  updatedAt?: string;
};

/** order by min() on columns of table "qx.VideoSource" */
export type qx_VideoSource_min_order_by = {
  cloudStorageDays?: order_by;
  cloudStorageTimelapseDays?: order_by;
  createdAt?: order_by;
  description?: order_by;
  deviceID?: order_by;
  fps?: order_by;
  id?: order_by;
  imageSize?: order_by;
  localStorageDays?: order_by;
  minLikelihood?: order_by;
  name?: order_by;
  placeID?: order_by;
  refID?: order_by;
  scheduleID?: order_by;
  searchText?: order_by;
  snapshotMediaProfileID?: order_by;
  timelapseInterval?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.VideoSource" */
export type qx_VideoSource_mutation_response = {
  __typename?: 'qx_VideoSource_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_VideoSource>;
};

/** input type for inserting object relation for remote table "qx.VideoSource" */
export type qx_VideoSource_obj_rel_insert_input = {
  data: qx_VideoSource_insert_input;
  /** upsert condition */
  on_conflict?: qx_VideoSource_on_conflict;
};

/** on_conflict condition type for table "qx.VideoSource" */
export type qx_VideoSource_on_conflict = {
  constraint: qx_VideoSource_constraint;
  update_columns?: Array<qx_VideoSource_update_column>;
  where?: qx_VideoSource_bool_exp;
};

/** Ordering options when selecting data from "qx.VideoSource". */
export type qx_VideoSource_order_by = {
  CloudStorageOption?: qx_CloudStorageOptions_order_by;
  Doors_aggregate?: qx_Door_aggregate_order_by;
  audioSources_aggregate?: audioSourceVideoSource_aggregate_order_by;
  canOperate?: order_by;
  cloudStorageAvailable?: order_by;
  cloudStorageDays?: order_by;
  cloudStorageMax?: order_by;
  cloudStorageTimelapseDays?: order_by;
  cloudStorageUsed?: order_by;
  createdAt?: order_by;
  description?: order_by;
  device?: qx_Device_order_by;
  deviceConnectionStatus?: order_by;
  deviceID?: order_by;
  devicePacStatus?: order_by;
  devicePacsHWUpdate?: order_by;
  dewarpProfile_aggregate?: qx_LensProfile_aggregate_order_by;
  disabledByLicense?: order_by;
  displaySettings?: order_by;
  eMountPosition?: qx_eMountPosition_order_by;
  enabled?: order_by;
  events_aggregate?: qx_Event_aggregate_order_by;
  fps?: order_by;
  gatewayConnectionStatus?: order_by;
  gatewayID?: order_by;
  gatewayPlaceID?: order_by;
  gatewaySyncStatus?: order_by;
  id?: order_by;
  imageSize?: order_by;
  imagingOptions?: order_by;
  imagingSettings?: order_by;
  isBillable?: order_by;
  latestSnapshots_aggregate?: qx_Snapshot_aggregate_order_by;
  localStorageDays?: order_by;
  mediaProfiles_aggregate?: qx_MediaProfile_aggregate_order_by;
  metadataEnabled?: order_by;
  minLikelihood?: order_by;
  mountPosition?: order_by;
  name?: order_by;
  newestMedia_aggregate?: qx_vNewestMedia_aggregate_order_by;
  oldestMedia_aggregate?: qx_vOldestMedia_aggregate_order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
  privileges_aggregate?: personVideoSourceAppPrivileges_aggregate_order_by;
  profileMSupported?: order_by;
  ptzSettings?: order_by;
  refID?: order_by;
  schedule?: qx_Schedule_order_by;
  scheduleID?: order_by;
  searchText?: order_by;
  snapshotMediaProfileID?: order_by;
  snapshots_aggregate?: qx_Snapshot_aggregate_order_by;
  state?: videoSourceState_order_by;
  tamperActive?: order_by;
  timelapseInterval?: order_by;
  timezone?: order_by;
  updatedAt?: order_by;
  videoSourceStorageAudits_aggregate?: qx_VideoSourceStorageAudit_aggregate_order_by;
};

/** primary key columns input for table: qx.VideoSource */
export type qx_VideoSource_pk_columns_input = {
  id: string;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type qx_VideoSource_prepend_input = {
  displaySettings?: any;
  imagingOptions?: any;
  imagingSettings?: any;
  ptzSettings?: any;
};

/** select columns of table "qx.VideoSource" */
export enum qx_VideoSource_select_column {
  /** column name */
  cloudStorageDays = 'cloudStorageDays',
  /** column name */
  cloudStorageTimelapseDays = 'cloudStorageTimelapseDays',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  description = 'description',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  disabledByLicense = 'disabledByLicense',
  /** column name */
  displaySettings = 'displaySettings',
  /** column name */
  enabled = 'enabled',
  /** column name */
  fps = 'fps',
  /** column name */
  id = 'id',
  /** column name */
  imageSize = 'imageSize',
  /** column name */
  imagingOptions = 'imagingOptions',
  /** column name */
  imagingSettings = 'imagingSettings',
  /** column name */
  isBillable = 'isBillable',
  /** column name */
  localStorageDays = 'localStorageDays',
  /** column name */
  metadataEnabled = 'metadataEnabled',
  /** column name */
  minLikelihood = 'minLikelihood',
  /** column name */
  mountPosition = 'mountPosition',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  ptzSettings = 'ptzSettings',
  /** column name */
  refID = 'refID',
  /** column name */
  scheduleID = 'scheduleID',
  /** column name */
  searchText = 'searchText',
  /** column name */
  snapshotMediaProfileID = 'snapshotMediaProfileID',
  /** column name */
  tamperActive = 'tamperActive',
  /** column name */
  timelapseInterval = 'timelapseInterval',
  /** column name */
  updatedAt = 'updatedAt'
}

/** select "qx_VideoSource_aggregate_bool_exp_bool_and_arguments_columns" columns of table "qx.VideoSource" */
export enum qx_VideoSource_select_column_qx_VideoSource_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  disabledByLicense = 'disabledByLicense',
  /** column name */
  enabled = 'enabled',
  /** column name */
  isBillable = 'isBillable',
  /** column name */
  metadataEnabled = 'metadataEnabled',
  /** column name */
  tamperActive = 'tamperActive'
}

/** select "qx_VideoSource_aggregate_bool_exp_bool_or_arguments_columns" columns of table "qx.VideoSource" */
export enum qx_VideoSource_select_column_qx_VideoSource_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  disabledByLicense = 'disabledByLicense',
  /** column name */
  enabled = 'enabled',
  /** column name */
  isBillable = 'isBillable',
  /** column name */
  metadataEnabled = 'metadataEnabled',
  /** column name */
  tamperActive = 'tamperActive'
}

/** input type for updating data in table "qx.VideoSource" */
export type qx_VideoSource_set_input = {
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  createdAt?: string;
  description?: string;
  deviceID?: string;
  disabledByLicense?: boolean;
  displaySettings?: any;
  enabled?: boolean;
  fps?: number;
  id?: string;
  imageSize?: string;
  imagingOptions?: any;
  imagingSettings?: any;
  isBillable?: boolean;
  localStorageDays?: number;
  metadataEnabled?: boolean;
  minLikelihood?: number;
  mountPosition?: qx_eMountPosition_enum;
  name?: string;
  placeID?: string;
  ptzSettings?: any;
  refID?: string;
  scheduleID?: string;
  searchText?: string;
  snapshotMediaProfileID?: string;
  tamperActive?: boolean;
  timelapseInterval?: number;
  updatedAt?: string;
};

/** aggregate stddev on columns */
export type qx_VideoSource_stddev_fields = {
  __typename?: 'qx_VideoSource_stddev_fields';
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  fps?: number;
  id?: number;
  localStorageDays?: number;
  minLikelihood?: number;
  snapshotMediaProfileID?: number;
  timelapseInterval?: number;
};

/** order by stddev() on columns of table "qx.VideoSource" */
export type qx_VideoSource_stddev_order_by = {
  cloudStorageDays?: order_by;
  cloudStorageTimelapseDays?: order_by;
  fps?: order_by;
  id?: order_by;
  localStorageDays?: order_by;
  minLikelihood?: order_by;
  snapshotMediaProfileID?: order_by;
  timelapseInterval?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_VideoSource_stddev_pop_fields = {
  __typename?: 'qx_VideoSource_stddev_pop_fields';
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  fps?: number;
  id?: number;
  localStorageDays?: number;
  minLikelihood?: number;
  snapshotMediaProfileID?: number;
  timelapseInterval?: number;
};

/** order by stddev_pop() on columns of table "qx.VideoSource" */
export type qx_VideoSource_stddev_pop_order_by = {
  cloudStorageDays?: order_by;
  cloudStorageTimelapseDays?: order_by;
  fps?: order_by;
  id?: order_by;
  localStorageDays?: order_by;
  minLikelihood?: order_by;
  snapshotMediaProfileID?: order_by;
  timelapseInterval?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_VideoSource_stddev_samp_fields = {
  __typename?: 'qx_VideoSource_stddev_samp_fields';
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  fps?: number;
  id?: number;
  localStorageDays?: number;
  minLikelihood?: number;
  snapshotMediaProfileID?: number;
  timelapseInterval?: number;
};

/** order by stddev_samp() on columns of table "qx.VideoSource" */
export type qx_VideoSource_stddev_samp_order_by = {
  cloudStorageDays?: order_by;
  cloudStorageTimelapseDays?: order_by;
  fps?: order_by;
  id?: order_by;
  localStorageDays?: order_by;
  minLikelihood?: order_by;
  snapshotMediaProfileID?: order_by;
  timelapseInterval?: order_by;
};

/** Streaming cursor of the table "qx_VideoSource" */
export type qx_VideoSource_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_VideoSource_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_VideoSource_stream_cursor_value_input = {
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  createdAt?: string;
  description?: string;
  deviceID?: string;
  disabledByLicense?: boolean;
  displaySettings?: any;
  enabled?: boolean;
  fps?: number;
  id?: string;
  imageSize?: string;
  imagingOptions?: any;
  imagingSettings?: any;
  isBillable?: boolean;
  localStorageDays?: number;
  metadataEnabled?: boolean;
  minLikelihood?: number;
  mountPosition?: qx_eMountPosition_enum;
  name?: string;
  placeID?: string;
  ptzSettings?: any;
  refID?: string;
  scheduleID?: string;
  searchText?: string;
  snapshotMediaProfileID?: string;
  tamperActive?: boolean;
  timelapseInterval?: number;
  updatedAt?: string;
};

/** aggregate sum on columns */
export type qx_VideoSource_sum_fields = {
  __typename?: 'qx_VideoSource_sum_fields';
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  fps?: number;
  id?: string;
  localStorageDays?: number;
  minLikelihood?: number;
  snapshotMediaProfileID?: string;
  timelapseInterval?: number;
};

/** order by sum() on columns of table "qx.VideoSource" */
export type qx_VideoSource_sum_order_by = {
  cloudStorageDays?: order_by;
  cloudStorageTimelapseDays?: order_by;
  fps?: order_by;
  id?: order_by;
  localStorageDays?: order_by;
  minLikelihood?: order_by;
  snapshotMediaProfileID?: order_by;
  timelapseInterval?: order_by;
};

/** update columns of table "qx.VideoSource" */
export enum qx_VideoSource_update_column {
  /** column name */
  cloudStorageDays = 'cloudStorageDays',
  /** column name */
  cloudStorageTimelapseDays = 'cloudStorageTimelapseDays',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  description = 'description',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  disabledByLicense = 'disabledByLicense',
  /** column name */
  displaySettings = 'displaySettings',
  /** column name */
  enabled = 'enabled',
  /** column name */
  fps = 'fps',
  /** column name */
  id = 'id',
  /** column name */
  imageSize = 'imageSize',
  /** column name */
  imagingOptions = 'imagingOptions',
  /** column name */
  imagingSettings = 'imagingSettings',
  /** column name */
  isBillable = 'isBillable',
  /** column name */
  localStorageDays = 'localStorageDays',
  /** column name */
  metadataEnabled = 'metadataEnabled',
  /** column name */
  minLikelihood = 'minLikelihood',
  /** column name */
  mountPosition = 'mountPosition',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  ptzSettings = 'ptzSettings',
  /** column name */
  refID = 'refID',
  /** column name */
  scheduleID = 'scheduleID',
  /** column name */
  searchText = 'searchText',
  /** column name */
  snapshotMediaProfileID = 'snapshotMediaProfileID',
  /** column name */
  tamperActive = 'tamperActive',
  /** column name */
  timelapseInterval = 'timelapseInterval',
  /** column name */
  updatedAt = 'updatedAt'
}

export type qx_VideoSource_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: qx_VideoSource_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: qx_VideoSource_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: qx_VideoSource_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: qx_VideoSource_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_VideoSource_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: qx_VideoSource_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_VideoSource_set_input;
  /** filter the rows which have to be updated */
  where: qx_VideoSource_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_VideoSource_var_pop_fields = {
  __typename?: 'qx_VideoSource_var_pop_fields';
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  fps?: number;
  id?: number;
  localStorageDays?: number;
  minLikelihood?: number;
  snapshotMediaProfileID?: number;
  timelapseInterval?: number;
};

/** order by var_pop() on columns of table "qx.VideoSource" */
export type qx_VideoSource_var_pop_order_by = {
  cloudStorageDays?: order_by;
  cloudStorageTimelapseDays?: order_by;
  fps?: order_by;
  id?: order_by;
  localStorageDays?: order_by;
  minLikelihood?: order_by;
  snapshotMediaProfileID?: order_by;
  timelapseInterval?: order_by;
};

/** aggregate var_samp on columns */
export type qx_VideoSource_var_samp_fields = {
  __typename?: 'qx_VideoSource_var_samp_fields';
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  fps?: number;
  id?: number;
  localStorageDays?: number;
  minLikelihood?: number;
  snapshotMediaProfileID?: number;
  timelapseInterval?: number;
};

/** order by var_samp() on columns of table "qx.VideoSource" */
export type qx_VideoSource_var_samp_order_by = {
  cloudStorageDays?: order_by;
  cloudStorageTimelapseDays?: order_by;
  fps?: order_by;
  id?: order_by;
  localStorageDays?: order_by;
  minLikelihood?: order_by;
  snapshotMediaProfileID?: order_by;
  timelapseInterval?: order_by;
};

/** aggregate variance on columns */
export type qx_VideoSource_variance_fields = {
  __typename?: 'qx_VideoSource_variance_fields';
  cloudStorageDays?: number;
  cloudStorageTimelapseDays?: number;
  fps?: number;
  id?: number;
  localStorageDays?: number;
  minLikelihood?: number;
  snapshotMediaProfileID?: number;
  timelapseInterval?: number;
};

/** order by variance() on columns of table "qx.VideoSource" */
export type qx_VideoSource_variance_order_by = {
  cloudStorageDays?: order_by;
  cloudStorageTimelapseDays?: order_by;
  fps?: order_by;
  id?: order_by;
  localStorageDays?: order_by;
  minLikelihood?: order_by;
  snapshotMediaProfileID?: order_by;
  timelapseInterval?: order_by;
};

/** columns and relationships of "qx.View" */
export type qx_View = {
  __typename?: 'qx_View';
  createdAt: string;
  id: string;
  isDefault?: boolean;
  name: string;
  /** An object relationship */
  person?: qx_Person;
  personID?: string;
  /** An object relationship */
  place: qx_Place;
  placeID: string;
  /** An array relationship */
  placesAsDefault: Array<qx_Place>;
  /** An aggregate relationship */
  placesAsDefault_aggregate: qx_Place_aggregate;
  settings: any;
  snapshot?: string;
  snapshot_lg?: string;
  snapshot_md?: string;
  snapshot_sm?: string;
  snapshot_xl?: string;
  updatedAt?: string;
};


/** columns and relationships of "qx.View" */
export type qx_ViewplacesAsDefaultArgs = {
  distinct_on?: Array<qx_Place_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Place_order_by>;
  where?: qx_Place_bool_exp;
};


/** columns and relationships of "qx.View" */
export type qx_ViewplacesAsDefault_aggregateArgs = {
  distinct_on?: Array<qx_Place_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Place_order_by>;
  where?: qx_Place_bool_exp;
};


/** columns and relationships of "qx.View" */
export type qx_ViewsettingsArgs = {
  path?: string;
};

/** aggregated selection of "qx.View" */
export type qx_View_aggregate = {
  __typename?: 'qx_View_aggregate';
  aggregate?: qx_View_aggregate_fields;
  nodes: Array<qx_View>;
};

export type qx_View_aggregate_bool_exp = {
  count?: qx_View_aggregate_bool_exp_count;
};

export type qx_View_aggregate_bool_exp_count = {
  arguments?: Array<qx_View_select_column>;
  distinct?: boolean;
  filter?: qx_View_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.View" */
export type qx_View_aggregate_fields = {
  __typename?: 'qx_View_aggregate_fields';
  count: number;
  max?: qx_View_max_fields;
  min?: qx_View_min_fields;
};


/** aggregate fields of "qx.View" */
export type qx_View_aggregate_fieldscountArgs = {
  columns?: Array<qx_View_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.View" */
export type qx_View_aggregate_order_by = {
  count?: order_by;
  max?: qx_View_max_order_by;
  min?: qx_View_min_order_by;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type qx_View_append_input = {
  settings?: any;
};

/** input type for inserting array relation for remote table "qx.View" */
export type qx_View_arr_rel_insert_input = {
  data: Array<qx_View_insert_input>;
  /** upsert condition */
  on_conflict?: qx_View_on_conflict;
};

/** Boolean expression to filter rows from the table "qx.View". All fields are combined with a logical 'AND'. */
export type qx_View_bool_exp = {
  _and?: Array<qx_View_bool_exp>;
  _not?: qx_View_bool_exp;
  _or?: Array<qx_View_bool_exp>;
  createdAt?: timestamptz_comparison_exp;
  id?: String_comparison_exp;
  isDefault?: Boolean_comparison_exp;
  name?: String_comparison_exp;
  person?: qx_Person_bool_exp;
  personID?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
  placesAsDefault?: qx_Place_bool_exp;
  placesAsDefault_aggregate?: qx_Place_aggregate_bool_exp;
  settings?: jsonb_comparison_exp;
  snapshot?: String_comparison_exp;
  snapshot_lg?: String_comparison_exp;
  snapshot_md?: String_comparison_exp;
  snapshot_sm?: String_comparison_exp;
  snapshot_xl?: String_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
};

/** unique or primary key constraints on table "qx.View" */
export enum qx_View_constraint {
  /** unique or primary key constraint on columns "name", "placeID" */
  View_name_placeID_key = 'View_name_placeID_key',
  /** unique or primary key constraint on columns "id" */
  View_pkey = 'View_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type qx_View_delete_at_path_input = {
  settings?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type qx_View_delete_elem_input = {
  settings?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type qx_View_delete_key_input = {
  settings?: string;
};

/** input type for inserting data into table "qx.View" */
export type qx_View_insert_input = {
  createdAt?: string;
  id?: string;
  name?: string;
  person?: qx_Person_obj_rel_insert_input;
  personID?: string;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
  placesAsDefault?: qx_Place_arr_rel_insert_input;
  settings?: any;
  snapshot?: string;
  snapshot_lg?: string;
  snapshot_md?: string;
  snapshot_sm?: string;
  snapshot_xl?: string;
  updatedAt?: string;
};

/** aggregate max on columns */
export type qx_View_max_fields = {
  __typename?: 'qx_View_max_fields';
  createdAt?: string;
  id?: string;
  name?: string;
  personID?: string;
  placeID?: string;
  snapshot?: string;
  snapshot_lg?: string;
  snapshot_md?: string;
  snapshot_sm?: string;
  snapshot_xl?: string;
  updatedAt?: string;
};

/** order by max() on columns of table "qx.View" */
export type qx_View_max_order_by = {
  createdAt?: order_by;
  id?: order_by;
  name?: order_by;
  personID?: order_by;
  placeID?: order_by;
  snapshot?: order_by;
  snapshot_lg?: order_by;
  snapshot_md?: order_by;
  snapshot_sm?: order_by;
  snapshot_xl?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type qx_View_min_fields = {
  __typename?: 'qx_View_min_fields';
  createdAt?: string;
  id?: string;
  name?: string;
  personID?: string;
  placeID?: string;
  snapshot?: string;
  snapshot_lg?: string;
  snapshot_md?: string;
  snapshot_sm?: string;
  snapshot_xl?: string;
  updatedAt?: string;
};

/** order by min() on columns of table "qx.View" */
export type qx_View_min_order_by = {
  createdAt?: order_by;
  id?: order_by;
  name?: order_by;
  personID?: order_by;
  placeID?: order_by;
  snapshot?: order_by;
  snapshot_lg?: order_by;
  snapshot_md?: order_by;
  snapshot_sm?: order_by;
  snapshot_xl?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.View" */
export type qx_View_mutation_response = {
  __typename?: 'qx_View_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_View>;
};

/** input type for inserting object relation for remote table "qx.View" */
export type qx_View_obj_rel_insert_input = {
  data: qx_View_insert_input;
  /** upsert condition */
  on_conflict?: qx_View_on_conflict;
};

/** on_conflict condition type for table "qx.View" */
export type qx_View_on_conflict = {
  constraint: qx_View_constraint;
  update_columns?: Array<qx_View_update_column>;
  where?: qx_View_bool_exp;
};

/** Ordering options when selecting data from "qx.View". */
export type qx_View_order_by = {
  createdAt?: order_by;
  id?: order_by;
  isDefault?: order_by;
  name?: order_by;
  person?: qx_Person_order_by;
  personID?: order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
  placesAsDefault_aggregate?: qx_Place_aggregate_order_by;
  settings?: order_by;
  snapshot?: order_by;
  snapshot_lg?: order_by;
  snapshot_md?: order_by;
  snapshot_sm?: order_by;
  snapshot_xl?: order_by;
  updatedAt?: order_by;
};

/** primary key columns input for table: qx.View */
export type qx_View_pk_columns_input = {
  id: string;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type qx_View_prepend_input = {
  settings?: any;
};

/** select columns of table "qx.View" */
export enum qx_View_select_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  personID = 'personID',
  /** column name */
  placeID = 'placeID',
  /** column name */
  settings = 'settings',
  /** column name */
  snapshot = 'snapshot',
  /** column name */
  snapshot_lg = 'snapshot_lg',
  /** column name */
  snapshot_md = 'snapshot_md',
  /** column name */
  snapshot_sm = 'snapshot_sm',
  /** column name */
  snapshot_xl = 'snapshot_xl',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "qx.View" */
export type qx_View_set_input = {
  createdAt?: string;
  id?: string;
  name?: string;
  personID?: string;
  placeID?: string;
  settings?: any;
  snapshot?: string;
  snapshot_lg?: string;
  snapshot_md?: string;
  snapshot_sm?: string;
  snapshot_xl?: string;
  updatedAt?: string;
};

/** Streaming cursor of the table "qx_View" */
export type qx_View_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_View_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_View_stream_cursor_value_input = {
  createdAt?: string;
  id?: string;
  name?: string;
  personID?: string;
  placeID?: string;
  settings?: any;
  snapshot?: string;
  snapshot_lg?: string;
  snapshot_md?: string;
  snapshot_sm?: string;
  snapshot_xl?: string;
  updatedAt?: string;
};

/** update columns of table "qx.View" */
export enum qx_View_update_column {
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  personID = 'personID',
  /** column name */
  placeID = 'placeID',
  /** column name */
  settings = 'settings',
  /** column name */
  snapshot = 'snapshot',
  /** column name */
  snapshot_lg = 'snapshot_lg',
  /** column name */
  snapshot_md = 'snapshot_md',
  /** column name */
  snapshot_sm = 'snapshot_sm',
  /** column name */
  snapshot_xl = 'snapshot_xl',
  /** column name */
  updatedAt = 'updatedAt'
}

export type qx_View_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: qx_View_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: qx_View_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: qx_View_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: qx_View_delete_key_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: qx_View_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_View_set_input;
  /** filter the rows which have to be updated */
  where: qx_View_bool_exp;
};

/** columns and relationships of "qx.WiegandCardFormat" */
export type qx_WiegandCardFormat = {
  __typename?: 'qx_WiegandCardFormat';
  /** An object relationship */
  Place: qx_Place;
  format?: any;
  id: string;
  name: string;
  placeID: string;
  updatedAt?: string;
};


/** columns and relationships of "qx.WiegandCardFormat" */
export type qx_WiegandCardFormatformatArgs = {
  path?: string;
};

/** aggregated selection of "qx.WiegandCardFormat" */
export type qx_WiegandCardFormat_aggregate = {
  __typename?: 'qx_WiegandCardFormat_aggregate';
  aggregate?: qx_WiegandCardFormat_aggregate_fields;
  nodes: Array<qx_WiegandCardFormat>;
};

export type qx_WiegandCardFormat_aggregate_bool_exp = {
  count?: qx_WiegandCardFormat_aggregate_bool_exp_count;
};

export type qx_WiegandCardFormat_aggregate_bool_exp_count = {
  arguments?: Array<qx_WiegandCardFormat_select_column>;
  distinct?: boolean;
  filter?: qx_WiegandCardFormat_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.WiegandCardFormat" */
export type qx_WiegandCardFormat_aggregate_fields = {
  __typename?: 'qx_WiegandCardFormat_aggregate_fields';
  count: number;
  max?: qx_WiegandCardFormat_max_fields;
  min?: qx_WiegandCardFormat_min_fields;
};


/** aggregate fields of "qx.WiegandCardFormat" */
export type qx_WiegandCardFormat_aggregate_fieldscountArgs = {
  columns?: Array<qx_WiegandCardFormat_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.WiegandCardFormat" */
export type qx_WiegandCardFormat_aggregate_order_by = {
  count?: order_by;
  max?: qx_WiegandCardFormat_max_order_by;
  min?: qx_WiegandCardFormat_min_order_by;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type qx_WiegandCardFormat_append_input = {
  format?: any;
};

/** input type for inserting array relation for remote table "qx.WiegandCardFormat" */
export type qx_WiegandCardFormat_arr_rel_insert_input = {
  data: Array<qx_WiegandCardFormat_insert_input>;
  /** upsert condition */
  on_conflict?: qx_WiegandCardFormat_on_conflict;
};

/** Boolean expression to filter rows from the table "qx.WiegandCardFormat". All fields are combined with a logical 'AND'. */
export type qx_WiegandCardFormat_bool_exp = {
  Place?: qx_Place_bool_exp;
  _and?: Array<qx_WiegandCardFormat_bool_exp>;
  _not?: qx_WiegandCardFormat_bool_exp;
  _or?: Array<qx_WiegandCardFormat_bool_exp>;
  format?: jsonb_comparison_exp;
  id?: String_comparison_exp;
  name?: String_comparison_exp;
  placeID?: String_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
};

/** unique or primary key constraints on table "qx.WiegandCardFormat" */
export enum qx_WiegandCardFormat_constraint {
  /** unique or primary key constraint on columns "id" */
  WiegandCardFormat_pkey = 'WiegandCardFormat_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type qx_WiegandCardFormat_delete_at_path_input = {
  format?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type qx_WiegandCardFormat_delete_elem_input = {
  format?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type qx_WiegandCardFormat_delete_key_input = {
  format?: string;
};

/** input type for inserting data into table "qx.WiegandCardFormat" */
export type qx_WiegandCardFormat_insert_input = {
  Place?: qx_Place_obj_rel_insert_input;
  format?: any;
  id?: string;
  name?: string;
  placeID?: string;
  updatedAt?: string;
};

/** aggregate max on columns */
export type qx_WiegandCardFormat_max_fields = {
  __typename?: 'qx_WiegandCardFormat_max_fields';
  id?: string;
  name?: string;
  placeID?: string;
  updatedAt?: string;
};

/** order by max() on columns of table "qx.WiegandCardFormat" */
export type qx_WiegandCardFormat_max_order_by = {
  id?: order_by;
  name?: order_by;
  placeID?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type qx_WiegandCardFormat_min_fields = {
  __typename?: 'qx_WiegandCardFormat_min_fields';
  id?: string;
  name?: string;
  placeID?: string;
  updatedAt?: string;
};

/** order by min() on columns of table "qx.WiegandCardFormat" */
export type qx_WiegandCardFormat_min_order_by = {
  id?: order_by;
  name?: order_by;
  placeID?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.WiegandCardFormat" */
export type qx_WiegandCardFormat_mutation_response = {
  __typename?: 'qx_WiegandCardFormat_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_WiegandCardFormat>;
};

/** on_conflict condition type for table "qx.WiegandCardFormat" */
export type qx_WiegandCardFormat_on_conflict = {
  constraint: qx_WiegandCardFormat_constraint;
  update_columns?: Array<qx_WiegandCardFormat_update_column>;
  where?: qx_WiegandCardFormat_bool_exp;
};

/** Ordering options when selecting data from "qx.WiegandCardFormat". */
export type qx_WiegandCardFormat_order_by = {
  Place?: qx_Place_order_by;
  format?: order_by;
  id?: order_by;
  name?: order_by;
  placeID?: order_by;
  updatedAt?: order_by;
};

/** primary key columns input for table: qx.WiegandCardFormat */
export type qx_WiegandCardFormat_pk_columns_input = {
  id: string;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type qx_WiegandCardFormat_prepend_input = {
  format?: any;
};

/** select columns of table "qx.WiegandCardFormat" */
export enum qx_WiegandCardFormat_select_column {
  /** column name */
  format = 'format',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "qx.WiegandCardFormat" */
export type qx_WiegandCardFormat_set_input = {
  format?: any;
  id?: string;
  name?: string;
  placeID?: string;
  updatedAt?: string;
};

/** Streaming cursor of the table "qx_WiegandCardFormat" */
export type qx_WiegandCardFormat_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_WiegandCardFormat_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_WiegandCardFormat_stream_cursor_value_input = {
  format?: any;
  id?: string;
  name?: string;
  placeID?: string;
  updatedAt?: string;
};

/** update columns of table "qx.WiegandCardFormat" */
export enum qx_WiegandCardFormat_update_column {
  /** column name */
  format = 'format',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  updatedAt = 'updatedAt'
}

export type qx_WiegandCardFormat_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: qx_WiegandCardFormat_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: qx_WiegandCardFormat_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: qx_WiegandCardFormat_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: qx_WiegandCardFormat_delete_key_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: qx_WiegandCardFormat_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_WiegandCardFormat_set_input;
  /** filter the rows which have to be updated */
  where: qx_WiegandCardFormat_bool_exp;
};

/** links a holiday set to the schedule blocks that apply on those holiday dates, overriding normal schedule behavior */
export type qx__HolidaySetToScheduleBlock = {
  __typename?: 'qx__HolidaySetToScheduleBlock';
  /** An object relationship */
  holidaySet: qx_HolidaySet;
  holidaySetID: string;
  /** An object relationship */
  scheduleBlock: qx_ScheduleBlock;
  scheduleBlockID: string;
  updatedAt?: string;
};

/** aggregated selection of "qx._HolidaySetToScheduleBlock" */
export type qx__HolidaySetToScheduleBlock_aggregate = {
  __typename?: 'qx__HolidaySetToScheduleBlock_aggregate';
  aggregate?: qx__HolidaySetToScheduleBlock_aggregate_fields;
  nodes: Array<qx__HolidaySetToScheduleBlock>;
};

export type qx__HolidaySetToScheduleBlock_aggregate_bool_exp = {
  count?: qx__HolidaySetToScheduleBlock_aggregate_bool_exp_count;
};

export type qx__HolidaySetToScheduleBlock_aggregate_bool_exp_count = {
  arguments?: Array<qx__HolidaySetToScheduleBlock_select_column>;
  distinct?: boolean;
  filter?: qx__HolidaySetToScheduleBlock_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx._HolidaySetToScheduleBlock" */
export type qx__HolidaySetToScheduleBlock_aggregate_fields = {
  __typename?: 'qx__HolidaySetToScheduleBlock_aggregate_fields';
  count: number;
  max?: qx__HolidaySetToScheduleBlock_max_fields;
  min?: qx__HolidaySetToScheduleBlock_min_fields;
};


/** aggregate fields of "qx._HolidaySetToScheduleBlock" */
export type qx__HolidaySetToScheduleBlock_aggregate_fieldscountArgs = {
  columns?: Array<qx__HolidaySetToScheduleBlock_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx._HolidaySetToScheduleBlock" */
export type qx__HolidaySetToScheduleBlock_aggregate_order_by = {
  count?: order_by;
  max?: qx__HolidaySetToScheduleBlock_max_order_by;
  min?: qx__HolidaySetToScheduleBlock_min_order_by;
};

/** input type for inserting array relation for remote table "qx._HolidaySetToScheduleBlock" */
export type qx__HolidaySetToScheduleBlock_arr_rel_insert_input = {
  data: Array<qx__HolidaySetToScheduleBlock_insert_input>;
  /** upsert condition */
  on_conflict?: qx__HolidaySetToScheduleBlock_on_conflict;
};

/** Boolean expression to filter rows from the table "qx._HolidaySetToScheduleBlock". All fields are combined with a logical 'AND'. */
export type qx__HolidaySetToScheduleBlock_bool_exp = {
  _and?: Array<qx__HolidaySetToScheduleBlock_bool_exp>;
  _not?: qx__HolidaySetToScheduleBlock_bool_exp;
  _or?: Array<qx__HolidaySetToScheduleBlock_bool_exp>;
  holidaySet?: qx_HolidaySet_bool_exp;
  holidaySetID?: String_comparison_exp;
  scheduleBlock?: qx_ScheduleBlock_bool_exp;
  scheduleBlockID?: String_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
};

/** unique or primary key constraints on table "qx._HolidaySetToScheduleBlock" */
export enum qx__HolidaySetToScheduleBlock_constraint {
  /** unique or primary key constraint on columns "scheduleBlockID", "holidaySetID" */
  _HolidaySetToScheduleBlock_holidaySetID_scheduleBlockID_key = '_HolidaySetToScheduleBlock_holidaySetID_scheduleBlockID_key',
  /** unique or primary key constraint on columns "scheduleBlockID", "holidaySetID" */
  _HolidaySetToScheduleBlock_pkey = '_HolidaySetToScheduleBlock_pkey'
}

/** input type for inserting data into table "qx._HolidaySetToScheduleBlock" */
export type qx__HolidaySetToScheduleBlock_insert_input = {
  holidaySet?: qx_HolidaySet_obj_rel_insert_input;
  holidaySetID?: string;
  scheduleBlock?: qx_ScheduleBlock_obj_rel_insert_input;
  scheduleBlockID?: string;
  updatedAt?: string;
};

/** aggregate max on columns */
export type qx__HolidaySetToScheduleBlock_max_fields = {
  __typename?: 'qx__HolidaySetToScheduleBlock_max_fields';
  holidaySetID?: string;
  scheduleBlockID?: string;
  updatedAt?: string;
};

/** order by max() on columns of table "qx._HolidaySetToScheduleBlock" */
export type qx__HolidaySetToScheduleBlock_max_order_by = {
  holidaySetID?: order_by;
  scheduleBlockID?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type qx__HolidaySetToScheduleBlock_min_fields = {
  __typename?: 'qx__HolidaySetToScheduleBlock_min_fields';
  holidaySetID?: string;
  scheduleBlockID?: string;
  updatedAt?: string;
};

/** order by min() on columns of table "qx._HolidaySetToScheduleBlock" */
export type qx__HolidaySetToScheduleBlock_min_order_by = {
  holidaySetID?: order_by;
  scheduleBlockID?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx._HolidaySetToScheduleBlock" */
export type qx__HolidaySetToScheduleBlock_mutation_response = {
  __typename?: 'qx__HolidaySetToScheduleBlock_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx__HolidaySetToScheduleBlock>;
};

/** on_conflict condition type for table "qx._HolidaySetToScheduleBlock" */
export type qx__HolidaySetToScheduleBlock_on_conflict = {
  constraint: qx__HolidaySetToScheduleBlock_constraint;
  update_columns?: Array<qx__HolidaySetToScheduleBlock_update_column>;
  where?: qx__HolidaySetToScheduleBlock_bool_exp;
};

/** Ordering options when selecting data from "qx._HolidaySetToScheduleBlock". */
export type qx__HolidaySetToScheduleBlock_order_by = {
  holidaySet?: qx_HolidaySet_order_by;
  holidaySetID?: order_by;
  scheduleBlock?: qx_ScheduleBlock_order_by;
  scheduleBlockID?: order_by;
  updatedAt?: order_by;
};

/** primary key columns input for table: qx._HolidaySetToScheduleBlock */
export type qx__HolidaySetToScheduleBlock_pk_columns_input = {
  holidaySetID: string;
  scheduleBlockID: string;
};

/** select columns of table "qx._HolidaySetToScheduleBlock" */
export enum qx__HolidaySetToScheduleBlock_select_column {
  /** column name */
  holidaySetID = 'holidaySetID',
  /** column name */
  scheduleBlockID = 'scheduleBlockID',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "qx._HolidaySetToScheduleBlock" */
export type qx__HolidaySetToScheduleBlock_set_input = {
  holidaySetID?: string;
  scheduleBlockID?: string;
  updatedAt?: string;
};

/** Streaming cursor of the table "qx__HolidaySetToScheduleBlock" */
export type qx__HolidaySetToScheduleBlock_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx__HolidaySetToScheduleBlock_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx__HolidaySetToScheduleBlock_stream_cursor_value_input = {
  holidaySetID?: string;
  scheduleBlockID?: string;
  updatedAt?: string;
};

/** update columns of table "qx._HolidaySetToScheduleBlock" */
export enum qx__HolidaySetToScheduleBlock_update_column {
  /** column name */
  holidaySetID = 'holidaySetID',
  /** column name */
  scheduleBlockID = 'scheduleBlockID',
  /** column name */
  updatedAt = 'updatedAt'
}

export type qx__HolidaySetToScheduleBlock_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx__HolidaySetToScheduleBlock_set_input;
  /** filter the rows which have to be updated */
  where: qx__HolidaySetToScheduleBlock_bool_exp;
};

/** maps a personID to a groupID through the group / person table */
export type qx__PersonToGroup = {
  __typename?: 'qx__PersonToGroup';
  /** An object relationship */
  group: qx_Group;
  groupID: string;
  /** An object relationship */
  person: qx_Person;
  personID: string;
};

/** aggregated selection of "qx._PersonToGroup" */
export type qx__PersonToGroup_aggregate = {
  __typename?: 'qx__PersonToGroup_aggregate';
  aggregate?: qx__PersonToGroup_aggregate_fields;
  nodes: Array<qx__PersonToGroup>;
};

export type qx__PersonToGroup_aggregate_bool_exp = {
  count?: qx__PersonToGroup_aggregate_bool_exp_count;
};

export type qx__PersonToGroup_aggregate_bool_exp_count = {
  arguments?: Array<qx__PersonToGroup_select_column>;
  distinct?: boolean;
  filter?: qx__PersonToGroup_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx._PersonToGroup" */
export type qx__PersonToGroup_aggregate_fields = {
  __typename?: 'qx__PersonToGroup_aggregate_fields';
  count: number;
  max?: qx__PersonToGroup_max_fields;
  min?: qx__PersonToGroup_min_fields;
};


/** aggregate fields of "qx._PersonToGroup" */
export type qx__PersonToGroup_aggregate_fieldscountArgs = {
  columns?: Array<qx__PersonToGroup_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx._PersonToGroup" */
export type qx__PersonToGroup_aggregate_order_by = {
  count?: order_by;
  max?: qx__PersonToGroup_max_order_by;
  min?: qx__PersonToGroup_min_order_by;
};

/** input type for inserting array relation for remote table "qx._PersonToGroup" */
export type qx__PersonToGroup_arr_rel_insert_input = {
  data: Array<qx__PersonToGroup_insert_input>;
  /** upsert condition */
  on_conflict?: qx__PersonToGroup_on_conflict;
};

/** Boolean expression to filter rows from the table "qx._PersonToGroup". All fields are combined with a logical 'AND'. */
export type qx__PersonToGroup_bool_exp = {
  _and?: Array<qx__PersonToGroup_bool_exp>;
  _not?: qx__PersonToGroup_bool_exp;
  _or?: Array<qx__PersonToGroup_bool_exp>;
  group?: qx_Group_bool_exp;
  groupID?: String_comparison_exp;
  person?: qx_Person_bool_exp;
  personID?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx._PersonToGroup" */
export enum qx__PersonToGroup_constraint {
  /** unique or primary key constraint on columns "groupID", "personID" */
  _PersonToGroup_groupID_personID_key = '_PersonToGroup_groupID_personID_key',
  /** unique or primary key constraint on columns "groupID", "personID" */
  _PersonToGroup_pkey = '_PersonToGroup_pkey'
}

/** input type for inserting data into table "qx._PersonToGroup" */
export type qx__PersonToGroup_insert_input = {
  group?: qx_Group_obj_rel_insert_input;
  groupID?: string;
  person?: qx_Person_obj_rel_insert_input;
  personID?: string;
};

/** aggregate max on columns */
export type qx__PersonToGroup_max_fields = {
  __typename?: 'qx__PersonToGroup_max_fields';
  groupID?: string;
  personID?: string;
};

/** order by max() on columns of table "qx._PersonToGroup" */
export type qx__PersonToGroup_max_order_by = {
  groupID?: order_by;
  personID?: order_by;
};

/** aggregate min on columns */
export type qx__PersonToGroup_min_fields = {
  __typename?: 'qx__PersonToGroup_min_fields';
  groupID?: string;
  personID?: string;
};

/** order by min() on columns of table "qx._PersonToGroup" */
export type qx__PersonToGroup_min_order_by = {
  groupID?: order_by;
  personID?: order_by;
};

/** response of any mutation on the table "qx._PersonToGroup" */
export type qx__PersonToGroup_mutation_response = {
  __typename?: 'qx__PersonToGroup_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx__PersonToGroup>;
};

/** on_conflict condition type for table "qx._PersonToGroup" */
export type qx__PersonToGroup_on_conflict = {
  constraint: qx__PersonToGroup_constraint;
  update_columns?: Array<qx__PersonToGroup_update_column>;
  where?: qx__PersonToGroup_bool_exp;
};

/** Ordering options when selecting data from "qx._PersonToGroup". */
export type qx__PersonToGroup_order_by = {
  group?: qx_Group_order_by;
  groupID?: order_by;
  person?: qx_Person_order_by;
  personID?: order_by;
};

/** primary key columns input for table: qx._PersonToGroup */
export type qx__PersonToGroup_pk_columns_input = {
  groupID: string;
  personID: string;
};

/** select columns of table "qx._PersonToGroup" */
export enum qx__PersonToGroup_select_column {
  /** column name */
  groupID = 'groupID',
  /** column name */
  personID = 'personID'
}

/** input type for updating data in table "qx._PersonToGroup" */
export type qx__PersonToGroup_set_input = {
  groupID?: string;
  personID?: string;
};

/** Streaming cursor of the table "qx__PersonToGroup" */
export type qx__PersonToGroup_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx__PersonToGroup_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx__PersonToGroup_stream_cursor_value_input = {
  groupID?: string;
  personID?: string;
};

/** update columns of table "qx._PersonToGroup" */
export enum qx__PersonToGroup_update_column {
  /** column name */
  groupID = 'groupID',
  /** column name */
  personID = 'personID'
}

export type qx__PersonToGroup_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx__PersonToGroup_set_input;
  /** filter the rows which have to be updated */
  where: qx__PersonToGroup_bool_exp;
};

/** precomputed lookup of a place's ancestor places at each level of the hierarchy (customer, integrator, site, gateway, home) for fast joins without recursive queries */
export type qx__PlaceToHomePlaces = {
  __typename?: 'qx__PlaceToHomePlaces';
  /** An object relationship */
  customerPlace?: qx_Place;
  customerPlaceID?: string;
  /** An object relationship */
  gatewayPlace?: qx_Place;
  gatewayPlaceID?: string;
  /** An object relationship */
  homePlace?: qx_Place;
  homePlaceID?: string;
  /** An object relationship */
  integratorPlace?: qx_Place;
  integratorPlaceID?: string;
  /** An object relationship */
  place?: qx_Place;
  placeID?: string;
  /** An object relationship */
  sitePlace?: qx_Place;
  sitePlaceID?: string;
};

/** aggregated selection of "qx._PlaceToHomePlaces" */
export type qx__PlaceToHomePlaces_aggregate = {
  __typename?: 'qx__PlaceToHomePlaces_aggregate';
  aggregate?: qx__PlaceToHomePlaces_aggregate_fields;
  nodes: Array<qx__PlaceToHomePlaces>;
};

/** aggregate fields of "qx._PlaceToHomePlaces" */
export type qx__PlaceToHomePlaces_aggregate_fields = {
  __typename?: 'qx__PlaceToHomePlaces_aggregate_fields';
  count: number;
  max?: qx__PlaceToHomePlaces_max_fields;
  min?: qx__PlaceToHomePlaces_min_fields;
};


/** aggregate fields of "qx._PlaceToHomePlaces" */
export type qx__PlaceToHomePlaces_aggregate_fieldscountArgs = {
  columns?: Array<qx__PlaceToHomePlaces_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx._PlaceToHomePlaces". All fields are combined with a logical 'AND'. */
export type qx__PlaceToHomePlaces_bool_exp = {
  _and?: Array<qx__PlaceToHomePlaces_bool_exp>;
  _not?: qx__PlaceToHomePlaces_bool_exp;
  _or?: Array<qx__PlaceToHomePlaces_bool_exp>;
  customerPlace?: qx_Place_bool_exp;
  customerPlaceID?: String_comparison_exp;
  gatewayPlace?: qx_Place_bool_exp;
  gatewayPlaceID?: String_comparison_exp;
  homePlace?: qx_Place_bool_exp;
  homePlaceID?: String_comparison_exp;
  integratorPlace?: qx_Place_bool_exp;
  integratorPlaceID?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
  sitePlace?: qx_Place_bool_exp;
  sitePlaceID?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx._PlaceToHomePlaces" */
export enum qx__PlaceToHomePlaces_constraint {
  /** unique or primary key constraint on columns "placeID" */
  idx_placetohomeplaces_placeid = 'idx_placetohomeplaces_placeid'
}

/** input type for inserting data into table "qx._PlaceToHomePlaces" */
export type qx__PlaceToHomePlaces_insert_input = {
  customerPlace?: qx_Place_obj_rel_insert_input;
  customerPlaceID?: string;
  gatewayPlace?: qx_Place_obj_rel_insert_input;
  gatewayPlaceID?: string;
  homePlace?: qx_Place_obj_rel_insert_input;
  homePlaceID?: string;
  integratorPlace?: qx_Place_obj_rel_insert_input;
  integratorPlaceID?: string;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
  sitePlace?: qx_Place_obj_rel_insert_input;
  sitePlaceID?: string;
};

/** aggregate max on columns */
export type qx__PlaceToHomePlaces_max_fields = {
  __typename?: 'qx__PlaceToHomePlaces_max_fields';
  customerPlaceID?: string;
  gatewayPlaceID?: string;
  homePlaceID?: string;
  integratorPlaceID?: string;
  placeID?: string;
  sitePlaceID?: string;
};

/** aggregate min on columns */
export type qx__PlaceToHomePlaces_min_fields = {
  __typename?: 'qx__PlaceToHomePlaces_min_fields';
  customerPlaceID?: string;
  gatewayPlaceID?: string;
  homePlaceID?: string;
  integratorPlaceID?: string;
  placeID?: string;
  sitePlaceID?: string;
};

/** input type for inserting object relation for remote table "qx._PlaceToHomePlaces" */
export type qx__PlaceToHomePlaces_obj_rel_insert_input = {
  data: qx__PlaceToHomePlaces_insert_input;
  /** upsert condition */
  on_conflict?: qx__PlaceToHomePlaces_on_conflict;
};

/** on_conflict condition type for table "qx._PlaceToHomePlaces" */
export type qx__PlaceToHomePlaces_on_conflict = {
  constraint: qx__PlaceToHomePlaces_constraint;
  update_columns?: Array<qx__PlaceToHomePlaces_update_column>;
  where?: qx__PlaceToHomePlaces_bool_exp;
};

/** Ordering options when selecting data from "qx._PlaceToHomePlaces". */
export type qx__PlaceToHomePlaces_order_by = {
  customerPlace?: qx_Place_order_by;
  customerPlaceID?: order_by;
  gatewayPlace?: qx_Place_order_by;
  gatewayPlaceID?: order_by;
  homePlace?: qx_Place_order_by;
  homePlaceID?: order_by;
  integratorPlace?: qx_Place_order_by;
  integratorPlaceID?: order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
  sitePlace?: qx_Place_order_by;
  sitePlaceID?: order_by;
};

/** select columns of table "qx._PlaceToHomePlaces" */
export enum qx__PlaceToHomePlaces_select_column {
  /** column name */
  customerPlaceID = 'customerPlaceID',
  /** column name */
  gatewayPlaceID = 'gatewayPlaceID',
  /** column name */
  homePlaceID = 'homePlaceID',
  /** column name */
  integratorPlaceID = 'integratorPlaceID',
  /** column name */
  placeID = 'placeID',
  /** column name */
  sitePlaceID = 'sitePlaceID'
}

/** Streaming cursor of the table "qx__PlaceToHomePlaces" */
export type qx__PlaceToHomePlaces_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx__PlaceToHomePlaces_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx__PlaceToHomePlaces_stream_cursor_value_input = {
  customerPlaceID?: string;
  gatewayPlaceID?: string;
  homePlaceID?: string;
  integratorPlaceID?: string;
  placeID?: string;
  sitePlaceID?: string;
};

/** update columns of table "qx._PlaceToHomePlaces" */
export enum qx__PlaceToHomePlaces_update_column {
  /** column name */
  customerPlaceID = 'customerPlaceID',
  /** column name */
  gatewayPlaceID = 'gatewayPlaceID',
  /** column name */
  homePlaceID = 'homePlaceID',
  /** column name */
  integratorPlaceID = 'integratorPlaceID',
  /** column name */
  placeID = 'placeID',
  /** column name */
  sitePlaceID = 'sitePlaceID'
}

/** maps individual privilege flags to a role, defining which application capabilities that role grants */
export type qx__PrivilegeEnumToRole = {
  __typename?: 'qx__PrivilegeEnumToRole';
  privilege: qx_ePrivilege_enum;
  /** An object relationship */
  role: qx_Role;
  roleID: string;
  /** An object relationship */
  toPrivilege: qx_ePrivilege;
};

/** aggregated selection of "qx._PrivilegeEnumToRole" */
export type qx__PrivilegeEnumToRole_aggregate = {
  __typename?: 'qx__PrivilegeEnumToRole_aggregate';
  aggregate?: qx__PrivilegeEnumToRole_aggregate_fields;
  nodes: Array<qx__PrivilegeEnumToRole>;
};

export type qx__PrivilegeEnumToRole_aggregate_bool_exp = {
  count?: qx__PrivilegeEnumToRole_aggregate_bool_exp_count;
};

export type qx__PrivilegeEnumToRole_aggregate_bool_exp_count = {
  arguments?: Array<qx__PrivilegeEnumToRole_select_column>;
  distinct?: boolean;
  filter?: qx__PrivilegeEnumToRole_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx._PrivilegeEnumToRole" */
export type qx__PrivilegeEnumToRole_aggregate_fields = {
  __typename?: 'qx__PrivilegeEnumToRole_aggregate_fields';
  count: number;
  max?: qx__PrivilegeEnumToRole_max_fields;
  min?: qx__PrivilegeEnumToRole_min_fields;
};


/** aggregate fields of "qx._PrivilegeEnumToRole" */
export type qx__PrivilegeEnumToRole_aggregate_fieldscountArgs = {
  columns?: Array<qx__PrivilegeEnumToRole_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx._PrivilegeEnumToRole" */
export type qx__PrivilegeEnumToRole_aggregate_order_by = {
  count?: order_by;
  max?: qx__PrivilegeEnumToRole_max_order_by;
  min?: qx__PrivilegeEnumToRole_min_order_by;
};

/** input type for inserting array relation for remote table "qx._PrivilegeEnumToRole" */
export type qx__PrivilegeEnumToRole_arr_rel_insert_input = {
  data: Array<qx__PrivilegeEnumToRole_insert_input>;
  /** upsert condition */
  on_conflict?: qx__PrivilegeEnumToRole_on_conflict;
};

/** Boolean expression to filter rows from the table "qx._PrivilegeEnumToRole". All fields are combined with a logical 'AND'. */
export type qx__PrivilegeEnumToRole_bool_exp = {
  _and?: Array<qx__PrivilegeEnumToRole_bool_exp>;
  _not?: qx__PrivilegeEnumToRole_bool_exp;
  _or?: Array<qx__PrivilegeEnumToRole_bool_exp>;
  privilege?: qx_ePrivilege_enum_comparison_exp;
  role?: qx_Role_bool_exp;
  roleID?: String_comparison_exp;
  toPrivilege?: qx_ePrivilege_bool_exp;
};

/** unique or primary key constraints on table "qx._PrivilegeEnumToRole" */
export enum qx__PrivilegeEnumToRole_constraint {
  /** unique or primary key constraint on columns "roleID", "privilege" */
  _PrivilegeEnumToRole_pkey = '_PrivilegeEnumToRole_pkey',
  /** unique or primary key constraint on columns "roleID", "privilege" */
  _PrivilegeEnumToRole_privilege_roleID_key = '_PrivilegeEnumToRole_privilege_roleID_key'
}

/** input type for inserting data into table "qx._PrivilegeEnumToRole" */
export type qx__PrivilegeEnumToRole_insert_input = {
  privilege?: qx_ePrivilege_enum;
  role?: qx_Role_obj_rel_insert_input;
  roleID?: string;
  toPrivilege?: qx_ePrivilege_obj_rel_insert_input;
};

/** aggregate max on columns */
export type qx__PrivilegeEnumToRole_max_fields = {
  __typename?: 'qx__PrivilegeEnumToRole_max_fields';
  roleID?: string;
};

/** order by max() on columns of table "qx._PrivilegeEnumToRole" */
export type qx__PrivilegeEnumToRole_max_order_by = {
  roleID?: order_by;
};

/** aggregate min on columns */
export type qx__PrivilegeEnumToRole_min_fields = {
  __typename?: 'qx__PrivilegeEnumToRole_min_fields';
  roleID?: string;
};

/** order by min() on columns of table "qx._PrivilegeEnumToRole" */
export type qx__PrivilegeEnumToRole_min_order_by = {
  roleID?: order_by;
};

/** response of any mutation on the table "qx._PrivilegeEnumToRole" */
export type qx__PrivilegeEnumToRole_mutation_response = {
  __typename?: 'qx__PrivilegeEnumToRole_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx__PrivilegeEnumToRole>;
};

/** on_conflict condition type for table "qx._PrivilegeEnumToRole" */
export type qx__PrivilegeEnumToRole_on_conflict = {
  constraint: qx__PrivilegeEnumToRole_constraint;
  update_columns?: Array<qx__PrivilegeEnumToRole_update_column>;
  where?: qx__PrivilegeEnumToRole_bool_exp;
};

/** Ordering options when selecting data from "qx._PrivilegeEnumToRole". */
export type qx__PrivilegeEnumToRole_order_by = {
  privilege?: order_by;
  role?: qx_Role_order_by;
  roleID?: order_by;
  toPrivilege?: qx_ePrivilege_order_by;
};

/** primary key columns input for table: qx._PrivilegeEnumToRole */
export type qx__PrivilegeEnumToRole_pk_columns_input = {
  privilege: qx_ePrivilege_enum;
  roleID: string;
};

/** select columns of table "qx._PrivilegeEnumToRole" */
export enum qx__PrivilegeEnumToRole_select_column {
  /** column name */
  privilege = 'privilege',
  /** column name */
  roleID = 'roleID'
}

/** input type for updating data in table "qx._PrivilegeEnumToRole" */
export type qx__PrivilegeEnumToRole_set_input = {
  privilege?: qx_ePrivilege_enum;
  roleID?: string;
};

/** Streaming cursor of the table "qx__PrivilegeEnumToRole" */
export type qx__PrivilegeEnumToRole_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx__PrivilegeEnumToRole_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx__PrivilegeEnumToRole_stream_cursor_value_input = {
  privilege?: qx_ePrivilege_enum;
  roleID?: string;
};

/** update columns of table "qx._PrivilegeEnumToRole" */
export enum qx__PrivilegeEnumToRole_update_column {
  /** column name */
  privilege = 'privilege',
  /** column name */
  roleID = 'roleID'
}

export type qx__PrivilegeEnumToRole_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx__PrivilegeEnumToRole_set_input;
  /** filter the rows which have to be updated */
  where: qx__PrivilegeEnumToRole_bool_exp;
};

export type qx_chat_usage_per_model_args = {
  from?: string;
  placeId?: string;
  placeType?: string;
  to?: string;
};

export type qx_chat_usage_series_args = {
  from?: string;
  groupBy?: string;
  placeId?: string;
  to?: string;
};

export type qx_device_oldest_media_args = {
  device?: qx_Device;
};

/** enum: types of access control hardware boards supported by the system */
export type qx_eAccessBoardType = {
  __typename?: 'qx_eAccessBoardType';
  /** An array relationship */
  catalog: Array<qx_AccessCatalog>;
  /** An aggregate relationship */
  catalog_aggregate: qx_AccessCatalog_aggregate;
  comment?: string;
  value: string;
};


/** enum: types of access control hardware boards supported by the system */
export type qx_eAccessBoardTypecatalogArgs = {
  distinct_on?: Array<qx_AccessCatalog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessCatalog_order_by>;
  where?: qx_AccessCatalog_bool_exp;
};


/** enum: types of access control hardware boards supported by the system */
export type qx_eAccessBoardTypecatalog_aggregateArgs = {
  distinct_on?: Array<qx_AccessCatalog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessCatalog_order_by>;
  where?: qx_AccessCatalog_bool_exp;
};

/** aggregated selection of "qx.eAccessBoardType" */
export type qx_eAccessBoardType_aggregate = {
  __typename?: 'qx_eAccessBoardType_aggregate';
  aggregate?: qx_eAccessBoardType_aggregate_fields;
  nodes: Array<qx_eAccessBoardType>;
};

/** aggregate fields of "qx.eAccessBoardType" */
export type qx_eAccessBoardType_aggregate_fields = {
  __typename?: 'qx_eAccessBoardType_aggregate_fields';
  count: number;
  max?: qx_eAccessBoardType_max_fields;
  min?: qx_eAccessBoardType_min_fields;
};


/** aggregate fields of "qx.eAccessBoardType" */
export type qx_eAccessBoardType_aggregate_fieldscountArgs = {
  columns?: Array<qx_eAccessBoardType_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eAccessBoardType". All fields are combined with a logical 'AND'. */
export type qx_eAccessBoardType_bool_exp = {
  _and?: Array<qx_eAccessBoardType_bool_exp>;
  _not?: qx_eAccessBoardType_bool_exp;
  _or?: Array<qx_eAccessBoardType_bool_exp>;
  catalog?: qx_AccessCatalog_bool_exp;
  catalog_aggregate?: qx_AccessCatalog_aggregate_bool_exp;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eAccessBoardType" */
export enum qx_eAccessBoardType_constraint {
  /** unique or primary key constraint on columns "value" */
  eMercuryBoardType_pkey = 'eMercuryBoardType_pkey'
}

export enum qx_eAccessBoardType_enum {
  /** SCP */
  SCP = 'SCP',
  /** SIO */
  SIO = 'SIO',
  /** Unknown */
  Unknown = 'Unknown'
}

/** Boolean expression to compare columns of type "qx_eAccessBoardType_enum". All fields are combined with logical 'AND'. */
export type qx_eAccessBoardType_enum_comparison_exp = {
  _eq?: qx_eAccessBoardType_enum;
  _in?: Array<qx_eAccessBoardType_enum>;
  _is_null?: boolean;
  _neq?: qx_eAccessBoardType_enum;
  _nin?: Array<qx_eAccessBoardType_enum>;
};

/** input type for inserting data into table "qx.eAccessBoardType" */
export type qx_eAccessBoardType_insert_input = {
  catalog?: qx_AccessCatalog_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eAccessBoardType_max_fields = {
  __typename?: 'qx_eAccessBoardType_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eAccessBoardType_min_fields = {
  __typename?: 'qx_eAccessBoardType_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eAccessBoardType" */
export type qx_eAccessBoardType_mutation_response = {
  __typename?: 'qx_eAccessBoardType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eAccessBoardType>;
};

/** input type for inserting object relation for remote table "qx.eAccessBoardType" */
export type qx_eAccessBoardType_obj_rel_insert_input = {
  data: qx_eAccessBoardType_insert_input;
  /** upsert condition */
  on_conflict?: qx_eAccessBoardType_on_conflict;
};

/** on_conflict condition type for table "qx.eAccessBoardType" */
export type qx_eAccessBoardType_on_conflict = {
  constraint: qx_eAccessBoardType_constraint;
  update_columns?: Array<qx_eAccessBoardType_update_column>;
  where?: qx_eAccessBoardType_bool_exp;
};

/** Ordering options when selecting data from "qx.eAccessBoardType". */
export type qx_eAccessBoardType_order_by = {
  catalog_aggregate?: qx_AccessCatalog_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eAccessBoardType */
export type qx_eAccessBoardType_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eAccessBoardType" */
export enum qx_eAccessBoardType_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eAccessBoardType" */
export type qx_eAccessBoardType_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eAccessBoardType" */
export type qx_eAccessBoardType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eAccessBoardType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eAccessBoardType_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eAccessBoardType" */
export enum qx_eAccessBoardType_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eAccessBoardType_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eAccessBoardType_set_input;
  /** filter the rows which have to be updated */
  where: qx_eAccessBoardType_bool_exp;
};

/** enum: reasons an access attempt was denied (invalid credential, schedule restriction, lockdown, etc.) */
export type qx_eAccessDeniedReason = {
  __typename?: 'qx_eAccessDeniedReason';
  comment?: string;
  /** An array relationship */
  doors: Array<qx_Event>;
  /** An aggregate relationship */
  doors_aggregate: qx_Event_aggregate;
  value: string;
};


/** enum: reasons an access attempt was denied (invalid credential, schedule restriction, lockdown, etc.) */
export type qx_eAccessDeniedReasondoorsArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};


/** enum: reasons an access attempt was denied (invalid credential, schedule restriction, lockdown, etc.) */
export type qx_eAccessDeniedReasondoors_aggregateArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};

/** aggregated selection of "qx.eAccessDeniedReason" */
export type qx_eAccessDeniedReason_aggregate = {
  __typename?: 'qx_eAccessDeniedReason_aggregate';
  aggregate?: qx_eAccessDeniedReason_aggregate_fields;
  nodes: Array<qx_eAccessDeniedReason>;
};

/** aggregate fields of "qx.eAccessDeniedReason" */
export type qx_eAccessDeniedReason_aggregate_fields = {
  __typename?: 'qx_eAccessDeniedReason_aggregate_fields';
  count: number;
  max?: qx_eAccessDeniedReason_max_fields;
  min?: qx_eAccessDeniedReason_min_fields;
};


/** aggregate fields of "qx.eAccessDeniedReason" */
export type qx_eAccessDeniedReason_aggregate_fieldscountArgs = {
  columns?: Array<qx_eAccessDeniedReason_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eAccessDeniedReason". All fields are combined with a logical 'AND'. */
export type qx_eAccessDeniedReason_bool_exp = {
  _and?: Array<qx_eAccessDeniedReason_bool_exp>;
  _not?: qx_eAccessDeniedReason_bool_exp;
  _or?: Array<qx_eAccessDeniedReason_bool_exp>;
  comment?: String_comparison_exp;
  doors?: qx_Event_bool_exp;
  doors_aggregate?: qx_Event_aggregate_bool_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eAccessDeniedReason" */
export enum qx_eAccessDeniedReason_constraint {
  /** unique or primary key constraint on columns "value" */
  eAccessDeniedReason_pkey = 'eAccessDeniedReason_pkey'
}

/** input type for inserting data into table "qx.eAccessDeniedReason" */
export type qx_eAccessDeniedReason_insert_input = {
  comment?: string;
  doors?: qx_Event_arr_rel_insert_input;
  value?: string;
};

/** aggregate max on columns */
export type qx_eAccessDeniedReason_max_fields = {
  __typename?: 'qx_eAccessDeniedReason_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eAccessDeniedReason_min_fields = {
  __typename?: 'qx_eAccessDeniedReason_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eAccessDeniedReason" */
export type qx_eAccessDeniedReason_mutation_response = {
  __typename?: 'qx_eAccessDeniedReason_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eAccessDeniedReason>;
};

/** on_conflict condition type for table "qx.eAccessDeniedReason" */
export type qx_eAccessDeniedReason_on_conflict = {
  constraint: qx_eAccessDeniedReason_constraint;
  update_columns?: Array<qx_eAccessDeniedReason_update_column>;
  where?: qx_eAccessDeniedReason_bool_exp;
};

/** Ordering options when selecting data from "qx.eAccessDeniedReason". */
export type qx_eAccessDeniedReason_order_by = {
  comment?: order_by;
  doors_aggregate?: qx_Event_aggregate_order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eAccessDeniedReason */
export type qx_eAccessDeniedReason_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eAccessDeniedReason" */
export enum qx_eAccessDeniedReason_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eAccessDeniedReason" */
export type qx_eAccessDeniedReason_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eAccessDeniedReason" */
export type qx_eAccessDeniedReason_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eAccessDeniedReason_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eAccessDeniedReason_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eAccessDeniedReason" */
export enum qx_eAccessDeniedReason_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eAccessDeniedReason_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eAccessDeniedReason_set_input;
  /** filter the rows which have to be updated */
  where: qx_eAccessDeniedReason_bool_exp;
};

/** enum: communication interface types for connecting access hardware (RS485, Wiegand, OSDP, etc.) */
export type qx_eAccessInterfaceType = {
  __typename?: 'qx_eAccessInterfaceType';
  /** An array relationship */
  catalog: Array<qx_AccessCatalog>;
  /** An aggregate relationship */
  catalog_aggregate: qx_AccessCatalog_aggregate;
  comment?: string;
  value: string;
};


/** enum: communication interface types for connecting access hardware (RS485, Wiegand, OSDP, etc.) */
export type qx_eAccessInterfaceTypecatalogArgs = {
  distinct_on?: Array<qx_AccessCatalog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessCatalog_order_by>;
  where?: qx_AccessCatalog_bool_exp;
};


/** enum: communication interface types for connecting access hardware (RS485, Wiegand, OSDP, etc.) */
export type qx_eAccessInterfaceTypecatalog_aggregateArgs = {
  distinct_on?: Array<qx_AccessCatalog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessCatalog_order_by>;
  where?: qx_AccessCatalog_bool_exp;
};

/** aggregated selection of "qx.eAccessInterfaceType" */
export type qx_eAccessInterfaceType_aggregate = {
  __typename?: 'qx_eAccessInterfaceType_aggregate';
  aggregate?: qx_eAccessInterfaceType_aggregate_fields;
  nodes: Array<qx_eAccessInterfaceType>;
};

/** aggregate fields of "qx.eAccessInterfaceType" */
export type qx_eAccessInterfaceType_aggregate_fields = {
  __typename?: 'qx_eAccessInterfaceType_aggregate_fields';
  count: number;
  max?: qx_eAccessInterfaceType_max_fields;
  min?: qx_eAccessInterfaceType_min_fields;
};


/** aggregate fields of "qx.eAccessInterfaceType" */
export type qx_eAccessInterfaceType_aggregate_fieldscountArgs = {
  columns?: Array<qx_eAccessInterfaceType_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eAccessInterfaceType". All fields are combined with a logical 'AND'. */
export type qx_eAccessInterfaceType_bool_exp = {
  _and?: Array<qx_eAccessInterfaceType_bool_exp>;
  _not?: qx_eAccessInterfaceType_bool_exp;
  _or?: Array<qx_eAccessInterfaceType_bool_exp>;
  catalog?: qx_AccessCatalog_bool_exp;
  catalog_aggregate?: qx_AccessCatalog_aggregate_bool_exp;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eAccessInterfaceType" */
export enum qx_eAccessInterfaceType_constraint {
  /** unique or primary key constraint on columns "value" */
  eMercuryInterfaceType_pkey = 'eMercuryInterfaceType_pkey'
}

export enum qx_eAccessInterfaceType_enum {
  /** Allegion */
  Allegion = 'Allegion',
  /** Aperio */
  Aperio = 'Aperio',
  /** Network */
  Network = 'Network',
  /** Onboard */
  Onboard = 'Onboard',
  /** OverWatch */
  OverWatch = 'OverWatch',
  /** Serial */
  Serial = 'Serial',
  /** Unknown */
  Unknown = 'Unknown'
}

/** Boolean expression to compare columns of type "qx_eAccessInterfaceType_enum". All fields are combined with logical 'AND'. */
export type qx_eAccessInterfaceType_enum_comparison_exp = {
  _eq?: qx_eAccessInterfaceType_enum;
  _in?: Array<qx_eAccessInterfaceType_enum>;
  _is_null?: boolean;
  _neq?: qx_eAccessInterfaceType_enum;
  _nin?: Array<qx_eAccessInterfaceType_enum>;
};

/** input type for inserting data into table "qx.eAccessInterfaceType" */
export type qx_eAccessInterfaceType_insert_input = {
  catalog?: qx_AccessCatalog_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eAccessInterfaceType_max_fields = {
  __typename?: 'qx_eAccessInterfaceType_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eAccessInterfaceType_min_fields = {
  __typename?: 'qx_eAccessInterfaceType_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eAccessInterfaceType" */
export type qx_eAccessInterfaceType_mutation_response = {
  __typename?: 'qx_eAccessInterfaceType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eAccessInterfaceType>;
};

/** input type for inserting object relation for remote table "qx.eAccessInterfaceType" */
export type qx_eAccessInterfaceType_obj_rel_insert_input = {
  data: qx_eAccessInterfaceType_insert_input;
  /** upsert condition */
  on_conflict?: qx_eAccessInterfaceType_on_conflict;
};

/** on_conflict condition type for table "qx.eAccessInterfaceType" */
export type qx_eAccessInterfaceType_on_conflict = {
  constraint: qx_eAccessInterfaceType_constraint;
  update_columns?: Array<qx_eAccessInterfaceType_update_column>;
  where?: qx_eAccessInterfaceType_bool_exp;
};

/** Ordering options when selecting data from "qx.eAccessInterfaceType". */
export type qx_eAccessInterfaceType_order_by = {
  catalog_aggregate?: qx_AccessCatalog_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eAccessInterfaceType */
export type qx_eAccessInterfaceType_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eAccessInterfaceType" */
export enum qx_eAccessInterfaceType_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eAccessInterfaceType" */
export type qx_eAccessInterfaceType_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eAccessInterfaceType" */
export type qx_eAccessInterfaceType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eAccessInterfaceType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eAccessInterfaceType_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eAccessInterfaceType" */
export enum qx_eAccessInterfaceType_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eAccessInterfaceType_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eAccessInterfaceType_set_input;
  /** filter the rows which have to be updated */
  where: qx_eAccessInterfaceType_bool_exp;
};

/** enum: manufacturer brands of access control hardware (Mercury, Allegion, etc.) */
export type qx_eAccessMake = {
  __typename?: 'qx_eAccessMake';
  /** An array relationship */
  ReaderAccessTypeCompatibilities: Array<readerAccessTypeCompatibility>;
  /** An aggregate relationship */
  ReaderAccessTypeCompatibilities_aggregate: readerAccessTypeCompatibility_aggregate;
  /** An array relationship */
  ReaderProtocolCompatibilities: Array<readerProtocolCompatibility>;
  /** An aggregate relationship */
  ReaderProtocolCompatibilities_aggregate: readerProtocolCompatibility_aggregate;
  /** An array relationship */
  SuperviseInputCompatibilities: Array<superviseInputCompatibility>;
  /** An aggregate relationship */
  SuperviseInputCompatibilities_aggregate: superviseInputCompatibility_aggregate;
  description?: string;
  name: string;
};


/** enum: manufacturer brands of access control hardware (Mercury, Allegion, etc.) */
export type qx_eAccessMakeReaderAccessTypeCompatibilitiesArgs = {
  distinct_on?: Array<readerAccessTypeCompatibility_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<readerAccessTypeCompatibility_order_by>;
  where?: readerAccessTypeCompatibility_bool_exp;
};


/** enum: manufacturer brands of access control hardware (Mercury, Allegion, etc.) */
export type qx_eAccessMakeReaderAccessTypeCompatibilities_aggregateArgs = {
  distinct_on?: Array<readerAccessTypeCompatibility_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<readerAccessTypeCompatibility_order_by>;
  where?: readerAccessTypeCompatibility_bool_exp;
};


/** enum: manufacturer brands of access control hardware (Mercury, Allegion, etc.) */
export type qx_eAccessMakeReaderProtocolCompatibilitiesArgs = {
  distinct_on?: Array<readerProtocolCompatibility_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<readerProtocolCompatibility_order_by>;
  where?: readerProtocolCompatibility_bool_exp;
};


/** enum: manufacturer brands of access control hardware (Mercury, Allegion, etc.) */
export type qx_eAccessMakeReaderProtocolCompatibilities_aggregateArgs = {
  distinct_on?: Array<readerProtocolCompatibility_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<readerProtocolCompatibility_order_by>;
  where?: readerProtocolCompatibility_bool_exp;
};


/** enum: manufacturer brands of access control hardware (Mercury, Allegion, etc.) */
export type qx_eAccessMakeSuperviseInputCompatibilitiesArgs = {
  distinct_on?: Array<superviseInputCompatibility_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<superviseInputCompatibility_order_by>;
  where?: superviseInputCompatibility_bool_exp;
};


/** enum: manufacturer brands of access control hardware (Mercury, Allegion, etc.) */
export type qx_eAccessMakeSuperviseInputCompatibilities_aggregateArgs = {
  distinct_on?: Array<superviseInputCompatibility_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<superviseInputCompatibility_order_by>;
  where?: superviseInputCompatibility_bool_exp;
};

/** aggregated selection of "qx.eAccessMake" */
export type qx_eAccessMake_aggregate = {
  __typename?: 'qx_eAccessMake_aggregate';
  aggregate?: qx_eAccessMake_aggregate_fields;
  nodes: Array<qx_eAccessMake>;
};

/** aggregate fields of "qx.eAccessMake" */
export type qx_eAccessMake_aggregate_fields = {
  __typename?: 'qx_eAccessMake_aggregate_fields';
  count: number;
  max?: qx_eAccessMake_max_fields;
  min?: qx_eAccessMake_min_fields;
};


/** aggregate fields of "qx.eAccessMake" */
export type qx_eAccessMake_aggregate_fieldscountArgs = {
  columns?: Array<qx_eAccessMake_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eAccessMake". All fields are combined with a logical 'AND'. */
export type qx_eAccessMake_bool_exp = {
  ReaderAccessTypeCompatibilities?: readerAccessTypeCompatibility_bool_exp;
  ReaderAccessTypeCompatibilities_aggregate?: readerAccessTypeCompatibility_aggregate_bool_exp;
  ReaderProtocolCompatibilities?: readerProtocolCompatibility_bool_exp;
  ReaderProtocolCompatibilities_aggregate?: readerProtocolCompatibility_aggregate_bool_exp;
  SuperviseInputCompatibilities?: superviseInputCompatibility_bool_exp;
  SuperviseInputCompatibilities_aggregate?: superviseInputCompatibility_aggregate_bool_exp;
  _and?: Array<qx_eAccessMake_bool_exp>;
  _not?: qx_eAccessMake_bool_exp;
  _or?: Array<qx_eAccessMake_bool_exp>;
  description?: String_comparison_exp;
  name?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eAccessMake" */
export enum qx_eAccessMake_constraint {
  /** unique or primary key constraint on columns "name" */
  eAccessMake_pkey = 'eAccessMake_pkey'
}

export enum qx_eAccessMake_enum {
  Axis = 'Axis',
  Mercury = 'Mercury',
  Rosslare = 'Rosslare'
}

/** Boolean expression to compare columns of type "qx_eAccessMake_enum". All fields are combined with logical 'AND'. */
export type qx_eAccessMake_enum_comparison_exp = {
  _eq?: qx_eAccessMake_enum;
  _in?: Array<qx_eAccessMake_enum>;
  _is_null?: boolean;
  _neq?: qx_eAccessMake_enum;
  _nin?: Array<qx_eAccessMake_enum>;
};

/** input type for inserting data into table "qx.eAccessMake" */
export type qx_eAccessMake_insert_input = {
  ReaderAccessTypeCompatibilities?: readerAccessTypeCompatibility_arr_rel_insert_input;
  ReaderProtocolCompatibilities?: readerProtocolCompatibility_arr_rel_insert_input;
  SuperviseInputCompatibilities?: superviseInputCompatibility_arr_rel_insert_input;
  description?: string;
  name?: string;
};

/** aggregate max on columns */
export type qx_eAccessMake_max_fields = {
  __typename?: 'qx_eAccessMake_max_fields';
  description?: string;
  name?: string;
};

/** aggregate min on columns */
export type qx_eAccessMake_min_fields = {
  __typename?: 'qx_eAccessMake_min_fields';
  description?: string;
  name?: string;
};

/** response of any mutation on the table "qx.eAccessMake" */
export type qx_eAccessMake_mutation_response = {
  __typename?: 'qx_eAccessMake_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eAccessMake>;
};

/** input type for inserting object relation for remote table "qx.eAccessMake" */
export type qx_eAccessMake_obj_rel_insert_input = {
  data: qx_eAccessMake_insert_input;
  /** upsert condition */
  on_conflict?: qx_eAccessMake_on_conflict;
};

/** on_conflict condition type for table "qx.eAccessMake" */
export type qx_eAccessMake_on_conflict = {
  constraint: qx_eAccessMake_constraint;
  update_columns?: Array<qx_eAccessMake_update_column>;
  where?: qx_eAccessMake_bool_exp;
};

/** Ordering options when selecting data from "qx.eAccessMake". */
export type qx_eAccessMake_order_by = {
  ReaderAccessTypeCompatibilities_aggregate?: readerAccessTypeCompatibility_aggregate_order_by;
  ReaderProtocolCompatibilities_aggregate?: readerProtocolCompatibility_aggregate_order_by;
  SuperviseInputCompatibilities_aggregate?: superviseInputCompatibility_aggregate_order_by;
  description?: order_by;
  name?: order_by;
};

/** primary key columns input for table: qx.eAccessMake */
export type qx_eAccessMake_pk_columns_input = {
  name: string;
};

/** select columns of table "qx.eAccessMake" */
export enum qx_eAccessMake_select_column {
  /** column name */
  description = 'description',
  /** column name */
  name = 'name'
}

/** input type for updating data in table "qx.eAccessMake" */
export type qx_eAccessMake_set_input = {
  description?: string;
  name?: string;
};

/** Streaming cursor of the table "qx_eAccessMake" */
export type qx_eAccessMake_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eAccessMake_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eAccessMake_stream_cursor_value_input = {
  description?: string;
  name?: string;
};

/** update columns of table "qx.eAccessMake" */
export enum qx_eAccessMake_update_column {
  /** column name */
  description = 'description',
  /** column name */
  name = 'name'
}

export type qx_eAccessMake_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eAccessMake_set_input;
  /** filter the rows which have to be updated */
  where: qx_eAccessMake_bool_exp;
};

/** enum: commands that can be sent to an access point (momentary unlock, lock, unlock, grant access) */
export type qx_eAccessPointAction = {
  __typename?: 'qx_eAccessPointAction';
  /** An array relationship */
  Readers: Array<qx_Reader>;
  /** An aggregate relationship */
  Readers_aggregate: qx_Reader_aggregate;
  comment?: string;
  value: string;
};


/** enum: commands that can be sent to an access point (momentary unlock, lock, unlock, grant access) */
export type qx_eAccessPointActionReadersArgs = {
  distinct_on?: Array<qx_Reader_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Reader_order_by>;
  where?: qx_Reader_bool_exp;
};


/** enum: commands that can be sent to an access point (momentary unlock, lock, unlock, grant access) */
export type qx_eAccessPointActionReaders_aggregateArgs = {
  distinct_on?: Array<qx_Reader_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Reader_order_by>;
  where?: qx_Reader_bool_exp;
};

/** aggregated selection of "qx.eAccessPointAction" */
export type qx_eAccessPointAction_aggregate = {
  __typename?: 'qx_eAccessPointAction_aggregate';
  aggregate?: qx_eAccessPointAction_aggregate_fields;
  nodes: Array<qx_eAccessPointAction>;
};

/** aggregate fields of "qx.eAccessPointAction" */
export type qx_eAccessPointAction_aggregate_fields = {
  __typename?: 'qx_eAccessPointAction_aggregate_fields';
  count: number;
  max?: qx_eAccessPointAction_max_fields;
  min?: qx_eAccessPointAction_min_fields;
};


/** aggregate fields of "qx.eAccessPointAction" */
export type qx_eAccessPointAction_aggregate_fieldscountArgs = {
  columns?: Array<qx_eAccessPointAction_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eAccessPointAction". All fields are combined with a logical 'AND'. */
export type qx_eAccessPointAction_bool_exp = {
  Readers?: qx_Reader_bool_exp;
  Readers_aggregate?: qx_Reader_aggregate_bool_exp;
  _and?: Array<qx_eAccessPointAction_bool_exp>;
  _not?: qx_eAccessPointAction_bool_exp;
  _or?: Array<qx_eAccessPointAction_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eAccessPointAction" */
export enum qx_eAccessPointAction_constraint {
  /** unique or primary key constraint on columns "value" */
  eAccessPointAction_pkey = 'eAccessPointAction_pkey'
}

export enum qx_eAccessPointAction_enum {
  /** Access */
  Access = 'Access',
  /** Bypass */
  Bypass = 'Bypass',
  /** Unknown */
  Unknown = 'Unknown'
}

/** Boolean expression to compare columns of type "qx_eAccessPointAction_enum". All fields are combined with logical 'AND'. */
export type qx_eAccessPointAction_enum_comparison_exp = {
  _eq?: qx_eAccessPointAction_enum;
  _in?: Array<qx_eAccessPointAction_enum>;
  _is_null?: boolean;
  _neq?: qx_eAccessPointAction_enum;
  _nin?: Array<qx_eAccessPointAction_enum>;
};

/** input type for inserting data into table "qx.eAccessPointAction" */
export type qx_eAccessPointAction_insert_input = {
  Readers?: qx_Reader_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eAccessPointAction_max_fields = {
  __typename?: 'qx_eAccessPointAction_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eAccessPointAction_min_fields = {
  __typename?: 'qx_eAccessPointAction_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eAccessPointAction" */
export type qx_eAccessPointAction_mutation_response = {
  __typename?: 'qx_eAccessPointAction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eAccessPointAction>;
};

/** input type for inserting object relation for remote table "qx.eAccessPointAction" */
export type qx_eAccessPointAction_obj_rel_insert_input = {
  data: qx_eAccessPointAction_insert_input;
  /** upsert condition */
  on_conflict?: qx_eAccessPointAction_on_conflict;
};

/** on_conflict condition type for table "qx.eAccessPointAction" */
export type qx_eAccessPointAction_on_conflict = {
  constraint: qx_eAccessPointAction_constraint;
  update_columns?: Array<qx_eAccessPointAction_update_column>;
  where?: qx_eAccessPointAction_bool_exp;
};

/** Ordering options when selecting data from "qx.eAccessPointAction". */
export type qx_eAccessPointAction_order_by = {
  Readers_aggregate?: qx_Reader_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eAccessPointAction */
export type qx_eAccessPointAction_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eAccessPointAction" */
export enum qx_eAccessPointAction_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eAccessPointAction" */
export type qx_eAccessPointAction_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eAccessPointAction" */
export type qx_eAccessPointAction_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eAccessPointAction_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eAccessPointAction_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eAccessPointAction" */
export enum qx_eAccessPointAction_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eAccessPointAction_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eAccessPointAction_set_input;
  /** filter the rows which have to be updated */
  where: qx_eAccessPointAction_bool_exp;
};

/** enum: direction of travel at an access point (entry, exit, both) */
export type qx_eAccessPointDirection = {
  __typename?: 'qx_eAccessPointDirection';
  /** An array relationship */
  Locks: Array<qx_Lock>;
  /** An aggregate relationship */
  Locks_aggregate: qx_Lock_aggregate;
  /** An array relationship */
  Readers: Array<qx_Reader>;
  /** An aggregate relationship */
  Readers_aggregate: qx_Reader_aggregate;
  comment?: string;
  value: string;
};


/** enum: direction of travel at an access point (entry, exit, both) */
export type qx_eAccessPointDirectionLocksArgs = {
  distinct_on?: Array<qx_Lock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Lock_order_by>;
  where?: qx_Lock_bool_exp;
};


/** enum: direction of travel at an access point (entry, exit, both) */
export type qx_eAccessPointDirectionLocks_aggregateArgs = {
  distinct_on?: Array<qx_Lock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Lock_order_by>;
  where?: qx_Lock_bool_exp;
};


/** enum: direction of travel at an access point (entry, exit, both) */
export type qx_eAccessPointDirectionReadersArgs = {
  distinct_on?: Array<qx_Reader_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Reader_order_by>;
  where?: qx_Reader_bool_exp;
};


/** enum: direction of travel at an access point (entry, exit, both) */
export type qx_eAccessPointDirectionReaders_aggregateArgs = {
  distinct_on?: Array<qx_Reader_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Reader_order_by>;
  where?: qx_Reader_bool_exp;
};

/** aggregated selection of "qx.eAccessPointDirection" */
export type qx_eAccessPointDirection_aggregate = {
  __typename?: 'qx_eAccessPointDirection_aggregate';
  aggregate?: qx_eAccessPointDirection_aggregate_fields;
  nodes: Array<qx_eAccessPointDirection>;
};

/** aggregate fields of "qx.eAccessPointDirection" */
export type qx_eAccessPointDirection_aggregate_fields = {
  __typename?: 'qx_eAccessPointDirection_aggregate_fields';
  count: number;
  max?: qx_eAccessPointDirection_max_fields;
  min?: qx_eAccessPointDirection_min_fields;
};


/** aggregate fields of "qx.eAccessPointDirection" */
export type qx_eAccessPointDirection_aggregate_fieldscountArgs = {
  columns?: Array<qx_eAccessPointDirection_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eAccessPointDirection". All fields are combined with a logical 'AND'. */
export type qx_eAccessPointDirection_bool_exp = {
  Locks?: qx_Lock_bool_exp;
  Locks_aggregate?: qx_Lock_aggregate_bool_exp;
  Readers?: qx_Reader_bool_exp;
  Readers_aggregate?: qx_Reader_aggregate_bool_exp;
  _and?: Array<qx_eAccessPointDirection_bool_exp>;
  _not?: qx_eAccessPointDirection_bool_exp;
  _or?: Array<qx_eAccessPointDirection_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eAccessPointDirection" */
export enum qx_eAccessPointDirection_constraint {
  /** unique or primary key constraint on columns "value" */
  eAccessPointDirection_pkey = 'eAccessPointDirection_pkey'
}

export enum qx_eAccessPointDirection_enum {
  /** Enter */
  Enter = 'Enter',
  /** Exit */
  Exit = 'Exit',
  /** Unknown */
  Unknown = 'Unknown'
}

/** Boolean expression to compare columns of type "qx_eAccessPointDirection_enum". All fields are combined with logical 'AND'. */
export type qx_eAccessPointDirection_enum_comparison_exp = {
  _eq?: qx_eAccessPointDirection_enum;
  _in?: Array<qx_eAccessPointDirection_enum>;
  _is_null?: boolean;
  _neq?: qx_eAccessPointDirection_enum;
  _nin?: Array<qx_eAccessPointDirection_enum>;
};

/** input type for inserting data into table "qx.eAccessPointDirection" */
export type qx_eAccessPointDirection_insert_input = {
  Locks?: qx_Lock_arr_rel_insert_input;
  Readers?: qx_Reader_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eAccessPointDirection_max_fields = {
  __typename?: 'qx_eAccessPointDirection_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eAccessPointDirection_min_fields = {
  __typename?: 'qx_eAccessPointDirection_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eAccessPointDirection" */
export type qx_eAccessPointDirection_mutation_response = {
  __typename?: 'qx_eAccessPointDirection_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eAccessPointDirection>;
};

/** input type for inserting object relation for remote table "qx.eAccessPointDirection" */
export type qx_eAccessPointDirection_obj_rel_insert_input = {
  data: qx_eAccessPointDirection_insert_input;
  /** upsert condition */
  on_conflict?: qx_eAccessPointDirection_on_conflict;
};

/** on_conflict condition type for table "qx.eAccessPointDirection" */
export type qx_eAccessPointDirection_on_conflict = {
  constraint: qx_eAccessPointDirection_constraint;
  update_columns?: Array<qx_eAccessPointDirection_update_column>;
  where?: qx_eAccessPointDirection_bool_exp;
};

/** Ordering options when selecting data from "qx.eAccessPointDirection". */
export type qx_eAccessPointDirection_order_by = {
  Locks_aggregate?: qx_Lock_aggregate_order_by;
  Readers_aggregate?: qx_Reader_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eAccessPointDirection */
export type qx_eAccessPointDirection_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eAccessPointDirection" */
export enum qx_eAccessPointDirection_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eAccessPointDirection" */
export type qx_eAccessPointDirection_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eAccessPointDirection" */
export type qx_eAccessPointDirection_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eAccessPointDirection_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eAccessPointDirection_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eAccessPointDirection" */
export enum qx_eAccessPointDirection_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eAccessPointDirection_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eAccessPointDirection_set_input;
  /** filter the rows which have to be updated */
  where: qx_eAccessPointDirection_bool_exp;
};

/** enum: types of access points (door, gate, elevator, turnstile, etc.) */
export type qx_eAccessPointType = {
  __typename?: 'qx_eAccessPointType';
  /** An array relationship */
  Readers: Array<qx_Reader>;
  /** An aggregate relationship */
  Readers_aggregate: qx_Reader_aggregate;
  comment?: string;
  value: string;
};


/** enum: types of access points (door, gate, elevator, turnstile, etc.) */
export type qx_eAccessPointTypeReadersArgs = {
  distinct_on?: Array<qx_Reader_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Reader_order_by>;
  where?: qx_Reader_bool_exp;
};


/** enum: types of access points (door, gate, elevator, turnstile, etc.) */
export type qx_eAccessPointTypeReaders_aggregateArgs = {
  distinct_on?: Array<qx_Reader_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Reader_order_by>;
  where?: qx_Reader_bool_exp;
};

/** aggregated selection of "qx.eAccessPointType" */
export type qx_eAccessPointType_aggregate = {
  __typename?: 'qx_eAccessPointType_aggregate';
  aggregate?: qx_eAccessPointType_aggregate_fields;
  nodes: Array<qx_eAccessPointType>;
};

/** aggregate fields of "qx.eAccessPointType" */
export type qx_eAccessPointType_aggregate_fields = {
  __typename?: 'qx_eAccessPointType_aggregate_fields';
  count: number;
  max?: qx_eAccessPointType_max_fields;
  min?: qx_eAccessPointType_min_fields;
};


/** aggregate fields of "qx.eAccessPointType" */
export type qx_eAccessPointType_aggregate_fieldscountArgs = {
  columns?: Array<qx_eAccessPointType_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eAccessPointType". All fields are combined with a logical 'AND'. */
export type qx_eAccessPointType_bool_exp = {
  Readers?: qx_Reader_bool_exp;
  Readers_aggregate?: qx_Reader_aggregate_bool_exp;
  _and?: Array<qx_eAccessPointType_bool_exp>;
  _not?: qx_eAccessPointType_bool_exp;
  _or?: Array<qx_eAccessPointType_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eAccessPointType" */
export enum qx_eAccessPointType_constraint {
  /** unique or primary key constraint on columns "value" */
  eAccessPointType_pkey = 'eAccessPointType_pkey'
}

export enum qx_eAccessPointType_enum {
  /** Button */
  Button = 'Button',
  /** Reader */
  Reader = 'Reader',
  /** Unknown */
  Unknown = 'Unknown'
}

/** Boolean expression to compare columns of type "qx_eAccessPointType_enum". All fields are combined with logical 'AND'. */
export type qx_eAccessPointType_enum_comparison_exp = {
  _eq?: qx_eAccessPointType_enum;
  _in?: Array<qx_eAccessPointType_enum>;
  _is_null?: boolean;
  _neq?: qx_eAccessPointType_enum;
  _nin?: Array<qx_eAccessPointType_enum>;
};

/** input type for inserting data into table "qx.eAccessPointType" */
export type qx_eAccessPointType_insert_input = {
  Readers?: qx_Reader_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eAccessPointType_max_fields = {
  __typename?: 'qx_eAccessPointType_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eAccessPointType_min_fields = {
  __typename?: 'qx_eAccessPointType_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eAccessPointType" */
export type qx_eAccessPointType_mutation_response = {
  __typename?: 'qx_eAccessPointType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eAccessPointType>;
};

/** input type for inserting object relation for remote table "qx.eAccessPointType" */
export type qx_eAccessPointType_obj_rel_insert_input = {
  data: qx_eAccessPointType_insert_input;
  /** upsert condition */
  on_conflict?: qx_eAccessPointType_on_conflict;
};

/** on_conflict condition type for table "qx.eAccessPointType" */
export type qx_eAccessPointType_on_conflict = {
  constraint: qx_eAccessPointType_constraint;
  update_columns?: Array<qx_eAccessPointType_update_column>;
  where?: qx_eAccessPointType_bool_exp;
};

/** Ordering options when selecting data from "qx.eAccessPointType". */
export type qx_eAccessPointType_order_by = {
  Readers_aggregate?: qx_Reader_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eAccessPointType */
export type qx_eAccessPointType_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eAccessPointType" */
export enum qx_eAccessPointType_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eAccessPointType" */
export type qx_eAccessPointType_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eAccessPointType" */
export type qx_eAccessPointType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eAccessPointType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eAccessPointType_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eAccessPointType" */
export enum qx_eAccessPointType_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eAccessPointType_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eAccessPointType_set_input;
  /** filter the rows which have to be updated */
  where: qx_eAccessPointType_bool_exp;
};

/** enum: categories of application-level privileges that can be granted to roles */
export type qx_eAppPrivilegeType = {
  __typename?: 'qx_eAppPrivilegeType';
  /** An array relationship */
  RoleAppPrivileges: Array<roleAppPrivileges>;
  /** An aggregate relationship */
  RoleAppPrivileges_aggregate: roleAppPrivileges_aggregate;
  comment?: string;
  value: string;
};


/** enum: categories of application-level privileges that can be granted to roles */
export type qx_eAppPrivilegeTypeRoleAppPrivilegesArgs = {
  distinct_on?: Array<roleAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<roleAppPrivileges_order_by>;
  where?: roleAppPrivileges_bool_exp;
};


/** enum: categories of application-level privileges that can be granted to roles */
export type qx_eAppPrivilegeTypeRoleAppPrivileges_aggregateArgs = {
  distinct_on?: Array<roleAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<roleAppPrivileges_order_by>;
  where?: roleAppPrivileges_bool_exp;
};

/** aggregated selection of "qx.eAppPrivilegeType" */
export type qx_eAppPrivilegeType_aggregate = {
  __typename?: 'qx_eAppPrivilegeType_aggregate';
  aggregate?: qx_eAppPrivilegeType_aggregate_fields;
  nodes: Array<qx_eAppPrivilegeType>;
};

/** aggregate fields of "qx.eAppPrivilegeType" */
export type qx_eAppPrivilegeType_aggregate_fields = {
  __typename?: 'qx_eAppPrivilegeType_aggregate_fields';
  count: number;
  max?: qx_eAppPrivilegeType_max_fields;
  min?: qx_eAppPrivilegeType_min_fields;
};


/** aggregate fields of "qx.eAppPrivilegeType" */
export type qx_eAppPrivilegeType_aggregate_fieldscountArgs = {
  columns?: Array<qx_eAppPrivilegeType_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eAppPrivilegeType". All fields are combined with a logical 'AND'. */
export type qx_eAppPrivilegeType_bool_exp = {
  RoleAppPrivileges?: roleAppPrivileges_bool_exp;
  RoleAppPrivileges_aggregate?: roleAppPrivileges_aggregate_bool_exp;
  _and?: Array<qx_eAppPrivilegeType_bool_exp>;
  _not?: qx_eAppPrivilegeType_bool_exp;
  _or?: Array<qx_eAppPrivilegeType_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eAppPrivilegeType" */
export enum qx_eAppPrivilegeType_constraint {
  /** unique or primary key constraint on columns "value" */
  eAppPrivilegeType_pkey = 'eAppPrivilegeType_pkey'
}

export enum qx_eAppPrivilegeType_enum {
  /** protects a device */
  device = 'device',
  /** protects a door */
  door = 'door',
  /** protects an intrusion partition */
  intrusion = 'intrusion',
  /** protects places within a path */
  path = 'path',
  /** protects a place */
  place = 'place',
  /** protects a camera */
  videoSource = 'videoSource'
}

/** Boolean expression to compare columns of type "qx_eAppPrivilegeType_enum". All fields are combined with logical 'AND'. */
export type qx_eAppPrivilegeType_enum_comparison_exp = {
  _eq?: qx_eAppPrivilegeType_enum;
  _in?: Array<qx_eAppPrivilegeType_enum>;
  _is_null?: boolean;
  _neq?: qx_eAppPrivilegeType_enum;
  _nin?: Array<qx_eAppPrivilegeType_enum>;
};

/** input type for inserting data into table "qx.eAppPrivilegeType" */
export type qx_eAppPrivilegeType_insert_input = {
  RoleAppPrivileges?: roleAppPrivileges_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eAppPrivilegeType_max_fields = {
  __typename?: 'qx_eAppPrivilegeType_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eAppPrivilegeType_min_fields = {
  __typename?: 'qx_eAppPrivilegeType_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eAppPrivilegeType" */
export type qx_eAppPrivilegeType_mutation_response = {
  __typename?: 'qx_eAppPrivilegeType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eAppPrivilegeType>;
};

/** input type for inserting object relation for remote table "qx.eAppPrivilegeType" */
export type qx_eAppPrivilegeType_obj_rel_insert_input = {
  data: qx_eAppPrivilegeType_insert_input;
  /** upsert condition */
  on_conflict?: qx_eAppPrivilegeType_on_conflict;
};

/** on_conflict condition type for table "qx.eAppPrivilegeType" */
export type qx_eAppPrivilegeType_on_conflict = {
  constraint: qx_eAppPrivilegeType_constraint;
  update_columns?: Array<qx_eAppPrivilegeType_update_column>;
  where?: qx_eAppPrivilegeType_bool_exp;
};

/** Ordering options when selecting data from "qx.eAppPrivilegeType". */
export type qx_eAppPrivilegeType_order_by = {
  RoleAppPrivileges_aggregate?: roleAppPrivileges_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eAppPrivilegeType */
export type qx_eAppPrivilegeType_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eAppPrivilegeType" */
export enum qx_eAppPrivilegeType_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eAppPrivilegeType" */
export type qx_eAppPrivilegeType_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eAppPrivilegeType" */
export type qx_eAppPrivilegeType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eAppPrivilegeType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eAppPrivilegeType_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eAppPrivilegeType" */
export enum qx_eAppPrivilegeType_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eAppPrivilegeType_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eAppPrivilegeType_set_input;
  /** filter the rows which have to be updated */
  where: qx_eAppPrivilegeType_bool_exp;
};

/** enum: external identity provider types supported for user authentication (local, Azure AD, Okta, etc.) */
export type qx_eAuthProvider = {
  __typename?: 'qx_eAuthProvider';
  comment: string;
  value: string;
};

/** aggregated selection of "qx.eAuthProvider" */
export type qx_eAuthProvider_aggregate = {
  __typename?: 'qx_eAuthProvider_aggregate';
  aggregate?: qx_eAuthProvider_aggregate_fields;
  nodes: Array<qx_eAuthProvider>;
};

/** aggregate fields of "qx.eAuthProvider" */
export type qx_eAuthProvider_aggregate_fields = {
  __typename?: 'qx_eAuthProvider_aggregate_fields';
  count: number;
  max?: qx_eAuthProvider_max_fields;
  min?: qx_eAuthProvider_min_fields;
};


/** aggregate fields of "qx.eAuthProvider" */
export type qx_eAuthProvider_aggregate_fieldscountArgs = {
  columns?: Array<qx_eAuthProvider_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eAuthProvider". All fields are combined with a logical 'AND'. */
export type qx_eAuthProvider_bool_exp = {
  _and?: Array<qx_eAuthProvider_bool_exp>;
  _not?: qx_eAuthProvider_bool_exp;
  _or?: Array<qx_eAuthProvider_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eAuthProvider" */
export enum qx_eAuthProvider_constraint {
  /** unique or primary key constraint on columns "value" */
  eAuthProvider_pkey = 'eAuthProvider_pkey'
}

export enum qx_eAuthProvider_enum {
  /** Entra */
  entra = 'entra',
  /** LDAP */
  ldap = 'ldap'
}

/** Boolean expression to compare columns of type "qx_eAuthProvider_enum". All fields are combined with logical 'AND'. */
export type qx_eAuthProvider_enum_comparison_exp = {
  _eq?: qx_eAuthProvider_enum;
  _in?: Array<qx_eAuthProvider_enum>;
  _is_null?: boolean;
  _neq?: qx_eAuthProvider_enum;
  _nin?: Array<qx_eAuthProvider_enum>;
};

/** input type for inserting data into table "qx.eAuthProvider" */
export type qx_eAuthProvider_insert_input = {
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eAuthProvider_max_fields = {
  __typename?: 'qx_eAuthProvider_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eAuthProvider_min_fields = {
  __typename?: 'qx_eAuthProvider_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eAuthProvider" */
export type qx_eAuthProvider_mutation_response = {
  __typename?: 'qx_eAuthProvider_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eAuthProvider>;
};

/** on_conflict condition type for table "qx.eAuthProvider" */
export type qx_eAuthProvider_on_conflict = {
  constraint: qx_eAuthProvider_constraint;
  update_columns?: Array<qx_eAuthProvider_update_column>;
  where?: qx_eAuthProvider_bool_exp;
};

/** Ordering options when selecting data from "qx.eAuthProvider". */
export type qx_eAuthProvider_order_by = {
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eAuthProvider */
export type qx_eAuthProvider_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eAuthProvider" */
export enum qx_eAuthProvider_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eAuthProvider" */
export type qx_eAuthProvider_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eAuthProvider" */
export type qx_eAuthProvider_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eAuthProvider_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eAuthProvider_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eAuthProvider" */
export enum qx_eAuthProvider_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eAuthProvider_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eAuthProvider_set_input;
  /** filter the rows which have to be updated */
  where: qx_eAuthProvider_bool_exp;
};

/** enum: authentication strategy types determining how credentials are validated */
export type qx_eAuthStrategy = {
  __typename?: 'qx_eAuthStrategy';
  comment?: string;
  value: string;
};

/** aggregated selection of "qx.eAuthStrategy" */
export type qx_eAuthStrategy_aggregate = {
  __typename?: 'qx_eAuthStrategy_aggregate';
  aggregate?: qx_eAuthStrategy_aggregate_fields;
  nodes: Array<qx_eAuthStrategy>;
};

/** aggregate fields of "qx.eAuthStrategy" */
export type qx_eAuthStrategy_aggregate_fields = {
  __typename?: 'qx_eAuthStrategy_aggregate_fields';
  count: number;
  max?: qx_eAuthStrategy_max_fields;
  min?: qx_eAuthStrategy_min_fields;
};


/** aggregate fields of "qx.eAuthStrategy" */
export type qx_eAuthStrategy_aggregate_fieldscountArgs = {
  columns?: Array<qx_eAuthStrategy_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eAuthStrategy". All fields are combined with a logical 'AND'. */
export type qx_eAuthStrategy_bool_exp = {
  _and?: Array<qx_eAuthStrategy_bool_exp>;
  _not?: qx_eAuthStrategy_bool_exp;
  _or?: Array<qx_eAuthStrategy_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eAuthStrategy" */
export enum qx_eAuthStrategy_constraint {
  /** unique or primary key constraint on columns "value" */
  eAuthStrategy_pkey = 'eAuthStrategy_pkey'
}

/** input type for inserting data into table "qx.eAuthStrategy" */
export type qx_eAuthStrategy_insert_input = {
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eAuthStrategy_max_fields = {
  __typename?: 'qx_eAuthStrategy_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eAuthStrategy_min_fields = {
  __typename?: 'qx_eAuthStrategy_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eAuthStrategy" */
export type qx_eAuthStrategy_mutation_response = {
  __typename?: 'qx_eAuthStrategy_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eAuthStrategy>;
};

/** on_conflict condition type for table "qx.eAuthStrategy" */
export type qx_eAuthStrategy_on_conflict = {
  constraint: qx_eAuthStrategy_constraint;
  update_columns?: Array<qx_eAuthStrategy_update_column>;
  where?: qx_eAuthStrategy_bool_exp;
};

/** Ordering options when selecting data from "qx.eAuthStrategy". */
export type qx_eAuthStrategy_order_by = {
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eAuthStrategy */
export type qx_eAuthStrategy_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eAuthStrategy" */
export enum qx_eAuthStrategy_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eAuthStrategy" */
export type qx_eAuthStrategy_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eAuthStrategy" */
export type qx_eAuthStrategy_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eAuthStrategy_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eAuthStrategy_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eAuthStrategy" */
export enum qx_eAuthStrategy_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eAuthStrategy_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eAuthStrategy_set_input;
  /** filter the rows which have to be updated */
  where: qx_eAuthStrategy_bool_exp;
};

/** enum: battery charge level states for battery-powered door hardware */
export type qx_eBatteryLevel = {
  __typename?: 'qx_eBatteryLevel';
  /** An array relationship */
  Doors: Array<qx_Door>;
  /** An aggregate relationship */
  Doors_aggregate: qx_Door_aggregate;
  comment?: string;
  value: string;
};


/** enum: battery charge level states for battery-powered door hardware */
export type qx_eBatteryLevelDoorsArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


/** enum: battery charge level states for battery-powered door hardware */
export type qx_eBatteryLevelDoors_aggregateArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};

/** aggregated selection of "qx.eBatteryLevel" */
export type qx_eBatteryLevel_aggregate = {
  __typename?: 'qx_eBatteryLevel_aggregate';
  aggregate?: qx_eBatteryLevel_aggregate_fields;
  nodes: Array<qx_eBatteryLevel>;
};

/** aggregate fields of "qx.eBatteryLevel" */
export type qx_eBatteryLevel_aggregate_fields = {
  __typename?: 'qx_eBatteryLevel_aggregate_fields';
  count: number;
  max?: qx_eBatteryLevel_max_fields;
  min?: qx_eBatteryLevel_min_fields;
};


/** aggregate fields of "qx.eBatteryLevel" */
export type qx_eBatteryLevel_aggregate_fieldscountArgs = {
  columns?: Array<qx_eBatteryLevel_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eBatteryLevel". All fields are combined with a logical 'AND'. */
export type qx_eBatteryLevel_bool_exp = {
  Doors?: qx_Door_bool_exp;
  Doors_aggregate?: qx_Door_aggregate_bool_exp;
  _and?: Array<qx_eBatteryLevel_bool_exp>;
  _not?: qx_eBatteryLevel_bool_exp;
  _or?: Array<qx_eBatteryLevel_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eBatteryLevel" */
export enum qx_eBatteryLevel_constraint {
  /** unique or primary key constraint on columns "value" */
  eBatteryLevel_pkey = 'eBatteryLevel_pkey'
}

export enum qx_eBatteryLevel_enum {
  /** Flat */
  Flat = 'Flat',
  /** Low */
  Low = 'Low',
  /** Normal */
  Normal = 'Normal',
  /** Unknown */
  Unknown = 'Unknown'
}

/** Boolean expression to compare columns of type "qx_eBatteryLevel_enum". All fields are combined with logical 'AND'. */
export type qx_eBatteryLevel_enum_comparison_exp = {
  _eq?: qx_eBatteryLevel_enum;
  _in?: Array<qx_eBatteryLevel_enum>;
  _is_null?: boolean;
  _neq?: qx_eBatteryLevel_enum;
  _nin?: Array<qx_eBatteryLevel_enum>;
};

/** input type for inserting data into table "qx.eBatteryLevel" */
export type qx_eBatteryLevel_insert_input = {
  Doors?: qx_Door_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eBatteryLevel_max_fields = {
  __typename?: 'qx_eBatteryLevel_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eBatteryLevel_min_fields = {
  __typename?: 'qx_eBatteryLevel_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eBatteryLevel" */
export type qx_eBatteryLevel_mutation_response = {
  __typename?: 'qx_eBatteryLevel_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eBatteryLevel>;
};

/** input type for inserting object relation for remote table "qx.eBatteryLevel" */
export type qx_eBatteryLevel_obj_rel_insert_input = {
  data: qx_eBatteryLevel_insert_input;
  /** upsert condition */
  on_conflict?: qx_eBatteryLevel_on_conflict;
};

/** on_conflict condition type for table "qx.eBatteryLevel" */
export type qx_eBatteryLevel_on_conflict = {
  constraint: qx_eBatteryLevel_constraint;
  update_columns?: Array<qx_eBatteryLevel_update_column>;
  where?: qx_eBatteryLevel_bool_exp;
};

/** Ordering options when selecting data from "qx.eBatteryLevel". */
export type qx_eBatteryLevel_order_by = {
  Doors_aggregate?: qx_Door_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eBatteryLevel */
export type qx_eBatteryLevel_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eBatteryLevel" */
export enum qx_eBatteryLevel_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eBatteryLevel" */
export type qx_eBatteryLevel_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eBatteryLevel" */
export type qx_eBatteryLevel_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eBatteryLevel_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eBatteryLevel_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eBatteryLevel" */
export enum qx_eBatteryLevel_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eBatteryLevel_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eBatteryLevel_set_input;
  /** filter the rows which have to be updated */
  where: qx_eBatteryLevel_bool_exp;
};

/** enum: serial communication baud rate values for hardware peripheral connections */
export type qx_eBaudrate = {
  __typename?: 'qx_eBaudrate';
  /** An array relationship */
  Readers: Array<qx_Reader>;
  /** An aggregate relationship */
  Readers_aggregate: qx_Reader_aggregate;
  comment?: string;
  /** An array relationship */
  mercuryInventories: Array<qx_AccessInventory>;
  /** An aggregate relationship */
  mercuryInventories_aggregate: qx_AccessInventory_aggregate;
  value: string;
};


/** enum: serial communication baud rate values for hardware peripheral connections */
export type qx_eBaudrateReadersArgs = {
  distinct_on?: Array<qx_Reader_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Reader_order_by>;
  where?: qx_Reader_bool_exp;
};


/** enum: serial communication baud rate values for hardware peripheral connections */
export type qx_eBaudrateReaders_aggregateArgs = {
  distinct_on?: Array<qx_Reader_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Reader_order_by>;
  where?: qx_Reader_bool_exp;
};


/** enum: serial communication baud rate values for hardware peripheral connections */
export type qx_eBaudratemercuryInventoriesArgs = {
  distinct_on?: Array<qx_AccessInventory_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessInventory_order_by>;
  where?: qx_AccessInventory_bool_exp;
};


/** enum: serial communication baud rate values for hardware peripheral connections */
export type qx_eBaudratemercuryInventories_aggregateArgs = {
  distinct_on?: Array<qx_AccessInventory_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessInventory_order_by>;
  where?: qx_AccessInventory_bool_exp;
};

/** aggregated selection of "qx.eBaudrate" */
export type qx_eBaudrate_aggregate = {
  __typename?: 'qx_eBaudrate_aggregate';
  aggregate?: qx_eBaudrate_aggregate_fields;
  nodes: Array<qx_eBaudrate>;
};

/** aggregate fields of "qx.eBaudrate" */
export type qx_eBaudrate_aggregate_fields = {
  __typename?: 'qx_eBaudrate_aggregate_fields';
  count: number;
  max?: qx_eBaudrate_max_fields;
  min?: qx_eBaudrate_min_fields;
};


/** aggregate fields of "qx.eBaudrate" */
export type qx_eBaudrate_aggregate_fieldscountArgs = {
  columns?: Array<qx_eBaudrate_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eBaudrate". All fields are combined with a logical 'AND'. */
export type qx_eBaudrate_bool_exp = {
  Readers?: qx_Reader_bool_exp;
  Readers_aggregate?: qx_Reader_aggregate_bool_exp;
  _and?: Array<qx_eBaudrate_bool_exp>;
  _not?: qx_eBaudrate_bool_exp;
  _or?: Array<qx_eBaudrate_bool_exp>;
  comment?: String_comparison_exp;
  mercuryInventories?: qx_AccessInventory_bool_exp;
  mercuryInventories_aggregate?: qx_AccessInventory_aggregate_bool_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eBaudrate" */
export enum qx_eBaudrate_constraint {
  /** unique or primary key constraint on columns "value" */
  eBaudrate_pkey = 'eBaudrate_pkey'
}

export enum qx_eBaudrate_enum {
  /** -1 */
  Default = 'Default',
  /** 9600 */
  bps9600 = 'bps9600',
  /** 19200 */
  bps19200 = 'bps19200',
  /** 38400 */
  bps38400 = 'bps38400',
  /** 57600 */
  bps56700 = 'bps56700',
  /** 115200 */
  bps115200 = 'bps115200',
  /** 230400 */
  bps230400 = 'bps230400'
}

/** Boolean expression to compare columns of type "qx_eBaudrate_enum". All fields are combined with logical 'AND'. */
export type qx_eBaudrate_enum_comparison_exp = {
  _eq?: qx_eBaudrate_enum;
  _in?: Array<qx_eBaudrate_enum>;
  _is_null?: boolean;
  _neq?: qx_eBaudrate_enum;
  _nin?: Array<qx_eBaudrate_enum>;
};

/** input type for inserting data into table "qx.eBaudrate" */
export type qx_eBaudrate_insert_input = {
  Readers?: qx_Reader_arr_rel_insert_input;
  comment?: string;
  mercuryInventories?: qx_AccessInventory_arr_rel_insert_input;
  value?: string;
};

/** aggregate max on columns */
export type qx_eBaudrate_max_fields = {
  __typename?: 'qx_eBaudrate_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eBaudrate_min_fields = {
  __typename?: 'qx_eBaudrate_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eBaudrate" */
export type qx_eBaudrate_mutation_response = {
  __typename?: 'qx_eBaudrate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eBaudrate>;
};

/** input type for inserting object relation for remote table "qx.eBaudrate" */
export type qx_eBaudrate_obj_rel_insert_input = {
  data: qx_eBaudrate_insert_input;
  /** upsert condition */
  on_conflict?: qx_eBaudrate_on_conflict;
};

/** on_conflict condition type for table "qx.eBaudrate" */
export type qx_eBaudrate_on_conflict = {
  constraint: qx_eBaudrate_constraint;
  update_columns?: Array<qx_eBaudrate_update_column>;
  where?: qx_eBaudrate_bool_exp;
};

/** Ordering options when selecting data from "qx.eBaudrate". */
export type qx_eBaudrate_order_by = {
  Readers_aggregate?: qx_Reader_aggregate_order_by;
  comment?: order_by;
  mercuryInventories_aggregate?: qx_AccessInventory_aggregate_order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eBaudrate */
export type qx_eBaudrate_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eBaudrate" */
export enum qx_eBaudrate_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eBaudrate" */
export type qx_eBaudrate_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eBaudrate" */
export type qx_eBaudrate_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eBaudrate_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eBaudrate_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eBaudrate" */
export enum qx_eBaudrate_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eBaudrate_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eBaudrate_set_input;
  /** filter the rows which have to be updated */
  where: qx_eBaudrate_bool_exp;
};

/** columns and relationships of "qx.eBillingTier" */
export type qx_eBillingTier = {
  __typename?: 'qx_eBillingTier';
  comment: string;
  monthlyPriceCents: number;
  monthlyTokenQuota: number;
  value: string;
};

/** aggregated selection of "qx.eBillingTier" */
export type qx_eBillingTier_aggregate = {
  __typename?: 'qx_eBillingTier_aggregate';
  aggregate?: qx_eBillingTier_aggregate_fields;
  nodes: Array<qx_eBillingTier>;
};

/** aggregate fields of "qx.eBillingTier" */
export type qx_eBillingTier_aggregate_fields = {
  __typename?: 'qx_eBillingTier_aggregate_fields';
  avg?: qx_eBillingTier_avg_fields;
  count: number;
  max?: qx_eBillingTier_max_fields;
  min?: qx_eBillingTier_min_fields;
  stddev?: qx_eBillingTier_stddev_fields;
  stddev_pop?: qx_eBillingTier_stddev_pop_fields;
  stddev_samp?: qx_eBillingTier_stddev_samp_fields;
  sum?: qx_eBillingTier_sum_fields;
  var_pop?: qx_eBillingTier_var_pop_fields;
  var_samp?: qx_eBillingTier_var_samp_fields;
  variance?: qx_eBillingTier_variance_fields;
};


/** aggregate fields of "qx.eBillingTier" */
export type qx_eBillingTier_aggregate_fieldscountArgs = {
  columns?: Array<qx_eBillingTier_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type qx_eBillingTier_avg_fields = {
  __typename?: 'qx_eBillingTier_avg_fields';
  monthlyPriceCents?: number;
  monthlyTokenQuota?: number;
};

/** Boolean expression to filter rows from the table "qx.eBillingTier". All fields are combined with a logical 'AND'. */
export type qx_eBillingTier_bool_exp = {
  _and?: Array<qx_eBillingTier_bool_exp>;
  _not?: qx_eBillingTier_bool_exp;
  _or?: Array<qx_eBillingTier_bool_exp>;
  comment?: String_comparison_exp;
  monthlyPriceCents?: Int_comparison_exp;
  monthlyTokenQuota?: Int_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eBillingTier" */
export enum qx_eBillingTier_constraint {
  /** unique or primary key constraint on columns "value" */
  eBillingTier_pkey = 'eBillingTier_pkey'
}

/** input type for incrementing numeric columns in table "qx.eBillingTier" */
export type qx_eBillingTier_inc_input = {
  monthlyPriceCents?: number;
  monthlyTokenQuota?: number;
};

/** input type for inserting data into table "qx.eBillingTier" */
export type qx_eBillingTier_insert_input = {
  comment?: string;
  monthlyPriceCents?: number;
  monthlyTokenQuota?: number;
  value?: string;
};

/** aggregate max on columns */
export type qx_eBillingTier_max_fields = {
  __typename?: 'qx_eBillingTier_max_fields';
  comment?: string;
  monthlyPriceCents?: number;
  monthlyTokenQuota?: number;
  value?: string;
};

/** aggregate min on columns */
export type qx_eBillingTier_min_fields = {
  __typename?: 'qx_eBillingTier_min_fields';
  comment?: string;
  monthlyPriceCents?: number;
  monthlyTokenQuota?: number;
  value?: string;
};

/** response of any mutation on the table "qx.eBillingTier" */
export type qx_eBillingTier_mutation_response = {
  __typename?: 'qx_eBillingTier_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eBillingTier>;
};

/** input type for inserting object relation for remote table "qx.eBillingTier" */
export type qx_eBillingTier_obj_rel_insert_input = {
  data: qx_eBillingTier_insert_input;
  /** upsert condition */
  on_conflict?: qx_eBillingTier_on_conflict;
};

/** on_conflict condition type for table "qx.eBillingTier" */
export type qx_eBillingTier_on_conflict = {
  constraint: qx_eBillingTier_constraint;
  update_columns?: Array<qx_eBillingTier_update_column>;
  where?: qx_eBillingTier_bool_exp;
};

/** Ordering options when selecting data from "qx.eBillingTier". */
export type qx_eBillingTier_order_by = {
  comment?: order_by;
  monthlyPriceCents?: order_by;
  monthlyTokenQuota?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eBillingTier */
export type qx_eBillingTier_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eBillingTier" */
export enum qx_eBillingTier_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  monthlyPriceCents = 'monthlyPriceCents',
  /** column name */
  monthlyTokenQuota = 'monthlyTokenQuota',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eBillingTier" */
export type qx_eBillingTier_set_input = {
  comment?: string;
  monthlyPriceCents?: number;
  monthlyTokenQuota?: number;
  value?: string;
};

/** aggregate stddev on columns */
export type qx_eBillingTier_stddev_fields = {
  __typename?: 'qx_eBillingTier_stddev_fields';
  monthlyPriceCents?: number;
  monthlyTokenQuota?: number;
};

/** aggregate stddev_pop on columns */
export type qx_eBillingTier_stddev_pop_fields = {
  __typename?: 'qx_eBillingTier_stddev_pop_fields';
  monthlyPriceCents?: number;
  monthlyTokenQuota?: number;
};

/** aggregate stddev_samp on columns */
export type qx_eBillingTier_stddev_samp_fields = {
  __typename?: 'qx_eBillingTier_stddev_samp_fields';
  monthlyPriceCents?: number;
  monthlyTokenQuota?: number;
};

/** Streaming cursor of the table "qx_eBillingTier" */
export type qx_eBillingTier_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eBillingTier_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eBillingTier_stream_cursor_value_input = {
  comment?: string;
  monthlyPriceCents?: number;
  monthlyTokenQuota?: number;
  value?: string;
};

/** aggregate sum on columns */
export type qx_eBillingTier_sum_fields = {
  __typename?: 'qx_eBillingTier_sum_fields';
  monthlyPriceCents?: number;
  monthlyTokenQuota?: number;
};

/** update columns of table "qx.eBillingTier" */
export enum qx_eBillingTier_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  monthlyPriceCents = 'monthlyPriceCents',
  /** column name */
  monthlyTokenQuota = 'monthlyTokenQuota',
  /** column name */
  value = 'value'
}

export type qx_eBillingTier_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_eBillingTier_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eBillingTier_set_input;
  /** filter the rows which have to be updated */
  where: qx_eBillingTier_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_eBillingTier_var_pop_fields = {
  __typename?: 'qx_eBillingTier_var_pop_fields';
  monthlyPriceCents?: number;
  monthlyTokenQuota?: number;
};

/** aggregate var_samp on columns */
export type qx_eBillingTier_var_samp_fields = {
  __typename?: 'qx_eBillingTier_var_samp_fields';
  monthlyPriceCents?: number;
  monthlyTokenQuota?: number;
};

/** aggregate variance on columns */
export type qx_eBillingTier_variance_fields = {
  __typename?: 'qx_eBillingTier_variance_fields';
  monthlyPriceCents?: number;
  monthlyTokenQuota?: number;
};

/** enum: processing and availability states of a recorded video clip (processing, available, failed, etc.) */
export type qx_eClipStatus = {
  __typename?: 'qx_eClipStatus';
  /** An array relationship */
  clips: Array<qx_Clip>;
  /** An aggregate relationship */
  clips_aggregate: qx_Clip_aggregate;
  comment?: string;
  value: string;
};


/** enum: processing and availability states of a recorded video clip (processing, available, failed, etc.) */
export type qx_eClipStatusclipsArgs = {
  distinct_on?: Array<qx_Clip_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Clip_order_by>;
  where?: qx_Clip_bool_exp;
};


/** enum: processing and availability states of a recorded video clip (processing, available, failed, etc.) */
export type qx_eClipStatusclips_aggregateArgs = {
  distinct_on?: Array<qx_Clip_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Clip_order_by>;
  where?: qx_Clip_bool_exp;
};

/** aggregated selection of "qx.eClipStatus" */
export type qx_eClipStatus_aggregate = {
  __typename?: 'qx_eClipStatus_aggregate';
  aggregate?: qx_eClipStatus_aggregate_fields;
  nodes: Array<qx_eClipStatus>;
};

/** aggregate fields of "qx.eClipStatus" */
export type qx_eClipStatus_aggregate_fields = {
  __typename?: 'qx_eClipStatus_aggregate_fields';
  count: number;
  max?: qx_eClipStatus_max_fields;
  min?: qx_eClipStatus_min_fields;
};


/** aggregate fields of "qx.eClipStatus" */
export type qx_eClipStatus_aggregate_fieldscountArgs = {
  columns?: Array<qx_eClipStatus_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eClipStatus". All fields are combined with a logical 'AND'. */
export type qx_eClipStatus_bool_exp = {
  _and?: Array<qx_eClipStatus_bool_exp>;
  _not?: qx_eClipStatus_bool_exp;
  _or?: Array<qx_eClipStatus_bool_exp>;
  clips?: qx_Clip_bool_exp;
  clips_aggregate?: qx_Clip_aggregate_bool_exp;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eClipStatus" */
export enum qx_eClipStatus_constraint {
  /** unique or primary key constraint on columns "value" */
  eClipStatus_pkey = 'eClipStatus_pkey'
}

export enum qx_eClipStatus_enum {
  /** Error */
  Error = 'Error',
  /** Finished */
  Finished = 'Finished',
  /** Finished with errors */
  FinishedWithErrors = 'FinishedWithErrors',
  /** Initialized */
  Initialized = 'Initialized',
  /** Processing */
  Processing = 'Processing'
}

/** Boolean expression to compare columns of type "qx_eClipStatus_enum". All fields are combined with logical 'AND'. */
export type qx_eClipStatus_enum_comparison_exp = {
  _eq?: qx_eClipStatus_enum;
  _in?: Array<qx_eClipStatus_enum>;
  _is_null?: boolean;
  _neq?: qx_eClipStatus_enum;
  _nin?: Array<qx_eClipStatus_enum>;
};

/** input type for inserting data into table "qx.eClipStatus" */
export type qx_eClipStatus_insert_input = {
  clips?: qx_Clip_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eClipStatus_max_fields = {
  __typename?: 'qx_eClipStatus_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eClipStatus_min_fields = {
  __typename?: 'qx_eClipStatus_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eClipStatus" */
export type qx_eClipStatus_mutation_response = {
  __typename?: 'qx_eClipStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eClipStatus>;
};

/** input type for inserting object relation for remote table "qx.eClipStatus" */
export type qx_eClipStatus_obj_rel_insert_input = {
  data: qx_eClipStatus_insert_input;
  /** upsert condition */
  on_conflict?: qx_eClipStatus_on_conflict;
};

/** on_conflict condition type for table "qx.eClipStatus" */
export type qx_eClipStatus_on_conflict = {
  constraint: qx_eClipStatus_constraint;
  update_columns?: Array<qx_eClipStatus_update_column>;
  where?: qx_eClipStatus_bool_exp;
};

/** Ordering options when selecting data from "qx.eClipStatus". */
export type qx_eClipStatus_order_by = {
  clips_aggregate?: qx_Clip_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eClipStatus */
export type qx_eClipStatus_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eClipStatus" */
export enum qx_eClipStatus_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eClipStatus" */
export type qx_eClipStatus_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eClipStatus" */
export type qx_eClipStatus_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eClipStatus_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eClipStatus_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eClipStatus" */
export enum qx_eClipStatus_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eClipStatus_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eClipStatus_set_input;
  /** filter the rows which have to be updated */
  where: qx_eClipStatus_bool_exp;
};

/** enum: types of video clips (on-demand, event-triggered, scheduled recording) */
export type qx_eClipType = {
  __typename?: 'qx_eClipType';
  /** An array relationship */
  clips: Array<qx_Clip>;
  /** An aggregate relationship */
  clips_aggregate: qx_Clip_aggregate;
  comment?: string;
  value: string;
};


/** enum: types of video clips (on-demand, event-triggered, scheduled recording) */
export type qx_eClipTypeclipsArgs = {
  distinct_on?: Array<qx_Clip_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Clip_order_by>;
  where?: qx_Clip_bool_exp;
};


/** enum: types of video clips (on-demand, event-triggered, scheduled recording) */
export type qx_eClipTypeclips_aggregateArgs = {
  distinct_on?: Array<qx_Clip_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Clip_order_by>;
  where?: qx_Clip_bool_exp;
};

/** aggregated selection of "qx.eClipType" */
export type qx_eClipType_aggregate = {
  __typename?: 'qx_eClipType_aggregate';
  aggregate?: qx_eClipType_aggregate_fields;
  nodes: Array<qx_eClipType>;
};

/** aggregate fields of "qx.eClipType" */
export type qx_eClipType_aggregate_fields = {
  __typename?: 'qx_eClipType_aggregate_fields';
  count: number;
  max?: qx_eClipType_max_fields;
  min?: qx_eClipType_min_fields;
};


/** aggregate fields of "qx.eClipType" */
export type qx_eClipType_aggregate_fieldscountArgs = {
  columns?: Array<qx_eClipType_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eClipType". All fields are combined with a logical 'AND'. */
export type qx_eClipType_bool_exp = {
  _and?: Array<qx_eClipType_bool_exp>;
  _not?: qx_eClipType_bool_exp;
  _or?: Array<qx_eClipType_bool_exp>;
  clips?: qx_Clip_bool_exp;
  clips_aggregate?: qx_Clip_aggregate_bool_exp;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eClipType" */
export enum qx_eClipType_constraint {
  /** unique or primary key constraint on columns "value" */
  eClipType_pkey = 'eClipType_pkey'
}

export enum qx_eClipType_enum {
  /** Event */
  Event = 'Event'
}

/** Boolean expression to compare columns of type "qx_eClipType_enum". All fields are combined with logical 'AND'. */
export type qx_eClipType_enum_comparison_exp = {
  _eq?: qx_eClipType_enum;
  _in?: Array<qx_eClipType_enum>;
  _is_null?: boolean;
  _neq?: qx_eClipType_enum;
  _nin?: Array<qx_eClipType_enum>;
};

/** input type for inserting data into table "qx.eClipType" */
export type qx_eClipType_insert_input = {
  clips?: qx_Clip_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eClipType_max_fields = {
  __typename?: 'qx_eClipType_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eClipType_min_fields = {
  __typename?: 'qx_eClipType_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eClipType" */
export type qx_eClipType_mutation_response = {
  __typename?: 'qx_eClipType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eClipType>;
};

/** input type for inserting object relation for remote table "qx.eClipType" */
export type qx_eClipType_obj_rel_insert_input = {
  data: qx_eClipType_insert_input;
  /** upsert condition */
  on_conflict?: qx_eClipType_on_conflict;
};

/** on_conflict condition type for table "qx.eClipType" */
export type qx_eClipType_on_conflict = {
  constraint: qx_eClipType_constraint;
  update_columns?: Array<qx_eClipType_update_column>;
  where?: qx_eClipType_bool_exp;
};

/** Ordering options when selecting data from "qx.eClipType". */
export type qx_eClipType_order_by = {
  clips_aggregate?: qx_Clip_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eClipType */
export type qx_eClipType_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eClipType" */
export enum qx_eClipType_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eClipType" */
export type qx_eClipType_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eClipType" */
export type qx_eClipType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eClipType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eClipType_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eClipType" */
export enum qx_eClipType_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eClipType_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eClipType_set_input;
  /** filter the rows which have to be updated */
  where: qx_eClipType_bool_exp;
};

/** enum: what a credential is - managed here, synced from an identity provider, or an OSS card */
export type qx_eCredentialType = {
  __typename?: 'qx_eCredentialType';
  comment?: string;
  /** An array relationship */
  credentials: Array<qx_Credential>;
  /** An aggregate relationship */
  credentials_aggregate: qx_Credential_aggregate;
  value: string;
};


/** enum: what a credential is - managed here, synced from an identity provider, or an OSS card */
export type qx_eCredentialTypecredentialsArgs = {
  distinct_on?: Array<qx_Credential_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Credential_order_by>;
  where?: qx_Credential_bool_exp;
};


/** enum: what a credential is - managed here, synced from an identity provider, or an OSS card */
export type qx_eCredentialTypecredentials_aggregateArgs = {
  distinct_on?: Array<qx_Credential_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Credential_order_by>;
  where?: qx_Credential_bool_exp;
};

/** aggregated selection of "qx.eCredentialType" */
export type qx_eCredentialType_aggregate = {
  __typename?: 'qx_eCredentialType_aggregate';
  aggregate?: qx_eCredentialType_aggregate_fields;
  nodes: Array<qx_eCredentialType>;
};

/** aggregate fields of "qx.eCredentialType" */
export type qx_eCredentialType_aggregate_fields = {
  __typename?: 'qx_eCredentialType_aggregate_fields';
  count: number;
  max?: qx_eCredentialType_max_fields;
  min?: qx_eCredentialType_min_fields;
};


/** aggregate fields of "qx.eCredentialType" */
export type qx_eCredentialType_aggregate_fieldscountArgs = {
  columns?: Array<qx_eCredentialType_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eCredentialType". All fields are combined with a logical 'AND'. */
export type qx_eCredentialType_bool_exp = {
  _and?: Array<qx_eCredentialType_bool_exp>;
  _not?: qx_eCredentialType_bool_exp;
  _or?: Array<qx_eCredentialType_bool_exp>;
  comment?: String_comparison_exp;
  credentials?: qx_Credential_bool_exp;
  credentials_aggregate?: qx_Credential_aggregate_bool_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eCredentialType" */
export enum qx_eCredentialType_constraint {
  /** unique or primary key constraint on columns "value" */
  eCredentialType_pkey = 'eCredentialType_pkey'
}

export enum qx_eCredentialType_enum {
  /** Body-Worn Camera (BWC) */
  BWC = 'BWC',
  /** Default */
  Default = 'Default',
  /** Open Security Standard (OSS) */
  OSS = 'OSS',
  /** Single Sign-On (SSO) */
  SSO = 'SSO'
}

/** Boolean expression to compare columns of type "qx_eCredentialType_enum". All fields are combined with logical 'AND'. */
export type qx_eCredentialType_enum_comparison_exp = {
  _eq?: qx_eCredentialType_enum;
  _in?: Array<qx_eCredentialType_enum>;
  _is_null?: boolean;
  _neq?: qx_eCredentialType_enum;
  _nin?: Array<qx_eCredentialType_enum>;
};

/** input type for inserting data into table "qx.eCredentialType" */
export type qx_eCredentialType_insert_input = {
  comment?: string;
  credentials?: qx_Credential_arr_rel_insert_input;
  value?: string;
};

/** aggregate max on columns */
export type qx_eCredentialType_max_fields = {
  __typename?: 'qx_eCredentialType_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eCredentialType_min_fields = {
  __typename?: 'qx_eCredentialType_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eCredentialType" */
export type qx_eCredentialType_mutation_response = {
  __typename?: 'qx_eCredentialType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eCredentialType>;
};

/** input type for inserting object relation for remote table "qx.eCredentialType" */
export type qx_eCredentialType_obj_rel_insert_input = {
  data: qx_eCredentialType_insert_input;
  /** upsert condition */
  on_conflict?: qx_eCredentialType_on_conflict;
};

/** on_conflict condition type for table "qx.eCredentialType" */
export type qx_eCredentialType_on_conflict = {
  constraint: qx_eCredentialType_constraint;
  update_columns?: Array<qx_eCredentialType_update_column>;
  where?: qx_eCredentialType_bool_exp;
};

/** Ordering options when selecting data from "qx.eCredentialType". */
export type qx_eCredentialType_order_by = {
  comment?: order_by;
  credentials_aggregate?: qx_Credential_aggregate_order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eCredentialType */
export type qx_eCredentialType_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eCredentialType" */
export enum qx_eCredentialType_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eCredentialType" */
export type qx_eCredentialType_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eCredentialType" */
export type qx_eCredentialType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eCredentialType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eCredentialType_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eCredentialType" */
export enum qx_eCredentialType_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eCredentialType_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eCredentialType_set_input;
  /** filter the rows which have to be updated */
  where: qx_eCredentialType_bool_exp;
};

/** enum: normal (resting) state of a digital I/O point when no event is active (normally open or normally closed) */
export type qx_eDIONormalState = {
  __typename?: 'qx_eDIONormalState';
  /** An array relationship */
  DeviceDIOs: Array<qx_DeviceDIO>;
  /** An aggregate relationship */
  DeviceDIOs_aggregate: qx_DeviceDIO_aggregate;
  comment?: string;
  value: string;
};


/** enum: normal (resting) state of a digital I/O point when no event is active (normally open or normally closed) */
export type qx_eDIONormalStateDeviceDIOsArgs = {
  distinct_on?: Array<qx_DeviceDIO_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DeviceDIO_order_by>;
  where?: qx_DeviceDIO_bool_exp;
};


/** enum: normal (resting) state of a digital I/O point when no event is active (normally open or normally closed) */
export type qx_eDIONormalStateDeviceDIOs_aggregateArgs = {
  distinct_on?: Array<qx_DeviceDIO_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DeviceDIO_order_by>;
  where?: qx_DeviceDIO_bool_exp;
};

/** aggregated selection of "qx.eDIONormalState" */
export type qx_eDIONormalState_aggregate = {
  __typename?: 'qx_eDIONormalState_aggregate';
  aggregate?: qx_eDIONormalState_aggregate_fields;
  nodes: Array<qx_eDIONormalState>;
};

/** aggregate fields of "qx.eDIONormalState" */
export type qx_eDIONormalState_aggregate_fields = {
  __typename?: 'qx_eDIONormalState_aggregate_fields';
  count: number;
  max?: qx_eDIONormalState_max_fields;
  min?: qx_eDIONormalState_min_fields;
};


/** aggregate fields of "qx.eDIONormalState" */
export type qx_eDIONormalState_aggregate_fieldscountArgs = {
  columns?: Array<qx_eDIONormalState_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eDIONormalState". All fields are combined with a logical 'AND'. */
export type qx_eDIONormalState_bool_exp = {
  DeviceDIOs?: qx_DeviceDIO_bool_exp;
  DeviceDIOs_aggregate?: qx_DeviceDIO_aggregate_bool_exp;
  _and?: Array<qx_eDIONormalState_bool_exp>;
  _not?: qx_eDIONormalState_bool_exp;
  _or?: Array<qx_eDIONormalState_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eDIONormalState" */
export enum qx_eDIONormalState_constraint {
  /** unique or primary key constraint on columns "value" */
  eDIONormalState_pkey = 'eDIONormalState_pkey'
}

export enum qx_eDIONormalState_enum {
  /** Close */
  Close = 'Close',
  /** Open */
  Open = 'Open',
  /** Unknown */
  Unknown = 'Unknown'
}

/** Boolean expression to compare columns of type "qx_eDIONormalState_enum". All fields are combined with logical 'AND'. */
export type qx_eDIONormalState_enum_comparison_exp = {
  _eq?: qx_eDIONormalState_enum;
  _in?: Array<qx_eDIONormalState_enum>;
  _is_null?: boolean;
  _neq?: qx_eDIONormalState_enum;
  _nin?: Array<qx_eDIONormalState_enum>;
};

/** input type for inserting data into table "qx.eDIONormalState" */
export type qx_eDIONormalState_insert_input = {
  DeviceDIOs?: qx_DeviceDIO_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eDIONormalState_max_fields = {
  __typename?: 'qx_eDIONormalState_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eDIONormalState_min_fields = {
  __typename?: 'qx_eDIONormalState_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eDIONormalState" */
export type qx_eDIONormalState_mutation_response = {
  __typename?: 'qx_eDIONormalState_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eDIONormalState>;
};

/** input type for inserting object relation for remote table "qx.eDIONormalState" */
export type qx_eDIONormalState_obj_rel_insert_input = {
  data: qx_eDIONormalState_insert_input;
  /** upsert condition */
  on_conflict?: qx_eDIONormalState_on_conflict;
};

/** on_conflict condition type for table "qx.eDIONormalState" */
export type qx_eDIONormalState_on_conflict = {
  constraint: qx_eDIONormalState_constraint;
  update_columns?: Array<qx_eDIONormalState_update_column>;
  where?: qx_eDIONormalState_bool_exp;
};

/** Ordering options when selecting data from "qx.eDIONormalState". */
export type qx_eDIONormalState_order_by = {
  DeviceDIOs_aggregate?: qx_DeviceDIO_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eDIONormalState */
export type qx_eDIONormalState_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eDIONormalState" */
export enum qx_eDIONormalState_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eDIONormalState" */
export type qx_eDIONormalState_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eDIONormalState" */
export type qx_eDIONormalState_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eDIONormalState_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eDIONormalState_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eDIONormalState" */
export enum qx_eDIONormalState_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eDIONormalState_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eDIONormalState_set_input;
  /** filter the rows which have to be updated */
  where: qx_eDIONormalState_bool_exp;
};

/** enum: current active/inactive state of a digital I/O point */
export type qx_eDIOState = {
  __typename?: 'qx_eDIOState';
  /** An array relationship */
  DeviceDIOs: Array<qx_DeviceDIO>;
  /** An aggregate relationship */
  DeviceDIOs_aggregate: qx_DeviceDIO_aggregate;
  comment?: string;
  value: string;
};


/** enum: current active/inactive state of a digital I/O point */
export type qx_eDIOStateDeviceDIOsArgs = {
  distinct_on?: Array<qx_DeviceDIO_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DeviceDIO_order_by>;
  where?: qx_DeviceDIO_bool_exp;
};


/** enum: current active/inactive state of a digital I/O point */
export type qx_eDIOStateDeviceDIOs_aggregateArgs = {
  distinct_on?: Array<qx_DeviceDIO_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DeviceDIO_order_by>;
  where?: qx_DeviceDIO_bool_exp;
};

/** aggregated selection of "qx.eDIOState" */
export type qx_eDIOState_aggregate = {
  __typename?: 'qx_eDIOState_aggregate';
  aggregate?: qx_eDIOState_aggregate_fields;
  nodes: Array<qx_eDIOState>;
};

/** aggregate fields of "qx.eDIOState" */
export type qx_eDIOState_aggregate_fields = {
  __typename?: 'qx_eDIOState_aggregate_fields';
  count: number;
  max?: qx_eDIOState_max_fields;
  min?: qx_eDIOState_min_fields;
};


/** aggregate fields of "qx.eDIOState" */
export type qx_eDIOState_aggregate_fieldscountArgs = {
  columns?: Array<qx_eDIOState_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eDIOState". All fields are combined with a logical 'AND'. */
export type qx_eDIOState_bool_exp = {
  DeviceDIOs?: qx_DeviceDIO_bool_exp;
  DeviceDIOs_aggregate?: qx_DeviceDIO_aggregate_bool_exp;
  _and?: Array<qx_eDIOState_bool_exp>;
  _not?: qx_eDIOState_bool_exp;
  _or?: Array<qx_eDIOState_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eDIOState" */
export enum qx_eDIOState_constraint {
  /** unique or primary key constraint on columns "value" */
  eDIOState_pkey = 'eDIOState_pkey'
}

export enum qx_eDIOState_enum {
  /** Alarm */
  Alarm = 'Alarm',
  /** Fault */
  Fault = 'Fault',
  /** Normal */
  Normal = 'Normal',
  /** Trigger */
  Trigger = 'Trigger',
  /** Unknown */
  Unknown = 'Unknown'
}

/** Boolean expression to compare columns of type "qx_eDIOState_enum". All fields are combined with logical 'AND'. */
export type qx_eDIOState_enum_comparison_exp = {
  _eq?: qx_eDIOState_enum;
  _in?: Array<qx_eDIOState_enum>;
  _is_null?: boolean;
  _neq?: qx_eDIOState_enum;
  _nin?: Array<qx_eDIOState_enum>;
};

/** input type for inserting data into table "qx.eDIOState" */
export type qx_eDIOState_insert_input = {
  DeviceDIOs?: qx_DeviceDIO_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eDIOState_max_fields = {
  __typename?: 'qx_eDIOState_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eDIOState_min_fields = {
  __typename?: 'qx_eDIOState_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eDIOState" */
export type qx_eDIOState_mutation_response = {
  __typename?: 'qx_eDIOState_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eDIOState>;
};

/** input type for inserting object relation for remote table "qx.eDIOState" */
export type qx_eDIOState_obj_rel_insert_input = {
  data: qx_eDIOState_insert_input;
  /** upsert condition */
  on_conflict?: qx_eDIOState_on_conflict;
};

/** on_conflict condition type for table "qx.eDIOState" */
export type qx_eDIOState_on_conflict = {
  constraint: qx_eDIOState_constraint;
  update_columns?: Array<qx_eDIOState_update_column>;
  where?: qx_eDIOState_bool_exp;
};

/** Ordering options when selecting data from "qx.eDIOState". */
export type qx_eDIOState_order_by = {
  DeviceDIOs_aggregate?: qx_DeviceDIO_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eDIOState */
export type qx_eDIOState_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eDIOState" */
export enum qx_eDIOState_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eDIOState" */
export type qx_eDIOState_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eDIOState" */
export type qx_eDIOState_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eDIOState_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eDIOState_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eDIOState" */
export enum qx_eDIOState_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eDIOState_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eDIOState_set_input;
  /** filter the rows which have to be updated */
  where: qx_eDIOState_bool_exp;
};

/** enum: whether a DIO channel is a digital input or a digital output */
export type qx_eDIOType = {
  __typename?: 'qx_eDIOType';
  /** An array relationship */
  DeviceDIOs: Array<qx_DeviceDIO>;
  /** An aggregate relationship */
  DeviceDIOs_aggregate: qx_DeviceDIO_aggregate;
  comment?: string;
  value: string;
};


/** enum: whether a DIO channel is a digital input or a digital output */
export type qx_eDIOTypeDeviceDIOsArgs = {
  distinct_on?: Array<qx_DeviceDIO_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DeviceDIO_order_by>;
  where?: qx_DeviceDIO_bool_exp;
};


/** enum: whether a DIO channel is a digital input or a digital output */
export type qx_eDIOTypeDeviceDIOs_aggregateArgs = {
  distinct_on?: Array<qx_DeviceDIO_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DeviceDIO_order_by>;
  where?: qx_DeviceDIO_bool_exp;
};

/** aggregated selection of "qx.eDIOType" */
export type qx_eDIOType_aggregate = {
  __typename?: 'qx_eDIOType_aggregate';
  aggregate?: qx_eDIOType_aggregate_fields;
  nodes: Array<qx_eDIOType>;
};

/** aggregate fields of "qx.eDIOType" */
export type qx_eDIOType_aggregate_fields = {
  __typename?: 'qx_eDIOType_aggregate_fields';
  count: number;
  max?: qx_eDIOType_max_fields;
  min?: qx_eDIOType_min_fields;
};


/** aggregate fields of "qx.eDIOType" */
export type qx_eDIOType_aggregate_fieldscountArgs = {
  columns?: Array<qx_eDIOType_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eDIOType". All fields are combined with a logical 'AND'. */
export type qx_eDIOType_bool_exp = {
  DeviceDIOs?: qx_DeviceDIO_bool_exp;
  DeviceDIOs_aggregate?: qx_DeviceDIO_aggregate_bool_exp;
  _and?: Array<qx_eDIOType_bool_exp>;
  _not?: qx_eDIOType_bool_exp;
  _or?: Array<qx_eDIOType_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eDIOType" */
export enum qx_eDIOType_constraint {
  /** unique or primary key constraint on columns "value" */
  eDIOType_pkey = 'eDIOType_pkey'
}

export enum qx_eDIOType_enum {
  /** Beeper */
  Beeper = 'Beeper',
  /** Door Contact */
  DoorContact = 'DoorContact',
  /** Input */
  Input = 'Input',
  /** LED */
  LED = 'LED',
  /** Lock */
  Lock = 'Lock',
  /** Output */
  Output = 'Output',
  /** REX */
  REX = 'REX',
  /** Relay */
  Relay = 'Relay',
  /** Serial */
  Serial = 'Serial',
  /** Tamper */
  Tamper = 'Tamper',
  /** Unknown */
  Unknown = 'Unknown',
  /** Wiegand */
  Wiegand = 'Wiegand',
  /** Wireless */
  Wireless = 'Wireless'
}

/** Boolean expression to compare columns of type "qx_eDIOType_enum". All fields are combined with logical 'AND'. */
export type qx_eDIOType_enum_comparison_exp = {
  _eq?: qx_eDIOType_enum;
  _in?: Array<qx_eDIOType_enum>;
  _is_null?: boolean;
  _neq?: qx_eDIOType_enum;
  _nin?: Array<qx_eDIOType_enum>;
};

/** input type for inserting data into table "qx.eDIOType" */
export type qx_eDIOType_insert_input = {
  DeviceDIOs?: qx_DeviceDIO_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eDIOType_max_fields = {
  __typename?: 'qx_eDIOType_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eDIOType_min_fields = {
  __typename?: 'qx_eDIOType_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eDIOType" */
export type qx_eDIOType_mutation_response = {
  __typename?: 'qx_eDIOType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eDIOType>;
};

/** input type for inserting object relation for remote table "qx.eDIOType" */
export type qx_eDIOType_obj_rel_insert_input = {
  data: qx_eDIOType_insert_input;
  /** upsert condition */
  on_conflict?: qx_eDIOType_on_conflict;
};

/** on_conflict condition type for table "qx.eDIOType" */
export type qx_eDIOType_on_conflict = {
  constraint: qx_eDIOType_constraint;
  update_columns?: Array<qx_eDIOType_update_column>;
  where?: qx_eDIOType_bool_exp;
};

/** Ordering options when selecting data from "qx.eDIOType". */
export type qx_eDIOType_order_by = {
  DeviceDIOs_aggregate?: qx_DeviceDIO_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eDIOType */
export type qx_eDIOType_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eDIOType" */
export enum qx_eDIOType_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eDIOType" */
export type qx_eDIOType_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eDIOType" */
export type qx_eDIOType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eDIOType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eDIOType_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eDIOType" */
export enum qx_eDIOType_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eDIOType_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eDIOType_set_input;
  /** filter the rows which have to be updated */
  where: qx_eDIOType_bool_exp;
};

/** enum: network connectivity states of a device (online, offline, connecting) */
export type qx_eDeviceConnectionStatus = {
  __typename?: 'qx_eDeviceConnectionStatus';
  comment?: string;
  /** An array relationship */
  devices: Array<qx_Device>;
  /** An aggregate relationship */
  devices_aggregate: qx_Device_aggregate;
  /** An array relationship */
  mercuryInventories: Array<qx_AccessInventory>;
  /** An aggregate relationship */
  mercuryInventories_aggregate: qx_AccessInventory_aggregate;
  value: string;
};


/** enum: network connectivity states of a device (online, offline, connecting) */
export type qx_eDeviceConnectionStatusdevicesArgs = {
  distinct_on?: Array<qx_Device_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Device_order_by>;
  where?: qx_Device_bool_exp;
};


/** enum: network connectivity states of a device (online, offline, connecting) */
export type qx_eDeviceConnectionStatusdevices_aggregateArgs = {
  distinct_on?: Array<qx_Device_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Device_order_by>;
  where?: qx_Device_bool_exp;
};


/** enum: network connectivity states of a device (online, offline, connecting) */
export type qx_eDeviceConnectionStatusmercuryInventoriesArgs = {
  distinct_on?: Array<qx_AccessInventory_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessInventory_order_by>;
  where?: qx_AccessInventory_bool_exp;
};


/** enum: network connectivity states of a device (online, offline, connecting) */
export type qx_eDeviceConnectionStatusmercuryInventories_aggregateArgs = {
  distinct_on?: Array<qx_AccessInventory_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessInventory_order_by>;
  where?: qx_AccessInventory_bool_exp;
};

/** aggregated selection of "qx.eDeviceConnectionStatus" */
export type qx_eDeviceConnectionStatus_aggregate = {
  __typename?: 'qx_eDeviceConnectionStatus_aggregate';
  aggregate?: qx_eDeviceConnectionStatus_aggregate_fields;
  nodes: Array<qx_eDeviceConnectionStatus>;
};

/** aggregate fields of "qx.eDeviceConnectionStatus" */
export type qx_eDeviceConnectionStatus_aggregate_fields = {
  __typename?: 'qx_eDeviceConnectionStatus_aggregate_fields';
  count: number;
  max?: qx_eDeviceConnectionStatus_max_fields;
  min?: qx_eDeviceConnectionStatus_min_fields;
};


/** aggregate fields of "qx.eDeviceConnectionStatus" */
export type qx_eDeviceConnectionStatus_aggregate_fieldscountArgs = {
  columns?: Array<qx_eDeviceConnectionStatus_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.eDeviceConnectionStatus" */
export type qx_eDeviceConnectionStatus_aggregate_order_by = {
  count?: order_by;
  max?: qx_eDeviceConnectionStatus_max_order_by;
  min?: qx_eDeviceConnectionStatus_min_order_by;
};

/** Boolean expression to filter rows from the table "qx.eDeviceConnectionStatus". All fields are combined with a logical 'AND'. */
export type qx_eDeviceConnectionStatus_bool_exp = {
  _and?: Array<qx_eDeviceConnectionStatus_bool_exp>;
  _not?: qx_eDeviceConnectionStatus_bool_exp;
  _or?: Array<qx_eDeviceConnectionStatus_bool_exp>;
  comment?: String_comparison_exp;
  devices?: qx_Device_bool_exp;
  devices_aggregate?: qx_Device_aggregate_bool_exp;
  mercuryInventories?: qx_AccessInventory_bool_exp;
  mercuryInventories_aggregate?: qx_AccessInventory_aggregate_bool_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eDeviceConnectionStatus" */
export enum qx_eDeviceConnectionStatus_constraint {
  /** unique or primary key constraint on columns "value" */
  eDeviceConnectionStatus_pkey = 'eDeviceConnectionStatus_pkey'
}

export enum qx_eDeviceConnectionStatus_enum {
  /** Connected But Awaiting Events */
  AwaitingEvents = 'AwaitingEvents',
  /** Connected */
  Connected = 'Connected',
  /** Connecting */
  Connecting = 'Connecting',
  /** Device will be deleted once cloud storage has expired */
  DeleteOnCloudStorageExpire = 'DeleteOnCloudStorageExpire',
  /** Device is marked to be deleted */
  Deleting = 'Deleting',
  /** Mercury Device Detached State */
  Detached = 'Detached',
  /** Disconnected */
  Disconnected = 'Disconnected',
  /** Event Subscription Failed */
  EventSubscriptionFailed = 'EventSubscriptionFailed',
  /** Invalid Credentials */
  InvalidCredentials = 'InvalidCredentials',
  /** Connected Without Events */
  NoEvents = 'NoEvents',
  /** Not Supported */
  NotSupported = 'NotSupported',
  /** Device Offline State */
  Offline = 'Offline',
  /** Device Online State */
  Online = 'Online',
  /** Rebooting */
  Rebooting = 'Rebooting',
  /** Unknown */
  Unknown = 'Unknown',
  /** Devices Need Upgrade */
  UpgradeNeeded = 'UpgradeNeeded',
  /** Upgrading */
  Upgrading = 'Upgrading'
}

/** Boolean expression to compare columns of type "qx_eDeviceConnectionStatus_enum". All fields are combined with logical 'AND'. */
export type qx_eDeviceConnectionStatus_enum_comparison_exp = {
  _eq?: qx_eDeviceConnectionStatus_enum;
  _in?: Array<qx_eDeviceConnectionStatus_enum>;
  _is_null?: boolean;
  _neq?: qx_eDeviceConnectionStatus_enum;
  _nin?: Array<qx_eDeviceConnectionStatus_enum>;
};

/** input type for inserting data into table "qx.eDeviceConnectionStatus" */
export type qx_eDeviceConnectionStatus_insert_input = {
  comment?: string;
  devices?: qx_Device_arr_rel_insert_input;
  mercuryInventories?: qx_AccessInventory_arr_rel_insert_input;
  value?: string;
};

/** aggregate max on columns */
export type qx_eDeviceConnectionStatus_max_fields = {
  __typename?: 'qx_eDeviceConnectionStatus_max_fields';
  comment?: string;
  value?: string;
};

/** order by max() on columns of table "qx.eDeviceConnectionStatus" */
export type qx_eDeviceConnectionStatus_max_order_by = {
  comment?: order_by;
  value?: order_by;
};

/** aggregate min on columns */
export type qx_eDeviceConnectionStatus_min_fields = {
  __typename?: 'qx_eDeviceConnectionStatus_min_fields';
  comment?: string;
  value?: string;
};

/** order by min() on columns of table "qx.eDeviceConnectionStatus" */
export type qx_eDeviceConnectionStatus_min_order_by = {
  comment?: order_by;
  value?: order_by;
};

/** response of any mutation on the table "qx.eDeviceConnectionStatus" */
export type qx_eDeviceConnectionStatus_mutation_response = {
  __typename?: 'qx_eDeviceConnectionStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eDeviceConnectionStatus>;
};

/** input type for inserting object relation for remote table "qx.eDeviceConnectionStatus" */
export type qx_eDeviceConnectionStatus_obj_rel_insert_input = {
  data: qx_eDeviceConnectionStatus_insert_input;
  /** upsert condition */
  on_conflict?: qx_eDeviceConnectionStatus_on_conflict;
};

/** on_conflict condition type for table "qx.eDeviceConnectionStatus" */
export type qx_eDeviceConnectionStatus_on_conflict = {
  constraint: qx_eDeviceConnectionStatus_constraint;
  update_columns?: Array<qx_eDeviceConnectionStatus_update_column>;
  where?: qx_eDeviceConnectionStatus_bool_exp;
};

/** Ordering options when selecting data from "qx.eDeviceConnectionStatus". */
export type qx_eDeviceConnectionStatus_order_by = {
  comment?: order_by;
  devices_aggregate?: qx_Device_aggregate_order_by;
  mercuryInventories_aggregate?: qx_AccessInventory_aggregate_order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eDeviceConnectionStatus */
export type qx_eDeviceConnectionStatus_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eDeviceConnectionStatus" */
export enum qx_eDeviceConnectionStatus_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eDeviceConnectionStatus" */
export type qx_eDeviceConnectionStatus_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eDeviceConnectionStatus" */
export type qx_eDeviceConnectionStatus_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eDeviceConnectionStatus_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eDeviceConnectionStatus_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eDeviceConnectionStatus" */
export enum qx_eDeviceConnectionStatus_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eDeviceConnectionStatus_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eDeviceConnectionStatus_set_input;
  /** filter the rows which have to be updated */
  where: qx_eDeviceConnectionStatus_bool_exp;
};

/** enum: functional categories of hardware devices (camera, access board, sensor unit) */
export type qx_eDeviceKind = {
  __typename?: 'qx_eDeviceKind';
  comment?: string;
  /** An array relationship */
  devices: Array<qx_Device>;
  /** An aggregate relationship */
  devices_aggregate: qx_Device_aggregate;
  value: string;
};


/** enum: functional categories of hardware devices (camera, access board, sensor unit) */
export type qx_eDeviceKinddevicesArgs = {
  distinct_on?: Array<qx_Device_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Device_order_by>;
  where?: qx_Device_bool_exp;
};


/** enum: functional categories of hardware devices (camera, access board, sensor unit) */
export type qx_eDeviceKinddevices_aggregateArgs = {
  distinct_on?: Array<qx_Device_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Device_order_by>;
  where?: qx_Device_bool_exp;
};

/** aggregated selection of "qx.eDeviceKind" */
export type qx_eDeviceKind_aggregate = {
  __typename?: 'qx_eDeviceKind_aggregate';
  aggregate?: qx_eDeviceKind_aggregate_fields;
  nodes: Array<qx_eDeviceKind>;
};

/** aggregate fields of "qx.eDeviceKind" */
export type qx_eDeviceKind_aggregate_fields = {
  __typename?: 'qx_eDeviceKind_aggregate_fields';
  count: number;
  max?: qx_eDeviceKind_max_fields;
  min?: qx_eDeviceKind_min_fields;
};


/** aggregate fields of "qx.eDeviceKind" */
export type qx_eDeviceKind_aggregate_fieldscountArgs = {
  columns?: Array<qx_eDeviceKind_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eDeviceKind". All fields are combined with a logical 'AND'. */
export type qx_eDeviceKind_bool_exp = {
  _and?: Array<qx_eDeviceKind_bool_exp>;
  _not?: qx_eDeviceKind_bool_exp;
  _or?: Array<qx_eDeviceKind_bool_exp>;
  comment?: String_comparison_exp;
  devices?: qx_Device_bool_exp;
  devices_aggregate?: qx_Device_aggregate_bool_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eDeviceKind" */
export enum qx_eDeviceKind_constraint {
  /** unique or primary key constraint on columns "value" */
  eDeviceKind_pkey = 'eDeviceKind_pkey'
}

export enum qx_eDeviceKind_enum {
  /** Access */
  Access = 'Access',
  /** Body-worn camera */
  BodyWorn = 'BodyWorn',
  /** Camera */
  Camera = 'Camera',
  /** Intrusion */
  Intrusion = 'Intrusion',
  /** Offline Lock */
  OfflineLock = 'OfflineLock',
  /** Sensor */
  Sensor = 'Sensor',
  /** Switch */
  Switch = 'Switch',
  /** Unknown */
  Unknown = 'Unknown'
}

/** Boolean expression to compare columns of type "qx_eDeviceKind_enum". All fields are combined with logical 'AND'. */
export type qx_eDeviceKind_enum_comparison_exp = {
  _eq?: qx_eDeviceKind_enum;
  _in?: Array<qx_eDeviceKind_enum>;
  _is_null?: boolean;
  _neq?: qx_eDeviceKind_enum;
  _nin?: Array<qx_eDeviceKind_enum>;
};

/** input type for inserting data into table "qx.eDeviceKind" */
export type qx_eDeviceKind_insert_input = {
  comment?: string;
  devices?: qx_Device_arr_rel_insert_input;
  value?: string;
};

/** aggregate max on columns */
export type qx_eDeviceKind_max_fields = {
  __typename?: 'qx_eDeviceKind_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eDeviceKind_min_fields = {
  __typename?: 'qx_eDeviceKind_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eDeviceKind" */
export type qx_eDeviceKind_mutation_response = {
  __typename?: 'qx_eDeviceKind_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eDeviceKind>;
};

/** input type for inserting object relation for remote table "qx.eDeviceKind" */
export type qx_eDeviceKind_obj_rel_insert_input = {
  data: qx_eDeviceKind_insert_input;
  /** upsert condition */
  on_conflict?: qx_eDeviceKind_on_conflict;
};

/** on_conflict condition type for table "qx.eDeviceKind" */
export type qx_eDeviceKind_on_conflict = {
  constraint: qx_eDeviceKind_constraint;
  update_columns?: Array<qx_eDeviceKind_update_column>;
  where?: qx_eDeviceKind_bool_exp;
};

/** Ordering options when selecting data from "qx.eDeviceKind". */
export type qx_eDeviceKind_order_by = {
  comment?: order_by;
  devices_aggregate?: qx_Device_aggregate_order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eDeviceKind */
export type qx_eDeviceKind_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eDeviceKind" */
export enum qx_eDeviceKind_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eDeviceKind" */
export type qx_eDeviceKind_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eDeviceKind" */
export type qx_eDeviceKind_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eDeviceKind_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eDeviceKind_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eDeviceKind" */
export enum qx_eDeviceKind_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eDeviceKind_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eDeviceKind_set_input;
  /** filter the rows which have to be updated */
  where: qx_eDeviceKind_bool_exp;
};

/** enum: alarm condition states for a door (no alarm, door forced open, door held open, etc.) */
export type qx_eDoorAlarm = {
  __typename?: 'qx_eDoorAlarm';
  /** An array relationship */
  accessInventories: Array<qx_AccessInventory>;
  /** An aggregate relationship */
  accessInventories_aggregate: qx_AccessInventory_aggregate;
  comment?: string;
  /** An array relationship */
  doors: Array<qx_Door>;
  /** An aggregate relationship */
  doors_aggregate: qx_Door_aggregate;
  value: string;
};


/** enum: alarm condition states for a door (no alarm, door forced open, door held open, etc.) */
export type qx_eDoorAlarmaccessInventoriesArgs = {
  distinct_on?: Array<qx_AccessInventory_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessInventory_order_by>;
  where?: qx_AccessInventory_bool_exp;
};


/** enum: alarm condition states for a door (no alarm, door forced open, door held open, etc.) */
export type qx_eDoorAlarmaccessInventories_aggregateArgs = {
  distinct_on?: Array<qx_AccessInventory_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessInventory_order_by>;
  where?: qx_AccessInventory_bool_exp;
};


/** enum: alarm condition states for a door (no alarm, door forced open, door held open, etc.) */
export type qx_eDoorAlarmdoorsArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


/** enum: alarm condition states for a door (no alarm, door forced open, door held open, etc.) */
export type qx_eDoorAlarmdoors_aggregateArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};

/** aggregated selection of "qx.eDoorAlarm" */
export type qx_eDoorAlarm_aggregate = {
  __typename?: 'qx_eDoorAlarm_aggregate';
  aggregate?: qx_eDoorAlarm_aggregate_fields;
  nodes: Array<qx_eDoorAlarm>;
};

/** aggregate fields of "qx.eDoorAlarm" */
export type qx_eDoorAlarm_aggregate_fields = {
  __typename?: 'qx_eDoorAlarm_aggregate_fields';
  count: number;
  max?: qx_eDoorAlarm_max_fields;
  min?: qx_eDoorAlarm_min_fields;
};


/** aggregate fields of "qx.eDoorAlarm" */
export type qx_eDoorAlarm_aggregate_fieldscountArgs = {
  columns?: Array<qx_eDoorAlarm_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eDoorAlarm". All fields are combined with a logical 'AND'. */
export type qx_eDoorAlarm_bool_exp = {
  _and?: Array<qx_eDoorAlarm_bool_exp>;
  _not?: qx_eDoorAlarm_bool_exp;
  _or?: Array<qx_eDoorAlarm_bool_exp>;
  accessInventories?: qx_AccessInventory_bool_exp;
  accessInventories_aggregate?: qx_AccessInventory_aggregate_bool_exp;
  comment?: String_comparison_exp;
  doors?: qx_Door_bool_exp;
  doors_aggregate?: qx_Door_aggregate_bool_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eDoorAlarm" */
export enum qx_eDoorAlarm_constraint {
  /** unique or primary key constraint on columns "value" */
  eDoorAlarm_pkey = 'eDoorAlarm_pkey'
}

export enum qx_eDoorAlarm_enum {
  /** Battery Alarm */
  BatteryAlarm = 'BatteryAlarm',
  /** Forced Open */
  DoorForcedOpen = 'DoorForcedOpen',
  /** Open Too Long */
  DoorOpenTooLong = 'DoorOpenTooLong',
  /** Open Too Long Warning */
  DoorOpenTooLongWarn = 'DoorOpenTooLongWarn',
  /** Lock Jammed */
  LockJammed = 'LockJammed',
  /** Normal */
  Normal = 'Normal',
  /** Power Fault */
  PowerFault = 'PowerFault',
  /** Radio Disturbance */
  RadioDisturbance = 'RadioDisturbance',
  /** Tampering */
  Tampering = 'Tampering',
  /** Unknown */
  Unknown = 'Unknown'
}

/** Boolean expression to compare columns of type "qx_eDoorAlarm_enum". All fields are combined with logical 'AND'. */
export type qx_eDoorAlarm_enum_comparison_exp = {
  _eq?: qx_eDoorAlarm_enum;
  _in?: Array<qx_eDoorAlarm_enum>;
  _is_null?: boolean;
  _neq?: qx_eDoorAlarm_enum;
  _nin?: Array<qx_eDoorAlarm_enum>;
};

/** input type for inserting data into table "qx.eDoorAlarm" */
export type qx_eDoorAlarm_insert_input = {
  accessInventories?: qx_AccessInventory_arr_rel_insert_input;
  comment?: string;
  doors?: qx_Door_arr_rel_insert_input;
  value?: string;
};

/** aggregate max on columns */
export type qx_eDoorAlarm_max_fields = {
  __typename?: 'qx_eDoorAlarm_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eDoorAlarm_min_fields = {
  __typename?: 'qx_eDoorAlarm_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eDoorAlarm" */
export type qx_eDoorAlarm_mutation_response = {
  __typename?: 'qx_eDoorAlarm_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eDoorAlarm>;
};

/** input type for inserting object relation for remote table "qx.eDoorAlarm" */
export type qx_eDoorAlarm_obj_rel_insert_input = {
  data: qx_eDoorAlarm_insert_input;
  /** upsert condition */
  on_conflict?: qx_eDoorAlarm_on_conflict;
};

/** on_conflict condition type for table "qx.eDoorAlarm" */
export type qx_eDoorAlarm_on_conflict = {
  constraint: qx_eDoorAlarm_constraint;
  update_columns?: Array<qx_eDoorAlarm_update_column>;
  where?: qx_eDoorAlarm_bool_exp;
};

/** Ordering options when selecting data from "qx.eDoorAlarm". */
export type qx_eDoorAlarm_order_by = {
  accessInventories_aggregate?: qx_AccessInventory_aggregate_order_by;
  comment?: order_by;
  doors_aggregate?: qx_Door_aggregate_order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eDoorAlarm */
export type qx_eDoorAlarm_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eDoorAlarm" */
export enum qx_eDoorAlarm_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eDoorAlarm" */
export type qx_eDoorAlarm_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eDoorAlarm" */
export type qx_eDoorAlarm_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eDoorAlarm_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eDoorAlarm_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eDoorAlarm" */
export enum qx_eDoorAlarm_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eDoorAlarm_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eDoorAlarm_set_input;
  /** filter the rows which have to be updated */
  where: qx_eDoorAlarm_bool_exp;
};

/** enum: operational modes of a door (normal, locked, unlocked, access-control only, etc.) */
export type qx_eDoorMode = {
  __typename?: 'qx_eDoorMode';
  comment?: string;
  /** An array relationship */
  doors: Array<qx_Door>;
  /** An aggregate relationship */
  doors_aggregate: qx_Door_aggregate;
  value: string;
};


/** enum: operational modes of a door (normal, locked, unlocked, access-control only, etc.) */
export type qx_eDoorModedoorsArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


/** enum: operational modes of a door (normal, locked, unlocked, access-control only, etc.) */
export type qx_eDoorModedoors_aggregateArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};

/** aggregated selection of "qx.eDoorMode" */
export type qx_eDoorMode_aggregate = {
  __typename?: 'qx_eDoorMode_aggregate';
  aggregate?: qx_eDoorMode_aggregate_fields;
  nodes: Array<qx_eDoorMode>;
};

/** aggregate fields of "qx.eDoorMode" */
export type qx_eDoorMode_aggregate_fields = {
  __typename?: 'qx_eDoorMode_aggregate_fields';
  count: number;
  max?: qx_eDoorMode_max_fields;
  min?: qx_eDoorMode_min_fields;
};


/** aggregate fields of "qx.eDoorMode" */
export type qx_eDoorMode_aggregate_fieldscountArgs = {
  columns?: Array<qx_eDoorMode_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eDoorMode". All fields are combined with a logical 'AND'. */
export type qx_eDoorMode_bool_exp = {
  _and?: Array<qx_eDoorMode_bool_exp>;
  _not?: qx_eDoorMode_bool_exp;
  _or?: Array<qx_eDoorMode_bool_exp>;
  comment?: String_comparison_exp;
  doors?: qx_Door_bool_exp;
  doors_aggregate?: qx_Door_aggregate_bool_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eDoorMode" */
export enum qx_eDoorMode_constraint {
  /** unique or primary key constraint on columns "value" */
  eDoorMode_pkey = 'eDoorMode_pkey'
}

export enum qx_eDoorMode_enum {
  /** Accessed */
  Accessed = 'Accessed',
  /** Blocked */
  Blocked = 'Blocked',
  /** Double Locked */
  DoubleLocked = 'DoubleLocked',
  /** Lockdown Held Open */
  LockdownDoorOpen = 'LockdownDoorOpen',
  /** Locked */
  Locked = 'Locked',
  /** Locked Down */
  LockedDown = 'LockedDown',
  /** Locked Open */
  LockedOpen = 'LockedOpen',
  /** Overridden Locked */
  OverriddenLocked = 'OverriddenLocked',
  /** Overridden Unlocked */
  OverriddenUnlocked = 'OverriddenUnlocked',
  /** Virtual Revert Door Command */
  RevertDoor = 'RevertDoor',
  /** Unknown */
  Unknown = 'Unknown',
  /** Unlocked */
  Unlocked = 'Unlocked'
}

/** Boolean expression to compare columns of type "qx_eDoorMode_enum". All fields are combined with logical 'AND'. */
export type qx_eDoorMode_enum_comparison_exp = {
  _eq?: qx_eDoorMode_enum;
  _in?: Array<qx_eDoorMode_enum>;
  _is_null?: boolean;
  _neq?: qx_eDoorMode_enum;
  _nin?: Array<qx_eDoorMode_enum>;
};

/** input type for inserting data into table "qx.eDoorMode" */
export type qx_eDoorMode_insert_input = {
  comment?: string;
  doors?: qx_Door_arr_rel_insert_input;
  value?: string;
};

/** aggregate max on columns */
export type qx_eDoorMode_max_fields = {
  __typename?: 'qx_eDoorMode_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eDoorMode_min_fields = {
  __typename?: 'qx_eDoorMode_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eDoorMode" */
export type qx_eDoorMode_mutation_response = {
  __typename?: 'qx_eDoorMode_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eDoorMode>;
};

/** input type for inserting object relation for remote table "qx.eDoorMode" */
export type qx_eDoorMode_obj_rel_insert_input = {
  data: qx_eDoorMode_insert_input;
  /** upsert condition */
  on_conflict?: qx_eDoorMode_on_conflict;
};

/** on_conflict condition type for table "qx.eDoorMode" */
export type qx_eDoorMode_on_conflict = {
  constraint: qx_eDoorMode_constraint;
  update_columns?: Array<qx_eDoorMode_update_column>;
  where?: qx_eDoorMode_bool_exp;
};

/** Ordering options when selecting data from "qx.eDoorMode". */
export type qx_eDoorMode_order_by = {
  comment?: order_by;
  doors_aggregate?: qx_Door_aggregate_order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eDoorMode */
export type qx_eDoorMode_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eDoorMode" */
export enum qx_eDoorMode_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eDoorMode" */
export type qx_eDoorMode_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eDoorMode" */
export type qx_eDoorMode_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eDoorMode_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eDoorMode_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eDoorMode" */
export enum qx_eDoorMode_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eDoorMode_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eDoorMode_set_input;
  /** filter the rows which have to be updated */
  where: qx_eDoorMode_bool_exp;
};

/** enum: door position monitor sensor configuration types (none, door contact, REX, supervised, etc.) */
export type qx_eDoorMonitor = {
  __typename?: 'qx_eDoorMonitor';
  /** An array relationship */
  Doors: Array<qx_Door>;
  /** An aggregate relationship */
  Doors_aggregate: qx_Door_aggregate;
  comment?: string;
  value: string;
};


/** enum: door position monitor sensor configuration types (none, door contact, REX, supervised, etc.) */
export type qx_eDoorMonitorDoorsArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


/** enum: door position monitor sensor configuration types (none, door contact, REX, supervised, etc.) */
export type qx_eDoorMonitorDoors_aggregateArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};

/** aggregated selection of "qx.eDoorMonitor" */
export type qx_eDoorMonitor_aggregate = {
  __typename?: 'qx_eDoorMonitor_aggregate';
  aggregate?: qx_eDoorMonitor_aggregate_fields;
  nodes: Array<qx_eDoorMonitor>;
};

/** aggregate fields of "qx.eDoorMonitor" */
export type qx_eDoorMonitor_aggregate_fields = {
  __typename?: 'qx_eDoorMonitor_aggregate_fields';
  count: number;
  max?: qx_eDoorMonitor_max_fields;
  min?: qx_eDoorMonitor_min_fields;
};


/** aggregate fields of "qx.eDoorMonitor" */
export type qx_eDoorMonitor_aggregate_fieldscountArgs = {
  columns?: Array<qx_eDoorMonitor_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eDoorMonitor". All fields are combined with a logical 'AND'. */
export type qx_eDoorMonitor_bool_exp = {
  Doors?: qx_Door_bool_exp;
  Doors_aggregate?: qx_Door_aggregate_bool_exp;
  _and?: Array<qx_eDoorMonitor_bool_exp>;
  _not?: qx_eDoorMonitor_bool_exp;
  _or?: Array<qx_eDoorMonitor_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eDoorMonitor" */
export enum qx_eDoorMonitor_constraint {
  /** unique or primary key constraint on columns "value" */
  eDoorMonitor_pkey = 'eDoorMonitor_pkey'
}

export enum qx_eDoorMonitor_enum {
  /** None */
  None = 'None',
  /** Open Circuit: Closed Door */
  OpenCircuitClosedDoor = 'OpenCircuitClosedDoor',
  /** Open Circuit: Open Door */
  OpenCircuitOpenDoor = 'OpenCircuitOpenDoor'
}

/** Boolean expression to compare columns of type "qx_eDoorMonitor_enum". All fields are combined with logical 'AND'. */
export type qx_eDoorMonitor_enum_comparison_exp = {
  _eq?: qx_eDoorMonitor_enum;
  _in?: Array<qx_eDoorMonitor_enum>;
  _is_null?: boolean;
  _neq?: qx_eDoorMonitor_enum;
  _nin?: Array<qx_eDoorMonitor_enum>;
};

/** input type for inserting data into table "qx.eDoorMonitor" */
export type qx_eDoorMonitor_insert_input = {
  Doors?: qx_Door_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eDoorMonitor_max_fields = {
  __typename?: 'qx_eDoorMonitor_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eDoorMonitor_min_fields = {
  __typename?: 'qx_eDoorMonitor_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eDoorMonitor" */
export type qx_eDoorMonitor_mutation_response = {
  __typename?: 'qx_eDoorMonitor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eDoorMonitor>;
};

/** input type for inserting object relation for remote table "qx.eDoorMonitor" */
export type qx_eDoorMonitor_obj_rel_insert_input = {
  data: qx_eDoorMonitor_insert_input;
  /** upsert condition */
  on_conflict?: qx_eDoorMonitor_on_conflict;
};

/** on_conflict condition type for table "qx.eDoorMonitor" */
export type qx_eDoorMonitor_on_conflict = {
  constraint: qx_eDoorMonitor_constraint;
  update_columns?: Array<qx_eDoorMonitor_update_column>;
  where?: qx_eDoorMonitor_bool_exp;
};

/** Ordering options when selecting data from "qx.eDoorMonitor". */
export type qx_eDoorMonitor_order_by = {
  Doors_aggregate?: qx_Door_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eDoorMonitor */
export type qx_eDoorMonitor_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eDoorMonitor" */
export enum qx_eDoorMonitor_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eDoorMonitor" */
export type qx_eDoorMonitor_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eDoorMonitor" */
export type qx_eDoorMonitor_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eDoorMonitor_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eDoorMonitor_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eDoorMonitor" */
export enum qx_eDoorMonitor_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eDoorMonitor_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eDoorMonitor_set_input;
  /** filter the rows which have to be updated */
  where: qx_eDoorMonitor_bool_exp;
};

/** enum: physical position state of a door (open, closed, unknown) */
export type qx_eDoorState = {
  __typename?: 'qx_eDoorState';
  comment?: string;
  /** An array relationship */
  doors: Array<qx_Door>;
  /** An aggregate relationship */
  doors_aggregate: qx_Door_aggregate;
  value: string;
};


/** enum: physical position state of a door (open, closed, unknown) */
export type qx_eDoorStatedoorsArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


/** enum: physical position state of a door (open, closed, unknown) */
export type qx_eDoorStatedoors_aggregateArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};

/** aggregated selection of "qx.eDoorState" */
export type qx_eDoorState_aggregate = {
  __typename?: 'qx_eDoorState_aggregate';
  aggregate?: qx_eDoorState_aggregate_fields;
  nodes: Array<qx_eDoorState>;
};

/** aggregate fields of "qx.eDoorState" */
export type qx_eDoorState_aggregate_fields = {
  __typename?: 'qx_eDoorState_aggregate_fields';
  count: number;
  max?: qx_eDoorState_max_fields;
  min?: qx_eDoorState_min_fields;
};


/** aggregate fields of "qx.eDoorState" */
export type qx_eDoorState_aggregate_fieldscountArgs = {
  columns?: Array<qx_eDoorState_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eDoorState". All fields are combined with a logical 'AND'. */
export type qx_eDoorState_bool_exp = {
  _and?: Array<qx_eDoorState_bool_exp>;
  _not?: qx_eDoorState_bool_exp;
  _or?: Array<qx_eDoorState_bool_exp>;
  comment?: String_comparison_exp;
  doors?: qx_Door_bool_exp;
  doors_aggregate?: qx_Door_aggregate_bool_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eDoorState" */
export enum qx_eDoorState_constraint {
  /** unique or primary key constraint on columns "value" */
  eDoorState_pkey = 'eDoorState_pkey'
}

export enum qx_eDoorState_enum {
  /** Closed */
  Closed = 'Closed',
  /** Fault */
  Fault = 'Fault',
  /** Not Supported */
  NotSupported = 'NotSupported',
  /** Open */
  Open = 'Open',
  /** Unknown */
  Unknown = 'Unknown'
}

/** Boolean expression to compare columns of type "qx_eDoorState_enum". All fields are combined with logical 'AND'. */
export type qx_eDoorState_enum_comparison_exp = {
  _eq?: qx_eDoorState_enum;
  _in?: Array<qx_eDoorState_enum>;
  _is_null?: boolean;
  _neq?: qx_eDoorState_enum;
  _nin?: Array<qx_eDoorState_enum>;
};

/** input type for inserting data into table "qx.eDoorState" */
export type qx_eDoorState_insert_input = {
  comment?: string;
  doors?: qx_Door_arr_rel_insert_input;
  value?: string;
};

/** aggregate max on columns */
export type qx_eDoorState_max_fields = {
  __typename?: 'qx_eDoorState_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eDoorState_min_fields = {
  __typename?: 'qx_eDoorState_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eDoorState" */
export type qx_eDoorState_mutation_response = {
  __typename?: 'qx_eDoorState_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eDoorState>;
};

/** input type for inserting object relation for remote table "qx.eDoorState" */
export type qx_eDoorState_obj_rel_insert_input = {
  data: qx_eDoorState_insert_input;
  /** upsert condition */
  on_conflict?: qx_eDoorState_on_conflict;
};

/** on_conflict condition type for table "qx.eDoorState" */
export type qx_eDoorState_on_conflict = {
  constraint: qx_eDoorState_constraint;
  update_columns?: Array<qx_eDoorState_update_column>;
  where?: qx_eDoorState_bool_exp;
};

/** Ordering options when selecting data from "qx.eDoorState". */
export type qx_eDoorState_order_by = {
  comment?: order_by;
  doors_aggregate?: qx_Door_aggregate_order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eDoorState */
export type qx_eDoorState_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eDoorState" */
export enum qx_eDoorState_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eDoorState" */
export type qx_eDoorState_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eDoorState" */
export type qx_eDoorState_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eDoorState_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eDoorState_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eDoorState" */
export enum qx_eDoorState_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eDoorState_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eDoorState_set_input;
  /** filter the rows which have to be updated */
  where: qx_eDoorState_bool_exp;
};

/** enum: delivery channel types for flow automation notifications (email, push notification, SMS) */
export type qx_eFlowNotificationType = {
  __typename?: 'qx_eFlowNotificationType';
  comment?: string;
  value: string;
};

/** aggregated selection of "qx.eFlowNotificationType" */
export type qx_eFlowNotificationType_aggregate = {
  __typename?: 'qx_eFlowNotificationType_aggregate';
  aggregate?: qx_eFlowNotificationType_aggregate_fields;
  nodes: Array<qx_eFlowNotificationType>;
};

/** aggregate fields of "qx.eFlowNotificationType" */
export type qx_eFlowNotificationType_aggregate_fields = {
  __typename?: 'qx_eFlowNotificationType_aggregate_fields';
  count: number;
  max?: qx_eFlowNotificationType_max_fields;
  min?: qx_eFlowNotificationType_min_fields;
};


/** aggregate fields of "qx.eFlowNotificationType" */
export type qx_eFlowNotificationType_aggregate_fieldscountArgs = {
  columns?: Array<qx_eFlowNotificationType_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eFlowNotificationType". All fields are combined with a logical 'AND'. */
export type qx_eFlowNotificationType_bool_exp = {
  _and?: Array<qx_eFlowNotificationType_bool_exp>;
  _not?: qx_eFlowNotificationType_bool_exp;
  _or?: Array<qx_eFlowNotificationType_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eFlowNotificationType" */
export enum qx_eFlowNotificationType_constraint {
  /** unique or primary key constraint on columns "value" */
  eFlowNotificationType_pkey = 'eFlowNotificationType_pkey'
}

/** input type for inserting data into table "qx.eFlowNotificationType" */
export type qx_eFlowNotificationType_insert_input = {
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eFlowNotificationType_max_fields = {
  __typename?: 'qx_eFlowNotificationType_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eFlowNotificationType_min_fields = {
  __typename?: 'qx_eFlowNotificationType_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eFlowNotificationType" */
export type qx_eFlowNotificationType_mutation_response = {
  __typename?: 'qx_eFlowNotificationType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eFlowNotificationType>;
};

/** on_conflict condition type for table "qx.eFlowNotificationType" */
export type qx_eFlowNotificationType_on_conflict = {
  constraint: qx_eFlowNotificationType_constraint;
  update_columns?: Array<qx_eFlowNotificationType_update_column>;
  where?: qx_eFlowNotificationType_bool_exp;
};

/** Ordering options when selecting data from "qx.eFlowNotificationType". */
export type qx_eFlowNotificationType_order_by = {
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eFlowNotificationType */
export type qx_eFlowNotificationType_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eFlowNotificationType" */
export enum qx_eFlowNotificationType_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eFlowNotificationType" */
export type qx_eFlowNotificationType_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eFlowNotificationType" */
export type qx_eFlowNotificationType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eFlowNotificationType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eFlowNotificationType_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eFlowNotificationType" */
export enum qx_eFlowNotificationType_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eFlowNotificationType_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eFlowNotificationType_set_input;
  /** filter the rows which have to be updated */
  where: qx_eFlowNotificationType_bool_exp;
};

/** enum: enabled/disabled and health states of a flow automation rule */
export type qx_eFlowStatus = {
  __typename?: 'qx_eFlowStatus';
  comment?: string;
  /** An array relationship */
  flows: Array<qx_Flow>;
  /** An aggregate relationship */
  flows_aggregate: qx_Flow_aggregate;
  value: string;
};


/** enum: enabled/disabled and health states of a flow automation rule */
export type qx_eFlowStatusflowsArgs = {
  distinct_on?: Array<qx_Flow_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Flow_order_by>;
  where?: qx_Flow_bool_exp;
};


/** enum: enabled/disabled and health states of a flow automation rule */
export type qx_eFlowStatusflows_aggregateArgs = {
  distinct_on?: Array<qx_Flow_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Flow_order_by>;
  where?: qx_Flow_bool_exp;
};

/** aggregated selection of "qx.eFlowStatus" */
export type qx_eFlowStatus_aggregate = {
  __typename?: 'qx_eFlowStatus_aggregate';
  aggregate?: qx_eFlowStatus_aggregate_fields;
  nodes: Array<qx_eFlowStatus>;
};

/** aggregate fields of "qx.eFlowStatus" */
export type qx_eFlowStatus_aggregate_fields = {
  __typename?: 'qx_eFlowStatus_aggregate_fields';
  count: number;
  max?: qx_eFlowStatus_max_fields;
  min?: qx_eFlowStatus_min_fields;
};


/** aggregate fields of "qx.eFlowStatus" */
export type qx_eFlowStatus_aggregate_fieldscountArgs = {
  columns?: Array<qx_eFlowStatus_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eFlowStatus". All fields are combined with a logical 'AND'. */
export type qx_eFlowStatus_bool_exp = {
  _and?: Array<qx_eFlowStatus_bool_exp>;
  _not?: qx_eFlowStatus_bool_exp;
  _or?: Array<qx_eFlowStatus_bool_exp>;
  comment?: String_comparison_exp;
  flows?: qx_Flow_bool_exp;
  flows_aggregate?: qx_Flow_aggregate_bool_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eFlowStatus" */
export enum qx_eFlowStatus_constraint {
  /** unique or primary key constraint on columns "value" */
  eFlowStatus_pkey = 'eFlowStatus_pkey'
}

export enum qx_eFlowStatus_enum {
  /** Error */
  Error = 'Error',
  /** Flow is firing */
  Firing = 'Firing',
  /** Normal */
  Normal = 'Normal'
}

/** Boolean expression to compare columns of type "qx_eFlowStatus_enum". All fields are combined with logical 'AND'. */
export type qx_eFlowStatus_enum_comparison_exp = {
  _eq?: qx_eFlowStatus_enum;
  _in?: Array<qx_eFlowStatus_enum>;
  _is_null?: boolean;
  _neq?: qx_eFlowStatus_enum;
  _nin?: Array<qx_eFlowStatus_enum>;
};

/** input type for inserting data into table "qx.eFlowStatus" */
export type qx_eFlowStatus_insert_input = {
  comment?: string;
  flows?: qx_Flow_arr_rel_insert_input;
  value?: string;
};

/** aggregate max on columns */
export type qx_eFlowStatus_max_fields = {
  __typename?: 'qx_eFlowStatus_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eFlowStatus_min_fields = {
  __typename?: 'qx_eFlowStatus_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eFlowStatus" */
export type qx_eFlowStatus_mutation_response = {
  __typename?: 'qx_eFlowStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eFlowStatus>;
};

/** input type for inserting object relation for remote table "qx.eFlowStatus" */
export type qx_eFlowStatus_obj_rel_insert_input = {
  data: qx_eFlowStatus_insert_input;
  /** upsert condition */
  on_conflict?: qx_eFlowStatus_on_conflict;
};

/** on_conflict condition type for table "qx.eFlowStatus" */
export type qx_eFlowStatus_on_conflict = {
  constraint: qx_eFlowStatus_constraint;
  update_columns?: Array<qx_eFlowStatus_update_column>;
  where?: qx_eFlowStatus_bool_exp;
};

/** Ordering options when selecting data from "qx.eFlowStatus". */
export type qx_eFlowStatus_order_by = {
  comment?: order_by;
  flows_aggregate?: qx_Flow_aggregate_order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eFlowStatus */
export type qx_eFlowStatus_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eFlowStatus" */
export enum qx_eFlowStatus_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eFlowStatus" */
export type qx_eFlowStatus_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eFlowStatus" */
export type qx_eFlowStatus_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eFlowStatus_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eFlowStatus_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eFlowStatus" */
export enum qx_eFlowStatus_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eFlowStatus_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eFlowStatus_set_input;
  /** filter the rows which have to be updated */
  where: qx_eFlowStatus_bool_exp;
};

/** enum: completion status of an individual action step within a flow trace execution (pending, success, failed, skipped) */
export type qx_eFlowTraceActionStatus = {
  __typename?: 'qx_eFlowTraceActionStatus';
  comment?: string;
  value: string;
};

/** aggregated selection of "qx.eFlowTraceActionStatus" */
export type qx_eFlowTraceActionStatus_aggregate = {
  __typename?: 'qx_eFlowTraceActionStatus_aggregate';
  aggregate?: qx_eFlowTraceActionStatus_aggregate_fields;
  nodes: Array<qx_eFlowTraceActionStatus>;
};

/** aggregate fields of "qx.eFlowTraceActionStatus" */
export type qx_eFlowTraceActionStatus_aggregate_fields = {
  __typename?: 'qx_eFlowTraceActionStatus_aggregate_fields';
  count: number;
  max?: qx_eFlowTraceActionStatus_max_fields;
  min?: qx_eFlowTraceActionStatus_min_fields;
};


/** aggregate fields of "qx.eFlowTraceActionStatus" */
export type qx_eFlowTraceActionStatus_aggregate_fieldscountArgs = {
  columns?: Array<qx_eFlowTraceActionStatus_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eFlowTraceActionStatus". All fields are combined with a logical 'AND'. */
export type qx_eFlowTraceActionStatus_bool_exp = {
  _and?: Array<qx_eFlowTraceActionStatus_bool_exp>;
  _not?: qx_eFlowTraceActionStatus_bool_exp;
  _or?: Array<qx_eFlowTraceActionStatus_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eFlowTraceActionStatus" */
export enum qx_eFlowTraceActionStatus_constraint {
  /** unique or primary key constraint on columns "value" */
  eFlowTraceActionStatus_pkey = 'eFlowTraceActionStatus_pkey'
}

/** input type for inserting data into table "qx.eFlowTraceActionStatus" */
export type qx_eFlowTraceActionStatus_insert_input = {
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eFlowTraceActionStatus_max_fields = {
  __typename?: 'qx_eFlowTraceActionStatus_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eFlowTraceActionStatus_min_fields = {
  __typename?: 'qx_eFlowTraceActionStatus_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eFlowTraceActionStatus" */
export type qx_eFlowTraceActionStatus_mutation_response = {
  __typename?: 'qx_eFlowTraceActionStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eFlowTraceActionStatus>;
};

/** on_conflict condition type for table "qx.eFlowTraceActionStatus" */
export type qx_eFlowTraceActionStatus_on_conflict = {
  constraint: qx_eFlowTraceActionStatus_constraint;
  update_columns?: Array<qx_eFlowTraceActionStatus_update_column>;
  where?: qx_eFlowTraceActionStatus_bool_exp;
};

/** Ordering options when selecting data from "qx.eFlowTraceActionStatus". */
export type qx_eFlowTraceActionStatus_order_by = {
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eFlowTraceActionStatus */
export type qx_eFlowTraceActionStatus_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eFlowTraceActionStatus" */
export enum qx_eFlowTraceActionStatus_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eFlowTraceActionStatus" */
export type qx_eFlowTraceActionStatus_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eFlowTraceActionStatus" */
export type qx_eFlowTraceActionStatus_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eFlowTraceActionStatus_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eFlowTraceActionStatus_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eFlowTraceActionStatus" */
export enum qx_eFlowTraceActionStatus_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eFlowTraceActionStatus_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eFlowTraceActionStatus_set_input;
  /** filter the rows which have to be updated */
  where: qx_eFlowTraceActionStatus_bool_exp;
};

/** enum: overall execution state of a flow trace run (running, completed, failed, cancelled) */
export type qx_eFlowTraceState = {
  __typename?: 'qx_eFlowTraceState';
  comment?: string;
  value: string;
};

/** aggregated selection of "qx.eFlowTraceState" */
export type qx_eFlowTraceState_aggregate = {
  __typename?: 'qx_eFlowTraceState_aggregate';
  aggregate?: qx_eFlowTraceState_aggregate_fields;
  nodes: Array<qx_eFlowTraceState>;
};

/** aggregate fields of "qx.eFlowTraceState" */
export type qx_eFlowTraceState_aggregate_fields = {
  __typename?: 'qx_eFlowTraceState_aggregate_fields';
  count: number;
  max?: qx_eFlowTraceState_max_fields;
  min?: qx_eFlowTraceState_min_fields;
};


/** aggregate fields of "qx.eFlowTraceState" */
export type qx_eFlowTraceState_aggregate_fieldscountArgs = {
  columns?: Array<qx_eFlowTraceState_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eFlowTraceState". All fields are combined with a logical 'AND'. */
export type qx_eFlowTraceState_bool_exp = {
  _and?: Array<qx_eFlowTraceState_bool_exp>;
  _not?: qx_eFlowTraceState_bool_exp;
  _or?: Array<qx_eFlowTraceState_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eFlowTraceState" */
export enum qx_eFlowTraceState_constraint {
  /** unique or primary key constraint on columns "value" */
  eFlowTraceStatus_pkey = 'eFlowTraceStatus_pkey'
}

export enum qx_eFlowTraceState_enum {
  /** Conditions were not met */
  ConditionsWereNotMet = 'ConditionsWereNotMet',
  /** Did not trigger */
  DidNotTrigger = 'DidNotTrigger',
  /** Caused rule to fire */
  Fired = 'Fired',
  /** Idle */
  Idle = 'Idle',
  /** Failed to pass post-guard */
  PostGuard = 'PostGuard',
  /** Failed to pass pre-guard */
  PreGuard = 'PreGuard',
  /** Running */
  Running = 'Running'
}

/** Boolean expression to compare columns of type "qx_eFlowTraceState_enum". All fields are combined with logical 'AND'. */
export type qx_eFlowTraceState_enum_comparison_exp = {
  _eq?: qx_eFlowTraceState_enum;
  _in?: Array<qx_eFlowTraceState_enum>;
  _is_null?: boolean;
  _neq?: qx_eFlowTraceState_enum;
  _nin?: Array<qx_eFlowTraceState_enum>;
};

/** input type for inserting data into table "qx.eFlowTraceState" */
export type qx_eFlowTraceState_insert_input = {
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eFlowTraceState_max_fields = {
  __typename?: 'qx_eFlowTraceState_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eFlowTraceState_min_fields = {
  __typename?: 'qx_eFlowTraceState_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eFlowTraceState" */
export type qx_eFlowTraceState_mutation_response = {
  __typename?: 'qx_eFlowTraceState_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eFlowTraceState>;
};

/** on_conflict condition type for table "qx.eFlowTraceState" */
export type qx_eFlowTraceState_on_conflict = {
  constraint: qx_eFlowTraceState_constraint;
  update_columns?: Array<qx_eFlowTraceState_update_column>;
  where?: qx_eFlowTraceState_bool_exp;
};

/** Ordering options when selecting data from "qx.eFlowTraceState". */
export type qx_eFlowTraceState_order_by = {
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eFlowTraceState */
export type qx_eFlowTraceState_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eFlowTraceState" */
export enum qx_eFlowTraceState_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eFlowTraceState" */
export type qx_eFlowTraceState_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eFlowTraceState" */
export type qx_eFlowTraceState_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eFlowTraceState_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eFlowTraceState_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eFlowTraceState" */
export enum qx_eFlowTraceState_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eFlowTraceState_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eFlowTraceState_set_input;
  /** filter the rows which have to be updated */
  where: qx_eFlowTraceState_bool_exp;
};

/** enum: types of services a gateway is configured to provide (access control, video, both) */
export type qx_eGatewayServiceType = {
  __typename?: 'qx_eGatewayServiceType';
  comment?: string;
  value: string;
};

/** aggregated selection of "qx.eGatewayServiceType" */
export type qx_eGatewayServiceType_aggregate = {
  __typename?: 'qx_eGatewayServiceType_aggregate';
  aggregate?: qx_eGatewayServiceType_aggregate_fields;
  nodes: Array<qx_eGatewayServiceType>;
};

/** aggregate fields of "qx.eGatewayServiceType" */
export type qx_eGatewayServiceType_aggregate_fields = {
  __typename?: 'qx_eGatewayServiceType_aggregate_fields';
  count: number;
  max?: qx_eGatewayServiceType_max_fields;
  min?: qx_eGatewayServiceType_min_fields;
};


/** aggregate fields of "qx.eGatewayServiceType" */
export type qx_eGatewayServiceType_aggregate_fieldscountArgs = {
  columns?: Array<qx_eGatewayServiceType_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eGatewayServiceType". All fields are combined with a logical 'AND'. */
export type qx_eGatewayServiceType_bool_exp = {
  _and?: Array<qx_eGatewayServiceType_bool_exp>;
  _not?: qx_eGatewayServiceType_bool_exp;
  _or?: Array<qx_eGatewayServiceType_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eGatewayServiceType" */
export enum qx_eGatewayServiceType_constraint {
  /** unique or primary key constraint on columns "value" */
  eGatewayServiceType_pkey = 'eGatewayServiceType_pkey'
}

/** input type for inserting data into table "qx.eGatewayServiceType" */
export type qx_eGatewayServiceType_insert_input = {
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eGatewayServiceType_max_fields = {
  __typename?: 'qx_eGatewayServiceType_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eGatewayServiceType_min_fields = {
  __typename?: 'qx_eGatewayServiceType_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eGatewayServiceType" */
export type qx_eGatewayServiceType_mutation_response = {
  __typename?: 'qx_eGatewayServiceType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eGatewayServiceType>;
};

/** on_conflict condition type for table "qx.eGatewayServiceType" */
export type qx_eGatewayServiceType_on_conflict = {
  constraint: qx_eGatewayServiceType_constraint;
  update_columns?: Array<qx_eGatewayServiceType_update_column>;
  where?: qx_eGatewayServiceType_bool_exp;
};

/** Ordering options when selecting data from "qx.eGatewayServiceType". */
export type qx_eGatewayServiceType_order_by = {
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eGatewayServiceType */
export type qx_eGatewayServiceType_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eGatewayServiceType" */
export enum qx_eGatewayServiceType_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eGatewayServiceType" */
export type qx_eGatewayServiceType_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eGatewayServiceType" */
export type qx_eGatewayServiceType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eGatewayServiceType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eGatewayServiceType_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eGatewayServiceType" */
export enum qx_eGatewayServiceType_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eGatewayServiceType_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eGatewayServiceType_set_input;
  /** filter the rows which have to be updated */
  where: qx_eGatewayServiceType_bool_exp;
};

/** enum: configuration synchronization states between the cloud and a gateway (synced, pending, error) */
export type qx_eGatewaySyncStatus = {
  __typename?: 'qx_eGatewaySyncStatus';
  /** An array relationship */
  Gateways: Array<qx_Gateway>;
  /** An aggregate relationship */
  Gateways_aggregate: qx_Gateway_aggregate;
  comment?: string;
  value: string;
};


/** enum: configuration synchronization states between the cloud and a gateway (synced, pending, error) */
export type qx_eGatewaySyncStatusGatewaysArgs = {
  distinct_on?: Array<qx_Gateway_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Gateway_order_by>;
  where?: qx_Gateway_bool_exp;
};


/** enum: configuration synchronization states between the cloud and a gateway (synced, pending, error) */
export type qx_eGatewaySyncStatusGateways_aggregateArgs = {
  distinct_on?: Array<qx_Gateway_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Gateway_order_by>;
  where?: qx_Gateway_bool_exp;
};

/** aggregated selection of "qx.eGatewaySyncStatus" */
export type qx_eGatewaySyncStatus_aggregate = {
  __typename?: 'qx_eGatewaySyncStatus_aggregate';
  aggregate?: qx_eGatewaySyncStatus_aggregate_fields;
  nodes: Array<qx_eGatewaySyncStatus>;
};

/** aggregate fields of "qx.eGatewaySyncStatus" */
export type qx_eGatewaySyncStatus_aggregate_fields = {
  __typename?: 'qx_eGatewaySyncStatus_aggregate_fields';
  count: number;
  max?: qx_eGatewaySyncStatus_max_fields;
  min?: qx_eGatewaySyncStatus_min_fields;
};


/** aggregate fields of "qx.eGatewaySyncStatus" */
export type qx_eGatewaySyncStatus_aggregate_fieldscountArgs = {
  columns?: Array<qx_eGatewaySyncStatus_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eGatewaySyncStatus". All fields are combined with a logical 'AND'. */
export type qx_eGatewaySyncStatus_bool_exp = {
  Gateways?: qx_Gateway_bool_exp;
  Gateways_aggregate?: qx_Gateway_aggregate_bool_exp;
  _and?: Array<qx_eGatewaySyncStatus_bool_exp>;
  _not?: qx_eGatewaySyncStatus_bool_exp;
  _or?: Array<qx_eGatewaySyncStatus_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eGatewaySyncStatus" */
export enum qx_eGatewaySyncStatus_constraint {
  /** unique or primary key constraint on columns "value" */
  eGatewaySyncStatus_pkey = 'eGatewaySyncStatus_pkey'
}

export enum qx_eGatewaySyncStatus_enum {
  /** Gateway is Not Compatible with Cloud */
  NotCompatible = 'NotCompatible',
  /** Out of Sync with Cloud */
  OutOfSync = 'OutOfSync',
  /** Partial Sync Update Failed */
  PartialSyncFailed = 'PartialSyncFailed',
  /** Queued For Sync */
  Queued = 'Queued',
  /** Gateway Requires Upgrade to a Gateway */
  RequiresUpgrade = 'RequiresUpgrade',
  /** Sync Failed */
  SyncFailed = 'SyncFailed',
  /** Synced with Cloud */
  Synced = 'Synced',
  /** Syncing with Cloud */
  Syncing = 'Syncing'
}

/** Boolean expression to compare columns of type "qx_eGatewaySyncStatus_enum". All fields are combined with logical 'AND'. */
export type qx_eGatewaySyncStatus_enum_comparison_exp = {
  _eq?: qx_eGatewaySyncStatus_enum;
  _in?: Array<qx_eGatewaySyncStatus_enum>;
  _is_null?: boolean;
  _neq?: qx_eGatewaySyncStatus_enum;
  _nin?: Array<qx_eGatewaySyncStatus_enum>;
};

/** input type for inserting data into table "qx.eGatewaySyncStatus" */
export type qx_eGatewaySyncStatus_insert_input = {
  Gateways?: qx_Gateway_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eGatewaySyncStatus_max_fields = {
  __typename?: 'qx_eGatewaySyncStatus_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eGatewaySyncStatus_min_fields = {
  __typename?: 'qx_eGatewaySyncStatus_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eGatewaySyncStatus" */
export type qx_eGatewaySyncStatus_mutation_response = {
  __typename?: 'qx_eGatewaySyncStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eGatewaySyncStatus>;
};

/** input type for inserting object relation for remote table "qx.eGatewaySyncStatus" */
export type qx_eGatewaySyncStatus_obj_rel_insert_input = {
  data: qx_eGatewaySyncStatus_insert_input;
  /** upsert condition */
  on_conflict?: qx_eGatewaySyncStatus_on_conflict;
};

/** on_conflict condition type for table "qx.eGatewaySyncStatus" */
export type qx_eGatewaySyncStatus_on_conflict = {
  constraint: qx_eGatewaySyncStatus_constraint;
  update_columns?: Array<qx_eGatewaySyncStatus_update_column>;
  where?: qx_eGatewaySyncStatus_bool_exp;
};

/** Ordering options when selecting data from "qx.eGatewaySyncStatus". */
export type qx_eGatewaySyncStatus_order_by = {
  Gateways_aggregate?: qx_Gateway_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eGatewaySyncStatus */
export type qx_eGatewaySyncStatus_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eGatewaySyncStatus" */
export enum qx_eGatewaySyncStatus_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eGatewaySyncStatus" */
export type qx_eGatewaySyncStatus_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eGatewaySyncStatus" */
export type qx_eGatewaySyncStatus_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eGatewaySyncStatus_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eGatewaySyncStatus_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eGatewaySyncStatus" */
export enum qx_eGatewaySyncStatus_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eGatewaySyncStatus_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eGatewaySyncStatus_set_input;
  /** filter the rows which have to be updated */
  where: qx_eGatewaySyncStatus_bool_exp;
};

/** Configured zone type */
export type qx_eIntrusionZoneType = {
  __typename?: 'qx_eIntrusionZoneType';
  /** An array relationship */
  IntrusionZones: Array<IntrusionZone>;
  /** An aggregate relationship */
  IntrusionZones_aggregate: IntrusionZone_aggregate;
  comment: string;
  value: string;
};


/** Configured zone type */
export type qx_eIntrusionZoneTypeIntrusionZonesArgs = {
  distinct_on?: Array<IntrusionZone_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<IntrusionZone_order_by>;
  where?: IntrusionZone_bool_exp;
};


/** Configured zone type */
export type qx_eIntrusionZoneTypeIntrusionZones_aggregateArgs = {
  distinct_on?: Array<IntrusionZone_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<IntrusionZone_order_by>;
  where?: IntrusionZone_bool_exp;
};

/** aggregated selection of "qx.eIntrusionZoneType" */
export type qx_eIntrusionZoneType_aggregate = {
  __typename?: 'qx_eIntrusionZoneType_aggregate';
  aggregate?: qx_eIntrusionZoneType_aggregate_fields;
  nodes: Array<qx_eIntrusionZoneType>;
};

/** aggregate fields of "qx.eIntrusionZoneType" */
export type qx_eIntrusionZoneType_aggregate_fields = {
  __typename?: 'qx_eIntrusionZoneType_aggregate_fields';
  count: number;
  max?: qx_eIntrusionZoneType_max_fields;
  min?: qx_eIntrusionZoneType_min_fields;
};


/** aggregate fields of "qx.eIntrusionZoneType" */
export type qx_eIntrusionZoneType_aggregate_fieldscountArgs = {
  columns?: Array<qx_eIntrusionZoneType_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eIntrusionZoneType". All fields are combined with a logical 'AND'. */
export type qx_eIntrusionZoneType_bool_exp = {
  IntrusionZones?: IntrusionZone_bool_exp;
  IntrusionZones_aggregate?: IntrusionZone_aggregate_bool_exp;
  _and?: Array<qx_eIntrusionZoneType_bool_exp>;
  _not?: qx_eIntrusionZoneType_bool_exp;
  _or?: Array<qx_eIntrusionZoneType_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eIntrusionZoneType" */
export enum qx_eIntrusionZoneType_constraint {
  /** unique or primary key constraint on columns "value" */
  eIntrusionZoneType_pkey = 'eIntrusionZoneType_pkey'
}

export enum qx_eIntrusionZoneType_enum {
  /** Auto Verify Fire */
  Auto_Verify_Fire = 'Auto_Verify_Fire',
  /** Day Zone */
  Day_Zone = 'Day_Zone',
  /** Delay 1 */
  Delay1 = 'Delay1',
  /** Delay 2 */
  Delay2 = 'Delay2',
  /** Delay Stay Away */
  Delay_Stay_Away = 'Delay_Stay_Away',
  /** Delayed Fire */
  Delayed_Fire = 'Delayed_Fire',
  /** Door Bell */
  Door_Bell = 'Door_Bell',
  /** Final Door Set */
  Final_Door_Set = 'Final_Door_Set',
  /** Fire Supervisory */
  Fire_Supervisory = 'Fire_Supervisory',
  /** Instant */
  Instant = 'Instant',
  /** Instant Stay Away */
  Instant_Stay_Away = 'Instant_Stay_Away',
  /** Interior */
  Interior = 'Interior',
  /** Interior Delay */
  Interior_Delay = 'Interior_Delay',
  /** Interior Stay Away */
  Interior_Stay_Away = 'Interior_Stay_Away',
  /** Maintain Arm */
  Maintain_Arm = 'Maintain_Arm',
  /** Maintain Disarm */
  Maintain_Disarm = 'Maintain_Disarm',
  /** Momentary Arm */
  Momentary_Arm = 'Momentary_Arm',
  /** Momentary Disarm */
  Momentary_Disarm = 'Momentary_Disarm',
  /** Night Zone */
  Night_Zone = 'Night_Zone',
  /** Null Zone - disabled */
  Null_Zone = 'Null_Zone',
  /** Push To Set */
  Push_To_Set = 'Push_To_Set',
  /** Standard Fire */
  Standard_Fire = 'Standard_Fire',
  /** 24HR Bell Buzzer */
  TwentyFourHour_Bell_Buzzer = 'TwentyFourHour_Bell_Buzzer',
  /** 24HR Burglary */
  TwentyFourHour_Burglary = 'TwentyFourHour_Burglary',
  /** 24HR CO */
  TwentyFourHour_CO = 'TwentyFourHour_CO',
  /** 24HR Emergency */
  TwentyFourHour_Emergency = 'TwentyFourHour_Emergency',
  /** 24HR Flood */
  TwentyFourHour_Flood = 'TwentyFourHour_Flood',
  /** 24HR Gas */
  TwentyFourHour_Gas = 'TwentyFourHour_Gas',
  /** 24HR Heat */
  TwentyFourHour_Heat = 'TwentyFourHour_Heat',
  /** 24HR High Temperature */
  TwentyFourHour_High_Temperature = 'TwentyFourHour_High_Temperature',
  /** 24HR Holdup */
  TwentyFourHour_Holdup = 'TwentyFourHour_Holdup',
  /** 24HR Latch Tamper */
  TwentyFourHour_Latch_Tamper = 'TwentyFourHour_Latch_Tamper',
  /** 24HR Low Temperature */
  TwentyFourHour_Low_Temperature = 'TwentyFourHour_Low_Temperature',
  /** 24HR Medical */
  TwentyFourHour_Medical = 'TwentyFourHour_Medical',
  /** 24HR Non Alarm */
  TwentyFourHour_Non_Alarm = 'TwentyFourHour_Non_Alarm',
  /** 24HR Non Latch */
  TwentyFourHour_Non_Latch = 'TwentyFourHour_Non_Latch',
  /** 24HR Panic */
  TwentyFourHour_Panic = 'TwentyFourHour_Panic',
  /** 24HR Sprinkler */
  TwentyFourHour_Sprinkler = 'TwentyFourHour_Sprinkler',
  /** 24HR Supervisory */
  TwentyFourHour_Supervisory = 'TwentyFourHour_Supervisory',
  /** 24HR Supervisory Buzzer */
  TwentyFourHour_Supervisory_Buzzer = 'TwentyFourHour_Supervisory_Buzzer'
}

/** Boolean expression to compare columns of type "qx_eIntrusionZoneType_enum". All fields are combined with logical 'AND'. */
export type qx_eIntrusionZoneType_enum_comparison_exp = {
  _eq?: qx_eIntrusionZoneType_enum;
  _in?: Array<qx_eIntrusionZoneType_enum>;
  _is_null?: boolean;
  _neq?: qx_eIntrusionZoneType_enum;
  _nin?: Array<qx_eIntrusionZoneType_enum>;
};

/** input type for inserting data into table "qx.eIntrusionZoneType" */
export type qx_eIntrusionZoneType_insert_input = {
  IntrusionZones?: IntrusionZone_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eIntrusionZoneType_max_fields = {
  __typename?: 'qx_eIntrusionZoneType_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eIntrusionZoneType_min_fields = {
  __typename?: 'qx_eIntrusionZoneType_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eIntrusionZoneType" */
export type qx_eIntrusionZoneType_mutation_response = {
  __typename?: 'qx_eIntrusionZoneType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eIntrusionZoneType>;
};

/** input type for inserting object relation for remote table "qx.eIntrusionZoneType" */
export type qx_eIntrusionZoneType_obj_rel_insert_input = {
  data: qx_eIntrusionZoneType_insert_input;
  /** upsert condition */
  on_conflict?: qx_eIntrusionZoneType_on_conflict;
};

/** on_conflict condition type for table "qx.eIntrusionZoneType" */
export type qx_eIntrusionZoneType_on_conflict = {
  constraint: qx_eIntrusionZoneType_constraint;
  update_columns?: Array<qx_eIntrusionZoneType_update_column>;
  where?: qx_eIntrusionZoneType_bool_exp;
};

/** Ordering options when selecting data from "qx.eIntrusionZoneType". */
export type qx_eIntrusionZoneType_order_by = {
  IntrusionZones_aggregate?: IntrusionZone_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eIntrusionZoneType */
export type qx_eIntrusionZoneType_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eIntrusionZoneType" */
export enum qx_eIntrusionZoneType_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eIntrusionZoneType" */
export type qx_eIntrusionZoneType_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eIntrusionZoneType" */
export type qx_eIntrusionZoneType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eIntrusionZoneType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eIntrusionZoneType_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eIntrusionZoneType" */
export enum qx_eIntrusionZoneType_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eIntrusionZoneType_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eIntrusionZoneType_set_input;
  /** filter the rows which have to be updated */
  where: qx_eIntrusionZoneType_bool_exp;
};

/** enum: operating modes of a keypad credential reader (PIN only, card only, card+PIN, etc.) */
export type qx_eKeypadMode = {
  __typename?: 'qx_eKeypadMode';
  /** An array relationship */
  Readers: Array<qx_Reader>;
  /** An aggregate relationship */
  Readers_aggregate: qx_Reader_aggregate;
  comment?: string;
  value: string;
};


/** enum: operating modes of a keypad credential reader (PIN only, card only, card+PIN, etc.) */
export type qx_eKeypadModeReadersArgs = {
  distinct_on?: Array<qx_Reader_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Reader_order_by>;
  where?: qx_Reader_bool_exp;
};


/** enum: operating modes of a keypad credential reader (PIN only, card only, card+PIN, etc.) */
export type qx_eKeypadModeReaders_aggregateArgs = {
  distinct_on?: Array<qx_Reader_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Reader_order_by>;
  where?: qx_Reader_bool_exp;
};

/** aggregated selection of "qx.eKeypadMode" */
export type qx_eKeypadMode_aggregate = {
  __typename?: 'qx_eKeypadMode_aggregate';
  aggregate?: qx_eKeypadMode_aggregate_fields;
  nodes: Array<qx_eKeypadMode>;
};

/** aggregate fields of "qx.eKeypadMode" */
export type qx_eKeypadMode_aggregate_fields = {
  __typename?: 'qx_eKeypadMode_aggregate_fields';
  count: number;
  max?: qx_eKeypadMode_max_fields;
  min?: qx_eKeypadMode_min_fields;
};


/** aggregate fields of "qx.eKeypadMode" */
export type qx_eKeypadMode_aggregate_fieldscountArgs = {
  columns?: Array<qx_eKeypadMode_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eKeypadMode". All fields are combined with a logical 'AND'. */
export type qx_eKeypadMode_bool_exp = {
  Readers?: qx_Reader_bool_exp;
  Readers_aggregate?: qx_Reader_aggregate_bool_exp;
  _and?: Array<qx_eKeypadMode_bool_exp>;
  _not?: qx_eKeypadMode_bool_exp;
  _or?: Array<qx_eKeypadMode_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eKeypadMode" */
export enum qx_eKeypadMode_constraint {
  /** unique or primary key constraint on columns "value" */
  eKeypadMode_pkey = 'eKeypadMode_pkey'
}

export enum qx_eKeypadMode_enum {
  /** 8 */
  ALIVE10BIT4 = 'ALIVE10BIT4',
  /** 9 */
  ALIVE10BIT8 = 'ALIVE10BIT8',
  /** 6 */
  ALIVE60BIT4 = 'ALIVE60BIT4',
  /** 7 */
  ALIVE60BIT8 = 'ALIVE60BIT8',
  /** 2 */
  HID = 'HID',
  /** 3 */
  INDALA = 'INDALA',
  /** 1 */
  MR20 = 'MR20',
  /** 4 */
  MR20NT = 'MR20NT',
  /** 0 */
  None = 'None',
  /** 5 */
  OEMX1 = 'OEMX1'
}

/** Boolean expression to compare columns of type "qx_eKeypadMode_enum". All fields are combined with logical 'AND'. */
export type qx_eKeypadMode_enum_comparison_exp = {
  _eq?: qx_eKeypadMode_enum;
  _in?: Array<qx_eKeypadMode_enum>;
  _is_null?: boolean;
  _neq?: qx_eKeypadMode_enum;
  _nin?: Array<qx_eKeypadMode_enum>;
};

/** input type for inserting data into table "qx.eKeypadMode" */
export type qx_eKeypadMode_insert_input = {
  Readers?: qx_Reader_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eKeypadMode_max_fields = {
  __typename?: 'qx_eKeypadMode_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eKeypadMode_min_fields = {
  __typename?: 'qx_eKeypadMode_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eKeypadMode" */
export type qx_eKeypadMode_mutation_response = {
  __typename?: 'qx_eKeypadMode_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eKeypadMode>;
};

/** input type for inserting object relation for remote table "qx.eKeypadMode" */
export type qx_eKeypadMode_obj_rel_insert_input = {
  data: qx_eKeypadMode_insert_input;
  /** upsert condition */
  on_conflict?: qx_eKeypadMode_on_conflict;
};

/** on_conflict condition type for table "qx.eKeypadMode" */
export type qx_eKeypadMode_on_conflict = {
  constraint: qx_eKeypadMode_constraint;
  update_columns?: Array<qx_eKeypadMode_update_column>;
  where?: qx_eKeypadMode_bool_exp;
};

/** Ordering options when selecting data from "qx.eKeypadMode". */
export type qx_eKeypadMode_order_by = {
  Readers_aggregate?: qx_Reader_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eKeypadMode */
export type qx_eKeypadMode_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eKeypadMode" */
export enum qx_eKeypadMode_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eKeypadMode" */
export type qx_eKeypadMode_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eKeypadMode" */
export type qx_eKeypadMode_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eKeypadMode_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eKeypadMode_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eKeypadMode" */
export enum qx_eKeypadMode_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eKeypadMode_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eKeypadMode_set_input;
  /** filter the rows which have to be updated */
  where: qx_eKeypadMode_bool_exp;
};

/** columns and relationships of "qx.eLockMode" */
export type qx_eLockMode = {
  __typename?: 'qx_eLockMode';
  comment: string;
  value: string;
};

/** aggregated selection of "qx.eLockMode" */
export type qx_eLockMode_aggregate = {
  __typename?: 'qx_eLockMode_aggregate';
  aggregate?: qx_eLockMode_aggregate_fields;
  nodes: Array<qx_eLockMode>;
};

/** aggregate fields of "qx.eLockMode" */
export type qx_eLockMode_aggregate_fields = {
  __typename?: 'qx_eLockMode_aggregate_fields';
  count: number;
  max?: qx_eLockMode_max_fields;
  min?: qx_eLockMode_min_fields;
};


/** aggregate fields of "qx.eLockMode" */
export type qx_eLockMode_aggregate_fieldscountArgs = {
  columns?: Array<qx_eLockMode_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eLockMode". All fields are combined with a logical 'AND'. */
export type qx_eLockMode_bool_exp = {
  _and?: Array<qx_eLockMode_bool_exp>;
  _not?: qx_eLockMode_bool_exp;
  _or?: Array<qx_eLockMode_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eLockMode" */
export enum qx_eLockMode_constraint {
  /** unique or primary key constraint on columns "value" */
  eLockMode_pkey = 'eLockMode_pkey'
}

export enum qx_eLockMode_enum {
  /** Apartment */
  Apartment = 'Apartment',
  /** Classroom */
  Classroom = 'Classroom',
  /** Office */
  Office = 'Office',
  /** Privacy */
  Privacy = 'Privacy',
  /** Unknown */
  Unknown = 'Unknown'
}

/** Boolean expression to compare columns of type "qx_eLockMode_enum". All fields are combined with logical 'AND'. */
export type qx_eLockMode_enum_comparison_exp = {
  _eq?: qx_eLockMode_enum;
  _in?: Array<qx_eLockMode_enum>;
  _is_null?: boolean;
  _neq?: qx_eLockMode_enum;
  _nin?: Array<qx_eLockMode_enum>;
};

/** input type for inserting data into table "qx.eLockMode" */
export type qx_eLockMode_insert_input = {
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eLockMode_max_fields = {
  __typename?: 'qx_eLockMode_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eLockMode_min_fields = {
  __typename?: 'qx_eLockMode_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eLockMode" */
export type qx_eLockMode_mutation_response = {
  __typename?: 'qx_eLockMode_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eLockMode>;
};

/** input type for inserting object relation for remote table "qx.eLockMode" */
export type qx_eLockMode_obj_rel_insert_input = {
  data: qx_eLockMode_insert_input;
  /** upsert condition */
  on_conflict?: qx_eLockMode_on_conflict;
};

/** on_conflict condition type for table "qx.eLockMode" */
export type qx_eLockMode_on_conflict = {
  constraint: qx_eLockMode_constraint;
  update_columns?: Array<qx_eLockMode_update_column>;
  where?: qx_eLockMode_bool_exp;
};

/** Ordering options when selecting data from "qx.eLockMode". */
export type qx_eLockMode_order_by = {
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eLockMode */
export type qx_eLockMode_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eLockMode" */
export enum qx_eLockMode_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eLockMode" */
export type qx_eLockMode_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eLockMode" */
export type qx_eLockMode_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eLockMode_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eLockMode_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eLockMode" */
export enum qx_eLockMode_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eLockMode_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eLockMode_set_input;
  /** filter the rows which have to be updated */
  where: qx_eLockMode_bool_exp;
};

/** enum: power supply monitoring states for a lock (normal, low power, no power, etc.) */
export type qx_eLockPowerMonitor = {
  __typename?: 'qx_eLockPowerMonitor';
  /** An array relationship */
  Locks: Array<qx_Lock>;
  /** An aggregate relationship */
  Locks_aggregate: qx_Lock_aggregate;
  comment?: string;
  value: string;
};


/** enum: power supply monitoring states for a lock (normal, low power, no power, etc.) */
export type qx_eLockPowerMonitorLocksArgs = {
  distinct_on?: Array<qx_Lock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Lock_order_by>;
  where?: qx_Lock_bool_exp;
};


/** enum: power supply monitoring states for a lock (normal, low power, no power, etc.) */
export type qx_eLockPowerMonitorLocks_aggregateArgs = {
  distinct_on?: Array<qx_Lock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Lock_order_by>;
  where?: qx_Lock_bool_exp;
};

/** aggregated selection of "qx.eLockPowerMonitor" */
export type qx_eLockPowerMonitor_aggregate = {
  __typename?: 'qx_eLockPowerMonitor_aggregate';
  aggregate?: qx_eLockPowerMonitor_aggregate_fields;
  nodes: Array<qx_eLockPowerMonitor>;
};

/** aggregate fields of "qx.eLockPowerMonitor" */
export type qx_eLockPowerMonitor_aggregate_fields = {
  __typename?: 'qx_eLockPowerMonitor_aggregate_fields';
  count: number;
  max?: qx_eLockPowerMonitor_max_fields;
  min?: qx_eLockPowerMonitor_min_fields;
};


/** aggregate fields of "qx.eLockPowerMonitor" */
export type qx_eLockPowerMonitor_aggregate_fieldscountArgs = {
  columns?: Array<qx_eLockPowerMonitor_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eLockPowerMonitor". All fields are combined with a logical 'AND'. */
export type qx_eLockPowerMonitor_bool_exp = {
  Locks?: qx_Lock_bool_exp;
  Locks_aggregate?: qx_Lock_aggregate_bool_exp;
  _and?: Array<qx_eLockPowerMonitor_bool_exp>;
  _not?: qx_eLockPowerMonitor_bool_exp;
  _or?: Array<qx_eLockPowerMonitor_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eLockPowerMonitor" */
export enum qx_eLockPowerMonitor_constraint {
  /** unique or primary key constraint on columns "value" */
  eLockPowerMonitor_pkey = 'eLockPowerMonitor_pkey'
}

export enum qx_eLockPowerMonitor_enum {
  /** Fail-Safe */
  FailSafe = 'FailSafe',
  /** Fail-Secure */
  FailSecure = 'FailSecure',
  /** None */
  None = 'None'
}

/** Boolean expression to compare columns of type "qx_eLockPowerMonitor_enum". All fields are combined with logical 'AND'. */
export type qx_eLockPowerMonitor_enum_comparison_exp = {
  _eq?: qx_eLockPowerMonitor_enum;
  _in?: Array<qx_eLockPowerMonitor_enum>;
  _is_null?: boolean;
  _neq?: qx_eLockPowerMonitor_enum;
  _nin?: Array<qx_eLockPowerMonitor_enum>;
};

/** input type for inserting data into table "qx.eLockPowerMonitor" */
export type qx_eLockPowerMonitor_insert_input = {
  Locks?: qx_Lock_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eLockPowerMonitor_max_fields = {
  __typename?: 'qx_eLockPowerMonitor_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eLockPowerMonitor_min_fields = {
  __typename?: 'qx_eLockPowerMonitor_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eLockPowerMonitor" */
export type qx_eLockPowerMonitor_mutation_response = {
  __typename?: 'qx_eLockPowerMonitor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eLockPowerMonitor>;
};

/** input type for inserting object relation for remote table "qx.eLockPowerMonitor" */
export type qx_eLockPowerMonitor_obj_rel_insert_input = {
  data: qx_eLockPowerMonitor_insert_input;
  /** upsert condition */
  on_conflict?: qx_eLockPowerMonitor_on_conflict;
};

/** on_conflict condition type for table "qx.eLockPowerMonitor" */
export type qx_eLockPowerMonitor_on_conflict = {
  constraint: qx_eLockPowerMonitor_constraint;
  update_columns?: Array<qx_eLockPowerMonitor_update_column>;
  where?: qx_eLockPowerMonitor_bool_exp;
};

/** Ordering options when selecting data from "qx.eLockPowerMonitor". */
export type qx_eLockPowerMonitor_order_by = {
  Locks_aggregate?: qx_Lock_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eLockPowerMonitor */
export type qx_eLockPowerMonitor_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eLockPowerMonitor" */
export enum qx_eLockPowerMonitor_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eLockPowerMonitor" */
export type qx_eLockPowerMonitor_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eLockPowerMonitor" */
export type qx_eLockPowerMonitor_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eLockPowerMonitor_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eLockPowerMonitor_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eLockPowerMonitor" */
export enum qx_eLockPowerMonitor_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eLockPowerMonitor_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eLockPowerMonitor_set_input;
  /** filter the rows which have to be updated */
  where: qx_eLockPowerMonitor_bool_exp;
};

/** enum: relay output monitoring states for a lock (energized, de-energized, fault) */
export type qx_eLockRelayMonitor = {
  __typename?: 'qx_eLockRelayMonitor';
  /** An array relationship */
  Locks: Array<qx_Lock>;
  /** An aggregate relationship */
  Locks_aggregate: qx_Lock_aggregate;
  comment?: string;
  value: string;
};


/** enum: relay output monitoring states for a lock (energized, de-energized, fault) */
export type qx_eLockRelayMonitorLocksArgs = {
  distinct_on?: Array<qx_Lock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Lock_order_by>;
  where?: qx_Lock_bool_exp;
};


/** enum: relay output monitoring states for a lock (energized, de-energized, fault) */
export type qx_eLockRelayMonitorLocks_aggregateArgs = {
  distinct_on?: Array<qx_Lock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Lock_order_by>;
  where?: qx_Lock_bool_exp;
};

/** aggregated selection of "qx.eLockRelayMonitor" */
export type qx_eLockRelayMonitor_aggregate = {
  __typename?: 'qx_eLockRelayMonitor_aggregate';
  aggregate?: qx_eLockRelayMonitor_aggregate_fields;
  nodes: Array<qx_eLockRelayMonitor>;
};

/** aggregate fields of "qx.eLockRelayMonitor" */
export type qx_eLockRelayMonitor_aggregate_fields = {
  __typename?: 'qx_eLockRelayMonitor_aggregate_fields';
  count: number;
  max?: qx_eLockRelayMonitor_max_fields;
  min?: qx_eLockRelayMonitor_min_fields;
};


/** aggregate fields of "qx.eLockRelayMonitor" */
export type qx_eLockRelayMonitor_aggregate_fieldscountArgs = {
  columns?: Array<qx_eLockRelayMonitor_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eLockRelayMonitor". All fields are combined with a logical 'AND'. */
export type qx_eLockRelayMonitor_bool_exp = {
  Locks?: qx_Lock_bool_exp;
  Locks_aggregate?: qx_Lock_aggregate_bool_exp;
  _and?: Array<qx_eLockRelayMonitor_bool_exp>;
  _not?: qx_eLockRelayMonitor_bool_exp;
  _or?: Array<qx_eLockRelayMonitor_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eLockRelayMonitor" */
export enum qx_eLockRelayMonitor_constraint {
  /** unique or primary key constraint on columns "value" */
  eLockRelayMonitor_pkey = 'eLockRelayMonitor_pkey'
}

export enum qx_eLockRelayMonitor_enum {
  /** None */
  None = 'None',
  /** Open-Locked */
  OpenLocked = 'OpenLocked',
  /** Open-Unlock */
  OpenUnlock = 'OpenUnlock'
}

/** Boolean expression to compare columns of type "qx_eLockRelayMonitor_enum". All fields are combined with logical 'AND'. */
export type qx_eLockRelayMonitor_enum_comparison_exp = {
  _eq?: qx_eLockRelayMonitor_enum;
  _in?: Array<qx_eLockRelayMonitor_enum>;
  _is_null?: boolean;
  _neq?: qx_eLockRelayMonitor_enum;
  _nin?: Array<qx_eLockRelayMonitor_enum>;
};

/** input type for inserting data into table "qx.eLockRelayMonitor" */
export type qx_eLockRelayMonitor_insert_input = {
  Locks?: qx_Lock_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eLockRelayMonitor_max_fields = {
  __typename?: 'qx_eLockRelayMonitor_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eLockRelayMonitor_min_fields = {
  __typename?: 'qx_eLockRelayMonitor_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eLockRelayMonitor" */
export type qx_eLockRelayMonitor_mutation_response = {
  __typename?: 'qx_eLockRelayMonitor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eLockRelayMonitor>;
};

/** input type for inserting object relation for remote table "qx.eLockRelayMonitor" */
export type qx_eLockRelayMonitor_obj_rel_insert_input = {
  data: qx_eLockRelayMonitor_insert_input;
  /** upsert condition */
  on_conflict?: qx_eLockRelayMonitor_on_conflict;
};

/** on_conflict condition type for table "qx.eLockRelayMonitor" */
export type qx_eLockRelayMonitor_on_conflict = {
  constraint: qx_eLockRelayMonitor_constraint;
  update_columns?: Array<qx_eLockRelayMonitor_update_column>;
  where?: qx_eLockRelayMonitor_bool_exp;
};

/** Ordering options when selecting data from "qx.eLockRelayMonitor". */
export type qx_eLockRelayMonitor_order_by = {
  Locks_aggregate?: qx_Lock_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eLockRelayMonitor */
export type qx_eLockRelayMonitor_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eLockRelayMonitor" */
export enum qx_eLockRelayMonitor_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eLockRelayMonitor" */
export type qx_eLockRelayMonitor_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eLockRelayMonitor" */
export type qx_eLockRelayMonitor_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eLockRelayMonitor_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eLockRelayMonitor_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eLockRelayMonitor" */
export enum qx_eLockRelayMonitor_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eLockRelayMonitor_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eLockRelayMonitor_set_input;
  /** filter the rows which have to be updated */
  where: qx_eLockRelayMonitor_bool_exp;
};

/** enum: types of electromechanical lock hardware (electric strike, maglock, electromagnetic bolt, etc.) */
export type qx_eLockType = {
  __typename?: 'qx_eLockType';
  /** An array relationship */
  Locks: Array<qx_Lock>;
  /** An aggregate relationship */
  Locks_aggregate: qx_Lock_aggregate;
  comment?: string;
  value: string;
};


/** enum: types of electromechanical lock hardware (electric strike, maglock, electromagnetic bolt, etc.) */
export type qx_eLockTypeLocksArgs = {
  distinct_on?: Array<qx_Lock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Lock_order_by>;
  where?: qx_Lock_bool_exp;
};


/** enum: types of electromechanical lock hardware (electric strike, maglock, electromagnetic bolt, etc.) */
export type qx_eLockTypeLocks_aggregateArgs = {
  distinct_on?: Array<qx_Lock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Lock_order_by>;
  where?: qx_Lock_bool_exp;
};

/** aggregated selection of "qx.eLockType" */
export type qx_eLockType_aggregate = {
  __typename?: 'qx_eLockType_aggregate';
  aggregate?: qx_eLockType_aggregate_fields;
  nodes: Array<qx_eLockType>;
};

/** aggregate fields of "qx.eLockType" */
export type qx_eLockType_aggregate_fields = {
  __typename?: 'qx_eLockType_aggregate_fields';
  count: number;
  max?: qx_eLockType_max_fields;
  min?: qx_eLockType_min_fields;
};


/** aggregate fields of "qx.eLockType" */
export type qx_eLockType_aggregate_fieldscountArgs = {
  columns?: Array<qx_eLockType_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eLockType". All fields are combined with a logical 'AND'. */
export type qx_eLockType_bool_exp = {
  Locks?: qx_Lock_bool_exp;
  Locks_aggregate?: qx_Lock_aggregate_bool_exp;
  _and?: Array<qx_eLockType_bool_exp>;
  _not?: qx_eLockType_bool_exp;
  _or?: Array<qx_eLockType_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eLockType" */
export enum qx_eLockType_constraint {
  /** unique or primary key constraint on columns "value" */
  eLockType_pkey = 'eLockType_pkey'
}

export enum qx_eLockType_enum {
  /** Allegion */
  Allegion = 'Allegion',
  /** Aperio */
  Aperio = 'Aperio',
  /** Relay */
  Relay = 'Relay',
  /** Unknown */
  Unknown = 'Unknown',
  /** 12V */
  v12 = 'v12'
}

/** Boolean expression to compare columns of type "qx_eLockType_enum". All fields are combined with logical 'AND'. */
export type qx_eLockType_enum_comparison_exp = {
  _eq?: qx_eLockType_enum;
  _in?: Array<qx_eLockType_enum>;
  _is_null?: boolean;
  _neq?: qx_eLockType_enum;
  _nin?: Array<qx_eLockType_enum>;
};

/** input type for inserting data into table "qx.eLockType" */
export type qx_eLockType_insert_input = {
  Locks?: qx_Lock_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eLockType_max_fields = {
  __typename?: 'qx_eLockType_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eLockType_min_fields = {
  __typename?: 'qx_eLockType_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eLockType" */
export type qx_eLockType_mutation_response = {
  __typename?: 'qx_eLockType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eLockType>;
};

/** input type for inserting object relation for remote table "qx.eLockType" */
export type qx_eLockType_obj_rel_insert_input = {
  data: qx_eLockType_insert_input;
  /** upsert condition */
  on_conflict?: qx_eLockType_on_conflict;
};

/** on_conflict condition type for table "qx.eLockType" */
export type qx_eLockType_on_conflict = {
  constraint: qx_eLockType_constraint;
  update_columns?: Array<qx_eLockType_update_column>;
  where?: qx_eLockType_bool_exp;
};

/** Ordering options when selecting data from "qx.eLockType". */
export type qx_eLockType_order_by = {
  Locks_aggregate?: qx_Lock_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eLockType */
export type qx_eLockType_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eLockType" */
export enum qx_eLockType_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eLockType" */
export type qx_eLockType_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eLockType" */
export type qx_eLockType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eLockType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eLockType_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eLockType" */
export enum qx_eLockType_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eLockType_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eLockType_set_input;
  /** filter the rows which have to be updated */
  where: qx_eLockType_bool_exp;
};

/** enum: latch mode options for Mercury Security hardware monitor points, controlling how input state changes are held */
export type qx_eMercuryMonitorPointLatchModes = {
  __typename?: 'qx_eMercuryMonitorPointLatchModes';
  /** An array relationship */
  MercuryMonitorPoints: Array<qx_MercuryMonitorPoint>;
  /** An aggregate relationship */
  MercuryMonitorPoints_aggregate: qx_MercuryMonitorPoint_aggregate;
  comment?: string;
  value: string;
};


/** enum: latch mode options for Mercury Security hardware monitor points, controlling how input state changes are held */
export type qx_eMercuryMonitorPointLatchModesMercuryMonitorPointsArgs = {
  distinct_on?: Array<qx_MercuryMonitorPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MercuryMonitorPoint_order_by>;
  where?: qx_MercuryMonitorPoint_bool_exp;
};


/** enum: latch mode options for Mercury Security hardware monitor points, controlling how input state changes are held */
export type qx_eMercuryMonitorPointLatchModesMercuryMonitorPoints_aggregateArgs = {
  distinct_on?: Array<qx_MercuryMonitorPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MercuryMonitorPoint_order_by>;
  where?: qx_MercuryMonitorPoint_bool_exp;
};

/** aggregated selection of "qx.eMercuryMonitorPointLatchModes" */
export type qx_eMercuryMonitorPointLatchModes_aggregate = {
  __typename?: 'qx_eMercuryMonitorPointLatchModes_aggregate';
  aggregate?: qx_eMercuryMonitorPointLatchModes_aggregate_fields;
  nodes: Array<qx_eMercuryMonitorPointLatchModes>;
};

/** aggregate fields of "qx.eMercuryMonitorPointLatchModes" */
export type qx_eMercuryMonitorPointLatchModes_aggregate_fields = {
  __typename?: 'qx_eMercuryMonitorPointLatchModes_aggregate_fields';
  count: number;
  max?: qx_eMercuryMonitorPointLatchModes_max_fields;
  min?: qx_eMercuryMonitorPointLatchModes_min_fields;
};


/** aggregate fields of "qx.eMercuryMonitorPointLatchModes" */
export type qx_eMercuryMonitorPointLatchModes_aggregate_fieldscountArgs = {
  columns?: Array<qx_eMercuryMonitorPointLatchModes_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eMercuryMonitorPointLatchModes". All fields are combined with a logical 'AND'. */
export type qx_eMercuryMonitorPointLatchModes_bool_exp = {
  MercuryMonitorPoints?: qx_MercuryMonitorPoint_bool_exp;
  MercuryMonitorPoints_aggregate?: qx_MercuryMonitorPoint_aggregate_bool_exp;
  _and?: Array<qx_eMercuryMonitorPointLatchModes_bool_exp>;
  _not?: qx_eMercuryMonitorPointLatchModes_bool_exp;
  _or?: Array<qx_eMercuryMonitorPointLatchModes_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eMercuryMonitorPointLatchModes" */
export enum qx_eMercuryMonitorPointLatchModes_constraint {
  /** unique or primary key constraint on columns "value" */
  eMercuryMonitorPointLatchModes_pkey = 'eMercuryMonitorPointLatchModes_pkey'
}

export enum qx_eMercuryMonitorPointLatchModes_enum {
  /** Latching */
  Latching = 'Latching',
  /** Non-Latching */
  NonLatching = 'NonLatching',
  /** Normal */
  Normal = 'Normal'
}

/** Boolean expression to compare columns of type "qx_eMercuryMonitorPointLatchModes_enum". All fields are combined with logical 'AND'. */
export type qx_eMercuryMonitorPointLatchModes_enum_comparison_exp = {
  _eq?: qx_eMercuryMonitorPointLatchModes_enum;
  _in?: Array<qx_eMercuryMonitorPointLatchModes_enum>;
  _is_null?: boolean;
  _neq?: qx_eMercuryMonitorPointLatchModes_enum;
  _nin?: Array<qx_eMercuryMonitorPointLatchModes_enum>;
};

/** input type for inserting data into table "qx.eMercuryMonitorPointLatchModes" */
export type qx_eMercuryMonitorPointLatchModes_insert_input = {
  MercuryMonitorPoints?: qx_MercuryMonitorPoint_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eMercuryMonitorPointLatchModes_max_fields = {
  __typename?: 'qx_eMercuryMonitorPointLatchModes_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eMercuryMonitorPointLatchModes_min_fields = {
  __typename?: 'qx_eMercuryMonitorPointLatchModes_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eMercuryMonitorPointLatchModes" */
export type qx_eMercuryMonitorPointLatchModes_mutation_response = {
  __typename?: 'qx_eMercuryMonitorPointLatchModes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eMercuryMonitorPointLatchModes>;
};

/** input type for inserting object relation for remote table "qx.eMercuryMonitorPointLatchModes" */
export type qx_eMercuryMonitorPointLatchModes_obj_rel_insert_input = {
  data: qx_eMercuryMonitorPointLatchModes_insert_input;
  /** upsert condition */
  on_conflict?: qx_eMercuryMonitorPointLatchModes_on_conflict;
};

/** on_conflict condition type for table "qx.eMercuryMonitorPointLatchModes" */
export type qx_eMercuryMonitorPointLatchModes_on_conflict = {
  constraint: qx_eMercuryMonitorPointLatchModes_constraint;
  update_columns?: Array<qx_eMercuryMonitorPointLatchModes_update_column>;
  where?: qx_eMercuryMonitorPointLatchModes_bool_exp;
};

/** Ordering options when selecting data from "qx.eMercuryMonitorPointLatchModes". */
export type qx_eMercuryMonitorPointLatchModes_order_by = {
  MercuryMonitorPoints_aggregate?: qx_MercuryMonitorPoint_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eMercuryMonitorPointLatchModes */
export type qx_eMercuryMonitorPointLatchModes_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eMercuryMonitorPointLatchModes" */
export enum qx_eMercuryMonitorPointLatchModes_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eMercuryMonitorPointLatchModes" */
export type qx_eMercuryMonitorPointLatchModes_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eMercuryMonitorPointLatchModes" */
export type qx_eMercuryMonitorPointLatchModes_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eMercuryMonitorPointLatchModes_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eMercuryMonitorPointLatchModes_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eMercuryMonitorPointLatchModes" */
export enum qx_eMercuryMonitorPointLatchModes_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eMercuryMonitorPointLatchModes_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eMercuryMonitorPointLatchModes_set_input;
  /** filter the rows which have to be updated */
  where: qx_eMercuryMonitorPointLatchModes_bool_exp;
};

/** enum: monitored lock state values used to report the lock's secured/unsecured state back to the controller */
export type qx_eMonitorLockState = {
  __typename?: 'qx_eMonitorLockState';
  /** An array relationship */
  Doors: Array<qx_Door>;
  /** An aggregate relationship */
  Doors_aggregate: qx_Door_aggregate;
  comment?: string;
  value: string;
};


/** enum: monitored lock state values used to report the lock's secured/unsecured state back to the controller */
export type qx_eMonitorLockStateDoorsArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


/** enum: monitored lock state values used to report the lock's secured/unsecured state back to the controller */
export type qx_eMonitorLockStateDoors_aggregateArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};

/** aggregated selection of "qx.eMonitorLockState" */
export type qx_eMonitorLockState_aggregate = {
  __typename?: 'qx_eMonitorLockState_aggregate';
  aggregate?: qx_eMonitorLockState_aggregate_fields;
  nodes: Array<qx_eMonitorLockState>;
};

/** aggregate fields of "qx.eMonitorLockState" */
export type qx_eMonitorLockState_aggregate_fields = {
  __typename?: 'qx_eMonitorLockState_aggregate_fields';
  count: number;
  max?: qx_eMonitorLockState_max_fields;
  min?: qx_eMonitorLockState_min_fields;
};


/** aggregate fields of "qx.eMonitorLockState" */
export type qx_eMonitorLockState_aggregate_fieldscountArgs = {
  columns?: Array<qx_eMonitorLockState_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eMonitorLockState". All fields are combined with a logical 'AND'. */
export type qx_eMonitorLockState_bool_exp = {
  Doors?: qx_Door_bool_exp;
  Doors_aggregate?: qx_Door_aggregate_bool_exp;
  _and?: Array<qx_eMonitorLockState_bool_exp>;
  _not?: qx_eMonitorLockState_bool_exp;
  _or?: Array<qx_eMonitorLockState_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eMonitorLockState" */
export enum qx_eMonitorLockState_constraint {
  /** unique or primary key constraint on columns "value" */
  eMonitorLockState_pkey = 'eMonitorLockState_pkey'
}

export enum qx_eMonitorLockState_enum {
  /** None */
  None = 'None',
  /** Open Circuit: Locked */
  OpenCircuitLocked = 'OpenCircuitLocked',
  /** Open Circuit: Unlocked */
  OpenCircuitUnlocked = 'OpenCircuitUnlocked'
}

/** Boolean expression to compare columns of type "qx_eMonitorLockState_enum". All fields are combined with logical 'AND'. */
export type qx_eMonitorLockState_enum_comparison_exp = {
  _eq?: qx_eMonitorLockState_enum;
  _in?: Array<qx_eMonitorLockState_enum>;
  _is_null?: boolean;
  _neq?: qx_eMonitorLockState_enum;
  _nin?: Array<qx_eMonitorLockState_enum>;
};

/** input type for inserting data into table "qx.eMonitorLockState" */
export type qx_eMonitorLockState_insert_input = {
  Doors?: qx_Door_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eMonitorLockState_max_fields = {
  __typename?: 'qx_eMonitorLockState_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eMonitorLockState_min_fields = {
  __typename?: 'qx_eMonitorLockState_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eMonitorLockState" */
export type qx_eMonitorLockState_mutation_response = {
  __typename?: 'qx_eMonitorLockState_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eMonitorLockState>;
};

/** input type for inserting object relation for remote table "qx.eMonitorLockState" */
export type qx_eMonitorLockState_obj_rel_insert_input = {
  data: qx_eMonitorLockState_insert_input;
  /** upsert condition */
  on_conflict?: qx_eMonitorLockState_on_conflict;
};

/** on_conflict condition type for table "qx.eMonitorLockState" */
export type qx_eMonitorLockState_on_conflict = {
  constraint: qx_eMonitorLockState_constraint;
  update_columns?: Array<qx_eMonitorLockState_update_column>;
  where?: qx_eMonitorLockState_bool_exp;
};

/** Ordering options when selecting data from "qx.eMonitorLockState". */
export type qx_eMonitorLockState_order_by = {
  Doors_aggregate?: qx_Door_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eMonitorLockState */
export type qx_eMonitorLockState_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eMonitorLockState" */
export enum qx_eMonitorLockState_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eMonitorLockState" */
export type qx_eMonitorLockState_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eMonitorLockState" */
export type qx_eMonitorLockState_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eMonitorLockState_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eMonitorLockState_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eMonitorLockState" */
export enum qx_eMonitorLockState_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eMonitorLockState_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eMonitorLockState_set_input;
  /** filter the rows which have to be updated */
  where: qx_eMonitorLockState_bool_exp;
};

/** enum: physical mounting position options for cameras (ceiling, wall, pendant, corner, etc.) */
export type qx_eMountPosition = {
  __typename?: 'qx_eMountPosition';
  comment?: string;
  value: string;
  /** An array relationship */
  videoSources: Array<qx_VideoSource>;
  /** An aggregate relationship */
  videoSources_aggregate: qx_VideoSource_aggregate;
};


/** enum: physical mounting position options for cameras (ceiling, wall, pendant, corner, etc.) */
export type qx_eMountPositionvideoSourcesArgs = {
  distinct_on?: Array<qx_VideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_VideoSource_order_by>;
  where?: qx_VideoSource_bool_exp;
};


/** enum: physical mounting position options for cameras (ceiling, wall, pendant, corner, etc.) */
export type qx_eMountPositionvideoSources_aggregateArgs = {
  distinct_on?: Array<qx_VideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_VideoSource_order_by>;
  where?: qx_VideoSource_bool_exp;
};

/** aggregated selection of "qx.eMountPosition" */
export type qx_eMountPosition_aggregate = {
  __typename?: 'qx_eMountPosition_aggregate';
  aggregate?: qx_eMountPosition_aggregate_fields;
  nodes: Array<qx_eMountPosition>;
};

/** aggregate fields of "qx.eMountPosition" */
export type qx_eMountPosition_aggregate_fields = {
  __typename?: 'qx_eMountPosition_aggregate_fields';
  count: number;
  max?: qx_eMountPosition_max_fields;
  min?: qx_eMountPosition_min_fields;
};


/** aggregate fields of "qx.eMountPosition" */
export type qx_eMountPosition_aggregate_fieldscountArgs = {
  columns?: Array<qx_eMountPosition_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eMountPosition". All fields are combined with a logical 'AND'. */
export type qx_eMountPosition_bool_exp = {
  _and?: Array<qx_eMountPosition_bool_exp>;
  _not?: qx_eMountPosition_bool_exp;
  _or?: Array<qx_eMountPosition_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
  videoSources?: qx_VideoSource_bool_exp;
  videoSources_aggregate?: qx_VideoSource_aggregate_bool_exp;
};

/** unique or primary key constraints on table "qx.eMountPosition" */
export enum qx_eMountPosition_constraint {
  /** unique or primary key constraint on columns "value" */
  eMountPosition_pkey = 'eMountPosition_pkey'
}

export enum qx_eMountPosition_enum {
  /** Ceiling */
  Ceiling = 'Ceiling',
  /** Floor */
  Floor = 'Floor',
  /** Wall */
  Wall = 'Wall'
}

/** Boolean expression to compare columns of type "qx_eMountPosition_enum". All fields are combined with logical 'AND'. */
export type qx_eMountPosition_enum_comparison_exp = {
  _eq?: qx_eMountPosition_enum;
  _in?: Array<qx_eMountPosition_enum>;
  _is_null?: boolean;
  _neq?: qx_eMountPosition_enum;
  _nin?: Array<qx_eMountPosition_enum>;
};

/** input type for inserting data into table "qx.eMountPosition" */
export type qx_eMountPosition_insert_input = {
  comment?: string;
  value?: string;
  videoSources?: qx_VideoSource_arr_rel_insert_input;
};

/** aggregate max on columns */
export type qx_eMountPosition_max_fields = {
  __typename?: 'qx_eMountPosition_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eMountPosition_min_fields = {
  __typename?: 'qx_eMountPosition_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eMountPosition" */
export type qx_eMountPosition_mutation_response = {
  __typename?: 'qx_eMountPosition_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eMountPosition>;
};

/** input type for inserting object relation for remote table "qx.eMountPosition" */
export type qx_eMountPosition_obj_rel_insert_input = {
  data: qx_eMountPosition_insert_input;
  /** upsert condition */
  on_conflict?: qx_eMountPosition_on_conflict;
};

/** on_conflict condition type for table "qx.eMountPosition" */
export type qx_eMountPosition_on_conflict = {
  constraint: qx_eMountPosition_constraint;
  update_columns?: Array<qx_eMountPosition_update_column>;
  where?: qx_eMountPosition_bool_exp;
};

/** Ordering options when selecting data from "qx.eMountPosition". */
export type qx_eMountPosition_order_by = {
  comment?: order_by;
  value?: order_by;
  videoSources_aggregate?: qx_VideoSource_aggregate_order_by;
};

/** primary key columns input for table: qx.eMountPosition */
export type qx_eMountPosition_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eMountPosition" */
export enum qx_eMountPosition_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eMountPosition" */
export type qx_eMountPosition_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eMountPosition" */
export type qx_eMountPosition_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eMountPosition_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eMountPosition_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eMountPosition" */
export enum qx_eMountPosition_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eMountPosition_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eMountPosition_set_input;
  /** filter the rows which have to be updated */
  where: qx_eMountPosition_bool_exp;
};

/** enum: generic action types that can be applied to system objects within automations (create, update, delete, trigger, etc.) */
export type qx_eObjectAction = {
  __typename?: 'qx_eObjectAction';
  comment?: string;
  value: string;
  /** An array relationship */
  videoSources: Array<qx_Event>;
  /** An aggregate relationship */
  videoSources_aggregate: qx_Event_aggregate;
};


/** enum: generic action types that can be applied to system objects within automations (create, update, delete, trigger, etc.) */
export type qx_eObjectActionvideoSourcesArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};


/** enum: generic action types that can be applied to system objects within automations (create, update, delete, trigger, etc.) */
export type qx_eObjectActionvideoSources_aggregateArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};

/** aggregated selection of "qx.eObjectAction" */
export type qx_eObjectAction_aggregate = {
  __typename?: 'qx_eObjectAction_aggregate';
  aggregate?: qx_eObjectAction_aggregate_fields;
  nodes: Array<qx_eObjectAction>;
};

/** aggregate fields of "qx.eObjectAction" */
export type qx_eObjectAction_aggregate_fields = {
  __typename?: 'qx_eObjectAction_aggregate_fields';
  count: number;
  max?: qx_eObjectAction_max_fields;
  min?: qx_eObjectAction_min_fields;
};


/** aggregate fields of "qx.eObjectAction" */
export type qx_eObjectAction_aggregate_fieldscountArgs = {
  columns?: Array<qx_eObjectAction_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eObjectAction". All fields are combined with a logical 'AND'. */
export type qx_eObjectAction_bool_exp = {
  _and?: Array<qx_eObjectAction_bool_exp>;
  _not?: qx_eObjectAction_bool_exp;
  _or?: Array<qx_eObjectAction_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
  videoSources?: qx_Event_bool_exp;
  videoSources_aggregate?: qx_Event_aggregate_bool_exp;
};

/** unique or primary key constraints on table "qx.eObjectAction" */
export enum qx_eObjectAction_constraint {
  /** unique or primary key constraint on columns "value" */
  eObjectAction_pkey = 'eObjectAction_pkey'
}

/** input type for inserting data into table "qx.eObjectAction" */
export type qx_eObjectAction_insert_input = {
  comment?: string;
  value?: string;
  videoSources?: qx_Event_arr_rel_insert_input;
};

/** aggregate max on columns */
export type qx_eObjectAction_max_fields = {
  __typename?: 'qx_eObjectAction_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eObjectAction_min_fields = {
  __typename?: 'qx_eObjectAction_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eObjectAction" */
export type qx_eObjectAction_mutation_response = {
  __typename?: 'qx_eObjectAction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eObjectAction>;
};

/** on_conflict condition type for table "qx.eObjectAction" */
export type qx_eObjectAction_on_conflict = {
  constraint: qx_eObjectAction_constraint;
  update_columns?: Array<qx_eObjectAction_update_column>;
  where?: qx_eObjectAction_bool_exp;
};

/** Ordering options when selecting data from "qx.eObjectAction". */
export type qx_eObjectAction_order_by = {
  comment?: order_by;
  value?: order_by;
  videoSources_aggregate?: qx_Event_aggregate_order_by;
};

/** primary key columns input for table: qx.eObjectAction */
export type qx_eObjectAction_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eObjectAction" */
export enum qx_eObjectAction_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eObjectAction" */
export type qx_eObjectAction_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eObjectAction" */
export type qx_eObjectAction_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eObjectAction_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eObjectAction_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eObjectAction" */
export enum qx_eObjectAction_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eObjectAction_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eObjectAction_set_input;
  /** filter the rows which have to be updated */
  where: qx_eObjectAction_bool_exp;
};

/** enum: Physical Access Control System provisioning status states for door hardware (unprovisioned, provisioning, provisioned, error) */
export type qx_ePACSStatus = {
  __typename?: 'qx_ePACSStatus';
  /** An array relationship */
  Devices: Array<qx_Device>;
  /** An aggregate relationship */
  Devices_aggregate: qx_Device_aggregate;
  comment?: string;
  /** An array relationship */
  devices: Array<qx_Device>;
  /** An aggregate relationship */
  devices_aggregate: qx_Device_aggregate;
  value: string;
};


/** enum: Physical Access Control System provisioning status states for door hardware (unprovisioned, provisioning, provisioned, error) */
export type qx_ePACSStatusDevicesArgs = {
  distinct_on?: Array<qx_Device_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Device_order_by>;
  where?: qx_Device_bool_exp;
};


/** enum: Physical Access Control System provisioning status states for door hardware (unprovisioned, provisioning, provisioned, error) */
export type qx_ePACSStatusDevices_aggregateArgs = {
  distinct_on?: Array<qx_Device_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Device_order_by>;
  where?: qx_Device_bool_exp;
};


/** enum: Physical Access Control System provisioning status states for door hardware (unprovisioned, provisioning, provisioned, error) */
export type qx_ePACSStatusdevicesArgs = {
  distinct_on?: Array<qx_Device_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Device_order_by>;
  where?: qx_Device_bool_exp;
};


/** enum: Physical Access Control System provisioning status states for door hardware (unprovisioned, provisioning, provisioned, error) */
export type qx_ePACSStatusdevices_aggregateArgs = {
  distinct_on?: Array<qx_Device_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Device_order_by>;
  where?: qx_Device_bool_exp;
};

/** aggregated selection of "qx.ePACSStatus" */
export type qx_ePACSStatus_aggregate = {
  __typename?: 'qx_ePACSStatus_aggregate';
  aggregate?: qx_ePACSStatus_aggregate_fields;
  nodes: Array<qx_ePACSStatus>;
};

/** aggregate fields of "qx.ePACSStatus" */
export type qx_ePACSStatus_aggregate_fields = {
  __typename?: 'qx_ePACSStatus_aggregate_fields';
  count: number;
  max?: qx_ePACSStatus_max_fields;
  min?: qx_ePACSStatus_min_fields;
};


/** aggregate fields of "qx.ePACSStatus" */
export type qx_ePACSStatus_aggregate_fieldscountArgs = {
  columns?: Array<qx_ePACSStatus_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.ePACSStatus". All fields are combined with a logical 'AND'. */
export type qx_ePACSStatus_bool_exp = {
  Devices?: qx_Device_bool_exp;
  Devices_aggregate?: qx_Device_aggregate_bool_exp;
  _and?: Array<qx_ePACSStatus_bool_exp>;
  _not?: qx_ePACSStatus_bool_exp;
  _or?: Array<qx_ePACSStatus_bool_exp>;
  comment?: String_comparison_exp;
  devices?: qx_Device_bool_exp;
  devices_aggregate?: qx_Device_aggregate_bool_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.ePACSStatus" */
export enum qx_ePACSStatus_constraint {
  /** unique or primary key constraint on columns "value" */
  ePACSStatus_pkey = 'ePACSStatus_pkey'
}

export enum qx_ePACSStatus_enum {
  /** Needs Update */
  NeedsUpdate = 'NeedsUpdate',
  /** Offline Device Configuration Attempt */
  NeedsUpdateOnConnect = 'NeedsUpdateOnConnect',
  /** Unknown */
  Unknown = 'Unknown',
  /** Update Failed */
  UpdateFailed = 'UpdateFailed',
  /** Updated */
  Updated = 'Updated',
  /** Updating */
  Updating = 'Updating',
  /** Validation Failed */
  ValidateFailed = 'ValidateFailed'
}

/** Boolean expression to compare columns of type "qx_ePACSStatus_enum". All fields are combined with logical 'AND'. */
export type qx_ePACSStatus_enum_comparison_exp = {
  _eq?: qx_ePACSStatus_enum;
  _in?: Array<qx_ePACSStatus_enum>;
  _is_null?: boolean;
  _neq?: qx_ePACSStatus_enum;
  _nin?: Array<qx_ePACSStatus_enum>;
};

/** input type for inserting data into table "qx.ePACSStatus" */
export type qx_ePACSStatus_insert_input = {
  Devices?: qx_Device_arr_rel_insert_input;
  comment?: string;
  devices?: qx_Device_arr_rel_insert_input;
  value?: string;
};

/** aggregate max on columns */
export type qx_ePACSStatus_max_fields = {
  __typename?: 'qx_ePACSStatus_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_ePACSStatus_min_fields = {
  __typename?: 'qx_ePACSStatus_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.ePACSStatus" */
export type qx_ePACSStatus_mutation_response = {
  __typename?: 'qx_ePACSStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_ePACSStatus>;
};

/** input type for inserting object relation for remote table "qx.ePACSStatus" */
export type qx_ePACSStatus_obj_rel_insert_input = {
  data: qx_ePACSStatus_insert_input;
  /** upsert condition */
  on_conflict?: qx_ePACSStatus_on_conflict;
};

/** on_conflict condition type for table "qx.ePACSStatus" */
export type qx_ePACSStatus_on_conflict = {
  constraint: qx_ePACSStatus_constraint;
  update_columns?: Array<qx_ePACSStatus_update_column>;
  where?: qx_ePACSStatus_bool_exp;
};

/** Ordering options when selecting data from "qx.ePACSStatus". */
export type qx_ePACSStatus_order_by = {
  Devices_aggregate?: qx_Device_aggregate_order_by;
  comment?: order_by;
  devices_aggregate?: qx_Device_aggregate_order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.ePACSStatus */
export type qx_ePACSStatus_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.ePACSStatus" */
export enum qx_ePACSStatus_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.ePACSStatus" */
export type qx_ePACSStatus_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_ePACSStatus" */
export type qx_ePACSStatus_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_ePACSStatus_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_ePACSStatus_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.ePACSStatus" */
export enum qx_ePACSStatus_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_ePACSStatus_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_ePACSStatus_set_input;
  /** filter the rows which have to be updated */
  where: qx_ePACSStatus_bool_exp;
};

/** enum: account status states of a person (active, suspended, deleted) */
export type qx_ePersonStatus = {
  __typename?: 'qx_ePersonStatus';
  comment?: string;
  value: string;
};

/** aggregated selection of "qx.ePersonStatus" */
export type qx_ePersonStatus_aggregate = {
  __typename?: 'qx_ePersonStatus_aggregate';
  aggregate?: qx_ePersonStatus_aggregate_fields;
  nodes: Array<qx_ePersonStatus>;
};

/** aggregate fields of "qx.ePersonStatus" */
export type qx_ePersonStatus_aggregate_fields = {
  __typename?: 'qx_ePersonStatus_aggregate_fields';
  count: number;
  max?: qx_ePersonStatus_max_fields;
  min?: qx_ePersonStatus_min_fields;
};


/** aggregate fields of "qx.ePersonStatus" */
export type qx_ePersonStatus_aggregate_fieldscountArgs = {
  columns?: Array<qx_ePersonStatus_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.ePersonStatus". All fields are combined with a logical 'AND'. */
export type qx_ePersonStatus_bool_exp = {
  _and?: Array<qx_ePersonStatus_bool_exp>;
  _not?: qx_ePersonStatus_bool_exp;
  _or?: Array<qx_ePersonStatus_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.ePersonStatus" */
export enum qx_ePersonStatus_constraint {
  /** unique or primary key constraint on columns "value" */
  ePersonStatus_pkey = 'ePersonStatus_pkey'
}

/** input type for inserting data into table "qx.ePersonStatus" */
export type qx_ePersonStatus_insert_input = {
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_ePersonStatus_max_fields = {
  __typename?: 'qx_ePersonStatus_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_ePersonStatus_min_fields = {
  __typename?: 'qx_ePersonStatus_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.ePersonStatus" */
export type qx_ePersonStatus_mutation_response = {
  __typename?: 'qx_ePersonStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_ePersonStatus>;
};

/** on_conflict condition type for table "qx.ePersonStatus" */
export type qx_ePersonStatus_on_conflict = {
  constraint: qx_ePersonStatus_constraint;
  update_columns?: Array<qx_ePersonStatus_update_column>;
  where?: qx_ePersonStatus_bool_exp;
};

/** Ordering options when selecting data from "qx.ePersonStatus". */
export type qx_ePersonStatus_order_by = {
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.ePersonStatus */
export type qx_ePersonStatus_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.ePersonStatus" */
export enum qx_ePersonStatus_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.ePersonStatus" */
export type qx_ePersonStatus_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_ePersonStatus" */
export type qx_ePersonStatus_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_ePersonStatus_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_ePersonStatus_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.ePersonStatus" */
export enum qx_ePersonStatus_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_ePersonStatus_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_ePersonStatus_set_input;
  /** filter the rows which have to be updated */
  where: qx_ePersonStatus_bool_exp;
};

/** enum: node type categories in the place hierarchy (root, customer, integrator, site, area, room, etc.) */
export type qx_ePlaceType = {
  __typename?: 'qx_ePlaceType';
  comment?: string;
  /** An array relationship */
  places: Array<qx_Place>;
  /** An aggregate relationship */
  places_aggregate: qx_Place_aggregate;
  value: string;
};


/** enum: node type categories in the place hierarchy (root, customer, integrator, site, area, room, etc.) */
export type qx_ePlaceTypeplacesArgs = {
  distinct_on?: Array<qx_Place_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Place_order_by>;
  where?: qx_Place_bool_exp;
};


/** enum: node type categories in the place hierarchy (root, customer, integrator, site, area, room, etc.) */
export type qx_ePlaceTypeplaces_aggregateArgs = {
  distinct_on?: Array<qx_Place_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Place_order_by>;
  where?: qx_Place_bool_exp;
};

/** aggregated selection of "qx.ePlaceType" */
export type qx_ePlaceType_aggregate = {
  __typename?: 'qx_ePlaceType_aggregate';
  aggregate?: qx_ePlaceType_aggregate_fields;
  nodes: Array<qx_ePlaceType>;
};

/** aggregate fields of "qx.ePlaceType" */
export type qx_ePlaceType_aggregate_fields = {
  __typename?: 'qx_ePlaceType_aggregate_fields';
  count: number;
  max?: qx_ePlaceType_max_fields;
  min?: qx_ePlaceType_min_fields;
};


/** aggregate fields of "qx.ePlaceType" */
export type qx_ePlaceType_aggregate_fieldscountArgs = {
  columns?: Array<qx_ePlaceType_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.ePlaceType". All fields are combined with a logical 'AND'. */
export type qx_ePlaceType_bool_exp = {
  _and?: Array<qx_ePlaceType_bool_exp>;
  _not?: qx_ePlaceType_bool_exp;
  _or?: Array<qx_ePlaceType_bool_exp>;
  comment?: String_comparison_exp;
  places?: qx_Place_bool_exp;
  places_aggregate?: qx_Place_aggregate_bool_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.ePlaceType" */
export enum qx_ePlaceType_constraint {
  /** unique or primary key constraint on columns "value" */
  ePlaceType_pkey = 'ePlaceType_pkey'
}

export enum qx_ePlaceType_enum {
  /** Area */
  Area = 'Area',
  /** Customer */
  Customer = 'Customer',
  /** Integrator */
  Integrator = 'Integrator',
  /** Qumulex Top Level */
  Root = 'Root',
  /** Site */
  Site = 'Site',
  /** Unknown */
  Unknown = 'Unknown'
}

/** Boolean expression to compare columns of type "qx_ePlaceType_enum". All fields are combined with logical 'AND'. */
export type qx_ePlaceType_enum_comparison_exp = {
  _eq?: qx_ePlaceType_enum;
  _in?: Array<qx_ePlaceType_enum>;
  _is_null?: boolean;
  _neq?: qx_ePlaceType_enum;
  _nin?: Array<qx_ePlaceType_enum>;
};

/** input type for inserting data into table "qx.ePlaceType" */
export type qx_ePlaceType_insert_input = {
  comment?: string;
  places?: qx_Place_arr_rel_insert_input;
  value?: string;
};

/** aggregate max on columns */
export type qx_ePlaceType_max_fields = {
  __typename?: 'qx_ePlaceType_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_ePlaceType_min_fields = {
  __typename?: 'qx_ePlaceType_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.ePlaceType" */
export type qx_ePlaceType_mutation_response = {
  __typename?: 'qx_ePlaceType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_ePlaceType>;
};

/** input type for inserting object relation for remote table "qx.ePlaceType" */
export type qx_ePlaceType_obj_rel_insert_input = {
  data: qx_ePlaceType_insert_input;
  /** upsert condition */
  on_conflict?: qx_ePlaceType_on_conflict;
};

/** on_conflict condition type for table "qx.ePlaceType" */
export type qx_ePlaceType_on_conflict = {
  constraint: qx_ePlaceType_constraint;
  update_columns?: Array<qx_ePlaceType_update_column>;
  where?: qx_ePlaceType_bool_exp;
};

/** Ordering options when selecting data from "qx.ePlaceType". */
export type qx_ePlaceType_order_by = {
  comment?: order_by;
  places_aggregate?: qx_Place_aggregate_order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.ePlaceType */
export type qx_ePlaceType_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.ePlaceType" */
export enum qx_ePlaceType_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.ePlaceType" */
export type qx_ePlaceType_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_ePlaceType" */
export type qx_ePlaceType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_ePlaceType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_ePlaceType_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.ePlaceType" */
export enum qx_ePlaceType_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_ePlaceType_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_ePlaceType_set_input;
  /** filter the rows which have to be updated */
  where: qx_ePlaceType_bool_exp;
};

/** enum: individual application privilege definitions (e.g., DoorConfig, PeopleView, CameraView) */
export type qx_ePrivilege = {
  __typename?: 'qx_ePrivilege';
  comment?: string;
  /** An array relationship */
  toRoles: Array<qx__PrivilegeEnumToRole>;
  /** An aggregate relationship */
  toRoles_aggregate: qx__PrivilegeEnumToRole_aggregate;
  value: string;
};


/** enum: individual application privilege definitions (e.g., DoorConfig, PeopleView, CameraView) */
export type qx_ePrivilegetoRolesArgs = {
  distinct_on?: Array<qx__PrivilegeEnumToRole_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__PrivilegeEnumToRole_order_by>;
  where?: qx__PrivilegeEnumToRole_bool_exp;
};


/** enum: individual application privilege definitions (e.g., DoorConfig, PeopleView, CameraView) */
export type qx_ePrivilegetoRoles_aggregateArgs = {
  distinct_on?: Array<qx__PrivilegeEnumToRole_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__PrivilegeEnumToRole_order_by>;
  where?: qx__PrivilegeEnumToRole_bool_exp;
};

/** aggregated selection of "qx.ePrivilege" */
export type qx_ePrivilege_aggregate = {
  __typename?: 'qx_ePrivilege_aggregate';
  aggregate?: qx_ePrivilege_aggregate_fields;
  nodes: Array<qx_ePrivilege>;
};

/** aggregate fields of "qx.ePrivilege" */
export type qx_ePrivilege_aggregate_fields = {
  __typename?: 'qx_ePrivilege_aggregate_fields';
  count: number;
  max?: qx_ePrivilege_max_fields;
  min?: qx_ePrivilege_min_fields;
};


/** aggregate fields of "qx.ePrivilege" */
export type qx_ePrivilege_aggregate_fieldscountArgs = {
  columns?: Array<qx_ePrivilege_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.ePrivilege". All fields are combined with a logical 'AND'. */
export type qx_ePrivilege_bool_exp = {
  _and?: Array<qx_ePrivilege_bool_exp>;
  _not?: qx_ePrivilege_bool_exp;
  _or?: Array<qx_ePrivilege_bool_exp>;
  comment?: String_comparison_exp;
  toRoles?: qx__PrivilegeEnumToRole_bool_exp;
  toRoles_aggregate?: qx__PrivilegeEnumToRole_aggregate_bool_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.ePrivilege" */
export enum qx_ePrivilege_constraint {
  /** unique or primary key constraint on columns "value" */
  ePrivilege_pkey = 'ePrivilege_pkey'
}

export enum qx_ePrivilege_enum {
  /** Use the AI Assistant */
  AIAssistant = 'AIAssistant',
  /** Manage AI billing tier and overage spending */
  AIBilling = 'AIBilling',
  /** Generation of Access Reports */
  AccessReports = 'AccessReports',
  /** Viewing of Audit Trails */
  Audit = 'Audit',
  /** Configuration of Gateway Bandwidth */
  BandwidthConfig = 'BandwidthConfig',
  /** Configuration of Cameras */
  CameraConfig = 'CameraConfig',
  /** Control of Cameras */
  CameraOperator = 'CameraOperator',
  /** View Cameras */
  CameraView = 'CameraView',
  /** Clip Management */
  ClipManagement = 'ClipManagement',
  /** Configuration of Devices */
  DeviceConfig = 'DeviceConfig',
  /** Control of Device DIOs */
  DeviceOperator = 'DeviceOperator',
  /** View of devices */
  DeviceView = 'DeviceView',
  /** Configuration of Doors */
  DoorConfig = 'DoorConfig',
  /** Control of Doors */
  DoorOperator = 'DoorOperator',
  /** View Doors */
  DoorView = 'DoorView',
  /** Configuration of Gateways */
  GatewayConfig = 'GatewayConfig',
  /** View of Gateways */
  GatewayView = 'GatewayView',
  /** Configuration of Intrusion Panel and Zoness */
  IntrusionConfig = 'IntrusionConfig',
  /** Control of Intrusion Panels and Zones */
  IntrusionOperator = 'IntrusionOperator',
  /** View Intrustion Panels and Zones */
  IntrusionView = 'IntrusionView',
  /** Viewing of Live Events */
  LiveEvents = 'LiveEvents',
  /** Live Video Access */
  LiveVideo = 'LiveVideo',
  /** Control Lockdown of Places */
  LockDown = 'LockDown',
  /** People Management */
  PeopleConfig = 'PeopleConfig',
  /** View of People */
  PeopleView = 'PeopleView',
  /** Configuration of Places */
  PlaceConfig = 'PlaceConfig',
  /** Recorded Video Access */
  RecordedVideo = 'RecordedVideo',
  /** Role Management */
  RoleConfig = 'RoleConfig',
  /** Configuration of Rules */
  RulesConfig = 'RulesConfig',
  /** View of Rules */
  RulesView = 'RulesView',
  /** Configuration of Schedules */
  ScheduleConfig = 'ScheduleConfig',
  /** Searching of Events */
  Search = 'Search',
  /** View of Snapshots */
  Snapshots = 'Snapshots',
  /** Allows Inviting Users to Qx Control */
  UserCreation = 'UserCreation',
  /** View based on Place Hierarchy */
  View = 'View',
  /** Configuration of Views */
  ViewConfig = 'ViewConfig'
}

/** Boolean expression to compare columns of type "qx_ePrivilege_enum". All fields are combined with logical 'AND'. */
export type qx_ePrivilege_enum_comparison_exp = {
  _eq?: qx_ePrivilege_enum;
  _in?: Array<qx_ePrivilege_enum>;
  _is_null?: boolean;
  _neq?: qx_ePrivilege_enum;
  _nin?: Array<qx_ePrivilege_enum>;
};

/** input type for inserting data into table "qx.ePrivilege" */
export type qx_ePrivilege_insert_input = {
  comment?: string;
  toRoles?: qx__PrivilegeEnumToRole_arr_rel_insert_input;
  value?: string;
};

/** aggregate max on columns */
export type qx_ePrivilege_max_fields = {
  __typename?: 'qx_ePrivilege_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_ePrivilege_min_fields = {
  __typename?: 'qx_ePrivilege_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.ePrivilege" */
export type qx_ePrivilege_mutation_response = {
  __typename?: 'qx_ePrivilege_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_ePrivilege>;
};

/** input type for inserting object relation for remote table "qx.ePrivilege" */
export type qx_ePrivilege_obj_rel_insert_input = {
  data: qx_ePrivilege_insert_input;
  /** upsert condition */
  on_conflict?: qx_ePrivilege_on_conflict;
};

/** on_conflict condition type for table "qx.ePrivilege" */
export type qx_ePrivilege_on_conflict = {
  constraint: qx_ePrivilege_constraint;
  update_columns?: Array<qx_ePrivilege_update_column>;
  where?: qx_ePrivilege_bool_exp;
};

/** Ordering options when selecting data from "qx.ePrivilege". */
export type qx_ePrivilege_order_by = {
  comment?: order_by;
  toRoles_aggregate?: qx__PrivilegeEnumToRole_aggregate_order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.ePrivilege */
export type qx_ePrivilege_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.ePrivilege" */
export enum qx_ePrivilege_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.ePrivilege" */
export type qx_ePrivilege_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_ePrivilege" */
export type qx_ePrivilege_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_ePrivilege_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_ePrivilege_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.ePrivilege" */
export enum qx_ePrivilege_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_ePrivilege_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_ePrivilege_set_input;
  /** filter the rows which have to be updated */
  where: qx_ePrivilege_bool_exp;
};

/** enum: how a reader grants access (credential only, PIN only, card+PIN dual authentication, etc.) */
export type qx_eReaderAccessType = {
  __typename?: 'qx_eReaderAccessType';
  /** An array relationship */
  ReaderAccessTypeCompatibilities: Array<readerAccessTypeCompatibility>;
  /** An aggregate relationship */
  ReaderAccessTypeCompatibilities_aggregate: readerAccessTypeCompatibility_aggregate;
  comment?: string;
  /** An array relationship */
  readers: Array<qx_Reader>;
  /** An aggregate relationship */
  readers_aggregate: qx_Reader_aggregate;
  value: string;
};


/** enum: how a reader grants access (credential only, PIN only, card+PIN dual authentication, etc.) */
export type qx_eReaderAccessTypeReaderAccessTypeCompatibilitiesArgs = {
  distinct_on?: Array<readerAccessTypeCompatibility_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<readerAccessTypeCompatibility_order_by>;
  where?: readerAccessTypeCompatibility_bool_exp;
};


/** enum: how a reader grants access (credential only, PIN only, card+PIN dual authentication, etc.) */
export type qx_eReaderAccessTypeReaderAccessTypeCompatibilities_aggregateArgs = {
  distinct_on?: Array<readerAccessTypeCompatibility_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<readerAccessTypeCompatibility_order_by>;
  where?: readerAccessTypeCompatibility_bool_exp;
};


/** enum: how a reader grants access (credential only, PIN only, card+PIN dual authentication, etc.) */
export type qx_eReaderAccessTypereadersArgs = {
  distinct_on?: Array<qx_Reader_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Reader_order_by>;
  where?: qx_Reader_bool_exp;
};


/** enum: how a reader grants access (credential only, PIN only, card+PIN dual authentication, etc.) */
export type qx_eReaderAccessTypereaders_aggregateArgs = {
  distinct_on?: Array<qx_Reader_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Reader_order_by>;
  where?: qx_Reader_bool_exp;
};

/** aggregated selection of "qx.eReaderAccessType" */
export type qx_eReaderAccessType_aggregate = {
  __typename?: 'qx_eReaderAccessType_aggregate';
  aggregate?: qx_eReaderAccessType_aggregate_fields;
  nodes: Array<qx_eReaderAccessType>;
};

/** aggregate fields of "qx.eReaderAccessType" */
export type qx_eReaderAccessType_aggregate_fields = {
  __typename?: 'qx_eReaderAccessType_aggregate_fields';
  count: number;
  max?: qx_eReaderAccessType_max_fields;
  min?: qx_eReaderAccessType_min_fields;
};


/** aggregate fields of "qx.eReaderAccessType" */
export type qx_eReaderAccessType_aggregate_fieldscountArgs = {
  columns?: Array<qx_eReaderAccessType_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eReaderAccessType". All fields are combined with a logical 'AND'. */
export type qx_eReaderAccessType_bool_exp = {
  ReaderAccessTypeCompatibilities?: readerAccessTypeCompatibility_bool_exp;
  ReaderAccessTypeCompatibilities_aggregate?: readerAccessTypeCompatibility_aggregate_bool_exp;
  _and?: Array<qx_eReaderAccessType_bool_exp>;
  _not?: qx_eReaderAccessType_bool_exp;
  _or?: Array<qx_eReaderAccessType_bool_exp>;
  comment?: String_comparison_exp;
  readers?: qx_Reader_bool_exp;
  readers_aggregate?: qx_Reader_aggregate_bool_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eReaderAccessType" */
export enum qx_eReaderAccessType_constraint {
  /** unique or primary key constraint on columns "value" */
  eReaderAccessType_pkey = 'eReaderAccessType_pkey'
}

export enum qx_eReaderAccessType_enum {
  /** Card and PIN */
  CardAndPin = 'CardAndPin',
  /** Card Only */
  CardOnly = 'CardOnly',
  /** Card or PIN */
  CardOrPin = 'CardOrPin',
  /** PIN Only */
  PinOnly = 'PinOnly',
  /** Unknown */
  Unknown = 'Unknown'
}

/** Boolean expression to compare columns of type "qx_eReaderAccessType_enum". All fields are combined with logical 'AND'. */
export type qx_eReaderAccessType_enum_comparison_exp = {
  _eq?: qx_eReaderAccessType_enum;
  _in?: Array<qx_eReaderAccessType_enum>;
  _is_null?: boolean;
  _neq?: qx_eReaderAccessType_enum;
  _nin?: Array<qx_eReaderAccessType_enum>;
};

/** input type for inserting data into table "qx.eReaderAccessType" */
export type qx_eReaderAccessType_insert_input = {
  ReaderAccessTypeCompatibilities?: readerAccessTypeCompatibility_arr_rel_insert_input;
  comment?: string;
  readers?: qx_Reader_arr_rel_insert_input;
  value?: string;
};

/** aggregate max on columns */
export type qx_eReaderAccessType_max_fields = {
  __typename?: 'qx_eReaderAccessType_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eReaderAccessType_min_fields = {
  __typename?: 'qx_eReaderAccessType_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eReaderAccessType" */
export type qx_eReaderAccessType_mutation_response = {
  __typename?: 'qx_eReaderAccessType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eReaderAccessType>;
};

/** input type for inserting object relation for remote table "qx.eReaderAccessType" */
export type qx_eReaderAccessType_obj_rel_insert_input = {
  data: qx_eReaderAccessType_insert_input;
  /** upsert condition */
  on_conflict?: qx_eReaderAccessType_on_conflict;
};

/** on_conflict condition type for table "qx.eReaderAccessType" */
export type qx_eReaderAccessType_on_conflict = {
  constraint: qx_eReaderAccessType_constraint;
  update_columns?: Array<qx_eReaderAccessType_update_column>;
  where?: qx_eReaderAccessType_bool_exp;
};

/** Ordering options when selecting data from "qx.eReaderAccessType". */
export type qx_eReaderAccessType_order_by = {
  ReaderAccessTypeCompatibilities_aggregate?: readerAccessTypeCompatibility_aggregate_order_by;
  comment?: order_by;
  readers_aggregate?: qx_Reader_aggregate_order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eReaderAccessType */
export type qx_eReaderAccessType_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eReaderAccessType" */
export enum qx_eReaderAccessType_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eReaderAccessType" */
export type qx_eReaderAccessType_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eReaderAccessType" */
export type qx_eReaderAccessType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eReaderAccessType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eReaderAccessType_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eReaderAccessType" */
export enum qx_eReaderAccessType_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eReaderAccessType_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eReaderAccessType_set_input;
  /** filter the rows which have to be updated */
  where: qx_eReaderAccessType_bool_exp;
};

/** enum: communication protocols used by credential readers (Wiegand, OSDP, RS485, etc.) */
export type qx_eReaderProtocol = {
  __typename?: 'qx_eReaderProtocol';
  /** An array relationship */
  ReaderProtocolCompatibilities: Array<readerProtocolCompatibility>;
  /** An aggregate relationship */
  ReaderProtocolCompatibilities_aggregate: readerProtocolCompatibility_aggregate;
  /** An array relationship */
  Readers: Array<qx_Reader>;
  /** An aggregate relationship */
  Readers_aggregate: qx_Reader_aggregate;
  comment?: string;
  value: string;
};


/** enum: communication protocols used by credential readers (Wiegand, OSDP, RS485, etc.) */
export type qx_eReaderProtocolReaderProtocolCompatibilitiesArgs = {
  distinct_on?: Array<readerProtocolCompatibility_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<readerProtocolCompatibility_order_by>;
  where?: readerProtocolCompatibility_bool_exp;
};


/** enum: communication protocols used by credential readers (Wiegand, OSDP, RS485, etc.) */
export type qx_eReaderProtocolReaderProtocolCompatibilities_aggregateArgs = {
  distinct_on?: Array<readerProtocolCompatibility_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<readerProtocolCompatibility_order_by>;
  where?: readerProtocolCompatibility_bool_exp;
};


/** enum: communication protocols used by credential readers (Wiegand, OSDP, RS485, etc.) */
export type qx_eReaderProtocolReadersArgs = {
  distinct_on?: Array<qx_Reader_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Reader_order_by>;
  where?: qx_Reader_bool_exp;
};


/** enum: communication protocols used by credential readers (Wiegand, OSDP, RS485, etc.) */
export type qx_eReaderProtocolReaders_aggregateArgs = {
  distinct_on?: Array<qx_Reader_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Reader_order_by>;
  where?: qx_Reader_bool_exp;
};

/** aggregated selection of "qx.eReaderProtocol" */
export type qx_eReaderProtocol_aggregate = {
  __typename?: 'qx_eReaderProtocol_aggregate';
  aggregate?: qx_eReaderProtocol_aggregate_fields;
  nodes: Array<qx_eReaderProtocol>;
};

/** aggregate fields of "qx.eReaderProtocol" */
export type qx_eReaderProtocol_aggregate_fields = {
  __typename?: 'qx_eReaderProtocol_aggregate_fields';
  count: number;
  max?: qx_eReaderProtocol_max_fields;
  min?: qx_eReaderProtocol_min_fields;
};


/** aggregate fields of "qx.eReaderProtocol" */
export type qx_eReaderProtocol_aggregate_fieldscountArgs = {
  columns?: Array<qx_eReaderProtocol_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eReaderProtocol". All fields are combined with a logical 'AND'. */
export type qx_eReaderProtocol_bool_exp = {
  ReaderProtocolCompatibilities?: readerProtocolCompatibility_bool_exp;
  ReaderProtocolCompatibilities_aggregate?: readerProtocolCompatibility_aggregate_bool_exp;
  Readers?: qx_Reader_bool_exp;
  Readers_aggregate?: qx_Reader_aggregate_bool_exp;
  _and?: Array<qx_eReaderProtocol_bool_exp>;
  _not?: qx_eReaderProtocol_bool_exp;
  _or?: Array<qx_eReaderProtocol_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eReaderProtocol" */
export enum qx_eReaderProtocol_constraint {
  /** unique or primary key constraint on columns "value" */
  eReaderProtocol_pkey = 'eReaderProtocol_pkey'
}

export enum qx_eReaderProtocol_enum {
  /** Aperio */
  Aperio = 'Aperio',
  /** OSDP */
  OSDP = 'OSDP',
  /** Standard */
  Standard = 'Standard',
  /** Standard (no facility code) */
  StandardNoFC = 'StandardNoFC',
  /** Unknown */
  Unknown = 'Unknown',
  /** Wiegand */
  Wiegand = 'Wiegand',
  /** Wiegand-0 */
  Wiegand0 = 'Wiegand0'
}

/** Boolean expression to compare columns of type "qx_eReaderProtocol_enum". All fields are combined with logical 'AND'. */
export type qx_eReaderProtocol_enum_comparison_exp = {
  _eq?: qx_eReaderProtocol_enum;
  _in?: Array<qx_eReaderProtocol_enum>;
  _is_null?: boolean;
  _neq?: qx_eReaderProtocol_enum;
  _nin?: Array<qx_eReaderProtocol_enum>;
};

/** input type for inserting data into table "qx.eReaderProtocol" */
export type qx_eReaderProtocol_insert_input = {
  ReaderProtocolCompatibilities?: readerProtocolCompatibility_arr_rel_insert_input;
  Readers?: qx_Reader_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eReaderProtocol_max_fields = {
  __typename?: 'qx_eReaderProtocol_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eReaderProtocol_min_fields = {
  __typename?: 'qx_eReaderProtocol_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eReaderProtocol" */
export type qx_eReaderProtocol_mutation_response = {
  __typename?: 'qx_eReaderProtocol_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eReaderProtocol>;
};

/** input type for inserting object relation for remote table "qx.eReaderProtocol" */
export type qx_eReaderProtocol_obj_rel_insert_input = {
  data: qx_eReaderProtocol_insert_input;
  /** upsert condition */
  on_conflict?: qx_eReaderProtocol_on_conflict;
};

/** on_conflict condition type for table "qx.eReaderProtocol" */
export type qx_eReaderProtocol_on_conflict = {
  constraint: qx_eReaderProtocol_constraint;
  update_columns?: Array<qx_eReaderProtocol_update_column>;
  where?: qx_eReaderProtocol_bool_exp;
};

/** Ordering options when selecting data from "qx.eReaderProtocol". */
export type qx_eReaderProtocol_order_by = {
  ReaderProtocolCompatibilities_aggregate?: readerProtocolCompatibility_aggregate_order_by;
  Readers_aggregate?: qx_Reader_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eReaderProtocol */
export type qx_eReaderProtocol_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eReaderProtocol" */
export enum qx_eReaderProtocol_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eReaderProtocol" */
export type qx_eReaderProtocol_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eReaderProtocol" */
export type qx_eReaderProtocol_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eReaderProtocol_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eReaderProtocol_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eReaderProtocol" */
export enum qx_eReaderProtocol_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eReaderProtocol_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eReaderProtocol_set_input;
  /** filter the rows which have to be updated */
  where: qx_eReaderProtocol_bool_exp;
};

/** enum: Request to Exit (REX) sensor activation states (inactive, active) */
export type qx_eRexState = {
  __typename?: 'qx_eRexState';
  /** An array relationship */
  Readers: Array<qx_Reader>;
  /** An aggregate relationship */
  Readers_aggregate: qx_Reader_aggregate;
  comment?: string;
  value: string;
};


/** enum: Request to Exit (REX) sensor activation states (inactive, active) */
export type qx_eRexStateReadersArgs = {
  distinct_on?: Array<qx_Reader_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Reader_order_by>;
  where?: qx_Reader_bool_exp;
};


/** enum: Request to Exit (REX) sensor activation states (inactive, active) */
export type qx_eRexStateReaders_aggregateArgs = {
  distinct_on?: Array<qx_Reader_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Reader_order_by>;
  where?: qx_Reader_bool_exp;
};

/** aggregated selection of "qx.eRexState" */
export type qx_eRexState_aggregate = {
  __typename?: 'qx_eRexState_aggregate';
  aggregate?: qx_eRexState_aggregate_fields;
  nodes: Array<qx_eRexState>;
};

/** aggregate fields of "qx.eRexState" */
export type qx_eRexState_aggregate_fields = {
  __typename?: 'qx_eRexState_aggregate_fields';
  count: number;
  max?: qx_eRexState_max_fields;
  min?: qx_eRexState_min_fields;
};


/** aggregate fields of "qx.eRexState" */
export type qx_eRexState_aggregate_fieldscountArgs = {
  columns?: Array<qx_eRexState_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eRexState". All fields are combined with a logical 'AND'. */
export type qx_eRexState_bool_exp = {
  Readers?: qx_Reader_bool_exp;
  Readers_aggregate?: qx_Reader_aggregate_bool_exp;
  _and?: Array<qx_eRexState_bool_exp>;
  _not?: qx_eRexState_bool_exp;
  _or?: Array<qx_eRexState_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eRexState" */
export enum qx_eRexState_constraint {
  /** unique or primary key constraint on columns "value" */
  eRexState_pkey = 'eRexState_pkey'
}

export enum qx_eRexState_enum {
  /** Normally Closed */
  NormallyClosed = 'NormallyClosed',
  /** Normally Open */
  NormallyOpen = 'NormallyOpen',
  /** Unknown */
  Unknown = 'Unknown'
}

/** Boolean expression to compare columns of type "qx_eRexState_enum". All fields are combined with logical 'AND'. */
export type qx_eRexState_enum_comparison_exp = {
  _eq?: qx_eRexState_enum;
  _in?: Array<qx_eRexState_enum>;
  _is_null?: boolean;
  _neq?: qx_eRexState_enum;
  _nin?: Array<qx_eRexState_enum>;
};

/** input type for inserting data into table "qx.eRexState" */
export type qx_eRexState_insert_input = {
  Readers?: qx_Reader_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eRexState_max_fields = {
  __typename?: 'qx_eRexState_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eRexState_min_fields = {
  __typename?: 'qx_eRexState_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eRexState" */
export type qx_eRexState_mutation_response = {
  __typename?: 'qx_eRexState_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eRexState>;
};

/** input type for inserting object relation for remote table "qx.eRexState" */
export type qx_eRexState_obj_rel_insert_input = {
  data: qx_eRexState_insert_input;
  /** upsert condition */
  on_conflict?: qx_eRexState_on_conflict;
};

/** on_conflict condition type for table "qx.eRexState" */
export type qx_eRexState_on_conflict = {
  constraint: qx_eRexState_constraint;
  update_columns?: Array<qx_eRexState_update_column>;
  where?: qx_eRexState_bool_exp;
};

/** Ordering options when selecting data from "qx.eRexState". */
export type qx_eRexState_order_by = {
  Readers_aggregate?: qx_Reader_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eRexState */
export type qx_eRexState_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eRexState" */
export enum qx_eRexState_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eRexState" */
export type qx_eRexState_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eRexState" */
export type qx_eRexState_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eRexState_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eRexState_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eRexState" */
export enum qx_eRexState_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eRexState_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eRexState_set_input;
  /** filter the rows which have to be updated */
  where: qx_eRexState_bool_exp;
};

/** enum: trigger actions that can be configured to fire when a sensor activates */
export type qx_eSensorAction = {
  __typename?: 'qx_eSensorAction';
  comment?: string;
  /** An array relationship */
  devices: Array<qx_Event>;
  /** An aggregate relationship */
  devices_aggregate: qx_Event_aggregate;
  value: string;
};


/** enum: trigger actions that can be configured to fire when a sensor activates */
export type qx_eSensorActiondevicesArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};


/** enum: trigger actions that can be configured to fire when a sensor activates */
export type qx_eSensorActiondevices_aggregateArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};

/** aggregated selection of "qx.eSensorAction" */
export type qx_eSensorAction_aggregate = {
  __typename?: 'qx_eSensorAction_aggregate';
  aggregate?: qx_eSensorAction_aggregate_fields;
  nodes: Array<qx_eSensorAction>;
};

/** aggregate fields of "qx.eSensorAction" */
export type qx_eSensorAction_aggregate_fields = {
  __typename?: 'qx_eSensorAction_aggregate_fields';
  count: number;
  max?: qx_eSensorAction_max_fields;
  min?: qx_eSensorAction_min_fields;
};


/** aggregate fields of "qx.eSensorAction" */
export type qx_eSensorAction_aggregate_fieldscountArgs = {
  columns?: Array<qx_eSensorAction_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eSensorAction". All fields are combined with a logical 'AND'. */
export type qx_eSensorAction_bool_exp = {
  _and?: Array<qx_eSensorAction_bool_exp>;
  _not?: qx_eSensorAction_bool_exp;
  _or?: Array<qx_eSensorAction_bool_exp>;
  comment?: String_comparison_exp;
  devices?: qx_Event_bool_exp;
  devices_aggregate?: qx_Event_aggregate_bool_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eSensorAction" */
export enum qx_eSensorAction_constraint {
  /** unique or primary key constraint on columns "value" */
  eSensorAction_pkey = 'eSensorAction_pkey'
}

/** input type for inserting data into table "qx.eSensorAction" */
export type qx_eSensorAction_insert_input = {
  comment?: string;
  devices?: qx_Event_arr_rel_insert_input;
  value?: string;
};

/** aggregate max on columns */
export type qx_eSensorAction_max_fields = {
  __typename?: 'qx_eSensorAction_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eSensorAction_min_fields = {
  __typename?: 'qx_eSensorAction_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eSensorAction" */
export type qx_eSensorAction_mutation_response = {
  __typename?: 'qx_eSensorAction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eSensorAction>;
};

/** on_conflict condition type for table "qx.eSensorAction" */
export type qx_eSensorAction_on_conflict = {
  constraint: qx_eSensorAction_constraint;
  update_columns?: Array<qx_eSensorAction_update_column>;
  where?: qx_eSensorAction_bool_exp;
};

/** Ordering options when selecting data from "qx.eSensorAction". */
export type qx_eSensorAction_order_by = {
  comment?: order_by;
  devices_aggregate?: qx_Event_aggregate_order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eSensorAction */
export type qx_eSensorAction_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eSensorAction" */
export enum qx_eSensorAction_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eSensorAction" */
export type qx_eSensorAction_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eSensorAction" */
export type qx_eSensorAction_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eSensorAction_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eSensorAction_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eSensorAction" */
export enum qx_eSensorAction_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eSensorAction_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eSensorAction_set_input;
  /** filter the rows which have to be updated */
  where: qx_eSensorAction_bool_exp;
};

/** enum: physical types of sensors (motion, door contact, temperature, smoke, etc.) */
export type qx_eSensorType = {
  __typename?: 'qx_eSensorType';
  /** An array relationship */
  Sensors: Array<qx_Sensor>;
  /** An aggregate relationship */
  Sensors_aggregate: qx_Sensor_aggregate;
  comment?: string;
  value: string;
};


/** enum: physical types of sensors (motion, door contact, temperature, smoke, etc.) */
export type qx_eSensorTypeSensorsArgs = {
  distinct_on?: Array<qx_Sensor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Sensor_order_by>;
  where?: qx_Sensor_bool_exp;
};


/** enum: physical types of sensors (motion, door contact, temperature, smoke, etc.) */
export type qx_eSensorTypeSensors_aggregateArgs = {
  distinct_on?: Array<qx_Sensor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Sensor_order_by>;
  where?: qx_Sensor_bool_exp;
};

/** aggregated selection of "qx.eSensorType" */
export type qx_eSensorType_aggregate = {
  __typename?: 'qx_eSensorType_aggregate';
  aggregate?: qx_eSensorType_aggregate_fields;
  nodes: Array<qx_eSensorType>;
};

/** aggregate fields of "qx.eSensorType" */
export type qx_eSensorType_aggregate_fields = {
  __typename?: 'qx_eSensorType_aggregate_fields';
  count: number;
  max?: qx_eSensorType_max_fields;
  min?: qx_eSensorType_min_fields;
};


/** aggregate fields of "qx.eSensorType" */
export type qx_eSensorType_aggregate_fieldscountArgs = {
  columns?: Array<qx_eSensorType_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eSensorType". All fields are combined with a logical 'AND'. */
export type qx_eSensorType_bool_exp = {
  Sensors?: qx_Sensor_bool_exp;
  Sensors_aggregate?: qx_Sensor_aggregate_bool_exp;
  _and?: Array<qx_eSensorType_bool_exp>;
  _not?: qx_eSensorType_bool_exp;
  _or?: Array<qx_eSensorType_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eSensorType" */
export enum qx_eSensorType_constraint {
  /** unique or primary key constraint on columns "value" */
  eSensorType_pkey = 'eSensorType_pkey'
}

export enum qx_eSensorType_enum {
  /** Humidity */
  Humidity = 'Humidity',
  /** Occupancy */
  Occupancy = 'Occupancy',
  /** Open Close */
  OpenClose = 'OpenClose',
  /** Panic Button */
  PanicButton = 'PanicButton',
  /** Smart Sensor */
  SmartSensor = 'SmartSensor',
  /** Temperature */
  Temperature = 'Temperature',
  /** Unknown */
  Unknown = 'Unknown',
  /** Water Leak */
  WaterLeak = 'WaterLeak'
}

/** Boolean expression to compare columns of type "qx_eSensorType_enum". All fields are combined with logical 'AND'. */
export type qx_eSensorType_enum_comparison_exp = {
  _eq?: qx_eSensorType_enum;
  _in?: Array<qx_eSensorType_enum>;
  _is_null?: boolean;
  _neq?: qx_eSensorType_enum;
  _nin?: Array<qx_eSensorType_enum>;
};

/** input type for inserting data into table "qx.eSensorType" */
export type qx_eSensorType_insert_input = {
  Sensors?: qx_Sensor_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eSensorType_max_fields = {
  __typename?: 'qx_eSensorType_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eSensorType_min_fields = {
  __typename?: 'qx_eSensorType_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eSensorType" */
export type qx_eSensorType_mutation_response = {
  __typename?: 'qx_eSensorType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eSensorType>;
};

/** input type for inserting object relation for remote table "qx.eSensorType" */
export type qx_eSensorType_obj_rel_insert_input = {
  data: qx_eSensorType_insert_input;
  /** upsert condition */
  on_conflict?: qx_eSensorType_on_conflict;
};

/** on_conflict condition type for table "qx.eSensorType" */
export type qx_eSensorType_on_conflict = {
  constraint: qx_eSensorType_constraint;
  update_columns?: Array<qx_eSensorType_update_column>;
  where?: qx_eSensorType_bool_exp;
};

/** Ordering options when selecting data from "qx.eSensorType". */
export type qx_eSensorType_order_by = {
  Sensors_aggregate?: qx_Sensor_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eSensorType */
export type qx_eSensorType_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eSensorType" */
export enum qx_eSensorType_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eSensorType" */
export type qx_eSensorType_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eSensorType" */
export type qx_eSensorType_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eSensorType_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eSensorType_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eSensorType" */
export enum qx_eSensorType_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eSensorType_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eSensorType_set_input;
  /** filter the rows which have to be updated */
  where: qx_eSensorType_bool_exp;
};

/** enum: live video stream availability states (streaming, offline, error, etc.) */
export type qx_eStreamStatus = {
  __typename?: 'qx_eStreamStatus';
  comment?: string;
  /** An array relationship */
  mediaProfiles: Array<qx_MediaProfile>;
  /** An aggregate relationship */
  mediaProfiles_aggregate: qx_MediaProfile_aggregate;
  value: string;
};


/** enum: live video stream availability states (streaming, offline, error, etc.) */
export type qx_eStreamStatusmediaProfilesArgs = {
  distinct_on?: Array<qx_MediaProfile_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MediaProfile_order_by>;
  where?: qx_MediaProfile_bool_exp;
};


/** enum: live video stream availability states (streaming, offline, error, etc.) */
export type qx_eStreamStatusmediaProfiles_aggregateArgs = {
  distinct_on?: Array<qx_MediaProfile_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MediaProfile_order_by>;
  where?: qx_MediaProfile_bool_exp;
};

/** aggregated selection of "qx.eStreamStatus" */
export type qx_eStreamStatus_aggregate = {
  __typename?: 'qx_eStreamStatus_aggregate';
  aggregate?: qx_eStreamStatus_aggregate_fields;
  nodes: Array<qx_eStreamStatus>;
};

/** aggregate fields of "qx.eStreamStatus" */
export type qx_eStreamStatus_aggregate_fields = {
  __typename?: 'qx_eStreamStatus_aggregate_fields';
  count: number;
  max?: qx_eStreamStatus_max_fields;
  min?: qx_eStreamStatus_min_fields;
};


/** aggregate fields of "qx.eStreamStatus" */
export type qx_eStreamStatus_aggregate_fieldscountArgs = {
  columns?: Array<qx_eStreamStatus_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eStreamStatus". All fields are combined with a logical 'AND'. */
export type qx_eStreamStatus_bool_exp = {
  _and?: Array<qx_eStreamStatus_bool_exp>;
  _not?: qx_eStreamStatus_bool_exp;
  _or?: Array<qx_eStreamStatus_bool_exp>;
  comment?: String_comparison_exp;
  mediaProfiles?: qx_MediaProfile_bool_exp;
  mediaProfiles_aggregate?: qx_MediaProfile_aggregate_bool_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eStreamStatus" */
export enum qx_eStreamStatus_constraint {
  /** unique or primary key constraint on columns "value" */
  eStreamStatus_pkey = 'eStreamStatus_pkey'
}

export enum qx_eStreamStatus_enum {
  /** Connected */
  Connected = 'Connected',
  /** Connecting */
  Connecting = 'Connecting',
  /** Disconnected */
  Disconnected = 'Disconnected',
  /** Invalid Credentials */
  InvalidCredentials = 'InvalidCredentials',
  /** Not Supported */
  NotSupported = 'NotSupported',
  /** Stream Has Not Recieved Data for a Long Time */
  Timeout = 'Timeout',
  /** Unknown */
  Unknown = 'Unknown',
  /** Write Failed */
  WriteFailed = 'WriteFailed'
}

/** Boolean expression to compare columns of type "qx_eStreamStatus_enum". All fields are combined with logical 'AND'. */
export type qx_eStreamStatus_enum_comparison_exp = {
  _eq?: qx_eStreamStatus_enum;
  _in?: Array<qx_eStreamStatus_enum>;
  _is_null?: boolean;
  _neq?: qx_eStreamStatus_enum;
  _nin?: Array<qx_eStreamStatus_enum>;
};

/** input type for inserting data into table "qx.eStreamStatus" */
export type qx_eStreamStatus_insert_input = {
  comment?: string;
  mediaProfiles?: qx_MediaProfile_arr_rel_insert_input;
  value?: string;
};

/** aggregate max on columns */
export type qx_eStreamStatus_max_fields = {
  __typename?: 'qx_eStreamStatus_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eStreamStatus_min_fields = {
  __typename?: 'qx_eStreamStatus_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eStreamStatus" */
export type qx_eStreamStatus_mutation_response = {
  __typename?: 'qx_eStreamStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eStreamStatus>;
};

/** input type for inserting object relation for remote table "qx.eStreamStatus" */
export type qx_eStreamStatus_obj_rel_insert_input = {
  data: qx_eStreamStatus_insert_input;
  /** upsert condition */
  on_conflict?: qx_eStreamStatus_on_conflict;
};

/** on_conflict condition type for table "qx.eStreamStatus" */
export type qx_eStreamStatus_on_conflict = {
  constraint: qx_eStreamStatus_constraint;
  update_columns?: Array<qx_eStreamStatus_update_column>;
  where?: qx_eStreamStatus_bool_exp;
};

/** Ordering options when selecting data from "qx.eStreamStatus". */
export type qx_eStreamStatus_order_by = {
  comment?: order_by;
  mediaProfiles_aggregate?: qx_MediaProfile_aggregate_order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eStreamStatus */
export type qx_eStreamStatus_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eStreamStatus" */
export enum qx_eStreamStatus_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eStreamStatus" */
export type qx_eStreamStatus_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eStreamStatus" */
export type qx_eStreamStatus_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eStreamStatus_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eStreamStatus_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eStreamStatus" */
export enum qx_eStreamStatus_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eStreamStatus_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eStreamStatus_set_input;
  /** filter the rows which have to be updated */
  where: qx_eStreamStatus_bool_exp;
};

/** enum: electrical supervision modes for input points, enabling tamper detection via end-of-line resistors (none, EOL, double EOL) */
export type qx_eSuperviseInputs = {
  __typename?: 'qx_eSuperviseInputs';
  /** An array relationship */
  DeviceDIOs: Array<qx_DeviceDIO>;
  /** An aggregate relationship */
  DeviceDIOs_aggregate: qx_DeviceDIO_aggregate;
  /** An array relationship */
  SuperviseInputCompatibilities: Array<superviseInputCompatibility>;
  /** An aggregate relationship */
  SuperviseInputCompatibilities_aggregate: superviseInputCompatibility_aggregate;
  comment?: string;
  value: string;
};


/** enum: electrical supervision modes for input points, enabling tamper detection via end-of-line resistors (none, EOL, double EOL) */
export type qx_eSuperviseInputsDeviceDIOsArgs = {
  distinct_on?: Array<qx_DeviceDIO_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DeviceDIO_order_by>;
  where?: qx_DeviceDIO_bool_exp;
};


/** enum: electrical supervision modes for input points, enabling tamper detection via end-of-line resistors (none, EOL, double EOL) */
export type qx_eSuperviseInputsDeviceDIOs_aggregateArgs = {
  distinct_on?: Array<qx_DeviceDIO_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DeviceDIO_order_by>;
  where?: qx_DeviceDIO_bool_exp;
};


/** enum: electrical supervision modes for input points, enabling tamper detection via end-of-line resistors (none, EOL, double EOL) */
export type qx_eSuperviseInputsSuperviseInputCompatibilitiesArgs = {
  distinct_on?: Array<superviseInputCompatibility_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<superviseInputCompatibility_order_by>;
  where?: superviseInputCompatibility_bool_exp;
};


/** enum: electrical supervision modes for input points, enabling tamper detection via end-of-line resistors (none, EOL, double EOL) */
export type qx_eSuperviseInputsSuperviseInputCompatibilities_aggregateArgs = {
  distinct_on?: Array<superviseInputCompatibility_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<superviseInputCompatibility_order_by>;
  where?: superviseInputCompatibility_bool_exp;
};

/** aggregated selection of "qx.eSuperviseInputs" */
export type qx_eSuperviseInputs_aggregate = {
  __typename?: 'qx_eSuperviseInputs_aggregate';
  aggregate?: qx_eSuperviseInputs_aggregate_fields;
  nodes: Array<qx_eSuperviseInputs>;
};

/** aggregate fields of "qx.eSuperviseInputs" */
export type qx_eSuperviseInputs_aggregate_fields = {
  __typename?: 'qx_eSuperviseInputs_aggregate_fields';
  count: number;
  max?: qx_eSuperviseInputs_max_fields;
  min?: qx_eSuperviseInputs_min_fields;
};


/** aggregate fields of "qx.eSuperviseInputs" */
export type qx_eSuperviseInputs_aggregate_fieldscountArgs = {
  columns?: Array<qx_eSuperviseInputs_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.eSuperviseInputs". All fields are combined with a logical 'AND'. */
export type qx_eSuperviseInputs_bool_exp = {
  DeviceDIOs?: qx_DeviceDIO_bool_exp;
  DeviceDIOs_aggregate?: qx_DeviceDIO_aggregate_bool_exp;
  SuperviseInputCompatibilities?: superviseInputCompatibility_bool_exp;
  SuperviseInputCompatibilities_aggregate?: superviseInputCompatibility_aggregate_bool_exp;
  _and?: Array<qx_eSuperviseInputs_bool_exp>;
  _not?: qx_eSuperviseInputs_bool_exp;
  _or?: Array<qx_eSuperviseInputs_bool_exp>;
  comment?: String_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.eSuperviseInputs" */
export enum qx_eSuperviseInputs_constraint {
  /** unique or primary key constraint on columns "value" */
  eSuperviseInputs_pkey = 'eSuperviseInputs_pkey'
}

export enum qx_eSuperviseInputs_enum {
  /** None */
  None = 'None',
  /** 4-State 1K */
  Normal1K = 'Normal1K',
  /** 4-State 2K */
  Normal2K = 'Normal2K',
  /** 4-State 5K */
  Normal5K = 'Normal5K',
  /** 4-State 10K */
  Normal10K = 'Normal10K',
  /** 1 Resistor */
  Resistors1 = 'Resistors1',
  /** 2 Resistors */
  Resistors2 = 'Resistors2',
  /** 3-State 1K */
  Tristate1K = 'Tristate1K',
  /** 3-State 2K */
  Tristate2K = 'Tristate2K',
  /** 3-State 5K */
  Tristate5K = 'Tristate5K',
  /** 3-State 10K */
  Tristate10K = 'Tristate10K'
}

/** Boolean expression to compare columns of type "qx_eSuperviseInputs_enum". All fields are combined with logical 'AND'. */
export type qx_eSuperviseInputs_enum_comparison_exp = {
  _eq?: qx_eSuperviseInputs_enum;
  _in?: Array<qx_eSuperviseInputs_enum>;
  _is_null?: boolean;
  _neq?: qx_eSuperviseInputs_enum;
  _nin?: Array<qx_eSuperviseInputs_enum>;
};

/** input type for inserting data into table "qx.eSuperviseInputs" */
export type qx_eSuperviseInputs_insert_input = {
  DeviceDIOs?: qx_DeviceDIO_arr_rel_insert_input;
  SuperviseInputCompatibilities?: superviseInputCompatibility_arr_rel_insert_input;
  comment?: string;
  value?: string;
};

/** aggregate max on columns */
export type qx_eSuperviseInputs_max_fields = {
  __typename?: 'qx_eSuperviseInputs_max_fields';
  comment?: string;
  value?: string;
};

/** aggregate min on columns */
export type qx_eSuperviseInputs_min_fields = {
  __typename?: 'qx_eSuperviseInputs_min_fields';
  comment?: string;
  value?: string;
};

/** response of any mutation on the table "qx.eSuperviseInputs" */
export type qx_eSuperviseInputs_mutation_response = {
  __typename?: 'qx_eSuperviseInputs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_eSuperviseInputs>;
};

/** input type for inserting object relation for remote table "qx.eSuperviseInputs" */
export type qx_eSuperviseInputs_obj_rel_insert_input = {
  data: qx_eSuperviseInputs_insert_input;
  /** upsert condition */
  on_conflict?: qx_eSuperviseInputs_on_conflict;
};

/** on_conflict condition type for table "qx.eSuperviseInputs" */
export type qx_eSuperviseInputs_on_conflict = {
  constraint: qx_eSuperviseInputs_constraint;
  update_columns?: Array<qx_eSuperviseInputs_update_column>;
  where?: qx_eSuperviseInputs_bool_exp;
};

/** Ordering options when selecting data from "qx.eSuperviseInputs". */
export type qx_eSuperviseInputs_order_by = {
  DeviceDIOs_aggregate?: qx_DeviceDIO_aggregate_order_by;
  SuperviseInputCompatibilities_aggregate?: superviseInputCompatibility_aggregate_order_by;
  comment?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.eSuperviseInputs */
export type qx_eSuperviseInputs_pk_columns_input = {
  value: string;
};

/** select columns of table "qx.eSuperviseInputs" */
export enum qx_eSuperviseInputs_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.eSuperviseInputs" */
export type qx_eSuperviseInputs_set_input = {
  comment?: string;
  value?: string;
};

/** Streaming cursor of the table "qx_eSuperviseInputs" */
export type qx_eSuperviseInputs_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_eSuperviseInputs_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_eSuperviseInputs_stream_cursor_value_input = {
  comment?: string;
  value?: string;
};

/** update columns of table "qx.eSuperviseInputs" */
export enum qx_eSuperviseInputs_update_column {
  /** column name */
  comment = 'comment',
  /** column name */
  value = 'value'
}

export type qx_eSuperviseInputs_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_eSuperviseInputs_set_input;
  /** filter the rows which have to be updated */
  where: qx_eSuperviseInputs_bool_exp;
};

export type qx_event_type_status_values_args = {
  et?: qx_Event;
};

export type qx_events_by_hour_args = {
  currentPath?: string;
  hoursToGet?: number;
};

export type qx_find_credential_from_place_args = {
  credentialid?: string;
  eventplaceid?: string;
};

export type qx_media_profile_oldest_media_args = {
  profile?: qx_MediaProfile;
};

export type qx_place_hierarchy_args = {
  hasura_session?: any;
  place?: qx_Place;
};

export type qx_search_segments_args = {
  deviceID?: string;
  refID?: string;
  videoEnd?: string;
  videoSourceID?: string;
  videoStart?: string;
};

export type qx_search_snapshots_args = {
  videoEnd?: string;
  videoSourceID?: string;
  videoStart?: string;
};

export type qx_search_timeline_args = {
  currentPath?: string;
  doorIDs?: any;
  endDateTime?: string;
  localTimeZone?: string;
  mustHaveVideo?: string;
  personIDs?: any;
  placeIDs?: any;
  startDateTime?: string;
  statuses?: any;
  timeInterval?: number;
  timezoneOffset?: number;
  types?: any;
  videoSourceIDs?: any;
};

/** columns and relationships of "qx.vChatBillingByModel" */
export type qx_vChatBillingByModel = {
  __typename?: 'qx_vChatBillingByModel';
  actualCostCents?: string;
  billableTokens?: string;
  billingPeriodStart?: string;
  billingTier?: string;
  cachedInputTokens?: string;
  costCents?: string;
  inputTokens?: string;
  model?: string;
  outputTokens?: string;
  overageTokens?: string;
  /** An object relationship */
  place?: qx_Place;
  placeId?: string;
  prompts?: string;
};

/** aggregated selection of "qx.vChatBillingByModel" */
export type qx_vChatBillingByModel_aggregate = {
  __typename?: 'qx_vChatBillingByModel_aggregate';
  aggregate?: qx_vChatBillingByModel_aggregate_fields;
  nodes: Array<qx_vChatBillingByModel>;
};

/** aggregate fields of "qx.vChatBillingByModel" */
export type qx_vChatBillingByModel_aggregate_fields = {
  __typename?: 'qx_vChatBillingByModel_aggregate_fields';
  avg?: qx_vChatBillingByModel_avg_fields;
  count: number;
  max?: qx_vChatBillingByModel_max_fields;
  min?: qx_vChatBillingByModel_min_fields;
  stddev?: qx_vChatBillingByModel_stddev_fields;
  stddev_pop?: qx_vChatBillingByModel_stddev_pop_fields;
  stddev_samp?: qx_vChatBillingByModel_stddev_samp_fields;
  sum?: qx_vChatBillingByModel_sum_fields;
  var_pop?: qx_vChatBillingByModel_var_pop_fields;
  var_samp?: qx_vChatBillingByModel_var_samp_fields;
  variance?: qx_vChatBillingByModel_variance_fields;
};


/** aggregate fields of "qx.vChatBillingByModel" */
export type qx_vChatBillingByModel_aggregate_fieldscountArgs = {
  columns?: Array<qx_vChatBillingByModel_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type qx_vChatBillingByModel_avg_fields = {
  __typename?: 'qx_vChatBillingByModel_avg_fields';
  actualCostCents?: number;
  billableTokens?: number;
  cachedInputTokens?: number;
  costCents?: number;
  inputTokens?: number;
  outputTokens?: number;
  overageTokens?: number;
  prompts?: number;
};

/** Boolean expression to filter rows from the table "qx.vChatBillingByModel". All fields are combined with a logical 'AND'. */
export type qx_vChatBillingByModel_bool_exp = {
  _and?: Array<qx_vChatBillingByModel_bool_exp>;
  _not?: qx_vChatBillingByModel_bool_exp;
  _or?: Array<qx_vChatBillingByModel_bool_exp>;
  actualCostCents?: bigint_comparison_exp;
  billableTokens?: bigint_comparison_exp;
  billingPeriodStart?: date_comparison_exp;
  billingTier?: String_comparison_exp;
  cachedInputTokens?: bigint_comparison_exp;
  costCents?: bigint_comparison_exp;
  inputTokens?: bigint_comparison_exp;
  model?: String_comparison_exp;
  outputTokens?: bigint_comparison_exp;
  overageTokens?: bigint_comparison_exp;
  place?: qx_Place_bool_exp;
  placeId?: String_comparison_exp;
  prompts?: bigint_comparison_exp;
};

/** aggregate max on columns */
export type qx_vChatBillingByModel_max_fields = {
  __typename?: 'qx_vChatBillingByModel_max_fields';
  actualCostCents?: string;
  billableTokens?: string;
  billingPeriodStart?: string;
  billingTier?: string;
  cachedInputTokens?: string;
  costCents?: string;
  inputTokens?: string;
  model?: string;
  outputTokens?: string;
  overageTokens?: string;
  placeId?: string;
  prompts?: string;
};

/** aggregate min on columns */
export type qx_vChatBillingByModel_min_fields = {
  __typename?: 'qx_vChatBillingByModel_min_fields';
  actualCostCents?: string;
  billableTokens?: string;
  billingPeriodStart?: string;
  billingTier?: string;
  cachedInputTokens?: string;
  costCents?: string;
  inputTokens?: string;
  model?: string;
  outputTokens?: string;
  overageTokens?: string;
  placeId?: string;
  prompts?: string;
};

/** Ordering options when selecting data from "qx.vChatBillingByModel". */
export type qx_vChatBillingByModel_order_by = {
  actualCostCents?: order_by;
  billableTokens?: order_by;
  billingPeriodStart?: order_by;
  billingTier?: order_by;
  cachedInputTokens?: order_by;
  costCents?: order_by;
  inputTokens?: order_by;
  model?: order_by;
  outputTokens?: order_by;
  overageTokens?: order_by;
  place?: qx_Place_order_by;
  placeId?: order_by;
  prompts?: order_by;
};

/** select columns of table "qx.vChatBillingByModel" */
export enum qx_vChatBillingByModel_select_column {
  /** column name */
  actualCostCents = 'actualCostCents',
  /** column name */
  billableTokens = 'billableTokens',
  /** column name */
  billingPeriodStart = 'billingPeriodStart',
  /** column name */
  billingTier = 'billingTier',
  /** column name */
  cachedInputTokens = 'cachedInputTokens',
  /** column name */
  costCents = 'costCents',
  /** column name */
  inputTokens = 'inputTokens',
  /** column name */
  model = 'model',
  /** column name */
  outputTokens = 'outputTokens',
  /** column name */
  overageTokens = 'overageTokens',
  /** column name */
  placeId = 'placeId',
  /** column name */
  prompts = 'prompts'
}

/** aggregate stddev on columns */
export type qx_vChatBillingByModel_stddev_fields = {
  __typename?: 'qx_vChatBillingByModel_stddev_fields';
  actualCostCents?: number;
  billableTokens?: number;
  cachedInputTokens?: number;
  costCents?: number;
  inputTokens?: number;
  outputTokens?: number;
  overageTokens?: number;
  prompts?: number;
};

/** aggregate stddev_pop on columns */
export type qx_vChatBillingByModel_stddev_pop_fields = {
  __typename?: 'qx_vChatBillingByModel_stddev_pop_fields';
  actualCostCents?: number;
  billableTokens?: number;
  cachedInputTokens?: number;
  costCents?: number;
  inputTokens?: number;
  outputTokens?: number;
  overageTokens?: number;
  prompts?: number;
};

/** aggregate stddev_samp on columns */
export type qx_vChatBillingByModel_stddev_samp_fields = {
  __typename?: 'qx_vChatBillingByModel_stddev_samp_fields';
  actualCostCents?: number;
  billableTokens?: number;
  cachedInputTokens?: number;
  costCents?: number;
  inputTokens?: number;
  outputTokens?: number;
  overageTokens?: number;
  prompts?: number;
};

/** Streaming cursor of the table "qx_vChatBillingByModel" */
export type qx_vChatBillingByModel_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_vChatBillingByModel_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_vChatBillingByModel_stream_cursor_value_input = {
  actualCostCents?: string;
  billableTokens?: string;
  billingPeriodStart?: string;
  billingTier?: string;
  cachedInputTokens?: string;
  costCents?: string;
  inputTokens?: string;
  model?: string;
  outputTokens?: string;
  overageTokens?: string;
  placeId?: string;
  prompts?: string;
};

/** aggregate sum on columns */
export type qx_vChatBillingByModel_sum_fields = {
  __typename?: 'qx_vChatBillingByModel_sum_fields';
  actualCostCents?: string;
  billableTokens?: string;
  cachedInputTokens?: string;
  costCents?: string;
  inputTokens?: string;
  outputTokens?: string;
  overageTokens?: string;
  prompts?: string;
};

/** aggregate var_pop on columns */
export type qx_vChatBillingByModel_var_pop_fields = {
  __typename?: 'qx_vChatBillingByModel_var_pop_fields';
  actualCostCents?: number;
  billableTokens?: number;
  cachedInputTokens?: number;
  costCents?: number;
  inputTokens?: number;
  outputTokens?: number;
  overageTokens?: number;
  prompts?: number;
};

/** aggregate var_samp on columns */
export type qx_vChatBillingByModel_var_samp_fields = {
  __typename?: 'qx_vChatBillingByModel_var_samp_fields';
  actualCostCents?: number;
  billableTokens?: number;
  cachedInputTokens?: number;
  costCents?: number;
  inputTokens?: number;
  outputTokens?: number;
  overageTokens?: number;
  prompts?: number;
};

/** aggregate variance on columns */
export type qx_vChatBillingByModel_variance_fields = {
  __typename?: 'qx_vChatBillingByModel_variance_fields';
  actualCostCents?: number;
  billableTokens?: number;
  cachedInputTokens?: number;
  costCents?: number;
  inputTokens?: number;
  outputTokens?: number;
  overageTokens?: number;
  prompts?: number;
};

/** columns and relationships of "qx.vChatBillingSummary" */
export type qx_vChatBillingSummary = {
  __typename?: 'qx_vChatBillingSummary';
  actualCostCents?: string;
  billableDays?: number;
  billableTokens?: string;
  billingPeriodStart?: string;
  billingTier?: string;
  costCents?: string;
  firstUsedAt?: string;
  lastUsedAt?: string;
  monthlyTokenQuota?: number;
  overageTokens?: string;
  /** An object relationship */
  place?: qx_Place;
  placeId?: string;
  prompts?: string;
  tierActivatedAt?: string;
};

/** aggregated selection of "qx.vChatBillingSummary" */
export type qx_vChatBillingSummary_aggregate = {
  __typename?: 'qx_vChatBillingSummary_aggregate';
  aggregate?: qx_vChatBillingSummary_aggregate_fields;
  nodes: Array<qx_vChatBillingSummary>;
};

/** aggregate fields of "qx.vChatBillingSummary" */
export type qx_vChatBillingSummary_aggregate_fields = {
  __typename?: 'qx_vChatBillingSummary_aggregate_fields';
  avg?: qx_vChatBillingSummary_avg_fields;
  count: number;
  max?: qx_vChatBillingSummary_max_fields;
  min?: qx_vChatBillingSummary_min_fields;
  stddev?: qx_vChatBillingSummary_stddev_fields;
  stddev_pop?: qx_vChatBillingSummary_stddev_pop_fields;
  stddev_samp?: qx_vChatBillingSummary_stddev_samp_fields;
  sum?: qx_vChatBillingSummary_sum_fields;
  var_pop?: qx_vChatBillingSummary_var_pop_fields;
  var_samp?: qx_vChatBillingSummary_var_samp_fields;
  variance?: qx_vChatBillingSummary_variance_fields;
};


/** aggregate fields of "qx.vChatBillingSummary" */
export type qx_vChatBillingSummary_aggregate_fieldscountArgs = {
  columns?: Array<qx_vChatBillingSummary_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type qx_vChatBillingSummary_avg_fields = {
  __typename?: 'qx_vChatBillingSummary_avg_fields';
  actualCostCents?: number;
  billableDays?: number;
  billableTokens?: number;
  costCents?: number;
  monthlyTokenQuota?: number;
  overageTokens?: number;
  prompts?: number;
};

/** Boolean expression to filter rows from the table "qx.vChatBillingSummary". All fields are combined with a logical 'AND'. */
export type qx_vChatBillingSummary_bool_exp = {
  _and?: Array<qx_vChatBillingSummary_bool_exp>;
  _not?: qx_vChatBillingSummary_bool_exp;
  _or?: Array<qx_vChatBillingSummary_bool_exp>;
  actualCostCents?: bigint_comparison_exp;
  billableDays?: Int_comparison_exp;
  billableTokens?: bigint_comparison_exp;
  billingPeriodStart?: date_comparison_exp;
  billingTier?: String_comparison_exp;
  costCents?: bigint_comparison_exp;
  firstUsedAt?: timestamptz_comparison_exp;
  lastUsedAt?: timestamptz_comparison_exp;
  monthlyTokenQuota?: Int_comparison_exp;
  overageTokens?: bigint_comparison_exp;
  place?: qx_Place_bool_exp;
  placeId?: String_comparison_exp;
  prompts?: bigint_comparison_exp;
  tierActivatedAt?: timestamptz_comparison_exp;
};

/** aggregate max on columns */
export type qx_vChatBillingSummary_max_fields = {
  __typename?: 'qx_vChatBillingSummary_max_fields';
  actualCostCents?: string;
  billableDays?: number;
  billableTokens?: string;
  billingPeriodStart?: string;
  billingTier?: string;
  costCents?: string;
  firstUsedAt?: string;
  lastUsedAt?: string;
  monthlyTokenQuota?: number;
  overageTokens?: string;
  placeId?: string;
  prompts?: string;
  tierActivatedAt?: string;
};

/** aggregate min on columns */
export type qx_vChatBillingSummary_min_fields = {
  __typename?: 'qx_vChatBillingSummary_min_fields';
  actualCostCents?: string;
  billableDays?: number;
  billableTokens?: string;
  billingPeriodStart?: string;
  billingTier?: string;
  costCents?: string;
  firstUsedAt?: string;
  lastUsedAt?: string;
  monthlyTokenQuota?: number;
  overageTokens?: string;
  placeId?: string;
  prompts?: string;
  tierActivatedAt?: string;
};

/** Ordering options when selecting data from "qx.vChatBillingSummary". */
export type qx_vChatBillingSummary_order_by = {
  actualCostCents?: order_by;
  billableDays?: order_by;
  billableTokens?: order_by;
  billingPeriodStart?: order_by;
  billingTier?: order_by;
  costCents?: order_by;
  firstUsedAt?: order_by;
  lastUsedAt?: order_by;
  monthlyTokenQuota?: order_by;
  overageTokens?: order_by;
  place?: qx_Place_order_by;
  placeId?: order_by;
  prompts?: order_by;
  tierActivatedAt?: order_by;
};

/** select columns of table "qx.vChatBillingSummary" */
export enum qx_vChatBillingSummary_select_column {
  /** column name */
  actualCostCents = 'actualCostCents',
  /** column name */
  billableDays = 'billableDays',
  /** column name */
  billableTokens = 'billableTokens',
  /** column name */
  billingPeriodStart = 'billingPeriodStart',
  /** column name */
  billingTier = 'billingTier',
  /** column name */
  costCents = 'costCents',
  /** column name */
  firstUsedAt = 'firstUsedAt',
  /** column name */
  lastUsedAt = 'lastUsedAt',
  /** column name */
  monthlyTokenQuota = 'monthlyTokenQuota',
  /** column name */
  overageTokens = 'overageTokens',
  /** column name */
  placeId = 'placeId',
  /** column name */
  prompts = 'prompts',
  /** column name */
  tierActivatedAt = 'tierActivatedAt'
}

/** aggregate stddev on columns */
export type qx_vChatBillingSummary_stddev_fields = {
  __typename?: 'qx_vChatBillingSummary_stddev_fields';
  actualCostCents?: number;
  billableDays?: number;
  billableTokens?: number;
  costCents?: number;
  monthlyTokenQuota?: number;
  overageTokens?: number;
  prompts?: number;
};

/** aggregate stddev_pop on columns */
export type qx_vChatBillingSummary_stddev_pop_fields = {
  __typename?: 'qx_vChatBillingSummary_stddev_pop_fields';
  actualCostCents?: number;
  billableDays?: number;
  billableTokens?: number;
  costCents?: number;
  monthlyTokenQuota?: number;
  overageTokens?: number;
  prompts?: number;
};

/** aggregate stddev_samp on columns */
export type qx_vChatBillingSummary_stddev_samp_fields = {
  __typename?: 'qx_vChatBillingSummary_stddev_samp_fields';
  actualCostCents?: number;
  billableDays?: number;
  billableTokens?: number;
  costCents?: number;
  monthlyTokenQuota?: number;
  overageTokens?: number;
  prompts?: number;
};

/** Streaming cursor of the table "qx_vChatBillingSummary" */
export type qx_vChatBillingSummary_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_vChatBillingSummary_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_vChatBillingSummary_stream_cursor_value_input = {
  actualCostCents?: string;
  billableDays?: number;
  billableTokens?: string;
  billingPeriodStart?: string;
  billingTier?: string;
  costCents?: string;
  firstUsedAt?: string;
  lastUsedAt?: string;
  monthlyTokenQuota?: number;
  overageTokens?: string;
  placeId?: string;
  prompts?: string;
  tierActivatedAt?: string;
};

/** aggregate sum on columns */
export type qx_vChatBillingSummary_sum_fields = {
  __typename?: 'qx_vChatBillingSummary_sum_fields';
  actualCostCents?: string;
  billableDays?: number;
  billableTokens?: string;
  costCents?: string;
  monthlyTokenQuota?: number;
  overageTokens?: string;
  prompts?: string;
};

/** aggregate var_pop on columns */
export type qx_vChatBillingSummary_var_pop_fields = {
  __typename?: 'qx_vChatBillingSummary_var_pop_fields';
  actualCostCents?: number;
  billableDays?: number;
  billableTokens?: number;
  costCents?: number;
  monthlyTokenQuota?: number;
  overageTokens?: number;
  prompts?: number;
};

/** aggregate var_samp on columns */
export type qx_vChatBillingSummary_var_samp_fields = {
  __typename?: 'qx_vChatBillingSummary_var_samp_fields';
  actualCostCents?: number;
  billableDays?: number;
  billableTokens?: number;
  costCents?: number;
  monthlyTokenQuota?: number;
  overageTokens?: number;
  prompts?: number;
};

/** aggregate variance on columns */
export type qx_vChatBillingSummary_variance_fields = {
  __typename?: 'qx_vChatBillingSummary_variance_fields';
  actualCostCents?: number;
  billableDays?: number;
  billableTokens?: number;
  costCents?: number;
  monthlyTokenQuota?: number;
  overageTokens?: number;
  prompts?: number;
};

/** columns and relationships of "qx.vChatPromptUsage" */
export type qx_vChatPromptUsage = {
  __typename?: 'qx_vChatPromptUsage';
  actualCostCents?: number;
  billableTokens?: number;
  billingPeriodStart?: string;
  billingTier?: string;
  cachedInputTokens?: number;
  costCents?: number;
  createdAt?: string;
  inputTokens?: number;
  model?: string;
  outputTokens?: number;
  /** An object relationship */
  person?: qx_Person;
  personEmail?: string;
  personId?: string;
  personName?: string;
  /** An object relationship */
  place?: qx_Place;
  placeId?: string;
  runId?: string;
  threadId?: string;
  threadTitle?: string;
  totalTokens?: number;
};

/** aggregated selection of "qx.vChatPromptUsage" */
export type qx_vChatPromptUsage_aggregate = {
  __typename?: 'qx_vChatPromptUsage_aggregate';
  aggregate?: qx_vChatPromptUsage_aggregate_fields;
  nodes: Array<qx_vChatPromptUsage>;
};

/** aggregate fields of "qx.vChatPromptUsage" */
export type qx_vChatPromptUsage_aggregate_fields = {
  __typename?: 'qx_vChatPromptUsage_aggregate_fields';
  avg?: qx_vChatPromptUsage_avg_fields;
  count: number;
  max?: qx_vChatPromptUsage_max_fields;
  min?: qx_vChatPromptUsage_min_fields;
  stddev?: qx_vChatPromptUsage_stddev_fields;
  stddev_pop?: qx_vChatPromptUsage_stddev_pop_fields;
  stddev_samp?: qx_vChatPromptUsage_stddev_samp_fields;
  sum?: qx_vChatPromptUsage_sum_fields;
  var_pop?: qx_vChatPromptUsage_var_pop_fields;
  var_samp?: qx_vChatPromptUsage_var_samp_fields;
  variance?: qx_vChatPromptUsage_variance_fields;
};


/** aggregate fields of "qx.vChatPromptUsage" */
export type qx_vChatPromptUsage_aggregate_fieldscountArgs = {
  columns?: Array<qx_vChatPromptUsage_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type qx_vChatPromptUsage_avg_fields = {
  __typename?: 'qx_vChatPromptUsage_avg_fields';
  actualCostCents?: number;
  billableTokens?: number;
  cachedInputTokens?: number;
  costCents?: number;
  inputTokens?: number;
  outputTokens?: number;
  totalTokens?: number;
};

/** Boolean expression to filter rows from the table "qx.vChatPromptUsage". All fields are combined with a logical 'AND'. */
export type qx_vChatPromptUsage_bool_exp = {
  _and?: Array<qx_vChatPromptUsage_bool_exp>;
  _not?: qx_vChatPromptUsage_bool_exp;
  _or?: Array<qx_vChatPromptUsage_bool_exp>;
  actualCostCents?: Int_comparison_exp;
  billableTokens?: Int_comparison_exp;
  billingPeriodStart?: date_comparison_exp;
  billingTier?: String_comparison_exp;
  cachedInputTokens?: Int_comparison_exp;
  costCents?: Int_comparison_exp;
  createdAt?: timestamptz_comparison_exp;
  inputTokens?: Int_comparison_exp;
  model?: String_comparison_exp;
  outputTokens?: Int_comparison_exp;
  person?: qx_Person_bool_exp;
  personEmail?: String_comparison_exp;
  personId?: String_comparison_exp;
  personName?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  placeId?: String_comparison_exp;
  runId?: String_comparison_exp;
  threadId?: String_comparison_exp;
  threadTitle?: String_comparison_exp;
  totalTokens?: Int_comparison_exp;
};

/** aggregate max on columns */
export type qx_vChatPromptUsage_max_fields = {
  __typename?: 'qx_vChatPromptUsage_max_fields';
  actualCostCents?: number;
  billableTokens?: number;
  billingPeriodStart?: string;
  billingTier?: string;
  cachedInputTokens?: number;
  costCents?: number;
  createdAt?: string;
  inputTokens?: number;
  model?: string;
  outputTokens?: number;
  personEmail?: string;
  personId?: string;
  personName?: string;
  placeId?: string;
  runId?: string;
  threadId?: string;
  threadTitle?: string;
  totalTokens?: number;
};

/** aggregate min on columns */
export type qx_vChatPromptUsage_min_fields = {
  __typename?: 'qx_vChatPromptUsage_min_fields';
  actualCostCents?: number;
  billableTokens?: number;
  billingPeriodStart?: string;
  billingTier?: string;
  cachedInputTokens?: number;
  costCents?: number;
  createdAt?: string;
  inputTokens?: number;
  model?: string;
  outputTokens?: number;
  personEmail?: string;
  personId?: string;
  personName?: string;
  placeId?: string;
  runId?: string;
  threadId?: string;
  threadTitle?: string;
  totalTokens?: number;
};

/** Ordering options when selecting data from "qx.vChatPromptUsage". */
export type qx_vChatPromptUsage_order_by = {
  actualCostCents?: order_by;
  billableTokens?: order_by;
  billingPeriodStart?: order_by;
  billingTier?: order_by;
  cachedInputTokens?: order_by;
  costCents?: order_by;
  createdAt?: order_by;
  inputTokens?: order_by;
  model?: order_by;
  outputTokens?: order_by;
  person?: qx_Person_order_by;
  personEmail?: order_by;
  personId?: order_by;
  personName?: order_by;
  place?: qx_Place_order_by;
  placeId?: order_by;
  runId?: order_by;
  threadId?: order_by;
  threadTitle?: order_by;
  totalTokens?: order_by;
};

/** select columns of table "qx.vChatPromptUsage" */
export enum qx_vChatPromptUsage_select_column {
  /** column name */
  actualCostCents = 'actualCostCents',
  /** column name */
  billableTokens = 'billableTokens',
  /** column name */
  billingPeriodStart = 'billingPeriodStart',
  /** column name */
  billingTier = 'billingTier',
  /** column name */
  cachedInputTokens = 'cachedInputTokens',
  /** column name */
  costCents = 'costCents',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  inputTokens = 'inputTokens',
  /** column name */
  model = 'model',
  /** column name */
  outputTokens = 'outputTokens',
  /** column name */
  personEmail = 'personEmail',
  /** column name */
  personId = 'personId',
  /** column name */
  personName = 'personName',
  /** column name */
  placeId = 'placeId',
  /** column name */
  runId = 'runId',
  /** column name */
  threadId = 'threadId',
  /** column name */
  threadTitle = 'threadTitle',
  /** column name */
  totalTokens = 'totalTokens'
}

/** aggregate stddev on columns */
export type qx_vChatPromptUsage_stddev_fields = {
  __typename?: 'qx_vChatPromptUsage_stddev_fields';
  actualCostCents?: number;
  billableTokens?: number;
  cachedInputTokens?: number;
  costCents?: number;
  inputTokens?: number;
  outputTokens?: number;
  totalTokens?: number;
};

/** aggregate stddev_pop on columns */
export type qx_vChatPromptUsage_stddev_pop_fields = {
  __typename?: 'qx_vChatPromptUsage_stddev_pop_fields';
  actualCostCents?: number;
  billableTokens?: number;
  cachedInputTokens?: number;
  costCents?: number;
  inputTokens?: number;
  outputTokens?: number;
  totalTokens?: number;
};

/** aggregate stddev_samp on columns */
export type qx_vChatPromptUsage_stddev_samp_fields = {
  __typename?: 'qx_vChatPromptUsage_stddev_samp_fields';
  actualCostCents?: number;
  billableTokens?: number;
  cachedInputTokens?: number;
  costCents?: number;
  inputTokens?: number;
  outputTokens?: number;
  totalTokens?: number;
};

/** Streaming cursor of the table "qx_vChatPromptUsage" */
export type qx_vChatPromptUsage_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_vChatPromptUsage_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_vChatPromptUsage_stream_cursor_value_input = {
  actualCostCents?: number;
  billableTokens?: number;
  billingPeriodStart?: string;
  billingTier?: string;
  cachedInputTokens?: number;
  costCents?: number;
  createdAt?: string;
  inputTokens?: number;
  model?: string;
  outputTokens?: number;
  personEmail?: string;
  personId?: string;
  personName?: string;
  placeId?: string;
  runId?: string;
  threadId?: string;
  threadTitle?: string;
  totalTokens?: number;
};

/** aggregate sum on columns */
export type qx_vChatPromptUsage_sum_fields = {
  __typename?: 'qx_vChatPromptUsage_sum_fields';
  actualCostCents?: number;
  billableTokens?: number;
  cachedInputTokens?: number;
  costCents?: number;
  inputTokens?: number;
  outputTokens?: number;
  totalTokens?: number;
};

/** aggregate var_pop on columns */
export type qx_vChatPromptUsage_var_pop_fields = {
  __typename?: 'qx_vChatPromptUsage_var_pop_fields';
  actualCostCents?: number;
  billableTokens?: number;
  cachedInputTokens?: number;
  costCents?: number;
  inputTokens?: number;
  outputTokens?: number;
  totalTokens?: number;
};

/** aggregate var_samp on columns */
export type qx_vChatPromptUsage_var_samp_fields = {
  __typename?: 'qx_vChatPromptUsage_var_samp_fields';
  actualCostCents?: number;
  billableTokens?: number;
  cachedInputTokens?: number;
  costCents?: number;
  inputTokens?: number;
  outputTokens?: number;
  totalTokens?: number;
};

/** aggregate variance on columns */
export type qx_vChatPromptUsage_variance_fields = {
  __typename?: 'qx_vChatPromptUsage_variance_fields';
  actualCostCents?: number;
  billableTokens?: number;
  cachedInputTokens?: number;
  costCents?: number;
  inputTokens?: number;
  outputTokens?: number;
  totalTokens?: number;
};

/** columns and relationships of "qx.vChatUsagePerModel" */
export type qx_vChatUsagePerModel = {
  __typename?: 'qx_vChatUsagePerModel';
  billableTokens?: number;
  cachedInputCostCents?: number;
  cachedInputTokens?: number;
  inputCostCents?: number;
  inputTokens?: number;
  model?: string;
  outputCostCents?: number;
  outputTokens?: number;
  /** An object relationship */
  place?: qx_Place;
  placeId?: string;
  prompts?: number;
  provider?: string;
  totalCostCents?: number;
  uncachedInputTokens?: number;
};

export type qx_vChatUsagePerModel_aggregate = {
  __typename?: 'qx_vChatUsagePerModel_aggregate';
  aggregate?: qx_vChatUsagePerModel_aggregate_fields;
  nodes: Array<qx_vChatUsagePerModel>;
};

/** aggregate fields of "qx.vChatUsagePerModel" */
export type qx_vChatUsagePerModel_aggregate_fields = {
  __typename?: 'qx_vChatUsagePerModel_aggregate_fields';
  avg?: qx_vChatUsagePerModel_avg_fields;
  count: number;
  max?: qx_vChatUsagePerModel_max_fields;
  min?: qx_vChatUsagePerModel_min_fields;
  stddev?: qx_vChatUsagePerModel_stddev_fields;
  stddev_pop?: qx_vChatUsagePerModel_stddev_pop_fields;
  stddev_samp?: qx_vChatUsagePerModel_stddev_samp_fields;
  sum?: qx_vChatUsagePerModel_sum_fields;
  var_pop?: qx_vChatUsagePerModel_var_pop_fields;
  var_samp?: qx_vChatUsagePerModel_var_samp_fields;
  variance?: qx_vChatUsagePerModel_variance_fields;
};


/** aggregate fields of "qx.vChatUsagePerModel" */
export type qx_vChatUsagePerModel_aggregate_fieldscountArgs = {
  columns?: Array<qx_vChatUsagePerModel_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type qx_vChatUsagePerModel_avg_fields = {
  __typename?: 'qx_vChatUsagePerModel_avg_fields';
  billableTokens?: number;
  cachedInputCostCents?: number;
  cachedInputTokens?: number;
  inputCostCents?: number;
  inputTokens?: number;
  outputCostCents?: number;
  outputTokens?: number;
  prompts?: number;
  totalCostCents?: number;
  uncachedInputTokens?: number;
};

/** Boolean expression to filter rows from the table "qx.vChatUsagePerModel". All fields are combined with a logical 'AND'. */
export type qx_vChatUsagePerModel_bool_exp = {
  _and?: Array<qx_vChatUsagePerModel_bool_exp>;
  _not?: qx_vChatUsagePerModel_bool_exp;
  _or?: Array<qx_vChatUsagePerModel_bool_exp>;
  billableTokens?: Int_comparison_exp;
  cachedInputCostCents?: Int_comparison_exp;
  cachedInputTokens?: Int_comparison_exp;
  inputCostCents?: Int_comparison_exp;
  inputTokens?: Int_comparison_exp;
  model?: String_comparison_exp;
  outputCostCents?: Int_comparison_exp;
  outputTokens?: Int_comparison_exp;
  place?: qx_Place_bool_exp;
  placeId?: String_comparison_exp;
  prompts?: Int_comparison_exp;
  provider?: String_comparison_exp;
  totalCostCents?: Int_comparison_exp;
  uncachedInputTokens?: Int_comparison_exp;
};

/** aggregate max on columns */
export type qx_vChatUsagePerModel_max_fields = {
  __typename?: 'qx_vChatUsagePerModel_max_fields';
  billableTokens?: number;
  cachedInputCostCents?: number;
  cachedInputTokens?: number;
  inputCostCents?: number;
  inputTokens?: number;
  model?: string;
  outputCostCents?: number;
  outputTokens?: number;
  placeId?: string;
  prompts?: number;
  provider?: string;
  totalCostCents?: number;
  uncachedInputTokens?: number;
};

/** aggregate min on columns */
export type qx_vChatUsagePerModel_min_fields = {
  __typename?: 'qx_vChatUsagePerModel_min_fields';
  billableTokens?: number;
  cachedInputCostCents?: number;
  cachedInputTokens?: number;
  inputCostCents?: number;
  inputTokens?: number;
  model?: string;
  outputCostCents?: number;
  outputTokens?: number;
  placeId?: string;
  prompts?: number;
  provider?: string;
  totalCostCents?: number;
  uncachedInputTokens?: number;
};

/** Ordering options when selecting data from "qx.vChatUsagePerModel". */
export type qx_vChatUsagePerModel_order_by = {
  billableTokens?: order_by;
  cachedInputCostCents?: order_by;
  cachedInputTokens?: order_by;
  inputCostCents?: order_by;
  inputTokens?: order_by;
  model?: order_by;
  outputCostCents?: order_by;
  outputTokens?: order_by;
  place?: qx_Place_order_by;
  placeId?: order_by;
  prompts?: order_by;
  provider?: order_by;
  totalCostCents?: order_by;
  uncachedInputTokens?: order_by;
};

/** select columns of table "qx.vChatUsagePerModel" */
export enum qx_vChatUsagePerModel_select_column {
  /** column name */
  billableTokens = 'billableTokens',
  /** column name */
  cachedInputCostCents = 'cachedInputCostCents',
  /** column name */
  cachedInputTokens = 'cachedInputTokens',
  /** column name */
  inputCostCents = 'inputCostCents',
  /** column name */
  inputTokens = 'inputTokens',
  /** column name */
  model = 'model',
  /** column name */
  outputCostCents = 'outputCostCents',
  /** column name */
  outputTokens = 'outputTokens',
  /** column name */
  placeId = 'placeId',
  /** column name */
  prompts = 'prompts',
  /** column name */
  provider = 'provider',
  /** column name */
  totalCostCents = 'totalCostCents',
  /** column name */
  uncachedInputTokens = 'uncachedInputTokens'
}

/** aggregate stddev on columns */
export type qx_vChatUsagePerModel_stddev_fields = {
  __typename?: 'qx_vChatUsagePerModel_stddev_fields';
  billableTokens?: number;
  cachedInputCostCents?: number;
  cachedInputTokens?: number;
  inputCostCents?: number;
  inputTokens?: number;
  outputCostCents?: number;
  outputTokens?: number;
  prompts?: number;
  totalCostCents?: number;
  uncachedInputTokens?: number;
};

/** aggregate stddev_pop on columns */
export type qx_vChatUsagePerModel_stddev_pop_fields = {
  __typename?: 'qx_vChatUsagePerModel_stddev_pop_fields';
  billableTokens?: number;
  cachedInputCostCents?: number;
  cachedInputTokens?: number;
  inputCostCents?: number;
  inputTokens?: number;
  outputCostCents?: number;
  outputTokens?: number;
  prompts?: number;
  totalCostCents?: number;
  uncachedInputTokens?: number;
};

/** aggregate stddev_samp on columns */
export type qx_vChatUsagePerModel_stddev_samp_fields = {
  __typename?: 'qx_vChatUsagePerModel_stddev_samp_fields';
  billableTokens?: number;
  cachedInputCostCents?: number;
  cachedInputTokens?: number;
  inputCostCents?: number;
  inputTokens?: number;
  outputCostCents?: number;
  outputTokens?: number;
  prompts?: number;
  totalCostCents?: number;
  uncachedInputTokens?: number;
};

/** Streaming cursor of the table "qx_vChatUsagePerModel" */
export type qx_vChatUsagePerModel_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_vChatUsagePerModel_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_vChatUsagePerModel_stream_cursor_value_input = {
  billableTokens?: number;
  cachedInputCostCents?: number;
  cachedInputTokens?: number;
  inputCostCents?: number;
  inputTokens?: number;
  model?: string;
  outputCostCents?: number;
  outputTokens?: number;
  placeId?: string;
  prompts?: number;
  provider?: string;
  totalCostCents?: number;
  uncachedInputTokens?: number;
};

/** aggregate sum on columns */
export type qx_vChatUsagePerModel_sum_fields = {
  __typename?: 'qx_vChatUsagePerModel_sum_fields';
  billableTokens?: number;
  cachedInputCostCents?: number;
  cachedInputTokens?: number;
  inputCostCents?: number;
  inputTokens?: number;
  outputCostCents?: number;
  outputTokens?: number;
  prompts?: number;
  totalCostCents?: number;
  uncachedInputTokens?: number;
};

/** aggregate var_pop on columns */
export type qx_vChatUsagePerModel_var_pop_fields = {
  __typename?: 'qx_vChatUsagePerModel_var_pop_fields';
  billableTokens?: number;
  cachedInputCostCents?: number;
  cachedInputTokens?: number;
  inputCostCents?: number;
  inputTokens?: number;
  outputCostCents?: number;
  outputTokens?: number;
  prompts?: number;
  totalCostCents?: number;
  uncachedInputTokens?: number;
};

/** aggregate var_samp on columns */
export type qx_vChatUsagePerModel_var_samp_fields = {
  __typename?: 'qx_vChatUsagePerModel_var_samp_fields';
  billableTokens?: number;
  cachedInputCostCents?: number;
  cachedInputTokens?: number;
  inputCostCents?: number;
  inputTokens?: number;
  outputCostCents?: number;
  outputTokens?: number;
  prompts?: number;
  totalCostCents?: number;
  uncachedInputTokens?: number;
};

/** aggregate variance on columns */
export type qx_vChatUsagePerModel_variance_fields = {
  __typename?: 'qx_vChatUsagePerModel_variance_fields';
  billableTokens?: number;
  cachedInputCostCents?: number;
  cachedInputTokens?: number;
  inputCostCents?: number;
  inputTokens?: number;
  outputCostCents?: number;
  outputTokens?: number;
  prompts?: number;
  totalCostCents?: number;
  uncachedInputTokens?: number;
};

/** columns and relationships of "qx.vChatUsageSeries" */
export type qx_vChatUsageSeries = {
  __typename?: 'qx_vChatUsageSeries';
  billableTokens?: number;
  bucket?: string;
  /** An object relationship */
  place?: qx_Place;
  placeId?: string;
  series?: string;
};

export type qx_vChatUsageSeries_aggregate = {
  __typename?: 'qx_vChatUsageSeries_aggregate';
  aggregate?: qx_vChatUsageSeries_aggregate_fields;
  nodes: Array<qx_vChatUsageSeries>;
};

/** aggregate fields of "qx.vChatUsageSeries" */
export type qx_vChatUsageSeries_aggregate_fields = {
  __typename?: 'qx_vChatUsageSeries_aggregate_fields';
  avg?: qx_vChatUsageSeries_avg_fields;
  count: number;
  max?: qx_vChatUsageSeries_max_fields;
  min?: qx_vChatUsageSeries_min_fields;
  stddev?: qx_vChatUsageSeries_stddev_fields;
  stddev_pop?: qx_vChatUsageSeries_stddev_pop_fields;
  stddev_samp?: qx_vChatUsageSeries_stddev_samp_fields;
  sum?: qx_vChatUsageSeries_sum_fields;
  var_pop?: qx_vChatUsageSeries_var_pop_fields;
  var_samp?: qx_vChatUsageSeries_var_samp_fields;
  variance?: qx_vChatUsageSeries_variance_fields;
};


/** aggregate fields of "qx.vChatUsageSeries" */
export type qx_vChatUsageSeries_aggregate_fieldscountArgs = {
  columns?: Array<qx_vChatUsageSeries_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type qx_vChatUsageSeries_avg_fields = {
  __typename?: 'qx_vChatUsageSeries_avg_fields';
  billableTokens?: number;
};

/** Boolean expression to filter rows from the table "qx.vChatUsageSeries". All fields are combined with a logical 'AND'. */
export type qx_vChatUsageSeries_bool_exp = {
  _and?: Array<qx_vChatUsageSeries_bool_exp>;
  _not?: qx_vChatUsageSeries_bool_exp;
  _or?: Array<qx_vChatUsageSeries_bool_exp>;
  billableTokens?: Int_comparison_exp;
  bucket?: date_comparison_exp;
  place?: qx_Place_bool_exp;
  placeId?: String_comparison_exp;
  series?: String_comparison_exp;
};

/** aggregate max on columns */
export type qx_vChatUsageSeries_max_fields = {
  __typename?: 'qx_vChatUsageSeries_max_fields';
  billableTokens?: number;
  bucket?: string;
  placeId?: string;
  series?: string;
};

/** aggregate min on columns */
export type qx_vChatUsageSeries_min_fields = {
  __typename?: 'qx_vChatUsageSeries_min_fields';
  billableTokens?: number;
  bucket?: string;
  placeId?: string;
  series?: string;
};

/** Ordering options when selecting data from "qx.vChatUsageSeries". */
export type qx_vChatUsageSeries_order_by = {
  billableTokens?: order_by;
  bucket?: order_by;
  place?: qx_Place_order_by;
  placeId?: order_by;
  series?: order_by;
};

/** select columns of table "qx.vChatUsageSeries" */
export enum qx_vChatUsageSeries_select_column {
  /** column name */
  billableTokens = 'billableTokens',
  /** column name */
  bucket = 'bucket',
  /** column name */
  placeId = 'placeId',
  /** column name */
  series = 'series'
}

/** aggregate stddev on columns */
export type qx_vChatUsageSeries_stddev_fields = {
  __typename?: 'qx_vChatUsageSeries_stddev_fields';
  billableTokens?: number;
};

/** aggregate stddev_pop on columns */
export type qx_vChatUsageSeries_stddev_pop_fields = {
  __typename?: 'qx_vChatUsageSeries_stddev_pop_fields';
  billableTokens?: number;
};

/** aggregate stddev_samp on columns */
export type qx_vChatUsageSeries_stddev_samp_fields = {
  __typename?: 'qx_vChatUsageSeries_stddev_samp_fields';
  billableTokens?: number;
};

/** Streaming cursor of the table "qx_vChatUsageSeries" */
export type qx_vChatUsageSeries_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_vChatUsageSeries_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_vChatUsageSeries_stream_cursor_value_input = {
  billableTokens?: number;
  bucket?: string;
  placeId?: string;
  series?: string;
};

/** aggregate sum on columns */
export type qx_vChatUsageSeries_sum_fields = {
  __typename?: 'qx_vChatUsageSeries_sum_fields';
  billableTokens?: number;
};

/** aggregate var_pop on columns */
export type qx_vChatUsageSeries_var_pop_fields = {
  __typename?: 'qx_vChatUsageSeries_var_pop_fields';
  billableTokens?: number;
};

/** aggregate var_samp on columns */
export type qx_vChatUsageSeries_var_samp_fields = {
  __typename?: 'qx_vChatUsageSeries_var_samp_fields';
  billableTokens?: number;
};

/** aggregate variance on columns */
export type qx_vChatUsageSeries_variance_fields = {
  __typename?: 'qx_vChatUsageSeries_variance_fields';
  billableTokens?: number;
};

/** columns and relationships of "qx.vDevicePlace" */
export type qx_vDevicePlace = {
  __typename?: 'qx_vDevicePlace';
  /** An object relationship */
  device?: qx_Device;
  deviceID?: string;
  /** An object relationship */
  place?: qx_Place;
  placeID?: string;
};

/** aggregated selection of "qx.vDevicePlace" */
export type qx_vDevicePlace_aggregate = {
  __typename?: 'qx_vDevicePlace_aggregate';
  aggregate?: qx_vDevicePlace_aggregate_fields;
  nodes: Array<qx_vDevicePlace>;
};

/** aggregate fields of "qx.vDevicePlace" */
export type qx_vDevicePlace_aggregate_fields = {
  __typename?: 'qx_vDevicePlace_aggregate_fields';
  count: number;
  max?: qx_vDevicePlace_max_fields;
  min?: qx_vDevicePlace_min_fields;
};


/** aggregate fields of "qx.vDevicePlace" */
export type qx_vDevicePlace_aggregate_fieldscountArgs = {
  columns?: Array<qx_vDevicePlace_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.vDevicePlace". All fields are combined with a logical 'AND'. */
export type qx_vDevicePlace_bool_exp = {
  _and?: Array<qx_vDevicePlace_bool_exp>;
  _not?: qx_vDevicePlace_bool_exp;
  _or?: Array<qx_vDevicePlace_bool_exp>;
  device?: qx_Device_bool_exp;
  deviceID?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
};

/** input type for inserting data into table "qx.vDevicePlace" */
export type qx_vDevicePlace_insert_input = {
  device?: qx_Device_obj_rel_insert_input;
  deviceID?: string;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
};

/** aggregate max on columns */
export type qx_vDevicePlace_max_fields = {
  __typename?: 'qx_vDevicePlace_max_fields';
  deviceID?: string;
  placeID?: string;
};

/** aggregate min on columns */
export type qx_vDevicePlace_min_fields = {
  __typename?: 'qx_vDevicePlace_min_fields';
  deviceID?: string;
  placeID?: string;
};

/** input type for inserting object relation for remote table "qx.vDevicePlace" */
export type qx_vDevicePlace_obj_rel_insert_input = {
  data: qx_vDevicePlace_insert_input;
};

/** Ordering options when selecting data from "qx.vDevicePlace". */
export type qx_vDevicePlace_order_by = {
  device?: qx_Device_order_by;
  deviceID?: order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
};

/** select columns of table "qx.vDevicePlace" */
export enum qx_vDevicePlace_select_column {
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  placeID = 'placeID'
}

/** Streaming cursor of the table "qx_vDevicePlace" */
export type qx_vDevicePlace_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_vDevicePlace_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_vDevicePlace_stream_cursor_value_input = {
  deviceID?: string;
  placeID?: string;
};

/** columns and relationships of "qx.vDoorAccessByPerson" */
export type qx_vDoorAccessByPerson = {
  __typename?: 'qx_vDoorAccessByPerson';
  /** An object relationship */
  door?: qx_Door;
  doorID?: string;
  /** An object relationship */
  person?: qx_Person;
  personID?: string;
};

/** aggregated selection of "qx.vDoorAccessByPerson" */
export type qx_vDoorAccessByPerson_aggregate = {
  __typename?: 'qx_vDoorAccessByPerson_aggregate';
  aggregate?: qx_vDoorAccessByPerson_aggregate_fields;
  nodes: Array<qx_vDoorAccessByPerson>;
};

/** aggregate fields of "qx.vDoorAccessByPerson" */
export type qx_vDoorAccessByPerson_aggregate_fields = {
  __typename?: 'qx_vDoorAccessByPerson_aggregate_fields';
  avg?: qx_vDoorAccessByPerson_avg_fields;
  count: number;
  max?: qx_vDoorAccessByPerson_max_fields;
  min?: qx_vDoorAccessByPerson_min_fields;
  stddev?: qx_vDoorAccessByPerson_stddev_fields;
  stddev_pop?: qx_vDoorAccessByPerson_stddev_pop_fields;
  stddev_samp?: qx_vDoorAccessByPerson_stddev_samp_fields;
  sum?: qx_vDoorAccessByPerson_sum_fields;
  var_pop?: qx_vDoorAccessByPerson_var_pop_fields;
  var_samp?: qx_vDoorAccessByPerson_var_samp_fields;
  variance?: qx_vDoorAccessByPerson_variance_fields;
};


/** aggregate fields of "qx.vDoorAccessByPerson" */
export type qx_vDoorAccessByPerson_aggregate_fieldscountArgs = {
  columns?: Array<qx_vDoorAccessByPerson_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type qx_vDoorAccessByPerson_avg_fields = {
  __typename?: 'qx_vDoorAccessByPerson_avg_fields';
  doorID?: number;
};

/** Boolean expression to filter rows from the table "qx.vDoorAccessByPerson". All fields are combined with a logical 'AND'. */
export type qx_vDoorAccessByPerson_bool_exp = {
  _and?: Array<qx_vDoorAccessByPerson_bool_exp>;
  _not?: qx_vDoorAccessByPerson_bool_exp;
  _or?: Array<qx_vDoorAccessByPerson_bool_exp>;
  door?: qx_Door_bool_exp;
  doorID?: bigint_comparison_exp;
  person?: qx_Person_bool_exp;
  personID?: String_comparison_exp;
};

/** aggregate max on columns */
export type qx_vDoorAccessByPerson_max_fields = {
  __typename?: 'qx_vDoorAccessByPerson_max_fields';
  doorID?: string;
  personID?: string;
};

/** aggregate min on columns */
export type qx_vDoorAccessByPerson_min_fields = {
  __typename?: 'qx_vDoorAccessByPerson_min_fields';
  doorID?: string;
  personID?: string;
};

/** Ordering options when selecting data from "qx.vDoorAccessByPerson". */
export type qx_vDoorAccessByPerson_order_by = {
  door?: qx_Door_order_by;
  doorID?: order_by;
  person?: qx_Person_order_by;
  personID?: order_by;
};

/** select columns of table "qx.vDoorAccessByPerson" */
export enum qx_vDoorAccessByPerson_select_column {
  /** column name */
  doorID = 'doorID',
  /** column name */
  personID = 'personID'
}

/** aggregate stddev on columns */
export type qx_vDoorAccessByPerson_stddev_fields = {
  __typename?: 'qx_vDoorAccessByPerson_stddev_fields';
  doorID?: number;
};

/** aggregate stddev_pop on columns */
export type qx_vDoorAccessByPerson_stddev_pop_fields = {
  __typename?: 'qx_vDoorAccessByPerson_stddev_pop_fields';
  doorID?: number;
};

/** aggregate stddev_samp on columns */
export type qx_vDoorAccessByPerson_stddev_samp_fields = {
  __typename?: 'qx_vDoorAccessByPerson_stddev_samp_fields';
  doorID?: number;
};

/** Streaming cursor of the table "qx_vDoorAccessByPerson" */
export type qx_vDoorAccessByPerson_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_vDoorAccessByPerson_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_vDoorAccessByPerson_stream_cursor_value_input = {
  doorID?: string;
  personID?: string;
};

/** aggregate sum on columns */
export type qx_vDoorAccessByPerson_sum_fields = {
  __typename?: 'qx_vDoorAccessByPerson_sum_fields';
  doorID?: string;
};

/** aggregate var_pop on columns */
export type qx_vDoorAccessByPerson_var_pop_fields = {
  __typename?: 'qx_vDoorAccessByPerson_var_pop_fields';
  doorID?: number;
};

/** aggregate var_samp on columns */
export type qx_vDoorAccessByPerson_var_samp_fields = {
  __typename?: 'qx_vDoorAccessByPerson_var_samp_fields';
  doorID?: number;
};

/** aggregate variance on columns */
export type qx_vDoorAccessByPerson_variance_fields = {
  __typename?: 'qx_vDoorAccessByPerson_variance_fields';
  doorID?: number;
};

/** columns and relationships of "qx.vEventsByHour" */
export type qx_vEventsByHour = {
  __typename?: 'qx_vEventsByHour';
  eventCount?: number;
  hourOfDay?: string;
  path?: string;
};

export type qx_vEventsByHour_aggregate = {
  __typename?: 'qx_vEventsByHour_aggregate';
  aggregate?: qx_vEventsByHour_aggregate_fields;
  nodes: Array<qx_vEventsByHour>;
};

/** aggregate fields of "qx.vEventsByHour" */
export type qx_vEventsByHour_aggregate_fields = {
  __typename?: 'qx_vEventsByHour_aggregate_fields';
  avg?: qx_vEventsByHour_avg_fields;
  count: number;
  max?: qx_vEventsByHour_max_fields;
  min?: qx_vEventsByHour_min_fields;
  stddev?: qx_vEventsByHour_stddev_fields;
  stddev_pop?: qx_vEventsByHour_stddev_pop_fields;
  stddev_samp?: qx_vEventsByHour_stddev_samp_fields;
  sum?: qx_vEventsByHour_sum_fields;
  var_pop?: qx_vEventsByHour_var_pop_fields;
  var_samp?: qx_vEventsByHour_var_samp_fields;
  variance?: qx_vEventsByHour_variance_fields;
};


/** aggregate fields of "qx.vEventsByHour" */
export type qx_vEventsByHour_aggregate_fieldscountArgs = {
  columns?: Array<qx_vEventsByHour_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type qx_vEventsByHour_avg_fields = {
  __typename?: 'qx_vEventsByHour_avg_fields';
  eventCount?: number;
};

/** Boolean expression to filter rows from the table "qx.vEventsByHour". All fields are combined with a logical 'AND'. */
export type qx_vEventsByHour_bool_exp = {
  _and?: Array<qx_vEventsByHour_bool_exp>;
  _not?: qx_vEventsByHour_bool_exp;
  _or?: Array<qx_vEventsByHour_bool_exp>;
  eventCount?: Int_comparison_exp;
  hourOfDay?: timestamptz_comparison_exp;
  path?: String_comparison_exp;
};

/** aggregate max on columns */
export type qx_vEventsByHour_max_fields = {
  __typename?: 'qx_vEventsByHour_max_fields';
  eventCount?: number;
  hourOfDay?: string;
  path?: string;
};

/** aggregate min on columns */
export type qx_vEventsByHour_min_fields = {
  __typename?: 'qx_vEventsByHour_min_fields';
  eventCount?: number;
  hourOfDay?: string;
  path?: string;
};

/** Ordering options when selecting data from "qx.vEventsByHour". */
export type qx_vEventsByHour_order_by = {
  eventCount?: order_by;
  hourOfDay?: order_by;
  path?: order_by;
};

/** select columns of table "qx.vEventsByHour" */
export enum qx_vEventsByHour_select_column {
  /** column name */
  eventCount = 'eventCount',
  /** column name */
  hourOfDay = 'hourOfDay',
  /** column name */
  path = 'path'
}

/** aggregate stddev on columns */
export type qx_vEventsByHour_stddev_fields = {
  __typename?: 'qx_vEventsByHour_stddev_fields';
  eventCount?: number;
};

/** aggregate stddev_pop on columns */
export type qx_vEventsByHour_stddev_pop_fields = {
  __typename?: 'qx_vEventsByHour_stddev_pop_fields';
  eventCount?: number;
};

/** aggregate stddev_samp on columns */
export type qx_vEventsByHour_stddev_samp_fields = {
  __typename?: 'qx_vEventsByHour_stddev_samp_fields';
  eventCount?: number;
};

/** Streaming cursor of the table "qx_vEventsByHour" */
export type qx_vEventsByHour_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_vEventsByHour_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_vEventsByHour_stream_cursor_value_input = {
  eventCount?: number;
  hourOfDay?: string;
  path?: string;
};

/** aggregate sum on columns */
export type qx_vEventsByHour_sum_fields = {
  __typename?: 'qx_vEventsByHour_sum_fields';
  eventCount?: number;
};

/** aggregate var_pop on columns */
export type qx_vEventsByHour_var_pop_fields = {
  __typename?: 'qx_vEventsByHour_var_pop_fields';
  eventCount?: number;
};

/** aggregate var_samp on columns */
export type qx_vEventsByHour_var_samp_fields = {
  __typename?: 'qx_vEventsByHour_var_samp_fields';
  eventCount?: number;
};

/** aggregate variance on columns */
export type qx_vEventsByHour_variance_fields = {
  __typename?: 'qx_vEventsByHour_variance_fields';
  eventCount?: number;
};

/** columns and relationships of "qx.vNewestMedia" */
export type qx_vNewestMedia = {
  __typename?: 'qx_vNewestMedia';
  date?: string;
  type?: string;
};

/** aggregated selection of "qx.vNewestMedia" */
export type qx_vNewestMedia_aggregate = {
  __typename?: 'qx_vNewestMedia_aggregate';
  aggregate?: qx_vNewestMedia_aggregate_fields;
  nodes: Array<qx_vNewestMedia>;
};

/** aggregate fields of "qx.vNewestMedia" */
export type qx_vNewestMedia_aggregate_fields = {
  __typename?: 'qx_vNewestMedia_aggregate_fields';
  count: number;
  max?: qx_vNewestMedia_max_fields;
  min?: qx_vNewestMedia_min_fields;
};


/** aggregate fields of "qx.vNewestMedia" */
export type qx_vNewestMedia_aggregate_fieldscountArgs = {
  columns?: Array<qx_vNewestMedia_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.vNewestMedia" */
export type qx_vNewestMedia_aggregate_order_by = {
  count?: order_by;
  max?: qx_vNewestMedia_max_order_by;
  min?: qx_vNewestMedia_min_order_by;
};

/** Boolean expression to filter rows from the table "qx.vNewestMedia". All fields are combined with a logical 'AND'. */
export type qx_vNewestMedia_bool_exp = {
  _and?: Array<qx_vNewestMedia_bool_exp>;
  _not?: qx_vNewestMedia_bool_exp;
  _or?: Array<qx_vNewestMedia_bool_exp>;
  date?: timestamp_comparison_exp;
  type?: String_comparison_exp;
};

/** aggregate max on columns */
export type qx_vNewestMedia_max_fields = {
  __typename?: 'qx_vNewestMedia_max_fields';
  date?: string;
  type?: string;
};

/** order by max() on columns of table "qx.vNewestMedia" */
export type qx_vNewestMedia_max_order_by = {
  date?: order_by;
  type?: order_by;
};

/** aggregate min on columns */
export type qx_vNewestMedia_min_fields = {
  __typename?: 'qx_vNewestMedia_min_fields';
  date?: string;
  type?: string;
};

/** order by min() on columns of table "qx.vNewestMedia" */
export type qx_vNewestMedia_min_order_by = {
  date?: order_by;
  type?: order_by;
};

/** Ordering options when selecting data from "qx.vNewestMedia". */
export type qx_vNewestMedia_order_by = {
  date?: order_by;
  type?: order_by;
};

/** select columns of table "qx.vNewestMedia" */
export enum qx_vNewestMedia_select_column {
  /** column name */
  date = 'date',
  /** column name */
  type = 'type'
}

/** Streaming cursor of the table "qx_vNewestMedia" */
export type qx_vNewestMedia_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_vNewestMedia_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_vNewestMedia_stream_cursor_value_input = {
  date?: string;
  type?: string;
};

/** columns and relationships of "qx.vOldestMedia" */
export type qx_vOldestMedia = {
  __typename?: 'qx_vOldestMedia';
  date?: string;
  type?: string;
};

export type qx_vOldestMedia_aggregate = {
  __typename?: 'qx_vOldestMedia_aggregate';
  aggregate?: qx_vOldestMedia_aggregate_fields;
  nodes: Array<qx_vOldestMedia>;
};

/** aggregate fields of "qx.vOldestMedia" */
export type qx_vOldestMedia_aggregate_fields = {
  __typename?: 'qx_vOldestMedia_aggregate_fields';
  count: number;
  max?: qx_vOldestMedia_max_fields;
  min?: qx_vOldestMedia_min_fields;
};


/** aggregate fields of "qx.vOldestMedia" */
export type qx_vOldestMedia_aggregate_fieldscountArgs = {
  columns?: Array<qx_vOldestMedia_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.vOldestMedia" */
export type qx_vOldestMedia_aggregate_order_by = {
  count?: order_by;
  max?: qx_vOldestMedia_max_order_by;
  min?: qx_vOldestMedia_min_order_by;
};

/** Boolean expression to filter rows from the table "qx.vOldestMedia". All fields are combined with a logical 'AND'. */
export type qx_vOldestMedia_bool_exp = {
  _and?: Array<qx_vOldestMedia_bool_exp>;
  _not?: qx_vOldestMedia_bool_exp;
  _or?: Array<qx_vOldestMedia_bool_exp>;
  date?: timestamptz_comparison_exp;
  type?: String_comparison_exp;
};

/** aggregate max on columns */
export type qx_vOldestMedia_max_fields = {
  __typename?: 'qx_vOldestMedia_max_fields';
  date?: string;
  type?: string;
};

/** order by max() on columns of table "qx.vOldestMedia" */
export type qx_vOldestMedia_max_order_by = {
  date?: order_by;
  type?: order_by;
};

/** aggregate min on columns */
export type qx_vOldestMedia_min_fields = {
  __typename?: 'qx_vOldestMedia_min_fields';
  date?: string;
  type?: string;
};

/** order by min() on columns of table "qx.vOldestMedia" */
export type qx_vOldestMedia_min_order_by = {
  date?: order_by;
  type?: order_by;
};

/** Ordering options when selecting data from "qx.vOldestMedia". */
export type qx_vOldestMedia_order_by = {
  date?: order_by;
  type?: order_by;
};

/** select columns of table "qx.vOldestMedia" */
export enum qx_vOldestMedia_select_column {
  /** column name */
  date = 'date',
  /** column name */
  type = 'type'
}

/** Streaming cursor of the table "qx_vOldestMedia" */
export type qx_vOldestMedia_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_vOldestMedia_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_vOldestMedia_stream_cursor_value_input = {
  date?: string;
  type?: string;
};

/** columns and relationships of "qx.vPersonAccessHistory" */
export type qx_vPersonAccessHistory = {
  __typename?: 'qx_vPersonAccessHistory';
  /** An object relationship */
  door?: qx_Door;
  doorID?: string;
  /** An object relationship */
  person?: qx_Person;
  personID?: string;
  /** An object relationship */
  place?: qx_Place;
  placeID?: string;
  serverTime?: string;
  type?: string;
};

/** aggregated selection of "qx.vPersonAccessHistory" */
export type qx_vPersonAccessHistory_aggregate = {
  __typename?: 'qx_vPersonAccessHistory_aggregate';
  aggregate?: qx_vPersonAccessHistory_aggregate_fields;
  nodes: Array<qx_vPersonAccessHistory>;
};

/** aggregate fields of "qx.vPersonAccessHistory" */
export type qx_vPersonAccessHistory_aggregate_fields = {
  __typename?: 'qx_vPersonAccessHistory_aggregate_fields';
  avg?: qx_vPersonAccessHistory_avg_fields;
  count: number;
  max?: qx_vPersonAccessHistory_max_fields;
  min?: qx_vPersonAccessHistory_min_fields;
  stddev?: qx_vPersonAccessHistory_stddev_fields;
  stddev_pop?: qx_vPersonAccessHistory_stddev_pop_fields;
  stddev_samp?: qx_vPersonAccessHistory_stddev_samp_fields;
  sum?: qx_vPersonAccessHistory_sum_fields;
  var_pop?: qx_vPersonAccessHistory_var_pop_fields;
  var_samp?: qx_vPersonAccessHistory_var_samp_fields;
  variance?: qx_vPersonAccessHistory_variance_fields;
};


/** aggregate fields of "qx.vPersonAccessHistory" */
export type qx_vPersonAccessHistory_aggregate_fieldscountArgs = {
  columns?: Array<qx_vPersonAccessHistory_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.vPersonAccessHistory" */
export type qx_vPersonAccessHistory_aggregate_order_by = {
  avg?: qx_vPersonAccessHistory_avg_order_by;
  count?: order_by;
  max?: qx_vPersonAccessHistory_max_order_by;
  min?: qx_vPersonAccessHistory_min_order_by;
  stddev?: qx_vPersonAccessHistory_stddev_order_by;
  stddev_pop?: qx_vPersonAccessHistory_stddev_pop_order_by;
  stddev_samp?: qx_vPersonAccessHistory_stddev_samp_order_by;
  sum?: qx_vPersonAccessHistory_sum_order_by;
  var_pop?: qx_vPersonAccessHistory_var_pop_order_by;
  var_samp?: qx_vPersonAccessHistory_var_samp_order_by;
  variance?: qx_vPersonAccessHistory_variance_order_by;
};

/** aggregate avg on columns */
export type qx_vPersonAccessHistory_avg_fields = {
  __typename?: 'qx_vPersonAccessHistory_avg_fields';
  doorID?: number;
};

/** order by avg() on columns of table "qx.vPersonAccessHistory" */
export type qx_vPersonAccessHistory_avg_order_by = {
  doorID?: order_by;
};

/** Boolean expression to filter rows from the table "qx.vPersonAccessHistory". All fields are combined with a logical 'AND'. */
export type qx_vPersonAccessHistory_bool_exp = {
  _and?: Array<qx_vPersonAccessHistory_bool_exp>;
  _not?: qx_vPersonAccessHistory_bool_exp;
  _or?: Array<qx_vPersonAccessHistory_bool_exp>;
  door?: qx_Door_bool_exp;
  doorID?: bigint_comparison_exp;
  person?: qx_Person_bool_exp;
  personID?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
  serverTime?: timestamptz_comparison_exp;
  type?: String_comparison_exp;
};

/** aggregate max on columns */
export type qx_vPersonAccessHistory_max_fields = {
  __typename?: 'qx_vPersonAccessHistory_max_fields';
  doorID?: string;
  personID?: string;
  placeID?: string;
  serverTime?: string;
  type?: string;
};

/** order by max() on columns of table "qx.vPersonAccessHistory" */
export type qx_vPersonAccessHistory_max_order_by = {
  doorID?: order_by;
  personID?: order_by;
  placeID?: order_by;
  serverTime?: order_by;
  type?: order_by;
};

/** aggregate min on columns */
export type qx_vPersonAccessHistory_min_fields = {
  __typename?: 'qx_vPersonAccessHistory_min_fields';
  doorID?: string;
  personID?: string;
  placeID?: string;
  serverTime?: string;
  type?: string;
};

/** order by min() on columns of table "qx.vPersonAccessHistory" */
export type qx_vPersonAccessHistory_min_order_by = {
  doorID?: order_by;
  personID?: order_by;
  placeID?: order_by;
  serverTime?: order_by;
  type?: order_by;
};

/** Ordering options when selecting data from "qx.vPersonAccessHistory". */
export type qx_vPersonAccessHistory_order_by = {
  door?: qx_Door_order_by;
  doorID?: order_by;
  person?: qx_Person_order_by;
  personID?: order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
  serverTime?: order_by;
  type?: order_by;
};

/** select columns of table "qx.vPersonAccessHistory" */
export enum qx_vPersonAccessHistory_select_column {
  /** column name */
  doorID = 'doorID',
  /** column name */
  personID = 'personID',
  /** column name */
  placeID = 'placeID',
  /** column name */
  serverTime = 'serverTime',
  /** column name */
  type = 'type'
}

/** aggregate stddev on columns */
export type qx_vPersonAccessHistory_stddev_fields = {
  __typename?: 'qx_vPersonAccessHistory_stddev_fields';
  doorID?: number;
};

/** order by stddev() on columns of table "qx.vPersonAccessHistory" */
export type qx_vPersonAccessHistory_stddev_order_by = {
  doorID?: order_by;
};

/** aggregate stddev_pop on columns */
export type qx_vPersonAccessHistory_stddev_pop_fields = {
  __typename?: 'qx_vPersonAccessHistory_stddev_pop_fields';
  doorID?: number;
};

/** order by stddev_pop() on columns of table "qx.vPersonAccessHistory" */
export type qx_vPersonAccessHistory_stddev_pop_order_by = {
  doorID?: order_by;
};

/** aggregate stddev_samp on columns */
export type qx_vPersonAccessHistory_stddev_samp_fields = {
  __typename?: 'qx_vPersonAccessHistory_stddev_samp_fields';
  doorID?: number;
};

/** order by stddev_samp() on columns of table "qx.vPersonAccessHistory" */
export type qx_vPersonAccessHistory_stddev_samp_order_by = {
  doorID?: order_by;
};

/** Streaming cursor of the table "qx_vPersonAccessHistory" */
export type qx_vPersonAccessHistory_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_vPersonAccessHistory_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_vPersonAccessHistory_stream_cursor_value_input = {
  doorID?: string;
  personID?: string;
  placeID?: string;
  serverTime?: string;
  type?: string;
};

/** aggregate sum on columns */
export type qx_vPersonAccessHistory_sum_fields = {
  __typename?: 'qx_vPersonAccessHistory_sum_fields';
  doorID?: string;
};

/** order by sum() on columns of table "qx.vPersonAccessHistory" */
export type qx_vPersonAccessHistory_sum_order_by = {
  doorID?: order_by;
};

/** aggregate var_pop on columns */
export type qx_vPersonAccessHistory_var_pop_fields = {
  __typename?: 'qx_vPersonAccessHistory_var_pop_fields';
  doorID?: number;
};

/** order by var_pop() on columns of table "qx.vPersonAccessHistory" */
export type qx_vPersonAccessHistory_var_pop_order_by = {
  doorID?: order_by;
};

/** aggregate var_samp on columns */
export type qx_vPersonAccessHistory_var_samp_fields = {
  __typename?: 'qx_vPersonAccessHistory_var_samp_fields';
  doorID?: number;
};

/** order by var_samp() on columns of table "qx.vPersonAccessHistory" */
export type qx_vPersonAccessHistory_var_samp_order_by = {
  doorID?: order_by;
};

/** aggregate variance on columns */
export type qx_vPersonAccessHistory_variance_fields = {
  __typename?: 'qx_vPersonAccessHistory_variance_fields';
  doorID?: number;
};

/** order by variance() on columns of table "qx.vPersonAccessHistory" */
export type qx_vPersonAccessHistory_variance_order_by = {
  doorID?: order_by;
};

/** columns and relationships of "qx.vPlaceAiBillingSummary" */
export type qx_vPlaceAiBillingSummary = {
  __typename?: 'qx_vPlaceAiBillingSummary';
  billingPeriodEnd?: string;
  billingPeriodStart?: string;
  billingTier?: string;
  centsUsed?: number;
  monthlyTokenQuota?: number;
  overageBudgetCents?: number;
  overageCentsRemaining?: number;
  overageTokens?: number;
  /** An object relationship */
  place?: qx_Place;
  placeID?: string;
  queryPlaceID?: string;
  tokensRemaining?: number;
  tokensUsed?: number;
};

/** aggregated selection of "qx.vPlaceAiBillingSummary" */
export type qx_vPlaceAiBillingSummary_aggregate = {
  __typename?: 'qx_vPlaceAiBillingSummary_aggregate';
  aggregate?: qx_vPlaceAiBillingSummary_aggregate_fields;
  nodes: Array<qx_vPlaceAiBillingSummary>;
};

/** aggregate fields of "qx.vPlaceAiBillingSummary" */
export type qx_vPlaceAiBillingSummary_aggregate_fields = {
  __typename?: 'qx_vPlaceAiBillingSummary_aggregate_fields';
  avg?: qx_vPlaceAiBillingSummary_avg_fields;
  count: number;
  max?: qx_vPlaceAiBillingSummary_max_fields;
  min?: qx_vPlaceAiBillingSummary_min_fields;
  stddev?: qx_vPlaceAiBillingSummary_stddev_fields;
  stddev_pop?: qx_vPlaceAiBillingSummary_stddev_pop_fields;
  stddev_samp?: qx_vPlaceAiBillingSummary_stddev_samp_fields;
  sum?: qx_vPlaceAiBillingSummary_sum_fields;
  var_pop?: qx_vPlaceAiBillingSummary_var_pop_fields;
  var_samp?: qx_vPlaceAiBillingSummary_var_samp_fields;
  variance?: qx_vPlaceAiBillingSummary_variance_fields;
};


/** aggregate fields of "qx.vPlaceAiBillingSummary" */
export type qx_vPlaceAiBillingSummary_aggregate_fieldscountArgs = {
  columns?: Array<qx_vPlaceAiBillingSummary_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type qx_vPlaceAiBillingSummary_avg_fields = {
  __typename?: 'qx_vPlaceAiBillingSummary_avg_fields';
  centsUsed?: number;
  monthlyTokenQuota?: number;
  overageBudgetCents?: number;
  overageCentsRemaining?: number;
  overageTokens?: number;
  tokensRemaining?: number;
  tokensUsed?: number;
};

/** Boolean expression to filter rows from the table "qx.vPlaceAiBillingSummary". All fields are combined with a logical 'AND'. */
export type qx_vPlaceAiBillingSummary_bool_exp = {
  _and?: Array<qx_vPlaceAiBillingSummary_bool_exp>;
  _not?: qx_vPlaceAiBillingSummary_bool_exp;
  _or?: Array<qx_vPlaceAiBillingSummary_bool_exp>;
  billingPeriodEnd?: date_comparison_exp;
  billingPeriodStart?: date_comparison_exp;
  billingTier?: String_comparison_exp;
  centsUsed?: Int_comparison_exp;
  monthlyTokenQuota?: Int_comparison_exp;
  overageBudgetCents?: Int_comparison_exp;
  overageCentsRemaining?: Int_comparison_exp;
  overageTokens?: Int_comparison_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
  queryPlaceID?: String_comparison_exp;
  tokensRemaining?: Int_comparison_exp;
  tokensUsed?: Int_comparison_exp;
};

/** input type for inserting data into table "qx.vPlaceAiBillingSummary" */
export type qx_vPlaceAiBillingSummary_insert_input = {
  billingPeriodEnd?: string;
  billingPeriodStart?: string;
  billingTier?: string;
  centsUsed?: number;
  monthlyTokenQuota?: number;
  overageBudgetCents?: number;
  overageCentsRemaining?: number;
  overageTokens?: number;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
  queryPlaceID?: string;
  tokensRemaining?: number;
  tokensUsed?: number;
};

/** aggregate max on columns */
export type qx_vPlaceAiBillingSummary_max_fields = {
  __typename?: 'qx_vPlaceAiBillingSummary_max_fields';
  billingPeriodEnd?: string;
  billingPeriodStart?: string;
  billingTier?: string;
  centsUsed?: number;
  monthlyTokenQuota?: number;
  overageBudgetCents?: number;
  overageCentsRemaining?: number;
  overageTokens?: number;
  placeID?: string;
  queryPlaceID?: string;
  tokensRemaining?: number;
  tokensUsed?: number;
};

/** aggregate min on columns */
export type qx_vPlaceAiBillingSummary_min_fields = {
  __typename?: 'qx_vPlaceAiBillingSummary_min_fields';
  billingPeriodEnd?: string;
  billingPeriodStart?: string;
  billingTier?: string;
  centsUsed?: number;
  monthlyTokenQuota?: number;
  overageBudgetCents?: number;
  overageCentsRemaining?: number;
  overageTokens?: number;
  placeID?: string;
  queryPlaceID?: string;
  tokensRemaining?: number;
  tokensUsed?: number;
};

/** input type for inserting object relation for remote table "qx.vPlaceAiBillingSummary" */
export type qx_vPlaceAiBillingSummary_obj_rel_insert_input = {
  data: qx_vPlaceAiBillingSummary_insert_input;
};

/** Ordering options when selecting data from "qx.vPlaceAiBillingSummary". */
export type qx_vPlaceAiBillingSummary_order_by = {
  billingPeriodEnd?: order_by;
  billingPeriodStart?: order_by;
  billingTier?: order_by;
  centsUsed?: order_by;
  monthlyTokenQuota?: order_by;
  overageBudgetCents?: order_by;
  overageCentsRemaining?: order_by;
  overageTokens?: order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
  queryPlaceID?: order_by;
  tokensRemaining?: order_by;
  tokensUsed?: order_by;
};

/** select columns of table "qx.vPlaceAiBillingSummary" */
export enum qx_vPlaceAiBillingSummary_select_column {
  /** column name */
  billingPeriodEnd = 'billingPeriodEnd',
  /** column name */
  billingPeriodStart = 'billingPeriodStart',
  /** column name */
  billingTier = 'billingTier',
  /** column name */
  centsUsed = 'centsUsed',
  /** column name */
  monthlyTokenQuota = 'monthlyTokenQuota',
  /** column name */
  overageBudgetCents = 'overageBudgetCents',
  /** column name */
  overageCentsRemaining = 'overageCentsRemaining',
  /** column name */
  overageTokens = 'overageTokens',
  /** column name */
  placeID = 'placeID',
  /** column name */
  queryPlaceID = 'queryPlaceID',
  /** column name */
  tokensRemaining = 'tokensRemaining',
  /** column name */
  tokensUsed = 'tokensUsed'
}

/** aggregate stddev on columns */
export type qx_vPlaceAiBillingSummary_stddev_fields = {
  __typename?: 'qx_vPlaceAiBillingSummary_stddev_fields';
  centsUsed?: number;
  monthlyTokenQuota?: number;
  overageBudgetCents?: number;
  overageCentsRemaining?: number;
  overageTokens?: number;
  tokensRemaining?: number;
  tokensUsed?: number;
};

/** aggregate stddev_pop on columns */
export type qx_vPlaceAiBillingSummary_stddev_pop_fields = {
  __typename?: 'qx_vPlaceAiBillingSummary_stddev_pop_fields';
  centsUsed?: number;
  monthlyTokenQuota?: number;
  overageBudgetCents?: number;
  overageCentsRemaining?: number;
  overageTokens?: number;
  tokensRemaining?: number;
  tokensUsed?: number;
};

/** aggregate stddev_samp on columns */
export type qx_vPlaceAiBillingSummary_stddev_samp_fields = {
  __typename?: 'qx_vPlaceAiBillingSummary_stddev_samp_fields';
  centsUsed?: number;
  monthlyTokenQuota?: number;
  overageBudgetCents?: number;
  overageCentsRemaining?: number;
  overageTokens?: number;
  tokensRemaining?: number;
  tokensUsed?: number;
};

/** Streaming cursor of the table "qx_vPlaceAiBillingSummary" */
export type qx_vPlaceAiBillingSummary_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_vPlaceAiBillingSummary_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_vPlaceAiBillingSummary_stream_cursor_value_input = {
  billingPeriodEnd?: string;
  billingPeriodStart?: string;
  billingTier?: string;
  centsUsed?: number;
  monthlyTokenQuota?: number;
  overageBudgetCents?: number;
  overageCentsRemaining?: number;
  overageTokens?: number;
  placeID?: string;
  queryPlaceID?: string;
  tokensRemaining?: number;
  tokensUsed?: number;
};

/** aggregate sum on columns */
export type qx_vPlaceAiBillingSummary_sum_fields = {
  __typename?: 'qx_vPlaceAiBillingSummary_sum_fields';
  centsUsed?: number;
  monthlyTokenQuota?: number;
  overageBudgetCents?: number;
  overageCentsRemaining?: number;
  overageTokens?: number;
  tokensRemaining?: number;
  tokensUsed?: number;
};

/** aggregate var_pop on columns */
export type qx_vPlaceAiBillingSummary_var_pop_fields = {
  __typename?: 'qx_vPlaceAiBillingSummary_var_pop_fields';
  centsUsed?: number;
  monthlyTokenQuota?: number;
  overageBudgetCents?: number;
  overageCentsRemaining?: number;
  overageTokens?: number;
  tokensRemaining?: number;
  tokensUsed?: number;
};

/** aggregate var_samp on columns */
export type qx_vPlaceAiBillingSummary_var_samp_fields = {
  __typename?: 'qx_vPlaceAiBillingSummary_var_samp_fields';
  centsUsed?: number;
  monthlyTokenQuota?: number;
  overageBudgetCents?: number;
  overageCentsRemaining?: number;
  overageTokens?: number;
  tokensRemaining?: number;
  tokensUsed?: number;
};

/** aggregate variance on columns */
export type qx_vPlaceAiBillingSummary_variance_fields = {
  __typename?: 'qx_vPlaceAiBillingSummary_variance_fields';
  centsUsed?: number;
  monthlyTokenQuota?: number;
  overageBudgetCents?: number;
  overageCentsRemaining?: number;
  overageTokens?: number;
  tokensRemaining?: number;
  tokensUsed?: number;
};

/** columns and relationships of "qx.vPlaceHierarchy" */
export type qx_vPlaceHierarchy = {
  __typename?: 'qx_vPlaceHierarchy';
  name?: string;
};

export type qx_vPlaceHierarchy_aggregate = {
  __typename?: 'qx_vPlaceHierarchy_aggregate';
  aggregate?: qx_vPlaceHierarchy_aggregate_fields;
  nodes: Array<qx_vPlaceHierarchy>;
};

/** aggregate fields of "qx.vPlaceHierarchy" */
export type qx_vPlaceHierarchy_aggregate_fields = {
  __typename?: 'qx_vPlaceHierarchy_aggregate_fields';
  count: number;
  max?: qx_vPlaceHierarchy_max_fields;
  min?: qx_vPlaceHierarchy_min_fields;
};


/** aggregate fields of "qx.vPlaceHierarchy" */
export type qx_vPlaceHierarchy_aggregate_fieldscountArgs = {
  columns?: Array<qx_vPlaceHierarchy_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.vPlaceHierarchy" */
export type qx_vPlaceHierarchy_aggregate_order_by = {
  count?: order_by;
  max?: qx_vPlaceHierarchy_max_order_by;
  min?: qx_vPlaceHierarchy_min_order_by;
};

/** Boolean expression to filter rows from the table "qx.vPlaceHierarchy". All fields are combined with a logical 'AND'. */
export type qx_vPlaceHierarchy_bool_exp = {
  _and?: Array<qx_vPlaceHierarchy_bool_exp>;
  _not?: qx_vPlaceHierarchy_bool_exp;
  _or?: Array<qx_vPlaceHierarchy_bool_exp>;
  name?: String_comparison_exp;
};

/** aggregate max on columns */
export type qx_vPlaceHierarchy_max_fields = {
  __typename?: 'qx_vPlaceHierarchy_max_fields';
  name?: string;
};

/** order by max() on columns of table "qx.vPlaceHierarchy" */
export type qx_vPlaceHierarchy_max_order_by = {
  name?: order_by;
};

/** aggregate min on columns */
export type qx_vPlaceHierarchy_min_fields = {
  __typename?: 'qx_vPlaceHierarchy_min_fields';
  name?: string;
};

/** order by min() on columns of table "qx.vPlaceHierarchy" */
export type qx_vPlaceHierarchy_min_order_by = {
  name?: order_by;
};

/** Ordering options when selecting data from "qx.vPlaceHierarchy". */
export type qx_vPlaceHierarchy_order_by = {
  name?: order_by;
};

/** select columns of table "qx.vPlaceHierarchy" */
export enum qx_vPlaceHierarchy_select_column {
  /** column name */
  name = 'name'
}

/** Streaming cursor of the table "qx_vPlaceHierarchy" */
export type qx_vPlaceHierarchy_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_vPlaceHierarchy_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_vPlaceHierarchy_stream_cursor_value_input = {
  name?: string;
};

/** columns and relationships of "qx.vPlacePrivilege" */
export type qx_vPlacePrivilege = {
  __typename?: 'qx_vPlacePrivilege';
  AIAssistant?: string;
  AIBilling?: string;
  AccessReports?: string;
  Audit?: string;
  BandwidthConfig?: string;
  CameraConfig?: string;
  CameraOperator?: string;
  CameraView?: string;
  ClipManagement?: string;
  DeviceConfig?: string;
  DeviceOperator?: string;
  DeviceView?: string;
  DoorConfig?: string;
  DoorOperator?: string;
  DoorView?: string;
  GatewayConfig?: string;
  GatewayView?: string;
  IntrusionConfig?: string;
  IntrusionOperator?: string;
  IntrusionView?: string;
  LiveEvents?: string;
  LiveVideo?: string;
  LockDown?: string;
  PeopleConfig?: string;
  PeopleView?: string;
  PlaceConfig?: string;
  RecordedVideo?: string;
  RoleConfig?: string;
  RulesConfig?: string;
  RulesView?: string;
  ScheduleConfig?: string;
  Search?: string;
  Snapshots?: string;
  UserCreation?: string;
  View?: string;
  ViewConfig?: string;
  id?: string;
};

/** aggregated selection of "qx.vPlacePrivilege" */
export type qx_vPlacePrivilege_aggregate = {
  __typename?: 'qx_vPlacePrivilege_aggregate';
  aggregate?: qx_vPlacePrivilege_aggregate_fields;
  nodes: Array<qx_vPlacePrivilege>;
};

/** aggregate fields of "qx.vPlacePrivilege" */
export type qx_vPlacePrivilege_aggregate_fields = {
  __typename?: 'qx_vPlacePrivilege_aggregate_fields';
  avg?: qx_vPlacePrivilege_avg_fields;
  count: number;
  max?: qx_vPlacePrivilege_max_fields;
  min?: qx_vPlacePrivilege_min_fields;
  stddev?: qx_vPlacePrivilege_stddev_fields;
  stddev_pop?: qx_vPlacePrivilege_stddev_pop_fields;
  stddev_samp?: qx_vPlacePrivilege_stddev_samp_fields;
  sum?: qx_vPlacePrivilege_sum_fields;
  var_pop?: qx_vPlacePrivilege_var_pop_fields;
  var_samp?: qx_vPlacePrivilege_var_samp_fields;
  variance?: qx_vPlacePrivilege_variance_fields;
};


/** aggregate fields of "qx.vPlacePrivilege" */
export type qx_vPlacePrivilege_aggregate_fieldscountArgs = {
  columns?: Array<qx_vPlacePrivilege_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type qx_vPlacePrivilege_avg_fields = {
  __typename?: 'qx_vPlacePrivilege_avg_fields';
  AIAssistant?: number;
  AIBilling?: number;
  AccessReports?: number;
  Audit?: number;
  BandwidthConfig?: number;
  CameraConfig?: number;
  CameraOperator?: number;
  CameraView?: number;
  ClipManagement?: number;
  DeviceConfig?: number;
  DeviceOperator?: number;
  DeviceView?: number;
  DoorConfig?: number;
  DoorOperator?: number;
  DoorView?: number;
  GatewayConfig?: number;
  GatewayView?: number;
  IntrusionConfig?: number;
  IntrusionOperator?: number;
  IntrusionView?: number;
  LiveEvents?: number;
  LiveVideo?: number;
  LockDown?: number;
  PeopleConfig?: number;
  PeopleView?: number;
  PlaceConfig?: number;
  RecordedVideo?: number;
  RoleConfig?: number;
  RulesConfig?: number;
  RulesView?: number;
  ScheduleConfig?: number;
  Search?: number;
  Snapshots?: number;
  UserCreation?: number;
  View?: number;
  ViewConfig?: number;
};

/** Boolean expression to filter rows from the table "qx.vPlacePrivilege". All fields are combined with a logical 'AND'. */
export type qx_vPlacePrivilege_bool_exp = {
  AIAssistant?: bigint_comparison_exp;
  AIBilling?: bigint_comparison_exp;
  AccessReports?: bigint_comparison_exp;
  Audit?: bigint_comparison_exp;
  BandwidthConfig?: bigint_comparison_exp;
  CameraConfig?: bigint_comparison_exp;
  CameraOperator?: bigint_comparison_exp;
  CameraView?: bigint_comparison_exp;
  ClipManagement?: bigint_comparison_exp;
  DeviceConfig?: bigint_comparison_exp;
  DeviceOperator?: bigint_comparison_exp;
  DeviceView?: bigint_comparison_exp;
  DoorConfig?: bigint_comparison_exp;
  DoorOperator?: bigint_comparison_exp;
  DoorView?: bigint_comparison_exp;
  GatewayConfig?: bigint_comparison_exp;
  GatewayView?: bigint_comparison_exp;
  IntrusionConfig?: bigint_comparison_exp;
  IntrusionOperator?: bigint_comparison_exp;
  IntrusionView?: bigint_comparison_exp;
  LiveEvents?: bigint_comparison_exp;
  LiveVideo?: bigint_comparison_exp;
  LockDown?: bigint_comparison_exp;
  PeopleConfig?: bigint_comparison_exp;
  PeopleView?: bigint_comparison_exp;
  PlaceConfig?: bigint_comparison_exp;
  RecordedVideo?: bigint_comparison_exp;
  RoleConfig?: bigint_comparison_exp;
  RulesConfig?: bigint_comparison_exp;
  RulesView?: bigint_comparison_exp;
  ScheduleConfig?: bigint_comparison_exp;
  Search?: bigint_comparison_exp;
  Snapshots?: bigint_comparison_exp;
  UserCreation?: bigint_comparison_exp;
  View?: bigint_comparison_exp;
  ViewConfig?: bigint_comparison_exp;
  _and?: Array<qx_vPlacePrivilege_bool_exp>;
  _not?: qx_vPlacePrivilege_bool_exp;
  _or?: Array<qx_vPlacePrivilege_bool_exp>;
  id?: String_comparison_exp;
};

/** input type for incrementing numeric columns in table "qx.vPlacePrivilege" */
export type qx_vPlacePrivilege_inc_input = {
  AIAssistant?: string;
  AIBilling?: string;
  AccessReports?: string;
  Audit?: string;
  BandwidthConfig?: string;
  CameraConfig?: string;
  CameraOperator?: string;
  CameraView?: string;
  ClipManagement?: string;
  DeviceConfig?: string;
  DeviceOperator?: string;
  DeviceView?: string;
  DoorConfig?: string;
  DoorOperator?: string;
  DoorView?: string;
  GatewayConfig?: string;
  GatewayView?: string;
  IntrusionConfig?: string;
  IntrusionOperator?: string;
  IntrusionView?: string;
  LiveEvents?: string;
  LiveVideo?: string;
  LockDown?: string;
  PeopleConfig?: string;
  PeopleView?: string;
  PlaceConfig?: string;
  RecordedVideo?: string;
  RoleConfig?: string;
  RulesConfig?: string;
  RulesView?: string;
  ScheduleConfig?: string;
  Search?: string;
  Snapshots?: string;
  UserCreation?: string;
  View?: string;
  ViewConfig?: string;
};

/** input type for inserting data into table "qx.vPlacePrivilege" */
export type qx_vPlacePrivilege_insert_input = {
  AIAssistant?: string;
  AIBilling?: string;
  AccessReports?: string;
  Audit?: string;
  BandwidthConfig?: string;
  CameraConfig?: string;
  CameraOperator?: string;
  CameraView?: string;
  ClipManagement?: string;
  DeviceConfig?: string;
  DeviceOperator?: string;
  DeviceView?: string;
  DoorConfig?: string;
  DoorOperator?: string;
  DoorView?: string;
  GatewayConfig?: string;
  GatewayView?: string;
  IntrusionConfig?: string;
  IntrusionOperator?: string;
  IntrusionView?: string;
  LiveEvents?: string;
  LiveVideo?: string;
  LockDown?: string;
  PeopleConfig?: string;
  PeopleView?: string;
  PlaceConfig?: string;
  RecordedVideo?: string;
  RoleConfig?: string;
  RulesConfig?: string;
  RulesView?: string;
  ScheduleConfig?: string;
  Search?: string;
  Snapshots?: string;
  UserCreation?: string;
  View?: string;
  ViewConfig?: string;
  id?: string;
};

/** aggregate max on columns */
export type qx_vPlacePrivilege_max_fields = {
  __typename?: 'qx_vPlacePrivilege_max_fields';
  AIAssistant?: string;
  AIBilling?: string;
  AccessReports?: string;
  Audit?: string;
  BandwidthConfig?: string;
  CameraConfig?: string;
  CameraOperator?: string;
  CameraView?: string;
  ClipManagement?: string;
  DeviceConfig?: string;
  DeviceOperator?: string;
  DeviceView?: string;
  DoorConfig?: string;
  DoorOperator?: string;
  DoorView?: string;
  GatewayConfig?: string;
  GatewayView?: string;
  IntrusionConfig?: string;
  IntrusionOperator?: string;
  IntrusionView?: string;
  LiveEvents?: string;
  LiveVideo?: string;
  LockDown?: string;
  PeopleConfig?: string;
  PeopleView?: string;
  PlaceConfig?: string;
  RecordedVideo?: string;
  RoleConfig?: string;
  RulesConfig?: string;
  RulesView?: string;
  ScheduleConfig?: string;
  Search?: string;
  Snapshots?: string;
  UserCreation?: string;
  View?: string;
  ViewConfig?: string;
  id?: string;
};

/** aggregate min on columns */
export type qx_vPlacePrivilege_min_fields = {
  __typename?: 'qx_vPlacePrivilege_min_fields';
  AIAssistant?: string;
  AIBilling?: string;
  AccessReports?: string;
  Audit?: string;
  BandwidthConfig?: string;
  CameraConfig?: string;
  CameraOperator?: string;
  CameraView?: string;
  ClipManagement?: string;
  DeviceConfig?: string;
  DeviceOperator?: string;
  DeviceView?: string;
  DoorConfig?: string;
  DoorOperator?: string;
  DoorView?: string;
  GatewayConfig?: string;
  GatewayView?: string;
  IntrusionConfig?: string;
  IntrusionOperator?: string;
  IntrusionView?: string;
  LiveEvents?: string;
  LiveVideo?: string;
  LockDown?: string;
  PeopleConfig?: string;
  PeopleView?: string;
  PlaceConfig?: string;
  RecordedVideo?: string;
  RoleConfig?: string;
  RulesConfig?: string;
  RulesView?: string;
  ScheduleConfig?: string;
  Search?: string;
  Snapshots?: string;
  UserCreation?: string;
  View?: string;
  ViewConfig?: string;
  id?: string;
};

/** response of any mutation on the table "qx.vPlacePrivilege" */
export type qx_vPlacePrivilege_mutation_response = {
  __typename?: 'qx_vPlacePrivilege_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_vPlacePrivilege>;
};

/** input type for inserting object relation for remote table "qx.vPlacePrivilege" */
export type qx_vPlacePrivilege_obj_rel_insert_input = {
  data: qx_vPlacePrivilege_insert_input;
};

/** Ordering options when selecting data from "qx.vPlacePrivilege". */
export type qx_vPlacePrivilege_order_by = {
  AIAssistant?: order_by;
  AIBilling?: order_by;
  AccessReports?: order_by;
  Audit?: order_by;
  BandwidthConfig?: order_by;
  CameraConfig?: order_by;
  CameraOperator?: order_by;
  CameraView?: order_by;
  ClipManagement?: order_by;
  DeviceConfig?: order_by;
  DeviceOperator?: order_by;
  DeviceView?: order_by;
  DoorConfig?: order_by;
  DoorOperator?: order_by;
  DoorView?: order_by;
  GatewayConfig?: order_by;
  GatewayView?: order_by;
  IntrusionConfig?: order_by;
  IntrusionOperator?: order_by;
  IntrusionView?: order_by;
  LiveEvents?: order_by;
  LiveVideo?: order_by;
  LockDown?: order_by;
  PeopleConfig?: order_by;
  PeopleView?: order_by;
  PlaceConfig?: order_by;
  RecordedVideo?: order_by;
  RoleConfig?: order_by;
  RulesConfig?: order_by;
  RulesView?: order_by;
  ScheduleConfig?: order_by;
  Search?: order_by;
  Snapshots?: order_by;
  UserCreation?: order_by;
  View?: order_by;
  ViewConfig?: order_by;
  id?: order_by;
};

/** select columns of table "qx.vPlacePrivilege" */
export enum qx_vPlacePrivilege_select_column {
  /** column name */
  AIAssistant = 'AIAssistant',
  /** column name */
  AIBilling = 'AIBilling',
  /** column name */
  AccessReports = 'AccessReports',
  /** column name */
  Audit = 'Audit',
  /** column name */
  BandwidthConfig = 'BandwidthConfig',
  /** column name */
  CameraConfig = 'CameraConfig',
  /** column name */
  CameraOperator = 'CameraOperator',
  /** column name */
  CameraView = 'CameraView',
  /** column name */
  ClipManagement = 'ClipManagement',
  /** column name */
  DeviceConfig = 'DeviceConfig',
  /** column name */
  DeviceOperator = 'DeviceOperator',
  /** column name */
  DeviceView = 'DeviceView',
  /** column name */
  DoorConfig = 'DoorConfig',
  /** column name */
  DoorOperator = 'DoorOperator',
  /** column name */
  DoorView = 'DoorView',
  /** column name */
  GatewayConfig = 'GatewayConfig',
  /** column name */
  GatewayView = 'GatewayView',
  /** column name */
  IntrusionConfig = 'IntrusionConfig',
  /** column name */
  IntrusionOperator = 'IntrusionOperator',
  /** column name */
  IntrusionView = 'IntrusionView',
  /** column name */
  LiveEvents = 'LiveEvents',
  /** column name */
  LiveVideo = 'LiveVideo',
  /** column name */
  LockDown = 'LockDown',
  /** column name */
  PeopleConfig = 'PeopleConfig',
  /** column name */
  PeopleView = 'PeopleView',
  /** column name */
  PlaceConfig = 'PlaceConfig',
  /** column name */
  RecordedVideo = 'RecordedVideo',
  /** column name */
  RoleConfig = 'RoleConfig',
  /** column name */
  RulesConfig = 'RulesConfig',
  /** column name */
  RulesView = 'RulesView',
  /** column name */
  ScheduleConfig = 'ScheduleConfig',
  /** column name */
  Search = 'Search',
  /** column name */
  Snapshots = 'Snapshots',
  /** column name */
  UserCreation = 'UserCreation',
  /** column name */
  View = 'View',
  /** column name */
  ViewConfig = 'ViewConfig',
  /** column name */
  id = 'id'
}

/** input type for updating data in table "qx.vPlacePrivilege" */
export type qx_vPlacePrivilege_set_input = {
  AIAssistant?: string;
  AIBilling?: string;
  AccessReports?: string;
  Audit?: string;
  BandwidthConfig?: string;
  CameraConfig?: string;
  CameraOperator?: string;
  CameraView?: string;
  ClipManagement?: string;
  DeviceConfig?: string;
  DeviceOperator?: string;
  DeviceView?: string;
  DoorConfig?: string;
  DoorOperator?: string;
  DoorView?: string;
  GatewayConfig?: string;
  GatewayView?: string;
  IntrusionConfig?: string;
  IntrusionOperator?: string;
  IntrusionView?: string;
  LiveEvents?: string;
  LiveVideo?: string;
  LockDown?: string;
  PeopleConfig?: string;
  PeopleView?: string;
  PlaceConfig?: string;
  RecordedVideo?: string;
  RoleConfig?: string;
  RulesConfig?: string;
  RulesView?: string;
  ScheduleConfig?: string;
  Search?: string;
  Snapshots?: string;
  UserCreation?: string;
  View?: string;
  ViewConfig?: string;
  id?: string;
};

/** aggregate stddev on columns */
export type qx_vPlacePrivilege_stddev_fields = {
  __typename?: 'qx_vPlacePrivilege_stddev_fields';
  AIAssistant?: number;
  AIBilling?: number;
  AccessReports?: number;
  Audit?: number;
  BandwidthConfig?: number;
  CameraConfig?: number;
  CameraOperator?: number;
  CameraView?: number;
  ClipManagement?: number;
  DeviceConfig?: number;
  DeviceOperator?: number;
  DeviceView?: number;
  DoorConfig?: number;
  DoorOperator?: number;
  DoorView?: number;
  GatewayConfig?: number;
  GatewayView?: number;
  IntrusionConfig?: number;
  IntrusionOperator?: number;
  IntrusionView?: number;
  LiveEvents?: number;
  LiveVideo?: number;
  LockDown?: number;
  PeopleConfig?: number;
  PeopleView?: number;
  PlaceConfig?: number;
  RecordedVideo?: number;
  RoleConfig?: number;
  RulesConfig?: number;
  RulesView?: number;
  ScheduleConfig?: number;
  Search?: number;
  Snapshots?: number;
  UserCreation?: number;
  View?: number;
  ViewConfig?: number;
};

/** aggregate stddev_pop on columns */
export type qx_vPlacePrivilege_stddev_pop_fields = {
  __typename?: 'qx_vPlacePrivilege_stddev_pop_fields';
  AIAssistant?: number;
  AIBilling?: number;
  AccessReports?: number;
  Audit?: number;
  BandwidthConfig?: number;
  CameraConfig?: number;
  CameraOperator?: number;
  CameraView?: number;
  ClipManagement?: number;
  DeviceConfig?: number;
  DeviceOperator?: number;
  DeviceView?: number;
  DoorConfig?: number;
  DoorOperator?: number;
  DoorView?: number;
  GatewayConfig?: number;
  GatewayView?: number;
  IntrusionConfig?: number;
  IntrusionOperator?: number;
  IntrusionView?: number;
  LiveEvents?: number;
  LiveVideo?: number;
  LockDown?: number;
  PeopleConfig?: number;
  PeopleView?: number;
  PlaceConfig?: number;
  RecordedVideo?: number;
  RoleConfig?: number;
  RulesConfig?: number;
  RulesView?: number;
  ScheduleConfig?: number;
  Search?: number;
  Snapshots?: number;
  UserCreation?: number;
  View?: number;
  ViewConfig?: number;
};

/** aggregate stddev_samp on columns */
export type qx_vPlacePrivilege_stddev_samp_fields = {
  __typename?: 'qx_vPlacePrivilege_stddev_samp_fields';
  AIAssistant?: number;
  AIBilling?: number;
  AccessReports?: number;
  Audit?: number;
  BandwidthConfig?: number;
  CameraConfig?: number;
  CameraOperator?: number;
  CameraView?: number;
  ClipManagement?: number;
  DeviceConfig?: number;
  DeviceOperator?: number;
  DeviceView?: number;
  DoorConfig?: number;
  DoorOperator?: number;
  DoorView?: number;
  GatewayConfig?: number;
  GatewayView?: number;
  IntrusionConfig?: number;
  IntrusionOperator?: number;
  IntrusionView?: number;
  LiveEvents?: number;
  LiveVideo?: number;
  LockDown?: number;
  PeopleConfig?: number;
  PeopleView?: number;
  PlaceConfig?: number;
  RecordedVideo?: number;
  RoleConfig?: number;
  RulesConfig?: number;
  RulesView?: number;
  ScheduleConfig?: number;
  Search?: number;
  Snapshots?: number;
  UserCreation?: number;
  View?: number;
  ViewConfig?: number;
};

/** Streaming cursor of the table "qx_vPlacePrivilege" */
export type qx_vPlacePrivilege_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_vPlacePrivilege_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_vPlacePrivilege_stream_cursor_value_input = {
  AIAssistant?: string;
  AIBilling?: string;
  AccessReports?: string;
  Audit?: string;
  BandwidthConfig?: string;
  CameraConfig?: string;
  CameraOperator?: string;
  CameraView?: string;
  ClipManagement?: string;
  DeviceConfig?: string;
  DeviceOperator?: string;
  DeviceView?: string;
  DoorConfig?: string;
  DoorOperator?: string;
  DoorView?: string;
  GatewayConfig?: string;
  GatewayView?: string;
  IntrusionConfig?: string;
  IntrusionOperator?: string;
  IntrusionView?: string;
  LiveEvents?: string;
  LiveVideo?: string;
  LockDown?: string;
  PeopleConfig?: string;
  PeopleView?: string;
  PlaceConfig?: string;
  RecordedVideo?: string;
  RoleConfig?: string;
  RulesConfig?: string;
  RulesView?: string;
  ScheduleConfig?: string;
  Search?: string;
  Snapshots?: string;
  UserCreation?: string;
  View?: string;
  ViewConfig?: string;
  id?: string;
};

/** aggregate sum on columns */
export type qx_vPlacePrivilege_sum_fields = {
  __typename?: 'qx_vPlacePrivilege_sum_fields';
  AIAssistant?: string;
  AIBilling?: string;
  AccessReports?: string;
  Audit?: string;
  BandwidthConfig?: string;
  CameraConfig?: string;
  CameraOperator?: string;
  CameraView?: string;
  ClipManagement?: string;
  DeviceConfig?: string;
  DeviceOperator?: string;
  DeviceView?: string;
  DoorConfig?: string;
  DoorOperator?: string;
  DoorView?: string;
  GatewayConfig?: string;
  GatewayView?: string;
  IntrusionConfig?: string;
  IntrusionOperator?: string;
  IntrusionView?: string;
  LiveEvents?: string;
  LiveVideo?: string;
  LockDown?: string;
  PeopleConfig?: string;
  PeopleView?: string;
  PlaceConfig?: string;
  RecordedVideo?: string;
  RoleConfig?: string;
  RulesConfig?: string;
  RulesView?: string;
  ScheduleConfig?: string;
  Search?: string;
  Snapshots?: string;
  UserCreation?: string;
  View?: string;
  ViewConfig?: string;
};

export type qx_vPlacePrivilege_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qx_vPlacePrivilege_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_vPlacePrivilege_set_input;
  /** filter the rows which have to be updated */
  where: qx_vPlacePrivilege_bool_exp;
};

/** aggregate var_pop on columns */
export type qx_vPlacePrivilege_var_pop_fields = {
  __typename?: 'qx_vPlacePrivilege_var_pop_fields';
  AIAssistant?: number;
  AIBilling?: number;
  AccessReports?: number;
  Audit?: number;
  BandwidthConfig?: number;
  CameraConfig?: number;
  CameraOperator?: number;
  CameraView?: number;
  ClipManagement?: number;
  DeviceConfig?: number;
  DeviceOperator?: number;
  DeviceView?: number;
  DoorConfig?: number;
  DoorOperator?: number;
  DoorView?: number;
  GatewayConfig?: number;
  GatewayView?: number;
  IntrusionConfig?: number;
  IntrusionOperator?: number;
  IntrusionView?: number;
  LiveEvents?: number;
  LiveVideo?: number;
  LockDown?: number;
  PeopleConfig?: number;
  PeopleView?: number;
  PlaceConfig?: number;
  RecordedVideo?: number;
  RoleConfig?: number;
  RulesConfig?: number;
  RulesView?: number;
  ScheduleConfig?: number;
  Search?: number;
  Snapshots?: number;
  UserCreation?: number;
  View?: number;
  ViewConfig?: number;
};

/** aggregate var_samp on columns */
export type qx_vPlacePrivilege_var_samp_fields = {
  __typename?: 'qx_vPlacePrivilege_var_samp_fields';
  AIAssistant?: number;
  AIBilling?: number;
  AccessReports?: number;
  Audit?: number;
  BandwidthConfig?: number;
  CameraConfig?: number;
  CameraOperator?: number;
  CameraView?: number;
  ClipManagement?: number;
  DeviceConfig?: number;
  DeviceOperator?: number;
  DeviceView?: number;
  DoorConfig?: number;
  DoorOperator?: number;
  DoorView?: number;
  GatewayConfig?: number;
  GatewayView?: number;
  IntrusionConfig?: number;
  IntrusionOperator?: number;
  IntrusionView?: number;
  LiveEvents?: number;
  LiveVideo?: number;
  LockDown?: number;
  PeopleConfig?: number;
  PeopleView?: number;
  PlaceConfig?: number;
  RecordedVideo?: number;
  RoleConfig?: number;
  RulesConfig?: number;
  RulesView?: number;
  ScheduleConfig?: number;
  Search?: number;
  Snapshots?: number;
  UserCreation?: number;
  View?: number;
  ViewConfig?: number;
};

/** aggregate variance on columns */
export type qx_vPlacePrivilege_variance_fields = {
  __typename?: 'qx_vPlacePrivilege_variance_fields';
  AIAssistant?: number;
  AIBilling?: number;
  AccessReports?: number;
  Audit?: number;
  BandwidthConfig?: number;
  CameraConfig?: number;
  CameraOperator?: number;
  CameraView?: number;
  ClipManagement?: number;
  DeviceConfig?: number;
  DeviceOperator?: number;
  DeviceView?: number;
  DoorConfig?: number;
  DoorOperator?: number;
  DoorView?: number;
  GatewayConfig?: number;
  GatewayView?: number;
  IntrusionConfig?: number;
  IntrusionOperator?: number;
  IntrusionView?: number;
  LiveEvents?: number;
  LiveVideo?: number;
  LockDown?: number;
  PeopleConfig?: number;
  PeopleView?: number;
  PlaceConfig?: number;
  RecordedVideo?: number;
  RoleConfig?: number;
  RulesConfig?: number;
  RulesView?: number;
  ScheduleConfig?: number;
  Search?: number;
  Snapshots?: number;
  UserCreation?: number;
  View?: number;
  ViewConfig?: number;
};

/** columns and relationships of "qx.vProfiles" */
export type qx_vProfiles = {
  __typename?: 'qx_vProfiles';
  avatar?: string;
  avatar_lg?: string;
  avatar_md?: string;
  avatar_sm?: string;
  avatar_xl?: string;
  certification?: string;
  createdAt?: string;
  department?: string;
  email?: string;
  employeeID?: string;
  externalPersonID?: string;
  firstName?: string;
  id?: string;
  lastLogin?: string;
  lastName?: string;
  licensePlate?: string;
  lockdownImmunity?: boolean;
  phoneNumbers?: any;
  /** An object relationship */
  place?: qx_Place;
  placeID?: string;
  roleID?: string;
  salutation?: string;
  searchText?: string;
  suffix?: string;
  title?: string;
  updatedAt?: string;
};


/** columns and relationships of "qx.vProfiles" */
export type qx_vProfilesphoneNumbersArgs = {
  path?: string;
};

/** aggregated selection of "qx.vProfiles" */
export type qx_vProfiles_aggregate = {
  __typename?: 'qx_vProfiles_aggregate';
  aggregate?: qx_vProfiles_aggregate_fields;
  nodes: Array<qx_vProfiles>;
};

/** aggregate fields of "qx.vProfiles" */
export type qx_vProfiles_aggregate_fields = {
  __typename?: 'qx_vProfiles_aggregate_fields';
  count: number;
  max?: qx_vProfiles_max_fields;
  min?: qx_vProfiles_min_fields;
};


/** aggregate fields of "qx.vProfiles" */
export type qx_vProfiles_aggregate_fieldscountArgs = {
  columns?: Array<qx_vProfiles_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type qx_vProfiles_append_input = {
  phoneNumbers?: any;
};

/** Boolean expression to filter rows from the table "qx.vProfiles". All fields are combined with a logical 'AND'. */
export type qx_vProfiles_bool_exp = {
  _and?: Array<qx_vProfiles_bool_exp>;
  _not?: qx_vProfiles_bool_exp;
  _or?: Array<qx_vProfiles_bool_exp>;
  avatar?: String_comparison_exp;
  avatar_lg?: String_comparison_exp;
  avatar_md?: String_comparison_exp;
  avatar_sm?: String_comparison_exp;
  avatar_xl?: String_comparison_exp;
  certification?: String_comparison_exp;
  createdAt?: timestamptz_comparison_exp;
  department?: String_comparison_exp;
  email?: String_comparison_exp;
  employeeID?: String_comparison_exp;
  externalPersonID?: String_comparison_exp;
  firstName?: String_comparison_exp;
  id?: String_comparison_exp;
  lastLogin?: timestamptz_comparison_exp;
  lastName?: String_comparison_exp;
  licensePlate?: String_comparison_exp;
  lockdownImmunity?: Boolean_comparison_exp;
  phoneNumbers?: jsonb_comparison_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
  roleID?: String_comparison_exp;
  salutation?: String_comparison_exp;
  searchText?: String_comparison_exp;
  suffix?: String_comparison_exp;
  title?: String_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type qx_vProfiles_delete_at_path_input = {
  phoneNumbers?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type qx_vProfiles_delete_elem_input = {
  phoneNumbers?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type qx_vProfiles_delete_key_input = {
  phoneNumbers?: string;
};

/** input type for inserting data into table "qx.vProfiles" */
export type qx_vProfiles_insert_input = {
  avatar?: string;
  avatar_lg?: string;
  avatar_md?: string;
  avatar_sm?: string;
  avatar_xl?: string;
  certification?: string;
  createdAt?: string;
  department?: string;
  email?: string;
  employeeID?: string;
  externalPersonID?: string;
  firstName?: string;
  id?: string;
  lastLogin?: string;
  lastName?: string;
  licensePlate?: string;
  lockdownImmunity?: boolean;
  phoneNumbers?: any;
  place?: qx_Place_obj_rel_insert_input;
  placeID?: string;
  roleID?: string;
  salutation?: string;
  searchText?: string;
  suffix?: string;
  title?: string;
  updatedAt?: string;
};

/** aggregate max on columns */
export type qx_vProfiles_max_fields = {
  __typename?: 'qx_vProfiles_max_fields';
  avatar?: string;
  avatar_lg?: string;
  avatar_md?: string;
  avatar_sm?: string;
  avatar_xl?: string;
  certification?: string;
  createdAt?: string;
  department?: string;
  email?: string;
  employeeID?: string;
  externalPersonID?: string;
  firstName?: string;
  id?: string;
  lastLogin?: string;
  lastName?: string;
  licensePlate?: string;
  placeID?: string;
  roleID?: string;
  salutation?: string;
  searchText?: string;
  suffix?: string;
  title?: string;
  updatedAt?: string;
};

/** aggregate min on columns */
export type qx_vProfiles_min_fields = {
  __typename?: 'qx_vProfiles_min_fields';
  avatar?: string;
  avatar_lg?: string;
  avatar_md?: string;
  avatar_sm?: string;
  avatar_xl?: string;
  certification?: string;
  createdAt?: string;
  department?: string;
  email?: string;
  employeeID?: string;
  externalPersonID?: string;
  firstName?: string;
  id?: string;
  lastLogin?: string;
  lastName?: string;
  licensePlate?: string;
  placeID?: string;
  roleID?: string;
  salutation?: string;
  searchText?: string;
  suffix?: string;
  title?: string;
  updatedAt?: string;
};

/** response of any mutation on the table "qx.vProfiles" */
export type qx_vProfiles_mutation_response = {
  __typename?: 'qx_vProfiles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qx_vProfiles>;
};

/** Ordering options when selecting data from "qx.vProfiles". */
export type qx_vProfiles_order_by = {
  avatar?: order_by;
  avatar_lg?: order_by;
  avatar_md?: order_by;
  avatar_sm?: order_by;
  avatar_xl?: order_by;
  certification?: order_by;
  createdAt?: order_by;
  department?: order_by;
  email?: order_by;
  employeeID?: order_by;
  externalPersonID?: order_by;
  firstName?: order_by;
  id?: order_by;
  lastLogin?: order_by;
  lastName?: order_by;
  licensePlate?: order_by;
  lockdownImmunity?: order_by;
  phoneNumbers?: order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
  roleID?: order_by;
  salutation?: order_by;
  searchText?: order_by;
  suffix?: order_by;
  title?: order_by;
  updatedAt?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type qx_vProfiles_prepend_input = {
  phoneNumbers?: any;
};

/** select columns of table "qx.vProfiles" */
export enum qx_vProfiles_select_column {
  /** column name */
  avatar = 'avatar',
  /** column name */
  avatar_lg = 'avatar_lg',
  /** column name */
  avatar_md = 'avatar_md',
  /** column name */
  avatar_sm = 'avatar_sm',
  /** column name */
  avatar_xl = 'avatar_xl',
  /** column name */
  certification = 'certification',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  department = 'department',
  /** column name */
  email = 'email',
  /** column name */
  employeeID = 'employeeID',
  /** column name */
  externalPersonID = 'externalPersonID',
  /** column name */
  firstName = 'firstName',
  /** column name */
  id = 'id',
  /** column name */
  lastLogin = 'lastLogin',
  /** column name */
  lastName = 'lastName',
  /** column name */
  licensePlate = 'licensePlate',
  /** column name */
  lockdownImmunity = 'lockdownImmunity',
  /** column name */
  phoneNumbers = 'phoneNumbers',
  /** column name */
  placeID = 'placeID',
  /** column name */
  roleID = 'roleID',
  /** column name */
  salutation = 'salutation',
  /** column name */
  searchText = 'searchText',
  /** column name */
  suffix = 'suffix',
  /** column name */
  title = 'title',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "qx.vProfiles" */
export type qx_vProfiles_set_input = {
  avatar?: string;
  avatar_lg?: string;
  avatar_md?: string;
  avatar_sm?: string;
  avatar_xl?: string;
  certification?: string;
  createdAt?: string;
  department?: string;
  email?: string;
  employeeID?: string;
  externalPersonID?: string;
  firstName?: string;
  id?: string;
  lastLogin?: string;
  lastName?: string;
  licensePlate?: string;
  lockdownImmunity?: boolean;
  phoneNumbers?: any;
  placeID?: string;
  roleID?: string;
  salutation?: string;
  searchText?: string;
  suffix?: string;
  title?: string;
  updatedAt?: string;
};

/** Streaming cursor of the table "qx_vProfiles" */
export type qx_vProfiles_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_vProfiles_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_vProfiles_stream_cursor_value_input = {
  avatar?: string;
  avatar_lg?: string;
  avatar_md?: string;
  avatar_sm?: string;
  avatar_xl?: string;
  certification?: string;
  createdAt?: string;
  department?: string;
  email?: string;
  employeeID?: string;
  externalPersonID?: string;
  firstName?: string;
  id?: string;
  lastLogin?: string;
  lastName?: string;
  licensePlate?: string;
  lockdownImmunity?: boolean;
  phoneNumbers?: any;
  placeID?: string;
  roleID?: string;
  salutation?: string;
  searchText?: string;
  suffix?: string;
  title?: string;
  updatedAt?: string;
};

export type qx_vProfiles_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: qx_vProfiles_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: qx_vProfiles_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: qx_vProfiles_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: qx_vProfiles_delete_key_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: qx_vProfiles_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qx_vProfiles_set_input;
  /** filter the rows which have to be updated */
  where: qx_vProfiles_bool_exp;
};

/** columns and relationships of "qx.vSearchTimeline" */
export type qx_vSearchTimeline = {
  __typename?: 'qx_vSearchTimeline';
  eventCount?: number;
  /** An object relationship */
  place?: qx_Place;
  placeID?: string;
  priority?: number;
  timeBucket?: string;
  type?: string;
};

export type qx_vSearchTimeline_aggregate = {
  __typename?: 'qx_vSearchTimeline_aggregate';
  aggregate?: qx_vSearchTimeline_aggregate_fields;
  nodes: Array<qx_vSearchTimeline>;
};

/** aggregate fields of "qx.vSearchTimeline" */
export type qx_vSearchTimeline_aggregate_fields = {
  __typename?: 'qx_vSearchTimeline_aggregate_fields';
  avg?: qx_vSearchTimeline_avg_fields;
  count: number;
  max?: qx_vSearchTimeline_max_fields;
  min?: qx_vSearchTimeline_min_fields;
  stddev?: qx_vSearchTimeline_stddev_fields;
  stddev_pop?: qx_vSearchTimeline_stddev_pop_fields;
  stddev_samp?: qx_vSearchTimeline_stddev_samp_fields;
  sum?: qx_vSearchTimeline_sum_fields;
  var_pop?: qx_vSearchTimeline_var_pop_fields;
  var_samp?: qx_vSearchTimeline_var_samp_fields;
  variance?: qx_vSearchTimeline_variance_fields;
};


/** aggregate fields of "qx.vSearchTimeline" */
export type qx_vSearchTimeline_aggregate_fieldscountArgs = {
  columns?: Array<qx_vSearchTimeline_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type qx_vSearchTimeline_avg_fields = {
  __typename?: 'qx_vSearchTimeline_avg_fields';
  eventCount?: number;
  priority?: number;
};

/** Boolean expression to filter rows from the table "qx.vSearchTimeline". All fields are combined with a logical 'AND'. */
export type qx_vSearchTimeline_bool_exp = {
  _and?: Array<qx_vSearchTimeline_bool_exp>;
  _not?: qx_vSearchTimeline_bool_exp;
  _or?: Array<qx_vSearchTimeline_bool_exp>;
  eventCount?: Int_comparison_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
  priority?: Int_comparison_exp;
  timeBucket?: timestamptz_comparison_exp;
  type?: String_comparison_exp;
};

/** aggregate max on columns */
export type qx_vSearchTimeline_max_fields = {
  __typename?: 'qx_vSearchTimeline_max_fields';
  eventCount?: number;
  placeID?: string;
  priority?: number;
  timeBucket?: string;
  type?: string;
};

/** aggregate min on columns */
export type qx_vSearchTimeline_min_fields = {
  __typename?: 'qx_vSearchTimeline_min_fields';
  eventCount?: number;
  placeID?: string;
  priority?: number;
  timeBucket?: string;
  type?: string;
};

/** Ordering options when selecting data from "qx.vSearchTimeline". */
export type qx_vSearchTimeline_order_by = {
  eventCount?: order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
  priority?: order_by;
  timeBucket?: order_by;
  type?: order_by;
};

/** select columns of table "qx.vSearchTimeline" */
export enum qx_vSearchTimeline_select_column {
  /** column name */
  eventCount = 'eventCount',
  /** column name */
  placeID = 'placeID',
  /** column name */
  priority = 'priority',
  /** column name */
  timeBucket = 'timeBucket',
  /** column name */
  type = 'type'
}

/** aggregate stddev on columns */
export type qx_vSearchTimeline_stddev_fields = {
  __typename?: 'qx_vSearchTimeline_stddev_fields';
  eventCount?: number;
  priority?: number;
};

/** aggregate stddev_pop on columns */
export type qx_vSearchTimeline_stddev_pop_fields = {
  __typename?: 'qx_vSearchTimeline_stddev_pop_fields';
  eventCount?: number;
  priority?: number;
};

/** aggregate stddev_samp on columns */
export type qx_vSearchTimeline_stddev_samp_fields = {
  __typename?: 'qx_vSearchTimeline_stddev_samp_fields';
  eventCount?: number;
  priority?: number;
};

/** Streaming cursor of the table "qx_vSearchTimeline" */
export type qx_vSearchTimeline_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qx_vSearchTimeline_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qx_vSearchTimeline_stream_cursor_value_input = {
  eventCount?: number;
  placeID?: string;
  priority?: number;
  timeBucket?: string;
  type?: string;
};

/** aggregate sum on columns */
export type qx_vSearchTimeline_sum_fields = {
  __typename?: 'qx_vSearchTimeline_sum_fields';
  eventCount?: number;
  priority?: number;
};

/** aggregate var_pop on columns */
export type qx_vSearchTimeline_var_pop_fields = {
  __typename?: 'qx_vSearchTimeline_var_pop_fields';
  eventCount?: number;
  priority?: number;
};

/** aggregate var_samp on columns */
export type qx_vSearchTimeline_var_samp_fields = {
  __typename?: 'qx_vSearchTimeline_var_samp_fields';
  eventCount?: number;
  priority?: number;
};

/** aggregate variance on columns */
export type qx_vSearchTimeline_variance_fields = {
  __typename?: 'qx_vSearchTimeline_variance_fields';
  eventCount?: number;
  priority?: number;
};

export type qx_video_source_oldest_media_args = {
  video_source?: qx_VideoSource;
};

/** columns and relationships of "qxanalytics.CloudUsage" */
export type qxanalytics_CloudUsage = {
  __typename?: 'qxanalytics_CloudUsage';
  /** An object relationship */
  gateway?: qx_Gateway;
  gatewayID?: any;
  numClips?: number;
  recorded?: string;
  sizeClips?: string;
  /** An object relationship */
  videoSource?: qx_VideoSource;
  videoSourceID?: string;
};

/** aggregated selection of "qxanalytics.CloudUsage" */
export type qxanalytics_CloudUsage_aggregate = {
  __typename?: 'qxanalytics_CloudUsage_aggregate';
  aggregate?: qxanalytics_CloudUsage_aggregate_fields;
  nodes: Array<qxanalytics_CloudUsage>;
};

/** aggregate fields of "qxanalytics.CloudUsage" */
export type qxanalytics_CloudUsage_aggregate_fields = {
  __typename?: 'qxanalytics_CloudUsage_aggregate_fields';
  avg?: qxanalytics_CloudUsage_avg_fields;
  count: number;
  max?: qxanalytics_CloudUsage_max_fields;
  min?: qxanalytics_CloudUsage_min_fields;
  stddev?: qxanalytics_CloudUsage_stddev_fields;
  stddev_pop?: qxanalytics_CloudUsage_stddev_pop_fields;
  stddev_samp?: qxanalytics_CloudUsage_stddev_samp_fields;
  sum?: qxanalytics_CloudUsage_sum_fields;
  var_pop?: qxanalytics_CloudUsage_var_pop_fields;
  var_samp?: qxanalytics_CloudUsage_var_samp_fields;
  variance?: qxanalytics_CloudUsage_variance_fields;
};


/** aggregate fields of "qxanalytics.CloudUsage" */
export type qxanalytics_CloudUsage_aggregate_fieldscountArgs = {
  columns?: Array<qxanalytics_CloudUsage_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type qxanalytics_CloudUsage_avg_fields = {
  __typename?: 'qxanalytics_CloudUsage_avg_fields';
  numClips?: number;
  sizeClips?: number;
  videoSourceID?: number;
};

/** Boolean expression to filter rows from the table "qxanalytics.CloudUsage". All fields are combined with a logical 'AND'. */
export type qxanalytics_CloudUsage_bool_exp = {
  _and?: Array<qxanalytics_CloudUsage_bool_exp>;
  _not?: qxanalytics_CloudUsage_bool_exp;
  _or?: Array<qxanalytics_CloudUsage_bool_exp>;
  gateway?: qx_Gateway_bool_exp;
  gatewayID?: bpchar_comparison_exp;
  numClips?: Int_comparison_exp;
  recorded?: date_comparison_exp;
  sizeClips?: bigint_comparison_exp;
  videoSource?: qx_VideoSource_bool_exp;
  videoSourceID?: bigint_comparison_exp;
};

/** input type for incrementing numeric columns in table "qxanalytics.CloudUsage" */
export type qxanalytics_CloudUsage_inc_input = {
  numClips?: number;
  sizeClips?: string;
  videoSourceID?: string;
};

/** input type for inserting data into table "qxanalytics.CloudUsage" */
export type qxanalytics_CloudUsage_insert_input = {
  gateway?: qx_Gateway_obj_rel_insert_input;
  gatewayID?: any;
  numClips?: number;
  recorded?: string;
  sizeClips?: string;
  videoSource?: qx_VideoSource_obj_rel_insert_input;
  videoSourceID?: string;
};

/** aggregate max on columns */
export type qxanalytics_CloudUsage_max_fields = {
  __typename?: 'qxanalytics_CloudUsage_max_fields';
  gatewayID?: any;
  numClips?: number;
  recorded?: string;
  sizeClips?: string;
  videoSourceID?: string;
};

/** aggregate min on columns */
export type qxanalytics_CloudUsage_min_fields = {
  __typename?: 'qxanalytics_CloudUsage_min_fields';
  gatewayID?: any;
  numClips?: number;
  recorded?: string;
  sizeClips?: string;
  videoSourceID?: string;
};

/** response of any mutation on the table "qxanalytics.CloudUsage" */
export type qxanalytics_CloudUsage_mutation_response = {
  __typename?: 'qxanalytics_CloudUsage_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<qxanalytics_CloudUsage>;
};

/** Ordering options when selecting data from "qxanalytics.CloudUsage". */
export type qxanalytics_CloudUsage_order_by = {
  gateway?: qx_Gateway_order_by;
  gatewayID?: order_by;
  numClips?: order_by;
  recorded?: order_by;
  sizeClips?: order_by;
  videoSource?: qx_VideoSource_order_by;
  videoSourceID?: order_by;
};

/** select columns of table "qxanalytics.CloudUsage" */
export enum qxanalytics_CloudUsage_select_column {
  /** column name */
  gatewayID = 'gatewayID',
  /** column name */
  numClips = 'numClips',
  /** column name */
  recorded = 'recorded',
  /** column name */
  sizeClips = 'sizeClips',
  /** column name */
  videoSourceID = 'videoSourceID'
}

/** input type for updating data in table "qxanalytics.CloudUsage" */
export type qxanalytics_CloudUsage_set_input = {
  gatewayID?: any;
  numClips?: number;
  recorded?: string;
  sizeClips?: string;
  videoSourceID?: string;
};

/** aggregate stddev on columns */
export type qxanalytics_CloudUsage_stddev_fields = {
  __typename?: 'qxanalytics_CloudUsage_stddev_fields';
  numClips?: number;
  sizeClips?: number;
  videoSourceID?: number;
};

/** aggregate stddev_pop on columns */
export type qxanalytics_CloudUsage_stddev_pop_fields = {
  __typename?: 'qxanalytics_CloudUsage_stddev_pop_fields';
  numClips?: number;
  sizeClips?: number;
  videoSourceID?: number;
};

/** aggregate stddev_samp on columns */
export type qxanalytics_CloudUsage_stddev_samp_fields = {
  __typename?: 'qxanalytics_CloudUsage_stddev_samp_fields';
  numClips?: number;
  sizeClips?: number;
  videoSourceID?: number;
};

/** Streaming cursor of the table "qxanalytics_CloudUsage" */
export type qxanalytics_CloudUsage_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: qxanalytics_CloudUsage_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type qxanalytics_CloudUsage_stream_cursor_value_input = {
  gatewayID?: any;
  numClips?: number;
  recorded?: string;
  sizeClips?: string;
  videoSourceID?: string;
};

/** aggregate sum on columns */
export type qxanalytics_CloudUsage_sum_fields = {
  __typename?: 'qxanalytics_CloudUsage_sum_fields';
  numClips?: number;
  sizeClips?: string;
  videoSourceID?: string;
};

export type qxanalytics_CloudUsage_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: qxanalytics_CloudUsage_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: qxanalytics_CloudUsage_set_input;
  /** filter the rows which have to be updated */
  where: qxanalytics_CloudUsage_bool_exp;
};

/** aggregate var_pop on columns */
export type qxanalytics_CloudUsage_var_pop_fields = {
  __typename?: 'qxanalytics_CloudUsage_var_pop_fields';
  numClips?: number;
  sizeClips?: number;
  videoSourceID?: number;
};

/** aggregate var_samp on columns */
export type qxanalytics_CloudUsage_var_samp_fields = {
  __typename?: 'qxanalytics_CloudUsage_var_samp_fields';
  numClips?: number;
  sizeClips?: number;
  videoSourceID?: number;
};

/** aggregate variance on columns */
export type qxanalytics_CloudUsage_variance_fields = {
  __typename?: 'qxanalytics_CloudUsage_variance_fields';
  numClips?: number;
  sizeClips?: number;
  videoSourceID?: number;
};

/** columns and relationships of "qx.ReaderAccessTypeCompatibility" */
export type readerAccessTypeCompatibility = {
  __typename?: 'readerAccessTypeCompatibility';
  /** An object relationship */
  eAccessMake: qx_eAccessMake;
  /** An object relationship */
  eReaderAccessType: qx_eReaderAccessType;
  id: number;
  panel: qx_eAccessMake_enum;
  type: qx_eReaderAccessType_enum;
};

/** aggregated selection of "qx.ReaderAccessTypeCompatibility" */
export type readerAccessTypeCompatibility_aggregate = {
  __typename?: 'readerAccessTypeCompatibility_aggregate';
  aggregate?: readerAccessTypeCompatibility_aggregate_fields;
  nodes: Array<readerAccessTypeCompatibility>;
};

export type readerAccessTypeCompatibility_aggregate_bool_exp = {
  count?: readerAccessTypeCompatibility_aggregate_bool_exp_count;
};

export type readerAccessTypeCompatibility_aggregate_bool_exp_count = {
  arguments?: Array<readerAccessTypeCompatibility_select_column>;
  distinct?: boolean;
  filter?: readerAccessTypeCompatibility_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.ReaderAccessTypeCompatibility" */
export type readerAccessTypeCompatibility_aggregate_fields = {
  __typename?: 'readerAccessTypeCompatibility_aggregate_fields';
  avg?: readerAccessTypeCompatibility_avg_fields;
  count: number;
  max?: readerAccessTypeCompatibility_max_fields;
  min?: readerAccessTypeCompatibility_min_fields;
  stddev?: readerAccessTypeCompatibility_stddev_fields;
  stddev_pop?: readerAccessTypeCompatibility_stddev_pop_fields;
  stddev_samp?: readerAccessTypeCompatibility_stddev_samp_fields;
  sum?: readerAccessTypeCompatibility_sum_fields;
  var_pop?: readerAccessTypeCompatibility_var_pop_fields;
  var_samp?: readerAccessTypeCompatibility_var_samp_fields;
  variance?: readerAccessTypeCompatibility_variance_fields;
};


/** aggregate fields of "qx.ReaderAccessTypeCompatibility" */
export type readerAccessTypeCompatibility_aggregate_fieldscountArgs = {
  columns?: Array<readerAccessTypeCompatibility_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.ReaderAccessTypeCompatibility" */
export type readerAccessTypeCompatibility_aggregate_order_by = {
  avg?: readerAccessTypeCompatibility_avg_order_by;
  count?: order_by;
  max?: readerAccessTypeCompatibility_max_order_by;
  min?: readerAccessTypeCompatibility_min_order_by;
  stddev?: readerAccessTypeCompatibility_stddev_order_by;
  stddev_pop?: readerAccessTypeCompatibility_stddev_pop_order_by;
  stddev_samp?: readerAccessTypeCompatibility_stddev_samp_order_by;
  sum?: readerAccessTypeCompatibility_sum_order_by;
  var_pop?: readerAccessTypeCompatibility_var_pop_order_by;
  var_samp?: readerAccessTypeCompatibility_var_samp_order_by;
  variance?: readerAccessTypeCompatibility_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.ReaderAccessTypeCompatibility" */
export type readerAccessTypeCompatibility_arr_rel_insert_input = {
  data: Array<readerAccessTypeCompatibility_insert_input>;
  /** upsert condition */
  on_conflict?: readerAccessTypeCompatibility_on_conflict;
};

/** aggregate avg on columns */
export type readerAccessTypeCompatibility_avg_fields = {
  __typename?: 'readerAccessTypeCompatibility_avg_fields';
  id?: number;
};

/** order by avg() on columns of table "qx.ReaderAccessTypeCompatibility" */
export type readerAccessTypeCompatibility_avg_order_by = {
  id?: order_by;
};

/** Boolean expression to filter rows from the table "qx.ReaderAccessTypeCompatibility". All fields are combined with a logical 'AND'. */
export type readerAccessTypeCompatibility_bool_exp = {
  _and?: Array<readerAccessTypeCompatibility_bool_exp>;
  _not?: readerAccessTypeCompatibility_bool_exp;
  _or?: Array<readerAccessTypeCompatibility_bool_exp>;
  eAccessMake?: qx_eAccessMake_bool_exp;
  eReaderAccessType?: qx_eReaderAccessType_bool_exp;
  id?: Int_comparison_exp;
  panel?: qx_eAccessMake_enum_comparison_exp;
  type?: qx_eReaderAccessType_enum_comparison_exp;
};

/** unique or primary key constraints on table "qx.ReaderAccessTypeCompatibility" */
export enum readerAccessTypeCompatibility_constraint {
  /** unique or primary key constraint on columns "id" */
  ReaderAccessTypeCompatibility_pkey = 'ReaderAccessTypeCompatibility_pkey',
  /** unique or primary key constraint on columns "type", "panel" */
  ReaderAccessTypeCompatibility_type_panel_key = 'ReaderAccessTypeCompatibility_type_panel_key'
}

/** input type for incrementing numeric columns in table "qx.ReaderAccessTypeCompatibility" */
export type readerAccessTypeCompatibility_inc_input = {
  id?: number;
};

/** input type for inserting data into table "qx.ReaderAccessTypeCompatibility" */
export type readerAccessTypeCompatibility_insert_input = {
  eAccessMake?: qx_eAccessMake_obj_rel_insert_input;
  eReaderAccessType?: qx_eReaderAccessType_obj_rel_insert_input;
  id?: number;
  panel?: qx_eAccessMake_enum;
  type?: qx_eReaderAccessType_enum;
};

/** aggregate max on columns */
export type readerAccessTypeCompatibility_max_fields = {
  __typename?: 'readerAccessTypeCompatibility_max_fields';
  id?: number;
};

/** order by max() on columns of table "qx.ReaderAccessTypeCompatibility" */
export type readerAccessTypeCompatibility_max_order_by = {
  id?: order_by;
};

/** aggregate min on columns */
export type readerAccessTypeCompatibility_min_fields = {
  __typename?: 'readerAccessTypeCompatibility_min_fields';
  id?: number;
};

/** order by min() on columns of table "qx.ReaderAccessTypeCompatibility" */
export type readerAccessTypeCompatibility_min_order_by = {
  id?: order_by;
};

/** response of any mutation on the table "qx.ReaderAccessTypeCompatibility" */
export type readerAccessTypeCompatibility_mutation_response = {
  __typename?: 'readerAccessTypeCompatibility_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<readerAccessTypeCompatibility>;
};

/** on_conflict condition type for table "qx.ReaderAccessTypeCompatibility" */
export type readerAccessTypeCompatibility_on_conflict = {
  constraint: readerAccessTypeCompatibility_constraint;
  update_columns?: Array<readerAccessTypeCompatibility_update_column>;
  where?: readerAccessTypeCompatibility_bool_exp;
};

/** Ordering options when selecting data from "qx.ReaderAccessTypeCompatibility". */
export type readerAccessTypeCompatibility_order_by = {
  eAccessMake?: qx_eAccessMake_order_by;
  eReaderAccessType?: qx_eReaderAccessType_order_by;
  id?: order_by;
  panel?: order_by;
  type?: order_by;
};

/** primary key columns input for table: qx.ReaderAccessTypeCompatibility */
export type readerAccessTypeCompatibility_pk_columns_input = {
  id: number;
};

/** select columns of table "qx.ReaderAccessTypeCompatibility" */
export enum readerAccessTypeCompatibility_select_column {
  /** column name */
  id = 'id',
  /** column name */
  panel = 'panel',
  /** column name */
  type = 'type'
}

/** input type for updating data in table "qx.ReaderAccessTypeCompatibility" */
export type readerAccessTypeCompatibility_set_input = {
  id?: number;
  panel?: qx_eAccessMake_enum;
  type?: qx_eReaderAccessType_enum;
};

/** aggregate stddev on columns */
export type readerAccessTypeCompatibility_stddev_fields = {
  __typename?: 'readerAccessTypeCompatibility_stddev_fields';
  id?: number;
};

/** order by stddev() on columns of table "qx.ReaderAccessTypeCompatibility" */
export type readerAccessTypeCompatibility_stddev_order_by = {
  id?: order_by;
};

/** aggregate stddev_pop on columns */
export type readerAccessTypeCompatibility_stddev_pop_fields = {
  __typename?: 'readerAccessTypeCompatibility_stddev_pop_fields';
  id?: number;
};

/** order by stddev_pop() on columns of table "qx.ReaderAccessTypeCompatibility" */
export type readerAccessTypeCompatibility_stddev_pop_order_by = {
  id?: order_by;
};

/** aggregate stddev_samp on columns */
export type readerAccessTypeCompatibility_stddev_samp_fields = {
  __typename?: 'readerAccessTypeCompatibility_stddev_samp_fields';
  id?: number;
};

/** order by stddev_samp() on columns of table "qx.ReaderAccessTypeCompatibility" */
export type readerAccessTypeCompatibility_stddev_samp_order_by = {
  id?: order_by;
};

/** Streaming cursor of the table "readerAccessTypeCompatibility" */
export type readerAccessTypeCompatibility_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: readerAccessTypeCompatibility_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type readerAccessTypeCompatibility_stream_cursor_value_input = {
  id?: number;
  panel?: qx_eAccessMake_enum;
  type?: qx_eReaderAccessType_enum;
};

/** aggregate sum on columns */
export type readerAccessTypeCompatibility_sum_fields = {
  __typename?: 'readerAccessTypeCompatibility_sum_fields';
  id?: number;
};

/** order by sum() on columns of table "qx.ReaderAccessTypeCompatibility" */
export type readerAccessTypeCompatibility_sum_order_by = {
  id?: order_by;
};

/** update columns of table "qx.ReaderAccessTypeCompatibility" */
export enum readerAccessTypeCompatibility_update_column {
  /** column name */
  id = 'id',
  /** column name */
  panel = 'panel',
  /** column name */
  type = 'type'
}

export type readerAccessTypeCompatibility_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: readerAccessTypeCompatibility_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: readerAccessTypeCompatibility_set_input;
  /** filter the rows which have to be updated */
  where: readerAccessTypeCompatibility_bool_exp;
};

/** aggregate var_pop on columns */
export type readerAccessTypeCompatibility_var_pop_fields = {
  __typename?: 'readerAccessTypeCompatibility_var_pop_fields';
  id?: number;
};

/** order by var_pop() on columns of table "qx.ReaderAccessTypeCompatibility" */
export type readerAccessTypeCompatibility_var_pop_order_by = {
  id?: order_by;
};

/** aggregate var_samp on columns */
export type readerAccessTypeCompatibility_var_samp_fields = {
  __typename?: 'readerAccessTypeCompatibility_var_samp_fields';
  id?: number;
};

/** order by var_samp() on columns of table "qx.ReaderAccessTypeCompatibility" */
export type readerAccessTypeCompatibility_var_samp_order_by = {
  id?: order_by;
};

/** aggregate variance on columns */
export type readerAccessTypeCompatibility_variance_fields = {
  __typename?: 'readerAccessTypeCompatibility_variance_fields';
  id?: number;
};

/** order by variance() on columns of table "qx.ReaderAccessTypeCompatibility" */
export type readerAccessTypeCompatibility_variance_order_by = {
  id?: order_by;
};

/** audit view tracking historical changes to reader hardware configurations */
export type readerAudit = {
  __typename?: 'readerAudit';
  action?: string;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  /** An object relationship */
  reader?: qx_Reader;
  row_data?: any;
  time?: string;
};


/** audit view tracking historical changes to reader hardware configurations */
export type readerAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes to reader hardware configurations */
export type readerAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.vReaderAudit" */
export type readerAudit_aggregate = {
  __typename?: 'readerAudit_aggregate';
  aggregate?: readerAudit_aggregate_fields;
  nodes: Array<readerAudit>;
};

/** aggregate fields of "audit.vReaderAudit" */
export type readerAudit_aggregate_fields = {
  __typename?: 'readerAudit_aggregate_fields';
  avg?: readerAudit_avg_fields;
  count: number;
  max?: readerAudit_max_fields;
  min?: readerAudit_min_fields;
  stddev?: readerAudit_stddev_fields;
  stddev_pop?: readerAudit_stddev_pop_fields;
  stddev_samp?: readerAudit_stddev_samp_fields;
  sum?: readerAudit_sum_fields;
  var_pop?: readerAudit_var_pop_fields;
  var_samp?: readerAudit_var_samp_fields;
  variance?: readerAudit_variance_fields;
};


/** aggregate fields of "audit.vReaderAudit" */
export type readerAudit_aggregate_fieldscountArgs = {
  columns?: Array<readerAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type readerAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type readerAudit_avg_fields = {
  __typename?: 'readerAudit_avg_fields';
  auditID?: number;
};

/** Boolean expression to filter rows from the table "audit.vReaderAudit". All fields are combined with a logical 'AND'. */
export type readerAudit_bool_exp = {
  _and?: Array<readerAudit_bool_exp>;
  _not?: readerAudit_bool_exp;
  _or?: Array<readerAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  id?: String_comparison_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  reader?: qx_Reader_bool_exp;
  row_data?: jsonb_comparison_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type readerAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type readerAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type readerAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.vReaderAudit" */
export type readerAudit_inc_input = {
  auditID?: string;
};

/** input type for inserting data into table "audit.vReaderAudit" */
export type readerAudit_insert_input = {
  action?: string;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  reader?: qx_Reader_obj_rel_insert_input;
  row_data?: any;
  time?: string;
};

/** aggregate max on columns */
export type readerAudit_max_fields = {
  __typename?: 'readerAudit_max_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** aggregate min on columns */
export type readerAudit_min_fields = {
  __typename?: 'readerAudit_min_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** response of any mutation on the table "audit.vReaderAudit" */
export type readerAudit_mutation_response = {
  __typename?: 'readerAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<readerAudit>;
};

/** Ordering options when selecting data from "audit.vReaderAudit". */
export type readerAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  id?: order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  reader?: qx_Reader_order_by;
  row_data?: order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type readerAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.vReaderAudit" */
export enum readerAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  id = 'id',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.vReaderAudit" */
export type readerAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type readerAudit_stddev_fields = {
  __typename?: 'readerAudit_stddev_fields';
  auditID?: number;
};

/** aggregate stddev_pop on columns */
export type readerAudit_stddev_pop_fields = {
  __typename?: 'readerAudit_stddev_pop_fields';
  auditID?: number;
};

/** aggregate stddev_samp on columns */
export type readerAudit_stddev_samp_fields = {
  __typename?: 'readerAudit_stddev_samp_fields';
  auditID?: number;
};

/** Streaming cursor of the table "readerAudit" */
export type readerAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: readerAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type readerAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type readerAudit_sum_fields = {
  __typename?: 'readerAudit_sum_fields';
  auditID?: string;
};

export type readerAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: readerAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: readerAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: readerAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: readerAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: readerAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: readerAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: readerAudit_set_input;
  /** filter the rows which have to be updated */
  where: readerAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type readerAudit_var_pop_fields = {
  __typename?: 'readerAudit_var_pop_fields';
  auditID?: number;
};

/** aggregate var_samp on columns */
export type readerAudit_var_samp_fields = {
  __typename?: 'readerAudit_var_samp_fields';
  auditID?: number;
};

/** aggregate variance on columns */
export type readerAudit_variance_fields = {
  __typename?: 'readerAudit_variance_fields';
  auditID?: number;
};

/** columns and relationships of "qx.ReaderProtocolCompatibility" */
export type readerProtocolCompatibility = {
  __typename?: 'readerProtocolCompatibility';
  /** An object relationship */
  eAccessMake: qx_eAccessMake;
  /** An object relationship */
  eReaderProtocol: qx_eReaderProtocol;
  id: number;
  panel: qx_eAccessMake_enum;
  type: qx_eReaderProtocol_enum;
};

/** aggregated selection of "qx.ReaderProtocolCompatibility" */
export type readerProtocolCompatibility_aggregate = {
  __typename?: 'readerProtocolCompatibility_aggregate';
  aggregate?: readerProtocolCompatibility_aggregate_fields;
  nodes: Array<readerProtocolCompatibility>;
};

export type readerProtocolCompatibility_aggregate_bool_exp = {
  count?: readerProtocolCompatibility_aggregate_bool_exp_count;
};

export type readerProtocolCompatibility_aggregate_bool_exp_count = {
  arguments?: Array<readerProtocolCompatibility_select_column>;
  distinct?: boolean;
  filter?: readerProtocolCompatibility_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.ReaderProtocolCompatibility" */
export type readerProtocolCompatibility_aggregate_fields = {
  __typename?: 'readerProtocolCompatibility_aggregate_fields';
  avg?: readerProtocolCompatibility_avg_fields;
  count: number;
  max?: readerProtocolCompatibility_max_fields;
  min?: readerProtocolCompatibility_min_fields;
  stddev?: readerProtocolCompatibility_stddev_fields;
  stddev_pop?: readerProtocolCompatibility_stddev_pop_fields;
  stddev_samp?: readerProtocolCompatibility_stddev_samp_fields;
  sum?: readerProtocolCompatibility_sum_fields;
  var_pop?: readerProtocolCompatibility_var_pop_fields;
  var_samp?: readerProtocolCompatibility_var_samp_fields;
  variance?: readerProtocolCompatibility_variance_fields;
};


/** aggregate fields of "qx.ReaderProtocolCompatibility" */
export type readerProtocolCompatibility_aggregate_fieldscountArgs = {
  columns?: Array<readerProtocolCompatibility_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.ReaderProtocolCompatibility" */
export type readerProtocolCompatibility_aggregate_order_by = {
  avg?: readerProtocolCompatibility_avg_order_by;
  count?: order_by;
  max?: readerProtocolCompatibility_max_order_by;
  min?: readerProtocolCompatibility_min_order_by;
  stddev?: readerProtocolCompatibility_stddev_order_by;
  stddev_pop?: readerProtocolCompatibility_stddev_pop_order_by;
  stddev_samp?: readerProtocolCompatibility_stddev_samp_order_by;
  sum?: readerProtocolCompatibility_sum_order_by;
  var_pop?: readerProtocolCompatibility_var_pop_order_by;
  var_samp?: readerProtocolCompatibility_var_samp_order_by;
  variance?: readerProtocolCompatibility_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.ReaderProtocolCompatibility" */
export type readerProtocolCompatibility_arr_rel_insert_input = {
  data: Array<readerProtocolCompatibility_insert_input>;
  /** upsert condition */
  on_conflict?: readerProtocolCompatibility_on_conflict;
};

/** aggregate avg on columns */
export type readerProtocolCompatibility_avg_fields = {
  __typename?: 'readerProtocolCompatibility_avg_fields';
  id?: number;
};

/** order by avg() on columns of table "qx.ReaderProtocolCompatibility" */
export type readerProtocolCompatibility_avg_order_by = {
  id?: order_by;
};

/** Boolean expression to filter rows from the table "qx.ReaderProtocolCompatibility". All fields are combined with a logical 'AND'. */
export type readerProtocolCompatibility_bool_exp = {
  _and?: Array<readerProtocolCompatibility_bool_exp>;
  _not?: readerProtocolCompatibility_bool_exp;
  _or?: Array<readerProtocolCompatibility_bool_exp>;
  eAccessMake?: qx_eAccessMake_bool_exp;
  eReaderProtocol?: qx_eReaderProtocol_bool_exp;
  id?: Int_comparison_exp;
  panel?: qx_eAccessMake_enum_comparison_exp;
  type?: qx_eReaderProtocol_enum_comparison_exp;
};

/** unique or primary key constraints on table "qx.ReaderProtocolCompatibility" */
export enum readerProtocolCompatibility_constraint {
  /** unique or primary key constraint on columns "id" */
  ReaderProtocolCompatibility_pkey = 'ReaderProtocolCompatibility_pkey',
  /** unique or primary key constraint on columns "type", "panel" */
  ReaderProtocolCompatibility_type_panel_key = 'ReaderProtocolCompatibility_type_panel_key'
}

/** input type for incrementing numeric columns in table "qx.ReaderProtocolCompatibility" */
export type readerProtocolCompatibility_inc_input = {
  id?: number;
};

/** input type for inserting data into table "qx.ReaderProtocolCompatibility" */
export type readerProtocolCompatibility_insert_input = {
  eAccessMake?: qx_eAccessMake_obj_rel_insert_input;
  eReaderProtocol?: qx_eReaderProtocol_obj_rel_insert_input;
  id?: number;
  panel?: qx_eAccessMake_enum;
  type?: qx_eReaderProtocol_enum;
};

/** aggregate max on columns */
export type readerProtocolCompatibility_max_fields = {
  __typename?: 'readerProtocolCompatibility_max_fields';
  id?: number;
};

/** order by max() on columns of table "qx.ReaderProtocolCompatibility" */
export type readerProtocolCompatibility_max_order_by = {
  id?: order_by;
};

/** aggregate min on columns */
export type readerProtocolCompatibility_min_fields = {
  __typename?: 'readerProtocolCompatibility_min_fields';
  id?: number;
};

/** order by min() on columns of table "qx.ReaderProtocolCompatibility" */
export type readerProtocolCompatibility_min_order_by = {
  id?: order_by;
};

/** response of any mutation on the table "qx.ReaderProtocolCompatibility" */
export type readerProtocolCompatibility_mutation_response = {
  __typename?: 'readerProtocolCompatibility_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<readerProtocolCompatibility>;
};

/** on_conflict condition type for table "qx.ReaderProtocolCompatibility" */
export type readerProtocolCompatibility_on_conflict = {
  constraint: readerProtocolCompatibility_constraint;
  update_columns?: Array<readerProtocolCompatibility_update_column>;
  where?: readerProtocolCompatibility_bool_exp;
};

/** Ordering options when selecting data from "qx.ReaderProtocolCompatibility". */
export type readerProtocolCompatibility_order_by = {
  eAccessMake?: qx_eAccessMake_order_by;
  eReaderProtocol?: qx_eReaderProtocol_order_by;
  id?: order_by;
  panel?: order_by;
  type?: order_by;
};

/** primary key columns input for table: qx.ReaderProtocolCompatibility */
export type readerProtocolCompatibility_pk_columns_input = {
  id: number;
};

/** select columns of table "qx.ReaderProtocolCompatibility" */
export enum readerProtocolCompatibility_select_column {
  /** column name */
  id = 'id',
  /** column name */
  panel = 'panel',
  /** column name */
  type = 'type'
}

/** input type for updating data in table "qx.ReaderProtocolCompatibility" */
export type readerProtocolCompatibility_set_input = {
  id?: number;
  panel?: qx_eAccessMake_enum;
  type?: qx_eReaderProtocol_enum;
};

/** aggregate stddev on columns */
export type readerProtocolCompatibility_stddev_fields = {
  __typename?: 'readerProtocolCompatibility_stddev_fields';
  id?: number;
};

/** order by stddev() on columns of table "qx.ReaderProtocolCompatibility" */
export type readerProtocolCompatibility_stddev_order_by = {
  id?: order_by;
};

/** aggregate stddev_pop on columns */
export type readerProtocolCompatibility_stddev_pop_fields = {
  __typename?: 'readerProtocolCompatibility_stddev_pop_fields';
  id?: number;
};

/** order by stddev_pop() on columns of table "qx.ReaderProtocolCompatibility" */
export type readerProtocolCompatibility_stddev_pop_order_by = {
  id?: order_by;
};

/** aggregate stddev_samp on columns */
export type readerProtocolCompatibility_stddev_samp_fields = {
  __typename?: 'readerProtocolCompatibility_stddev_samp_fields';
  id?: number;
};

/** order by stddev_samp() on columns of table "qx.ReaderProtocolCompatibility" */
export type readerProtocolCompatibility_stddev_samp_order_by = {
  id?: order_by;
};

/** Streaming cursor of the table "readerProtocolCompatibility" */
export type readerProtocolCompatibility_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: readerProtocolCompatibility_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type readerProtocolCompatibility_stream_cursor_value_input = {
  id?: number;
  panel?: qx_eAccessMake_enum;
  type?: qx_eReaderProtocol_enum;
};

/** aggregate sum on columns */
export type readerProtocolCompatibility_sum_fields = {
  __typename?: 'readerProtocolCompatibility_sum_fields';
  id?: number;
};

/** order by sum() on columns of table "qx.ReaderProtocolCompatibility" */
export type readerProtocolCompatibility_sum_order_by = {
  id?: order_by;
};

/** update columns of table "qx.ReaderProtocolCompatibility" */
export enum readerProtocolCompatibility_update_column {
  /** column name */
  id = 'id',
  /** column name */
  panel = 'panel',
  /** column name */
  type = 'type'
}

export type readerProtocolCompatibility_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: readerProtocolCompatibility_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: readerProtocolCompatibility_set_input;
  /** filter the rows which have to be updated */
  where: readerProtocolCompatibility_bool_exp;
};

/** aggregate var_pop on columns */
export type readerProtocolCompatibility_var_pop_fields = {
  __typename?: 'readerProtocolCompatibility_var_pop_fields';
  id?: number;
};

/** order by var_pop() on columns of table "qx.ReaderProtocolCompatibility" */
export type readerProtocolCompatibility_var_pop_order_by = {
  id?: order_by;
};

/** aggregate var_samp on columns */
export type readerProtocolCompatibility_var_samp_fields = {
  __typename?: 'readerProtocolCompatibility_var_samp_fields';
  id?: number;
};

/** order by var_samp() on columns of table "qx.ReaderProtocolCompatibility" */
export type readerProtocolCompatibility_var_samp_order_by = {
  id?: order_by;
};

/** aggregate variance on columns */
export type readerProtocolCompatibility_variance_fields = {
  __typename?: 'readerProtocolCompatibility_variance_fields';
  id?: number;
};

/** order by variance() on columns of table "qx.ReaderProtocolCompatibility" */
export type readerProtocolCompatibility_variance_order_by = {
  id?: order_by;
};

export type readerSettings = {
  configuration?: Array<namevalue>;
  direction?: string;
  doorRefId?: string;
  enabled?: boolean;
  protocol?: string;
  refId?: string;
  type?: string;
};

/** columns and relationships of "qx.RoleAppPrivileges" */
export type roleAppPrivileges = {
  __typename?: 'roleAppPrivileges';
  created_at: string;
  /** An object relationship */
  eAppPrivilegeType: qx_eAppPrivilegeType;
  id: string;
  privileges: any;
  /** An object relationship */
  role: qx_Role;
  roleID: string;
  type: qx_eAppPrivilegeType_enum;
  updated_at: string;
  value: string;
};


/** columns and relationships of "qx.RoleAppPrivileges" */
export type roleAppPrivilegesprivilegesArgs = {
  path?: string;
};

/** aggregated selection of "qx.RoleAppPrivileges" */
export type roleAppPrivileges_aggregate = {
  __typename?: 'roleAppPrivileges_aggregate';
  aggregate?: roleAppPrivileges_aggregate_fields;
  nodes: Array<roleAppPrivileges>;
};

export type roleAppPrivileges_aggregate_bool_exp = {
  count?: roleAppPrivileges_aggregate_bool_exp_count;
};

export type roleAppPrivileges_aggregate_bool_exp_count = {
  arguments?: Array<roleAppPrivileges_select_column>;
  distinct?: boolean;
  filter?: roleAppPrivileges_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.RoleAppPrivileges" */
export type roleAppPrivileges_aggregate_fields = {
  __typename?: 'roleAppPrivileges_aggregate_fields';
  avg?: roleAppPrivileges_avg_fields;
  count: number;
  max?: roleAppPrivileges_max_fields;
  min?: roleAppPrivileges_min_fields;
  stddev?: roleAppPrivileges_stddev_fields;
  stddev_pop?: roleAppPrivileges_stddev_pop_fields;
  stddev_samp?: roleAppPrivileges_stddev_samp_fields;
  sum?: roleAppPrivileges_sum_fields;
  var_pop?: roleAppPrivileges_var_pop_fields;
  var_samp?: roleAppPrivileges_var_samp_fields;
  variance?: roleAppPrivileges_variance_fields;
};


/** aggregate fields of "qx.RoleAppPrivileges" */
export type roleAppPrivileges_aggregate_fieldscountArgs = {
  columns?: Array<roleAppPrivileges_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.RoleAppPrivileges" */
export type roleAppPrivileges_aggregate_order_by = {
  avg?: roleAppPrivileges_avg_order_by;
  count?: order_by;
  max?: roleAppPrivileges_max_order_by;
  min?: roleAppPrivileges_min_order_by;
  stddev?: roleAppPrivileges_stddev_order_by;
  stddev_pop?: roleAppPrivileges_stddev_pop_order_by;
  stddev_samp?: roleAppPrivileges_stddev_samp_order_by;
  sum?: roleAppPrivileges_sum_order_by;
  var_pop?: roleAppPrivileges_var_pop_order_by;
  var_samp?: roleAppPrivileges_var_samp_order_by;
  variance?: roleAppPrivileges_variance_order_by;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type roleAppPrivileges_append_input = {
  privileges?: any;
};

/** input type for inserting array relation for remote table "qx.RoleAppPrivileges" */
export type roleAppPrivileges_arr_rel_insert_input = {
  data: Array<roleAppPrivileges_insert_input>;
  /** upsert condition */
  on_conflict?: roleAppPrivileges_on_conflict;
};

/** aggregate avg on columns */
export type roleAppPrivileges_avg_fields = {
  __typename?: 'roleAppPrivileges_avg_fields';
  id?: number;
};

/** order by avg() on columns of table "qx.RoleAppPrivileges" */
export type roleAppPrivileges_avg_order_by = {
  id?: order_by;
};

/** Boolean expression to filter rows from the table "qx.RoleAppPrivileges". All fields are combined with a logical 'AND'. */
export type roleAppPrivileges_bool_exp = {
  _and?: Array<roleAppPrivileges_bool_exp>;
  _not?: roleAppPrivileges_bool_exp;
  _or?: Array<roleAppPrivileges_bool_exp>;
  created_at?: timestamptz_comparison_exp;
  eAppPrivilegeType?: qx_eAppPrivilegeType_bool_exp;
  id?: bigint_comparison_exp;
  privileges?: jsonb_comparison_exp;
  role?: qx_Role_bool_exp;
  roleID?: String_comparison_exp;
  type?: qx_eAppPrivilegeType_enum_comparison_exp;
  updated_at?: timestamptz_comparison_exp;
  value?: String_comparison_exp;
};

/** unique or primary key constraints on table "qx.RoleAppPrivileges" */
export enum roleAppPrivileges_constraint {
  /** unique or primary key constraint on columns "id" */
  AppPermissions_pkey = 'AppPermissions_pkey',
  /** unique or primary key constraint on columns "type", "roleID", "value" */
  RoleAppPrivileges_roleID_type_value_key = 'RoleAppPrivileges_roleID_type_value_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type roleAppPrivileges_delete_at_path_input = {
  privileges?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type roleAppPrivileges_delete_elem_input = {
  privileges?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type roleAppPrivileges_delete_key_input = {
  privileges?: string;
};

/** input type for incrementing numeric columns in table "qx.RoleAppPrivileges" */
export type roleAppPrivileges_inc_input = {
  id?: string;
};

/** input type for inserting data into table "qx.RoleAppPrivileges" */
export type roleAppPrivileges_insert_input = {
  created_at?: string;
  eAppPrivilegeType?: qx_eAppPrivilegeType_obj_rel_insert_input;
  id?: string;
  privileges?: any;
  role?: qx_Role_obj_rel_insert_input;
  roleID?: string;
  type?: qx_eAppPrivilegeType_enum;
  updated_at?: string;
  value?: string;
};

/** aggregate max on columns */
export type roleAppPrivileges_max_fields = {
  __typename?: 'roleAppPrivileges_max_fields';
  created_at?: string;
  id?: string;
  roleID?: string;
  updated_at?: string;
  value?: string;
};

/** order by max() on columns of table "qx.RoleAppPrivileges" */
export type roleAppPrivileges_max_order_by = {
  created_at?: order_by;
  id?: order_by;
  roleID?: order_by;
  updated_at?: order_by;
  value?: order_by;
};

/** aggregate min on columns */
export type roleAppPrivileges_min_fields = {
  __typename?: 'roleAppPrivileges_min_fields';
  created_at?: string;
  id?: string;
  roleID?: string;
  updated_at?: string;
  value?: string;
};

/** order by min() on columns of table "qx.RoleAppPrivileges" */
export type roleAppPrivileges_min_order_by = {
  created_at?: order_by;
  id?: order_by;
  roleID?: order_by;
  updated_at?: order_by;
  value?: order_by;
};

/** response of any mutation on the table "qx.RoleAppPrivileges" */
export type roleAppPrivileges_mutation_response = {
  __typename?: 'roleAppPrivileges_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<roleAppPrivileges>;
};

/** on_conflict condition type for table "qx.RoleAppPrivileges" */
export type roleAppPrivileges_on_conflict = {
  constraint: roleAppPrivileges_constraint;
  update_columns?: Array<roleAppPrivileges_update_column>;
  where?: roleAppPrivileges_bool_exp;
};

/** Ordering options when selecting data from "qx.RoleAppPrivileges". */
export type roleAppPrivileges_order_by = {
  created_at?: order_by;
  eAppPrivilegeType?: qx_eAppPrivilegeType_order_by;
  id?: order_by;
  privileges?: order_by;
  role?: qx_Role_order_by;
  roleID?: order_by;
  type?: order_by;
  updated_at?: order_by;
  value?: order_by;
};

/** primary key columns input for table: qx.RoleAppPrivileges */
export type roleAppPrivileges_pk_columns_input = {
  id: string;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type roleAppPrivileges_prepend_input = {
  privileges?: any;
};

/** select columns of table "qx.RoleAppPrivileges" */
export enum roleAppPrivileges_select_column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  id = 'id',
  /** column name */
  privileges = 'privileges',
  /** column name */
  roleID = 'roleID',
  /** column name */
  type = 'type',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  value = 'value'
}

/** input type for updating data in table "qx.RoleAppPrivileges" */
export type roleAppPrivileges_set_input = {
  created_at?: string;
  id?: string;
  privileges?: any;
  roleID?: string;
  type?: qx_eAppPrivilegeType_enum;
  updated_at?: string;
  value?: string;
};

/** aggregate stddev on columns */
export type roleAppPrivileges_stddev_fields = {
  __typename?: 'roleAppPrivileges_stddev_fields';
  id?: number;
};

/** order by stddev() on columns of table "qx.RoleAppPrivileges" */
export type roleAppPrivileges_stddev_order_by = {
  id?: order_by;
};

/** aggregate stddev_pop on columns */
export type roleAppPrivileges_stddev_pop_fields = {
  __typename?: 'roleAppPrivileges_stddev_pop_fields';
  id?: number;
};

/** order by stddev_pop() on columns of table "qx.RoleAppPrivileges" */
export type roleAppPrivileges_stddev_pop_order_by = {
  id?: order_by;
};

/** aggregate stddev_samp on columns */
export type roleAppPrivileges_stddev_samp_fields = {
  __typename?: 'roleAppPrivileges_stddev_samp_fields';
  id?: number;
};

/** order by stddev_samp() on columns of table "qx.RoleAppPrivileges" */
export type roleAppPrivileges_stddev_samp_order_by = {
  id?: order_by;
};

/** Streaming cursor of the table "roleAppPrivileges" */
export type roleAppPrivileges_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: roleAppPrivileges_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type roleAppPrivileges_stream_cursor_value_input = {
  created_at?: string;
  id?: string;
  privileges?: any;
  roleID?: string;
  type?: qx_eAppPrivilegeType_enum;
  updated_at?: string;
  value?: string;
};

/** aggregate sum on columns */
export type roleAppPrivileges_sum_fields = {
  __typename?: 'roleAppPrivileges_sum_fields';
  id?: string;
};

/** order by sum() on columns of table "qx.RoleAppPrivileges" */
export type roleAppPrivileges_sum_order_by = {
  id?: order_by;
};

/** update columns of table "qx.RoleAppPrivileges" */
export enum roleAppPrivileges_update_column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  id = 'id',
  /** column name */
  privileges = 'privileges',
  /** column name */
  roleID = 'roleID',
  /** column name */
  type = 'type',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  value = 'value'
}

export type roleAppPrivileges_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: roleAppPrivileges_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: roleAppPrivileges_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: roleAppPrivileges_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: roleAppPrivileges_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: roleAppPrivileges_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: roleAppPrivileges_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: roleAppPrivileges_set_input;
  /** filter the rows which have to be updated */
  where: roleAppPrivileges_bool_exp;
};

/** aggregate var_pop on columns */
export type roleAppPrivileges_var_pop_fields = {
  __typename?: 'roleAppPrivileges_var_pop_fields';
  id?: number;
};

/** order by var_pop() on columns of table "qx.RoleAppPrivileges" */
export type roleAppPrivileges_var_pop_order_by = {
  id?: order_by;
};

/** aggregate var_samp on columns */
export type roleAppPrivileges_var_samp_fields = {
  __typename?: 'roleAppPrivileges_var_samp_fields';
  id?: number;
};

/** order by var_samp() on columns of table "qx.RoleAppPrivileges" */
export type roleAppPrivileges_var_samp_order_by = {
  id?: order_by;
};

/** aggregate variance on columns */
export type roleAppPrivileges_variance_fields = {
  __typename?: 'roleAppPrivileges_variance_fields';
  id?: number;
};

/** order by variance() on columns of table "qx.RoleAppPrivileges" */
export type roleAppPrivileges_variance_order_by = {
  id?: order_by;
};

/** audit view tracking historical changes to role definitions */
export type roleAudit = {
  __typename?: 'roleAudit';
  action?: string;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  /** An object relationship */
  role?: qx_Role;
  row_data?: any;
  time?: string;
};


/** audit view tracking historical changes to role definitions */
export type roleAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes to role definitions */
export type roleAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.vRoleAudit" */
export type roleAudit_aggregate = {
  __typename?: 'roleAudit_aggregate';
  aggregate?: roleAudit_aggregate_fields;
  nodes: Array<roleAudit>;
};

/** aggregate fields of "audit.vRoleAudit" */
export type roleAudit_aggregate_fields = {
  __typename?: 'roleAudit_aggregate_fields';
  avg?: roleAudit_avg_fields;
  count: number;
  max?: roleAudit_max_fields;
  min?: roleAudit_min_fields;
  stddev?: roleAudit_stddev_fields;
  stddev_pop?: roleAudit_stddev_pop_fields;
  stddev_samp?: roleAudit_stddev_samp_fields;
  sum?: roleAudit_sum_fields;
  var_pop?: roleAudit_var_pop_fields;
  var_samp?: roleAudit_var_samp_fields;
  variance?: roleAudit_variance_fields;
};


/** aggregate fields of "audit.vRoleAudit" */
export type roleAudit_aggregate_fieldscountArgs = {
  columns?: Array<roleAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type roleAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type roleAudit_avg_fields = {
  __typename?: 'roleAudit_avg_fields';
  auditID?: number;
};

/** Boolean expression to filter rows from the table "audit.vRoleAudit". All fields are combined with a logical 'AND'. */
export type roleAudit_bool_exp = {
  _and?: Array<roleAudit_bool_exp>;
  _not?: roleAudit_bool_exp;
  _or?: Array<roleAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  id?: String_comparison_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  role?: qx_Role_bool_exp;
  row_data?: jsonb_comparison_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type roleAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type roleAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type roleAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.vRoleAudit" */
export type roleAudit_inc_input = {
  auditID?: string;
};

/** input type for inserting data into table "audit.vRoleAudit" */
export type roleAudit_insert_input = {
  action?: string;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  role?: qx_Role_obj_rel_insert_input;
  row_data?: any;
  time?: string;
};

/** aggregate max on columns */
export type roleAudit_max_fields = {
  __typename?: 'roleAudit_max_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** aggregate min on columns */
export type roleAudit_min_fields = {
  __typename?: 'roleAudit_min_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** response of any mutation on the table "audit.vRoleAudit" */
export type roleAudit_mutation_response = {
  __typename?: 'roleAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<roleAudit>;
};

/** Ordering options when selecting data from "audit.vRoleAudit". */
export type roleAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  id?: order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  role?: qx_Role_order_by;
  row_data?: order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type roleAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.vRoleAudit" */
export enum roleAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  id = 'id',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.vRoleAudit" */
export type roleAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type roleAudit_stddev_fields = {
  __typename?: 'roleAudit_stddev_fields';
  auditID?: number;
};

/** aggregate stddev_pop on columns */
export type roleAudit_stddev_pop_fields = {
  __typename?: 'roleAudit_stddev_pop_fields';
  auditID?: number;
};

/** aggregate stddev_samp on columns */
export type roleAudit_stddev_samp_fields = {
  __typename?: 'roleAudit_stddev_samp_fields';
  auditID?: number;
};

/** Streaming cursor of the table "roleAudit" */
export type roleAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: roleAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type roleAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type roleAudit_sum_fields = {
  __typename?: 'roleAudit_sum_fields';
  auditID?: string;
};

export type roleAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: roleAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: roleAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: roleAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: roleAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: roleAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: roleAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: roleAudit_set_input;
  /** filter the rows which have to be updated */
  where: roleAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type roleAudit_var_pop_fields = {
  __typename?: 'roleAudit_var_pop_fields';
  auditID?: number;
};

/** aggregate var_samp on columns */
export type roleAudit_var_samp_fields = {
  __typename?: 'roleAudit_var_samp_fields';
  auditID?: number;
};

/** aggregate variance on columns */
export type roleAudit_variance_fields = {
  __typename?: 'roleAudit_variance_fields';
  auditID?: number;
};

/** columns and relationships of "qx.RosslareCatalog" */
export type rosslareCatalogs = {
  __typename?: 'rosslareCatalogs';
  /** An object relationship */
  Place: qx_Place;
  id: string;
  interface: string;
  model: number;
  nInputs: number;
  nOutputs: number;
  nReaders: number;
  name: string;
  placeID: string;
  type: string;
  updatedAt?: string;
};

/** aggregated selection of "qx.RosslareCatalog" */
export type rosslareCatalogs_aggregate = {
  __typename?: 'rosslareCatalogs_aggregate';
  aggregate?: rosslareCatalogs_aggregate_fields;
  nodes: Array<rosslareCatalogs>;
};

export type rosslareCatalogs_aggregate_bool_exp = {
  count?: rosslareCatalogs_aggregate_bool_exp_count;
};

export type rosslareCatalogs_aggregate_bool_exp_count = {
  arguments?: Array<rosslareCatalogs_select_column>;
  distinct?: boolean;
  filter?: rosslareCatalogs_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.RosslareCatalog" */
export type rosslareCatalogs_aggregate_fields = {
  __typename?: 'rosslareCatalogs_aggregate_fields';
  avg?: rosslareCatalogs_avg_fields;
  count: number;
  max?: rosslareCatalogs_max_fields;
  min?: rosslareCatalogs_min_fields;
  stddev?: rosslareCatalogs_stddev_fields;
  stddev_pop?: rosslareCatalogs_stddev_pop_fields;
  stddev_samp?: rosslareCatalogs_stddev_samp_fields;
  sum?: rosslareCatalogs_sum_fields;
  var_pop?: rosslareCatalogs_var_pop_fields;
  var_samp?: rosslareCatalogs_var_samp_fields;
  variance?: rosslareCatalogs_variance_fields;
};


/** aggregate fields of "qx.RosslareCatalog" */
export type rosslareCatalogs_aggregate_fieldscountArgs = {
  columns?: Array<rosslareCatalogs_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.RosslareCatalog" */
export type rosslareCatalogs_aggregate_order_by = {
  avg?: rosslareCatalogs_avg_order_by;
  count?: order_by;
  max?: rosslareCatalogs_max_order_by;
  min?: rosslareCatalogs_min_order_by;
  stddev?: rosslareCatalogs_stddev_order_by;
  stddev_pop?: rosslareCatalogs_stddev_pop_order_by;
  stddev_samp?: rosslareCatalogs_stddev_samp_order_by;
  sum?: rosslareCatalogs_sum_order_by;
  var_pop?: rosslareCatalogs_var_pop_order_by;
  var_samp?: rosslareCatalogs_var_samp_order_by;
  variance?: rosslareCatalogs_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.RosslareCatalog" */
export type rosslareCatalogs_arr_rel_insert_input = {
  data: Array<rosslareCatalogs_insert_input>;
  /** upsert condition */
  on_conflict?: rosslareCatalogs_on_conflict;
};

/** aggregate avg on columns */
export type rosslareCatalogs_avg_fields = {
  __typename?: 'rosslareCatalogs_avg_fields';
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
};

/** order by avg() on columns of table "qx.RosslareCatalog" */
export type rosslareCatalogs_avg_order_by = {
  model?: order_by;
  nInputs?: order_by;
  nOutputs?: order_by;
  nReaders?: order_by;
};

/** Boolean expression to filter rows from the table "qx.RosslareCatalog". All fields are combined with a logical 'AND'. */
export type rosslareCatalogs_bool_exp = {
  Place?: qx_Place_bool_exp;
  _and?: Array<rosslareCatalogs_bool_exp>;
  _not?: rosslareCatalogs_bool_exp;
  _or?: Array<rosslareCatalogs_bool_exp>;
  id?: String_comparison_exp;
  interface?: String_comparison_exp;
  model?: Int_comparison_exp;
  nInputs?: Int_comparison_exp;
  nOutputs?: Int_comparison_exp;
  nReaders?: Int_comparison_exp;
  name?: String_comparison_exp;
  placeID?: String_comparison_exp;
  type?: String_comparison_exp;
  updatedAt?: timestamptz_comparison_exp;
};

/** unique or primary key constraints on table "qx.RosslareCatalog" */
export enum rosslareCatalogs_constraint {
  /** unique or primary key constraint on columns "id" */
  RosslareCatalog_pkey = 'RosslareCatalog_pkey'
}

/** input type for incrementing numeric columns in table "qx.RosslareCatalog" */
export type rosslareCatalogs_inc_input = {
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
};

/** input type for inserting data into table "qx.RosslareCatalog" */
export type rosslareCatalogs_insert_input = {
  Place?: qx_Place_obj_rel_insert_input;
  id?: string;
  interface?: string;
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
  name?: string;
  placeID?: string;
  type?: string;
  updatedAt?: string;
};

/** aggregate max on columns */
export type rosslareCatalogs_max_fields = {
  __typename?: 'rosslareCatalogs_max_fields';
  id?: string;
  interface?: string;
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
  name?: string;
  placeID?: string;
  type?: string;
  updatedAt?: string;
};

/** order by max() on columns of table "qx.RosslareCatalog" */
export type rosslareCatalogs_max_order_by = {
  id?: order_by;
  interface?: order_by;
  model?: order_by;
  nInputs?: order_by;
  nOutputs?: order_by;
  nReaders?: order_by;
  name?: order_by;
  placeID?: order_by;
  type?: order_by;
  updatedAt?: order_by;
};

/** aggregate min on columns */
export type rosslareCatalogs_min_fields = {
  __typename?: 'rosslareCatalogs_min_fields';
  id?: string;
  interface?: string;
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
  name?: string;
  placeID?: string;
  type?: string;
  updatedAt?: string;
};

/** order by min() on columns of table "qx.RosslareCatalog" */
export type rosslareCatalogs_min_order_by = {
  id?: order_by;
  interface?: order_by;
  model?: order_by;
  nInputs?: order_by;
  nOutputs?: order_by;
  nReaders?: order_by;
  name?: order_by;
  placeID?: order_by;
  type?: order_by;
  updatedAt?: order_by;
};

/** response of any mutation on the table "qx.RosslareCatalog" */
export type rosslareCatalogs_mutation_response = {
  __typename?: 'rosslareCatalogs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<rosslareCatalogs>;
};

/** on_conflict condition type for table "qx.RosslareCatalog" */
export type rosslareCatalogs_on_conflict = {
  constraint: rosslareCatalogs_constraint;
  update_columns?: Array<rosslareCatalogs_update_column>;
  where?: rosslareCatalogs_bool_exp;
};

/** Ordering options when selecting data from "qx.RosslareCatalog". */
export type rosslareCatalogs_order_by = {
  Place?: qx_Place_order_by;
  id?: order_by;
  interface?: order_by;
  model?: order_by;
  nInputs?: order_by;
  nOutputs?: order_by;
  nReaders?: order_by;
  name?: order_by;
  placeID?: order_by;
  type?: order_by;
  updatedAt?: order_by;
};

/** primary key columns input for table: qx.RosslareCatalog */
export type rosslareCatalogs_pk_columns_input = {
  id: string;
};

/** select columns of table "qx.RosslareCatalog" */
export enum rosslareCatalogs_select_column {
  /** column name */
  id = 'id',
  /** column name */
  interface = 'interface',
  /** column name */
  model = 'model',
  /** column name */
  nInputs = 'nInputs',
  /** column name */
  nOutputs = 'nOutputs',
  /** column name */
  nReaders = 'nReaders',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  type = 'type',
  /** column name */
  updatedAt = 'updatedAt'
}

/** input type for updating data in table "qx.RosslareCatalog" */
export type rosslareCatalogs_set_input = {
  id?: string;
  interface?: string;
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
  name?: string;
  placeID?: string;
  type?: string;
  updatedAt?: string;
};

/** aggregate stddev on columns */
export type rosslareCatalogs_stddev_fields = {
  __typename?: 'rosslareCatalogs_stddev_fields';
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
};

/** order by stddev() on columns of table "qx.RosslareCatalog" */
export type rosslareCatalogs_stddev_order_by = {
  model?: order_by;
  nInputs?: order_by;
  nOutputs?: order_by;
  nReaders?: order_by;
};

/** aggregate stddev_pop on columns */
export type rosslareCatalogs_stddev_pop_fields = {
  __typename?: 'rosslareCatalogs_stddev_pop_fields';
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
};

/** order by stddev_pop() on columns of table "qx.RosslareCatalog" */
export type rosslareCatalogs_stddev_pop_order_by = {
  model?: order_by;
  nInputs?: order_by;
  nOutputs?: order_by;
  nReaders?: order_by;
};

/** aggregate stddev_samp on columns */
export type rosslareCatalogs_stddev_samp_fields = {
  __typename?: 'rosslareCatalogs_stddev_samp_fields';
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
};

/** order by stddev_samp() on columns of table "qx.RosslareCatalog" */
export type rosslareCatalogs_stddev_samp_order_by = {
  model?: order_by;
  nInputs?: order_by;
  nOutputs?: order_by;
  nReaders?: order_by;
};

/** Streaming cursor of the table "rosslareCatalogs" */
export type rosslareCatalogs_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: rosslareCatalogs_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type rosslareCatalogs_stream_cursor_value_input = {
  id?: string;
  interface?: string;
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
  name?: string;
  placeID?: string;
  type?: string;
  updatedAt?: string;
};

/** aggregate sum on columns */
export type rosslareCatalogs_sum_fields = {
  __typename?: 'rosslareCatalogs_sum_fields';
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
};

/** order by sum() on columns of table "qx.RosslareCatalog" */
export type rosslareCatalogs_sum_order_by = {
  model?: order_by;
  nInputs?: order_by;
  nOutputs?: order_by;
  nReaders?: order_by;
};

/** update columns of table "qx.RosslareCatalog" */
export enum rosslareCatalogs_update_column {
  /** column name */
  id = 'id',
  /** column name */
  interface = 'interface',
  /** column name */
  model = 'model',
  /** column name */
  nInputs = 'nInputs',
  /** column name */
  nOutputs = 'nOutputs',
  /** column name */
  nReaders = 'nReaders',
  /** column name */
  name = 'name',
  /** column name */
  placeID = 'placeID',
  /** column name */
  type = 'type',
  /** column name */
  updatedAt = 'updatedAt'
}

export type rosslareCatalogs_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: rosslareCatalogs_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: rosslareCatalogs_set_input;
  /** filter the rows which have to be updated */
  where: rosslareCatalogs_bool_exp;
};

/** aggregate var_pop on columns */
export type rosslareCatalogs_var_pop_fields = {
  __typename?: 'rosslareCatalogs_var_pop_fields';
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
};

/** order by var_pop() on columns of table "qx.RosslareCatalog" */
export type rosslareCatalogs_var_pop_order_by = {
  model?: order_by;
  nInputs?: order_by;
  nOutputs?: order_by;
  nReaders?: order_by;
};

/** aggregate var_samp on columns */
export type rosslareCatalogs_var_samp_fields = {
  __typename?: 'rosslareCatalogs_var_samp_fields';
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
};

/** order by var_samp() on columns of table "qx.RosslareCatalog" */
export type rosslareCatalogs_var_samp_order_by = {
  model?: order_by;
  nInputs?: order_by;
  nOutputs?: order_by;
  nReaders?: order_by;
};

/** aggregate variance on columns */
export type rosslareCatalogs_variance_fields = {
  __typename?: 'rosslareCatalogs_variance_fields';
  model?: number;
  nInputs?: number;
  nOutputs?: number;
  nReaders?: number;
};

/** order by variance() on columns of table "qx.RosslareCatalog" */
export type rosslareCatalogs_variance_order_by = {
  model?: order_by;
  nInputs?: order_by;
  nOutputs?: order_by;
  nReaders?: order_by;
};

/** columns and relationships of "qx.S3BucketConfiguration" */
export type s3BucketConfigurations = {
  __typename?: 's3BucketConfigurations';
  bucket: string;
  enabled: boolean;
  endpoint: string;
  id: number;
  key: string;
  name: string;
  secret: string;
  type: eS3BucketType_enum;
};

/** aggregated selection of "qx.S3BucketConfiguration" */
export type s3BucketConfigurations_aggregate = {
  __typename?: 's3BucketConfigurations_aggregate';
  aggregate?: s3BucketConfigurations_aggregate_fields;
  nodes: Array<s3BucketConfigurations>;
};

/** aggregate fields of "qx.S3BucketConfiguration" */
export type s3BucketConfigurations_aggregate_fields = {
  __typename?: 's3BucketConfigurations_aggregate_fields';
  avg?: s3BucketConfigurations_avg_fields;
  count: number;
  max?: s3BucketConfigurations_max_fields;
  min?: s3BucketConfigurations_min_fields;
  stddev?: s3BucketConfigurations_stddev_fields;
  stddev_pop?: s3BucketConfigurations_stddev_pop_fields;
  stddev_samp?: s3BucketConfigurations_stddev_samp_fields;
  sum?: s3BucketConfigurations_sum_fields;
  var_pop?: s3BucketConfigurations_var_pop_fields;
  var_samp?: s3BucketConfigurations_var_samp_fields;
  variance?: s3BucketConfigurations_variance_fields;
};


/** aggregate fields of "qx.S3BucketConfiguration" */
export type s3BucketConfigurations_aggregate_fieldscountArgs = {
  columns?: Array<s3BucketConfigurations_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type s3BucketConfigurations_avg_fields = {
  __typename?: 's3BucketConfigurations_avg_fields';
  id?: number;
};

/** Boolean expression to filter rows from the table "qx.S3BucketConfiguration". All fields are combined with a logical 'AND'. */
export type s3BucketConfigurations_bool_exp = {
  _and?: Array<s3BucketConfigurations_bool_exp>;
  _not?: s3BucketConfigurations_bool_exp;
  _or?: Array<s3BucketConfigurations_bool_exp>;
  bucket?: String_comparison_exp;
  enabled?: Boolean_comparison_exp;
  endpoint?: String_comparison_exp;
  id?: Int_comparison_exp;
  key?: String_comparison_exp;
  name?: String_comparison_exp;
  secret?: String_comparison_exp;
  type?: eS3BucketType_enum_comparison_exp;
};

/** unique or primary key constraints on table "qx.S3BucketConfiguration" */
export enum s3BucketConfigurations_constraint {
  /** unique or primary key constraint on columns "name" */
  S3BucketConfiguration_name_key = 'S3BucketConfiguration_name_key',
  /** unique or primary key constraint on columns "id" */
  S3BucketConfiguration_pkey = 'S3BucketConfiguration_pkey'
}

/** input type for incrementing numeric columns in table "qx.S3BucketConfiguration" */
export type s3BucketConfigurations_inc_input = {
  id?: number;
};

/** input type for inserting data into table "qx.S3BucketConfiguration" */
export type s3BucketConfigurations_insert_input = {
  bucket?: string;
  enabled?: boolean;
  endpoint?: string;
  id?: number;
  key?: string;
  name?: string;
  secret?: string;
  type?: eS3BucketType_enum;
};

/** aggregate max on columns */
export type s3BucketConfigurations_max_fields = {
  __typename?: 's3BucketConfigurations_max_fields';
  bucket?: string;
  endpoint?: string;
  id?: number;
  key?: string;
  name?: string;
  secret?: string;
};

/** aggregate min on columns */
export type s3BucketConfigurations_min_fields = {
  __typename?: 's3BucketConfigurations_min_fields';
  bucket?: string;
  endpoint?: string;
  id?: number;
  key?: string;
  name?: string;
  secret?: string;
};

/** response of any mutation on the table "qx.S3BucketConfiguration" */
export type s3BucketConfigurations_mutation_response = {
  __typename?: 's3BucketConfigurations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<s3BucketConfigurations>;
};

/** on_conflict condition type for table "qx.S3BucketConfiguration" */
export type s3BucketConfigurations_on_conflict = {
  constraint: s3BucketConfigurations_constraint;
  update_columns?: Array<s3BucketConfigurations_update_column>;
  where?: s3BucketConfigurations_bool_exp;
};

/** Ordering options when selecting data from "qx.S3BucketConfiguration". */
export type s3BucketConfigurations_order_by = {
  bucket?: order_by;
  enabled?: order_by;
  endpoint?: order_by;
  id?: order_by;
  key?: order_by;
  name?: order_by;
  secret?: order_by;
  type?: order_by;
};

/** primary key columns input for table: qx.S3BucketConfiguration */
export type s3BucketConfigurations_pk_columns_input = {
  id: number;
};

/** select columns of table "qx.S3BucketConfiguration" */
export enum s3BucketConfigurations_select_column {
  /** column name */
  bucket = 'bucket',
  /** column name */
  enabled = 'enabled',
  /** column name */
  endpoint = 'endpoint',
  /** column name */
  id = 'id',
  /** column name */
  key = 'key',
  /** column name */
  name = 'name',
  /** column name */
  secret = 'secret',
  /** column name */
  type = 'type'
}

/** input type for updating data in table "qx.S3BucketConfiguration" */
export type s3BucketConfigurations_set_input = {
  bucket?: string;
  enabled?: boolean;
  endpoint?: string;
  id?: number;
  key?: string;
  name?: string;
  secret?: string;
  type?: eS3BucketType_enum;
};

/** aggregate stddev on columns */
export type s3BucketConfigurations_stddev_fields = {
  __typename?: 's3BucketConfigurations_stddev_fields';
  id?: number;
};

/** aggregate stddev_pop on columns */
export type s3BucketConfigurations_stddev_pop_fields = {
  __typename?: 's3BucketConfigurations_stddev_pop_fields';
  id?: number;
};

/** aggregate stddev_samp on columns */
export type s3BucketConfigurations_stddev_samp_fields = {
  __typename?: 's3BucketConfigurations_stddev_samp_fields';
  id?: number;
};

/** Streaming cursor of the table "s3BucketConfigurations" */
export type s3BucketConfigurations_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: s3BucketConfigurations_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type s3BucketConfigurations_stream_cursor_value_input = {
  bucket?: string;
  enabled?: boolean;
  endpoint?: string;
  id?: number;
  key?: string;
  name?: string;
  secret?: string;
  type?: eS3BucketType_enum;
};

/** aggregate sum on columns */
export type s3BucketConfigurations_sum_fields = {
  __typename?: 's3BucketConfigurations_sum_fields';
  id?: number;
};

/** update columns of table "qx.S3BucketConfiguration" */
export enum s3BucketConfigurations_update_column {
  /** column name */
  bucket = 'bucket',
  /** column name */
  enabled = 'enabled',
  /** column name */
  endpoint = 'endpoint',
  /** column name */
  id = 'id',
  /** column name */
  key = 'key',
  /** column name */
  name = 'name',
  /** column name */
  secret = 'secret',
  /** column name */
  type = 'type'
}

export type s3BucketConfigurations_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: s3BucketConfigurations_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: s3BucketConfigurations_set_input;
  /** filter the rows which have to be updated */
  where: s3BucketConfigurations_bool_exp;
};

/** aggregate var_pop on columns */
export type s3BucketConfigurations_var_pop_fields = {
  __typename?: 's3BucketConfigurations_var_pop_fields';
  id?: number;
};

/** aggregate var_samp on columns */
export type s3BucketConfigurations_var_samp_fields = {
  __typename?: 's3BucketConfigurations_var_samp_fields';
  id?: number;
};

/** aggregate variance on columns */
export type s3BucketConfigurations_variance_fields = {
  __typename?: 's3BucketConfigurations_variance_fields';
  id?: number;
};

/** fields of action: "scanSegments" */
export type scanSegments = {
  __typename?: 'scanSegments';
  /** the time at which this action was created */
  created_at: string;
  /** errors related to the invocation */
  errors?: any;
  /** the unique id of an action */
  id: any;
  /** the output fields of this action */
  output: SuccessOutput;
};

/** audit view tracking historical changes to schedule configurations */
export type scheduleAudit = {
  __typename?: 'scheduleAudit';
  action?: string;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  row_data?: any;
  /** An object relationship */
  schedule?: qx_Schedule;
  time?: string;
};


/** audit view tracking historical changes to schedule configurations */
export type scheduleAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes to schedule configurations */
export type scheduleAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.vScheduleAudit" */
export type scheduleAudit_aggregate = {
  __typename?: 'scheduleAudit_aggregate';
  aggregate?: scheduleAudit_aggregate_fields;
  nodes: Array<scheduleAudit>;
};

/** aggregate fields of "audit.vScheduleAudit" */
export type scheduleAudit_aggregate_fields = {
  __typename?: 'scheduleAudit_aggregate_fields';
  avg?: scheduleAudit_avg_fields;
  count: number;
  max?: scheduleAudit_max_fields;
  min?: scheduleAudit_min_fields;
  stddev?: scheduleAudit_stddev_fields;
  stddev_pop?: scheduleAudit_stddev_pop_fields;
  stddev_samp?: scheduleAudit_stddev_samp_fields;
  sum?: scheduleAudit_sum_fields;
  var_pop?: scheduleAudit_var_pop_fields;
  var_samp?: scheduleAudit_var_samp_fields;
  variance?: scheduleAudit_variance_fields;
};


/** aggregate fields of "audit.vScheduleAudit" */
export type scheduleAudit_aggregate_fieldscountArgs = {
  columns?: Array<scheduleAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type scheduleAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type scheduleAudit_avg_fields = {
  __typename?: 'scheduleAudit_avg_fields';
  auditID?: number;
};

/** Boolean expression to filter rows from the table "audit.vScheduleAudit". All fields are combined with a logical 'AND'. */
export type scheduleAudit_bool_exp = {
  _and?: Array<scheduleAudit_bool_exp>;
  _not?: scheduleAudit_bool_exp;
  _or?: Array<scheduleAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  id?: String_comparison_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  schedule?: qx_Schedule_bool_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type scheduleAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type scheduleAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type scheduleAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.vScheduleAudit" */
export type scheduleAudit_inc_input = {
  auditID?: string;
};

/** input type for inserting data into table "audit.vScheduleAudit" */
export type scheduleAudit_insert_input = {
  action?: string;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  row_data?: any;
  schedule?: qx_Schedule_obj_rel_insert_input;
  time?: string;
};

/** aggregate max on columns */
export type scheduleAudit_max_fields = {
  __typename?: 'scheduleAudit_max_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** aggregate min on columns */
export type scheduleAudit_min_fields = {
  __typename?: 'scheduleAudit_min_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** response of any mutation on the table "audit.vScheduleAudit" */
export type scheduleAudit_mutation_response = {
  __typename?: 'scheduleAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<scheduleAudit>;
};

/** Ordering options when selecting data from "audit.vScheduleAudit". */
export type scheduleAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  id?: order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  row_data?: order_by;
  schedule?: qx_Schedule_order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type scheduleAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.vScheduleAudit" */
export enum scheduleAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  id = 'id',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.vScheduleAudit" */
export type scheduleAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type scheduleAudit_stddev_fields = {
  __typename?: 'scheduleAudit_stddev_fields';
  auditID?: number;
};

/** aggregate stddev_pop on columns */
export type scheduleAudit_stddev_pop_fields = {
  __typename?: 'scheduleAudit_stddev_pop_fields';
  auditID?: number;
};

/** aggregate stddev_samp on columns */
export type scheduleAudit_stddev_samp_fields = {
  __typename?: 'scheduleAudit_stddev_samp_fields';
  auditID?: number;
};

/** Streaming cursor of the table "scheduleAudit" */
export type scheduleAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: scheduleAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type scheduleAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type scheduleAudit_sum_fields = {
  __typename?: 'scheduleAudit_sum_fields';
  auditID?: string;
};

export type scheduleAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: scheduleAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: scheduleAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: scheduleAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: scheduleAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: scheduleAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: scheduleAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: scheduleAudit_set_input;
  /** filter the rows which have to be updated */
  where: scheduleAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type scheduleAudit_var_pop_fields = {
  __typename?: 'scheduleAudit_var_pop_fields';
  auditID?: number;
};

/** aggregate var_samp on columns */
export type scheduleAudit_var_samp_fields = {
  __typename?: 'scheduleAudit_var_samp_fields';
  auditID?: number;
};

/** aggregate variance on columns */
export type scheduleAudit_variance_fields = {
  __typename?: 'scheduleAudit_variance_fields';
  auditID?: number;
};

/** audit view tracking historical changes to schedule block time windows */
export type scheduleBlockAudit = {
  __typename?: 'scheduleBlockAudit';
  action?: string;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  row_data?: any;
  /** An object relationship */
  scheduleBlock?: qx_ScheduleBlock;
  time?: string;
};


/** audit view tracking historical changes to schedule block time windows */
export type scheduleBlockAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes to schedule block time windows */
export type scheduleBlockAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.vScheduleBlockAudit" */
export type scheduleBlockAudit_aggregate = {
  __typename?: 'scheduleBlockAudit_aggregate';
  aggregate?: scheduleBlockAudit_aggregate_fields;
  nodes: Array<scheduleBlockAudit>;
};

/** aggregate fields of "audit.vScheduleBlockAudit" */
export type scheduleBlockAudit_aggregate_fields = {
  __typename?: 'scheduleBlockAudit_aggregate_fields';
  avg?: scheduleBlockAudit_avg_fields;
  count: number;
  max?: scheduleBlockAudit_max_fields;
  min?: scheduleBlockAudit_min_fields;
  stddev?: scheduleBlockAudit_stddev_fields;
  stddev_pop?: scheduleBlockAudit_stddev_pop_fields;
  stddev_samp?: scheduleBlockAudit_stddev_samp_fields;
  sum?: scheduleBlockAudit_sum_fields;
  var_pop?: scheduleBlockAudit_var_pop_fields;
  var_samp?: scheduleBlockAudit_var_samp_fields;
  variance?: scheduleBlockAudit_variance_fields;
};


/** aggregate fields of "audit.vScheduleBlockAudit" */
export type scheduleBlockAudit_aggregate_fieldscountArgs = {
  columns?: Array<scheduleBlockAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type scheduleBlockAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type scheduleBlockAudit_avg_fields = {
  __typename?: 'scheduleBlockAudit_avg_fields';
  auditID?: number;
};

/** Boolean expression to filter rows from the table "audit.vScheduleBlockAudit". All fields are combined with a logical 'AND'. */
export type scheduleBlockAudit_bool_exp = {
  _and?: Array<scheduleBlockAudit_bool_exp>;
  _not?: scheduleBlockAudit_bool_exp;
  _or?: Array<scheduleBlockAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  id?: String_comparison_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  scheduleBlock?: qx_ScheduleBlock_bool_exp;
  time?: timestamptz_comparison_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type scheduleBlockAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type scheduleBlockAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type scheduleBlockAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.vScheduleBlockAudit" */
export type scheduleBlockAudit_inc_input = {
  auditID?: string;
};

/** input type for inserting data into table "audit.vScheduleBlockAudit" */
export type scheduleBlockAudit_insert_input = {
  action?: string;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  row_data?: any;
  scheduleBlock?: qx_ScheduleBlock_obj_rel_insert_input;
  time?: string;
};

/** aggregate max on columns */
export type scheduleBlockAudit_max_fields = {
  __typename?: 'scheduleBlockAudit_max_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** aggregate min on columns */
export type scheduleBlockAudit_min_fields = {
  __typename?: 'scheduleBlockAudit_min_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** response of any mutation on the table "audit.vScheduleBlockAudit" */
export type scheduleBlockAudit_mutation_response = {
  __typename?: 'scheduleBlockAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<scheduleBlockAudit>;
};

/** Ordering options when selecting data from "audit.vScheduleBlockAudit". */
export type scheduleBlockAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  id?: order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  row_data?: order_by;
  scheduleBlock?: qx_ScheduleBlock_order_by;
  time?: order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type scheduleBlockAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.vScheduleBlockAudit" */
export enum scheduleBlockAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  id = 'id',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.vScheduleBlockAudit" */
export type scheduleBlockAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type scheduleBlockAudit_stddev_fields = {
  __typename?: 'scheduleBlockAudit_stddev_fields';
  auditID?: number;
};

/** aggregate stddev_pop on columns */
export type scheduleBlockAudit_stddev_pop_fields = {
  __typename?: 'scheduleBlockAudit_stddev_pop_fields';
  auditID?: number;
};

/** aggregate stddev_samp on columns */
export type scheduleBlockAudit_stddev_samp_fields = {
  __typename?: 'scheduleBlockAudit_stddev_samp_fields';
  auditID?: number;
};

/** Streaming cursor of the table "scheduleBlockAudit" */
export type scheduleBlockAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: scheduleBlockAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type scheduleBlockAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type scheduleBlockAudit_sum_fields = {
  __typename?: 'scheduleBlockAudit_sum_fields';
  auditID?: string;
};

export type scheduleBlockAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: scheduleBlockAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: scheduleBlockAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: scheduleBlockAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: scheduleBlockAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: scheduleBlockAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: scheduleBlockAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: scheduleBlockAudit_set_input;
  /** filter the rows which have to be updated */
  where: scheduleBlockAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type scheduleBlockAudit_var_pop_fields = {
  __typename?: 'scheduleBlockAudit_var_pop_fields';
  auditID?: number;
};

/** aggregate var_samp on columns */
export type scheduleBlockAudit_var_samp_fields = {
  __typename?: 'scheduleBlockAudit_var_samp_fields';
  auditID?: number;
};

/** aggregate variance on columns */
export type scheduleBlockAudit_variance_fields = {
  __typename?: 'scheduleBlockAudit_variance_fields';
  auditID?: number;
};

/** fields of action: "setupCameraGateway" */
export type setupCameraGateway = {
  __typename?: 'setupCameraGateway';
  /** the time at which this action was created */
  created_at: string;
  /** errors related to the invocation */
  errors?: any;
  /** the unique id of an action */
  id: any;
  /** the output fields of this action */
  output?: SetupCameraGatewayOutput;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type smallint_comparison_exp = {
  _eq?: Scalars['smallint']['input'];
  _gt?: Scalars['smallint']['input'];
  _gte?: Scalars['smallint']['input'];
  _in?: Array<Scalars['smallint']['input']>;
  _is_null?: boolean;
  _lt?: Scalars['smallint']['input'];
  _lte?: Scalars['smallint']['input'];
  _neq?: Scalars['smallint']['input'];
  _nin?: Array<Scalars['smallint']['input']>;
};

export type subscription_root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "analytics.AnalyticSource" */
  AnalyticSources: Array<AnalyticSources>;
  /** fetch aggregated fields from the table: "analytics.AnalyticSource" */
  AnalyticSources_aggregate: AnalyticSources_aggregate;
  /** fetch data from the table: "analytics.AnalyticSource" using primary key columns */
  AnalyticSources_by_pk?: AnalyticSources;
  /** fetch data from the table in a streaming manner: "analytics.AnalyticSource" */
  AnalyticSources_stream: Array<AnalyticSources>;
  /** fetch data from the table: "qx.ApplicationUserGatewayPassword" */
  ApplicationUserGatewayPassword: Array<ApplicationUserGatewayPassword>;
  /** fetch aggregated fields from the table: "qx.ApplicationUserGatewayPassword" */
  ApplicationUserGatewayPassword_aggregate: ApplicationUserGatewayPassword_aggregate;
  /** fetch data from the table: "qx.ApplicationUserGatewayPassword" using primary key columns */
  ApplicationUserGatewayPassword_by_pk?: ApplicationUserGatewayPassword;
  /** fetch data from the table in a streaming manner: "qx.ApplicationUserGatewayPassword" */
  ApplicationUserGatewayPassword_stream: Array<ApplicationUserGatewayPassword>;
  /** fetch data from the table: "qx.ApplicationUserTwoFactor" */
  ApplicationUserTwoFactor: Array<ApplicationUserTwoFactor>;
  /** fetch aggregated fields from the table: "qx.ApplicationUserTwoFactor" */
  ApplicationUserTwoFactor_aggregate: ApplicationUserTwoFactor_aggregate;
  /** fetch data from the table: "qx.ApplicationUserTwoFactor" using primary key columns */
  ApplicationUserTwoFactor_by_pk?: ApplicationUserTwoFactor;
  /** fetch data from the table in a streaming manner: "qx.ApplicationUserTwoFactor" */
  ApplicationUserTwoFactor_stream: Array<ApplicationUserTwoFactor>;
  /** fetch data from the table: "qx.AuditLog" using primary key columns */
  AuditLog?: qx_AuditLog;
  /** fetch aggregated fields from the table: "qx.AuditLog" */
  AuditLogAggregate: qx_AuditLog_aggregate;
  /** An array relationship */
  AuditLogs: Array<qx_AuditLog>;
  /** fetch data from the table: "qx.DSCConnection" */
  DSCConnection: Array<DSCConnection>;
  /** fetch aggregated fields from the table: "qx.DSCConnection" */
  DSCConnection_aggregate: DSCConnection_aggregate;
  /** fetch data from the table: "qx.DSCConnection" using primary key columns */
  DSCConnection_by_pk?: DSCConnection;
  /** fetch data from the table in a streaming manner: "qx.DSCConnection" */
  DSCConnection_stream: Array<DSCConnection>;
  /** fetch data from the table: "qx.DeviceDIO" using primary key columns */
  DeviceDIO?: qx_DeviceDIO;
  /** An array relationship */
  DeviceDIOs: Array<qx_DeviceDIO>;
  /** fetch aggregated fields from the table: "qx.DeviceDIO" */
  DeviceDioAggregate: qx_DeviceDIO_aggregate;
  /** fetch data from the table: "qx.IntrusionAccessCode" */
  IntrusionAccessCode: Array<IntrusionAccessCode>;
  /** fetch aggregated fields from the table: "qx.IntrusionAccessCode" */
  IntrusionAccessCode_aggregate: IntrusionAccessCode_aggregate;
  /** fetch data from the table: "qx.IntrusionAccessCode" using primary key columns */
  IntrusionAccessCode_by_pk?: IntrusionAccessCode;
  /** fetch data from the table in a streaming manner: "qx.IntrusionAccessCode" */
  IntrusionAccessCode_stream: Array<IntrusionAccessCode>;
  /** fetch data from the table: "qx.IntrusionPartition" */
  IntrusionPartition: Array<IntrusionPartition>;
  /** fetch aggregated fields from the table: "qx.IntrusionPartition" */
  IntrusionPartition_aggregate: IntrusionPartition_aggregate;
  /** fetch data from the table: "qx.IntrusionPartition" using primary key columns */
  IntrusionPartition_by_pk?: IntrusionPartition;
  /** fetch data from the table in a streaming manner: "qx.IntrusionPartition" */
  IntrusionPartition_stream: Array<IntrusionPartition>;
  /** fetch data from the table: "qx.IntrusionZone" */
  IntrusionZone: Array<IntrusionZone>;
  /** fetch aggregated fields from the table: "qx.IntrusionZone" */
  IntrusionZone_aggregate: IntrusionZone_aggregate;
  /** fetch data from the table: "qx.IntrusionZone" using primary key columns */
  IntrusionZone_by_pk?: IntrusionZone;
  /** fetch data from the table in a streaming manner: "qx.IntrusionZone" */
  IntrusionZone_stream: Array<IntrusionZone>;
  /** An array relationship */
  PartitionZoneAssignments: Array<PartitionZoneAssignments>;
  /** An aggregate relationship */
  PartitionZoneAssignments_aggregate: PartitionZoneAssignments_aggregate;
  /** fetch data from the table: "qx.PartitionZoneAssignments" using primary key columns */
  PartitionZoneAssignments_by_pk?: PartitionZoneAssignments;
  /** fetch data from the table in a streaming manner: "qx.PartitionZoneAssignments" */
  PartitionZoneAssignments_stream: Array<PartitionZoneAssignments>;
  /** fetch data from the table: "qx.PassKeyProvider" */
  PassKeyProvider: Array<PassKeyProvider>;
  /** fetch aggregated fields from the table: "qx.PassKeyProvider" */
  PassKeyProvider_aggregate: PassKeyProvider_aggregate;
  /** fetch data from the table: "qx.PassKeyProvider" using primary key columns */
  PassKeyProvider_by_pk?: PassKeyProvider;
  /** fetch data from the table in a streaming manner: "qx.PassKeyProvider" */
  PassKeyProvider_stream: Array<PassKeyProvider>;
  /** An array relationship */
  PermissionPartitionAssignments: Array<PermissionPartitionAssignments>;
  /** An aggregate relationship */
  PermissionPartitionAssignments_aggregate: PermissionPartitionAssignments_aggregate;
  /** fetch data from the table: "qx.PermissionPartitionAssignments" using primary key columns */
  PermissionPartitionAssignments_by_pk?: PermissionPartitionAssignments;
  /** fetch data from the table in a streaming manner: "qx.PermissionPartitionAssignments" */
  PermissionPartitionAssignments_stream: Array<PermissionPartitionAssignments>;
  /** fetch data from the table: "qx.PersonTermsAgreement" */
  PersonTermsAgreement: Array<PersonTermsAgreement>;
  /** fetch aggregated fields from the table: "qx.PersonTermsAgreement" */
  PersonTermsAgreement_aggregate: PersonTermsAgreement_aggregate;
  /** fetch data from the table: "qx.PersonTermsAgreement" using primary key columns */
  PersonTermsAgreement_by_pk?: PersonTermsAgreement;
  /** fetch data from the table in a streaming manner: "qx.PersonTermsAgreement" */
  PersonTermsAgreement_stream: Array<PersonTermsAgreement>;
  /** fetch data from the table: "qx.eAccessBoardType" using primary key columns */
  accessBoardTypeEnum?: qx_eAccessBoardType;
  /** fetch aggregated fields from the table: "qx.eAccessBoardType" */
  accessBoardTypeEnumAggregate: qx_eAccessBoardType_aggregate;
  /** fetch data from the table: "qx.eAccessBoardType" */
  accessBoardTypeEnums: Array<qx_eAccessBoardType>;
  /** fetch data from the table: "qx.AccessCatalog" using primary key columns */
  accessCatalog?: qx_AccessCatalog;
  /** fetch aggregated fields from the table: "qx.AccessCatalog" */
  accessCatalogAggregate: qx_AccessCatalog_aggregate;
  /** fetch data from the table: "qx.AccessCatalog" */
  accessCatalogs: Array<qx_AccessCatalog>;
  /** fetch data from the table: "qx.eAccessDeniedReason" using primary key columns */
  accessDeniedReasonEnum?: qx_eAccessDeniedReason;
  /** fetch aggregated fields from the table: "qx.eAccessDeniedReason" */
  accessDeniedReasonEnumAggregate: qx_eAccessDeniedReason_aggregate;
  /** fetch data from the table: "qx.eAccessDeniedReason" */
  accessDeniedReasonEnums: Array<qx_eAccessDeniedReason>;
  /** fetch data from the table: "qx.eAccessInterfaceType" using primary key columns */
  accessInterfaceTypeEnum?: qx_eAccessInterfaceType;
  /** fetch aggregated fields from the table: "qx.eAccessInterfaceType" */
  accessInterfaceTypeEnumAggregate: qx_eAccessInterfaceType_aggregate;
  /** fetch data from the table: "qx.eAccessInterfaceType" */
  accessInterfaceTypeEnums: Array<qx_eAccessInterfaceType>;
  /** An array relationship */
  accessInventories: Array<qx_AccessInventory>;
  /** fetch data from the table: "qx.AccessInventory" using primary key columns */
  accessInventory?: qx_AccessInventory;
  /** fetch aggregated fields from the table: "qx.AccessInventory" */
  accessInventoryAggregate: qx_AccessInventory_aggregate;
  /** fetch data from the table: "qx.eAccessPointAction" using primary key columns */
  accessPointActionEnum?: qx_eAccessPointAction;
  /** fetch aggregated fields from the table: "qx.eAccessPointAction" */
  accessPointActionEnumAggregate: qx_eAccessPointAction_aggregate;
  /** fetch data from the table: "qx.eAccessPointAction" */
  accessPointActionEnums: Array<qx_eAccessPointAction>;
  /** fetch data from the table: "qx.eAccessPointDirection" using primary key columns */
  accessPointDirectionEnum?: qx_eAccessPointDirection;
  /** fetch aggregated fields from the table: "qx.eAccessPointDirection" */
  accessPointDirectionEnumAggregate: qx_eAccessPointDirection_aggregate;
  /** fetch data from the table: "qx.eAccessPointDirection" */
  accessPointDirectionEnums: Array<qx_eAccessPointDirection>;
  /** fetch data from the table: "qx.eAccessPointType" using primary key columns */
  accessPointTypeEnum?: qx_eAccessPointType;
  /** fetch aggregated fields from the table: "qx.eAccessPointType" */
  accessPointTypeEnumAggregate: qx_eAccessPointType_aggregate;
  /** fetch data from the table: "qx.eAccessPointType" */
  accessPointTypeEnums: Array<qx_eAccessPointType>;
  /** An array relationship */
  analyticAttributeProperties: Array<analyticAttributeProperties>;
  /** An aggregate relationship */
  analyticAttributeProperties_aggregate: analyticAttributeProperties_aggregate;
  /** fetch data from the table: "analytics.AnalyticAttributeProperty" using primary key columns */
  analyticAttributeProperties_by_pk?: analyticAttributeProperties;
  /** fetch data from the table in a streaming manner: "analytics.AnalyticAttributeProperty" */
  analyticAttributeProperties_stream: Array<analyticAttributeProperties>;
  /** fetch data from the table: "analytics.AnalyticAttribute" */
  analyticAttributes: Array<analyticAttributes>;
  /** fetch aggregated fields from the table: "analytics.AnalyticAttribute" */
  analyticAttributes_aggregate: analyticAttributes_aggregate;
  /** fetch data from the table: "analytics.AnalyticAttribute" using primary key columns */
  analyticAttributes_by_pk?: analyticAttributes;
  /** fetch data from the table in a streaming manner: "analytics.AnalyticAttribute" */
  analyticAttributes_stream: Array<analyticAttributes>;
  /** An array relationship */
  analyticDetectedProperties: Array<analyticDetectedProperties>;
  /** An aggregate relationship */
  analyticDetectedProperties_aggregate: analyticDetectedProperties_aggregate;
  /** fetch data from the table: "analytics.AnalyticPropertyDetected" using primary key columns */
  analyticDetectedProperties_by_pk?: analyticDetectedProperties;
  /** fetch data from the table in a streaming manner: "analytics.AnalyticPropertyDetected" */
  analyticDetectedProperties_stream: Array<analyticDetectedProperties>;
  /** fetch data from the table: "analytics.AnalyticType" */
  analyticTypes: Array<analyticTypes>;
  /** fetch aggregated fields from the table: "analytics.AnalyticType" */
  analyticTypes_aggregate: analyticTypes_aggregate;
  /** fetch data from the table: "analytics.AnalyticType" using primary key columns */
  analyticTypes_by_pk?: analyticTypes;
  /** fetch data from the table in a streaming manner: "analytics.AnalyticType" */
  analyticTypes_stream: Array<analyticTypes>;
  /** An array relationship */
  analytics: Array<analytics>;
  /** An aggregate relationship */
  analytics_aggregate: analytics_aggregate;
  /** fetch data from the table: "analytics.Analytic" using primary key columns */
  analytics_by_pk?: analytics;
  /** fetch data from the table in a streaming manner: "analytics.Analytic" */
  analytics_stream: Array<analytics>;
  /** fetch data from the table: "qx.ApplicationUserAppPassword" */
  applicationUserAppPasswords: Array<applicationUserAppPasswords>;
  /** fetch aggregated fields from the table: "qx.ApplicationUserAppPassword" */
  applicationUserAppPasswords_aggregate: applicationUserAppPasswords_aggregate;
  /** fetch data from the table: "qx.ApplicationUserAppPassword" using primary key columns */
  applicationUserAppPasswords_by_pk?: applicationUserAppPasswords;
  /** fetch data from the table in a streaming manner: "qx.ApplicationUserAppPassword" */
  applicationUserAppPasswords_stream: Array<applicationUserAppPasswords>;
  /** fetch data from the table: "qx.ApplicationUserDevice" */
  applicationUserDevices: Array<applicationUserDevices>;
  /** fetch aggregated fields from the table: "qx.ApplicationUserDevice" */
  applicationUserDevices_aggregate: applicationUserDevices_aggregate;
  /** fetch data from the table: "qx.ApplicationUserDevice" using primary key columns */
  applicationUserDevices_by_pk?: applicationUserDevices;
  /** fetch data from the table in a streaming manner: "qx.ApplicationUserDevice" */
  applicationUserDevices_stream: Array<applicationUserDevices>;
  /** fetch data from the table: "analytics.AttributeProperty" */
  attributeProperties: Array<attributeProperties>;
  /** fetch aggregated fields from the table: "analytics.AttributeProperty" */
  attributeProperties_aggregate: attributeProperties_aggregate;
  /** fetch data from the table: "analytics.AttributeProperty" using primary key columns */
  attributeProperties_by_pk?: attributeProperties;
  /** fetch data from the table in a streaming manner: "analytics.AttributeProperty" */
  attributeProperties_stream: Array<attributeProperties>;
  /** fetch data from the table: "analytics.Attribute" */
  attributes: Array<attributes>;
  /** fetch aggregated fields from the table: "analytics.Attribute" */
  attributes_aggregate: attributes_aggregate;
  /** fetch data from the table: "analytics.Attribute" using primary key columns */
  attributes_by_pk?: attributes;
  /** fetch data from the table in a streaming manner: "analytics.Attribute" */
  attributes_stream: Array<attributes>;
  /** fetch data from the table: "qx.AudioSource" using primary key columns */
  audioSource?: qx_AudioSource;
  /** fetch aggregated fields from the table: "qx.AudioSource" */
  audioSourceAggregate: qx_AudioSource_aggregate;
  /** fetch data from the table: "audit.vAudioSourceAudit" */
  audioSourceAudit: Array<audioSourceAudit>;
  /** fetch aggregated fields from the table: "audit.vAudioSourceAudit" */
  audioSourceAudit_aggregate: audioSourceAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.vAudioSourceAudit" */
  audioSourceAudit_stream: Array<audioSourceAudit>;
  /** fetch data from the table: "qx.vAudioSourceVideoSource" */
  audioSourceVideoSource: Array<audioSourceVideoSource>;
  /** fetch aggregated fields from the table: "qx.vAudioSourceVideoSource" */
  audioSourceVideoSource_aggregate: audioSourceVideoSource_aggregate;
  /** fetch data from the table in a streaming manner: "qx.vAudioSourceVideoSource" */
  audioSourceVideoSource_stream: Array<audioSourceVideoSource>;
  /** An array relationship */
  audioSources: Array<qx_AudioSource>;
  /** fetch data from the table: "audit.logged_actions" */
  audit_logged_actions: Array<audit_logged_actions>;
  /** fetch aggregated fields from the table: "audit.logged_actions" */
  audit_logged_actions_aggregate: audit_logged_actions_aggregate;
  /** fetch data from the table: "audit.logged_actions" using primary key columns */
  audit_logged_actions_by_pk?: audit_logged_actions;
  /** fetch data from the table in a streaming manner: "audit.logged_actions" */
  audit_logged_actions_stream: Array<audit_logged_actions>;
  /** fetch data from the table: "audit.vSensorAudit" */
  audit_vSensorAudit: Array<audit_vSensorAudit>;
  /** fetch aggregated fields from the table: "audit.vSensorAudit" */
  audit_vSensorAudit_aggregate: audit_vSensorAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.vSensorAudit" */
  audit_vSensorAudit_stream: Array<audit_vSensorAudit>;
  /** fetch data from the table: "qx.AuditableAction" */
  auditableActions: Array<qx_AuditableAction>;
  /** fetch data from the table: "qx.AuditableType" */
  auditableTypes: Array<qx_AuditableType>;
  /** fetch data from the table: "qx.eAuthStrategy" using primary key columns */
  authStrategyEnum?: qx_eAuthStrategy;
  /** fetch aggregated fields from the table: "qx.eAuthStrategy" */
  authStrategyEnumAggregate: qx_eAuthStrategy_aggregate;
  /** fetch data from the table: "qx.eAuthStrategy" */
  authStrategyEnums: Array<qx_eAuthStrategy>;
  /** fetch data from the table: "qx.eBatteryLevel" using primary key columns */
  batteryLevelEnum?: qx_eBatteryLevel;
  /** fetch aggregated fields from the table: "qx.eBatteryLevel" */
  batteryLevelEnumAggregate: qx_eBatteryLevel_aggregate;
  /** fetch data from the table: "qx.eBatteryLevel" */
  batteryLevelEnums: Array<qx_eBatteryLevel>;
  /** fetch data from the table: "qx.eBaudrate" using primary key columns */
  baudrateEnum?: qx_eBaudrate;
  /** fetch aggregated fields from the table: "qx.eBaudrate" */
  baudrateEnumAggregate: qx_eBaudrate_aggregate;
  /** fetch data from the table: "qx.eBaudrate" */
  baudrateEnums: Array<qx_eBaudrate>;
  /** fetch data from the table: "qx.BillingPeriod" using primary key columns */
  billingPeriod?: qx_BillingPeriod;
  /** fetch aggregated fields from the table: "qx.BillingPeriod" */
  billingPeriodAggregate: qx_BillingPeriod_aggregate;
  /** fetch data from the table: "qx.BillingPeriod" */
  billingPeriods: Array<qx_BillingPeriod>;
  /** fetch data from the table: "qx.eBillingTier" using primary key columns */
  billingTierEnum?: qx_eBillingTier;
  /** fetch aggregated fields from the table: "qx.eBillingTier" */
  billingTierEnumAggregate: qx_eBillingTier_aggregate;
  /** fetch data from the table: "qx.eBillingTier" */
  billingTierEnums: Array<qx_eBillingTier>;
  /** fetch aggregated fields from the table: "qx.vChatBillingByModel" */
  chatBillingByModelAggregate: qx_vChatBillingByModel_aggregate;
  /** fetch data from the table: "qx.vChatBillingByModel" */
  chatBillingByModels: Array<qx_vChatBillingByModel>;
  /** fetch data from the table: "qx.vChatBillingSummary" */
  chatBillingSummaries: Array<qx_vChatBillingSummary>;
  /** fetch aggregated fields from the table: "qx.vChatBillingSummary" */
  chatBillingSummaryAggregate: qx_vChatBillingSummary_aggregate;
  /** fetch aggregated fields from the table: "qx.vChatPromptUsage" */
  chatPromptUsageAggregate: qx_vChatPromptUsage_aggregate;
  /** fetch data from the table: "qx.vChatPromptUsage" */
  chatPromptUsages: Array<qx_vChatPromptUsage>;
  /** fetch data from the table: "qx.ChatUsageHistory" */
  chatUsageHistories: Array<qx_ChatUsageHistory>;
  /** fetch data from the table: "qx.ChatUsageHistory" using primary key columns */
  chatUsageHistory?: qx_ChatUsageHistory;
  /** fetch aggregated fields from the table: "qx.ChatUsageHistory" */
  chatUsageHistoryAggregate: qx_ChatUsageHistory_aggregate;
  /** execute function "qx.chat_usage_per_model" which returns "qx.vChatUsagePerModel" */
  chat_usage_per_model: Array<qx_vChatUsagePerModel>;
  /** execute function "qx.chat_usage_series" which returns "qx.vChatUsageSeries" */
  chat_usage_series: Array<qx_vChatUsageSeries>;
  /** fetch data from the table: "qx.Clip" using primary key columns */
  clip?: qx_Clip;
  /** fetch aggregated fields from the table: "qx.Clip" */
  clipAggregate: qx_Clip_aggregate;
  /** fetch aggregated fields from the table: "qx.ClipAuditLog" */
  clipAuditLogAggregate: qx_ClipAuditLog_aggregate;
  /** fetch data from the table: "qx.ClipAuditLog" */
  clipAuditLogs: Array<qx_ClipAuditLog>;
  /** fetch data from the table: "qx.eClipStatus" using primary key columns */
  clipStatusReasonEnum?: qx_eClipStatus;
  /** fetch aggregated fields from the table: "qx.eClipStatus" */
  clipStatusReasonEnumAggregate: qx_eClipStatus_aggregate;
  /** fetch data from the table: "qx.eClipStatus" */
  clipStatusReasonEnums: Array<qx_eClipStatus>;
  /** fetch data from the table: "qx.eClipType" using primary key columns */
  clipTypeEnum?: qx_eClipType;
  /** fetch aggregated fields from the table: "qx.eClipType" */
  clipTypeEnumAggregate: qx_eClipType_aggregate;
  /** fetch data from the table: "qx.eClipType" */
  clipTypeEnums: Array<qx_eClipType>;
  /** An array relationship */
  clips: Array<qx_Clip>;
  /** fetch data from the table: "qx.CloudStorageOptions" using primary key columns */
  cloudStorageOption?: qx_CloudStorageOptions;
  /** fetch data from the table: "qx.CloudStorageOptions" */
  cloudStorageOptions: Array<qx_CloudStorageOptions>;
  /** fetch aggregated fields from the table: "qx.CloudStorageOptions" */
  cloudStorageOptionsAggregate: qx_CloudStorageOptions_aggregate;
  /** fetch data from the table: "qx.CloudStorageTimelapseOptions" */
  cloudStorageTimelapseOptions: Array<cloudStorageTimelapseOptions>;
  /** fetch aggregated fields from the table: "qx.CloudStorageTimelapseOptions" */
  cloudStorageTimelapseOptions_aggregate: cloudStorageTimelapseOptions_aggregate;
  /** fetch data from the table: "qx.CloudStorageTimelapseOptions" using primary key columns */
  cloudStorageTimelapseOptions_by_pk?: cloudStorageTimelapseOptions;
  /** fetch data from the table in a streaming manner: "qx.CloudStorageTimelapseOptions" */
  cloudStorageTimelapseOptions_stream: Array<cloudStorageTimelapseOptions>;
  /** fetch data from the table: "qx.Credential" using primary key columns */
  credential?: qx_Credential;
  /** fetch aggregated fields from the table: "qx.Credential" */
  credentialAggregate: qx_Credential_aggregate;
  /** fetch data from the table: "audit.vCredentialAudit" */
  credentialAudit: Array<credentialAudit>;
  /** fetch aggregated fields from the table: "audit.vCredentialAudit" */
  credentialAudit_aggregate: credentialAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.vCredentialAudit" */
  credentialAudit_stream: Array<credentialAudit>;
  /** fetch data from the table: "qx.eCredentialType" using primary key columns */
  credentialTypeEnum?: qx_eCredentialType;
  /** fetch aggregated fields from the table: "qx.eCredentialType" */
  credentialTypeEnumAggregate: qx_eCredentialType_aggregate;
  /** fetch data from the table: "qx.eCredentialType" */
  credentialTypeEnums: Array<qx_eCredentialType>;
  /** An array relationship */
  credentials: Array<qx_Credential>;
  /** fetch data from the table: "qx.CustomerPermission" using primary key columns */
  customerPermission?: qx_CustomerPermission;
  /** fetch aggregated fields from the table: "qx.CustomerPermission" */
  customerPermissionAggregate: qx_CustomerPermission_aggregate;
  /** fetch data from the table: "audit.vCustomerPermissionAudit" */
  customerPermissionAudit: Array<customerPermissionAudit>;
  /** fetch aggregated fields from the table: "audit.vCustomerPermissionAudit" */
  customerPermissionAudit_aggregate: customerPermissionAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.vCustomerPermissionAudit" */
  customerPermissionAudit_stream: Array<customerPermissionAudit>;
  /** fetch data from the table: "qx.CustomerPermission" */
  customerPermissions: Array<qx_CustomerPermission>;
  /** fetch data from the table: "qx.Device" using primary key columns */
  device?: qx_Device;
  /** fetch aggregated fields from the table: "qx.Device" */
  deviceAggregate: qx_Device_aggregate;
  /** fetch data from the table: "qx.DeviceAnalyticSource" */
  deviceAnalyticSource: Array<deviceAnalyticSource>;
  /** fetch aggregated fields from the table: "qx.DeviceAnalyticSource" */
  deviceAnalyticSource_aggregate: deviceAnalyticSource_aggregate;
  /** fetch data from the table: "qx.DeviceAnalyticSource" using primary key columns */
  deviceAnalyticSource_by_pk?: deviceAnalyticSource;
  /** fetch data from the table in a streaming manner: "qx.DeviceAnalyticSource" */
  deviceAnalyticSource_stream: Array<deviceAnalyticSource>;
  /** fetch data from the table: "audit.vDeviceAudit" */
  deviceAudit: Array<deviceAudit>;
  /** fetch aggregated fields from the table: "audit.vDeviceAudit" */
  deviceAudit_aggregate: deviceAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.vDeviceAudit" */
  deviceAudit_stream: Array<deviceAudit>;
  /** fetch data from the table: "qx.eDeviceConnectionStatus" using primary key columns */
  deviceConnectionStatusEnum?: qx_eDeviceConnectionStatus;
  /** fetch aggregated fields from the table: "qx.eDeviceConnectionStatus" */
  deviceConnectionStatusEnumAggregate: qx_eDeviceConnectionStatus_aggregate;
  /** fetch data from the table: "qx.eDeviceConnectionStatus" */
  deviceConnectionStatusEnums: Array<qx_eDeviceConnectionStatus>;
  /** fetch data from the table: "audit.vDeviceDIOAudit" */
  deviceDIOAudit: Array<deviceDIOAudit>;
  /** fetch aggregated fields from the table: "audit.vDeviceDIOAudit" */
  deviceDIOAudit_aggregate: deviceDIOAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.vDeviceDIOAudit" */
  deviceDIOAudit_stream: Array<deviceDIOAudit>;
  /** fetch data from the table: "qx.eDeviceKind" using primary key columns */
  deviceKindEnum?: qx_eDeviceKind;
  /** fetch aggregated fields from the table: "qx.eDeviceKind" */
  deviceKindEnumAggregate: qx_eDeviceKind_aggregate;
  /** fetch data from the table: "qx.eDeviceKind" */
  deviceKindEnums: Array<qx_eDeviceKind>;
  /** An array relationship */
  devices: Array<qx_Device>;
  /** fetch data from the table: "qx.eDIONormalState" using primary key columns */
  dioNormalStateEnum?: qx_eDIONormalState;
  /** fetch aggregated fields from the table: "qx.eDIONormalState" */
  dioNormalStateEnumAggregate: qx_eDIONormalState_aggregate;
  /** fetch data from the table: "qx.eDIONormalState" */
  dioNormalStateEnums: Array<qx_eDIONormalState>;
  /** fetch data from the table: "qx.eDIOState" using primary key columns */
  dioStateEnum?: qx_eDIOState;
  /** fetch aggregated fields from the table: "qx.eDIOState" */
  dioStateEnumAggregate: qx_eDIOState_aggregate;
  /** fetch data from the table: "qx.eDIOState" */
  dioStateEnums: Array<qx_eDIOState>;
  /** fetch data from the table: "qx.eDIOType" using primary key columns */
  dioTypeEnum?: qx_eDIOType;
  /** fetch aggregated fields from the table: "qx.eDIOType" */
  dioTypeEnumAggregate: qx_eDIOType_aggregate;
  /** fetch data from the table: "qx.eDIOType" */
  dioTypeEnums: Array<qx_eDIOType>;
  /** fetch data from the table: "qx.DiscoveryType" */
  discoveryTypes: Array<qx_DiscoveryType>;
  /** fetch data from the table: "qx.Door" using primary key columns */
  door?: qx_Door;
  /** fetch aggregated fields from the table: "qx.Door" */
  doorAggregate: qx_Door_aggregate;
  /** fetch data from the table: "qx.eDoorAlarm" using primary key columns */
  doorAlarmEnum?: qx_eDoorAlarm;
  /** fetch aggregated fields from the table: "qx.eDoorAlarm" */
  doorAlarmEnumAggregate: qx_eDoorAlarm_aggregate;
  /** fetch data from the table: "qx.eDoorAlarm" */
  doorAlarmEnums: Array<qx_eDoorAlarm>;
  /** fetch data from the table: "audit.vDoorAudit" */
  doorAudit: Array<doorAudit>;
  /** fetch aggregated fields from the table: "audit.vDoorAudit" */
  doorAudit_aggregate: doorAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.vDoorAudit" */
  doorAudit_stream: Array<doorAudit>;
  /** fetch data from the table: "qx.DoorConfiguration" using primary key columns */
  doorConfiguration?: qx_DoorConfiguration;
  /** fetch aggregated fields from the table: "qx.DoorConfiguration" */
  doorConfigurationAggregate: qx_DoorConfiguration_aggregate;
  /** fetch data from the table: "qx.DoorConfiguration" */
  doorConfigurations: Array<qx_DoorConfiguration>;
  /** fetch data from the table: "qx.DoorMeta" using primary key columns */
  doorMeta?: qx_DoorMeta;
  /** fetch aggregated fields from the table: "qx.DoorMeta" */
  doorMetaAggregate: qx_DoorMeta_aggregate;
  /** fetch data from the table: "qx.DoorMeta" */
  doorMetas: Array<qx_DoorMeta>;
  /** fetch data from the table: "qx.eDoorMode" using primary key columns */
  doorModeEnum?: qx_eDoorMode;
  /** fetch aggregated fields from the table: "qx.eDoorMode" */
  doorModeEnumAggregate: qx_eDoorMode_aggregate;
  /** fetch data from the table: "qx.eDoorMode" */
  doorModeEnums: Array<qx_eDoorMode>;
  /** fetch data from the table: "qx.eDoorMonitor" using primary key columns */
  doorMonitorEnum?: qx_eDoorMonitor;
  /** fetch aggregated fields from the table: "qx.eDoorMonitor" */
  doorMonitorEnumAggregate: qx_eDoorMonitor_aggregate;
  /** fetch data from the table: "qx.eDoorMonitor" */
  doorMonitorEnums: Array<qx_eDoorMonitor>;
  /** fetch data from the table: "qx.eDoorState" using primary key columns */
  doorStateEnum?: qx_eDoorState;
  /** fetch aggregated fields from the table: "qx.eDoorState" */
  doorStateEnumAggregate: qx_eDoorState_aggregate;
  /** fetch data from the table: "qx.eDoorState" */
  doorStateEnums: Array<qx_eDoorState>;
  /** fetch data from the table: "qx.DoorTemplate" using primary key columns */
  doorTemplate?: qx_DoorTemplate;
  /** fetch aggregated fields from the table: "qx.DoorTemplate" */
  doorTemplateAggregate: qx_DoorTemplate_aggregate;
  /** fetch data from the table: "qx.DoorTemplate" */
  doorTemplates: Array<qx_DoorTemplate>;
  /** An array relationship */
  doors: Array<qx_Door>;
  /** fetch data from the table: "analytics.eAnalyticIntegration" */
  eAnalyticIntegrations: Array<eAnalyticIntegrations>;
  /** fetch aggregated fields from the table: "analytics.eAnalyticIntegration" */
  eAnalyticIntegrations_aggregate: eAnalyticIntegrations_aggregate;
  /** fetch data from the table: "analytics.eAnalyticIntegration" using primary key columns */
  eAnalyticIntegrations_by_pk?: eAnalyticIntegrations;
  /** fetch data from the table in a streaming manner: "analytics.eAnalyticIntegration" */
  eAnalyticIntegrations_stream: Array<eAnalyticIntegrations>;
  /** fetch data from the table: "analytics.eAnalyticState" */
  eAnalyticStates: Array<eAnalyticStates>;
  /** fetch aggregated fields from the table: "analytics.eAnalyticState" */
  eAnalyticStates_aggregate: eAnalyticStates_aggregate;
  /** fetch data from the table: "analytics.eAnalyticState" using primary key columns */
  eAnalyticStates_by_pk?: eAnalyticStates;
  /** fetch data from the table in a streaming manner: "analytics.eAnalyticState" */
  eAnalyticStates_stream: Array<eAnalyticStates>;
  /** fetch data from the table: "qx.eGatewayType" */
  eGatewayType: Array<eGatewayType>;
  /** fetch aggregated fields from the table: "qx.eGatewayType" */
  eGatewayType_aggregate: eGatewayType_aggregate;
  /** fetch data from the table: "qx.eGatewayType" using primary key columns */
  eGatewayType_by_pk?: eGatewayType;
  /** fetch data from the table in a streaming manner: "qx.eGatewayType" */
  eGatewayType_stream: Array<eGatewayType>;
  /** fetch data from the table: "qx.eS3BucketType" */
  eS3BucketType: Array<eS3BucketType>;
  /** fetch aggregated fields from the table: "qx.eS3BucketType" */
  eS3BucketType_aggregate: eS3BucketType_aggregate;
  /** fetch data from the table: "qx.eS3BucketType" using primary key columns */
  eS3BucketType_by_pk?: eS3BucketType;
  /** fetch data from the table in a streaming manner: "qx.eS3BucketType" */
  eS3BucketType_stream: Array<eS3BucketType>;
  /** fetch data from the table: "qx.Event" using primary key columns */
  event?: qx_Event;
  /** fetch aggregated fields from the table: "qx.Event" */
  eventAggregate: qx_Event_aggregate;
  /** fetch data from the table: "qx.EventType" using primary key columns */
  eventType?: qx_EventType;
  /** fetch aggregated fields from the table: "qx.EventType" */
  eventTypeAggregate: qx_EventType_aggregate;
  /** fetch data from the table: "qx.EventType" */
  eventTypes: Array<qx_EventType>;
  /** An array relationship */
  events: Array<qx_Event>;
  /** fetch data from the table: "qx.Flow" using primary key columns */
  flow?: qx_Flow;
  /** fetch aggregated fields from the table: "qx.Flow" */
  flowAggregate: qx_Flow_aggregate;
  /** fetch data from the table: "audit.vFlowAudit" */
  flowAudit: Array<flowAudit>;
  /** fetch aggregated fields from the table: "audit.vFlowAudit" */
  flowAudit_aggregate: flowAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.vFlowAudit" */
  flowAudit_stream: Array<flowAudit>;
  /** fetch data from the table: "qx.FlowTrace" using primary key columns */
  flowTrace?: qx_FlowTrace;
  /** fetch aggregated fields from the table: "qx.FlowTrace" */
  flowTraceAggregate: qx_FlowTrace_aggregate;
  /** fetch data from the table: "qx.FlowTrace" */
  flowTraces: Array<qx_FlowTrace>;
  /** An array relationship */
  flows: Array<qx_Flow>;
  /** fetch data from the table: "qx.Gateway" using primary key columns */
  gateway?: qx_Gateway;
  /** fetch aggregated fields from the table: "qx.Gateway" */
  gatewayAggregate: qx_Gateway_aggregate;
  /** fetch data from the table: "audit.vGatewayAudit" */
  gatewayAudit: Array<gatewayAudit>;
  /** fetch aggregated fields from the table: "audit.vGatewayAudit" */
  gatewayAudit_aggregate: gatewayAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.vGatewayAudit" */
  gatewayAudit_stream: Array<gatewayAudit>;
  /** fetch data from the table: "qx.GatewayBandwidthSchedule" using primary key columns */
  gatewayBandwidthSchedule?: qx_GatewayBandwidthSchedule;
  /** fetch aggregated fields from the table: "qx.GatewayBandwidthSchedule" */
  gatewayBandwidthScheduleAggregate: qx_GatewayBandwidthSchedule_aggregate;
  /** fetch data from the table: "audit.vGatewayBandwidthScheduleAudit" */
  gatewayBandwidthScheduleAudit: Array<gatewayBandwidthScheduleAudit>;
  /** fetch aggregated fields from the table: "audit.vGatewayBandwidthScheduleAudit" */
  gatewayBandwidthScheduleAudit_aggregate: gatewayBandwidthScheduleAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.vGatewayBandwidthScheduleAudit" */
  gatewayBandwidthScheduleAudit_stream: Array<gatewayBandwidthScheduleAudit>;
  /** An array relationship */
  gatewayBandwidthSchedules: Array<qx_GatewayBandwidthSchedule>;
  /** fetch data from the table: "qx.eGatewayServiceType" */
  gatewayServiceEnums: Array<qx_eGatewayServiceType>;
  /** fetch data from the table: "qx.eGatewayServiceType" using primary key columns */
  gatewayServiceTypeEnum?: qx_eGatewayServiceType;
  /** fetch aggregated fields from the table: "qx.eGatewayServiceType" */
  gatewayServiceTypeEnumAggregate: qx_eGatewayServiceType_aggregate;
  /** fetch data from the table: "qx.eGatewaySyncStatus" using primary key columns */
  gatewaySyncStatusEnum?: qx_eGatewaySyncStatus;
  /** fetch aggregated fields from the table: "qx.eGatewaySyncStatus" */
  gatewaySyncStatusEnumAggregate: qx_eGatewaySyncStatus_aggregate;
  /** fetch data from the table: "qx.eGatewaySyncStatus" */
  gatewaySyncStatusEnums: Array<qx_eGatewaySyncStatus>;
  /** An array relationship */
  gateways: Array<qx_Gateway>;
  /** fetch data from the table: "qx.Group" using primary key columns */
  group?: qx_Group;
  /** fetch aggregated fields from the table: "qx.Group" */
  groupAggregate: qx_Group_aggregate;
  /** fetch data from the table: "audit.vGroupAudit" */
  groupAudit: Array<groupAudit>;
  /** fetch aggregated fields from the table: "audit.vGroupAudit" */
  groupAudit_aggregate: groupAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.vGroupAudit" */
  groupAudit_stream: Array<groupAudit>;
  /** An array relationship */
  groups: Array<qx_Group>;
  /** fetch data from the table: "qx.GuestAccess" */
  guestAccess: Array<guestAccess>;
  /** fetch aggregated fields from the table: "qx.GuestAccess" */
  guestAccess_aggregate: guestAccess_aggregate;
  /** fetch data from the table: "qx.GuestAccess" using primary key columns */
  guestAccess_by_pk?: guestAccess;
  /** fetch data from the table in a streaming manner: "qx.GuestAccess" */
  guestAccess_stream: Array<guestAccess>;
  /** fetch data from the table: "qx.HolidaySet" using primary key columns */
  holidaySet?: qx_HolidaySet;
  /** fetch aggregated fields from the table: "qx.HolidaySet" */
  holidaySetAggregate: qx_HolidaySet_aggregate;
  /** fetch data from the table: "audit.vHolidaySetAudit" */
  holidaySetAudit: Array<holidaySetAudit>;
  /** fetch aggregated fields from the table: "audit.vHolidaySetAudit" */
  holidaySetAudit_aggregate: holidaySetAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.vHolidaySetAudit" */
  holidaySetAudit_stream: Array<holidaySetAudit>;
  /** fetch data from the table: "qx._HolidaySetToScheduleBlock" using primary key columns */
  holidaySetToScheduleBlock?: qx__HolidaySetToScheduleBlock;
  /** fetch aggregated fields from the table: "qx._HolidaySetToScheduleBlock" */
  holidaySetToScheduleBlockAggregate: qx__HolidaySetToScheduleBlock_aggregate;
  /** fetch data from the table: "audit.v_HolidaySetToScheduleBlockAudit" */
  holidaySetToScheduleBlockAudit: Array<holidaySetToScheduleBlockAudit>;
  /** fetch aggregated fields from the table: "audit.v_HolidaySetToScheduleBlockAudit" */
  holidaySetToScheduleBlockAudit_aggregate: holidaySetToScheduleBlockAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.v_HolidaySetToScheduleBlockAudit" */
  holidaySetToScheduleBlockAudit_stream: Array<holidaySetToScheduleBlockAudit>;
  /** fetch data from the table: "qx._HolidaySetToScheduleBlock" */
  holidaySetToScheduleBlocks: Array<qx__HolidaySetToScheduleBlock>;
  /** An array relationship */
  holidaySets: Array<qx_HolidaySet>;
  /** fetch data from the table: "qx.InputPoint" using primary key columns */
  inputPoint?: qx_InputPoint;
  /** fetch aggregated fields from the table: "qx.InputPoint" */
  inputPointAggregate: qx_InputPoint_aggregate;
  /** fetch data from the table: "audit.vInputPointAudit" */
  inputPointAudit: Array<inputPointAudit>;
  /** fetch aggregated fields from the table: "audit.vInputPointAudit" */
  inputPointAudit_aggregate: inputPointAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.vInputPointAudit" */
  inputPointAudit_stream: Array<inputPointAudit>;
  /** fetch data from the table: "qx.InputPoint" */
  inputPoints: Array<qx_InputPoint>;
  /** fetch data from the table: "qx.eKeypadMode" using primary key columns */
  keyModeEnum?: qx_eKeypadMode;
  /** fetch aggregated fields from the table: "qx.eKeypadMode" */
  keyModeEnumAggregate: qx_eKeypadMode_aggregate;
  /** fetch data from the table: "qx.eKeypadMode" */
  keyModeEnums: Array<qx_eKeypadMode>;
  /** fetch data from the table: "qx.Layout" using primary key columns */
  layout?: qx_Layout;
  /** An array relationship */
  layouts: Array<qx_Layout>;
  /** fetch aggregated fields from the table: "qx.Layout" */
  layoutsAggregate: qx_Layout_aggregate;
  /** fetch data from the table: "qx.LensProfile" using primary key columns */
  lensProfile?: qx_LensProfile;
  /** fetch aggregated fields from the table: "qx.LensProfile" */
  lensProfileAggregate: qx_LensProfile_aggregate;
  /** fetch data from the table: "qx.LensProfile" */
  lensProfiles: Array<qx_LensProfile>;
  /** fetch data from the table: "qx.SharedLinkType" */
  linkableTypes: Array<qx_SharedLinkType>;
  /** fetch data from the table: "qx.Lock" using primary key columns */
  lock?: qx_Lock;
  /** fetch aggregated fields from the table: "qx.Lock" */
  lockAggregate: qx_Lock_aggregate;
  /** fetch data from the table: "audit.vLockAudit" */
  lockAudit: Array<lockAudit>;
  /** fetch aggregated fields from the table: "audit.vLockAudit" */
  lockAudit_aggregate: lockAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.vLockAudit" */
  lockAudit_stream: Array<lockAudit>;
  /** fetch data from the table: "qx.eLockPowerMonitor" using primary key columns */
  lockPowerMonitorEnum?: qx_eLockPowerMonitor;
  /** fetch aggregated fields from the table: "qx.eLockPowerMonitor" */
  lockPowerMonitorEnumAggregate: qx_eLockPowerMonitor_aggregate;
  /** fetch data from the table: "qx.eLockPowerMonitor" */
  lockPowerMonitorEnums: Array<qx_eLockPowerMonitor>;
  /** fetch data from the table: "qx.eLockRelayMonitor" using primary key columns */
  lockRelayMonitorEnum?: qx_eLockRelayMonitor;
  /** fetch aggregated fields from the table: "qx.eLockRelayMonitor" */
  lockRelayMonitorEnumAggregate: qx_eLockRelayMonitor_aggregate;
  /** fetch data from the table: "qx.eLockRelayMonitor" */
  lockRelayMonitorEnums: Array<qx_eLockRelayMonitor>;
  /** fetch data from the table: "qx.eLockType" using primary key columns */
  lockTypeEnum?: qx_eLockType;
  /** fetch aggregated fields from the table: "qx.eLockType" */
  lockTypeEnumAggregate: qx_eLockType_aggregate;
  /** fetch data from the table: "qx.eLockType" */
  lockTypeEnums: Array<qx_eLockType>;
  /** An array relationship */
  locks: Array<qx_Lock>;
  /** fetch data from the table: "qx.MediaProfile" using primary key columns */
  mediaProfile?: qx_MediaProfile;
  /** fetch aggregated fields from the table: "qx.MediaProfile" */
  mediaProfileAggregate: qx_MediaProfile_aggregate;
  /** fetch data from the table: "audit.vMediaProfileAudit" */
  mediaProfileAudit: Array<mediaProfileAudit>;
  /** fetch aggregated fields from the table: "audit.vMediaProfileAudit" */
  mediaProfileAudit_aggregate: mediaProfileAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.vMediaProfileAudit" */
  mediaProfileAudit_stream: Array<mediaProfileAudit>;
  /** An array relationship */
  mediaProfiles: Array<qx_MediaProfile>;
  /** fetch data from the table: "qx.MercuryControlPoint" using primary key columns */
  mercuryControlPoint?: qx_MercuryControlPoint;
  /** fetch aggregated fields from the table: "qx.MercuryControlPoint" */
  mercuryControlPointAggregate: qx_MercuryControlPoint_aggregate;
  /** fetch data from the table: "qx.MercuryControlPoint" */
  mercuryControlPoints: Array<qx_MercuryControlPoint>;
  /** fetch data from the table: "qx.MercuryMonitorPoint" using primary key columns */
  mercuryMonitorPoint?: qx_MercuryMonitorPoint;
  /** fetch aggregated fields from the table: "qx.MercuryMonitorPoint" */
  mercuryMonitorPointAggregate: qx_MercuryMonitorPoint_aggregate;
  /** fetch data from the table: "qx.MercuryMonitorPoint" */
  mercuryMonitorPoints: Array<qx_MercuryMonitorPoint>;
  /** fetch data from the table: "qx.eMonitorLockState" using primary key columns */
  monitorLockStateEnum?: qx_eMonitorLockState;
  /** fetch aggregated fields from the table: "qx.eMonitorLockState" */
  monitorLockStateEnumAggregate: qx_eMonitorLockState_aggregate;
  /** fetch data from the table: "qx.eMonitorLockState" */
  monitorLockStateEnums: Array<qx_eMonitorLockState>;
  /** fetch data from the table: "qx.eMountPosition" using primary key columns */
  mountPositionEnum?: qx_eMountPosition;
  /** fetch aggregated fields from the table: "qx.eMountPosition" */
  mountPositionEnumAggregate: qx_eMountPosition_aggregate;
  /** fetch data from the table: "qx.eMountPosition" */
  mountPositionEnums: Array<qx_eMountPosition>;
  /** fetch data from the table: "qx.eFlowNotificationType" using primary key columns */
  notificationTypeEnum?: qx_eFlowNotificationType;
  /** fetch aggregated fields from the table: "qx.eFlowNotificationType" */
  notificationTypeEnumAggregate: qx_eFlowNotificationType_aggregate;
  /** fetch data from the table: "qx.eFlowNotificationType" */
  notificationTypeEnums: Array<qx_eFlowNotificationType>;
  /** fetch data from the table: "qx.eObjectAction" using primary key columns */
  objectActionEnum?: qx_eObjectAction;
  /** fetch aggregated fields from the table: "qx.eObjectAction" */
  objectActionEnumAggregate: qx_eObjectAction_aggregate;
  /** fetch data from the table: "qx.eObjectAction" */
  objectActionEnums: Array<qx_eObjectAction>;
  /** fetch data from the table: "qx.OssIdAssignment" using primary key columns */
  ossIdAssignment?: qx_OssIdAssignment;
  /** fetch aggregated fields from the table: "qx.OssIdAssignment" */
  ossIdAssignmentAggregate: qx_OssIdAssignment_aggregate;
  /** fetch data from the table: "qx.OssIdAssignment" */
  ossIdAssignments: Array<qx_OssIdAssignment>;
  /** fetch data from the table: "qx.OutputPoint" using primary key columns */
  outputPoint?: qx_OutputPoint;
  /** fetch aggregated fields from the table: "qx.OutputPoint" */
  outputPointAggregate: qx_OutputPoint_aggregate;
  /** fetch data from the table: "audit.vOutputPointAudit" */
  outputPointAudit: Array<outputPointAudit>;
  /** fetch aggregated fields from the table: "audit.vOutputPointAudit" */
  outputPointAudit_aggregate: outputPointAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.vOutputPointAudit" */
  outputPointAudit_stream: Array<outputPointAudit>;
  /** fetch data from the table: "qx.OutputPoint" */
  outputPoints: Array<qx_OutputPoint>;
  /** fetch data from the table: "qx.ePACSStatus" using primary key columns */
  pacsStatusEnum?: qx_ePACSStatus;
  /** fetch aggregated fields from the table: "qx.ePACSStatus" */
  pacsStatusEnumAggregate: qx_ePACSStatus_aggregate;
  /** fetch data from the table: "qx.ePACSStatus" */
  pacsStatusEnums: Array<qx_ePACSStatus>;
  /** An array relationship */
  people: Array<qx_Person>;
  /** fetch data from the table: "qx.Permission" using primary key columns */
  permission?: qx_Permission;
  /** fetch aggregated fields from the table: "qx.Permission" */
  permissionAggregate: qx_Permission_aggregate;
  /** fetch data from the table: "audit.vPermissionAudit" */
  permissionAudit: Array<permissionAudit>;
  /** fetch aggregated fields from the table: "audit.vPermissionAudit" */
  permissionAudit_aggregate: permissionAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.vPermissionAudit" */
  permissionAudit_stream: Array<permissionAudit>;
  /** An array relationship */
  permissions: Array<qx_Permission>;
  /** fetch data from the table: "qx.Person" using primary key columns */
  person?: qx_Person;
  /** fetch aggregated fields from the table: "qx.Person" */
  personAggregate: qx_Person_aggregate;
  /** fetch data from the table: "qx.vPersonAudioSourceAppPrivileges" */
  personAudioSourceAppPrivileges: Array<personAudioSourceAppPrivileges>;
  /** fetch aggregated fields from the table: "qx.vPersonAudioSourceAppPrivileges" */
  personAudioSourceAppPrivileges_aggregate: personAudioSourceAppPrivileges_aggregate;
  /** fetch data from the table in a streaming manner: "qx.vPersonAudioSourceAppPrivileges" */
  personAudioSourceAppPrivileges_stream: Array<personAudioSourceAppPrivileges>;
  /** fetch data from the table: "audit.vPersonAudit" */
  personAudit: Array<personAudit>;
  /** fetch aggregated fields from the table: "audit.vPersonAudit" */
  personAudit_aggregate: personAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.vPersonAudit" */
  personAudit_stream: Array<personAudit>;
  /** An array relationship */
  personDeviceAppPrivileges: Array<personDeviceAppPrivileges>;
  /** An aggregate relationship */
  personDeviceAppPrivileges_aggregate: personDeviceAppPrivileges_aggregate;
  /** fetch data from the table: "qx.PersonDeviceAppPrivileges" using primary key columns */
  personDeviceAppPrivileges_by_pk?: personDeviceAppPrivileges;
  /** fetch data from the table in a streaming manner: "qx.PersonDeviceAppPrivileges" */
  personDeviceAppPrivileges_stream: Array<personDeviceAppPrivileges>;
  /** An array relationship */
  personDoorAppPrivileges: Array<personDoorAppPrivileges>;
  /** An aggregate relationship */
  personDoorAppPrivileges_aggregate: personDoorAppPrivileges_aggregate;
  /** fetch data from the table: "qx.PersonDoorAppPrivileges" using primary key columns */
  personDoorAppPrivileges_by_pk?: personDoorAppPrivileges;
  /** fetch data from the table in a streaming manner: "qx.PersonDoorAppPrivileges" */
  personDoorAppPrivileges_stream: Array<personDoorAppPrivileges>;
  /** fetch data from the table: "qx._PersonToGroup" using primary key columns */
  personGroup?: qx__PersonToGroup;
  /** fetch aggregated fields from the table: "qx._PersonToGroup" */
  personGroupAggregate: qx__PersonToGroup_aggregate;
  /** fetch data from the table: "qx._PersonToGroup" */
  personGroups: Array<qx__PersonToGroup>;
  /** fetch data from the table: "qx.PersonIntrusionPartitionAppPrivileges" */
  personIntrusionPartitionAppPrivileges: Array<personIntrusionPartitionAppPrivileges>;
  /** fetch aggregated fields from the table: "qx.PersonIntrusionPartitionAppPrivileges" */
  personIntrusionPartitionAppPrivileges_aggregate: personIntrusionPartitionAppPrivileges_aggregate;
  /** fetch data from the table: "qx.PersonIntrusionPartitionAppPrivileges" using primary key columns */
  personIntrusionPartitionAppPrivileges_by_pk?: personIntrusionPartitionAppPrivileges;
  /** fetch data from the table in a streaming manner: "qx.PersonIntrusionPartitionAppPrivileges" */
  personIntrusionPartitionAppPrivileges_stream: Array<personIntrusionPartitionAppPrivileges>;
  /** An array relationship */
  personPlaceAppPrivileges: Array<personPlaceAppPrivileges>;
  /** An aggregate relationship */
  personPlaceAppPrivileges_aggregate: personPlaceAppPrivileges_aggregate;
  /** fetch data from the table: "qx.PersonPlaceAppPrivileges" using primary key columns */
  personPlaceAppPrivileges_by_pk?: personPlaceAppPrivileges;
  /** fetch data from the table in a streaming manner: "qx.PersonPlaceAppPrivileges" */
  personPlaceAppPrivileges_stream: Array<personPlaceAppPrivileges>;
  /** fetch data from the table: "qx.ePersonStatus" using primary key columns */
  personStatusEnum?: qx_ePersonStatus;
  /** fetch aggregated fields from the table: "qx.ePersonStatus" */
  personStatusEnumAggregate: qx_ePersonStatus_aggregate;
  /** fetch data from the table: "qx.ePersonStatus" */
  personStatusEnums: Array<qx_ePersonStatus>;
  /** fetch data from the table: "audit.v_PersonToGroupAudit" */
  personToGroupAudit: Array<personToGroupAudit>;
  /** fetch aggregated fields from the table: "audit.v_PersonToGroupAudit" */
  personToGroupAudit_aggregate: personToGroupAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.v_PersonToGroupAudit" */
  personToGroupAudit_stream: Array<personToGroupAudit>;
  /** An array relationship */
  personVideoSourceAppPrivileges: Array<personVideoSourceAppPrivileges>;
  /** An aggregate relationship */
  personVideoSourceAppPrivileges_aggregate: personVideoSourceAppPrivileges_aggregate;
  /** fetch data from the table: "qx.PersonVideoSourceAppPrivileges" using primary key columns */
  personVideoSourceAppPrivileges_by_pk?: personVideoSourceAppPrivileges;
  /** fetch data from the table in a streaming manner: "qx.PersonVideoSourceAppPrivileges" */
  personVideoSourceAppPrivileges_stream: Array<personVideoSourceAppPrivileges>;
  /** fetch data from the table: "qx.Place" using primary key columns */
  place?: qx_Place;
  /** fetch aggregated fields from the table: "qx.Place" */
  placeAggregate: qx_Place_aggregate;
  /** fetch data from the table: "audit.vPlaceAudit" */
  placeAudit: Array<placeAudit>;
  /** fetch aggregated fields from the table: "audit.vPlaceAudit" */
  placeAudit_aggregate: placeAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.vPlaceAudit" */
  placeAudit_stream: Array<placeAudit>;
  /** fetch data from the table: "qx.ePlaceType" using primary key columns */
  placeTypeEnum?: qx_ePlaceType;
  /** fetch aggregated fields from the table: "qx.ePlaceType" */
  placeTypeEnumAggregate: qx_ePlaceType_aggregate;
  /** fetch data from the table: "qx.ePlaceType" */
  placeTypeEnums: Array<qx_ePlaceType>;
  /** fetch data from the table: "qx.PlaceWhitelist" */
  placeWhiteLists: Array<placeWhiteLists>;
  /** fetch aggregated fields from the table: "qx.PlaceWhitelist" */
  placeWhiteLists_aggregate: placeWhiteLists_aggregate;
  /** fetch data from the table: "qx.PlaceWhitelist" using primary key columns */
  placeWhiteLists_by_pk?: placeWhiteLists;
  /** fetch data from the table in a streaming manner: "qx.PlaceWhitelist" */
  placeWhiteLists_stream: Array<placeWhiteLists>;
  /** An array relationship */
  places: Array<qx_Place>;
  /** fetch data from the table: "qx.ePrivilege" using primary key columns */
  privilegeEnum?: qx_ePrivilege;
  /** fetch aggregated fields from the table: "qx.ePrivilege" */
  privilegeEnumAggregate: qx_ePrivilege_aggregate;
  /** fetch data from the table: "qx._PrivilegeEnumToRole" using primary key columns */
  privilegeEnumToRole?: qx__PrivilegeEnumToRole;
  /** fetch aggregated fields from the table: "qx._PrivilegeEnumToRole" */
  privilegeEnumToRoleAggregate: qx__PrivilegeEnumToRole_aggregate;
  /** fetch data from the table: "audit.v_PrivilegeEnumToRoleAudit" */
  privilegeEnumToRoleAudit: Array<privilegeEnumToRoleAudit>;
  /** fetch aggregated fields from the table: "audit.v_PrivilegeEnumToRoleAudit" */
  privilegeEnumToRoleAudit_aggregate: privilegeEnumToRoleAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.v_PrivilegeEnumToRoleAudit" */
  privilegeEnumToRoleAudit_stream: Array<privilegeEnumToRoleAudit>;
  /** fetch data from the table: "qx._PrivilegeEnumToRole" */
  privilegeEnumToRoles: Array<qx__PrivilegeEnumToRole>;
  /** fetch data from the table: "qx.ePrivilege" */
  privilegeEnums: Array<qx_ePrivilege>;
  /** fetch data from the table: "qx.AccessCatalogCapabilities" */
  qx_AccessCatalogCapabilities: Array<qx_AccessCatalogCapabilities>;
  /** fetch aggregated fields from the table: "qx.AccessCatalogCapabilities" */
  qx_AccessCatalogCapabilities_aggregate: qx_AccessCatalogCapabilities_aggregate;
  /** fetch data from the table: "qx.AccessCatalogCapabilities" using primary key columns */
  qx_AccessCatalogCapabilities_by_pk?: qx_AccessCatalogCapabilities;
  /** fetch data from the table in a streaming manner: "qx.AccessCatalogCapabilities" */
  qx_AccessCatalogCapabilities_stream: Array<qx_AccessCatalogCapabilities>;
  /** fetch data from the table in a streaming manner: "qx.AccessCatalog" */
  qx_AccessCatalog_stream: Array<qx_AccessCatalog>;
  /** fetch data from the table in a streaming manner: "qx.AccessInventory" */
  qx_AccessInventory_stream: Array<qx_AccessInventory>;
  /** fetch data from the table in a streaming manner: "qx.AudioSource" */
  qx_AudioSource_stream: Array<qx_AudioSource>;
  /** fetch data from the table in a streaming manner: "qx.AuditLog" */
  qx_AuditLog_stream: Array<qx_AuditLog>;
  /** fetch aggregated fields from the table: "qx.AuditableAction" */
  qx_AuditableAction_aggregate: qx_AuditableAction_aggregate;
  /** fetch data from the table: "qx.AuditableAction" using primary key columns */
  qx_AuditableAction_by_pk?: qx_AuditableAction;
  /** fetch data from the table in a streaming manner: "qx.AuditableAction" */
  qx_AuditableAction_stream: Array<qx_AuditableAction>;
  /** fetch aggregated fields from the table: "qx.AuditableType" */
  qx_AuditableType_aggregate: qx_AuditableType_aggregate;
  /** fetch data from the table: "qx.AuditableType" using primary key columns */
  qx_AuditableType_by_pk?: qx_AuditableType;
  /** fetch data from the table in a streaming manner: "qx.AuditableType" */
  qx_AuditableType_stream: Array<qx_AuditableType>;
  /** fetch data from the table in a streaming manner: "qx.BillingPeriod" */
  qx_BillingPeriod_stream: Array<qx_BillingPeriod>;
  /** fetch data from the table: "qx.CatalogProtocolOverride" */
  qx_CatalogProtocolOverride: Array<qx_CatalogProtocolOverride>;
  /** fetch aggregated fields from the table: "qx.CatalogProtocolOverride" */
  qx_CatalogProtocolOverride_aggregate: qx_CatalogProtocolOverride_aggregate;
  /** fetch data from the table: "qx.CatalogProtocolOverride" using primary key columns */
  qx_CatalogProtocolOverride_by_pk?: qx_CatalogProtocolOverride;
  /** fetch data from the table in a streaming manner: "qx.CatalogProtocolOverride" */
  qx_CatalogProtocolOverride_stream: Array<qx_CatalogProtocolOverride>;
  /** fetch data from the table in a streaming manner: "qx.ChatUsageHistory" */
  qx_ChatUsageHistory_stream: Array<qx_ChatUsageHistory>;
  /** fetch data from the table in a streaming manner: "qx.ClipAuditLog" */
  qx_ClipAuditLog_stream: Array<qx_ClipAuditLog>;
  /** fetch data from the table in a streaming manner: "qx.Clip" */
  qx_Clip_stream: Array<qx_Clip>;
  /** fetch data from the table in a streaming manner: "qx.CloudStorageOptions" */
  qx_CloudStorageOptions_stream: Array<qx_CloudStorageOptions>;
  /** fetch data from the table in a streaming manner: "qx.Credential" */
  qx_Credential_stream: Array<qx_Credential>;
  /** fetch data from the table: "qx.CustomerAuthProvider" */
  qx_CustomerAuthProvider: Array<qx_CustomerAuthProvider>;
  /** fetch aggregated fields from the table: "qx.CustomerAuthProvider" */
  qx_CustomerAuthProvider_aggregate: qx_CustomerAuthProvider_aggregate;
  /** fetch data from the table: "qx.CustomerAuthProvider" using primary key columns */
  qx_CustomerAuthProvider_by_pk?: qx_CustomerAuthProvider;
  /** fetch data from the table in a streaming manner: "qx.CustomerAuthProvider" */
  qx_CustomerAuthProvider_stream: Array<qx_CustomerAuthProvider>;
  /** fetch data from the table in a streaming manner: "qx.CustomerPermission" */
  qx_CustomerPermission_stream: Array<qx_CustomerPermission>;
  /** fetch data from the table in a streaming manner: "qx.DeviceDIO" */
  qx_DeviceDIO_stream: Array<qx_DeviceDIO>;
  /** fetch data from the table in a streaming manner: "qx.Device" */
  qx_Device_stream: Array<qx_Device>;
  /** fetch aggregated fields from the table: "qx.DiscoveryType" */
  qx_DiscoveryType_aggregate: qx_DiscoveryType_aggregate;
  /** fetch data from the table: "qx.DiscoveryType" using primary key columns */
  qx_DiscoveryType_by_pk?: qx_DiscoveryType;
  /** fetch data from the table in a streaming manner: "qx.DiscoveryType" */
  qx_DiscoveryType_stream: Array<qx_DiscoveryType>;
  /** fetch data from the table in a streaming manner: "qx.DoorConfiguration" */
  qx_DoorConfiguration_stream: Array<qx_DoorConfiguration>;
  /** fetch data from the table in a streaming manner: "qx.DoorMeta" */
  qx_DoorMeta_stream: Array<qx_DoorMeta>;
  /** fetch data from the table in a streaming manner: "qx.DoorTemplate" */
  qx_DoorTemplate_stream: Array<qx_DoorTemplate>;
  /** fetch data from the table in a streaming manner: "qx.Door" */
  qx_Door_stream: Array<qx_Door>;
  /** fetch data from the table in a streaming manner: "qx.EventType" */
  qx_EventType_stream: Array<qx_EventType>;
  /** fetch data from the table in a streaming manner: "qx.Event" */
  qx_Event_stream: Array<qx_Event>;
  /** fetch data from the table in a streaming manner: "qx.FlowTrace" */
  qx_FlowTrace_stream: Array<qx_FlowTrace>;
  /** fetch data from the table in a streaming manner: "qx.Flow" */
  qx_Flow_stream: Array<qx_Flow>;
  /** fetch data from the table in a streaming manner: "qx.GatewayBandwidthSchedule" */
  qx_GatewayBandwidthSchedule_stream: Array<qx_GatewayBandwidthSchedule>;
  /** fetch data from the table in a streaming manner: "qx.Gateway" */
  qx_Gateway_stream: Array<qx_Gateway>;
  /** fetch data from the table in a streaming manner: "qx.Group" */
  qx_Group_stream: Array<qx_Group>;
  /** fetch data from the table in a streaming manner: "qx.HolidaySet" */
  qx_HolidaySet_stream: Array<qx_HolidaySet>;
  /** fetch data from the table in a streaming manner: "qx.InputPoint" */
  qx_InputPoint_stream: Array<qx_InputPoint>;
  /** fetch data from the table: "qx.IntrusionAlarm" */
  qx_IntrusionAlarm: Array<qx_IntrusionAlarm>;
  /** fetch aggregated fields from the table: "qx.IntrusionAlarm" */
  qx_IntrusionAlarm_aggregate: qx_IntrusionAlarm_aggregate;
  /** fetch data from the table: "qx.IntrusionAlarm" using primary key columns */
  qx_IntrusionAlarm_by_pk?: qx_IntrusionAlarm;
  /** fetch data from the table in a streaming manner: "qx.IntrusionAlarm" */
  qx_IntrusionAlarm_stream: Array<qx_IntrusionAlarm>;
  /** fetch data from the table: "qx.IntrusionPartitionState" */
  qx_IntrusionPartitionState: Array<qx_IntrusionPartitionState>;
  /** fetch aggregated fields from the table: "qx.IntrusionPartitionState" */
  qx_IntrusionPartitionState_aggregate: qx_IntrusionPartitionState_aggregate;
  /** fetch data from the table: "qx.IntrusionPartitionState" using primary key columns */
  qx_IntrusionPartitionState_by_pk?: qx_IntrusionPartitionState;
  /** fetch data from the table in a streaming manner: "qx.IntrusionPartitionState" */
  qx_IntrusionPartitionState_stream: Array<qx_IntrusionPartitionState>;
  /** fetch data from the table: "qx.IntrusionZoneState" */
  qx_IntrusionZoneState: Array<qx_IntrusionZoneState>;
  /** fetch aggregated fields from the table: "qx.IntrusionZoneState" */
  qx_IntrusionZoneState_aggregate: qx_IntrusionZoneState_aggregate;
  /** fetch data from the table: "qx.IntrusionZoneState" using primary key columns */
  qx_IntrusionZoneState_by_pk?: qx_IntrusionZoneState;
  /** fetch data from the table in a streaming manner: "qx.IntrusionZoneState" */
  qx_IntrusionZoneState_stream: Array<qx_IntrusionZoneState>;
  /** fetch data from the table in a streaming manner: "qx.Layout" */
  qx_Layout_stream: Array<qx_Layout>;
  /** fetch data from the table in a streaming manner: "qx.LensProfile" */
  qx_LensProfile_stream: Array<qx_LensProfile>;
  /** fetch data from the table in a streaming manner: "qx.Lock" */
  qx_Lock_stream: Array<qx_Lock>;
  /** fetch data from the table: "qx.MediaProfileRecording" */
  qx_MediaProfileRecording: Array<qx_MediaProfileRecording>;
  /** fetch aggregated fields from the table: "qx.MediaProfileRecording" */
  qx_MediaProfileRecording_aggregate: qx_MediaProfileRecording_aggregate;
  /** fetch data from the table: "qx.MediaProfileRecording" using primary key columns */
  qx_MediaProfileRecording_by_pk?: qx_MediaProfileRecording;
  /** fetch data from the table in a streaming manner: "qx.MediaProfileRecording" */
  qx_MediaProfileRecording_stream: Array<qx_MediaProfileRecording>;
  /** fetch data from the table in a streaming manner: "qx.MediaProfile" */
  qx_MediaProfile_stream: Array<qx_MediaProfile>;
  /** fetch data from the table in a streaming manner: "qx.MercuryControlPoint" */
  qx_MercuryControlPoint_stream: Array<qx_MercuryControlPoint>;
  /** fetch data from the table in a streaming manner: "qx.MercuryMonitorPoint" */
  qx_MercuryMonitorPoint_stream: Array<qx_MercuryMonitorPoint>;
  /** fetch data from the table in a streaming manner: "qx.OssIdAssignment" */
  qx_OssIdAssignment_stream: Array<qx_OssIdAssignment>;
  /** fetch data from the table: "qx.OssKey" */
  qx_OssKey: Array<qx_OssKey>;
  /** fetch aggregated fields from the table: "qx.OssKey" */
  qx_OssKey_aggregate: qx_OssKey_aggregate;
  /** fetch data from the table: "qx.OssKey" using primary key columns */
  qx_OssKey_by_pk?: qx_OssKey;
  /** fetch data from the table in a streaming manner: "qx.OssKey" */
  qx_OssKey_stream: Array<qx_OssKey>;
  /** fetch data from the table in a streaming manner: "qx.OutputPoint" */
  qx_OutputPoint_stream: Array<qx_OutputPoint>;
  /** fetch data from the table in a streaming manner: "qx.Permission" */
  qx_Permission_stream: Array<qx_Permission>;
  /** fetch data from the table in a streaming manner: "qx.Person" */
  qx_Person_stream: Array<qx_Person>;
  /** fetch data from the table in a streaming manner: "qx.Place" */
  qx_Place_stream: Array<qx_Place>;
  /** fetch data from the table in a streaming manner: "qx.Reader" */
  qx_Reader_stream: Array<qx_Reader>;
  /** fetch data from the table in a streaming manner: "qx.Role" */
  qx_Role_stream: Array<qx_Role>;
  /** fetch data from the table in a streaming manner: "qx.RosslareConnection" */
  qx_RosslareConnection_stream: Array<qx_RosslareConnection>;
  /** fetch data from the table in a streaming manner: "qx.ScheduleBlock" */
  qx_ScheduleBlock_stream: Array<qx_ScheduleBlock>;
  /** fetch data from the table in a streaming manner: "qx.Schedule" */
  qx_Schedule_stream: Array<qx_Schedule>;
  /** fetch data from the table in a streaming manner: "qx.Segment" */
  qx_Segment_stream: Array<qx_Segment>;
  /** fetch data from the table in a streaming manner: "qx.Sensor" */
  qx_Sensor_stream: Array<qx_Sensor>;
  /** fetch data from the table in a streaming manner: "qx.SharedLinkAuditLog" */
  qx_SharedLinkAuditLog_stream: Array<qx_SharedLinkAuditLog>;
  /** fetch aggregated fields from the table: "qx.SharedLinkType" */
  qx_SharedLinkType_aggregate: qx_SharedLinkType_aggregate;
  /** fetch data from the table: "qx.SharedLinkType" using primary key columns */
  qx_SharedLinkType_by_pk?: qx_SharedLinkType;
  /** fetch data from the table in a streaming manner: "qx.SharedLinkType" */
  qx_SharedLinkType_stream: Array<qx_SharedLinkType>;
  /** fetch data from the table in a streaming manner: "qx.SharedLinks" */
  qx_SharedLinks_stream: Array<qx_SharedLinks>;
  /** fetch data from the table in a streaming manner: "qx.Snapshot" */
  qx_Snapshot_stream: Array<qx_Snapshot>;
  /** fetch data from the table in a streaming manner: "qx.TermsAgreement" */
  qx_TermsAgreement_stream: Array<qx_TermsAgreement>;
  /** fetch data from the table in a streaming manner: "qx.TimeZone" */
  qx_TimeZone_stream: Array<qx_TimeZone>;
  /** fetch data from the table in a streaming manner: "qx.UserSetting" */
  qx_UserSetting_stream: Array<qx_UserSetting>;
  /** fetch data from the table: "qx.VideoSourceStorageAudit" */
  qx_VideoSourceStorageAudit: Array<qx_VideoSourceStorageAudit>;
  /** fetch aggregated fields from the table: "qx.VideoSourceStorageAudit" */
  qx_VideoSourceStorageAudit_aggregate: qx_VideoSourceStorageAudit_aggregate;
  /** fetch data from the table: "qx.VideoSourceStorageAudit" using primary key columns */
  qx_VideoSourceStorageAudit_by_pk?: qx_VideoSourceStorageAudit;
  /** fetch data from the table in a streaming manner: "qx.VideoSourceStorageAudit" */
  qx_VideoSourceStorageAudit_stream: Array<qx_VideoSourceStorageAudit>;
  /** fetch data from the table in a streaming manner: "qx.VideoSource" */
  qx_VideoSource_stream: Array<qx_VideoSource>;
  /** fetch data from the table in a streaming manner: "qx.View" */
  qx_View_stream: Array<qx_View>;
  /** fetch data from the table in a streaming manner: "qx.WiegandCardFormat" */
  qx_WiegandCardFormat_stream: Array<qx_WiegandCardFormat>;
  /** fetch data from the table in a streaming manner: "qx._HolidaySetToScheduleBlock" */
  qx__HolidaySetToScheduleBlock_stream: Array<qx__HolidaySetToScheduleBlock>;
  /** fetch data from the table in a streaming manner: "qx._PersonToGroup" */
  qx__PersonToGroup_stream: Array<qx__PersonToGroup>;
  /** fetch data from the table: "qx._PlaceToHomePlaces" */
  qx__PlaceToHomePlaces: Array<qx__PlaceToHomePlaces>;
  /** fetch aggregated fields from the table: "qx._PlaceToHomePlaces" */
  qx__PlaceToHomePlaces_aggregate: qx__PlaceToHomePlaces_aggregate;
  /** fetch data from the table in a streaming manner: "qx._PlaceToHomePlaces" */
  qx__PlaceToHomePlaces_stream: Array<qx__PlaceToHomePlaces>;
  /** fetch data from the table in a streaming manner: "qx._PrivilegeEnumToRole" */
  qx__PrivilegeEnumToRole_stream: Array<qx__PrivilegeEnumToRole>;
  /** execute function "qx.chat_usage_per_model" and query aggregates on result of table type "qx.vChatUsagePerModel" */
  qx_chat_usage_per_model_aggregate: qx_vChatUsagePerModel_aggregate;
  /** execute function "qx.chat_usage_series" and query aggregates on result of table type "qx.vChatUsageSeries" */
  qx_chat_usage_series_aggregate: qx_vChatUsageSeries_aggregate;
  /** execute function "qx.device_oldest_media" which returns "qx.vOldestMedia" */
  qx_device_oldest_media: Array<qx_vOldestMedia>;
  /** execute function "qx.device_oldest_media" and query aggregates on result of table type "qx.vOldestMedia" */
  qx_device_oldest_media_aggregate: qx_vOldestMedia_aggregate;
  /** fetch data from the table in a streaming manner: "qx.eAccessBoardType" */
  qx_eAccessBoardType_stream: Array<qx_eAccessBoardType>;
  /** fetch data from the table in a streaming manner: "qx.eAccessDeniedReason" */
  qx_eAccessDeniedReason_stream: Array<qx_eAccessDeniedReason>;
  /** fetch data from the table in a streaming manner: "qx.eAccessInterfaceType" */
  qx_eAccessInterfaceType_stream: Array<qx_eAccessInterfaceType>;
  /** fetch data from the table: "qx.eAccessMake" */
  qx_eAccessMake: Array<qx_eAccessMake>;
  /** fetch aggregated fields from the table: "qx.eAccessMake" */
  qx_eAccessMake_aggregate: qx_eAccessMake_aggregate;
  /** fetch data from the table: "qx.eAccessMake" using primary key columns */
  qx_eAccessMake_by_pk?: qx_eAccessMake;
  /** fetch data from the table in a streaming manner: "qx.eAccessMake" */
  qx_eAccessMake_stream: Array<qx_eAccessMake>;
  /** fetch data from the table in a streaming manner: "qx.eAccessPointAction" */
  qx_eAccessPointAction_stream: Array<qx_eAccessPointAction>;
  /** fetch data from the table in a streaming manner: "qx.eAccessPointDirection" */
  qx_eAccessPointDirection_stream: Array<qx_eAccessPointDirection>;
  /** fetch data from the table in a streaming manner: "qx.eAccessPointType" */
  qx_eAccessPointType_stream: Array<qx_eAccessPointType>;
  /** fetch data from the table: "qx.eAppPrivilegeType" */
  qx_eAppPrivilegeType: Array<qx_eAppPrivilegeType>;
  /** fetch aggregated fields from the table: "qx.eAppPrivilegeType" */
  qx_eAppPrivilegeType_aggregate: qx_eAppPrivilegeType_aggregate;
  /** fetch data from the table: "qx.eAppPrivilegeType" using primary key columns */
  qx_eAppPrivilegeType_by_pk?: qx_eAppPrivilegeType;
  /** fetch data from the table in a streaming manner: "qx.eAppPrivilegeType" */
  qx_eAppPrivilegeType_stream: Array<qx_eAppPrivilegeType>;
  /** fetch data from the table: "qx.eAuthProvider" */
  qx_eAuthProvider: Array<qx_eAuthProvider>;
  /** fetch aggregated fields from the table: "qx.eAuthProvider" */
  qx_eAuthProvider_aggregate: qx_eAuthProvider_aggregate;
  /** fetch data from the table: "qx.eAuthProvider" using primary key columns */
  qx_eAuthProvider_by_pk?: qx_eAuthProvider;
  /** fetch data from the table in a streaming manner: "qx.eAuthProvider" */
  qx_eAuthProvider_stream: Array<qx_eAuthProvider>;
  /** fetch data from the table in a streaming manner: "qx.eAuthStrategy" */
  qx_eAuthStrategy_stream: Array<qx_eAuthStrategy>;
  /** fetch data from the table in a streaming manner: "qx.eBatteryLevel" */
  qx_eBatteryLevel_stream: Array<qx_eBatteryLevel>;
  /** fetch data from the table in a streaming manner: "qx.eBaudrate" */
  qx_eBaudrate_stream: Array<qx_eBaudrate>;
  /** fetch data from the table in a streaming manner: "qx.eBillingTier" */
  qx_eBillingTier_stream: Array<qx_eBillingTier>;
  /** fetch data from the table in a streaming manner: "qx.eClipStatus" */
  qx_eClipStatus_stream: Array<qx_eClipStatus>;
  /** fetch data from the table in a streaming manner: "qx.eClipType" */
  qx_eClipType_stream: Array<qx_eClipType>;
  /** fetch data from the table in a streaming manner: "qx.eCredentialType" */
  qx_eCredentialType_stream: Array<qx_eCredentialType>;
  /** fetch data from the table in a streaming manner: "qx.eDIONormalState" */
  qx_eDIONormalState_stream: Array<qx_eDIONormalState>;
  /** fetch data from the table in a streaming manner: "qx.eDIOState" */
  qx_eDIOState_stream: Array<qx_eDIOState>;
  /** fetch data from the table in a streaming manner: "qx.eDIOType" */
  qx_eDIOType_stream: Array<qx_eDIOType>;
  /** fetch data from the table in a streaming manner: "qx.eDeviceConnectionStatus" */
  qx_eDeviceConnectionStatus_stream: Array<qx_eDeviceConnectionStatus>;
  /** fetch data from the table in a streaming manner: "qx.eDeviceKind" */
  qx_eDeviceKind_stream: Array<qx_eDeviceKind>;
  /** fetch data from the table in a streaming manner: "qx.eDoorAlarm" */
  qx_eDoorAlarm_stream: Array<qx_eDoorAlarm>;
  /** fetch data from the table in a streaming manner: "qx.eDoorMode" */
  qx_eDoorMode_stream: Array<qx_eDoorMode>;
  /** fetch data from the table in a streaming manner: "qx.eDoorMonitor" */
  qx_eDoorMonitor_stream: Array<qx_eDoorMonitor>;
  /** fetch data from the table in a streaming manner: "qx.eDoorState" */
  qx_eDoorState_stream: Array<qx_eDoorState>;
  /** fetch data from the table in a streaming manner: "qx.eFlowNotificationType" */
  qx_eFlowNotificationType_stream: Array<qx_eFlowNotificationType>;
  /** fetch data from the table: "qx.eFlowStatus" */
  qx_eFlowStatus: Array<qx_eFlowStatus>;
  /** fetch aggregated fields from the table: "qx.eFlowStatus" */
  qx_eFlowStatus_aggregate: qx_eFlowStatus_aggregate;
  /** fetch data from the table: "qx.eFlowStatus" using primary key columns */
  qx_eFlowStatus_by_pk?: qx_eFlowStatus;
  /** fetch data from the table in a streaming manner: "qx.eFlowStatus" */
  qx_eFlowStatus_stream: Array<qx_eFlowStatus>;
  /** fetch data from the table: "qx.eFlowTraceActionStatus" */
  qx_eFlowTraceActionStatus: Array<qx_eFlowTraceActionStatus>;
  /** fetch aggregated fields from the table: "qx.eFlowTraceActionStatus" */
  qx_eFlowTraceActionStatus_aggregate: qx_eFlowTraceActionStatus_aggregate;
  /** fetch data from the table: "qx.eFlowTraceActionStatus" using primary key columns */
  qx_eFlowTraceActionStatus_by_pk?: qx_eFlowTraceActionStatus;
  /** fetch data from the table in a streaming manner: "qx.eFlowTraceActionStatus" */
  qx_eFlowTraceActionStatus_stream: Array<qx_eFlowTraceActionStatus>;
  /** fetch data from the table: "qx.eFlowTraceState" */
  qx_eFlowTraceState: Array<qx_eFlowTraceState>;
  /** fetch aggregated fields from the table: "qx.eFlowTraceState" */
  qx_eFlowTraceState_aggregate: qx_eFlowTraceState_aggregate;
  /** fetch data from the table: "qx.eFlowTraceState" using primary key columns */
  qx_eFlowTraceState_by_pk?: qx_eFlowTraceState;
  /** fetch data from the table in a streaming manner: "qx.eFlowTraceState" */
  qx_eFlowTraceState_stream: Array<qx_eFlowTraceState>;
  /** fetch data from the table in a streaming manner: "qx.eGatewayServiceType" */
  qx_eGatewayServiceType_stream: Array<qx_eGatewayServiceType>;
  /** fetch data from the table in a streaming manner: "qx.eGatewaySyncStatus" */
  qx_eGatewaySyncStatus_stream: Array<qx_eGatewaySyncStatus>;
  /** fetch data from the table: "qx.eIntrusionZoneType" */
  qx_eIntrusionZoneType: Array<qx_eIntrusionZoneType>;
  /** fetch aggregated fields from the table: "qx.eIntrusionZoneType" */
  qx_eIntrusionZoneType_aggregate: qx_eIntrusionZoneType_aggregate;
  /** fetch data from the table: "qx.eIntrusionZoneType" using primary key columns */
  qx_eIntrusionZoneType_by_pk?: qx_eIntrusionZoneType;
  /** fetch data from the table in a streaming manner: "qx.eIntrusionZoneType" */
  qx_eIntrusionZoneType_stream: Array<qx_eIntrusionZoneType>;
  /** fetch data from the table in a streaming manner: "qx.eKeypadMode" */
  qx_eKeypadMode_stream: Array<qx_eKeypadMode>;
  /** fetch data from the table: "qx.eLockMode" */
  qx_eLockMode: Array<qx_eLockMode>;
  /** fetch aggregated fields from the table: "qx.eLockMode" */
  qx_eLockMode_aggregate: qx_eLockMode_aggregate;
  /** fetch data from the table: "qx.eLockMode" using primary key columns */
  qx_eLockMode_by_pk?: qx_eLockMode;
  /** fetch data from the table in a streaming manner: "qx.eLockMode" */
  qx_eLockMode_stream: Array<qx_eLockMode>;
  /** fetch data from the table in a streaming manner: "qx.eLockPowerMonitor" */
  qx_eLockPowerMonitor_stream: Array<qx_eLockPowerMonitor>;
  /** fetch data from the table in a streaming manner: "qx.eLockRelayMonitor" */
  qx_eLockRelayMonitor_stream: Array<qx_eLockRelayMonitor>;
  /** fetch data from the table in a streaming manner: "qx.eLockType" */
  qx_eLockType_stream: Array<qx_eLockType>;
  /** fetch data from the table: "qx.eMercuryMonitorPointLatchModes" */
  qx_eMercuryMonitorPointLatchModes: Array<qx_eMercuryMonitorPointLatchModes>;
  /** fetch aggregated fields from the table: "qx.eMercuryMonitorPointLatchModes" */
  qx_eMercuryMonitorPointLatchModes_aggregate: qx_eMercuryMonitorPointLatchModes_aggregate;
  /** fetch data from the table: "qx.eMercuryMonitorPointLatchModes" using primary key columns */
  qx_eMercuryMonitorPointLatchModes_by_pk?: qx_eMercuryMonitorPointLatchModes;
  /** fetch data from the table in a streaming manner: "qx.eMercuryMonitorPointLatchModes" */
  qx_eMercuryMonitorPointLatchModes_stream: Array<qx_eMercuryMonitorPointLatchModes>;
  /** fetch data from the table in a streaming manner: "qx.eMonitorLockState" */
  qx_eMonitorLockState_stream: Array<qx_eMonitorLockState>;
  /** fetch data from the table in a streaming manner: "qx.eMountPosition" */
  qx_eMountPosition_stream: Array<qx_eMountPosition>;
  /** fetch data from the table in a streaming manner: "qx.eObjectAction" */
  qx_eObjectAction_stream: Array<qx_eObjectAction>;
  /** fetch data from the table in a streaming manner: "qx.ePACSStatus" */
  qx_ePACSStatus_stream: Array<qx_ePACSStatus>;
  /** fetch data from the table in a streaming manner: "qx.ePersonStatus" */
  qx_ePersonStatus_stream: Array<qx_ePersonStatus>;
  /** fetch data from the table in a streaming manner: "qx.ePlaceType" */
  qx_ePlaceType_stream: Array<qx_ePlaceType>;
  /** fetch data from the table in a streaming manner: "qx.ePrivilege" */
  qx_ePrivilege_stream: Array<qx_ePrivilege>;
  /** fetch data from the table in a streaming manner: "qx.eReaderAccessType" */
  qx_eReaderAccessType_stream: Array<qx_eReaderAccessType>;
  /** fetch data from the table in a streaming manner: "qx.eReaderProtocol" */
  qx_eReaderProtocol_stream: Array<qx_eReaderProtocol>;
  /** fetch data from the table in a streaming manner: "qx.eRexState" */
  qx_eRexState_stream: Array<qx_eRexState>;
  /** fetch data from the table in a streaming manner: "qx.eSensorAction" */
  qx_eSensorAction_stream: Array<qx_eSensorAction>;
  /** fetch data from the table in a streaming manner: "qx.eSensorType" */
  qx_eSensorType_stream: Array<qx_eSensorType>;
  /** fetch data from the table in a streaming manner: "qx.eStreamStatus" */
  qx_eStreamStatus_stream: Array<qx_eStreamStatus>;
  /** fetch data from the table in a streaming manner: "qx.eSuperviseInputs" */
  qx_eSuperviseInputs_stream: Array<qx_eSuperviseInputs>;
  /** execute function "qx.event_type_status_values" which returns "qx.eDeviceConnectionStatus" */
  qx_event_type_status_values: Array<qx_eDeviceConnectionStatus>;
  /** execute function "qx.event_type_status_values" and query aggregates on result of table type "qx.eDeviceConnectionStatus" */
  qx_event_type_status_values_aggregate: qx_eDeviceConnectionStatus_aggregate;
  /** execute function "qx.events_by_hour" which returns "qx.vEventsByHour" */
  qx_events_by_hour: Array<qx_vEventsByHour>;
  /** execute function "qx.events_by_hour" and query aggregates on result of table type "qx.vEventsByHour" */
  qx_events_by_hour_aggregate: qx_vEventsByHour_aggregate;
  /** execute function "qx.find_credential_from_place" which returns "qx.Credential" */
  qx_find_credential_from_place: Array<qx_Credential>;
  /** execute function "qx.find_credential_from_place" and query aggregates on result of table type "qx.Credential" */
  qx_find_credential_from_place_aggregate: qx_Credential_aggregate;
  /** execute function "qx.media_profile_oldest_media" which returns "qx.vOldestMedia" */
  qx_media_profile_oldest_media: Array<qx_vOldestMedia>;
  /** execute function "qx.media_profile_oldest_media" and query aggregates on result of table type "qx.vOldestMedia" */
  qx_media_profile_oldest_media_aggregate: qx_vOldestMedia_aggregate;
  /** execute function "qx.place_hierarchy" which returns "qx.vPlaceHierarchy" */
  qx_place_hierarchy: Array<qx_vPlaceHierarchy>;
  /** execute function "qx.place_hierarchy" and query aggregates on result of table type "qx.vPlaceHierarchy" */
  qx_place_hierarchy_aggregate: qx_vPlaceHierarchy_aggregate;
  /** execute function "qx.search_segments" which returns "qx.Segment" */
  qx_search_segments: Array<qx_Segment>;
  /** execute function "qx.search_segments" and query aggregates on result of table type "qx.Segment" */
  qx_search_segments_aggregate: qx_Segment_aggregate;
  /** execute function "qx.search_snapshots" which returns "qx.Snapshot" */
  qx_search_snapshots: Array<qx_Snapshot>;
  /** execute function "qx.search_snapshots" and query aggregates on result of table type "qx.Snapshot" */
  qx_search_snapshots_aggregate: qx_Snapshot_aggregate;
  /** execute function "qx.search_timeline" which returns "qx.vSearchTimeline" */
  qx_search_timeline: Array<qx_vSearchTimeline>;
  /** execute function "qx.search_timeline" and query aggregates on result of table type "qx.vSearchTimeline" */
  qx_search_timeline_aggregate: qx_vSearchTimeline_aggregate;
  /** fetch data from the table in a streaming manner: "qx.vChatBillingByModel" */
  qx_vChatBillingByModel_stream: Array<qx_vChatBillingByModel>;
  /** fetch data from the table in a streaming manner: "qx.vChatBillingSummary" */
  qx_vChatBillingSummary_stream: Array<qx_vChatBillingSummary>;
  /** fetch data from the table in a streaming manner: "qx.vChatPromptUsage" */
  qx_vChatPromptUsage_stream: Array<qx_vChatPromptUsage>;
  /** fetch data from the table: "qx.vChatUsagePerModel" */
  qx_vChatUsagePerModel: Array<qx_vChatUsagePerModel>;
  /** fetch aggregated fields from the table: "qx.vChatUsagePerModel" */
  qx_vChatUsagePerModel_aggregate: qx_vChatUsagePerModel_aggregate;
  /** fetch data from the table in a streaming manner: "qx.vChatUsagePerModel" */
  qx_vChatUsagePerModel_stream: Array<qx_vChatUsagePerModel>;
  /** fetch data from the table: "qx.vChatUsageSeries" */
  qx_vChatUsageSeries: Array<qx_vChatUsageSeries>;
  /** fetch aggregated fields from the table: "qx.vChatUsageSeries" */
  qx_vChatUsageSeries_aggregate: qx_vChatUsageSeries_aggregate;
  /** fetch data from the table in a streaming manner: "qx.vChatUsageSeries" */
  qx_vChatUsageSeries_stream: Array<qx_vChatUsageSeries>;
  /** fetch data from the table: "qx.vDevicePlace" */
  qx_vDevicePlace: Array<qx_vDevicePlace>;
  /** fetch aggregated fields from the table: "qx.vDevicePlace" */
  qx_vDevicePlace_aggregate: qx_vDevicePlace_aggregate;
  /** fetch data from the table in a streaming manner: "qx.vDevicePlace" */
  qx_vDevicePlace_stream: Array<qx_vDevicePlace>;
  /** fetch data from the table: "qx.vDoorAccessByPerson" */
  qx_vDoorAccessByPerson: Array<qx_vDoorAccessByPerson>;
  /** fetch aggregated fields from the table: "qx.vDoorAccessByPerson" */
  qx_vDoorAccessByPerson_aggregate: qx_vDoorAccessByPerson_aggregate;
  /** fetch data from the table in a streaming manner: "qx.vDoorAccessByPerson" */
  qx_vDoorAccessByPerson_stream: Array<qx_vDoorAccessByPerson>;
  /** fetch data from the table: "qx.vEventsByHour" */
  qx_vEventsByHour: Array<qx_vEventsByHour>;
  /** fetch aggregated fields from the table: "qx.vEventsByHour" */
  qx_vEventsByHour_aggregate: qx_vEventsByHour_aggregate;
  /** fetch data from the table in a streaming manner: "qx.vEventsByHour" */
  qx_vEventsByHour_stream: Array<qx_vEventsByHour>;
  /** fetch data from the table: "qx.vNewestMedia" */
  qx_vNewestMedia: Array<qx_vNewestMedia>;
  /** fetch aggregated fields from the table: "qx.vNewestMedia" */
  qx_vNewestMedia_aggregate: qx_vNewestMedia_aggregate;
  /** fetch data from the table in a streaming manner: "qx.vNewestMedia" */
  qx_vNewestMedia_stream: Array<qx_vNewestMedia>;
  /** fetch data from the table: "qx.vOldestMedia" */
  qx_vOldestMedia: Array<qx_vOldestMedia>;
  /** fetch aggregated fields from the table: "qx.vOldestMedia" */
  qx_vOldestMedia_aggregate: qx_vOldestMedia_aggregate;
  /** fetch data from the table in a streaming manner: "qx.vOldestMedia" */
  qx_vOldestMedia_stream: Array<qx_vOldestMedia>;
  /** fetch data from the table: "qx.vPersonAccessHistory" */
  qx_vPersonAccessHistory: Array<qx_vPersonAccessHistory>;
  /** fetch aggregated fields from the table: "qx.vPersonAccessHistory" */
  qx_vPersonAccessHistory_aggregate: qx_vPersonAccessHistory_aggregate;
  /** fetch data from the table in a streaming manner: "qx.vPersonAccessHistory" */
  qx_vPersonAccessHistory_stream: Array<qx_vPersonAccessHistory>;
  /** fetch data from the table: "qx.vPlaceAiBillingSummary" */
  qx_vPlaceAiBillingSummary: Array<qx_vPlaceAiBillingSummary>;
  /** fetch aggregated fields from the table: "qx.vPlaceAiBillingSummary" */
  qx_vPlaceAiBillingSummary_aggregate: qx_vPlaceAiBillingSummary_aggregate;
  /** fetch data from the table in a streaming manner: "qx.vPlaceAiBillingSummary" */
  qx_vPlaceAiBillingSummary_stream: Array<qx_vPlaceAiBillingSummary>;
  /** fetch data from the table: "qx.vPlaceHierarchy" */
  qx_vPlaceHierarchy: Array<qx_vPlaceHierarchy>;
  /** fetch aggregated fields from the table: "qx.vPlaceHierarchy" */
  qx_vPlaceHierarchy_aggregate: qx_vPlaceHierarchy_aggregate;
  /** fetch data from the table in a streaming manner: "qx.vPlaceHierarchy" */
  qx_vPlaceHierarchy_stream: Array<qx_vPlaceHierarchy>;
  /** fetch data from the table: "qx.vPlacePrivilege" */
  qx_vPlacePrivilege: Array<qx_vPlacePrivilege>;
  /** fetch aggregated fields from the table: "qx.vPlacePrivilege" */
  qx_vPlacePrivilege_aggregate: qx_vPlacePrivilege_aggregate;
  /** fetch data from the table in a streaming manner: "qx.vPlacePrivilege" */
  qx_vPlacePrivilege_stream: Array<qx_vPlacePrivilege>;
  /** fetch data from the table: "qx.vProfiles" */
  qx_vProfiles: Array<qx_vProfiles>;
  /** fetch aggregated fields from the table: "qx.vProfiles" */
  qx_vProfiles_aggregate: qx_vProfiles_aggregate;
  /** fetch data from the table in a streaming manner: "qx.vProfiles" */
  qx_vProfiles_stream: Array<qx_vProfiles>;
  /** fetch data from the table: "qx.vSearchTimeline" */
  qx_vSearchTimeline: Array<qx_vSearchTimeline>;
  /** fetch aggregated fields from the table: "qx.vSearchTimeline" */
  qx_vSearchTimeline_aggregate: qx_vSearchTimeline_aggregate;
  /** fetch data from the table in a streaming manner: "qx.vSearchTimeline" */
  qx_vSearchTimeline_stream: Array<qx_vSearchTimeline>;
  /** execute function "qx.video_source_oldest_media" which returns "qx.vOldestMedia" */
  qx_video_source_oldest_media: Array<qx_vOldestMedia>;
  /** execute function "qx.video_source_oldest_media" and query aggregates on result of table type "qx.vOldestMedia" */
  qx_video_source_oldest_media_aggregate: qx_vOldestMedia_aggregate;
  /** fetch data from the table: "qxanalytics.CloudUsage" */
  qxanalytics_CloudUsage: Array<qxanalytics_CloudUsage>;
  /** fetch aggregated fields from the table: "qxanalytics.CloudUsage" */
  qxanalytics_CloudUsage_aggregate: qxanalytics_CloudUsage_aggregate;
  /** fetch data from the table in a streaming manner: "qxanalytics.CloudUsage" */
  qxanalytics_CloudUsage_stream: Array<qxanalytics_CloudUsage>;
  /** fetch data from the table: "qx.Reader" using primary key columns */
  reader?: qx_Reader;
  /** fetch data from the table: "qx.ReaderAccessTypeCompatibility" */
  readerAccessTypeCompatibility: Array<readerAccessTypeCompatibility>;
  /** fetch aggregated fields from the table: "qx.ReaderAccessTypeCompatibility" */
  readerAccessTypeCompatibility_aggregate: readerAccessTypeCompatibility_aggregate;
  /** fetch data from the table: "qx.ReaderAccessTypeCompatibility" using primary key columns */
  readerAccessTypeCompatibility_by_pk?: readerAccessTypeCompatibility;
  /** fetch data from the table in a streaming manner: "qx.ReaderAccessTypeCompatibility" */
  readerAccessTypeCompatibility_stream: Array<readerAccessTypeCompatibility>;
  /** fetch data from the table: "qx.eReaderAccessType" using primary key columns */
  readerAccessTypeEnum?: qx_eReaderAccessType;
  /** fetch aggregated fields from the table: "qx.eReaderAccessType" */
  readerAccessTypeEnumAggregate: qx_eReaderAccessType_aggregate;
  /** fetch data from the table: "qx.eReaderAccessType" */
  readerAccessTypeEnums: Array<qx_eReaderAccessType>;
  /** fetch aggregated fields from the table: "qx.Reader" */
  readerAggregate: qx_Reader_aggregate;
  /** fetch data from the table: "audit.vReaderAudit" */
  readerAudit: Array<readerAudit>;
  /** fetch aggregated fields from the table: "audit.vReaderAudit" */
  readerAudit_aggregate: readerAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.vReaderAudit" */
  readerAudit_stream: Array<readerAudit>;
  /** fetch data from the table: "qx.ReaderProtocolCompatibility" */
  readerProtocolCompatibility: Array<readerProtocolCompatibility>;
  /** fetch aggregated fields from the table: "qx.ReaderProtocolCompatibility" */
  readerProtocolCompatibility_aggregate: readerProtocolCompatibility_aggregate;
  /** fetch data from the table: "qx.ReaderProtocolCompatibility" using primary key columns */
  readerProtocolCompatibility_by_pk?: readerProtocolCompatibility;
  /** fetch data from the table in a streaming manner: "qx.ReaderProtocolCompatibility" */
  readerProtocolCompatibility_stream: Array<readerProtocolCompatibility>;
  /** fetch data from the table: "qx.eReaderProtocol" using primary key columns */
  readerProtocolEnum?: qx_eReaderProtocol;
  /** fetch aggregated fields from the table: "qx.eReaderProtocol" */
  readerProtocolEnumAggregate: qx_eReaderProtocol_aggregate;
  /** fetch data from the table: "qx.eReaderProtocol" */
  readerProtocolEnums: Array<qx_eReaderProtocol>;
  /** An array relationship */
  readers: Array<qx_Reader>;
  /** fetch data from the table: "qx.eRexState" using primary key columns */
  rexStateEnum?: qx_eRexState;
  /** fetch aggregated fields from the table: "qx.eRexState" */
  rexStateEnumAggregate: qx_eRexState_aggregate;
  /** fetch data from the table: "qx.eRexState" */
  rexStateEnums: Array<qx_eRexState>;
  /** fetch data from the table: "qx.Role" using primary key columns */
  role?: qx_Role;
  /** fetch aggregated fields from the table: "qx.Role" */
  roleAggregate: qx_Role_aggregate;
  /** fetch data from the table: "qx.RoleAppPrivileges" */
  roleAppPrivileges: Array<roleAppPrivileges>;
  /** fetch aggregated fields from the table: "qx.RoleAppPrivileges" */
  roleAppPrivileges_aggregate: roleAppPrivileges_aggregate;
  /** fetch data from the table: "qx.RoleAppPrivileges" using primary key columns */
  roleAppPrivileges_by_pk?: roleAppPrivileges;
  /** fetch data from the table in a streaming manner: "qx.RoleAppPrivileges" */
  roleAppPrivileges_stream: Array<roleAppPrivileges>;
  /** fetch data from the table: "audit.vRoleAudit" */
  roleAudit: Array<roleAudit>;
  /** fetch aggregated fields from the table: "audit.vRoleAudit" */
  roleAudit_aggregate: roleAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.vRoleAudit" */
  roleAudit_stream: Array<roleAudit>;
  /** An array relationship */
  roles: Array<qx_Role>;
  /** fetch data from the table: "qx.RosslareCatalog" */
  rosslareCatalogs: Array<rosslareCatalogs>;
  /** fetch aggregated fields from the table: "qx.RosslareCatalog" */
  rosslareCatalogs_aggregate: rosslareCatalogs_aggregate;
  /** fetch data from the table: "qx.RosslareCatalog" using primary key columns */
  rosslareCatalogs_by_pk?: rosslareCatalogs;
  /** fetch data from the table in a streaming manner: "qx.RosslareCatalog" */
  rosslareCatalogs_stream: Array<rosslareCatalogs>;
  /** fetch data from the table: "qx.RosslareConnection" using primary key columns */
  rosslareConnection?: qx_RosslareConnection;
  /** fetch aggregated fields from the table: "qx.RosslareConnection" */
  rosslareConnectionAggregate: qx_RosslareConnection_aggregate;
  /** fetch data from the table: "qx.RosslareConnection" */
  rosslareConnections: Array<qx_RosslareConnection>;
  /** fetch data from the table: "qx.S3BucketConfiguration" */
  s3BucketConfigurations: Array<s3BucketConfigurations>;
  /** fetch aggregated fields from the table: "qx.S3BucketConfiguration" */
  s3BucketConfigurations_aggregate: s3BucketConfigurations_aggregate;
  /** fetch data from the table: "qx.S3BucketConfiguration" using primary key columns */
  s3BucketConfigurations_by_pk?: s3BucketConfigurations;
  /** fetch data from the table in a streaming manner: "qx.S3BucketConfiguration" */
  s3BucketConfigurations_stream: Array<s3BucketConfigurations>;
  scanSegments?: scanSegments;
  /** fetch data from the table: "qx.Schedule" using primary key columns */
  schedule?: qx_Schedule;
  /** fetch aggregated fields from the table: "qx.Schedule" */
  scheduleAggregate: qx_Schedule_aggregate;
  /** fetch data from the table: "audit.vScheduleAudit" */
  scheduleAudit: Array<scheduleAudit>;
  /** fetch aggregated fields from the table: "audit.vScheduleAudit" */
  scheduleAudit_aggregate: scheduleAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.vScheduleAudit" */
  scheduleAudit_stream: Array<scheduleAudit>;
  /** fetch data from the table: "qx.ScheduleBlock" using primary key columns */
  scheduleBlock?: qx_ScheduleBlock;
  /** fetch aggregated fields from the table: "qx.ScheduleBlock" */
  scheduleBlockAggregate: qx_ScheduleBlock_aggregate;
  /** fetch data from the table: "audit.vScheduleBlockAudit" */
  scheduleBlockAudit: Array<scheduleBlockAudit>;
  /** fetch aggregated fields from the table: "audit.vScheduleBlockAudit" */
  scheduleBlockAudit_aggregate: scheduleBlockAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.vScheduleBlockAudit" */
  scheduleBlockAudit_stream: Array<scheduleBlockAudit>;
  /** fetch data from the table: "qx.ScheduleBlock" */
  scheduleBlocks: Array<qx_ScheduleBlock>;
  /** An array relationship */
  schedules: Array<qx_Schedule>;
  /** fetch data from the table: "qx.Segment" using primary key columns */
  segment?: qx_Segment;
  /** fetch aggregated fields from the table: "qx.Segment" */
  segmentAggregate: qx_Segment_aggregate;
  /** An array relationship */
  segments: Array<qx_Segment>;
  /** fetch data from the table: "qx.Sensor" using primary key columns */
  sensor?: qx_Sensor;
  /** fetch data from the table: "qx.eSensorAction" using primary key columns */
  sensorActionEnum?: qx_eSensorAction;
  /** fetch data from the table: "qx.eSensorAction" */
  sensorActionEnums: Array<qx_eSensorAction>;
  /** fetch aggregated fields from the table: "qx.eSensorAction" */
  sensorActionEnumsAggregate: qx_eSensorAction_aggregate;
  /** fetch aggregated fields from the table: "qx.Sensor" */
  sensorAggregate: qx_Sensor_aggregate;
  /** fetch data from the table: "qx.eSensorType" using primary key columns */
  sensorTypeEnum?: qx_eSensorType;
  /** fetch data from the table: "qx.eSensorType" */
  sensorTypeEnums: Array<qx_eSensorType>;
  /** fetch aggregated fields from the table: "qx.eSensorType" */
  sensorTypeEnumsAggregate: qx_eSensorType_aggregate;
  /** An array relationship */
  sensors: Array<qx_Sensor>;
  setupCameraGateway?: setupCameraGateway;
  /** fetch data from the table: "qx.SharedLinks" using primary key columns */
  sharedLink?: qx_SharedLinks;
  /** fetch aggregated fields from the table: "qx.SharedLinks" */
  sharedLinkAggregate: qx_SharedLinks_aggregate;
  /** fetch aggregated fields from the table: "qx.SharedLinkAuditLog" */
  sharedLinkAuditLogAggregate: qx_SharedLinkAuditLog_aggregate;
  /** fetch data from the table: "qx.SharedLinkAuditLog" */
  sharedLinkAuditLogs: Array<qx_SharedLinkAuditLog>;
  /** An array relationship */
  sharedLinks: Array<qx_SharedLinks>;
  /** fetch data from the table: "qx.Snapshot" using primary key columns */
  snapshot?: qx_Snapshot;
  /** fetch aggregated fields from the table: "qx.Snapshot" */
  snapshotAggregate: qx_Snapshot_aggregate;
  /** An array relationship */
  snapshots: Array<qx_Snapshot>;
  /** fetch data from the table: "qx.eStreamStatus" using primary key columns */
  streamStatusEnum?: qx_eStreamStatus;
  /** fetch aggregated fields from the table: "qx.eStreamStatus" */
  streamStatusEnumAggregate: qx_eStreamStatus_aggregate;
  /** fetch data from the table: "qx.eStreamStatus" */
  streamStatusEnums: Array<qx_eStreamStatus>;
  /** fetch data from the table: "qx.SuperviseInputCompatibility" */
  superviseInputCompatibility: Array<superviseInputCompatibility>;
  /** fetch aggregated fields from the table: "qx.SuperviseInputCompatibility" */
  superviseInputCompatibility_aggregate: superviseInputCompatibility_aggregate;
  /** fetch data from the table: "qx.SuperviseInputCompatibility" using primary key columns */
  superviseInputCompatibility_by_pk?: superviseInputCompatibility;
  /** fetch data from the table in a streaming manner: "qx.SuperviseInputCompatibility" */
  superviseInputCompatibility_stream: Array<superviseInputCompatibility>;
  /** fetch data from the table: "qx.eSuperviseInputs" using primary key columns */
  superviseInputsEnum?: qx_eSuperviseInputs;
  /** fetch aggregated fields from the table: "qx.eSuperviseInputs" */
  superviseInputsEnumAggregate: qx_eSuperviseInputs_aggregate;
  /** fetch data from the table: "qx.eSuperviseInputs" */
  superviseInputsEnums: Array<qx_eSuperviseInputs>;
  /** fetch data from the table: "qx.TermsAgreement" using primary key columns */
  termsAgreement?: qx_TermsAgreement;
  /** fetch aggregated fields from the table: "qx.TermsAgreement" */
  termsAgreementAggregate: qx_TermsAgreement_aggregate;
  /** fetch data from the table: "qx.TermsAgreement" */
  termsAgreements: Array<qx_TermsAgreement>;
  /** fetch data from the table: "qx.TimeZone" using primary key columns */
  timeZone?: qx_TimeZone;
  /** fetch aggregated fields from the table: "qx.TimeZone" */
  timeZoneAggregate: qx_TimeZone_aggregate;
  /** fetch data from the table: "qx.TimeZone" */
  timeZones: Array<qx_TimeZone>;
  updateCustomerCanSelfServe?: updateCustomerCanSelfServe;
  updateCustomerPlacePrivileges?: updateCustomerPlacePrivileges;
  /** fetch data from the table: "qx.UserSetting" using primary key columns */
  userSetting?: qx_UserSetting;
  /** An array relationship */
  userSettings: Array<qx_UserSetting>;
  /** fetch aggregated fields from the table: "qx.UserSetting" */
  userSettingsAggregate: qx_UserSetting_aggregate;
  /** fetch data from the table: "qx.vEventStatus" */
  vEventStatuses: Array<vEventStatuses>;
  /** fetch aggregated fields from the table: "qx.vEventStatus" */
  vEventStatuses_aggregate: vEventStatuses_aggregate;
  /** fetch data from the table in a streaming manner: "qx.vEventStatus" */
  vEventStatuses_stream: Array<vEventStatuses>;
  /** fetch data from the table: "qx.vEvents" */
  vEvents: Array<vEvents>;
  /** fetch aggregated fields from the table: "qx.vEvents" */
  vEvents_aggregate: vEvents_aggregate;
  /** fetch data from the table in a streaming manner: "qx.vEvents" */
  vEvents_stream: Array<vEvents>;
  /** fetch data from the table: "qx.VideoSource" using primary key columns */
  videoSource?: qx_VideoSource;
  /** fetch aggregated fields from the table: "qx.VideoSource" */
  videoSourceAggregate: qx_VideoSource_aggregate;
  /** fetch data from the table: "audit.vVideoSourceAudit" */
  videoSourceAudit: Array<videoSourceAudit>;
  /** fetch aggregated fields from the table: "audit.vVideoSourceAudit" */
  videoSourceAudit_aggregate: videoSourceAudit_aggregate;
  /** fetch data from the table in a streaming manner: "audit.vVideoSourceAudit" */
  videoSourceAudit_stream: Array<videoSourceAudit>;
  /** fetch data from the table: "qx.VideoSourceState" */
  videoSourceState: Array<videoSourceState>;
  /** fetch aggregated fields from the table: "qx.VideoSourceState" */
  videoSourceState_aggregate: videoSourceState_aggregate;
  /** fetch data from the table: "qx.VideoSourceState" using primary key columns */
  videoSourceState_by_pk?: videoSourceState;
  /** fetch data from the table in a streaming manner: "qx.VideoSourceState" */
  videoSourceState_stream: Array<videoSourceState>;
  /** An array relationship */
  videoSources: Array<qx_VideoSource>;
  /** fetch data from the table: "qx.View" using primary key columns */
  view?: qx_View;
  /** An array relationship */
  views: Array<qx_View>;
  /** fetch aggregated fields from the table: "qx.View" */
  viewsAggregate: qx_View_aggregate;
  /** fetch data from the table: "qx.WiegandCardFormat" using primary key columns */
  wiegandCardFormat?: qx_WiegandCardFormat;
  /** fetch aggregated fields from the table: "qx.WiegandCardFormat" */
  wiegandCardFormatAggregate: qx_WiegandCardFormat_aggregate;
  /** fetch data from the table: "qx.WiegandCardFormat" */
  wiegandCardFormats: Array<qx_WiegandCardFormat>;
};


export type subscription_rootAnalyticSourcesArgs = {
  distinct_on?: Array<AnalyticSources_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<AnalyticSources_order_by>;
  where?: AnalyticSources_bool_exp;
};


export type subscription_rootAnalyticSources_aggregateArgs = {
  distinct_on?: Array<AnalyticSources_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<AnalyticSources_order_by>;
  where?: AnalyticSources_bool_exp;
};


export type subscription_rootAnalyticSources_by_pkArgs = {
  value: string;
};


export type subscription_rootAnalyticSources_streamArgs = {
  batch_size: number;
  cursor: Array<AnalyticSources_stream_cursor_input>;
  where?: AnalyticSources_bool_exp;
};


export type subscription_rootApplicationUserGatewayPasswordArgs = {
  distinct_on?: Array<ApplicationUserGatewayPassword_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<ApplicationUserGatewayPassword_order_by>;
  where?: ApplicationUserGatewayPassword_bool_exp;
};


export type subscription_rootApplicationUserGatewayPassword_aggregateArgs = {
  distinct_on?: Array<ApplicationUserGatewayPassword_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<ApplicationUserGatewayPassword_order_by>;
  where?: ApplicationUserGatewayPassword_bool_exp;
};


export type subscription_rootApplicationUserGatewayPassword_by_pkArgs = {
  id: string;
};


export type subscription_rootApplicationUserGatewayPassword_streamArgs = {
  batch_size: number;
  cursor: Array<ApplicationUserGatewayPassword_stream_cursor_input>;
  where?: ApplicationUserGatewayPassword_bool_exp;
};


export type subscription_rootApplicationUserTwoFactorArgs = {
  distinct_on?: Array<ApplicationUserTwoFactor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<ApplicationUserTwoFactor_order_by>;
  where?: ApplicationUserTwoFactor_bool_exp;
};


export type subscription_rootApplicationUserTwoFactor_aggregateArgs = {
  distinct_on?: Array<ApplicationUserTwoFactor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<ApplicationUserTwoFactor_order_by>;
  where?: ApplicationUserTwoFactor_bool_exp;
};


export type subscription_rootApplicationUserTwoFactor_by_pkArgs = {
  id: string;
};


export type subscription_rootApplicationUserTwoFactor_streamArgs = {
  batch_size: number;
  cursor: Array<ApplicationUserTwoFactor_stream_cursor_input>;
  where?: ApplicationUserTwoFactor_bool_exp;
};


export type subscription_rootAuditLogArgs = {
  id: string;
};


export type subscription_rootAuditLogAggregateArgs = {
  distinct_on?: Array<qx_AuditLog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AuditLog_order_by>;
  where?: qx_AuditLog_bool_exp;
};


export type subscription_rootAuditLogsArgs = {
  distinct_on?: Array<qx_AuditLog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AuditLog_order_by>;
  where?: qx_AuditLog_bool_exp;
};


export type subscription_rootDSCConnectionArgs = {
  distinct_on?: Array<DSCConnection_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<DSCConnection_order_by>;
  where?: DSCConnection_bool_exp;
};


export type subscription_rootDSCConnection_aggregateArgs = {
  distinct_on?: Array<DSCConnection_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<DSCConnection_order_by>;
  where?: DSCConnection_bool_exp;
};


export type subscription_rootDSCConnection_by_pkArgs = {
  deviceID: string;
};


export type subscription_rootDSCConnection_streamArgs = {
  batch_size: number;
  cursor: Array<DSCConnection_stream_cursor_input>;
  where?: DSCConnection_bool_exp;
};


export type subscription_rootDeviceDIOArgs = {
  id: string;
};


export type subscription_rootDeviceDIOsArgs = {
  distinct_on?: Array<qx_DeviceDIO_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DeviceDIO_order_by>;
  where?: qx_DeviceDIO_bool_exp;
};


export type subscription_rootDeviceDioAggregateArgs = {
  distinct_on?: Array<qx_DeviceDIO_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DeviceDIO_order_by>;
  where?: qx_DeviceDIO_bool_exp;
};


export type subscription_rootIntrusionAccessCodeArgs = {
  distinct_on?: Array<IntrusionAccessCode_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<IntrusionAccessCode_order_by>;
  where?: IntrusionAccessCode_bool_exp;
};


export type subscription_rootIntrusionAccessCode_aggregateArgs = {
  distinct_on?: Array<IntrusionAccessCode_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<IntrusionAccessCode_order_by>;
  where?: IntrusionAccessCode_bool_exp;
};


export type subscription_rootIntrusionAccessCode_by_pkArgs = {
  id: string;
};


export type subscription_rootIntrusionAccessCode_streamArgs = {
  batch_size: number;
  cursor: Array<IntrusionAccessCode_stream_cursor_input>;
  where?: IntrusionAccessCode_bool_exp;
};


export type subscription_rootIntrusionPartitionArgs = {
  distinct_on?: Array<IntrusionPartition_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<IntrusionPartition_order_by>;
  where?: IntrusionPartition_bool_exp;
};


export type subscription_rootIntrusionPartition_aggregateArgs = {
  distinct_on?: Array<IntrusionPartition_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<IntrusionPartition_order_by>;
  where?: IntrusionPartition_bool_exp;
};


export type subscription_rootIntrusionPartition_by_pkArgs = {
  id: string;
};


export type subscription_rootIntrusionPartition_streamArgs = {
  batch_size: number;
  cursor: Array<IntrusionPartition_stream_cursor_input>;
  where?: IntrusionPartition_bool_exp;
};


export type subscription_rootIntrusionZoneArgs = {
  distinct_on?: Array<IntrusionZone_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<IntrusionZone_order_by>;
  where?: IntrusionZone_bool_exp;
};


export type subscription_rootIntrusionZone_aggregateArgs = {
  distinct_on?: Array<IntrusionZone_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<IntrusionZone_order_by>;
  where?: IntrusionZone_bool_exp;
};


export type subscription_rootIntrusionZone_by_pkArgs = {
  id: string;
};


export type subscription_rootIntrusionZone_streamArgs = {
  batch_size: number;
  cursor: Array<IntrusionZone_stream_cursor_input>;
  where?: IntrusionZone_bool_exp;
};


export type subscription_rootPartitionZoneAssignmentsArgs = {
  distinct_on?: Array<PartitionZoneAssignments_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<PartitionZoneAssignments_order_by>;
  where?: PartitionZoneAssignments_bool_exp;
};


export type subscription_rootPartitionZoneAssignments_aggregateArgs = {
  distinct_on?: Array<PartitionZoneAssignments_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<PartitionZoneAssignments_order_by>;
  where?: PartitionZoneAssignments_bool_exp;
};


export type subscription_rootPartitionZoneAssignments_by_pkArgs = {
  id: string;
};


export type subscription_rootPartitionZoneAssignments_streamArgs = {
  batch_size: number;
  cursor: Array<PartitionZoneAssignments_stream_cursor_input>;
  where?: PartitionZoneAssignments_bool_exp;
};


export type subscription_rootPassKeyProviderArgs = {
  distinct_on?: Array<PassKeyProvider_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<PassKeyProvider_order_by>;
  where?: PassKeyProvider_bool_exp;
};


export type subscription_rootPassKeyProvider_aggregateArgs = {
  distinct_on?: Array<PassKeyProvider_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<PassKeyProvider_order_by>;
  where?: PassKeyProvider_bool_exp;
};


export type subscription_rootPassKeyProvider_by_pkArgs = {
  aaguid: string;
};


export type subscription_rootPassKeyProvider_streamArgs = {
  batch_size: number;
  cursor: Array<PassKeyProvider_stream_cursor_input>;
  where?: PassKeyProvider_bool_exp;
};


export type subscription_rootPermissionPartitionAssignmentsArgs = {
  distinct_on?: Array<PermissionPartitionAssignments_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<PermissionPartitionAssignments_order_by>;
  where?: PermissionPartitionAssignments_bool_exp;
};


export type subscription_rootPermissionPartitionAssignments_aggregateArgs = {
  distinct_on?: Array<PermissionPartitionAssignments_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<PermissionPartitionAssignments_order_by>;
  where?: PermissionPartitionAssignments_bool_exp;
};


export type subscription_rootPermissionPartitionAssignments_by_pkArgs = {
  id: string;
};


export type subscription_rootPermissionPartitionAssignments_streamArgs = {
  batch_size: number;
  cursor: Array<PermissionPartitionAssignments_stream_cursor_input>;
  where?: PermissionPartitionAssignments_bool_exp;
};


export type subscription_rootPersonTermsAgreementArgs = {
  distinct_on?: Array<PersonTermsAgreement_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<PersonTermsAgreement_order_by>;
  where?: PersonTermsAgreement_bool_exp;
};


export type subscription_rootPersonTermsAgreement_aggregateArgs = {
  distinct_on?: Array<PersonTermsAgreement_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<PersonTermsAgreement_order_by>;
  where?: PersonTermsAgreement_bool_exp;
};


export type subscription_rootPersonTermsAgreement_by_pkArgs = {
  email: string;
};


export type subscription_rootPersonTermsAgreement_streamArgs = {
  batch_size: number;
  cursor: Array<PersonTermsAgreement_stream_cursor_input>;
  where?: PersonTermsAgreement_bool_exp;
};


export type subscription_rootaccessBoardTypeEnumArgs = {
  value: string;
};


export type subscription_rootaccessBoardTypeEnumAggregateArgs = {
  distinct_on?: Array<qx_eAccessBoardType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessBoardType_order_by>;
  where?: qx_eAccessBoardType_bool_exp;
};


export type subscription_rootaccessBoardTypeEnumsArgs = {
  distinct_on?: Array<qx_eAccessBoardType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessBoardType_order_by>;
  where?: qx_eAccessBoardType_bool_exp;
};


export type subscription_rootaccessCatalogArgs = {
  id: string;
};


export type subscription_rootaccessCatalogAggregateArgs = {
  distinct_on?: Array<qx_AccessCatalog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessCatalog_order_by>;
  where?: qx_AccessCatalog_bool_exp;
};


export type subscription_rootaccessCatalogsArgs = {
  distinct_on?: Array<qx_AccessCatalog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessCatalog_order_by>;
  where?: qx_AccessCatalog_bool_exp;
};


export type subscription_rootaccessDeniedReasonEnumArgs = {
  value: string;
};


export type subscription_rootaccessDeniedReasonEnumAggregateArgs = {
  distinct_on?: Array<qx_eAccessDeniedReason_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessDeniedReason_order_by>;
  where?: qx_eAccessDeniedReason_bool_exp;
};


export type subscription_rootaccessDeniedReasonEnumsArgs = {
  distinct_on?: Array<qx_eAccessDeniedReason_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessDeniedReason_order_by>;
  where?: qx_eAccessDeniedReason_bool_exp;
};


export type subscription_rootaccessInterfaceTypeEnumArgs = {
  value: string;
};


export type subscription_rootaccessInterfaceTypeEnumAggregateArgs = {
  distinct_on?: Array<qx_eAccessInterfaceType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessInterfaceType_order_by>;
  where?: qx_eAccessInterfaceType_bool_exp;
};


export type subscription_rootaccessInterfaceTypeEnumsArgs = {
  distinct_on?: Array<qx_eAccessInterfaceType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessInterfaceType_order_by>;
  where?: qx_eAccessInterfaceType_bool_exp;
};


export type subscription_rootaccessInventoriesArgs = {
  distinct_on?: Array<qx_AccessInventory_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessInventory_order_by>;
  where?: qx_AccessInventory_bool_exp;
};


export type subscription_rootaccessInventoryArgs = {
  id: string;
};


export type subscription_rootaccessInventoryAggregateArgs = {
  distinct_on?: Array<qx_AccessInventory_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessInventory_order_by>;
  where?: qx_AccessInventory_bool_exp;
};


export type subscription_rootaccessPointActionEnumArgs = {
  value: string;
};


export type subscription_rootaccessPointActionEnumAggregateArgs = {
  distinct_on?: Array<qx_eAccessPointAction_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessPointAction_order_by>;
  where?: qx_eAccessPointAction_bool_exp;
};


export type subscription_rootaccessPointActionEnumsArgs = {
  distinct_on?: Array<qx_eAccessPointAction_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessPointAction_order_by>;
  where?: qx_eAccessPointAction_bool_exp;
};


export type subscription_rootaccessPointDirectionEnumArgs = {
  value: string;
};


export type subscription_rootaccessPointDirectionEnumAggregateArgs = {
  distinct_on?: Array<qx_eAccessPointDirection_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessPointDirection_order_by>;
  where?: qx_eAccessPointDirection_bool_exp;
};


export type subscription_rootaccessPointDirectionEnumsArgs = {
  distinct_on?: Array<qx_eAccessPointDirection_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessPointDirection_order_by>;
  where?: qx_eAccessPointDirection_bool_exp;
};


export type subscription_rootaccessPointTypeEnumArgs = {
  value: string;
};


export type subscription_rootaccessPointTypeEnumAggregateArgs = {
  distinct_on?: Array<qx_eAccessPointType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessPointType_order_by>;
  where?: qx_eAccessPointType_bool_exp;
};


export type subscription_rootaccessPointTypeEnumsArgs = {
  distinct_on?: Array<qx_eAccessPointType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessPointType_order_by>;
  where?: qx_eAccessPointType_bool_exp;
};


export type subscription_rootanalyticAttributePropertiesArgs = {
  distinct_on?: Array<analyticAttributeProperties_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticAttributeProperties_order_by>;
  where?: analyticAttributeProperties_bool_exp;
};


export type subscription_rootanalyticAttributeProperties_aggregateArgs = {
  distinct_on?: Array<analyticAttributeProperties_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticAttributeProperties_order_by>;
  where?: analyticAttributeProperties_bool_exp;
};


export type subscription_rootanalyticAttributeProperties_by_pkArgs = {
  analyticAttributeID: string;
  attributePropertyValue: string;
};


export type subscription_rootanalyticAttributeProperties_streamArgs = {
  batch_size: number;
  cursor: Array<analyticAttributeProperties_stream_cursor_input>;
  where?: analyticAttributeProperties_bool_exp;
};


export type subscription_rootanalyticAttributesArgs = {
  distinct_on?: Array<analyticAttributes_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticAttributes_order_by>;
  where?: analyticAttributes_bool_exp;
};


export type subscription_rootanalyticAttributes_aggregateArgs = {
  distinct_on?: Array<analyticAttributes_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticAttributes_order_by>;
  where?: analyticAttributes_bool_exp;
};


export type subscription_rootanalyticAttributes_by_pkArgs = {
  id: string;
};


export type subscription_rootanalyticAttributes_streamArgs = {
  batch_size: number;
  cursor: Array<analyticAttributes_stream_cursor_input>;
  where?: analyticAttributes_bool_exp;
};


export type subscription_rootanalyticDetectedPropertiesArgs = {
  distinct_on?: Array<analyticDetectedProperties_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticDetectedProperties_order_by>;
  where?: analyticDetectedProperties_bool_exp;
};


export type subscription_rootanalyticDetectedProperties_aggregateArgs = {
  distinct_on?: Array<analyticDetectedProperties_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticDetectedProperties_order_by>;
  where?: analyticDetectedProperties_bool_exp;
};


export type subscription_rootanalyticDetectedProperties_by_pkArgs = {
  id: string;
};


export type subscription_rootanalyticDetectedProperties_streamArgs = {
  batch_size: number;
  cursor: Array<analyticDetectedProperties_stream_cursor_input>;
  where?: analyticDetectedProperties_bool_exp;
};


export type subscription_rootanalyticTypesArgs = {
  distinct_on?: Array<analyticTypes_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticTypes_order_by>;
  where?: analyticTypes_bool_exp;
};


export type subscription_rootanalyticTypes_aggregateArgs = {
  distinct_on?: Array<analyticTypes_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analyticTypes_order_by>;
  where?: analyticTypes_bool_exp;
};


export type subscription_rootanalyticTypes_by_pkArgs = {
  type: string;
};


export type subscription_rootanalyticTypes_streamArgs = {
  batch_size: number;
  cursor: Array<analyticTypes_stream_cursor_input>;
  where?: analyticTypes_bool_exp;
};


export type subscription_rootanalyticsArgs = {
  distinct_on?: Array<analytics_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analytics_order_by>;
  where?: analytics_bool_exp;
};


export type subscription_rootanalytics_aggregateArgs = {
  distinct_on?: Array<analytics_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<analytics_order_by>;
  where?: analytics_bool_exp;
};


export type subscription_rootanalytics_by_pkArgs = {
  id: string;
};


export type subscription_rootanalytics_streamArgs = {
  batch_size: number;
  cursor: Array<analytics_stream_cursor_input>;
  where?: analytics_bool_exp;
};


export type subscription_rootapplicationUserAppPasswordsArgs = {
  distinct_on?: Array<applicationUserAppPasswords_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<applicationUserAppPasswords_order_by>;
  where?: applicationUserAppPasswords_bool_exp;
};


export type subscription_rootapplicationUserAppPasswords_aggregateArgs = {
  distinct_on?: Array<applicationUserAppPasswords_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<applicationUserAppPasswords_order_by>;
  where?: applicationUserAppPasswords_bool_exp;
};


export type subscription_rootapplicationUserAppPasswords_by_pkArgs = {
  id: string;
};


export type subscription_rootapplicationUserAppPasswords_streamArgs = {
  batch_size: number;
  cursor: Array<applicationUserAppPasswords_stream_cursor_input>;
  where?: applicationUserAppPasswords_bool_exp;
};


export type subscription_rootapplicationUserDevicesArgs = {
  distinct_on?: Array<applicationUserDevices_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<applicationUserDevices_order_by>;
  where?: applicationUserDevices_bool_exp;
};


export type subscription_rootapplicationUserDevices_aggregateArgs = {
  distinct_on?: Array<applicationUserDevices_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<applicationUserDevices_order_by>;
  where?: applicationUserDevices_bool_exp;
};


export type subscription_rootapplicationUserDevices_by_pkArgs = {
  id: string;
};


export type subscription_rootapplicationUserDevices_streamArgs = {
  batch_size: number;
  cursor: Array<applicationUserDevices_stream_cursor_input>;
  where?: applicationUserDevices_bool_exp;
};


export type subscription_rootattributePropertiesArgs = {
  distinct_on?: Array<attributeProperties_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<attributeProperties_order_by>;
  where?: attributeProperties_bool_exp;
};


export type subscription_rootattributeProperties_aggregateArgs = {
  distinct_on?: Array<attributeProperties_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<attributeProperties_order_by>;
  where?: attributeProperties_bool_exp;
};


export type subscription_rootattributeProperties_by_pkArgs = {
  value: string;
};


export type subscription_rootattributeProperties_streamArgs = {
  batch_size: number;
  cursor: Array<attributeProperties_stream_cursor_input>;
  where?: attributeProperties_bool_exp;
};


export type subscription_rootattributesArgs = {
  distinct_on?: Array<attributes_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<attributes_order_by>;
  where?: attributes_bool_exp;
};


export type subscription_rootattributes_aggregateArgs = {
  distinct_on?: Array<attributes_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<attributes_order_by>;
  where?: attributes_bool_exp;
};


export type subscription_rootattributes_by_pkArgs = {
  type: string;
};


export type subscription_rootattributes_streamArgs = {
  batch_size: number;
  cursor: Array<attributes_stream_cursor_input>;
  where?: attributes_bool_exp;
};


export type subscription_rootaudioSourceArgs = {
  id: string;
};


export type subscription_rootaudioSourceAggregateArgs = {
  distinct_on?: Array<qx_AudioSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AudioSource_order_by>;
  where?: qx_AudioSource_bool_exp;
};


export type subscription_rootaudioSourceAuditArgs = {
  distinct_on?: Array<audioSourceAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<audioSourceAudit_order_by>;
  where?: audioSourceAudit_bool_exp;
};


export type subscription_rootaudioSourceAudit_aggregateArgs = {
  distinct_on?: Array<audioSourceAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<audioSourceAudit_order_by>;
  where?: audioSourceAudit_bool_exp;
};


export type subscription_rootaudioSourceAudit_streamArgs = {
  batch_size: number;
  cursor: Array<audioSourceAudit_stream_cursor_input>;
  where?: audioSourceAudit_bool_exp;
};


export type subscription_rootaudioSourceVideoSourceArgs = {
  distinct_on?: Array<audioSourceVideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<audioSourceVideoSource_order_by>;
  where?: audioSourceVideoSource_bool_exp;
};


export type subscription_rootaudioSourceVideoSource_aggregateArgs = {
  distinct_on?: Array<audioSourceVideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<audioSourceVideoSource_order_by>;
  where?: audioSourceVideoSource_bool_exp;
};


export type subscription_rootaudioSourceVideoSource_streamArgs = {
  batch_size: number;
  cursor: Array<audioSourceVideoSource_stream_cursor_input>;
  where?: audioSourceVideoSource_bool_exp;
};


export type subscription_rootaudioSourcesArgs = {
  distinct_on?: Array<qx_AudioSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AudioSource_order_by>;
  where?: qx_AudioSource_bool_exp;
};


export type subscription_rootaudit_logged_actionsArgs = {
  distinct_on?: Array<audit_logged_actions_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<audit_logged_actions_order_by>;
  where?: audit_logged_actions_bool_exp;
};


export type subscription_rootaudit_logged_actions_aggregateArgs = {
  distinct_on?: Array<audit_logged_actions_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<audit_logged_actions_order_by>;
  where?: audit_logged_actions_bool_exp;
};


export type subscription_rootaudit_logged_actions_by_pkArgs = {
  event_id: string;
};


export type subscription_rootaudit_logged_actions_streamArgs = {
  batch_size: number;
  cursor: Array<audit_logged_actions_stream_cursor_input>;
  where?: audit_logged_actions_bool_exp;
};


export type subscription_rootaudit_vSensorAuditArgs = {
  distinct_on?: Array<audit_vSensorAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<audit_vSensorAudit_order_by>;
  where?: audit_vSensorAudit_bool_exp;
};


export type subscription_rootaudit_vSensorAudit_aggregateArgs = {
  distinct_on?: Array<audit_vSensorAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<audit_vSensorAudit_order_by>;
  where?: audit_vSensorAudit_bool_exp;
};


export type subscription_rootaudit_vSensorAudit_streamArgs = {
  batch_size: number;
  cursor: Array<audit_vSensorAudit_stream_cursor_input>;
  where?: audit_vSensorAudit_bool_exp;
};


export type subscription_rootauditableActionsArgs = {
  distinct_on?: Array<qx_AuditableAction_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AuditableAction_order_by>;
  where?: qx_AuditableAction_bool_exp;
};


export type subscription_rootauditableTypesArgs = {
  distinct_on?: Array<qx_AuditableType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AuditableType_order_by>;
  where?: qx_AuditableType_bool_exp;
};


export type subscription_rootauthStrategyEnumArgs = {
  value: string;
};


export type subscription_rootauthStrategyEnumAggregateArgs = {
  distinct_on?: Array<qx_eAuthStrategy_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAuthStrategy_order_by>;
  where?: qx_eAuthStrategy_bool_exp;
};


export type subscription_rootauthStrategyEnumsArgs = {
  distinct_on?: Array<qx_eAuthStrategy_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAuthStrategy_order_by>;
  where?: qx_eAuthStrategy_bool_exp;
};


export type subscription_rootbatteryLevelEnumArgs = {
  value: string;
};


export type subscription_rootbatteryLevelEnumAggregateArgs = {
  distinct_on?: Array<qx_eBatteryLevel_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eBatteryLevel_order_by>;
  where?: qx_eBatteryLevel_bool_exp;
};


export type subscription_rootbatteryLevelEnumsArgs = {
  distinct_on?: Array<qx_eBatteryLevel_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eBatteryLevel_order_by>;
  where?: qx_eBatteryLevel_bool_exp;
};


export type subscription_rootbaudrateEnumArgs = {
  value: string;
};


export type subscription_rootbaudrateEnumAggregateArgs = {
  distinct_on?: Array<qx_eBaudrate_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eBaudrate_order_by>;
  where?: qx_eBaudrate_bool_exp;
};


export type subscription_rootbaudrateEnumsArgs = {
  distinct_on?: Array<qx_eBaudrate_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eBaudrate_order_by>;
  where?: qx_eBaudrate_bool_exp;
};


export type subscription_rootbillingPeriodArgs = {
  billingPeriodMonths: number;
};


export type subscription_rootbillingPeriodAggregateArgs = {
  distinct_on?: Array<qx_BillingPeriod_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_BillingPeriod_order_by>;
  where?: qx_BillingPeriod_bool_exp;
};


export type subscription_rootbillingPeriodsArgs = {
  distinct_on?: Array<qx_BillingPeriod_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_BillingPeriod_order_by>;
  where?: qx_BillingPeriod_bool_exp;
};


export type subscription_rootbillingTierEnumArgs = {
  value: string;
};


export type subscription_rootbillingTierEnumAggregateArgs = {
  distinct_on?: Array<qx_eBillingTier_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eBillingTier_order_by>;
  where?: qx_eBillingTier_bool_exp;
};


export type subscription_rootbillingTierEnumsArgs = {
  distinct_on?: Array<qx_eBillingTier_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eBillingTier_order_by>;
  where?: qx_eBillingTier_bool_exp;
};


export type subscription_rootchatBillingByModelAggregateArgs = {
  distinct_on?: Array<qx_vChatBillingByModel_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatBillingByModel_order_by>;
  where?: qx_vChatBillingByModel_bool_exp;
};


export type subscription_rootchatBillingByModelsArgs = {
  distinct_on?: Array<qx_vChatBillingByModel_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatBillingByModel_order_by>;
  where?: qx_vChatBillingByModel_bool_exp;
};


export type subscription_rootchatBillingSummariesArgs = {
  distinct_on?: Array<qx_vChatBillingSummary_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatBillingSummary_order_by>;
  where?: qx_vChatBillingSummary_bool_exp;
};


export type subscription_rootchatBillingSummaryAggregateArgs = {
  distinct_on?: Array<qx_vChatBillingSummary_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatBillingSummary_order_by>;
  where?: qx_vChatBillingSummary_bool_exp;
};


export type subscription_rootchatPromptUsageAggregateArgs = {
  distinct_on?: Array<qx_vChatPromptUsage_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatPromptUsage_order_by>;
  where?: qx_vChatPromptUsage_bool_exp;
};


export type subscription_rootchatPromptUsagesArgs = {
  distinct_on?: Array<qx_vChatPromptUsage_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatPromptUsage_order_by>;
  where?: qx_vChatPromptUsage_bool_exp;
};


export type subscription_rootchatUsageHistoriesArgs = {
  distinct_on?: Array<qx_ChatUsageHistory_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ChatUsageHistory_order_by>;
  where?: qx_ChatUsageHistory_bool_exp;
};


export type subscription_rootchatUsageHistoryArgs = {
  id: any;
};


export type subscription_rootchatUsageHistoryAggregateArgs = {
  distinct_on?: Array<qx_ChatUsageHistory_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ChatUsageHistory_order_by>;
  where?: qx_ChatUsageHistory_bool_exp;
};


export type subscription_rootchat_usage_per_modelArgs = {
  args?: qx_chat_usage_per_model_args;
  distinct_on?: Array<qx_vChatUsagePerModel_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatUsagePerModel_order_by>;
  where?: qx_vChatUsagePerModel_bool_exp;
};


export type subscription_rootchat_usage_seriesArgs = {
  args: qx_chat_usage_series_args;
  distinct_on?: Array<qx_vChatUsageSeries_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatUsageSeries_order_by>;
  where?: qx_vChatUsageSeries_bool_exp;
};


export type subscription_rootclipArgs = {
  id: string;
};


export type subscription_rootclipAggregateArgs = {
  distinct_on?: Array<qx_Clip_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Clip_order_by>;
  where?: qx_Clip_bool_exp;
};


export type subscription_rootclipAuditLogAggregateArgs = {
  distinct_on?: Array<qx_ClipAuditLog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ClipAuditLog_order_by>;
  where?: qx_ClipAuditLog_bool_exp;
};


export type subscription_rootclipAuditLogsArgs = {
  distinct_on?: Array<qx_ClipAuditLog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ClipAuditLog_order_by>;
  where?: qx_ClipAuditLog_bool_exp;
};


export type subscription_rootclipStatusReasonEnumArgs = {
  value: string;
};


export type subscription_rootclipStatusReasonEnumAggregateArgs = {
  distinct_on?: Array<qx_eClipStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eClipStatus_order_by>;
  where?: qx_eClipStatus_bool_exp;
};


export type subscription_rootclipStatusReasonEnumsArgs = {
  distinct_on?: Array<qx_eClipStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eClipStatus_order_by>;
  where?: qx_eClipStatus_bool_exp;
};


export type subscription_rootclipTypeEnumArgs = {
  value: string;
};


export type subscription_rootclipTypeEnumAggregateArgs = {
  distinct_on?: Array<qx_eClipType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eClipType_order_by>;
  where?: qx_eClipType_bool_exp;
};


export type subscription_rootclipTypeEnumsArgs = {
  distinct_on?: Array<qx_eClipType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eClipType_order_by>;
  where?: qx_eClipType_bool_exp;
};


export type subscription_rootclipsArgs = {
  distinct_on?: Array<qx_Clip_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Clip_order_by>;
  where?: qx_Clip_bool_exp;
};


export type subscription_rootcloudStorageOptionArgs = {
  cloudStorageDays: number;
};


export type subscription_rootcloudStorageOptionsArgs = {
  distinct_on?: Array<qx_CloudStorageOptions_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_CloudStorageOptions_order_by>;
  where?: qx_CloudStorageOptions_bool_exp;
};


export type subscription_rootcloudStorageOptionsAggregateArgs = {
  distinct_on?: Array<qx_CloudStorageOptions_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_CloudStorageOptions_order_by>;
  where?: qx_CloudStorageOptions_bool_exp;
};


export type subscription_rootcloudStorageTimelapseOptionsArgs = {
  distinct_on?: Array<cloudStorageTimelapseOptions_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<cloudStorageTimelapseOptions_order_by>;
  where?: cloudStorageTimelapseOptions_bool_exp;
};


export type subscription_rootcloudStorageTimelapseOptions_aggregateArgs = {
  distinct_on?: Array<cloudStorageTimelapseOptions_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<cloudStorageTimelapseOptions_order_by>;
  where?: cloudStorageTimelapseOptions_bool_exp;
};


export type subscription_rootcloudStorageTimelapseOptions_by_pkArgs = {
  cloudStorageDays: number;
};


export type subscription_rootcloudStorageTimelapseOptions_streamArgs = {
  batch_size: number;
  cursor: Array<cloudStorageTimelapseOptions_stream_cursor_input>;
  where?: cloudStorageTimelapseOptions_bool_exp;
};


export type subscription_rootcredentialArgs = {
  id: string;
};


export type subscription_rootcredentialAggregateArgs = {
  distinct_on?: Array<qx_Credential_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Credential_order_by>;
  where?: qx_Credential_bool_exp;
};


export type subscription_rootcredentialAuditArgs = {
  distinct_on?: Array<credentialAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<credentialAudit_order_by>;
  where?: credentialAudit_bool_exp;
};


export type subscription_rootcredentialAudit_aggregateArgs = {
  distinct_on?: Array<credentialAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<credentialAudit_order_by>;
  where?: credentialAudit_bool_exp;
};


export type subscription_rootcredentialAudit_streamArgs = {
  batch_size: number;
  cursor: Array<credentialAudit_stream_cursor_input>;
  where?: credentialAudit_bool_exp;
};


export type subscription_rootcredentialTypeEnumArgs = {
  value: string;
};


export type subscription_rootcredentialTypeEnumAggregateArgs = {
  distinct_on?: Array<qx_eCredentialType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eCredentialType_order_by>;
  where?: qx_eCredentialType_bool_exp;
};


export type subscription_rootcredentialTypeEnumsArgs = {
  distinct_on?: Array<qx_eCredentialType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eCredentialType_order_by>;
  where?: qx_eCredentialType_bool_exp;
};


export type subscription_rootcredentialsArgs = {
  distinct_on?: Array<qx_Credential_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Credential_order_by>;
  where?: qx_Credential_bool_exp;
};


export type subscription_rootcustomerPermissionArgs = {
  customerPlaceID: string;
};


export type subscription_rootcustomerPermissionAggregateArgs = {
  distinct_on?: Array<qx_CustomerPermission_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_CustomerPermission_order_by>;
  where?: qx_CustomerPermission_bool_exp;
};


export type subscription_rootcustomerPermissionAuditArgs = {
  distinct_on?: Array<customerPermissionAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<customerPermissionAudit_order_by>;
  where?: customerPermissionAudit_bool_exp;
};


export type subscription_rootcustomerPermissionAudit_aggregateArgs = {
  distinct_on?: Array<customerPermissionAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<customerPermissionAudit_order_by>;
  where?: customerPermissionAudit_bool_exp;
};


export type subscription_rootcustomerPermissionAudit_streamArgs = {
  batch_size: number;
  cursor: Array<customerPermissionAudit_stream_cursor_input>;
  where?: customerPermissionAudit_bool_exp;
};


export type subscription_rootcustomerPermissionsArgs = {
  distinct_on?: Array<qx_CustomerPermission_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_CustomerPermission_order_by>;
  where?: qx_CustomerPermission_bool_exp;
};


export type subscription_rootdeviceArgs = {
  id: string;
};


export type subscription_rootdeviceAggregateArgs = {
  distinct_on?: Array<qx_Device_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Device_order_by>;
  where?: qx_Device_bool_exp;
};


export type subscription_rootdeviceAnalyticSourceArgs = {
  distinct_on?: Array<deviceAnalyticSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<deviceAnalyticSource_order_by>;
  where?: deviceAnalyticSource_bool_exp;
};


export type subscription_rootdeviceAnalyticSource_aggregateArgs = {
  distinct_on?: Array<deviceAnalyticSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<deviceAnalyticSource_order_by>;
  where?: deviceAnalyticSource_bool_exp;
};


export type subscription_rootdeviceAnalyticSource_by_pkArgs = {
  id: number;
};


export type subscription_rootdeviceAnalyticSource_streamArgs = {
  batch_size: number;
  cursor: Array<deviceAnalyticSource_stream_cursor_input>;
  where?: deviceAnalyticSource_bool_exp;
};


export type subscription_rootdeviceAuditArgs = {
  distinct_on?: Array<deviceAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<deviceAudit_order_by>;
  where?: deviceAudit_bool_exp;
};


export type subscription_rootdeviceAudit_aggregateArgs = {
  distinct_on?: Array<deviceAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<deviceAudit_order_by>;
  where?: deviceAudit_bool_exp;
};


export type subscription_rootdeviceAudit_streamArgs = {
  batch_size: number;
  cursor: Array<deviceAudit_stream_cursor_input>;
  where?: deviceAudit_bool_exp;
};


export type subscription_rootdeviceConnectionStatusEnumArgs = {
  value: string;
};


export type subscription_rootdeviceConnectionStatusEnumAggregateArgs = {
  distinct_on?: Array<qx_eDeviceConnectionStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDeviceConnectionStatus_order_by>;
  where?: qx_eDeviceConnectionStatus_bool_exp;
};


export type subscription_rootdeviceConnectionStatusEnumsArgs = {
  distinct_on?: Array<qx_eDeviceConnectionStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDeviceConnectionStatus_order_by>;
  where?: qx_eDeviceConnectionStatus_bool_exp;
};


export type subscription_rootdeviceDIOAuditArgs = {
  distinct_on?: Array<deviceDIOAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<deviceDIOAudit_order_by>;
  where?: deviceDIOAudit_bool_exp;
};


export type subscription_rootdeviceDIOAudit_aggregateArgs = {
  distinct_on?: Array<deviceDIOAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<deviceDIOAudit_order_by>;
  where?: deviceDIOAudit_bool_exp;
};


export type subscription_rootdeviceDIOAudit_streamArgs = {
  batch_size: number;
  cursor: Array<deviceDIOAudit_stream_cursor_input>;
  where?: deviceDIOAudit_bool_exp;
};


export type subscription_rootdeviceKindEnumArgs = {
  value: string;
};


export type subscription_rootdeviceKindEnumAggregateArgs = {
  distinct_on?: Array<qx_eDeviceKind_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDeviceKind_order_by>;
  where?: qx_eDeviceKind_bool_exp;
};


export type subscription_rootdeviceKindEnumsArgs = {
  distinct_on?: Array<qx_eDeviceKind_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDeviceKind_order_by>;
  where?: qx_eDeviceKind_bool_exp;
};


export type subscription_rootdevicesArgs = {
  distinct_on?: Array<qx_Device_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Device_order_by>;
  where?: qx_Device_bool_exp;
};


export type subscription_rootdioNormalStateEnumArgs = {
  value: string;
};


export type subscription_rootdioNormalStateEnumAggregateArgs = {
  distinct_on?: Array<qx_eDIONormalState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDIONormalState_order_by>;
  where?: qx_eDIONormalState_bool_exp;
};


export type subscription_rootdioNormalStateEnumsArgs = {
  distinct_on?: Array<qx_eDIONormalState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDIONormalState_order_by>;
  where?: qx_eDIONormalState_bool_exp;
};


export type subscription_rootdioStateEnumArgs = {
  value: string;
};


export type subscription_rootdioStateEnumAggregateArgs = {
  distinct_on?: Array<qx_eDIOState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDIOState_order_by>;
  where?: qx_eDIOState_bool_exp;
};


export type subscription_rootdioStateEnumsArgs = {
  distinct_on?: Array<qx_eDIOState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDIOState_order_by>;
  where?: qx_eDIOState_bool_exp;
};


export type subscription_rootdioTypeEnumArgs = {
  value: string;
};


export type subscription_rootdioTypeEnumAggregateArgs = {
  distinct_on?: Array<qx_eDIOType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDIOType_order_by>;
  where?: qx_eDIOType_bool_exp;
};


export type subscription_rootdioTypeEnumsArgs = {
  distinct_on?: Array<qx_eDIOType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDIOType_order_by>;
  where?: qx_eDIOType_bool_exp;
};


export type subscription_rootdiscoveryTypesArgs = {
  distinct_on?: Array<qx_DiscoveryType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DiscoveryType_order_by>;
  where?: qx_DiscoveryType_bool_exp;
};


export type subscription_rootdoorArgs = {
  id: string;
};


export type subscription_rootdoorAggregateArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


export type subscription_rootdoorAlarmEnumArgs = {
  value: string;
};


export type subscription_rootdoorAlarmEnumAggregateArgs = {
  distinct_on?: Array<qx_eDoorAlarm_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDoorAlarm_order_by>;
  where?: qx_eDoorAlarm_bool_exp;
};


export type subscription_rootdoorAlarmEnumsArgs = {
  distinct_on?: Array<qx_eDoorAlarm_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDoorAlarm_order_by>;
  where?: qx_eDoorAlarm_bool_exp;
};


export type subscription_rootdoorAuditArgs = {
  distinct_on?: Array<doorAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<doorAudit_order_by>;
  where?: doorAudit_bool_exp;
};


export type subscription_rootdoorAudit_aggregateArgs = {
  distinct_on?: Array<doorAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<doorAudit_order_by>;
  where?: doorAudit_bool_exp;
};


export type subscription_rootdoorAudit_streamArgs = {
  batch_size: number;
  cursor: Array<doorAudit_stream_cursor_input>;
  where?: doorAudit_bool_exp;
};


export type subscription_rootdoorConfigurationArgs = {
  id: string;
};


export type subscription_rootdoorConfigurationAggregateArgs = {
  distinct_on?: Array<qx_DoorConfiguration_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DoorConfiguration_order_by>;
  where?: qx_DoorConfiguration_bool_exp;
};


export type subscription_rootdoorConfigurationsArgs = {
  distinct_on?: Array<qx_DoorConfiguration_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DoorConfiguration_order_by>;
  where?: qx_DoorConfiguration_bool_exp;
};


export type subscription_rootdoorMetaArgs = {
  id: string;
};


export type subscription_rootdoorMetaAggregateArgs = {
  distinct_on?: Array<qx_DoorMeta_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DoorMeta_order_by>;
  where?: qx_DoorMeta_bool_exp;
};


export type subscription_rootdoorMetasArgs = {
  distinct_on?: Array<qx_DoorMeta_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DoorMeta_order_by>;
  where?: qx_DoorMeta_bool_exp;
};


export type subscription_rootdoorModeEnumArgs = {
  value: string;
};


export type subscription_rootdoorModeEnumAggregateArgs = {
  distinct_on?: Array<qx_eDoorMode_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDoorMode_order_by>;
  where?: qx_eDoorMode_bool_exp;
};


export type subscription_rootdoorModeEnumsArgs = {
  distinct_on?: Array<qx_eDoorMode_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDoorMode_order_by>;
  where?: qx_eDoorMode_bool_exp;
};


export type subscription_rootdoorMonitorEnumArgs = {
  value: string;
};


export type subscription_rootdoorMonitorEnumAggregateArgs = {
  distinct_on?: Array<qx_eDoorMonitor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDoorMonitor_order_by>;
  where?: qx_eDoorMonitor_bool_exp;
};


export type subscription_rootdoorMonitorEnumsArgs = {
  distinct_on?: Array<qx_eDoorMonitor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDoorMonitor_order_by>;
  where?: qx_eDoorMonitor_bool_exp;
};


export type subscription_rootdoorStateEnumArgs = {
  value: string;
};


export type subscription_rootdoorStateEnumAggregateArgs = {
  distinct_on?: Array<qx_eDoorState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDoorState_order_by>;
  where?: qx_eDoorState_bool_exp;
};


export type subscription_rootdoorStateEnumsArgs = {
  distinct_on?: Array<qx_eDoorState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDoorState_order_by>;
  where?: qx_eDoorState_bool_exp;
};


export type subscription_rootdoorTemplateArgs = {
  id: string;
};


export type subscription_rootdoorTemplateAggregateArgs = {
  distinct_on?: Array<qx_DoorTemplate_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DoorTemplate_order_by>;
  where?: qx_DoorTemplate_bool_exp;
};


export type subscription_rootdoorTemplatesArgs = {
  distinct_on?: Array<qx_DoorTemplate_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DoorTemplate_order_by>;
  where?: qx_DoorTemplate_bool_exp;
};


export type subscription_rootdoorsArgs = {
  distinct_on?: Array<qx_Door_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Door_order_by>;
  where?: qx_Door_bool_exp;
};


export type subscription_rooteAnalyticIntegrationsArgs = {
  distinct_on?: Array<eAnalyticIntegrations_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<eAnalyticIntegrations_order_by>;
  where?: eAnalyticIntegrations_bool_exp;
};


export type subscription_rooteAnalyticIntegrations_aggregateArgs = {
  distinct_on?: Array<eAnalyticIntegrations_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<eAnalyticIntegrations_order_by>;
  where?: eAnalyticIntegrations_bool_exp;
};


export type subscription_rooteAnalyticIntegrations_by_pkArgs = {
  value: string;
};


export type subscription_rooteAnalyticIntegrations_streamArgs = {
  batch_size: number;
  cursor: Array<eAnalyticIntegrations_stream_cursor_input>;
  where?: eAnalyticIntegrations_bool_exp;
};


export type subscription_rooteAnalyticStatesArgs = {
  distinct_on?: Array<eAnalyticStates_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<eAnalyticStates_order_by>;
  where?: eAnalyticStates_bool_exp;
};


export type subscription_rooteAnalyticStates_aggregateArgs = {
  distinct_on?: Array<eAnalyticStates_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<eAnalyticStates_order_by>;
  where?: eAnalyticStates_bool_exp;
};


export type subscription_rooteAnalyticStates_by_pkArgs = {
  value: string;
};


export type subscription_rooteAnalyticStates_streamArgs = {
  batch_size: number;
  cursor: Array<eAnalyticStates_stream_cursor_input>;
  where?: eAnalyticStates_bool_exp;
};


export type subscription_rooteGatewayTypeArgs = {
  distinct_on?: Array<eGatewayType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<eGatewayType_order_by>;
  where?: eGatewayType_bool_exp;
};


export type subscription_rooteGatewayType_aggregateArgs = {
  distinct_on?: Array<eGatewayType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<eGatewayType_order_by>;
  where?: eGatewayType_bool_exp;
};


export type subscription_rooteGatewayType_by_pkArgs = {
  value: string;
};


export type subscription_rooteGatewayType_streamArgs = {
  batch_size: number;
  cursor: Array<eGatewayType_stream_cursor_input>;
  where?: eGatewayType_bool_exp;
};


export type subscription_rooteS3BucketTypeArgs = {
  distinct_on?: Array<eS3BucketType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<eS3BucketType_order_by>;
  where?: eS3BucketType_bool_exp;
};


export type subscription_rooteS3BucketType_aggregateArgs = {
  distinct_on?: Array<eS3BucketType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<eS3BucketType_order_by>;
  where?: eS3BucketType_bool_exp;
};


export type subscription_rooteS3BucketType_by_pkArgs = {
  value: string;
};


export type subscription_rooteS3BucketType_streamArgs = {
  batch_size: number;
  cursor: Array<eS3BucketType_stream_cursor_input>;
  where?: eS3BucketType_bool_exp;
};


export type subscription_rooteventArgs = {
  id: string;
  serverTime: string;
};


export type subscription_rooteventAggregateArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};


export type subscription_rooteventTypeArgs = {
  type: string;
};


export type subscription_rooteventTypeAggregateArgs = {
  distinct_on?: Array<qx_EventType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_EventType_order_by>;
  where?: qx_EventType_bool_exp;
};


export type subscription_rooteventTypesArgs = {
  distinct_on?: Array<qx_EventType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_EventType_order_by>;
  where?: qx_EventType_bool_exp;
};


export type subscription_rooteventsArgs = {
  distinct_on?: Array<qx_Event_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Event_order_by>;
  where?: qx_Event_bool_exp;
};


export type subscription_rootflowArgs = {
  id: string;
};


export type subscription_rootflowAggregateArgs = {
  distinct_on?: Array<qx_Flow_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Flow_order_by>;
  where?: qx_Flow_bool_exp;
};


export type subscription_rootflowAuditArgs = {
  distinct_on?: Array<flowAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<flowAudit_order_by>;
  where?: flowAudit_bool_exp;
};


export type subscription_rootflowAudit_aggregateArgs = {
  distinct_on?: Array<flowAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<flowAudit_order_by>;
  where?: flowAudit_bool_exp;
};


export type subscription_rootflowAudit_streamArgs = {
  batch_size: number;
  cursor: Array<flowAudit_stream_cursor_input>;
  where?: flowAudit_bool_exp;
};


export type subscription_rootflowTraceArgs = {
  id: string;
};


export type subscription_rootflowTraceAggregateArgs = {
  distinct_on?: Array<qx_FlowTrace_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_FlowTrace_order_by>;
  where?: qx_FlowTrace_bool_exp;
};


export type subscription_rootflowTracesArgs = {
  distinct_on?: Array<qx_FlowTrace_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_FlowTrace_order_by>;
  where?: qx_FlowTrace_bool_exp;
};


export type subscription_rootflowsArgs = {
  distinct_on?: Array<qx_Flow_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Flow_order_by>;
  where?: qx_Flow_bool_exp;
};


export type subscription_rootgatewayArgs = {
  id: string;
};


export type subscription_rootgatewayAggregateArgs = {
  distinct_on?: Array<qx_Gateway_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Gateway_order_by>;
  where?: qx_Gateway_bool_exp;
};


export type subscription_rootgatewayAuditArgs = {
  distinct_on?: Array<gatewayAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<gatewayAudit_order_by>;
  where?: gatewayAudit_bool_exp;
};


export type subscription_rootgatewayAudit_aggregateArgs = {
  distinct_on?: Array<gatewayAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<gatewayAudit_order_by>;
  where?: gatewayAudit_bool_exp;
};


export type subscription_rootgatewayAudit_streamArgs = {
  batch_size: number;
  cursor: Array<gatewayAudit_stream_cursor_input>;
  where?: gatewayAudit_bool_exp;
};


export type subscription_rootgatewayBandwidthScheduleArgs = {
  id: string;
};


export type subscription_rootgatewayBandwidthScheduleAggregateArgs = {
  distinct_on?: Array<qx_GatewayBandwidthSchedule_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_GatewayBandwidthSchedule_order_by>;
  where?: qx_GatewayBandwidthSchedule_bool_exp;
};


export type subscription_rootgatewayBandwidthScheduleAuditArgs = {
  distinct_on?: Array<gatewayBandwidthScheduleAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<gatewayBandwidthScheduleAudit_order_by>;
  where?: gatewayBandwidthScheduleAudit_bool_exp;
};


export type subscription_rootgatewayBandwidthScheduleAudit_aggregateArgs = {
  distinct_on?: Array<gatewayBandwidthScheduleAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<gatewayBandwidthScheduleAudit_order_by>;
  where?: gatewayBandwidthScheduleAudit_bool_exp;
};


export type subscription_rootgatewayBandwidthScheduleAudit_streamArgs = {
  batch_size: number;
  cursor: Array<gatewayBandwidthScheduleAudit_stream_cursor_input>;
  where?: gatewayBandwidthScheduleAudit_bool_exp;
};


export type subscription_rootgatewayBandwidthSchedulesArgs = {
  distinct_on?: Array<qx_GatewayBandwidthSchedule_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_GatewayBandwidthSchedule_order_by>;
  where?: qx_GatewayBandwidthSchedule_bool_exp;
};


export type subscription_rootgatewayServiceEnumsArgs = {
  distinct_on?: Array<qx_eGatewayServiceType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eGatewayServiceType_order_by>;
  where?: qx_eGatewayServiceType_bool_exp;
};


export type subscription_rootgatewayServiceTypeEnumArgs = {
  value: string;
};


export type subscription_rootgatewayServiceTypeEnumAggregateArgs = {
  distinct_on?: Array<qx_eGatewayServiceType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eGatewayServiceType_order_by>;
  where?: qx_eGatewayServiceType_bool_exp;
};


export type subscription_rootgatewaySyncStatusEnumArgs = {
  value: string;
};


export type subscription_rootgatewaySyncStatusEnumAggregateArgs = {
  distinct_on?: Array<qx_eGatewaySyncStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eGatewaySyncStatus_order_by>;
  where?: qx_eGatewaySyncStatus_bool_exp;
};


export type subscription_rootgatewaySyncStatusEnumsArgs = {
  distinct_on?: Array<qx_eGatewaySyncStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eGatewaySyncStatus_order_by>;
  where?: qx_eGatewaySyncStatus_bool_exp;
};


export type subscription_rootgatewaysArgs = {
  distinct_on?: Array<qx_Gateway_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Gateway_order_by>;
  where?: qx_Gateway_bool_exp;
};


export type subscription_rootgroupArgs = {
  id: string;
};


export type subscription_rootgroupAggregateArgs = {
  distinct_on?: Array<qx_Group_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Group_order_by>;
  where?: qx_Group_bool_exp;
};


export type subscription_rootgroupAuditArgs = {
  distinct_on?: Array<groupAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<groupAudit_order_by>;
  where?: groupAudit_bool_exp;
};


export type subscription_rootgroupAudit_aggregateArgs = {
  distinct_on?: Array<groupAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<groupAudit_order_by>;
  where?: groupAudit_bool_exp;
};


export type subscription_rootgroupAudit_streamArgs = {
  batch_size: number;
  cursor: Array<groupAudit_stream_cursor_input>;
  where?: groupAudit_bool_exp;
};


export type subscription_rootgroupsArgs = {
  distinct_on?: Array<qx_Group_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Group_order_by>;
  where?: qx_Group_bool_exp;
};


export type subscription_rootguestAccessArgs = {
  distinct_on?: Array<guestAccess_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<guestAccess_order_by>;
  where?: guestAccess_bool_exp;
};


export type subscription_rootguestAccess_aggregateArgs = {
  distinct_on?: Array<guestAccess_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<guestAccess_order_by>;
  where?: guestAccess_bool_exp;
};


export type subscription_rootguestAccess_by_pkArgs = {
  personID: string;
};


export type subscription_rootguestAccess_streamArgs = {
  batch_size: number;
  cursor: Array<guestAccess_stream_cursor_input>;
  where?: guestAccess_bool_exp;
};


export type subscription_rootholidaySetArgs = {
  id: string;
};


export type subscription_rootholidaySetAggregateArgs = {
  distinct_on?: Array<qx_HolidaySet_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_HolidaySet_order_by>;
  where?: qx_HolidaySet_bool_exp;
};


export type subscription_rootholidaySetAuditArgs = {
  distinct_on?: Array<holidaySetAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<holidaySetAudit_order_by>;
  where?: holidaySetAudit_bool_exp;
};


export type subscription_rootholidaySetAudit_aggregateArgs = {
  distinct_on?: Array<holidaySetAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<holidaySetAudit_order_by>;
  where?: holidaySetAudit_bool_exp;
};


export type subscription_rootholidaySetAudit_streamArgs = {
  batch_size: number;
  cursor: Array<holidaySetAudit_stream_cursor_input>;
  where?: holidaySetAudit_bool_exp;
};


export type subscription_rootholidaySetToScheduleBlockArgs = {
  holidaySetID: string;
  scheduleBlockID: string;
};


export type subscription_rootholidaySetToScheduleBlockAggregateArgs = {
  distinct_on?: Array<qx__HolidaySetToScheduleBlock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__HolidaySetToScheduleBlock_order_by>;
  where?: qx__HolidaySetToScheduleBlock_bool_exp;
};


export type subscription_rootholidaySetToScheduleBlockAuditArgs = {
  distinct_on?: Array<holidaySetToScheduleBlockAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<holidaySetToScheduleBlockAudit_order_by>;
  where?: holidaySetToScheduleBlockAudit_bool_exp;
};


export type subscription_rootholidaySetToScheduleBlockAudit_aggregateArgs = {
  distinct_on?: Array<holidaySetToScheduleBlockAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<holidaySetToScheduleBlockAudit_order_by>;
  where?: holidaySetToScheduleBlockAudit_bool_exp;
};


export type subscription_rootholidaySetToScheduleBlockAudit_streamArgs = {
  batch_size: number;
  cursor: Array<holidaySetToScheduleBlockAudit_stream_cursor_input>;
  where?: holidaySetToScheduleBlockAudit_bool_exp;
};


export type subscription_rootholidaySetToScheduleBlocksArgs = {
  distinct_on?: Array<qx__HolidaySetToScheduleBlock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__HolidaySetToScheduleBlock_order_by>;
  where?: qx__HolidaySetToScheduleBlock_bool_exp;
};


export type subscription_rootholidaySetsArgs = {
  distinct_on?: Array<qx_HolidaySet_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_HolidaySet_order_by>;
  where?: qx_HolidaySet_bool_exp;
};


export type subscription_rootinputPointArgs = {
  id: string;
};


export type subscription_rootinputPointAggregateArgs = {
  distinct_on?: Array<qx_InputPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_InputPoint_order_by>;
  where?: qx_InputPoint_bool_exp;
};


export type subscription_rootinputPointAuditArgs = {
  distinct_on?: Array<inputPointAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<inputPointAudit_order_by>;
  where?: inputPointAudit_bool_exp;
};


export type subscription_rootinputPointAudit_aggregateArgs = {
  distinct_on?: Array<inputPointAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<inputPointAudit_order_by>;
  where?: inputPointAudit_bool_exp;
};


export type subscription_rootinputPointAudit_streamArgs = {
  batch_size: number;
  cursor: Array<inputPointAudit_stream_cursor_input>;
  where?: inputPointAudit_bool_exp;
};


export type subscription_rootinputPointsArgs = {
  distinct_on?: Array<qx_InputPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_InputPoint_order_by>;
  where?: qx_InputPoint_bool_exp;
};


export type subscription_rootkeyModeEnumArgs = {
  value: string;
};


export type subscription_rootkeyModeEnumAggregateArgs = {
  distinct_on?: Array<qx_eKeypadMode_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eKeypadMode_order_by>;
  where?: qx_eKeypadMode_bool_exp;
};


export type subscription_rootkeyModeEnumsArgs = {
  distinct_on?: Array<qx_eKeypadMode_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eKeypadMode_order_by>;
  where?: qx_eKeypadMode_bool_exp;
};


export type subscription_rootlayoutArgs = {
  id: string;
};


export type subscription_rootlayoutsArgs = {
  distinct_on?: Array<qx_Layout_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Layout_order_by>;
  where?: qx_Layout_bool_exp;
};


export type subscription_rootlayoutsAggregateArgs = {
  distinct_on?: Array<qx_Layout_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Layout_order_by>;
  where?: qx_Layout_bool_exp;
};


export type subscription_rootlensProfileArgs = {
  id: string;
};


export type subscription_rootlensProfileAggregateArgs = {
  distinct_on?: Array<qx_LensProfile_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_LensProfile_order_by>;
  where?: qx_LensProfile_bool_exp;
};


export type subscription_rootlensProfilesArgs = {
  distinct_on?: Array<qx_LensProfile_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_LensProfile_order_by>;
  where?: qx_LensProfile_bool_exp;
};


export type subscription_rootlinkableTypesArgs = {
  distinct_on?: Array<qx_SharedLinkType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_SharedLinkType_order_by>;
  where?: qx_SharedLinkType_bool_exp;
};


export type subscription_rootlockArgs = {
  id: string;
};


export type subscription_rootlockAggregateArgs = {
  distinct_on?: Array<qx_Lock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Lock_order_by>;
  where?: qx_Lock_bool_exp;
};


export type subscription_rootlockAuditArgs = {
  distinct_on?: Array<lockAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<lockAudit_order_by>;
  where?: lockAudit_bool_exp;
};


export type subscription_rootlockAudit_aggregateArgs = {
  distinct_on?: Array<lockAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<lockAudit_order_by>;
  where?: lockAudit_bool_exp;
};


export type subscription_rootlockAudit_streamArgs = {
  batch_size: number;
  cursor: Array<lockAudit_stream_cursor_input>;
  where?: lockAudit_bool_exp;
};


export type subscription_rootlockPowerMonitorEnumArgs = {
  value: string;
};


export type subscription_rootlockPowerMonitorEnumAggregateArgs = {
  distinct_on?: Array<qx_eLockPowerMonitor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eLockPowerMonitor_order_by>;
  where?: qx_eLockPowerMonitor_bool_exp;
};


export type subscription_rootlockPowerMonitorEnumsArgs = {
  distinct_on?: Array<qx_eLockPowerMonitor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eLockPowerMonitor_order_by>;
  where?: qx_eLockPowerMonitor_bool_exp;
};


export type subscription_rootlockRelayMonitorEnumArgs = {
  value: string;
};


export type subscription_rootlockRelayMonitorEnumAggregateArgs = {
  distinct_on?: Array<qx_eLockRelayMonitor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eLockRelayMonitor_order_by>;
  where?: qx_eLockRelayMonitor_bool_exp;
};


export type subscription_rootlockRelayMonitorEnumsArgs = {
  distinct_on?: Array<qx_eLockRelayMonitor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eLockRelayMonitor_order_by>;
  where?: qx_eLockRelayMonitor_bool_exp;
};


export type subscription_rootlockTypeEnumArgs = {
  value: string;
};


export type subscription_rootlockTypeEnumAggregateArgs = {
  distinct_on?: Array<qx_eLockType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eLockType_order_by>;
  where?: qx_eLockType_bool_exp;
};


export type subscription_rootlockTypeEnumsArgs = {
  distinct_on?: Array<qx_eLockType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eLockType_order_by>;
  where?: qx_eLockType_bool_exp;
};


export type subscription_rootlocksArgs = {
  distinct_on?: Array<qx_Lock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Lock_order_by>;
  where?: qx_Lock_bool_exp;
};


export type subscription_rootmediaProfileArgs = {
  id: string;
};


export type subscription_rootmediaProfileAggregateArgs = {
  distinct_on?: Array<qx_MediaProfile_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MediaProfile_order_by>;
  where?: qx_MediaProfile_bool_exp;
};


export type subscription_rootmediaProfileAuditArgs = {
  distinct_on?: Array<mediaProfileAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<mediaProfileAudit_order_by>;
  where?: mediaProfileAudit_bool_exp;
};


export type subscription_rootmediaProfileAudit_aggregateArgs = {
  distinct_on?: Array<mediaProfileAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<mediaProfileAudit_order_by>;
  where?: mediaProfileAudit_bool_exp;
};


export type subscription_rootmediaProfileAudit_streamArgs = {
  batch_size: number;
  cursor: Array<mediaProfileAudit_stream_cursor_input>;
  where?: mediaProfileAudit_bool_exp;
};


export type subscription_rootmediaProfilesArgs = {
  distinct_on?: Array<qx_MediaProfile_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MediaProfile_order_by>;
  where?: qx_MediaProfile_bool_exp;
};


export type subscription_rootmercuryControlPointArgs = {
  id: string;
};


export type subscription_rootmercuryControlPointAggregateArgs = {
  distinct_on?: Array<qx_MercuryControlPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MercuryControlPoint_order_by>;
  where?: qx_MercuryControlPoint_bool_exp;
};


export type subscription_rootmercuryControlPointsArgs = {
  distinct_on?: Array<qx_MercuryControlPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MercuryControlPoint_order_by>;
  where?: qx_MercuryControlPoint_bool_exp;
};


export type subscription_rootmercuryMonitorPointArgs = {
  id: string;
};


export type subscription_rootmercuryMonitorPointAggregateArgs = {
  distinct_on?: Array<qx_MercuryMonitorPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MercuryMonitorPoint_order_by>;
  where?: qx_MercuryMonitorPoint_bool_exp;
};


export type subscription_rootmercuryMonitorPointsArgs = {
  distinct_on?: Array<qx_MercuryMonitorPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MercuryMonitorPoint_order_by>;
  where?: qx_MercuryMonitorPoint_bool_exp;
};


export type subscription_rootmonitorLockStateEnumArgs = {
  value: string;
};


export type subscription_rootmonitorLockStateEnumAggregateArgs = {
  distinct_on?: Array<qx_eMonitorLockState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eMonitorLockState_order_by>;
  where?: qx_eMonitorLockState_bool_exp;
};


export type subscription_rootmonitorLockStateEnumsArgs = {
  distinct_on?: Array<qx_eMonitorLockState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eMonitorLockState_order_by>;
  where?: qx_eMonitorLockState_bool_exp;
};


export type subscription_rootmountPositionEnumArgs = {
  value: string;
};


export type subscription_rootmountPositionEnumAggregateArgs = {
  distinct_on?: Array<qx_eMountPosition_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eMountPosition_order_by>;
  where?: qx_eMountPosition_bool_exp;
};


export type subscription_rootmountPositionEnumsArgs = {
  distinct_on?: Array<qx_eMountPosition_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eMountPosition_order_by>;
  where?: qx_eMountPosition_bool_exp;
};


export type subscription_rootnotificationTypeEnumArgs = {
  value: string;
};


export type subscription_rootnotificationTypeEnumAggregateArgs = {
  distinct_on?: Array<qx_eFlowNotificationType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eFlowNotificationType_order_by>;
  where?: qx_eFlowNotificationType_bool_exp;
};


export type subscription_rootnotificationTypeEnumsArgs = {
  distinct_on?: Array<qx_eFlowNotificationType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eFlowNotificationType_order_by>;
  where?: qx_eFlowNotificationType_bool_exp;
};


export type subscription_rootobjectActionEnumArgs = {
  value: string;
};


export type subscription_rootobjectActionEnumAggregateArgs = {
  distinct_on?: Array<qx_eObjectAction_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eObjectAction_order_by>;
  where?: qx_eObjectAction_bool_exp;
};


export type subscription_rootobjectActionEnumsArgs = {
  distinct_on?: Array<qx_eObjectAction_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eObjectAction_order_by>;
  where?: qx_eObjectAction_bool_exp;
};


export type subscription_rootossIdAssignmentArgs = {
  id: string;
};


export type subscription_rootossIdAssignmentAggregateArgs = {
  distinct_on?: Array<qx_OssIdAssignment_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_OssIdAssignment_order_by>;
  where?: qx_OssIdAssignment_bool_exp;
};


export type subscription_rootossIdAssignmentsArgs = {
  distinct_on?: Array<qx_OssIdAssignment_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_OssIdAssignment_order_by>;
  where?: qx_OssIdAssignment_bool_exp;
};


export type subscription_rootoutputPointArgs = {
  id: string;
};


export type subscription_rootoutputPointAggregateArgs = {
  distinct_on?: Array<qx_OutputPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_OutputPoint_order_by>;
  where?: qx_OutputPoint_bool_exp;
};


export type subscription_rootoutputPointAuditArgs = {
  distinct_on?: Array<outputPointAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<outputPointAudit_order_by>;
  where?: outputPointAudit_bool_exp;
};


export type subscription_rootoutputPointAudit_aggregateArgs = {
  distinct_on?: Array<outputPointAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<outputPointAudit_order_by>;
  where?: outputPointAudit_bool_exp;
};


export type subscription_rootoutputPointAudit_streamArgs = {
  batch_size: number;
  cursor: Array<outputPointAudit_stream_cursor_input>;
  where?: outputPointAudit_bool_exp;
};


export type subscription_rootoutputPointsArgs = {
  distinct_on?: Array<qx_OutputPoint_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_OutputPoint_order_by>;
  where?: qx_OutputPoint_bool_exp;
};


export type subscription_rootpacsStatusEnumArgs = {
  value: string;
};


export type subscription_rootpacsStatusEnumAggregateArgs = {
  distinct_on?: Array<qx_ePACSStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ePACSStatus_order_by>;
  where?: qx_ePACSStatus_bool_exp;
};


export type subscription_rootpacsStatusEnumsArgs = {
  distinct_on?: Array<qx_ePACSStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ePACSStatus_order_by>;
  where?: qx_ePACSStatus_bool_exp;
};


export type subscription_rootpeopleArgs = {
  distinct_on?: Array<qx_Person_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Person_order_by>;
  where?: qx_Person_bool_exp;
};


export type subscription_rootpermissionArgs = {
  id: string;
};


export type subscription_rootpermissionAggregateArgs = {
  distinct_on?: Array<qx_Permission_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Permission_order_by>;
  where?: qx_Permission_bool_exp;
};


export type subscription_rootpermissionAuditArgs = {
  distinct_on?: Array<permissionAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<permissionAudit_order_by>;
  where?: permissionAudit_bool_exp;
};


export type subscription_rootpermissionAudit_aggregateArgs = {
  distinct_on?: Array<permissionAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<permissionAudit_order_by>;
  where?: permissionAudit_bool_exp;
};


export type subscription_rootpermissionAudit_streamArgs = {
  batch_size: number;
  cursor: Array<permissionAudit_stream_cursor_input>;
  where?: permissionAudit_bool_exp;
};


export type subscription_rootpermissionsArgs = {
  distinct_on?: Array<qx_Permission_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Permission_order_by>;
  where?: qx_Permission_bool_exp;
};


export type subscription_rootpersonArgs = {
  id: string;
};


export type subscription_rootpersonAggregateArgs = {
  distinct_on?: Array<qx_Person_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Person_order_by>;
  where?: qx_Person_bool_exp;
};


export type subscription_rootpersonAudioSourceAppPrivilegesArgs = {
  distinct_on?: Array<personAudioSourceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personAudioSourceAppPrivileges_order_by>;
  where?: personAudioSourceAppPrivileges_bool_exp;
};


export type subscription_rootpersonAudioSourceAppPrivileges_aggregateArgs = {
  distinct_on?: Array<personAudioSourceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personAudioSourceAppPrivileges_order_by>;
  where?: personAudioSourceAppPrivileges_bool_exp;
};


export type subscription_rootpersonAudioSourceAppPrivileges_streamArgs = {
  batch_size: number;
  cursor: Array<personAudioSourceAppPrivileges_stream_cursor_input>;
  where?: personAudioSourceAppPrivileges_bool_exp;
};


export type subscription_rootpersonAuditArgs = {
  distinct_on?: Array<personAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personAudit_order_by>;
  where?: personAudit_bool_exp;
};


export type subscription_rootpersonAudit_aggregateArgs = {
  distinct_on?: Array<personAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personAudit_order_by>;
  where?: personAudit_bool_exp;
};


export type subscription_rootpersonAudit_streamArgs = {
  batch_size: number;
  cursor: Array<personAudit_stream_cursor_input>;
  where?: personAudit_bool_exp;
};


export type subscription_rootpersonDeviceAppPrivilegesArgs = {
  distinct_on?: Array<personDeviceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personDeviceAppPrivileges_order_by>;
  where?: personDeviceAppPrivileges_bool_exp;
};


export type subscription_rootpersonDeviceAppPrivileges_aggregateArgs = {
  distinct_on?: Array<personDeviceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personDeviceAppPrivileges_order_by>;
  where?: personDeviceAppPrivileges_bool_exp;
};


export type subscription_rootpersonDeviceAppPrivileges_by_pkArgs = {
  deviceID: string;
  personID: string;
};


export type subscription_rootpersonDeviceAppPrivileges_streamArgs = {
  batch_size: number;
  cursor: Array<personDeviceAppPrivileges_stream_cursor_input>;
  where?: personDeviceAppPrivileges_bool_exp;
};


export type subscription_rootpersonDoorAppPrivilegesArgs = {
  distinct_on?: Array<personDoorAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personDoorAppPrivileges_order_by>;
  where?: personDoorAppPrivileges_bool_exp;
};


export type subscription_rootpersonDoorAppPrivileges_aggregateArgs = {
  distinct_on?: Array<personDoorAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personDoorAppPrivileges_order_by>;
  where?: personDoorAppPrivileges_bool_exp;
};


export type subscription_rootpersonDoorAppPrivileges_by_pkArgs = {
  doorID: string;
  personID: string;
};


export type subscription_rootpersonDoorAppPrivileges_streamArgs = {
  batch_size: number;
  cursor: Array<personDoorAppPrivileges_stream_cursor_input>;
  where?: personDoorAppPrivileges_bool_exp;
};


export type subscription_rootpersonGroupArgs = {
  groupID: string;
  personID: string;
};


export type subscription_rootpersonGroupAggregateArgs = {
  distinct_on?: Array<qx__PersonToGroup_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__PersonToGroup_order_by>;
  where?: qx__PersonToGroup_bool_exp;
};


export type subscription_rootpersonGroupsArgs = {
  distinct_on?: Array<qx__PersonToGroup_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__PersonToGroup_order_by>;
  where?: qx__PersonToGroup_bool_exp;
};


export type subscription_rootpersonIntrusionPartitionAppPrivilegesArgs = {
  distinct_on?: Array<personIntrusionPartitionAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personIntrusionPartitionAppPrivileges_order_by>;
  where?: personIntrusionPartitionAppPrivileges_bool_exp;
};


export type subscription_rootpersonIntrusionPartitionAppPrivileges_aggregateArgs = {
  distinct_on?: Array<personIntrusionPartitionAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personIntrusionPartitionAppPrivileges_order_by>;
  where?: personIntrusionPartitionAppPrivileges_bool_exp;
};


export type subscription_rootpersonIntrusionPartitionAppPrivileges_by_pkArgs = {
  partitionID: string;
  personID: string;
};


export type subscription_rootpersonIntrusionPartitionAppPrivileges_streamArgs = {
  batch_size: number;
  cursor: Array<personIntrusionPartitionAppPrivileges_stream_cursor_input>;
  where?: personIntrusionPartitionAppPrivileges_bool_exp;
};


export type subscription_rootpersonPlaceAppPrivilegesArgs = {
  distinct_on?: Array<personPlaceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personPlaceAppPrivileges_order_by>;
  where?: personPlaceAppPrivileges_bool_exp;
};


export type subscription_rootpersonPlaceAppPrivileges_aggregateArgs = {
  distinct_on?: Array<personPlaceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personPlaceAppPrivileges_order_by>;
  where?: personPlaceAppPrivileges_bool_exp;
};


export type subscription_rootpersonPlaceAppPrivileges_by_pkArgs = {
  personID: string;
  placeID: string;
};


export type subscription_rootpersonPlaceAppPrivileges_streamArgs = {
  batch_size: number;
  cursor: Array<personPlaceAppPrivileges_stream_cursor_input>;
  where?: personPlaceAppPrivileges_bool_exp;
};


export type subscription_rootpersonStatusEnumArgs = {
  value: string;
};


export type subscription_rootpersonStatusEnumAggregateArgs = {
  distinct_on?: Array<qx_ePersonStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ePersonStatus_order_by>;
  where?: qx_ePersonStatus_bool_exp;
};


export type subscription_rootpersonStatusEnumsArgs = {
  distinct_on?: Array<qx_ePersonStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ePersonStatus_order_by>;
  where?: qx_ePersonStatus_bool_exp;
};


export type subscription_rootpersonToGroupAuditArgs = {
  distinct_on?: Array<personToGroupAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personToGroupAudit_order_by>;
  where?: personToGroupAudit_bool_exp;
};


export type subscription_rootpersonToGroupAudit_aggregateArgs = {
  distinct_on?: Array<personToGroupAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personToGroupAudit_order_by>;
  where?: personToGroupAudit_bool_exp;
};


export type subscription_rootpersonToGroupAudit_streamArgs = {
  batch_size: number;
  cursor: Array<personToGroupAudit_stream_cursor_input>;
  where?: personToGroupAudit_bool_exp;
};


export type subscription_rootpersonVideoSourceAppPrivilegesArgs = {
  distinct_on?: Array<personVideoSourceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personVideoSourceAppPrivileges_order_by>;
  where?: personVideoSourceAppPrivileges_bool_exp;
};


export type subscription_rootpersonVideoSourceAppPrivileges_aggregateArgs = {
  distinct_on?: Array<personVideoSourceAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<personVideoSourceAppPrivileges_order_by>;
  where?: personVideoSourceAppPrivileges_bool_exp;
};


export type subscription_rootpersonVideoSourceAppPrivileges_by_pkArgs = {
  personID: string;
  videoSourceID: string;
};


export type subscription_rootpersonVideoSourceAppPrivileges_streamArgs = {
  batch_size: number;
  cursor: Array<personVideoSourceAppPrivileges_stream_cursor_input>;
  where?: personVideoSourceAppPrivileges_bool_exp;
};


export type subscription_rootplaceArgs = {
  id: string;
};


export type subscription_rootplaceAggregateArgs = {
  distinct_on?: Array<qx_Place_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Place_order_by>;
  where?: qx_Place_bool_exp;
};


export type subscription_rootplaceAuditArgs = {
  distinct_on?: Array<placeAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<placeAudit_order_by>;
  where?: placeAudit_bool_exp;
};


export type subscription_rootplaceAudit_aggregateArgs = {
  distinct_on?: Array<placeAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<placeAudit_order_by>;
  where?: placeAudit_bool_exp;
};


export type subscription_rootplaceAudit_streamArgs = {
  batch_size: number;
  cursor: Array<placeAudit_stream_cursor_input>;
  where?: placeAudit_bool_exp;
};


export type subscription_rootplaceTypeEnumArgs = {
  value: string;
};


export type subscription_rootplaceTypeEnumAggregateArgs = {
  distinct_on?: Array<qx_ePlaceType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ePlaceType_order_by>;
  where?: qx_ePlaceType_bool_exp;
};


export type subscription_rootplaceTypeEnumsArgs = {
  distinct_on?: Array<qx_ePlaceType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ePlaceType_order_by>;
  where?: qx_ePlaceType_bool_exp;
};


export type subscription_rootplaceWhiteListsArgs = {
  distinct_on?: Array<placeWhiteLists_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<placeWhiteLists_order_by>;
  where?: placeWhiteLists_bool_exp;
};


export type subscription_rootplaceWhiteLists_aggregateArgs = {
  distinct_on?: Array<placeWhiteLists_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<placeWhiteLists_order_by>;
  where?: placeWhiteLists_bool_exp;
};


export type subscription_rootplaceWhiteLists_by_pkArgs = {
  id: string;
};


export type subscription_rootplaceWhiteLists_streamArgs = {
  batch_size: number;
  cursor: Array<placeWhiteLists_stream_cursor_input>;
  where?: placeWhiteLists_bool_exp;
};


export type subscription_rootplacesArgs = {
  distinct_on?: Array<qx_Place_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Place_order_by>;
  where?: qx_Place_bool_exp;
};


export type subscription_rootprivilegeEnumArgs = {
  value: string;
};


export type subscription_rootprivilegeEnumAggregateArgs = {
  distinct_on?: Array<qx_ePrivilege_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ePrivilege_order_by>;
  where?: qx_ePrivilege_bool_exp;
};


export type subscription_rootprivilegeEnumToRoleArgs = {
  privilege: qx_ePrivilege_enum;
  roleID: string;
};


export type subscription_rootprivilegeEnumToRoleAggregateArgs = {
  distinct_on?: Array<qx__PrivilegeEnumToRole_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__PrivilegeEnumToRole_order_by>;
  where?: qx__PrivilegeEnumToRole_bool_exp;
};


export type subscription_rootprivilegeEnumToRoleAuditArgs = {
  distinct_on?: Array<privilegeEnumToRoleAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<privilegeEnumToRoleAudit_order_by>;
  where?: privilegeEnumToRoleAudit_bool_exp;
};


export type subscription_rootprivilegeEnumToRoleAudit_aggregateArgs = {
  distinct_on?: Array<privilegeEnumToRoleAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<privilegeEnumToRoleAudit_order_by>;
  where?: privilegeEnumToRoleAudit_bool_exp;
};


export type subscription_rootprivilegeEnumToRoleAudit_streamArgs = {
  batch_size: number;
  cursor: Array<privilegeEnumToRoleAudit_stream_cursor_input>;
  where?: privilegeEnumToRoleAudit_bool_exp;
};


export type subscription_rootprivilegeEnumToRolesArgs = {
  distinct_on?: Array<qx__PrivilegeEnumToRole_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__PrivilegeEnumToRole_order_by>;
  where?: qx__PrivilegeEnumToRole_bool_exp;
};


export type subscription_rootprivilegeEnumsArgs = {
  distinct_on?: Array<qx_ePrivilege_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ePrivilege_order_by>;
  where?: qx_ePrivilege_bool_exp;
};


export type subscription_rootqx_AccessCatalogCapabilitiesArgs = {
  distinct_on?: Array<qx_AccessCatalogCapabilities_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessCatalogCapabilities_order_by>;
  where?: qx_AccessCatalogCapabilities_bool_exp;
};


export type subscription_rootqx_AccessCatalogCapabilities_aggregateArgs = {
  distinct_on?: Array<qx_AccessCatalogCapabilities_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AccessCatalogCapabilities_order_by>;
  where?: qx_AccessCatalogCapabilities_bool_exp;
};


export type subscription_rootqx_AccessCatalogCapabilities_by_pkArgs = {
  catalogID: string;
};


export type subscription_rootqx_AccessCatalogCapabilities_streamArgs = {
  batch_size: number;
  cursor: Array<qx_AccessCatalogCapabilities_stream_cursor_input>;
  where?: qx_AccessCatalogCapabilities_bool_exp;
};


export type subscription_rootqx_AccessCatalog_streamArgs = {
  batch_size: number;
  cursor: Array<qx_AccessCatalog_stream_cursor_input>;
  where?: qx_AccessCatalog_bool_exp;
};


export type subscription_rootqx_AccessInventory_streamArgs = {
  batch_size: number;
  cursor: Array<qx_AccessInventory_stream_cursor_input>;
  where?: qx_AccessInventory_bool_exp;
};


export type subscription_rootqx_AudioSource_streamArgs = {
  batch_size: number;
  cursor: Array<qx_AudioSource_stream_cursor_input>;
  where?: qx_AudioSource_bool_exp;
};


export type subscription_rootqx_AuditLog_streamArgs = {
  batch_size: number;
  cursor: Array<qx_AuditLog_stream_cursor_input>;
  where?: qx_AuditLog_bool_exp;
};


export type subscription_rootqx_AuditableAction_aggregateArgs = {
  distinct_on?: Array<qx_AuditableAction_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AuditableAction_order_by>;
  where?: qx_AuditableAction_bool_exp;
};


export type subscription_rootqx_AuditableAction_by_pkArgs = {
  value: string;
};


export type subscription_rootqx_AuditableAction_streamArgs = {
  batch_size: number;
  cursor: Array<qx_AuditableAction_stream_cursor_input>;
  where?: qx_AuditableAction_bool_exp;
};


export type subscription_rootqx_AuditableType_aggregateArgs = {
  distinct_on?: Array<qx_AuditableType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_AuditableType_order_by>;
  where?: qx_AuditableType_bool_exp;
};


export type subscription_rootqx_AuditableType_by_pkArgs = {
  value: string;
};


export type subscription_rootqx_AuditableType_streamArgs = {
  batch_size: number;
  cursor: Array<qx_AuditableType_stream_cursor_input>;
  where?: qx_AuditableType_bool_exp;
};


export type subscription_rootqx_BillingPeriod_streamArgs = {
  batch_size: number;
  cursor: Array<qx_BillingPeriod_stream_cursor_input>;
  where?: qx_BillingPeriod_bool_exp;
};


export type subscription_rootqx_CatalogProtocolOverrideArgs = {
  distinct_on?: Array<qx_CatalogProtocolOverride_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_CatalogProtocolOverride_order_by>;
  where?: qx_CatalogProtocolOverride_bool_exp;
};


export type subscription_rootqx_CatalogProtocolOverride_aggregateArgs = {
  distinct_on?: Array<qx_CatalogProtocolOverride_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_CatalogProtocolOverride_order_by>;
  where?: qx_CatalogProtocolOverride_bool_exp;
};


export type subscription_rootqx_CatalogProtocolOverride_by_pkArgs = {
  id: number;
};


export type subscription_rootqx_CatalogProtocolOverride_streamArgs = {
  batch_size: number;
  cursor: Array<qx_CatalogProtocolOverride_stream_cursor_input>;
  where?: qx_CatalogProtocolOverride_bool_exp;
};


export type subscription_rootqx_ChatUsageHistory_streamArgs = {
  batch_size: number;
  cursor: Array<qx_ChatUsageHistory_stream_cursor_input>;
  where?: qx_ChatUsageHistory_bool_exp;
};


export type subscription_rootqx_ClipAuditLog_streamArgs = {
  batch_size: number;
  cursor: Array<qx_ClipAuditLog_stream_cursor_input>;
  where?: qx_ClipAuditLog_bool_exp;
};


export type subscription_rootqx_Clip_streamArgs = {
  batch_size: number;
  cursor: Array<qx_Clip_stream_cursor_input>;
  where?: qx_Clip_bool_exp;
};


export type subscription_rootqx_CloudStorageOptions_streamArgs = {
  batch_size: number;
  cursor: Array<qx_CloudStorageOptions_stream_cursor_input>;
  where?: qx_CloudStorageOptions_bool_exp;
};


export type subscription_rootqx_Credential_streamArgs = {
  batch_size: number;
  cursor: Array<qx_Credential_stream_cursor_input>;
  where?: qx_Credential_bool_exp;
};


export type subscription_rootqx_CustomerAuthProviderArgs = {
  distinct_on?: Array<qx_CustomerAuthProvider_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_CustomerAuthProvider_order_by>;
  where?: qx_CustomerAuthProvider_bool_exp;
};


export type subscription_rootqx_CustomerAuthProvider_aggregateArgs = {
  distinct_on?: Array<qx_CustomerAuthProvider_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_CustomerAuthProvider_order_by>;
  where?: qx_CustomerAuthProvider_bool_exp;
};


export type subscription_rootqx_CustomerAuthProvider_by_pkArgs = {
  id: string;
};


export type subscription_rootqx_CustomerAuthProvider_streamArgs = {
  batch_size: number;
  cursor: Array<qx_CustomerAuthProvider_stream_cursor_input>;
  where?: qx_CustomerAuthProvider_bool_exp;
};


export type subscription_rootqx_CustomerPermission_streamArgs = {
  batch_size: number;
  cursor: Array<qx_CustomerPermission_stream_cursor_input>;
  where?: qx_CustomerPermission_bool_exp;
};


export type subscription_rootqx_DeviceDIO_streamArgs = {
  batch_size: number;
  cursor: Array<qx_DeviceDIO_stream_cursor_input>;
  where?: qx_DeviceDIO_bool_exp;
};


export type subscription_rootqx_Device_streamArgs = {
  batch_size: number;
  cursor: Array<qx_Device_stream_cursor_input>;
  where?: qx_Device_bool_exp;
};


export type subscription_rootqx_DiscoveryType_aggregateArgs = {
  distinct_on?: Array<qx_DiscoveryType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_DiscoveryType_order_by>;
  where?: qx_DiscoveryType_bool_exp;
};


export type subscription_rootqx_DiscoveryType_by_pkArgs = {
  value: string;
};


export type subscription_rootqx_DiscoveryType_streamArgs = {
  batch_size: number;
  cursor: Array<qx_DiscoveryType_stream_cursor_input>;
  where?: qx_DiscoveryType_bool_exp;
};


export type subscription_rootqx_DoorConfiguration_streamArgs = {
  batch_size: number;
  cursor: Array<qx_DoorConfiguration_stream_cursor_input>;
  where?: qx_DoorConfiguration_bool_exp;
};


export type subscription_rootqx_DoorMeta_streamArgs = {
  batch_size: number;
  cursor: Array<qx_DoorMeta_stream_cursor_input>;
  where?: qx_DoorMeta_bool_exp;
};


export type subscription_rootqx_DoorTemplate_streamArgs = {
  batch_size: number;
  cursor: Array<qx_DoorTemplate_stream_cursor_input>;
  where?: qx_DoorTemplate_bool_exp;
};


export type subscription_rootqx_Door_streamArgs = {
  batch_size: number;
  cursor: Array<qx_Door_stream_cursor_input>;
  where?: qx_Door_bool_exp;
};


export type subscription_rootqx_EventType_streamArgs = {
  batch_size: number;
  cursor: Array<qx_EventType_stream_cursor_input>;
  where?: qx_EventType_bool_exp;
};


export type subscription_rootqx_Event_streamArgs = {
  batch_size: number;
  cursor: Array<qx_Event_stream_cursor_input>;
  where?: qx_Event_bool_exp;
};


export type subscription_rootqx_FlowTrace_streamArgs = {
  batch_size: number;
  cursor: Array<qx_FlowTrace_stream_cursor_input>;
  where?: qx_FlowTrace_bool_exp;
};


export type subscription_rootqx_Flow_streamArgs = {
  batch_size: number;
  cursor: Array<qx_Flow_stream_cursor_input>;
  where?: qx_Flow_bool_exp;
};


export type subscription_rootqx_GatewayBandwidthSchedule_streamArgs = {
  batch_size: number;
  cursor: Array<qx_GatewayBandwidthSchedule_stream_cursor_input>;
  where?: qx_GatewayBandwidthSchedule_bool_exp;
};


export type subscription_rootqx_Gateway_streamArgs = {
  batch_size: number;
  cursor: Array<qx_Gateway_stream_cursor_input>;
  where?: qx_Gateway_bool_exp;
};


export type subscription_rootqx_Group_streamArgs = {
  batch_size: number;
  cursor: Array<qx_Group_stream_cursor_input>;
  where?: qx_Group_bool_exp;
};


export type subscription_rootqx_HolidaySet_streamArgs = {
  batch_size: number;
  cursor: Array<qx_HolidaySet_stream_cursor_input>;
  where?: qx_HolidaySet_bool_exp;
};


export type subscription_rootqx_InputPoint_streamArgs = {
  batch_size: number;
  cursor: Array<qx_InputPoint_stream_cursor_input>;
  where?: qx_InputPoint_bool_exp;
};


export type subscription_rootqx_IntrusionAlarmArgs = {
  distinct_on?: Array<qx_IntrusionAlarm_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_IntrusionAlarm_order_by>;
  where?: qx_IntrusionAlarm_bool_exp;
};


export type subscription_rootqx_IntrusionAlarm_aggregateArgs = {
  distinct_on?: Array<qx_IntrusionAlarm_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_IntrusionAlarm_order_by>;
  where?: qx_IntrusionAlarm_bool_exp;
};


export type subscription_rootqx_IntrusionAlarm_by_pkArgs = {
  value: string;
};


export type subscription_rootqx_IntrusionAlarm_streamArgs = {
  batch_size: number;
  cursor: Array<qx_IntrusionAlarm_stream_cursor_input>;
  where?: qx_IntrusionAlarm_bool_exp;
};


export type subscription_rootqx_IntrusionPartitionStateArgs = {
  distinct_on?: Array<qx_IntrusionPartitionState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_IntrusionPartitionState_order_by>;
  where?: qx_IntrusionPartitionState_bool_exp;
};


export type subscription_rootqx_IntrusionPartitionState_aggregateArgs = {
  distinct_on?: Array<qx_IntrusionPartitionState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_IntrusionPartitionState_order_by>;
  where?: qx_IntrusionPartitionState_bool_exp;
};


export type subscription_rootqx_IntrusionPartitionState_by_pkArgs = {
  value: string;
};


export type subscription_rootqx_IntrusionPartitionState_streamArgs = {
  batch_size: number;
  cursor: Array<qx_IntrusionPartitionState_stream_cursor_input>;
  where?: qx_IntrusionPartitionState_bool_exp;
};


export type subscription_rootqx_IntrusionZoneStateArgs = {
  distinct_on?: Array<qx_IntrusionZoneState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_IntrusionZoneState_order_by>;
  where?: qx_IntrusionZoneState_bool_exp;
};


export type subscription_rootqx_IntrusionZoneState_aggregateArgs = {
  distinct_on?: Array<qx_IntrusionZoneState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_IntrusionZoneState_order_by>;
  where?: qx_IntrusionZoneState_bool_exp;
};


export type subscription_rootqx_IntrusionZoneState_by_pkArgs = {
  value: string;
};


export type subscription_rootqx_IntrusionZoneState_streamArgs = {
  batch_size: number;
  cursor: Array<qx_IntrusionZoneState_stream_cursor_input>;
  where?: qx_IntrusionZoneState_bool_exp;
};


export type subscription_rootqx_Layout_streamArgs = {
  batch_size: number;
  cursor: Array<qx_Layout_stream_cursor_input>;
  where?: qx_Layout_bool_exp;
};


export type subscription_rootqx_LensProfile_streamArgs = {
  batch_size: number;
  cursor: Array<qx_LensProfile_stream_cursor_input>;
  where?: qx_LensProfile_bool_exp;
};


export type subscription_rootqx_Lock_streamArgs = {
  batch_size: number;
  cursor: Array<qx_Lock_stream_cursor_input>;
  where?: qx_Lock_bool_exp;
};


export type subscription_rootqx_MediaProfileRecordingArgs = {
  distinct_on?: Array<qx_MediaProfileRecording_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MediaProfileRecording_order_by>;
  where?: qx_MediaProfileRecording_bool_exp;
};


export type subscription_rootqx_MediaProfileRecording_aggregateArgs = {
  distinct_on?: Array<qx_MediaProfileRecording_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_MediaProfileRecording_order_by>;
  where?: qx_MediaProfileRecording_bool_exp;
};


export type subscription_rootqx_MediaProfileRecording_by_pkArgs = {
  id: string;
};


export type subscription_rootqx_MediaProfileRecording_streamArgs = {
  batch_size: number;
  cursor: Array<qx_MediaProfileRecording_stream_cursor_input>;
  where?: qx_MediaProfileRecording_bool_exp;
};


export type subscription_rootqx_MediaProfile_streamArgs = {
  batch_size: number;
  cursor: Array<qx_MediaProfile_stream_cursor_input>;
  where?: qx_MediaProfile_bool_exp;
};


export type subscription_rootqx_MercuryControlPoint_streamArgs = {
  batch_size: number;
  cursor: Array<qx_MercuryControlPoint_stream_cursor_input>;
  where?: qx_MercuryControlPoint_bool_exp;
};


export type subscription_rootqx_MercuryMonitorPoint_streamArgs = {
  batch_size: number;
  cursor: Array<qx_MercuryMonitorPoint_stream_cursor_input>;
  where?: qx_MercuryMonitorPoint_bool_exp;
};


export type subscription_rootqx_OssIdAssignment_streamArgs = {
  batch_size: number;
  cursor: Array<qx_OssIdAssignment_stream_cursor_input>;
  where?: qx_OssIdAssignment_bool_exp;
};


export type subscription_rootqx_OssKeyArgs = {
  distinct_on?: Array<qx_OssKey_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_OssKey_order_by>;
  where?: qx_OssKey_bool_exp;
};


export type subscription_rootqx_OssKey_aggregateArgs = {
  distinct_on?: Array<qx_OssKey_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_OssKey_order_by>;
  where?: qx_OssKey_bool_exp;
};


export type subscription_rootqx_OssKey_by_pkArgs = {
  customerPlaceID: string;
};


export type subscription_rootqx_OssKey_streamArgs = {
  batch_size: number;
  cursor: Array<qx_OssKey_stream_cursor_input>;
  where?: qx_OssKey_bool_exp;
};


export type subscription_rootqx_OutputPoint_streamArgs = {
  batch_size: number;
  cursor: Array<qx_OutputPoint_stream_cursor_input>;
  where?: qx_OutputPoint_bool_exp;
};


export type subscription_rootqx_Permission_streamArgs = {
  batch_size: number;
  cursor: Array<qx_Permission_stream_cursor_input>;
  where?: qx_Permission_bool_exp;
};


export type subscription_rootqx_Person_streamArgs = {
  batch_size: number;
  cursor: Array<qx_Person_stream_cursor_input>;
  where?: qx_Person_bool_exp;
};


export type subscription_rootqx_Place_streamArgs = {
  batch_size: number;
  cursor: Array<qx_Place_stream_cursor_input>;
  where?: qx_Place_bool_exp;
};


export type subscription_rootqx_Reader_streamArgs = {
  batch_size: number;
  cursor: Array<qx_Reader_stream_cursor_input>;
  where?: qx_Reader_bool_exp;
};


export type subscription_rootqx_Role_streamArgs = {
  batch_size: number;
  cursor: Array<qx_Role_stream_cursor_input>;
  where?: qx_Role_bool_exp;
};


export type subscription_rootqx_RosslareConnection_streamArgs = {
  batch_size: number;
  cursor: Array<qx_RosslareConnection_stream_cursor_input>;
  where?: qx_RosslareConnection_bool_exp;
};


export type subscription_rootqx_ScheduleBlock_streamArgs = {
  batch_size: number;
  cursor: Array<qx_ScheduleBlock_stream_cursor_input>;
  where?: qx_ScheduleBlock_bool_exp;
};


export type subscription_rootqx_Schedule_streamArgs = {
  batch_size: number;
  cursor: Array<qx_Schedule_stream_cursor_input>;
  where?: qx_Schedule_bool_exp;
};


export type subscription_rootqx_Segment_streamArgs = {
  batch_size: number;
  cursor: Array<qx_Segment_stream_cursor_input>;
  where?: qx_Segment_bool_exp;
};


export type subscription_rootqx_Sensor_streamArgs = {
  batch_size: number;
  cursor: Array<qx_Sensor_stream_cursor_input>;
  where?: qx_Sensor_bool_exp;
};


export type subscription_rootqx_SharedLinkAuditLog_streamArgs = {
  batch_size: number;
  cursor: Array<qx_SharedLinkAuditLog_stream_cursor_input>;
  where?: qx_SharedLinkAuditLog_bool_exp;
};


export type subscription_rootqx_SharedLinkType_aggregateArgs = {
  distinct_on?: Array<qx_SharedLinkType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_SharedLinkType_order_by>;
  where?: qx_SharedLinkType_bool_exp;
};


export type subscription_rootqx_SharedLinkType_by_pkArgs = {
  value: string;
};


export type subscription_rootqx_SharedLinkType_streamArgs = {
  batch_size: number;
  cursor: Array<qx_SharedLinkType_stream_cursor_input>;
  where?: qx_SharedLinkType_bool_exp;
};


export type subscription_rootqx_SharedLinks_streamArgs = {
  batch_size: number;
  cursor: Array<qx_SharedLinks_stream_cursor_input>;
  where?: qx_SharedLinks_bool_exp;
};


export type subscription_rootqx_Snapshot_streamArgs = {
  batch_size: number;
  cursor: Array<qx_Snapshot_stream_cursor_input>;
  where?: qx_Snapshot_bool_exp;
};


export type subscription_rootqx_TermsAgreement_streamArgs = {
  batch_size: number;
  cursor: Array<qx_TermsAgreement_stream_cursor_input>;
  where?: qx_TermsAgreement_bool_exp;
};


export type subscription_rootqx_TimeZone_streamArgs = {
  batch_size: number;
  cursor: Array<qx_TimeZone_stream_cursor_input>;
  where?: qx_TimeZone_bool_exp;
};


export type subscription_rootqx_UserSetting_streamArgs = {
  batch_size: number;
  cursor: Array<qx_UserSetting_stream_cursor_input>;
  where?: qx_UserSetting_bool_exp;
};


export type subscription_rootqx_VideoSourceStorageAuditArgs = {
  distinct_on?: Array<qx_VideoSourceStorageAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_VideoSourceStorageAudit_order_by>;
  where?: qx_VideoSourceStorageAudit_bool_exp;
};


export type subscription_rootqx_VideoSourceStorageAudit_aggregateArgs = {
  distinct_on?: Array<qx_VideoSourceStorageAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_VideoSourceStorageAudit_order_by>;
  where?: qx_VideoSourceStorageAudit_bool_exp;
};


export type subscription_rootqx_VideoSourceStorageAudit_by_pkArgs = {
  id: string;
};


export type subscription_rootqx_VideoSourceStorageAudit_streamArgs = {
  batch_size: number;
  cursor: Array<qx_VideoSourceStorageAudit_stream_cursor_input>;
  where?: qx_VideoSourceStorageAudit_bool_exp;
};


export type subscription_rootqx_VideoSource_streamArgs = {
  batch_size: number;
  cursor: Array<qx_VideoSource_stream_cursor_input>;
  where?: qx_VideoSource_bool_exp;
};


export type subscription_rootqx_View_streamArgs = {
  batch_size: number;
  cursor: Array<qx_View_stream_cursor_input>;
  where?: qx_View_bool_exp;
};


export type subscription_rootqx_WiegandCardFormat_streamArgs = {
  batch_size: number;
  cursor: Array<qx_WiegandCardFormat_stream_cursor_input>;
  where?: qx_WiegandCardFormat_bool_exp;
};


export type subscription_rootqx__HolidaySetToScheduleBlock_streamArgs = {
  batch_size: number;
  cursor: Array<qx__HolidaySetToScheduleBlock_stream_cursor_input>;
  where?: qx__HolidaySetToScheduleBlock_bool_exp;
};


export type subscription_rootqx__PersonToGroup_streamArgs = {
  batch_size: number;
  cursor: Array<qx__PersonToGroup_stream_cursor_input>;
  where?: qx__PersonToGroup_bool_exp;
};


export type subscription_rootqx__PlaceToHomePlacesArgs = {
  distinct_on?: Array<qx__PlaceToHomePlaces_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__PlaceToHomePlaces_order_by>;
  where?: qx__PlaceToHomePlaces_bool_exp;
};


export type subscription_rootqx__PlaceToHomePlaces_aggregateArgs = {
  distinct_on?: Array<qx__PlaceToHomePlaces_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx__PlaceToHomePlaces_order_by>;
  where?: qx__PlaceToHomePlaces_bool_exp;
};


export type subscription_rootqx__PlaceToHomePlaces_streamArgs = {
  batch_size: number;
  cursor: Array<qx__PlaceToHomePlaces_stream_cursor_input>;
  where?: qx__PlaceToHomePlaces_bool_exp;
};


export type subscription_rootqx__PrivilegeEnumToRole_streamArgs = {
  batch_size: number;
  cursor: Array<qx__PrivilegeEnumToRole_stream_cursor_input>;
  where?: qx__PrivilegeEnumToRole_bool_exp;
};


export type subscription_rootqx_chat_usage_per_model_aggregateArgs = {
  args?: qx_chat_usage_per_model_args;
  distinct_on?: Array<qx_vChatUsagePerModel_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatUsagePerModel_order_by>;
  where?: qx_vChatUsagePerModel_bool_exp;
};


export type subscription_rootqx_chat_usage_series_aggregateArgs = {
  args: qx_chat_usage_series_args;
  distinct_on?: Array<qx_vChatUsageSeries_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatUsageSeries_order_by>;
  where?: qx_vChatUsageSeries_bool_exp;
};


export type subscription_rootqx_device_oldest_mediaArgs = {
  args: qx_device_oldest_media_args;
  distinct_on?: Array<qx_vOldestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vOldestMedia_order_by>;
  where?: qx_vOldestMedia_bool_exp;
};


export type subscription_rootqx_device_oldest_media_aggregateArgs = {
  args: qx_device_oldest_media_args;
  distinct_on?: Array<qx_vOldestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vOldestMedia_order_by>;
  where?: qx_vOldestMedia_bool_exp;
};


export type subscription_rootqx_eAccessBoardType_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eAccessBoardType_stream_cursor_input>;
  where?: qx_eAccessBoardType_bool_exp;
};


export type subscription_rootqx_eAccessDeniedReason_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eAccessDeniedReason_stream_cursor_input>;
  where?: qx_eAccessDeniedReason_bool_exp;
};


export type subscription_rootqx_eAccessInterfaceType_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eAccessInterfaceType_stream_cursor_input>;
  where?: qx_eAccessInterfaceType_bool_exp;
};


export type subscription_rootqx_eAccessMakeArgs = {
  distinct_on?: Array<qx_eAccessMake_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessMake_order_by>;
  where?: qx_eAccessMake_bool_exp;
};


export type subscription_rootqx_eAccessMake_aggregateArgs = {
  distinct_on?: Array<qx_eAccessMake_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAccessMake_order_by>;
  where?: qx_eAccessMake_bool_exp;
};


export type subscription_rootqx_eAccessMake_by_pkArgs = {
  name: string;
};


export type subscription_rootqx_eAccessMake_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eAccessMake_stream_cursor_input>;
  where?: qx_eAccessMake_bool_exp;
};


export type subscription_rootqx_eAccessPointAction_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eAccessPointAction_stream_cursor_input>;
  where?: qx_eAccessPointAction_bool_exp;
};


export type subscription_rootqx_eAccessPointDirection_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eAccessPointDirection_stream_cursor_input>;
  where?: qx_eAccessPointDirection_bool_exp;
};


export type subscription_rootqx_eAccessPointType_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eAccessPointType_stream_cursor_input>;
  where?: qx_eAccessPointType_bool_exp;
};


export type subscription_rootqx_eAppPrivilegeTypeArgs = {
  distinct_on?: Array<qx_eAppPrivilegeType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAppPrivilegeType_order_by>;
  where?: qx_eAppPrivilegeType_bool_exp;
};


export type subscription_rootqx_eAppPrivilegeType_aggregateArgs = {
  distinct_on?: Array<qx_eAppPrivilegeType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAppPrivilegeType_order_by>;
  where?: qx_eAppPrivilegeType_bool_exp;
};


export type subscription_rootqx_eAppPrivilegeType_by_pkArgs = {
  value: string;
};


export type subscription_rootqx_eAppPrivilegeType_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eAppPrivilegeType_stream_cursor_input>;
  where?: qx_eAppPrivilegeType_bool_exp;
};


export type subscription_rootqx_eAuthProviderArgs = {
  distinct_on?: Array<qx_eAuthProvider_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAuthProvider_order_by>;
  where?: qx_eAuthProvider_bool_exp;
};


export type subscription_rootqx_eAuthProvider_aggregateArgs = {
  distinct_on?: Array<qx_eAuthProvider_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eAuthProvider_order_by>;
  where?: qx_eAuthProvider_bool_exp;
};


export type subscription_rootqx_eAuthProvider_by_pkArgs = {
  value: string;
};


export type subscription_rootqx_eAuthProvider_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eAuthProvider_stream_cursor_input>;
  where?: qx_eAuthProvider_bool_exp;
};


export type subscription_rootqx_eAuthStrategy_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eAuthStrategy_stream_cursor_input>;
  where?: qx_eAuthStrategy_bool_exp;
};


export type subscription_rootqx_eBatteryLevel_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eBatteryLevel_stream_cursor_input>;
  where?: qx_eBatteryLevel_bool_exp;
};


export type subscription_rootqx_eBaudrate_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eBaudrate_stream_cursor_input>;
  where?: qx_eBaudrate_bool_exp;
};


export type subscription_rootqx_eBillingTier_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eBillingTier_stream_cursor_input>;
  where?: qx_eBillingTier_bool_exp;
};


export type subscription_rootqx_eClipStatus_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eClipStatus_stream_cursor_input>;
  where?: qx_eClipStatus_bool_exp;
};


export type subscription_rootqx_eClipType_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eClipType_stream_cursor_input>;
  where?: qx_eClipType_bool_exp;
};


export type subscription_rootqx_eCredentialType_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eCredentialType_stream_cursor_input>;
  where?: qx_eCredentialType_bool_exp;
};


export type subscription_rootqx_eDIONormalState_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eDIONormalState_stream_cursor_input>;
  where?: qx_eDIONormalState_bool_exp;
};


export type subscription_rootqx_eDIOState_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eDIOState_stream_cursor_input>;
  where?: qx_eDIOState_bool_exp;
};


export type subscription_rootqx_eDIOType_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eDIOType_stream_cursor_input>;
  where?: qx_eDIOType_bool_exp;
};


export type subscription_rootqx_eDeviceConnectionStatus_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eDeviceConnectionStatus_stream_cursor_input>;
  where?: qx_eDeviceConnectionStatus_bool_exp;
};


export type subscription_rootqx_eDeviceKind_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eDeviceKind_stream_cursor_input>;
  where?: qx_eDeviceKind_bool_exp;
};


export type subscription_rootqx_eDoorAlarm_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eDoorAlarm_stream_cursor_input>;
  where?: qx_eDoorAlarm_bool_exp;
};


export type subscription_rootqx_eDoorMode_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eDoorMode_stream_cursor_input>;
  where?: qx_eDoorMode_bool_exp;
};


export type subscription_rootqx_eDoorMonitor_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eDoorMonitor_stream_cursor_input>;
  where?: qx_eDoorMonitor_bool_exp;
};


export type subscription_rootqx_eDoorState_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eDoorState_stream_cursor_input>;
  where?: qx_eDoorState_bool_exp;
};


export type subscription_rootqx_eFlowNotificationType_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eFlowNotificationType_stream_cursor_input>;
  where?: qx_eFlowNotificationType_bool_exp;
};


export type subscription_rootqx_eFlowStatusArgs = {
  distinct_on?: Array<qx_eFlowStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eFlowStatus_order_by>;
  where?: qx_eFlowStatus_bool_exp;
};


export type subscription_rootqx_eFlowStatus_aggregateArgs = {
  distinct_on?: Array<qx_eFlowStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eFlowStatus_order_by>;
  where?: qx_eFlowStatus_bool_exp;
};


export type subscription_rootqx_eFlowStatus_by_pkArgs = {
  value: string;
};


export type subscription_rootqx_eFlowStatus_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eFlowStatus_stream_cursor_input>;
  where?: qx_eFlowStatus_bool_exp;
};


export type subscription_rootqx_eFlowTraceActionStatusArgs = {
  distinct_on?: Array<qx_eFlowTraceActionStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eFlowTraceActionStatus_order_by>;
  where?: qx_eFlowTraceActionStatus_bool_exp;
};


export type subscription_rootqx_eFlowTraceActionStatus_aggregateArgs = {
  distinct_on?: Array<qx_eFlowTraceActionStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eFlowTraceActionStatus_order_by>;
  where?: qx_eFlowTraceActionStatus_bool_exp;
};


export type subscription_rootqx_eFlowTraceActionStatus_by_pkArgs = {
  value: string;
};


export type subscription_rootqx_eFlowTraceActionStatus_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eFlowTraceActionStatus_stream_cursor_input>;
  where?: qx_eFlowTraceActionStatus_bool_exp;
};


export type subscription_rootqx_eFlowTraceStateArgs = {
  distinct_on?: Array<qx_eFlowTraceState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eFlowTraceState_order_by>;
  where?: qx_eFlowTraceState_bool_exp;
};


export type subscription_rootqx_eFlowTraceState_aggregateArgs = {
  distinct_on?: Array<qx_eFlowTraceState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eFlowTraceState_order_by>;
  where?: qx_eFlowTraceState_bool_exp;
};


export type subscription_rootqx_eFlowTraceState_by_pkArgs = {
  value: string;
};


export type subscription_rootqx_eFlowTraceState_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eFlowTraceState_stream_cursor_input>;
  where?: qx_eFlowTraceState_bool_exp;
};


export type subscription_rootqx_eGatewayServiceType_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eGatewayServiceType_stream_cursor_input>;
  where?: qx_eGatewayServiceType_bool_exp;
};


export type subscription_rootqx_eGatewaySyncStatus_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eGatewaySyncStatus_stream_cursor_input>;
  where?: qx_eGatewaySyncStatus_bool_exp;
};


export type subscription_rootqx_eIntrusionZoneTypeArgs = {
  distinct_on?: Array<qx_eIntrusionZoneType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eIntrusionZoneType_order_by>;
  where?: qx_eIntrusionZoneType_bool_exp;
};


export type subscription_rootqx_eIntrusionZoneType_aggregateArgs = {
  distinct_on?: Array<qx_eIntrusionZoneType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eIntrusionZoneType_order_by>;
  where?: qx_eIntrusionZoneType_bool_exp;
};


export type subscription_rootqx_eIntrusionZoneType_by_pkArgs = {
  value: string;
};


export type subscription_rootqx_eIntrusionZoneType_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eIntrusionZoneType_stream_cursor_input>;
  where?: qx_eIntrusionZoneType_bool_exp;
};


export type subscription_rootqx_eKeypadMode_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eKeypadMode_stream_cursor_input>;
  where?: qx_eKeypadMode_bool_exp;
};


export type subscription_rootqx_eLockModeArgs = {
  distinct_on?: Array<qx_eLockMode_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eLockMode_order_by>;
  where?: qx_eLockMode_bool_exp;
};


export type subscription_rootqx_eLockMode_aggregateArgs = {
  distinct_on?: Array<qx_eLockMode_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eLockMode_order_by>;
  where?: qx_eLockMode_bool_exp;
};


export type subscription_rootqx_eLockMode_by_pkArgs = {
  value: string;
};


export type subscription_rootqx_eLockMode_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eLockMode_stream_cursor_input>;
  where?: qx_eLockMode_bool_exp;
};


export type subscription_rootqx_eLockPowerMonitor_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eLockPowerMonitor_stream_cursor_input>;
  where?: qx_eLockPowerMonitor_bool_exp;
};


export type subscription_rootqx_eLockRelayMonitor_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eLockRelayMonitor_stream_cursor_input>;
  where?: qx_eLockRelayMonitor_bool_exp;
};


export type subscription_rootqx_eLockType_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eLockType_stream_cursor_input>;
  where?: qx_eLockType_bool_exp;
};


export type subscription_rootqx_eMercuryMonitorPointLatchModesArgs = {
  distinct_on?: Array<qx_eMercuryMonitorPointLatchModes_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eMercuryMonitorPointLatchModes_order_by>;
  where?: qx_eMercuryMonitorPointLatchModes_bool_exp;
};


export type subscription_rootqx_eMercuryMonitorPointLatchModes_aggregateArgs = {
  distinct_on?: Array<qx_eMercuryMonitorPointLatchModes_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eMercuryMonitorPointLatchModes_order_by>;
  where?: qx_eMercuryMonitorPointLatchModes_bool_exp;
};


export type subscription_rootqx_eMercuryMonitorPointLatchModes_by_pkArgs = {
  value: string;
};


export type subscription_rootqx_eMercuryMonitorPointLatchModes_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eMercuryMonitorPointLatchModes_stream_cursor_input>;
  where?: qx_eMercuryMonitorPointLatchModes_bool_exp;
};


export type subscription_rootqx_eMonitorLockState_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eMonitorLockState_stream_cursor_input>;
  where?: qx_eMonitorLockState_bool_exp;
};


export type subscription_rootqx_eMountPosition_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eMountPosition_stream_cursor_input>;
  where?: qx_eMountPosition_bool_exp;
};


export type subscription_rootqx_eObjectAction_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eObjectAction_stream_cursor_input>;
  where?: qx_eObjectAction_bool_exp;
};


export type subscription_rootqx_ePACSStatus_streamArgs = {
  batch_size: number;
  cursor: Array<qx_ePACSStatus_stream_cursor_input>;
  where?: qx_ePACSStatus_bool_exp;
};


export type subscription_rootqx_ePersonStatus_streamArgs = {
  batch_size: number;
  cursor: Array<qx_ePersonStatus_stream_cursor_input>;
  where?: qx_ePersonStatus_bool_exp;
};


export type subscription_rootqx_ePlaceType_streamArgs = {
  batch_size: number;
  cursor: Array<qx_ePlaceType_stream_cursor_input>;
  where?: qx_ePlaceType_bool_exp;
};


export type subscription_rootqx_ePrivilege_streamArgs = {
  batch_size: number;
  cursor: Array<qx_ePrivilege_stream_cursor_input>;
  where?: qx_ePrivilege_bool_exp;
};


export type subscription_rootqx_eReaderAccessType_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eReaderAccessType_stream_cursor_input>;
  where?: qx_eReaderAccessType_bool_exp;
};


export type subscription_rootqx_eReaderProtocol_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eReaderProtocol_stream_cursor_input>;
  where?: qx_eReaderProtocol_bool_exp;
};


export type subscription_rootqx_eRexState_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eRexState_stream_cursor_input>;
  where?: qx_eRexState_bool_exp;
};


export type subscription_rootqx_eSensorAction_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eSensorAction_stream_cursor_input>;
  where?: qx_eSensorAction_bool_exp;
};


export type subscription_rootqx_eSensorType_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eSensorType_stream_cursor_input>;
  where?: qx_eSensorType_bool_exp;
};


export type subscription_rootqx_eStreamStatus_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eStreamStatus_stream_cursor_input>;
  where?: qx_eStreamStatus_bool_exp;
};


export type subscription_rootqx_eSuperviseInputs_streamArgs = {
  batch_size: number;
  cursor: Array<qx_eSuperviseInputs_stream_cursor_input>;
  where?: qx_eSuperviseInputs_bool_exp;
};


export type subscription_rootqx_event_type_status_valuesArgs = {
  args: qx_event_type_status_values_args;
  distinct_on?: Array<qx_eDeviceConnectionStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDeviceConnectionStatus_order_by>;
  where?: qx_eDeviceConnectionStatus_bool_exp;
};


export type subscription_rootqx_event_type_status_values_aggregateArgs = {
  args: qx_event_type_status_values_args;
  distinct_on?: Array<qx_eDeviceConnectionStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eDeviceConnectionStatus_order_by>;
  where?: qx_eDeviceConnectionStatus_bool_exp;
};


export type subscription_rootqx_events_by_hourArgs = {
  args: qx_events_by_hour_args;
  distinct_on?: Array<qx_vEventsByHour_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vEventsByHour_order_by>;
  where?: qx_vEventsByHour_bool_exp;
};


export type subscription_rootqx_events_by_hour_aggregateArgs = {
  args: qx_events_by_hour_args;
  distinct_on?: Array<qx_vEventsByHour_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vEventsByHour_order_by>;
  where?: qx_vEventsByHour_bool_exp;
};


export type subscription_rootqx_find_credential_from_placeArgs = {
  args: qx_find_credential_from_place_args;
  distinct_on?: Array<qx_Credential_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Credential_order_by>;
  where?: qx_Credential_bool_exp;
};


export type subscription_rootqx_find_credential_from_place_aggregateArgs = {
  args: qx_find_credential_from_place_args;
  distinct_on?: Array<qx_Credential_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Credential_order_by>;
  where?: qx_Credential_bool_exp;
};


export type subscription_rootqx_media_profile_oldest_mediaArgs = {
  args: qx_media_profile_oldest_media_args;
  distinct_on?: Array<qx_vOldestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vOldestMedia_order_by>;
  where?: qx_vOldestMedia_bool_exp;
};


export type subscription_rootqx_media_profile_oldest_media_aggregateArgs = {
  args: qx_media_profile_oldest_media_args;
  distinct_on?: Array<qx_vOldestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vOldestMedia_order_by>;
  where?: qx_vOldestMedia_bool_exp;
};


export type subscription_rootqx_place_hierarchyArgs = {
  args: qx_place_hierarchy_args;
  distinct_on?: Array<qx_vPlaceHierarchy_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vPlaceHierarchy_order_by>;
  where?: qx_vPlaceHierarchy_bool_exp;
};


export type subscription_rootqx_place_hierarchy_aggregateArgs = {
  args: qx_place_hierarchy_args;
  distinct_on?: Array<qx_vPlaceHierarchy_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vPlaceHierarchy_order_by>;
  where?: qx_vPlaceHierarchy_bool_exp;
};


export type subscription_rootqx_search_segmentsArgs = {
  args: qx_search_segments_args;
  distinct_on?: Array<qx_Segment_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Segment_order_by>;
  where?: qx_Segment_bool_exp;
};


export type subscription_rootqx_search_segments_aggregateArgs = {
  args: qx_search_segments_args;
  distinct_on?: Array<qx_Segment_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Segment_order_by>;
  where?: qx_Segment_bool_exp;
};


export type subscription_rootqx_search_snapshotsArgs = {
  args: qx_search_snapshots_args;
  distinct_on?: Array<qx_Snapshot_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Snapshot_order_by>;
  where?: qx_Snapshot_bool_exp;
};


export type subscription_rootqx_search_snapshots_aggregateArgs = {
  args: qx_search_snapshots_args;
  distinct_on?: Array<qx_Snapshot_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Snapshot_order_by>;
  where?: qx_Snapshot_bool_exp;
};


export type subscription_rootqx_search_timelineArgs = {
  args: qx_search_timeline_args;
  distinct_on?: Array<qx_vSearchTimeline_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vSearchTimeline_order_by>;
  where?: qx_vSearchTimeline_bool_exp;
};


export type subscription_rootqx_search_timeline_aggregateArgs = {
  args: qx_search_timeline_args;
  distinct_on?: Array<qx_vSearchTimeline_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vSearchTimeline_order_by>;
  where?: qx_vSearchTimeline_bool_exp;
};


export type subscription_rootqx_vChatBillingByModel_streamArgs = {
  batch_size: number;
  cursor: Array<qx_vChatBillingByModel_stream_cursor_input>;
  where?: qx_vChatBillingByModel_bool_exp;
};


export type subscription_rootqx_vChatBillingSummary_streamArgs = {
  batch_size: number;
  cursor: Array<qx_vChatBillingSummary_stream_cursor_input>;
  where?: qx_vChatBillingSummary_bool_exp;
};


export type subscription_rootqx_vChatPromptUsage_streamArgs = {
  batch_size: number;
  cursor: Array<qx_vChatPromptUsage_stream_cursor_input>;
  where?: qx_vChatPromptUsage_bool_exp;
};


export type subscription_rootqx_vChatUsagePerModelArgs = {
  distinct_on?: Array<qx_vChatUsagePerModel_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatUsagePerModel_order_by>;
  where?: qx_vChatUsagePerModel_bool_exp;
};


export type subscription_rootqx_vChatUsagePerModel_aggregateArgs = {
  distinct_on?: Array<qx_vChatUsagePerModel_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatUsagePerModel_order_by>;
  where?: qx_vChatUsagePerModel_bool_exp;
};


export type subscription_rootqx_vChatUsagePerModel_streamArgs = {
  batch_size: number;
  cursor: Array<qx_vChatUsagePerModel_stream_cursor_input>;
  where?: qx_vChatUsagePerModel_bool_exp;
};


export type subscription_rootqx_vChatUsageSeriesArgs = {
  distinct_on?: Array<qx_vChatUsageSeries_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatUsageSeries_order_by>;
  where?: qx_vChatUsageSeries_bool_exp;
};


export type subscription_rootqx_vChatUsageSeries_aggregateArgs = {
  distinct_on?: Array<qx_vChatUsageSeries_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vChatUsageSeries_order_by>;
  where?: qx_vChatUsageSeries_bool_exp;
};


export type subscription_rootqx_vChatUsageSeries_streamArgs = {
  batch_size: number;
  cursor: Array<qx_vChatUsageSeries_stream_cursor_input>;
  where?: qx_vChatUsageSeries_bool_exp;
};


export type subscription_rootqx_vDevicePlaceArgs = {
  distinct_on?: Array<qx_vDevicePlace_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vDevicePlace_order_by>;
  where?: qx_vDevicePlace_bool_exp;
};


export type subscription_rootqx_vDevicePlace_aggregateArgs = {
  distinct_on?: Array<qx_vDevicePlace_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vDevicePlace_order_by>;
  where?: qx_vDevicePlace_bool_exp;
};


export type subscription_rootqx_vDevicePlace_streamArgs = {
  batch_size: number;
  cursor: Array<qx_vDevicePlace_stream_cursor_input>;
  where?: qx_vDevicePlace_bool_exp;
};


export type subscription_rootqx_vDoorAccessByPersonArgs = {
  distinct_on?: Array<qx_vDoorAccessByPerson_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vDoorAccessByPerson_order_by>;
  where?: qx_vDoorAccessByPerson_bool_exp;
};


export type subscription_rootqx_vDoorAccessByPerson_aggregateArgs = {
  distinct_on?: Array<qx_vDoorAccessByPerson_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vDoorAccessByPerson_order_by>;
  where?: qx_vDoorAccessByPerson_bool_exp;
};


export type subscription_rootqx_vDoorAccessByPerson_streamArgs = {
  batch_size: number;
  cursor: Array<qx_vDoorAccessByPerson_stream_cursor_input>;
  where?: qx_vDoorAccessByPerson_bool_exp;
};


export type subscription_rootqx_vEventsByHourArgs = {
  distinct_on?: Array<qx_vEventsByHour_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vEventsByHour_order_by>;
  where?: qx_vEventsByHour_bool_exp;
};


export type subscription_rootqx_vEventsByHour_aggregateArgs = {
  distinct_on?: Array<qx_vEventsByHour_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vEventsByHour_order_by>;
  where?: qx_vEventsByHour_bool_exp;
};


export type subscription_rootqx_vEventsByHour_streamArgs = {
  batch_size: number;
  cursor: Array<qx_vEventsByHour_stream_cursor_input>;
  where?: qx_vEventsByHour_bool_exp;
};


export type subscription_rootqx_vNewestMediaArgs = {
  distinct_on?: Array<qx_vNewestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vNewestMedia_order_by>;
  where?: qx_vNewestMedia_bool_exp;
};


export type subscription_rootqx_vNewestMedia_aggregateArgs = {
  distinct_on?: Array<qx_vNewestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vNewestMedia_order_by>;
  where?: qx_vNewestMedia_bool_exp;
};


export type subscription_rootqx_vNewestMedia_streamArgs = {
  batch_size: number;
  cursor: Array<qx_vNewestMedia_stream_cursor_input>;
  where?: qx_vNewestMedia_bool_exp;
};


export type subscription_rootqx_vOldestMediaArgs = {
  distinct_on?: Array<qx_vOldestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vOldestMedia_order_by>;
  where?: qx_vOldestMedia_bool_exp;
};


export type subscription_rootqx_vOldestMedia_aggregateArgs = {
  distinct_on?: Array<qx_vOldestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vOldestMedia_order_by>;
  where?: qx_vOldestMedia_bool_exp;
};


export type subscription_rootqx_vOldestMedia_streamArgs = {
  batch_size: number;
  cursor: Array<qx_vOldestMedia_stream_cursor_input>;
  where?: qx_vOldestMedia_bool_exp;
};


export type subscription_rootqx_vPersonAccessHistoryArgs = {
  distinct_on?: Array<qx_vPersonAccessHistory_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vPersonAccessHistory_order_by>;
  where?: qx_vPersonAccessHistory_bool_exp;
};


export type subscription_rootqx_vPersonAccessHistory_aggregateArgs = {
  distinct_on?: Array<qx_vPersonAccessHistory_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vPersonAccessHistory_order_by>;
  where?: qx_vPersonAccessHistory_bool_exp;
};


export type subscription_rootqx_vPersonAccessHistory_streamArgs = {
  batch_size: number;
  cursor: Array<qx_vPersonAccessHistory_stream_cursor_input>;
  where?: qx_vPersonAccessHistory_bool_exp;
};


export type subscription_rootqx_vPlaceAiBillingSummaryArgs = {
  distinct_on?: Array<qx_vPlaceAiBillingSummary_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vPlaceAiBillingSummary_order_by>;
  where?: qx_vPlaceAiBillingSummary_bool_exp;
};


export type subscription_rootqx_vPlaceAiBillingSummary_aggregateArgs = {
  distinct_on?: Array<qx_vPlaceAiBillingSummary_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vPlaceAiBillingSummary_order_by>;
  where?: qx_vPlaceAiBillingSummary_bool_exp;
};


export type subscription_rootqx_vPlaceAiBillingSummary_streamArgs = {
  batch_size: number;
  cursor: Array<qx_vPlaceAiBillingSummary_stream_cursor_input>;
  where?: qx_vPlaceAiBillingSummary_bool_exp;
};


export type subscription_rootqx_vPlaceHierarchyArgs = {
  distinct_on?: Array<qx_vPlaceHierarchy_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vPlaceHierarchy_order_by>;
  where?: qx_vPlaceHierarchy_bool_exp;
};


export type subscription_rootqx_vPlaceHierarchy_aggregateArgs = {
  distinct_on?: Array<qx_vPlaceHierarchy_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vPlaceHierarchy_order_by>;
  where?: qx_vPlaceHierarchy_bool_exp;
};


export type subscription_rootqx_vPlaceHierarchy_streamArgs = {
  batch_size: number;
  cursor: Array<qx_vPlaceHierarchy_stream_cursor_input>;
  where?: qx_vPlaceHierarchy_bool_exp;
};


export type subscription_rootqx_vPlacePrivilegeArgs = {
  distinct_on?: Array<qx_vPlacePrivilege_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vPlacePrivilege_order_by>;
  where?: qx_vPlacePrivilege_bool_exp;
};


export type subscription_rootqx_vPlacePrivilege_aggregateArgs = {
  distinct_on?: Array<qx_vPlacePrivilege_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vPlacePrivilege_order_by>;
  where?: qx_vPlacePrivilege_bool_exp;
};


export type subscription_rootqx_vPlacePrivilege_streamArgs = {
  batch_size: number;
  cursor: Array<qx_vPlacePrivilege_stream_cursor_input>;
  where?: qx_vPlacePrivilege_bool_exp;
};


export type subscription_rootqx_vProfilesArgs = {
  distinct_on?: Array<qx_vProfiles_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vProfiles_order_by>;
  where?: qx_vProfiles_bool_exp;
};


export type subscription_rootqx_vProfiles_aggregateArgs = {
  distinct_on?: Array<qx_vProfiles_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vProfiles_order_by>;
  where?: qx_vProfiles_bool_exp;
};


export type subscription_rootqx_vProfiles_streamArgs = {
  batch_size: number;
  cursor: Array<qx_vProfiles_stream_cursor_input>;
  where?: qx_vProfiles_bool_exp;
};


export type subscription_rootqx_vSearchTimelineArgs = {
  distinct_on?: Array<qx_vSearchTimeline_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vSearchTimeline_order_by>;
  where?: qx_vSearchTimeline_bool_exp;
};


export type subscription_rootqx_vSearchTimeline_aggregateArgs = {
  distinct_on?: Array<qx_vSearchTimeline_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vSearchTimeline_order_by>;
  where?: qx_vSearchTimeline_bool_exp;
};


export type subscription_rootqx_vSearchTimeline_streamArgs = {
  batch_size: number;
  cursor: Array<qx_vSearchTimeline_stream_cursor_input>;
  where?: qx_vSearchTimeline_bool_exp;
};


export type subscription_rootqx_video_source_oldest_mediaArgs = {
  args: qx_video_source_oldest_media_args;
  distinct_on?: Array<qx_vOldestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vOldestMedia_order_by>;
  where?: qx_vOldestMedia_bool_exp;
};


export type subscription_rootqx_video_source_oldest_media_aggregateArgs = {
  args: qx_video_source_oldest_media_args;
  distinct_on?: Array<qx_vOldestMedia_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_vOldestMedia_order_by>;
  where?: qx_vOldestMedia_bool_exp;
};


export type subscription_rootqxanalytics_CloudUsageArgs = {
  distinct_on?: Array<qxanalytics_CloudUsage_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qxanalytics_CloudUsage_order_by>;
  where?: qxanalytics_CloudUsage_bool_exp;
};


export type subscription_rootqxanalytics_CloudUsage_aggregateArgs = {
  distinct_on?: Array<qxanalytics_CloudUsage_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qxanalytics_CloudUsage_order_by>;
  where?: qxanalytics_CloudUsage_bool_exp;
};


export type subscription_rootqxanalytics_CloudUsage_streamArgs = {
  batch_size: number;
  cursor: Array<qxanalytics_CloudUsage_stream_cursor_input>;
  where?: qxanalytics_CloudUsage_bool_exp;
};


export type subscription_rootreaderArgs = {
  id: string;
};


export type subscription_rootreaderAccessTypeCompatibilityArgs = {
  distinct_on?: Array<readerAccessTypeCompatibility_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<readerAccessTypeCompatibility_order_by>;
  where?: readerAccessTypeCompatibility_bool_exp;
};


export type subscription_rootreaderAccessTypeCompatibility_aggregateArgs = {
  distinct_on?: Array<readerAccessTypeCompatibility_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<readerAccessTypeCompatibility_order_by>;
  where?: readerAccessTypeCompatibility_bool_exp;
};


export type subscription_rootreaderAccessTypeCompatibility_by_pkArgs = {
  id: number;
};


export type subscription_rootreaderAccessTypeCompatibility_streamArgs = {
  batch_size: number;
  cursor: Array<readerAccessTypeCompatibility_stream_cursor_input>;
  where?: readerAccessTypeCompatibility_bool_exp;
};


export type subscription_rootreaderAccessTypeEnumArgs = {
  value: string;
};


export type subscription_rootreaderAccessTypeEnumAggregateArgs = {
  distinct_on?: Array<qx_eReaderAccessType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eReaderAccessType_order_by>;
  where?: qx_eReaderAccessType_bool_exp;
};


export type subscription_rootreaderAccessTypeEnumsArgs = {
  distinct_on?: Array<qx_eReaderAccessType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eReaderAccessType_order_by>;
  where?: qx_eReaderAccessType_bool_exp;
};


export type subscription_rootreaderAggregateArgs = {
  distinct_on?: Array<qx_Reader_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Reader_order_by>;
  where?: qx_Reader_bool_exp;
};


export type subscription_rootreaderAuditArgs = {
  distinct_on?: Array<readerAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<readerAudit_order_by>;
  where?: readerAudit_bool_exp;
};


export type subscription_rootreaderAudit_aggregateArgs = {
  distinct_on?: Array<readerAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<readerAudit_order_by>;
  where?: readerAudit_bool_exp;
};


export type subscription_rootreaderAudit_streamArgs = {
  batch_size: number;
  cursor: Array<readerAudit_stream_cursor_input>;
  where?: readerAudit_bool_exp;
};


export type subscription_rootreaderProtocolCompatibilityArgs = {
  distinct_on?: Array<readerProtocolCompatibility_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<readerProtocolCompatibility_order_by>;
  where?: readerProtocolCompatibility_bool_exp;
};


export type subscription_rootreaderProtocolCompatibility_aggregateArgs = {
  distinct_on?: Array<readerProtocolCompatibility_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<readerProtocolCompatibility_order_by>;
  where?: readerProtocolCompatibility_bool_exp;
};


export type subscription_rootreaderProtocolCompatibility_by_pkArgs = {
  id: number;
};


export type subscription_rootreaderProtocolCompatibility_streamArgs = {
  batch_size: number;
  cursor: Array<readerProtocolCompatibility_stream_cursor_input>;
  where?: readerProtocolCompatibility_bool_exp;
};


export type subscription_rootreaderProtocolEnumArgs = {
  value: string;
};


export type subscription_rootreaderProtocolEnumAggregateArgs = {
  distinct_on?: Array<qx_eReaderProtocol_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eReaderProtocol_order_by>;
  where?: qx_eReaderProtocol_bool_exp;
};


export type subscription_rootreaderProtocolEnumsArgs = {
  distinct_on?: Array<qx_eReaderProtocol_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eReaderProtocol_order_by>;
  where?: qx_eReaderProtocol_bool_exp;
};


export type subscription_rootreadersArgs = {
  distinct_on?: Array<qx_Reader_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Reader_order_by>;
  where?: qx_Reader_bool_exp;
};


export type subscription_rootrexStateEnumArgs = {
  value: string;
};


export type subscription_rootrexStateEnumAggregateArgs = {
  distinct_on?: Array<qx_eRexState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eRexState_order_by>;
  where?: qx_eRexState_bool_exp;
};


export type subscription_rootrexStateEnumsArgs = {
  distinct_on?: Array<qx_eRexState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eRexState_order_by>;
  where?: qx_eRexState_bool_exp;
};


export type subscription_rootroleArgs = {
  id: string;
};


export type subscription_rootroleAggregateArgs = {
  distinct_on?: Array<qx_Role_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Role_order_by>;
  where?: qx_Role_bool_exp;
};


export type subscription_rootroleAppPrivilegesArgs = {
  distinct_on?: Array<roleAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<roleAppPrivileges_order_by>;
  where?: roleAppPrivileges_bool_exp;
};


export type subscription_rootroleAppPrivileges_aggregateArgs = {
  distinct_on?: Array<roleAppPrivileges_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<roleAppPrivileges_order_by>;
  where?: roleAppPrivileges_bool_exp;
};


export type subscription_rootroleAppPrivileges_by_pkArgs = {
  id: string;
};


export type subscription_rootroleAppPrivileges_streamArgs = {
  batch_size: number;
  cursor: Array<roleAppPrivileges_stream_cursor_input>;
  where?: roleAppPrivileges_bool_exp;
};


export type subscription_rootroleAuditArgs = {
  distinct_on?: Array<roleAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<roleAudit_order_by>;
  where?: roleAudit_bool_exp;
};


export type subscription_rootroleAudit_aggregateArgs = {
  distinct_on?: Array<roleAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<roleAudit_order_by>;
  where?: roleAudit_bool_exp;
};


export type subscription_rootroleAudit_streamArgs = {
  batch_size: number;
  cursor: Array<roleAudit_stream_cursor_input>;
  where?: roleAudit_bool_exp;
};


export type subscription_rootrolesArgs = {
  distinct_on?: Array<qx_Role_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Role_order_by>;
  where?: qx_Role_bool_exp;
};


export type subscription_rootrosslareCatalogsArgs = {
  distinct_on?: Array<rosslareCatalogs_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<rosslareCatalogs_order_by>;
  where?: rosslareCatalogs_bool_exp;
};


export type subscription_rootrosslareCatalogs_aggregateArgs = {
  distinct_on?: Array<rosslareCatalogs_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<rosslareCatalogs_order_by>;
  where?: rosslareCatalogs_bool_exp;
};


export type subscription_rootrosslareCatalogs_by_pkArgs = {
  id: string;
};


export type subscription_rootrosslareCatalogs_streamArgs = {
  batch_size: number;
  cursor: Array<rosslareCatalogs_stream_cursor_input>;
  where?: rosslareCatalogs_bool_exp;
};


export type subscription_rootrosslareConnectionArgs = {
  deviceID: string;
};


export type subscription_rootrosslareConnectionAggregateArgs = {
  distinct_on?: Array<qx_RosslareConnection_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_RosslareConnection_order_by>;
  where?: qx_RosslareConnection_bool_exp;
};


export type subscription_rootrosslareConnectionsArgs = {
  distinct_on?: Array<qx_RosslareConnection_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_RosslareConnection_order_by>;
  where?: qx_RosslareConnection_bool_exp;
};


export type subscription_roots3BucketConfigurationsArgs = {
  distinct_on?: Array<s3BucketConfigurations_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<s3BucketConfigurations_order_by>;
  where?: s3BucketConfigurations_bool_exp;
};


export type subscription_roots3BucketConfigurations_aggregateArgs = {
  distinct_on?: Array<s3BucketConfigurations_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<s3BucketConfigurations_order_by>;
  where?: s3BucketConfigurations_bool_exp;
};


export type subscription_roots3BucketConfigurations_by_pkArgs = {
  id: number;
};


export type subscription_roots3BucketConfigurations_streamArgs = {
  batch_size: number;
  cursor: Array<s3BucketConfigurations_stream_cursor_input>;
  where?: s3BucketConfigurations_bool_exp;
};


export type subscription_rootscanSegmentsArgs = {
  id: any;
};


export type subscription_rootscheduleArgs = {
  id: string;
};


export type subscription_rootscheduleAggregateArgs = {
  distinct_on?: Array<qx_Schedule_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Schedule_order_by>;
  where?: qx_Schedule_bool_exp;
};


export type subscription_rootscheduleAuditArgs = {
  distinct_on?: Array<scheduleAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<scheduleAudit_order_by>;
  where?: scheduleAudit_bool_exp;
};


export type subscription_rootscheduleAudit_aggregateArgs = {
  distinct_on?: Array<scheduleAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<scheduleAudit_order_by>;
  where?: scheduleAudit_bool_exp;
};


export type subscription_rootscheduleAudit_streamArgs = {
  batch_size: number;
  cursor: Array<scheduleAudit_stream_cursor_input>;
  where?: scheduleAudit_bool_exp;
};


export type subscription_rootscheduleBlockArgs = {
  id: string;
};


export type subscription_rootscheduleBlockAggregateArgs = {
  distinct_on?: Array<qx_ScheduleBlock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ScheduleBlock_order_by>;
  where?: qx_ScheduleBlock_bool_exp;
};


export type subscription_rootscheduleBlockAuditArgs = {
  distinct_on?: Array<scheduleBlockAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<scheduleBlockAudit_order_by>;
  where?: scheduleBlockAudit_bool_exp;
};


export type subscription_rootscheduleBlockAudit_aggregateArgs = {
  distinct_on?: Array<scheduleBlockAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<scheduleBlockAudit_order_by>;
  where?: scheduleBlockAudit_bool_exp;
};


export type subscription_rootscheduleBlockAudit_streamArgs = {
  batch_size: number;
  cursor: Array<scheduleBlockAudit_stream_cursor_input>;
  where?: scheduleBlockAudit_bool_exp;
};


export type subscription_rootscheduleBlocksArgs = {
  distinct_on?: Array<qx_ScheduleBlock_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_ScheduleBlock_order_by>;
  where?: qx_ScheduleBlock_bool_exp;
};


export type subscription_rootschedulesArgs = {
  distinct_on?: Array<qx_Schedule_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Schedule_order_by>;
  where?: qx_Schedule_bool_exp;
};


export type subscription_rootsegmentArgs = {
  id: string;
};


export type subscription_rootsegmentAggregateArgs = {
  distinct_on?: Array<qx_Segment_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Segment_order_by>;
  where?: qx_Segment_bool_exp;
};


export type subscription_rootsegmentsArgs = {
  distinct_on?: Array<qx_Segment_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Segment_order_by>;
  where?: qx_Segment_bool_exp;
};


export type subscription_rootsensorArgs = {
  id: string;
};


export type subscription_rootsensorActionEnumArgs = {
  value: string;
};


export type subscription_rootsensorActionEnumsArgs = {
  distinct_on?: Array<qx_eSensorAction_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eSensorAction_order_by>;
  where?: qx_eSensorAction_bool_exp;
};


export type subscription_rootsensorActionEnumsAggregateArgs = {
  distinct_on?: Array<qx_eSensorAction_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eSensorAction_order_by>;
  where?: qx_eSensorAction_bool_exp;
};


export type subscription_rootsensorAggregateArgs = {
  distinct_on?: Array<qx_Sensor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Sensor_order_by>;
  where?: qx_Sensor_bool_exp;
};


export type subscription_rootsensorTypeEnumArgs = {
  value: string;
};


export type subscription_rootsensorTypeEnumsArgs = {
  distinct_on?: Array<qx_eSensorType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eSensorType_order_by>;
  where?: qx_eSensorType_bool_exp;
};


export type subscription_rootsensorTypeEnumsAggregateArgs = {
  distinct_on?: Array<qx_eSensorType_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eSensorType_order_by>;
  where?: qx_eSensorType_bool_exp;
};


export type subscription_rootsensorsArgs = {
  distinct_on?: Array<qx_Sensor_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Sensor_order_by>;
  where?: qx_Sensor_bool_exp;
};


export type subscription_rootsetupCameraGatewayArgs = {
  id: any;
};


export type subscription_rootsharedLinkArgs = {
  id: string;
};


export type subscription_rootsharedLinkAggregateArgs = {
  distinct_on?: Array<qx_SharedLinks_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_SharedLinks_order_by>;
  where?: qx_SharedLinks_bool_exp;
};


export type subscription_rootsharedLinkAuditLogAggregateArgs = {
  distinct_on?: Array<qx_SharedLinkAuditLog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_SharedLinkAuditLog_order_by>;
  where?: qx_SharedLinkAuditLog_bool_exp;
};


export type subscription_rootsharedLinkAuditLogsArgs = {
  distinct_on?: Array<qx_SharedLinkAuditLog_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_SharedLinkAuditLog_order_by>;
  where?: qx_SharedLinkAuditLog_bool_exp;
};


export type subscription_rootsharedLinksArgs = {
  distinct_on?: Array<qx_SharedLinks_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_SharedLinks_order_by>;
  where?: qx_SharedLinks_bool_exp;
};


export type subscription_rootsnapshotArgs = {
  id: string;
};


export type subscription_rootsnapshotAggregateArgs = {
  distinct_on?: Array<qx_Snapshot_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Snapshot_order_by>;
  where?: qx_Snapshot_bool_exp;
};


export type subscription_rootsnapshotsArgs = {
  distinct_on?: Array<qx_Snapshot_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_Snapshot_order_by>;
  where?: qx_Snapshot_bool_exp;
};


export type subscription_rootstreamStatusEnumArgs = {
  value: string;
};


export type subscription_rootstreamStatusEnumAggregateArgs = {
  distinct_on?: Array<qx_eStreamStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eStreamStatus_order_by>;
  where?: qx_eStreamStatus_bool_exp;
};


export type subscription_rootstreamStatusEnumsArgs = {
  distinct_on?: Array<qx_eStreamStatus_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eStreamStatus_order_by>;
  where?: qx_eStreamStatus_bool_exp;
};


export type subscription_rootsuperviseInputCompatibilityArgs = {
  distinct_on?: Array<superviseInputCompatibility_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<superviseInputCompatibility_order_by>;
  where?: superviseInputCompatibility_bool_exp;
};


export type subscription_rootsuperviseInputCompatibility_aggregateArgs = {
  distinct_on?: Array<superviseInputCompatibility_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<superviseInputCompatibility_order_by>;
  where?: superviseInputCompatibility_bool_exp;
};


export type subscription_rootsuperviseInputCompatibility_by_pkArgs = {
  id: number;
};


export type subscription_rootsuperviseInputCompatibility_streamArgs = {
  batch_size: number;
  cursor: Array<superviseInputCompatibility_stream_cursor_input>;
  where?: superviseInputCompatibility_bool_exp;
};


export type subscription_rootsuperviseInputsEnumArgs = {
  value: string;
};


export type subscription_rootsuperviseInputsEnumAggregateArgs = {
  distinct_on?: Array<qx_eSuperviseInputs_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eSuperviseInputs_order_by>;
  where?: qx_eSuperviseInputs_bool_exp;
};


export type subscription_rootsuperviseInputsEnumsArgs = {
  distinct_on?: Array<qx_eSuperviseInputs_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_eSuperviseInputs_order_by>;
  where?: qx_eSuperviseInputs_bool_exp;
};


export type subscription_roottermsAgreementArgs = {
  id: string;
};


export type subscription_roottermsAgreementAggregateArgs = {
  distinct_on?: Array<qx_TermsAgreement_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_TermsAgreement_order_by>;
  where?: qx_TermsAgreement_bool_exp;
};


export type subscription_roottermsAgreementsArgs = {
  distinct_on?: Array<qx_TermsAgreement_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_TermsAgreement_order_by>;
  where?: qx_TermsAgreement_bool_exp;
};


export type subscription_roottimeZoneArgs = {
  name: string;
};


export type subscription_roottimeZoneAggregateArgs = {
  distinct_on?: Array<qx_TimeZone_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_TimeZone_order_by>;
  where?: qx_TimeZone_bool_exp;
};


export type subscription_roottimeZonesArgs = {
  distinct_on?: Array<qx_TimeZone_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_TimeZone_order_by>;
  where?: qx_TimeZone_bool_exp;
};


export type subscription_rootupdateCustomerCanSelfServeArgs = {
  id: any;
};


export type subscription_rootupdateCustomerPlacePrivilegesArgs = {
  id: any;
};


export type subscription_rootuserSettingArgs = {
  id: string;
};


export type subscription_rootuserSettingsArgs = {
  distinct_on?: Array<qx_UserSetting_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_UserSetting_order_by>;
  where?: qx_UserSetting_bool_exp;
};


export type subscription_rootuserSettingsAggregateArgs = {
  distinct_on?: Array<qx_UserSetting_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_UserSetting_order_by>;
  where?: qx_UserSetting_bool_exp;
};


export type subscription_rootvEventStatusesArgs = {
  distinct_on?: Array<vEventStatuses_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<vEventStatuses_order_by>;
  where?: vEventStatuses_bool_exp;
};


export type subscription_rootvEventStatuses_aggregateArgs = {
  distinct_on?: Array<vEventStatuses_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<vEventStatuses_order_by>;
  where?: vEventStatuses_bool_exp;
};


export type subscription_rootvEventStatuses_streamArgs = {
  batch_size: number;
  cursor: Array<vEventStatuses_stream_cursor_input>;
  where?: vEventStatuses_bool_exp;
};


export type subscription_rootvEventsArgs = {
  distinct_on?: Array<vEvents_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<vEvents_order_by>;
  where?: vEvents_bool_exp;
};


export type subscription_rootvEvents_aggregateArgs = {
  distinct_on?: Array<vEvents_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<vEvents_order_by>;
  where?: vEvents_bool_exp;
};


export type subscription_rootvEvents_streamArgs = {
  batch_size: number;
  cursor: Array<vEvents_stream_cursor_input>;
  where?: vEvents_bool_exp;
};


export type subscription_rootvideoSourceArgs = {
  id: string;
};


export type subscription_rootvideoSourceAggregateArgs = {
  distinct_on?: Array<qx_VideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_VideoSource_order_by>;
  where?: qx_VideoSource_bool_exp;
};


export type subscription_rootvideoSourceAuditArgs = {
  distinct_on?: Array<videoSourceAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<videoSourceAudit_order_by>;
  where?: videoSourceAudit_bool_exp;
};


export type subscription_rootvideoSourceAudit_aggregateArgs = {
  distinct_on?: Array<videoSourceAudit_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<videoSourceAudit_order_by>;
  where?: videoSourceAudit_bool_exp;
};


export type subscription_rootvideoSourceAudit_streamArgs = {
  batch_size: number;
  cursor: Array<videoSourceAudit_stream_cursor_input>;
  where?: videoSourceAudit_bool_exp;
};


export type subscription_rootvideoSourceStateArgs = {
  distinct_on?: Array<videoSourceState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<videoSourceState_order_by>;
  where?: videoSourceState_bool_exp;
};


export type subscription_rootvideoSourceState_aggregateArgs = {
  distinct_on?: Array<videoSourceState_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<videoSourceState_order_by>;
  where?: videoSourceState_bool_exp;
};


export type subscription_rootvideoSourceState_by_pkArgs = {
  videoSourceID: string;
};


export type subscription_rootvideoSourceState_streamArgs = {
  batch_size: number;
  cursor: Array<videoSourceState_stream_cursor_input>;
  where?: videoSourceState_bool_exp;
};


export type subscription_rootvideoSourcesArgs = {
  distinct_on?: Array<qx_VideoSource_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_VideoSource_order_by>;
  where?: qx_VideoSource_bool_exp;
};


export type subscription_rootviewArgs = {
  id: string;
};


export type subscription_rootviewsArgs = {
  distinct_on?: Array<qx_View_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_View_order_by>;
  where?: qx_View_bool_exp;
};


export type subscription_rootviewsAggregateArgs = {
  distinct_on?: Array<qx_View_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_View_order_by>;
  where?: qx_View_bool_exp;
};


export type subscription_rootwiegandCardFormatArgs = {
  id: string;
};


export type subscription_rootwiegandCardFormatAggregateArgs = {
  distinct_on?: Array<qx_WiegandCardFormat_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_WiegandCardFormat_order_by>;
  where?: qx_WiegandCardFormat_bool_exp;
};


export type subscription_rootwiegandCardFormatsArgs = {
  distinct_on?: Array<qx_WiegandCardFormat_select_column>;
  limit?: number;
  offset?: number;
  order_by?: Array<qx_WiegandCardFormat_order_by>;
  where?: qx_WiegandCardFormat_bool_exp;
};

/** columns and relationships of "qx.SuperviseInputCompatibility" */
export type superviseInputCompatibility = {
  __typename?: 'superviseInputCompatibility';
  /** An object relationship */
  eAccessMake: qx_eAccessMake;
  /** An object relationship */
  eSuperviseInput: qx_eSuperviseInputs;
  id: number;
  panel: qx_eAccessMake_enum;
  type: qx_eSuperviseInputs_enum;
};

/** aggregated selection of "qx.SuperviseInputCompatibility" */
export type superviseInputCompatibility_aggregate = {
  __typename?: 'superviseInputCompatibility_aggregate';
  aggregate?: superviseInputCompatibility_aggregate_fields;
  nodes: Array<superviseInputCompatibility>;
};

export type superviseInputCompatibility_aggregate_bool_exp = {
  count?: superviseInputCompatibility_aggregate_bool_exp_count;
};

export type superviseInputCompatibility_aggregate_bool_exp_count = {
  arguments?: Array<superviseInputCompatibility_select_column>;
  distinct?: boolean;
  filter?: superviseInputCompatibility_bool_exp;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "qx.SuperviseInputCompatibility" */
export type superviseInputCompatibility_aggregate_fields = {
  __typename?: 'superviseInputCompatibility_aggregate_fields';
  avg?: superviseInputCompatibility_avg_fields;
  count: number;
  max?: superviseInputCompatibility_max_fields;
  min?: superviseInputCompatibility_min_fields;
  stddev?: superviseInputCompatibility_stddev_fields;
  stddev_pop?: superviseInputCompatibility_stddev_pop_fields;
  stddev_samp?: superviseInputCompatibility_stddev_samp_fields;
  sum?: superviseInputCompatibility_sum_fields;
  var_pop?: superviseInputCompatibility_var_pop_fields;
  var_samp?: superviseInputCompatibility_var_samp_fields;
  variance?: superviseInputCompatibility_variance_fields;
};


/** aggregate fields of "qx.SuperviseInputCompatibility" */
export type superviseInputCompatibility_aggregate_fieldscountArgs = {
  columns?: Array<superviseInputCompatibility_select_column>;
  distinct?: boolean;
};

/** order by aggregate values of table "qx.SuperviseInputCompatibility" */
export type superviseInputCompatibility_aggregate_order_by = {
  avg?: superviseInputCompatibility_avg_order_by;
  count?: order_by;
  max?: superviseInputCompatibility_max_order_by;
  min?: superviseInputCompatibility_min_order_by;
  stddev?: superviseInputCompatibility_stddev_order_by;
  stddev_pop?: superviseInputCompatibility_stddev_pop_order_by;
  stddev_samp?: superviseInputCompatibility_stddev_samp_order_by;
  sum?: superviseInputCompatibility_sum_order_by;
  var_pop?: superviseInputCompatibility_var_pop_order_by;
  var_samp?: superviseInputCompatibility_var_samp_order_by;
  variance?: superviseInputCompatibility_variance_order_by;
};

/** input type for inserting array relation for remote table "qx.SuperviseInputCompatibility" */
export type superviseInputCompatibility_arr_rel_insert_input = {
  data: Array<superviseInputCompatibility_insert_input>;
  /** upsert condition */
  on_conflict?: superviseInputCompatibility_on_conflict;
};

/** aggregate avg on columns */
export type superviseInputCompatibility_avg_fields = {
  __typename?: 'superviseInputCompatibility_avg_fields';
  id?: number;
};

/** order by avg() on columns of table "qx.SuperviseInputCompatibility" */
export type superviseInputCompatibility_avg_order_by = {
  id?: order_by;
};

/** Boolean expression to filter rows from the table "qx.SuperviseInputCompatibility". All fields are combined with a logical 'AND'. */
export type superviseInputCompatibility_bool_exp = {
  _and?: Array<superviseInputCompatibility_bool_exp>;
  _not?: superviseInputCompatibility_bool_exp;
  _or?: Array<superviseInputCompatibility_bool_exp>;
  eAccessMake?: qx_eAccessMake_bool_exp;
  eSuperviseInput?: qx_eSuperviseInputs_bool_exp;
  id?: Int_comparison_exp;
  panel?: qx_eAccessMake_enum_comparison_exp;
  type?: qx_eSuperviseInputs_enum_comparison_exp;
};

/** unique or primary key constraints on table "qx.SuperviseInputCompatibility" */
export enum superviseInputCompatibility_constraint {
  /** unique or primary key constraint on columns "id" */
  SuperviseInputCompatibility_pkey = 'SuperviseInputCompatibility_pkey',
  /** unique or primary key constraint on columns "type", "panel" */
  SuperviseInputCompatibility_type_panel_key = 'SuperviseInputCompatibility_type_panel_key'
}

/** input type for incrementing numeric columns in table "qx.SuperviseInputCompatibility" */
export type superviseInputCompatibility_inc_input = {
  id?: number;
};

/** input type for inserting data into table "qx.SuperviseInputCompatibility" */
export type superviseInputCompatibility_insert_input = {
  eAccessMake?: qx_eAccessMake_obj_rel_insert_input;
  eSuperviseInput?: qx_eSuperviseInputs_obj_rel_insert_input;
  id?: number;
  panel?: qx_eAccessMake_enum;
  type?: qx_eSuperviseInputs_enum;
};

/** aggregate max on columns */
export type superviseInputCompatibility_max_fields = {
  __typename?: 'superviseInputCompatibility_max_fields';
  id?: number;
};

/** order by max() on columns of table "qx.SuperviseInputCompatibility" */
export type superviseInputCompatibility_max_order_by = {
  id?: order_by;
};

/** aggregate min on columns */
export type superviseInputCompatibility_min_fields = {
  __typename?: 'superviseInputCompatibility_min_fields';
  id?: number;
};

/** order by min() on columns of table "qx.SuperviseInputCompatibility" */
export type superviseInputCompatibility_min_order_by = {
  id?: order_by;
};

/** response of any mutation on the table "qx.SuperviseInputCompatibility" */
export type superviseInputCompatibility_mutation_response = {
  __typename?: 'superviseInputCompatibility_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<superviseInputCompatibility>;
};

/** on_conflict condition type for table "qx.SuperviseInputCompatibility" */
export type superviseInputCompatibility_on_conflict = {
  constraint: superviseInputCompatibility_constraint;
  update_columns?: Array<superviseInputCompatibility_update_column>;
  where?: superviseInputCompatibility_bool_exp;
};

/** Ordering options when selecting data from "qx.SuperviseInputCompatibility". */
export type superviseInputCompatibility_order_by = {
  eAccessMake?: qx_eAccessMake_order_by;
  eSuperviseInput?: qx_eSuperviseInputs_order_by;
  id?: order_by;
  panel?: order_by;
  type?: order_by;
};

/** primary key columns input for table: qx.SuperviseInputCompatibility */
export type superviseInputCompatibility_pk_columns_input = {
  id: number;
};

/** select columns of table "qx.SuperviseInputCompatibility" */
export enum superviseInputCompatibility_select_column {
  /** column name */
  id = 'id',
  /** column name */
  panel = 'panel',
  /** column name */
  type = 'type'
}

/** input type for updating data in table "qx.SuperviseInputCompatibility" */
export type superviseInputCompatibility_set_input = {
  id?: number;
  panel?: qx_eAccessMake_enum;
  type?: qx_eSuperviseInputs_enum;
};

/** aggregate stddev on columns */
export type superviseInputCompatibility_stddev_fields = {
  __typename?: 'superviseInputCompatibility_stddev_fields';
  id?: number;
};

/** order by stddev() on columns of table "qx.SuperviseInputCompatibility" */
export type superviseInputCompatibility_stddev_order_by = {
  id?: order_by;
};

/** aggregate stddev_pop on columns */
export type superviseInputCompatibility_stddev_pop_fields = {
  __typename?: 'superviseInputCompatibility_stddev_pop_fields';
  id?: number;
};

/** order by stddev_pop() on columns of table "qx.SuperviseInputCompatibility" */
export type superviseInputCompatibility_stddev_pop_order_by = {
  id?: order_by;
};

/** aggregate stddev_samp on columns */
export type superviseInputCompatibility_stddev_samp_fields = {
  __typename?: 'superviseInputCompatibility_stddev_samp_fields';
  id?: number;
};

/** order by stddev_samp() on columns of table "qx.SuperviseInputCompatibility" */
export type superviseInputCompatibility_stddev_samp_order_by = {
  id?: order_by;
};

/** Streaming cursor of the table "superviseInputCompatibility" */
export type superviseInputCompatibility_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: superviseInputCompatibility_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type superviseInputCompatibility_stream_cursor_value_input = {
  id?: number;
  panel?: qx_eAccessMake_enum;
  type?: qx_eSuperviseInputs_enum;
};

/** aggregate sum on columns */
export type superviseInputCompatibility_sum_fields = {
  __typename?: 'superviseInputCompatibility_sum_fields';
  id?: number;
};

/** order by sum() on columns of table "qx.SuperviseInputCompatibility" */
export type superviseInputCompatibility_sum_order_by = {
  id?: order_by;
};

/** update columns of table "qx.SuperviseInputCompatibility" */
export enum superviseInputCompatibility_update_column {
  /** column name */
  id = 'id',
  /** column name */
  panel = 'panel',
  /** column name */
  type = 'type'
}

export type superviseInputCompatibility_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: superviseInputCompatibility_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: superviseInputCompatibility_set_input;
  /** filter the rows which have to be updated */
  where: superviseInputCompatibility_bool_exp;
};

/** aggregate var_pop on columns */
export type superviseInputCompatibility_var_pop_fields = {
  __typename?: 'superviseInputCompatibility_var_pop_fields';
  id?: number;
};

/** order by var_pop() on columns of table "qx.SuperviseInputCompatibility" */
export type superviseInputCompatibility_var_pop_order_by = {
  id?: order_by;
};

/** aggregate var_samp on columns */
export type superviseInputCompatibility_var_samp_fields = {
  __typename?: 'superviseInputCompatibility_var_samp_fields';
  id?: number;
};

/** order by var_samp() on columns of table "qx.SuperviseInputCompatibility" */
export type superviseInputCompatibility_var_samp_order_by = {
  id?: order_by;
};

/** aggregate variance on columns */
export type superviseInputCompatibility_variance_fields = {
  __typename?: 'superviseInputCompatibility_variance_fields';
  id?: number;
};

/** order by variance() on columns of table "qx.SuperviseInputCompatibility" */
export type superviseInputCompatibility_variance_order_by = {
  id?: order_by;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type timestamp_comparison_exp = {
  _eq?: string;
  _gt?: string;
  _gte?: string;
  _in?: Array<string>;
  _is_null?: boolean;
  _lt?: string;
  _lte?: string;
  _neq?: string;
  _nin?: Array<string>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type timestamptz_comparison_exp = {
  _eq?: string;
  _gt?: string;
  _gte?: string;
  _in?: Array<string>;
  _is_null?: boolean;
  _lt?: string;
  _lte?: string;
  _neq?: string;
  _nin?: Array<string>;
};

/** fields of action: "updateCustomerCanSelfServe" */
export type updateCustomerCanSelfServe = {
  __typename?: 'updateCustomerCanSelfServe';
  /** the time at which this action was created */
  created_at: string;
  /** errors related to the invocation */
  errors?: any;
  /** the unique id of an action */
  id: any;
  /** the output fields of this action */
  output?: SuccessOutput;
};

/** fields of action: "updateCustomerPlacePrivileges" */
export type updateCustomerPlacePrivileges = {
  __typename?: 'updateCustomerPlacePrivileges';
  /** the time at which this action was created */
  created_at: string;
  /** errors related to the invocation */
  errors?: any;
  /** the unique id of an action */
  id: any;
  /** the output fields of this action */
  output?: SuccessOutput;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type uuid_comparison_exp = {
  _eq?: any;
  _gt?: any;
  _gte?: any;
  _in?: Array<any>;
  _is_null?: boolean;
  _lt?: any;
  _lte?: any;
  _neq?: any;
  _nin?: Array<any>;
};

/** columns and relationships of "qx.vEventStatus" */
export type vEventStatuses = {
  __typename?: 'vEventStatuses';
  comment?: string;
  status?: string;
  type?: string;
};

/** aggregated selection of "qx.vEventStatus" */
export type vEventStatuses_aggregate = {
  __typename?: 'vEventStatuses_aggregate';
  aggregate?: vEventStatuses_aggregate_fields;
  nodes: Array<vEventStatuses>;
};

/** aggregate fields of "qx.vEventStatus" */
export type vEventStatuses_aggregate_fields = {
  __typename?: 'vEventStatuses_aggregate_fields';
  count: number;
  max?: vEventStatuses_max_fields;
  min?: vEventStatuses_min_fields;
};


/** aggregate fields of "qx.vEventStatus" */
export type vEventStatuses_aggregate_fieldscountArgs = {
  columns?: Array<vEventStatuses_select_column>;
  distinct?: boolean;
};

/** Boolean expression to filter rows from the table "qx.vEventStatus". All fields are combined with a logical 'AND'. */
export type vEventStatuses_bool_exp = {
  _and?: Array<vEventStatuses_bool_exp>;
  _not?: vEventStatuses_bool_exp;
  _or?: Array<vEventStatuses_bool_exp>;
  comment?: String_comparison_exp;
  status?: String_comparison_exp;
  type?: String_comparison_exp;
};

/** aggregate max on columns */
export type vEventStatuses_max_fields = {
  __typename?: 'vEventStatuses_max_fields';
  comment?: string;
  status?: string;
  type?: string;
};

/** aggregate min on columns */
export type vEventStatuses_min_fields = {
  __typename?: 'vEventStatuses_min_fields';
  comment?: string;
  status?: string;
  type?: string;
};

/** Ordering options when selecting data from "qx.vEventStatus". */
export type vEventStatuses_order_by = {
  comment?: order_by;
  status?: order_by;
  type?: order_by;
};

/** select columns of table "qx.vEventStatus" */
export enum vEventStatuses_select_column {
  /** column name */
  comment = 'comment',
  /** column name */
  status = 'status',
  /** column name */
  type = 'type'
}

/** Streaming cursor of the table "vEventStatuses" */
export type vEventStatuses_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: vEventStatuses_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type vEventStatuses_stream_cursor_value_input = {
  comment?: string;
  status?: string;
  type?: string;
};

/** columns and relationships of "qx.vEvents" */
export type vEvents = {
  __typename?: 'vEvents';
  active?: boolean;
  bits?: number;
  card?: string;
  cloudTime?: string;
  /** An object relationship */
  device?: qx_Device;
  /** An object relationship */
  deviceDIO?: qx_DeviceDIO;
  deviceDIOID?: string;
  deviceID?: string;
  /** An object relationship */
  door?: qx_Door;
  doorID?: string;
  duration?: any;
  /** An object relationship */
  end?: qx_Event;
  eventEnd?: string;
  eventStart?: string;
  /** An object relationship */
  gateway?: qx_Gateway;
  gatewayID?: string;
  hasVideo?: boolean;
  id?: string;
  inCloud?: boolean;
  /** An object relationship */
  mediaProfile?: qx_MediaProfile;
  mediaProfileID?: string;
  onGateway?: boolean;
  /** An object relationship */
  partition?: IntrusionPartition;
  partitionID?: string;
  /** An object relationship */
  person?: qx_Person;
  personID?: string;
  /** An object relationship */
  place?: qx_Place;
  placeID?: string;
  profile?: string;
  /** An object relationship */
  reader?: qx_Reader;
  readerID?: string;
  /** An object relationship */
  sensor?: qx_Sensor;
  sensorID?: string;
  serverTime?: string;
  /** An object relationship */
  snapshot?: qx_Snapshot;
  snapshotID?: string;
  /** An object relationship */
  start?: qx_Event;
  startID?: string;
  status?: string;
  time?: string;
  /** An object relationship */
  toType?: qx_EventType;
  type?: string;
  typeStatusActiveID?: string;
  /** An object relationship */
  videoSource?: qx_VideoSource;
  videoSourceID?: string;
  /** An object relationship */
  zone?: IntrusionZone;
  zoneID?: string;
};

/** aggregated selection of "qx.vEvents" */
export type vEvents_aggregate = {
  __typename?: 'vEvents_aggregate';
  aggregate?: vEvents_aggregate_fields;
  nodes: Array<vEvents>;
};

/** aggregate fields of "qx.vEvents" */
export type vEvents_aggregate_fields = {
  __typename?: 'vEvents_aggregate_fields';
  avg?: vEvents_avg_fields;
  count: number;
  max?: vEvents_max_fields;
  min?: vEvents_min_fields;
  stddev?: vEvents_stddev_fields;
  stddev_pop?: vEvents_stddev_pop_fields;
  stddev_samp?: vEvents_stddev_samp_fields;
  sum?: vEvents_sum_fields;
  var_pop?: vEvents_var_pop_fields;
  var_samp?: vEvents_var_samp_fields;
  variance?: vEvents_variance_fields;
};


/** aggregate fields of "qx.vEvents" */
export type vEvents_aggregate_fieldscountArgs = {
  columns?: Array<vEvents_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type vEvents_avg_fields = {
  __typename?: 'vEvents_avg_fields';
  bits?: number;
  doorID?: number;
  id?: number;
  mediaProfileID?: number;
  sensorID?: number;
  startID?: number;
  typeStatusActiveID?: number;
  videoSourceID?: number;
};

/** Boolean expression to filter rows from the table "qx.vEvents". All fields are combined with a logical 'AND'. */
export type vEvents_bool_exp = {
  _and?: Array<vEvents_bool_exp>;
  _not?: vEvents_bool_exp;
  _or?: Array<vEvents_bool_exp>;
  active?: Boolean_comparison_exp;
  bits?: Int_comparison_exp;
  card?: String_comparison_exp;
  cloudTime?: timestamptz_comparison_exp;
  device?: qx_Device_bool_exp;
  deviceDIO?: qx_DeviceDIO_bool_exp;
  deviceDIOID?: String_comparison_exp;
  deviceID?: String_comparison_exp;
  door?: qx_Door_bool_exp;
  doorID?: bigint_comparison_exp;
  duration?: interval_comparison_exp;
  end?: qx_Event_bool_exp;
  eventEnd?: timestamptz_comparison_exp;
  eventStart?: timestamptz_comparison_exp;
  gateway?: qx_Gateway_bool_exp;
  gatewayID?: String_comparison_exp;
  hasVideo?: Boolean_comparison_exp;
  id?: bigint_comparison_exp;
  inCloud?: Boolean_comparison_exp;
  mediaProfile?: qx_MediaProfile_bool_exp;
  mediaProfileID?: bigint_comparison_exp;
  onGateway?: Boolean_comparison_exp;
  partition?: IntrusionPartition_bool_exp;
  partitionID?: String_comparison_exp;
  person?: qx_Person_bool_exp;
  personID?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  placeID?: String_comparison_exp;
  profile?: String_comparison_exp;
  reader?: qx_Reader_bool_exp;
  readerID?: String_comparison_exp;
  sensor?: qx_Sensor_bool_exp;
  sensorID?: bigint_comparison_exp;
  serverTime?: timestamptz_comparison_exp;
  snapshot?: qx_Snapshot_bool_exp;
  snapshotID?: String_comparison_exp;
  start?: qx_Event_bool_exp;
  startID?: bigint_comparison_exp;
  status?: String_comparison_exp;
  time?: timestamptz_comparison_exp;
  toType?: qx_EventType_bool_exp;
  type?: String_comparison_exp;
  typeStatusActiveID?: bigint_comparison_exp;
  videoSource?: qx_VideoSource_bool_exp;
  videoSourceID?: bigint_comparison_exp;
  zone?: IntrusionZone_bool_exp;
  zoneID?: String_comparison_exp;
};

/** aggregate max on columns */
export type vEvents_max_fields = {
  __typename?: 'vEvents_max_fields';
  bits?: number;
  card?: string;
  cloudTime?: string;
  deviceDIOID?: string;
  deviceID?: string;
  doorID?: string;
  eventEnd?: string;
  eventStart?: string;
  gatewayID?: string;
  id?: string;
  mediaProfileID?: string;
  partitionID?: string;
  personID?: string;
  placeID?: string;
  profile?: string;
  readerID?: string;
  sensorID?: string;
  serverTime?: string;
  snapshotID?: string;
  startID?: string;
  status?: string;
  time?: string;
  type?: string;
  typeStatusActiveID?: string;
  videoSourceID?: string;
  zoneID?: string;
};

/** aggregate min on columns */
export type vEvents_min_fields = {
  __typename?: 'vEvents_min_fields';
  bits?: number;
  card?: string;
  cloudTime?: string;
  deviceDIOID?: string;
  deviceID?: string;
  doorID?: string;
  eventEnd?: string;
  eventStart?: string;
  gatewayID?: string;
  id?: string;
  mediaProfileID?: string;
  partitionID?: string;
  personID?: string;
  placeID?: string;
  profile?: string;
  readerID?: string;
  sensorID?: string;
  serverTime?: string;
  snapshotID?: string;
  startID?: string;
  status?: string;
  time?: string;
  type?: string;
  typeStatusActiveID?: string;
  videoSourceID?: string;
  zoneID?: string;
};

/** Ordering options when selecting data from "qx.vEvents". */
export type vEvents_order_by = {
  active?: order_by;
  bits?: order_by;
  card?: order_by;
  cloudTime?: order_by;
  device?: qx_Device_order_by;
  deviceDIO?: qx_DeviceDIO_order_by;
  deviceDIOID?: order_by;
  deviceID?: order_by;
  door?: qx_Door_order_by;
  doorID?: order_by;
  duration?: order_by;
  end?: qx_Event_order_by;
  eventEnd?: order_by;
  eventStart?: order_by;
  gateway?: qx_Gateway_order_by;
  gatewayID?: order_by;
  hasVideo?: order_by;
  id?: order_by;
  inCloud?: order_by;
  mediaProfile?: qx_MediaProfile_order_by;
  mediaProfileID?: order_by;
  onGateway?: order_by;
  partition?: IntrusionPartition_order_by;
  partitionID?: order_by;
  person?: qx_Person_order_by;
  personID?: order_by;
  place?: qx_Place_order_by;
  placeID?: order_by;
  profile?: order_by;
  reader?: qx_Reader_order_by;
  readerID?: order_by;
  sensor?: qx_Sensor_order_by;
  sensorID?: order_by;
  serverTime?: order_by;
  snapshot?: qx_Snapshot_order_by;
  snapshotID?: order_by;
  start?: qx_Event_order_by;
  startID?: order_by;
  status?: order_by;
  time?: order_by;
  toType?: qx_EventType_order_by;
  type?: order_by;
  typeStatusActiveID?: order_by;
  videoSource?: qx_VideoSource_order_by;
  videoSourceID?: order_by;
  zone?: IntrusionZone_order_by;
  zoneID?: order_by;
};

/** select columns of table "qx.vEvents" */
export enum vEvents_select_column {
  /** column name */
  active = 'active',
  /** column name */
  bits = 'bits',
  /** column name */
  card = 'card',
  /** column name */
  cloudTime = 'cloudTime',
  /** column name */
  deviceDIOID = 'deviceDIOID',
  /** column name */
  deviceID = 'deviceID',
  /** column name */
  doorID = 'doorID',
  /** column name */
  duration = 'duration',
  /** column name */
  eventEnd = 'eventEnd',
  /** column name */
  eventStart = 'eventStart',
  /** column name */
  gatewayID = 'gatewayID',
  /** column name */
  hasVideo = 'hasVideo',
  /** column name */
  id = 'id',
  /** column name */
  inCloud = 'inCloud',
  /** column name */
  mediaProfileID = 'mediaProfileID',
  /** column name */
  onGateway = 'onGateway',
  /** column name */
  partitionID = 'partitionID',
  /** column name */
  personID = 'personID',
  /** column name */
  placeID = 'placeID',
  /** column name */
  profile = 'profile',
  /** column name */
  readerID = 'readerID',
  /** column name */
  sensorID = 'sensorID',
  /** column name */
  serverTime = 'serverTime',
  /** column name */
  snapshotID = 'snapshotID',
  /** column name */
  startID = 'startID',
  /** column name */
  status = 'status',
  /** column name */
  time = 'time',
  /** column name */
  type = 'type',
  /** column name */
  typeStatusActiveID = 'typeStatusActiveID',
  /** column name */
  videoSourceID = 'videoSourceID',
  /** column name */
  zoneID = 'zoneID'
}

/** aggregate stddev on columns */
export type vEvents_stddev_fields = {
  __typename?: 'vEvents_stddev_fields';
  bits?: number;
  doorID?: number;
  id?: number;
  mediaProfileID?: number;
  sensorID?: number;
  startID?: number;
  typeStatusActiveID?: number;
  videoSourceID?: number;
};

/** aggregate stddev_pop on columns */
export type vEvents_stddev_pop_fields = {
  __typename?: 'vEvents_stddev_pop_fields';
  bits?: number;
  doorID?: number;
  id?: number;
  mediaProfileID?: number;
  sensorID?: number;
  startID?: number;
  typeStatusActiveID?: number;
  videoSourceID?: number;
};

/** aggregate stddev_samp on columns */
export type vEvents_stddev_samp_fields = {
  __typename?: 'vEvents_stddev_samp_fields';
  bits?: number;
  doorID?: number;
  id?: number;
  mediaProfileID?: number;
  sensorID?: number;
  startID?: number;
  typeStatusActiveID?: number;
  videoSourceID?: number;
};

/** Streaming cursor of the table "vEvents" */
export type vEvents_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: vEvents_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type vEvents_stream_cursor_value_input = {
  active?: boolean;
  bits?: number;
  card?: string;
  cloudTime?: string;
  deviceDIOID?: string;
  deviceID?: string;
  doorID?: string;
  duration?: any;
  eventEnd?: string;
  eventStart?: string;
  gatewayID?: string;
  hasVideo?: boolean;
  id?: string;
  inCloud?: boolean;
  mediaProfileID?: string;
  onGateway?: boolean;
  partitionID?: string;
  personID?: string;
  placeID?: string;
  profile?: string;
  readerID?: string;
  sensorID?: string;
  serverTime?: string;
  snapshotID?: string;
  startID?: string;
  status?: string;
  time?: string;
  type?: string;
  typeStatusActiveID?: string;
  videoSourceID?: string;
  zoneID?: string;
};

/** aggregate sum on columns */
export type vEvents_sum_fields = {
  __typename?: 'vEvents_sum_fields';
  bits?: number;
  doorID?: string;
  id?: string;
  mediaProfileID?: string;
  sensorID?: string;
  startID?: string;
  typeStatusActiveID?: string;
  videoSourceID?: string;
};

/** aggregate var_pop on columns */
export type vEvents_var_pop_fields = {
  __typename?: 'vEvents_var_pop_fields';
  bits?: number;
  doorID?: number;
  id?: number;
  mediaProfileID?: number;
  sensorID?: number;
  startID?: number;
  typeStatusActiveID?: number;
  videoSourceID?: number;
};

/** aggregate var_samp on columns */
export type vEvents_var_samp_fields = {
  __typename?: 'vEvents_var_samp_fields';
  bits?: number;
  doorID?: number;
  id?: number;
  mediaProfileID?: number;
  sensorID?: number;
  startID?: number;
  typeStatusActiveID?: number;
  videoSourceID?: number;
};

/** aggregate variance on columns */
export type vEvents_variance_fields = {
  __typename?: 'vEvents_variance_fields';
  bits?: number;
  doorID?: number;
  id?: number;
  mediaProfileID?: number;
  sensorID?: number;
  startID?: number;
  typeStatusActiveID?: number;
  videoSourceID?: number;
};

/** audit view tracking historical changes to video source configurations */
export type videoSourceAudit = {
  __typename?: 'videoSourceAudit';
  action?: string;
  auditID?: string;
  /** An object relationship */
  changedBy?: qx_Person;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  /** An object relationship */
  place?: qx_Place;
  place_id?: string;
  row_data?: any;
  time?: string;
  /** An object relationship */
  videoSource?: qx_VideoSource;
};


/** audit view tracking historical changes to video source configurations */
export type videoSourceAuditchanged_fieldsArgs = {
  path?: string;
};


/** audit view tracking historical changes to video source configurations */
export type videoSourceAuditrow_dataArgs = {
  path?: string;
};

/** aggregated selection of "audit.vVideoSourceAudit" */
export type videoSourceAudit_aggregate = {
  __typename?: 'videoSourceAudit_aggregate';
  aggregate?: videoSourceAudit_aggregate_fields;
  nodes: Array<videoSourceAudit>;
};

/** aggregate fields of "audit.vVideoSourceAudit" */
export type videoSourceAudit_aggregate_fields = {
  __typename?: 'videoSourceAudit_aggregate_fields';
  avg?: videoSourceAudit_avg_fields;
  count: number;
  max?: videoSourceAudit_max_fields;
  min?: videoSourceAudit_min_fields;
  stddev?: videoSourceAudit_stddev_fields;
  stddev_pop?: videoSourceAudit_stddev_pop_fields;
  stddev_samp?: videoSourceAudit_stddev_samp_fields;
  sum?: videoSourceAudit_sum_fields;
  var_pop?: videoSourceAudit_var_pop_fields;
  var_samp?: videoSourceAudit_var_samp_fields;
  variance?: videoSourceAudit_variance_fields;
};


/** aggregate fields of "audit.vVideoSourceAudit" */
export type videoSourceAudit_aggregate_fieldscountArgs = {
  columns?: Array<videoSourceAudit_select_column>;
  distinct?: boolean;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type videoSourceAudit_append_input = {
  changed_fields?: any;
  row_data?: any;
};

/** aggregate avg on columns */
export type videoSourceAudit_avg_fields = {
  __typename?: 'videoSourceAudit_avg_fields';
  auditID?: number;
  id?: number;
};

/** Boolean expression to filter rows from the table "audit.vVideoSourceAudit". All fields are combined with a logical 'AND'. */
export type videoSourceAudit_bool_exp = {
  _and?: Array<videoSourceAudit_bool_exp>;
  _not?: videoSourceAudit_bool_exp;
  _or?: Array<videoSourceAudit_bool_exp>;
  action?: String_comparison_exp;
  auditID?: bigint_comparison_exp;
  changedBy?: qx_Person_bool_exp;
  changed_fields?: jsonb_comparison_exp;
  id?: bigint_comparison_exp;
  person_id?: String_comparison_exp;
  place?: qx_Place_bool_exp;
  place_id?: String_comparison_exp;
  row_data?: jsonb_comparison_exp;
  time?: timestamptz_comparison_exp;
  videoSource?: qx_VideoSource_bool_exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type videoSourceAudit_delete_at_path_input = {
  changed_fields?: Array<string>;
  row_data?: Array<string>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type videoSourceAudit_delete_elem_input = {
  changed_fields?: number;
  row_data?: number;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type videoSourceAudit_delete_key_input = {
  changed_fields?: string;
  row_data?: string;
};

/** input type for incrementing numeric columns in table "audit.vVideoSourceAudit" */
export type videoSourceAudit_inc_input = {
  auditID?: string;
  id?: string;
};

/** input type for inserting data into table "audit.vVideoSourceAudit" */
export type videoSourceAudit_insert_input = {
  action?: string;
  auditID?: string;
  changedBy?: qx_Person_obj_rel_insert_input;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place?: qx_Place_obj_rel_insert_input;
  place_id?: string;
  row_data?: any;
  time?: string;
  videoSource?: qx_VideoSource_obj_rel_insert_input;
};

/** aggregate max on columns */
export type videoSourceAudit_max_fields = {
  __typename?: 'videoSourceAudit_max_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** aggregate min on columns */
export type videoSourceAudit_min_fields = {
  __typename?: 'videoSourceAudit_min_fields';
  action?: string;
  auditID?: string;
  id?: string;
  person_id?: string;
  place_id?: string;
  time?: string;
};

/** response of any mutation on the table "audit.vVideoSourceAudit" */
export type videoSourceAudit_mutation_response = {
  __typename?: 'videoSourceAudit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<videoSourceAudit>;
};

/** Ordering options when selecting data from "audit.vVideoSourceAudit". */
export type videoSourceAudit_order_by = {
  action?: order_by;
  auditID?: order_by;
  changedBy?: qx_Person_order_by;
  changed_fields?: order_by;
  id?: order_by;
  person_id?: order_by;
  place?: qx_Place_order_by;
  place_id?: order_by;
  row_data?: order_by;
  time?: order_by;
  videoSource?: qx_VideoSource_order_by;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type videoSourceAudit_prepend_input = {
  changed_fields?: any;
  row_data?: any;
};

/** select columns of table "audit.vVideoSourceAudit" */
export enum videoSourceAudit_select_column {
  /** column name */
  action = 'action',
  /** column name */
  auditID = 'auditID',
  /** column name */
  changed_fields = 'changed_fields',
  /** column name */
  id = 'id',
  /** column name */
  person_id = 'person_id',
  /** column name */
  place_id = 'place_id',
  /** column name */
  row_data = 'row_data',
  /** column name */
  time = 'time'
}

/** input type for updating data in table "audit.vVideoSourceAudit" */
export type videoSourceAudit_set_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate stddev on columns */
export type videoSourceAudit_stddev_fields = {
  __typename?: 'videoSourceAudit_stddev_fields';
  auditID?: number;
  id?: number;
};

/** aggregate stddev_pop on columns */
export type videoSourceAudit_stddev_pop_fields = {
  __typename?: 'videoSourceAudit_stddev_pop_fields';
  auditID?: number;
  id?: number;
};

/** aggregate stddev_samp on columns */
export type videoSourceAudit_stddev_samp_fields = {
  __typename?: 'videoSourceAudit_stddev_samp_fields';
  auditID?: number;
  id?: number;
};

/** Streaming cursor of the table "videoSourceAudit" */
export type videoSourceAudit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: videoSourceAudit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type videoSourceAudit_stream_cursor_value_input = {
  action?: string;
  auditID?: string;
  changed_fields?: any;
  id?: string;
  person_id?: string;
  place_id?: string;
  row_data?: any;
  time?: string;
};

/** aggregate sum on columns */
export type videoSourceAudit_sum_fields = {
  __typename?: 'videoSourceAudit_sum_fields';
  auditID?: string;
  id?: string;
};

export type videoSourceAudit_updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: videoSourceAudit_append_input;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: videoSourceAudit_delete_at_path_input;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: videoSourceAudit_delete_elem_input;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: videoSourceAudit_delete_key_input;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: videoSourceAudit_inc_input;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: videoSourceAudit_prepend_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: videoSourceAudit_set_input;
  /** filter the rows which have to be updated */
  where: videoSourceAudit_bool_exp;
};

/** aggregate var_pop on columns */
export type videoSourceAudit_var_pop_fields = {
  __typename?: 'videoSourceAudit_var_pop_fields';
  auditID?: number;
  id?: number;
};

/** aggregate var_samp on columns */
export type videoSourceAudit_var_samp_fields = {
  __typename?: 'videoSourceAudit_var_samp_fields';
  auditID?: number;
  id?: number;
};

/** aggregate variance on columns */
export type videoSourceAudit_variance_fields = {
  __typename?: 'videoSourceAudit_variance_fields';
  auditID?: number;
  id?: number;
};

/** columns and relationships of "qx.VideoSourceState" */
export type videoSourceState = {
  __typename?: 'videoSourceState';
  lastMotionAt?: string;
  motionActive: boolean;
  /** An object relationship */
  videoSource: qx_VideoSource;
  videoSourceID: string;
};

/** aggregated selection of "qx.VideoSourceState" */
export type videoSourceState_aggregate = {
  __typename?: 'videoSourceState_aggregate';
  aggregate?: videoSourceState_aggregate_fields;
  nodes: Array<videoSourceState>;
};

/** aggregate fields of "qx.VideoSourceState" */
export type videoSourceState_aggregate_fields = {
  __typename?: 'videoSourceState_aggregate_fields';
  avg?: videoSourceState_avg_fields;
  count: number;
  max?: videoSourceState_max_fields;
  min?: videoSourceState_min_fields;
  stddev?: videoSourceState_stddev_fields;
  stddev_pop?: videoSourceState_stddev_pop_fields;
  stddev_samp?: videoSourceState_stddev_samp_fields;
  sum?: videoSourceState_sum_fields;
  var_pop?: videoSourceState_var_pop_fields;
  var_samp?: videoSourceState_var_samp_fields;
  variance?: videoSourceState_variance_fields;
};


/** aggregate fields of "qx.VideoSourceState" */
export type videoSourceState_aggregate_fieldscountArgs = {
  columns?: Array<videoSourceState_select_column>;
  distinct?: boolean;
};

/** aggregate avg on columns */
export type videoSourceState_avg_fields = {
  __typename?: 'videoSourceState_avg_fields';
  videoSourceID?: number;
};

/** Boolean expression to filter rows from the table "qx.VideoSourceState". All fields are combined with a logical 'AND'. */
export type videoSourceState_bool_exp = {
  _and?: Array<videoSourceState_bool_exp>;
  _not?: videoSourceState_bool_exp;
  _or?: Array<videoSourceState_bool_exp>;
  lastMotionAt?: timestamptz_comparison_exp;
  motionActive?: Boolean_comparison_exp;
  videoSource?: qx_VideoSource_bool_exp;
  videoSourceID?: bigint_comparison_exp;
};

/** unique or primary key constraints on table "qx.VideoSourceState" */
export enum videoSourceState_constraint {
  /** unique or primary key constraint on columns "videoSourceID" */
  VideoSourceState_pkey = 'VideoSourceState_pkey'
}

/** input type for incrementing numeric columns in table "qx.VideoSourceState" */
export type videoSourceState_inc_input = {
  videoSourceID?: string;
};

/** input type for inserting data into table "qx.VideoSourceState" */
export type videoSourceState_insert_input = {
  lastMotionAt?: string;
  motionActive?: boolean;
  videoSource?: qx_VideoSource_obj_rel_insert_input;
  videoSourceID?: string;
};

/** aggregate max on columns */
export type videoSourceState_max_fields = {
  __typename?: 'videoSourceState_max_fields';
  lastMotionAt?: string;
  videoSourceID?: string;
};

/** aggregate min on columns */
export type videoSourceState_min_fields = {
  __typename?: 'videoSourceState_min_fields';
  lastMotionAt?: string;
  videoSourceID?: string;
};

/** response of any mutation on the table "qx.VideoSourceState" */
export type videoSourceState_mutation_response = {
  __typename?: 'videoSourceState_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: number;
  /** data from the rows affected by the mutation */
  returning: Array<videoSourceState>;
};

/** input type for inserting object relation for remote table "qx.VideoSourceState" */
export type videoSourceState_obj_rel_insert_input = {
  data: videoSourceState_insert_input;
  /** upsert condition */
  on_conflict?: videoSourceState_on_conflict;
};

/** on_conflict condition type for table "qx.VideoSourceState" */
export type videoSourceState_on_conflict = {
  constraint: videoSourceState_constraint;
  update_columns?: Array<videoSourceState_update_column>;
  where?: videoSourceState_bool_exp;
};

/** Ordering options when selecting data from "qx.VideoSourceState". */
export type videoSourceState_order_by = {
  lastMotionAt?: order_by;
  motionActive?: order_by;
  videoSource?: qx_VideoSource_order_by;
  videoSourceID?: order_by;
};

/** primary key columns input for table: qx.VideoSourceState */
export type videoSourceState_pk_columns_input = {
  videoSourceID: string;
};

/** select columns of table "qx.VideoSourceState" */
export enum videoSourceState_select_column {
  /** column name */
  lastMotionAt = 'lastMotionAt',
  /** column name */
  motionActive = 'motionActive',
  /** column name */
  videoSourceID = 'videoSourceID'
}

/** input type for updating data in table "qx.VideoSourceState" */
export type videoSourceState_set_input = {
  lastMotionAt?: string;
  motionActive?: boolean;
  videoSourceID?: string;
};

/** aggregate stddev on columns */
export type videoSourceState_stddev_fields = {
  __typename?: 'videoSourceState_stddev_fields';
  videoSourceID?: number;
};

/** aggregate stddev_pop on columns */
export type videoSourceState_stddev_pop_fields = {
  __typename?: 'videoSourceState_stddev_pop_fields';
  videoSourceID?: number;
};

/** aggregate stddev_samp on columns */
export type videoSourceState_stddev_samp_fields = {
  __typename?: 'videoSourceState_stddev_samp_fields';
  videoSourceID?: number;
};

/** Streaming cursor of the table "videoSourceState" */
export type videoSourceState_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: videoSourceState_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: cursor_ordering;
};

/** Initial value of the column from where the streaming should start */
export type videoSourceState_stream_cursor_value_input = {
  lastMotionAt?: string;
  motionActive?: boolean;
  videoSourceID?: string;
};

/** aggregate sum on columns */
export type videoSourceState_sum_fields = {
  __typename?: 'videoSourceState_sum_fields';
  videoSourceID?: string;
};

/** update columns of table "qx.VideoSourceState" */
export enum videoSourceState_update_column {
  /** column name */
  lastMotionAt = 'lastMotionAt',
  /** column name */
  motionActive = 'motionActive',
  /** column name */
  videoSourceID = 'videoSourceID'
}

export type videoSourceState_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: videoSourceState_inc_input;
  /** sets the columns of the filtered rows to the given values */
  _set?: videoSourceState_set_input;
  /** filter the rows which have to be updated */
  where: videoSourceState_bool_exp;
};

/** aggregate var_pop on columns */
export type videoSourceState_var_pop_fields = {
  __typename?: 'videoSourceState_var_pop_fields';
  videoSourceID?: number;
};

/** aggregate var_samp on columns */
export type videoSourceState_var_samp_fields = {
  __typename?: 'videoSourceState_var_samp_fields';
  videoSourceID?: number;
};

/** aggregate variance on columns */
export type videoSourceState_variance_fields = {
  __typename?: 'videoSourceState_variance_fields';
  videoSourceID?: number;
};

export type GQL_PREP_LIVE_VIDEO_PLAYERQueryVariables = Exact<{
  id: string;
}>;


export type GQL_PREP_LIVE_VIDEO_PLAYERQuery = { __typename?: 'query_root', videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string, enabled: boolean, cloudStorageDays: number, cloudStorageTimelapseDays: number, timelapseInterval: number, fps?: number | undefined, imageSize?: string | undefined, imagingSettings?: any | undefined, imagingOptions?: any | undefined, ptzSettings?: any | undefined, deviceID: string, gatewayID?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string }, snapshots?: Array<{ __typename?: 'qx_Snapshot', id: string, base64?: string | undefined, signedUrl?: string | undefined }> | undefined, device: { __typename?: 'qx_Device', id: string, name: string, kind: qx_eDeviceKind_enum, gatewayID: string, make?: string | undefined, model?: string | undefined, serial?: string | undefined, firmware?: string | undefined, connectionStatus: qx_eDeviceConnectionStatus_enum, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string }>, gateway: { __typename?: 'qx_Gateway', id: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, name: string, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, path: string } } }, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, refID: string, videoSourceID: any, snapshotUrl?: string | undefined, videoEncoderSettings?: any | undefined, streamEnabled: boolean, streamStatus: qx_eStreamStatus_enum, streamFile: string, viewToken?: string | undefined, liveToken?: string | undefined, ptzToken?: string | undefined, ptzPresets?: any | undefined, snapshotToken?: string | undefined, audioCodec?: string | undefined, audioEncoderSettings?: any | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, refID: string, enabled: boolean } | undefined }> }> };

export type GQL_AI_BILLING_SUMMARYQueryVariables = Exact<{
  placeId: string;
}>;


export type GQL_AI_BILLING_SUMMARYQuery = { __typename?: 'query_root', place?: { __typename?: 'qx_Place', id: string, aiBillingSummary?: { __typename?: 'qx_vPlaceAiBillingSummary', placeID?: string | undefined, billingTier?: string | undefined, monthlyTokenQuota?: number | undefined, tokensUsed?: number | undefined, centsUsed?: number | undefined, overageBudgetCents?: number | undefined, billingPeriodStart?: any | undefined, billingPeriodEnd?: any | undefined } | undefined } | undefined };

export type GQL_SUB_AI_BILLING_SUMMARYSubscriptionVariables = Exact<{
  billingPlaceId: string;
  billingPeriodStart: string;
  billingPeriodEnd: string;
}>;


export type GQL_SUB_AI_BILLING_SUMMARYSubscription = { __typename?: 'subscription_root', qx_vPlaceAiBillingSummary: Array<{ __typename?: 'qx_vPlaceAiBillingSummary', placeID?: string | undefined, billingTier?: string | undefined, monthlyTokenQuota?: number | undefined, tokensUsed?: number | undefined, centsUsed?: number | undefined, overageBudgetCents?: number | undefined, billingPeriodStart?: any | undefined, billingPeriodEnd?: any | undefined }> };

export type GQL_GET_APP_PASSWORDSQueryVariables = Exact<{
  personID: string;
}>;


export type GQL_GET_APP_PASSWORDSQuery = { __typename?: 'query_root', applicationUserAppPasswords: Array<{ __typename?: 'applicationUserAppPasswords', id: any, label: string, qxApi?: boolean | undefined, createdAt: any, lastUsedAt?: any | undefined }> };

export type GQL_CREATE_APP_PASSWORDMutationVariables = Exact<{ [key: string]: never; }>;


export type GQL_CREATE_APP_PASSWORDMutation = { __typename?: 'mutation_root', createAppPassword: { __typename?: 'AppPassword', token: string } };

export type GQL_DELETE_APP_PASSWORDMutationVariables = Exact<{
  id: string;
}>;


export type GQL_DELETE_APP_PASSWORDMutation = { __typename?: 'mutation_root', delete_applicationUserAppPasswords_by_pk?: { __typename?: 'applicationUserAppPasswords', id: any } | undefined };

export type AuthWebDeviceFragment = { __typename?: 'applicationUserDevices', id: any, label?: string | undefined, createdAt?: any | undefined, lastUsedAt?: any | undefined, provider?: { __typename?: 'PassKeyProvider', aaguid: string, icon_dark?: string | undefined, icon_light?: string | undefined, name: string } | undefined };

export type GQL_USER_AUTH_DEVICESQueryVariables = Exact<{ [key: string]: never; }>;


export type GQL_USER_AUTH_DEVICESQuery = { __typename?: 'query_root', applicationUserDevices: Array<{ __typename?: 'applicationUserDevices', id: any, label?: string | undefined, createdAt?: any | undefined, lastUsedAt?: any | undefined, provider?: { __typename?: 'PassKeyProvider', aaguid: string, icon_dark?: string | undefined, icon_light?: string | undefined, name: string } | undefined }> };

export type GQL_SUB_AUTH_DEVICESSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GQL_SUB_AUTH_DEVICESSubscription = { __typename?: 'subscription_root', applicationUserDevices: Array<{ __typename?: 'applicationUserDevices', id: any, label?: string | undefined, createdAt?: any | undefined, lastUsedAt?: any | undefined, provider?: { __typename?: 'PassKeyProvider', aaguid: string, icon_dark?: string | undefined, icon_light?: string | undefined, name: string } | undefined }> };

export type GQL_SET_DEVICE_LABEL_FOR_PASSKEY_REGISTRATIONMutationVariables = Exact<{
  label: string;
  deviceID: string;
  personID: string;
}>;


export type GQL_SET_DEVICE_LABEL_FOR_PASSKEY_REGISTRATIONMutation = { __typename?: 'mutation_root', update_applicationUserDevices?: { __typename?: 'applicationUserDevices_mutation_response', affected_rows: number } | undefined };

export type GQL_GET_AUTH_SESSIONSQueryVariables = Exact<{ [key: string]: never; }>;


export type GQL_GET_AUTH_SESSIONSQuery = { __typename?: 'query_root', authSessions: Array<{ __typename?: 'AuthSession', id: string, ip: string, current: boolean, lastUsed: any, expiresAt: any, signedInAt: any, strategy: AuthStrategy, type: SessionType, device?: { __typename?: 'AuthSessionDevice', client: { __typename?: 'AuthSessionDeviceClient', engine?: string | undefined, engine_version?: string | undefined, name?: string | undefined, short_name?: string | undefined, type?: string | undefined, version?: string | undefined, family?: string | undefined }, device: { __typename?: 'AuthSessionDeviceInfo', brand?: string | undefined, id?: string | undefined, model?: string | undefined, type?: string | undefined }, os: { __typename?: 'AuthSessionDeviceOS', family?: string | undefined, name?: string | undefined, platform?: string | undefined, short_name?: string | undefined, version?: string | undefined } } | undefined, location?: { __typename?: 'AuthSessionLocation', city?: string | undefined, country?: string | undefined } | undefined }> };

export type GQL_GET_BILLING_PERIODSQueryVariables = Exact<{ [key: string]: never; }>;


export type GQL_GET_BILLING_PERIODSQuery = { __typename?: 'query_root', billingPeriods: Array<{ __typename?: 'qx_BillingPeriod', name: string, billingPeriodMonths: number }> };

export type GQL_GET_BILLING_TIERSQueryVariables = Exact<{ [key: string]: never; }>;


export type GQL_GET_BILLING_TIERSQuery = { __typename?: 'query_root', billingTierEnums: Array<{ __typename?: 'qx_eBillingTier', value: string, comment: string, monthlyPriceCents: number, monthlyTokenQuota: number }> };

export type GQL_GET_VIDEO_SOURCE_STORAGE_USEDQueryVariables = Exact<{
  videoSourceId: string;
}>;


export type GQL_GET_VIDEO_SOURCE_STORAGE_USEDQuery = { __typename?: 'query_root', videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, cloudStorageUsed?: string | undefined, cloudStorageAvailable?: string | undefined, cloudStorageMax?: string | undefined } | undefined };

export type GQL_GET_EVENT_TYPES_AND_STATUSESQueryVariables = Exact<{ [key: string]: never; }>;


export type GQL_GET_EVENT_TYPES_AND_STATUSESQuery = { __typename?: 'query_root', eventTypes: Array<{ __typename?: 'qx_EventType', type: string, statusTable?: string | undefined, id: string, statusValues?: Array<{ __typename?: 'qx_eDeviceConnectionStatus', comment?: string | undefined, value: string }> | undefined }> };

export type GQL_GET_EVENT_BY_IDQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_EVENT_BY_IDQuery = { __typename?: 'query_root', vEvents: Array<{ __typename?: 'vEvents', id?: any | undefined, active?: boolean | undefined, card?: string | undefined, bits?: number | undefined, status?: string | undefined, time?: any | undefined, type?: string | undefined, duration?: any | undefined, hasVideo?: boolean | undefined, inCloud?: boolean | undefined, onGateway?: boolean | undefined, eventStart?: any | undefined, eventEnd?: any | undefined, personID?: string | undefined, doorID?: any | undefined, videoSourceID?: any | undefined, deviceID?: string | undefined, zoneID?: string | undefined, partitionID?: string | undefined, placeID?: string | undefined, profile?: string | undefined, serverTime?: any | undefined, person?: { __typename?: 'qx_Person', id: string, avatar_sm?: string | undefined, firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined } | undefined, door?: { __typename?: 'qx_Door', id: any, name: string } | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string } | undefined, device?: { __typename?: 'qx_Device', id: string, name: string } | undefined, zone?: { __typename?: 'IntrusionZone', id: string, name: string } | undefined, partition?: { __typename?: 'IntrusionPartition', id: string, name: string } | undefined, place?: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, type: eGatewayType_enum } | undefined } | undefined, snapshot?: { __typename?: 'qx_Snapshot', id: string, signedUrl?: string | undefined } | undefined }> };

export type GQ_GET_CAMERA_CLIP_INFOQueryVariables = Exact<{
  id: string;
  start: string;
  end: string;
}>;


export type GQ_GET_CAMERA_CLIP_INFOQuery = { __typename?: 'query_root', videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, deviceID: string, gatewayID?: string | undefined, snapshotMediaProfileID?: any | undefined, timelapseInterval: number, place: { __typename?: 'qx_Place', id: string, name: string }, device: { __typename?: 'qx_Device', id: string, name: string, make?: string | undefined, model?: string | undefined, gateway: { __typename?: 'qx_Gateway', id: string, name: string, type: eGatewayType_enum } }, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, refID: string, viewToken?: string | undefined, cloudViewToken?: string | undefined, cloudSnapshotToken?: string | undefined, snapshotToken?: string | undefined, audioEncoderSettings?: any | undefined, videoEncoderSettings?: any | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, enabled: boolean } | undefined }> } | undefined, getMediaProfileRecording: Array<{ __typename?: 'MediaProfileRecordingItem', baseDate: any, mediaProfileID: string, recordings: any, type: string } | undefined> };

export type GQL_GET_SYSTEM_INFORMATIONQueryVariables = Exact<{ [key: string]: never; }>;


export type GQL_GET_SYSTEM_INFORMATIONQuery = { __typename?: 'query_root', systemInformation: Array<{ __typename?: 'SysInfo', bootTime?: any | undefined, gatewayID?: string | undefined, env: string, error?: string | undefined, name: string, prodLevel?: string | undefined, time?: any | undefined, version?: string | undefined }> };

export type CameraDeviceGatewayFieldsFragment = { __typename?: 'qx_VideoSource', deviceID: string, gatewayID?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined };

export type CameraSearchFragment = { __typename?: 'qx_VideoSource', id: any, enabled: boolean, name: string, profileMSupported?: boolean | undefined, metadataEnabled?: boolean | undefined, scheduleID?: string | undefined, cloudStorageDays: number, cloudStorageTimelapseDays: number, timelapseInterval: number, deviceID: string, gatewayID?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, state?: { __typename?: 'videoSourceState', videoSourceID: any, lastMotionAt?: any | undefined } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined }, audioSources: Array<{ __typename?: 'audioSourceVideoSource', audioSourceID?: any | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, enabled: boolean } | undefined }>, device: { __typename?: 'qx_Device', id: string, make?: string | undefined, model?: string | undefined, kind: qx_eDeviceKind_enum, serial?: string | undefined, firmware?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, port: number, tls: boolean, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, type: eGatewayType_enum, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum } }, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, refID: string, streamEnabled: boolean, streamStatus: qx_eStreamStatus_enum, deletedAt?: any | undefined }> };

export type CameraFieldsFragment = { __typename?: 'qx_VideoSource', id: any, name: string, description?: string | undefined, enabled: boolean, cloudStorageDays: number, cloudStorageTimelapseDays: number, snapshotMediaProfileID?: any | undefined, timelapseInterval: number, mountPosition?: qx_eMountPosition_enum | undefined, profileMSupported?: boolean | undefined, metadataEnabled?: boolean | undefined, deviceID: string, fps?: number | undefined, imageSize?: string | undefined, imagingSettings?: any | undefined, imagingOptions?: any | undefined, gatewayID?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, state?: { __typename?: 'videoSourceState', videoSourceID: any, lastMotionAt?: any | undefined } | undefined, audioSources: Array<{ __typename?: 'audioSourceVideoSource', audioSourceID?: any | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, enabled: boolean } | undefined }>, schedule?: { __typename?: 'qx_Schedule', id: string, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, date: any, duration: string, weekdays?: string | undefined }> } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined }, device: { __typename?: 'qx_Device', id: string, name: string, profileMSupported?: boolean | undefined, gatewayID: string, port: number, tls: boolean, make?: string | undefined, model?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, deviceUsername?: string | undefined, devicePassword?: string | undefined, serial?: string | undefined, kind: qx_eDeviceKind_enum, firmware?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, createdAt: any, oldestMedia?: Array<{ __typename?: 'qx_vOldestMedia', type?: string | undefined, date?: any | undefined }> | undefined, audioSources: Array<{ __typename?: 'qx_AudioSource', id: any, name: string, refID: string, enabled: boolean, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, audioEncoderSettings?: any | undefined, videoSourceID: any }> }>, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, nics?: any | undefined, place: { __typename?: 'qx_Place', id: string, name: string, timezone?: string | undefined, type: qx_ePlaceType_enum, path: string } }, deviceAnalyticSources: Array<{ __typename?: 'deviceAnalyticSource', id: number, analyticSource: { __typename?: 'AnalyticSources', id: number, comment?: string | undefined, value: string } }> }, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, refID: string, videoSourceID: any, snapshotUrl?: string | undefined, videoEncoderSettings?: any | undefined, streamEnabled: boolean, streamStatus: qx_eStreamStatus_enum, streamFile: string, audioEncoderSettings?: any | undefined, audioCodec?: string | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, refID: string, enabled: boolean } | undefined }> };

export type SingleCameraSubscriptionFragment = { __typename?: 'qx_VideoSource', id: any, name: string, description?: string | undefined, enabled: boolean, cloudStorageDays: number, cloudStorageTimelapseDays: number, snapshotMediaProfileID?: any | undefined, timelapseInterval: number, mountPosition?: qx_eMountPosition_enum | undefined, profileMSupported?: boolean | undefined, metadataEnabled?: boolean | undefined, deviceID: string, fps?: number | undefined, imageSize?: string | undefined, imagingSettings?: any | undefined, imagingOptions?: any | undefined, gatewayID?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, state?: { __typename?: 'videoSourceState', videoSourceID: any, lastMotionAt?: any | undefined } | undefined, audioSources: Array<{ __typename?: 'audioSourceVideoSource', audioSourceID?: any | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, enabled: boolean } | undefined }>, schedule?: { __typename?: 'qx_Schedule', id: string, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, date: any, duration: string, weekdays?: string | undefined }> } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined }, device: { __typename?: 'qx_Device', id: string, name: string, profileMSupported?: boolean | undefined, gatewayID: string, port: number, tls: boolean, make?: string | undefined, model?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, deviceUsername?: string | undefined, devicePassword?: string | undefined, serial?: string | undefined, kind: qx_eDeviceKind_enum, firmware?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, createdAt: any, oldestMedia?: Array<{ __typename?: 'qx_vOldestMedia', type?: string | undefined, date?: any | undefined }> | undefined, audioSources: Array<{ __typename?: 'qx_AudioSource', id: any, name: string, refID: string, enabled: boolean, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, audioEncoderSettings?: any | undefined, videoSourceID: any }> }>, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, nics?: any | undefined, place: { __typename?: 'qx_Place', id: string, name: string, timezone?: string | undefined, type: qx_ePlaceType_enum, path: string } }, deviceAnalyticSources: Array<{ __typename?: 'deviceAnalyticSource', id: number, analyticSource: { __typename?: 'AnalyticSources', id: number, comment?: string | undefined, value: string } }> }, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, refID: string, videoSourceID: any, snapshotUrl?: string | undefined, videoEncoderSettings?: any | undefined, streamEnabled: boolean, streamStatus: qx_eStreamStatus_enum, streamFile: string, audioEncoderSettings?: any | undefined, audioCodec?: string | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, refID: string, enabled: boolean } | undefined }> };

export type SnapshotsFieldFragment = { __typename?: 'qx_VideoSource', snapshots?: Array<{ __typename?: 'qx_Snapshot', id: string, base64?: string | undefined, signedUrl?: string | undefined, aspectRatio?: any | undefined }> | undefined };

export type SingleCameraFragment = { __typename?: 'qx_VideoSource', id: any, name: string, description?: string | undefined, enabled: boolean, cloudStorageDays: number, cloudStorageTimelapseDays: number, snapshotMediaProfileID?: any | undefined, timelapseInterval: number, mountPosition?: qx_eMountPosition_enum | undefined, profileMSupported?: boolean | undefined, metadataEnabled?: boolean | undefined, deviceID: string, fps?: number | undefined, imageSize?: string | undefined, imagingSettings?: any | undefined, imagingOptions?: any | undefined, gatewayID?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, state?: { __typename?: 'videoSourceState', videoSourceID: any, lastMotionAt?: any | undefined } | undefined, audioSources: Array<{ __typename?: 'audioSourceVideoSource', audioSourceID?: any | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, enabled: boolean } | undefined }>, schedule?: { __typename?: 'qx_Schedule', id: string, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, date: any, duration: string, weekdays?: string | undefined }> } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined }, device: { __typename?: 'qx_Device', id: string, name: string, profileMSupported?: boolean | undefined, gatewayID: string, port: number, tls: boolean, make?: string | undefined, model?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, deviceUsername?: string | undefined, devicePassword?: string | undefined, serial?: string | undefined, kind: qx_eDeviceKind_enum, firmware?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, createdAt: any, oldestMedia?: Array<{ __typename?: 'qx_vOldestMedia', type?: string | undefined, date?: any | undefined }> | undefined, audioSources: Array<{ __typename?: 'qx_AudioSource', id: any, name: string, refID: string, enabled: boolean, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, audioEncoderSettings?: any | undefined, videoSourceID: any }> }>, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, nics?: any | undefined, place: { __typename?: 'qx_Place', id: string, name: string, timezone?: string | undefined, type: qx_ePlaceType_enum, path: string } }, deviceAnalyticSources: Array<{ __typename?: 'deviceAnalyticSource', id: number, analyticSource: { __typename?: 'AnalyticSources', id: number, comment?: string | undefined, value: string } }> }, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, refID: string, videoSourceID: any, snapshotUrl?: string | undefined, videoEncoderSettings?: any | undefined, streamEnabled: boolean, streamStatus: qx_eStreamStatus_enum, streamFile: string, audioEncoderSettings?: any | undefined, audioCodec?: string | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, refID: string, enabled: boolean } | undefined }>, snapshots?: Array<{ __typename?: 'qx_Snapshot', id: string, base64?: string | undefined, signedUrl?: string | undefined, aspectRatio?: any | undefined }> | undefined };

export type LiveScrollerCameraResolveFragment = { __typename?: 'qx_VideoSource', id: any, name: string };

export type MediaProfileFormFragment = { __typename?: 'qx_MediaProfile', id: any, deviceID: string, refID: string, streamEnabled: boolean, warped: boolean, videoEncoderOptions?: any | undefined, videoEncoderSettings?: any | undefined };

export type GQL_CREATE_CAMERA_DEVICEMutationVariables = Exact<{
  device: CreateDeviceInput;
}>;


export type GQL_CREATE_CAMERA_DEVICEMutation = { __typename?: 'mutation_root', createDevices: Array<{ __typename?: 'CreateDeviceOutput', id: string, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string, description?: string | undefined, enabled: boolean, cloudStorageDays: number, cloudStorageTimelapseDays: number, snapshotMediaProfileID?: any | undefined, timelapseInterval: number, mountPosition?: qx_eMountPosition_enum | undefined, profileMSupported?: boolean | undefined, metadataEnabled?: boolean | undefined, deviceID: string, fps?: number | undefined, imageSize?: string | undefined, imagingSettings?: any | undefined, imagingOptions?: any | undefined, gatewayID?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, state?: { __typename?: 'videoSourceState', videoSourceID: any, lastMotionAt?: any | undefined } | undefined, audioSources: Array<{ __typename?: 'audioSourceVideoSource', audioSourceID?: any | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, enabled: boolean } | undefined }>, schedule?: { __typename?: 'qx_Schedule', id: string, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, date: any, duration: string, weekdays?: string | undefined }> } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined }, device: { __typename?: 'qx_Device', id: string, name: string, profileMSupported?: boolean | undefined, gatewayID: string, port: number, tls: boolean, make?: string | undefined, model?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, deviceUsername?: string | undefined, devicePassword?: string | undefined, serial?: string | undefined, kind: qx_eDeviceKind_enum, firmware?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, createdAt: any, oldestMedia?: Array<{ __typename?: 'qx_vOldestMedia', type?: string | undefined, date?: any | undefined }> | undefined, audioSources: Array<{ __typename?: 'qx_AudioSource', id: any, name: string, refID: string, enabled: boolean, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, audioEncoderSettings?: any | undefined, videoSourceID: any }> }>, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, nics?: any | undefined, place: { __typename?: 'qx_Place', id: string, name: string, timezone?: string | undefined, type: qx_ePlaceType_enum, path: string } }, deviceAnalyticSources: Array<{ __typename?: 'deviceAnalyticSource', id: number, analyticSource: { __typename?: 'AnalyticSources', id: number, comment?: string | undefined, value: string } }> }, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, refID: string, videoSourceID: any, snapshotUrl?: string | undefined, videoEncoderSettings?: any | undefined, streamEnabled: boolean, streamStatus: qx_eStreamStatus_enum, streamFile: string, audioEncoderSettings?: any | undefined, audioCodec?: string | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, refID: string, enabled: boolean } | undefined }>, snapshots?: Array<{ __typename?: 'qx_Snapshot', id: string, base64?: string | undefined, signedUrl?: string | undefined, aspectRatio?: any | undefined }> | undefined }> }> };

export type GQL_GET_CAMERA_BY_IDQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_CAMERA_BY_IDQuery = { __typename?: 'query_root', videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, description?: string | undefined, enabled: boolean, cloudStorageDays: number, cloudStorageTimelapseDays: number, snapshotMediaProfileID?: any | undefined, timelapseInterval: number, mountPosition?: qx_eMountPosition_enum | undefined, profileMSupported?: boolean | undefined, metadataEnabled?: boolean | undefined, deviceID: string, fps?: number | undefined, imageSize?: string | undefined, imagingSettings?: any | undefined, imagingOptions?: any | undefined, gatewayID?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, state?: { __typename?: 'videoSourceState', videoSourceID: any, lastMotionAt?: any | undefined } | undefined, audioSources: Array<{ __typename?: 'audioSourceVideoSource', audioSourceID?: any | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, enabled: boolean } | undefined }>, schedule?: { __typename?: 'qx_Schedule', id: string, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, date: any, duration: string, weekdays?: string | undefined }> } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined }, device: { __typename?: 'qx_Device', id: string, name: string, profileMSupported?: boolean | undefined, gatewayID: string, port: number, tls: boolean, make?: string | undefined, model?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, deviceUsername?: string | undefined, devicePassword?: string | undefined, serial?: string | undefined, kind: qx_eDeviceKind_enum, firmware?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, createdAt: any, oldestMedia?: Array<{ __typename?: 'qx_vOldestMedia', type?: string | undefined, date?: any | undefined }> | undefined, audioSources: Array<{ __typename?: 'qx_AudioSource', id: any, name: string, refID: string, enabled: boolean, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, audioEncoderSettings?: any | undefined, videoSourceID: any }> }>, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, nics?: any | undefined, place: { __typename?: 'qx_Place', id: string, name: string, timezone?: string | undefined, type: qx_ePlaceType_enum, path: string } }, deviceAnalyticSources: Array<{ __typename?: 'deviceAnalyticSource', id: number, analyticSource: { __typename?: 'AnalyticSources', id: number, comment?: string | undefined, value: string } }> }, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, refID: string, videoSourceID: any, snapshotUrl?: string | undefined, videoEncoderSettings?: any | undefined, streamEnabled: boolean, streamStatus: qx_eStreamStatus_enum, streamFile: string, audioEncoderSettings?: any | undefined, audioCodec?: string | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, refID: string, enabled: boolean } | undefined }>, snapshots?: Array<{ __typename?: 'qx_Snapshot', id: string, base64?: string | undefined, signedUrl?: string | undefined, aspectRatio?: any | undefined }> | undefined } | undefined };

export type GQL_GET_CAMERAS_BY_IDSQueryVariables = Exact<{
  ids: Array<string> | string;
}>;


export type GQL_GET_CAMERAS_BY_IDSQuery = { __typename?: 'query_root', videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string }> };

export type GQL_GET_AI_TOOL_RESULT_CAMERAS_BY_IDSQueryVariables = Exact<{
  ids: Array<string> | string;
}>;


export type GQL_GET_AI_TOOL_RESULT_CAMERAS_BY_IDSQuery = { __typename?: 'query_root', videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, enabled: boolean, name: string, profileMSupported?: boolean | undefined, metadataEnabled?: boolean | undefined, scheduleID?: string | undefined, cloudStorageDays: number, cloudStorageTimelapseDays: number, timelapseInterval: number, deviceID: string, gatewayID?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, state?: { __typename?: 'videoSourceState', videoSourceID: any, lastMotionAt?: any | undefined } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined }, audioSources: Array<{ __typename?: 'audioSourceVideoSource', audioSourceID?: any | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, enabled: boolean } | undefined }>, device: { __typename?: 'qx_Device', id: string, make?: string | undefined, model?: string | undefined, kind: qx_eDeviceKind_enum, serial?: string | undefined, firmware?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, port: number, tls: boolean, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, type: eGatewayType_enum, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum } }, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, refID: string, streamEnabled: boolean, streamStatus: qx_eStreamStatus_enum, deletedAt?: any | undefined }>, snapshots?: Array<{ __typename?: 'qx_Snapshot', id: string, base64?: string | undefined, signedUrl?: string | undefined, aspectRatio?: any | undefined }> | undefined }> };

export type GQL_SUB_CAMERA_BY_IDSubscriptionVariables = Exact<{
  id: string;
}>;


export type GQL_SUB_CAMERA_BY_IDSubscription = { __typename?: 'subscription_root', videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, description?: string | undefined, enabled: boolean, cloudStorageDays: number, cloudStorageTimelapseDays: number, snapshotMediaProfileID?: any | undefined, timelapseInterval: number, mountPosition?: qx_eMountPosition_enum | undefined, profileMSupported?: boolean | undefined, metadataEnabled?: boolean | undefined, deviceID: string, fps?: number | undefined, imageSize?: string | undefined, imagingSettings?: any | undefined, imagingOptions?: any | undefined, gatewayID?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, state?: { __typename?: 'videoSourceState', videoSourceID: any, lastMotionAt?: any | undefined } | undefined, audioSources: Array<{ __typename?: 'audioSourceVideoSource', audioSourceID?: any | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, enabled: boolean } | undefined }>, schedule?: { __typename?: 'qx_Schedule', id: string, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, date: any, duration: string, weekdays?: string | undefined }> } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined }, device: { __typename?: 'qx_Device', id: string, name: string, profileMSupported?: boolean | undefined, gatewayID: string, port: number, tls: boolean, make?: string | undefined, model?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, deviceUsername?: string | undefined, devicePassword?: string | undefined, serial?: string | undefined, kind: qx_eDeviceKind_enum, firmware?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, createdAt: any, oldestMedia?: Array<{ __typename?: 'qx_vOldestMedia', type?: string | undefined, date?: any | undefined }> | undefined, audioSources: Array<{ __typename?: 'qx_AudioSource', id: any, name: string, refID: string, enabled: boolean, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, audioEncoderSettings?: any | undefined, videoSourceID: any }> }>, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, nics?: any | undefined, place: { __typename?: 'qx_Place', id: string, name: string, timezone?: string | undefined, type: qx_ePlaceType_enum, path: string } }, deviceAnalyticSources: Array<{ __typename?: 'deviceAnalyticSource', id: number, analyticSource: { __typename?: 'AnalyticSources', id: number, comment?: string | undefined, value: string } }> }, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, refID: string, videoSourceID: any, snapshotUrl?: string | undefined, videoEncoderSettings?: any | undefined, streamEnabled: boolean, streamStatus: qx_eStreamStatus_enum, streamFile: string, audioEncoderSettings?: any | undefined, audioCodec?: string | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, refID: string, enabled: boolean } | undefined }> } | undefined };

export type GQL_GET_CAMERA_MEDIA_PROFILE_FORMQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_CAMERA_MEDIA_PROFILE_FORMQuery = { __typename?: 'query_root', mediaProfile?: { __typename?: 'qx_MediaProfile', id: any, deviceID: string, refID: string, streamEnabled: boolean, warped: boolean, videoEncoderOptions?: any | undefined, videoEncoderSettings?: any | undefined } | undefined };

export type GQL_UPDATE_VIDEO_SOURCE_BY_IDMutationVariables = Exact<{
  id: string;
  data: qx_VideoSource_set_input;
}>;


export type GQL_UPDATE_VIDEO_SOURCE_BY_IDMutation = { __typename?: 'mutation_root', updateVideoSource?: { __typename?: 'qx_VideoSource', id: any } | undefined };

export type GQL_DELETE_CAMERA_DEVICE_BY_IDMutationVariables = Exact<{
  id: string;
}>;


export type GQL_DELETE_CAMERA_DEVICE_BY_IDMutation = { __typename?: 'mutation_root', deleteDeviceVideoData: { __typename?: 'DeleteDeviceVideoDataOutput', status: string } };

export type GQL_GET_CAMERAS_BY_DEVICE_IDQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_CAMERAS_BY_DEVICE_IDQuery = { __typename?: 'query_root', videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string, description?: string | undefined, enabled: boolean, cloudStorageDays: number, cloudStorageTimelapseDays: number, snapshotMediaProfileID?: any | undefined, timelapseInterval: number, mountPosition?: qx_eMountPosition_enum | undefined, profileMSupported?: boolean | undefined, metadataEnabled?: boolean | undefined, deviceID: string, fps?: number | undefined, imageSize?: string | undefined, imagingSettings?: any | undefined, imagingOptions?: any | undefined, gatewayID?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, state?: { __typename?: 'videoSourceState', videoSourceID: any, lastMotionAt?: any | undefined } | undefined, audioSources: Array<{ __typename?: 'audioSourceVideoSource', audioSourceID?: any | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, enabled: boolean } | undefined }>, schedule?: { __typename?: 'qx_Schedule', id: string, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, date: any, duration: string, weekdays?: string | undefined }> } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined }, device: { __typename?: 'qx_Device', id: string, name: string, profileMSupported?: boolean | undefined, gatewayID: string, port: number, tls: boolean, make?: string | undefined, model?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, deviceUsername?: string | undefined, devicePassword?: string | undefined, serial?: string | undefined, kind: qx_eDeviceKind_enum, firmware?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, createdAt: any, oldestMedia?: Array<{ __typename?: 'qx_vOldestMedia', type?: string | undefined, date?: any | undefined }> | undefined, audioSources: Array<{ __typename?: 'qx_AudioSource', id: any, name: string, refID: string, enabled: boolean, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, audioEncoderSettings?: any | undefined, videoSourceID: any }> }>, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, nics?: any | undefined, place: { __typename?: 'qx_Place', id: string, name: string, timezone?: string | undefined, type: qx_ePlaceType_enum, path: string } }, deviceAnalyticSources: Array<{ __typename?: 'deviceAnalyticSource', id: number, analyticSource: { __typename?: 'AnalyticSources', id: number, comment?: string | undefined, value: string } }> }, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, refID: string, videoSourceID: any, snapshotUrl?: string | undefined, videoEncoderSettings?: any | undefined, streamEnabled: boolean, streamStatus: qx_eStreamStatus_enum, streamFile: string, audioEncoderSettings?: any | undefined, audioCodec?: string | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, refID: string, enabled: boolean } | undefined }>, snapshots?: Array<{ __typename?: 'qx_Snapshot', id: string, base64?: string | undefined, signedUrl?: string | undefined, aspectRatio?: any | undefined }> | undefined }> };

export type GQL_CAMERA_SEARCHQueryVariables = Exact<{
  where?: qx_VideoSource_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_VideoSource_order_by> | qx_VideoSource_order_by;
}>;


export type GQL_CAMERA_SEARCHQuery = { __typename?: 'query_root', videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, enabled: boolean, name: string, profileMSupported?: boolean | undefined, metadataEnabled?: boolean | undefined, scheduleID?: string | undefined, cloudStorageDays: number, cloudStorageTimelapseDays: number, timelapseInterval: number, deviceID: string, gatewayID?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, snapshots?: Array<{ __typename?: 'qx_Snapshot', id: string, base64?: string | undefined, signedUrl?: string | undefined, aspectRatio?: any | undefined }> | undefined, state?: { __typename?: 'videoSourceState', videoSourceID: any, lastMotionAt?: any | undefined } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined }, audioSources: Array<{ __typename?: 'audioSourceVideoSource', audioSourceID?: any | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, enabled: boolean } | undefined }>, device: { __typename?: 'qx_Device', id: string, make?: string | undefined, model?: string | undefined, kind: qx_eDeviceKind_enum, serial?: string | undefined, firmware?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, port: number, tls: boolean, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, type: eGatewayType_enum, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum } }, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, refID: string, streamEnabled: boolean, streamStatus: qx_eStreamStatus_enum, deletedAt?: any | undefined }> }>, videoSourceAggregate: { __typename?: 'qx_VideoSource_aggregate', aggregate?: { __typename?: 'qx_VideoSource_aggregate_fields', count: number } | undefined } };

export type GQL_CAMERA_SEARCH_SUBSCRIPTIONVariables = Exact<{
  where?: qx_VideoSource_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_VideoSource_order_by> | qx_VideoSource_order_by;
}>;


export type GQL_CAMERA_SEARCH_SUBSCRIPTION = { __typename?: 'subscription_root', videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, enabled: boolean, name: string, profileMSupported?: boolean | undefined, metadataEnabled?: boolean | undefined, scheduleID?: string | undefined, cloudStorageDays: number, cloudStorageTimelapseDays: number, timelapseInterval: number, deviceID: string, gatewayID?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, state?: { __typename?: 'videoSourceState', videoSourceID: any, lastMotionAt?: any | undefined } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined }, audioSources: Array<{ __typename?: 'audioSourceVideoSource', audioSourceID?: any | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, enabled: boolean } | undefined }>, device: { __typename?: 'qx_Device', id: string, make?: string | undefined, model?: string | undefined, kind: qx_eDeviceKind_enum, serial?: string | undefined, firmware?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, port: number, tls: boolean, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, type: eGatewayType_enum, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum } }, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, refID: string, streamEnabled: boolean, streamStatus: qx_eStreamStatus_enum, deletedAt?: any | undefined }> }> };

export type DeviceVideoSourceFormFragment = { __typename?: 'qx_VideoSource', id: any, refID: string, name: string, description?: string | undefined, enabled: boolean, cloudStorageDays: number, cloudStorageTimelapseDays: number, timelapseInterval: number, mountPosition?: qx_eMountPosition_enum | undefined, placeID: string, place: { __typename?: 'qx_Place', id: string, name: string }, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, refID: string, deviceID: string, warped: boolean, streamEnabled: boolean, streamStatus: qx_eStreamStatus_enum, videoEncoderOptions?: any | undefined, videoEncoderSettings?: any | undefined }> };

export type GQL_SUB_CAMERA_DEVICE_FORM_CREATESubscriptionVariables = Exact<{
  id: string;
}>;


export type GQL_SUB_CAMERA_DEVICE_FORM_CREATESubscription = { __typename?: 'subscription_root', videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, refID: string, name: string, description?: string | undefined, enabled: boolean, cloudStorageDays: number, cloudStorageTimelapseDays: number, timelapseInterval: number, mountPosition?: qx_eMountPosition_enum | undefined, placeID: string, place: { __typename?: 'qx_Place', id: string, name: string }, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, refID: string, deviceID: string, warped: boolean, streamEnabled: boolean, streamStatus: qx_eStreamStatus_enum, videoEncoderOptions?: any | undefined, videoEncoderSettings?: any | undefined }> }> };

export type UseEventSearchFragment = { __typename?: 'vEvents', id?: any | undefined, active?: boolean | undefined, card?: string | undefined, bits?: number | undefined, status?: string | undefined, time?: any | undefined, serverTime?: any | undefined, type?: string | undefined, duration?: any | undefined, hasVideo?: boolean | undefined, inCloud?: boolean | undefined, onGateway?: boolean | undefined, eventStart?: any | undefined, eventEnd?: any | undefined, sensorID?: any | undefined, personID?: string | undefined, doorID?: any | undefined, videoSourceID?: any | undefined, mediaProfileID?: any | undefined, deviceID?: string | undefined, zoneID?: string | undefined, partitionID?: string | undefined, gatewayID?: string | undefined, placeID?: string | undefined, profile?: string | undefined, sensor?: { __typename?: 'qx_Sensor', id: any, name: string, type: qx_eSensorType_enum } | undefined, person?: { __typename?: 'qx_Person', id: string, avatar_sm?: string | undefined, firstName?: string | undefined, lastName?: string | undefined } | undefined, door?: { __typename?: 'qx_Door', id: any, name: string } | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string } | undefined, device?: { __typename?: 'qx_Device', id: string, name: string, kind: qx_eDeviceKind_enum } | undefined, zone?: { __typename?: 'IntrusionZone', id: string, name: string } | undefined, partition?: { __typename?: 'IntrusionPartition', id: string, name: string } | undefined, toType?: { __typename?: 'qx_EventType', priority: number } | undefined, place?: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, type: eGatewayType_enum } | undefined } | undefined, snapshot?: { __typename?: 'qx_Snapshot', id: string, signedUrl?: string | undefined, aspectRatio?: any | undefined } | undefined };

export type LiveScrollerEventFragment = { __typename?: 'vEvents', id?: any | undefined, active?: boolean | undefined, card?: string | undefined, bits?: number | undefined, status?: string | undefined, time?: any | undefined, serverTime?: any | undefined, type?: string | undefined, profile?: string | undefined, duration?: any | undefined, hasVideo?: boolean | undefined, sensorID?: any | undefined, personID?: string | undefined, doorID?: any | undefined, videoSourceID?: any | undefined, mediaProfileID?: any | undefined, deviceID?: string | undefined, zoneID?: string | undefined, partitionID?: string | undefined, gatewayID?: string | undefined, placeID?: string | undefined, sensor?: { __typename?: 'qx_Sensor', id: any, name: string, type: qx_eSensorType_enum } | undefined, person?: { __typename?: 'qx_Person', id: string, avatar_sm?: string | undefined, firstName?: string | undefined, lastName?: string | undefined } | undefined, door?: { __typename?: 'qx_Door', id: any, name: string } | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string } | undefined, device?: { __typename?: 'qx_Device', id: string, name: string, kind: qx_eDeviceKind_enum } | undefined, zone?: { __typename?: 'IntrusionZone', id: string, name: string } | undefined, partition?: { __typename?: 'IntrusionPartition', id: string, name: string } | undefined, toType?: { __typename?: 'qx_EventType', priority: number } | undefined, place?: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, type: eGatewayType_enum } | undefined } | undefined, snapshot?: { __typename?: 'qx_Snapshot', id: string, signedUrl?: string | undefined, aspectRatio?: any | undefined } | undefined };

export type GQL_GET_AI_TOOL_RESULT_EVENTS_BY_IDSQueryVariables = Exact<{
  ids: Array<string> | string;
}>;


export type GQL_GET_AI_TOOL_RESULT_EVENTS_BY_IDSQuery = { __typename?: 'query_root', vEvents: Array<{ __typename?: 'vEvents', id?: any | undefined, active?: boolean | undefined, card?: string | undefined, bits?: number | undefined, status?: string | undefined, time?: any | undefined, serverTime?: any | undefined, type?: string | undefined, duration?: any | undefined, hasVideo?: boolean | undefined, inCloud?: boolean | undefined, onGateway?: boolean | undefined, eventStart?: any | undefined, eventEnd?: any | undefined, sensorID?: any | undefined, personID?: string | undefined, doorID?: any | undefined, videoSourceID?: any | undefined, mediaProfileID?: any | undefined, deviceID?: string | undefined, zoneID?: string | undefined, partitionID?: string | undefined, gatewayID?: string | undefined, placeID?: string | undefined, profile?: string | undefined, sensor?: { __typename?: 'qx_Sensor', id: any, name: string, type: qx_eSensorType_enum } | undefined, person?: { __typename?: 'qx_Person', id: string, avatar_sm?: string | undefined, firstName?: string | undefined, lastName?: string | undefined } | undefined, door?: { __typename?: 'qx_Door', id: any, name: string } | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string } | undefined, device?: { __typename?: 'qx_Device', id: string, name: string, kind: qx_eDeviceKind_enum } | undefined, zone?: { __typename?: 'IntrusionZone', id: string, name: string } | undefined, partition?: { __typename?: 'IntrusionPartition', id: string, name: string } | undefined, toType?: { __typename?: 'qx_EventType', priority: number } | undefined, place?: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, type: eGatewayType_enum } | undefined } | undefined, snapshot?: { __typename?: 'qx_Snapshot', id: string, signedUrl?: string | undefined, aspectRatio?: any | undefined } | undefined }> };

export type GQL_SEARCH_V_EVENTSQueryVariables = Exact<{
  where: vEvents_bool_exp;
  limit: number;
  order_by: Array<vEvents_order_by> | vEvents_order_by;
}>;


export type GQL_SEARCH_V_EVENTSQuery = { __typename?: 'query_root', vEvents: Array<{ __typename?: 'vEvents', id?: any | undefined, active?: boolean | undefined, card?: string | undefined, bits?: number | undefined, status?: string | undefined, time?: any | undefined, serverTime?: any | undefined, type?: string | undefined, duration?: any | undefined, hasVideo?: boolean | undefined, inCloud?: boolean | undefined, onGateway?: boolean | undefined, eventStart?: any | undefined, eventEnd?: any | undefined, sensorID?: any | undefined, personID?: string | undefined, doorID?: any | undefined, videoSourceID?: any | undefined, mediaProfileID?: any | undefined, deviceID?: string | undefined, zoneID?: string | undefined, partitionID?: string | undefined, gatewayID?: string | undefined, placeID?: string | undefined, profile?: string | undefined, sensor?: { __typename?: 'qx_Sensor', id: any, name: string, type: qx_eSensorType_enum } | undefined, person?: { __typename?: 'qx_Person', id: string, avatar_sm?: string | undefined, firstName?: string | undefined, lastName?: string | undefined } | undefined, door?: { __typename?: 'qx_Door', id: any, name: string } | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string } | undefined, device?: { __typename?: 'qx_Device', id: string, name: string, kind: qx_eDeviceKind_enum } | undefined, zone?: { __typename?: 'IntrusionZone', id: string, name: string } | undefined, partition?: { __typename?: 'IntrusionPartition', id: string, name: string } | undefined, toType?: { __typename?: 'qx_EventType', priority: number } | undefined, place?: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, type: eGatewayType_enum } | undefined } | undefined, snapshot?: { __typename?: 'qx_Snapshot', id: string, signedUrl?: string | undefined, aspectRatio?: any | undefined } | undefined }> };

export type GQL_LIVE_SCROLLER_V_EVENTSQueryVariables = Exact<{
  where: vEvents_bool_exp;
  limit: number;
  order_by: Array<vEvents_order_by> | vEvents_order_by;
}>;


export type GQL_LIVE_SCROLLER_V_EVENTSQuery = { __typename?: 'query_root', vEvents: Array<{ __typename?: 'vEvents', id?: any | undefined, active?: boolean | undefined, card?: string | undefined, bits?: number | undefined, status?: string | undefined, time?: any | undefined, serverTime?: any | undefined, type?: string | undefined, profile?: string | undefined, duration?: any | undefined, hasVideo?: boolean | undefined, sensorID?: any | undefined, personID?: string | undefined, doorID?: any | undefined, videoSourceID?: any | undefined, mediaProfileID?: any | undefined, deviceID?: string | undefined, zoneID?: string | undefined, partitionID?: string | undefined, gatewayID?: string | undefined, placeID?: string | undefined, sensor?: { __typename?: 'qx_Sensor', id: any, name: string, type: qx_eSensorType_enum } | undefined, person?: { __typename?: 'qx_Person', id: string, avatar_sm?: string | undefined, firstName?: string | undefined, lastName?: string | undefined } | undefined, door?: { __typename?: 'qx_Door', id: any, name: string } | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string } | undefined, device?: { __typename?: 'qx_Device', id: string, name: string, kind: qx_eDeviceKind_enum } | undefined, zone?: { __typename?: 'IntrusionZone', id: string, name: string } | undefined, partition?: { __typename?: 'IntrusionPartition', id: string, name: string } | undefined, toType?: { __typename?: 'qx_EventType', priority: number } | undefined, place?: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, type: eGatewayType_enum } | undefined } | undefined, snapshot?: { __typename?: 'qx_Snapshot', id: string, signedUrl?: string | undefined, aspectRatio?: any | undefined } | undefined }> };

export type GQL_SUBSCRIBE_V_EVENTSSubscriptionVariables = Exact<{
  where: vEvents_bool_exp;
  limit: number;
  order_by: Array<vEvents_order_by> | vEvents_order_by;
}>;


export type GQL_SUBSCRIBE_V_EVENTSSubscription = { __typename?: 'subscription_root', vEvents: Array<{ __typename?: 'vEvents', id?: any | undefined, active?: boolean | undefined, card?: string | undefined, bits?: number | undefined, status?: string | undefined, time?: any | undefined, serverTime?: any | undefined, type?: string | undefined, duration?: any | undefined, hasVideo?: boolean | undefined, inCloud?: boolean | undefined, onGateway?: boolean | undefined, eventStart?: any | undefined, eventEnd?: any | undefined, sensorID?: any | undefined, personID?: string | undefined, doorID?: any | undefined, videoSourceID?: any | undefined, mediaProfileID?: any | undefined, deviceID?: string | undefined, zoneID?: string | undefined, partitionID?: string | undefined, gatewayID?: string | undefined, placeID?: string | undefined, profile?: string | undefined, sensor?: { __typename?: 'qx_Sensor', id: any, name: string, type: qx_eSensorType_enum } | undefined, person?: { __typename?: 'qx_Person', id: string, avatar_sm?: string | undefined, firstName?: string | undefined, lastName?: string | undefined } | undefined, door?: { __typename?: 'qx_Door', id: any, name: string } | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string } | undefined, device?: { __typename?: 'qx_Device', id: string, name: string, kind: qx_eDeviceKind_enum } | undefined, zone?: { __typename?: 'IntrusionZone', id: string, name: string } | undefined, partition?: { __typename?: 'IntrusionPartition', id: string, name: string } | undefined, toType?: { __typename?: 'qx_EventType', priority: number } | undefined, place?: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, type: eGatewayType_enum } | undefined } | undefined, snapshot?: { __typename?: 'qx_Snapshot', id: string, signedUrl?: string | undefined, aspectRatio?: any | undefined } | undefined }> };

export type doorsPlacesAndCamerasQueryVariables = Exact<{
  path: string;
}>;


export type doorsPlacesAndCamerasQuery = { __typename?: 'query_root', places: Array<{ __typename?: 'qx_Place', id: string, name: string }>, people: Array<{ __typename?: 'qx_Person', id: string, lastName?: string | undefined, firstName?: string | undefined }>, doors: Array<{ __typename?: 'qx_Door', id: any, name: string }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string }> };

export type GQL_SEARCH_CAMERA_DOOR_PERSON_PLACEQueryVariables = Exact<{
  whereCameras?: qx_VideoSource_bool_exp;
  whereDoors?: qx_Door_bool_exp;
  wherePlaces?: qx_Place_bool_exp;
  wherePeople?: qx_Person_bool_exp;
}>;


export type GQL_SEARCH_CAMERA_DOOR_PERSON_PLACEQuery = { __typename?: 'query_root', videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }>, doors: Array<{ __typename?: 'qx_Door', id: any, name: string, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }>, people: Array<{ __typename?: 'qx_Person', id: string, lastName?: string | undefined, firstName?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }>, places: Array<{ __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }> };

export type GQL_GET_CAMERA_DOOR_PERSON_PLACEQueryVariables = Exact<{
  Camera?: Array<string> | string;
  Door?: Array<string> | string;
  Person?: Array<string> | string;
  Place?: Array<string> | string;
}>;


export type GQL_GET_CAMERA_DOOR_PERSON_PLACEQuery = { __typename?: 'query_root', videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string }>, doors: Array<{ __typename?: 'qx_Door', id: any, name: string }>, people: Array<{ __typename?: 'qx_Person', id: string, lastName?: string | undefined, firstName?: string | undefined }>, places: Array<{ __typename?: 'qx_Place', id: string, name: string }> };

export type CredentialFragment = { __typename?: 'qx_Credential', id: string, pin?: string | undefined, value: string, validFrom?: any | undefined, validTo?: any | undefined, enabled: boolean, extendedTimeEnabled: boolean, personID: string, status?: string | undefined, type: qx_eCredentialType_enum };

export type getCredentialByIdQueryVariables = Exact<{
  id: string;
}>;


export type getCredentialByIdQuery = { __typename?: 'query_root', credential?: { __typename?: 'qx_Credential', id: string, pin?: string | undefined, value: string, validFrom?: any | undefined, validTo?: any | undefined, enabled: boolean, extendedTimeEnabled: boolean, personID: string, status?: string | undefined, type: qx_eCredentialType_enum } | undefined };

export type createCredentialsMutationVariables = Exact<{
  credentials: Array<qx_Credential_insert_input> | qx_Credential_insert_input;
}>;


export type createCredentialsMutation = { __typename?: 'mutation_root', createCredentials?: { __typename?: 'qx_Credential_mutation_response', returning: Array<{ __typename?: 'qx_Credential', id: string, pin?: string | undefined, value: string, validFrom?: any | undefined, validTo?: any | undefined, enabled: boolean, extendedTimeEnabled: boolean, personID: string, status?: string | undefined, type: qx_eCredentialType_enum }> } | undefined };

export type updateCredentialByIdMutationVariables = Exact<{
  id: string;
  credential: qx_Credential_set_input;
}>;


export type updateCredentialByIdMutation = { __typename?: 'mutation_root', updateCredentials?: { __typename?: 'qx_Credential_mutation_response', affected_rows: number } | undefined };

export type deleteCredentialByIdMutationVariables = Exact<{
  id: string;
}>;


export type deleteCredentialByIdMutation = { __typename?: 'mutation_root', deleteCredentials?: { __typename?: 'qx_Credential_mutation_response', affected_rows: number } | undefined };

export type GQL_CREDENTIAL_SEARCHQueryVariables = Exact<{
  where?: qx_Credential_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Credential_order_by> | qx_Credential_order_by;
}>;


export type GQL_CREDENTIAL_SEARCHQuery = { __typename?: 'query_root', credentials: Array<{ __typename?: 'qx_Credential', id: string, pin?: string | undefined, value: string, validFrom?: any | undefined, validTo?: any | undefined, enabled: boolean, extendedTimeEnabled: boolean, personID: string, status?: string | undefined, type: qx_eCredentialType_enum }>, credentialAggregate: { __typename?: 'qx_Credential_aggregate', aggregate?: { __typename?: 'qx_Credential_aggregate_fields', count: number } | undefined } };

export type checkForUniqueCredentialQueryVariables = Exact<{
  credentialID?: string;
  cardNumber: string;
  customerPlaceID: string;
}>;


export type checkForUniqueCredentialQuery = { __typename?: 'query_root', credentials: Array<{ __typename?: 'qx_Credential', id: string }> };

export type checkForUniquePinQueryVariables = Exact<{
  credentialID?: string;
  pin: string;
  custPlaceID: string;
}>;


export type checkForUniquePinQuery = { __typename?: 'query_root', credentials: Array<{ __typename?: 'qx_Credential', id: string }> };

export type checkForUniqueSiteCodeAndPinCombinationQueryVariables = Exact<{
  credentialID?: string;
  siteCode: string;
  pin: string;
  custPlaceID: string;
}>;


export type checkForUniqueSiteCodeAndPinCombinationQuery = { __typename?: 'query_root', credentials: Array<{ __typename?: 'qx_Credential', id: string, value: string, pin?: string | undefined, status?: string | undefined, person: { __typename?: 'qx_Person', id: string, email?: string | undefined, firstName?: string | undefined, lastName?: string | undefined } }> };

export type GenericDeviceFragment = { __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, enabled: boolean, name: string, profileMSupported?: boolean | undefined, description?: string | undefined, gatewayID: string, port: number, tls: boolean, make?: string | undefined, model?: string | undefined, serial?: string | undefined, deviceMac?: string | undefined, deviceAddress?: string | undefined, deviceUsername?: string | undefined, devicePassword?: string | undefined, firmware?: string | undefined, pacsConfigurationID?: string | undefined, meta?: any | undefined, connectionStatus: qx_eDeviceConnectionStatus_enum, createdAt: any, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, oldestMedia?: Array<{ __typename?: 'qx_vOldestMedia', type?: string | undefined, date?: any | undefined }> | undefined, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, nics?: any | undefined, hostname?: string | undefined, placeID: string, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }, sensors: Array<{ __typename?: 'qx_Sensor', id: any, name: string, type: qx_eSensorType_enum, enabled: boolean, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined } }>, doors: Array<{ __typename?: 'qx_Door', id: any, name: string, type?: string | undefined, enabled: boolean, disabledByLicense: boolean, lockdownImmunity?: boolean | undefined, canOperate?: boolean | undefined, mode: qx_eDoorMode_enum, state: qx_eDoorState_enum, alarm: qx_eDoorAlarm_enum, doorMonitor: qx_eDoorMonitor_enum, doorMonitorAddress?: string | undefined, deviceConnectionStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined }, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, outside?: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } | undefined }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string, enabled: boolean, deviceConnectionStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, profileMSupported?: boolean | undefined, metadataEnabled?: boolean | undefined, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, refID: string, streamEnabled: boolean, streamStatus: qx_eStreamStatus_enum, deletedAt?: any | undefined }>, audioSources: Array<{ __typename?: 'audioSourceVideoSource', audioSourceID?: any | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, enabled: boolean } | undefined }>, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined, kind: qx_eDeviceKind_enum, enabled: boolean }, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }>, audioSources: Array<{ __typename?: 'qx_AudioSource', id: any, name: string, refID: string, enabled: boolean, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, audioEncoderSettings?: any | undefined, videoSourceID: any }> }>, deviceAnalyticSources: Array<{ __typename?: 'deviceAnalyticSource', id: number, analyticSource: { __typename?: 'AnalyticSources', id: number, comment?: string | undefined, value: string } }> };

export type DeviceSearchFragment = { __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, enabled: boolean, name: string, description?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, port: number, serial?: string | undefined, tls: boolean, meta?: any | undefined, make?: string | undefined, model?: string | undefined, firmware?: string | undefined, ntp?: boolean | undefined, timezone?: string | undefined, dst?: boolean | undefined, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, connectionStatus: qx_eDeviceConnectionStatus_enum, profileMSupported?: boolean | undefined, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, nics?: any | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }, doors: Array<{ __typename?: 'qx_Door', id: any, name: string, enabled: boolean }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string, enabled: boolean }>, intrusionPartitionCount: Array<{ __typename?: 'IntrusionPartition', index: number, stateValues?: any | undefined, alarmValues?: any | undefined }>, intrusionZoneCount: Array<{ __typename?: 'IntrusionZone', index: number, stateValues?: any | undefined, alarmValues?: any | undefined }> };

export type IntrusionPanelSearchFragment = { __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, enabled: boolean, name: string, description?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, port: number, serial?: string | undefined, tls: boolean, meta?: any | undefined, make?: string | undefined, model?: string | undefined, firmware?: string | undefined, ntp?: boolean | undefined, timezone?: string | undefined, dst?: boolean | undefined, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, connectionStatus: qx_eDeviceConnectionStatus_enum, profileMSupported?: boolean | undefined, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, nics?: any | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }, doors: Array<{ __typename?: 'qx_Door', id: any, name: string, enabled: boolean }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string, enabled: boolean }>, intrusionPartitionCount: Array<{ __typename?: 'IntrusionPartition', index: number, stateValues?: any | undefined, alarmValues?: any | undefined }>, intrusionZoneCount: Array<{ __typename?: 'IntrusionZone', index: number, stateValues?: any | undefined, alarmValues?: any | undefined }> };

export type LiveScrollerDeviceResolveFragment = { __typename?: 'qx_Device', id: string, name: string, kind: qx_eDeviceKind_enum };

export type GQL_GET_DEVICES_BY_IDSQueryVariables = Exact<{
  ids: Array<string> | string;
}>;


export type GQL_GET_DEVICES_BY_IDSQuery = { __typename?: 'query_root', devices: Array<{ __typename?: 'qx_Device', id: string, name: string, kind: qx_eDeviceKind_enum }> };

export type GQL_GET_AI_TOOL_RESULT_DEVICES_BY_IDSQueryVariables = Exact<{
  ids: Array<string> | string;
}>;


export type GQL_GET_AI_TOOL_RESULT_DEVICES_BY_IDSQuery = { __typename?: 'query_root', devices: Array<{ __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, enabled: boolean, name: string, description?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, port: number, serial?: string | undefined, tls: boolean, meta?: any | undefined, make?: string | undefined, model?: string | undefined, firmware?: string | undefined, ntp?: boolean | undefined, timezone?: string | undefined, dst?: boolean | undefined, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, connectionStatus: qx_eDeviceConnectionStatus_enum, profileMSupported?: boolean | undefined, doors: Array<{ __typename?: 'qx_Door', id: any, name: string, enabled: boolean, type?: string | undefined, description?: string | undefined, canOperate?: boolean | undefined, mode: qx_eDoorMode_enum, state: qx_eDoorState_enum, timezone?: string | undefined, alarm: qx_eDoorAlarm_enum, batteryLevel: qx_eBatteryLevel_enum, doorMonitor: qx_eDoorMonitor_enum, doorMonitorAddress?: string | undefined, lockdownImmunity?: boolean | undefined, defaultVideoSourceID?: any | undefined, deviceID: string, devicePacsStatus?: string | undefined, devicePacsHWUpdate?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, unlockSchedule?: { __typename?: 'qx_Schedule', id: string, name: string, thumbnail?: string | undefined, isActive?: boolean | undefined, holidayActive?: string | undefined, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, scheduleID: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }> } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, path: string, timezone?: string | undefined, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, outside?: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } | undefined, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, kind: qx_eDeviceKind_enum, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } } }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string, enabled: boolean, profileMSupported?: boolean | undefined, metadataEnabled?: boolean | undefined, scheduleID?: string | undefined, cloudStorageDays: number, cloudStorageTimelapseDays: number, timelapseInterval: number, deviceID: string, gatewayID?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, state?: { __typename?: 'videoSourceState', videoSourceID: any, lastMotionAt?: any | undefined } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined }, audioSources: Array<{ __typename?: 'audioSourceVideoSource', audioSourceID?: any | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, enabled: boolean } | undefined }>, device: { __typename?: 'qx_Device', id: string, make?: string | undefined, model?: string | undefined, kind: qx_eDeviceKind_enum, serial?: string | undefined, firmware?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, port: number, tls: boolean, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, type: eGatewayType_enum, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum } }, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, refID: string, streamEnabled: boolean, streamStatus: qx_eStreamStatus_enum, deletedAt?: any | undefined }>, snapshots?: Array<{ __typename?: 'qx_Snapshot', id: string, base64?: string | undefined, signedUrl?: string | undefined, aspectRatio?: any | undefined }> | undefined }>, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, nics?: any | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }, intrusionPartitionCount: Array<{ __typename?: 'IntrusionPartition', index: number, stateValues?: any | undefined, alarmValues?: any | undefined }>, intrusionZoneCount: Array<{ __typename?: 'IntrusionZone', index: number, stateValues?: any | undefined, alarmValues?: any | undefined }> }> };

export type GQL_GET_DEVICE_BY_IDQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_DEVICE_BY_IDQuery = { __typename?: 'query_root', device?: { __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, enabled: boolean, name: string, profileMSupported?: boolean | undefined, description?: string | undefined, gatewayID: string, port: number, tls: boolean, make?: string | undefined, model?: string | undefined, serial?: string | undefined, deviceMac?: string | undefined, deviceAddress?: string | undefined, deviceUsername?: string | undefined, devicePassword?: string | undefined, firmware?: string | undefined, pacsConfigurationID?: string | undefined, meta?: any | undefined, connectionStatus: qx_eDeviceConnectionStatus_enum, createdAt: any, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, oldestMedia?: Array<{ __typename?: 'qx_vOldestMedia', type?: string | undefined, date?: any | undefined }> | undefined, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, nics?: any | undefined, hostname?: string | undefined, placeID: string, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }, sensors: Array<{ __typename?: 'qx_Sensor', id: any, name: string, type: qx_eSensorType_enum, enabled: boolean, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined } }>, doors: Array<{ __typename?: 'qx_Door', id: any, name: string, type?: string | undefined, enabled: boolean, disabledByLicense: boolean, lockdownImmunity?: boolean | undefined, canOperate?: boolean | undefined, mode: qx_eDoorMode_enum, state: qx_eDoorState_enum, alarm: qx_eDoorAlarm_enum, doorMonitor: qx_eDoorMonitor_enum, doorMonitorAddress?: string | undefined, deviceConnectionStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined }, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, outside?: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } | undefined }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string, enabled: boolean, deviceConnectionStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, profileMSupported?: boolean | undefined, metadataEnabled?: boolean | undefined, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, refID: string, streamEnabled: boolean, streamStatus: qx_eStreamStatus_enum, deletedAt?: any | undefined }>, audioSources: Array<{ __typename?: 'audioSourceVideoSource', audioSourceID?: any | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, enabled: boolean } | undefined }>, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined, kind: qx_eDeviceKind_enum, enabled: boolean }, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }>, audioSources: Array<{ __typename?: 'qx_AudioSource', id: any, name: string, refID: string, enabled: boolean, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, audioEncoderSettings?: any | undefined, videoSourceID: any }> }>, deviceAnalyticSources: Array<{ __typename?: 'deviceAnalyticSource', id: number, analyticSource: { __typename?: 'AnalyticSources', id: number, comment?: string | undefined, value: string } }> } | undefined };

export type GQL_SUB_DEVICE_BY_IDSubscriptionVariables = Exact<{
  id: string;
}>;


export type GQL_SUB_DEVICE_BY_IDSubscription = { __typename?: 'subscription_root', device?: { __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, enabled: boolean, name: string, profileMSupported?: boolean | undefined, description?: string | undefined, gatewayID: string, port: number, tls: boolean, make?: string | undefined, model?: string | undefined, serial?: string | undefined, deviceMac?: string | undefined, deviceAddress?: string | undefined, deviceUsername?: string | undefined, devicePassword?: string | undefined, firmware?: string | undefined, pacsConfigurationID?: string | undefined, meta?: any | undefined, connectionStatus: qx_eDeviceConnectionStatus_enum, createdAt: any, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, oldestMedia?: Array<{ __typename?: 'qx_vOldestMedia', type?: string | undefined, date?: any | undefined }> | undefined, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, nics?: any | undefined, hostname?: string | undefined, placeID: string, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }, sensors: Array<{ __typename?: 'qx_Sensor', id: any, name: string, type: qx_eSensorType_enum, enabled: boolean, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined } }>, doors: Array<{ __typename?: 'qx_Door', id: any, name: string, type?: string | undefined, enabled: boolean, disabledByLicense: boolean, lockdownImmunity?: boolean | undefined, canOperate?: boolean | undefined, mode: qx_eDoorMode_enum, state: qx_eDoorState_enum, alarm: qx_eDoorAlarm_enum, doorMonitor: qx_eDoorMonitor_enum, doorMonitorAddress?: string | undefined, deviceConnectionStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined }, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, outside?: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } | undefined }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string, enabled: boolean, deviceConnectionStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, profileMSupported?: boolean | undefined, metadataEnabled?: boolean | undefined, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, refID: string, streamEnabled: boolean, streamStatus: qx_eStreamStatus_enum, deletedAt?: any | undefined }>, audioSources: Array<{ __typename?: 'audioSourceVideoSource', audioSourceID?: any | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, enabled: boolean } | undefined }>, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined, kind: qx_eDeviceKind_enum, enabled: boolean }, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }>, audioSources: Array<{ __typename?: 'qx_AudioSource', id: any, name: string, refID: string, enabled: boolean, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, audioEncoderSettings?: any | undefined, videoSourceID: any }> }>, deviceAnalyticSources: Array<{ __typename?: 'deviceAnalyticSource', id: number, analyticSource: { __typename?: 'AnalyticSources', id: number, comment?: string | undefined, value: string } }> } | undefined };

export type GQL_UPDATE_DEVICE_BY_IDMutationVariables = Exact<{
  id: string;
  device?: qx_Device_set_input;
}>;


export type GQL_UPDATE_DEVICE_BY_IDMutation = { __typename?: 'mutation_root', updateDevice?: { __typename?: 'qx_Device', id: string } | undefined };

export type GQL_GET_DEVICE_PROXY_URLQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_DEVICE_PROXY_URLQuery = { __typename?: 'query_root', device?: { __typename?: 'qx_Device', id: string, proxyUrl?: string | undefined } | undefined };

export type GQL_CHECK_DEVICES_FOR_UNIQUE_GATEWAY_IP_PORTQueryVariables = Exact<{
  where?: qx_Device_bool_exp;
}>;


export type GQL_CHECK_DEVICES_FOR_UNIQUE_GATEWAY_IP_PORTQuery = { __typename?: 'query_root', devices: Array<{ __typename?: 'qx_Device', id: string }> };

export type GQL_DEVICE_SEARCHQueryVariables = Exact<{
  where?: qx_Device_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Device_order_by> | qx_Device_order_by;
}>;


export type GQL_DEVICE_SEARCHQuery = { __typename?: 'query_root', devices: Array<{ __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, enabled: boolean, name: string, description?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, port: number, serial?: string | undefined, tls: boolean, meta?: any | undefined, make?: string | undefined, model?: string | undefined, firmware?: string | undefined, ntp?: boolean | undefined, timezone?: string | undefined, dst?: boolean | undefined, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, connectionStatus: qx_eDeviceConnectionStatus_enum, profileMSupported?: boolean | undefined, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string, enabled: boolean, snapshots?: Array<{ __typename?: 'qx_Snapshot', id: string, base64?: string | undefined, signedUrl?: string | undefined, aspectRatio?: any | undefined }> | undefined }>, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, nics?: any | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }, doors: Array<{ __typename?: 'qx_Door', id: any, name: string, enabled: boolean }>, intrusionPartitionCount: Array<{ __typename?: 'IntrusionPartition', index: number, stateValues?: any | undefined, alarmValues?: any | undefined }>, intrusionZoneCount: Array<{ __typename?: 'IntrusionZone', index: number, stateValues?: any | undefined, alarmValues?: any | undefined }> }>, deviceAggregate: { __typename?: 'qx_Device_aggregate', aggregate?: { __typename?: 'qx_Device_aggregate_fields', count: number } | undefined } };

export type GQL_INTRUSION_PANEL_SEARCHQueryVariables = Exact<{
  where?: qx_Device_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Device_order_by> | qx_Device_order_by;
}>;


export type GQL_INTRUSION_PANEL_SEARCHQuery = { __typename?: 'query_root', devices: Array<{ __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, enabled: boolean, name: string, description?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, port: number, serial?: string | undefined, tls: boolean, meta?: any | undefined, make?: string | undefined, model?: string | undefined, firmware?: string | undefined, ntp?: boolean | undefined, timezone?: string | undefined, dst?: boolean | undefined, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, connectionStatus: qx_eDeviceConnectionStatus_enum, profileMSupported?: boolean | undefined, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, nics?: any | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }, doors: Array<{ __typename?: 'qx_Door', id: any, name: string, enabled: boolean }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string, enabled: boolean }>, intrusionPartitionCount: Array<{ __typename?: 'IntrusionPartition', index: number, stateValues?: any | undefined, alarmValues?: any | undefined }>, intrusionZoneCount: Array<{ __typename?: 'IntrusionZone', index: number, stateValues?: any | undefined, alarmValues?: any | undefined }> }>, deviceAggregate: { __typename?: 'qx_Device_aggregate', aggregate?: { __typename?: 'qx_Device_aggregate_fields', count: number } | undefined } };

export type IntrusionPanelDetailFragment = { __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, enabled: boolean, name: string, description?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, port: number, serial?: string | undefined, tls: boolean, meta?: any | undefined, make?: string | undefined, model?: string | undefined, firmware?: string | undefined, ntp?: boolean | undefined, timezone?: string | undefined, dst?: boolean | undefined, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, connectionStatus: qx_eDeviceConnectionStatus_enum, profileMSupported?: boolean | undefined, dscConnections: Array<{ __typename?: 'DSCConnection', integrationKey: string }>, IntrusionPartitions: Array<{ __typename?: 'IntrusionPartition', enabled: boolean, canArm?: boolean | undefined, canDisarm?: boolean | undefined, id: string, name: string, index: number, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, PartitionZoneAssignments: Array<{ __typename?: 'PartitionZoneAssignments', enabled: boolean, partitionID: string, zoneID: string, IntrusionZone: { __typename?: 'IntrusionZone', id: string, name: string, index: number, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, canBypass?: boolean | undefined, type: qx_eIntrusionZoneType_enum, defaultVideoSourceID?: any | undefined, VideoSource?: { __typename?: 'qx_VideoSource', id: any } | undefined } }> }>, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, nics?: any | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }, doors: Array<{ __typename?: 'qx_Door', id: any, name: string, enabled: boolean }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string, enabled: boolean }>, intrusionPartitionCount: Array<{ __typename?: 'IntrusionPartition', index: number, stateValues?: any | undefined, alarmValues?: any | undefined }>, intrusionZoneCount: Array<{ __typename?: 'IntrusionZone', index: number, stateValues?: any | undefined, alarmValues?: any | undefined }> };

export type GQL_GET_INTRUSION_PANEL_BY_IDQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_INTRUSION_PANEL_BY_IDQuery = { __typename?: 'query_root', device?: { __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, enabled: boolean, name: string, description?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, port: number, serial?: string | undefined, tls: boolean, meta?: any | undefined, make?: string | undefined, model?: string | undefined, firmware?: string | undefined, ntp?: boolean | undefined, timezone?: string | undefined, dst?: boolean | undefined, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, connectionStatus: qx_eDeviceConnectionStatus_enum, profileMSupported?: boolean | undefined, dscConnections: Array<{ __typename?: 'DSCConnection', integrationKey: string }>, IntrusionPartitions: Array<{ __typename?: 'IntrusionPartition', enabled: boolean, canArm?: boolean | undefined, canDisarm?: boolean | undefined, id: string, name: string, index: number, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, PartitionZoneAssignments: Array<{ __typename?: 'PartitionZoneAssignments', enabled: boolean, partitionID: string, zoneID: string, IntrusionZone: { __typename?: 'IntrusionZone', id: string, name: string, index: number, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, canBypass?: boolean | undefined, type: qx_eIntrusionZoneType_enum, defaultVideoSourceID?: any | undefined, VideoSource?: { __typename?: 'qx_VideoSource', id: any } | undefined } }> }>, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, nics?: any | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }, doors: Array<{ __typename?: 'qx_Door', id: any, name: string, enabled: boolean }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string, enabled: boolean }>, intrusionPartitionCount: Array<{ __typename?: 'IntrusionPartition', index: number, stateValues?: any | undefined, alarmValues?: any | undefined }>, intrusionZoneCount: Array<{ __typename?: 'IntrusionZone', index: number, stateValues?: any | undefined, alarmValues?: any | undefined }> } | undefined };

export type GQL_SUB_INTRUSION_PANEL_BY_IDSubscriptionVariables = Exact<{
  id: string;
}>;


export type GQL_SUB_INTRUSION_PANEL_BY_IDSubscription = { __typename?: 'subscription_root', device?: { __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, enabled: boolean, name: string, description?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, port: number, serial?: string | undefined, tls: boolean, meta?: any | undefined, make?: string | undefined, model?: string | undefined, firmware?: string | undefined, ntp?: boolean | undefined, timezone?: string | undefined, dst?: boolean | undefined, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, connectionStatus: qx_eDeviceConnectionStatus_enum, profileMSupported?: boolean | undefined, dscConnections: Array<{ __typename?: 'DSCConnection', integrationKey: string }>, IntrusionPartitions: Array<{ __typename?: 'IntrusionPartition', enabled: boolean, canArm?: boolean | undefined, canDisarm?: boolean | undefined, id: string, name: string, index: number, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, PartitionZoneAssignments: Array<{ __typename?: 'PartitionZoneAssignments', enabled: boolean, partitionID: string, zoneID: string, IntrusionZone: { __typename?: 'IntrusionZone', id: string, name: string, index: number, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, canBypass?: boolean | undefined, type: qx_eIntrusionZoneType_enum, defaultVideoSourceID?: any | undefined, VideoSource?: { __typename?: 'qx_VideoSource', id: any } | undefined } }> }>, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, nics?: any | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }, doors: Array<{ __typename?: 'qx_Door', id: any, name: string, enabled: boolean }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string, enabled: boolean }>, intrusionPartitionCount: Array<{ __typename?: 'IntrusionPartition', index: number, stateValues?: any | undefined, alarmValues?: any | undefined }>, intrusionZoneCount: Array<{ __typename?: 'IntrusionZone', index: number, stateValues?: any | undefined, alarmValues?: any | undefined }> } | undefined };

export type IntrusionPartitionEditableFieldsFragment = { __typename?: 'IntrusionPartition', id: string, description?: string | undefined, placeID: string, Place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } };

export type IntrusionPartitionSearchFragment = { __typename?: 'IntrusionPartition', enabled: boolean, id: string, description?: string | undefined, placeID: string, name: string, index: number, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, PartitionZoneAssignments: Array<{ __typename?: 'PartitionZoneAssignments', zoneID: string, IntrusionZone: { __typename?: 'IntrusionZone', id: string, stateValues?: any | undefined, alarmValues?: any | undefined } }>, Device: { __typename?: 'qx_Device', deviceAddress?: string | undefined, id: string, name: string, connectionStatus: qx_eDeviceConnectionStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } }, Place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } };

export type GQL_INTRUSION_PARTITION_SEARCHQueryVariables = Exact<{
  where?: IntrusionPartition_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<IntrusionPartition_order_by> | IntrusionPartition_order_by;
}>;


export type GQL_INTRUSION_PARTITION_SEARCHQuery = { __typename?: 'query_root', IntrusionPartition: Array<{ __typename?: 'IntrusionPartition', enabled: boolean, id: string, description?: string | undefined, placeID: string, name: string, index: number, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, PartitionZoneAssignments: Array<{ __typename?: 'PartitionZoneAssignments', zoneID: string, IntrusionZone: { __typename?: 'IntrusionZone', id: string, stateValues?: any | undefined, alarmValues?: any | undefined } }>, Device: { __typename?: 'qx_Device', deviceAddress?: string | undefined, id: string, name: string, connectionStatus: qx_eDeviceConnectionStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } }, Place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }> };

export type GQL_SUB_INTRUSION_PARTITION_SEARCHSubscriptionVariables = Exact<{
  where?: IntrusionPartition_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<IntrusionPartition_order_by> | IntrusionPartition_order_by;
}>;


export type GQL_SUB_INTRUSION_PARTITION_SEARCHSubscription = { __typename?: 'subscription_root', IntrusionPartition: Array<{ __typename?: 'IntrusionPartition', enabled: boolean, id: string, description?: string | undefined, placeID: string, name: string, index: number, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, PartitionZoneAssignments: Array<{ __typename?: 'PartitionZoneAssignments', zoneID: string, IntrusionZone: { __typename?: 'IntrusionZone', id: string, stateValues?: any | undefined, alarmValues?: any | undefined } }>, Device: { __typename?: 'qx_Device', deviceAddress?: string | undefined, id: string, name: string, connectionStatus: qx_eDeviceConnectionStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } }, Place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }> };

export type IntrusionPartitionDetailFragment = { __typename?: 'IntrusionPartition', enabled: boolean, canArm?: boolean | undefined, canDisarm?: boolean | undefined, id: string, description?: string | undefined, placeID: string, name: string, index: number, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, PartitionZoneAssignments: Array<{ __typename?: 'PartitionZoneAssignments', enabled: boolean, partitionID: string, zoneID: string, IntrusionZone: { __typename?: 'IntrusionZone', id: string, name: string, index: number, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, canBypass?: boolean | undefined, type: qx_eIntrusionZoneType_enum, defaultVideoSourceID?: any | undefined, VideoSource?: { __typename?: 'qx_VideoSource', id: any } | undefined } }>, Device: { __typename?: 'qx_Device', description?: string | undefined, id: string, name: string, connectionStatus: qx_eDeviceConnectionStatus_enum, IntrusionPartitions: Array<{ __typename?: 'IntrusionPartition', id: string, name: string, index: number, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, PartitionZoneAssignments: Array<{ __typename?: 'PartitionZoneAssignments', zoneID: string, IntrusionZone: { __typename?: 'IntrusionZone', id: string, name: string, index: number, stateValues?: any | undefined, alarmValues?: any | undefined } }> }>, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } }, Place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } };

export type GQL_GET_INTRUSION_PARTITION_BY_IDQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_INTRUSION_PARTITION_BY_IDQuery = { __typename?: 'query_root', IntrusionPartition_by_pk?: { __typename?: 'IntrusionPartition', enabled: boolean, canArm?: boolean | undefined, canDisarm?: boolean | undefined, id: string, description?: string | undefined, placeID: string, name: string, index: number, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, PartitionZoneAssignments: Array<{ __typename?: 'PartitionZoneAssignments', enabled: boolean, partitionID: string, zoneID: string, IntrusionZone: { __typename?: 'IntrusionZone', id: string, name: string, index: number, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, canBypass?: boolean | undefined, type: qx_eIntrusionZoneType_enum, defaultVideoSourceID?: any | undefined, VideoSource?: { __typename?: 'qx_VideoSource', id: any } | undefined } }>, Device: { __typename?: 'qx_Device', description?: string | undefined, id: string, name: string, connectionStatus: qx_eDeviceConnectionStatus_enum, IntrusionPartitions: Array<{ __typename?: 'IntrusionPartition', id: string, name: string, index: number, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, PartitionZoneAssignments: Array<{ __typename?: 'PartitionZoneAssignments', zoneID: string, IntrusionZone: { __typename?: 'IntrusionZone', id: string, name: string, index: number, stateValues?: any | undefined, alarmValues?: any | undefined } }> }>, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } }, Place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } | undefined };

export type GQL_SUB_INTRUSION_PARTITION_BY_IDSubscriptionVariables = Exact<{
  id: string;
}>;


export type GQL_SUB_INTRUSION_PARTITION_BY_IDSubscription = { __typename?: 'subscription_root', IntrusionPartition_by_pk?: { __typename?: 'IntrusionPartition', enabled: boolean, canArm?: boolean | undefined, canDisarm?: boolean | undefined, id: string, description?: string | undefined, placeID: string, name: string, index: number, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, PartitionZoneAssignments: Array<{ __typename?: 'PartitionZoneAssignments', enabled: boolean, partitionID: string, zoneID: string, IntrusionZone: { __typename?: 'IntrusionZone', id: string, name: string, index: number, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, canBypass?: boolean | undefined, type: qx_eIntrusionZoneType_enum, defaultVideoSourceID?: any | undefined, VideoSource?: { __typename?: 'qx_VideoSource', id: any } | undefined } }>, Device: { __typename?: 'qx_Device', description?: string | undefined, id: string, name: string, connectionStatus: qx_eDeviceConnectionStatus_enum, IntrusionPartitions: Array<{ __typename?: 'IntrusionPartition', id: string, name: string, index: number, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, PartitionZoneAssignments: Array<{ __typename?: 'PartitionZoneAssignments', zoneID: string, IntrusionZone: { __typename?: 'IntrusionZone', id: string, name: string, index: number, stateValues?: any | undefined, alarmValues?: any | undefined } }> }>, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } }, Place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } | undefined };

export type GQL_UPDATE_INTRUSION_PARTITION_BY_IDMutationVariables = Exact<{
  id: string;
  partition: IntrusionPartition_set_input;
}>;


export type GQL_UPDATE_INTRUSION_PARTITION_BY_IDMutation = { __typename?: 'mutation_root', update_IntrusionPartition_by_pk?: { __typename?: 'IntrusionPartition', id: string, description?: string | undefined, placeID: string, Place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } | undefined };

export type GQL_ARM_INTRUSION_PARTITIONMutationVariables = Exact<{
  deviceID: string;
  partitionID: string;
  armMode: IntrusionArmMode;
}>;


export type GQL_ARM_INTRUSION_PARTITIONMutation = { __typename?: 'mutation_root', armPartition: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_BYPASS_INTRUSION_ZONEMutationVariables = Exact<{
  deviceID: string;
  zoneID: string;
}>;


export type GQL_BYPASS_INTRUSION_ZONEMutation = { __typename?: 'mutation_root', bypassZone: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_UPDATE_DEVICE_WITH_CONNECTIONMutationVariables = Exact<{
  input: UpdateDeviceWithConnectionInput;
}>;


export type GQL_UPDATE_DEVICE_WITH_CONNECTIONMutation = { __typename?: 'mutation_root', updateDeviceWithConnection: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_AXIS_BODY_WORN_USER_LISTQueryVariables = Exact<{
  deviceID: string;
}>;


export type GQL_AXIS_BODY_WORN_USER_LISTQuery = { __typename?: 'query_root', axisBodyWornUserList: Array<{ __typename?: 'AxisBodyWornUser', id: string, name: string }> };

export type GQL_DEVICE_SEARCH_SUBSCRIPTIONVariables = Exact<{
  where?: qx_Device_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Device_order_by> | qx_Device_order_by;
}>;


export type GQL_DEVICE_SEARCH_SUBSCRIPTION = { __typename?: 'subscription_root', devices: Array<{ __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, enabled: boolean, name: string, description?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, port: number, serial?: string | undefined, tls: boolean, meta?: any | undefined, make?: string | undefined, model?: string | undefined, firmware?: string | undefined, ntp?: boolean | undefined, timezone?: string | undefined, dst?: boolean | undefined, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, connectionStatus: qx_eDeviceConnectionStatus_enum, profileMSupported?: boolean | undefined, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, nics?: any | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }, doors: Array<{ __typename?: 'qx_Door', id: any, name: string, enabled: boolean }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string, enabled: boolean }>, intrusionPartitionCount: Array<{ __typename?: 'IntrusionPartition', index: number, stateValues?: any | undefined, alarmValues?: any | undefined }>, intrusionZoneCount: Array<{ __typename?: 'IntrusionZone', index: number, stateValues?: any | undefined, alarmValues?: any | undefined }> }> };

export type GQL_DIO_ACTIVATE_OUTPUTMutationVariables = Exact<{
  outputPointID: string;
}>;


export type GQL_DIO_ACTIVATE_OUTPUTMutation = { __typename?: 'mutation_root', activateOutput: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_DIO_DEACTIVATE_OUTPUTMutationVariables = Exact<{
  outputPointID: string;
}>;


export type GQL_DIO_DEACTIVATE_OUTPUTMutation = { __typename?: 'mutation_root', deactivateOutput: { __typename?: 'SuccessOutput', success: boolean } };

export type DoorDeviceGatewayFieldsFragment = { __typename?: 'qx_Door', deviceID: string, devicePacsStatus?: string | undefined, devicePacsHWUpdate?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined };

export type DoorPermissionsFragment = { __typename?: 'qx_Permission', id: string, name: string, thumbnail?: string | undefined, thumbnail_sm?: string | undefined, group: { __typename?: 'qx_Group', id: string, name: string, toPeople: Array<{ __typename?: 'qx__PersonToGroup', personID: string }> }, schedule: { __typename?: 'qx_Schedule', id: string, name: string } };

export type DoorInsideOutsideFragment = { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, permissions: Array<{ __typename?: 'qx_Permission', id: string, name: string, thumbnail?: string | undefined, thumbnail_sm?: string | undefined, group: { __typename?: 'qx_Group', id: string, name: string, toPeople: Array<{ __typename?: 'qx__PersonToGroup', personID: string }> }, schedule: { __typename?: 'qx_Schedule', id: string, name: string } }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string }> };

export type DoorSingleFragment = { __typename?: 'qx_Door', id: any, type?: string | undefined, name: string, canOperate?: boolean | undefined, description?: string | undefined, updatedAt?: any | undefined, enabled: boolean, defaultVideoSourceID?: any | undefined, batteryLevel: qx_eBatteryLevel_enum, doorMonitorAlarm: boolean, lockdownImmunity?: boolean | undefined, accessTime?: string | undefined, openTime?: string | undefined, extendedAccessTime?: string | undefined, extendedOpenTime?: string | undefined, preAlarmTime?: string | undefined, lockAddress?: string | undefined, doorMonitorAddress?: string | undefined, mode: qx_eDoorMode_enum, state: qx_eDoorState_enum, timezone?: string | undefined, alarm: qx_eDoorAlarm_enum, unlockScheduleID?: string | undefined, disabledByLicense: boolean, deviceID: string, doorMonitor: qx_eDoorMonitor_enum, devicePacsStatus?: string | undefined, devicePacsHWUpdate?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } | undefined, device: { __typename?: 'qx_Device', id: string, name: string, description?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, kind: qx_eDeviceKind_enum, meta?: any | undefined, make?: string | undefined, model?: string | undefined, serial?: string | undefined, firmware?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, deviceUsername?: string | undefined, devicePassword?: string | undefined, port: number, tls: boolean, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, pacsUpdateTime: any, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string, path: string } } }, place: { __typename?: 'qx_Place', id: string, name: string, path: string, timezone?: string | undefined, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, inside: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, permissions: Array<{ __typename?: 'qx_Permission', id: string, name: string, thumbnail?: string | undefined, thumbnail_sm?: string | undefined, group: { __typename?: 'qx_Group', id: string, name: string, toPeople: Array<{ __typename?: 'qx__PersonToGroup', personID: string }> }, schedule: { __typename?: 'qx_Schedule', id: string, name: string } }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string }> }, outside?: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, permissions: Array<{ __typename?: 'qx_Permission', id: string, name: string, thumbnail?: string | undefined, thumbnail_sm?: string | undefined, group: { __typename?: 'qx_Group', id: string, name: string, toPeople: Array<{ __typename?: 'qx__PersonToGroup', personID: string }> }, schedule: { __typename?: 'qx_Schedule', id: string, name: string } }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string }> } | undefined, unlockSchedule?: { __typename?: 'qx_Schedule', id: string, name: string, isActive?: boolean | undefined, holidayActive?: string | undefined, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, scheduleID: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }>, permissions: Array<{ __typename?: 'qx_Permission', id: string, name: string }>, place: { __typename?: 'qx_Place', id: string, name: string } } | undefined };

export type GQL_GET_DOOR_BY_IDQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_DOOR_BY_IDQuery = { __typename?: 'query_root', door?: { __typename?: 'qx_Door', id: any, type?: string | undefined, name: string, canOperate?: boolean | undefined, description?: string | undefined, updatedAt?: any | undefined, enabled: boolean, defaultVideoSourceID?: any | undefined, batteryLevel: qx_eBatteryLevel_enum, doorMonitorAlarm: boolean, lockdownImmunity?: boolean | undefined, accessTime?: string | undefined, openTime?: string | undefined, extendedAccessTime?: string | undefined, extendedOpenTime?: string | undefined, preAlarmTime?: string | undefined, lockAddress?: string | undefined, doorMonitorAddress?: string | undefined, mode: qx_eDoorMode_enum, state: qx_eDoorState_enum, timezone?: string | undefined, alarm: qx_eDoorAlarm_enum, unlockScheduleID?: string | undefined, disabledByLicense: boolean, deviceID: string, doorMonitor: qx_eDoorMonitor_enum, devicePacsStatus?: string | undefined, devicePacsHWUpdate?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } | undefined, device: { __typename?: 'qx_Device', id: string, name: string, description?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, kind: qx_eDeviceKind_enum, meta?: any | undefined, make?: string | undefined, model?: string | undefined, serial?: string | undefined, firmware?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, deviceUsername?: string | undefined, devicePassword?: string | undefined, port: number, tls: boolean, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, pacsUpdateTime: any, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string, path: string } } }, place: { __typename?: 'qx_Place', id: string, name: string, path: string, timezone?: string | undefined, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, inside: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, permissions: Array<{ __typename?: 'qx_Permission', id: string, name: string, thumbnail?: string | undefined, thumbnail_sm?: string | undefined, group: { __typename?: 'qx_Group', id: string, name: string, toPeople: Array<{ __typename?: 'qx__PersonToGroup', personID: string }> }, schedule: { __typename?: 'qx_Schedule', id: string, name: string } }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string }> }, outside?: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, permissions: Array<{ __typename?: 'qx_Permission', id: string, name: string, thumbnail?: string | undefined, thumbnail_sm?: string | undefined, group: { __typename?: 'qx_Group', id: string, name: string, toPeople: Array<{ __typename?: 'qx__PersonToGroup', personID: string }> }, schedule: { __typename?: 'qx_Schedule', id: string, name: string } }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string }> } | undefined, unlockSchedule?: { __typename?: 'qx_Schedule', id: string, name: string, isActive?: boolean | undefined, holidayActive?: string | undefined, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, scheduleID: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }>, permissions: Array<{ __typename?: 'qx_Permission', id: string, name: string }>, place: { __typename?: 'qx_Place', id: string, name: string } } | undefined } | undefined };

export type GQL_SUB_DOOR_BY_IDSubscriptionVariables = Exact<{
  id: string;
}>;


export type GQL_SUB_DOOR_BY_IDSubscription = { __typename?: 'subscription_root', door?: { __typename?: 'qx_Door', id: any, type?: string | undefined, name: string, canOperate?: boolean | undefined, description?: string | undefined, updatedAt?: any | undefined, enabled: boolean, defaultVideoSourceID?: any | undefined, batteryLevel: qx_eBatteryLevel_enum, doorMonitorAlarm: boolean, lockdownImmunity?: boolean | undefined, accessTime?: string | undefined, openTime?: string | undefined, extendedAccessTime?: string | undefined, extendedOpenTime?: string | undefined, preAlarmTime?: string | undefined, lockAddress?: string | undefined, doorMonitorAddress?: string | undefined, mode: qx_eDoorMode_enum, state: qx_eDoorState_enum, timezone?: string | undefined, alarm: qx_eDoorAlarm_enum, unlockScheduleID?: string | undefined, disabledByLicense: boolean, deviceID: string, doorMonitor: qx_eDoorMonitor_enum, devicePacsStatus?: string | undefined, devicePacsHWUpdate?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } | undefined, device: { __typename?: 'qx_Device', id: string, name: string, description?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, kind: qx_eDeviceKind_enum, meta?: any | undefined, make?: string | undefined, model?: string | undefined, serial?: string | undefined, firmware?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, deviceUsername?: string | undefined, devicePassword?: string | undefined, port: number, tls: boolean, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, pacsUpdateTime: any, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string, path: string } } }, place: { __typename?: 'qx_Place', id: string, name: string, path: string, timezone?: string | undefined, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, inside: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, permissions: Array<{ __typename?: 'qx_Permission', id: string, name: string, thumbnail?: string | undefined, thumbnail_sm?: string | undefined, group: { __typename?: 'qx_Group', id: string, name: string, toPeople: Array<{ __typename?: 'qx__PersonToGroup', personID: string }> }, schedule: { __typename?: 'qx_Schedule', id: string, name: string } }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string }> }, outside?: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, permissions: Array<{ __typename?: 'qx_Permission', id: string, name: string, thumbnail?: string | undefined, thumbnail_sm?: string | undefined, group: { __typename?: 'qx_Group', id: string, name: string, toPeople: Array<{ __typename?: 'qx__PersonToGroup', personID: string }> }, schedule: { __typename?: 'qx_Schedule', id: string, name: string } }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string }> } | undefined, unlockSchedule?: { __typename?: 'qx_Schedule', id: string, name: string, isActive?: boolean | undefined, holidayActive?: string | undefined, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, scheduleID: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }>, permissions: Array<{ __typename?: 'qx_Permission', id: string, name: string }>, place: { __typename?: 'qx_Place', id: string, name: string } } | undefined } | undefined };

export type GQL_MOMENTARY_UNLOCK_DOOR_BY_IDMutationVariables = Exact<{
  id: string;
}>;


export type GQL_MOMENTARY_UNLOCK_DOOR_BY_IDMutation = { __typename?: 'mutation_root', accessDoor: { __typename?: 'SuccessOutput', success: boolean } };

export type DoorSearchFragment = { __typename?: 'qx_Door', id: any, type?: string | undefined, name: string, description?: string | undefined, canOperate?: boolean | undefined, mode: qx_eDoorMode_enum, enabled: boolean, state: qx_eDoorState_enum, timezone?: string | undefined, alarm: qx_eDoorAlarm_enum, batteryLevel: qx_eBatteryLevel_enum, doorMonitor: qx_eDoorMonitor_enum, doorMonitorAddress?: string | undefined, lockdownImmunity?: boolean | undefined, defaultVideoSourceID?: any | undefined, deviceID: string, devicePacsStatus?: string | undefined, devicePacsHWUpdate?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, unlockSchedule?: { __typename?: 'qx_Schedule', id: string, name: string, thumbnail?: string | undefined, isActive?: boolean | undefined, holidayActive?: string | undefined, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, scheduleID: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }> } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, path: string, timezone?: string | undefined, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, outside?: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } | undefined, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, kind: qx_eDeviceKind_enum, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } } };

export type GQL_DOOR_SEARCHQueryVariables = Exact<{
  where?: qx_Door_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Door_order_by> | qx_Door_order_by;
}>;


export type GQL_DOOR_SEARCHQuery = { __typename?: 'query_root', doors: Array<{ __typename?: 'qx_Door', id: any, type?: string | undefined, name: string, description?: string | undefined, canOperate?: boolean | undefined, mode: qx_eDoorMode_enum, enabled: boolean, state: qx_eDoorState_enum, timezone?: string | undefined, alarm: qx_eDoorAlarm_enum, batteryLevel: qx_eBatteryLevel_enum, doorMonitor: qx_eDoorMonitor_enum, doorMonitorAddress?: string | undefined, lockdownImmunity?: boolean | undefined, defaultVideoSourceID?: any | undefined, deviceID: string, devicePacsStatus?: string | undefined, devicePacsHWUpdate?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, unlockSchedule?: { __typename?: 'qx_Schedule', id: string, name: string, thumbnail?: string | undefined, isActive?: boolean | undefined, holidayActive?: string | undefined, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, scheduleID: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }> } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, path: string, timezone?: string | undefined, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, outside?: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } | undefined, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, kind: qx_eDeviceKind_enum, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } } }>, doorAggregate: { __typename?: 'qx_Door_aggregate', aggregate?: { __typename?: 'qx_Door_aggregate_fields', count: number } | undefined } };

export type DoorSearchMiniFragment = { __typename?: 'qx_Door', id: any, name: string, canOperate?: boolean | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } };

export type LiveScrollerDoorResolveFragment = { __typename?: 'qx_Door', id: any, name: string };

export type GQL_DOOR_SEARCH_MINIQueryVariables = Exact<{
  where?: qx_Door_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Door_order_by> | qx_Door_order_by;
}>;


export type GQL_DOOR_SEARCH_MINIQuery = { __typename?: 'query_root', doors: Array<{ __typename?: 'qx_Door', id: any, name: string, canOperate?: boolean | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }>, doorAggregate: { __typename?: 'qx_Door_aggregate', aggregate?: { __typename?: 'qx_Door_aggregate_fields', count: number } | undefined } };

export type GQL_GET_DOORS_BY_IDSQueryVariables = Exact<{
  ids: Array<string> | string;
}>;


export type GQL_GET_DOORS_BY_IDSQuery = { __typename?: 'query_root', doors: Array<{ __typename?: 'qx_Door', id: any, name: string }> };

export type GQL_GET_AI_TOOL_RESULT_DOORS_BY_IDSQueryVariables = Exact<{
  ids: Array<string> | string;
}>;


export type GQL_GET_AI_TOOL_RESULT_DOORS_BY_IDSQuery = { __typename?: 'query_root', doors: Array<{ __typename?: 'qx_Door', id: any, type?: string | undefined, name: string, description?: string | undefined, canOperate?: boolean | undefined, mode: qx_eDoorMode_enum, enabled: boolean, state: qx_eDoorState_enum, timezone?: string | undefined, alarm: qx_eDoorAlarm_enum, batteryLevel: qx_eBatteryLevel_enum, doorMonitor: qx_eDoorMonitor_enum, doorMonitorAddress?: string | undefined, lockdownImmunity?: boolean | undefined, defaultVideoSourceID?: any | undefined, deviceID: string, devicePacsStatus?: string | undefined, devicePacsHWUpdate?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, unlockSchedule?: { __typename?: 'qx_Schedule', id: string, name: string, thumbnail?: string | undefined, isActive?: boolean | undefined, holidayActive?: string | undefined, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, scheduleID: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }> } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, path: string, timezone?: string | undefined, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, outside?: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } | undefined, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, kind: qx_eDeviceKind_enum, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } } }> };

export type GQL_DOOR_SEARCH_SUBSCRIPTIONVariables = Exact<{
  where?: qx_Door_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Door_order_by> | qx_Door_order_by;
}>;


export type GQL_DOOR_SEARCH_SUBSCRIPTION = { __typename?: 'subscription_root', doors: Array<{ __typename?: 'qx_Door', id: any, type?: string | undefined, name: string, description?: string | undefined, canOperate?: boolean | undefined, mode: qx_eDoorMode_enum, enabled: boolean, state: qx_eDoorState_enum, timezone?: string | undefined, alarm: qx_eDoorAlarm_enum, batteryLevel: qx_eBatteryLevel_enum, doorMonitor: qx_eDoorMonitor_enum, doorMonitorAddress?: string | undefined, lockdownImmunity?: boolean | undefined, defaultVideoSourceID?: any | undefined, deviceID: string, devicePacsStatus?: string | undefined, devicePacsHWUpdate?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, unlockSchedule?: { __typename?: 'qx_Schedule', id: string, name: string, thumbnail?: string | undefined, isActive?: boolean | undefined, holidayActive?: string | undefined, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, scheduleID: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }> } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, path: string, timezone?: string | undefined, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, outside?: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } | undefined, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, kind: qx_eDeviceKind_enum, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } } }> };

export type getEventTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type getEventTypesQuery = { __typename?: 'query_root', eventTypes: Array<{ __typename?: 'qx_EventType', type: string, priority: number, uniqueID: string, id: string }> };

export type GQL_GET_EVENT_STATUS_LABELSQueryVariables = Exact<{
  where: vEventStatuses_bool_exp;
}>;


export type GQL_GET_EVENT_STATUS_LABELSQuery = { __typename?: 'query_root', vEventStatuses: Array<{ __typename?: 'vEventStatuses', type?: string | undefined, status?: string | undefined, comment?: string | undefined }> };

export type GatewaySearchFragment = { __typename?: 'qx_Gateway', id: string, name: string, thumbnail?: string | undefined, thumbnail_md?: string | undefined, oldestMedia?: any | undefined, syncStatus: qx_eGatewaySyncStatus_enum, licenseDetails?: any | undefined, features: any, hostname?: string | undefined, type: eGatewayType_enum, serial?: string | undefined, version?: string | undefined, wireguardIP?: string | undefined, connectionStatus: boolean, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, devices: Array<{ __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, doors: Array<{ __typename?: 'qx_Door', id: any, enabled: boolean }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, enabled: boolean }> }> };

export type GQL_GET_GATEWAYS_BY_IDSQueryVariables = Exact<{
  ids: Array<string> | string;
}>;


export type GQL_GET_GATEWAYS_BY_IDSQuery = { __typename?: 'query_root', gateways: Array<{ __typename?: 'qx_Gateway', id: string, name: string, thumbnail?: string | undefined, thumbnail_md?: string | undefined, oldestMedia?: any | undefined, syncStatus: qx_eGatewaySyncStatus_enum, licenseDetails?: any | undefined, features: any, hostname?: string | undefined, type: eGatewayType_enum, serial?: string | undefined, version?: string | undefined, wireguardIP?: string | undefined, connectionStatus: boolean, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, devices: Array<{ __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, doors: Array<{ __typename?: 'qx_Door', id: any, enabled: boolean }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, enabled: boolean }> }> }> };

export type GQL_CREATE_GATEWAY_BANDWIDTH_SCHEDULEMutationVariables = Exact<{
  bandwidthSchedule: qx_GatewayBandwidthSchedule_insert_input;
}>;


export type GQL_CREATE_GATEWAY_BANDWIDTH_SCHEDULEMutation = { __typename?: 'mutation_root', createGatewayBandwidthSchedule?: { __typename?: 'qx_GatewayBandwidthSchedule', id: any } | undefined };

export type GQL_UPDATE_GATEWAY_BANDWIDTH_SCHEDULEMutationVariables = Exact<{
  id: string;
  data: qx_GatewayBandwidthSchedule_set_input;
}>;


export type GQL_UPDATE_GATEWAY_BANDWIDTH_SCHEDULEMutation = { __typename?: 'mutation_root', updateGatewayBandwidthSchedule?: { __typename?: 'qx_GatewayBandwidthSchedule', id: any } | undefined };

export type GQL_DELETE_GATEWAY_BANDWIDTH_SCHEDULEMutationVariables = Exact<{
  id: string;
}>;


export type GQL_DELETE_GATEWAY_BANDWIDTH_SCHEDULEMutation = { __typename?: 'mutation_root', deleteGatewayBandwidthSchedule?: { __typename?: 'qx_GatewayBandwidthSchedule', id: any } | undefined };

export type SingleGroupFragment = { __typename?: 'qx_Group', id: string, name: string, externalGroupID?: string | undefined, thumbnail_lg?: string | undefined, place: { __typename?: 'qx_Place', name: string, id: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, toPeople_aggregate: { __typename?: 'qx__PersonToGroup_aggregate', aggregate?: { __typename?: 'qx__PersonToGroup_aggregate_fields', count: number } | undefined }, permissions_aggregate: { __typename?: 'qx_Permission_aggregate', aggregate?: { __typename?: 'qx_Permission_aggregate_fields', count: number } | undefined }, toPeople: Array<{ __typename?: 'qx__PersonToGroup', person: { __typename?: 'qx_Person', id: string, avatar_sm?: string | undefined, firstName?: string | undefined, lastName?: string | undefined } }> };

export type CRUDGroupFragment = { __typename?: 'qx_Group', id: string, name: string };

export type GQL_GET_GROUP_BY_IDQueryVariables = Exact<{
  id: string;
  currentScopePath: string;
}>;


export type GQL_GET_GROUP_BY_IDQuery = { __typename?: 'query_root', group?: { __typename?: 'qx_Group', id: string, name: string, externalGroupID?: string | undefined, thumbnail_lg?: string | undefined, place: { __typename?: 'qx_Place', name: string, id: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, toPeople_aggregate: { __typename?: 'qx__PersonToGroup_aggregate', aggregate?: { __typename?: 'qx__PersonToGroup_aggregate_fields', count: number } | undefined }, permissions_aggregate: { __typename?: 'qx_Permission_aggregate', aggregate?: { __typename?: 'qx_Permission_aggregate_fields', count: number } | undefined }, toPeople: Array<{ __typename?: 'qx__PersonToGroup', person: { __typename?: 'qx_Person', id: string, avatar_sm?: string | undefined, firstName?: string | undefined, lastName?: string | undefined } }> } | undefined };

export type GQL_SUB_GROUP_BY_IDSubscriptionVariables = Exact<{
  id: string;
  currentScopePath: string;
}>;


export type GQL_SUB_GROUP_BY_IDSubscription = { __typename?: 'subscription_root', group?: { __typename?: 'qx_Group', id: string, name: string, externalGroupID?: string | undefined, thumbnail_lg?: string | undefined, place: { __typename?: 'qx_Place', name: string, id: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, toPeople_aggregate: { __typename?: 'qx__PersonToGroup_aggregate', aggregate?: { __typename?: 'qx__PersonToGroup_aggregate_fields', count: number } | undefined }, permissions_aggregate: { __typename?: 'qx_Permission_aggregate', aggregate?: { __typename?: 'qx_Permission_aggregate_fields', count: number } | undefined }, toPeople: Array<{ __typename?: 'qx__PersonToGroup', person: { __typename?: 'qx_Person', id: string, avatar_sm?: string | undefined, firstName?: string | undefined, lastName?: string | undefined } }> } | undefined };

export type GQL_CREATE_GROUPMutationVariables = Exact<{
  group: qx_Group_insert_input;
}>;


export type GQL_CREATE_GROUPMutation = { __typename?: 'mutation_root', createGroup?: { __typename?: 'qx_Group', id: string, name: string } | undefined };

export type GQL_GROUP_ADD_PEOPLEMutationVariables = Exact<{
  objects: Array<qx__PersonToGroup_insert_input> | qx__PersonToGroup_insert_input;
}>;


export type GQL_GROUP_ADD_PEOPLEMutation = { __typename?: 'mutation_root', createPersonGroups?: { __typename?: 'qx__PersonToGroup_mutation_response', returning: Array<{ __typename?: 'qx__PersonToGroup', personID: string, groupID: string }> } | undefined };

export type GQL_UPDATE_GROUP_BY_IDMutationVariables = Exact<{
  id: string;
  group: qx_Group_set_input;
}>;


export type GQL_UPDATE_GROUP_BY_IDMutation = { __typename?: 'mutation_root', updateGroup?: { __typename?: 'qx_Group', id: string, name: string } | undefined };

export type GQL_GROUP_REMOVE_PEOPLEMutationVariables = Exact<{
  groupID: string;
  removePeople: Array<string> | string;
}>;


export type GQL_GROUP_REMOVE_PEOPLEMutation = { __typename?: 'mutation_root', deletePersonGroups?: { __typename?: 'qx__PersonToGroup_mutation_response', returning: Array<{ __typename?: 'qx__PersonToGroup', personID: string }> } | undefined };

export type GQL_DELETE_GROUP_BY_IDMutationVariables = Exact<{
  id: string;
}>;


export type GQL_DELETE_GROUP_BY_IDMutation = { __typename?: 'mutation_root', deleteGroup?: { __typename?: 'qx_Group', id: string } | undefined };

export type GroupSearchFragment = { __typename?: 'qx_Group', id: string, name: string, description?: string | undefined, thumbnail?: string | undefined, externalGroupID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, toPeople_aggregate: { __typename?: 'qx__PersonToGroup_aggregate', aggregate?: { __typename?: 'qx__PersonToGroup_aggregate_fields', count: number } | undefined }, permissions_aggregate: { __typename?: 'qx_Permission_aggregate', aggregate?: { __typename?: 'qx_Permission_aggregate_fields', count: number } | undefined } };

export type GQL_GROUP_SEARCHQueryVariables = Exact<{
  where?: qx_Group_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Group_order_by> | qx_Group_order_by;
  currentScopePath: string;
}>;


export type GQL_GROUP_SEARCHQuery = { __typename?: 'query_root', groups: Array<{ __typename?: 'qx_Group', id: string, name: string, description?: string | undefined, thumbnail?: string | undefined, externalGroupID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, toPeople_aggregate: { __typename?: 'qx__PersonToGroup_aggregate', aggregate?: { __typename?: 'qx__PersonToGroup_aggregate_fields', count: number } | undefined }, permissions_aggregate: { __typename?: 'qx_Permission_aggregate', aggregate?: { __typename?: 'qx_Permission_aggregate_fields', count: number } | undefined } }>, groupAggregate: { __typename?: 'qx_Group_aggregate', aggregate?: { __typename?: 'qx_Group_aggregate_fields', count: number } | undefined } };

export type GQL_GROUP_SEARCH_SUBSCRIPTIONVariables = Exact<{
  where?: qx_Group_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Group_order_by> | qx_Group_order_by;
  currentScopePath: string;
}>;


export type GQL_GROUP_SEARCH_SUBSCRIPTION = { __typename?: 'subscription_root', groups: Array<{ __typename?: 'qx_Group', id: string, name: string, description?: string | undefined, thumbnail?: string | undefined, externalGroupID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, toPeople_aggregate: { __typename?: 'qx__PersonToGroup_aggregate', aggregate?: { __typename?: 'qx__PersonToGroup_aggregate_fields', count: number } | undefined }, permissions_aggregate: { __typename?: 'qx_Permission_aggregate', aggregate?: { __typename?: 'qx_Permission_aggregate_fields', count: number } | undefined } }> };

export type HolidaySetFragment = { __typename?: 'qx_HolidaySet', id: string, name: string, description?: string | undefined, placeID: string, dates?: any | undefined, place: { __typename?: 'qx_Place', id: string, type: qx_ePlaceType_enum, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined } };

export type getHolidaySetsQueryVariables = Exact<{
  path: string;
}>;


export type getHolidaySetsQuery = { __typename?: 'query_root', holidaySets: Array<{ __typename?: 'qx_HolidaySet', id: string, name: string, description?: string | undefined, placeID: string, dates?: any | undefined, place: { __typename?: 'qx_Place', id: string, type: qx_ePlaceType_enum, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined } }> };

export type subscribeToAllHolidaySetsUpdatesSubscriptionVariables = Exact<{
  path: string;
}>;


export type subscribeToAllHolidaySetsUpdatesSubscription = { __typename?: 'subscription_root', holidaySets: Array<{ __typename?: 'qx_HolidaySet', id: string, name: string, description?: string | undefined, placeID: string, dates?: any | undefined, place: { __typename?: 'qx_Place', id: string, type: qx_ePlaceType_enum, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined } }> };

export type getHolidaySetByIdQueryVariables = Exact<{
  id: string;
}>;


export type getHolidaySetByIdQuery = { __typename?: 'query_root', holidaySet?: { __typename?: 'qx_HolidaySet', id: string, name: string, description?: string | undefined, placeID: string, dates?: any | undefined, place: { __typename?: 'qx_Place', id: string, type: qx_ePlaceType_enum, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined } } | undefined };

export type GQL_SUB_HOLIDAY_SET_BY_IDSubscriptionVariables = Exact<{
  id: string;
}>;


export type GQL_SUB_HOLIDAY_SET_BY_IDSubscription = { __typename?: 'subscription_root', holidaySet?: { __typename?: 'qx_HolidaySet', id: string, name: string, description?: string | undefined, placeID: string, dates?: any | undefined, place: { __typename?: 'qx_Place', id: string, type: qx_ePlaceType_enum, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined } } | undefined };

export type updateHolidaySetByIdMutationVariables = Exact<{
  id: string;
  holidaySet: qx_HolidaySet_set_input;
}>;


export type updateHolidaySetByIdMutation = { __typename?: 'mutation_root', updateHolidaySets?: { __typename?: 'qx_HolidaySet_mutation_response', returning: Array<{ __typename?: 'qx_HolidaySet', id: string, name: string, description?: string | undefined, placeID: string, dates?: any | undefined, place: { __typename?: 'qx_Place', id: string, type: qx_ePlaceType_enum, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined } }> } | undefined };

export type GQL_HOLIDAY_SET_SEARCHQueryVariables = Exact<{
  where?: qx_HolidaySet_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_HolidaySet_order_by> | qx_HolidaySet_order_by;
}>;


export type GQL_HOLIDAY_SET_SEARCHQuery = { __typename?: 'query_root', holidaySets: Array<{ __typename?: 'qx_HolidaySet', id: string, name: string, description?: string | undefined, placeID: string, dates?: any | undefined, place: { __typename?: 'qx_Place', id: string, type: qx_ePlaceType_enum, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined } }>, holidaySetAggregate: { __typename?: 'qx_HolidaySet_aggregate', aggregate?: { __typename?: 'qx_HolidaySet_aggregate_fields', count: number } | undefined } };

export type GQL_HOLIDAY_SET_SEARCH_SUBSCRIPTIONVariables = Exact<{
  where?: qx_HolidaySet_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_HolidaySet_order_by> | qx_HolidaySet_order_by;
}>;


export type GQL_HOLIDAY_SET_SEARCH_SUBSCRIPTION = { __typename?: 'subscription_root', holidaySets: Array<{ __typename?: 'qx_HolidaySet', id: string, name: string, description?: string | undefined, placeID: string, dates?: any | undefined, place: { __typename?: 'qx_Place', id: string, type: qx_ePlaceType_enum, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined } }> };

export type IntrusionEventRelationFragment = { __typename?: 'vEvents', partitionID?: string | undefined, zoneID?: string | undefined, partition?: { __typename?: 'IntrusionPartition', id: string, name: string } | undefined, zone?: { __typename?: 'IntrusionZone', id: string, name: string } | undefined, start?: { __typename?: 'qx_Event', id: any, partitionID?: string | undefined, zoneID?: string | undefined } | undefined, end?: { __typename?: 'qx_Event', id: any, partitionID?: string | undefined, zoneID?: string | undefined } | undefined };

export type GQL_SEARCH_INTRUSION_V_EVENTSQueryVariables = Exact<{
  where: vEvents_bool_exp;
  limit: number;
  order_by: Array<vEvents_order_by> | vEvents_order_by;
}>;


export type GQL_SEARCH_INTRUSION_V_EVENTSQuery = { __typename?: 'query_root', vEvents: Array<{ __typename?: 'vEvents', id?: any | undefined, active?: boolean | undefined, card?: string | undefined, bits?: number | undefined, status?: string | undefined, time?: any | undefined, serverTime?: any | undefined, type?: string | undefined, duration?: any | undefined, hasVideo?: boolean | undefined, inCloud?: boolean | undefined, onGateway?: boolean | undefined, eventStart?: any | undefined, eventEnd?: any | undefined, sensorID?: any | undefined, personID?: string | undefined, doorID?: any | undefined, videoSourceID?: any | undefined, mediaProfileID?: any | undefined, deviceID?: string | undefined, zoneID?: string | undefined, partitionID?: string | undefined, gatewayID?: string | undefined, placeID?: string | undefined, profile?: string | undefined, sensor?: { __typename?: 'qx_Sensor', id: any, name: string, type: qx_eSensorType_enum } | undefined, person?: { __typename?: 'qx_Person', id: string, avatar_sm?: string | undefined, firstName?: string | undefined, lastName?: string | undefined } | undefined, door?: { __typename?: 'qx_Door', id: any, name: string } | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string } | undefined, device?: { __typename?: 'qx_Device', id: string, name: string, kind: qx_eDeviceKind_enum } | undefined, zone?: { __typename?: 'IntrusionZone', id: string, name: string } | undefined, partition?: { __typename?: 'IntrusionPartition', id: string, name: string } | undefined, toType?: { __typename?: 'qx_EventType', priority: number } | undefined, place?: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, type: eGatewayType_enum } | undefined } | undefined, snapshot?: { __typename?: 'qx_Snapshot', id: string, signedUrl?: string | undefined, aspectRatio?: any | undefined } | undefined, start?: { __typename?: 'qx_Event', id: any, partitionID?: string | undefined, zoneID?: string | undefined } | undefined, end?: { __typename?: 'qx_Event', id: any, partitionID?: string | undefined, zoneID?: string | undefined } | undefined }> };

export type GQL_GET_INTRUSION_PARTITIONS_BY_IDSQueryVariables = Exact<{
  ids: Array<string> | string;
}>;


export type GQL_GET_INTRUSION_PARTITIONS_BY_IDSQuery = { __typename?: 'query_root', IntrusionPartition: Array<{ __typename?: 'IntrusionPartition', id: string, name: string }> };

export type GQL_GET_INTRUSION_ZONES_BY_IDSQueryVariables = Exact<{
  ids: Array<string> | string;
}>;


export type GQL_GET_INTRUSION_ZONES_BY_IDSQuery = { __typename?: 'query_root', IntrusionZone: Array<{ __typename?: 'IntrusionZone', id: string, name: string }> };

export type IntrusionGatewayFieldsFragment = { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } };

export type IntrusionPanelDeviceFieldsFragment = { __typename?: 'qx_Device', id: string, name: string, connectionStatus: qx_eDeviceConnectionStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } };

export type IntrusionPartitionStateFieldsFragment = { __typename?: 'IntrusionPartition', id: string, name: string, index: number, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined };

export type IntrusionZoneStateFieldsFragment = { __typename?: 'IntrusionZone', id: string, name: string, index: number, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, canBypass?: boolean | undefined, type: qx_eIntrusionZoneType_enum, defaultVideoSourceID?: any | undefined, VideoSource?: { __typename?: 'qx_VideoSource', id: any } | undefined };

export type IntrusionZoneSummaryFieldsFragment = { __typename?: 'IntrusionZone', id: string, name: string, index: number, stateValues?: any | undefined, alarmValues?: any | undefined };

export type IntrusionZoneAssignmentFragment = { __typename?: 'PartitionZoneAssignments', enabled: boolean, partitionID: string, zoneID: string, IntrusionZone: { __typename?: 'IntrusionZone', id: string, name: string, index: number, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, canBypass?: boolean | undefined, type: qx_eIntrusionZoneType_enum, defaultVideoSourceID?: any | undefined, VideoSource?: { __typename?: 'qx_VideoSource', id: any } | undefined } };

export type IntrusionZoneAssignmentSummaryFragment = { __typename?: 'PartitionZoneAssignments', zoneID: string, IntrusionZone: { __typename?: 'IntrusionZone', id: string, name: string, index: number, stateValues?: any | undefined, alarmValues?: any | undefined } };

export type LockFragment = { __typename?: 'qx_Lock', id: string, name: string, direction: qx_eAccessPointDirection_enum, enabled: boolean, type: qx_eLockType_enum, relayMonitor?: qx_eLockRelayMonitor_enum | undefined, powerMonitor?: qx_eLockPowerMonitor_enum | undefined, mode?: qx_eLockMode_enum | undefined };

export type GQL_GET_LOCKS_BY_DOOR_IDQueryVariables = Exact<{
  doorId: string;
}>;


export type GQL_GET_LOCKS_BY_DOOR_IDQuery = { __typename?: 'query_root', locks: Array<{ __typename?: 'qx_Lock', id: string, name: string, direction: qx_eAccessPointDirection_enum, enabled: boolean, type: qx_eLockType_enum, relayMonitor?: qx_eLockRelayMonitor_enum | undefined, powerMonitor?: qx_eLockPowerMonitor_enum | undefined, mode?: qx_eLockMode_enum | undefined }> };

export type PeopleFragment = { __typename?: 'qx_Person', id: string, externalPersonID?: string | undefined, createdAt: any, updatedAt?: any | undefined, roleID?: string | undefined, email?: string | undefined, employeeID?: string | undefined, title?: string | undefined, suffix?: string | undefined, firstName?: string | undefined, lastName?: string | undefined, salutation?: string | undefined, avatar_md?: string | undefined, department?: string | undefined, role?: { __typename?: 'qx_Role', id: string, name: string } | undefined, toGroups: Array<{ __typename?: 'qx__PersonToGroup', group: { __typename?: 'qx_Group', id: string, name: string } }>, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, addresses?: any | undefined }, credentials: Array<{ __typename?: 'qx_Credential', id: string, pin?: string | undefined, value: string, validFrom?: any | undefined, validTo?: any | undefined, enabled: boolean, extendedTimeEnabled: boolean, externalSync: boolean }> };

export type SinglePersonFragment = { __typename?: 'qx_Person', id: string, externalPersonID?: string | undefined, roleExternalSync: boolean, createdAt: any, updatedAt?: any | undefined, roleID?: string | undefined, email?: string | undefined, employeeID?: string | undefined, title?: string | undefined, suffix?: string | undefined, firstName?: string | undefined, lastName?: string | undefined, lockdownImmunity?: boolean | undefined, placeID: string, salutation?: string | undefined, department?: string | undefined, phoneNumbers?: any | undefined, licensePlate?: string | undefined, certification?: string | undefined, role?: { __typename?: 'qx_Role', id: string, name: string } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, addresses?: any | undefined, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined } | undefined }, credentials: Array<{ __typename?: 'qx_Credential', id: string, pin?: string | undefined, value: string, validFrom?: any | undefined, validTo?: any | undefined, enabled: boolean, extendedTimeEnabled: boolean, externalSync: boolean, status?: string | undefined, type: qx_eCredentialType_enum, reason?: string | undefined }> };

export type GQL_GET_PERSON_BY_IDQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_PERSON_BY_IDQuery = { __typename?: 'query_root', person?: { __typename?: 'qx_Person', avatar?: string | undefined, id: string, externalPersonID?: string | undefined, roleExternalSync: boolean, createdAt: any, updatedAt?: any | undefined, roleID?: string | undefined, email?: string | undefined, employeeID?: string | undefined, title?: string | undefined, suffix?: string | undefined, firstName?: string | undefined, lastName?: string | undefined, lockdownImmunity?: boolean | undefined, placeID: string, salutation?: string | undefined, department?: string | undefined, phoneNumbers?: any | undefined, licensePlate?: string | undefined, certification?: string | undefined, role?: { __typename?: 'qx_Role', id: string, name: string } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, addresses?: any | undefined, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined } | undefined }, credentials: Array<{ __typename?: 'qx_Credential', id: string, pin?: string | undefined, value: string, validFrom?: any | undefined, validTo?: any | undefined, enabled: boolean, extendedTimeEnabled: boolean, externalSync: boolean, status?: string | undefined, type: qx_eCredentialType_enum, reason?: string | undefined }> } | undefined };

export type GQL_SUB_PERSON_BY_IDSubscriptionVariables = Exact<{
  id: string;
}>;


export type GQL_SUB_PERSON_BY_IDSubscription = { __typename?: 'subscription_root', person?: { __typename?: 'qx_Person', id: string, externalPersonID?: string | undefined, roleExternalSync: boolean, createdAt: any, updatedAt?: any | undefined, roleID?: string | undefined, email?: string | undefined, employeeID?: string | undefined, title?: string | undefined, suffix?: string | undefined, firstName?: string | undefined, lastName?: string | undefined, lockdownImmunity?: boolean | undefined, placeID: string, salutation?: string | undefined, department?: string | undefined, phoneNumbers?: any | undefined, licensePlate?: string | undefined, certification?: string | undefined, role?: { __typename?: 'qx_Role', id: string, name: string } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, addresses?: any | undefined, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined } | undefined }, credentials: Array<{ __typename?: 'qx_Credential', id: string, pin?: string | undefined, value: string, validFrom?: any | undefined, validTo?: any | undefined, enabled: boolean, extendedTimeEnabled: boolean, externalSync: boolean, status?: string | undefined, type: qx_eCredentialType_enum, reason?: string | undefined }> } | undefined };

export type PersonToGroupsFragment = { __typename?: 'qx_Person', toGroups: Array<{ __typename?: 'qx__PersonToGroup', group: { __typename?: 'qx_Group', id: string, permissions: Array<{ __typename?: 'qx_Permission', id: string, placeID: string, schedule: { __typename?: 'qx_Schedule', id: string, name: string, thumbnail?: string | undefined } }> } }> };

export type PersonSearchFragment = { __typename?: 'qx_Person', id: string, externalPersonID?: string | undefined, firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined, employeeID?: string | undefined, department?: string | undefined, title?: string | undefined, lockdownImmunity?: boolean | undefined, createdAt: any, updatedAt?: any | undefined, status?: string | undefined, roleID?: string | undefined, credentials: Array<{ __typename?: 'qx_Credential', id: string, validFrom?: any | undefined, validTo?: any | undefined, enabled: boolean }>, role?: { __typename?: 'qx_Role', id: string, name: string } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } };

export type GQL_PERSON_SEARCHQueryVariables = Exact<{
  where?: qx_Person_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Person_order_by> | qx_Person_order_by;
}>;


export type GQL_PERSON_SEARCHQuery = { __typename?: 'query_root', people: Array<{ __typename?: 'qx_Person', avatar_md?: string | undefined, id: string, externalPersonID?: string | undefined, firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined, employeeID?: string | undefined, department?: string | undefined, title?: string | undefined, lockdownImmunity?: boolean | undefined, createdAt: any, updatedAt?: any | undefined, status?: string | undefined, roleID?: string | undefined, credentials: Array<{ __typename?: 'qx_Credential', id: string, validFrom?: any | undefined, validTo?: any | undefined, enabled: boolean }>, role?: { __typename?: 'qx_Role', id: string, name: string } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }>, personAggregate: { __typename?: 'qx_Person_aggregate', aggregate?: { __typename?: 'qx_Person_aggregate_fields', count: number } | undefined } };

export type GQL_PERSON_TO_GROUPS_SEARCHQueryVariables = Exact<{
  where?: qx_Person_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Person_order_by> | qx_Person_order_by;
}>;


export type GQL_PERSON_TO_GROUPS_SEARCHQuery = { __typename?: 'query_root', people: Array<{ __typename?: 'qx_Person', avatar_md?: string | undefined, id: string, externalPersonID?: string | undefined, firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined, employeeID?: string | undefined, department?: string | undefined, title?: string | undefined, lockdownImmunity?: boolean | undefined, createdAt: any, updatedAt?: any | undefined, status?: string | undefined, roleID?: string | undefined, credentials: Array<{ __typename?: 'qx_Credential', id: string, validFrom?: any | undefined, validTo?: any | undefined, enabled: boolean }>, role?: { __typename?: 'qx_Role', id: string, name: string } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, toGroups: Array<{ __typename?: 'qx__PersonToGroup', group: { __typename?: 'qx_Group', id: string, permissions: Array<{ __typename?: 'qx_Permission', id: string, placeID: string, schedule: { __typename?: 'qx_Schedule', id: string, name: string, thumbnail?: string | undefined } }> } }> }>, personAggregate: { __typename?: 'qx_Person_aggregate', aggregate?: { __typename?: 'qx_Person_aggregate_fields', count: number } | undefined } };

export type PersonSearchMiniFragment = { __typename?: 'qx_Person', id: string, firstName?: string | undefined, lastName?: string | undefined, title?: string | undefined, department?: string | undefined, email?: string | undefined, avatar_sm?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } };

export type LiveScrollerPersonResolveFragment = { __typename?: 'qx_Person', id: string, firstName?: string | undefined, lastName?: string | undefined, avatar_sm?: string | undefined };

export type AiToolResultPersonResolveFragment = { __typename?: 'qx_Person', id: string, firstName?: string | undefined, lastName?: string | undefined, title?: string | undefined, status?: string | undefined, avatar_sm?: string | undefined, role?: { __typename?: 'qx_Role', id: string, name: string } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } };

export type GQL_PERSON_SEARCH_MINIQueryVariables = Exact<{
  where?: qx_Person_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Person_order_by> | qx_Person_order_by;
}>;


export type GQL_PERSON_SEARCH_MINIQuery = { __typename?: 'query_root', people: Array<{ __typename?: 'qx_Person', id: string, firstName?: string | undefined, lastName?: string | undefined, title?: string | undefined, department?: string | undefined, email?: string | undefined, avatar_sm?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }>, personAggregate: { __typename?: 'qx_Person_aggregate', aggregate?: { __typename?: 'qx_Person_aggregate_fields', count: number } | undefined } };

export type GQL_GET_PEOPLE_BY_IDSQueryVariables = Exact<{
  ids: Array<string> | string;
}>;


export type GQL_GET_PEOPLE_BY_IDSQuery = { __typename?: 'query_root', people: Array<{ __typename?: 'qx_Person', id: string, firstName?: string | undefined, lastName?: string | undefined, avatar_sm?: string | undefined }> };

export type GQL_GET_AI_TOOL_RESULT_PEOPLE_BY_IDSQueryVariables = Exact<{
  ids: Array<string> | string;
}>;


export type GQL_GET_AI_TOOL_RESULT_PEOPLE_BY_IDSQuery = { __typename?: 'query_root', people: Array<{ __typename?: 'qx_Person', id: string, firstName?: string | undefined, lastName?: string | undefined, title?: string | undefined, status?: string | undefined, avatar_sm?: string | undefined, role?: { __typename?: 'qx_Role', id: string, name: string } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }> };

export type GQL_PERSON_SEARCH_SUBSCRIPTIONVariables = Exact<{
  where?: qx_Person_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Person_order_by> | qx_Person_order_by;
  currentScopePath?: string;
}>;


export type GQL_PERSON_SEARCH_SUBSCRIPTION = { __typename?: 'subscription_root', people: Array<{ __typename?: 'qx_Person', id: string, externalPersonID?: string | undefined, firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined, employeeID?: string | undefined, department?: string | undefined, title?: string | undefined, lockdownImmunity?: boolean | undefined, createdAt: any, updatedAt?: any | undefined, status?: string | undefined, roleID?: string | undefined, credentials: Array<{ __typename?: 'qx_Credential', id: string, validFrom?: any | undefined, validTo?: any | undefined, enabled: boolean }>, role?: { __typename?: 'qx_Role', id: string, name: string } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }> };

export type GQL_PERSON_TO_GROUPS_SEARCH_SUBSCRIPTIONVariables = Exact<{
  where?: qx_Person_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Person_order_by> | qx_Person_order_by;
  currentScopePath?: string;
}>;


export type GQL_PERSON_TO_GROUPS_SEARCH_SUBSCRIPTION = { __typename?: 'subscription_root', people: Array<{ __typename?: 'qx_Person', id: string, externalPersonID?: string | undefined, firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined, employeeID?: string | undefined, department?: string | undefined, title?: string | undefined, lockdownImmunity?: boolean | undefined, createdAt: any, updatedAt?: any | undefined, status?: string | undefined, roleID?: string | undefined, credentials: Array<{ __typename?: 'qx_Credential', id: string, validFrom?: any | undefined, validTo?: any | undefined, enabled: boolean }>, role?: { __typename?: 'qx_Role', id: string, name: string } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, toGroups: Array<{ __typename?: 'qx__PersonToGroup', group: { __typename?: 'qx_Group', id: string, permissions: Array<{ __typename?: 'qx_Permission', id: string, placeID: string, schedule: { __typename?: 'qx_Schedule', id: string, name: string, thumbnail?: string | undefined } }> } }> }> };

export type PermissionFragment = { __typename?: 'qx_Permission', id: string, name: string, thumbnail_lg?: string | undefined, group: { __typename?: 'qx_Group', id: string, name: string, description?: string | undefined, thumbnail?: string | undefined }, place: { __typename?: 'qx_Place', id: string, name: string }, schedule: { __typename?: 'qx_Schedule', id: string, name: string } };

export type getPermissionsDataQueryVariables = Exact<{
  path: string;
}>;


export type getPermissionsDataQuery = { __typename?: 'query_root', permissions: Array<{ __typename?: 'qx_Permission', id: string, name: string, thumbnail_lg?: string | undefined, group: { __typename?: 'qx_Group', id: string, name: string, description?: string | undefined, thumbnail?: string | undefined }, place: { __typename?: 'qx_Place', id: string, name: string }, schedule: { __typename?: 'qx_Schedule', id: string, name: string } }> };

export type getPermissionByIdQueryVariables = Exact<{
  id: string;
}>;


export type getPermissionByIdQuery = { __typename?: 'query_root', permission?: { __typename?: 'qx_Permission', id: string, name: string, thumbnail_lg?: string | undefined, group: { __typename?: 'qx_Group', id: string, name: string, description?: string | undefined, thumbnail?: string | undefined }, place: { __typename?: 'qx_Place', id: string, name: string }, schedule: { __typename?: 'qx_Schedule', id: string, name: string } } | undefined };

export type subscribeToAllPermissionsUpdatesSubscriptionVariables = Exact<{
  path: string;
}>;


export type subscribeToAllPermissionsUpdatesSubscription = { __typename?: 'subscription_root', permissions: Array<{ __typename?: 'qx_Permission', id: string, name: string, thumbnail_lg?: string | undefined, group: { __typename?: 'qx_Group', id: string, name: string, description?: string | undefined, thumbnail?: string | undefined }, place: { __typename?: 'qx_Place', id: string, name: string }, schedule: { __typename?: 'qx_Schedule', id: string, name: string } }> };

export type SinglePermissionFragment = { __typename?: 'qx_Permission', id: string, thumbnail_lg?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, group: { __typename?: 'qx_Group', id: string, name: string }, schedule: { __typename?: 'qx_Schedule', id: string, name: string, thumbnail?: string | undefined } };

export type PermissionGroupFragment = { __typename?: 'qx_Permission', id: string, name: string, thumbnail_sm?: string | undefined, group: { __typename?: 'qx_Group', id: string, name: string, toPeople_aggregate: { __typename?: 'qx__PersonToGroup_aggregate', aggregate?: { __typename?: 'qx__PersonToGroup_aggregate_fields', count: number } | undefined } }, place: { __typename?: 'qx_Place', id: string, name: string }, schedule: { __typename?: 'qx_Schedule', id: string, name: string, thumbnail?: string | undefined } };

export type GQL_GET_PERMISSION_BY_IDQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_PERMISSION_BY_IDQuery = { __typename?: 'query_root', permission?: { __typename?: 'qx_Permission', id: string, thumbnail_lg?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, group: { __typename?: 'qx_Group', id: string, name: string }, schedule: { __typename?: 'qx_Schedule', id: string, name: string, thumbnail?: string | undefined } } | undefined };

export type GQL_SUB_PERMISSION_BY_IDSubscriptionVariables = Exact<{
  id: string;
}>;


export type GQL_SUB_PERMISSION_BY_IDSubscription = { __typename?: 'subscription_root', permission?: { __typename?: 'qx_Permission', id: string, thumbnail_lg?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, group: { __typename?: 'qx_Group', id: string, name: string }, schedule: { __typename?: 'qx_Schedule', id: string, name: string, thumbnail?: string | undefined } } | undefined };

export type getPermissionsDataByPlaceIdsQueryVariables = Exact<{
  placeIDs?: Array<string> | string;
}>;


export type getPermissionsDataByPlaceIdsQuery = { __typename?: 'query_root', permissions: Array<{ __typename?: 'qx_Permission', id: string, name: string, thumbnail_sm?: string | undefined, group: { __typename?: 'qx_Group', id: string, name: string, toPeople_aggregate: { __typename?: 'qx__PersonToGroup_aggregate', aggregate?: { __typename?: 'qx__PersonToGroup_aggregate_fields', count: number } | undefined } }, place: { __typename?: 'qx_Place', id: string, name: string }, schedule: { __typename?: 'qx_Schedule', id: string, name: string, thumbnail?: string | undefined } }> };

export type GQL_GET_PERMISSION_BY_PARTITIONIDQueryVariables = Exact<{
  partitionID: string;
}>;


export type GQL_GET_PERMISSION_BY_PARTITIONIDQuery = { __typename?: 'query_root', permissions: Array<{ __typename?: 'qx_Permission', id: string, name: string, thumbnail_sm?: string | undefined, group: { __typename?: 'qx_Group', id: string, name: string, toPeople_aggregate: { __typename?: 'qx__PersonToGroup_aggregate', aggregate?: { __typename?: 'qx__PersonToGroup_aggregate_fields', count: number } | undefined } }, place: { __typename?: 'qx_Place', id: string, name: string }, schedule: { __typename?: 'qx_Schedule', id: string, name: string, thumbnail?: string | undefined } }> };

export type GQL_PARTITIONS_BY_PERMISSION_SEARCHQueryVariables = Exact<{
  where?: PermissionPartitionAssignments_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<PermissionPartitionAssignments_order_by> | PermissionPartitionAssignments_order_by;
}>;


export type GQL_PARTITIONS_BY_PERMISSION_SEARCHQuery = { __typename?: 'query_root', PermissionPartitionAssignments: Array<{ __typename?: 'PermissionPartitionAssignments', id: string, IntrusionPartition: { __typename?: 'IntrusionPartition', id: string, name: string, Place: { __typename?: 'qx_Place', id: string, name: string }, Device: { __typename?: 'qx_Device', id: string, name: string } } }> };

export type getPermissionsDataByPersonIdQueryVariables = Exact<{
  personID: string;
}>;


export type getPermissionsDataByPersonIdQuery = { __typename?: 'query_root', permissions: Array<{ __typename?: 'qx_Permission', id: string, thumbnail_lg?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, group: { __typename?: 'qx_Group', id: string, name: string }, schedule: { __typename?: 'qx_Schedule', id: string, name: string, thumbnail?: string | undefined } }> };

export type PermissionFormFragment = { __typename?: 'qx_Permission', id: string, placeID: string, scheduleID: string, groupID: string, thumbnail?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string }, schedule: { __typename?: 'qx_Schedule', id: string, name: string }, group: { __typename?: 'qx_Group', id: string, name: string }, PermissionPartitionAssignments: Array<{ __typename?: 'PermissionPartitionAssignments', partitionID: string, IntrusionPartition: { __typename?: 'IntrusionPartition', id: string, name: string } }> };

export type getPermissionFormQueryVariables = Exact<{
  id: string;
}>;


export type getPermissionFormQuery = { __typename?: 'query_root', permission?: { __typename?: 'qx_Permission', id: string, placeID: string, scheduleID: string, groupID: string, thumbnail?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string }, schedule: { __typename?: 'qx_Schedule', id: string, name: string }, group: { __typename?: 'qx_Group', id: string, name: string }, PermissionPartitionAssignments: Array<{ __typename?: 'PermissionPartitionAssignments', partitionID: string, IntrusionPartition: { __typename?: 'IntrusionPartition', id: string, name: string } }> } | undefined };

export type GQL_CREATE_PERMISSION_WITH_PARTITIONSMutationVariables = Exact<{
  partitionIds: Array<string> | string;
  permission: PermissionWithPartitionsInput;
}>;


export type GQL_CREATE_PERMISSION_WITH_PARTITIONSMutation = { __typename?: 'mutation_root', createPermissionWithPartitions: { __typename?: 'StringOutput', output: string } };

export type GQL_UPDATE_PERMISSION_WITH_PARTITIONSMutationVariables = Exact<{
  id: string;
  partitionIds: Array<string> | string;
  permission: PermissionWithPartitionsInput;
}>;


export type GQL_UPDATE_PERMISSION_WITH_PARTITIONSMutation = { __typename?: 'mutation_root', updatePermissionWithPartitions: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_GET_INTRUSION_PARTITIONS_BY_PLACEQueryVariables = Exact<{
  placeID: string;
}>;


export type GQL_GET_INTRUSION_PARTITIONS_BY_PLACEQuery = { __typename?: 'query_root', IntrusionPartition: Array<{ __typename?: 'IntrusionPartition', id: string, name: string, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }> };

export type deletePermissionMutationVariables = Exact<{
  id: string;
}>;


export type deletePermissionMutation = { __typename?: 'mutation_root', deletePermission?: { __typename?: 'qx_Permission', id: string } | undefined };

export type PermissionSearchFragment = { __typename?: 'qx_Permission', id: string, name: string, thumbnail?: string | undefined, group: { __typename?: 'qx_Group', id: string, name: string, thumbnail?: string | undefined, toPeople_aggregate: { __typename?: 'qx__PersonToGroup_aggregate', aggregate?: { __typename?: 'qx__PersonToGroup_aggregate_fields', count: number } | undefined } }, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, schedule: { __typename?: 'qx_Schedule', id: string, name: string, thumbnail?: string | undefined } };

export type GQL_PERMISSION_SEARCHQueryVariables = Exact<{
  where?: qx_Permission_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Permission_order_by> | qx_Permission_order_by;
}>;


export type GQL_PERMISSION_SEARCHQuery = { __typename?: 'query_root', permissions: Array<{ __typename?: 'qx_Permission', id: string, name: string, thumbnail?: string | undefined, group: { __typename?: 'qx_Group', id: string, name: string, thumbnail?: string | undefined, toPeople_aggregate: { __typename?: 'qx__PersonToGroup_aggregate', aggregate?: { __typename?: 'qx__PersonToGroup_aggregate_fields', count: number } | undefined } }, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, schedule: { __typename?: 'qx_Schedule', id: string, name: string, thumbnail?: string | undefined } }>, permissionAggregate: { __typename?: 'qx_Permission_aggregate', aggregate?: { __typename?: 'qx_Permission_aggregate_fields', count: number } | undefined } };

export type GQL_PERMISSION_SEARCH_SUBSCRIPTIONVariables = Exact<{
  where?: qx_Permission_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Permission_order_by> | qx_Permission_order_by;
}>;


export type GQL_PERMISSION_SEARCH_SUBSCRIPTION = { __typename?: 'subscription_root', permissions: Array<{ __typename?: 'qx_Permission', id: string, name: string, thumbnail?: string | undefined, group: { __typename?: 'qx_Group', id: string, name: string, thumbnail?: string | undefined, toPeople_aggregate: { __typename?: 'qx__PersonToGroup_aggregate', aggregate?: { __typename?: 'qx__PersonToGroup_aggregate_fields', count: number } | undefined } }, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, schedule: { __typename?: 'qx_Schedule', id: string, name: string, thumbnail?: string | undefined } }> };

export type checkForUniquePermissionQueryVariables = Exact<{
  id?: string;
  placeID: string;
  groupID: string;
}>;


export type checkForUniquePermissionQuery = { __typename?: 'query_root', permissions: Array<{ __typename?: 'qx_Permission', id: string }> };

export type PlaceWhiteListFragment = { __typename?: 'placeWhiteLists', id: any, ip: any, alias: string, placeID: string };

export type PlaceFragment = { __typename?: 'qx_Place', id: string, qxCustomerID?: string | undefined, accountNumber?: string | undefined, name: string, type: qx_ePlaceType_enum, path: string, canSelfServe?: boolean | undefined, requireTwoFactor: boolean, timezone?: string | undefined, isLockedDown: boolean, parentPlaceID?: string | undefined, addresses?: any | undefined, aiBillingTier: string, aiOverageBudgetCents?: number | undefined, authProvider?: { __typename?: 'qx_CustomerAuthProvider', id: any, customerPlaceID: string, provider: qx_eAuthProvider_enum, sso: boolean, sync: boolean, syncedByPersonID?: string | undefined, lastSynced?: any | undefined, error?: string | undefined, config?: any | undefined, syncedSetupBy?: { __typename?: 'qx_Person', avatar_md?: string | undefined, id: string, firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined } | undefined } | undefined, defaultView?: { __typename?: 'qx_View', id: string, name: string } | undefined, parentPlace?: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, path: string, timezone?: string | undefined, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string } } | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined, customerPlace?: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, accountNumber?: string | undefined, anniversaryDate?: any | undefined, billingPeriodMonths?: number | undefined, canSelfServe?: boolean | undefined } | undefined, homePlace?: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, path: string, accountNumber?: string | undefined, anniversaryDate?: any | undefined, billingPeriodMonths?: number | undefined, canSelfServe?: boolean | undefined } | undefined } | undefined, children: Array<{ __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, path: string, addresses?: any | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } | undefined, parentPlace?: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum } | undefined, children: Array<{ __typename?: 'qx_Place', id: string, path: string, addresses?: any | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } | undefined }> }>, whitelists: Array<{ __typename?: 'placeWhiteLists', id: any, ip: any, alias: string, placeID: string }> };

export type LiveScrollerPlaceResolveFragment = { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, type: eGatewayType_enum } | undefined };

export type PlaceSearchFragment = { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined };

export type PlaceBillingFragment = { __typename?: 'qx_Place', anniversaryDate?: any | undefined, billingStartDate?: any | undefined, billingPeriodMonths?: number | undefined };

export type GQL_UPDATE_PLACE_BY_IDMutationVariables = Exact<{
  id: string;
  data: qx_Place_set_input;
}>;


export type GQL_UPDATE_PLACE_BY_IDMutation = { __typename?: 'mutation_root', updatePlaces?: { __typename: 'qx_Place_mutation_response', returning: Array<{ __typename: 'qx_Place', id: string, name: string, aiBillingTier: string, aiOverageBudgetCents?: number | undefined, canSelfServe?: boolean | undefined, pendingBillingTier?: string | undefined, pendingBillingTierStartsAt?: any | undefined, parentPlace?: { __typename: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum } | undefined }> } | undefined };

export type GQL_CANCEL_PENDING_BILLING_DOWNGRADEMutationVariables = Exact<{
  placeID: string;
}>;


export type GQL_CANCEL_PENDING_BILLING_DOWNGRADEMutation = { __typename?: 'mutation_root', cancelPendingBillingDowngrade: { __typename?: 'SuccessOutput', success: boolean } };

export type StateStoreSubscribeToPlaceByIdSubscriptionVariables = Exact<{
  id: string;
}>;


export type StateStoreSubscribeToPlaceByIdSubscription = { __typename?: 'subscription_root', place?: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, path: string, isLockedDown: boolean } | undefined };

export type GQL_PLACE_SEARCHQueryVariables = Exact<{
  where?: qx_Place_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Place_order_by> | qx_Place_order_by;
}>;


export type GQL_PLACE_SEARCHQuery = { __typename?: 'query_root', places: Array<{ __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }>, placeAggregate: { __typename?: 'qx_Place_aggregate', aggregate?: { __typename?: 'qx_Place_aggregate_fields', count: number } | undefined } };

export type GQL_GET_PLACE_IDS_BY_IDQueryVariables = Exact<{
  where?: qx_Place_bool_exp;
  limit?: number;
}>;


export type GQL_GET_PLACE_IDS_BY_IDQuery = { __typename?: 'query_root', places: Array<{ __typename?: 'qx_Place', id: string }> };

export type GQL_GET_CUSTOMER_PLACE_IDQueryVariables = Exact<{
  placeID: string;
}>;


export type GQL_GET_CUSTOMER_PLACE_IDQuery = { __typename?: 'query_root', place?: { __typename?: 'qx_Place', id: string, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined, homePlace?: { __typename?: 'qx_Place', id: string, path: string, isLockedDown: boolean, canSelfServe?: boolean | undefined } | undefined, customerPlace?: { __typename?: 'qx_Place', id: string, path: string, name: string, type: qx_ePlaceType_enum, isLockedDown: boolean, canSelfServe?: boolean | undefined } | undefined } | undefined } | undefined };

export type GQL_GET_PLACE_BY_IDQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_PLACE_BY_IDQuery = { __typename?: 'query_root', place?: { __typename?: 'qx_Place', id: string, qxCustomerID?: string | undefined, accountNumber?: string | undefined, name: string, type: qx_ePlaceType_enum, path: string, canSelfServe?: boolean | undefined, requireTwoFactor: boolean, timezone?: string | undefined, isLockedDown: boolean, parentPlaceID?: string | undefined, addresses?: any | undefined, aiBillingTier: string, aiOverageBudgetCents?: number | undefined, anniversaryDate?: any | undefined, billingStartDate?: any | undefined, billingPeriodMonths?: number | undefined, authProvider?: { __typename?: 'qx_CustomerAuthProvider', id: any, customerPlaceID: string, provider: qx_eAuthProvider_enum, sso: boolean, sync: boolean, syncedByPersonID?: string | undefined, lastSynced?: any | undefined, error?: string | undefined, config?: any | undefined, syncedSetupBy?: { __typename?: 'qx_Person', avatar_md?: string | undefined, id: string, firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined } | undefined } | undefined, defaultView?: { __typename?: 'qx_View', id: string, name: string } | undefined, parentPlace?: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, path: string, timezone?: string | undefined, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string } } | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined, customerPlace?: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, accountNumber?: string | undefined, anniversaryDate?: any | undefined, billingPeriodMonths?: number | undefined, canSelfServe?: boolean | undefined } | undefined, homePlace?: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, path: string, accountNumber?: string | undefined, anniversaryDate?: any | undefined, billingPeriodMonths?: number | undefined, canSelfServe?: boolean | undefined } | undefined } | undefined, children: Array<{ __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, path: string, addresses?: any | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } | undefined, parentPlace?: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum } | undefined, children: Array<{ __typename?: 'qx_Place', id: string, path: string, addresses?: any | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } | undefined }> }>, whitelists: Array<{ __typename?: 'placeWhiteLists', id: any, ip: any, alias: string, placeID: string }> } | undefined };

export type GQL_GET_PLACES_BY_IDSQueryVariables = Exact<{
  ids: Array<string> | string;
}>;


export type GQL_GET_PLACES_BY_IDSQuery = { __typename?: 'query_root', places: Array<{ __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, type: eGatewayType_enum } | undefined }> };

export type GQL_SUB_PLACE_BY_IDSubscriptionVariables = Exact<{
  id: string;
}>;


export type GQL_SUB_PLACE_BY_IDSubscription = { __typename?: 'subscription_root', place?: { __typename?: 'qx_Place', id: string, qxCustomerID?: string | undefined, accountNumber?: string | undefined, name: string, type: qx_ePlaceType_enum, path: string, canSelfServe?: boolean | undefined, requireTwoFactor: boolean, timezone?: string | undefined, isLockedDown: boolean, parentPlaceID?: string | undefined, addresses?: any | undefined, aiBillingTier: string, aiOverageBudgetCents?: number | undefined, anniversaryDate?: any | undefined, billingStartDate?: any | undefined, billingPeriodMonths?: number | undefined, authProvider?: { __typename?: 'qx_CustomerAuthProvider', id: any, customerPlaceID: string, provider: qx_eAuthProvider_enum, sso: boolean, sync: boolean, syncedByPersonID?: string | undefined, lastSynced?: any | undefined, error?: string | undefined, config?: any | undefined, syncedSetupBy?: { __typename?: 'qx_Person', avatar_md?: string | undefined, id: string, firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined } | undefined } | undefined, defaultView?: { __typename?: 'qx_View', id: string, name: string } | undefined, parentPlace?: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, path: string, timezone?: string | undefined, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string } } | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined, customerPlace?: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, accountNumber?: string | undefined, anniversaryDate?: any | undefined, billingPeriodMonths?: number | undefined, canSelfServe?: boolean | undefined } | undefined, homePlace?: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, path: string, accountNumber?: string | undefined, anniversaryDate?: any | undefined, billingPeriodMonths?: number | undefined, canSelfServe?: boolean | undefined } | undefined } | undefined, children: Array<{ __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, path: string, addresses?: any | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } | undefined, parentPlace?: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum } | undefined, children: Array<{ __typename?: 'qx_Place', id: string, path: string, addresses?: any | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } | undefined }> }>, whitelists: Array<{ __typename?: 'placeWhiteLists', id: any, ip: any, alias: string, placeID: string }> } | undefined };

export type GQL_GET_PLACE_HOME_BY_IDQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_PLACE_HOME_BY_IDQuery = { __typename?: 'query_root', place?: { __typename?: 'qx_Place', id: string, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined, placeID?: string | undefined, sitePlaceID?: string | undefined, homePlace?: { __typename?: 'qx_Place', id: string, type: qx_ePlaceType_enum, name: string, canSelfServe?: boolean | undefined, path: string } | undefined, customerPlace?: { __typename?: 'qx_Place', id: string, type: qx_ePlaceType_enum, name: string, canSelfServe?: boolean | undefined, path: string } | undefined, integratorPlace?: { __typename?: 'qx_Place', id: string, type: qx_ePlaceType_enum, name: string, path: string } | undefined, place?: { __typename?: 'qx_Place', id: string, type: qx_ePlaceType_enum, name: string, path: string } | undefined, sitePlace?: { __typename?: 'qx_Place', id: string, type: qx_ePlaceType_enum, name: string, path: string } | undefined } | undefined } | undefined };

export type GQL_GET_ACCESS_REPORT_INFOMutationVariables = Exact<{
  type: ReportType;
}>;


export type GQL_GET_ACCESS_REPORT_INFOMutation = { __typename?: 'mutation_root', accessReportInfo: { __typename?: 'AccessReportInfo', columns: Array<string>, filterable: Array<string>, sortable: Array<string>, type: ReportType } };

export type AccessReportFragment = { __typename?: 'AccessReport', columns: Array<string>, rows?: any | undefined, totalCount: number, type: ReportType };

export type GQL_GET_ACCESS_REPORTMutationVariables = Exact<{
  type: ReportType;
  limit?: number;
  offset?: number;
  orderBy?: Array<AccessReportOrderByInput> | AccessReportOrderByInput;
  filter?: AccessReportFilterInput;
  options?: AccessReportOptionsInput;
}>;


export type GQL_GET_ACCESS_REPORTMutation = { __typename?: 'mutation_root', accessReport: { __typename?: 'AccessReport', columns: Array<string>, rows?: any | undefined, totalCount: number, type: ReportType } };

export type GQL_GET_ACCESS_REPORT_DOWNLOAD_URLMutationVariables = Exact<{
  type: ReportType;
  limit?: number;
  offset?: number;
  orderBy?: Array<AccessReportOrderByInput> | AccessReportOrderByInput;
  filter?: AccessReportFilterInput;
  options?: AccessReportOptionsInput;
}>;


export type GQL_GET_ACCESS_REPORT_DOWNLOAD_URLMutation = { __typename?: 'mutation_root', getDownloadAccessReportUrl: { __typename?: 'AccessReportUrlOutput', expiresAt: any, url: string } };

export type RuleFragment = { __typename?: 'qx_Flow', id: any, name: string, description?: string | undefined, enabled?: boolean | undefined, status: qx_eFlowStatus_enum, flow?: any | undefined, placeID: string, scheduleID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, schedule?: { __typename?: 'qx_Schedule', id: string, name: string, description?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string }, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }> } | undefined };

export type GQL_GET_RULE_FORMQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_RULE_FORMQuery = { __typename?: 'query_root', flow?: { __typename?: 'qx_Flow', id: any, name: string, description?: string | undefined, enabled?: boolean | undefined, status: qx_eFlowStatus_enum, flow?: any | undefined, placeID: string, scheduleID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, schedule?: { __typename?: 'qx_Schedule', id: string, name: string, description?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string }, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }> } | undefined } | undefined };

export type GQL_GET_RULES_BY_IDSQueryVariables = Exact<{
  ids: Array<string> | string;
}>;


export type GQL_GET_RULES_BY_IDSQuery = { __typename?: 'query_root', flows: Array<{ __typename?: 'qx_Flow', id: any, name: string, description?: string | undefined, enabled?: boolean | undefined, status: qx_eFlowStatus_enum, flow?: any | undefined, placeID: string, scheduleID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, schedule?: { __typename?: 'qx_Schedule', id: string, name: string, description?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string }, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }> } | undefined }> };

export type GQL_RULE_SEARCHQueryVariables = Exact<{
  where?: qx_Flow_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Flow_order_by> | qx_Flow_order_by;
}>;


export type GQL_RULE_SEARCHQuery = { __typename?: 'query_root', flows: Array<{ __typename?: 'qx_Flow', id: any, name: string, description?: string | undefined, enabled?: boolean | undefined, status: qx_eFlowStatus_enum, flow?: any | undefined, placeID: string, scheduleID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, schedule?: { __typename?: 'qx_Schedule', id: string, name: string, description?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string }, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }> } | undefined }>, flowAggregate: { __typename?: 'qx_Flow_aggregate', aggregate?: { __typename?: 'qx_Flow_aggregate_fields', count: number } | undefined } };

export type GQL_RULE_SEARCH_SUBSCRIPTIONVariables = Exact<{
  where?: qx_Flow_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Flow_order_by> | qx_Flow_order_by;
}>;


export type GQL_RULE_SEARCH_SUBSCRIPTION = { __typename?: 'subscription_root', flows: Array<{ __typename?: 'qx_Flow', id: any, name: string, description?: string | undefined, enabled?: boolean | undefined, status: qx_eFlowStatus_enum, flow?: any | undefined, placeID: string, scheduleID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, schedule?: { __typename?: 'qx_Schedule', id: string, name: string, description?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string }, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }> } | undefined }> };

export type GQL_CREATE_RULEMutationVariables = Exact<{
  rule: qx_Flow_insert_input;
}>;


export type GQL_CREATE_RULEMutation = { __typename?: 'mutation_root', createFlow?: { __typename?: 'qx_Flow', id: any, name: string, description?: string | undefined, enabled?: boolean | undefined, status: qx_eFlowStatus_enum, flow?: any | undefined, placeID: string, scheduleID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, schedule?: { __typename?: 'qx_Schedule', id: string, name: string, description?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string }, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }> } | undefined } | undefined };

export type GQL_UPDATE_RULE_BY_IDMutationVariables = Exact<{
  id: string;
  rule: qx_Flow_set_input;
}>;


export type GQL_UPDATE_RULE_BY_IDMutation = { __typename?: 'mutation_root', updateFlow?: { __typename?: 'qx_Flow', id: any, name: string, description?: string | undefined, enabled?: boolean | undefined, status: qx_eFlowStatus_enum, flow?: any | undefined, placeID: string, scheduleID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, schedule?: { __typename?: 'qx_Schedule', id: string, name: string, description?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string }, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }> } | undefined } | undefined };

export type GQL_DELETE_RULE_BY_IDMutationVariables = Exact<{
  id: string;
}>;


export type GQL_DELETE_RULE_BY_IDMutation = { __typename?: 'mutation_root', deleteFlow?: { __typename?: 'qx_Flow', id: any, name: string } | undefined };

export type GQL_GET_RULE_ACTIONSQueryVariables = Exact<{ [key: string]: never; }>;


export type GQL_GET_RULE_ACTIONSQuery = { __typename?: 'query_root', getFlowActions: Array<{ __typename?: 'FlowAction', name: string, environments: Array<string>, arguments?: Array<string | undefined> | undefined } | undefined> };

export type GQL_GET_RULE_FIRING_DATAQueryVariables = Exact<{
  ruleID: string;
}>;


export type GQL_GET_RULE_FIRING_DATAQuery = { __typename?: 'query_root', getFlowFiringData: { __typename?: 'JsonOutput', output: any } };

export type GQL_RULE_CLEAR_CACHEMutationVariables = Exact<{
  ruleID: string;
}>;


export type GQL_RULE_CLEAR_CACHEMutation = { __typename?: 'mutation_root', clearFlowStatus: { __typename?: 'SuccessOutput', success: boolean } };

export type ToHomePlacesCustomerPlaceFragment = { __typename?: 'qx_Place', id: string, name: string, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', homePlace?: { __typename?: 'qx_Place', id: string, name: string, canSelfServe?: boolean | undefined } | undefined } | undefined };

export type GQL_GET_RULE_FIRING_DATA_MAPQueryVariables = Exact<{
  deviceID?: Array<string> | string;
  personID?: Array<string> | string;
  doorID?: Array<string> | string;
  gatewayID?: Array<string> | string;
  placeID?: Array<string> | string;
  videoSourceID?: Array<string> | string;
  mediaProfileID?: Array<string> | string;
}>;


export type GQL_GET_RULE_FIRING_DATA_MAPQuery = { __typename?: 'query_root', doors: Array<{ __typename?: 'qx_Door', id: any, type?: string | undefined, name: string, description?: string | undefined, canOperate?: boolean | undefined, mode: qx_eDoorMode_enum, enabled: boolean, state: qx_eDoorState_enum, timezone?: string | undefined, alarm: qx_eDoorAlarm_enum, batteryLevel: qx_eBatteryLevel_enum, doorMonitor: qx_eDoorMonitor_enum, doorMonitorAddress?: string | undefined, lockdownImmunity?: boolean | undefined, defaultVideoSourceID?: any | undefined, deviceID: string, devicePacsStatus?: string | undefined, devicePacsHWUpdate?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, path: string, timezone?: string | undefined, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', homePlace?: { __typename?: 'qx_Place', id: string, name: string, canSelfServe?: boolean | undefined } | undefined } | undefined }, unlockSchedule?: { __typename?: 'qx_Schedule', id: string, name: string, thumbnail?: string | undefined, isActive?: boolean | undefined, holidayActive?: string | undefined, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, scheduleID: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }> } | undefined, outside?: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } | undefined, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, kind: qx_eDeviceKind_enum, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } } }>, places: Array<{ __typename?: 'qx_Place', isLockedDown: boolean, id: string, name: string, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', homePlace?: { __typename?: 'qx_Place', id: string, name: string, canSelfServe?: boolean | undefined } | undefined } | undefined }>, gateways: Array<{ __typename?: 'qx_Gateway', id: string, name: string, thumbnail?: string | undefined, thumbnail_md?: string | undefined, oldestMedia?: any | undefined, syncStatus: qx_eGatewaySyncStatus_enum, licenseDetails?: any | undefined, features: any, hostname?: string | undefined, type: eGatewayType_enum, serial?: string | undefined, version?: string | undefined, wireguardIP?: string | undefined, connectionStatus: boolean, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', homePlace?: { __typename?: 'qx_Place', id: string, name: string, canSelfServe?: boolean | undefined } | undefined } | undefined }, devices: Array<{ __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, doors: Array<{ __typename?: 'qx_Door', id: any, enabled: boolean }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, enabled: boolean }> }> }>, people: Array<{ __typename?: 'qx_Person', id: string, firstName?: string | undefined, lastName?: string | undefined, avatar_sm?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', homePlace?: { __typename?: 'qx_Place', id: string, name: string, canSelfServe?: boolean | undefined } | undefined } | undefined } }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, enabled: boolean, name: string, profileMSupported?: boolean | undefined, metadataEnabled?: boolean | undefined, scheduleID?: string | undefined, cloudStorageDays: number, cloudStorageTimelapseDays: number, timelapseInterval: number, deviceID: string, gatewayID?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined, homePlace?: { __typename?: 'qx_Place', id: string, name: string, canSelfServe?: boolean | undefined } | undefined } | undefined }, state?: { __typename?: 'videoSourceState', videoSourceID: any, lastMotionAt?: any | undefined } | undefined, audioSources: Array<{ __typename?: 'audioSourceVideoSource', audioSourceID?: any | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, enabled: boolean } | undefined }>, device: { __typename?: 'qx_Device', id: string, make?: string | undefined, model?: string | undefined, kind: qx_eDeviceKind_enum, serial?: string | undefined, firmware?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, port: number, tls: boolean, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, type: eGatewayType_enum, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum } }, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, refID: string, streamEnabled: boolean, streamStatus: qx_eStreamStatus_enum, deletedAt?: any | undefined }> }> };

export type SavedClipFragment = { __typename?: 'qx_Clip', id: any, name?: string | undefined, progress: any, duration?: number | undefined, startTime: any, endTime: any, createdAt: any, expiresAt?: any | undefined, deletedAt?: any | undefined, placeID: string, metadata?: any | undefined, base64?: string | undefined, description?: string | undefined, createdBy?: string | undefined, type: qx_eClipType_enum, status: qx_eClipStatus_enum, error?: string | undefined, size?: any | undefined, checksum?: string | undefined, videoSourceID?: any | undefined, person?: { __typename?: 'qx_Person', id: string, firstName?: string | undefined, lastName?: string | undefined, avatar_sm?: string | undefined } | undefined, place?: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } | undefined, eClipStatus: { __typename?: 'qx_eClipStatus', value: string, comment?: string | undefined }, auditLog_aggregate: { __typename?: 'qx_ClipAuditLog_aggregate', aggregate?: { __typename?: 'qx_ClipAuditLog_aggregate_fields', count: number } | undefined } };

export type SavedClipSearchFragment = { __typename?: 'qx_Clip', id: any, name?: string | undefined, progress: any, duration?: number | undefined, startTime: any, expiresAt?: any | undefined, createdAt: any, metadata?: any | undefined, description?: string | undefined, placeID: string, status: qx_eClipStatus_enum, size?: any | undefined, base64?: string | undefined, error?: string | undefined, checksum?: string | undefined, place?: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } | undefined, auditLog_aggregate: { __typename?: 'qx_ClipAuditLog_aggregate', aggregate?: { __typename?: 'qx_ClipAuditLog_aggregate_fields', count: number } | undefined } };

export type SavedClipFormFragment = { __typename?: 'qx_Clip', id: any, name?: string | undefined, expiresAt?: any | undefined, description?: string | undefined };

export type SavedClipAuditLogPersonClipFragment = { __typename?: 'qx_Person', firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined, employeeID?: string | undefined, avatar_sm?: string | undefined };

export type SavedClipAuditLogFragment = { __typename?: 'qx_ClipAuditLog', id?: string | undefined, personID?: string | undefined, alternateID?: string | undefined, action?: string | undefined, changes?: any | undefined, createdAt?: any | undefined, person?: { __typename?: 'qx_Person', firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined, employeeID?: string | undefined, avatar_sm?: string | undefined } | undefined };

export type SavedClipSharePersonSearchFragment = { __typename?: 'qx_Person', id: string, firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined, employeeID?: string | undefined, avatar_md?: string | undefined };

export type SharedLinksFragment = { __typename?: 'qx_SharedLinks', id: any, url?: string | undefined, expiresAt?: any | undefined, singleUse?: boolean | undefined, createdAt?: any | undefined, ownerID: string, emails?: Array<string> | undefined, persons?: Array<string> | undefined, linkableType: qx_SharedLinkType_enum, linkableID: any, createdBy?: { __typename?: 'qx_Person', id: string, lastName?: string | undefined, firstName?: string | undefined, avatar_sm?: string | undefined } | undefined, clip?: { __typename?: 'qx_Clip', id: any } | undefined };

export type GQL_SAVED_CLIP_SEARCHQueryVariables = Exact<{
  where?: qx_Clip_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Clip_order_by> | qx_Clip_order_by;
}>;


export type GQL_SAVED_CLIP_SEARCHQuery = { __typename?: 'query_root', clips: Array<{ __typename?: 'qx_Clip', id: any, name?: string | undefined, progress: any, duration?: number | undefined, startTime: any, expiresAt?: any | undefined, createdAt: any, metadata?: any | undefined, description?: string | undefined, placeID: string, status: qx_eClipStatus_enum, size?: any | undefined, base64?: string | undefined, error?: string | undefined, checksum?: string | undefined, place?: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } | undefined, auditLog_aggregate: { __typename?: 'qx_ClipAuditLog_aggregate', aggregate?: { __typename?: 'qx_ClipAuditLog_aggregate_fields', count: number } | undefined } }>, clipAggregate: { __typename?: 'qx_Clip_aggregate', aggregate?: { __typename?: 'qx_Clip_aggregate_fields', count: number } | undefined } };

export type GQL_SAVED_CLIP_SEARCH_SUBSCRIPTIONVariables = Exact<{
  where?: qx_Clip_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Clip_order_by> | qx_Clip_order_by;
}>;


export type GQL_SAVED_CLIP_SEARCH_SUBSCRIPTION = { __typename?: 'subscription_root', clips: Array<{ __typename?: 'qx_Clip', id: any, name?: string | undefined, progress: any, duration?: number | undefined, startTime: any, expiresAt?: any | undefined, createdAt: any, metadata?: any | undefined, description?: string | undefined, placeID: string, status: qx_eClipStatus_enum, size?: any | undefined, base64?: string | undefined, error?: string | undefined, checksum?: string | undefined, place?: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } | undefined, auditLog_aggregate: { __typename?: 'qx_ClipAuditLog_aggregate', aggregate?: { __typename?: 'qx_ClipAuditLog_aggregate_fields', count: number } | undefined } }> };

export type GQL_SAVED_CLIP_AUDIT_LOG_SEARCHQueryVariables = Exact<{
  where?: qx_ClipAuditLog_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_ClipAuditLog_order_by> | qx_ClipAuditLog_order_by;
}>;


export type GQL_SAVED_CLIP_AUDIT_LOG_SEARCHQuery = { __typename?: 'query_root', clipAuditLogs: Array<{ __typename?: 'qx_ClipAuditLog', id?: string | undefined, personID?: string | undefined, alternateID?: string | undefined, action?: string | undefined, changes?: any | undefined, createdAt?: any | undefined, person?: { __typename?: 'qx_Person', firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined, employeeID?: string | undefined, avatar_sm?: string | undefined } | undefined }>, clipAuditLogAggregate: { __typename?: 'qx_ClipAuditLog_aggregate', aggregate?: { __typename?: 'qx_ClipAuditLog_aggregate_fields', count: number } | undefined } };

export type GQL_SAVED_CLIP_AUDIT_LOG_SEARCH_SUBSCRIPTIONVariables = Exact<{
  where?: qx_ClipAuditLog_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_ClipAuditLog_order_by> | qx_ClipAuditLog_order_by;
}>;


export type GQL_SAVED_CLIP_AUDIT_LOG_SEARCH_SUBSCRIPTION = { __typename?: 'subscription_root', clipAuditLogs: Array<{ __typename?: 'qx_ClipAuditLog', id?: string | undefined, personID?: string | undefined, alternateID?: string | undefined, action?: string | undefined, changes?: any | undefined, createdAt?: any | undefined, person?: { __typename?: 'qx_Person', firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined, employeeID?: string | undefined, avatar_sm?: string | undefined } | undefined }> };

export type GQL_SAVED_CLIP_SHARED_LINKSQueryVariables = Exact<{
  clipID: string;
}>;


export type GQL_SAVED_CLIP_SHARED_LINKSQuery = { __typename?: 'query_root', sharedLinks: Array<{ __typename?: 'qx_SharedLinks', id: any, url?: string | undefined, expiresAt?: any | undefined, singleUse?: boolean | undefined, createdAt?: any | undefined, ownerID: string, emails?: Array<string> | undefined, persons?: Array<string> | undefined, linkableType: qx_SharedLinkType_enum, linkableID: any, createdBy?: { __typename?: 'qx_Person', id: string, lastName?: string | undefined, firstName?: string | undefined, avatar_sm?: string | undefined } | undefined, clip?: { __typename?: 'qx_Clip', id: any } | undefined }> };

export type GQL_SAVED_CLIP_SHARE_PERSON_SEARCHQueryVariables = Exact<{
  where?: qx_Person_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Person_order_by> | qx_Person_order_by;
}>;


export type GQL_SAVED_CLIP_SHARE_PERSON_SEARCHQuery = { __typename?: 'query_root', people: Array<{ __typename?: 'qx_Person', id: string, firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined, employeeID?: string | undefined, avatar_md?: string | undefined }>, personAggregate: { __typename?: 'qx_Person_aggregate', aggregate?: { __typename?: 'qx_Person_aggregate_fields', count: number } | undefined } };

export type GQL_SAVED_CLIP_SHARE_SEARCH_SUBSCRIPTIONVariables = Exact<{
  where?: qx_Person_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Person_order_by> | qx_Person_order_by;
}>;


export type GQL_SAVED_CLIP_SHARE_SEARCH_SUBSCRIPTION = { __typename?: 'subscription_root', people: Array<{ __typename?: 'qx_Person', id: string, firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined, employeeID?: string | undefined, avatar_md?: string | undefined }> };

export type GQL_GET_SHARED_LINK_BY_CLIP_ID_WITH_LIMITQueryVariables = Exact<{
  clipID: string;
  limit?: number;
}>;


export type GQL_GET_SHARED_LINK_BY_CLIP_ID_WITH_LIMITQuery = { __typename?: 'query_root', sharedLinks: Array<{ __typename?: 'qx_SharedLinks', id: any, url?: string | undefined }> };

export type GQL_GET_SHARED_LINKQueryVariables = Exact<{
  linkID: string;
}>;


export type GQL_GET_SHARED_LINKQuery = { __typename?: 'query_root', sharedLink?: { __typename?: 'qx_SharedLinks', id: any, url?: string | undefined, expiresAt?: any | undefined, singleUse?: boolean | undefined, createdAt?: any | undefined, ownerID: string, emails?: Array<string> | undefined, persons?: Array<string> | undefined, linkableType: qx_SharedLinkType_enum, linkableID: any, createdBy?: { __typename?: 'qx_Person', id: string, lastName?: string | undefined, firstName?: string | undefined, avatar_sm?: string | undefined } | undefined, clip?: { __typename?: 'qx_Clip', id: any } | undefined } | undefined };

export type ScheduleHolidayActiveFragment = { __typename?: 'qx_Schedule', holidayActive?: string | undefined };

export type ScheduleActiveFragment = { __typename?: 'qx_Schedule', isActive?: boolean | undefined };

export type ScheduleBlockFragment = { __typename?: 'qx_ScheduleBlock', id: string, scheduleID: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> };

export type ScheduleDoorListUnlockFragment = { __typename?: 'qx_Schedule', id: string, name: string, thumbnail?: string | undefined, isActive?: boolean | undefined, holidayActive?: string | undefined, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, scheduleID: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }> };

export type ScheduleFragment = { __typename?: 'qx_Schedule', id: string, name: string, description?: string | undefined, placeID: string, holidayActive?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined }, permissions: Array<{ __typename?: 'qx_Permission', id: string }>, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, scheduleID: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }> };

export type ScheduleSearchFragment = { __typename?: 'qx_Schedule', id: string, name: string, description?: string | undefined, holidayActive?: string | undefined, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, scheduleID: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }>, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined } };

export type GQL_GET_SCHEDULE_BY_IDQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_SCHEDULE_BY_IDQuery = { __typename?: 'query_root', schedule?: { __typename?: 'qx_Schedule', thumbnail?: string | undefined, id: string, name: string, description?: string | undefined, placeID: string, holidayActive?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined }, permissions: Array<{ __typename?: 'qx_Permission', id: string }>, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, scheduleID: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }> } | undefined };

export type GQL_SUB_SCHEDULE_BY_IDSubscriptionVariables = Exact<{
  id: string;
}>;


export type GQL_SUB_SCHEDULE_BY_IDSubscription = { __typename?: 'subscription_root', schedule?: { __typename?: 'qx_Schedule', id: string, name: string, description?: string | undefined, placeID: string, holidayActive?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined }, permissions: Array<{ __typename?: 'qx_Permission', id: string }>, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, scheduleID: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }> } | undefined };

export type GQL_SCHEDULE_SEARCHQueryVariables = Exact<{
  where?: qx_Schedule_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Schedule_order_by> | qx_Schedule_order_by;
}>;


export type GQL_SCHEDULE_SEARCHQuery = { __typename?: 'query_root', schedules: Array<{ __typename?: 'qx_Schedule', thumbnail?: string | undefined, id: string, name: string, description?: string | undefined, holidayActive?: string | undefined, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, scheduleID: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }>, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined } }>, scheduleAggregate: { __typename?: 'qx_Schedule_aggregate', aggregate?: { __typename?: 'qx_Schedule_aggregate_fields', count: number } | undefined } };

export type GQL_SCHEDULE_SEARCH_SUBSCRIPTIONVariables = Exact<{
  where?: qx_Schedule_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Schedule_order_by> | qx_Schedule_order_by;
}>;


export type GQL_SCHEDULE_SEARCH_SUBSCRIPTION = { __typename?: 'subscription_root', schedules: Array<{ __typename?: 'qx_Schedule', id: string, name: string, description?: string | undefined, holidayActive?: string | undefined, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, scheduleID: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }>, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined } }> };

export type SensorDeviceGatewayFieldsFragment = { __typename?: 'qx_Sensor', deviceConnectionStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined };

export type SensorSingleFragment = { __typename?: 'qx_Sensor', id: any, defaultVideoSourceID?: any | undefined, batteryLevel: qx_eBatteryLevel_enum, connectionStatus: qx_eDeviceConnectionStatus_enum, createdAt?: any | undefined, description?: string | undefined, deviceID: string, disabledByLicense: boolean, enabled: boolean, name: string, placeID: string, serial: string, state: qx_eDIOState_enum, type: qx_eSensorType_enum, updatedAt?: any | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, place: { __typename?: 'qx_Place', id: string, name: string } } | undefined, eBatteryLevel: { __typename?: 'qx_eBatteryLevel', comment?: string | undefined }, eDIOState: { __typename?: 'qx_eDIOState', comment?: string | undefined }, eDeviceConnectionStatus: { __typename?: 'qx_eDeviceConnectionStatus', comment?: string | undefined }, eSensorType: { __typename?: 'qx_eSensorType', comment?: string | undefined }, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, port: number, tls: boolean, model?: string | undefined, firmware?: string | undefined, serial?: string | undefined, deviceUsername?: string | undefined, devicePassword?: string | undefined, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } }, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } | undefined } };

export type SensorSearchMiniFragment = { __typename?: 'qx_Sensor', id: any, name: string, type: qx_eSensorType_enum, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } };

export type LiveScrollerSensorResolveFragment = { __typename?: 'qx_Sensor', id: any, name: string, type: qx_eSensorType_enum };

export type GQL_SENSOR_SEARCH_MINIQueryVariables = Exact<{
  where?: qx_Sensor_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Sensor_order_by> | qx_Sensor_order_by;
}>;


export type GQL_SENSOR_SEARCH_MINIQuery = { __typename?: 'query_root', sensors: Array<{ __typename?: 'qx_Sensor', id: any, name: string, type: qx_eSensorType_enum, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }>, sensorAggregate: { __typename?: 'qx_Sensor_aggregate', aggregate?: { __typename?: 'qx_Sensor_aggregate_fields', count: number } | undefined } };

export type GQL_GET_SENSORS_BY_IDSQueryVariables = Exact<{
  ids: Array<string> | string;
}>;


export type GQL_GET_SENSORS_BY_IDSQuery = { __typename?: 'query_root', sensors: Array<{ __typename?: 'qx_Sensor', id: any, name: string, type: qx_eSensorType_enum }> };

export type GQL_GET_SENSOR_BY_IDQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_SENSOR_BY_IDQuery = { __typename?: 'query_root', sensor?: { __typename?: 'qx_Sensor', id: any, defaultVideoSourceID?: any | undefined, batteryLevel: qx_eBatteryLevel_enum, connectionStatus: qx_eDeviceConnectionStatus_enum, createdAt?: any | undefined, description?: string | undefined, deviceID: string, disabledByLicense: boolean, enabled: boolean, name: string, placeID: string, serial: string, state: qx_eDIOState_enum, type: qx_eSensorType_enum, updatedAt?: any | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, place: { __typename?: 'qx_Place', id: string, name: string } } | undefined, eBatteryLevel: { __typename?: 'qx_eBatteryLevel', comment?: string | undefined }, eDIOState: { __typename?: 'qx_eDIOState', comment?: string | undefined }, eDeviceConnectionStatus: { __typename?: 'qx_eDeviceConnectionStatus', comment?: string | undefined }, eSensorType: { __typename?: 'qx_eSensorType', comment?: string | undefined }, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, port: number, tls: boolean, model?: string | undefined, firmware?: string | undefined, serial?: string | undefined, deviceUsername?: string | undefined, devicePassword?: string | undefined, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } }, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } | undefined } } | undefined };

export type GQL_SUB_SENSOR_BY_IDSubscriptionVariables = Exact<{
  id: string;
}>;


export type GQL_SUB_SENSOR_BY_IDSubscription = { __typename?: 'subscription_root', sensor?: { __typename?: 'qx_Sensor', id: any, defaultVideoSourceID?: any | undefined, batteryLevel: qx_eBatteryLevel_enum, connectionStatus: qx_eDeviceConnectionStatus_enum, createdAt?: any | undefined, description?: string | undefined, deviceID: string, disabledByLicense: boolean, enabled: boolean, name: string, placeID: string, serial: string, state: qx_eDIOState_enum, type: qx_eSensorType_enum, updatedAt?: any | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, place: { __typename?: 'qx_Place', id: string, name: string } } | undefined, eBatteryLevel: { __typename?: 'qx_eBatteryLevel', comment?: string | undefined }, eDIOState: { __typename?: 'qx_eDIOState', comment?: string | undefined }, eDeviceConnectionStatus: { __typename?: 'qx_eDeviceConnectionStatus', comment?: string | undefined }, eSensorType: { __typename?: 'qx_eSensorType', comment?: string | undefined }, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, port: number, tls: boolean, model?: string | undefined, firmware?: string | undefined, serial?: string | undefined, deviceUsername?: string | undefined, devicePassword?: string | undefined, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } }, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } | undefined } } | undefined };

export type SensorSearchFragment = { __typename?: 'qx_Sensor', id: any, defaultVideoSourceID?: any | undefined, batteryLevel: qx_eBatteryLevel_enum, connectionStatus: qx_eDeviceConnectionStatus_enum, createdAt?: any | undefined, description?: string | undefined, deviceID: string, disabledByLicense: boolean, enabled: boolean, name: string, placeID: string, serial: string, state: qx_eDIOState_enum, type: qx_eSensorType_enum, updatedAt?: any | undefined, deviceConnectionStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string } | undefined, eBatteryLevel: { __typename?: 'qx_eBatteryLevel', comment?: string | undefined, value: string }, eDIOState: { __typename?: 'qx_eDIOState', comment?: string | undefined, value: string }, eDeviceConnectionStatus: { __typename?: 'qx_eDeviceConnectionStatus', comment?: string | undefined, value: string }, eSensorType: { __typename?: 'qx_eSensorType', comment?: string | undefined, value: string }, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } }, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } | undefined } };

export type GQL_SENSOR_SEARCHQueryVariables = Exact<{
  where?: qx_Sensor_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Sensor_order_by> | qx_Sensor_order_by;
}>;


export type GQL_SENSOR_SEARCHQuery = { __typename?: 'query_root', sensors: Array<{ __typename?: 'qx_Sensor', id: any, defaultVideoSourceID?: any | undefined, batteryLevel: qx_eBatteryLevel_enum, connectionStatus: qx_eDeviceConnectionStatus_enum, createdAt?: any | undefined, description?: string | undefined, deviceID: string, disabledByLicense: boolean, enabled: boolean, name: string, placeID: string, serial: string, state: qx_eDIOState_enum, type: qx_eSensorType_enum, updatedAt?: any | undefined, deviceConnectionStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string } | undefined, eBatteryLevel: { __typename?: 'qx_eBatteryLevel', comment?: string | undefined, value: string }, eDIOState: { __typename?: 'qx_eDIOState', comment?: string | undefined, value: string }, eDeviceConnectionStatus: { __typename?: 'qx_eDeviceConnectionStatus', comment?: string | undefined, value: string }, eSensorType: { __typename?: 'qx_eSensorType', comment?: string | undefined, value: string }, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } }, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } | undefined } }>, sensorAggregate: { __typename?: 'qx_Sensor_aggregate', aggregate?: { __typename?: 'qx_Sensor_aggregate_fields', count: number } | undefined } };

export type GQL_SENSOR_SEARCH_SUBSCRIPTIONVariables = Exact<{
  where?: qx_Sensor_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Sensor_order_by> | qx_Sensor_order_by;
}>;


export type GQL_SENSOR_SEARCH_SUBSCRIPTION = { __typename?: 'subscription_root', sensors: Array<{ __typename?: 'qx_Sensor', id: any, defaultVideoSourceID?: any | undefined, batteryLevel: qx_eBatteryLevel_enum, connectionStatus: qx_eDeviceConnectionStatus_enum, createdAt?: any | undefined, description?: string | undefined, deviceID: string, disabledByLicense: boolean, enabled: boolean, name: string, placeID: string, serial: string, state: qx_eDIOState_enum, type: qx_eSensorType_enum, updatedAt?: any | undefined, deviceConnectionStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string } | undefined, eBatteryLevel: { __typename?: 'qx_eBatteryLevel', comment?: string | undefined, value: string }, eDIOState: { __typename?: 'qx_eDIOState', comment?: string | undefined, value: string }, eDeviceConnectionStatus: { __typename?: 'qx_eDeviceConnectionStatus', comment?: string | undefined, value: string }, eSensorType: { __typename?: 'qx_eSensorType', comment?: string | undefined, value: string }, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } }, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } | undefined } }> };

export type SnapshotsAndEventsStatsQueryVariables = Exact<{
  path: string;
  date: string;
  dateMinus1: string;
  dateMinus2: string;
  dateMinus3: string;
  dateMinus4: string;
  dateMinus5: string;
  dateMinus6: string;
  dateMinus7: string;
}>;


export type SnapshotsAndEventsStatsQuery = { __typename?: 'query_root', dateSnapshotCount: { __typename?: 'qx_Snapshot_aggregate', aggregate?: { __typename?: 'qx_Snapshot_aggregate_fields', count: number } | undefined }, dateMinus1SnapshotCount: { __typename?: 'qx_Snapshot_aggregate', aggregate?: { __typename?: 'qx_Snapshot_aggregate_fields', count: number } | undefined }, dateMinus2SnapshotCount: { __typename?: 'qx_Snapshot_aggregate', aggregate?: { __typename?: 'qx_Snapshot_aggregate_fields', count: number } | undefined }, dateMinus3SnapshotCount: { __typename?: 'qx_Snapshot_aggregate', aggregate?: { __typename?: 'qx_Snapshot_aggregate_fields', count: number } | undefined }, dateMinus4SnapshotCount: { __typename?: 'qx_Snapshot_aggregate', aggregate?: { __typename?: 'qx_Snapshot_aggregate_fields', count: number } | undefined }, dateMinus5SnapshotCount: { __typename?: 'qx_Snapshot_aggregate', aggregate?: { __typename?: 'qx_Snapshot_aggregate_fields', count: number } | undefined }, dateMinus6SnapshotCount: { __typename?: 'qx_Snapshot_aggregate', aggregate?: { __typename?: 'qx_Snapshot_aggregate_fields', count: number } | undefined }, dateEventCount: { __typename?: 'qx_Event_aggregate', aggregate?: { __typename?: 'qx_Event_aggregate_fields', count: number } | undefined }, dateMinus1EventCount: { __typename?: 'qx_Event_aggregate', aggregate?: { __typename?: 'qx_Event_aggregate_fields', count: number } | undefined }, dateMinus2EventCount: { __typename?: 'qx_Event_aggregate', aggregate?: { __typename?: 'qx_Event_aggregate_fields', count: number } | undefined }, dateMinus3EventCount: { __typename?: 'qx_Event_aggregate', aggregate?: { __typename?: 'qx_Event_aggregate_fields', count: number } | undefined }, dateMinus4EventCount: { __typename?: 'qx_Event_aggregate', aggregate?: { __typename?: 'qx_Event_aggregate_fields', count: number } | undefined }, dateMinus5EventCount: { __typename?: 'qx_Event_aggregate', aggregate?: { __typename?: 'qx_Event_aggregate_fields', count: number } | undefined }, dateMinus6EventCount: { __typename?: 'qx_Event_aggregate', aggregate?: { __typename?: 'qx_Event_aggregate_fields', count: number } | undefined } };

export type getEnumStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type getEnumStatusesQuery = { __typename?: 'query_root', deviceConnectionStatusEnums: Array<{ __typename: 'qx_eDeviceConnectionStatus', value: string, comment?: string | undefined }>, streamStatusEnums: Array<{ __typename: 'qx_eStreamStatus', value: string, comment?: string | undefined }>, objectActionEnums: Array<{ __typename: 'qx_eObjectAction', value: string, comment?: string | undefined }>, doorModeEnums: Array<{ __typename: 'qx_eDoorMode', value: string, comment?: string | undefined }>, doorStateEnums: Array<{ __typename: 'qx_eDoorState', value: string, comment?: string | undefined }>, doorAlarmEnums: Array<{ __typename: 'qx_eDoorAlarm', value: string, comment?: string | undefined }>, accessDeniedReasonEnums: Array<{ __typename: 'qx_eAccessDeniedReason', value: string, comment?: string | undefined }>, batteryLevelEnums: Array<{ __typename: 'qx_eBatteryLevel', value: string, comment?: string | undefined }> };

export type TimeZoneFragment = { __typename?: 'qx_TimeZone', name: string, description: string, iana?: string | undefined, tzoffset?: any | undefined };

export type GQL_GET_TIMEZONESQueryVariables = Exact<{ [key: string]: never; }>;


export type GQL_GET_TIMEZONESQuery = { __typename?: 'query_root', timeZones: Array<{ __typename?: 'qx_TimeZone', name: string, description: string, iana?: string | undefined, tzoffset?: any | undefined }> };

export type UserSettingFragment = { __typename?: 'qx_UserSetting', personID: string, name: string, value: any, updatedAt?: any | undefined };

export type subscribeToAllUserSettingUpdatesSubscriptionVariables = Exact<{
  id: string;
}>;


export type subscribeToAllUserSettingUpdatesSubscription = { __typename?: 'subscription_root', userSetting?: { __typename?: 'qx_UserSetting', personID: string, name: string, value: any, updatedAt?: any | undefined } | undefined };

export type userSettingQueryVariables = Exact<{
  personID: string;
  settingName: string;
}>;


export type userSettingQuery = { __typename?: 'query_root', userSettings: Array<{ __typename?: 'qx_UserSetting', id: string, value: any, updatedAt?: any | undefined }> };

export type subscribeToUserSettingSubscriptionVariables = Exact<{
  personID: string;
  settingName: string;
}>;


export type subscribeToUserSettingSubscription = { __typename?: 'subscription_root', userSettings: Array<{ __typename?: 'qx_UserSetting', id: string, value: any, updatedAt?: any | undefined }> };

export type updateSettingsMutationVariables = Exact<{
  personID: string;
  settingName: string;
  val: any;
}>;


export type updateSettingsMutation = { __typename?: 'mutation_root', createUserSettings?: { __typename?: 'qx_UserSetting_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'qx_UserSetting', name: string, value: any, updatedAt?: any | undefined }> } | undefined };

export type UserSettingsLayoutFragment = { __typename?: 'qx_UserSetting', id: string, name: string, value: any };

export type ViewFragment = { __typename?: 'qx_View', id: string, settings: any, name: string, personID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, defaultView?: { __typename?: 'qx_View', id: string, name: string } | undefined } };

export type ViewSearchFragment = { __typename?: 'qx_View', id: string, settings: any, name: string, isDefault?: boolean | undefined, personID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, defaultView?: { __typename?: 'qx_View', id: string, name: string } | undefined } };

export type ViewFormFragment = { __typename?: 'qx_View', id: string, name: string, personID?: string | undefined, placeID: string, place: { __typename?: 'qx_Place', id: string, name: string, defaultViewID?: string | undefined } };

export type GQL_GET_VIEW_BY_ID_AND_PATHQueryVariables = Exact<{
  id: string;
  path: string;
}>;


export type GQL_GET_VIEW_BY_ID_AND_PATHQuery = { __typename?: 'query_root', views: Array<{ __typename?: 'qx_View', id: string, settings: any, name: string, personID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, defaultView?: { __typename?: 'qx_View', id: string, name: string } | undefined } }> };

export type GQL_VIEW_SEARCHQueryVariables = Exact<{
  where?: qx_View_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_View_order_by> | qx_View_order_by;
}>;


export type GQL_VIEW_SEARCHQuery = { __typename?: 'query_root', views: Array<{ __typename?: 'qx_View', id: string, settings: any, name: string, isDefault?: boolean | undefined, personID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, defaultView?: { __typename?: 'qx_View', id: string, name: string } | undefined } }>, viewsAggregate: { __typename?: 'qx_View_aggregate', aggregate?: { __typename?: 'qx_View_aggregate_fields', count: number } | undefined } };

export type GQL_VIEW_SEARCH_SUBSCRIPTIONVariables = Exact<{
  where?: qx_View_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_View_order_by> | qx_View_order_by;
}>;


export type GQL_VIEW_SEARCH_SUBSCRIPTION = { __typename?: 'subscription_root', views: Array<{ __typename?: 'qx_View', id: string, settings: any, name: string, isDefault?: boolean | undefined, personID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, defaultView?: { __typename?: 'qx_View', id: string, name: string } | undefined } }> };

export type GQL_GET_VIEW_FORMQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_VIEW_FORMQuery = { __typename?: 'query_root', view?: { __typename?: 'qx_View', id: string, name: string, personID?: string | undefined, placeID: string, place: { __typename?: 'qx_Place', id: string, name: string, defaultViewID?: string | undefined } } | undefined };

export type GQL_UPDATE_VIEW_BY_IDMutationVariables = Exact<{
  id: string;
  view?: qx_View_set_input;
}>;


export type GQL_UPDATE_VIEW_BY_IDMutation = { __typename?: 'mutation_root', updateView?: { __typename?: 'qx_View', id: string } | undefined };

export type GQL_DELETE_VIEW_BY_IDMutationVariables = Exact<{
  id: string;
}>;


export type GQL_DELETE_VIEW_BY_IDMutation = { __typename?: 'mutation_root', deleteView?: { __typename?: 'qx_View', id: string } | undefined };

export type ZoneEditableFieldsFragment = { __typename?: 'IntrusionZone', id: string, description?: string | undefined, placeID: string, Place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } };

export type ZoneSearchFragment = { __typename?: 'IntrusionZone', id: string, name: string, index: number, type: qx_eIntrusionZoneType_enum, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, canBypass?: boolean | undefined, defaultVideoSourceID?: any | undefined, deviceID: string, description?: string | undefined, placeID: string, eIntrusionZoneType: { __typename?: 'qx_eIntrusionZoneType', comment: string, value: string }, VideoSource?: { __typename?: 'qx_VideoSource', id: any, snapshots?: Array<{ __typename?: 'qx_Snapshot', id: string, base64?: string | undefined, signedUrl?: string | undefined, aspectRatio?: any | undefined }> | undefined } | undefined, Device: { __typename?: 'qx_Device', deviceAddress?: string | undefined, id: string, name: string, connectionStatus: qx_eDeviceConnectionStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } }, PartitionZoneAssignments: Array<{ __typename?: 'PartitionZoneAssignments', enabled: boolean, partitionID: string, IntrusionPartition: { __typename?: 'IntrusionPartition', id: string, name: string, index: number, stateValues?: any | undefined, alarmValues?: any | undefined } }>, Place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } };

export type GQL_ZONE_SEARCHQueryVariables = Exact<{
  where?: IntrusionZone_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<IntrusionZone_order_by> | IntrusionZone_order_by;
}>;


export type GQL_ZONE_SEARCHQuery = { __typename?: 'query_root', IntrusionZone: Array<{ __typename?: 'IntrusionZone', id: string, name: string, index: number, type: qx_eIntrusionZoneType_enum, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, canBypass?: boolean | undefined, defaultVideoSourceID?: any | undefined, deviceID: string, description?: string | undefined, placeID: string, eIntrusionZoneType: { __typename?: 'qx_eIntrusionZoneType', comment: string, value: string }, VideoSource?: { __typename?: 'qx_VideoSource', id: any, snapshots?: Array<{ __typename?: 'qx_Snapshot', id: string, base64?: string | undefined, signedUrl?: string | undefined, aspectRatio?: any | undefined }> | undefined } | undefined, Device: { __typename?: 'qx_Device', deviceAddress?: string | undefined, id: string, name: string, connectionStatus: qx_eDeviceConnectionStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } }, PartitionZoneAssignments: Array<{ __typename?: 'PartitionZoneAssignments', enabled: boolean, partitionID: string, IntrusionPartition: { __typename?: 'IntrusionPartition', id: string, name: string, index: number, stateValues?: any | undefined, alarmValues?: any | undefined } }>, Place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }> };

export type GQL_SUB_ZONE_SEARCHSubscriptionVariables = Exact<{
  where?: IntrusionZone_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<IntrusionZone_order_by> | IntrusionZone_order_by;
}>;


export type GQL_SUB_ZONE_SEARCHSubscription = { __typename?: 'subscription_root', IntrusionZone: Array<{ __typename?: 'IntrusionZone', id: string, name: string, index: number, type: qx_eIntrusionZoneType_enum, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, canBypass?: boolean | undefined, defaultVideoSourceID?: any | undefined, deviceID: string, description?: string | undefined, placeID: string, eIntrusionZoneType: { __typename?: 'qx_eIntrusionZoneType', comment: string, value: string }, VideoSource?: { __typename?: 'qx_VideoSource', id: any, snapshots?: Array<{ __typename?: 'qx_Snapshot', id: string, base64?: string | undefined, signedUrl?: string | undefined, aspectRatio?: any | undefined }> | undefined } | undefined, Device: { __typename?: 'qx_Device', deviceAddress?: string | undefined, id: string, name: string, connectionStatus: qx_eDeviceConnectionStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } }, PartitionZoneAssignments: Array<{ __typename?: 'PartitionZoneAssignments', enabled: boolean, partitionID: string, IntrusionPartition: { __typename?: 'IntrusionPartition', id: string, name: string, index: number, stateValues?: any | undefined, alarmValues?: any | undefined } }>, Place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }> };

export type ZoneDetailFragment = { __typename?: 'IntrusionZone', id: string, name: string, index: number, type: qx_eIntrusionZoneType_enum, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, canBypass?: boolean | undefined, defaultVideoSourceID?: any | undefined, deviceID: string, description?: string | undefined, placeID: string, VideoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, enabled: boolean, deviceConnectionStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, profileMSupported?: boolean | undefined, metadataEnabled?: boolean | undefined, place: { __typename?: 'qx_Place', id: string, name: string }, device: { __typename?: 'qx_Device', id: string, enabled: boolean }, audioSources: Array<{ __typename?: 'audioSourceVideoSource', audioSource?: { __typename?: 'qx_AudioSource', id: any, enabled: boolean } | undefined }> } | undefined, Device: { __typename?: 'qx_Device', description?: string | undefined, id: string, name: string, connectionStatus: qx_eDeviceConnectionStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } }, PartitionZoneAssignments: Array<{ __typename?: 'PartitionZoneAssignments', enabled: boolean, partitionID: string, IntrusionPartition: { __typename?: 'IntrusionPartition', id: string, name: string, index: number, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, PartitionZoneAssignments: Array<{ __typename?: 'PartitionZoneAssignments', zoneID: string, IntrusionZone: { __typename?: 'IntrusionZone', id: string, name: string, index: number, stateValues?: any | undefined, alarmValues?: any | undefined } }> } }>, Place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } };

export type GQL_GET_ZONE_BY_IDQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_ZONE_BY_IDQuery = { __typename?: 'query_root', IntrusionZone_by_pk?: { __typename?: 'IntrusionZone', id: string, name: string, index: number, type: qx_eIntrusionZoneType_enum, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, canBypass?: boolean | undefined, defaultVideoSourceID?: any | undefined, deviceID: string, description?: string | undefined, placeID: string, VideoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, enabled: boolean, deviceConnectionStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, profileMSupported?: boolean | undefined, metadataEnabled?: boolean | undefined, place: { __typename?: 'qx_Place', id: string, name: string }, device: { __typename?: 'qx_Device', id: string, enabled: boolean }, audioSources: Array<{ __typename?: 'audioSourceVideoSource', audioSource?: { __typename?: 'qx_AudioSource', id: any, enabled: boolean } | undefined }> } | undefined, Device: { __typename?: 'qx_Device', description?: string | undefined, id: string, name: string, connectionStatus: qx_eDeviceConnectionStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } }, PartitionZoneAssignments: Array<{ __typename?: 'PartitionZoneAssignments', enabled: boolean, partitionID: string, IntrusionPartition: { __typename?: 'IntrusionPartition', id: string, name: string, index: number, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, PartitionZoneAssignments: Array<{ __typename?: 'PartitionZoneAssignments', zoneID: string, IntrusionZone: { __typename?: 'IntrusionZone', id: string, name: string, index: number, stateValues?: any | undefined, alarmValues?: any | undefined } }> } }>, Place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } | undefined };

export type GQL_SUB_ZONE_BY_IDSubscriptionVariables = Exact<{
  id: string;
}>;


export type GQL_SUB_ZONE_BY_IDSubscription = { __typename?: 'subscription_root', IntrusionZone_by_pk?: { __typename?: 'IntrusionZone', id: string, name: string, index: number, type: qx_eIntrusionZoneType_enum, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, canBypass?: boolean | undefined, defaultVideoSourceID?: any | undefined, deviceID: string, description?: string | undefined, placeID: string, VideoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, enabled: boolean, deviceConnectionStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, profileMSupported?: boolean | undefined, metadataEnabled?: boolean | undefined, place: { __typename?: 'qx_Place', id: string, name: string }, device: { __typename?: 'qx_Device', id: string, enabled: boolean }, audioSources: Array<{ __typename?: 'audioSourceVideoSource', audioSource?: { __typename?: 'qx_AudioSource', id: any, enabled: boolean } | undefined }> } | undefined, Device: { __typename?: 'qx_Device', description?: string | undefined, id: string, name: string, connectionStatus: qx_eDeviceConnectionStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } }, PartitionZoneAssignments: Array<{ __typename?: 'PartitionZoneAssignments', enabled: boolean, partitionID: string, IntrusionPartition: { __typename?: 'IntrusionPartition', id: string, name: string, index: number, state: number, stateValues?: any | undefined, alarm: number, alarmValues?: any | undefined, PartitionZoneAssignments: Array<{ __typename?: 'PartitionZoneAssignments', zoneID: string, IntrusionZone: { __typename?: 'IntrusionZone', id: string, name: string, index: number, stateValues?: any | undefined, alarmValues?: any | undefined } }> } }>, Place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } | undefined };

export type GQL_UPDATE_ZONE_BY_IDMutationVariables = Exact<{
  id: string;
  zone: IntrusionZone_set_input;
}>;


export type GQL_UPDATE_ZONE_BY_IDMutation = { __typename?: 'mutation_root', update_IntrusionZone_by_pk?: { __typename?: 'IntrusionZone', defaultVideoSourceID?: any | undefined, id: string, description?: string | undefined, placeID: string, VideoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, place: { __typename?: 'qx_Place', id: string, name: string } } | undefined, Place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } | undefined };

export type GQL_ANALYTIC_ATTRIBUTE_SEARCHQueryVariables = Exact<{
  where?: analyticAttributes_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<analyticAttributes_order_by> | analyticAttributes_order_by;
}>;


export type GQL_ANALYTIC_ATTRIBUTE_SEARCHQuery = { __typename?: 'query_root', analyticAttributes: Array<{ __typename?: 'analyticAttributes', id: any, analyticType: string, attributeType: string, parentAttributeType?: string | undefined, attribute: { __typename?: 'attributes', label: string, description?: string | undefined, mapType?: string | undefined, state?: eAnalyticStates_enum | undefined, type: string } }>, analyticAttributes_aggregate: { __typename?: 'analyticAttributes_aggregate', aggregate?: { __typename?: 'analyticAttributes_aggregate_fields', count: number } | undefined } };

export type GQL_GET_ANALYTIC_ATTRIBUTESQueryVariables = Exact<{
  type: string;
}>;


export type GQL_GET_ANALYTIC_ATTRIBUTESQuery = { __typename?: 'query_root', analyticAttributes: Array<{ __typename?: 'analyticAttributes', id: any, attributeType: string, parentAttributeType?: string | undefined, attribute: { __typename?: 'attributes', label: string, description?: string | undefined, mapType?: string | undefined, state?: eAnalyticStates_enum | undefined, type: string }, analyticAttributeProperties: Array<{ __typename?: 'analyticAttributeProperties', analyticAttributeID: any, attributePropertyValue: string, attributeProperty: { __typename?: 'attributeProperties', label?: string | undefined, value: string, parentAttributeProperty?: string | undefined } }> }> };

export type GQL_ANALYTIC_SEARCHQueryVariables = Exact<{
  where?: analytics_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<analytics_order_by> | analytics_order_by;
}>;


export type GQL_ANALYTIC_SEARCHQuery = { __typename?: 'query_root', analytics: Array<{ __typename?: 'analytics', id: any, analyticType?: string | undefined, time: any, endTime?: any | undefined, likelihood?: number | undefined, videoSourceID?: any | undefined, snapshotID?: string | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, place: { __typename?: 'qx_Place', id: string, name: string, path: string, type: qx_ePlaceType_enum, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', homePlace?: { __typename?: 'qx_Place', id: string, name: string, path: string, type: qx_ePlaceType_enum } | undefined } | undefined } } | undefined, snapshot?: { __typename?: 'qx_Snapshot', id: string, signedUrl?: string | undefined, aspectRatio?: any | undefined } | undefined }> };

export type GQL_ANALYTIC_TYPE_SEARCHQueryVariables = Exact<{
  where?: analyticTypes_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<analyticTypes_order_by> | analyticTypes_order_by;
}>;


export type GQL_ANALYTIC_TYPE_SEARCHQuery = { __typename?: 'query_root', analyticTypes: Array<{ __typename?: 'analyticTypes', type: string, label?: string | undefined, mapType?: string | undefined, description?: string | undefined, sensitivity?: number | undefined, snapshotCooldown?: number | undefined, state?: eAnalyticStates_enum | undefined, integration: eAnalyticIntegrations_enum }>, analyticTypes_aggregate: { __typename?: 'analyticTypes_aggregate', aggregate?: { __typename?: 'analyticTypes_aggregate_fields', count: number } | undefined } };

export type GQL_ANALYTIC_TYPEQueryVariables = Exact<{
  type: string;
}>;


export type GQL_ANALYTIC_TYPEQuery = { __typename?: 'query_root', analyticTypes_by_pk?: { __typename?: 'analyticTypes', type: string, label?: string | undefined, mapType?: string | undefined, description?: string | undefined, sensitivity?: number | undefined, snapshotCooldown?: number | undefined, state?: eAnalyticStates_enum | undefined, integration: eAnalyticIntegrations_enum } | undefined };

export type GQL_GET_ANALYTIC_BY_IDQueryVariables = Exact<{
  analyticId: string;
}>;


export type GQL_GET_ANALYTIC_BY_IDQuery = { __typename?: 'query_root', analytics: Array<{ __typename?: 'analytics', id: any, analyticType?: string | undefined, time: any, endTime?: any | undefined, likelihood?: number | undefined, objectID?: string | undefined, snapshotID?: string | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, place: { __typename?: 'qx_Place', id: string, name: string, path: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', homePlace?: { __typename?: 'qx_Place', id: string, name: string, path: string, type: qx_ePlaceType_enum } | undefined } | undefined } } | undefined, snapshot?: { __typename?: 'qx_Snapshot', id: string, signedUrl?: string | undefined, aspectRatio?: any | undefined } | undefined, detectedProperties: Array<{ __typename?: 'analyticDetectedProperties', id: any, likelihood?: number | undefined, property?: string | undefined, time: any, value?: string | undefined, analyticAttribute: { __typename?: 'analyticAttributes', id: any, parentAttribute?: { __typename?: 'attributes', type: string, label: string } | undefined, attribute: { __typename?: 'attributes', type: string, label: string } }, attributeProperty?: { __typename?: 'attributeProperties', label?: string | undefined, value: string } | undefined }> }> };

export type GQL_ATTRIBUTE_PROPERTY_SEARCHQueryVariables = Exact<{
  where?: attributeProperties_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<attributeProperties_order_by> | attributeProperties_order_by;
}>;


export type GQL_ATTRIBUTE_PROPERTY_SEARCHQuery = { __typename?: 'query_root', attributeProperties: Array<{ __typename?: 'attributeProperties', value: string, label?: string | undefined, parentAttributeProperty?: string | undefined, state?: eAnalyticStates_enum | undefined, analyticAttributeProperties: Array<{ __typename?: 'analyticAttributeProperties', attributePropertyValue: string, analyticAttributeID: any, analyticAttribute: { __typename?: 'analyticAttributes', analyticType: string, attributeType: string, attribute: { __typename?: 'attributes', label: string, type: string, mapType?: string | undefined } } }> }>, attributeProperties_aggregate: { __typename?: 'attributeProperties_aggregate', aggregate?: { __typename?: 'attributeProperties_aggregate_fields', count: number } | undefined } };

export type GQL_ATTRIBUTE_SEARCHQueryVariables = Exact<{
  where?: attributes_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<attributes_order_by> | attributes_order_by;
}>;


export type GQL_ATTRIBUTE_SEARCHQuery = { __typename?: 'query_root', attributes: Array<{ __typename?: 'attributes', label: string, description?: string | undefined, mapType?: string | undefined, state?: eAnalyticStates_enum | undefined, type: string }>, attributes_aggregate: { __typename?: 'attributes_aggregate', aggregate?: { __typename?: 'attributes_aggregate_fields', count: number } | undefined } };

export type GQL_UPDATE_ANALYTIC_TYPEMutationVariables = Exact<{
  type: string;
  data: analyticTypes_set_input;
}>;


export type GQL_UPDATE_ANALYTIC_TYPEMutation = { __typename?: 'mutation_root', update_analyticTypes_by_pk?: { __typename?: 'analyticTypes', description?: string | undefined, label?: string | undefined, type: string, mapType?: string | undefined, sensitivity?: number | undefined, snapshotCooldown?: number | undefined, state?: eAnalyticStates_enum | undefined } | undefined };

export type GQL_UPDATE_ANALYTIC_TYPESMutationVariables = Exact<{
  set: analyticTypes_set_input;
  where: analyticTypes_bool_exp;
}>;


export type GQL_UPDATE_ANALYTIC_TYPESMutation = { __typename?: 'mutation_root', update_analyticTypes_many?: Array<{ __typename?: 'analyticTypes_mutation_response', affected_rows: number } | undefined> | undefined };

export type GQL_UPDATE_ATTRIBUTE_PROPERTIESMutationVariables = Exact<{
  set: attributeProperties_set_input;
  where: attributeProperties_bool_exp;
}>;


export type GQL_UPDATE_ATTRIBUTE_PROPERTIESMutation = { __typename?: 'mutation_root', update_attributeProperties_many?: Array<{ __typename?: 'attributeProperties_mutation_response', affected_rows: number } | undefined> | undefined };

export type GQL_UPDATE_ATTRIBUTE_PROPERTYMutationVariables = Exact<{
  value: string;
  data: attributeProperties_set_input;
}>;


export type GQL_UPDATE_ATTRIBUTE_PROPERTYMutation = { __typename?: 'mutation_root', update_attributeProperties_by_pk?: { __typename?: 'attributeProperties', state?: eAnalyticStates_enum | undefined, value: string, label?: string | undefined, parentAttributeProperty?: string | undefined } | undefined };

export type GQL_UPDATE_ATTRIBUTEMutationVariables = Exact<{
  type: string;
  data: attributes_set_input;
}>;


export type GQL_UPDATE_ATTRIBUTEMutation = { __typename?: 'mutation_root', update_attributes_by_pk?: { __typename?: 'attributes', description?: string | undefined, label: string, mapType?: string | undefined, state?: eAnalyticStates_enum | undefined, type: string } | undefined };

export type GQL_UPDATE_ATTRIBUTESMutationVariables = Exact<{
  set: attributes_set_input;
  where: attributes_bool_exp;
}>;


export type GQL_UPDATE_ATTRIBUTESMutation = { __typename?: 'mutation_root', update_attributes_many?: Array<{ __typename?: 'attributes_mutation_response', affected_rows: number } | undefined> | undefined };

export type AudioSourceSearchFragment = { __typename?: 'qx_AudioSource', id: any, name: string, refID: string, description?: string | undefined, channels?: any | undefined, enabled: boolean, device: { __typename?: 'qx_Device', id: string, name: string, devicePlace?: { __typename?: 'qx_vDevicePlace', place?: { __typename?: 'qx_Place', id: string, path: string, name: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } | undefined } | undefined } };

export type GQL_AUDIO_SOURCE_SEARCHQueryVariables = Exact<{
  where?: qx_AudioSource_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_AudioSource_order_by> | qx_AudioSource_order_by;
  currentScopePath?: string;
}>;


export type GQL_AUDIO_SOURCE_SEARCHQuery = { __typename?: 'query_root', audioSources: Array<{ __typename?: 'qx_AudioSource', id: any, name: string, refID: string, description?: string | undefined, channels?: any | undefined, enabled: boolean, device: { __typename?: 'qx_Device', id: string, name: string, devicePlace?: { __typename?: 'qx_vDevicePlace', place?: { __typename?: 'qx_Place', id: string, path: string, name: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } | undefined } | undefined } }>, audioSourceAggregate: { __typename?: 'qx_AudioSource_aggregate', aggregate?: { __typename?: 'qx_AudioSource_aggregate_fields', count: number } | undefined } };

export type LiveVideoPlayerContinuousRecordBorderFragment = { __typename?: 'qx_VideoSource', id: any, name: string, timezone?: string | undefined, schedule?: { __typename?: 'qx_Schedule', id: string, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, date: any, duration: string, weekdays?: string | undefined }> } | undefined };

export type LiveVideoPlayerMotionRecordBorderFragment = { __typename?: 'qx_VideoSource', id: any, state?: { __typename?: 'videoSourceState', videoSourceID: any, motionActive: boolean } | undefined };

export type GQL_GET_CAMERA_CONTINUOUS_BORDERSQueryVariables = Exact<{
  cameraID: string;
}>;


export type GQL_GET_CAMERA_CONTINUOUS_BORDERSQuery = { __typename?: 'query_root', videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, timezone?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string }, schedule?: { __typename?: 'qx_Schedule', id: string, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, date: any, duration: string, weekdays?: string | undefined }> } | undefined } | undefined };

export type GQL_SUB_CAMERA_CONTINUOUS_BORDERSSubscriptionVariables = Exact<{
  cameraID: string;
}>;


export type GQL_SUB_CAMERA_CONTINUOUS_BORDERSSubscription = { __typename?: 'subscription_root', videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, timezone?: string | undefined, schedule?: { __typename?: 'qx_Schedule', id: string, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, date: any, duration: string, weekdays?: string | undefined }> } | undefined } | undefined };

export type GQL_GET_CAMERA_MOTION_BORDERSQueryVariables = Exact<{
  cameraID: string;
}>;


export type GQL_GET_CAMERA_MOTION_BORDERSQuery = { __typename?: 'query_root', videoSource?: { __typename?: 'qx_VideoSource', id: any, state?: { __typename?: 'videoSourceState', videoSourceID: any, motionActive: boolean } | undefined } | undefined };

export type GQL_SUB_CAMERA_MOTION_BORDERSSubscriptionVariables = Exact<{
  cameraID: string;
}>;


export type GQL_SUB_CAMERA_MOTION_BORDERSSubscription = { __typename?: 'subscription_root', videoSource?: { __typename?: 'qx_VideoSource', id: any, state?: { __typename?: 'videoSourceState', videoSourceID: any, motionActive: boolean } | undefined } | undefined };

export type GQL_GET_CAMERA_PERMISSIONQueryVariables = Exact<{
  cameraID: string;
}>;


export type GQL_GET_CAMERA_PERMISSIONQuery = { __typename?: 'query_root', videoSource?: { __typename?: 'qx_VideoSource', id: any, place: { __typename?: 'qx_Place', id: string, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlace?: { __typename?: 'qx_Place', id: string, customerPermissions?: { __typename?: 'qx_CustomerPermission', customerPlaceID: string, allowIntegratorAccessOperations?: boolean | undefined, allowIntegratorVideoOperations: boolean, allowIntegratorConfig: boolean, allowQxSupport: boolean, canEnableServices?: boolean | undefined } | undefined } | undefined } | undefined } } | undefined };

export type CameraFormFragment = { __typename?: 'qx_VideoSource', id: any, refID: string, name: string, description?: string | undefined, enabled: boolean, cloudStorageDays: number, cloudStorageTimelapseDays: number, snapshotMediaProfileID?: any | undefined, timelapseInterval: number, mountPosition?: qx_eMountPosition_enum | undefined, placeID: string, metadataEnabled?: boolean | undefined, scheduleID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined }, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, refID: string, deviceID: string, warped: boolean, streamEnabled: boolean, streamStatus: qx_eStreamStatus_enum, videoEncoderOptions?: any | undefined, videoEncoderSettings?: any | undefined, audioEncoderSettings?: any | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, refID: string, enabled: boolean } | undefined }>, schedule?: { __typename?: 'qx_Schedule', id: string, name: string, place: { __typename?: 'qx_Place', id: string, name: string } } | undefined };

export type GQL_GET_CAMERA_FORMQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_CAMERA_FORMQuery = { __typename?: 'query_root', videoSource?: { __typename?: 'qx_VideoSource', id: any, refID: string, name: string, description?: string | undefined, enabled: boolean, cloudStorageDays: number, cloudStorageTimelapseDays: number, snapshotMediaProfileID?: any | undefined, timelapseInterval: number, mountPosition?: qx_eMountPosition_enum | undefined, placeID: string, metadataEnabled?: boolean | undefined, scheduleID?: string | undefined, deviceID: string, gatewayID?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined, deviceUsername?: string | undefined, devicePassword?: string | undefined, profileMSupported?: boolean | undefined, tls: boolean, port: number, gatewayID: string, gateway: { __typename?: 'qx_Gateway', id: string, name: string, type: eGatewayType_enum }, audioSources: Array<{ __typename?: 'qx_AudioSource', id: any, refID: string, enabled: boolean, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, videoSourceID: any }> }> }, place: { __typename?: 'qx_Place', id: string, name: string, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined }, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, refID: string, deviceID: string, warped: boolean, streamEnabled: boolean, streamStatus: qx_eStreamStatus_enum, videoEncoderOptions?: any | undefined, videoEncoderSettings?: any | undefined, audioEncoderSettings?: any | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, refID: string, enabled: boolean } | undefined }>, schedule?: { __typename?: 'qx_Schedule', id: string, name: string, place: { __typename?: 'qx_Place', id: string, name: string } } | undefined } | undefined };

export type GQL_GET_CLOUD_STORAGE_OPTIONSQueryVariables = Exact<{ [key: string]: never; }>;


export type GQL_GET_CLOUD_STORAGE_OPTIONSQuery = { __typename?: 'query_root', cloudStorageOptions: Array<{ __typename?: 'qx_CloudStorageOptions', partName?: string | undefined, cloudStorageDays: number }> };

export type GQL_GET_CLOUD_STORAGE_TIMELAPSE_OPTIONSQueryVariables = Exact<{ [key: string]: never; }>;


export type GQL_GET_CLOUD_STORAGE_TIMELAPSE_OPTIONSQuery = { __typename?: 'query_root', cloudStorageTimelapseOptions: Array<{ __typename?: 'cloudStorageTimelapseOptions', partName?: string | undefined, cloudStorageDays: number }> };

export type MediaProfileSearchFragment = { __typename?: 'qx_MediaProfile', id: any, refID: string, streamEnabled: boolean, streamStatus: qx_eStreamStatus_enum, warped: boolean, videoEncoderSettings?: any | undefined, audioEncoderSettings?: any | undefined, rtspUrl?: string | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, refID: string, enabled: boolean } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } };

export type GQL_MEDIA_PROFILE_SEARCHQueryVariables = Exact<{
  where?: qx_MediaProfile_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_MediaProfile_order_by> | qx_MediaProfile_order_by;
}>;


export type GQL_MEDIA_PROFILE_SEARCHQuery = { __typename?: 'query_root', mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, refID: string, streamEnabled: boolean, streamStatus: qx_eStreamStatus_enum, warped: boolean, videoEncoderSettings?: any | undefined, audioEncoderSettings?: any | undefined, rtspUrl?: string | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, refID: string, enabled: boolean } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }>, mediaProfileAggregate: { __typename?: 'qx_MediaProfile_aggregate', aggregate?: { __typename?: 'qx_MediaProfile_aggregate_fields', count: number } | undefined } };

export type GQL_MEDIA_PROFILE_SEARCH_SUBSCRIPTIONVariables = Exact<{
  where?: qx_MediaProfile_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_MediaProfile_order_by> | qx_MediaProfile_order_by;
}>;


export type GQL_MEDIA_PROFILE_SEARCH_SUBSCRIPTION = { __typename?: 'subscription_root', mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, refID: string, streamEnabled: boolean, streamStatus: qx_eStreamStatus_enum, warped: boolean, videoEncoderSettings?: any | undefined, audioEncoderSettings?: any | undefined, rtspUrl?: string | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, refID: string, enabled: boolean } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }> };

export type GQL_UPDATE_CAMERA_BY_IDMutationVariables = Exact<{
  id: string;
  camera: qx_VideoSource_set_input;
}>;


export type GQL_UPDATE_CAMERA_BY_IDMutation = { __typename?: 'mutation_root', updateVideoSource?: { __typename?: 'qx_VideoSource', id: any } | undefined };

export type GQL_UPDATE_MEDIA_PROFILE_BY_IDMutationVariables = Exact<{
  id: string;
  data: qx_MediaProfile_set_input;
}>;


export type GQL_UPDATE_MEDIA_PROFILE_BY_IDMutation = { __typename?: 'mutation_root', updateMediaProfile?: { __typename?: 'qx_MediaProfile', id: any, deviceID: string, refID: string, streamEnabled: boolean, warped: boolean, videoEncoderOptions?: any | undefined, videoEncoderSettings?: any | undefined } | undefined };

export type GQL_UPDATE_VIDEO_ENCODER_SETTINGSMutationVariables = Exact<{
  deviceID?: string;
  refID?: string;
  videoEncoderSettings?: MinionVideoEncoderSettingsInput;
}>;


export type GQL_UPDATE_VIDEO_ENCODER_SETTINGSMutation = { __typename?: 'mutation_root', updateMinion: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_UPDATE_AUDIO_SOURCE_BY_IDMutationVariables = Exact<{
  id: string;
  enabled?: boolean;
}>;


export type GQL_UPDATE_AUDIO_SOURCE_BY_IDMutation = { __typename?: 'mutation_root', updateAudioSource?: { __typename?: 'qx_AudioSource', id: any, enabled: boolean } | undefined };

export type GQL_CAMERA_SCHEMA_PLACE_SELECTQueryVariables = Exact<{
  gatewayID: string;
  placeID: string;
}>;


export type GQL_CAMERA_SCHEMA_PLACE_SELECTQuery = { __typename?: 'query_root', place?: { __typename?: 'qx_Place', id: string, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined } | undefined } | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, place: { __typename?: 'qx_Place', id: string, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined } | undefined } } | undefined };

export type OssDoorDataFragment = { __typename?: 'OSSDoorDataOutput', siteId?: number | undefined, tzoffset?: string | undefined, dst?: boolean | undefined, door?: { __typename?: 'OSSDoor', id?: string | undefined, ossID: number, name?: string | undefined, groups: Array<number>, unlockTime?: string | undefined, extendedUnlockTime?: string | undefined } | undefined };

export type OssPayloadPermissionFragment = { __typename?: 'qx_Permission', id: string, placeID: string, place: { __typename?: 'qx_Place', id: string, path: string }, schedule: { __typename?: 'qx_Schedule', id: string, name: string, blocks: Array<{ __typename?: 'qx_ScheduleBlock', date: any, duration: string, weekdays?: string | undefined }> } };

export type OssGatewayPlaceFragment = { __typename?: 'qx_Place', id: string, path: string, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined } | undefined };

export type OssSiteDoorPlaceFragment = { __typename?: 'qx_Door', id: any, place: { __typename?: 'qx_Place', id: string, path: string } };

export type OssIdAssignmentFragment = { __typename?: 'qx_OssIdAssignment', targetID: string, ossID: number };

export type OssBlockListFragment = { __typename?: 'OSSDataOutput', blockList: Array<string> };

export type OssCredentialUnlockTimeFragment = { __typename?: 'qx_Credential', extendedTimeEnabled: boolean, reason?: string | undefined };

export type OssCardOwnerFragment = { __typename?: 'qx_Credential', id: string, personID: string, reason?: string | undefined, person: { __typename?: 'qx_Person', id: string, salutation?: string | undefined, firstName?: string | undefined, lastName?: string | undefined, suffix?: string | undefined } };

export type OssKeysFragment = { __typename?: 'OSSKeysOutput', keys?: string | undefined };

export type OssDeviceCustomerPlaceFragment = { __typename?: 'qx_Device', id: string, gateway: { __typename?: 'qx_Gateway', id: string, place: { __typename?: 'qx_Place', id: string, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined } | undefined } } };

export type OssSitePlaceFragment = { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined };

export type GQL_GET_OSS_DOOR_DATAQueryVariables = Exact<{
  deviceID: string;
}>;


export type GQL_GET_OSS_DOOR_DATAQuery = { __typename?: 'query_root', getOSSDoorData: { __typename?: 'OSSDoorDataOutput', siteId?: number | undefined, tzoffset?: string | undefined, dst?: boolean | undefined, door?: { __typename?: 'OSSDoor', id?: string | undefined, ossID: number, name?: string | undefined, groups: Array<number>, unlockTime?: string | undefined, extendedUnlockTime?: string | undefined } | undefined } };

export type GQL_GET_OSS_PERMISSIONS_BY_PERSONQueryVariables = Exact<{
  personID: string;
}>;


export type GQL_GET_OSS_PERMISSIONS_BY_PERSONQuery = { __typename?: 'query_root', permissions: Array<{ __typename?: 'qx_Permission', id: string, placeID: string, place: { __typename?: 'qx_Place', id: string, path: string }, schedule: { __typename?: 'qx_Schedule', id: string, name: string, blocks: Array<{ __typename?: 'qx_ScheduleBlock', date: any, duration: string, weekdays?: string | undefined }> } }> };

export type GQL_GET_GATEWAY_PLACEQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_GATEWAY_PLACEQuery = { __typename?: 'query_root', place?: { __typename?: 'qx_Place', id: string, path: string, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined } | undefined } | undefined };

export type GQL_GET_OSS_SITE_DOOR_PLACESQueryVariables = Exact<{
  gatewayPlaceID: string;
  deviceKind: string;
}>;


export type GQL_GET_OSS_SITE_DOOR_PLACESQuery = { __typename?: 'query_root', doors: Array<{ __typename?: 'qx_Door', id: any, place: { __typename?: 'qx_Place', id: string, path: string } }> };

export type GQL_GET_OSS_ID_ASSIGNMENTSQueryVariables = Exact<{
  sitePlaceID: string;
  targetIDs: Array<string> | string;
}>;


export type GQL_GET_OSS_ID_ASSIGNMENTSQuery = { __typename?: 'query_root', ossIdAssignments: Array<{ __typename?: 'qx_OssIdAssignment', targetID: string, ossID: number }> };

export type GQL_GET_OSS_KEYSQueryVariables = Exact<{
  placeID: string;
}>;


export type GQL_GET_OSS_KEYSQuery = { __typename?: 'query_root', getOSSKeys: { __typename?: 'OSSKeysOutput', keys?: string | undefined } };

export type GQL_GET_OSS_DEVICE_CUSTOMER_PLACEQueryVariables = Exact<{
  deviceID: string;
}>;


export type GQL_GET_OSS_DEVICE_CUSTOMER_PLACEQuery = { __typename?: 'query_root', device?: { __typename?: 'qx_Device', id: string, gateway: { __typename?: 'qx_Gateway', id: string, place: { __typename?: 'qx_Place', id: string, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined } | undefined } } } | undefined };

export type GQL_GET_OSS_BLOCK_LISTQueryVariables = Exact<{
  placeID: string;
}>;


export type GQL_GET_OSS_BLOCK_LISTQuery = { __typename?: 'query_root', getOSSData: { __typename?: 'OSSDataOutput', blockList: Array<string> } };

export type GQL_GET_OSS_SITE_PLACESQueryVariables = Exact<{
  ids: Array<string> | string;
}>;


export type GQL_GET_OSS_SITE_PLACESQuery = { __typename?: 'query_root', places: Array<{ __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }> };

export type GQL_GET_OSS_CREDENTIAL_UNLOCK_TIMEQueryVariables = Exact<{
  personID: string;
}>;


export type GQL_GET_OSS_CREDENTIAL_UNLOCK_TIMEQuery = { __typename?: 'query_root', credentials: Array<{ __typename?: 'qx_Credential', extendedTimeEnabled: boolean, reason?: string | undefined }> };

export type GQL_FIND_CREDENTIAL_BY_VALUEQueryVariables = Exact<{
  value: string;
  customerPlaceID: string;
}>;


export type GQL_FIND_CREDENTIAL_BY_VALUEQuery = { __typename?: 'query_root', credentials: Array<{ __typename?: 'qx_Credential', id: string, personID: string, reason?: string | undefined, person: { __typename?: 'qx_Person', id: string, salutation?: string | undefined, firstName?: string | undefined, lastName?: string | undefined, suffix?: string | undefined } }> };

export type GQL_DELETE_WIEGAND_TWINSMutationVariables = Exact<{
  customerPlaceID: string;
  value: string;
}>;


export type GQL_DELETE_WIEGAND_TWINSMutation = { __typename?: 'mutation_root', deleteCredentials?: { __typename?: 'qx_Credential_mutation_response', affected_rows: number } | undefined };

export type GQL_DELETE_WIEGAND_CREDENTIALSMutationVariables = Exact<{
  personID: string;
  values: Array<string> | string;
}>;


export type GQL_DELETE_WIEGAND_CREDENTIALSMutation = { __typename?: 'mutation_root', deleteCredentials?: { __typename?: 'qx_Credential_mutation_response', affected_rows: number } | undefined };

export type GQL_GET_SCHEDULES_BY_HOLIDAY_SET_IDQueryVariables = Exact<{
  holidaySetID: string;
}>;


export type GQL_GET_SCHEDULES_BY_HOLIDAY_SET_IDQuery = { __typename?: 'query_root', schedules: Array<{ __typename?: 'qx_Schedule', id: string, name: string, doors: Array<{ __typename?: 'qx_Door', id: any, name: string, deviceID: string }>, permissions: Array<{ __typename?: 'qx_Permission', id: string, place: { __typename?: 'qx_Place', id: string, path: string } }> }> };

export type GQL_GET_DEVICES_BY_ID_OR_PLACEIDQueryVariables = Exact<{
  deviceIDs: Array<string> | string;
  placeIDs: Array<string> | string;
}>;


export type GQL_GET_DEVICES_BY_ID_OR_PLACEIDQuery = { __typename?: 'query_root', devices: Array<{ __typename?: 'qx_Device', id: string, name: string, doors: Array<{ __typename?: 'qx_Door', id: any, place: { __typename?: 'qx_Place', id: string, path: string } }> }> };

export type GQL_DEVICE_DIO_SEARCHQueryVariables = Exact<{
  where?: qx_DeviceDIO_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_DeviceDIO_order_by> | qx_DeviceDIO_order_by;
}>;


export type GQL_DEVICE_DIO_SEARCHQuery = { __typename?: 'query_root', DeviceDIOs: Array<{ __typename?: 'qx_DeviceDIO', id: string, name: string, state?: qx_eDIOState_enum | undefined, refID: string, type?: qx_eDIOType_enum | undefined, readerID?: string | undefined, lockID?: string | undefined, doorID?: any | undefined, deviceID: string, Device: { __typename?: 'qx_Device', id: string, name: string, make?: string | undefined, model?: string | undefined, gateway: { __typename?: 'qx_Gateway', id: string, name: string, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } }, Reader?: { __typename?: 'qx_Reader', id: string, DeviceDIOs: Array<{ __typename?: 'qx_DeviceDIO', id: string, readerID?: string | undefined, lockID?: string | undefined, InputPoints: Array<{ __typename?: 'qx_InputPoint', id: string, channel?: number | undefined }>, OutputPoints: Array<{ __typename?: 'qx_OutputPoint', id: string, channel?: number | undefined }> }> } | undefined, InputPoints: Array<{ __typename?: 'qx_InputPoint', id: string, channel?: number | undefined, deviceID: string }>, OutputPoints: Array<{ __typename?: 'qx_OutputPoint', id: string, channel?: number | undefined, pulse?: string | undefined, deviceID: string }> }>, DeviceDioAggregate: { __typename?: 'qx_DeviceDIO_aggregate', aggregate?: { __typename?: 'qx_DeviceDIO_aggregate_fields', count: number } | undefined } };

export type GQL_GET_DEVICE_MAKE_FOR_DIOSQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_DEVICE_MAKE_FOR_DIOSQuery = { __typename?: 'query_root', device?: { __typename?: 'qx_Device', id: string, make?: string | undefined, model?: string | undefined } | undefined };

export type DeviceFormDscConnectionFragment = { __typename?: 'DSCConnection', integrationKey: string, decryptedInstallerAccessCode?: string | undefined, decryptedIntegrationAccessCode?: string | undefined, decryptedMasterAccessCode?: string | undefined };

export type GQL_GET_DEVICE_FORMQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_DEVICE_FORMQuery = { __typename?: 'query_root', device?: { __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, enabled: boolean, name: string, description?: string | undefined, port: number, tls: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, deviceAddress?: string | undefined, deviceUsername?: string | undefined, devicePassword?: string | undefined, make?: string | undefined, model?: string | undefined, serial?: string | undefined, pacsConfigurationID?: string | undefined, meta?: any | undefined, gatewayID: string, dscConnections: Array<{ __typename?: 'DSCConnection', integrationKey: string, decryptedInstallerAccessCode?: string | undefined, decryptedIntegrationAccessCode?: string | undefined, decryptedMasterAccessCode?: string | undefined }>, gateway: { __typename?: 'qx_Gateway', id: string, name: string, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string } }, doors: Array<{ __typename?: 'qx_Door', id: any, name: string, description?: string | undefined, deviceID: string, unlockScheduleID?: string | undefined, refID: string, lockdownImmunity?: boolean | undefined, doorMonitorAlarm: boolean, placeID: string, inventoryID?: string | undefined, type?: string | undefined, outsideID?: string | undefined, accessTime?: string | undefined, doorMonitor: qx_eDoorMonitor_enum, defaultVideoSourceID?: any | undefined, lockAddress?: string | undefined, doorMonitorAddress?: string | undefined, doorMonitorSupervise?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string }, outside?: { __typename?: 'qx_Place', id: string, name: string } | undefined, locks: Array<{ __typename?: 'qx_Lock', id: string, name: string, refID: string, direction: qx_eAccessPointDirection_enum, enabled: boolean, type: qx_eLockType_enum, delay?: string | undefined, relayMonitor?: qx_eLockRelayMonitor_enum | undefined, powerMonitor?: qx_eLockPowerMonitor_enum | undefined, mode?: qx_eLockMode_enum | undefined }>, readers: Array<{ __typename?: 'qx_Reader', id: string, name: string, refID: string, direction: qx_eAccessPointDirection_enum, enabled: boolean, protocol: qx_eReaderProtocol_enum, type: qx_eAccessPointType_enum, rexState: qx_eRexState_enum, rexBypass: boolean, accessType: qx_eReaderAccessType_enum, supervise?: string | undefined, wiegandFormats?: any | undefined }> }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, refID: string, name: string, description?: string | undefined, enabled: boolean, cloudStorageDays: number, cloudStorageTimelapseDays: number, snapshotMediaProfileID?: any | undefined, timelapseInterval: number, mountPosition?: qx_eMountPosition_enum | undefined, placeID: string, metadataEnabled?: boolean | undefined, scheduleID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined }, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, refID: string, deviceID: string, warped: boolean, streamEnabled: boolean, streamStatus: qx_eStreamStatus_enum, videoEncoderOptions?: any | undefined, videoEncoderSettings?: any | undefined, audioEncoderSettings?: any | undefined, audioSource?: { __typename?: 'qx_AudioSource', id: any, refID: string, enabled: boolean } | undefined }>, schedule?: { __typename?: 'qx_Schedule', id: string, name: string, place: { __typename?: 'qx_Place', id: string, name: string } } | undefined }>, sensors: Array<{ __typename?: 'qx_Sensor', id: any, defaultVideoSourceID?: any | undefined, batteryLevel: qx_eBatteryLevel_enum, connectionStatus: qx_eDeviceConnectionStatus_enum, createdAt?: any | undefined, description?: string | undefined, deviceID: string, disabledByLicense: boolean, enabled: boolean, name: string, placeID: string, serial: string, state: qx_eDIOState_enum, type: qx_eSensorType_enum, updatedAt?: any | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string } | undefined, eBatteryLevel: { __typename?: 'qx_eBatteryLevel', comment?: string | undefined }, eDIOState: { __typename?: 'qx_eDIOState', comment?: string | undefined }, eDeviceConnectionStatus: { __typename?: 'qx_eDeviceConnectionStatus', comment?: string | undefined }, eSensorType: { __typename?: 'qx_eSensorType', comment?: string | undefined }, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined, connectionStatus: qx_eDeviceConnectionStatus_enum, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string } } }, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } | undefined } }> } | undefined };

export type GQL_PUSH_HARDWARE_CONFIGURATIONMutationVariables = Exact<{
  config: pacsSettings;
}>;


export type GQL_PUSH_HARDWARE_CONFIGURATIONMutation = { __typename?: 'mutation_root', pacsHardwareConfiguration: { __typename?: 'SuccessOutput', success: boolean } };

export type DeviceKindEnumFragment = { __typename?: 'qx_eDeviceKind', value: string, comment?: string | undefined };

export type GQL_GET_DEVICE_KIND_ENUMSQueryVariables = Exact<{ [key: string]: never; }>;


export type GQL_GET_DEVICE_KIND_ENUMSQuery = { __typename?: 'query_root', deviceKindEnums: Array<{ __typename?: 'qx_eDeviceKind', value: string, comment?: string | undefined }> };

export type GQL_DEVICE_REBOOTMutationVariables = Exact<{
  id: string;
}>;


export type GQL_DEVICE_REBOOTMutation = { __typename?: 'mutation_root', rebootMinion: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_DEVICE_RECONNECTMutationVariables = Exact<{
  id: string;
}>;


export type GQL_DEVICE_RECONNECTMutation = { __typename?: 'mutation_root', reconnectMinion: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_DEVICE_UPGRADEMutationVariables = Exact<{
  id: string;
}>;


export type GQL_DEVICE_UPGRADEMutation = { __typename?: 'mutation_root', upgradeRosslareFirmware: { __typename?: 'SuccessOutput', success: boolean } };

export type DeviceWarningStatusFragment = { __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, name: string, make?: string | undefined, model?: string | undefined, meta?: any | undefined, connectionStatus: qx_eDeviceConnectionStatus_enum, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum };

export type GQL_GET_DEVICE_WARNING_STATUSESQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_DEVICE_WARNING_STATUSESQuery = { __typename?: 'query_root', device?: { __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, name: string, make?: string | undefined, model?: string | undefined, meta?: any | undefined, connectionStatus: qx_eDeviceConnectionStatus_enum, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum } | undefined };

export type GQL_SUB_DEVICE_WARNING_STATUSESSubscriptionVariables = Exact<{
  id: string;
}>;


export type GQL_SUB_DEVICE_WARNING_STATUSESSubscription = { __typename?: 'subscription_root', device?: { __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, name: string, make?: string | undefined, model?: string | undefined, meta?: any | undefined, connectionStatus: qx_eDeviceConnectionStatus_enum, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum } | undefined };

export type GQL_GET_WIRING_TABLE_INFO_BY_IDQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_WIRING_TABLE_INFO_BY_IDQuery = { __typename?: 'query_root', device?: { __typename?: 'qx_Device', id: string, make?: string | undefined, model?: string | undefined, DeviceDIOs: Array<{ __typename?: 'qx_DeviceDIO', readerID?: string | undefined, lockID?: string | undefined, doorID?: any | undefined, deviceID: string, id: string, name: string, refID: string, type?: qx_eDIOType_enum | undefined, state?: qx_eDIOState_enum | undefined, enabled: boolean, Reader?: { __typename?: 'qx_Reader', id: string, type: qx_eAccessPointType_enum, refID: string, name: string } | undefined, eDIOType?: { __typename?: 'qx_eDIOType', value: string, comment?: string | undefined } | undefined, eDIOState?: { __typename?: 'qx_eDIOState', value: string, comment?: string | undefined } | undefined, InputPoints: Array<{ __typename?: 'qx_InputPoint', supervise?: string | undefined, id: string, channel?: number | undefined }>, OutputPoints: Array<{ __typename?: 'qx_OutputPoint', pulse?: string | undefined, id: string, channel?: number | undefined }>, Door?: { __typename?: 'qx_Door', id: any, name: string, inventoryID?: string | undefined, toAlarm: { __typename?: 'qx_eDoorAlarm', value: string }, toMode: { __typename?: 'qx_eDoorMode', value: string } } | undefined, accessInventory?: { __typename?: 'qx_AccessInventory', id: string } | undefined }>, doors: Array<{ __typename?: 'qx_Door', id: any, name: string, refID: string, inventoryID?: string | undefined, locks: Array<{ __typename?: 'qx_Lock', id: string, name: string, refID: string }>, readers: Array<{ __typename?: 'qx_Reader', id: string, name: string, type: qx_eAccessPointType_enum, refID: string, wiegandFormats?: any | undefined, DeviceDIOs: Array<{ __typename?: 'qx_DeviceDIO', id: string, OutputPoints: Array<{ __typename?: 'qx_OutputPoint', id: string, channel?: number | undefined }>, InputPoints: Array<{ __typename?: 'qx_InputPoint', id: string, channel?: number | undefined }> }> }>, dios: Array<{ __typename?: 'qx_DeviceDIO', id: string, name: string, type?: qx_eDIOType_enum | undefined, readerID?: string | undefined, lockID?: string | undefined, doorID?: any | undefined, deviceID: string, refID: string, OutputPoints: Array<{ __typename?: 'qx_OutputPoint', id: string, channel?: number | undefined }>, InputPoints: Array<{ __typename?: 'qx_InputPoint', id: string, channel?: number | undefined }> }> }> } | undefined };

export type DeviceBasicFragment = { __typename?: 'qx_Device', id: string, make?: string | undefined, model?: string | undefined };

export type DoorWiringFragment = { __typename?: 'qx_Door', id: any, name: string, refID: string, inventoryID?: string | undefined, locks: Array<{ __typename?: 'qx_Lock', id: string, name: string, refID: string }>, readers: Array<{ __typename?: 'qx_Reader', id: string, name: string, type: qx_eAccessPointType_enum, refID: string, wiegandFormats?: any | undefined, DeviceDIOs: Array<{ __typename?: 'qx_DeviceDIO', id: string, OutputPoints: Array<{ __typename?: 'qx_OutputPoint', id: string, channel?: number | undefined }>, InputPoints: Array<{ __typename?: 'qx_InputPoint', id: string, channel?: number | undefined }> }> }>, dios: Array<{ __typename?: 'qx_DeviceDIO', id: string, name: string, type?: qx_eDIOType_enum | undefined, readerID?: string | undefined, lockID?: string | undefined, doorID?: any | undefined, deviceID: string, refID: string, OutputPoints: Array<{ __typename?: 'qx_OutputPoint', id: string, channel?: number | undefined }>, InputPoints: Array<{ __typename?: 'qx_InputPoint', id: string, channel?: number | undefined }> }> };

export type GQL_CONFIRM_DEVICE_DELETEQueryVariables = Exact<{
  deviceID: string;
}>;


export type GQL_CONFIRM_DEVICE_DELETEQuery = { __typename?: 'query_root', device?: { __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, name: string, gateway: { __typename?: 'qx_Gateway', id: string, connectionStatus: boolean, type: eGatewayType_enum }, videoSources_aggregate: { __typename?: 'qx_VideoSource_aggregate', aggregate?: { __typename?: 'qx_VideoSource_aggregate_fields', count: number } | undefined }, doors_aggregate: { __typename?: 'qx_Door_aggregate', aggregate?: { __typename?: 'qx_Door_aggregate_fields', count: number } | undefined }, sensors_aggregate: { __typename?: 'qx_Sensor_aggregate', aggregate?: { __typename?: 'qx_Sensor_aggregate_fields', count: number } | undefined } } | undefined };

export type GQL_CREATE_DEVICEMutationVariables = Exact<{
  device: CreateDeviceInput;
}>;


export type GQL_CREATE_DEVICEMutation = { __typename?: 'mutation_root', createDevice: { __typename?: 'CreateDeviceOutput', id: string, kind: string, name: string, description?: string | undefined, port: string, tls: string, make?: string | undefined, model?: string | undefined, serial?: string | undefined, firmware?: string | undefined, connectionStatus: string } };

export type GQL_GET_DEVICE_NAME_FOR_DELETE_MESSAGEQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_DEVICE_NAME_FOR_DELETE_MESSAGEQuery = { __typename?: 'query_root', device?: { __typename?: 'qx_Device', id: string, name: string } | undefined };

export type GQL_DELETE_DEVICE_BY_IDMutationVariables = Exact<{
  id: string;
}>;


export type GQL_DELETE_DEVICE_BY_IDMutation = { __typename?: 'mutation_root', deleteDevice?: { __typename?: 'qx_Device', id: string, connectionStatus: qx_eDeviceConnectionStatus_enum } | undefined };

export type SuperviseInputFragment = { __typename?: 'qx_eSuperviseInputs', comment?: string | undefined, value: string };

export type ReaderProtocolFragment = { __typename?: 'qx_eReaderProtocol', comment?: string | undefined, value: string };

export type ReaderAccessTypeFragment = { __typename?: 'qx_eReaderAccessType', comment?: string | undefined, value: string };

export type GQL_GET_DEVICE_COMPATIBILITIESQueryVariables = Exact<{
  where: qx_eAccessMake_bool_exp;
}>;


export type GQL_GET_DEVICE_COMPATIBILITIESQuery = { __typename?: 'query_root', qx_eAccessMake: Array<{ __typename?: 'qx_eAccessMake', name: string, SuperviseInputCompatibilities: Array<{ __typename?: 'superviseInputCompatibility', panel: qx_eAccessMake_enum, type: qx_eSuperviseInputs_enum, eSuperviseInput: { __typename?: 'qx_eSuperviseInputs', comment?: string | undefined, value: string } }>, ReaderProtocolCompatibilities: Array<{ __typename?: 'readerProtocolCompatibility', panel: qx_eAccessMake_enum, type: qx_eReaderProtocol_enum, eReaderProtocol: { __typename?: 'qx_eReaderProtocol', comment?: string | undefined, value: string } }>, ReaderAccessTypeCompatibilities: Array<{ __typename?: 'readerAccessTypeCompatibility', id: number, panel: qx_eAccessMake_enum, type: qx_eReaderAccessType_enum, eReaderAccessType: { __typename?: 'qx_eReaderAccessType', comment?: string | undefined, value: string } }> }> };

export type GQL_GET_DOOR_CONFIG_BY_MAKE_MODELQueryVariables = Exact<{
  make: string;
  model: string;
}>;


export type GQL_GET_DOOR_CONFIG_BY_MAKE_MODELQuery = { __typename?: 'query_root', doorTemplates: Array<{ __typename?: 'qx_DoorTemplate', id: string, make: string, model: string, diagram?: string | undefined, name: string, configurationID: string }> };

export type GQL_GET_DEVICE_RTSP_SENSORQueryVariables = Exact<{
  gatewayID: string;
  ipv4: string;
}>;


export type GQL_GET_DEVICE_RTSP_SENSORQuery = { __typename?: 'query_root', devices: Array<{ __typename?: 'qx_Device', sensors: Array<{ __typename?: 'qx_Sensor', id: any, name: string }> }> };

export type GQL_GET_DEVICE_RTSPQueryVariables = Exact<{
  gatewayID: string;
  ipv4: string;
}>;


export type GQL_GET_DEVICE_RTSPQuery = { __typename?: 'query_root', devices: Array<{ __typename?: 'qx_Device', mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, videoSourceID: any, videoSource: { __typename?: 'qx_VideoSource', id: any, name: string } }> }> };

export type GQL_SUB_CREATED_DEVICESSubscriptionVariables = Exact<{
  where?: qx_Device_bool_exp;
}>;


export type GQL_SUB_CREATED_DEVICESSubscription = { __typename?: 'subscription_root', devices: Array<{ __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, deviceAddress?: string | undefined, deviceMac?: string | undefined, firmware?: string | undefined, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any }>, doors: Array<{ __typename?: 'qx_Door', id: any }>, sensors: Array<{ __typename?: 'qx_Sensor', id: any }> }> };

export type GQL_DEVICE_SET_MAINTENANCE_MODEMutationVariables = Exact<{
  id: string;
  detach: boolean;
}>;


export type GQL_DEVICE_SET_MAINTENANCE_MODEMutation = { __typename?: 'mutation_root', detachDevice: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_GET_READERS_BY_DEVICE_IDQueryVariables = Exact<{
  deviceID: string;
}>;


export type GQL_GET_READERS_BY_DEVICE_IDQuery = { __typename?: 'query_root', readers: Array<{ __typename?: 'qx_Reader', id: string, name: string, direction: qx_eAccessPointDirection_enum, doorID?: any | undefined, Door?: { __typename?: 'qx_Door', id: any, name: string } | undefined }> };

export type GQL_VALIDATE_DSC_SOFTWARE_UPDATEMutationVariables = Exact<{
  deviceID: string;
}>;


export type GQL_VALIDATE_DSC_SOFTWARE_UPDATEMutation = { __typename?: 'mutation_root', validateSoftware: { __typename?: 'ValidateHardwareResult', error?: string | undefined, success: boolean } };

export type OfflineLockDoorPlacesFragment = { __typename?: 'qx_Door', id: any, name: string, placeID: string, outsideID?: string | undefined };

export type GQL_GET_OFFLINE_LOCK_DOOR_PLACESQueryVariables = Exact<{
  deviceID: string;
}>;


export type GQL_GET_OFFLINE_LOCK_DOOR_PLACESQuery = { __typename?: 'query_root', doors: Array<{ __typename?: 'qx_Door', id: any, name: string, placeID: string, outsideID?: string | undefined }> };

export type getDoorNameFromCacheQueryVariables = Exact<{
  doorID: string;
}>;


export type getDoorNameFromCacheQuery = { __typename?: 'query_root', door?: { __typename?: 'qx_Door', id: any, name: string, canOperate?: boolean | undefined } | undefined };

export type GQL_GET_DOOR_FORMQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_DOOR_FORMQuery = { __typename?: 'query_root', door?: { __typename?: 'qx_Door', id: any, refID: string, name: string, description?: string | undefined, enabled: boolean, type?: string | undefined, doorMonitorAlarm: boolean, defaultVideoSourceID?: any | undefined, lockdownImmunity?: boolean | undefined, accessTime?: string | undefined, openTime?: string | undefined, extendedAccessTime?: string | undefined, extendedOpenTime?: string | undefined, preAlarmTime?: string | undefined, doorMonitor: qx_eDoorMonitor_enum, lockAddress?: string | undefined, doorMonitorAddress?: string | undefined, doorMonitorSupervise?: string | undefined, placeID: string, deviceID: string, inventoryID?: string | undefined, outsideID?: string | undefined, unlockScheduleID?: string | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined }, device: { __typename?: 'qx_Device', id: string, name: string, meta?: any | undefined, make?: string | undefined, model?: string | undefined, kind: qx_eDeviceKind_enum, gateway: { __typename?: 'qx_Gateway', id: string, name: string, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string, path: string } } }, outside?: { __typename?: 'qx_Place', id: string, name: string } | undefined, unlockSchedule?: { __typename?: 'qx_Schedule', id: string, name: string } | undefined, readers: Array<{ __typename?: 'qx_Reader', id: string, name: string, refID: string, direction: qx_eAccessPointDirection_enum, enabled: boolean, type: qx_eAccessPointType_enum, rexState: qx_eRexState_enum, rexBypass: boolean, protocol: qx_eReaderProtocol_enum, accessType: qx_eReaderAccessType_enum, supervise?: string | undefined, wiegandFormats?: any | undefined }>, locks: Array<{ __typename?: 'qx_Lock', id: string, name: string, refID: string, direction: qx_eAccessPointDirection_enum, enabled: boolean, delay?: string | undefined, type: qx_eLockType_enum, relayMonitor?: qx_eLockRelayMonitor_enum | undefined, powerMonitor?: qx_eLockPowerMonitor_enum | undefined, mode?: qx_eLockMode_enum | undefined }> } | undefined };

export type GQL_SEARCH_V_EVENTS_DOORQueryVariables = Exact<{
  where: vEvents_bool_exp;
  limit: number;
  order_by: Array<vEvents_order_by> | vEvents_order_by;
}>;


export type GQL_SEARCH_V_EVENTS_DOORQuery = { __typename?: 'query_root', vEvents: Array<{ __typename?: 'vEvents', id?: any | undefined, active?: boolean | undefined, card?: string | undefined, bits?: number | undefined, status?: string | undefined, time?: any | undefined, type?: string | undefined, duration?: any | undefined, hasVideo?: boolean | undefined, inCloud?: boolean | undefined, onGateway?: boolean | undefined, eventStart?: any | undefined, eventEnd?: any | undefined, personID?: string | undefined, doorID?: any | undefined, videoSourceID?: any | undefined, deviceID?: string | undefined, placeID?: string | undefined, profile?: string | undefined, serverTime?: any | undefined, person?: { __typename?: 'qx_Person', id: string, avatar?: string | undefined, firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined } | undefined, door?: { __typename?: 'qx_Door', id: any, name: string } | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string } | undefined, place?: { __typename?: 'qx_Place', id: string, name: string, path: string, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, type: eGatewayType_enum } | undefined, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } | undefined, snapshot?: { __typename?: 'qx_Snapshot', id: string, signedUrl?: string | undefined } | undefined }> };

export type GQL_GET_DOOR_UNLOCK_SCHEDULE_STATESQueryVariables = Exact<{
  scheduleIDs: Array<string> | string;
  tzOverride?: string;
}>;


export type GQL_GET_DOOR_UNLOCK_SCHEDULE_STATESQuery = { __typename?: 'query_root', schedules: Array<{ __typename?: 'qx_Schedule', id: string, isActive?: boolean | undefined, holidayActive?: string | undefined }> };

export type GQL_PACS_CONFIGURATION_UPDATE_PLACEMutationVariables = Exact<{
  placeID: string;
}>;


export type GQL_PACS_CONFIGURATION_UPDATE_PLACEMutation = { __typename?: 'mutation_root', pacsConfigurationUpdatePlace: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_CONFIRM_DOOR_DELETEQueryVariables = Exact<{
  doorID: string;
}>;


export type GQL_CONFIRM_DOOR_DELETEQuery = { __typename?: 'query_root', devices: Array<{ __typename?: 'qx_Device', id: string, make?: string | undefined, model?: string | undefined, name: string, doors_aggregate: { __typename?: 'qx_Door_aggregate', aggregate?: { __typename?: 'qx_Door_aggregate_fields', count: number } | undefined } }> };

export type GQL_CREATE_DOORMutationVariables = Exact<{
  door: qx_Door_insert_input;
}>;


export type GQL_CREATE_DOORMutation = { __typename?: 'mutation_root', createDoor?: { __typename?: 'qx_Door', id: any, name: string } | undefined };

export type GQL_DELETE_DOOR_BY_IDMutationVariables = Exact<{
  id: string;
}>;


export type GQL_DELETE_DOOR_BY_IDMutation = { __typename?: 'mutation_root', deleteDoor?: { __typename?: 'qx_Door', id: any, name: string, device: { __typename?: 'qx_Device', id: string, name: string, gateway: { __typename?: 'qx_Gateway', id: string, name: string } } } | undefined };

export type GQL_DEVICE_EXISTS_BY_IDQueryVariables = Exact<{
  id: string;
}>;


export type GQL_DEVICE_EXISTS_BY_IDQuery = { __typename?: 'query_root', device?: { __typename?: 'qx_Device', id: string } | undefined };

export type findDoorBeforeDeleteFragment = { __typename?: 'qx_Door', id: any, device: { __typename?: 'qx_Device', id: string } };

export type GQL_GET_DOOR_CONFIGURATION_BY_TEMPLATE_IDQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_DOOR_CONFIGURATION_BY_TEMPLATE_IDQuery = { __typename?: 'query_root', doorTemplate?: { __typename?: 'qx_DoorTemplate', id: string, DoorConfiguration: { __typename?: 'qx_DoorConfiguration', id: string, configuration?: any | undefined } } | undefined };

export type GQL_DOORS_BY_DEVICE_IDQueryVariables = Exact<{
  deviceId: string;
}>;


export type GQL_DOORS_BY_DEVICE_IDQuery = { __typename?: 'query_root', doors: Array<{ __typename?: 'qx_Door', id: any, refID: string, name: string, canOperate?: boolean | undefined, description?: string | undefined, enabled: boolean, type?: string | undefined, defaultVideoSourceID?: any | undefined, accessTime?: string | undefined, openTime?: string | undefined, extendedAccessTime?: string | undefined, extendedOpenTime?: string | undefined, preAlarmTime?: string | undefined, doorMonitor: qx_eDoorMonitor_enum, lockAddress?: string | undefined, doorMonitorAddress?: string | undefined, doorMonitorSupervise?: string | undefined, placeID: string, deviceID: string, outsideID?: string | undefined, unlockScheduleID?: string | undefined, VideoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, place: { __typename?: 'qx_Place', id: string, name: string } } | undefined, place: { __typename?: 'qx_Place', id: string, name: string }, device: { __typename?: 'qx_Device', id: string, name: string, meta?: any | undefined, make?: string | undefined, model?: string | undefined, gateway: { __typename?: 'qx_Gateway', id: string, name: string, place: { __typename?: 'qx_Place', id: string, name: string, path: string } } }, outside?: { __typename?: 'qx_Place', id: string, name: string } | undefined, unlockSchedule?: { __typename?: 'qx_Schedule', id: string, name: string } | undefined, Readers: Array<{ __typename?: 'qx_Reader', id: string, name: string, direction: qx_eAccessPointDirection_enum, enabled: boolean, type: qx_eAccessPointType_enum, rexState: qx_eRexState_enum, rexBypass: boolean, protocol: qx_eReaderProtocol_enum, accessType: qx_eReaderAccessType_enum, supervise?: string | undefined }>, Locks: Array<{ __typename?: 'qx_Lock', id: string, name: string, direction: qx_eAccessPointDirection_enum, enabled: boolean, delay?: string | undefined, type: qx_eLockType_enum, relayMonitor?: qx_eLockRelayMonitor_enum | undefined, powerMonitor?: qx_eLockPowerMonitor_enum | undefined, mode?: qx_eLockMode_enum | undefined }>, DeviceDIOs: Array<{ __typename?: 'qx_DeviceDIO', id: string, name: string, type?: qx_eDIOType_enum | undefined, defaultState?: qx_eDIONormalState_enum | undefined }> }> };

export type GQL_LOCK_DOOR_BY_IDMutationVariables = Exact<{
  id: string;
}>;


export type GQL_LOCK_DOOR_BY_IDMutation = { __typename?: 'mutation_root', lockDoor: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_LOCKDOWN_DOOR_BY_IDMutationVariables = Exact<{
  id: string;
}>;


export type GQL_LOCKDOWN_DOOR_BY_IDMutation = { __typename?: 'mutation_root', lockDownDoor: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_LOCKDOWN_RELEASE_DOOR_BY_IDMutationVariables = Exact<{
  id: string;
}>;


export type GQL_LOCKDOWN_RELEASE_DOOR_BY_IDMutation = { __typename?: 'mutation_root', lockDownReleaseDoor: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_REVERT_TO_SCHEDULE_DOOR_BY_IDMutationVariables = Exact<{
  id: string;
}>;


export type GQL_REVERT_TO_SCHEDULE_DOOR_BY_IDMutation = { __typename?: 'mutation_root', revertDoor: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_UNLOCK_DOOR_BY_IDMutationVariables = Exact<{
  id: string;
}>;


export type GQL_UNLOCK_DOOR_BY_IDMutation = { __typename?: 'mutation_root', unlockDoor: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_UPDATE_DOOR_BY_IDMutationVariables = Exact<{
  id: string;
  deviceID: string;
  door: qx_Door_set_input;
  supervise: string;
}>;


export type GQL_UPDATE_DOOR_BY_IDMutation = { __typename?: 'mutation_root', updateDoor?: { __typename?: 'qx_Door', id: any, name: string } | undefined, updateDoorContactSupervise: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_INITIAL_DOOR_READERS_AND_LOCKSQueryVariables = Exact<{
  doorID: string;
}>;


export type GQL_INITIAL_DOOR_READERS_AND_LOCKSQuery = { __typename?: 'query_root', locks: Array<{ __typename?: 'qx_Lock', id: string }>, readers: Array<{ __typename?: 'qx_Reader', id: string }> };

export type GQL_GET_EVENTS_INFO_PANEL_EVENTSQueryVariables = Exact<{
  where: vEvents_bool_exp;
  limit: number;
}>;


export type GQL_GET_EVENTS_INFO_PANEL_EVENTSQuery = { __typename?: 'query_root', vEvents: Array<{ __typename?: 'vEvents', id?: any | undefined, active?: boolean | undefined, card?: string | undefined, bits?: number | undefined, status?: string | undefined, time?: any | undefined, serverTime?: any | undefined, type?: string | undefined, duration?: any | undefined, hasVideo?: boolean | undefined, inCloud?: boolean | undefined, onGateway?: boolean | undefined, eventStart?: any | undefined, eventEnd?: any | undefined, sensorID?: any | undefined, personID?: string | undefined, doorID?: any | undefined, videoSourceID?: any | undefined, mediaProfileID?: any | undefined, deviceID?: string | undefined, zoneID?: string | undefined, partitionID?: string | undefined, gatewayID?: string | undefined, placeID?: string | undefined, profile?: string | undefined, sensor?: { __typename?: 'qx_Sensor', id: any, name: string, type: qx_eSensorType_enum } | undefined, person?: { __typename?: 'qx_Person', id: string, avatar_sm?: string | undefined, firstName?: string | undefined, lastName?: string | undefined } | undefined, door?: { __typename?: 'qx_Door', id: any, name: string } | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string } | undefined, device?: { __typename?: 'qx_Device', id: string, name: string, kind: qx_eDeviceKind_enum } | undefined, zone?: { __typename?: 'IntrusionZone', id: string, name: string } | undefined, partition?: { __typename?: 'IntrusionPartition', id: string, name: string } | undefined, toType?: { __typename?: 'qx_EventType', priority: number } | undefined, place?: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, type: eGatewayType_enum } | undefined } | undefined, snapshot?: { __typename?: 'qx_Snapshot', id: string, signedUrl?: string | undefined, aspectRatio?: any | undefined } | undefined }> };

export type GQL_GET_GATEWAY_LICENSE_INFOQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_GATEWAY_LICENSE_INFOQuery = { __typename?: 'query_root', gateway?: { __typename?: 'qx_Gateway', id: string, name: string, licenseDetails?: any | undefined, licenseExpiration?: any | undefined } | undefined };

export type DiscoveredDeviceFragment = { __typename?: 'DiscoveredDevice', addresses: any, discoveryDriver: string, firmwareVersion?: string | undefined, hardwareID?: string | undefined, location?: string | undefined, model?: string | undefined, name?: string | undefined, networkInterfaceAddress: string, networkInterfaceName: string, profiles?: Array<string> | undefined, scopes?: Array<string> | undefined, serialNumber?: string | undefined, type: string, utcDateTime?: string | undefined, vendor?: string | undefined, webServices?: Array<string> | undefined, deviceMac?: string | undefined };

export type GQL_DISCOVER_DEVICESQueryVariables = Exact<{
  gatewayID: string;
  driver: DiscoveryType;
  forceRefresh?: boolean;
}>;


export type GQL_DISCOVER_DEVICESQuery = { __typename?: 'query_root', discover: Array<{ __typename?: 'DiscoveredDevice', addresses: any, discoveryDriver: string, firmwareVersion?: string | undefined, hardwareID?: string | undefined, location?: string | undefined, model?: string | undefined, name?: string | undefined, networkInterfaceAddress: string, networkInterfaceName: string, profiles?: Array<string> | undefined, scopes?: Array<string> | undefined, serialNumber?: string | undefined, type: string, utcDateTime?: string | undefined, vendor?: string | undefined, webServices?: Array<string> | undefined, deviceMac?: string | undefined }> };

export type GQL_CHECK_FOR_EXISTING_DEVICESQueryVariables = Exact<{
  gatewayID: string;
  addresses?: Array<string> | string;
  macs?: Array<string> | string;
}>;


export type GQL_CHECK_FOR_EXISTING_DEVICESQuery = { __typename?: 'query_root', devices: Array<{ __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, name: string, description?: string | undefined, make?: string | undefined, model?: string | undefined, serial?: string | undefined, firmware?: string | undefined, deviceMac?: string | undefined, deviceAddress?: string | undefined, port: number, tls: boolean, gatewayID: string, createdAt: any, updatedAt?: any | undefined }> };

export type GQL_GET_GATEWAY_BANDWIDTH_METRICSQueryVariables = Exact<{
  gatewayID: string;
  unitOfTime: string;
}>;


export type GQL_GET_GATEWAY_BANDWIDTH_METRICSQuery = { __typename?: 'query_root', getBandwidthMetrics?: Array<{ __typename?: 'BandwidthMetricResponse', nic: string, unitOfTime: string, received?: Array<{ __typename?: 'Metric', timestamp: string, value: number }> | undefined, transmitted?: Array<{ __typename?: 'Metric', timestamp: string, value: number }> | undefined } | undefined> | undefined };

export type GQL_GET_GATEWAY_BANDWIDTH_SCHEDULESQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_GATEWAY_BANDWIDTH_SCHEDULESQuery = { __typename?: 'query_root', gatewayBandwidthSchedules: Array<{ __typename?: 'qx_GatewayBandwidthSchedule', id: any, active: boolean, limitMbps: number, enabled: boolean, gatewayID: string, schedule: { __typename?: 'qx_Schedule', id: string, name: string, thumbnail?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } }> };

export type GQL_SUB_GATEWAY_BANDWIDTH_SCHEDULESSubscriptionVariables = Exact<{
  id: string;
}>;


export type GQL_SUB_GATEWAY_BANDWIDTH_SCHEDULESSubscription = { __typename?: 'subscription_root', gatewayBandwidthSchedules: Array<{ __typename?: 'qx_GatewayBandwidthSchedule', id: any, active: boolean, limitMbps: number, enabled: boolean, gatewayID: string, schedule: { __typename?: 'qx_Schedule', id: string, name: string, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } }> };

export type GQL_DISC_STORAGE_STATSQueryVariables = Exact<{
  id: string;
}>;


export type GQL_DISC_STORAGE_STATSQuery = { __typename?: 'query_root', gateway?: { __typename?: 'qx_Gateway', id: string, disks?: any | undefined } | undefined };

export type GQL_GET_GATEWAY_FORMQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_GATEWAY_FORMQuery = { __typename?: 'query_root', gateway?: { __typename?: 'qx_Gateway', id: string, name: string, description?: string | undefined, thumbnail?: string | undefined, licenseDetails?: any | undefined, licenseExpiration?: any | undefined, services?: any | undefined, placeID: string, type: eGatewayType_enum } | undefined };

export type GatewayLicenseResourceFragment = { __typename?: 'qx_Gateway', id: string, name: string, syncStatus: qx_eGatewaySyncStatus_enum, serial?: string | undefined, licenseDetails?: any | undefined, type: eGatewayType_enum, devices: Array<{ __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, enabled: boolean }>, doors: Array<{ __typename?: 'qx_Door', id: any, enabled: boolean }> }> };

export type GQL_GET_GATEWAY_LICENSES_AVAILABLEQueryVariables = Exact<{
  path: string;
}>;


export type GQL_GET_GATEWAY_LICENSES_AVAILABLEQuery = { __typename?: 'query_root', gateways: Array<{ __typename?: 'qx_Gateway', id: string, name: string, syncStatus: qx_eGatewaySyncStatus_enum, serial?: string | undefined, licenseDetails?: any | undefined, type: eGatewayType_enum, devices: Array<{ __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, enabled: boolean }>, doors: Array<{ __typename?: 'qx_Door', id: any, enabled: boolean }> }> }> };

export type GQL_GET_NETWORK_INTERFACESQueryVariables = Exact<{
  gatewayID: string;
}>;


export type GQL_GET_NETWORK_INTERFACESQuery = { __typename?: 'query_root', gateway?: { __typename?: 'qx_Gateway', id: string, nics?: any | undefined } | undefined };

export type GQL_GET_GATEWAY_QUEUE_DEPTH_METRICSQueryVariables = Exact<{
  gatewayID: string;
  unitOfTime: string;
}>;


export type GQL_GET_GATEWAY_QUEUE_DEPTH_METRICSQuery = { __typename?: 'query_root', getUploadSegmentMetrics?: { __typename?: 'UploadSegmentMetricResponse', unitOfTime: string, bitsSent?: Array<{ __typename?: 'Metric', timestamp: string, value: number }> | undefined, bitsQueued?: Array<{ __typename?: 'Metric', timestamp: string, value: number }> | undefined, totalBitsQueued?: Array<{ __typename?: 'Metric', timestamp: string, value: number }> | undefined, secondsSent?: Array<{ __typename?: 'Metric', timestamp: string, value: number }> | undefined, secondsQueued?: Array<{ __typename?: 'Metric', timestamp: string, value: number }> | undefined, totalSecondsQueued?: Array<{ __typename?: 'Metric', timestamp: string, value: number }> | undefined } | undefined };

export type GQL_GATEWAY_SEARCHQueryVariables = Exact<{
  where?: qx_Gateway_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Gateway_order_by> | qx_Gateway_order_by;
}>;


export type GQL_GATEWAY_SEARCHQuery = { __typename?: 'query_root', gateways: Array<{ __typename?: 'qx_Gateway', id: string, name: string, thumbnail?: string | undefined, thumbnail_md?: string | undefined, oldestMedia?: any | undefined, syncStatus: qx_eGatewaySyncStatus_enum, licenseDetails?: any | undefined, features: any, hostname?: string | undefined, type: eGatewayType_enum, serial?: string | undefined, version?: string | undefined, wireguardIP?: string | undefined, connectionStatus: boolean, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, devices: Array<{ __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, doors: Array<{ __typename?: 'qx_Door', id: any, enabled: boolean }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, enabled: boolean }> }> }>, gatewayAggregate: { __typename?: 'qx_Gateway_aggregate', aggregate?: { __typename?: 'qx_Gateway_aggregate_fields', count: number } | undefined } };

export type GQL_SUB_GATEWAY_SEARCHSubscriptionVariables = Exact<{
  where?: qx_Gateway_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Gateway_order_by> | qx_Gateway_order_by;
}>;


export type GQL_SUB_GATEWAY_SEARCHSubscription = { __typename?: 'subscription_root', gateways: Array<{ __typename?: 'qx_Gateway', id: string, name: string, thumbnail?: string | undefined, thumbnail_md?: string | undefined, oldestMedia?: any | undefined, syncStatus: qx_eGatewaySyncStatus_enum, licenseDetails?: any | undefined, features: any, hostname?: string | undefined, type: eGatewayType_enum, serial?: string | undefined, version?: string | undefined, wireguardIP?: string | undefined, connectionStatus: boolean, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, devices: Array<{ __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum, doors: Array<{ __typename?: 'qx_Door', id: any, enabled: boolean }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, enabled: boolean }> }> }> };

export type GQL_GET_GATEWAY_SERVICE_ENUMSQueryVariables = Exact<{ [key: string]: never; }>;


export type GQL_GET_GATEWAY_SERVICE_ENUMSQuery = { __typename?: 'query_root', gatewayServiceEnums: Array<{ __typename?: 'qx_eGatewayServiceType', value: string, comment?: string | undefined }> };

export type GQL_STREAM_STORAGE_STATSQueryVariables = Exact<{
  gatewayID: string;
}>;


export type GQL_STREAM_STORAGE_STATSQuery = { __typename?: 'query_root', streamStorageStats: { __typename?: 'StorageDriveStats', available: number, percentageAvailable: number, total: number, path: string } };

export type GQL_GET_GATEWAY_NODE_METRICSQueryVariables = Exact<{
  gatewayID: string;
}>;


export type GQL_GET_GATEWAY_NODE_METRICSQuery = { __typename?: 'query_root', getGatewayNodeMetrics: Array<{ __typename?: 'NodeMetrics', cpu?: { __typename?: 'CpuStat', time?: any | undefined, total?: any | undefined, used?: any | undefined } | undefined, memory?: { __typename?: 'MemoryStat', time?: any | undefined, total?: any | undefined, used?: any | undefined } | undefined } | undefined> };

export type GQL_GET_GATEWAY_SERVICE_METRICSQueryVariables = Exact<{
  gatewayID: string;
}>;


export type GQL_GET_GATEWAY_SERVICE_METRICSQuery = { __typename?: 'query_root', getGatewayServiceMetrics: Array<{ __typename?: 'PodMetrics', name: string, cpu?: { __typename?: 'CpuStat', time?: any | undefined, total?: any | undefined, used?: any | undefined } | undefined, memory?: { __typename?: 'MemoryStat', time?: any | undefined, total?: any | undefined, used?: any | undefined } | undefined } | undefined> };

export type GQL_UPLOAD_STATSQueryVariables = Exact<{
  gatewayID: string;
}>;


export type GQL_UPLOAD_STATSQuery = { __typename?: 'query_root', gateway?: { __typename?: 'qx_Gateway', id: string, name: string, uploadDepth?: number | undefined } | undefined };

export type GQL_SUB_UPLOAD_STATSSubscriptionVariables = Exact<{
  gatewayID: string;
}>;


export type GQL_SUB_UPLOAD_STATSSubscription = { __typename?: 'subscription_root', gateway?: { __typename?: 'qx_Gateway', id: string, name: string, uploadDepth?: number | undefined } | undefined };

export type UseGatewayFragment = { __typename?: 'qx_Gateway', id: string, name: string, description?: string | undefined, thumbnail?: string | undefined, hostname?: string | undefined, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, wireguardIP?: string | undefined, features: any, syncError?: string | undefined, licenseDetails?: any | undefined, licenseExpiration?: any | undefined, uploadDepth?: number | undefined, oldestMedia?: any | undefined, type: eGatewayType_enum, serial?: string | undefined, model?: string | undefined, version?: string | undefined, firmware?: string | undefined, services?: any | undefined, place: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined, homePlace?: { __typename?: 'qx_Place', id: string, path: string } | undefined, customerPlace?: { __typename?: 'qx_Place', id: string, path: string } | undefined } | undefined }, devices: Array<{ __typename?: 'qx_Device', id: string, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string, enabled: boolean }> }> };

export type GQL_GET_GATEWAY_BY_IDQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_GATEWAY_BY_IDQuery = { __typename?: 'query_root', gateway?: { __typename?: 'qx_Gateway', id: string, name: string, description?: string | undefined, thumbnail?: string | undefined, hostname?: string | undefined, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, wireguardIP?: string | undefined, features: any, syncError?: string | undefined, licenseDetails?: any | undefined, licenseExpiration?: any | undefined, uploadDepth?: number | undefined, oldestMedia?: any | undefined, type: eGatewayType_enum, serial?: string | undefined, model?: string | undefined, version?: string | undefined, firmware?: string | undefined, services?: any | undefined, place: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined, homePlace?: { __typename?: 'qx_Place', id: string, path: string } | undefined, customerPlace?: { __typename?: 'qx_Place', id: string, path: string } | undefined } | undefined }, devices: Array<{ __typename?: 'qx_Device', id: string, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string, enabled: boolean }> }> } | undefined };

export type GQL_SUB_GATEWAY_BY_IDSubscriptionVariables = Exact<{
  id: string;
}>;


export type GQL_SUB_GATEWAY_BY_IDSubscription = { __typename?: 'subscription_root', gateway?: { __typename?: 'qx_Gateway', id: string, name: string, description?: string | undefined, thumbnail?: string | undefined, hostname?: string | undefined, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, wireguardIP?: string | undefined, features: any, syncError?: string | undefined, licenseDetails?: any | undefined, licenseExpiration?: any | undefined, uploadDepth?: number | undefined, oldestMedia?: any | undefined, type: eGatewayType_enum, serial?: string | undefined, model?: string | undefined, version?: string | undefined, firmware?: string | undefined, services?: any | undefined, place: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined, homePlace?: { __typename?: 'qx_Place', id: string, path: string } | undefined, customerPlace?: { __typename?: 'qx_Place', id: string, path: string } | undefined } | undefined }, devices: Array<{ __typename?: 'qx_Device', id: string, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string, enabled: boolean }> }> } | undefined };

export type GQL_CONFIRM_GATEWAY_DELETEQueryVariables = Exact<{
  gatewayID: string;
}>;


export type GQL_CONFIRM_GATEWAY_DELETEQuery = { __typename?: 'query_root', gateway?: { __typename?: 'qx_Gateway', id: string, connectionStatus: boolean, type: eGatewayType_enum, name: string, devices_aggregate: { __typename?: 'qx_Device_aggregate', aggregate?: { __typename?: 'qx_Device_aggregate_fields', count: number } | undefined } } | undefined };

export type GQL_GET_GATEWAY_NAME_FOR_DELETE_MESSAGEQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_GATEWAY_NAME_FOR_DELETE_MESSAGEQuery = { __typename?: 'query_root', gateway?: { __typename?: 'qx_Gateway', id: string, name: string } | undefined };

export type GQL_GATEWAY_DEVICES_TO_DELETEQueryVariables = Exact<{
  gatewayID: string;
}>;


export type GQL_GATEWAY_DEVICES_TO_DELETEQuery = { __typename?: 'query_root', gateway?: { __typename?: 'qx_Gateway', id: string, connectionStatus: boolean, type: eGatewayType_enum, name: string, devices: Array<{ __typename?: 'qx_Device', id: string, kind: qx_eDeviceKind_enum }> } | undefined };

export type deleteGatewayMutationVariables = Exact<{
  id: string;
}>;


export type deleteGatewayMutation = { __typename?: 'mutation_root', deleteGateway?: { __typename?: 'SuccessOutput', success: boolean } | undefined };

export type GQL_GET_GATEWAY_CONFIG_BY_IDQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_GATEWAY_CONFIG_BY_IDQuery = { __typename?: 'query_root', gateway?: { __typename?: 'qx_Gateway', id: string, name: string, serial?: string | undefined, hostname?: string | undefined, model?: string | undefined, lanIP?: string | undefined } | undefined, Door_Controllers: Array<{ __typename?: 'qx_Device', id: string, name: string, description?: string | undefined, make?: string | undefined, model?: string | undefined, serial?: string | undefined, pacsConfigurationID?: string | undefined, meta?: any | undefined, IP_Address?: string | undefined }>, doors: Array<{ __typename?: 'qx_Door', id: any, name: string, description?: string | undefined, createdAt: any, enabled: boolean, type?: string | undefined, refID: string, extendedAccessTime?: string | undefined, extendedOpenTime?: string | undefined, openTime?: string | undefined, mode: qx_eDoorMode_enum, lockdownImmunity?: boolean | undefined, lockAddress?: string | undefined, device: { __typename?: 'qx_Device', id: string, name: string, IP_Address?: string | undefined }, goes_to: { __typename?: 'qx_Place', id: string, name: string }, goes_from?: { __typename?: 'qx_Place', id: string, name: string } | undefined, unlockSchedule?: { __typename?: 'qx_Schedule', id: string, name: string } | undefined, Locks: Array<{ __typename?: 'qx_Lock', id: string, name: string, enabled: boolean, type: qx_eLockType_enum, relayMonitor?: qx_eLockRelayMonitor_enum | undefined, refID: string, powerMonitor?: qx_eLockPowerMonitor_enum | undefined, mode?: qx_eLockMode_enum | undefined }>, Readers: Array<{ __typename?: 'qx_Reader', id: string, name: string, protocol: qx_eReaderProtocol_enum, refID: string, rexBypass: boolean, rexState: qx_eRexState_enum, supervise?: string | undefined, type: qx_eAccessPointType_enum, wiegandFormats?: any | undefined, enabled: boolean, direction: qx_eAccessPointDirection_enum, baudrateID?: qx_eBaudrate_enum | undefined, address: number, accessType: qx_eReaderAccessType_enum, action: qx_eAccessPointAction_enum }>, Associated_Camera?: { __typename?: 'qx_VideoSource', id: any, name: string } | undefined }>, cameras: Array<{ __typename?: 'qx_VideoSource', id: any, name: string, description?: string | undefined, createdAt: any, enabled: boolean, device: { __typename?: 'qx_Device', id: string, make?: string | undefined, model?: string | undefined, IP_Address?: string | undefined }, Continuous_Record_Schedule?: { __typename?: 'qx_Schedule', id: string, name: string } | undefined }>, sensors: Array<{ __typename?: 'qx_Sensor', id: any, name: string, description?: string | undefined, createdAt?: any | undefined, enabled: boolean, type: qx_eSensorType_enum, device: { __typename?: 'qx_Device', id: string, make?: string | undefined, model?: string | undefined, IP_Address?: string | undefined } }>, DIOs_by_Device: Array<{ __typename?: 'qx_Device', id: string, name: string, description?: string | undefined, make?: string | undefined, model?: string | undefined, deviceAddress?: string | undefined, DeviceDIOs: Array<{ __typename?: 'qx_DeviceDIO', id: string, name: string, refID: string, type?: qx_eDIOType_enum | undefined }> }> };

export type GQL_GET_GATEWAY_COCKPIT_URLQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_GATEWAY_COCKPIT_URLQuery = { __typename?: 'query_root', gateway?: { __typename?: 'qx_Gateway', id: string, cockpitUrl?: string | undefined } | undefined };

export type GQL_REFRESH_GATEWAY_DEVICES_CONNECTION_STATUSESMutationVariables = Exact<{
  id: string;
}>;


export type GQL_REFRESH_GATEWAY_DEVICES_CONNECTION_STATUSESMutation = { __typename?: 'mutation_root', refreshDeviceConnectionStatuses?: { __typename?: 'SuccessOutput', success: boolean } | undefined };

export type GQL_SYNC_GATEWAYMutationVariables = Exact<{
  id: string;
}>;


export type GQL_SYNC_GATEWAYMutation = { __typename?: 'mutation_root', sync: { __typename?: 'SuccessResponse', success: boolean } };

export type GQL_UPDATE_GATEWAY_FEATURES_BY_IDMutationVariables = Exact<{
  gatewayID: string;
  features: any;
}>;


export type GQL_UPDATE_GATEWAY_FEATURES_BY_IDMutation = { __typename?: 'mutation_root', updateGatewayFeatures?: { __typename?: 'SuccessOutput', success: boolean } | undefined };

export type GQL_UPDATE_GATEWAY_LICENSEMutationVariables = Exact<{
  id: string;
  licenseJWT: string;
}>;


export type GQL_UPDATE_GATEWAY_LICENSEMutation = { __typename?: 'mutation_root', updateGatewayLicense: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_UPDATE_GATEWAY_BY_IDMutationVariables = Exact<{
  id: string;
  data?: qx_Gateway_set_input;
}>;


export type GQL_UPDATE_GATEWAY_BY_IDMutation = { __typename?: 'mutation_root', updateGateway?: { __typename?: 'qx_Gateway', id: string, name: string } | undefined };

export type GQL_CHECK_FOR_UNIQUE_BANDWIDTH_SCHEDULEQueryVariables = Exact<{
  gatewayID: string;
  bandwidthScheduleID: string;
  scheduleID: string;
}>;


export type GQL_CHECK_FOR_UNIQUE_BANDWIDTH_SCHEDULEQuery = { __typename?: 'query_root', gatewayBandwidthSchedules: Array<{ __typename?: 'qx_GatewayBandwidthSchedule', id: any }> };

export type GQL_CHECK_FOR_UNIQUE_BANDWIDTH_SCHEDULE_NO_IDQueryVariables = Exact<{
  gatewayID: string;
  scheduleID: string;
}>;


export type GQL_CHECK_FOR_UNIQUE_BANDWIDTH_SCHEDULE_NO_IDQuery = { __typename?: 'query_root', gatewayBandwidthSchedules: Array<{ __typename?: 'qx_GatewayBandwidthSchedule', id: any }> };

export type GQL_VALIDATE_GATEWAY_PLACE_TYPEQueryVariables = Exact<{
  placeID: string;
}>;


export type GQL_VALIDATE_GATEWAY_PLACE_TYPEQuery = { __typename?: 'query_root', place?: { __typename?: 'qx_Place', id: string, type: qx_ePlaceType_enum } | undefined };

export type GQL_GET_GROUP_FORMQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_GROUP_FORMQuery = { __typename?: 'query_root', group?: { __typename?: 'qx_Group', id: string, name: string, placeID: string, thumbnail?: string | undefined, externalGroupID?: string | undefined } | undefined };

export type GQL_CREATE_HOLIDAY_SETtMutationVariables = Exact<{
  data: qx_HolidaySet_insert_input;
}>;


export type GQL_CREATE_HOLIDAY_SETtMutation = { __typename?: 'mutation_root', createHolidaySets?: { __typename?: 'qx_HolidaySet_mutation_response', returning: Array<{ __typename?: 'qx_HolidaySet', id: string, name: string, description?: string | undefined, placeID: string, dates?: any | undefined, place: { __typename?: 'qx_Place', id: string, type: qx_ePlaceType_enum, name: string } }> } | undefined };

export type GQL_DELETE_HOLIDAY_SETMutationVariables = Exact<{
  id: string;
}>;


export type GQL_DELETE_HOLIDAY_SETMutation = { __typename?: 'mutation_root', deleteScheduleBlocks?: { __typename?: 'qx_ScheduleBlock_mutation_response', returning: Array<{ __typename?: 'qx_ScheduleBlock', id: string }> } | undefined, deleteHolidaySets?: { __typename?: 'qx_HolidaySet_mutation_response', returning: Array<{ __typename?: 'qx_HolidaySet', id: string }> } | undefined };

export type GQL_LAYOUT_SEARCHQueryVariables = Exact<{
  where?: qx_Layout_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Layout_order_by> | qx_Layout_order_by;
}>;


export type GQL_LAYOUT_SEARCHQuery = { __typename?: 'query_root', layouts: Array<{ __typename?: 'qx_Layout', id: string, settings: any, name: string, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }>, layoutsAggregate: { __typename?: 'qx_Layout_aggregate', aggregate?: { __typename?: 'qx_Layout_aggregate_fields', count: number } | undefined } };

export type GQL_CREATE_LOCKSMutationVariables = Exact<{
  locks: Array<qx_Lock_insert_input> | qx_Lock_insert_input;
}>;


export type GQL_CREATE_LOCKSMutation = { __typename?: 'mutation_root', createLocks?: { __typename?: 'qx_Lock_mutation_response', returning: Array<{ __typename?: 'qx_Lock', id: string }> } | undefined };

export type GQL_DELETE_LOCKS_BY_IDMutationVariables = Exact<{
  ids: Array<string> | string;
}>;


export type GQL_DELETE_LOCKS_BY_IDMutation = { __typename?: 'mutation_root', deleteLocks?: { __typename?: 'qx_Lock_mutation_response', affected_rows: number } | undefined };

export type GQL_UPDATE_LOCK_BY_IDMutationVariables = Exact<{
  id: string;
  lock: qx_Lock_set_input;
}>;


export type GQL_UPDATE_LOCK_BY_IDMutation = { __typename?: 'mutation_root', updateLock?: { __typename?: 'qx_Lock', id: string } | undefined };

export type GQL_LOCK_SEARCHQueryVariables = Exact<{
  where?: qx_Lock_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Lock_order_by> | qx_Lock_order_by;
}>;


export type GQL_LOCK_SEARCHQuery = { __typename?: 'query_root', locks: Array<{ __typename?: 'qx_Lock', id: string, name: string, type: qx_eLockType_enum, refID: string, direction: qx_eAccessPointDirection_enum, relayMonitor?: qx_eLockRelayMonitor_enum | undefined, powerMonitor?: qx_eLockPowerMonitor_enum | undefined, delay?: string | undefined, enabled: boolean, doorID?: any | undefined, deviceID: string, updatedAt?: any | undefined, inventoryID?: string | undefined }>, lockAggregate: { __typename?: 'qx_Lock_aggregate', aggregate?: { __typename?: 'qx_Lock_aggregate_fields', count: number } | undefined } };

export type GQL_SUB_MAP_RESOURCE_DOORSSubscriptionVariables = Exact<{
  doorIDs: Array<string> | string;
}>;


export type GQL_SUB_MAP_RESOURCE_DOORSSubscription = { __typename?: 'subscription_root', doors: Array<{ __typename?: 'qx_Door', id: any, name: string, enabled: boolean, state: qx_eDoorState_enum, alarm: qx_eDoorAlarm_enum, mode: qx_eDoorMode_enum, deviceID: string, devicePacsStatus?: string | undefined, devicePacsHWUpdate?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined }> };

export type GQL_SUB_MAP_RESOURCE_CAMERASSubscriptionVariables = Exact<{
  videoSourceIDs: Array<string> | string;
}>;


export type GQL_SUB_MAP_RESOURCE_CAMERASSubscription = { __typename?: 'subscription_root', videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string, enabled: boolean, mountPosition?: qx_eMountPosition_enum | undefined, deviceID: string, gatewayID?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined }> };

export type GQL_SUB_MAP_RESOURCE_SENSORSSubscriptionVariables = Exact<{
  sensorIDs: Array<string> | string;
}>;


export type GQL_SUB_MAP_RESOURCE_SENSORSSubscription = { __typename?: 'subscription_root', sensors: Array<{ __typename?: 'qx_Sensor', id: any, name: string, enabled: boolean, type: qx_eSensorType_enum, state: qx_eDIOState_enum, disabledByLicense: boolean, batteryLevel: qx_eBatteryLevel_enum, deviceConnectionStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined }> };

export type GQL_SUB_MAP_RESOURCE_GATEWAYSSubscriptionVariables = Exact<{
  gatewayIDs: Array<string> | string;
}>;


export type GQL_SUB_MAP_RESOURCE_GATEWAYSSubscription = { __typename?: 'subscription_root', gateways: Array<{ __typename?: 'qx_Gateway', id: string, name: string, syncStatus: qx_eGatewaySyncStatus_enum, connectionStatus: boolean }> };

export type GQL_SUB_MAP_RESOURCE_DIOSSubscriptionVariables = Exact<{
  dioIDs: Array<string> | string;
}>;


export type GQL_SUB_MAP_RESOURCE_DIOSSubscription = { __typename?: 'subscription_root', DeviceDIOs: Array<{ __typename?: 'qx_DeviceDIO', id: string, name: string, defaultState?: qx_eDIONormalState_enum | undefined, state?: qx_eDIOState_enum | undefined, type?: qx_eDIOType_enum | undefined, enabled: boolean }> };

export type GQL_GROUP_PATH_BY_GROUP_IDQueryVariables = Exact<{
  groupID: string;
}>;


export type GQL_GROUP_PATH_BY_GROUP_IDQuery = { __typename?: 'query_root', groups: Array<{ __typename?: 'qx_Group', id: string, place: { __typename?: 'qx_Place', id: string, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', homePlace?: { __typename?: 'qx_Place', id: string, type: qx_ePlaceType_enum, path: string } | undefined } | undefined } }> };

export type GQL_SCHEDULE_PATH_BY_SCHEDULE_IDQueryVariables = Exact<{
  scheduleID: string;
}>;


export type GQL_SCHEDULE_PATH_BY_SCHEDULE_IDQuery = { __typename?: 'query_root', schedules: Array<{ __typename?: 'qx_Schedule', id: string, place: { __typename?: 'qx_Place', id: string, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', integratorPlaceID?: string | undefined, customerPlaceID?: string | undefined, homePlace?: { __typename?: 'qx_Place', id: string, type: qx_ePlaceType_enum, path: string } | undefined } | undefined } }> };

export type GQL_GET_PERSON_FORMQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_PERSON_FORMQuery = { __typename?: 'query_root', person?: { __typename?: 'qx_Person', id: string, externalPersonID?: string | undefined, roleExternalSync: boolean, createdAt: any, updatedAt?: any | undefined, roleID?: string | undefined, email?: string | undefined, employeeID?: string | undefined, title?: string | undefined, suffix?: string | undefined, firstName?: string | undefined, lastName?: string | undefined, lockdownImmunity?: boolean | undefined, placeID: string, salutation?: string | undefined, department?: string | undefined, phoneNumbers?: any | undefined, licensePlate?: string | undefined, certification?: string | undefined, role?: { __typename?: 'qx_Role', id: string, name: string } | undefined, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, addresses?: any | undefined, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined } | undefined }, credentials: Array<{ __typename?: 'qx_Credential', id: string, pin?: string | undefined, value: string, validFrom?: any | undefined, validTo?: any | undefined, enabled: boolean, extendedTimeEnabled: boolean, externalSync: boolean, status?: string | undefined, type: qx_eCredentialType_enum, reason?: string | undefined }> } | undefined };

export type GQL_CREATE_PERSONMutationVariables = Exact<{
  person: qx_Person_insert_input;
}>;


export type GQL_CREATE_PERSONMutation = { __typename?: 'mutation_root', createPeople?: { __typename?: 'qx_Person_mutation_response', returning: Array<{ __typename?: 'qx_Person', id: string, externalPersonID?: string | undefined, createdAt: any, updatedAt?: any | undefined, roleID?: string | undefined, email?: string | undefined, employeeID?: string | undefined, title?: string | undefined, suffix?: string | undefined, firstName?: string | undefined, lastName?: string | undefined, salutation?: string | undefined, avatar_md?: string | undefined, department?: string | undefined, role?: { __typename?: 'qx_Role', id: string, name: string } | undefined, toGroups: Array<{ __typename?: 'qx__PersonToGroup', group: { __typename?: 'qx_Group', id: string, name: string } }>, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, addresses?: any | undefined }, credentials: Array<{ __typename?: 'qx_Credential', id: string, pin?: string | undefined, value: string, validFrom?: any | undefined, validTo?: any | undefined, enabled: boolean, extendedTimeEnabled: boolean, externalSync: boolean }> }> } | undefined };

export type GQL_CREATE_PEOPLEMutationVariables = Exact<{
  people: Array<qx_Person_insert_input> | qx_Person_insert_input;
}>;


export type GQL_CREATE_PEOPLEMutation = { __typename?: 'mutation_root', createPeople?: { __typename?: 'qx_Person_mutation_response', affected_rows: number } | undefined };

export type GQL_DELETE_PERSON_BY_IDMutationVariables = Exact<{
  id: string;
}>;


export type GQL_DELETE_PERSON_BY_IDMutation = { __typename?: 'mutation_root', deleteCredentials?: { __typename?: 'qx_Credential_mutation_response', affected_rows: number } | undefined, deletePeople?: { __typename?: 'qx_Person_mutation_response', affected_rows: number } | undefined };

export type GQL_DISABLE_PERSONMutationVariables = Exact<{
  personID: string;
}>;


export type GQL_DISABLE_PERSONMutation = { __typename?: 'mutation_root', updateCredentials?: { __typename?: 'qx_Credential_mutation_response', affected_rows: number } | undefined, updatePeople?: { __typename?: 'qx_Person_mutation_response', affected_rows: number } | undefined };

export type GQL_UPDATE_PERSON_BY_IDMutationVariables = Exact<{
  id: string;
  person: qx_Person_set_input;
  role?: string;
  groupsToRemove: Array<string> | string;
  groupsToAdd: Array<qx__PersonToGroup_insert_input> | qx__PersonToGroup_insert_input;
}>;


export type GQL_UPDATE_PERSON_BY_IDMutation = { __typename?: 'mutation_root', updatePeople?: { __typename?: 'qx_Person_mutation_response', returning: Array<{ __typename?: 'qx_Person', id: string, externalPersonID?: string | undefined, createdAt: any, updatedAt?: any | undefined, roleID?: string | undefined, email?: string | undefined, employeeID?: string | undefined, title?: string | undefined, suffix?: string | undefined, firstName?: string | undefined, lastName?: string | undefined, salutation?: string | undefined, avatar_md?: string | undefined, department?: string | undefined, role?: { __typename?: 'qx_Role', id: string, name: string } | undefined, toGroups: Array<{ __typename?: 'qx__PersonToGroup', group: { __typename?: 'qx_Group', id: string, name: string } }>, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, addresses?: any | undefined }, credentials: Array<{ __typename?: 'qx_Credential', id: string, pin?: string | undefined, value: string, validFrom?: any | undefined, validTo?: any | undefined, enabled: boolean, extendedTimeEnabled: boolean, externalSync: boolean }> }> } | undefined, deletePersonGroups?: { __typename?: 'qx__PersonToGroup_mutation_response', affected_rows: number } | undefined, createPersonGroups?: { __typename?: 'qx__PersonToGroup_mutation_response', returning: Array<{ __typename?: 'qx__PersonToGroup', personID: string, person: { __typename?: 'qx_Person', id: string, toGroups: Array<{ __typename?: 'qx__PersonToGroup', group: { __typename?: 'qx_Group', id: string, name: string } }> } }> } | undefined };

export type GQL_UPDATE_PROFILEMutationVariables = Exact<{
  id: string;
  form: qx_Person_set_input;
}>;


export type GQL_UPDATE_PROFILEMutation = { __typename?: 'mutation_root', updatePerson?: { __typename?: 'qx_Person', id: string, firstName?: string | undefined, lastName?: string | undefined, avatar?: string | undefined } | undefined };

export type GQL_CHECK_FOR_UNIQUE_EMAIL_BY_SCOPEQueryVariables = Exact<{
  where: qx_Person_bool_exp;
}>;


export type GQL_CHECK_FOR_UNIQUE_EMAIL_BY_SCOPEQuery = { __typename?: 'query_root', people: Array<{ __typename?: 'qx_Person', id: string }> };

export type GQL_ROLE_PATH_BY_ROLE_IDQueryVariables = Exact<{
  roleID: string;
}>;


export type GQL_ROLE_PATH_BY_ROLE_IDQuery = { __typename?: 'query_root', roles: Array<{ __typename?: 'qx_Role', id: string, place: { __typename?: 'qx_Place', id: string, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', integratorPlaceID?: string | undefined, customerPlaceID?: string | undefined, homePlace?: { __typename?: 'qx_Place', id: string, type: qx_ePlaceType_enum, path: string } | undefined } | undefined } }> };

export type GQL_GET_PERSON_PLACE_ID_CUSTOMERQueryVariables = Exact<{
  personID: string;
  placeID: string;
}>;


export type GQL_GET_PERSON_PLACE_ID_CUSTOMERQuery = { __typename?: 'query_root', person?: { __typename?: 'qx_Person', id: string, place: { __typename?: 'qx_Place', id: string, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', integratorPlaceID?: string | undefined, customerPlaceID?: string | undefined } | undefined } } | undefined, place?: { __typename?: 'qx_Place', id: string, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', integratorPlaceID?: string | undefined, customerPlaceID?: string | undefined } | undefined } | undefined };

export type GQL_GET_PLACE_LOCKDOWN_STATUSQueryVariables = Exact<{
  placeID: string;
}>;


export type GQL_GET_PLACE_LOCKDOWN_STATUSQuery = { __typename?: 'query_root', place?: { __typename?: 'qx_Place', id: string, name: string, isLockedDown: boolean } | undefined };

export type GQL_GET_PLACE_SERVICESQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_PLACE_SERVICESQuery = { __typename?: 'query_root', place?: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, authProvider?: { __typename?: 'qx_CustomerAuthProvider', id: any, customerPlaceID: string, provider: qx_eAuthProvider_enum, sso: boolean, sync: boolean, syncedByPersonID?: string | undefined, lastSynced?: any | undefined, error?: string | undefined, config?: any | undefined, syncedSetupBy?: { __typename?: 'qx_Person', avatar_md?: string | undefined, id: string, firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined } | undefined } | undefined } | undefined };

export type GQL_SETUP_SSOMutationVariables = Exact<{
  id: string;
}>;


export type GQL_SETUP_SSOMutation = { __typename?: 'mutation_root', setupSSO: { __typename?: 'SuccessResponse', success: boolean } };

export type GQL_MANUAL_SYNC_SSOMutationVariables = Exact<{
  id: string;
}>;


export type GQL_MANUAL_SYNC_SSOMutation = { __typename?: 'mutation_root', syncPeopleFromAuthProvider: { __typename?: 'SuccessResponse', success: boolean } };

export type GQL_REMOVE_SSOMutationVariables = Exact<{
  id: string;
}>;


export type GQL_REMOVE_SSOMutation = { __typename?: 'mutation_root', removeSSO: { __typename?: 'SuccessResponse', success: boolean } };

export type PlaceTreeFragment = { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, path: string, isLockedDown: boolean, parentPlaceID?: string | undefined, timezone?: string | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } | undefined };

export type GQL_GET_PLACES_AT_IDSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GQL_GET_PLACES_AT_IDSubscription = { __typename?: 'subscription_root', places: Array<{ __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, path: string, isLockedDown: boolean, parentPlaceID?: string | undefined, timezone?: string | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } | undefined }> };

export type GQL_AI_BILLING_PANEL_PLACEQueryVariables = Exact<{
  id: string;
}>;


export type GQL_AI_BILLING_PANEL_PLACEQuery = { __typename?: 'query_root', place?: { __typename?: 'qx_Place', id: string, type: qx_ePlaceType_enum, canSelfServe?: boolean | undefined, aiBillingTier: string, pendingBillingTier?: string | undefined, pendingBillingTierStartsAt?: any | undefined } | undefined };

export type GQL_PLACE_SELECT_TREEQueryVariables = Exact<{ [key: string]: never; }>;


export type GQL_PLACE_SELECT_TREEQuery = { __typename?: 'query_root', places: Array<{ __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, path: string, isLockedDown: boolean, parentPlaceID?: string | undefined, timezone?: string | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } | undefined }> };

export type GQL_GET_PLACE_FORMQueryVariables = Exact<{
  placeID: string;
}>;


export type GQL_GET_PLACE_FORMQuery = { __typename?: 'query_root', place?: { __typename?: 'qx_Place', id: string, qxCustomerID?: string | undefined, accountNumber?: string | undefined, name: string, type: qx_ePlaceType_enum, path: string, canSelfServe?: boolean | undefined, requireTwoFactor: boolean, timezone?: string | undefined, isLockedDown: boolean, parentPlaceID?: string | undefined, addresses?: any | undefined, aiBillingTier: string, aiOverageBudgetCents?: number | undefined, anniversaryDate?: any | undefined, billingStartDate?: any | undefined, billingPeriodMonths?: number | undefined, authProvider?: { __typename?: 'qx_CustomerAuthProvider', id: any, customerPlaceID: string, provider: qx_eAuthProvider_enum, sso: boolean, sync: boolean, syncedByPersonID?: string | undefined, lastSynced?: any | undefined, error?: string | undefined, config?: any | undefined, syncedSetupBy?: { __typename?: 'qx_Person', avatar_md?: string | undefined, id: string, firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined } | undefined } | undefined, defaultView?: { __typename?: 'qx_View', id: string, name: string } | undefined, parentPlace?: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, path: string, timezone?: string | undefined, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string } } | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined, customerPlace?: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, accountNumber?: string | undefined, anniversaryDate?: any | undefined, billingPeriodMonths?: number | undefined, canSelfServe?: boolean | undefined } | undefined, homePlace?: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, path: string, accountNumber?: string | undefined, anniversaryDate?: any | undefined, billingPeriodMonths?: number | undefined, canSelfServe?: boolean | undefined } | undefined } | undefined, children: Array<{ __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, path: string, addresses?: any | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } | undefined, parentPlace?: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum } | undefined, children: Array<{ __typename?: 'qx_Place', id: string, path: string, addresses?: any | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } | undefined }> }>, whitelists: Array<{ __typename?: 'placeWhiteLists', id: any, ip: any, alias: string, placeID: string }> } | undefined, customerPermissions: Array<{ __typename?: 'qx_CustomerPermission', customerPlaceID: string, canEnableServices?: boolean | undefined, allowIntegratorVideoOperations: boolean, allowIntegratorAccessOperations?: boolean | undefined, allowIntegratorConfig: boolean, allowQxSupport: boolean }>, placeWhiteLists: Array<{ __typename?: 'placeWhiteLists', id: any, ip: any, alias: string, placeID: string }> };

export type GQL_CREATE_PLACEMutationVariables = Exact<{
  place: qx_Place_insert_input;
}>;


export type GQL_CREATE_PLACEMutation = { __typename?: 'mutation_root', createPlaces?: { __typename?: 'qx_Place_mutation_response', returning: Array<{ __typename?: 'qx_Place', id: string, name: string, parentPlace?: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum } | undefined }> } | undefined };

export type GQL_DELETE_PLACE_BY_IDMutationVariables = Exact<{
  id: string;
}>;


export type GQL_DELETE_PLACE_BY_IDMutation = { __typename?: 'mutation_root', deletePlace?: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum } | undefined };

export type GQL_GET_TIMEZONE_FROM_PLACEQueryVariables = Exact<{
  placeID: string;
}>;


export type GQL_GET_TIMEZONE_FROM_PLACEQuery = { __typename?: 'query_root', place?: { __typename?: 'qx_Place', id: string, path: string, timezone?: string | undefined } | undefined };

export type GQL_GET_TIMEZONE_FROM_PARENT_PLACESQueryVariables = Exact<{
  ids: Array<string> | string;
}>;


export type GQL_GET_TIMEZONE_FROM_PARENT_PLACESQuery = { __typename?: 'query_root', places: Array<{ __typename?: 'qx_Place', id: string, timezone?: string | undefined }> };

export type GQL_MOVE_PLACEMutationVariables = Exact<{
  placeID: string;
  targetParentPlaceID: string;
}>;


export type GQL_MOVE_PLACEMutation = { __typename?: 'mutation_root', movePlace?: { __typename?: 'SuccessOutput', success: boolean } | undefined };

export type GQL_LOCKDOWN_PLACEMutationVariables = Exact<{
  placeID: string;
}>;


export type GQL_LOCKDOWN_PLACEMutation = { __typename?: 'mutation_root', lockDownPlace: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_LOCKDOWN_RELEASE_PLACEMutationVariables = Exact<{
  placeID: string;
}>;


export type GQL_LOCKDOWN_RELEASE_PLACEMutation = { __typename?: 'mutation_root', lockDownReleasePlace: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_INSERT_PLACE_WHITE_LIST_ONEMutationVariables = Exact<{
  object: placeWhiteLists_insert_input;
}>;


export type GQL_INSERT_PLACE_WHITE_LIST_ONEMutation = { __typename?: 'mutation_root', insert_placeWhiteLists_one?: { __typename?: 'placeWhiteLists', id: any, ip: any, alias: string, placeID: string } | undefined };

export type GQL_UPDATE_PLACE_WHITE_LIST_BY_PKMutationVariables = Exact<{
  id: string;
  set: placeWhiteLists_set_input;
}>;


export type GQL_UPDATE_PLACE_WHITE_LIST_BY_PKMutation = { __typename?: 'mutation_root', update_placeWhiteLists_by_pk?: { __typename?: 'placeWhiteLists', id: any, ip: any, alias: string, placeID: string } | undefined };

export type GQL_DELETE_PLACE_WHITE_LIST_BY_PKMutationVariables = Exact<{
  id: string;
}>;


export type GQL_DELETE_PLACE_WHITE_LIST_BY_PKMutation = { __typename?: 'mutation_root', delete_placeWhiteLists_by_pk?: { __typename?: 'placeWhiteLists', id: any } | undefined };

export type GQL_UPDATE_CUSTOMER_PERMISSIONMutationVariables = Exact<{ [key: string]: never; }>;


export type GQL_UPDATE_CUSTOMER_PERMISSIONMutation = { __typename?: 'mutation_root', updateCustomerPlacePrivileges: any };

export type GQL_ENABLE_CUSTOMER_SELF_SERVEMutationVariables = Exact<{
  customerPlaceID: string;
  canEnableServices: boolean;
}>;


export type GQL_ENABLE_CUSTOMER_SELF_SERVEMutation = { __typename?: 'mutation_root', updateCustomerCanSelfServe: any };

export type GQL_GET_PLACE_TYPE_BY_ID_INQueryVariables = Exact<{
  ids?: Array<string> | string;
}>;


export type GQL_GET_PLACE_TYPE_BY_ID_INQuery = { __typename?: 'query_root', places: Array<{ __typename?: 'qx_Place', id: string, path: string, name: string, type: qx_ePlaceType_enum, parentPlace?: { __typename?: 'qx_Place', id: string, name: string, path: string, type: qx_ePlaceType_enum } | undefined }> };

export type GQL_READER_SEARCHQueryVariables = Exact<{
  where?: qx_Reader_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Reader_order_by> | qx_Reader_order_by;
}>;


export type GQL_READER_SEARCHQuery = { __typename?: 'query_root', readers: Array<{ __typename?: 'qx_Reader', accessType: qx_eReaderAccessType_enum, action: qx_eAccessPointAction_enum, address: number, baudrateID?: qx_eBaudrate_enum | undefined, deviceID: string, direction: qx_eAccessPointDirection_enum, doorID?: any | undefined, enabled: boolean, id: string, inventoryID?: string | undefined, keypadModeID?: qx_eKeypadMode_enum | undefined, name: string, protocol: qx_eReaderProtocol_enum, refID: string, rexBypass: boolean, rexState: qx_eRexState_enum, supervise?: string | undefined, type: qx_eAccessPointType_enum, updatedAt?: any | undefined, door?: { __typename?: 'qx_Door', id: any, name: string, placeID: string } | undefined, device?: { __typename?: 'qx_Device', id: string, name: string, gatewayID: string } | undefined, accessInventory?: { __typename?: 'qx_AccessInventory', id: string } | undefined }>, readerAggregate: { __typename?: 'qx_Reader_aggregate', aggregate?: { __typename?: 'qx_Reader_aggregate_fields', count: number } | undefined } };

export type readersQueryVariables = Exact<{
  doorId: string;
}>;


export type readersQuery = { __typename?: 'query_root', readers: Array<{ __typename?: 'qx_Reader', id: string, name: string, direction: qx_eAccessPointDirection_enum, enabled: boolean, type: qx_eAccessPointType_enum, rexState: qx_eRexState_enum, rexBypass: boolean, accessType: qx_eReaderAccessType_enum, refID: string }> };

export type GQL_CREATE_READERMutationVariables = Exact<{
  reader: qx_Reader_insert_input;
}>;


export type GQL_CREATE_READERMutation = { __typename?: 'mutation_root', createReader?: { __typename?: 'qx_Reader', id: string } | undefined };

export type GQL_UPDATE_READER_SUPERVISEMutationVariables = Exact<{
  deviceID: string;
  readerID: string;
  supervise: string;
}>;


export type GQL_UPDATE_READER_SUPERVISEMutation = { __typename?: 'mutation_root', updateDoorRexSupervise: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_DELETE_READERS_BY_IDMutationVariables = Exact<{
  ids: Array<string> | string;
}>;


export type GQL_DELETE_READERS_BY_IDMutation = { __typename?: 'mutation_root', deleteReaders?: { __typename?: 'qx_Reader_mutation_response', affected_rows: number } | undefined };

export type GQL_UPDATE_READER_BY_IDMutationVariables = Exact<{
  id: string;
  reader: qx_Reader_set_input;
  deviceID: string;
  supervise: string;
}>;


export type GQL_UPDATE_READER_BY_IDMutation = { __typename?: 'mutation_root', updateReader?: { __typename?: 'qx_Reader', id: string, name: string, direction: qx_eAccessPointDirection_enum, enabled: boolean, type: qx_eAccessPointType_enum, rexState: qx_eRexState_enum, rexBypass: boolean, refID: string } | undefined, updateDoorRexSupervise: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_GET_ROLE_FORMQueryVariables = Exact<{
  id: string;
  currentScopePath: string;
}>;


export type GQL_GET_ROLE_FORMQuery = { __typename?: 'query_root', role?: { __typename?: 'qx_Role', id: string, name: string, description?: string | undefined, placeID: string, toPrivileges: Array<{ __typename?: 'qx__PrivilegeEnumToRole', privilege: qx_ePrivilege_enum }>, people_aggregate: { __typename?: 'qx_Person_aggregate', aggregate?: { __typename?: 'qx_Person_aggregate_fields', count: number } | undefined } } | undefined };

export type RoleSearchFragment = { __typename?: 'qx_Role', id: string, name: string, description?: string | undefined, toPrivileges_aggregate: { __typename?: 'qx__PrivilegeEnumToRole_aggregate', aggregate?: { __typename?: 'qx__PrivilegeEnumToRole_aggregate_fields', count: number } | undefined }, toPrivileges: Array<{ __typename?: 'qx__PrivilegeEnumToRole', privilege: qx_ePrivilege_enum }>, place: { __typename?: 'qx_Place', id: string, path: string, name: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } };

export type GQL_ROLE_SEARCHQueryVariables = Exact<{
  where?: qx_Role_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Role_order_by> | qx_Role_order_by;
  currentScopePath?: string;
}>;


export type GQL_ROLE_SEARCHQuery = { __typename?: 'query_root', roles: Array<{ __typename?: 'qx_Role', id: string, name: string, description?: string | undefined, people_aggregate: { __typename?: 'qx_Person_aggregate', aggregate?: { __typename?: 'qx_Person_aggregate_fields', count: number } | undefined }, toPrivileges_aggregate: { __typename?: 'qx__PrivilegeEnumToRole_aggregate', aggregate?: { __typename?: 'qx__PrivilegeEnumToRole_aggregate_fields', count: number } | undefined }, toPrivileges: Array<{ __typename?: 'qx__PrivilegeEnumToRole', privilege: qx_ePrivilege_enum }>, place: { __typename?: 'qx_Place', id: string, path: string, name: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }>, roleAggregate: { __typename?: 'qx_Role_aggregate', aggregate?: { __typename?: 'qx_Role_aggregate_fields', count: number } | undefined } };

export type GQL_ROLE_SEARCH_SUBSCRIPTIONVariables = Exact<{
  where?: qx_Role_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_Role_order_by> | qx_Role_order_by;
  currentScopePath?: string;
}>;


export type GQL_ROLE_SEARCH_SUBSCRIPTION = { __typename?: 'subscription_root', roles: Array<{ __typename?: 'qx_Role', id: string, name: string, description?: string | undefined, people_aggregate: { __typename?: 'qx_Person_aggregate', aggregate?: { __typename?: 'qx_Person_aggregate_fields', count: number } | undefined }, toPrivileges_aggregate: { __typename?: 'qx__PrivilegeEnumToRole_aggregate', aggregate?: { __typename?: 'qx__PrivilegeEnumToRole_aggregate_fields', count: number } | undefined }, toPrivileges: Array<{ __typename?: 'qx__PrivilegeEnumToRole', privilege: qx_ePrivilege_enum }>, place: { __typename?: 'qx_Place', id: string, path: string, name: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } }> };

export type UseRoleFragment = { __typename?: 'qx_Role', id: string, name: string, description?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, toPrivileges: Array<{ __typename?: 'qx__PrivilegeEnumToRole', privilege: qx_ePrivilege_enum }> };

export type GQL_GET_ROLE_BY_IDQueryVariables = Exact<{
  id: string;
  currentScopePath: string;
}>;


export type GQL_GET_ROLE_BY_IDQuery = { __typename?: 'query_root', role?: { __typename?: 'qx_Role', id: string, name: string, description?: string | undefined, people_aggregate: { __typename?: 'qx_Person_aggregate', aggregate?: { __typename?: 'qx_Person_aggregate_fields', count: number } | undefined }, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, toPrivileges: Array<{ __typename?: 'qx__PrivilegeEnumToRole', privilege: qx_ePrivilege_enum }> } | undefined };

export type GQL_SUB_ROLE_BY_IDSubscriptionVariables = Exact<{
  id: string;
  currentScopePath: string;
}>;


export type GQL_SUB_ROLE_BY_IDSubscription = { __typename?: 'subscription_root', role?: { __typename?: 'qx_Role', id: string, name: string, description?: string | undefined, people_aggregate: { __typename?: 'qx_Person_aggregate', aggregate?: { __typename?: 'qx_Person_aggregate_fields', count: number } | undefined }, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, toPrivileges: Array<{ __typename?: 'qx__PrivilegeEnumToRole', privilege: qx_ePrivilege_enum }> } | undefined };

export type GQL_CONFIRM_ROLE_DELETEQueryVariables = Exact<{
  roleID: string;
}>;


export type GQL_CONFIRM_ROLE_DELETEQuery = { __typename?: 'query_root', role?: { __typename?: 'qx_Role', id: string, name: string, description?: string | undefined, placeID: string, place: { __typename?: 'qx_Place', toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined }, toPrivileges: Array<{ __typename?: 'qx__PrivilegeEnumToRole', privilege: qx_ePrivilege_enum }>, people_aggregate: { __typename?: 'qx_Person_aggregate', aggregate?: { __typename?: 'qx_Person_aggregate_fields', count: number } | undefined } } | undefined };

export type GQL_REMOVE_ROLE_FROM_PEOPLEMutationVariables = Exact<{
  id: string;
}>;


export type GQL_REMOVE_ROLE_FROM_PEOPLEMutation = { __typename?: 'mutation_root', updatePeople?: { __typename?: 'qx_Person_mutation_response', affected_rows: number } | undefined };

export type GQL_ASSIGN_ROLE_TO_PEOPLEMutationVariables = Exact<{
  oldID: string;
  newID: string;
}>;


export type GQL_ASSIGN_ROLE_TO_PEOPLEMutation = { __typename?: 'mutation_root', updatePeople?: { __typename?: 'qx_Person_mutation_response', affected_rows: number } | undefined };

export type GQL_CREATE_ROLEMutationVariables = Exact<{
  role: qx_Role_insert_input;
}>;


export type GQL_CREATE_ROLEMutation = { __typename?: 'mutation_root', createRole?: { __typename?: 'qx_Role', id: string, name: string, toPrivileges: Array<{ __typename?: 'qx__PrivilegeEnumToRole', privilege: qx_ePrivilege_enum }> } | undefined };

export type GQL_DELETE_ROLESMutationVariables = Exact<{
  ids: Array<string> | string;
}>;


export type GQL_DELETE_ROLESMutation = { __typename?: 'mutation_root', deleteRoles?: { __typename?: 'qx_Role_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'qx_Role', name: string }> } | undefined };

export type GQL_UPDATE_ROLEMutationVariables = Exact<{
  id: string;
  keepPrivileges: Array<qx_ePrivilege_enum> | qx_ePrivilege_enum;
  createPrivileges: Array<qx__PrivilegeEnumToRole_insert_input> | qx__PrivilegeEnumToRole_insert_input;
  role: qx_Role_set_input;
}>;


export type GQL_UPDATE_ROLEMutation = { __typename?: 'mutation_root', deletePrivilegeEnumToRoles?: { __typename?: 'qx__PrivilegeEnumToRole_mutation_response', affected_rows: number } | undefined, createPrivilegeEnumToRoles?: { __typename?: 'qx__PrivilegeEnumToRole_mutation_response', affected_rows: number } | undefined, updateRole?: { __typename?: 'qx_Role', id: string, name: string, toPrivileges: Array<{ __typename?: 'qx__PrivilegeEnumToRole', privilege: qx_ePrivilege_enum }> } | undefined };

export type RuleActionNotificationEmailDisplayGetDataQueryVariables = Exact<{
  ids: Array<string> | string;
}>;


export type RuleActionNotificationEmailDisplayGetDataQuery = { __typename?: 'query_root', people: Array<{ __typename?: 'qx_Person', id: string, firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined, phoneNumbers?: any | undefined, avatar_sm?: string | undefined }> };

export type RuleActionNotificationSmsDisplayGetDataQueryVariables = Exact<{
  ids: Array<string> | string;
}>;


export type RuleActionNotificationSmsDisplayGetDataQuery = { __typename?: 'query_root', people: Array<{ __typename?: 'qx_Person', id: string, firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined, phoneNumbers?: any | undefined, avatar_sm?: string | undefined }> };

export type GQL_GET_PTZ_PRESETSQueryVariables = Exact<{
  cameraID: string;
}>;


export type GQL_GET_PTZ_PRESETSQuery = { __typename?: 'query_root', videoSource?: { __typename?: 'qx_VideoSource', id: any, mediaProfiles: Array<{ __typename?: 'qx_MediaProfile', id: any, ptzPresets?: any | undefined }> } | undefined };

export type GQL_RULE_TRACE_SEARCHQueryVariables = Exact<{
  where?: qx_FlowTrace_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_FlowTrace_order_by> | qx_FlowTrace_order_by;
}>;


export type GQL_RULE_TRACE_SEARCHQuery = { __typename?: 'query_root', flowTraces: Array<{ __typename?: 'qx_FlowTrace', error?: string | undefined, createdAt: any, finishedAt?: any | undefined, flowID: any, id: any, state?: qx_eFlowTraceState_enum | undefined, trace?: any | undefined, triggerData?: any | undefined, triggeredType: string }>, flowTraceAggregate: { __typename?: 'qx_FlowTrace_aggregate', aggregate?: { __typename?: 'qx_FlowTrace_aggregate_fields', count: number } | undefined } };

export type GQL_RULE_TRACE_SEARCH_SUBSCRIPTIONVariables = Exact<{
  where?: qx_FlowTrace_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_FlowTrace_order_by> | qx_FlowTrace_order_by;
}>;


export type GQL_RULE_TRACE_SEARCH_SUBSCRIPTION = { __typename?: 'subscription_root', flowTraces: Array<{ __typename?: 'qx_FlowTrace', error?: string | undefined, createdAt: any, finishedAt?: any | undefined, flowID: any, id: any, state?: qx_eFlowTraceState_enum | undefined, trace?: any | undefined, triggerData?: any | undefined, triggeredType: string }> };

export type GQL_GET_RULE_BY_IDQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_RULE_BY_IDQuery = { __typename?: 'query_root', flow?: { __typename?: 'qx_Flow', id: any, name: string, description?: string | undefined, enabled?: boolean | undefined, status: qx_eFlowStatus_enum, flow?: any | undefined, placeID: string, scheduleID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, schedule?: { __typename?: 'qx_Schedule', id: string, name: string, description?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string }, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }> } | undefined } | undefined };

export type GQL_SUB_RULE_BY_IDSubscriptionVariables = Exact<{
  id: string;
}>;


export type GQL_SUB_RULE_BY_IDSubscription = { __typename?: 'subscription_root', flow?: { __typename?: 'qx_Flow', id: any, name: string, description?: string | undefined, enabled?: boolean | undefined, status: qx_eFlowStatus_enum, flow?: any | undefined, placeID: string, scheduleID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, schedule?: { __typename?: 'qx_Schedule', id: string, name: string, description?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string }, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }> } | undefined } | undefined };

export type GQL_SAVED_CLIP_DELETE_ALL_SHARED_LINKSMutationVariables = Exact<{
  clipID: string;
}>;


export type GQL_SAVED_CLIP_DELETE_ALL_SHARED_LINKSMutation = { __typename?: 'mutation_root', removeSharedLinks: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_GET_SAVED_CLIP_DOWNLOAD_URLMutationVariables = Exact<{
  clipID: string;
}>;


export type GQL_GET_SAVED_CLIP_DOWNLOAD_URLMutation = { __typename?: 'mutation_root', getDownloadClipUrl: { __typename?: 'ClipUrlOutput', base64?: string | undefined, expiresAt: any, url: string } };

export type GQL_GET_SAVED_CLIP_FORMQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_SAVED_CLIP_FORMQuery = { __typename?: 'query_root', clip?: { __typename?: 'qx_Clip', id: any, name?: string | undefined, expiresAt?: any | undefined, description?: string | undefined } | undefined };

export type GQL_GET_CLIP_BY_IDQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_CLIP_BY_IDQuery = { __typename?: 'query_root', clip?: { __typename?: 'qx_Clip', id: any, name?: string | undefined, progress: any, duration?: number | undefined, startTime: any, endTime: any, createdAt: any, expiresAt?: any | undefined, deletedAt?: any | undefined, placeID: string, metadata?: any | undefined, base64?: string | undefined, description?: string | undefined, createdBy?: string | undefined, type: qx_eClipType_enum, status: qx_eClipStatus_enum, error?: string | undefined, size?: any | undefined, checksum?: string | undefined, videoSourceID?: any | undefined, person?: { __typename?: 'qx_Person', id: string, firstName?: string | undefined, lastName?: string | undefined, avatar_sm?: string | undefined } | undefined, place?: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } | undefined, eClipStatus: { __typename?: 'qx_eClipStatus', value: string, comment?: string | undefined }, auditLog_aggregate: { __typename?: 'qx_ClipAuditLog_aggregate', aggregate?: { __typename?: 'qx_ClipAuditLog_aggregate_fields', count: number } | undefined } } | undefined };

export type GQL_SUB_CLIP_BY_IDSubscriptionVariables = Exact<{
  id: string;
}>;


export type GQL_SUB_CLIP_BY_IDSubscription = { __typename?: 'subscription_root', clip?: { __typename?: 'qx_Clip', id: any, name?: string | undefined, progress: any, duration?: number | undefined, startTime: any, endTime: any, createdAt: any, expiresAt?: any | undefined, deletedAt?: any | undefined, placeID: string, metadata?: any | undefined, base64?: string | undefined, description?: string | undefined, createdBy?: string | undefined, type: qx_eClipType_enum, status: qx_eClipStatus_enum, error?: string | undefined, size?: any | undefined, checksum?: string | undefined, videoSourceID?: any | undefined, person?: { __typename?: 'qx_Person', id: string, firstName?: string | undefined, lastName?: string | undefined, avatar_sm?: string | undefined } | undefined, place?: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } | undefined, eClipStatus: { __typename?: 'qx_eClipStatus', value: string, comment?: string | undefined }, auditLog_aggregate: { __typename?: 'qx_ClipAuditLog_aggregate', aggregate?: { __typename?: 'qx_ClipAuditLog_aggregate_fields', count: number } | undefined } } | undefined };

export type GQL_SAVED_CLIP_SHARED_LINKS_SEARCHQueryVariables = Exact<{
  where?: qx_SharedLinks_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_SharedLinks_order_by> | qx_SharedLinks_order_by;
}>;


export type GQL_SAVED_CLIP_SHARED_LINKS_SEARCHQuery = { __typename?: 'query_root', sharedLinks: Array<{ __typename?: 'qx_SharedLinks', id: any, url?: string | undefined, expiresAt?: any | undefined, singleUse?: boolean | undefined, createdAt?: any | undefined, ownerID: string, emails?: Array<string> | undefined, persons?: Array<string> | undefined, linkableType: qx_SharedLinkType_enum, linkableID: any, createdBy?: { __typename?: 'qx_Person', id: string, lastName?: string | undefined, firstName?: string | undefined, avatar_sm?: string | undefined } | undefined, clip?: { __typename?: 'qx_Clip', id: any } | undefined }>, sharedLinkAggregate: { __typename?: 'qx_SharedLinks_aggregate', aggregate?: { __typename?: 'qx_SharedLinks_aggregate_fields', count: number } | undefined } };

export type GQL_SAVED_CLIP_SHARED_LINKS_SEARCH_SUBSCRIPTIONVariables = Exact<{
  where?: qx_SharedLinks_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_SharedLinks_order_by> | qx_SharedLinks_order_by;
}>;


export type GQL_SAVED_CLIP_SHARED_LINKS_SEARCH_SUBSCRIPTION = { __typename?: 'subscription_root', sharedLinks: Array<{ __typename?: 'qx_SharedLinks', id: any, url?: string | undefined, expiresAt?: any | undefined, singleUse?: boolean | undefined, createdAt?: any | undefined, ownerID: string, emails?: Array<string> | undefined, persons?: Array<string> | undefined, linkableType: qx_SharedLinkType_enum, linkableID: any, createdBy?: { __typename?: 'qx_Person', id: string, lastName?: string | undefined, firstName?: string | undefined, avatar_sm?: string | undefined } | undefined, clip?: { __typename?: 'qx_Clip', id: any } | undefined }> };

export type GQL_CREATE_SAVED_CLIPMutationVariables = Exact<{
  description: string;
  eventID?: string;
  expiresAt?: string;
  videoSourceID: string;
  name: string;
  startTime: string;
  endTime: string;
  timelapse?: boolean;
  timelapseDuration?: number;
}>;


export type GQL_CREATE_SAVED_CLIPMutation = { __typename?: 'mutation_root', saveClip: { __typename?: 'SaveClipOutput', success: boolean } };

export type GQL_SAVED_CLIP_CREATE_SHARED_LINKMutationVariables = Exact<{
  emails?: Array<string> | string;
  expiresAt?: string;
  linkableID: string;
  linkableType: SharedLinkType;
  persons?: Array<string> | string;
  singleUse: boolean;
}>;


export type GQL_SAVED_CLIP_CREATE_SHARED_LINKMutation = { __typename?: 'mutation_root', createSharedLink: { __typename?: 'GetSharedLinkUrlOutput', url: string, expiresAt?: any | undefined } };

export type GQL_DELETE_SAVED_CLIP_BY_IDMutationVariables = Exact<{
  clipID: string;
}>;


export type GQL_DELETE_SAVED_CLIP_BY_IDMutation = { __typename?: 'mutation_root', removeClip: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_SAVED_CLIP_DELETE_SHARED_LINKMutationVariables = Exact<{
  sharedLinkID: string;
}>;


export type GQL_SAVED_CLIP_DELETE_SHARED_LINKMutation = { __typename?: 'mutation_root', removeSharedLink: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_VIEW_SAVED_CLIPMutationVariables = Exact<{
  clipID: string;
}>;


export type GQL_VIEW_SAVED_CLIPMutation = { __typename?: 'mutation_root', getClipUrl: { __typename?: 'ClipUrlOutput', url: string, expiresAt: any } };

export type GQL_GET_SHARED_WITH_PEOPLEQueryVariables = Exact<{
  where?: qx_Person_bool_exp;
  orderBy?: Array<qx_Person_order_by> | qx_Person_order_by;
}>;


export type GQL_GET_SHARED_WITH_PEOPLEQuery = { __typename?: 'query_root', people: Array<{ __typename?: 'qx_Person', id: string, firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined, employeeID?: string | undefined, avatar_md?: string | undefined }> };

export type GQL_UPDATE_SAVED_CLIP_BY_IDMutationVariables = Exact<{
  clipID: string;
  name: string;
  description: string;
  expiresAt?: string;
}>;


export type GQL_UPDATE_SAVED_CLIP_BY_IDMutation = { __typename?: 'mutation_root', updateSavedClip: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_SAVED_CLIP_UPDATE_SHARED_LINKMutationVariables = Exact<{
  sharedLinkID: string;
  emails?: Array<string> | string;
  persons?: Array<string> | string;
  singleUse: boolean;
  expiresAt?: string;
}>;


export type GQL_SAVED_CLIP_UPDATE_SHARED_LINKMutation = { __typename?: 'mutation_root', updateSharedLinkDetails: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_GET_SCHEDULE_FORMQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_SCHEDULE_FORMQuery = { __typename?: 'query_root', schedule?: { __typename?: 'qx_Schedule', id: string, name: string, description?: string | undefined, thumbnail?: string | undefined, placeID: string, holidayActive?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined }, permissions: Array<{ __typename?: 'qx_Permission', id: string }>, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, scheduleID: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }>, doors_aggregate: { __typename?: 'qx_Door_aggregate', aggregate?: { __typename?: 'qx_Door_aggregate_fields', count: number } | undefined }, flows_aggregate: { __typename?: 'qx_Flow_aggregate', aggregate?: { __typename?: 'qx_Flow_aggregate_fields', count: number } | undefined }, permissions_aggregate: { __typename?: 'qx_Permission_aggregate', aggregate?: { __typename?: 'qx_Permission_aggregate_fields', count: number } | undefined }, videoSources_aggregate: { __typename?: 'qx_VideoSource_aggregate', aggregate?: { __typename?: 'qx_VideoSource_aggregate_fields', count: number } | undefined }, gatewayBandwidthSchedules_aggregate: { __typename?: 'qx_GatewayBandwidthSchedule_aggregate', aggregate?: { __typename?: 'qx_GatewayBandwidthSchedule_aggregate_fields', count: number } | undefined } } | undefined };

export type GQL_CREATE_SCHEDULEMutationVariables = Exact<{
  schedule: qx_Schedule_insert_input;
}>;


export type GQL_CREATE_SCHEDULEMutation = { __typename?: 'mutation_root', createSchedules?: { __typename?: 'qx_Schedule_mutation_response', returning: Array<{ __typename?: 'qx_Schedule', id: string }> } | undefined };

export type GQL_DELETE_SCHEDULEMutationVariables = Exact<{
  id: string;
}>;


export type GQL_DELETE_SCHEDULEMutation = { __typename?: 'mutation_root', deleteScheduleBlocks?: { __typename?: 'qx_ScheduleBlock_mutation_response', returning: Array<{ __typename?: 'qx_ScheduleBlock', id: string }> } | undefined, deleteSchedules?: { __typename?: 'qx_Schedule_mutation_response', returning: Array<{ __typename?: 'qx_Schedule', id: string }> } | undefined };

export type GQL_UPDATE_SCHEDULEMutationVariables = Exact<{
  id: string;
  schedule: qx_Schedule_set_input;
  blocks: Array<qx_ScheduleBlock_insert_input> | qx_ScheduleBlock_insert_input;
}>;


export type GQL_UPDATE_SCHEDULEMutation = { __typename?: 'mutation_root', deleteScheduleBlocks?: { __typename?: 'qx_ScheduleBlock_mutation_response', returning: Array<{ __typename?: 'qx_ScheduleBlock', id: string }> } | undefined, createScheduleBlocks?: { __typename?: 'qx_ScheduleBlock_mutation_response', returning: Array<{ __typename?: 'qx_ScheduleBlock', id: string, scheduleID: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }> } | undefined, updateSchedules?: { __typename?: 'qx_Schedule_mutation_response', returning: Array<{ __typename?: 'qx_Schedule', id: string, name: string, description?: string | undefined, placeID: string, holidayActive?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined }, permissions: Array<{ __typename?: 'qx_Permission', id: string }>, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, scheduleID: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }> }> } | undefined };

export type validateDeleteScheduleQueryVariables = Exact<{
  id: string;
}>;


export type validateDeleteScheduleQuery = { __typename?: 'query_root', schedule?: { __typename?: 'qx_Schedule', id: string, name: string, placeID: string, place: { __typename?: 'qx_Place', toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', customerPlaceID?: string | undefined, integratorPlaceID?: string | undefined } | undefined }, permissions_aggregate: { __typename?: 'qx_Permission_aggregate', aggregate?: { __typename?: 'qx_Permission_aggregate_fields', count: number } | undefined } } | undefined };

export type GQL_DELETE_SCHEDULE_PERMISSIONSMutationVariables = Exact<{
  id: string;
}>;


export type GQL_DELETE_SCHEDULE_PERMISSIONSMutation = { __typename?: 'mutation_root', deletePermissions?: { __typename?: 'qx_Permission_mutation_response', affected_rows: number } | undefined };

export type GQL_ASSIGN_SCHEDULE_PERMISSIONS_TO_SCHEDULE_IDMutationVariables = Exact<{
  oldID: string;
  newID: string;
}>;


export type GQL_ASSIGN_SCHEDULE_PERMISSIONS_TO_SCHEDULE_IDMutation = { __typename?: 'mutation_root', updatePermissions?: { __typename?: 'qx_Permission_mutation_response', affected_rows: number } | undefined };

export type GQL_HOLIDAY_SET_PATH_BY_IDQueryVariables = Exact<{
  hsID: string;
}>;


export type GQL_HOLIDAY_SET_PATH_BY_IDQuery = { __typename?: 'query_root', holidaySets: Array<{ __typename?: 'qx_HolidaySet', id: string, place: { __typename?: 'qx_Place', id: string, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', integratorPlaceID?: string | undefined, customerPlaceID?: string | undefined } | undefined } }> };

export type SensorFormFragment = { __typename?: 'qx_Sensor', id: any, defaultVideoSourceID?: any | undefined, batteryLevel: qx_eBatteryLevel_enum, connectionStatus: qx_eDeviceConnectionStatus_enum, createdAt?: any | undefined, description?: string | undefined, deviceID: string, disabledByLicense: boolean, enabled: boolean, name: string, placeID: string, serial: string, state: qx_eDIOState_enum, type: qx_eSensorType_enum, updatedAt?: any | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string } | undefined, eBatteryLevel: { __typename?: 'qx_eBatteryLevel', comment?: string | undefined }, eDIOState: { __typename?: 'qx_eDIOState', comment?: string | undefined }, eDeviceConnectionStatus: { __typename?: 'qx_eDeviceConnectionStatus', comment?: string | undefined }, eSensorType: { __typename?: 'qx_eSensorType', comment?: string | undefined }, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined, connectionStatus: qx_eDeviceConnectionStatus_enum, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string } } }, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } | undefined } };

export type GQL_GET_SENSOR_FORMQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_SENSOR_FORMQuery = { __typename?: 'query_root', sensor?: { __typename?: 'qx_Sensor', id: any, defaultVideoSourceID?: any | undefined, batteryLevel: qx_eBatteryLevel_enum, connectionStatus: qx_eDeviceConnectionStatus_enum, createdAt?: any | undefined, description?: string | undefined, deviceID: string, disabledByLicense: boolean, enabled: boolean, name: string, placeID: string, serial: string, state: qx_eDIOState_enum, type: qx_eSensorType_enum, updatedAt?: any | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string } | undefined, eBatteryLevel: { __typename?: 'qx_eBatteryLevel', comment?: string | undefined }, eDIOState: { __typename?: 'qx_eDIOState', comment?: string | undefined }, eDeviceConnectionStatus: { __typename?: 'qx_eDeviceConnectionStatus', comment?: string | undefined }, eSensorType: { __typename?: 'qx_eSensorType', comment?: string | undefined }, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined, connectionStatus: qx_eDeviceConnectionStatus_enum, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string } } }, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } | undefined } } | undefined };

export type GQL_SEARCH_V_EVENTS_SENSORQueryVariables = Exact<{
  where: vEvents_bool_exp;
  limit: number;
  order_by: Array<vEvents_order_by> | vEvents_order_by;
}>;


export type GQL_SEARCH_V_EVENTS_SENSORQuery = { __typename?: 'query_root', vEvents: Array<{ __typename?: 'vEvents', id?: any | undefined, active?: boolean | undefined, card?: string | undefined, bits?: number | undefined, status?: string | undefined, time?: any | undefined, type?: string | undefined, duration?: any | undefined, hasVideo?: boolean | undefined, inCloud?: boolean | undefined, onGateway?: boolean | undefined, eventStart?: any | undefined, eventEnd?: any | undefined, personID?: string | undefined, doorID?: any | undefined, videoSourceID?: any | undefined, deviceID?: string | undefined, placeID?: string | undefined, profile?: string | undefined, serverTime?: any | undefined, person?: { __typename?: 'qx_Person', id: string, avatar?: string | undefined, firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined } | undefined, door?: { __typename?: 'qx_Door', id: any, name: string } | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string } | undefined, place?: { __typename?: 'qx_Place', id: string, name: string, path: string, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, type: eGatewayType_enum } | undefined, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } | undefined, snapshot?: { __typename?: 'qx_Snapshot', id: string, signedUrl?: string | undefined } | undefined }> };

export type GQL_CONFIRM_SENSOR_DELETEQueryVariables = Exact<{
  sensorID: string;
}>;


export type GQL_CONFIRM_SENSOR_DELETEQuery = { __typename?: 'query_root', devices: Array<{ __typename?: 'qx_Device', id: string, make?: string | undefined, model?: string | undefined, name: string, sensors_aggregate: { __typename?: 'qx_Sensor_aggregate', aggregate?: { __typename?: 'qx_Sensor_aggregate_fields', count: number } | undefined } }> };

export type GQL_SENSORS_BY_DEVICE_IDQueryVariables = Exact<{
  deviceId: string;
}>;


export type GQL_SENSORS_BY_DEVICE_IDQuery = { __typename?: 'query_root', sensors: Array<{ __typename?: 'qx_Sensor', id: any, defaultVideoSourceID?: any | undefined, batteryLevel: qx_eBatteryLevel_enum, connectionStatus: qx_eDeviceConnectionStatus_enum, createdAt?: any | undefined, description?: string | undefined, deviceID: string, disabledByLicense: boolean, enabled: boolean, name: string, placeID: string, serial: string, state: qx_eDIOState_enum, type: qx_eSensorType_enum, updatedAt?: any | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, place: { __typename?: 'qx_Place', id: string, name: string } } | undefined, eBatteryLevel: { __typename?: 'qx_eBatteryLevel', comment?: string | undefined }, eDIOState: { __typename?: 'qx_eDIOState', comment?: string | undefined }, eDeviceConnectionStatus: { __typename?: 'qx_eDeviceConnectionStatus', comment?: string | undefined }, eSensorType: { __typename?: 'qx_eSensorType', comment?: string | undefined }, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, port: number, tls: boolean, model?: string | undefined, firmware?: string | undefined, serial?: string | undefined, deviceUsername?: string | undefined, devicePassword?: string | undefined, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } }, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } | undefined } }> };

export type GQL_UPDATE_SENSOR_BY_IDMutationVariables = Exact<{
  id: string;
  sensor: qx_Sensor_set_input;
}>;


export type GQL_UPDATE_SENSOR_BY_IDMutation = { __typename?: 'mutation_root', updateSensor?: { __typename?: 'qx_Sensor', id: any, name: string } | undefined };

export type GQL_GET_VIEW_BY_IDQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_VIEW_BY_IDQuery = { __typename?: 'query_root', view?: { __typename?: 'qx_View', id: string, settings: any, name: string, personID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, defaultView?: { __typename?: 'qx_View', id: string, name: string } | undefined } } | undefined };

export type GQL_SUB_VIEW_BY_IDSubscriptionVariables = Exact<{
  id: string;
}>;


export type GQL_SUB_VIEW_BY_IDSubscription = { __typename?: 'subscription_root', view?: { __typename?: 'qx_View', id: string, settings: any, name: string, personID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, defaultView?: { __typename?: 'qx_View', id: string, name: string } | undefined } } | undefined };

export type GQL_CREATE_VIEWMutationVariables = Exact<{
  view: qx_View_insert_input;
}>;


export type GQL_CREATE_VIEWMutation = { __typename?: 'mutation_root', createView?: { __typename?: 'qx_View', id: string } | undefined };

export type GQL_SUB_AXIS_DEVICE_READYSubscriptionVariables = Exact<{
  deviceID: string;
}>;


export type GQL_SUB_AXIS_DEVICE_READYSubscription = { __typename?: 'subscription_root', device?: { __typename?: 'qx_Device', id: string, meta?: any | undefined, createdAt: any, doors: Array<{ __typename?: 'qx_Door', id: any, name: string, locks: Array<{ __typename?: 'qx_Lock', id: string, name: string }>, readers: Array<{ __typename?: 'qx_Reader', id: string, name: string }> }> } | undefined };

export type GQL_GET_AXIS_DEVICE_READYQueryVariables = Exact<{
  deviceID: string;
}>;


export type GQL_GET_AXIS_DEVICE_READYQuery = { __typename?: 'query_root', device?: { __typename?: 'qx_Device', id: string, meta?: any | undefined, createdAt: any, doors: Array<{ __typename?: 'qx_Door', id: any, name: string, locks: Array<{ __typename?: 'qx_Lock', id: string, name: string }>, readers: Array<{ __typename?: 'qx_Reader', id: string, name: string }> }> } | undefined };

export type GQL_MERCURY_CATALOG_SEARCHQueryVariables = Exact<{
  where?: qx_AccessCatalog_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_AccessCatalog_order_by> | qx_AccessCatalog_order_by;
}>;


export type GQL_MERCURY_CATALOG_SEARCHQuery = { __typename?: 'query_root', accessCatalogs: Array<{ __typename?: 'qx_AccessCatalog', id: string, name: string, type: qx_eAccessBoardType_enum, interface: qx_eAccessInterfaceType_enum, nInputs: number, nOutputs: number, nReaders: number, model: number, placeID: string, AccessCatalogCapabilities?: { __typename?: 'qx_AccessCatalogCapabilities', catalogID: string, hasLockModes: boolean } | undefined, CatalogProtocolOverrides: Array<{ __typename?: 'qx_CatalogProtocolOverride', id: number, protocol: qx_eReaderProtocol_enum, enabled: boolean }> }>, accessCatalogAggregate: { __typename?: 'qx_AccessCatalog_aggregate', aggregate?: { __typename?: 'qx_AccessCatalog_aggregate_fields', count: number } | undefined } };

export type GQL_SUB_MERCURY_INVENTORY_FORMSubscriptionVariables = Exact<{
  id: string;
}>;


export type GQL_SUB_MERCURY_INVENTORY_FORMSubscription = { __typename?: 'subscription_root', accessInventories: Array<{ __typename?: 'qx_AccessInventory', deviceID: string, baudrate: qx_eBaudrate_enum, username?: string | undefined, password?: string | undefined, isEncrypted: boolean, inputsAvail: number, outputsAvail: number, readersAvail: number, sioAddress: number, sioPort: number, sioNumber: number, id: string, host: string, port: number, serialPortsAvail: number, catalogID: string, connectionStatus: qx_eDeviceConnectionStatus_enum, state: qx_eDoorAlarm_enum, readersPerDoor?: number | undefined, catalog: { __typename?: 'qx_AccessCatalog', id: string, name: string, type: qx_eAccessBoardType_enum, interface: qx_eAccessInterfaceType_enum, nInputs: number, nOutputs: number, nReaders: number, AccessCatalogCapabilities?: { __typename?: 'qx_AccessCatalogCapabilities', catalogID: string, hasLockModes: boolean } | undefined, CatalogProtocolOverrides: Array<{ __typename?: 'qx_CatalogProtocolOverride', id: number, protocol: qx_eReaderProtocol_enum, enabled: boolean }> } }> };

export type MercuryInventoryFragment = { __typename?: 'qx_AccessInventory', deviceID: string, baudrate: qx_eBaudrate_enum, username?: string | undefined, password?: string | undefined, isEncrypted: boolean, inputsAvail: number, outputsAvail: number, readersAvail: number, sioAddress: number, sioPort: number, sioNumber: number, id: string, host: string, port: number, serialPortsAvail: number, catalogID: string, connectionStatus: qx_eDeviceConnectionStatus_enum, state: qx_eDoorAlarm_enum, readersPerDoor?: number | undefined, catalog: { __typename?: 'qx_AccessCatalog', id: string, name: string, type: qx_eAccessBoardType_enum, interface: qx_eAccessInterfaceType_enum, nInputs: number, nOutputs: number, nReaders: number, AccessCatalogCapabilities?: { __typename?: 'qx_AccessCatalogCapabilities', catalogID: string, hasLockModes: boolean } | undefined, CatalogProtocolOverrides: Array<{ __typename?: 'qx_CatalogProtocolOverride', id: number, protocol: qx_eReaderProtocol_enum, enabled: boolean }> } };

export type GQL_MERCURY_INVENTORY_BY_IDQueryVariables = Exact<{
  id: string;
}>;


export type GQL_MERCURY_INVENTORY_BY_IDQuery = { __typename?: 'query_root', accessInventories: Array<{ __typename?: 'qx_AccessInventory', deviceID: string, baudrate: qx_eBaudrate_enum, username?: string | undefined, password?: string | undefined, isEncrypted: boolean, inputsAvail: number, outputsAvail: number, readersAvail: number, sioAddress: number, sioPort: number, sioNumber: number, id: string, host: string, port: number, serialPortsAvail: number, catalogID: string, connectionStatus: qx_eDeviceConnectionStatus_enum, state: qx_eDoorAlarm_enum, readersPerDoor?: number | undefined, catalog: { __typename?: 'qx_AccessCatalog', id: string, name: string, type: qx_eAccessBoardType_enum, interface: qx_eAccessInterfaceType_enum, nInputs: number, nOutputs: number, nReaders: number, AccessCatalogCapabilities?: { __typename?: 'qx_AccessCatalogCapabilities', catalogID: string, hasLockModes: boolean } | undefined, CatalogProtocolOverrides: Array<{ __typename?: 'qx_CatalogProtocolOverride', id: number, protocol: qx_eReaderProtocol_enum, enabled: boolean }> } }> };

export type GQL_SUB_MERCURY_DEVICE_WIRINGSubscriptionVariables = Exact<{
  deviceID: string;
}>;


export type GQL_SUB_MERCURY_DEVICE_WIRINGSubscription = { __typename?: 'subscription_root', accessInventories: Array<{ __typename?: 'qx_AccessInventory', deviceID: string, baudrate: qx_eBaudrate_enum, username?: string | undefined, password?: string | undefined, isEncrypted: boolean, inputsAvail: number, outputsAvail: number, readersAvail: number, sioAddress: number, sioPort: number, sioNumber: number, id: string, host: string, port: number, serialPortsAvail: number, catalogID: string, connectionStatus: qx_eDeviceConnectionStatus_enum, state: qx_eDoorAlarm_enum, readersPerDoor?: number | undefined, catalog: { __typename?: 'qx_AccessCatalog', id: string, name: string, type: qx_eAccessBoardType_enum, interface: qx_eAccessInterfaceType_enum, nInputs: number, nOutputs: number, nReaders: number, AccessCatalogCapabilities?: { __typename?: 'qx_AccessCatalogCapabilities', catalogID: string, hasLockModes: boolean } | undefined, CatalogProtocolOverrides: Array<{ __typename?: 'qx_CatalogProtocolOverride', id: number, protocol: qx_eReaderProtocol_enum, enabled: boolean }> } }> };

export type MercuryDeviceDioWiringFragment = { __typename?: 'qx_DeviceDIO', id: string, name: string, refID: string, type?: qx_eDIOType_enum | undefined, state?: qx_eDIOState_enum | undefined, enabled: boolean, InputPoints: Array<{ __typename?: 'qx_InputPoint', supervise?: string | undefined, deviceID: string, id: string, channel?: number | undefined, MercuryMonitorPoints: Array<{ __typename?: 'qx_MercuryMonitorPoint', id: string, holdTime?: string | undefined, debounce?: number | undefined, mode?: qx_eMercuryMonitorPointLatchModes_enum | undefined, delayEntry?: string | undefined, delayExit?: string | undefined, mask?: number | undefined, inventoryID: string, inputPointID: string }> }>, OutputPoints: Array<{ __typename?: 'qx_OutputPoint', pulse?: string | undefined, deviceID: string, id: string, channel?: number | undefined, MercuryControlPoints: Array<{ __typename?: 'qx_MercuryControlPoint', id: string, repeat?: boolean | undefined, onTime?: string | undefined, offTime?: string | undefined, inventoryID: string }> }>, Reader?: { __typename?: 'qx_Reader', id: string, name: string, inventoryID?: string | undefined } | undefined, Door?: { __typename?: 'qx_Door', id: any, name: string, inventoryID?: string | undefined, toAlarm: { __typename?: 'qx_eDoorAlarm', value: string }, toMode: { __typename?: 'qx_eDoorMode', value: string } } | undefined, eDIOType?: { __typename?: 'qx_eDIOType', value: string, comment?: string | undefined } | undefined, eDIOState?: { __typename?: 'qx_eDIOState', value: string, comment?: string | undefined } | undefined, accessInventory?: { __typename?: 'qx_AccessInventory', id: string } | undefined };

export type GQL_SUB_MERCURY_DIO_ALLSubscriptionVariables = Exact<{
  id: string;
}>;


export type GQL_SUB_MERCURY_DIO_ALLSubscription = { __typename?: 'subscription_root', DeviceDIOs: Array<{ __typename?: 'qx_DeviceDIO', id: string, name: string, refID: string, type?: qx_eDIOType_enum | undefined, state?: qx_eDIOState_enum | undefined, enabled: boolean, InputPoints: Array<{ __typename?: 'qx_InputPoint', supervise?: string | undefined, deviceID: string, id: string, channel?: number | undefined, MercuryMonitorPoints: Array<{ __typename?: 'qx_MercuryMonitorPoint', id: string, holdTime?: string | undefined, debounce?: number | undefined, mode?: qx_eMercuryMonitorPointLatchModes_enum | undefined, delayEntry?: string | undefined, delayExit?: string | undefined, mask?: number | undefined, inventoryID: string, inputPointID: string }> }>, OutputPoints: Array<{ __typename?: 'qx_OutputPoint', pulse?: string | undefined, deviceID: string, id: string, channel?: number | undefined, MercuryControlPoints: Array<{ __typename?: 'qx_MercuryControlPoint', id: string, repeat?: boolean | undefined, onTime?: string | undefined, offTime?: string | undefined, inventoryID: string }> }>, Reader?: { __typename?: 'qx_Reader', id: string, name: string, inventoryID?: string | undefined } | undefined, Door?: { __typename?: 'qx_Door', id: any, name: string, inventoryID?: string | undefined, toAlarm: { __typename?: 'qx_eDoorAlarm', value: string }, toMode: { __typename?: 'qx_eDoorMode', value: string } } | undefined, eDIOType?: { __typename?: 'qx_eDIOType', value: string, comment?: string | undefined } | undefined, eDIOState?: { __typename?: 'qx_eDIOState', value: string, comment?: string | undefined } | undefined, accessInventory?: { __typename?: 'qx_AccessInventory', id: string } | undefined }> };

export type GQL_GET_MERCURY_DEVICE_READYSubscriptionVariables = Exact<{
  deviceID: string;
}>;


export type GQL_GET_MERCURY_DEVICE_READYSubscription = { __typename?: 'subscription_root', device?: { __typename?: 'qx_Device', id: string, meta?: any | undefined } | undefined };

export type GQL_GET_BRAND_MERCURY_DEVICE_INVENTORY_BY_DEVICE_IDQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_BRAND_MERCURY_DEVICE_INVENTORY_BY_DEVICE_IDQuery = { __typename?: 'query_root', accessInventories: Array<{ __typename?: 'qx_AccessInventory', id: string, host: string, sioAddress: number, inputsAvail: number, outputsAvail: number, readersAvail: number, catalog: { __typename?: 'qx_AccessCatalog', id: string, name: string, type: qx_eAccessBoardType_enum, interface: qx_eAccessInterfaceType_enum, nInputs: number, nOutputs: number, nReaders: number, AccessCatalogCapabilities?: { __typename?: 'qx_AccessCatalogCapabilities', catalogID: string, hasLockModes: boolean } | undefined, CatalogProtocolOverrides: Array<{ __typename?: 'qx_CatalogProtocolOverride', id: number, protocol: qx_eReaderProtocol_enum, enabled: boolean }> } }> };

export type GQL_GET_MERCURY_DEVICE_DIO_USAGEQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_MERCURY_DEVICE_DIO_USAGEQuery = { __typename?: 'query_root', getMercuryDIOUsages: Array<{ __typename?: 'MercuryDIOUsageOutput', inputMax: number, outputMax: number, outputsAvailable?: Array<number | undefined> | undefined, inputsAvailable?: Array<number | undefined> | undefined, inventoryId: string, inputs?: Array<{ __typename?: 'DIOType', id: string, name: string, defaultState: string, type: string, channel: number, supervise: string } | undefined> | undefined, outputs?: Array<{ __typename?: 'DIOType', id: string, name: string, defaultState: string, type: string, channel: number } | undefined> | undefined } | undefined> };

export type GQL_GET_MERCURY_MODELSQueryVariables = Exact<{ [key: string]: never; }>;


export type GQL_GET_MERCURY_MODELSQuery = { __typename?: 'query_root', accessCatalogs: Array<{ __typename?: 'qx_AccessCatalog', id: string, name: string, type: qx_eAccessBoardType_enum, interface: qx_eAccessInterfaceType_enum, nInputs: number, nOutputs: number, nReaders: number, model: number, placeID: string }> };

export type GQL_VALIDATE_MERCURY_HARDWAREMutationVariables = Exact<{
  deviceID: string;
  config: any;
}>;


export type GQL_VALIDATE_MERCURY_HARDWAREMutation = { __typename?: 'mutation_root', validateHardware: { __typename?: 'ValidateHardwareResult', error?: string | undefined, success: boolean } };

export type GQL_VALIDATE_MERCURY_PACS_UPDATE_PART_1QueryVariables = Exact<{
  deviceID: string;
}>;


export type GQL_VALIDATE_MERCURY_PACS_UPDATE_PART_1Query = { __typename?: 'query_root', device?: { __typename?: 'qx_Device', id: string, doors: Array<{ __typename?: 'qx_Door', id: any, name: string, place: { __typename?: 'qx_Place', id: string, path: string }, unlockSchedule?: { __typename?: 'qx_Schedule', id: string, name: string, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, date: any, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string, dates?: any | undefined } }> }>, blocks_aggregate: { __typename?: 'qx_ScheduleBlock_aggregate', aggregate?: { __typename?: 'qx_ScheduleBlock_aggregate_fields', count: number } | undefined } } | undefined }> } | undefined };

export type GQL_VALIDATE_MERCURY_PACS_UPDATE_PART_2QueryVariables = Exact<{
  placeIDs?: Array<string> | string;
  max: number;
}>;


export type GQL_VALIDATE_MERCURY_PACS_UPDATE_PART_2Query = { __typename?: 'query_root', allotmentByPermission: Array<{ __typename?: 'qx_Permission', id: string, place: { __typename?: 'qx_Place', id: string, name: string }, group: { __typename?: 'qx_Group', id: string, name: string }, schedule: { __typename?: 'qx_Schedule', id: string, name: string, blocks_aggregate: { __typename?: 'qx_ScheduleBlock_aggregate', aggregate?: { __typename?: 'qx_ScheduleBlock_aggregate_fields', count: number } | undefined } } }>, holidaySetsByPermission: Array<{ __typename?: 'qx_Permission', id: string, name: string, schedule: { __typename?: 'qx_Schedule', id: string, name: string, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, date: any, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string, dates?: any | undefined } }> }> } }> };

export type GQL_VALIDATE_MERCURY_GET_DOOR_CONFIGURATIONQueryVariables = Exact<{ [key: string]: never; }>;


export type GQL_VALIDATE_MERCURY_GET_DOOR_CONFIGURATIONQuery = { __typename?: 'query_root', doorConfiguration?: { __typename?: 'qx_DoorConfiguration', id: string, configuration?: any | undefined } | undefined };

export type GQL_VALIDATE_MERCURY_GET_PERMISSIONS_BY_PLACE_IDQueryVariables = Exact<{
  placeIDs?: Array<qx_Permission_bool_exp> | qx_Permission_bool_exp;
}>;


export type GQL_VALIDATE_MERCURY_GET_PERMISSIONS_BY_PLACE_IDQuery = { __typename?: 'query_root', permissions: Array<{ __typename?: 'qx_Permission', id: string, group: { __typename?: 'qx_Group', id: string, toPeople: Array<{ __typename?: 'qx__PersonToGroup', personID: string, person: { __typename?: 'qx_Person', id: string, firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined, toGroups_aggregate: { __typename?: 'qx__PersonToGroup_aggregate', aggregate?: { __typename?: 'qx__PersonToGroup_aggregate_fields', count: number } | undefined }, credentials_aggregate: { __typename?: 'qx_Credential_aggregate', aggregate?: { __typename?: 'qx_Credential_aggregate_fields', count: number } | undefined } } }> } }> };

export type RosslareInventoryFragment = { __typename?: 'qx_AccessInventory', deviceID: string, readersAvail: number, id: string, host: string, port: number, sioPort: number, serialPortsAvail: number, sioAddress: number, catalogID: string, connectionStatus: qx_eDeviceConnectionStatus_enum, state: qx_eDoorAlarm_enum, readersPerDoor?: number | undefined, readers: Array<{ __typename?: 'qx_Reader', id: string, name: string, refID: string, type: qx_eAccessPointType_enum, deviceID: string, Door?: { __typename?: 'qx_Door', name: string, toAlarm: { __typename?: 'qx_eDoorAlarm', value: string }, toMode: { __typename?: 'qx_eDoorMode', value: string } } | undefined }>, catalog: { __typename?: 'qx_AccessCatalog', id: string, name: string, type: qx_eAccessBoardType_enum, interface: qx_eAccessInterfaceType_enum, nInputs: number, nOutputs: number, nReaders: number, AccessCatalogCapabilities?: { __typename?: 'qx_AccessCatalogCapabilities', catalogID: string, hasLockModes: boolean } | undefined, CatalogProtocolOverrides: Array<{ __typename?: 'qx_CatalogProtocolOverride', id: number, protocol: qx_eReaderProtocol_enum, enabled: boolean }> } };

export type GQL_GET_ROSSLARE_DEVICE_INVENTORYQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_ROSSLARE_DEVICE_INVENTORYQuery = { __typename?: 'query_root', accessInventories: Array<{ __typename?: 'qx_AccessInventory', deviceID: string, readersAvail: number, id: string, host: string, port: number, sioPort: number, serialPortsAvail: number, sioAddress: number, catalogID: string, connectionStatus: qx_eDeviceConnectionStatus_enum, state: qx_eDoorAlarm_enum, readersPerDoor?: number | undefined, readers: Array<{ __typename?: 'qx_Reader', id: string, name: string, refID: string, type: qx_eAccessPointType_enum, deviceID: string, Door?: { __typename?: 'qx_Door', name: string, toAlarm: { __typename?: 'qx_eDoorAlarm', value: string }, toMode: { __typename?: 'qx_eDoorMode', value: string } } | undefined }>, catalog: { __typename?: 'qx_AccessCatalog', id: string, name: string, type: qx_eAccessBoardType_enum, interface: qx_eAccessInterfaceType_enum, nInputs: number, nOutputs: number, nReaders: number, AccessCatalogCapabilities?: { __typename?: 'qx_AccessCatalogCapabilities', catalogID: string, hasLockModes: boolean } | undefined, CatalogProtocolOverrides: Array<{ __typename?: 'qx_CatalogProtocolOverride', id: number, protocol: qx_eReaderProtocol_enum, enabled: boolean }> } }> };

export type GQL_SUB_ROSSLARE_DEVICE_INVENTORYSubscriptionVariables = Exact<{
  deviceID: string;
}>;


export type GQL_SUB_ROSSLARE_DEVICE_INVENTORYSubscription = { __typename?: 'subscription_root', accessInventories: Array<{ __typename?: 'qx_AccessInventory', deviceID: string, readersAvail: number, id: string, host: string, port: number, sioPort: number, serialPortsAvail: number, sioAddress: number, catalogID: string, connectionStatus: qx_eDeviceConnectionStatus_enum, state: qx_eDoorAlarm_enum, readersPerDoor?: number | undefined, readers: Array<{ __typename?: 'qx_Reader', id: string, name: string, refID: string, type: qx_eAccessPointType_enum, deviceID: string, Door?: { __typename?: 'qx_Door', name: string, toAlarm: { __typename?: 'qx_eDoorAlarm', value: string }, toMode: { __typename?: 'qx_eDoorMode', value: string } } | undefined }>, catalog: { __typename?: 'qx_AccessCatalog', id: string, name: string, type: qx_eAccessBoardType_enum, interface: qx_eAccessInterfaceType_enum, nInputs: number, nOutputs: number, nReaders: number, AccessCatalogCapabilities?: { __typename?: 'qx_AccessCatalogCapabilities', catalogID: string, hasLockModes: boolean } | undefined, CatalogProtocolOverrides: Array<{ __typename?: 'qx_CatalogProtocolOverride', id: number, protocol: qx_eReaderProtocol_enum, enabled: boolean }> } }> };

export type RosslareDeviceDioWiringFragment = { __typename?: 'qx_DeviceDIO', defaultState?: qx_eDIONormalState_enum | undefined, superviseInput: qx_eSuperviseInputs_enum, id: string, name: string, refID: string, type?: qx_eDIOType_enum | undefined, state?: qx_eDIOState_enum | undefined, enabled: boolean, eDIONormalState?: { __typename?: 'qx_eDIONormalState', value: string, comment?: string | undefined } | undefined, Lock?: { __typename?: 'qx_Lock', id: string, name: string } | undefined, eDIOType?: { __typename?: 'qx_eDIOType', value: string, comment?: string | undefined } | undefined, eDIOState?: { __typename?: 'qx_eDIOState', value: string, comment?: string | undefined } | undefined, InputPoints: Array<{ __typename?: 'qx_InputPoint', supervise?: string | undefined, id: string, channel?: number | undefined }>, OutputPoints: Array<{ __typename?: 'qx_OutputPoint', pulse?: string | undefined, id: string, channel?: number | undefined }>, Reader?: { __typename?: 'qx_Reader', id: string, name: string } | undefined, Door?: { __typename?: 'qx_Door', id: any, name: string, inventoryID?: string | undefined, toAlarm: { __typename?: 'qx_eDoorAlarm', value: string }, toMode: { __typename?: 'qx_eDoorMode', value: string } } | undefined, accessInventory?: { __typename?: 'qx_AccessInventory', id: string } | undefined };

export type GQL_SUB_ROSSLARE_DEVICE_DIOSubscriptionVariables = Exact<{
  deviceID: string;
}>;


export type GQL_SUB_ROSSLARE_DEVICE_DIOSubscription = { __typename?: 'subscription_root', DeviceDIOs: Array<{ __typename?: 'qx_DeviceDIO', defaultState?: qx_eDIONormalState_enum | undefined, superviseInput: qx_eSuperviseInputs_enum, id: string, name: string, refID: string, type?: qx_eDIOType_enum | undefined, state?: qx_eDIOState_enum | undefined, enabled: boolean, eDIONormalState?: { __typename?: 'qx_eDIONormalState', value: string, comment?: string | undefined } | undefined, Lock?: { __typename?: 'qx_Lock', id: string, name: string } | undefined, eDIOType?: { __typename?: 'qx_eDIOType', value: string, comment?: string | undefined } | undefined, eDIOState?: { __typename?: 'qx_eDIOState', value: string, comment?: string | undefined } | undefined, InputPoints: Array<{ __typename?: 'qx_InputPoint', supervise?: string | undefined, id: string, channel?: number | undefined }>, OutputPoints: Array<{ __typename?: 'qx_OutputPoint', pulse?: string | undefined, id: string, channel?: number | undefined }>, Reader?: { __typename?: 'qx_Reader', id: string, name: string } | undefined, Door?: { __typename?: 'qx_Door', id: any, name: string, inventoryID?: string | undefined, toAlarm: { __typename?: 'qx_eDoorAlarm', value: string }, toMode: { __typename?: 'qx_eDoorMode', value: string } } | undefined, accessInventory?: { __typename?: 'qx_AccessInventory', id: string } | undefined }> };

export type GQL_GET_ROSSLARE_DEVICE_READYSubscriptionVariables = Exact<{
  deviceID: string;
}>;


export type GQL_GET_ROSSLARE_DEVICE_READYSubscription = { __typename?: 'subscription_root', device?: { __typename?: 'qx_Device', id: string, model?: string | undefined } | undefined };

export type GQL_GET_ROSSLARE_DEVICE_DIO_USAGEQueryVariables = Exact<{
  deviceID: string;
}>;


export type GQL_GET_ROSSLARE_DEVICE_DIO_USAGEQuery = { __typename?: 'query_root', DeviceDIOs: Array<{ __typename?: 'qx_DeviceDIO', id: string, name: string, type?: qx_eDIOType_enum | undefined, accessInventory?: { __typename?: 'qx_AccessInventory', id: string } | undefined, eDIONormalState?: { __typename?: 'qx_eDIONormalState', value: string, comment?: string | undefined } | undefined, eSuperviseInputs: { __typename?: 'qx_eSuperviseInputs', value: string }, InputPoints: Array<{ __typename?: 'qx_InputPoint', id: string, channel?: number | undefined }>, OutputPoints: Array<{ __typename?: 'qx_OutputPoint', id: string, channel?: number | undefined }> }> };

export type GQL_GET_ROSSLARE_MODELSQueryVariables = Exact<{
  type: qx_eAccessBoardType_enum;
}>;


export type GQL_GET_ROSSLARE_MODELSQuery = { __typename?: 'query_root', accessCatalogs: Array<{ __typename?: 'qx_AccessCatalog', id: string, name: string, type: qx_eAccessBoardType_enum, interface: qx_eAccessInterfaceType_enum, nInputs: number, nOutputs: number, nReaders: number, model: number, placeID: string }> };

export type GQL_VALIDATE_ROSSLARE_HARDWAREMutationVariables = Exact<{
  deviceID: string;
  config: any;
}>;


export type GQL_VALIDATE_ROSSLARE_HARDWAREMutation = { __typename?: 'mutation_root', validateHardware: { __typename?: 'ValidateHardwareResult', error?: string | undefined, success: boolean } };

export type GQL_VALIDATE_ROSSLARE_PACS_UPDATEMutationVariables = Exact<{
  deviceID: string;
}>;


export type GQL_VALIDATE_ROSSLARE_PACS_UPDATEMutation = { __typename?: 'mutation_root', validateSoftware: { __typename?: 'ValidateHardwareResult', error?: string | undefined, success: boolean } };

export type AccessCatalogProtocolOverrideFragment = { __typename?: 'qx_CatalogProtocolOverride', id: number, protocol: qx_eReaderProtocol_enum, enabled: boolean };

export type AccessCatalogCapabilitiesFragment = { __typename?: 'qx_AccessCatalogCapabilities', catalogID: string, hasLockModes: boolean };

export type DeviceInventoryCatalogFragment = { __typename?: 'qx_AccessCatalog', id: string, name: string, type: qx_eAccessBoardType_enum, interface: qx_eAccessInterfaceType_enum, nInputs: number, nOutputs: number, nReaders: number, AccessCatalogCapabilities?: { __typename?: 'qx_AccessCatalogCapabilities', catalogID: string, hasLockModes: boolean } | undefined, CatalogProtocolOverrides: Array<{ __typename?: 'qx_CatalogProtocolOverride', id: number, protocol: qx_eReaderProtocol_enum, enabled: boolean }> };

export type DeviceInventoryFragment = { __typename?: 'qx_AccessInventory', id: string, host: string, port: number, sioPort: number, serialPortsAvail: number, sioAddress: number, catalogID: string, connectionStatus: qx_eDeviceConnectionStatus_enum, state: qx_eDoorAlarm_enum, readersPerDoor?: number | undefined, catalog: { __typename?: 'qx_AccessCatalog', id: string, name: string, type: qx_eAccessBoardType_enum, interface: qx_eAccessInterfaceType_enum, nInputs: number, nOutputs: number, nReaders: number, AccessCatalogCapabilities?: { __typename?: 'qx_AccessCatalogCapabilities', catalogID: string, hasLockModes: boolean } | undefined, CatalogProtocolOverrides: Array<{ __typename?: 'qx_CatalogProtocolOverride', id: number, protocol: qx_eReaderProtocol_enum, enabled: boolean }> } };

export type AccessInventoryCatalogFragment = { __typename?: 'qx_AccessCatalog', id: string, name: string, type: qx_eAccessBoardType_enum, interface: qx_eAccessInterfaceType_enum, nInputs: number, nOutputs: number, nReaders: number, model: number, placeID: string, AccessCatalogCapabilities?: { __typename?: 'qx_AccessCatalogCapabilities', catalogID: string, hasLockModes: boolean } | undefined, CatalogProtocolOverrides: Array<{ __typename?: 'qx_CatalogProtocolOverride', id: number, protocol: qx_eReaderProtocol_enum, enabled: boolean }> };

export type AccessInventoryBaseFragment = { __typename?: 'qx_AccessInventory', id: string, host: string, port: number, sioPort: number, inputsAvail: number, outputsAvail: number, readersAvail: number, serialPortsAvail: number, sioAddress: number, catalogID: string, catalog: { __typename?: 'qx_AccessCatalog', id: string, name: string, type: qx_eAccessBoardType_enum, interface: qx_eAccessInterfaceType_enum, nInputs: number, nOutputs: number, nReaders: number, model: number, placeID: string, AccessCatalogCapabilities?: { __typename?: 'qx_AccessCatalogCapabilities', catalogID: string, hasLockModes: boolean } | undefined, CatalogProtocolOverrides: Array<{ __typename?: 'qx_CatalogProtocolOverride', id: number, protocol: qx_eReaderProtocol_enum, enabled: boolean }> } };

export type InputPointBasicFragment = { __typename?: 'qx_InputPoint', id: string, channel?: number | undefined };

export type OutputPointBasicFragment = { __typename?: 'qx_OutputPoint', id: string, channel?: number | undefined };

export type DeviceDioWiringFragment = { __typename?: 'qx_DeviceDIO', id: string, name: string, refID: string, type?: qx_eDIOType_enum | undefined, state?: qx_eDIOState_enum | undefined, enabled: boolean, eDIOType?: { __typename?: 'qx_eDIOType', value: string, comment?: string | undefined } | undefined, eDIOState?: { __typename?: 'qx_eDIOState', value: string, comment?: string | undefined } | undefined, InputPoints: Array<{ __typename?: 'qx_InputPoint', supervise?: string | undefined, id: string, channel?: number | undefined }>, OutputPoints: Array<{ __typename?: 'qx_OutputPoint', pulse?: string | undefined, id: string, channel?: number | undefined }>, Reader?: { __typename?: 'qx_Reader', id: string, name: string } | undefined, Door?: { __typename?: 'qx_Door', id: any, name: string, inventoryID?: string | undefined, toAlarm: { __typename?: 'qx_eDoorAlarm', value: string }, toMode: { __typename?: 'qx_eDoorMode', value: string } } | undefined, accessInventory?: { __typename?: 'qx_AccessInventory', id: string } | undefined };

export type GQL_SUBMIT_HARDWAREMutationVariables = Exact<{
  deviceID: string;
  config: any;
}>;


export type GQL_SUBMIT_HARDWAREMutation = { __typename?: 'mutation_root', submitHardware: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_SIGNOUTMutationVariables = Exact<{ [key: string]: never; }>;


export type GQL_SIGNOUTMutation = { __typename?: 'mutation_root', signout: { __typename?: 'SuccessResponse', success: boolean } };

export type GQL_SIGNOUT_SESSIONMutationVariables = Exact<{
  sid: string;
}>;


export type GQL_SIGNOUT_SESSIONMutation = { __typename?: 'mutation_root', signout: { __typename?: 'SuccessResponse', success: boolean } };

export type GQL_SIGNOUT_EVERYWHEREMutationVariables = Exact<{ [key: string]: never; }>;


export type GQL_SIGNOUT_EVERYWHEREMutation = { __typename?: 'mutation_root', signoutEverywhere: { __typename?: 'SuccessResponse', success: boolean } };

export type GQL_SUB_PERSON_PROFILESSubscriptionVariables = Exact<{
  email: string;
}>;


export type GQL_SUB_PERSON_PROFILESSubscription = { __typename?: 'subscription_root', qx_vProfiles: Array<{ __typename?: 'qx_vProfiles', id?: string | undefined, avatar_md?: string | undefined, firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined, placeID?: string | undefined, place?: { __typename?: 'qx_Place', id: string, name: string, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', integratorPlaceID?: string | undefined, customerPlaceID?: string | undefined, homePlace?: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, path: string } | undefined } | undefined } | undefined }> };

export type GQL_SWITCH_PROFILEMutationVariables = Exact<{
  personID: string;
}>;


export type GQL_SWITCH_PROFILEMutation = { __typename?: 'mutation_root', switchProfile: { __typename?: 'SuccessResponse', success: boolean } };

export type PlaceScopeFragment = { __typename?: 'qx_Place', id: string, name: string, path: string, type: qx_ePlaceType_enum, requireTwoFactor: boolean, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', integratorPlaceID?: string | undefined, customerPlaceID?: string | undefined, homePlace?: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, path: string, canSelfServe?: boolean | undefined, requireTwoFactor: boolean } | undefined } | undefined };

export type GQL_GET_USER_SCOPESQueryVariables = Exact<{
  ids?: Array<string> | string;
}>;


export type GQL_GET_USER_SCOPESQuery = { __typename?: 'query_root', places: Array<{ __typename?: 'qx_Place', id: string, name: string, path: string, type: qx_ePlaceType_enum, requireTwoFactor: boolean, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', integratorPlaceID?: string | undefined, customerPlaceID?: string | undefined, homePlace?: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, path: string, canSelfServe?: boolean | undefined, requireTwoFactor: boolean } | undefined } | undefined }> };

export type GQL_SUB_USER_SCOPESSubscriptionVariables = Exact<{
  ids?: Array<string> | string;
}>;


export type GQL_SUB_USER_SCOPESSubscription = { __typename?: 'subscription_root', places: Array<{ __typename?: 'qx_Place', id: string, name: string, path: string, type: qx_ePlaceType_enum, requireTwoFactor: boolean, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', integratorPlaceID?: string | undefined, customerPlaceID?: string | undefined, homePlace?: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, path: string, canSelfServe?: boolean | undefined, requireTwoFactor: boolean } | undefined } | undefined }> };

export type GQL_GET_PLACE_TO_SET_CURRENT_SCOPEQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_PLACE_TO_SET_CURRENT_SCOPEQuery = { __typename?: 'query_root', place?: { __typename?: 'qx_Place', id: string, name: string, path: string, type: qx_ePlaceType_enum, requireTwoFactor: boolean, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', integratorPlaceID?: string | undefined, customerPlaceID?: string | undefined, homePlace?: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, path: string, canSelfServe?: boolean | undefined, requireTwoFactor: boolean } | undefined } | undefined } | undefined };

export type GQL_CREATE_USER_SETTINGMutationVariables = Exact<{
  personID: string;
  name: string;
  value: any;
}>;


export type GQL_CREATE_USER_SETTINGMutation = { __typename?: 'mutation_root', createUserSetting?: { __typename?: 'qx_UserSetting', id: string, name: string, value: any, updatedAt?: any | undefined } | undefined };

export type GQL_DELETE_USER_SETTINGMutationVariables = Exact<{
  id: string;
}>;


export type GQL_DELETE_USER_SETTINGMutation = { __typename?: 'mutation_root', deleteUserSetting?: { __typename?: 'qx_UserSetting', id: string, name: string } | undefined };

export type GQL_GET_USER_SETTINGSQueryVariables = Exact<{
  personID: string;
}>;


export type GQL_GET_USER_SETTINGSQuery = { __typename?: 'query_root', userSettings: Array<{ __typename?: 'qx_UserSetting', id: string, name: string, value: any, updatedAt?: any | undefined }> };

export type GQL_SUB_USER_SETTINGSSubscriptionVariables = Exact<{
  personID: string;
}>;


export type GQL_SUB_USER_SETTINGSSubscription = { __typename?: 'subscription_root', userSettings: Array<{ __typename?: 'qx_UserSetting', id: string, name: string, value: any, updatedAt?: any | undefined }> };

export type GQL_UPDATE_USER_SETTINGMutationVariables = Exact<{
  id: string;
  value: any;
}>;


export type GQL_UPDATE_USER_SETTINGMutation = { __typename?: 'mutation_root', updateUserSetting?: { __typename?: 'qx_UserSetting', id: string, name: string, value: any } | undefined };

export type AuthPersonFragment = { __typename?: 'qx_Person', id: string, firstName?: string | undefined, lastName?: string | undefined, suffix?: string | undefined, salutation?: string | undefined, avatar_md?: string | undefined, placeID: string, email?: string | undefined, roleID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, path: string }, acceptedTerms?: { __typename?: 'PersonTermsAgreement', email: string, termsID: string } | undefined, gatewayPassword?: { __typename?: 'ApplicationUserGatewayPassword', id: string } | undefined, role?: { __typename?: 'qx_Role', id: string, name: string, toPrivileges: Array<{ __typename?: 'qx__PrivilegeEnumToRole', privilege: qx_ePrivilege_enum }> } | undefined };

export type GQL_GET_AUTH_PERSONQueryVariables = Exact<{
  personID: string;
}>;


export type GQL_GET_AUTH_PERSONQuery = { __typename?: 'query_root', people: Array<{ __typename?: 'qx_Person', id: string, firstName?: string | undefined, lastName?: string | undefined, suffix?: string | undefined, salutation?: string | undefined, avatar_md?: string | undefined, placeID: string, email?: string | undefined, roleID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, path: string }, acceptedTerms?: { __typename?: 'PersonTermsAgreement', email: string, termsID: string } | undefined, gatewayPassword?: { __typename?: 'ApplicationUserGatewayPassword', id: string } | undefined, role?: { __typename?: 'qx_Role', id: string, name: string, toPrivileges: Array<{ __typename?: 'qx__PrivilegeEnumToRole', privilege: qx_ePrivilege_enum }> } | undefined }> };

export type GQL_SUB_AUTH_PERSONSubscriptionVariables = Exact<{
  personID: string;
}>;


export type GQL_SUB_AUTH_PERSONSubscription = { __typename?: 'subscription_root', people: Array<{ __typename?: 'qx_Person', id: string, firstName?: string | undefined, lastName?: string | undefined, suffix?: string | undefined, salutation?: string | undefined, avatar_md?: string | undefined, placeID: string, email?: string | undefined, roleID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, path: string }, acceptedTerms?: { __typename?: 'PersonTermsAgreement', email: string, termsID: string } | undefined, gatewayPassword?: { __typename?: 'ApplicationUserGatewayPassword', id: string } | undefined, role?: { __typename?: 'qx_Role', id: string, name: string, toPrivileges: Array<{ __typename?: 'qx__PrivilegeEnumToRole', privilege: qx_ePrivilege_enum }> } | undefined }> };

export type GQL_SETUP_TWO_FACTORMutationVariables = Exact<{
  token: string;
}>;


export type GQL_SETUP_TWO_FACTORMutation = { __typename?: 'mutation_root', setupTwoFactor: { __typename?: 'BackupCodes', codes?: Array<string> | undefined } };

export type GQL_REMOVE_TWO_FACTORMutationVariables = Exact<{
  token: string;
}>;


export type GQL_REMOVE_TWO_FACTORMutation = { __typename?: 'mutation_root', removeTwoFactor: { __typename?: 'SuccessResponse', success: boolean } };

export type GQL_TWO_FACTOR_BACKUP_CODESQueryVariables = Exact<{
  token: string;
}>;


export type GQL_TWO_FACTOR_BACKUP_CODESQuery = { __typename?: 'query_root', getTwoFactorBackupCodes: { __typename?: 'BackupCodes', codes?: Array<string> | undefined, createdAt: any } };

export type GQL_TWO_FACTOR_GENERATE_BACKUP_CODESMutationVariables = Exact<{
  token: string;
}>;


export type GQL_TWO_FACTOR_GENERATE_BACKUP_CODESMutation = { __typename?: 'mutation_root', generateTwoFactorBackupCodes: { __typename?: 'BackupCodes', codes?: Array<string> | undefined, createdAt: any } };

export type GQL_GENERATE_TWO_FACTOR_QRQueryVariables = Exact<{ [key: string]: never; }>;


export type GQL_GENERATE_TWO_FACTOR_QRQuery = { __typename?: 'query_root', generateTwoFactorQr: { __typename?: 'QrResponse', qr: string, url: string } };

export type GQL_GET_AI_CONVERSATION_SCOPE_PLACESQueryVariables = Exact<{
  ids?: Array<string> | string;
}>;


export type GQL_GET_AI_CONVERSATION_SCOPE_PLACESQuery = { __typename?: 'query_root', places: Array<{ __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }> };

export type GQL_GET_AI_THREAD_SCOPE_PLACEQueryVariables = Exact<{
  ids?: Array<string> | string;
}>;


export type GQL_GET_AI_THREAD_SCOPE_PLACEQuery = { __typename?: 'query_root', places: Array<{ __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }> };

export type GQL_AI_PROMPT_USAGEQueryVariables = Exact<{
  where: qx_vChatPromptUsage_bool_exp;
  limit: number;
  offset: number;
  includeActualCost: boolean;
}>;


export type GQL_AI_PROMPT_USAGEQuery = { __typename?: 'query_root', rows: Array<{ __typename?: 'qx_vChatPromptUsage', runId?: string | undefined, threadId?: string | undefined, threadTitle?: string | undefined, placeId?: string | undefined, personId?: string | undefined, personName?: string | undefined, personEmail?: string | undefined, billingTier?: string | undefined, billingPeriodStart?: any | undefined, inputTokens?: number | undefined, outputTokens?: number | undefined, cachedInputTokens?: number | undefined, totalTokens?: number | undefined, billableTokens?: number | undefined, actualCostCents?: number | undefined, costCents?: number | undefined, model?: string | undefined, createdAt?: any | undefined }>, total: { __typename?: 'qx_vChatPromptUsage_aggregate', aggregate?: { __typename?: 'qx_vChatPromptUsage_aggregate_fields', count: number } | undefined } };

export type GQL_AI_USAGE_SERIESQueryVariables = Exact<{
  where: qx_vChatPromptUsage_bool_exp;
}>;


export type GQL_AI_USAGE_SERIESQuery = { __typename?: 'query_root', rows: Array<{ __typename?: 'qx_vChatPromptUsage', createdAt?: any | undefined, billableTokens?: number | undefined, model?: string | undefined, billingTier?: string | undefined, threadId?: string | undefined, threadTitle?: string | undefined, personId?: string | undefined, personName?: string | undefined }> };

export type GQL_AI_USAGE_PER_MODELQueryVariables = Exact<{
  from?: string;
  to?: string;
  placeId?: string;
  placeType?: string;
}>;


export type GQL_AI_USAGE_PER_MODELQuery = { __typename?: 'query_root', perModel: Array<{ __typename?: 'qx_vChatUsagePerModel', model?: string | undefined, provider?: string | undefined, prompts?: number | undefined, inputTokens?: number | undefined, outputTokens?: number | undefined, cachedInputTokens?: number | undefined, uncachedInputTokens?: number | undefined, billableTokens?: number | undefined, inputCostCents?: number | undefined, outputCostCents?: number | undefined, cachedInputCostCents?: number | undefined, totalCostCents?: number | undefined }> };

export type GQL_AI_USAGE_SUMMARY_PUBLICQueryVariables = Exact<{
  where: qx_vChatPromptUsage_bool_exp;
}>;


export type GQL_AI_USAGE_SUMMARY_PUBLICQuery = { __typename?: 'query_root', summary: { __typename?: 'qx_vChatPromptUsage_aggregate', aggregate?: { __typename?: 'qx_vChatPromptUsage_aggregate_fields', count: number, sum?: { __typename?: 'qx_vChatPromptUsage_sum_fields', billableTokens?: number | undefined } | undefined } | undefined } };

export type GQL_AI_USAGE_PLACESQueryVariables = Exact<{
  types?: Array<qx_ePlaceType_enum> | qx_ePlaceType_enum;
}>;


export type GQL_AI_USAGE_PLACESQuery = { __typename?: 'query_root', places: Array<{ __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum }> };

export type termsAgreementsQueryVariables = Exact<{
  date?: string;
}>;


export type termsAgreementsQuery = { __typename?: 'query_root', termsAgreements: Array<{ __typename?: 'qx_TermsAgreement', id: string, dateOfAgreement?: any | undefined, validUntil?: any | undefined, termsReference?: string | undefined }> };

export type GQL_ACCEPT_TERMS_AGREEMENTMutationVariables = Exact<{
  termsID: string;
}>;


export type GQL_ACCEPT_TERMS_AGREEMENTMutation = { __typename?: 'mutation_root', acceptTermsOfAgreement: { __typename?: 'SuccessOutput', success: boolean } };

export type GQL_GET_GATEWAY_TYPEQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_GATEWAY_TYPEQuery = { __typename?: 'query_root', gateway?: { __typename?: 'qx_Gateway', id: string, type: eGatewayType_enum } | undefined };

export type GQL_VALIDATE_LIVE_GATEWAY_BANDWIDTHQueryVariables = Exact<{
  path: string;
  gatewayID: string;
}>;


export type GQL_VALIDATE_LIVE_GATEWAY_BANDWIDTHQuery = { __typename?: 'query_root', gateways: Array<{ __typename?: 'qx_Gateway', id: string }> };

export type GQL_VALIDATE_SENSOR_BY_ID_AND_PATHQueryVariables = Exact<{
  id: string;
  path: string;
}>;


export type GQL_VALIDATE_SENSOR_BY_ID_AND_PATHQuery = { __typename?: 'query_root', sensors: Array<{ __typename?: 'qx_Sensor', id: any, defaultVideoSourceID?: any | undefined, batteryLevel: qx_eBatteryLevel_enum, connectionStatus: qx_eDeviceConnectionStatus_enum, createdAt?: any | undefined, description?: string | undefined, deviceID: string, disabledByLicense: boolean, enabled: boolean, name: string, placeID: string, serial: string, state: qx_eDIOState_enum, type: qx_eSensorType_enum, updatedAt?: any | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, place: { __typename?: 'qx_Place', id: string, name: string } } | undefined, eBatteryLevel: { __typename?: 'qx_eBatteryLevel', comment?: string | undefined }, eDIOState: { __typename?: 'qx_eDIOState', comment?: string | undefined }, eDeviceConnectionStatus: { __typename?: 'qx_eDeviceConnectionStatus', comment?: string | undefined }, eSensorType: { __typename?: 'qx_eSensorType', comment?: string | undefined }, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, port: number, tls: boolean, model?: string | undefined, firmware?: string | undefined, serial?: string | undefined, deviceUsername?: string | undefined, devicePassword?: string | undefined, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } }, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } | undefined } }> };

export type GQL_SUB_VALIDATE_SENSOR_BY_ID_AND_PATHSubscriptionVariables = Exact<{
  id: string;
  path: string;
}>;


export type GQL_SUB_VALIDATE_SENSOR_BY_ID_AND_PATHSubscription = { __typename?: 'subscription_root', sensors: Array<{ __typename?: 'qx_Sensor', id: any, defaultVideoSourceID?: any | undefined, batteryLevel: qx_eBatteryLevel_enum, connectionStatus: qx_eDeviceConnectionStatus_enum, createdAt?: any | undefined, description?: string | undefined, deviceID: string, disabledByLicense: boolean, enabled: boolean, name: string, placeID: string, serial: string, state: qx_eDIOState_enum, type: qx_eSensorType_enum, updatedAt?: any | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, place: { __typename?: 'qx_Place', id: string, name: string } } | undefined, eBatteryLevel: { __typename?: 'qx_eBatteryLevel', comment?: string | undefined }, eDIOState: { __typename?: 'qx_eDIOState', comment?: string | undefined }, eDeviceConnectionStatus: { __typename?: 'qx_eDeviceConnectionStatus', comment?: string | undefined }, eSensorType: { __typename?: 'qx_eSensorType', comment?: string | undefined }, device: { __typename?: 'qx_Device', id: string, deviceAddress?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, port: number, tls: boolean, model?: string | undefined, firmware?: string | undefined, serial?: string | undefined, deviceUsername?: string | undefined, devicePassword?: string | undefined, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } }, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, gateway?: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum } | undefined } }> };

export type GQL_VALIDATE_DOOR_BY_ID_AND_PATHQueryVariables = Exact<{
  id: string;
  path: string;
}>;


export type GQL_VALIDATE_DOOR_BY_ID_AND_PATHQuery = { __typename?: 'query_root', doors: Array<{ __typename?: 'qx_Door', id: any, type?: string | undefined, name: string, canOperate?: boolean | undefined, description?: string | undefined, updatedAt?: any | undefined, enabled: boolean, defaultVideoSourceID?: any | undefined, batteryLevel: qx_eBatteryLevel_enum, doorMonitorAlarm: boolean, lockdownImmunity?: boolean | undefined, accessTime?: string | undefined, openTime?: string | undefined, extendedAccessTime?: string | undefined, extendedOpenTime?: string | undefined, preAlarmTime?: string | undefined, lockAddress?: string | undefined, doorMonitorAddress?: string | undefined, mode: qx_eDoorMode_enum, state: qx_eDoorState_enum, timezone?: string | undefined, alarm: qx_eDoorAlarm_enum, unlockScheduleID?: string | undefined, disabledByLicense: boolean, deviceID: string, doorMonitor: qx_eDoorMonitor_enum, devicePacsStatus?: string | undefined, devicePacsHWUpdate?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } | undefined, device: { __typename?: 'qx_Device', id: string, name: string, description?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, kind: qx_eDeviceKind_enum, meta?: any | undefined, make?: string | undefined, model?: string | undefined, serial?: string | undefined, firmware?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, deviceUsername?: string | undefined, devicePassword?: string | undefined, port: number, tls: boolean, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, pacsUpdateTime: any, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string, path: string } } }, place: { __typename?: 'qx_Place', id: string, name: string, path: string, timezone?: string | undefined, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, inside: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, permissions: Array<{ __typename?: 'qx_Permission', id: string, name: string, thumbnail?: string | undefined, thumbnail_sm?: string | undefined, group: { __typename?: 'qx_Group', id: string, name: string, toPeople: Array<{ __typename?: 'qx__PersonToGroup', personID: string }> }, schedule: { __typename?: 'qx_Schedule', id: string, name: string } }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string }> }, outside?: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, permissions: Array<{ __typename?: 'qx_Permission', id: string, name: string, thumbnail?: string | undefined, thumbnail_sm?: string | undefined, group: { __typename?: 'qx_Group', id: string, name: string, toPeople: Array<{ __typename?: 'qx__PersonToGroup', personID: string }> }, schedule: { __typename?: 'qx_Schedule', id: string, name: string } }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string }> } | undefined, unlockSchedule?: { __typename?: 'qx_Schedule', id: string, name: string, isActive?: boolean | undefined, holidayActive?: string | undefined, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, scheduleID: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }>, permissions: Array<{ __typename?: 'qx_Permission', id: string, name: string }>, place: { __typename?: 'qx_Place', id: string, name: string } } | undefined }> };

export type GQL_SUB_VALIDATE_DOOR_BY_ID_AND_PATHSubscriptionVariables = Exact<{
  id: string;
  path: string;
}>;


export type GQL_SUB_VALIDATE_DOOR_BY_ID_AND_PATHSubscription = { __typename?: 'subscription_root', doors: Array<{ __typename?: 'qx_Door', id: any, type?: string | undefined, name: string, canOperate?: boolean | undefined, description?: string | undefined, updatedAt?: any | undefined, enabled: boolean, defaultVideoSourceID?: any | undefined, batteryLevel: qx_eBatteryLevel_enum, doorMonitorAlarm: boolean, lockdownImmunity?: boolean | undefined, accessTime?: string | undefined, openTime?: string | undefined, extendedAccessTime?: string | undefined, extendedOpenTime?: string | undefined, preAlarmTime?: string | undefined, lockAddress?: string | undefined, doorMonitorAddress?: string | undefined, mode: qx_eDoorMode_enum, state: qx_eDoorState_enum, timezone?: string | undefined, alarm: qx_eDoorAlarm_enum, unlockScheduleID?: string | undefined, disabledByLicense: boolean, deviceID: string, doorMonitor: qx_eDoorMonitor_enum, devicePacsStatus?: string | undefined, devicePacsHWUpdate?: string | undefined, deviceConnectionStatus?: string | undefined, gatewaySyncStatus?: string | undefined, gatewayConnectionStatus?: boolean | undefined, gatewayPlaceID?: string | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined } } | undefined, device: { __typename?: 'qx_Device', id: string, name: string, description?: string | undefined, enabled: boolean, connectionStatus: qx_eDeviceConnectionStatus_enum, kind: qx_eDeviceKind_enum, meta?: any | undefined, make?: string | undefined, model?: string | undefined, serial?: string | undefined, firmware?: string | undefined, deviceAddress?: string | undefined, deviceMac?: string | undefined, deviceUsername?: string | undefined, devicePassword?: string | undefined, port: number, tls: boolean, pacsStatus: qx_ePACSStatus_enum, pacsHWUpdate: qx_ePACSStatus_enum, pacsUpdateTime: any, gateway: { __typename?: 'qx_Gateway', id: string, name: string, connectionStatus: boolean, syncStatus: qx_eGatewaySyncStatus_enum, type: eGatewayType_enum, place: { __typename?: 'qx_Place', id: string, name: string, path: string } } }, place: { __typename?: 'qx_Place', id: string, name: string, path: string, timezone?: string | undefined, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, inside: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, permissions: Array<{ __typename?: 'qx_Permission', id: string, name: string, thumbnail?: string | undefined, thumbnail_sm?: string | undefined, group: { __typename?: 'qx_Group', id: string, name: string, toPeople: Array<{ __typename?: 'qx__PersonToGroup', personID: string }> }, schedule: { __typename?: 'qx_Schedule', id: string, name: string } }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string }> }, outside?: { __typename?: 'qx_Place', id: string, name: string, path: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, permissions: Array<{ __typename?: 'qx_Permission', id: string, name: string, thumbnail?: string | undefined, thumbnail_sm?: string | undefined, group: { __typename?: 'qx_Group', id: string, name: string, toPeople: Array<{ __typename?: 'qx__PersonToGroup', personID: string }> }, schedule: { __typename?: 'qx_Schedule', id: string, name: string } }>, videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string }> } | undefined, unlockSchedule?: { __typename?: 'qx_Schedule', id: string, name: string, isActive?: boolean | undefined, holidayActive?: string | undefined, blocks: Array<{ __typename?: 'qx_ScheduleBlock', id: string, scheduleID: string, date: any, duration: string, weekdays?: string | undefined, toHolidaySets: Array<{ __typename?: 'qx__HolidaySetToScheduleBlock', holidaySetID: string, scheduleBlockID: string, holidaySet: { __typename?: 'qx_HolidaySet', id: string, name: string } }> }>, permissions: Array<{ __typename?: 'qx_Permission', id: string, name: string }>, place: { __typename?: 'qx_Place', id: string, name: string } } | undefined }> };

export type GQL_VALIDATE_CAMERA_BY_ID_AND_PATHQueryVariables = Exact<{
  id: string;
}>;


export type GQL_VALIDATE_CAMERA_BY_ID_AND_PATHQuery = { __typename?: 'query_root', videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, place: { __typename?: 'qx_Place', id: string, path: string } }> };

export type GQL_GET_DEFAULT_PLACE_VIEWQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_DEFAULT_PLACE_VIEWQuery = { __typename?: 'query_root', views: Array<{ __typename?: 'qx_View', id: string, settings: any, name: string, personID?: string | undefined, place: { __typename?: 'qx_Place', id: string, name: string, type: qx_ePlaceType_enum, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined, defaultView?: { __typename?: 'qx_View', id: string, name: string } | undefined } }> };

export type validateRoleNotRootFragment = { __typename?: 'qx_Role', id: string, placeID: string, place: { __typename?: 'qx_Place', id: string } };

export type GQL_VALIDATE_ROLE_EDITQueryVariables = Exact<{
  id: string;
}>;


export type GQL_VALIDATE_ROLE_EDITQuery = { __typename?: 'query_root', role?: { __typename?: 'qx_Role', id: string, placeID: string } | undefined };

export type GQL_GET_CLIP_DELETED_STATUSQueryVariables = Exact<{
  id: string;
}>;


export type GQL_GET_CLIP_DELETED_STATUSQuery = { __typename?: 'query_root', clip?: { __typename?: 'qx_Clip', id: any, deletedAt?: any | undefined } | undefined };

export type GQL_GET_ANALYTICSQueryVariables = Exact<{
  limit: number;
  order_by: Array<analytics_order_by> | analytics_order_by;
  where: analytics_bool_exp;
}>;


export type GQL_GET_ANALYTICSQuery = { __typename?: 'query_root', analytics: Array<{ __typename?: 'analytics', id: any, analyticType?: string | undefined, time: any, endTime?: any | undefined, likelihood?: number | undefined, videoSourceID?: any | undefined, snapshotID?: string | undefined, videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, place: { __typename?: 'qx_Place', id: string, name: string, path: string, type: qx_ePlaceType_enum, toHomePlaces?: { __typename?: 'qx__PlaceToHomePlaces', homePlace?: { __typename?: 'qx_Place', id: string, name: string, path: string, type: qx_ePlaceType_enum } | undefined } | undefined } } | undefined, snapshot?: { __typename?: 'qx_Snapshot', id: string, signedUrl?: string | undefined, aspectRatio?: any | undefined } | undefined }> };

export type GQL_GET_EVENT_STATUS_KEYSQueryVariables = Exact<{ [key: string]: never; }>;


export type GQL_GET_EVENT_STATUS_KEYSQuery = { __typename?: 'query_root', vEventStatuses: Array<{ __typename?: 'vEventStatuses', type?: string | undefined, status?: string | undefined, comment?: string | undefined }> };

export type GQL_GET_EVENT_ACTIVE_STATUS_TYPESQueryVariables = Exact<{ [key: string]: never; }>;


export type GQL_GET_EVENT_ACTIVE_STATUS_TYPESQuery = { __typename?: 'query_root', eventTypes: Array<{ __typename?: 'qx_EventType', uniqueID: string, usesActive: boolean, statusTable?: string | undefined, stateful: boolean, type: string, statusValues?: Array<{ __typename?: 'qx_eDeviceConnectionStatus', value: string, comment?: string | undefined }> | undefined }> };

export type GQL_GET_SEARCH_EVENT_SAVED_FILTER_SCOPE_PLACESQueryVariables = Exact<{
  ids?: Array<string> | string;
}>;


export type GQL_GET_SEARCH_EVENT_SAVED_FILTER_SCOPE_PLACESQuery = { __typename?: 'query_root', places: Array<{ __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }> };

export type GQL_GET_PLACE_PATH_BY_PLACE_IDQueryVariables = Exact<{
  placeID: string;
}>;


export type GQL_GET_PLACE_PATH_BY_PLACE_IDQuery = { __typename?: 'query_root', place?: { __typename?: 'qx_Place', id: string, name: string, path: string } | undefined };

export type GQL_DELETE_PASSKEYMutationVariables = Exact<{
  id: string;
}>;


export type GQL_DELETE_PASSKEYMutation = { __typename?: 'mutation_root', delete_applicationUserDevices?: { __typename?: 'applicationUserDevices_mutation_response', affected_rows: number } | undefined };

export type GQL_CAMERA_SEARCH_WITH_GATEWAY_FEATURESQueryVariables = Exact<{
  where?: qx_VideoSource_bool_exp;
  limit?: number;
  offset?: number;
  orderBy?: Array<qx_VideoSource_order_by> | qx_VideoSource_order_by;
}>;


export type GQL_CAMERA_SEARCH_WITH_GATEWAY_FEATURESQuery = { __typename?: 'query_root', videoSources: Array<{ __typename?: 'qx_VideoSource', id: any, name: string, place: { __typename?: 'qx_Place', id: string, name: string, hierarchy?: Array<{ __typename?: 'qx_vPlaceHierarchy', name?: string | undefined }> | undefined }, device: { __typename?: 'qx_Device', id: string, make?: string | undefined, model?: string | undefined, gateway: { __typename?: 'qx_Gateway', id: string, name: string, type: eGatewayType_enum, features: any } }, snapshots?: Array<{ __typename?: 'qx_Snapshot', id: string, base64?: string | undefined, signedUrl?: string | undefined, aspectRatio?: any | undefined }> | undefined }>, videoSourceAggregate: { __typename?: 'qx_VideoSource_aggregate', aggregate?: { __typename?: 'qx_VideoSource_aggregate_fields', count: number } | undefined } };

export type GQL_TIMELINE_GET_CAMERA_BY_IDQueryVariables = Exact<{
  id: string;
}>;


export type GQL_TIMELINE_GET_CAMERA_BY_IDQuery = { __typename?: 'query_root', videoSource?: { __typename?: 'qx_VideoSource', id: any, name: string, placeID: string, place: { __typename?: 'qx_Place', path: string } } | undefined };

export type GQL_GET_TIMELINE_EVENT_TYPESQueryVariables = Exact<{ [key: string]: never; }>;


export type GQL_GET_TIMELINE_EVENT_TYPESQuery = { __typename?: 'query_root', eventTypes: Array<{ __typename?: 'qx_EventType', type: string, priority: number, id: string }> };

export type GQL_GET_TIMELINE_EVENTSQueryVariables = Exact<{
  where: vEvents_bool_exp;
  limit: number;
  order_by: Array<vEvents_order_by> | vEvents_order_by;
}>;


export type GQL_GET_TIMELINE_EVENTSQuery = { __typename?: 'query_root', vEvents: Array<{ __typename?: 'vEvents', id?: any | undefined, type?: string | undefined, time?: any | undefined, serverTime?: any | undefined, duration?: any | undefined, eventStart?: any | undefined, eventEnd?: any | undefined, status?: string | undefined, active?: boolean | undefined }> };

export type GQL_GET_TIMELINE_BUCKETSQueryVariables = Exact<{
  args: qx_search_timeline_args;
}>;


export type GQL_GET_TIMELINE_BUCKETSQuery = { __typename?: 'query_root', qx_search_timeline: Array<{ __typename?: 'qx_vSearchTimeline', eventCount?: number | undefined, timeBucket?: any | undefined, priority?: number | undefined, placeID?: string | undefined }> };

export type GQL_TIMELINE_GET_SEGMENT_DATAQueryVariables = Exact<{
  videoSourceID: string;
  startTime: string;
  endTime: string;
  unit: string;
  type: Array<string> | string;
}>;


export type GQL_TIMELINE_GET_SEGMENT_DATAQuery = { __typename?: 'query_root', getMediaProfileRecording: Array<{ __typename?: 'MediaProfileRecordingItem', mediaProfileID: string, type: string, baseDate: any, recordings: any } | undefined> };

export type GQL_GET_TIMELINE_SNAPSHOTSQueryVariables = Exact<{
  videoSourceID: string;
  startTime: string;
  endTime: string;
  unit: string;
  type: Array<string> | string;
}>;


export type GQL_GET_TIMELINE_SNAPSHOTSQuery = { __typename?: 'query_root', getMediaProfileRecording: Array<{ __typename?: 'MediaProfileRecordingItem', mediaProfileID: string, type: string, baseDate: any, recordings: any } | undefined> };
